import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  BigFloat: { input: any; output: any };
  BigInt: { input: any; output: any };
  Cursor: { input: any; output: any };
  Date: { input: any; output: any };
  Datetime: { input: any; output: any };
  GeoJSON: { input: any; output: any };
  Geometry: { input: any; output: any };
  JSON: { input: any; output: any };
  UUID: { input: any; output: any };
  Upload: { input: any; output: any };
};

export enum AccessTokenType {
  MACHINE = 'MACHINE',
  USER = 'USER'
}

/** A filter to be used against AccessTokenType fields. All fields are combined with a logical ‘and.’ */
export type AccessTokenTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<AccessTokenType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<AccessTokenType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<AccessTokenType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<AccessTokenType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<AccessTokenType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<AccessTokenType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<AccessTokenType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<AccessTokenType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<AccessTokenType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<AccessTokenType>>;
};

export type AccountCharge = Node & {
  __typename?: 'AccountCharge';
  /** Reads a single `AccountStatement` that is related to this `AccountCharge`. */
  accountStatement?: Maybe<AccountStatement>;
  accountStatementId: Scalars['Int']['output'];
  /** The category of the account charge. */
  category: UtilityAccountChargeCategory;
  /** The time the charge was created. */
  createdAt: Scalars['Datetime']['output'];
  /** The time the charge was deleted. */
  deletedAt?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['Int']['output'];
  /** The end date of the account charge. */
  intervalEnd: Scalars['Date']['output'];
  /** The start date of the account charge. */
  intervalStart: Scalars['Date']['output'];
  /** The label of the account charge. */
  label: Scalars['String']['output'];
  /** Returns the category of the label associated with this account charge. */
  labelCategory?: Maybe<ChargeLabelCategory>;
  /** Returns the display category or category of the label associated with this account charge. */
  labelCategoryName?: Maybe<Scalars['String']['output']>;
  /** This is used to further distinguish otherwise duplicate rows that need to be present */
  lineNumber: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  overrideAt?: Maybe<Scalars['Datetime']['output']>;
  /** Overrides the normalized month of the account_statement. */
  overrideStatementMonth?: Maybe<Scalars['Int']['output']>;
  /** Overrides the normalized year of the account_statement. */
  overrideStatementYear?: Maybe<Scalars['Int']['output']>;
  statementDate: Scalars['Date']['output'];
  statementMonth?: Maybe<Scalars['Int']['output']>;
  statementYear?: Maybe<Scalars['Int']['output']>;
  /** The time the charge was updated. */
  updatedAt: Scalars['Datetime']['output'];
  /** This original value of the charge. */
  value: Scalars['Float']['output'];
};

/**
 * A condition to be used against `AccountCharge` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AccountChargeCondition = {
  /** Checks for equality with the object’s `accountStatementId` field. */
  accountStatementId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `category` field. */
  category?: InputMaybe<UtilityAccountChargeCategory>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `intervalEnd` field. */
  intervalEnd?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `intervalStart` field. */
  intervalStart?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `lineNumber` field. */
  lineNumber?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `normalizedValue` field. */
  normalizedValue?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `overrideAt` field. */
  overrideAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `overrideStatementMonth` field. */
  overrideStatementMonth?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `overrideStatementYear` field. */
  overrideStatementYear?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `statementDate` field. */
  statementDate?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `AccountCharge` object types. All fields are combined with a logical ‘and.’ */
export type AccountChargeFilter = {
  /** Filter by the object’s `accountStatementId` field. */
  accountStatementId?: InputMaybe<IntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AccountChargeFilter>>;
  /** Filter by the object’s `category` field. */
  category?: InputMaybe<UtilityAccountChargeCategoryFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `intervalEnd` field. */
  intervalEnd?: InputMaybe<DateFilter>;
  /** Filter by the object’s `intervalStart` field. */
  intervalStart?: InputMaybe<DateFilter>;
  /** Filter by the object's `label` field. */
  label?: InputMaybe<StringFilter>;
  /** Filter by the object’s `labelCategoryName` field. */
  labelCategoryName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `lineNumber` field. */
  lineNumber?: InputMaybe<IntFilter>;
  /** Filter by the object’s `normalizedValue` field. */
  normalizedValue?: InputMaybe<FloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AccountChargeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AccountChargeFilter>>;
  /** Filter by the object’s `overrideAt` field. */
  overrideAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `overrideStatementMonth` field. */
  overrideStatementMonth?: InputMaybe<IntFilter>;
  /** Filter by the object’s `overrideStatementYear` field. */
  overrideStatementYear?: InputMaybe<IntFilter>;
  /** Filter by the object’s `statementDate` field. */
  statementDate?: InputMaybe<DateFilter>;
  /** Filter by the object’s `statementMonth` field. */
  statementMonth?: InputMaybe<IntFilter>;
  /** Filter by the object’s `statementYear` field. */
  statementYear?: InputMaybe<IntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object's `value` field. */
  value?: InputMaybe<FloatFilter>;
};

/** An input for mutations affecting `AccountCharge` */
export type AccountChargeInput = {
  /** Mutates a `AccountStatement` as part of the payload */
  accountStatement?: InputMaybe<AccountStatementInput>;
  accountStatementId?: InputMaybe<Scalars['Int']['input']>;
  /** The category of the account charge. */
  category: UtilityAccountChargeCategory;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** The end date of the account charge. */
  intervalEnd: Scalars['Date']['input'];
  /** The start date of the account charge. */
  intervalStart: Scalars['Date']['input'];
  /** The label of the account charge. */
  label: Scalars['String']['input'];
  /** This is used to further distinguish otherwise duplicate rows that need to be present */
  lineNumber?: InputMaybe<Scalars['Int']['input']>;
  statementDate: Scalars['Date']['input'];
  /** This original value of the charge. */
  value: Scalars['Float']['input'];
};

/** Represents an update to a `AccountCharge`. Fields that are set will be updated. */
export type AccountChargePatch = {
  label?: InputMaybe<Scalars['String']['input']>;
  /** Overrides the normalized month of the account_statement. */
  overrideStatementMonth?: InputMaybe<Scalars['Int']['input']>;
  /** Overrides the normalized year of the account_statement. */
  overrideStatementYear?: InputMaybe<Scalars['Int']['input']>;
  statementDate?: InputMaybe<Scalars['Date']['input']>;
  /** Overrides the value of the charge. */
  value?: InputMaybe<Scalars['Float']['input']>;
};

/** A connection to a list of `AccountCharge` values. */
export type AccountChargesConnection = {
  __typename?: 'AccountChargesConnection';
  /** A list of edges which contains the `AccountCharge` and cursor to aid in pagination. */
  edges: Array<AccountChargesEdge>;
  /** A list of `AccountCharge` objects. */
  nodes: Array<AccountCharge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AccountCharge` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `AccountCharge` edge in the connection. */
export type AccountChargesEdge = {
  __typename?: 'AccountChargesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `AccountCharge` at the end of the edge. */
  node: AccountCharge;
};

/** Mapping of an account_charge to a charge_label_category with optional model version and actor metadata. */
export type AccountChargesLabelCategory = Node & {
  __typename?: 'AccountChargesLabelCategory';
  /** Reads a single `AccountCharge` that is related to this `AccountChargesLabelCategory`. */
  accountCharge?: Maybe<AccountCharge>;
  /** Foreign key to public.account_charges.id. */
  accountChargeId: Scalars['Int']['output'];
  /** Reads a single `ChargeLabelCategory` that is related to this `AccountChargesLabelCategory`. */
  chargeLabelCategory?: Maybe<ChargeLabelCategory>;
  /** Foreign key to public.charge_label_categories.id. */
  chargeLabelCategoryId: Scalars['Int']['output'];
  /** The time the mapping was created. */
  createdAt: Scalars['Datetime']['output'];
  /** Primary key. */
  id: Scalars['Int']['output'];
  /** Identifier of the model version used when assigning this category (nullable). */
  modelVersion?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The time the mapping was last updated. */
  updatedAt: Scalars['Datetime']['output'];
  /** Actor (user or machine) who last updated this mapping. */
  updatedBy?: Maybe<Actor>;
};

/** Methods to use when ordering `AccountCharge`. */
export enum AccountChargesOrderBy {
  ACCOUNT_STATEMENT_ID_ASC = 'ACCOUNT_STATEMENT_ID_ASC',
  ACCOUNT_STATEMENT_ID_DESC = 'ACCOUNT_STATEMENT_ID_DESC',
  CATEGORY_ASC = 'CATEGORY_ASC',
  CATEGORY_DESC = 'CATEGORY_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DELETED_AT_ASC = 'DELETED_AT_ASC',
  DELETED_AT_DESC = 'DELETED_AT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  INTERVAL_END_ASC = 'INTERVAL_END_ASC',
  INTERVAL_END_DESC = 'INTERVAL_END_DESC',
  INTERVAL_START_ASC = 'INTERVAL_START_ASC',
  INTERVAL_START_DESC = 'INTERVAL_START_DESC',
  LABEL_ASC = 'LABEL_ASC',
  LABEL_DESC = 'LABEL_DESC',
  LINE_NUMBER_ASC = 'LINE_NUMBER_ASC',
  LINE_NUMBER_DESC = 'LINE_NUMBER_DESC',
  NATURAL = 'NATURAL',
  NORMALIZED_VALUE_ASC = 'NORMALIZED_VALUE_ASC',
  NORMALIZED_VALUE_DESC = 'NORMALIZED_VALUE_DESC',
  OVERRIDE_AT_ASC = 'OVERRIDE_AT_ASC',
  OVERRIDE_AT_DESC = 'OVERRIDE_AT_DESC',
  OVERRIDE_LABEL_ASC = 'OVERRIDE_LABEL_ASC',
  OVERRIDE_LABEL_DESC = 'OVERRIDE_LABEL_DESC',
  OVERRIDE_STATEMENT_MONTH_ASC = 'OVERRIDE_STATEMENT_MONTH_ASC',
  OVERRIDE_STATEMENT_MONTH_DESC = 'OVERRIDE_STATEMENT_MONTH_DESC',
  OVERRIDE_STATEMENT_YEAR_ASC = 'OVERRIDE_STATEMENT_YEAR_ASC',
  OVERRIDE_STATEMENT_YEAR_DESC = 'OVERRIDE_STATEMENT_YEAR_DESC',
  OVERRIDE_VALUE_ASC = 'OVERRIDE_VALUE_ASC',
  OVERRIDE_VALUE_DESC = 'OVERRIDE_VALUE_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  STATEMENT_DATE_ASC = 'STATEMENT_DATE_ASC',
  STATEMENT_DATE_DESC = 'STATEMENT_DATE_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  VALUE_ASC = 'VALUE_ASC',
  VALUE_DESC = 'VALUE_DESC'
}

export type AccountMissingStatement = {
  __typename?: 'AccountMissingStatement';
  metadata?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  statementDate?: Maybe<Scalars['Date']['output']>;
  statementMonth?: Maybe<Scalars['Int']['output']>;
  statementYear?: Maybe<Scalars['Int']['output']>;
  utilityAccountId?: Maybe<Scalars['Int']['output']>;
  /** Reads and enables pagination through a set of `UtilityMeter`. */
  utilityMeters: UtilityMetersConnection;
};

export type AccountMissingStatementUtilityMetersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<UtilityMeterFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `AccountMissingStatement` object types. All fields are combined with a logical ‘and.’ */
export type AccountMissingStatementFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AccountMissingStatementFilter>>;
  /** Filter by the object’s `metadata` field. */
  metadata?: InputMaybe<JsonListFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AccountMissingStatementFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AccountMissingStatementFilter>>;
  /** Filter by the object’s `statementDate` field. */
  statementDate?: InputMaybe<DateFilter>;
  /** Filter by the object’s `statementMonth` field. */
  statementMonth?: InputMaybe<IntFilter>;
  /** Filter by the object’s `statementYear` field. */
  statementYear?: InputMaybe<IntFilter>;
  /** Filter by the object’s `utilityAccountId` field. */
  utilityAccountId?: InputMaybe<IntFilter>;
};

/** A connection to a list of `AccountMissingStatement` values. */
export type AccountMissingStatementsConnection = {
  __typename?: 'AccountMissingStatementsConnection';
  /** A list of edges which contains the `AccountMissingStatement` and cursor to aid in pagination. */
  edges: Array<AccountMissingStatementsEdge>;
  /** A list of `AccountMissingStatement` objects. */
  nodes: Array<AccountMissingStatement>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AccountMissingStatement` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `AccountMissingStatement` edge in the connection. */
export type AccountMissingStatementsEdge = {
  __typename?: 'AccountMissingStatementsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `AccountMissingStatement` at the end of the edge. */
  node: AccountMissingStatement;
};

export type AccountStatement = Node & {
  __typename?: 'AccountStatement';
  /** Reads and enables pagination through a set of `AccountCharge`. */
  accountCharges: AccountChargesConnection;
  /** Reads and enables pagination through a set of `AccountStatementHistory`. */
  accountStatementHistories: AccountStatementHistoriesConnection;
  /** Reads and enables pagination through a set of `AccountStatementPdf`. */
  accountStatementPdfs: AccountStatementPdfsConnection;
  /** The time the statement was created. */
  createdAt: Scalars['Datetime']['output'];
  /** The currency code of the statement. */
  currencyCode: Scalars['String']['output'];
  /** Returns the deleted_at column of this record or its parent */
  deletedAt?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['Int']['output'];
  integration: UtilityIntegration;
  /** The identifier provided by the integration source */
  integrationKey: Scalars['String']['output'];
  /** The overall statement billing interval end */
  intervalEnd: Scalars['Date']['output'];
  /** The overall statement billing interval start */
  intervalStart: Scalars['Date']['output'];
  isValidated: Scalars['Boolean']['output'];
  metadata: Scalars['JSON']['output'];
  /** Reads and enables pagination through a set of `MeterStatement`. */
  meterStatements: MeterStatementsConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  normalizedTotalCharges?: Maybe<Scalars['Float']['output']>;
  overrideAt?: Maybe<Scalars['Datetime']['output']>;
  /** The normalized month of the statement. */
  statementMonth: Scalars['Int']['output'];
  /** The normalized year of the statement. */
  statementYear: Scalars['Int']['output'];
  totalCharges?: Maybe<Scalars['Float']['output']>;
  /** The time the statement was updated. */
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `UtilityAccount` that is related to this `AccountStatement`. */
  utilityAccount?: Maybe<UtilityAccount>;
  utilityAccountId: Scalars['Int']['output'];
  /** Reads a single `UtilityAccountStatement` that is related to this `AccountStatement`. */
  utilityAccountStatement?: Maybe<UtilityAccountStatement>;
  /** Reads a single `UtilityAccountStatementRollup` that is related to this `AccountStatement`. */
  utilityAccountStatementRollup?: Maybe<UtilityAccountStatementRollup>;
  /** Reads and enables pagination through a set of `UtilityMeterStatement`. */
  utilityMeterStatements: UtilityMeterStatementsConnection;
};

export type AccountStatementAccountChargesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AccountChargeCondition>;
  filter?: InputMaybe<AccountChargeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountChargesOrderBy>>;
};

export type AccountStatementAccountStatementHistoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AccountStatementHistoryCondition>;
  filter?: InputMaybe<AccountStatementHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountStatementHistoriesOrderBy>>;
};

export type AccountStatementAccountStatementPdfsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AccountStatementPdfCondition>;
  filter?: InputMaybe<AccountStatementPdfFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountStatementPdfsOrderBy>>;
};

export type AccountStatementMeterStatementsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MeterStatementCondition>;
  filter?: InputMaybe<MeterStatementFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MeterStatementsOrderBy>>;
};

export type AccountStatementUtilityMeterStatementsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UtilityMeterStatementCondition>;
  filter?: InputMaybe<UtilityMeterStatementFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UtilityMeterStatementsOrderBy>>;
};

/**
 * A condition to be used against `AccountStatement` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AccountStatementCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `integration` field. */
  integration?: InputMaybe<UtilityIntegration>;
  /** Checks for equality with the object’s `integrationKey` field. */
  integrationKey?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `intervalEnd` field. */
  intervalEnd?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `intervalStart` field. */
  intervalStart?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `isValidated` field. */
  isValidated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `metadata` field. */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `normalizedCurrencyCode` field. */
  normalizedCurrencyCode?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `overrideAt` field. */
  overrideAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `statementMonth` field. */
  statementMonth?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `statementYear` field. */
  statementYear?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `utilityAccountId` field. */
  utilityAccountId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `AccountStatement` object types. All fields are combined with a logical ‘and.’ */
export type AccountStatementFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AccountStatementFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object's `currencyCode` field. */
  currencyCode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `integration` field. */
  integration?: InputMaybe<UtilityIntegrationFilter>;
  /** Filter by the object’s `integrationKey` field. */
  integrationKey?: InputMaybe<StringFilter>;
  /** Filter by the object’s `intervalEnd` field. */
  intervalEnd?: InputMaybe<DateFilter>;
  /** Filter by the object’s `intervalStart` field. */
  intervalStart?: InputMaybe<DateFilter>;
  /** Filter by the object’s `isValidated` field. */
  isValidated?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `metadata` field. */
  metadata?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `normalizedCurrencyCode` field. */
  normalizedCurrencyCode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `normalizedTotalCharges` field. */
  normalizedTotalCharges?: InputMaybe<FloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AccountStatementFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AccountStatementFilter>>;
  /** Filter by the object’s `overrideAt` field. */
  overrideAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `statementMonth` field. */
  statementMonth?: InputMaybe<IntFilter>;
  /** Filter by the object’s `statementYear` field. */
  statementYear?: InputMaybe<IntFilter>;
  /** Filter by the object’s `totalCharges` field. */
  totalCharges?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `utilityAccountId` field. */
  utilityAccountId?: InputMaybe<IntFilter>;
};

/** A connection to a list of `AccountStatementHistory` values. */
export type AccountStatementHistoriesConnection = {
  __typename?: 'AccountStatementHistoriesConnection';
  /** A list of edges which contains the `AccountStatementHistory` and cursor to aid in pagination. */
  edges: Array<AccountStatementHistoriesEdge>;
  /** A list of `AccountStatementHistory` objects. */
  nodes: Array<AccountStatementHistory>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AccountStatementHistory` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `AccountStatementHistory` edge in the connection. */
export type AccountStatementHistoriesEdge = {
  __typename?: 'AccountStatementHistoriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `AccountStatementHistory` at the end of the edge. */
  node: AccountStatementHistory;
};

/** Methods to use when ordering `AccountStatementHistory`. */
export enum AccountStatementHistoriesOrderBy {
  ACCOUNT_STATEMENT_ID_ASC = 'ACCOUNT_STATEMENT_ID_ASC',
  ACCOUNT_STATEMENT_ID_DESC = 'ACCOUNT_STATEMENT_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  NATURAL = 'NATURAL'
}

export type AccountStatementHistory = {
  __typename?: 'AccountStatementHistory';
  /** Reads a single `AccountStatement` that is related to this `AccountStatementHistory`. */
  accountStatement?: Maybe<AccountStatement>;
  accountStatementId: Scalars['Int']['output'];
  /** The time this statement was created. */
  createdAt: Scalars['Datetime']['output'];
  description: Scalars['String']['output'];
};

/**
 * A condition to be used against `AccountStatementHistory` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type AccountStatementHistoryCondition = {
  /** Checks for equality with the object’s `accountStatementId` field. */
  accountStatementId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `AccountStatementHistory` object types. All fields are combined with a logical ‘and.’ */
export type AccountStatementHistoryFilter = {
  /** Filter by the object’s `accountStatementId` field. */
  accountStatementId?: InputMaybe<IntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AccountStatementHistoryFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AccountStatementHistoryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AccountStatementHistoryFilter>>;
};

/** An input for mutations affecting `AccountStatementHistory` */
export type AccountStatementHistoryInput = {
  /** Mutates a `AccountStatement` as part of the payload */
  accountStatement?: InputMaybe<AccountStatementInput>;
  accountStatementId?: InputMaybe<Scalars['Int']['input']>;
  description: Scalars['String']['input'];
};

/** An input for mutations affecting `AccountStatement` */
export type AccountStatementInput = {
  /** The currency code of the statement. */
  currencyCode: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  integration: UtilityIntegration;
  /** The identifier provided by the integration source */
  integrationKey?: InputMaybe<Scalars['String']['input']>;
  /** The overall statement billing interval end */
  intervalEnd: Scalars['Date']['input'];
  /** The overall statement billing interval start */
  intervalStart: Scalars['Date']['input'];
  isValidated?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** The normalized month of the statement. */
  statementMonth: Scalars['Int']['input'];
  /** The normalized year of the statement. */
  statementYear: Scalars['Int']['input'];
  /** Mutates a `UtilityAccount` as part of the payload */
  utilityAccount?: InputMaybe<UtilityAccountInput>;
  utilityAccountId?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents an update to a `AccountStatement`. Fields that are set will be updated. */
export type AccountStatementPatch = {
  /** Overrides the currencyCode of the statement. */
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  isValidated?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** The normalized month of the statement. */
  statementMonth?: InputMaybe<Scalars['Int']['input']>;
  /** The normalized year of the statement. */
  statementYear?: InputMaybe<Scalars['Int']['input']>;
};

export type AccountStatementPdf = Node & {
  __typename?: 'AccountStatementPdf';
  /** Reads a single `AccountStatement` that is related to this `AccountStatementPdf`. */
  accountStatement?: Maybe<AccountStatement>;
  accountStatementId: Scalars['Int']['output'];
  /** The time this record was created. */
  createdAt: Scalars['Datetime']['output'];
  /** The time the record was deleted. */
  deletedAt?: Maybe<Scalars['Datetime']['output']>;
  fileKey: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /** Reads and enables pagination through a set of `MeterStatement`. */
  meterStatements: MeterStatementsConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  path: Scalars['String']['output'];
  /** The relative path for the file. */
  serverPath: Scalars['String']['output'];
  /** The time this record was updated. */
  updatedAt: Scalars['Datetime']['output'];
  /** The presigned URI for the file. */
  uri: Scalars['String']['output'];
};

export type AccountStatementPdfMeterStatementsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MeterStatementCondition>;
  filter?: InputMaybe<MeterStatementFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MeterStatementsOrderBy>>;
};

/**
 * A condition to be used against `AccountStatementPdf` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type AccountStatementPdfCondition = {
  /** Checks for equality with the object’s `accountStatementId` field. */
  accountStatementId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `fileKey` field. */
  fileKey?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `path` field. */
  path?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `AccountStatementPdf` object types. All fields are combined with a logical ‘and.’ */
export type AccountStatementPdfFilter = {
  /** Filter by the object’s `accountStatementId` field. */
  accountStatementId?: InputMaybe<IntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AccountStatementPdfFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `fileKey` field. */
  fileKey?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AccountStatementPdfFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AccountStatementPdfFilter>>;
  /** Filter by the object’s `path` field. */
  path?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `AccountStatementPdf` */
export type AccountStatementPdfInput = {
  /** Mutates a `AccountStatement` as part of the payload */
  accountStatement?: InputMaybe<AccountStatementInput>;
  accountStatementId?: InputMaybe<Scalars['Int']['input']>;
  fileKey: Scalars['String']['input'];
  path?: InputMaybe<Scalars['Upload']['input']>;
};

/** A connection to a list of `AccountStatementPdf` values. */
export type AccountStatementPdfsConnection = {
  __typename?: 'AccountStatementPdfsConnection';
  /** A list of edges which contains the `AccountStatementPdf` and cursor to aid in pagination. */
  edges: Array<AccountStatementPdfsEdge>;
  /** A list of `AccountStatementPdf` objects. */
  nodes: Array<AccountStatementPdf>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AccountStatementPdf` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `AccountStatementPdf` edge in the connection. */
export type AccountStatementPdfsEdge = {
  __typename?: 'AccountStatementPdfsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `AccountStatementPdf` at the end of the edge. */
  node: AccountStatementPdf;
};

/** Methods to use when ordering `AccountStatementPdf`. */
export enum AccountStatementPdfsOrderBy {
  ACCOUNT_STATEMENT_ID_ASC = 'ACCOUNT_STATEMENT_ID_ASC',
  ACCOUNT_STATEMENT_ID_DESC = 'ACCOUNT_STATEMENT_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DELETED_AT_ASC = 'DELETED_AT_ASC',
  DELETED_AT_DESC = 'DELETED_AT_DESC',
  FILE_KEY_ASC = 'FILE_KEY_ASC',
  FILE_KEY_DESC = 'FILE_KEY_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  PATH_ASC = 'PATH_ASC',
  PATH_DESC = 'PATH_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** A connection to a list of `AccountStatement` values. */
export type AccountStatementsConnection = {
  __typename?: 'AccountStatementsConnection';
  /** A list of edges which contains the `AccountStatement` and cursor to aid in pagination. */
  edges: Array<AccountStatementsEdge>;
  /** A list of `AccountStatement` objects. */
  nodes: Array<AccountStatement>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AccountStatement` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `AccountStatement` edge in the connection. */
export type AccountStatementsEdge = {
  __typename?: 'AccountStatementsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `AccountStatement` at the end of the edge. */
  node: AccountStatement;
};

/** Methods to use when ordering `AccountStatement`. */
export enum AccountStatementsOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  CURRENCY_CODE_ASC = 'CURRENCY_CODE_ASC',
  CURRENCY_CODE_DESC = 'CURRENCY_CODE_DESC',
  DELETED_AT_ASC = 'DELETED_AT_ASC',
  DELETED_AT_DESC = 'DELETED_AT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  INTEGRATION_ASC = 'INTEGRATION_ASC',
  INTEGRATION_DESC = 'INTEGRATION_DESC',
  INTEGRATION_KEY_ASC = 'INTEGRATION_KEY_ASC',
  INTEGRATION_KEY_DESC = 'INTEGRATION_KEY_DESC',
  INTERVAL_END_ASC = 'INTERVAL_END_ASC',
  INTERVAL_END_DESC = 'INTERVAL_END_DESC',
  INTERVAL_START_ASC = 'INTERVAL_START_ASC',
  INTERVAL_START_DESC = 'INTERVAL_START_DESC',
  IS_VALIDATED_ASC = 'IS_VALIDATED_ASC',
  IS_VALIDATED_DESC = 'IS_VALIDATED_DESC',
  METADATA_ASC = 'METADATA_ASC',
  METADATA_DESC = 'METADATA_DESC',
  NATURAL = 'NATURAL',
  NORMALIZED_CURRENCY_CODE_ASC = 'NORMALIZED_CURRENCY_CODE_ASC',
  NORMALIZED_CURRENCY_CODE_DESC = 'NORMALIZED_CURRENCY_CODE_DESC',
  OVERRIDE_AT_ASC = 'OVERRIDE_AT_ASC',
  OVERRIDE_AT_DESC = 'OVERRIDE_AT_DESC',
  OVERRIDE_CURRENCY_CODE_ASC = 'OVERRIDE_CURRENCY_CODE_ASC',
  OVERRIDE_CURRENCY_CODE_DESC = 'OVERRIDE_CURRENCY_CODE_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  STATEMENT_MONTH_ASC = 'STATEMENT_MONTH_ASC',
  STATEMENT_MONTH_DESC = 'STATEMENT_MONTH_DESC',
  STATEMENT_YEAR_ASC = 'STATEMENT_YEAR_ASC',
  STATEMENT_YEAR_DESC = 'STATEMENT_YEAR_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  UTILITY_ACCOUNT_ID_ASC = 'UTILITY_ACCOUNT_ID_ASC',
  UTILITY_ACCOUNT_ID_DESC = 'UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_STATEMENT_PDF_ID_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_STATEMENT_PDF_ID_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_STATEMENT_PDF_ID_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_STATEMENT_PDF_ID_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_COUNT_ASC = 'UTILITY_METER_STATEMENTS_COUNT_ASC',
  UTILITY_METER_STATEMENTS_COUNT_DESC = 'UTILITY_METER_STATEMENTS_COUNT_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_STATEMENT_PDF_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_STATEMENT_PDF_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_STATEMENT_PDF_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_STATEMENT_PDF_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_STATEMENT_PDF_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_STATEMENT_PDF_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_STATEMENT_PDF_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_STATEMENT_PDF_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_MAX_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_MAX_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_MAX_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_MAX_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_MAX_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_MAX_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_MAX_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_MAX_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_MAX_ACCOUNT_STATEMENT_PDF_ID_ASC = 'UTILITY_METER_STATEMENTS_MAX_ACCOUNT_STATEMENT_PDF_ID_ASC',
  UTILITY_METER_STATEMENTS_MAX_ACCOUNT_STATEMENT_PDF_ID_DESC = 'UTILITY_METER_STATEMENTS_MAX_ACCOUNT_STATEMENT_PDF_ID_DESC',
  UTILITY_METER_STATEMENTS_MAX_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_MAX_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_MAX_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_MAX_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_MAX_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_MAX_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_MAX_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_MAX_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_MAX_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_MAX_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_MAX_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_MAX_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_MAX_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_MAX_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_MAX_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_MAX_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_MAX_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_MAX_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_MAX_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_MAX_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_MAX_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_MAX_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_MAX_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_MAX_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_MAX_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_MAX_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_MAX_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_MAX_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_MAX_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_MAX_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_MAX_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_MAX_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_MAX_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_MAX_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_MAX_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_MAX_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_MAX_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_MAX_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_MAX_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_MAX_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_MAX_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_MAX_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_MAX_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_MAX_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_MAX_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_MAX_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_MAX_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_MAX_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_MAX_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_MAX_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_MAX_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_MAX_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_MAX_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_MAX_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_MAX_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_MAX_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_MAX_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_MAX_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_MAX_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_MAX_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_MAX_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_MAX_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_MAX_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_MAX_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_MAX_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_MAX_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_MAX_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_MAX_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_MAX_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_MAX_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_MAX_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_MAX_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_MAX_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_MAX_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_MAX_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_MAX_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_MIN_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_MIN_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_MIN_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_MIN_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_MIN_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_MIN_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_MIN_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_MIN_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_MIN_ACCOUNT_STATEMENT_PDF_ID_ASC = 'UTILITY_METER_STATEMENTS_MIN_ACCOUNT_STATEMENT_PDF_ID_ASC',
  UTILITY_METER_STATEMENTS_MIN_ACCOUNT_STATEMENT_PDF_ID_DESC = 'UTILITY_METER_STATEMENTS_MIN_ACCOUNT_STATEMENT_PDF_ID_DESC',
  UTILITY_METER_STATEMENTS_MIN_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_MIN_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_MIN_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_MIN_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_MIN_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_MIN_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_MIN_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_MIN_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_MIN_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_MIN_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_MIN_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_MIN_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_MIN_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_MIN_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_MIN_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_MIN_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_MIN_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_MIN_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_MIN_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_MIN_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_MIN_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_MIN_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_MIN_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_MIN_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_MIN_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_MIN_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_MIN_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_MIN_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_MIN_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_MIN_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_MIN_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_MIN_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_MIN_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_MIN_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_MIN_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_MIN_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_MIN_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_MIN_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_MIN_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_MIN_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_MIN_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_MIN_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_MIN_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_MIN_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_MIN_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_MIN_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_MIN_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_MIN_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_MIN_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_MIN_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_MIN_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_MIN_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_MIN_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_MIN_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_MIN_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_MIN_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_MIN_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_MIN_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_MIN_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_MIN_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_MIN_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_MIN_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_MIN_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_MIN_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_MIN_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_MIN_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_MIN_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_MIN_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_MIN_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_MIN_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_MIN_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_MIN_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_MIN_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_MIN_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_MIN_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_MIN_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_STATEMENT_PDF_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_STATEMENT_PDF_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_STATEMENT_PDF_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_STATEMENT_PDF_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_PDF_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_PDF_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_PDF_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_PDF_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_SUM_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_SUM_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_SUM_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_SUM_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_SUM_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_SUM_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_SUM_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_SUM_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_SUM_ACCOUNT_STATEMENT_PDF_ID_ASC = 'UTILITY_METER_STATEMENTS_SUM_ACCOUNT_STATEMENT_PDF_ID_ASC',
  UTILITY_METER_STATEMENTS_SUM_ACCOUNT_STATEMENT_PDF_ID_DESC = 'UTILITY_METER_STATEMENTS_SUM_ACCOUNT_STATEMENT_PDF_ID_DESC',
  UTILITY_METER_STATEMENTS_SUM_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_SUM_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_SUM_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_SUM_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_SUM_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_SUM_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_SUM_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_SUM_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_SUM_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_SUM_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_SUM_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_SUM_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_SUM_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_SUM_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_SUM_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_SUM_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_SUM_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_SUM_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_SUM_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_SUM_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_SUM_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_SUM_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_SUM_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_SUM_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_SUM_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_SUM_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_SUM_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_SUM_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_SUM_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_SUM_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_SUM_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_SUM_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_SUM_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_SUM_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_SUM_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_SUM_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_SUM_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_SUM_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_SUM_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_SUM_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_SUM_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_SUM_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_SUM_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_SUM_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_SUM_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_SUM_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_SUM_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_SUM_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_SUM_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_SUM_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_SUM_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_SUM_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_SUM_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_SUM_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_SUM_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_SUM_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_SUM_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_SUM_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_SUM_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_SUM_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_SUM_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_SUM_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_SUM_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_SUM_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_SUM_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_SUM_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_SUM_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_SUM_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_SUM_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_SUM_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_SUM_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_SUM_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_SUM_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_SUM_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_SUM_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_SUM_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_PDF_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_PDF_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_PDF_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_PDF_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_PDF_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_PDF_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_PDF_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_PDF_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_METER_ID_DESC'
}

export type AcknowledgeControlEventInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  controlEventId: Scalars['Int']['input'];
};

/** All input for the `acknowledgeIncident` mutation. */
export type AcknowledgeIncidentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  incidentId: Scalars['Int']['input'];
};

/** The output of our `acknowledgeIncident` mutation. */
export type AcknowledgeIncidentPayload = {
  __typename?: 'AcknowledgeIncidentPayload';
  /** Reads a single `CheckMonitor` that is related to this `Incident`. */
  checkMonitor?: Maybe<CheckMonitor>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  incident?: Maybe<Incident>;
  /** An edge for our `Incident`. May be used by Relay 1. */
  incidentEdge?: Maybe<IncidentsEdge>;
  /** Reads a single `MonitorDetection` that is related to this `Incident`. */
  monitorDetection?: Maybe<MonitorDetection>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our `acknowledgeIncident` mutation. */
export type AcknowledgeIncidentPayloadIncidentEdgeArgs = {
  orderBy?: InputMaybe<Array<IncidentsOrderBy>>;
};

export type AcknowledgeSuggestionInput = {
  acknowledge: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
};

export enum Acknowledgement {
  ACKNOWLEDGED = 'ACKNOWLEDGED',
  REJECTED = 'REJECTED',
  UNACKNOWLEDGED = 'UNACKNOWLEDGED'
}

/** A filter to be used against Acknowledgement fields. All fields are combined with a logical ‘and.’ */
export type AcknowledgementFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Acknowledgement>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Acknowledgement>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Acknowledgement>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Acknowledgement>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Acknowledgement>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Acknowledgement>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Acknowledgement>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Acknowledgement>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Acknowledgement>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Acknowledgement>>;
};

/** Represents an accessor of the platform */
export type Actor = {
  __typename?: 'Actor';
  /** The display name of the actor. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The ID of the actor. */
  id?: Maybe<Scalars['String']['output']>;
  /** The associated machine user for the given actor. */
  machineUser?: Maybe<MachineUser>;
  type?: Maybe<AccessTokenType>;
  /** The associated user for the given actor. */
  user?: Maybe<User>;
};

/** A filter to be used against `Actor` object types. All fields are combined with a logical ‘and.’ */
export type ActorFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ActorFilter>>;
  /** Filter by the object’s `displayName` field. */
  displayName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ActorFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ActorFilter>>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<AccessTokenTypeFilter>;
};

/** An input for mutations affecting `Actor` */
export type ActorInput = {
  type?: InputMaybe<AccessTokenType>;
};

/** All input for the `addFavoriteFacility` mutation. */
export type AddFavoriteFacilityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  facilityId?: InputMaybe<Scalars['Int']['input']>;
};

/** The output of our `addFavoriteFacility` mutation. */
export type AddFavoriteFacilityPayload = {
  __typename?: 'AddFavoriteFacilityPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
};

/** The output of our `addFavoriteFacility` mutation. */
export type AddFavoriteFacilityPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** All input for the `addMetricMetadataDependency` mutation. */
export type AddMetricMetadataDependencyInput = {
  childMetric: Scalars['String']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  parentMetric: Scalars['String']['input'];
};

/** The output of our `addMetricMetadataDependency` mutation. */
export type AddMetricMetadataDependencyPayload = {
  __typename?: 'AddMetricMetadataDependencyPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  metricMetadata?: Maybe<Array<MetricMetadatum>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type AddProjectControllerInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['Int']['input'];
  userId: Scalars['String']['input'];
};

export type AddProjectControllerPayload = {
  __typename?: 'AddProjectControllerPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  project: Project;
  user: User;
};

export type AddReportManagerInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  reportId: Scalars['Int']['input'];
  userId: Scalars['String']['input'];
};

export type AddReportManagerPayload = {
  __typename?: 'AddReportManagerPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  report: Report;
  user: User;
};

/** A short-lived monitor instance for testing evaluation */
export type AdhocMonitor = {
  __typename?: 'AdhocMonitor';
  /** Aggregates a data point for the specified filter expression */
  data?: Maybe<MetricDataConnection>;
  /** Aggregates a data point for the specified filter expression */
  evaluate?: Maybe<MetricDataConnection>;
};

/** A short-lived monitor instance for testing evaluation */
export type AdhocMonitorDataArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  to: Scalars['String']['input'];
};

/** A short-lived monitor instance for testing evaluation */
export type AdhocMonitorEvaluateArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  assumeActiveDetection?: Scalars['Boolean']['input'];
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  resultOutput?: MonitorResultOuput;
  to: Scalars['String']['input'];
};

/** A short-lived monitor instance for testing evaluation */
export type AdhocMonitorInput = {
  /** The aggregation method to use for the monitor */
  aggregationMethod?: MetricDataAggregationMethod;
  /** The condition to evaluate for the monitor */
  condition?: ThresholdCondition;
  /** The data points to monitor */
  dataPointIds: Array<Scalars['BigInt']['input']>;
  /** The Return-to-Normal (RTN) duration that a trigger condition must meet to resolve (default: instant). */
  rtnDuration?: InputMaybe<IntervalInput>;
  /** The Return-to-Normal (RTN) value that a trigger condition must meet to resolve (default: thresholdValue). */
  rtnValue?: InputMaybe<Scalars['JSON']['input']>;
  /** The time interval to bucket the underlying raw metric stream within */
  samplingWindow?: InputMaybe<IntervalInput>;
  /** The duration the condition must be met for */
  thresholdDuration?: IntervalInput;
  /** The value to compare the data point against */
  thresholdValue: Scalars['JSON']['input'];
  /** The time interval to bucket the result set within */
  window?: IntervalInput;
};

/** An appointment */
export type Appointment = Node & {
  __typename?: 'Appointment';
  /** The time of the appointment */
  appointmentTime: Scalars['Datetime']['output'];
  /** The confirmation ID given when the appointment was confirmed */
  confirmationId: Scalars['String']['output'];
  /** The time when this record was created */
  createdAt: Scalars['Datetime']['output'];
  /** The time when this record was deleted */
  deletedAt?: Maybe<Scalars['Datetime']['output']>;
  /** Indicates if the appointment has been associated with a trailer appointment. */
  hasTrailerAppointment?: Maybe<Scalars['Boolean']['output']>;
  /** The internal ID of this appointment */
  id: Scalars['Int']['output'];
  /** The type of the load */
  loadType: LoadType;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The type of the order */
  orderType: OrderType;
  /** Reads a single `TrailerAppointment` that is related to this `Appointment`. */
  trailerAppointment?: Maybe<TrailerAppointment>;
  /** The time when this record was last updated */
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `Yard` that is related to this `Appointment`. */
  yard?: Maybe<Yard>;
  /** The yard to which this appointment belongs */
  yardId: Scalars['Int']['output'];
};

/**
 * A condition to be used against `Appointment` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type AppointmentCondition = {
  /** Checks for equality with the object’s `appointmentTime` field. */
  appointmentTime?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `confirmationId` field. */
  confirmationId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `loadType` field. */
  loadType?: InputMaybe<LoadType>;
  /** Checks for equality with the object’s `orderType` field. */
  orderType?: InputMaybe<OrderType>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `yardId` field. */
  yardId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `Appointment` object types. All fields are combined with a logical ‘and.’ */
export type AppointmentFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AppointmentFilter>>;
  /** Filter by the object’s `appointmentTime` field. */
  appointmentTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `confirmationId` field. */
  confirmationId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `hasTrailerAppointment` field. */
  hasTrailerAppointment?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `loadType` field. */
  loadType?: InputMaybe<LoadTypeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AppointmentFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AppointmentFilter>>;
  /** Filter by the object’s `orderType` field. */
  orderType?: InputMaybe<OrderTypeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `yardId` field. */
  yardId?: InputMaybe<IntFilter>;
};

/** A connection to a list of `Appointment` values. */
export type AppointmentsConnection = {
  __typename?: 'AppointmentsConnection';
  /** A list of edges which contains the `Appointment` and cursor to aid in pagination. */
  edges: Array<AppointmentsEdge>;
  /** A list of `Appointment` objects. */
  nodes: Array<Appointment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Appointment` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Appointment` edge in the connection. */
export type AppointmentsEdge = {
  __typename?: 'AppointmentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Appointment` at the end of the edge. */
  node: Appointment;
};

/** Methods to use when ordering `Appointment`. */
export enum AppointmentsOrderBy {
  APPOINTMENT_TIME_ASC = 'APPOINTMENT_TIME_ASC',
  APPOINTMENT_TIME_DESC = 'APPOINTMENT_TIME_DESC',
  CONFIRMATION_ID_ASC = 'CONFIRMATION_ID_ASC',
  CONFIRMATION_ID_DESC = 'CONFIRMATION_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DELETED_AT_ASC = 'DELETED_AT_ASC',
  DELETED_AT_DESC = 'DELETED_AT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LOAD_TYPE_ASC = 'LOAD_TYPE_ASC',
  LOAD_TYPE_DESC = 'LOAD_TYPE_DESC',
  NATURAL = 'NATURAL',
  ORDER_TYPE_ASC = 'ORDER_TYPE_ASC',
  ORDER_TYPE_DESC = 'ORDER_TYPE_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  YARD_ID_ASC = 'YARD_ID_ASC',
  YARD_ID_DESC = 'YARD_ID_DESC'
}

/** Represents the result of an assessment performed on a monitored asset over a time interval. */
export type Assessment = Node & {
  __typename?: 'Assessment';
  /** The end date of the analysis window. */
  analysisEnd: Scalars['Date']['output'];
  /** The start date of the analysis window. */
  analysisStart: Scalars['Date']['output'];
  /** Reads a single `AssessmentType` that is related to this `Assessment`. */
  assessmentType?: Maybe<AssessmentType>;
  /** References the assessment type used. */
  assessmentTypeId: Scalars['Int']['output'];
  /** Reads and enables pagination through a set of `ClassificationResult`. */
  classificationResults: ClassificationResultsConnection;
  /** The time the record was created. */
  createdAt: Scalars['Datetime']['output'];
  /** Whether any results within this assessment are inconclusive. */
  hasInconclusiveResults?: Maybe<Scalars['Boolean']['output']>;
  /** The identifier of the assessment. */
  id: Scalars['Int']['output'];
  isSignificant: Scalars['Boolean']['output'];
  /** Reads a single `MonitoredAsset` that is related to this `Assessment`. */
  monitoredAsset?: Maybe<MonitoredAsset>;
  /** References the monitored asset being assessed. */
  monitoredAssetId: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The computed health score of the asset based on classification results. */
  score: Scalars['BigFloat']['output'];
  /** The time the assessment was last summarized. */
  summarizedAt?: Maybe<Scalars['Datetime']['output']>;
  /** A summary or explanation of the assessment outcome. */
  summary?: Maybe<Scalars['String']['output']>;
  /** The time the record was last updated. */
  updatedAt: Scalars['Datetime']['output'];
};

/** Represents the result of an assessment performed on a monitored asset over a time interval. */
export type AssessmentClassificationResultsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ClassificationResultCondition>;
  filter?: InputMaybe<ClassificationResultFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ClassificationResultsOrderBy>>;
};

/**
 * A condition to be used against `Assessment` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type AssessmentCondition = {
  /** Checks for equality with the object’s `analysisEnd` field. */
  analysisEnd?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `analysisStart` field. */
  analysisStart?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `assessmentTypeId` field. */
  assessmentTypeId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `hasInconclusiveResults` field. */
  hasInconclusiveResults?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `isSignificant` field. */
  isSignificant?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `monitoredAssetId` field. */
  monitoredAssetId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `score` field. */
  score?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `summarizedAt` field. */
  summarizedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `summary` field. */
  summary?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `Assessment` object types. All fields are combined with a logical ‘and.’ */
export type AssessmentFilter = {
  /** Filter by the object’s `analysisEnd` field. */
  analysisEnd?: InputMaybe<DateFilter>;
  /** Filter by the object’s `analysisStart` field. */
  analysisStart?: InputMaybe<DateFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AssessmentFilter>>;
  /** Filter by the object’s `assessmentTypeId` field. */
  assessmentTypeId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `hasInconclusiveResults` field. */
  hasInconclusiveResults?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isSignificant` field. */
  isSignificant?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `monitoredAssetId` field. */
  monitoredAssetId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AssessmentFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AssessmentFilter>>;
  /** Filter by the object’s `score` field. */
  score?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `summarizedAt` field. */
  summarizedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `summary` field. */
  summary?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `Assessment` */
export type AssessmentInput = {
  /** The end date of the analysis window. */
  analysisEnd: Scalars['Date']['input'];
  /** The start date of the analysis window. */
  analysisStart: Scalars['Date']['input'];
  /** References the assessment type used. */
  assessmentTypeId: Scalars['Int']['input'];
  isSignificant?: InputMaybe<Scalars['Boolean']['input']>;
  /** References the monitored asset being assessed. */
  monitoredAssetId: Scalars['Int']['input'];
  /** The computed health score of the asset based on classification results. */
  score?: InputMaybe<Scalars['BigFloat']['input']>;
  /** A summary or explanation of the assessment outcome. */
  summary?: InputMaybe<Scalars['String']['input']>;
};

/** Represents an update to a `Assessment`. Fields that are set will be updated. */
export type AssessmentPatch = {
  /** The end date of the analysis window. */
  analysisEnd?: InputMaybe<Scalars['Date']['input']>;
  /** The start date of the analysis window. */
  analysisStart?: InputMaybe<Scalars['Date']['input']>;
  /** References the assessment type used. */
  assessmentTypeId?: InputMaybe<Scalars['Int']['input']>;
  isSignificant?: InputMaybe<Scalars['Boolean']['input']>;
  /** References the monitored asset being assessed. */
  monitoredAssetId?: InputMaybe<Scalars['Int']['input']>;
  /** The computed health score of the asset based on classification results. */
  score?: InputMaybe<Scalars['BigFloat']['input']>;
  /** A summary or explanation of the assessment outcome. */
  summary?: InputMaybe<Scalars['String']['input']>;
};

/** Defines a specific type of assessment, used to evaluate equipment condition within a software package. */
export type AssessmentType = Node & {
  __typename?: 'AssessmentType';
  /** Reads and enables pagination through a set of `Assessment`. */
  assessments: AssessmentsConnection;
  /** Reads and enables pagination through a set of `Classification`. */
  classifications: ClassificationsConnection;
  /** The time the record was created. */
  createdAt: Scalars['Datetime']['output'];
  /** A description of what the assessment type represents and evaluates. */
  description: Scalars['String']['output'];
  /** The identifier of the assessment type. */
  id: Scalars['Int']['output'];
  /** The display name of the assessment type. */
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The unique slug used to reference the assessment type. */
  slug: Scalars['String']['output'];
  /** Reads a single `SoftwarePackage` that is related to this `AssessmentType`. */
  softwarePackage?: Maybe<SoftwarePackage>;
  /** References the software package this assessment type belongs to. */
  softwarePackageId: Scalars['Int']['output'];
  /** The time the record was last updated. */
  updatedAt: Scalars['Datetime']['output'];
};

/** Defines a specific type of assessment, used to evaluate equipment condition within a software package. */
export type AssessmentTypeAssessmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AssessmentCondition>;
  filter?: InputMaybe<AssessmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AssessmentsOrderBy>>;
};

/** Defines a specific type of assessment, used to evaluate equipment condition within a software package. */
export type AssessmentTypeClassificationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ClassificationCondition>;
  filter?: InputMaybe<ClassificationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ClassificationsOrderBy>>;
};

/**
 * A condition to be used against `AssessmentType` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AssessmentTypeCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `slug` field. */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `softwarePackageId` field. */
  softwarePackageId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `AssessmentType` object types. All fields are combined with a logical ‘and.’ */
export type AssessmentTypeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AssessmentTypeFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AssessmentTypeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AssessmentTypeFilter>>;
  /** Filter by the object’s `slug` field. */
  slug?: InputMaybe<StringFilter>;
  /** Filter by the object’s `softwarePackageId` field. */
  softwarePackageId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `AssessmentType` */
export type AssessmentTypeInput = {
  /** A description of what the assessment type represents and evaluates. */
  description: Scalars['String']['input'];
  /** The display name of the assessment type. */
  name: Scalars['String']['input'];
  /** The unique slug used to reference the assessment type. */
  slug: Scalars['String']['input'];
  /** References the software package this assessment type belongs to. */
  softwarePackageId: Scalars['Int']['input'];
};

/** Represents an update to a `AssessmentType`. Fields that are set will be updated. */
export type AssessmentTypePatch = {
  /** A description of what the assessment type represents and evaluates. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The display name of the assessment type. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The unique slug used to reference the assessment type. */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** References the software package this assessment type belongs to. */
  softwarePackageId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `AssessmentType` values. */
export type AssessmentTypesConnection = {
  __typename?: 'AssessmentTypesConnection';
  /** A list of edges which contains the `AssessmentType` and cursor to aid in pagination. */
  edges: Array<AssessmentTypesEdge>;
  /** A list of `AssessmentType` objects. */
  nodes: Array<AssessmentType>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AssessmentType` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `AssessmentType` edge in the connection. */
export type AssessmentTypesEdge = {
  __typename?: 'AssessmentTypesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `AssessmentType` at the end of the edge. */
  node: AssessmentType;
};

/** Methods to use when ordering `AssessmentType`. */
export enum AssessmentTypesOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  SLUG_ASC = 'SLUG_ASC',
  SLUG_DESC = 'SLUG_DESC',
  SOFTWARE_PACKAGE_ID_ASC = 'SOFTWARE_PACKAGE_ID_ASC',
  SOFTWARE_PACKAGE_ID_DESC = 'SOFTWARE_PACKAGE_ID_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** A connection to a list of `Assessment` values. */
export type AssessmentsConnection = {
  __typename?: 'AssessmentsConnection';
  /** A list of edges which contains the `Assessment` and cursor to aid in pagination. */
  edges: Array<AssessmentsEdge>;
  /** A list of `Assessment` objects. */
  nodes: Array<Assessment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Assessment` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Assessment` edge in the connection. */
export type AssessmentsEdge = {
  __typename?: 'AssessmentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Assessment` at the end of the edge. */
  node: Assessment;
};

/** Methods to use when ordering `Assessment`. */
export enum AssessmentsOrderBy {
  ANALYSIS_END_ASC = 'ANALYSIS_END_ASC',
  ANALYSIS_END_DESC = 'ANALYSIS_END_DESC',
  ANALYSIS_START_ASC = 'ANALYSIS_START_ASC',
  ANALYSIS_START_DESC = 'ANALYSIS_START_DESC',
  ASSESSMENT_TYPE_ID_ASC = 'ASSESSMENT_TYPE_ID_ASC',
  ASSESSMENT_TYPE_ID_DESC = 'ASSESSMENT_TYPE_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  IS_SIGNIFICANT_ASC = 'IS_SIGNIFICANT_ASC',
  IS_SIGNIFICANT_DESC = 'IS_SIGNIFICANT_DESC',
  MONITORED_ASSET_ID_ASC = 'MONITORED_ASSET_ID_ASC',
  MONITORED_ASSET_ID_DESC = 'MONITORED_ASSET_ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  SCORE_ASC = 'SCORE_ASC',
  SCORE_DESC = 'SCORE_DESC',
  SUMMARIZED_AT_ASC = 'SUMMARIZED_AT_ASC',
  SUMMARIZED_AT_DESC = 'SUMMARIZED_AT_DESC',
  SUMMARY_ASC = 'SUMMARY_ASC',
  SUMMARY_DESC = 'SUMMARY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

export type Asset = {
  nodeId: Scalars['ID']['output'];
};

export type AssignSpaceInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  spaceId: Scalars['Int']['input'];
  trailerId: Scalars['Int']['input'];
  yardId: Scalars['Int']['input'];
};

export type AssignSpacePayload = {
  __typename?: 'AssignSpacePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  driver?: Maybe<Driver>;
  parkingSession: ParkSession;
  space: Space;
  trailer: Trailer;
  trailerAppointment?: Maybe<TrailerAppointment>;
};

export type AttributePairInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export enum AuthType {
  ACCESS_TOKEN = 'ACCESS_TOKEN',
  OAUTH2 = 'OAUTH2'
}

/** A filter to be used against AuthType fields. All fields are combined with a logical ‘and.’ */
export type AuthTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<AuthType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<AuthType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<AuthType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<AuthType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<AuthType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<AuthType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<AuthType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<AuthType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<AuthType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<AuthType>>;
};

/** A connection to a list of `BalancingAuthority` values. */
export type BalancingAuthoritiesConnection = {
  __typename?: 'BalancingAuthoritiesConnection';
  /** A list of edges which contains the `BalancingAuthority` and cursor to aid in pagination. */
  edges: Array<BalancingAuthoritiesEdge>;
  /** The grid demand value for the associated balancing authority. */
  gridDemand?: Maybe<MetricDataConnection>;
  /** A list of `BalancingAuthority` objects. */
  nodes: Array<BalancingAuthority>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BalancingAuthority` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A connection to a list of `BalancingAuthority` values. */
export type BalancingAuthoritiesConnectionGridDemandArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A `BalancingAuthority` edge in the connection. */
export type BalancingAuthoritiesEdge = {
  __typename?: 'BalancingAuthoritiesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `BalancingAuthority` at the end of the edge. */
  node: BalancingAuthority;
};

/** Methods to use when ordering `BalancingAuthority`. */
export enum BalancingAuthoritiesOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  GEOMETRY_ASC = 'GEOMETRY_ASC',
  GEOMETRY_DESC = 'GEOMETRY_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  SLUG_ASC = 'SLUG_ASC',
  SLUG_DESC = 'SLUG_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** Represents a balancing authority associated with emissions rate data. */
export type BalancingAuthority = Node & {
  __typename?: 'BalancingAuthority';
  /** The time the program was created. */
  createdAt: Scalars['Datetime']['output'];
  /** The facilities located in the region supported by the balancing authority. */
  facilitiesByArea: FacilitiesConnection;
  /** The geometry information of the balancing authority. */
  geometry?: Maybe<GeometryInterface>;
  /** The grid demand value for the associated balancing authority. */
  gridDemand?: Maybe<MetricDataConnection>;
  /** Returns the derived data point configuration for this connection */
  gridDemandDataPoint?: Maybe<DerivedDataPoint>;
  /** The identifer of the balancing authority. */
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `PricingNode`. */
  pricingNodes: PricingNodesConnection;
  /** The slug identifier of the balancing authority. */
  slug: Scalars['String']['output'];
  /** The time the program was updated. */
  updatedAt: Scalars['Datetime']['output'];
};

/** Represents a balancing authority associated with emissions rate data. */
export type BalancingAuthorityFacilitiesByAreaArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<FacilityFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents a balancing authority associated with emissions rate data. */
export type BalancingAuthorityGridDemandArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** Represents a balancing authority associated with emissions rate data. */
export type BalancingAuthorityPricingNodesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PricingNodeCondition>;
  filter?: InputMaybe<PricingNodeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PricingNodesOrderBy>>;
};

/**
 * A condition to be used against `BalancingAuthority` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type BalancingAuthorityCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `geometry` field. */
  geometry?: InputMaybe<Scalars['GeoJSON']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `slug` field. */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `BalancingAuthority` object types. All fields are combined with a logical ‘and.’ */
export type BalancingAuthorityFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BalancingAuthorityFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BalancingAuthorityFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BalancingAuthorityFilter>>;
  /** Filter by the object’s `slug` field. */
  slug?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `BalancingAuthority` */
export type BalancingAuthorityInput = {
  /** The geometry information of the balancing authority. */
  geometry?: InputMaybe<Scalars['GeoJSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** The slug identifier of the balancing authority. */
  slug: Scalars['String']['input'];
};

/** Represents an update to a `BalancingAuthority`. Fields that are set will be updated. */
export type BalancingAuthorityPatch = {
  /** The geometry information of the balancing authority. */
  geometry?: InputMaybe<Scalars['GeoJSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** The slug identifier of the balancing authority. */
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against BigFloat fields. All fields are combined with a logical ‘and.’ */
export type BigFloatFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['BigFloat']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['BigFloat']['input']>>;
};

/** A filter to be used against BigInt fields. All fields are combined with a logical ‘and.’ */
export type BigIntFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['BigInt']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['BigInt']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['BigInt']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['BigInt']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

/** A billable customer */
export type BillableCustomer = Node & {
  __typename?: 'BillableCustomer';
  /** The carrier code of this customer */
  carrierCode: Scalars['String']['output'];
  /** The time when this record was created */
  createdAt: Scalars['Datetime']['output'];
  /** Reads and enables pagination through a set of `CustomerBillingRate`. */
  customerBillingRatesByCustomerId: CustomerBillingRatesConnection;
  /** The internal ID of this customer */
  id: Scalars['Int']['output'];
  /** The name of this customer */
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `SubmeterSession`. */
  submeterSessionsByAssociatedCustomerId: SubmeterSessionsConnection;
  /** The time when this record was updated */
  updatedAt: Scalars['Datetime']['output'];
};

/** A billable customer */
export type BillableCustomerCustomerBillingRatesByCustomerIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CustomerBillingRateCondition>;
  filter?: InputMaybe<CustomerBillingRateFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CustomerBillingRatesOrderBy>>;
};

/** A billable customer */
export type BillableCustomerSubmeterSessionsByAssociatedCustomerIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SubmeterSessionCondition>;
  filter?: InputMaybe<SubmeterSessionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SubmeterSessionsOrderBy>>;
};

/**
 * A condition to be used against `BillableCustomer` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type BillableCustomerCondition = {
  /** Checks for equality with the object’s `carrierCode` field. */
  carrierCode?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `BillableCustomer` object types. All fields are combined with a logical ‘and.’ */
export type BillableCustomerFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BillableCustomerFilter>>;
  /** Filter by the object’s `carrierCode` field. */
  carrierCode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BillableCustomerFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BillableCustomerFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `BillableCustomer` */
export type BillableCustomerInput = {
  /** The carrier code of this customer */
  carrierCode: Scalars['String']['input'];
  /** The name of this customer */
  name: Scalars['String']['input'];
};

/** Represents an update to a `BillableCustomer`. Fields that are set will be updated. */
export type BillableCustomerPatch = {
  /** The carrier code of this customer */
  carrierCode?: InputMaybe<Scalars['String']['input']>;
  /** The name of this customer */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `BillableCustomer` values. */
export type BillableCustomersConnection = {
  __typename?: 'BillableCustomersConnection';
  /** A list of edges which contains the `BillableCustomer` and cursor to aid in pagination. */
  edges: Array<BillableCustomersEdge>;
  /** A list of `BillableCustomer` objects. */
  nodes: Array<BillableCustomer>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BillableCustomer` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `BillableCustomer` edge in the connection. */
export type BillableCustomersEdge = {
  __typename?: 'BillableCustomersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `BillableCustomer` at the end of the edge. */
  node: BillableCustomer;
};

/** Methods to use when ordering `BillableCustomer`. */
export enum BillableCustomersOrderBy {
  CARRIER_CODE_ASC = 'CARRIER_CODE_ASC',
  CARRIER_CODE_DESC = 'CARRIER_CODE_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** A single or multiple blast locations. This could be a blast cell, a grouping of blast locations, or some other type of blast. */
export type Blast = Node & {
  __typename?: 'Blast';
  /** Reads a single `DataPoint` that is related to this `Blast`. */
  actualUtilization?: Maybe<DataPoint>;
  /** The actual utilization metric */
  actualUtilizationId?: Maybe<Scalars['BigInt']['output']>;
  /** The total capacity of the blast, which is set when warehouse data is unavailable */
  assumedPalletCapacity?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `Blast`. */
  automationState?: Maybe<DataPoint>;
  /** An IOT datapoint indicating the current automation state, usually indicating if the facility has enabled automation (where available) */
  automationStateId?: Maybe<Scalars['BigInt']['output']>;
  /** Reads and enables pagination through a set of `BlastEvaporator`. */
  blastEvaporators: BlastEvaporatorsConnection;
  /** Reads and enables pagination through a set of `BlastPallet`. */
  blastPallets: BlastPalletsConnection;
  /** Reads and enables pagination through a set of `BlastRotation`. */
  blastRotations: BlastRotationsConnection;
  /** Reads a single `BlastType` that is related to this `Blast`. */
  blastType?: Maybe<BlastType>;
  /** The type of blast */
  blastTypeId: Scalars['Int']['output'];
  /** Reads a single `BuildingArea` that is related to this `Blast`. */
  buildingArea?: Maybe<BuildingArea>;
  /** The associated physical location within the facility */
  buildingAreaId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `Component` that is related to this `Blast`. */
  component?: Maybe<Component>;
  /** The associated component for control purposes, if available */
  componentId?: Maybe<Scalars['Int']['output']>;
  /** The time at which the record was created */
  createdAt: Scalars['Datetime']['output'];
  /** Reads and enables pagination through a set of `Evaporator`. */
  evaporators: EvaporatorsConnection;
  /** Reads a single `Facility` that is related to this `Blast`. */
  facility?: Maybe<Facility>;
  /** The facility a blast is within */
  facilityId: Scalars['Int']['output'];
  /** The unique, auto-generated ID of the record */
  id: Scalars['Int']['output'];
  /** Reads a single `DataPoint` that is related to this `Blast`. */
  idealUtilization?: Maybe<DataPoint>;
  /** The ideal utilization metric */
  idealUtilizationId?: Maybe<Scalars['BigInt']['output']>;
  /** Indicator for noting if a blast is currently being used as a blast. In some cases, a blast can be used as a general storage location */
  isActive: Scalars['Boolean']['output'];
  /** The unique local (facility-level) human-readable label of the blast */
  label: Scalars['String']['output'];
  /** Metadata information for a blast */
  metadata: Scalars['JSON']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `PalletLocation`. */
  palletLocations: PalletLocationsConnection;
  /** Indicator for determining an automation-enabled blast */
  remoteEnabled: Scalars['Boolean']['output'];
  /** Reads a single `DataPoint` that is related to this `Blast`. */
  stagingTimer?: Maybe<DataPoint>;
  /** An IOT datapoint indicating the time-delay if a blast has had its start time delayed by the control system */
  stagingTimerId?: Maybe<Scalars['BigInt']['output']>;
  /** Reads a single `DataPoint` that is related to this `Blast`. */
  state?: Maybe<DataPoint>;
  /** An IOT datapoint indicating the state of the blast */
  stateId?: Maybe<Scalars['BigInt']['output']>;
  /** Reads a single `DataPoint` that is related to this `Blast`. */
  timer?: Maybe<DataPoint>;
  /** An IOT datapoint indicating the amount of time left with a blast refrigeration cycle (if the facility uses this method) */
  timerId?: Maybe<Scalars['BigInt']['output']>;
  /** The time at which the record was updated */
  updatedAt: Scalars['Datetime']['output'];
  /**
   * The date when warehouse data is
   * available for the facility, which will inform when pallet information can be automatically gathered
   */
  warehouseDataAvailabilityStartDate?: Maybe<Scalars['Date']['output']>;
};

/** A single or multiple blast locations. This could be a blast cell, a grouping of blast locations, or some other type of blast. */
export type BlastBlastEvaporatorsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BlastEvaporatorCondition>;
  filter?: InputMaybe<BlastEvaporatorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BlastEvaporatorsOrderBy>>;
};

/** A single or multiple blast locations. This could be a blast cell, a grouping of blast locations, or some other type of blast. */
export type BlastBlastPalletsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BlastPalletCondition>;
  filter?: InputMaybe<BlastPalletFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BlastPalletsOrderBy>>;
};

/** A single or multiple blast locations. This could be a blast cell, a grouping of blast locations, or some other type of blast. */
export type BlastBlastRotationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BlastRotationCondition>;
  filter?: InputMaybe<BlastRotationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BlastRotationsOrderBy>>;
};

/** A single or multiple blast locations. This could be a blast cell, a grouping of blast locations, or some other type of blast. */
export type BlastEvaporatorsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<EvaporatorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** A single or multiple blast locations. This could be a blast cell, a grouping of blast locations, or some other type of blast. */
export type BlastPalletLocationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<PalletLocationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** A condition to be used against `Blast` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type BlastCondition = {
  /** Checks for equality with the object’s `actualUtilizationId` field. */
  actualUtilizationId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `assumedPalletCapacity` field. */
  assumedPalletCapacity?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `automationStateId` field. */
  automationStateId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `blastTypeId` field. */
  blastTypeId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `buildingAreaId` field. */
  buildingAreaId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `componentId` field. */
  componentId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `idealUtilizationId` field. */
  idealUtilizationId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `isActive` field. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `label` field. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `metadata` field. */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `remoteEnabled` field. */
  remoteEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `stagingTimerId` field. */
  stagingTimerId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `stateId` field. */
  stateId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `timerId` field. */
  timerId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A linker for indicating which evaporators are used for a blast location */
export type BlastEvaporator = Node & {
  __typename?: 'BlastEvaporator';
  /** Reads a single `Blast` that is related to this `BlastEvaporator`. */
  blast?: Maybe<Blast>;
  /** The associated blast */
  blastId?: Maybe<Scalars['Int']['output']>;
  /** The time at which the record was created */
  createdAt: Scalars['Datetime']['output'];
  /** Reads a single `Evaporator` that is related to this `BlastEvaporator`. */
  evaporator?: Maybe<Evaporator>;
  /** The associated evaporator */
  evaporatorId?: Maybe<Scalars['Int']['output']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The time at which the record was updated */
  updatedAt: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `BlastEvaporator` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type BlastEvaporatorCondition = {
  /** Checks for equality with the object’s `blastId` field. */
  blastId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `evaporatorId` field. */
  evaporatorId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `BlastEvaporator` object types. All fields are combined with a logical ‘and.’ */
export type BlastEvaporatorFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BlastEvaporatorFilter>>;
  /** Filter by the object’s `blastId` field. */
  blastId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `evaporatorId` field. */
  evaporatorId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BlastEvaporatorFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BlastEvaporatorFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `BlastEvaporator` */
export type BlastEvaporatorInput = {
  /** Mutates a `Blast` as part of the payload */
  blast?: InputMaybe<BlastInput>;
  /** The associated blast */
  blastId?: InputMaybe<Scalars['Int']['input']>;
  /** Mutates a `Evaporator` as part of the payload */
  evaporator?: InputMaybe<EvaporatorInput>;
  /** The associated evaporator */
  evaporatorId?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents an update to a `BlastEvaporator`. Fields that are set will be updated. */
export type BlastEvaporatorPatch = {
  /** The associated blast */
  blastId?: InputMaybe<Scalars['Int']['input']>;
  /** The associated evaporator */
  evaporatorId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `BlastEvaporator` values. */
export type BlastEvaporatorsConnection = {
  __typename?: 'BlastEvaporatorsConnection';
  /** A list of edges which contains the `BlastEvaporator` and cursor to aid in pagination. */
  edges: Array<BlastEvaporatorsEdge>;
  /** A list of `BlastEvaporator` objects. */
  nodes: Array<BlastEvaporator>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BlastEvaporator` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `BlastEvaporator` edge in the connection. */
export type BlastEvaporatorsEdge = {
  __typename?: 'BlastEvaporatorsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `BlastEvaporator` at the end of the edge. */
  node: BlastEvaporator;
};

/** Methods to use when ordering `BlastEvaporator`. */
export enum BlastEvaporatorsOrderBy {
  BLAST_ID_ASC = 'BLAST_ID_ASC',
  BLAST_ID_DESC = 'BLAST_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  EVAPORATOR_ID_ASC = 'EVAPORATOR_ID_ASC',
  EVAPORATOR_ID_DESC = 'EVAPORATOR_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** A filter to be used against `Blast` object types. All fields are combined with a logical ‘and.’ */
export type BlastFilter = {
  /** Filter by the object’s `actualUtilizationId` field. */
  actualUtilizationId?: InputMaybe<BigIntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BlastFilter>>;
  /** Filter by the object’s `assumedPalletCapacity` field. */
  assumedPalletCapacity?: InputMaybe<IntFilter>;
  /** Filter by the object’s `automationStateId` field. */
  automationStateId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `blastTypeId` field. */
  blastTypeId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `buildingAreaId` field. */
  buildingAreaId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `componentId` field. */
  componentId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `idealUtilizationId` field. */
  idealUtilizationId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `isActive` field. */
  isActive?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `label` field. */
  label?: InputMaybe<StringFilter>;
  /** Filter by the object’s `metadata` field. */
  metadata?: InputMaybe<JsonFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BlastFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BlastFilter>>;
  /** Filter by the object’s `remoteEnabled` field. */
  remoteEnabled?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `stagingTimerId` field. */
  stagingTimerId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `stateId` field. */
  stateId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `timerId` field. */
  timerId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `warehouseDataAvailabilityStartDate` field. */
  warehouseDataAvailabilityStartDate?: InputMaybe<DateFilter>;
};

/** An input for mutations affecting `Blast` */
export type BlastInput = {
  /** The actual utilization metric */
  actualUtilizationId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The total capacity of the blast, which is set when warehouse data is unavailable */
  assumedPalletCapacity?: InputMaybe<Scalars['Int']['input']>;
  /** An IOT datapoint indicating the current automation state, usually indicating if the facility has enabled automation (where available) */
  automationStateId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Mutates a `BlastType` as part of the payload */
  blastType?: InputMaybe<BlastTypeInput>;
  /** The type of blast */
  blastTypeId?: InputMaybe<Scalars['Int']['input']>;
  /** Mutates a `BuildingArea` as part of the payload */
  buildingArea?: InputMaybe<BuildingAreaInput>;
  /** The associated physical location within the facility */
  buildingAreaId?: InputMaybe<Scalars['Int']['input']>;
  /** The associated component for control purposes, if available */
  componentId?: InputMaybe<Scalars['Int']['input']>;
  /** Mutates a `DataPoint` as part of the payload */
  dataPoint?: InputMaybe<DataPointInput>;
  /** The facility a blast is within */
  facilityId: Scalars['Int']['input'];
  /** The ideal utilization metric */
  idealUtilizationId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Indicator for noting if a blast is currently being used as a blast. In some cases, a blast can be used as a general storage location */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** The unique local (facility-level) human-readable label of the blast */
  label: Scalars['String']['input'];
  /** Metadata information for a blast */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** Indicator for determining an automation-enabled blast */
  remoteEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** An IOT datapoint indicating the time-delay if a blast has had its start time delayed by the control system */
  stagingTimerId?: InputMaybe<Scalars['BigInt']['input']>;
  /** An IOT datapoint indicating the state of the blast */
  stateId?: InputMaybe<Scalars['BigInt']['input']>;
  /** An IOT datapoint indicating the amount of time left with a blast refrigeration cycle (if the facility uses this method) */
  timerId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** Pallets that have entered a blast at some point in their pallet event history */
export type BlastPallet = Node & {
  __typename?: 'BlastPallet';
  /** Reads a single `Blast` that is related to this `BlastPallet`. */
  blast?: Maybe<Blast>;
  /** The associated blast (determined by the pallet locations registered in blastPalletLocations) */
  blastId: Scalars['Int']['output'];
  /** The time at which the record was created */
  createdAt: Scalars['Datetime']['output'];
  /** The unique, auto-generated ID of the record */
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Pallet` that is related to this `BlastPallet`. */
  pallet?: Maybe<Pallet>;
  /** The time when a pallet was placed / dropped in the pallet location */
  palletDropTime?: Maybe<Scalars['Datetime']['output']>;
  /** The associated pallet */
  palletId: Scalars['Int']['output'];
  /** The time when a pallet was removed / picked from the pallet location */
  palletPickTime?: Maybe<Scalars['Datetime']['output']>;
  /** The time at which the record was updated */
  updatedAt: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `BlastPallet` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type BlastPalletCondition = {
  /** Checks for equality with the object’s `blastId` field. */
  blastId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `palletDropTime` field. */
  palletDropTime?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `palletId` field. */
  palletId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `palletPickTime` field. */
  palletPickTime?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `BlastPallet` object types. All fields are combined with a logical ‘and.’ */
export type BlastPalletFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BlastPalletFilter>>;
  /** Filter by the object’s `blastId` field. */
  blastId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BlastPalletFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BlastPalletFilter>>;
  /** Filter by the object’s `palletDropTime` field. */
  palletDropTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `palletId` field. */
  palletId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `palletPickTime` field. */
  palletPickTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `BlastPallet` */
export type BlastPalletInput = {
  /** Mutates a `Blast` as part of the payload */
  blast?: InputMaybe<BlastInput>;
  /** The associated blast (determined by the pallet locations registered in blastPalletLocations) */
  blastId?: InputMaybe<Scalars['Int']['input']>;
  /** Mutates a `Pallet` as part of the payload */
  pallet?: InputMaybe<PalletInput>;
  /** The time when a pallet was placed / dropped in the pallet location */
  palletDropTime?: InputMaybe<Scalars['Datetime']['input']>;
  /** The associated pallet */
  palletId?: InputMaybe<Scalars['Int']['input']>;
  /** The time when a pallet was removed / picked from the pallet location */
  palletPickTime?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A list of all pallet locations contained within a physical blast location */
export type BlastPalletLocation = Node & {
  __typename?: 'BlastPalletLocation';
  /** Reads a single `Blast` that is related to this `BlastPalletLocation`. */
  blast?: Maybe<Blast>;
  /** The associated blast */
  blastId?: Maybe<Scalars['Int']['output']>;
  /** The time at which the record was created */
  createdAt: Scalars['Datetime']['output'];
  /** The unique, auto-generated ID of the record */
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `PalletLocation` that is related to this `BlastPalletLocation`. */
  palletLocation?: Maybe<PalletLocation>;
  /** The associated pallet location within the same facility */
  palletLocationId?: Maybe<Scalars['Int']['output']>;
  /** The time at which the record was updated */
  updatedAt: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `BlastPalletLocation` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type BlastPalletLocationCondition = {
  /** Checks for equality with the object’s `blastId` field. */
  blastId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `palletLocationId` field. */
  palletLocationId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `BlastPalletLocation` object types. All fields are combined with a logical ‘and.’ */
export type BlastPalletLocationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BlastPalletLocationFilter>>;
  /** Filter by the object’s `blastId` field. */
  blastId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BlastPalletLocationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BlastPalletLocationFilter>>;
  /** Filter by the object’s `palletLocationId` field. */
  palletLocationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `BlastPalletLocation` */
export type BlastPalletLocationInput = {
  /** Mutates a `Blast` as part of the payload */
  blast?: InputMaybe<BlastInput>;
  /** The associated blast */
  blastId?: InputMaybe<Scalars['Int']['input']>;
  /** Mutates a `PalletLocation` as part of the payload */
  palletLocation?: InputMaybe<PalletLocationInput>;
  /** The associated pallet location within the same facility */
  palletLocationId?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents an update to a `BlastPalletLocation`. Fields that are set will be updated. */
export type BlastPalletLocationPatch = {
  /** The associated blast */
  blastId?: InputMaybe<Scalars['Int']['input']>;
  /** The associated pallet location within the same facility */
  palletLocationId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `BlastPalletLocation` values. */
export type BlastPalletLocationsConnection = {
  __typename?: 'BlastPalletLocationsConnection';
  /** A list of edges which contains the `BlastPalletLocation` and cursor to aid in pagination. */
  edges: Array<BlastPalletLocationsEdge>;
  /** A list of `BlastPalletLocation` objects. */
  nodes: Array<BlastPalletLocation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BlastPalletLocation` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `BlastPalletLocation` edge in the connection. */
export type BlastPalletLocationsEdge = {
  __typename?: 'BlastPalletLocationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `BlastPalletLocation` at the end of the edge. */
  node: BlastPalletLocation;
};

/** Methods to use when ordering `BlastPalletLocation`. */
export enum BlastPalletLocationsOrderBy {
  BLAST_ID_ASC = 'BLAST_ID_ASC',
  BLAST_ID_DESC = 'BLAST_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  PALLET_LOCATION_ID_ASC = 'PALLET_LOCATION_ID_ASC',
  PALLET_LOCATION_ID_DESC = 'PALLET_LOCATION_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** Represents an update to a `BlastPallet`. Fields that are set will be updated. */
export type BlastPalletPatch = {
  /** The associated blast (determined by the pallet locations registered in blastPalletLocations) */
  blastId?: InputMaybe<Scalars['Int']['input']>;
  /** The time when a pallet was placed / dropped in the pallet location */
  palletDropTime?: InputMaybe<Scalars['Datetime']['input']>;
  /** The associated pallet */
  palletId?: InputMaybe<Scalars['Int']['input']>;
  /** The time when a pallet was removed / picked from the pallet location */
  palletPickTime?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A connection to a list of `BlastPallet` values. */
export type BlastPalletsConnection = {
  __typename?: 'BlastPalletsConnection';
  /** A list of edges which contains the `BlastPallet` and cursor to aid in pagination. */
  edges: Array<BlastPalletsEdge>;
  /** A list of `BlastPallet` objects. */
  nodes: Array<BlastPallet>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BlastPallet` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `BlastPallet` edge in the connection. */
export type BlastPalletsEdge = {
  __typename?: 'BlastPalletsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `BlastPallet` at the end of the edge. */
  node: BlastPallet;
};

/** Methods to use when ordering `BlastPallet`. */
export enum BlastPalletsOrderBy {
  BLAST_ID_ASC = 'BLAST_ID_ASC',
  BLAST_ID_DESC = 'BLAST_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  PALLET_DROP_TIME_ASC = 'PALLET_DROP_TIME_ASC',
  PALLET_DROP_TIME_DESC = 'PALLET_DROP_TIME_DESC',
  PALLET_ID_ASC = 'PALLET_ID_ASC',
  PALLET_ID_DESC = 'PALLET_ID_DESC',
  PALLET_PICK_TIME_ASC = 'PALLET_PICK_TIME_ASC',
  PALLET_PICK_TIME_DESC = 'PALLET_PICK_TIME_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** Represents an update to a `Blast`. Fields that are set will be updated. */
export type BlastPatch = {
  /** The actual utilization metric */
  actualUtilizationId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The total capacity of the blast, which is set when warehouse data is unavailable */
  assumedPalletCapacity?: InputMaybe<Scalars['Int']['input']>;
  /** An IOT datapoint indicating the current automation state, usually indicating if the facility has enabled automation (where available) */
  automationStateId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The type of blast */
  blastTypeId?: InputMaybe<Scalars['Int']['input']>;
  /** The associated physical location within the facility */
  buildingAreaId?: InputMaybe<Scalars['Int']['input']>;
  /** The associated component for control purposes, if available */
  componentId?: InputMaybe<Scalars['Int']['input']>;
  /** The facility a blast is within */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** The ideal utilization metric */
  idealUtilizationId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Indicator for noting if a blast is currently being used as a blast. In some cases, a blast can be used as a general storage location */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** The unique local (facility-level) human-readable label of the blast */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Metadata information for a blast */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** Indicator for determining an automation-enabled blast */
  remoteEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** An IOT datapoint indicating the time-delay if a blast has had its start time delayed by the control system */
  stagingTimerId?: InputMaybe<Scalars['BigInt']['input']>;
  /** An IOT datapoint indicating the state of the blast */
  stateId?: InputMaybe<Scalars['BigInt']['input']>;
  /** An IOT datapoint indicating the amount of time left with a blast refrigeration cycle (if the facility uses this method) */
  timerId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A blast rotation, which encompasses the loading, running of refrigeration, and unloading of a blast */
export type BlastRotation = Node & {
  __typename?: 'BlastRotation';
  /** The total assumed pallets in the rotation, assuming warehouse data is unavailable for the rotation */
  assumedPalletCount?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `Blast` that is related to this `BlastRotation`. */
  blast?: Maybe<Blast>;
  /** The associated blast */
  blastId: Scalars['Int']['output'];
  /** Reads and enables pagination through a set of `BlastRotationAlert`. */
  blastRotationAlerts: BlastRotationAlertsConnection;
  /** Reads and enables pagination through a set of `BlastRotationEventLog`. */
  blastRotationEventLogs: BlastRotationEventLogsConnection;
  /** The time at which the record was created */
  createdAt: Scalars['Datetime']['output'];
  /** The current status of the blast rotation */
  currentStatus: Scalars['String']['output'];
  defrosts: BlastRotationsDefrostsConnection;
  /** The estimated end time of the refrigeration portion of the rotation */
  estimatedRefrigerationEndTime?: Maybe<Scalars['Datetime']['output']>;
  freezeEndTime?: Maybe<Scalars['Datetime']['output']>;
  freezeStartTime?: Maybe<Scalars['Datetime']['output']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['Int']['output'];
  loadEndTime?: Maybe<Scalars['Datetime']['output']>;
  loadStartTime?: Maybe<Scalars['Datetime']['output']>;
  metadata: Scalars['JSON']['output'];
  /** The methodology used to determine the metadata of the rotation, along with what pallets belong in the rotation */
  methodologyType?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The end time of a rotation */
  overallEndTime?: Maybe<Scalars['Datetime']['output']>;
  /** The start time of a rotation */
  overallStartTime: Scalars['Datetime']['output'];
  /** Reads and enables pagination through a set of `Pallet`. */
  pallets: PalletsConnection;
  /** The planned amount of time the freezing cycle is expected to take (if applicable) */
  plannedFreezingHours?: Maybe<Scalars['Float']['output']>;
  unloadEndTime?: Maybe<Scalars['Datetime']['output']>;
  unloadStartTime?: Maybe<Scalars['Datetime']['output']>;
  /** The time at which the record was updated */
  updatedAt: Scalars['Datetime']['output'];
};

/** A blast rotation, which encompasses the loading, running of refrigeration, and unloading of a blast */
export type BlastRotationBlastRotationAlertsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BlastRotationAlertCondition>;
  filter?: InputMaybe<BlastRotationAlertFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BlastRotationAlertsOrderBy>>;
};

/** A blast rotation, which encompasses the loading, running of refrigeration, and unloading of a blast */
export type BlastRotationBlastRotationEventLogsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BlastRotationEventLogCondition>;
  filter?: InputMaybe<BlastRotationEventLogFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BlastRotationEventLogsOrderBy>>;
};

/** A blast rotation, which encompasses the loading, running of refrigeration, and unloading of a blast */
export type BlastRotationDefrostsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<BlastRotationsDefrostsRecordFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** A blast rotation, which encompasses the loading, running of refrigeration, and unloading of a blast */
export type BlastRotationPalletsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<PalletFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** An alert on a blast rotation to indicate an action to be taken in a blast rotation */
export type BlastRotationAlert = Node & {
  __typename?: 'BlastRotationAlert';
  /** The short, human-readable type of this alert */
  alertType: Scalars['String']['output'];
  /** Reads a single `BlastRotation` that is related to this `BlastRotationAlert`. */
  blastRotation?: Maybe<BlastRotation>;
  /** The id of the blast rotation the alert is associated with */
  blastRotationId: Scalars['Int']['output'];
  /** The time the rotation alert was created. */
  createdAt: Scalars['Datetime']['output'];
  /** A short description describing the action to be taken */
  description: Scalars['String']['output'];
  /** The time the alert was no longer valid */
  endTime?: Maybe<Scalars['Datetime']['output']>;
  /** The identifer of the blast rotation alert */
  id: Scalars['Int']['output'];
  /** Indication of whether or not this alert is still active */
  isActive: Scalars['Boolean']['output'];
  /** The severity level of the alert */
  level: EnumBlastRotationAlertLevel;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The time the alert started */
  startTime: Scalars['Datetime']['output'];
  /** The time the rotation alert was updated. */
  updatedAt: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `BlastRotationAlert` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type BlastRotationAlertCondition = {
  /** Checks for equality with the object’s `alertType` field. */
  alertType?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `blastRotationId` field. */
  blastRotationId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `endTime` field. */
  endTime?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `isActive` field. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `level` field. */
  level?: InputMaybe<EnumBlastRotationAlertLevel>;
  /** Checks for equality with the object’s `startTime` field. */
  startTime?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `BlastRotationAlert` object types. All fields are combined with a logical ‘and.’ */
export type BlastRotationAlertFilter = {
  /** Filter by the object’s `alertType` field. */
  alertType?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BlastRotationAlertFilter>>;
  /** Filter by the object’s `blastRotationId` field. */
  blastRotationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `endTime` field. */
  endTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isActive` field. */
  isActive?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `level` field. */
  level?: InputMaybe<EnumBlastRotationAlertLevelFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BlastRotationAlertFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BlastRotationAlertFilter>>;
  /** Filter by the object’s `startTime` field. */
  startTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `BlastRotationAlert` */
export type BlastRotationAlertInput = {
  /** The short, human-readable type of this alert */
  alertType: Scalars['String']['input'];
  /** Mutates a `BlastRotation` as part of the payload */
  blastRotation?: InputMaybe<BlastRotationInput>;
  /** The id of the blast rotation the alert is associated with */
  blastRotationId?: InputMaybe<Scalars['Int']['input']>;
  /** A short description describing the action to be taken */
  description: Scalars['String']['input'];
  /** The time the alert was no longer valid */
  endTime?: InputMaybe<Scalars['Datetime']['input']>;
  /** Indication of whether or not this alert is still active */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** The severity level of the alert */
  level: EnumBlastRotationAlertLevel;
  /** The time the alert started */
  startTime: Scalars['Datetime']['input'];
};

/** Represents an update to a `BlastRotationAlert`. Fields that are set will be updated. */
export type BlastRotationAlertPatch = {
  /** The short, human-readable type of this alert */
  alertType?: InputMaybe<Scalars['String']['input']>;
  /** The id of the blast rotation the alert is associated with */
  blastRotationId?: InputMaybe<Scalars['Int']['input']>;
  /** A short description describing the action to be taken */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The time the alert was no longer valid */
  endTime?: InputMaybe<Scalars['Datetime']['input']>;
  /** Indication of whether or not this alert is still active */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** The severity level of the alert */
  level?: InputMaybe<EnumBlastRotationAlertLevel>;
  /** The time the alert started */
  startTime?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A connection to a list of `BlastRotationAlert` values. */
export type BlastRotationAlertsConnection = {
  __typename?: 'BlastRotationAlertsConnection';
  /** A list of edges which contains the `BlastRotationAlert` and cursor to aid in pagination. */
  edges: Array<BlastRotationAlertsEdge>;
  /** A list of `BlastRotationAlert` objects. */
  nodes: Array<BlastRotationAlert>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BlastRotationAlert` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `BlastRotationAlert` edge in the connection. */
export type BlastRotationAlertsEdge = {
  __typename?: 'BlastRotationAlertsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `BlastRotationAlert` at the end of the edge. */
  node: BlastRotationAlert;
};

/** Methods to use when ordering `BlastRotationAlert`. */
export enum BlastRotationAlertsOrderBy {
  ALERT_TYPE_ASC = 'ALERT_TYPE_ASC',
  ALERT_TYPE_DESC = 'ALERT_TYPE_DESC',
  BLAST_ROTATION_ID_ASC = 'BLAST_ROTATION_ID_ASC',
  BLAST_ROTATION_ID_DESC = 'BLAST_ROTATION_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  END_TIME_ASC = 'END_TIME_ASC',
  END_TIME_DESC = 'END_TIME_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  IS_ACTIVE_ASC = 'IS_ACTIVE_ASC',
  IS_ACTIVE_DESC = 'IS_ACTIVE_DESC',
  LEVEL_ASC = 'LEVEL_ASC',
  LEVEL_DESC = 'LEVEL_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  START_TIME_ASC = 'START_TIME_ASC',
  START_TIME_DESC = 'START_TIME_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/**
 * A condition to be used against `BlastRotation` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type BlastRotationCondition = {
  /** Checks for equality with the object’s `assumedPalletCount` field. */
  assumedPalletCount?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `blastId` field. */
  blastId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `currentStatus` field. */
  currentStatus?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `estimatedRefrigerationEndTime` field. */
  estimatedRefrigerationEndTime?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `metadata` field. */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `methodologyType` field. */
  methodologyType?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `overallEndTime` field. */
  overallEndTime?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `overallStartTime` field. */
  overallStartTime?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `plannedFreezingHours` field. */
  plannedFreezingHours?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A log of events that occur during a blast rotation */
export type BlastRotationEventLog = Node & {
  __typename?: 'BlastRotationEventLog';
  /** Reads a single `BlastRotation` that is related to this `BlastRotationEventLog`. */
  blastRotation?: Maybe<BlastRotation>;
  /** Reads a single `BlastRotationEventType` that is related to this `BlastRotationEventLog`. */
  blastRotationEventType?: Maybe<BlastRotationEventType>;
  /** The type of event for this record */
  blastRotationEventTypeId: Scalars['String']['output'];
  /** The associated blast rotation */
  blastRotationId: Scalars['Int']['output'];
  /** The time at which the record was created */
  createdAt: Scalars['Datetime']['output'];
  /** A short description of the event */
  description: Scalars['String']['output'];
  /** The time of the event */
  eventTime: Scalars['Datetime']['output'];
  /** The unique, auto-generated ID of the record */
  id: Scalars['Int']['output'];
  /** Additional, arbitrary information about the event */
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The time at which the record was updated */
  updatedAt: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `BlastRotationEventLog` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type BlastRotationEventLogCondition = {
  /** Checks for equality with the object’s `blastRotationEventTypeId` field. */
  blastRotationEventTypeId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `blastRotationId` field. */
  blastRotationId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `eventTime` field. */
  eventTime?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `metadata` field. */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `BlastRotationEventLog` object types. All fields are combined with a logical ‘and.’ */
export type BlastRotationEventLogFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BlastRotationEventLogFilter>>;
  /** Filter by the object’s `blastRotationEventTypeId` field. */
  blastRotationEventTypeId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `blastRotationId` field. */
  blastRotationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `eventTime` field. */
  eventTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `metadata` field. */
  metadata?: InputMaybe<JsonFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BlastRotationEventLogFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BlastRotationEventLogFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `BlastRotationEventLog` */
export type BlastRotationEventLogInput = {
  /** Mutates a `BlastRotation` as part of the payload */
  blastRotation?: InputMaybe<BlastRotationInput>;
  /** Mutates a `BlastRotationEventType` as part of the payload */
  blastRotationEventType?: InputMaybe<BlastRotationEventTypeInput>;
  /** The type of event for this record */
  blastRotationEventTypeId?: InputMaybe<Scalars['String']['input']>;
  /** The associated blast rotation */
  blastRotationId?: InputMaybe<Scalars['Int']['input']>;
  /** A short description of the event */
  description: Scalars['String']['input'];
  /** The time of the event */
  eventTime: Scalars['Datetime']['input'];
  /** Additional, arbitrary information about the event */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
};

/** Represents an update to a `BlastRotationEventLog`. Fields that are set will be updated. */
export type BlastRotationEventLogPatch = {
  /** The type of event for this record */
  blastRotationEventTypeId?: InputMaybe<Scalars['String']['input']>;
  /** The associated blast rotation */
  blastRotationId?: InputMaybe<Scalars['Int']['input']>;
  /** A short description of the event */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The time of the event */
  eventTime?: InputMaybe<Scalars['Datetime']['input']>;
  /** Additional, arbitrary information about the event */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
};

/** A connection to a list of `BlastRotationEventLog` values. */
export type BlastRotationEventLogsConnection = {
  __typename?: 'BlastRotationEventLogsConnection';
  /** A list of edges which contains the `BlastRotationEventLog` and cursor to aid in pagination. */
  edges: Array<BlastRotationEventLogsEdge>;
  /** A list of `BlastRotationEventLog` objects. */
  nodes: Array<BlastRotationEventLog>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BlastRotationEventLog` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `BlastRotationEventLog` edge in the connection. */
export type BlastRotationEventLogsEdge = {
  __typename?: 'BlastRotationEventLogsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `BlastRotationEventLog` at the end of the edge. */
  node: BlastRotationEventLog;
};

/** Methods to use when ordering `BlastRotationEventLog`. */
export enum BlastRotationEventLogsOrderBy {
  BLAST_ROTATION_EVENT_TYPE_ID_ASC = 'BLAST_ROTATION_EVENT_TYPE_ID_ASC',
  BLAST_ROTATION_EVENT_TYPE_ID_DESC = 'BLAST_ROTATION_EVENT_TYPE_ID_DESC',
  BLAST_ROTATION_ID_ASC = 'BLAST_ROTATION_ID_ASC',
  BLAST_ROTATION_ID_DESC = 'BLAST_ROTATION_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  EVENT_TIME_ASC = 'EVENT_TIME_ASC',
  EVENT_TIME_DESC = 'EVENT_TIME_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  METADATA_ASC = 'METADATA_ASC',
  METADATA_DESC = 'METADATA_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** A type of event that occurs within a blast rotation */
export type BlastRotationEventType = Node & {
  __typename?: 'BlastRotationEventType';
  /** Reads and enables pagination through a set of `BlastRotationEventLog`. */
  blastRotationEventLogs: BlastRotationEventLogsConnection;
  /** The time at which the record was created */
  createdAt: Scalars['Datetime']['output'];
  /** A unique, readable type of event that can occur within a blast rotation */
  eventType: Scalars['String']['output'];
  /** A UI-friendly label for the type of event */
  label: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The time at which the record was updated */
  updatedAt: Scalars['Datetime']['output'];
};

/** A type of event that occurs within a blast rotation */
export type BlastRotationEventTypeBlastRotationEventLogsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BlastRotationEventLogCondition>;
  filter?: InputMaybe<BlastRotationEventLogFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BlastRotationEventLogsOrderBy>>;
};

/**
 * A condition to be used against `BlastRotationEventType` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type BlastRotationEventTypeCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `eventType` field. */
  eventType?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `label` field. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `BlastRotationEventType` object types. All fields are combined with a logical ‘and.’ */
export type BlastRotationEventTypeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BlastRotationEventTypeFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `eventType` field. */
  eventType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `label` field. */
  label?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BlastRotationEventTypeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BlastRotationEventTypeFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `BlastRotationEventType` */
export type BlastRotationEventTypeInput = {
  /** A unique, readable type of event that can occur within a blast rotation */
  eventType: Scalars['String']['input'];
  /** A UI-friendly label for the type of event */
  label: Scalars['String']['input'];
};

/** Represents an update to a `BlastRotationEventType`. Fields that are set will be updated. */
export type BlastRotationEventTypePatch = {
  /** A unique, readable type of event that can occur within a blast rotation */
  eventType?: InputMaybe<Scalars['String']['input']>;
  /** A UI-friendly label for the type of event */
  label?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `BlastRotationEventType` values. */
export type BlastRotationEventTypesConnection = {
  __typename?: 'BlastRotationEventTypesConnection';
  /** A list of edges which contains the `BlastRotationEventType` and cursor to aid in pagination. */
  edges: Array<BlastRotationEventTypesEdge>;
  /** A list of `BlastRotationEventType` objects. */
  nodes: Array<BlastRotationEventType>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BlastRotationEventType` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `BlastRotationEventType` edge in the connection. */
export type BlastRotationEventTypesEdge = {
  __typename?: 'BlastRotationEventTypesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `BlastRotationEventType` at the end of the edge. */
  node: BlastRotationEventType;
};

/** Methods to use when ordering `BlastRotationEventType`. */
export enum BlastRotationEventTypesOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  EVENT_TYPE_ASC = 'EVENT_TYPE_ASC',
  EVENT_TYPE_DESC = 'EVENT_TYPE_DESC',
  LABEL_ASC = 'LABEL_ASC',
  LABEL_DESC = 'LABEL_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** A filter to be used against `BlastRotation` object types. All fields are combined with a logical ‘and.’ */
export type BlastRotationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BlastRotationFilter>>;
  /** Filter by the object’s `assumedPalletCount` field. */
  assumedPalletCount?: InputMaybe<IntFilter>;
  /** Filter by the object’s `blastId` field. */
  blastId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `currentStatus` field. */
  currentStatus?: InputMaybe<StringFilter>;
  /** Filter by the object’s `estimatedRefrigerationEndTime` field. */
  estimatedRefrigerationEndTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `freezeEndTime` field. */
  freezeEndTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `freezeStartTime` field. */
  freezeStartTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `loadEndTime` field. */
  loadEndTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `loadStartTime` field. */
  loadStartTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `metadata` field. */
  metadata?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `methodologyType` field. */
  methodologyType?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BlastRotationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BlastRotationFilter>>;
  /** Filter by the object’s `overallEndTime` field. */
  overallEndTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `overallStartTime` field. */
  overallStartTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `plannedFreezingHours` field. */
  plannedFreezingHours?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `unloadEndTime` field. */
  unloadEndTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `unloadStartTime` field. */
  unloadStartTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `BlastRotation` */
export type BlastRotationInput = {
  /** The total assumed pallets in the rotation, assuming warehouse data is unavailable for the rotation */
  assumedPalletCount?: InputMaybe<Scalars['Int']['input']>;
  /** Mutates a `Blast` as part of the payload */
  blast?: InputMaybe<BlastInput>;
  /** The associated blast */
  blastId?: InputMaybe<Scalars['Int']['input']>;
  /** The current status of the blast rotation */
  currentStatus?: InputMaybe<Scalars['String']['input']>;
  /** The estimated end time of the refrigeration portion of the rotation */
  estimatedRefrigerationEndTime?: InputMaybe<Scalars['Datetime']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** The methodology used to determine the metadata of the rotation, along with what pallets belong in the rotation */
  methodologyType?: InputMaybe<Scalars['String']['input']>;
  /** The end time of a rotation */
  overallEndTime?: InputMaybe<Scalars['Datetime']['input']>;
  /** The start time of a rotation */
  overallStartTime: Scalars['Datetime']['input'];
  /** The planned amount of time the freezing cycle is expected to take (if applicable) */
  plannedFreezingHours?: InputMaybe<Scalars['Float']['input']>;
};

/** A linker for indicating which pallets were present in a blast rotation */
export type BlastRotationPallet = Node & {
  __typename?: 'BlastRotationPallet';
  /** Reads a single `BlastRotation` that is related to this `BlastRotationPallet`. */
  blastRotation?: Maybe<BlastRotation>;
  /** The associated blast rotation */
  blastRotationId: Scalars['Int']['output'];
  /** The time at which the record was created */
  createdAt: Scalars['Datetime']['output'];
  /** The unique, auto-generated ID of the record */
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Pallet` that is related to this `BlastRotationPallet`. */
  pallet?: Maybe<Pallet>;
  /** The associated pallet */
  palletId: Scalars['Int']['output'];
  /** The time at which the record was updated */
  updatedAt: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `BlastRotationPallet` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type BlastRotationPalletCondition = {
  /** Checks for equality with the object’s `blastRotationId` field. */
  blastRotationId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `palletId` field. */
  palletId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `BlastRotationPallet` object types. All fields are combined with a logical ‘and.’ */
export type BlastRotationPalletFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BlastRotationPalletFilter>>;
  /** Filter by the object’s `blastRotationId` field. */
  blastRotationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BlastRotationPalletFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BlastRotationPalletFilter>>;
  /** Filter by the object’s `palletId` field. */
  palletId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `BlastRotationPallet` */
export type BlastRotationPalletInput = {
  /** Mutates a `BlastRotation` as part of the payload */
  blastRotation?: InputMaybe<BlastRotationInput>;
  /** The associated blast rotation */
  blastRotationId?: InputMaybe<Scalars['Int']['input']>;
  /** Mutates a `Pallet` as part of the payload */
  pallet?: InputMaybe<PalletInput>;
  /** The associated pallet */
  palletId?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents an update to a `BlastRotationPallet`. Fields that are set will be updated. */
export type BlastRotationPalletPatch = {
  /** The associated blast rotation */
  blastRotationId?: InputMaybe<Scalars['Int']['input']>;
  /** The associated pallet */
  palletId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `BlastRotationPallet` values. */
export type BlastRotationPalletsConnection = {
  __typename?: 'BlastRotationPalletsConnection';
  /** A list of edges which contains the `BlastRotationPallet` and cursor to aid in pagination. */
  edges: Array<BlastRotationPalletsEdge>;
  /** A list of `BlastRotationPallet` objects. */
  nodes: Array<BlastRotationPallet>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BlastRotationPallet` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `BlastRotationPallet` edge in the connection. */
export type BlastRotationPalletsEdge = {
  __typename?: 'BlastRotationPalletsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `BlastRotationPallet` at the end of the edge. */
  node: BlastRotationPallet;
};

/** Methods to use when ordering `BlastRotationPallet`. */
export enum BlastRotationPalletsOrderBy {
  BLAST_ROTATION_ID_ASC = 'BLAST_ROTATION_ID_ASC',
  BLAST_ROTATION_ID_DESC = 'BLAST_ROTATION_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  PALLET_ID_ASC = 'PALLET_ID_ASC',
  PALLET_ID_DESC = 'PALLET_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** Represents an update to a `BlastRotation`. Fields that are set will be updated. */
export type BlastRotationPatch = {
  /** The total assumed pallets in the rotation, assuming warehouse data is unavailable for the rotation */
  assumedPalletCount?: InputMaybe<Scalars['Int']['input']>;
  /** The associated blast */
  blastId?: InputMaybe<Scalars['Int']['input']>;
  /** The current status of the blast rotation */
  currentStatus?: InputMaybe<Scalars['String']['input']>;
  /** The estimated end time of the refrigeration portion of the rotation */
  estimatedRefrigerationEndTime?: InputMaybe<Scalars['Datetime']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** The methodology used to determine the metadata of the rotation, along with what pallets belong in the rotation */
  methodologyType?: InputMaybe<Scalars['String']['input']>;
  /** The end time of a rotation */
  overallEndTime?: InputMaybe<Scalars['Datetime']['input']>;
  /** The start time of a rotation */
  overallStartTime?: InputMaybe<Scalars['Datetime']['input']>;
  /** The planned amount of time the freezing cycle is expected to take (if applicable) */
  plannedFreezingHours?: InputMaybe<Scalars['Float']['input']>;
};

/** A connection to a list of `BlastRotation` values. */
export type BlastRotationsConnection = {
  __typename?: 'BlastRotationsConnection';
  /** A list of edges which contains the `BlastRotation` and cursor to aid in pagination. */
  edges: Array<BlastRotationsEdge>;
  /** A list of `BlastRotation` objects. */
  nodes: Array<BlastRotation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BlastRotation` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `BlastRotationsDefrostsRecord` edge in the connection. */
export type BlastRotationsDefrostEdge = {
  __typename?: 'BlastRotationsDefrostEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `BlastRotationsDefrostsRecord` at the end of the edge. */
  node: BlastRotationsDefrostsRecord;
};

/** A connection to a list of `BlastRotationsDefrostsRecord` values. */
export type BlastRotationsDefrostsConnection = {
  __typename?: 'BlastRotationsDefrostsConnection';
  /** A list of edges which contains the `BlastRotationsDefrostsRecord` and cursor to aid in pagination. */
  edges: Array<BlastRotationsDefrostEdge>;
  /** A list of `BlastRotationsDefrostsRecord` objects. */
  nodes: Array<BlastRotationsDefrostsRecord>;
  /** The count of *all* `BlastRotationsDefrostsRecord` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** The return type of our `defrosts` query. */
export type BlastRotationsDefrostsRecord = {
  __typename?: 'BlastRotationsDefrostsRecord';
  endTime?: Maybe<Scalars['Datetime']['output']>;
  startTime?: Maybe<Scalars['Datetime']['output']>;
  totalMinutes?: Maybe<Scalars['Int']['output']>;
};

/** A filter to be used against `BlastRotationsDefrostsRecord` object types. All fields are combined with a logical ‘and.’ */
export type BlastRotationsDefrostsRecordFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BlastRotationsDefrostsRecordFilter>>;
  /** Filter by the object’s `endTime` field. */
  endTime?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BlastRotationsDefrostsRecordFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BlastRotationsDefrostsRecordFilter>>;
  /** Filter by the object’s `startTime` field. */
  startTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `totalMinutes` field. */
  totalMinutes?: InputMaybe<IntFilter>;
};

/** A `BlastRotation` edge in the connection. */
export type BlastRotationsEdge = {
  __typename?: 'BlastRotationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `BlastRotation` at the end of the edge. */
  node: BlastRotation;
};

/** Methods to use when ordering `BlastRotation`. */
export enum BlastRotationsOrderBy {
  ASSUMED_PALLET_COUNT_ASC = 'ASSUMED_PALLET_COUNT_ASC',
  ASSUMED_PALLET_COUNT_DESC = 'ASSUMED_PALLET_COUNT_DESC',
  BLAST_ID_ASC = 'BLAST_ID_ASC',
  BLAST_ID_DESC = 'BLAST_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  CURRENT_STATUS_ASC = 'CURRENT_STATUS_ASC',
  CURRENT_STATUS_DESC = 'CURRENT_STATUS_DESC',
  ESTIMATED_REFRIGERATION_END_TIME_ASC = 'ESTIMATED_REFRIGERATION_END_TIME_ASC',
  ESTIMATED_REFRIGERATION_END_TIME_DESC = 'ESTIMATED_REFRIGERATION_END_TIME_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  METADATA_ASC = 'METADATA_ASC',
  METADATA_DESC = 'METADATA_DESC',
  METHODOLOGY_TYPE_ASC = 'METHODOLOGY_TYPE_ASC',
  METHODOLOGY_TYPE_DESC = 'METHODOLOGY_TYPE_DESC',
  NATURAL = 'NATURAL',
  OVERALL_END_TIME_ASC = 'OVERALL_END_TIME_ASC',
  OVERALL_END_TIME_DESC = 'OVERALL_END_TIME_DESC',
  OVERALL_START_TIME_ASC = 'OVERALL_START_TIME_ASC',
  OVERALL_START_TIME_DESC = 'OVERALL_START_TIME_DESC',
  PLANNED_FREEZING_HOURS_ASC = 'PLANNED_FREEZING_HOURS_ASC',
  PLANNED_FREEZING_HOURS_DESC = 'PLANNED_FREEZING_HOURS_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** A type or category of a blast to indicate a different operating environment across facilities */
export type BlastType = Node & {
  __typename?: 'BlastType';
  /** Reads and enables pagination through a set of `Blast`. */
  blasts: BlastsConnection;
  /** The time at which the record was created */
  createdAt: Scalars['Datetime']['output'];
  /** A brief description of this blast type or category */
  description: Scalars['String']['output'];
  /** The unique, auto-generated ID of the record */
  id: Scalars['Int']['output'];
  /** A human-readable label for the type or category */
  label: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The time at which the record was updated */
  updatedAt: Scalars['Datetime']['output'];
};

/** A type or category of a blast to indicate a different operating environment across facilities */
export type BlastTypeBlastsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BlastCondition>;
  filter?: InputMaybe<BlastFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BlastsOrderBy>>;
};

/**
 * A condition to be used against `BlastType` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type BlastTypeCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `label` field. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `BlastType` object types. All fields are combined with a logical ‘and.’ */
export type BlastTypeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BlastTypeFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `label` field. */
  label?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BlastTypeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BlastTypeFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `BlastType` */
export type BlastTypeInput = {
  /** A brief description of this blast type or category */
  description: Scalars['String']['input'];
  /** A human-readable label for the type or category */
  label: Scalars['String']['input'];
};

/** Represents an update to a `BlastType`. Fields that are set will be updated. */
export type BlastTypePatch = {
  /** A brief description of this blast type or category */
  description?: InputMaybe<Scalars['String']['input']>;
  /** A human-readable label for the type or category */
  label?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `BlastType` values. */
export type BlastTypesConnection = {
  __typename?: 'BlastTypesConnection';
  /** A list of edges which contains the `BlastType` and cursor to aid in pagination. */
  edges: Array<BlastTypesEdge>;
  /** A list of `BlastType` objects. */
  nodes: Array<BlastType>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BlastType` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `BlastType` edge in the connection. */
export type BlastTypesEdge = {
  __typename?: 'BlastTypesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `BlastType` at the end of the edge. */
  node: BlastType;
};

/** Methods to use when ordering `BlastType`. */
export enum BlastTypesOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LABEL_ASC = 'LABEL_ASC',
  LABEL_DESC = 'LABEL_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** A connection to a list of `Blast` values. */
export type BlastsConnection = {
  __typename?: 'BlastsConnection';
  /** Returns the aggregate actualUtilization timeseries data for the BlastsConnection  */
  actualUtilization?: Maybe<MetricDataConnection>;
  /** Returns the aggregate automationState timeseries data for the BlastsConnection  */
  automationState?: Maybe<MetricDataConnection>;
  /** A list of edges which contains the `Blast` and cursor to aid in pagination. */
  edges: Array<BlastsEdge>;
  /** Returns the aggregate idealUtilization timeseries data for the BlastsConnection  */
  idealUtilization?: Maybe<MetricDataConnection>;
  /** A list of `Blast` objects. */
  nodes: Array<Blast>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Returns the aggregate stagingTimer timeseries data for the BlastsConnection  */
  stagingTimer?: Maybe<MetricDataConnection>;
  /** Returns the aggregate state timeseries data for the BlastsConnection  */
  state?: Maybe<MetricDataConnection>;
  /** Returns the aggregate timer timeseries data for the BlastsConnection  */
  timer?: Maybe<MetricDataConnection>;
  /** The count of *all* `Blast` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A connection to a list of `Blast` values. */
export type BlastsConnectionActualUtilizationArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Blast` values. */
export type BlastsConnectionAutomationStateArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Blast` values. */
export type BlastsConnectionIdealUtilizationArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Blast` values. */
export type BlastsConnectionStagingTimerArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Blast` values. */
export type BlastsConnectionStateArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Blast` values. */
export type BlastsConnectionTimerArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A `Blast` edge in the connection. */
export type BlastsEdge = {
  __typename?: 'BlastsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Blast` at the end of the edge. */
  node: Blast;
};

/** Methods to use when ordering `Blast`. */
export enum BlastsOrderBy {
  ACTUAL_UTILIZATION_ID_ASC = 'ACTUAL_UTILIZATION_ID_ASC',
  ACTUAL_UTILIZATION_ID_DESC = 'ACTUAL_UTILIZATION_ID_DESC',
  ASSUMED_PALLET_CAPACITY_ASC = 'ASSUMED_PALLET_CAPACITY_ASC',
  ASSUMED_PALLET_CAPACITY_DESC = 'ASSUMED_PALLET_CAPACITY_DESC',
  AUTOMATION_STATE_ID_ASC = 'AUTOMATION_STATE_ID_ASC',
  AUTOMATION_STATE_ID_DESC = 'AUTOMATION_STATE_ID_DESC',
  BLAST_TYPE_ID_ASC = 'BLAST_TYPE_ID_ASC',
  BLAST_TYPE_ID_DESC = 'BLAST_TYPE_ID_DESC',
  BUILDING_AREA_ID_ASC = 'BUILDING_AREA_ID_ASC',
  BUILDING_AREA_ID_DESC = 'BUILDING_AREA_ID_DESC',
  COMPONENT_ID_ASC = 'COMPONENT_ID_ASC',
  COMPONENT_ID_DESC = 'COMPONENT_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  IDEAL_UTILIZATION_ID_ASC = 'IDEAL_UTILIZATION_ID_ASC',
  IDEAL_UTILIZATION_ID_DESC = 'IDEAL_UTILIZATION_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  IS_ACTIVE_ASC = 'IS_ACTIVE_ASC',
  IS_ACTIVE_DESC = 'IS_ACTIVE_DESC',
  LABEL_ASC = 'LABEL_ASC',
  LABEL_DESC = 'LABEL_DESC',
  METADATA_ASC = 'METADATA_ASC',
  METADATA_DESC = 'METADATA_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  REMOTE_ENABLED_ASC = 'REMOTE_ENABLED_ASC',
  REMOTE_ENABLED_DESC = 'REMOTE_ENABLED_DESC',
  STAGING_TIMER_ID_ASC = 'STAGING_TIMER_ID_ASC',
  STAGING_TIMER_ID_DESC = 'STAGING_TIMER_ID_DESC',
  STATE_ID_ASC = 'STATE_ID_ASC',
  STATE_ID_DESC = 'STATE_ID_DESC',
  TIMER_ID_ASC = 'TIMER_ID_ASC',
  TIMER_ID_DESC = 'TIMER_ID_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** A filter to be used against Boolean fields. All fields are combined with a logical ‘and.’ */
export type BooleanFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

/** This represents a physical building area or room that exists in a facility. */
export type BuildingArea = Node & {
  __typename?: 'BuildingArea';
  /** The area in square feet of the building area. */
  area?: Maybe<Scalars['Float']['output']>;
  /** Reads and enables pagination through a set of `Blast`. */
  blasts: BlastsConnection;
  /** Reads and enables pagination through a set of `BuildingAreaComplianceGroup`. */
  buildingAreaComplianceGroups: BuildingAreaComplianceGroupsConnection;
  /** Reads a single `BuildingAreaType` that is related to this `BuildingArea`. */
  buildingAreaType?: Maybe<BuildingAreaType>;
  /** This associates the building area with a building area type. */
  buildingAreaTypeId: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `ComplianceGroup`. */
  complianceGroups: ComplianceGroupsConnection;
  /** Reads and enables pagination through a set of `Compressor`. */
  compressor: CompressorsConnection;
  /** The time the building area was created. */
  createdAt: Scalars['Datetime']['output'];
  /** Long-form description of the building area. */
  description?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `Evaporator`. */
  evaporators: EvaporatorsConnection;
  /** The external customer or reference identifier for the building area. */
  externalCustomerId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Facility` that is related to this `BuildingArea`. */
  facility?: Maybe<Facility>;
  /** This represents the facility that the building area belongs to. */
  facilityId: Scalars['Int']['output'];
  /** The GIS Egeometry which specifies how the building area should be dispElayed on a map. */
  geometry?: Maybe<GeometryInterface>;
  id: Scalars['Int']['output'];
  /** Human-readable label for the building area. */
  label: Scalars['String']['output'];
  /** The metadata of the building area. */
  metadata: Scalars['JSON']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Manually set area in sqft that takes precedence over the area calculated from the geometry. */
  overrideArea?: Maybe<Scalars['Float']['output']>;
  /** Reads and enables pagination through a set of `PalletLocation`. */
  palletLocations: PalletLocationsConnection;
  /** Reads and enables pagination through a set of `BuildingAreaPalletHistory`. */
  pallets: BuildingAreaPalletHistoriesConnection;
  /** Reads and enables pagination through a set of `TemperatureSensor`. */
  temperatureSensors: TemperatureSensorsConnection;
  /** The time the building area was updated. */
  updatedAt: Scalars['Datetime']['output'];
};

/** This represents a physical building area or room that exists in a facility. */
export type BuildingAreaBlastsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BlastCondition>;
  filter?: InputMaybe<BlastFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BlastsOrderBy>>;
};

/** This represents a physical building area or room that exists in a facility. */
export type BuildingAreaBuildingAreaComplianceGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BuildingAreaComplianceGroupCondition>;
  filter?: InputMaybe<BuildingAreaComplianceGroupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BuildingAreaComplianceGroupsOrderBy>>;
};

/** This represents a physical building area or room that exists in a facility. */
export type BuildingAreaComplianceGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<ComplianceGroupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** This represents a physical building area or room that exists in a facility. */
export type BuildingAreaCompressorArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CompressorCondition>;
  filter?: InputMaybe<CompressorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CompressorsOrderBy>>;
};

/** This represents a physical building area or room that exists in a facility. */
export type BuildingAreaEvaporatorsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EvaporatorCondition>;
  filter?: InputMaybe<EvaporatorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvaporatorsOrderBy>>;
};

/** This represents a physical building area or room that exists in a facility. */
export type BuildingAreaPalletLocationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PalletLocationCondition>;
  filter?: InputMaybe<PalletLocationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PalletLocationsOrderBy>>;
};

/** This represents a physical building area or room that exists in a facility. */
export type BuildingAreaPalletsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  endTime: Scalars['Datetime']['input'];
  filter?: InputMaybe<BuildingAreaPalletHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  startTime: Scalars['Datetime']['input'];
};

/** This represents a physical building area or room that exists in a facility. */
export type BuildingAreaTemperatureSensorsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<TemperatureSensorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** A building areas compliance groups */
export type BuildingAreaComplianceGroup = Node & {
  __typename?: 'BuildingAreaComplianceGroup';
  /** Reads a single `BuildingArea` that is related to this `BuildingAreaComplianceGroup`. */
  buildingArea?: Maybe<BuildingArea>;
  /** The building area the compliance group applies to */
  buildingAreaId: Scalars['Int']['output'];
  /** Reads a single `ComplianceGroup` that is related to this `BuildingAreaComplianceGroup`. */
  complianceGroup?: Maybe<ComplianceGroup>;
  /** The associated compliance group */
  complianceGroupId: Scalars['Int']['output'];
  /** The type of compliance group for this relationship */
  complianceType: ComplianceType;
  /** The time at which the Building Area Compliance Range was created */
  createdAt: Scalars['Datetime']['output'];
  /** The id of the building area compliance group */
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The time at which the Building Area Compliance Range was updated */
  updatedAt: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `BuildingAreaComplianceGroup` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type BuildingAreaComplianceGroupCondition = {
  /** Checks for equality with the object’s `buildingAreaId` field. */
  buildingAreaId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `complianceGroupId` field. */
  complianceGroupId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `complianceType` field. */
  complianceType?: InputMaybe<ComplianceType>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `BuildingAreaComplianceGroup` object types. All fields are combined with a logical ‘and.’ */
export type BuildingAreaComplianceGroupFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BuildingAreaComplianceGroupFilter>>;
  /** Filter by the object’s `buildingAreaId` field. */
  buildingAreaId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `complianceGroupId` field. */
  complianceGroupId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `complianceType` field. */
  complianceType?: InputMaybe<ComplianceTypeFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BuildingAreaComplianceGroupFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BuildingAreaComplianceGroupFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `BuildingAreaComplianceGroup` */
export type BuildingAreaComplianceGroupInput = {
  /** Mutates a `BuildingArea` as part of the payload */
  buildingArea?: InputMaybe<BuildingAreaInput>;
  /** The building area the compliance group applies to */
  buildingAreaId?: InputMaybe<Scalars['Int']['input']>;
  /** Mutates a `ComplianceGroup` as part of the payload */
  complianceGroup?: InputMaybe<ComplianceGroupInput>;
  /** The associated compliance group */
  complianceGroupId?: InputMaybe<Scalars['Int']['input']>;
  /** The type of compliance group for this relationship */
  complianceType: ComplianceType;
};

/** Represents an update to a `BuildingAreaComplianceGroup`. Fields that are set will be updated. */
export type BuildingAreaComplianceGroupPatch = {
  /** The building area the compliance group applies to */
  buildingAreaId?: InputMaybe<Scalars['Int']['input']>;
  /** The associated compliance group */
  complianceGroupId?: InputMaybe<Scalars['Int']['input']>;
  /** The type of compliance group for this relationship */
  complianceType?: InputMaybe<ComplianceType>;
};

/** A connection to a list of `BuildingAreaComplianceGroup` values. */
export type BuildingAreaComplianceGroupsConnection = {
  __typename?: 'BuildingAreaComplianceGroupsConnection';
  /** A list of edges which contains the `BuildingAreaComplianceGroup` and cursor to aid in pagination. */
  edges: Array<BuildingAreaComplianceGroupsEdge>;
  /** A list of `BuildingAreaComplianceGroup` objects. */
  nodes: Array<BuildingAreaComplianceGroup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BuildingAreaComplianceGroup` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `BuildingAreaComplianceGroup` edge in the connection. */
export type BuildingAreaComplianceGroupsEdge = {
  __typename?: 'BuildingAreaComplianceGroupsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `BuildingAreaComplianceGroup` at the end of the edge. */
  node: BuildingAreaComplianceGroup;
};

/** Methods to use when ordering `BuildingAreaComplianceGroup`. */
export enum BuildingAreaComplianceGroupsOrderBy {
  BUILDING_AREA_ID_ASC = 'BUILDING_AREA_ID_ASC',
  BUILDING_AREA_ID_DESC = 'BUILDING_AREA_ID_DESC',
  COMPLIANCE_GROUP_ID_ASC = 'COMPLIANCE_GROUP_ID_ASC',
  COMPLIANCE_GROUP_ID_DESC = 'COMPLIANCE_GROUP_ID_DESC',
  COMPLIANCE_TYPE_ASC = 'COMPLIANCE_TYPE_ASC',
  COMPLIANCE_TYPE_DESC = 'COMPLIANCE_TYPE_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/**
 * A condition to be used against `BuildingArea` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type BuildingAreaCondition = {
  /** Checks for equality with the object’s `buildingAreaTypeId` field. */
  buildingAreaTypeId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `externalCustomerId` field. */
  externalCustomerId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `geometry` field. */
  geometry?: InputMaybe<Scalars['GeoJSON']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `label` field. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `metadata` field. */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `overrideArea` field. */
  overrideArea?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `BuildingArea` object types. All fields are combined with a logical ‘and.’ */
export type BuildingAreaFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BuildingAreaFilter>>;
  /** Filter by the object’s `area` field. */
  area?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `buildingAreaTypeId` field. */
  buildingAreaTypeId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `externalCustomerId` field. */
  externalCustomerId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `label` field. */
  label?: InputMaybe<StringFilter>;
  /** Filter by the object’s `metadata` field. */
  metadata?: InputMaybe<JsonFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BuildingAreaFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BuildingAreaFilter>>;
  /** Filter by the object’s `overrideArea` field. */
  overrideArea?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `BuildingArea` */
export type BuildingAreaInput = {
  /** Mutates a `BuildingAreaType` as part of the payload */
  buildingAreaType?: InputMaybe<BuildingAreaTypeInput>;
  /** This associates the building area with a building area type. */
  buildingAreaTypeId?: InputMaybe<Scalars['String']['input']>;
  /** Long-form description of the building area. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The external customer or reference identifier for the building area. */
  externalCustomerId?: InputMaybe<Scalars['String']['input']>;
  /** This represents the facility that the building area belongs to. */
  facilityId: Scalars['Int']['input'];
  /** The GIS Egeometry which specifies how the building area should be dispElayed on a map. */
  geometry?: InputMaybe<Scalars['GeoJSON']['input']>;
  /** Human-readable label for the building area. */
  label: Scalars['String']['input'];
  /** The metadata of the building area. */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** Manually set area in sqft that takes precedence over the area calculated from the geometry. */
  overrideArea?: InputMaybe<Scalars['Float']['input']>;
};

/** A connection to a list of `BuildingAreaPalletHistory` values. */
export type BuildingAreaPalletHistoriesConnection = {
  __typename?: 'BuildingAreaPalletHistoriesConnection';
  /** A list of edges which contains the `BuildingAreaPalletHistory` and cursor to aid in pagination. */
  edges: Array<BuildingAreaPalletHistoriesEdge>;
  /** A list of `BuildingAreaPalletHistory` objects. */
  nodes: Array<BuildingAreaPalletHistory>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BuildingAreaPalletHistory` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `BuildingAreaPalletHistory` edge in the connection. */
export type BuildingAreaPalletHistoriesEdge = {
  __typename?: 'BuildingAreaPalletHistoriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `BuildingAreaPalletHistory` at the end of the edge. */
  node: BuildingAreaPalletHistory;
};

/** Contains the history of pallets existing in a particular building area within a facility */
export type BuildingAreaPalletHistory = Node & {
  __typename?: 'BuildingAreaPalletHistory';
  /** Reads a single `BuildingArea` that is related to this `BuildingAreaPalletHistory`. */
  buildingArea?: Maybe<BuildingArea>;
  /** The referenced building area */
  buildingAreaId: Scalars['Int']['output'];
  /** The time at which the record was created */
  createdAt: Scalars['Datetime']['output'];
  deletedAt?: Maybe<Scalars['Datetime']['output']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['BigInt']['output'];
  /** The date and time of the pallet entering the building area */
  inTime: Scalars['Datetime']['output'];
  /** Reads a single `PalletHistory` that is related to this `BuildingAreaPalletHistory`. */
  inTransaction?: Maybe<PalletHistory>;
  /** The referenced transaction that registered the pallet as entering this building area */
  inTransactionId?: Maybe<Scalars['BigInt']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The data and time of the pallet exiting the building area */
  outTime?: Maybe<Scalars['Datetime']['output']>;
  /** Reads a single `PalletHistory` that is related to this `BuildingAreaPalletHistory`. */
  outTransaction?: Maybe<PalletHistory>;
  /** The referenced transaction that registered the pallet as leaving this building area */
  outTransactionId?: Maybe<Scalars['BigInt']['output']>;
  /** Reads a single `Pallet` that is related to this `BuildingAreaPalletHistory`. */
  pallet?: Maybe<Pallet>;
  /** The referenced warehouse pallet */
  palletId: Scalars['BigInt']['output'];
  /** Reads a single `PalletLocation` that is related to this `BuildingAreaPalletHistory`. */
  palletLocation?: Maybe<PalletLocation>;
  /** The pallet location within the building area this pallet is located in */
  palletLocationId?: Maybe<Scalars['BigInt']['output']>;
  /** The time at which the record was updated */
  updatedAt: Scalars['Datetime']['output'];
};

/** A filter to be used against `BuildingAreaPalletHistory` object types. All fields are combined with a logical ‘and.’ */
export type BuildingAreaPalletHistoryFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BuildingAreaPalletHistoryFilter>>;
  /** Filter by the object’s `buildingAreaId` field. */
  buildingAreaId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `inTime` field. */
  inTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `inTransactionId` field. */
  inTransactionId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `metadata` field. */
  metadata?: InputMaybe<JsonFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BuildingAreaPalletHistoryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BuildingAreaPalletHistoryFilter>>;
  /** Filter by the object’s `outTime` field. */
  outTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `outTransactionId` field. */
  outTransactionId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `palletId` field. */
  palletId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `palletLocationId` field. */
  palletLocationId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** Represents an update to a `BuildingArea`. Fields that are set will be updated. */
export type BuildingAreaPatch = {
  /** This associates the building area with a building area type. */
  buildingAreaTypeId?: InputMaybe<Scalars['String']['input']>;
  /** Long-form description of the building area. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The external customer or reference identifier for the building area. */
  externalCustomerId?: InputMaybe<Scalars['String']['input']>;
  /** This represents the facility that the building area belongs to. */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** The GIS Egeometry which specifies how the building area should be dispElayed on a map. */
  geometry?: InputMaybe<Scalars['GeoJSON']['input']>;
  /** Human-readable label for the building area. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** The metadata of the building area. */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** Manually set area in sqft that takes precedence over the area calculated from the geometry. */
  overrideArea?: InputMaybe<Scalars['Float']['input']>;
};

/** This represents the types or categories of building areas that exist in a facility. */
export type BuildingAreaType = Node & {
  __typename?: 'BuildingAreaType';
  /** Reads and enables pagination through a set of `BuildingArea`. */
  buildingAreas: BuildingAreasConnection;
  /** Long-form field used to elaborate on the type or capture alternate names of the type. */
  description: Scalars['String']['output'];
  /** Unstructured metadata associated with a building area */
  metadata: Scalars['JSON']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The short name of the building area type. */
  type: Scalars['String']['output'];
};

/** This represents the types or categories of building areas that exist in a facility. */
export type BuildingAreaTypeBuildingAreasArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BuildingAreaCondition>;
  filter?: InputMaybe<BuildingAreaFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BuildingAreasOrderBy>>;
};

/**
 * A condition to be used against `BuildingAreaType` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type BuildingAreaTypeCondition = {
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `metadata` field. */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `BuildingAreaType` object types. All fields are combined with a logical ‘and.’ */
export type BuildingAreaTypeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BuildingAreaTypeFilter>>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `metadata` field. */
  metadata?: InputMaybe<JsonFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BuildingAreaTypeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BuildingAreaTypeFilter>>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `BuildingAreaType` */
export type BuildingAreaTypeInput = {
  /** Long-form field used to elaborate on the type or capture alternate names of the type. */
  description: Scalars['String']['input'];
  /** Unstructured metadata associated with a building area */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** The short name of the building area type. */
  type: Scalars['String']['input'];
};

/** Represents an update to a `BuildingAreaType`. Fields that are set will be updated. */
export type BuildingAreaTypePatch = {
  /** Long-form field used to elaborate on the type or capture alternate names of the type. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Unstructured metadata associated with a building area */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** The short name of the building area type. */
  type?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `BuildingAreaType` values. */
export type BuildingAreaTypesConnection = {
  __typename?: 'BuildingAreaTypesConnection';
  /** A list of edges which contains the `BuildingAreaType` and cursor to aid in pagination. */
  edges: Array<BuildingAreaTypesEdge>;
  /** A list of `BuildingAreaType` objects. */
  nodes: Array<BuildingAreaType>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BuildingAreaType` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `BuildingAreaType` edge in the connection. */
export type BuildingAreaTypesEdge = {
  __typename?: 'BuildingAreaTypesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `BuildingAreaType` at the end of the edge. */
  node: BuildingAreaType;
};

/** Methods to use when ordering `BuildingAreaType`. */
export enum BuildingAreaTypesOrderBy {
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  METADATA_ASC = 'METADATA_ASC',
  METADATA_DESC = 'METADATA_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  TYPE_ASC = 'TYPE_ASC',
  TYPE_DESC = 'TYPE_DESC'
}

/** A connection to a list of `BuildingArea` values. */
export type BuildingAreasConnection = {
  __typename?: 'BuildingAreasConnection';
  /** A list of edges which contains the `BuildingArea` and cursor to aid in pagination. */
  edges: Array<BuildingAreasEdge>;
  /** A list of `BuildingArea` objects. */
  nodes: Array<BuildingArea>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BuildingArea` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `BuildingArea` edge in the connection. */
export type BuildingAreasEdge = {
  __typename?: 'BuildingAreasEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `BuildingArea` at the end of the edge. */
  node: BuildingArea;
};

/** Methods to use when ordering `BuildingArea`. */
export enum BuildingAreasOrderBy {
  BUILDING_AREA_TYPE_ID_ASC = 'BUILDING_AREA_TYPE_ID_ASC',
  BUILDING_AREA_TYPE_ID_DESC = 'BUILDING_AREA_TYPE_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  EXTERNAL_CUSTOMER_ID_ASC = 'EXTERNAL_CUSTOMER_ID_ASC',
  EXTERNAL_CUSTOMER_ID_DESC = 'EXTERNAL_CUSTOMER_ID_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  GEOMETRY_ASC = 'GEOMETRY_ASC',
  GEOMETRY_DESC = 'GEOMETRY_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LABEL_ASC = 'LABEL_ASC',
  LABEL_DESC = 'LABEL_DESC',
  METADATA_ASC = 'METADATA_ASC',
  METADATA_DESC = 'METADATA_DESC',
  NATURAL = 'NATURAL',
  OVERRIDE_AREA_ASC = 'OVERRIDE_AREA_ASC',
  OVERRIDE_AREA_DESC = 'OVERRIDE_AREA_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

export type BulkProjectUser = {
  controller?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['Boolean']['input']>;
  projectId: Scalars['Int']['input'];
  sms?: InputMaybe<Scalars['Boolean']['input']>;
  smsAI?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['String']['input'];
  watcher?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A connection to a list of `ChargeLabelCategory` values. */
export type ChargeLabelCategoriesConnection = {
  __typename?: 'ChargeLabelCategoriesConnection';
  /** A list of edges which contains the `ChargeLabelCategory` and cursor to aid in pagination. */
  edges: Array<ChargeLabelCategoriesEdge>;
  /** A list of `ChargeLabelCategory` objects. */
  nodes: Array<ChargeLabelCategory>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ChargeLabelCategory` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ChargeLabelCategory` edge in the connection. */
export type ChargeLabelCategoriesEdge = {
  __typename?: 'ChargeLabelCategoriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ChargeLabelCategory` at the end of the edge. */
  node: ChargeLabelCategory;
};

/** Methods to use when ordering `ChargeLabelCategory`. */
export enum ChargeLabelCategoriesOrderBy {
  CATEGORY_ASC = 'CATEGORY_ASC',
  CATEGORY_DESC = 'CATEGORY_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DISPLAY_CATEGORY_ASC = 'DISPLAY_CATEGORY_ASC',
  DISPLAY_CATEGORY_DESC = 'DISPLAY_CATEGORY_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** Charge label categories used to map charges to a human-readable display category. */
export type ChargeLabelCategory = Node & {
  __typename?: 'ChargeLabelCategory';
  /** Canonical, machine-friendly category identifier (snake_case). */
  category: Scalars['String']['output'];
  /** The time the category was created. */
  createdAt: Scalars['Datetime']['output'];
  /** Human-readable display label for the category. */
  displayCategory: Scalars['String']['output'];
  /** Primary key. */
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The time the category was last updated. */
  updatedAt: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `ChargeLabelCategory` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type ChargeLabelCategoryCondition = {
  /** Checks for equality with the object’s `category` field. */
  category?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `displayCategory` field. */
  displayCategory?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `ChargeLabelCategory` object types. All fields are combined with a logical ‘and.’ */
export type ChargeLabelCategoryFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ChargeLabelCategoryFilter>>;
  /** Filter by the object’s `category` field. */
  category?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `displayCategory` field. */
  displayCategory?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ChargeLabelCategoryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ChargeLabelCategoryFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

export type Chart = Node & {
  __typename?: 'Chart';
  config: Scalars['JSON']['output'];
  createdAt: Scalars['Datetime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Facility` that is related to this `Chart`. */
  facility?: Maybe<Facility>;
  facilityId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  updatedAt: Scalars['Datetime']['output'];
};

/** A condition to be used against `Chart` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type ChartCondition = {
  /** Checks for equality with the object’s `config` field. */
  config?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `Chart` object types. All fields are combined with a logical ‘and.’ */
export type ChartFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ChartFilter>>;
  /** Filter by the object’s `config` field. */
  config?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ChartFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ChartFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `Chart` */
export type ChartInput = {
  config?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

/** Represents an update to a `Chart`. Fields that are set will be updated. */
export type ChartPatch = {
  config?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `Chart` values. */
export type ChartsConnection = {
  __typename?: 'ChartsConnection';
  /** A list of edges which contains the `Chart` and cursor to aid in pagination. */
  edges: Array<ChartsEdge>;
  /** A list of `Chart` objects. */
  nodes: Array<Chart>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Chart` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Chart` edge in the connection. */
export type ChartsEdge = {
  __typename?: 'ChartsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Chart` at the end of the edge. */
  node: Chart;
};

/** Methods to use when ordering `Chart`. */
export enum ChartsOrderBy {
  CONFIG_ASC = 'CONFIG_ASC',
  CONFIG_DESC = 'CONFIG_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** A check is used to apply detections for one or more monitors in order to create incidents. */
export type Check = Node & {
  __typename?: 'Check';
  /** Additional attributes for the check */
  attributes: Array<Maybe<Scalars['String']['output']>>;
  /** Reads and enables pagination through a set of `CheckMonitor`. */
  checkMonitors: CheckMonitorsConnection;
  /** Indicates if produced incidents require a closure message before closing. */
  closureMessageRequired: Scalars['Boolean']['output'];
  /** The time the record was created. */
  createdAt: Scalars['Datetime']['output'];
  /** The description of the check. */
  description: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `FacilityCheck`. */
  facilityChecks: FacilityChecksConnection;
  /** The identifier of the check */
  id: Scalars['Int']['output'];
  /** Returns the incidents associated with a given check. */
  incidents: IncidentsConnection;
  /** Indicates if incidents can be produced from this check. */
  incidentsEnabled: Scalars['Boolean']['output'];
  /** Indicates whether the check is enabled or disabled. */
  isEnabled: Scalars['Boolean']['output'];
  /** The name of the check. */
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The amount of time between reminder notification sending. */
  reminderIntervalSeconds?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `Severity` that is related to this `Check`. */
  severity?: Maybe<Severity>;
  /** The severity of the check. */
  severityId: Scalars['Int']['output'];
  /** Indicates if produced incidents will automatically silence notifications once acknowledged. */
  silenceOnAcknowledge: Scalars['Boolean']['output'];
  /** The unique key of the check. */
  slug: Scalars['String']['output'];
  /** Reads a single `SoftwarePackage` that is related to this `Check`. */
  softwarePackage?: Maybe<SoftwarePackage>;
  softwarePackageId: Scalars['Int']['output'];
  /** The slug of the associated software package. */
  softwarePackageSlug?: Maybe<Scalars['String']['output']>;
  /**
   * Returns the software packages associated with a given check.
   * @deprecated Use direct softwarePackage field
   */
  softwarePackages: SoftwarePackagesConnection;
  /** The time the record was updated. */
  updatedAt: Scalars['Datetime']['output'];
};

/** A check is used to apply detections for one or more monitors in order to create incidents. */
export type CheckCheckMonitorsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CheckMonitorCondition>;
  filter?: InputMaybe<CheckMonitorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CheckMonitorsOrderBy>>;
};

/** A check is used to apply detections for one or more monitors in order to create incidents. */
export type CheckFacilityChecksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FacilityCheckCondition>;
  filter?: InputMaybe<FacilityCheckFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FacilityChecksOrderBy>>;
};

/** A check is used to apply detections for one or more monitors in order to create incidents. */
export type CheckIncidentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<IncidentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** A check is used to apply detections for one or more monitors in order to create incidents. */
export type CheckSoftwarePackagesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<SoftwarePackageFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** A condition to be used against `Check` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type CheckCondition = {
  /** Checks for equality with the object’s `attributes` field. */
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Checks for equality with the object’s `closureMessageRequired` field. */
  closureMessageRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `incidentsEnabled` field. */
  incidentsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `isEnabled` field. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `reminderIntervalSeconds` field. */
  reminderIntervalSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `severityId` field. */
  severityId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `silenceOnAcknowledge` field. */
  silenceOnAcknowledge?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `slug` field. */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `softwarePackageId` field. */
  softwarePackageId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `softwarePackageSlug` field. */
  softwarePackageSlug?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `Check` object types. All fields are combined with a logical ‘and.’ */
export type CheckFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CheckFilter>>;
  /** Filter by the object’s `attributes` field. */
  attributes?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `closureMessageRequired` field. */
  closureMessageRequired?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `incidentsEnabled` field. */
  incidentsEnabled?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isEnabled` field. */
  isEnabled?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CheckFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CheckFilter>>;
  /** Filter by the object’s `reminderIntervalSeconds` field. */
  reminderIntervalSeconds?: InputMaybe<IntFilter>;
  /** Filter by the object’s `severityId` field. */
  severityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `silenceOnAcknowledge` field. */
  silenceOnAcknowledge?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `slug` field. */
  slug?: InputMaybe<StringFilter>;
  /** Filter by the object’s `softwarePackageId` field. */
  softwarePackageId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `softwarePackageSlug` field. */
  softwarePackageSlug?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `Check` */
export type CheckInput = {
  /** Additional attributes for the check */
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Indicates if produced incidents require a closure message before closing. */
  closureMessageRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** The description of the check. */
  description: Scalars['String']['input'];
  /** Indicates if incidents can be produced from this check. */
  incidentsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates whether the check is enabled or disabled. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the check. */
  name: Scalars['String']['input'];
  /** The amount of time between reminder notification sending. */
  reminderIntervalSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** The severity of the check. */
  severityId: Scalars['Int']['input'];
  /** Indicates if produced incidents will automatically silence notifications once acknowledged. */
  silenceOnAcknowledge?: InputMaybe<Scalars['Boolean']['input']>;
  /** The unique key of the check. */
  slug: Scalars['String']['input'];
  softwarePackageId: Scalars['Int']['input'];
};

/** An association of monitors to checks. */
export type CheckMonitor = Node & {
  __typename?: 'CheckMonitor';
  /** Reads a single `Check` that is related to this `CheckMonitor`. */
  check?: Maybe<Check>;
  /** The check. */
  checkId: Scalars['Int']['output'];
  /** The slug of the check. */
  checkSlug?: Maybe<Scalars['String']['output']>;
  /** The time the record was created. */
  createdAt: Scalars['Datetime']['output'];
  /** Reads a single `Facility` that is related to this `CheckMonitor`. */
  facility?: Maybe<Facility>;
  /** The facility to which this monitor check belongs. */
  facilityId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** Reads and enables pagination through a set of `Incident`. */
  incidents: IncidentsConnection;
  /** Reads a single `Monitor` that is related to this `CheckMonitor`. */
  monitor?: Maybe<Monitor>;
  /** The monitor. */
  monitorId: Scalars['Int']['output'];
  /** The attributes of the related monitor. */
  monitorMergedAttributes?: Maybe<Scalars['JSON']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The time the record was updated. */
  updatedAt: Scalars['Datetime']['output'];
};

/** An association of monitors to checks. */
export type CheckMonitorIncidentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<IncidentCondition>;
  filter?: InputMaybe<IncidentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IncidentsOrderBy>>;
};

/**
 * A condition to be used against `CheckMonitor` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type CheckMonitorCondition = {
  /** Checks for equality with the object’s `checkId` field. */
  checkId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `checkSlug` field. */
  checkSlug?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `monitorId` field. */
  monitorId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `monitorMergedAttributes` field. */
  monitorMergedAttributes?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `CheckMonitor` object types. All fields are combined with a logical ‘and.’ */
export type CheckMonitorFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CheckMonitorFilter>>;
  /** Filter by the object’s `checkId` field. */
  checkId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `checkSlug` field. */
  checkSlug?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `monitorId` field. */
  monitorId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `monitorMergedAttributes` field. */
  monitorMergedAttributes?: InputMaybe<JsonFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CheckMonitorFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CheckMonitorFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `CheckMonitor` */
export type CheckMonitorInput = {
  /** The check. */
  checkId: Scalars['Int']['input'];
  /** The facility to which this monitor check belongs. */
  facilityId: Scalars['Int']['input'];
  /** Mutates a `Monitor` as part of the payload */
  monitor?: InputMaybe<MonitorInput>;
  /** The monitor. */
  monitorId?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents an update to a `CheckMonitor`. Fields that are set will be updated. */
export type CheckMonitorPatch = {
  /** The check. */
  checkId?: InputMaybe<Scalars['Int']['input']>;
  /** The facility to which this monitor check belongs. */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** The monitor. */
  monitorId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `CheckMonitor` values. */
export type CheckMonitorsConnection = {
  __typename?: 'CheckMonitorsConnection';
  /** A list of edges which contains the `CheckMonitor` and cursor to aid in pagination. */
  edges: Array<CheckMonitorsEdge>;
  /** A list of `CheckMonitor` objects. */
  nodes: Array<CheckMonitor>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CheckMonitor` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CheckMonitor` edge in the connection. */
export type CheckMonitorsEdge = {
  __typename?: 'CheckMonitorsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CheckMonitor` at the end of the edge. */
  node: CheckMonitor;
};

/** Methods to use when ordering `CheckMonitor`. */
export enum CheckMonitorsOrderBy {
  CHECK_ID_ASC = 'CHECK_ID_ASC',
  CHECK_ID_DESC = 'CHECK_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  MONITOR_ID_ASC = 'MONITOR_ID_ASC',
  MONITOR_ID_DESC = 'MONITOR_ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** Represents an update to a `Check`. Fields that are set will be updated. */
export type CheckPatch = {
  /** Additional attributes for the check */
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Indicates if produced incidents require a closure message before closing. */
  closureMessageRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** The description of the check. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Indicates if incidents can be produced from this check. */
  incidentsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates whether the check is enabled or disabled. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the check. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The amount of time between reminder notification sending. */
  reminderIntervalSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** The severity of the check. */
  severityId?: InputMaybe<Scalars['Int']['input']>;
  /** Indicates if produced incidents will automatically silence notifications once acknowledged. */
  silenceOnAcknowledge?: InputMaybe<Scalars['Boolean']['input']>;
  /** The unique key of the check. */
  slug?: InputMaybe<Scalars['String']['input']>;
  softwarePackageId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `Check` values. */
export type ChecksConnection = {
  __typename?: 'ChecksConnection';
  /** A list of edges which contains the `Check` and cursor to aid in pagination. */
  edges: Array<ChecksEdge>;
  /** A list of `Check` objects. */
  nodes: Array<Check>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Check` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Check` edge in the connection. */
export type ChecksEdge = {
  __typename?: 'ChecksEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Check` at the end of the edge. */
  node: Check;
};

/** Methods to use when ordering `Check`. */
export enum ChecksOrderBy {
  ATTRIBUTES_ASC = 'ATTRIBUTES_ASC',
  ATTRIBUTES_DESC = 'ATTRIBUTES_DESC',
  CLOSURE_MESSAGE_REQUIRED_ASC = 'CLOSURE_MESSAGE_REQUIRED_ASC',
  CLOSURE_MESSAGE_REQUIRED_DESC = 'CLOSURE_MESSAGE_REQUIRED_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  INCIDENTS_ENABLED_ASC = 'INCIDENTS_ENABLED_ASC',
  INCIDENTS_ENABLED_DESC = 'INCIDENTS_ENABLED_DESC',
  IS_ENABLED_ASC = 'IS_ENABLED_ASC',
  IS_ENABLED_DESC = 'IS_ENABLED_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  REMINDER_INTERVAL_SECONDS_ASC = 'REMINDER_INTERVAL_SECONDS_ASC',
  REMINDER_INTERVAL_SECONDS_DESC = 'REMINDER_INTERVAL_SECONDS_DESC',
  SEVERITY_ID_ASC = 'SEVERITY_ID_ASC',
  SEVERITY_ID_DESC = 'SEVERITY_ID_DESC',
  SILENCE_ON_ACKNOWLEDGE_ASC = 'SILENCE_ON_ACKNOWLEDGE_ASC',
  SILENCE_ON_ACKNOWLEDGE_DESC = 'SILENCE_ON_ACKNOWLEDGE_DESC',
  SLUG_ASC = 'SLUG_ASC',
  SLUG_DESC = 'SLUG_DESC',
  SOFTWARE_PACKAGE_ID_ASC = 'SOFTWARE_PACKAGE_ID_ASC',
  SOFTWARE_PACKAGE_ID_DESC = 'SOFTWARE_PACKAGE_ID_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** Defines known classification issues or patterns that an assessment may detect. */
export type Classification = Node & {
  __typename?: 'Classification';
  /** Reads a single `AssessmentType` that is related to this `Classification`. */
  assessmentType?: Maybe<AssessmentType>;
  /** References the assessment type this classification is associated with. */
  assessmentTypeId: Scalars['Int']['output'];
  /** Reads and enables pagination through a set of `ClassificationResult`. */
  classificationResults: ClassificationResultsConnection;
  /** The time the record was created. */
  createdAt: Scalars['Datetime']['output'];
  /** A detailed description of the classification issue. */
  description: Scalars['String']['output'];
  /** The identifier of the classification. */
  id: Scalars['Int']['output'];
  /** The name of the classification. */
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The time the record was last updated. */
  updatedAt: Scalars['Datetime']['output'];
  /** The weight or severity of this classification in score computation. */
  weight: Scalars['BigFloat']['output'];
};

/** Defines known classification issues or patterns that an assessment may detect. */
export type ClassificationClassificationResultsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ClassificationResultCondition>;
  filter?: InputMaybe<ClassificationResultFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ClassificationResultsOrderBy>>;
};

/**
 * A condition to be used against `Classification` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ClassificationCondition = {
  /** Checks for equality with the object’s `assessmentTypeId` field. */
  assessmentTypeId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `weight` field. */
  weight?: InputMaybe<Scalars['BigFloat']['input']>;
};

/** A filter to be used against `Classification` object types. All fields are combined with a logical ‘and.’ */
export type ClassificationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ClassificationFilter>>;
  /** Filter by the object’s `assessmentTypeId` field. */
  assessmentTypeId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ClassificationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ClassificationFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `weight` field. */
  weight?: InputMaybe<BigFloatFilter>;
};

/** An input for mutations affecting `Classification` */
export type ClassificationInput = {
  /** References the assessment type this classification is associated with. */
  assessmentTypeId: Scalars['Int']['input'];
  /** A detailed description of the classification issue. */
  description: Scalars['String']['input'];
  /** The name of the classification. */
  name: Scalars['String']['input'];
  /** The weight or severity of this classification in score computation. */
  weight?: InputMaybe<Scalars['BigFloat']['input']>;
};

/** Represents an update to a `Classification`. Fields that are set will be updated. */
export type ClassificationPatch = {
  /** References the assessment type this classification is associated with. */
  assessmentTypeId?: InputMaybe<Scalars['Int']['input']>;
  /** A detailed description of the classification issue. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The name of the classification. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The weight or severity of this classification in score computation. */
  weight?: InputMaybe<Scalars['BigFloat']['input']>;
};

/** Stores the individual classification results found during an assessment. */
export type ClassificationResult = Node & {
  __typename?: 'ClassificationResult';
  /** Reads a single `Assessment` that is related to this `ClassificationResult`. */
  assessment?: Maybe<Assessment>;
  /** References the assessment in which this classification was found. */
  assessmentId: Scalars['Int']['output'];
  /** Reads a single `Classification` that is related to this `ClassificationResult`. */
  classification?: Maybe<Classification>;
  /** References the classification that was triggered. */
  classificationId: Scalars['Int']['output'];
  /** The time the record was created. */
  createdAt: Scalars['Datetime']['output'];
  /** The identifier of the classification result. */
  id: Scalars['Int']['output'];
  /** The impact of the identified classification. */
  impactScore: Scalars['BigFloat']['output'];
  /** Whether the result contributes to the overall score. */
  isContributing: Scalars['Boolean']['output'];
  /** Whether the result had enough information to be classified reliably. */
  isInconclusive: Scalars['Boolean']['output'];
  /** A human-readable explanation for why the classification was triggered. */
  justification?: Maybe<Scalars['String']['output']>;
  /** The time the result was last justified. */
  justifiedAt?: Maybe<Scalars['Datetime']['output']>;
  /** The metadata associated with the identified classification result. */
  metadata: Scalars['JSON']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The time the record was last updated. */
  updatedAt: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `ClassificationResult` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type ClassificationResultCondition = {
  /** Checks for equality with the object’s `assessmentId` field. */
  assessmentId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `classificationId` field. */
  classificationId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `impactScore` field. */
  impactScore?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `isContributing` field. */
  isContributing?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `isInconclusive` field. */
  isInconclusive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `justification` field. */
  justification?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `justifiedAt` field. */
  justifiedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `metadata` field. */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `ClassificationResult` object types. All fields are combined with a logical ‘and.’ */
export type ClassificationResultFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ClassificationResultFilter>>;
  /** Filter by the object’s `assessmentId` field. */
  assessmentId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `classificationId` field. */
  classificationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `impactScore` field. */
  impactScore?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `isContributing` field. */
  isContributing?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isInconclusive` field. */
  isInconclusive?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `justification` field. */
  justification?: InputMaybe<StringFilter>;
  /** Filter by the object’s `justifiedAt` field. */
  justifiedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `metadata` field. */
  metadata?: InputMaybe<JsonFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ClassificationResultFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ClassificationResultFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `ClassificationResult` */
export type ClassificationResultInput = {
  /** References the assessment in which this classification was found. */
  assessmentId: Scalars['Int']['input'];
  /** References the classification that was triggered. */
  classificationId: Scalars['Int']['input'];
  /** The impact of the identified classification. */
  impactScore?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Whether the result contributes to the overall score. */
  isContributing?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the result had enough information to be classified reliably. */
  isInconclusive?: InputMaybe<Scalars['Boolean']['input']>;
  /** A human-readable explanation for why the classification was triggered. */
  justification?: InputMaybe<Scalars['String']['input']>;
  /** The metadata associated with the identified classification result. */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
};

/** Represents an update to a `ClassificationResult`. Fields that are set will be updated. */
export type ClassificationResultPatch = {
  /** References the assessment in which this classification was found. */
  assessmentId?: InputMaybe<Scalars['Int']['input']>;
  /** References the classification that was triggered. */
  classificationId?: InputMaybe<Scalars['Int']['input']>;
  /** The impact of the identified classification. */
  impactScore?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Whether the result contributes to the overall score. */
  isContributing?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the result had enough information to be classified reliably. */
  isInconclusive?: InputMaybe<Scalars['Boolean']['input']>;
  /** A human-readable explanation for why the classification was triggered. */
  justification?: InputMaybe<Scalars['String']['input']>;
  /** The metadata associated with the identified classification result. */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
};

/** A connection to a list of `ClassificationResult` values. */
export type ClassificationResultsConnection = {
  __typename?: 'ClassificationResultsConnection';
  /** A list of edges which contains the `ClassificationResult` and cursor to aid in pagination. */
  edges: Array<ClassificationResultsEdge>;
  /** A list of `ClassificationResult` objects. */
  nodes: Array<ClassificationResult>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ClassificationResult` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ClassificationResult` edge in the connection. */
export type ClassificationResultsEdge = {
  __typename?: 'ClassificationResultsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ClassificationResult` at the end of the edge. */
  node: ClassificationResult;
};

/** Methods to use when ordering `ClassificationResult`. */
export enum ClassificationResultsOrderBy {
  ASSESSMENT_ID_ASC = 'ASSESSMENT_ID_ASC',
  ASSESSMENT_ID_DESC = 'ASSESSMENT_ID_DESC',
  CLASSIFICATION_ID_ASC = 'CLASSIFICATION_ID_ASC',
  CLASSIFICATION_ID_DESC = 'CLASSIFICATION_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  IMPACT_SCORE_ASC = 'IMPACT_SCORE_ASC',
  IMPACT_SCORE_DESC = 'IMPACT_SCORE_DESC',
  IS_CONTRIBUTING_ASC = 'IS_CONTRIBUTING_ASC',
  IS_CONTRIBUTING_DESC = 'IS_CONTRIBUTING_DESC',
  IS_INCONCLUSIVE_ASC = 'IS_INCONCLUSIVE_ASC',
  IS_INCONCLUSIVE_DESC = 'IS_INCONCLUSIVE_DESC',
  JUSTIFICATION_ASC = 'JUSTIFICATION_ASC',
  JUSTIFICATION_DESC = 'JUSTIFICATION_DESC',
  JUSTIFIED_AT_ASC = 'JUSTIFIED_AT_ASC',
  JUSTIFIED_AT_DESC = 'JUSTIFIED_AT_DESC',
  METADATA_ASC = 'METADATA_ASC',
  METADATA_DESC = 'METADATA_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** A connection to a list of `Classification` values. */
export type ClassificationsConnection = {
  __typename?: 'ClassificationsConnection';
  /** A list of edges which contains the `Classification` and cursor to aid in pagination. */
  edges: Array<ClassificationsEdge>;
  /** A list of `Classification` objects. */
  nodes: Array<Classification>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Classification` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Classification` edge in the connection. */
export type ClassificationsEdge = {
  __typename?: 'ClassificationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Classification` at the end of the edge. */
  node: Classification;
};

/** Methods to use when ordering `Classification`. */
export enum ClassificationsOrderBy {
  ASSESSMENT_TYPE_ID_ASC = 'ASSESSMENT_TYPE_ID_ASC',
  ASSESSMENT_TYPE_ID_DESC = 'ASSESSMENT_TYPE_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  WEIGHT_ASC = 'WEIGHT_ASC',
  WEIGHT_DESC = 'WEIGHT_DESC'
}

/** All input for the `clearFacilityCommunication` mutation. */
export type ClearFacilityCommunicationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  facilityCommunicationId: Scalars['Int']['input'];
};

/** The output of our `clearFacilityCommunication` mutation. */
export type ClearFacilityCommunicationPayload = {
  __typename?: 'ClearFacilityCommunicationPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type ClearSpaceInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  notifyDriver?: InputMaybe<Scalars['Boolean']['input']>;
  spaceId: Scalars['Int']['input'];
  trailerId: Scalars['Int']['input'];
  yardId: Scalars['Int']['input'];
};

export type ClearSpacePayload = {
  __typename?: 'ClearSpacePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  space?: Maybe<Space>;
};

/** All input for the `closeIncident` mutation. */
export type CloseIncidentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  incidentId?: InputMaybe<Scalars['Int']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `closeIncident` mutation. */
export type CloseIncidentPayload = {
  __typename?: 'CloseIncidentPayload';
  /** Reads a single `CheckMonitor` that is related to this `Incident`. */
  checkMonitor?: Maybe<CheckMonitor>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  incident?: Maybe<Incident>;
  /** An edge for our `Incident`. May be used by Relay 1. */
  incidentEdge?: Maybe<IncidentsEdge>;
  /** Reads a single `MonitorDetection` that is related to this `Incident`. */
  monitorDetection?: Maybe<MonitorDetection>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our `closeIncident` mutation. */
export type CloseIncidentPayloadIncidentEdgeArgs = {
  orderBy?: InputMaybe<Array<IncidentsOrderBy>>;
};

export type CloseStaleDriverConversationsPayload = {
  __typename?: 'CloseStaleDriverConversationsPayload';
  activeCount: Scalars['Int']['output'];
  closedCount: Scalars['Int']['output'];
  hasMore: Scalars['Boolean']['output'];
  staleCount: Scalars['Int']['output'];
};

/** A grouping of compliance ranges that make up a single unique group */
export type ComplianceGroup = Node & {
  __typename?: 'ComplianceGroup';
  /** Reads and enables pagination through a set of `BuildingAreaComplianceGroup`. */
  buildingAreaComplianceGroups: BuildingAreaComplianceGroupsConnection;
  /** Reads and enables pagination through a set of `ComplianceRange`. */
  complianceRanges: ComplianceRangesConnection;
  /** The time at which the Compliance Group was created */
  createdAt: Scalars['Datetime']['output'];
  /** The id of the compliance group */
  id: Scalars['Int']['output'];
  /** The unique label of the compliance group (ex: Freezer, Cooler, Ice Cream Freezer) */
  label: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Whether or not the duration of time in/out of compliance is tracked for this compliance group */
  trackOutOfSpecification: Scalars['Boolean']['output'];
  /** The time at which the Compliance Group was updated */
  updatedAt: Scalars['Datetime']['output'];
};

/** A grouping of compliance ranges that make up a single unique group */
export type ComplianceGroupBuildingAreaComplianceGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BuildingAreaComplianceGroupCondition>;
  filter?: InputMaybe<BuildingAreaComplianceGroupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BuildingAreaComplianceGroupsOrderBy>>;
};

/** A grouping of compliance ranges that make up a single unique group */
export type ComplianceGroupComplianceRangesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ComplianceRangeCondition>;
  filter?: InputMaybe<ComplianceRangeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ComplianceRangesOrderBy>>;
};

/**
 * A condition to be used against `ComplianceGroup` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ComplianceGroupCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `label` field. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `trackOutOfSpecification` field. */
  trackOutOfSpecification?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `ComplianceGroup` object types. All fields are combined with a logical ‘and.’ */
export type ComplianceGroupFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ComplianceGroupFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `label` field. */
  label?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ComplianceGroupFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ComplianceGroupFilter>>;
  /** Filter by the object’s `trackOutOfSpecification` field. */
  trackOutOfSpecification?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `ComplianceGroup` */
export type ComplianceGroupInput = {
  /** The unique label of the compliance group (ex: Freezer, Cooler, Ice Cream Freezer) */
  label: Scalars['String']['input'];
  /** Whether or not the duration of time in/out of compliance is tracked for this compliance group */
  trackOutOfSpecification?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Represents an update to a `ComplianceGroup`. Fields that are set will be updated. */
export type ComplianceGroupPatch = {
  /** The unique label of the compliance group (ex: Freezer, Cooler, Ice Cream Freezer) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Whether or not the duration of time in/out of compliance is tracked for this compliance group */
  trackOutOfSpecification?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A connection to a list of `ComplianceGroup` values. */
export type ComplianceGroupsConnection = {
  __typename?: 'ComplianceGroupsConnection';
  /** A list of edges which contains the `ComplianceGroup` and cursor to aid in pagination. */
  edges: Array<ComplianceGroupsEdge>;
  /** A list of `ComplianceGroup` objects. */
  nodes: Array<ComplianceGroup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ComplianceGroup` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ComplianceGroup` edge in the connection. */
export type ComplianceGroupsEdge = {
  __typename?: 'ComplianceGroupsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ComplianceGroup` at the end of the edge. */
  node: ComplianceGroup;
};

/** Methods to use when ordering `ComplianceGroup`. */
export enum ComplianceGroupsOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LABEL_ASC = 'LABEL_ASC',
  LABEL_DESC = 'LABEL_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  TRACK_OUT_OF_SPECIFICATION_ASC = 'TRACK_OUT_OF_SPECIFICATION_ASC',
  TRACK_OUT_OF_SPECIFICATION_DESC = 'TRACK_OUT_OF_SPECIFICATION_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** A grouping of compliance ranges that make up a single unique group */
export type ComplianceRange = Node & {
  __typename?: 'ComplianceRange';
  /** Reads a single `ComplianceGroup` that is related to this `ComplianceRange`. */
  complianceGroup?: Maybe<ComplianceGroup>;
  /** The group this compliance range belongs to */
  complianceGroupId?: Maybe<Scalars['Int']['output']>;
  /** The time at which the Compliance Range was created */
  createdAt: Scalars['Datetime']['output'];
  /** The low value of the range (exclusive, < value) */
  highValue: Scalars['Float']['output'];
  /** The id of the compliance range */
  id: Scalars['Int']['output'];
  /** Set if the values in this range should be considered within the specification */
  isWithinSpecification: Scalars['Boolean']['output'];
  /** The unique label of the compliance range (ex: Out of Compliance, Above Compliance) */
  label: Scalars['String']['output'];
  /** The low value of the range (inclusive, >= value) */
  lowValue: Scalars['Float']['output'];
  /** Arbitrary data for storage */
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The time at which the Compliance Range was updated */
  updatedAt: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `ComplianceRange` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ComplianceRangeCondition = {
  /** Checks for equality with the object’s `complianceGroupId` field. */
  complianceGroupId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `highValue` field. */
  highValue?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `isWithinSpecification` field. */
  isWithinSpecification?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `label` field. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `lowValue` field. */
  lowValue?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `metadata` field. */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `ComplianceRange` object types. All fields are combined with a logical ‘and.’ */
export type ComplianceRangeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ComplianceRangeFilter>>;
  /** Filter by the object’s `complianceGroupId` field. */
  complianceGroupId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `highValue` field. */
  highValue?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isWithinSpecification` field. */
  isWithinSpecification?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `label` field. */
  label?: InputMaybe<StringFilter>;
  /** Filter by the object’s `lowValue` field. */
  lowValue?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `metadata` field. */
  metadata?: InputMaybe<JsonFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ComplianceRangeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ComplianceRangeFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `ComplianceRange` */
export type ComplianceRangeInput = {
  /** Mutates a `ComplianceGroup` as part of the payload */
  complianceGroup?: InputMaybe<ComplianceGroupInput>;
  /** The group this compliance range belongs to */
  complianceGroupId?: InputMaybe<Scalars['Int']['input']>;
  /** The low value of the range (exclusive, < value) */
  highValue: Scalars['Float']['input'];
  /** Set if the values in this range should be considered within the specification */
  isWithinSpecification: Scalars['Boolean']['input'];
  /** The unique label of the compliance range (ex: Out of Compliance, Above Compliance) */
  label: Scalars['String']['input'];
  /** The low value of the range (inclusive, >= value) */
  lowValue: Scalars['Float']['input'];
  /** Arbitrary data for storage */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
};

/** Represents an update to a `ComplianceRange`. Fields that are set will be updated. */
export type ComplianceRangePatch = {
  /** The group this compliance range belongs to */
  complianceGroupId?: InputMaybe<Scalars['Int']['input']>;
  /** The low value of the range (exclusive, < value) */
  highValue?: InputMaybe<Scalars['Float']['input']>;
  /** Set if the values in this range should be considered within the specification */
  isWithinSpecification?: InputMaybe<Scalars['Boolean']['input']>;
  /** The unique label of the compliance range (ex: Out of Compliance, Above Compliance) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** The low value of the range (inclusive, >= value) */
  lowValue?: InputMaybe<Scalars['Float']['input']>;
  /** Arbitrary data for storage */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
};

/** A connection to a list of `ComplianceRange` values. */
export type ComplianceRangesConnection = {
  __typename?: 'ComplianceRangesConnection';
  /** A list of edges which contains the `ComplianceRange` and cursor to aid in pagination. */
  edges: Array<ComplianceRangesEdge>;
  /** A list of `ComplianceRange` objects. */
  nodes: Array<ComplianceRange>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ComplianceRange` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ComplianceRange` edge in the connection. */
export type ComplianceRangesEdge = {
  __typename?: 'ComplianceRangesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ComplianceRange` at the end of the edge. */
  node: ComplianceRange;
};

/** Methods to use when ordering `ComplianceRange`. */
export enum ComplianceRangesOrderBy {
  COMPLIANCE_GROUP_ID_ASC = 'COMPLIANCE_GROUP_ID_ASC',
  COMPLIANCE_GROUP_ID_DESC = 'COMPLIANCE_GROUP_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  HIGH_VALUE_ASC = 'HIGH_VALUE_ASC',
  HIGH_VALUE_DESC = 'HIGH_VALUE_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  IS_WITHIN_SPECIFICATION_ASC = 'IS_WITHIN_SPECIFICATION_ASC',
  IS_WITHIN_SPECIFICATION_DESC = 'IS_WITHIN_SPECIFICATION_DESC',
  LABEL_ASC = 'LABEL_ASC',
  LABEL_DESC = 'LABEL_DESC',
  LOW_VALUE_ASC = 'LOW_VALUE_ASC',
  LOW_VALUE_DESC = 'LOW_VALUE_DESC',
  METADATA_ASC = 'METADATA_ASC',
  METADATA_DESC = 'METADATA_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

export enum ComplianceType {
  AMMONIA = 'AMMONIA',
  HUMIDITY = 'HUMIDITY',
  TEMPERATURE = 'TEMPERATURE'
}

/** A filter to be used against ComplianceType fields. All fields are combined with a logical ‘and.’ */
export type ComplianceTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<ComplianceType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<ComplianceType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<ComplianceType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<ComplianceType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<ComplianceType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<ComplianceType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<ComplianceType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<ComplianceType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<ComplianceType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<ComplianceType>>;
};

/** A component. */
export type Component = Node & {
  __typename?: 'Component';
  /** An optional alias for the component. */
  alias?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `ControlEvent`. */
  controlEvents: ControlEventsConnection;
  /** The date the component was created at */
  createdAt: Scalars['Datetime']['output'];
  /** Reads a single `Facility` that is related to this `Component`. */
  facility?: Maybe<Facility>;
  /** The identifier of the facility associated with the component */
  facilityId: Scalars['Int']['output'];
  /** The identifier of the component */
  id: Scalars['Int']['output'];
  /** Reads a single `MachineUser` that is related to this `Component`. */
  machineUser?: Maybe<MachineUser>;
  /** The identifier of the machine user associated with the component */
  machineUserId: Scalars['BigInt']['output'];
  /** Human readable name of the component */
  name: Scalars['String']['output'];
  /** The next or current `ControlEvent` associated with the component. */
  nextControlEvents: ControlEventsConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Whether the component is out of service */
  outOfService: Scalars['Boolean']['output'];
  /** Available permissions for the Component. */
  permissions?: Maybe<ComponentPermissions>;
  /** The date the component was updated at */
  updatedAt: Scalars['Datetime']['output'];
};

/** A component. */
export type ComponentControlEventsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ControlEventCondition>;
  filter?: InputMaybe<ControlEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ControlEventsOrderBy>>;
};

/** A component. */
export type ComponentNextControlEventsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<ControlEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * A condition to be used against `Component` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ComponentCondition = {
  /** Checks for equality with the object’s `alias` field. */
  alias?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `machineUserId` field. */
  machineUserId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `outOfService` field. */
  outOfService?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `Component` object types. All fields are combined with a logical ‘and.’ */
export type ComponentFilter = {
  /** Filter by the object’s `alias` field. */
  alias?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ComponentFilter>>;
  /** Filter by the permission can_write */
  canWrite?: InputMaybe<PermissionBooleanFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `machineUserId` field. */
  machineUserId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ComponentFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ComponentFilter>>;
  /** Filter by the object’s `outOfService` field. */
  outOfService?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `Component` */
export type ComponentInput = {
  /** An optional alias for the component. */
  alias?: InputMaybe<Scalars['String']['input']>;
  /** The date the component was created at */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** The identifier of the facility associated with the component */
  facilityId: Scalars['Int']['input'];
  /** The identifier of the component */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Mutates a `MachineUser` as part of the payload */
  machineUser?: InputMaybe<MachineUserInput>;
  /** The identifier of the machine user associated with the component */
  machineUserId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Human readable name of the component */
  name: Scalars['String']['input'];
  /** Whether the component is out of service */
  outOfService?: InputMaybe<Scalars['Boolean']['input']>;
  /** The date the component was updated at */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** Represents an update to a `Component`. Fields that are set will be updated. */
export type ComponentPatch = {
  /** An optional alias for the component. */
  alias?: InputMaybe<Scalars['String']['input']>;
  /** The date the component was created at */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** The identifier of the facility associated with the component */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** The identifier of the component */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** The identifier of the machine user associated with the component */
  machineUserId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Human readable name of the component */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Whether the component is out of service */
  outOfService?: InputMaybe<Scalars['Boolean']['input']>;
  /** The date the component was updated at */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** Permissive capabilities on a Component. */
export type ComponentPermissions = {
  __typename?: 'ComponentPermissions';
  /** Whether a user can update the component. */
  canWrite: Scalars['Boolean']['output'];
};

/** A connection to a list of `Component` values. */
export type ComponentsConnection = {
  __typename?: 'ComponentsConnection';
  /** A list of edges which contains the `Component` and cursor to aid in pagination. */
  edges: Array<ComponentsEdge>;
  /** A list of `Component` objects. */
  nodes: Array<Component>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Component` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Component` edge in the connection. */
export type ComponentsEdge = {
  __typename?: 'ComponentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Component` at the end of the edge. */
  node: Component;
};

/** Methods to use when ordering `Component`. */
export enum ComponentsOrderBy {
  ALIAS_ASC = 'ALIAS_ASC',
  ALIAS_DESC = 'ALIAS_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  MACHINE_USER_ID_ASC = 'MACHINE_USER_ID_ASC',
  MACHINE_USER_ID_DESC = 'MACHINE_USER_ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  OUT_OF_SERVICE_ASC = 'OUT_OF_SERVICE_ASC',
  OUT_OF_SERVICE_DESC = 'OUT_OF_SERVICE_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** This represents a compressor that exists in a facility */
export type Compressor = Node & {
  __typename?: 'Compressor';
  assetFacilityId?: Maybe<Scalars['Int']['output']>;
  assetName?: Maybe<Scalars['String']['output']>;
  /** Reads a single `BuildingArea` that is related to this `Compressor`. */
  buildingArea?: Maybe<BuildingArea>;
  /** The associated area of within a building */
  buildingAreaId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  capacity?: Maybe<DataPoint>;
  /** The capacity */
  capacityId?: Maybe<Scalars['BigInt']['output']>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  controlMode?: Maybe<DataPoint>;
  /** The control mode state value */
  controlModeId?: Maybe<Scalars['BigInt']['output']>;
  /** The time at which the Compressor was created. */
  createdAt: Scalars['Datetime']['output'];
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  differentialPressure?: Maybe<DataPoint>;
  /** The differential pressure */
  differentialPressureId?: Maybe<Scalars['BigInt']['output']>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  dischargePressure?: Maybe<DataPoint>;
  /** The discharge pressure */
  dischargePressureId?: Maybe<Scalars['BigInt']['output']>;
  /** Reads a single `Facility` that is related to this `Compressor`. */
  facility?: Maybe<Facility>;
  /** The facility a compressor is installed within */
  facilityId?: Maybe<Scalars['Int']['output']>;
  /** The geocoded location of a compressor */
  geometry?: Maybe<GeometryInterface>;
  /** The rated horsepower of a compressor */
  horsepower?: Maybe<Scalars['Int']['output']>;
  /** The id of the compressor. */
  id: Scalars['Int']['output'];
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  kwDemand?: Maybe<DataPoint>;
  /** The electrical demand (KW) */
  kwDemandId?: Maybe<Scalars['BigInt']['output']>;
  /** A human-readable label for a compressor */
  label: Scalars['String']['output'];
  /** The related monitored asset. */
  monitoredAsset?: Maybe<MonitoredAsset>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  motorAmps?: Maybe<DataPoint>;
  /** The measured amperage (A) */
  motorAmpsId?: Maybe<Scalars['BigInt']['output']>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  motorState?: Maybe<DataPoint>;
  /** The motor state */
  motorStateId?: Maybe<Scalars['BigInt']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  oilPressure?: Maybe<DataPoint>;
  /** The oil pressure */
  oilPressureId?: Maybe<Scalars['BigInt']['output']>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  oilTemperature?: Maybe<DataPoint>;
  /** The oil temperature */
  oilTemperatureId?: Maybe<Scalars['BigInt']['output']>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  onStatus?: Maybe<DataPoint>;
  /** The on status */
  onStatusId?: Maybe<Scalars['BigInt']['output']>;
  /** Reads a single `RefrigerationSystem` that is related to this `Compressor`. */
  refrigerationSystem?: Maybe<RefrigerationSystem>;
  /** References the refrigeration system this compressor belongs to */
  refrigerationSystemId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  runtimeHours?: Maybe<DataPoint>;
  /** The current runtime */
  runtimeHoursId?: Maybe<Scalars['BigInt']['output']>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  setpoint?: Maybe<DataPoint>;
  /** The setpoint */
  setpointId?: Maybe<Scalars['BigInt']['output']>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  slideValvePosition?: Maybe<DataPoint>;
  /** The slide valve position */
  slideValvePositionId?: Maybe<Scalars['BigInt']['output']>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  state?: Maybe<DataPoint>;
  /** The current state */
  stateId?: Maybe<Scalars['BigInt']['output']>;
  /** Reads and enables pagination through a set of `SuctionHeadersCompressor`. */
  suctionHeadersCompressors: SuctionHeadersCompressorsConnection;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  suctionPressure?: Maybe<DataPoint>;
  /** The suction pressure */
  suctionPressureId?: Maybe<Scalars['BigInt']['output']>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  suctionPressureSetpointDeviation?: Maybe<DataPoint>;
  /** The deviation between the suction pressure setpoint and the measured suction pressure */
  suctionPressureSetpointDeviationId?: Maybe<Scalars['BigInt']['output']>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  suctionTemperature?: Maybe<DataPoint>;
  /** The suction temperature */
  suctionTemperatureId?: Maybe<Scalars['BigInt']['output']>;
  /** The time at which the Compressor was updated. */
  updatedAt: Scalars['Datetime']['output'];
};

/** This represents a compressor that exists in a facility */
export type CompressorSuctionHeadersCompressorsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SuctionHeadersCompressorCondition>;
  filter?: InputMaybe<SuctionHeadersCompressorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SuctionHeadersCompressorsOrderBy>>;
};

/**
 * A condition to be used against `Compressor` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type CompressorCondition = {
  /** Checks for equality with the object’s `buildingAreaId` field. */
  buildingAreaId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `capacityId` field. */
  capacityId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `controlModeId` field. */
  controlModeId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `differentialPressureId` field. */
  differentialPressureId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `dischargePressureId` field. */
  dischargePressureId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `geometry` field. */
  geometry?: InputMaybe<Scalars['GeoJSON']['input']>;
  /** Checks for equality with the object’s `horsepower` field. */
  horsepower?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `kwDemandId` field. */
  kwDemandId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `label` field. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `motorAmpsId` field. */
  motorAmpsId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `motorStateId` field. */
  motorStateId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `oilPressureId` field. */
  oilPressureId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `oilTemperatureId` field. */
  oilTemperatureId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `onStatusId` field. */
  onStatusId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `refrigerationSystemId` field. */
  refrigerationSystemId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `runtimeHoursId` field. */
  runtimeHoursId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `setpointId` field. */
  setpointId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `slideValvePositionId` field. */
  slideValvePositionId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `stateId` field. */
  stateId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `suctionPressureId` field. */
  suctionPressureId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `suctionPressureSetpointDeviationId` field. */
  suctionPressureSetpointDeviationId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `suctionTemperatureId` field. */
  suctionTemperatureId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `Compressor` object types. All fields are combined with a logical ‘and.’ */
export type CompressorFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CompressorFilter>>;
  /** Filter by the object’s `assetFacilityId` field. */
  assetFacilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `assetName` field. */
  assetName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `buildingAreaId` field. */
  buildingAreaId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `capacityId` field. */
  capacityId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `controlModeId` field. */
  controlModeId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `differentialPressureId` field. */
  differentialPressureId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `dischargePressureId` field. */
  dischargePressureId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `horsepower` field. */
  horsepower?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `kwDemandId` field. */
  kwDemandId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `label` field. */
  label?: InputMaybe<StringFilter>;
  /** Filter by the object’s `motorAmpsId` field. */
  motorAmpsId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `motorStateId` field. */
  motorStateId?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CompressorFilter>;
  /** Filter by the object’s `oilPressureId` field. */
  oilPressureId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `oilTemperatureId` field. */
  oilTemperatureId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `onStatusId` field. */
  onStatusId?: InputMaybe<BigIntFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CompressorFilter>>;
  /** Filter by the object’s `refrigerationSystemId` field. */
  refrigerationSystemId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `runtimeHoursId` field. */
  runtimeHoursId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `setpointId` field. */
  setpointId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `slideValvePositionId` field. */
  slideValvePositionId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `stateId` field. */
  stateId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `suctionPressureId` field. */
  suctionPressureId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `suctionPressureSetpointDeviationId` field. */
  suctionPressureSetpointDeviationId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `suctionTemperatureId` field. */
  suctionTemperatureId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `Compressor` */
export type CompressorInput = {
  /** Mutates a `BuildingArea` as part of the payload */
  buildingArea?: InputMaybe<BuildingAreaInput>;
  /** The associated area of within a building */
  buildingAreaId?: InputMaybe<Scalars['Int']['input']>;
  /** The capacity */
  capacityId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The control mode state value */
  controlModeId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Mutates a `DataPoint` as part of the payload */
  dataPoint?: InputMaybe<DataPointInput>;
  /** The differential pressure */
  differentialPressureId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The discharge pressure */
  dischargePressureId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The facility a compressor is installed within */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** The geocoded location of a compressor */
  geometry?: InputMaybe<Scalars['GeoJSON']['input']>;
  /** The rated horsepower of a compressor */
  horsepower?: InputMaybe<Scalars['Int']['input']>;
  /** The electrical demand (KW) */
  kwDemandId?: InputMaybe<Scalars['BigInt']['input']>;
  /** A human-readable label for a compressor */
  label: Scalars['String']['input'];
  /** The measured amperage (A) */
  motorAmpsId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The motor state */
  motorStateId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The oil pressure */
  oilPressureId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The oil temperature */
  oilTemperatureId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The on status */
  onStatusId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Mutates a `RefrigerationSystem` as part of the payload */
  refrigerationSystem?: InputMaybe<RefrigerationSystemInput>;
  /** References the refrigeration system this compressor belongs to */
  refrigerationSystemId?: InputMaybe<Scalars['Int']['input']>;
  /** The current runtime */
  runtimeHoursId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The setpoint */
  setpointId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The slide valve position */
  slideValvePositionId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The current state */
  stateId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The suction pressure */
  suctionPressureId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The deviation between the suction pressure setpoint and the measured suction pressure */
  suctionPressureSetpointDeviationId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The suction temperature */
  suctionTemperatureId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** Represents an update to a `Compressor`. Fields that are set will be updated. */
export type CompressorPatch = {
  /** The associated area of within a building */
  buildingAreaId?: InputMaybe<Scalars['Int']['input']>;
  /** The capacity */
  capacityId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The control mode state value */
  controlModeId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The differential pressure */
  differentialPressureId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The discharge pressure */
  dischargePressureId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The facility a compressor is installed within */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** The geocoded location of a compressor */
  geometry?: InputMaybe<Scalars['GeoJSON']['input']>;
  /** The rated horsepower of a compressor */
  horsepower?: InputMaybe<Scalars['Int']['input']>;
  /** The electrical demand (KW) */
  kwDemandId?: InputMaybe<Scalars['BigInt']['input']>;
  /** A human-readable label for a compressor */
  label?: InputMaybe<Scalars['String']['input']>;
  /** The measured amperage (A) */
  motorAmpsId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The motor state */
  motorStateId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The oil pressure */
  oilPressureId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The oil temperature */
  oilTemperatureId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The on status */
  onStatusId?: InputMaybe<Scalars['BigInt']['input']>;
  /** References the refrigeration system this compressor belongs to */
  refrigerationSystemId?: InputMaybe<Scalars['Int']['input']>;
  /** The current runtime */
  runtimeHoursId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The setpoint */
  setpointId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The slide valve position */
  slideValvePositionId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The current state */
  stateId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The suction pressure */
  suctionPressureId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The deviation between the suction pressure setpoint and the measured suction pressure */
  suctionPressureSetpointDeviationId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The suction temperature */
  suctionTemperatureId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A connection to a list of `Compressor` values. */
export type CompressorsConnection = {
  __typename?: 'CompressorsConnection';
  /** Returns the aggregate capacity timeseries data for the CompressorsConnection  */
  capacity?: Maybe<MetricDataConnection>;
  /** Returns the aggregate controlMode timeseries data for the CompressorsConnection  */
  controlMode?: Maybe<MetricDataConnection>;
  /** Returns the aggregate differentialPressure timeseries data for the CompressorsConnection  */
  differentialPressure?: Maybe<MetricDataConnection>;
  /** Returns the aggregate dischargePressure timeseries data for the CompressorsConnection  */
  dischargePressure?: Maybe<MetricDataConnection>;
  /** A list of edges which contains the `Compressor` and cursor to aid in pagination. */
  edges: Array<CompressorsEdge>;
  /** Returns the aggregate kwDemand timeseries data for the CompressorsConnection  */
  kwDemand?: Maybe<MetricDataConnection>;
  /** Returns the aggregate motorAmps timeseries data for the CompressorsConnection  */
  motorAmps?: Maybe<MetricDataConnection>;
  /** Returns the aggregate motorState timeseries data for the CompressorsConnection  */
  motorState?: Maybe<MetricDataConnection>;
  /** A list of `Compressor` objects. */
  nodes: Array<Compressor>;
  /** Returns the aggregate oilPressure timeseries data for the CompressorsConnection  */
  oilPressure?: Maybe<MetricDataConnection>;
  /** Returns the aggregate oilTemperature timeseries data for the CompressorsConnection  */
  oilTemperature?: Maybe<MetricDataConnection>;
  /** Returns the aggregate onStatus timeseries data for the CompressorsConnection  */
  onStatus?: Maybe<MetricDataConnection>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Returns the aggregate runtimeHours timeseries data for the CompressorsConnection  */
  runtimeHours?: Maybe<MetricDataConnection>;
  /** Returns the aggregate setpoint timeseries data for the CompressorsConnection  */
  setpoint?: Maybe<MetricDataConnection>;
  /** Returns the aggregate slideValvePosition timeseries data for the CompressorsConnection  */
  slideValvePosition?: Maybe<MetricDataConnection>;
  /** Returns the aggregate state timeseries data for the CompressorsConnection  */
  state?: Maybe<MetricDataConnection>;
  /** Returns the aggregate suctionPressure timeseries data for the CompressorsConnection  */
  suctionPressure?: Maybe<MetricDataConnection>;
  /** Returns the aggregate suctionPressureSetpointDeviation timeseries data for the CompressorsConnection  */
  suctionPressureSetpointDeviation?: Maybe<MetricDataConnection>;
  /** Returns the aggregate suctionTemperature timeseries data for the CompressorsConnection  */
  suctionTemperature?: Maybe<MetricDataConnection>;
  /** The count of *all* `Compressor` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A connection to a list of `Compressor` values. */
export type CompressorsConnectionCapacityArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Compressor` values. */
export type CompressorsConnectionControlModeArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Compressor` values. */
export type CompressorsConnectionDifferentialPressureArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Compressor` values. */
export type CompressorsConnectionDischargePressureArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Compressor` values. */
export type CompressorsConnectionKwDemandArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Compressor` values. */
export type CompressorsConnectionMotorAmpsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Compressor` values. */
export type CompressorsConnectionMotorStateArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Compressor` values. */
export type CompressorsConnectionOilPressureArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Compressor` values. */
export type CompressorsConnectionOilTemperatureArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Compressor` values. */
export type CompressorsConnectionOnStatusArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Compressor` values. */
export type CompressorsConnectionRuntimeHoursArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Compressor` values. */
export type CompressorsConnectionSetpointArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Compressor` values. */
export type CompressorsConnectionSlideValvePositionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Compressor` values. */
export type CompressorsConnectionStateArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Compressor` values. */
export type CompressorsConnectionSuctionPressureArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Compressor` values. */
export type CompressorsConnectionSuctionPressureSetpointDeviationArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Compressor` values. */
export type CompressorsConnectionSuctionTemperatureArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A `Compressor` edge in the connection. */
export type CompressorsEdge = {
  __typename?: 'CompressorsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Compressor` at the end of the edge. */
  node: Compressor;
};

/** Methods to use when ordering `Compressor`. */
export enum CompressorsOrderBy {
  BUILDING_AREA_ID_ASC = 'BUILDING_AREA_ID_ASC',
  BUILDING_AREA_ID_DESC = 'BUILDING_AREA_ID_DESC',
  CAPACITY_ID_ASC = 'CAPACITY_ID_ASC',
  CAPACITY_ID_DESC = 'CAPACITY_ID_DESC',
  CONTROL_MODE_ID_ASC = 'CONTROL_MODE_ID_ASC',
  CONTROL_MODE_ID_DESC = 'CONTROL_MODE_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DIFFERENTIAL_PRESSURE_ID_ASC = 'DIFFERENTIAL_PRESSURE_ID_ASC',
  DIFFERENTIAL_PRESSURE_ID_DESC = 'DIFFERENTIAL_PRESSURE_ID_DESC',
  DISCHARGE_PRESSURE_ID_ASC = 'DISCHARGE_PRESSURE_ID_ASC',
  DISCHARGE_PRESSURE_ID_DESC = 'DISCHARGE_PRESSURE_ID_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  GEOMETRY_ASC = 'GEOMETRY_ASC',
  GEOMETRY_DESC = 'GEOMETRY_DESC',
  HORSEPOWER_ASC = 'HORSEPOWER_ASC',
  HORSEPOWER_DESC = 'HORSEPOWER_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  KW_DEMAND_ID_ASC = 'KW_DEMAND_ID_ASC',
  KW_DEMAND_ID_DESC = 'KW_DEMAND_ID_DESC',
  LABEL_ASC = 'LABEL_ASC',
  LABEL_DESC = 'LABEL_DESC',
  MOTOR_AMPS_ID_ASC = 'MOTOR_AMPS_ID_ASC',
  MOTOR_AMPS_ID_DESC = 'MOTOR_AMPS_ID_DESC',
  MOTOR_STATE_ID_ASC = 'MOTOR_STATE_ID_ASC',
  MOTOR_STATE_ID_DESC = 'MOTOR_STATE_ID_DESC',
  NATURAL = 'NATURAL',
  OIL_PRESSURE_ID_ASC = 'OIL_PRESSURE_ID_ASC',
  OIL_PRESSURE_ID_DESC = 'OIL_PRESSURE_ID_DESC',
  OIL_TEMPERATURE_ID_ASC = 'OIL_TEMPERATURE_ID_ASC',
  OIL_TEMPERATURE_ID_DESC = 'OIL_TEMPERATURE_ID_DESC',
  ON_STATUS_ID_ASC = 'ON_STATUS_ID_ASC',
  ON_STATUS_ID_DESC = 'ON_STATUS_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  REFRIGERATION_SYSTEM_ID_ASC = 'REFRIGERATION_SYSTEM_ID_ASC',
  REFRIGERATION_SYSTEM_ID_DESC = 'REFRIGERATION_SYSTEM_ID_DESC',
  RUNTIME_HOURS_ID_ASC = 'RUNTIME_HOURS_ID_ASC',
  RUNTIME_HOURS_ID_DESC = 'RUNTIME_HOURS_ID_DESC',
  SETPOINT_ID_ASC = 'SETPOINT_ID_ASC',
  SETPOINT_ID_DESC = 'SETPOINT_ID_DESC',
  SLIDE_VALVE_POSITION_ID_ASC = 'SLIDE_VALVE_POSITION_ID_ASC',
  SLIDE_VALVE_POSITION_ID_DESC = 'SLIDE_VALVE_POSITION_ID_DESC',
  STATE_ID_ASC = 'STATE_ID_ASC',
  STATE_ID_DESC = 'STATE_ID_DESC',
  SUCTION_PRESSURE_ID_ASC = 'SUCTION_PRESSURE_ID_ASC',
  SUCTION_PRESSURE_ID_DESC = 'SUCTION_PRESSURE_ID_DESC',
  SUCTION_PRESSURE_SETPOINT_DEVIATION_ID_ASC = 'SUCTION_PRESSURE_SETPOINT_DEVIATION_ID_ASC',
  SUCTION_PRESSURE_SETPOINT_DEVIATION_ID_DESC = 'SUCTION_PRESSURE_SETPOINT_DEVIATION_ID_DESC',
  SUCTION_TEMPERATURE_ID_ASC = 'SUCTION_TEMPERATURE_ID_ASC',
  SUCTION_TEMPERATURE_ID_DESC = 'SUCTION_TEMPERATURE_ID_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** A control event. */
export type ControlEvent = Node & {
  __typename?: 'ControlEvent';
  /** The timestamp of the last acknowledgement. */
  acknowledgedAt?: Maybe<Scalars['Datetime']['output']>;
  availableStates: Array<ControlEventState>;
  /** Reads a single `Component` that is related to this `ControlEvent`. */
  component?: Maybe<Component>;
  /** Returns the specific configuration for the component for this event. */
  componentConfiguration?: Maybe<ProjectComponent>;
  /** The identifier of the component associated with the control event */
  componentId: Scalars['Int']['output'];
  /** Reads and enables pagination through a set of `ControlEventActivityLog`. */
  controlEventActivityLogs: ControlEventActivityLogsConnection;
  /** Reads and enables pagination through a set of `ControlEventLog`. */
  controlEventLogs: ControlEventLogsConnection;
  /** Reads and enables pagination through a set of `ControlEventStateTransition`. */
  controlEventStateTransitions: ControlEventStateTransitionsConnection;
  /** The date the control event was created at */
  createdAt: Scalars['Datetime']['output'];
  /** The current Project Enrollment associated with the control event. */
  currentEnrollment?: Maybe<ProjectEnrollment>;
  currentState?: Maybe<ControlEventState>;
  /** The current `ControlEventState` associated with the control event. */
  currentStateRef?: Maybe<ControlEventStateTransition>;
  /** The time the control event ended */
  endTime: Scalars['Datetime']['output'];
  /** The identifier of the control event */
  id: Scalars['Int']['output'];
  /** Whether the control event is acknowledged. */
  isAcknowledged?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Available permissions for the ControlEvent. */
  permissions?: Maybe<ControlEventPermissions>;
  /** Key-value store for remote metadata. */
  remoteMetadata: Scalars['JSON']['output'];
  /** The time the control event started */
  startTime: Scalars['Datetime']['output'];
  /** The associated suggestion, if exists. */
  suggestion?: Maybe<Suggestion>;
  /** Reads a single `SuggestionControlEvent` that is related to this `ControlEvent`. */
  suggestionControlEvent?: Maybe<SuggestionControlEvent>;
  /** Reads and enables pagination through a set of `Suggestion`. */
  suggestions: SuggestionsConnection;
  updatedAt: Scalars['Datetime']['output'];
};

/** A control event. */
export type ControlEventControlEventActivityLogsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ControlEventActivityLogCondition>;
  filter?: InputMaybe<ControlEventActivityLogFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ControlEventActivityLogsOrderBy>>;
};

/** A control event. */
export type ControlEventControlEventLogsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ControlEventLogCondition>;
  filter?: InputMaybe<ControlEventLogFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ControlEventLogsOrderBy>>;
};

/** A control event. */
export type ControlEventControlEventStateTransitionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ControlEventStateTransitionCondition>;
  filter?: InputMaybe<ControlEventStateTransitionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ControlEventStateTransitionsOrderBy>>;
};

/** A control event. */
export type ControlEventSuggestionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<SuggestionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ControlEventActivityLog = {
  __typename?: 'ControlEventActivityLog';
  /** The actor who performed the activity. */
  actor?: Maybe<Actor>;
  /** Reads a single `ControlEvent` that is related to this `ControlEventActivityLog`. */
  controlEvent?: Maybe<ControlEvent>;
  /** The control event associated with this activity log. */
  controlEventId?: Maybe<Scalars['Int']['output']>;
  /** The metadata associated with the activity. */
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** The time at which the activity occurred. */
  time?: Maybe<Scalars['Datetime']['output']>;
  /** The type of activity that occurred. */
  type?: Maybe<Scalars['String']['output']>;
};

/**
 * A condition to be used against `ControlEventActivityLog` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type ControlEventActivityLogCondition = {
  /** Checks for equality with the object’s `actor` field. */
  actor?: InputMaybe<ActorInput>;
  /** Checks for equality with the object’s `controlEventId` field. */
  controlEventId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `metadata` field. */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `time` field. */
  time?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `ControlEventActivityLog` object types. All fields are combined with a logical ‘and.’ */
export type ControlEventActivityLogFilter = {
  /** Filter by the object’s `actor` field. */
  actor?: InputMaybe<ActorFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ControlEventActivityLogFilter>>;
  /** Filter by the object’s `controlEventId` field. */
  controlEventId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ControlEventActivityLogFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ControlEventActivityLogFilter>>;
  /** Filter by the object’s `time` field. */
  time?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<StringFilter>;
};

/** A connection to a list of `ControlEventActivityLog` values. */
export type ControlEventActivityLogsConnection = {
  __typename?: 'ControlEventActivityLogsConnection';
  /** A list of edges which contains the `ControlEventActivityLog` and cursor to aid in pagination. */
  edges: Array<ControlEventActivityLogsEdge>;
  /** A list of `ControlEventActivityLog` objects. */
  nodes: Array<ControlEventActivityLog>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ControlEventActivityLog` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ControlEventActivityLog` edge in the connection. */
export type ControlEventActivityLogsEdge = {
  __typename?: 'ControlEventActivityLogsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ControlEventActivityLog` at the end of the edge. */
  node: ControlEventActivityLog;
};

/** Methods to use when ordering `ControlEventActivityLog`. */
export enum ControlEventActivityLogsOrderBy {
  ACTOR_ASC = 'ACTOR_ASC',
  ACTOR_DESC = 'ACTOR_DESC',
  CONTROL_EVENT_ID_ASC = 'CONTROL_EVENT_ID_ASC',
  CONTROL_EVENT_ID_DESC = 'CONTROL_EVENT_ID_DESC',
  METADATA_ASC = 'METADATA_ASC',
  METADATA_DESC = 'METADATA_DESC',
  NATURAL = 'NATURAL',
  TIME_ASC = 'TIME_ASC',
  TIME_DESC = 'TIME_DESC',
  TYPE_ASC = 'TYPE_ASC',
  TYPE_DESC = 'TYPE_DESC'
}

/**
 * A condition to be used against `ControlEvent` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ControlEventCondition = {
  /** Checks for equality with the object’s `acknowledgedAt` field. */
  acknowledgedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `componentId` field. */
  componentId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `endTime` field. */
  endTime?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `remoteMetadata` field. */
  remoteMetadata?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `startTime` field. */
  startTime?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `ControlEvent` object types. All fields are combined with a logical ‘and.’ */
export type ControlEventFilter = {
  /** Filter by the object’s `acknowledgedAt` field. */
  acknowledgedAt?: InputMaybe<DatetimeFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ControlEventFilter>>;
  /** Filter by the permission can_write */
  canWrite?: InputMaybe<PermissionBooleanFilter>;
  /** Filter by the object’s `componentId` field. */
  componentId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `currentState` field. */
  currentState?: InputMaybe<ControlEventStateFilter>;
  /** Filter by the object’s `endTime` field. */
  endTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isAcknowledged` field. */
  isAcknowledged?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ControlEventFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ControlEventFilter>>;
  /** Filter by the object’s `remoteMetadata` field. */
  remoteMetadata?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `startTime` field. */
  startTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `ControlEvent` */
export type ControlEventInput = {
  /** The identifier of the component associated with the control event */
  componentId: Scalars['Int']['input'];
  /** The date the control event was created at */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** The time the control event ended */
  endTime: Scalars['Datetime']['input'];
  /** The identifier of the control event */
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  /** Key-value store for remote metadata. */
  remoteMetadata?: InputMaybe<Scalars['JSON']['input']>;
  /** The time the control event started */
  startTime: Scalars['Datetime']['input'];
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** Log messages for a given control event. */
export type ControlEventLog = Node & {
  __typename?: 'ControlEventLog';
  /** The identifier of the actor who logged the message. */
  actor?: Maybe<Actor>;
  /** Reads a single `ControlEvent` that is related to this `ControlEventLog`. */
  controlEvent?: Maybe<ControlEvent>;
  /** The identifier of the control event associated with the control event log entry */
  controlEventId: Scalars['Int']['output'];
  /** The date the control event log entry was created at */
  createdAt: Scalars['Datetime']['output'];
  /** The identifier of the control event log entry */
  id: Scalars['Int']['output'];
  /** The message of the log statement. */
  message: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
};

/**
 * A condition to be used against `ControlEventLog` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ControlEventLogCondition = {
  /** Checks for equality with the object’s `actor` field. */
  actor?: InputMaybe<ActorInput>;
  /** Checks for equality with the object’s `controlEventId` field. */
  controlEventId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `message` field. */
  message?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `ControlEventLog` object types. All fields are combined with a logical ‘and.’ */
export type ControlEventLogFilter = {
  /** Filter by the object’s `actor` field. */
  actor?: InputMaybe<ActorFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ControlEventLogFilter>>;
  /** Filter by the object’s `controlEventId` field. */
  controlEventId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `message` field. */
  message?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ControlEventLogFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ControlEventLogFilter>>;
};

/** An input for mutations affecting `ControlEventLog` */
export type ControlEventLogInput = {
  /** Mutates a `ControlEvent` as part of the payload */
  controlEvent?: InputMaybe<ControlEventInput>;
  /** The identifier of the control event associated with the control event log entry */
  controlEventId?: InputMaybe<Scalars['Int']['input']>;
  /** The message of the log statement. */
  message: Scalars['String']['input'];
};

/** Represents an update to a `ControlEventLog`. Fields that are set will be updated. */
export type ControlEventLogPatch = {
  /** The identifier of the control event associated with the control event log entry */
  controlEventId?: InputMaybe<Scalars['Int']['input']>;
  /** The message of the log statement. */
  message?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `ControlEventLog` values. */
export type ControlEventLogsConnection = {
  __typename?: 'ControlEventLogsConnection';
  /** A list of edges which contains the `ControlEventLog` and cursor to aid in pagination. */
  edges: Array<ControlEventLogsEdge>;
  /** A list of `ControlEventLog` objects. */
  nodes: Array<ControlEventLog>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ControlEventLog` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ControlEventLog` edge in the connection. */
export type ControlEventLogsEdge = {
  __typename?: 'ControlEventLogsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ControlEventLog` at the end of the edge. */
  node: ControlEventLog;
};

/** Methods to use when ordering `ControlEventLog`. */
export enum ControlEventLogsOrderBy {
  ACTOR_ASC = 'ACTOR_ASC',
  ACTOR_DESC = 'ACTOR_DESC',
  CONTROL_EVENT_ID_ASC = 'CONTROL_EVENT_ID_ASC',
  CONTROL_EVENT_ID_DESC = 'CONTROL_EVENT_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  MESSAGE_ASC = 'MESSAGE_ASC',
  MESSAGE_DESC = 'MESSAGE_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

/** Represents an update to a `ControlEvent`. Fields that are set will be updated. */
export type ControlEventPatch = {
  /** The time the control event ended */
  endTime?: InputMaybe<Scalars['Datetime']['input']>;
  /** The identifier of the control event */
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Key-value store for remote metadata. */
  remoteMetadata?: InputMaybe<Scalars['JSON']['input']>;
  /** The time the control event started */
  startTime?: InputMaybe<Scalars['Datetime']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** Permissive capabilities on a ControlEvent. */
export type ControlEventPermissions = {
  __typename?: 'ControlEventPermissions';
  /** Whether a user can write to the control event. */
  canWrite: Scalars['Boolean']['output'];
};

export enum ControlEventState {
  CANCELLED = 'CANCELLED',
  CANCEL_REQUESTED = 'CANCEL_REQUESTED',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  SCHEDULED = 'SCHEDULED',
  STARTED = 'STARTED'
}

/** A filter to be used against ControlEventState fields. All fields are combined with a logical ‘and.’ */
export type ControlEventStateFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<ControlEventState>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<ControlEventState>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<ControlEventState>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<ControlEventState>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<ControlEventState>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<ControlEventState>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<ControlEventState>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<ControlEventState>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<ControlEventState>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<ControlEventState>>;
};

export type ControlEventStateTransition = Node & {
  __typename?: 'ControlEventStateTransition';
  /** The identifier of the actor who performed the control event state transition. */
  actor?: Maybe<Actor>;
  /** Reads a single `ControlEvent` that is related to this `ControlEventStateTransition`. */
  controlEvent?: Maybe<ControlEvent>;
  /** The identifier of the control event associated with the control event state transition */
  controlEventId: Scalars['Int']['output'];
  /** The date the control event state transition was created at */
  createdAt: Scalars['Datetime']['output'];
  /** A description of the control event state transition */
  description?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The new state of the control event */
  state: ControlEventState;
};

/**
 * A condition to be used against `ControlEventStateTransition` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type ControlEventStateTransitionCondition = {
  /** Checks for equality with the object’s `actor` field. */
  actor?: InputMaybe<ActorInput>;
  /** Checks for equality with the object’s `controlEventId` field. */
  controlEventId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `state` field. */
  state?: InputMaybe<ControlEventState>;
};

/** A filter to be used against `ControlEventStateTransition` object types. All fields are combined with a logical ‘and.’ */
export type ControlEventStateTransitionFilter = {
  /** Filter by the object’s `actor` field. */
  actor?: InputMaybe<ActorFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ControlEventStateTransitionFilter>>;
  /** Filter by the object’s `controlEventId` field. */
  controlEventId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ControlEventStateTransitionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ControlEventStateTransitionFilter>>;
  /** Filter by the object’s `state` field. */
  state?: InputMaybe<ControlEventStateFilter>;
};

/** A connection to a list of `ControlEventStateTransition` values. */
export type ControlEventStateTransitionsConnection = {
  __typename?: 'ControlEventStateTransitionsConnection';
  /** A list of edges which contains the `ControlEventStateTransition` and cursor to aid in pagination. */
  edges: Array<ControlEventStateTransitionsEdge>;
  /** A list of `ControlEventStateTransition` objects. */
  nodes: Array<ControlEventStateTransition>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ControlEventStateTransition` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ControlEventStateTransition` edge in the connection. */
export type ControlEventStateTransitionsEdge = {
  __typename?: 'ControlEventStateTransitionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ControlEventStateTransition` at the end of the edge. */
  node: ControlEventStateTransition;
};

/** Methods to use when ordering `ControlEventStateTransition`. */
export enum ControlEventStateTransitionsOrderBy {
  ACTOR_ASC = 'ACTOR_ASC',
  ACTOR_DESC = 'ACTOR_DESC',
  CONTROL_EVENT_ID_ASC = 'CONTROL_EVENT_ID_ASC',
  CONTROL_EVENT_ID_DESC = 'CONTROL_EVENT_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  STATE_ASC = 'STATE_ASC',
  STATE_DESC = 'STATE_DESC'
}

/** A connection to a list of `ControlEvent` values. */
export type ControlEventsConnection = {
  __typename?: 'ControlEventsConnection';
  /** A list of edges which contains the `ControlEvent` and cursor to aid in pagination. */
  edges: Array<ControlEventsEdge>;
  /** A list of `ControlEvent` objects. */
  nodes: Array<ControlEvent>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ControlEvent` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ControlEvent` edge in the connection. */
export type ControlEventsEdge = {
  __typename?: 'ControlEventsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ControlEvent` at the end of the edge. */
  node: ControlEvent;
};

/** Methods to use when ordering `ControlEvent`. */
export enum ControlEventsOrderBy {
  ACKNOWLEDGED_AT_ASC = 'ACKNOWLEDGED_AT_ASC',
  ACKNOWLEDGED_AT_DESC = 'ACKNOWLEDGED_AT_DESC',
  COMPONENT_ID_ASC = 'COMPONENT_ID_ASC',
  COMPONENT_ID_DESC = 'COMPONENT_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  END_TIME_ASC = 'END_TIME_ASC',
  END_TIME_DESC = 'END_TIME_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  REMOTE_METADATA_ASC = 'REMOTE_METADATA_ASC',
  REMOTE_METADATA_DESC = 'REMOTE_METADATA_DESC',
  START_TIME_ASC = 'START_TIME_ASC',
  START_TIME_DESC = 'START_TIME_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

export enum ControlType {
  AUTOMATIC = 'AUTOMATIC',
  MANUAL = 'MANUAL'
}

/** A filter to be used against ControlType fields. All fields are combined with a logical ‘and.’ */
export type ControlTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<ControlType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<ControlType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<ControlType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<ControlType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<ControlType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<ControlType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<ControlType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<ControlType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<ControlType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<ControlType>>;
};

export enum Country {
  ABW = 'ABW',
  AFG = 'AFG',
  AGO = 'AGO',
  AIA = 'AIA',
  ALA = 'ALA',
  ALB = 'ALB',
  AND = 'AND',
  ARE = 'ARE',
  ARG = 'ARG',
  ARM = 'ARM',
  ASM = 'ASM',
  ATA = 'ATA',
  ATF = 'ATF',
  ATG = 'ATG',
  AUS = 'AUS',
  AUT = 'AUT',
  AZE = 'AZE',
  BDI = 'BDI',
  BEL = 'BEL',
  BEN = 'BEN',
  BES = 'BES',
  BFA = 'BFA',
  BGD = 'BGD',
  BGR = 'BGR',
  BHR = 'BHR',
  BHS = 'BHS',
  BIH = 'BIH',
  BLM = 'BLM',
  BLR = 'BLR',
  BLZ = 'BLZ',
  BMU = 'BMU',
  BOL = 'BOL',
  BRA = 'BRA',
  BRB = 'BRB',
  BRN = 'BRN',
  BTN = 'BTN',
  BVT = 'BVT',
  BWA = 'BWA',
  CAF = 'CAF',
  CAN = 'CAN',
  CCK = 'CCK',
  CHE = 'CHE',
  CHL = 'CHL',
  CHN = 'CHN',
  CIV = 'CIV',
  CMR = 'CMR',
  COD = 'COD',
  COG = 'COG',
  COK = 'COK',
  COL = 'COL',
  COM = 'COM',
  CPV = 'CPV',
  CRI = 'CRI',
  CUB = 'CUB',
  CUW = 'CUW',
  CXR = 'CXR',
  CYM = 'CYM',
  CYP = 'CYP',
  CZE = 'CZE',
  DEU = 'DEU',
  DJI = 'DJI',
  DMA = 'DMA',
  DNK = 'DNK',
  DOM = 'DOM',
  DZA = 'DZA',
  ECU = 'ECU',
  EGY = 'EGY',
  ERI = 'ERI',
  ESH = 'ESH',
  ESP = 'ESP',
  EST = 'EST',
  ETH = 'ETH',
  FIN = 'FIN',
  FJI = 'FJI',
  FLK = 'FLK',
  FRA = 'FRA',
  FRO = 'FRO',
  FSM = 'FSM',
  GAB = 'GAB',
  GBR = 'GBR',
  GEO = 'GEO',
  GGY = 'GGY',
  GHA = 'GHA',
  GIB = 'GIB',
  GIN = 'GIN',
  GLP = 'GLP',
  GMB = 'GMB',
  GNB = 'GNB',
  GNQ = 'GNQ',
  GRC = 'GRC',
  GRD = 'GRD',
  GRL = 'GRL',
  GTM = 'GTM',
  GUF = 'GUF',
  GUM = 'GUM',
  GUY = 'GUY',
  HKG = 'HKG',
  HMD = 'HMD',
  HND = 'HND',
  HRV = 'HRV',
  HTI = 'HTI',
  HUN = 'HUN',
  IDN = 'IDN',
  IMN = 'IMN',
  IND = 'IND',
  IOT = 'IOT',
  IRL = 'IRL',
  IRN = 'IRN',
  IRQ = 'IRQ',
  ISL = 'ISL',
  ISR = 'ISR',
  ITA = 'ITA',
  JAM = 'JAM',
  JEY = 'JEY',
  JOR = 'JOR',
  JPN = 'JPN',
  KAZ = 'KAZ',
  KEN = 'KEN',
  KGZ = 'KGZ',
  KHM = 'KHM',
  KIR = 'KIR',
  KNA = 'KNA',
  KOR = 'KOR',
  KWT = 'KWT',
  LAO = 'LAO',
  LBN = 'LBN',
  LBR = 'LBR',
  LBY = 'LBY',
  LCA = 'LCA',
  LIE = 'LIE',
  LKA = 'LKA',
  LSO = 'LSO',
  LTU = 'LTU',
  LUX = 'LUX',
  LVA = 'LVA',
  MAC = 'MAC',
  MAF = 'MAF',
  MAR = 'MAR',
  MCO = 'MCO',
  MDA = 'MDA',
  MDG = 'MDG',
  MDV = 'MDV',
  MEX = 'MEX',
  MHL = 'MHL',
  MKD = 'MKD',
  MLI = 'MLI',
  MLT = 'MLT',
  MMR = 'MMR',
  MNE = 'MNE',
  MNG = 'MNG',
  MNP = 'MNP',
  MOZ = 'MOZ',
  MRT = 'MRT',
  MSR = 'MSR',
  MTQ = 'MTQ',
  MUS = 'MUS',
  MWI = 'MWI',
  MYS = 'MYS',
  MYT = 'MYT',
  NAM = 'NAM',
  NCL = 'NCL',
  NER = 'NER',
  NFK = 'NFK',
  NGA = 'NGA',
  NIC = 'NIC',
  NIU = 'NIU',
  NLD = 'NLD',
  NOR = 'NOR',
  NPL = 'NPL',
  NRU = 'NRU',
  NZL = 'NZL',
  OMN = 'OMN',
  PAK = 'PAK',
  PAN = 'PAN',
  PCN = 'PCN',
  PER = 'PER',
  PHL = 'PHL',
  PLW = 'PLW',
  PNG = 'PNG',
  POL = 'POL',
  PRI = 'PRI',
  PRK = 'PRK',
  PRT = 'PRT',
  PRY = 'PRY',
  PSE = 'PSE',
  PYF = 'PYF',
  QAT = 'QAT',
  REU = 'REU',
  ROU = 'ROU',
  RUS = 'RUS',
  RWA = 'RWA',
  SAU = 'SAU',
  SDN = 'SDN',
  SEN = 'SEN',
  SGP = 'SGP',
  SGS = 'SGS',
  SHN = 'SHN',
  SJM = 'SJM',
  SLB = 'SLB',
  SLE = 'SLE',
  SLV = 'SLV',
  SMR = 'SMR',
  SOM = 'SOM',
  SPM = 'SPM',
  SRB = 'SRB',
  SSD = 'SSD',
  STP = 'STP',
  SUR = 'SUR',
  SVK = 'SVK',
  SVN = 'SVN',
  SWE = 'SWE',
  SWZ = 'SWZ',
  SXM = 'SXM',
  SYC = 'SYC',
  SYR = 'SYR',
  TCA = 'TCA',
  TCD = 'TCD',
  TGO = 'TGO',
  THA = 'THA',
  TJK = 'TJK',
  TKL = 'TKL',
  TKM = 'TKM',
  TLS = 'TLS',
  TON = 'TON',
  TTO = 'TTO',
  TUN = 'TUN',
  TUR = 'TUR',
  TUV = 'TUV',
  TZA = 'TZA',
  UGA = 'UGA',
  UKR = 'UKR',
  UMI = 'UMI',
  URY = 'URY',
  USA = 'USA',
  UZB = 'UZB',
  VAT = 'VAT',
  VCT = 'VCT',
  VEN = 'VEN',
  VGB = 'VGB',
  VIR = 'VIR',
  VNM = 'VNM',
  VUT = 'VUT',
  WLF = 'WLF',
  WSM = 'WSM',
  YEM = 'YEM',
  ZAF = 'ZAF',
  ZMB = 'ZMB',
  ZWE = 'ZWE'
}

/** A filter to be used against Country fields. All fields are combined with a logical ‘and.’ */
export type CountryFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Country>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Country>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Country>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Country>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Country>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Country>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Country>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Country>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Country>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Country>>;
};

export type CreateAccessTokenPayload = {
  accessKey: Scalars['String']['output'];
  clientMutationId?: Maybe<Scalars['String']['output']>;
  token: PlatformAccessToken;
};

/** All input for the create `AccountCharge` mutation. */
export type CreateAccountChargeInput = {
  /** The `AccountCharge` to be created by this mutation. */
  accountCharge: AccountChargeInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `AccountCharge` mutation. */
export type CreateAccountChargePayload = {
  __typename?: 'CreateAccountChargePayload';
  /** The `AccountCharge` that was created by this mutation. */
  accountCharge?: Maybe<AccountCharge>;
  /** An edge for our `AccountCharge`. May be used by Relay 1. */
  accountChargeEdge?: Maybe<AccountChargesEdge>;
  /** Reads a single `AccountStatement` that is related to this `AccountCharge`. */
  accountStatement?: Maybe<AccountStatement>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `AccountCharge` mutation. */
export type CreateAccountChargePayloadAccountChargeEdgeArgs = {
  orderBy?: InputMaybe<Array<AccountChargesOrderBy>>;
};

/** All input for the create `AccountStatementHistory` mutation. */
export type CreateAccountStatementHistoryInput = {
  /** The `AccountStatementHistory` to be created by this mutation. */
  accountStatementHistory: AccountStatementHistoryInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `AccountStatementHistory` mutation. */
export type CreateAccountStatementHistoryPayload = {
  __typename?: 'CreateAccountStatementHistoryPayload';
  /** Reads a single `AccountStatement` that is related to this `AccountStatementHistory`. */
  accountStatement?: Maybe<AccountStatement>;
  /** The `AccountStatementHistory` that was created by this mutation. */
  accountStatementHistory?: Maybe<AccountStatementHistory>;
  /** An edge for our `AccountStatementHistory`. May be used by Relay 1. */
  accountStatementHistoryEdge?: Maybe<AccountStatementHistoriesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `AccountStatementHistory` mutation. */
export type CreateAccountStatementHistoryPayloadAccountStatementHistoryEdgeArgs =
  {
    orderBy?: InputMaybe<Array<AccountStatementHistoriesOrderBy>>;
  };

/** All input for the create `AccountStatement` mutation. */
export type CreateAccountStatementInput = {
  /** The `AccountStatement` to be created by this mutation. */
  accountStatement: AccountStatementInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `AccountStatement` mutation. */
export type CreateAccountStatementPayload = {
  __typename?: 'CreateAccountStatementPayload';
  /** The `AccountStatement` that was created by this mutation. */
  accountStatement?: Maybe<AccountStatement>;
  /** An edge for our `AccountStatement`. May be used by Relay 1. */
  accountStatementEdge?: Maybe<AccountStatementsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `UtilityAccount` that is related to this `AccountStatement`. */
  utilityAccount?: Maybe<UtilityAccount>;
};

/** The output of our create `AccountStatement` mutation. */
export type CreateAccountStatementPayloadAccountStatementEdgeArgs = {
  orderBy?: InputMaybe<Array<AccountStatementsOrderBy>>;
};

/** All input for the create `AccountStatementPdf` mutation. */
export type CreateAccountStatementPdfInput = {
  /** The `AccountStatementPdf` to be created by this mutation. */
  accountStatementPdf: AccountStatementPdfInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `AccountStatementPdf` mutation. */
export type CreateAccountStatementPdfPayload = {
  __typename?: 'CreateAccountStatementPdfPayload';
  /** Reads a single `AccountStatement` that is related to this `AccountStatementPdf`. */
  accountStatement?: Maybe<AccountStatement>;
  /** The `AccountStatementPdf` that was created by this mutation. */
  accountStatementPdf?: Maybe<AccountStatementPdf>;
  /** An edge for our `AccountStatementPdf`. May be used by Relay 1. */
  accountStatementPdfEdge?: Maybe<AccountStatementPdfsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `AccountStatementPdf` mutation. */
export type CreateAccountStatementPdfPayloadAccountStatementPdfEdgeArgs = {
  orderBy?: InputMaybe<Array<AccountStatementPdfsOrderBy>>;
};

/** All input for the create `Assessment` mutation. */
export type CreateAssessmentInput = {
  /** The `Assessment` to be created by this mutation. */
  assessment: AssessmentInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `Assessment` mutation. */
export type CreateAssessmentPayload = {
  __typename?: 'CreateAssessmentPayload';
  /** The `Assessment` that was created by this mutation. */
  assessment?: Maybe<Assessment>;
  /** An edge for our `Assessment`. May be used by Relay 1. */
  assessmentEdge?: Maybe<AssessmentsEdge>;
  /** Reads a single `AssessmentType` that is related to this `Assessment`. */
  assessmentType?: Maybe<AssessmentType>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `MonitoredAsset` that is related to this `Assessment`. */
  monitoredAsset?: Maybe<MonitoredAsset>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `Assessment` mutation. */
export type CreateAssessmentPayloadAssessmentEdgeArgs = {
  orderBy?: InputMaybe<Array<AssessmentsOrderBy>>;
};

/** All input for the create `AssessmentType` mutation. */
export type CreateAssessmentTypeInput = {
  /** The `AssessmentType` to be created by this mutation. */
  assessmentType: AssessmentTypeInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `AssessmentType` mutation. */
export type CreateAssessmentTypePayload = {
  __typename?: 'CreateAssessmentTypePayload';
  /** The `AssessmentType` that was created by this mutation. */
  assessmentType?: Maybe<AssessmentType>;
  /** An edge for our `AssessmentType`. May be used by Relay 1. */
  assessmentTypeEdge?: Maybe<AssessmentTypesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SoftwarePackage` that is related to this `AssessmentType`. */
  softwarePackage?: Maybe<SoftwarePackage>;
};

/** The output of our create `AssessmentType` mutation. */
export type CreateAssessmentTypePayloadAssessmentTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<AssessmentTypesOrderBy>>;
};

/** All input for the create `BalancingAuthority` mutation. */
export type CreateBalancingAuthorityInput = {
  /** The `BalancingAuthority` to be created by this mutation. */
  balancingAuthority: BalancingAuthorityInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `BalancingAuthority` mutation. */
export type CreateBalancingAuthorityPayload = {
  __typename?: 'CreateBalancingAuthorityPayload';
  /** The `BalancingAuthority` that was created by this mutation. */
  balancingAuthority?: Maybe<BalancingAuthority>;
  /** An edge for our `BalancingAuthority`. May be used by Relay 1. */
  balancingAuthorityEdge?: Maybe<BalancingAuthoritiesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `BalancingAuthority` mutation. */
export type CreateBalancingAuthorityPayloadBalancingAuthorityEdgeArgs = {
  orderBy?: InputMaybe<Array<BalancingAuthoritiesOrderBy>>;
};

/** All input for the create `BillableCustomer` mutation. */
export type CreateBillableCustomerInput = {
  /** The `BillableCustomer` to be created by this mutation. */
  billableCustomer: BillableCustomerInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `BillableCustomer` mutation. */
export type CreateBillableCustomerPayload = {
  __typename?: 'CreateBillableCustomerPayload';
  /** The `BillableCustomer` that was created by this mutation. */
  billableCustomer?: Maybe<BillableCustomer>;
  /** An edge for our `BillableCustomer`. May be used by Relay 1. */
  billableCustomerEdge?: Maybe<BillableCustomersEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `BillableCustomer` mutation. */
export type CreateBillableCustomerPayloadBillableCustomerEdgeArgs = {
  orderBy?: InputMaybe<Array<BillableCustomersOrderBy>>;
};

/** All input for the create `BlastEvaporator` mutation. */
export type CreateBlastEvaporatorInput = {
  /** The `BlastEvaporator` to be created by this mutation. */
  blastEvaporator: BlastEvaporatorInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `BlastEvaporator` mutation. */
export type CreateBlastEvaporatorPayload = {
  __typename?: 'CreateBlastEvaporatorPayload';
  /** Reads a single `Blast` that is related to this `BlastEvaporator`. */
  blast?: Maybe<Blast>;
  /** The `BlastEvaporator` that was created by this mutation. */
  blastEvaporator?: Maybe<BlastEvaporator>;
  /** An edge for our `BlastEvaporator`. May be used by Relay 1. */
  blastEvaporatorEdge?: Maybe<BlastEvaporatorsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Evaporator` that is related to this `BlastEvaporator`. */
  evaporator?: Maybe<Evaporator>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `BlastEvaporator` mutation. */
export type CreateBlastEvaporatorPayloadBlastEvaporatorEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastEvaporatorsOrderBy>>;
};

/** All input for the create `Blast` mutation. */
export type CreateBlastInput = {
  /** The `Blast` to be created by this mutation. */
  blast: BlastInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** All input for the create `BlastPallet` mutation. */
export type CreateBlastPalletInput = {
  /** The `BlastPallet` to be created by this mutation. */
  blastPallet: BlastPalletInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** All input for the create `BlastPalletLocation` mutation. */
export type CreateBlastPalletLocationInput = {
  /** The `BlastPalletLocation` to be created by this mutation. */
  blastPalletLocation: BlastPalletLocationInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `BlastPalletLocation` mutation. */
export type CreateBlastPalletLocationPayload = {
  __typename?: 'CreateBlastPalletLocationPayload';
  /** Reads a single `Blast` that is related to this `BlastPalletLocation`. */
  blast?: Maybe<Blast>;
  /** The `BlastPalletLocation` that was created by this mutation. */
  blastPalletLocation?: Maybe<BlastPalletLocation>;
  /** An edge for our `BlastPalletLocation`. May be used by Relay 1. */
  blastPalletLocationEdge?: Maybe<BlastPalletLocationsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `PalletLocation` that is related to this `BlastPalletLocation`. */
  palletLocation?: Maybe<PalletLocation>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `BlastPalletLocation` mutation. */
export type CreateBlastPalletLocationPayloadBlastPalletLocationEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastPalletLocationsOrderBy>>;
};

/** The output of our create `BlastPallet` mutation. */
export type CreateBlastPalletPayload = {
  __typename?: 'CreateBlastPalletPayload';
  /** Reads a single `Blast` that is related to this `BlastPallet`. */
  blast?: Maybe<Blast>;
  /** The `BlastPallet` that was created by this mutation. */
  blastPallet?: Maybe<BlastPallet>;
  /** An edge for our `BlastPallet`. May be used by Relay 1. */
  blastPalletEdge?: Maybe<BlastPalletsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Pallet` that is related to this `BlastPallet`. */
  pallet?: Maybe<Pallet>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `BlastPallet` mutation. */
export type CreateBlastPalletPayloadBlastPalletEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastPalletsOrderBy>>;
};

/** The output of our create `Blast` mutation. */
export type CreateBlastPayload = {
  __typename?: 'CreateBlastPayload';
  /** Reads a single `DataPoint` that is related to this `Blast`. */
  actualUtilization?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Blast`. */
  automationState?: Maybe<DataPoint>;
  /** The `Blast` that was created by this mutation. */
  blast?: Maybe<Blast>;
  /** An edge for our `Blast`. May be used by Relay 1. */
  blastEdge?: Maybe<BlastsEdge>;
  /** Reads a single `BlastType` that is related to this `Blast`. */
  blastType?: Maybe<BlastType>;
  /** Reads a single `BuildingArea` that is related to this `Blast`. */
  buildingArea?: Maybe<BuildingArea>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Component` that is related to this `Blast`. */
  component?: Maybe<Component>;
  /** Reads a single `Facility` that is related to this `Blast`. */
  facility?: Maybe<Facility>;
  /** Reads a single `DataPoint` that is related to this `Blast`. */
  idealUtilization?: Maybe<DataPoint>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DataPoint` that is related to this `Blast`. */
  stagingTimer?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Blast`. */
  state?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Blast`. */
  timer?: Maybe<DataPoint>;
};

/** The output of our create `Blast` mutation. */
export type CreateBlastPayloadBlastEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastsOrderBy>>;
};

/** All input for the create `BlastRotationAlert` mutation. */
export type CreateBlastRotationAlertInput = {
  /** The `BlastRotationAlert` to be created by this mutation. */
  blastRotationAlert: BlastRotationAlertInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `BlastRotationAlert` mutation. */
export type CreateBlastRotationAlertPayload = {
  __typename?: 'CreateBlastRotationAlertPayload';
  /** Reads a single `BlastRotation` that is related to this `BlastRotationAlert`. */
  blastRotation?: Maybe<BlastRotation>;
  /** The `BlastRotationAlert` that was created by this mutation. */
  blastRotationAlert?: Maybe<BlastRotationAlert>;
  /** An edge for our `BlastRotationAlert`. May be used by Relay 1. */
  blastRotationAlertEdge?: Maybe<BlastRotationAlertsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `BlastRotationAlert` mutation. */
export type CreateBlastRotationAlertPayloadBlastRotationAlertEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastRotationAlertsOrderBy>>;
};

/** All input for the create `BlastRotationEventLog` mutation. */
export type CreateBlastRotationEventLogInput = {
  /** The `BlastRotationEventLog` to be created by this mutation. */
  blastRotationEventLog: BlastRotationEventLogInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `BlastRotationEventLog` mutation. */
export type CreateBlastRotationEventLogPayload = {
  __typename?: 'CreateBlastRotationEventLogPayload';
  /** Reads a single `BlastRotation` that is related to this `BlastRotationEventLog`. */
  blastRotation?: Maybe<BlastRotation>;
  /** The `BlastRotationEventLog` that was created by this mutation. */
  blastRotationEventLog?: Maybe<BlastRotationEventLog>;
  /** An edge for our `BlastRotationEventLog`. May be used by Relay 1. */
  blastRotationEventLogEdge?: Maybe<BlastRotationEventLogsEdge>;
  /** Reads a single `BlastRotationEventType` that is related to this `BlastRotationEventLog`. */
  blastRotationEventType?: Maybe<BlastRotationEventType>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `BlastRotationEventLog` mutation. */
export type CreateBlastRotationEventLogPayloadBlastRotationEventLogEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastRotationEventLogsOrderBy>>;
};

/** All input for the create `BlastRotationEventType` mutation. */
export type CreateBlastRotationEventTypeInput = {
  /** The `BlastRotationEventType` to be created by this mutation. */
  blastRotationEventType: BlastRotationEventTypeInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `BlastRotationEventType` mutation. */
export type CreateBlastRotationEventTypePayload = {
  __typename?: 'CreateBlastRotationEventTypePayload';
  /** The `BlastRotationEventType` that was created by this mutation. */
  blastRotationEventType?: Maybe<BlastRotationEventType>;
  /** An edge for our `BlastRotationEventType`. May be used by Relay 1. */
  blastRotationEventTypeEdge?: Maybe<BlastRotationEventTypesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `BlastRotationEventType` mutation. */
export type CreateBlastRotationEventTypePayloadBlastRotationEventTypeEdgeArgs =
  {
    orderBy?: InputMaybe<Array<BlastRotationEventTypesOrderBy>>;
  };

/** All input for the create `BlastRotation` mutation. */
export type CreateBlastRotationInput = {
  /** The `BlastRotation` to be created by this mutation. */
  blastRotation: BlastRotationInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** All input for the create `BlastRotationPallet` mutation. */
export type CreateBlastRotationPalletInput = {
  /** The `BlastRotationPallet` to be created by this mutation. */
  blastRotationPallet: BlastRotationPalletInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `BlastRotationPallet` mutation. */
export type CreateBlastRotationPalletPayload = {
  __typename?: 'CreateBlastRotationPalletPayload';
  /** Reads a single `BlastRotation` that is related to this `BlastRotationPallet`. */
  blastRotation?: Maybe<BlastRotation>;
  /** The `BlastRotationPallet` that was created by this mutation. */
  blastRotationPallet?: Maybe<BlastRotationPallet>;
  /** An edge for our `BlastRotationPallet`. May be used by Relay 1. */
  blastRotationPalletEdge?: Maybe<BlastRotationPalletsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Pallet` that is related to this `BlastRotationPallet`. */
  pallet?: Maybe<Pallet>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `BlastRotationPallet` mutation. */
export type CreateBlastRotationPalletPayloadBlastRotationPalletEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastRotationPalletsOrderBy>>;
};

/** The output of our create `BlastRotation` mutation. */
export type CreateBlastRotationPayload = {
  __typename?: 'CreateBlastRotationPayload';
  /** Reads a single `Blast` that is related to this `BlastRotation`. */
  blast?: Maybe<Blast>;
  /** The `BlastRotation` that was created by this mutation. */
  blastRotation?: Maybe<BlastRotation>;
  /** An edge for our `BlastRotation`. May be used by Relay 1. */
  blastRotationEdge?: Maybe<BlastRotationsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `BlastRotation` mutation. */
export type CreateBlastRotationPayloadBlastRotationEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastRotationsOrderBy>>;
};

/** All input for the create `BlastType` mutation. */
export type CreateBlastTypeInput = {
  /** The `BlastType` to be created by this mutation. */
  blastType: BlastTypeInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `BlastType` mutation. */
export type CreateBlastTypePayload = {
  __typename?: 'CreateBlastTypePayload';
  /** The `BlastType` that was created by this mutation. */
  blastType?: Maybe<BlastType>;
  /** An edge for our `BlastType`. May be used by Relay 1. */
  blastTypeEdge?: Maybe<BlastTypesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `BlastType` mutation. */
export type CreateBlastTypePayloadBlastTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastTypesOrderBy>>;
};

/** All input for the create `BuildingAreaComplianceGroup` mutation. */
export type CreateBuildingAreaComplianceGroupInput = {
  /** The `BuildingAreaComplianceGroup` to be created by this mutation. */
  buildingAreaComplianceGroup: BuildingAreaComplianceGroupInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `BuildingAreaComplianceGroup` mutation. */
export type CreateBuildingAreaComplianceGroupPayload = {
  __typename?: 'CreateBuildingAreaComplianceGroupPayload';
  /** Reads a single `BuildingArea` that is related to this `BuildingAreaComplianceGroup`. */
  buildingArea?: Maybe<BuildingArea>;
  /** The `BuildingAreaComplianceGroup` that was created by this mutation. */
  buildingAreaComplianceGroup?: Maybe<BuildingAreaComplianceGroup>;
  /** An edge for our `BuildingAreaComplianceGroup`. May be used by Relay 1. */
  buildingAreaComplianceGroupEdge?: Maybe<BuildingAreaComplianceGroupsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `ComplianceGroup` that is related to this `BuildingAreaComplianceGroup`. */
  complianceGroup?: Maybe<ComplianceGroup>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `BuildingAreaComplianceGroup` mutation. */
export type CreateBuildingAreaComplianceGroupPayloadBuildingAreaComplianceGroupEdgeArgs =
  {
    orderBy?: InputMaybe<Array<BuildingAreaComplianceGroupsOrderBy>>;
  };

/** All input for the create `BuildingArea` mutation. */
export type CreateBuildingAreaInput = {
  /** The `BuildingArea` to be created by this mutation. */
  buildingArea: BuildingAreaInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `BuildingArea` mutation. */
export type CreateBuildingAreaPayload = {
  __typename?: 'CreateBuildingAreaPayload';
  /** The `BuildingArea` that was created by this mutation. */
  buildingArea?: Maybe<BuildingArea>;
  /** An edge for our `BuildingArea`. May be used by Relay 1. */
  buildingAreaEdge?: Maybe<BuildingAreasEdge>;
  /** Reads a single `BuildingAreaType` that is related to this `BuildingArea`. */
  buildingAreaType?: Maybe<BuildingAreaType>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Facility` that is related to this `BuildingArea`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `BuildingArea` mutation. */
export type CreateBuildingAreaPayloadBuildingAreaEdgeArgs = {
  orderBy?: InputMaybe<Array<BuildingAreasOrderBy>>;
};

/** All input for the create `BuildingAreaType` mutation. */
export type CreateBuildingAreaTypeInput = {
  /** The `BuildingAreaType` to be created by this mutation. */
  buildingAreaType: BuildingAreaTypeInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `BuildingAreaType` mutation. */
export type CreateBuildingAreaTypePayload = {
  __typename?: 'CreateBuildingAreaTypePayload';
  /** The `BuildingAreaType` that was created by this mutation. */
  buildingAreaType?: Maybe<BuildingAreaType>;
  /** An edge for our `BuildingAreaType`. May be used by Relay 1. */
  buildingAreaTypeEdge?: Maybe<BuildingAreaTypesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `BuildingAreaType` mutation. */
export type CreateBuildingAreaTypePayloadBuildingAreaTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<BuildingAreaTypesOrderBy>>;
};

/** All input for the create `Chart` mutation. */
export type CreateChartInput = {
  /** The `Chart` to be created by this mutation. */
  chart: ChartInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `Chart` mutation. */
export type CreateChartPayload = {
  __typename?: 'CreateChartPayload';
  /** The `Chart` that was created by this mutation. */
  chart?: Maybe<Chart>;
  /** An edge for our `Chart`. May be used by Relay 1. */
  chartEdge?: Maybe<ChartsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Facility` that is related to this `Chart`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `Chart` mutation. */
export type CreateChartPayloadChartEdgeArgs = {
  orderBy?: InputMaybe<Array<ChartsOrderBy>>;
};

/** All input for the create `Check` mutation. */
export type CreateCheckInput = {
  /** The `Check` to be created by this mutation. */
  check: CheckInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** All input for the create `CheckMonitor` mutation. */
export type CreateCheckMonitorInput = {
  /** The `CheckMonitor` to be created by this mutation. */
  checkMonitor: CheckMonitorInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `CheckMonitor` mutation. */
export type CreateCheckMonitorPayload = {
  __typename?: 'CreateCheckMonitorPayload';
  /** Reads a single `Check` that is related to this `CheckMonitor`. */
  check?: Maybe<Check>;
  /** The `CheckMonitor` that was created by this mutation. */
  checkMonitor?: Maybe<CheckMonitor>;
  /** An edge for our `CheckMonitor`. May be used by Relay 1. */
  checkMonitorEdge?: Maybe<CheckMonitorsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Facility` that is related to this `CheckMonitor`. */
  facility?: Maybe<Facility>;
  /** Reads a single `Monitor` that is related to this `CheckMonitor`. */
  monitor?: Maybe<Monitor>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `CheckMonitor` mutation. */
export type CreateCheckMonitorPayloadCheckMonitorEdgeArgs = {
  orderBy?: InputMaybe<Array<CheckMonitorsOrderBy>>;
};

/** The output of our create `Check` mutation. */
export type CreateCheckPayload = {
  __typename?: 'CreateCheckPayload';
  /** The `Check` that was created by this mutation. */
  check?: Maybe<Check>;
  /** An edge for our `Check`. May be used by Relay 1. */
  checkEdge?: Maybe<ChecksEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Severity` that is related to this `Check`. */
  severity?: Maybe<Severity>;
  /** Reads a single `SoftwarePackage` that is related to this `Check`. */
  softwarePackage?: Maybe<SoftwarePackage>;
};

/** The output of our create `Check` mutation. */
export type CreateCheckPayloadCheckEdgeArgs = {
  orderBy?: InputMaybe<Array<ChecksOrderBy>>;
};

/** All input for the create `Classification` mutation. */
export type CreateClassificationInput = {
  /** The `Classification` to be created by this mutation. */
  classification: ClassificationInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `Classification` mutation. */
export type CreateClassificationPayload = {
  __typename?: 'CreateClassificationPayload';
  /** Reads a single `AssessmentType` that is related to this `Classification`. */
  assessmentType?: Maybe<AssessmentType>;
  /** The `Classification` that was created by this mutation. */
  classification?: Maybe<Classification>;
  /** An edge for our `Classification`. May be used by Relay 1. */
  classificationEdge?: Maybe<ClassificationsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `Classification` mutation. */
export type CreateClassificationPayloadClassificationEdgeArgs = {
  orderBy?: InputMaybe<Array<ClassificationsOrderBy>>;
};

/** All input for the create `ClassificationResult` mutation. */
export type CreateClassificationResultInput = {
  /** The `ClassificationResult` to be created by this mutation. */
  classificationResult: ClassificationResultInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `ClassificationResult` mutation. */
export type CreateClassificationResultPayload = {
  __typename?: 'CreateClassificationResultPayload';
  /** Reads a single `Assessment` that is related to this `ClassificationResult`. */
  assessment?: Maybe<Assessment>;
  /** Reads a single `Classification` that is related to this `ClassificationResult`. */
  classification?: Maybe<Classification>;
  /** The `ClassificationResult` that was created by this mutation. */
  classificationResult?: Maybe<ClassificationResult>;
  /** An edge for our `ClassificationResult`. May be used by Relay 1. */
  classificationResultEdge?: Maybe<ClassificationResultsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `ClassificationResult` mutation. */
export type CreateClassificationResultPayloadClassificationResultEdgeArgs = {
  orderBy?: InputMaybe<Array<ClassificationResultsOrderBy>>;
};

/** All input for the create `ComplianceGroup` mutation. */
export type CreateComplianceGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `ComplianceGroup` to be created by this mutation. */
  complianceGroup: ComplianceGroupInput;
};

/** The output of our create `ComplianceGroup` mutation. */
export type CreateComplianceGroupPayload = {
  __typename?: 'CreateComplianceGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `ComplianceGroup` that was created by this mutation. */
  complianceGroup?: Maybe<ComplianceGroup>;
  /** An edge for our `ComplianceGroup`. May be used by Relay 1. */
  complianceGroupEdge?: Maybe<ComplianceGroupsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `ComplianceGroup` mutation. */
export type CreateComplianceGroupPayloadComplianceGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<ComplianceGroupsOrderBy>>;
};

/** All input for the create `ComplianceRange` mutation. */
export type CreateComplianceRangeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `ComplianceRange` to be created by this mutation. */
  complianceRange: ComplianceRangeInput;
};

/** The output of our create `ComplianceRange` mutation. */
export type CreateComplianceRangePayload = {
  __typename?: 'CreateComplianceRangePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `ComplianceGroup` that is related to this `ComplianceRange`. */
  complianceGroup?: Maybe<ComplianceGroup>;
  /** The `ComplianceRange` that was created by this mutation. */
  complianceRange?: Maybe<ComplianceRange>;
  /** An edge for our `ComplianceRange`. May be used by Relay 1. */
  complianceRangeEdge?: Maybe<ComplianceRangesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `ComplianceRange` mutation. */
export type CreateComplianceRangePayloadComplianceRangeEdgeArgs = {
  orderBy?: InputMaybe<Array<ComplianceRangesOrderBy>>;
};

/** All input for the create `Component` mutation. */
export type CreateComponentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Component` to be created by this mutation. */
  component: ComponentInput;
};

/** The output of our create `Component` mutation. */
export type CreateComponentPayload = {
  __typename?: 'CreateComponentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Component` that was created by this mutation. */
  component?: Maybe<Component>;
  /** An edge for our `Component`. May be used by Relay 1. */
  componentEdge?: Maybe<ComponentsEdge>;
  /** Reads a single `Facility` that is related to this `Component`. */
  facility?: Maybe<Facility>;
  /** Reads a single `MachineUser` that is related to this `Component`. */
  machineUser?: Maybe<MachineUser>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `Component` mutation. */
export type CreateComponentPayloadComponentEdgeArgs = {
  orderBy?: InputMaybe<Array<ComponentsOrderBy>>;
};

/** All input for the create `Compressor` mutation. */
export type CreateCompressorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Compressor` to be created by this mutation. */
  compressor: CompressorInput;
};

/** The output of our create `Compressor` mutation. */
export type CreateCompressorPayload = {
  __typename?: 'CreateCompressorPayload';
  /** Reads a single `BuildingArea` that is related to this `Compressor`. */
  buildingArea?: Maybe<BuildingArea>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  capacity?: Maybe<DataPoint>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Compressor` that was created by this mutation. */
  compressor?: Maybe<Compressor>;
  /** An edge for our `Compressor`. May be used by Relay 1. */
  compressorEdge?: Maybe<CompressorsEdge>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  controlMode?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  differentialPressure?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  dischargePressure?: Maybe<DataPoint>;
  /** Reads a single `Facility` that is related to this `Compressor`. */
  facility?: Maybe<Facility>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  kwDemand?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  motorAmps?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  motorState?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  oilPressure?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  oilTemperature?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  onStatus?: Maybe<DataPoint>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RefrigerationSystem` that is related to this `Compressor`. */
  refrigerationSystem?: Maybe<RefrigerationSystem>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  runtimeHours?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  setpoint?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  slideValvePosition?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  state?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  suctionPressure?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  suctionPressureSetpointDeviation?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  suctionTemperature?: Maybe<DataPoint>;
};

/** The output of our create `Compressor` mutation. */
export type CreateCompressorPayloadCompressorEdgeArgs = {
  orderBy?: InputMaybe<Array<CompressorsOrderBy>>;
};

/** All input for the create `ControlEvent` mutation. */
export type CreateControlEventInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `ControlEvent` to be created by this mutation. */
  controlEvent: ControlEventInput;
};

/** All input for the create `ControlEventLog` mutation. */
export type CreateControlEventLogInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `ControlEventLog` to be created by this mutation. */
  controlEventLog: ControlEventLogInput;
};

/** The output of our create `ControlEventLog` mutation. */
export type CreateControlEventLogPayload = {
  __typename?: 'CreateControlEventLogPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `ControlEvent` that is related to this `ControlEventLog`. */
  controlEvent?: Maybe<ControlEvent>;
  /** The `ControlEventLog` that was created by this mutation. */
  controlEventLog?: Maybe<ControlEventLog>;
  /** An edge for our `ControlEventLog`. May be used by Relay 1. */
  controlEventLogEdge?: Maybe<ControlEventLogsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `ControlEventLog` mutation. */
export type CreateControlEventLogPayloadControlEventLogEdgeArgs = {
  orderBy?: InputMaybe<Array<ControlEventLogsOrderBy>>;
};

/** The output of our create `ControlEvent` mutation. */
export type CreateControlEventPayload = {
  __typename?: 'CreateControlEventPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Component` that is related to this `ControlEvent`. */
  component?: Maybe<Component>;
  /** The `ControlEvent` that was created by this mutation. */
  controlEvent?: Maybe<ControlEvent>;
  /** An edge for our `ControlEvent`. May be used by Relay 1. */
  controlEventEdge?: Maybe<ControlEventsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `ControlEvent` mutation. */
export type CreateControlEventPayloadControlEventEdgeArgs = {
  orderBy?: InputMaybe<Array<ControlEventsOrderBy>>;
};

/** All input for the create `CustomerBillingRate` mutation. */
export type CreateCustomerBillingRateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `CustomerBillingRate` to be created by this mutation. */
  customerBillingRate: CustomerBillingRateInput;
};

/** The output of our create `CustomerBillingRate` mutation. */
export type CreateCustomerBillingRatePayload = {
  __typename?: 'CreateCustomerBillingRatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `BillableCustomer` that is related to this `CustomerBillingRate`. */
  customer?: Maybe<BillableCustomer>;
  /** The `CustomerBillingRate` that was created by this mutation. */
  customerBillingRate?: Maybe<CustomerBillingRate>;
  /** An edge for our `CustomerBillingRate`. May be used by Relay 1. */
  customerBillingRateEdge?: Maybe<CustomerBillingRatesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `CustomerBillingRate` mutation. */
export type CreateCustomerBillingRatePayloadCustomerBillingRateEdgeArgs = {
  orderBy?: InputMaybe<Array<CustomerBillingRatesOrderBy>>;
};

/** All input for the create `Customer` mutation. */
export type CreateCustomerInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Customer` to be created by this mutation. */
  customer: CustomerInput;
};

export type CreateCustomerIntegrationCredentialInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  credential: Scalars['JSON']['input'];
  customerIntegrationId: Scalars['Int']['input'];
  expiresAt: Scalars['Datetime']['input'];
};

export type CreateCustomerIntegrationCredentialPayload = {
  __typename?: 'CreateCustomerIntegrationCredentialPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  customerIntegration: CustomerIntegration;
  customerIntegrationCredential: CustomerIntegrationCredential;
};

/** The output of our create `Customer` mutation. */
export type CreateCustomerPayload = {
  __typename?: 'CreateCustomerPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Customer` that was created by this mutation. */
  customer?: Maybe<Customer>;
  /** An edge for our `Customer`. May be used by Relay 1. */
  customerEdge?: Maybe<CustomersEdge>;
  /** Reads a single `Facility` that is related to this `Customer`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `Customer` mutation. */
export type CreateCustomerPayloadCustomerEdgeArgs = {
  orderBy?: InputMaybe<Array<CustomersOrderBy>>;
};

/** All input for the create `Dashboard` mutation. */
export type CreateDashboardInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Dashboard` to be created by this mutation. */
  dashboard: DashboardInput;
};

/** The output of our create `Dashboard` mutation. */
export type CreateDashboardPayload = {
  __typename?: 'CreateDashboardPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Dashboard` that was created by this mutation. */
  dashboard?: Maybe<Dashboard>;
  /** An edge for our `Dashboard`. May be used by Relay 1. */
  dashboardEdge?: Maybe<DashboardsEdge>;
  /** Reads a single `Facility` that is related to this `Dashboard`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `Dashboard` mutation. */
export type CreateDashboardPayloadDashboardEdgeArgs = {
  orderBy?: InputMaybe<Array<DashboardsOrderBy>>;
};

/** All input for the create `DataPoint` mutation. */
export type CreateDataPointInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `DataPoint` to be created by this mutation. */
  dataPoint: DataPointInput;
};

/** The output of our create `DataPoint` mutation. */
export type CreateDataPointPayload = {
  __typename?: 'CreateDataPointPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `DataPoint` that was created by this mutation. */
  dataPoint?: Maybe<DataPoint>;
  /** An edge for our `DataPoint`. May be used by Relay 1. */
  dataPointEdge?: Maybe<DataPointsEdge>;
  /** Reads a single `DataSource` that is related to this `DataPoint`. */
  dataSource?: Maybe<DataSource>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `DataPoint` mutation. */
export type CreateDataPointPayloadDataPointEdgeArgs = {
  orderBy?: InputMaybe<Array<DataPointsOrderBy>>;
};

/** All input for the create `DataSource` mutation. */
export type CreateDataSourceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `DataSource` to be created by this mutation. */
  dataSource: DataSourceInput;
};

/** The output of our create `DataSource` mutation. */
export type CreateDataSourcePayload = {
  __typename?: 'CreateDataSourcePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `DataSource` that was created by this mutation. */
  dataSource?: Maybe<DataSource>;
  /** An edge for our `DataSource`. May be used by Relay 1. */
  dataSourceEdge?: Maybe<DataSourcesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `DataSource` mutation. */
export type CreateDataSourcePayloadDataSourceEdgeArgs = {
  orderBy?: InputMaybe<Array<DataSourcesOrderBy>>;
};

/** All input for the create `Dependency` mutation. */
export type CreateDependencyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Dependency` to be created by this mutation. */
  dependency: DependencyInput;
};

/** The output of our create `Dependency` mutation. */
export type CreateDependencyPayload = {
  __typename?: 'CreateDependencyPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Dependency` that was created by this mutation. */
  dependency?: Maybe<Dependency>;
  /** An edge for our `Dependency`. May be used by Relay 1. */
  dependencyEdge?: Maybe<DependenciesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `Dependency` mutation. */
export type CreateDependencyPayloadDependencyEdgeArgs = {
  orderBy?: InputMaybe<Array<DependenciesOrderBy>>;
};

/** All input for the create `DischargeHeader` mutation. */
export type CreateDischargeHeaderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `DischargeHeader` to be created by this mutation. */
  dischargeHeader: DischargeHeaderInput;
};

/** The output of our create `DischargeHeader` mutation. */
export type CreateDischargeHeaderPayload = {
  __typename?: 'CreateDischargeHeaderPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `DischargeHeader` that was created by this mutation. */
  dischargeHeader?: Maybe<DischargeHeader>;
  /** An edge for our `DischargeHeader`. May be used by Relay 1. */
  dischargeHeaderEdge?: Maybe<DischargeHeadersEdge>;
  /** Reads a single `DataPoint` that is related to this `DischargeHeader`. */
  dischargePressure?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `DischargeHeader`. */
  dischargePressureSetpoint?: Maybe<DataPoint>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RefrigerationSystem` that is related to this `DischargeHeader`. */
  refrigerationSystem?: Maybe<RefrigerationSystem>;
};

/** The output of our create `DischargeHeader` mutation. */
export type CreateDischargeHeaderPayloadDischargeHeaderEdgeArgs = {
  orderBy?: InputMaybe<Array<DischargeHeadersOrderBy>>;
};

/** All input for the create `Door` mutation. */
export type CreateDoorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Door` to be created by this mutation. */
  door: DoorInput;
};

/** The output of our create `Door` mutation. */
export type CreateDoorPayload = {
  __typename?: 'CreateDoorPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Door` that was created by this mutation. */
  door?: Maybe<Door>;
  /** An edge for our `Door`. May be used by Relay 1. */
  doorEdge?: Maybe<DoorsEdge>;
  /** Reads a single `DataPoint` that is related to this `Door`. */
  doorState?: Maybe<DataPoint>;
  /** Reads a single `Facility` that is related to this `Door`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `Door` mutation. */
export type CreateDoorPayloadDoorEdgeArgs = {
  orderBy?: InputMaybe<Array<DoorsOrderBy>>;
};

/** All input for the create `Driver` mutation. */
export type CreateDriverInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Driver` to be created by this mutation. */
  driver: DriverInput;
};

/** The output of our create `Driver` mutation. */
export type CreateDriverPayload = {
  __typename?: 'CreateDriverPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Driver` that was created by this mutation. */
  driver?: Maybe<Driver>;
  /** An edge for our `Driver`. May be used by Relay 1. */
  driverEdge?: Maybe<DriversEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `Driver` mutation. */
export type CreateDriverPayloadDriverEdgeArgs = {
  orderBy?: InputMaybe<Array<DriversOrderBy>>;
};

/** All input for the create `ElectricalCircuit` mutation. */
export type CreateElectricalCircuitInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `ElectricalCircuit` to be created by this mutation. */
  electricalCircuit: ElectricalCircuitInput;
};

/** The output of our create `ElectricalCircuit` mutation. */
export type CreateElectricalCircuitPayload = {
  __typename?: 'CreateElectricalCircuitPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `ElectricalCircuit` that was created by this mutation. */
  electricalCircuit?: Maybe<ElectricalCircuit>;
  /** An edge for our `ElectricalCircuit`. May be used by Relay 1. */
  electricalCircuitEdge?: Maybe<ElectricalCircuitsEdge>;
  /** Reads a single `ElectricalMeteringPoint` that is related to this `ElectricalCircuit`. */
  electricalMeteringPoint?: Maybe<ElectricalMeteringPoint>;
  /** Reads a single `ElectricalPanel` that is related to this `ElectricalCircuit`. */
  electricalPanel?: Maybe<ElectricalPanel>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `ElectricalCircuit` mutation. */
export type CreateElectricalCircuitPayloadElectricalCircuitEdgeArgs = {
  orderBy?: InputMaybe<Array<ElectricalCircuitsOrderBy>>;
};

/** All input for the create `ElectricalMeteringPoint` mutation. */
export type CreateElectricalMeteringPointInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `ElectricalMeteringPoint` to be created by this mutation. */
  electricalMeteringPoint: ElectricalMeteringPointInput;
};

/** The output of our create `ElectricalMeteringPoint` mutation. */
export type CreateElectricalMeteringPointPayload = {
  __typename?: 'CreateElectricalMeteringPointPayload';
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  apparentPower?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  apparentPowerPhaseA?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  apparentPowerPhaseB?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  apparentPowerPhaseC?: Maybe<DataPoint>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  crestFactorPhaseA?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  crestFactorPhaseB?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  crestFactorPhaseC?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  cumulativeKwh?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  current?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  currentAmplitudeImbalance?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  currentAverage?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  currentThdAverage?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  currentThdPhaseA?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  currentThdPhaseB?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  currentThdPhaseC?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  currentUnbalanceFactor?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  demandPhaseA?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  demandPhaseB?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  demandPhaseC?: Maybe<DataPoint>;
  /** The `ElectricalMeteringPoint` that was created by this mutation. */
  electricalMeteringPoint?: Maybe<ElectricalMeteringPoint>;
  /** An edge for our `ElectricalMeteringPoint`. May be used by Relay 1. */
  electricalMeteringPointEdge?: Maybe<ElectricalMeteringPointsEdge>;
  /** Reads a single `Facility` that is related to this `ElectricalMeteringPoint`. */
  facility?: Maybe<Facility>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  frequency?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  frequencyDeviation?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  generatedEnergy?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  kwDemand?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  lineToLineDeviationAverage?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  lineToLineVoltage?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  lineToLineVoltageAb?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  lineToLineVoltageBc?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  lineToLineVoltageCa?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  lineToNeutralDeviationAverage?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  lineToNeutralVoltage?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  lineToNeutralVoltageA?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  lineToNeutralVoltageB?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  lineToNeutralVoltageC?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  netEnergy?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  neutralCurrent?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  phaseACurrent?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  phaseACurrentDeviation?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  phaseAVoltage?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  phaseAVoltageDeviation?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  phaseBCurrent?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  phaseBCurrentDeviation?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  phaseBVoltage?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  phaseBVoltageDeviation?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  phaseCCurrent?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  phaseCCurrentDeviation?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  phaseCVoltage?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  phaseCVoltageDeviation?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  powerFactor?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  powerFactorPhaseA?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  powerFactorPhaseB?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  powerFactorPhaseC?: Maybe<DataPoint>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  reactivePower?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  reactivePowerPhaseA?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  reactivePowerPhaseB?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  reactivePowerPhaseC?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  totalEnergy?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  voltageAmplitudeImbalance?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  voltageAverage?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  voltageThdAverage?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  voltageThdPhaseA?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  voltageThdPhaseB?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  voltageThdPhaseC?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  voltageUnbalanceFactor?: Maybe<DataPoint>;
};

/** The output of our create `ElectricalMeteringPoint` mutation. */
export type CreateElectricalMeteringPointPayloadElectricalMeteringPointEdgeArgs =
  {
    orderBy?: InputMaybe<Array<ElectricalMeteringPointsOrderBy>>;
  };

/** All input for the create `ElectricalPanel` mutation. */
export type CreateElectricalPanelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `ElectricalPanel` to be created by this mutation. */
  electricalPanel: ElectricalPanelInput;
};

/** The output of our create `ElectricalPanel` mutation. */
export type CreateElectricalPanelPayload = {
  __typename?: 'CreateElectricalPanelPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `ElectricalMeteringPoint` that is related to this `ElectricalPanel`. */
  electricalMeteringPoint?: Maybe<ElectricalMeteringPoint>;
  /** The `ElectricalPanel` that was created by this mutation. */
  electricalPanel?: Maybe<ElectricalPanel>;
  /** An edge for our `ElectricalPanel`. May be used by Relay 1. */
  electricalPanelEdge?: Maybe<ElectricalPanelsEdge>;
  /** Reads a single `Facility` that is related to this `ElectricalPanel`. */
  facility?: Maybe<Facility>;
  /** Reads a single `ElectricalCircuit` that is related to this `ElectricalPanel`. */
  parentCircuit?: Maybe<ElectricalCircuit>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `ElectricalPanel` mutation. */
export type CreateElectricalPanelPayloadElectricalPanelEdgeArgs = {
  orderBy?: InputMaybe<Array<ElectricalPanelsOrderBy>>;
};

/** All input for the create `Evaporator` mutation. */
export type CreateEvaporatorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Evaporator` to be created by this mutation. */
  evaporator: EvaporatorInput;
};

/** The output of our create `Evaporator` mutation. */
export type CreateEvaporatorPayload = {
  __typename?: 'CreateEvaporatorPayload';
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  ammoniaState?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  bleedSolenoid?: Maybe<DataPoint>;
  /** Reads a single `BuildingArea` that is related to this `Evaporator`. */
  buildingArea?: Maybe<BuildingArea>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  defrostState?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  defrostTemperature?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  defrostTimer?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  differentialAirTemperature?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  estimatedKwDemand?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  evapState?: Maybe<DataPoint>;
  /** The `Evaporator` that was created by this mutation. */
  evaporator?: Maybe<Evaporator>;
  /** An edge for our `Evaporator`. May be used by Relay 1. */
  evaporatorEdge?: Maybe<EvaporatorsEdge>;
  /** Reads a single `Facility` that is related to this `Evaporator`. */
  facility?: Maybe<Facility>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  fanState?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  fanTimer?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  hotGasSolenoid?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  liquidFeedRuntime?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  liquidFeedRuntimeSetpoint?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  liquidSolenoid?: Maybe<DataPoint>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RefrigerationSystem` that is related to this `Evaporator`. */
  refrigerationSystem?: Maybe<RefrigerationSystem>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  returnAirTemperature?: Maybe<DataPoint>;
  /** Reads a single `SuctionHeader` that is related to this `Evaporator`. */
  returnSuctionHeader?: Maybe<SuctionHeader>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  setpoint?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  softHotGasSolenoid?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  suctionPressure?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  suctionSolenoid?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  suctionTemperature?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  supplyAirTemperature?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  zoneTemperature?: Maybe<DataPoint>;
};

/** The output of our create `Evaporator` mutation. */
export type CreateEvaporatorPayloadEvaporatorEdgeArgs = {
  orderBy?: InputMaybe<Array<EvaporatorsOrderBy>>;
};

/** All input for the create `FacilityCheck` mutation. */
export type CreateFacilityCheckInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `FacilityCheck` to be created by this mutation. */
  facilityCheck: FacilityCheckInput;
};

/** The output of our create `FacilityCheck` mutation. */
export type CreateFacilityCheckPayload = {
  __typename?: 'CreateFacilityCheckPayload';
  /** Reads a single `Check` that is related to this `FacilityCheck`. */
  check?: Maybe<Check>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Facility` that is related to this `FacilityCheck`. */
  facility?: Maybe<Facility>;
  /** The `FacilityCheck` that was created by this mutation. */
  facilityCheck?: Maybe<FacilityCheck>;
  /** An edge for our `FacilityCheck`. May be used by Relay 1. */
  facilityCheckEdge?: Maybe<FacilityChecksEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `FacilityCheck` mutation. */
export type CreateFacilityCheckPayloadFacilityCheckEdgeArgs = {
  orderBy?: InputMaybe<Array<FacilityChecksOrderBy>>;
};

/** All input for the create `FacilityCommunication` mutation. */
export type CreateFacilityCommunicationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `FacilityCommunication` to be created by this mutation. */
  facilityCommunication: FacilityCommunicationInput;
};

/** The output of our create `FacilityCommunication` mutation. */
export type CreateFacilityCommunicationPayload = {
  __typename?: 'CreateFacilityCommunicationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Facility` that is related to this `FacilityCommunication`. */
  facility?: Maybe<Facility>;
  /** The `FacilityCommunication` that was created by this mutation. */
  facilityCommunication?: Maybe<FacilityCommunication>;
  /** An edge for our `FacilityCommunication`. May be used by Relay 1. */
  facilityCommunicationEdge?: Maybe<FacilityCommunicationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `FacilityCommunication` mutation. */
export type CreateFacilityCommunicationPayloadFacilityCommunicationEdgeArgs = {
  orderBy?: InputMaybe<Array<FacilityCommunicationsOrderBy>>;
};

/** All input for the create `FacilityDataSource` mutation. */
export type CreateFacilityDataSourceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `FacilityDataSource` to be created by this mutation. */
  facilityDataSource: FacilityDataSourceInput;
};

/** The output of our create `FacilityDataSource` mutation. */
export type CreateFacilityDataSourcePayload = {
  __typename?: 'CreateFacilityDataSourcePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DataSource` that is related to this `FacilityDataSource`. */
  dataSourceByDataSourceName?: Maybe<DataSource>;
  /** Reads a single `Facility` that is related to this `FacilityDataSource`. */
  facility?: Maybe<Facility>;
  /** The `FacilityDataSource` that was created by this mutation. */
  facilityDataSource?: Maybe<FacilityDataSource>;
  /** An edge for our `FacilityDataSource`. May be used by Relay 1. */
  facilityDataSourceEdge?: Maybe<FacilityDataSourcesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `FacilityDataSource` mutation. */
export type CreateFacilityDataSourcePayloadFacilityDataSourceEdgeArgs = {
  orderBy?: InputMaybe<Array<FacilityDataSourcesOrderBy>>;
};

/** All input for the create `FacilityDocument` mutation. */
export type CreateFacilityDocumentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `FacilityDocument` to be created by this mutation. */
  facilityDocument: FacilityDocumentInput;
};

/** The output of our create `FacilityDocument` mutation. */
export type CreateFacilityDocumentPayload = {
  __typename?: 'CreateFacilityDocumentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Facility` that is related to this `FacilityDocument`. */
  facility?: Maybe<Facility>;
  /** The `FacilityDocument` that was created by this mutation. */
  facilityDocument?: Maybe<FacilityDocument>;
  /** An edge for our `FacilityDocument`. May be used by Relay 1. */
  facilityDocumentEdge?: Maybe<FacilityDocumentsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SoftwarePackage` that is related to this `FacilityDocument`. */
  softwarePackage?: Maybe<SoftwarePackage>;
};

/** The output of our create `FacilityDocument` mutation. */
export type CreateFacilityDocumentPayloadFacilityDocumentEdgeArgs = {
  orderBy?: InputMaybe<Array<FacilityDocumentsOrderBy>>;
};

/** All input for the create `FacilityGroup` mutation. */
export type CreateFacilityGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `FacilityGroup` to be created by this mutation. */
  facilityGroup: FacilityGroupInput;
};

/** The output of our create `FacilityGroup` mutation. */
export type CreateFacilityGroupPayload = {
  __typename?: 'CreateFacilityGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `FacilityGroup` that was created by this mutation. */
  facilityGroup?: Maybe<FacilityGroup>;
  /** An edge for our `FacilityGroup`. May be used by Relay 1. */
  facilityGroupEdge?: Maybe<FacilityGroupsEdge>;
  /** Reads a single `FacilityGroup` that is related to this `FacilityGroup`. */
  parent?: Maybe<FacilityGroup>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `FacilityGroup` mutation. */
export type CreateFacilityGroupPayloadFacilityGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<FacilityGroupsOrderBy>>;
};

/** All input for the create `FacilityGroupsLinker` mutation. */
export type CreateFacilityGroupsLinkerInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `FacilityGroupsLinker` to be created by this mutation. */
  facilityGroupsLinker: FacilityGroupsLinkerInput;
};

/** The output of our create `FacilityGroupsLinker` mutation. */
export type CreateFacilityGroupsLinkerPayload = {
  __typename?: 'CreateFacilityGroupsLinkerPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Facility` that is related to this `FacilityGroupsLinker`. */
  facility?: Maybe<Facility>;
  /** Reads a single `FacilityGroup` that is related to this `FacilityGroupsLinker`. */
  facilityGrouping?: Maybe<FacilityGroup>;
  /** The `FacilityGroupsLinker` that was created by this mutation. */
  facilityGroupsLinker?: Maybe<FacilityGroupsLinker>;
  /** An edge for our `FacilityGroupsLinker`. May be used by Relay 1. */
  facilityGroupsLinkerEdge?: Maybe<FacilityGroupsLinkersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `FacilityGroupsLinker` mutation. */
export type CreateFacilityGroupsLinkerPayloadFacilityGroupsLinkerEdgeArgs = {
  orderBy?: InputMaybe<Array<FacilityGroupsLinkersOrderBy>>;
};

/** All input for the create `Facility` mutation. */
export type CreateFacilityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Facility` to be created by this mutation. */
  facility: FacilityInput;
};

/** The output of our create `Facility` mutation. */
export type CreateFacilityPayload = {
  __typename?: 'CreateFacilityPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Facility` that was created by this mutation. */
  facility?: Maybe<Facility>;
  /** An edge for our `Facility`. May be used by Relay 1. */
  facilityEdge?: Maybe<FacilitiesEdge>;
  /** Reads a single `PricingNode` that is related to this `Facility`. */
  pricingNode?: Maybe<PricingNode>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Timezone` that is related to this `Facility`. */
  timezone?: Maybe<Timezone>;
  /** Reads a single `UnitGroup` that is related to this `Facility`. */
  unitGroupItem?: Maybe<UnitGroup>;
};

/** The output of our create `Facility` mutation. */
export type CreateFacilityPayloadFacilityEdgeArgs = {
  orderBy?: InputMaybe<Array<FacilitiesOrderBy>>;
};

/** All input for the create `FacilitySoftwarePackage` mutation. */
export type CreateFacilitySoftwarePackageInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `FacilitySoftwarePackage` to be created by this mutation. */
  facilitySoftwarePackage: FacilitySoftwarePackageInput;
};

/** The output of our create `FacilitySoftwarePackage` mutation. */
export type CreateFacilitySoftwarePackagePayload = {
  __typename?: 'CreateFacilitySoftwarePackagePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Facility` that is related to this `FacilitySoftwarePackage`. */
  facility?: Maybe<Facility>;
  /** The `FacilitySoftwarePackage` that was created by this mutation. */
  facilitySoftwarePackage?: Maybe<FacilitySoftwarePackage>;
  /** An edge for our `FacilitySoftwarePackage`. May be used by Relay 1. */
  facilitySoftwarePackageEdge?: Maybe<FacilitySoftwarePackagesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SoftwarePackage` that is related to this `FacilitySoftwarePackage`. */
  softwarePackage?: Maybe<SoftwarePackage>;
};

/** The output of our create `FacilitySoftwarePackage` mutation. */
export type CreateFacilitySoftwarePackagePayloadFacilitySoftwarePackageEdgeArgs =
  {
    orderBy?: InputMaybe<Array<FacilitySoftwarePackagesOrderBy>>;
  };

/** All input for the create `FacilityTaggedDataPoint` mutation. */
export type CreateFacilityTaggedDataPointInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `FacilityTaggedDataPoint` to be created by this mutation. */
  facilityTaggedDataPoint: FacilityTaggedDataPointInput;
};

/** The output of our create `FacilityTaggedDataPoint` mutation. */
export type CreateFacilityTaggedDataPointPayload = {
  __typename?: 'CreateFacilityTaggedDataPointPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DataPoint` that is related to this `FacilityTaggedDataPoint`. */
  dataPoint?: Maybe<DataPoint>;
  /** Reads a single `Facility` that is related to this `FacilityTaggedDataPoint`. */
  facility?: Maybe<Facility>;
  /** The `FacilityTaggedDataPoint` that was created by this mutation. */
  facilityTaggedDataPoint?: Maybe<FacilityTaggedDataPoint>;
  /** An edge for our `FacilityTaggedDataPoint`. May be used by Relay 1. */
  facilityTaggedDataPointEdge?: Maybe<FacilityTaggedDataPointsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DataPointTag` that is related to this `FacilityTaggedDataPoint`. */
  tag?: Maybe<DataPointTag>;
};

/** The output of our create `FacilityTaggedDataPoint` mutation. */
export type CreateFacilityTaggedDataPointPayloadFacilityTaggedDataPointEdgeArgs =
  {
    orderBy?: InputMaybe<Array<FacilityTaggedDataPointsOrderBy>>;
  };

/** All input for the create `Gateway` mutation. */
export type CreateGatewayInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Gateway` to be created by this mutation. */
  gateway: GatewayInput;
};

/** The output of our create `Gateway` mutation. */
export type CreateGatewayPayload = {
  __typename?: 'CreateGatewayPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Facility` that is related to this `Gateway`. */
  facility?: Maybe<Facility>;
  /** The `Gateway` that was created by this mutation. */
  gateway?: Maybe<Gateway>;
  /** An edge for our `Gateway`. May be used by Relay 1. */
  gatewayEdge?: Maybe<GatewaysEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DataPoint` that is related to this `Gateway`. */
  status?: Maybe<DataPoint>;
};

/** The output of our create `Gateway` mutation. */
export type CreateGatewayPayloadGatewayEdgeArgs = {
  orderBy?: InputMaybe<Array<GatewaysOrderBy>>;
};

/** All input for the create `InboundOutboundLoad` mutation. */
export type CreateInboundOutboundLoadInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `InboundOutboundLoad` to be created by this mutation. */
  inboundOutboundLoad: InboundOutboundLoadInput;
};

/** The output of our create `InboundOutboundLoad` mutation. */
export type CreateInboundOutboundLoadPayload = {
  __typename?: 'CreateInboundOutboundLoadPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Facility` that is related to this `InboundOutboundLoad`. */
  facility?: Maybe<Facility>;
  /** The `InboundOutboundLoad` that was created by this mutation. */
  inboundOutboundLoad?: Maybe<InboundOutboundLoad>;
  /** An edge for our `InboundOutboundLoad`. May be used by Relay 1. */
  inboundOutboundLoadEdge?: Maybe<InboundOutboundLoadsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `InboundOutboundLoad` mutation. */
export type CreateInboundOutboundLoadPayloadInboundOutboundLoadEdgeArgs = {
  orderBy?: InputMaybe<Array<InboundOutboundLoadsOrderBy>>;
};

/** All input for the create `Incident` mutation. */
export type CreateIncidentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Incident` to be created by this mutation. */
  incident: IncidentInput;
};

/** All input for the create `IncidentLog` mutation. */
export type CreateIncidentLogInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `IncidentLog` to be created by this mutation. */
  incidentLog: IncidentLogInput;
};

/** The output of our create `IncidentLog` mutation. */
export type CreateIncidentLogPayload = {
  __typename?: 'CreateIncidentLogPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Incident` that is related to this `IncidentLog`. */
  incident?: Maybe<Incident>;
  /** The `IncidentLog` that was created by this mutation. */
  incidentLog?: Maybe<IncidentLog>;
  /** An edge for our `IncidentLog`. May be used by Relay 1. */
  incidentLogEdge?: Maybe<IncidentLogsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `IncidentLog` mutation. */
export type CreateIncidentLogPayloadIncidentLogEdgeArgs = {
  orderBy?: InputMaybe<Array<IncidentLogsOrderBy>>;
};

/** The output of our create `Incident` mutation. */
export type CreateIncidentPayload = {
  __typename?: 'CreateIncidentPayload';
  /** Reads a single `CheckMonitor` that is related to this `Incident`. */
  checkMonitor?: Maybe<CheckMonitor>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Incident` that was created by this mutation. */
  incident?: Maybe<Incident>;
  /** An edge for our `Incident`. May be used by Relay 1. */
  incidentEdge?: Maybe<IncidentsEdge>;
  /** Reads a single `MonitorDetection` that is related to this `Incident`. */
  monitorDetection?: Maybe<MonitorDetection>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `Incident` mutation. */
export type CreateIncidentPayloadIncidentEdgeArgs = {
  orderBy?: InputMaybe<Array<IncidentsOrderBy>>;
};

/** All input for the create `LiquidHeader` mutation. */
export type CreateLiquidHeaderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `LiquidHeader` to be created by this mutation. */
  liquidHeader: LiquidHeaderInput;
};

/** The output of our create `LiquidHeader` mutation. */
export type CreateLiquidHeaderPayload = {
  __typename?: 'CreateLiquidHeaderPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `LiquidHeader` that was created by this mutation. */
  liquidHeader?: Maybe<LiquidHeader>;
  /** An edge for our `LiquidHeader`. May be used by Relay 1. */
  liquidHeaderEdge?: Maybe<LiquidHeadersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RefrigerationSystem` that is related to this `LiquidHeader`. */
  refrigerationSystem?: Maybe<RefrigerationSystem>;
  /** Reads a single `Vessel` that is related to this `LiquidHeader`. */
  vessel?: Maybe<Vessel>;
};

/** The output of our create `LiquidHeader` mutation. */
export type CreateLiquidHeaderPayloadLiquidHeaderEdgeArgs = {
  orderBy?: InputMaybe<Array<LiquidHeadersOrderBy>>;
};

/** All input for the create `LiquidHeadersEvaporator` mutation. */
export type CreateLiquidHeadersEvaporatorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `LiquidHeadersEvaporator` to be created by this mutation. */
  liquidHeadersEvaporator: LiquidHeadersEvaporatorInput;
};

/** The output of our create `LiquidHeadersEvaporator` mutation. */
export type CreateLiquidHeadersEvaporatorPayload = {
  __typename?: 'CreateLiquidHeadersEvaporatorPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Evaporator` that is related to this `LiquidHeadersEvaporator`. */
  evaporator?: Maybe<Evaporator>;
  /** Reads a single `LiquidHeader` that is related to this `LiquidHeadersEvaporator`. */
  liquidHeader?: Maybe<LiquidHeader>;
  /** The `LiquidHeadersEvaporator` that was created by this mutation. */
  liquidHeadersEvaporator?: Maybe<LiquidHeadersEvaporator>;
  /** An edge for our `LiquidHeadersEvaporator`. May be used by Relay 1. */
  liquidHeadersEvaporatorEdge?: Maybe<LiquidHeadersEvaporatorsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `LiquidHeadersEvaporator` mutation. */
export type CreateLiquidHeadersEvaporatorPayloadLiquidHeadersEvaporatorEdgeArgs =
  {
    orderBy?: InputMaybe<Array<LiquidHeadersEvaporatorsOrderBy>>;
  };

export type CreateMachineAccessTokenInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  expiresAt?: InputMaybe<Scalars['Datetime']['input']>;
  machineUserId: Scalars['BigInt']['input'];
};

export type CreateMachineAccessTokenPayload = CreateAccessTokenPayload & {
  __typename?: 'CreateMachineAccessTokenPayload';
  accessKey: Scalars['String']['output'];
  clientMutationId?: Maybe<Scalars['String']['output']>;
  machineUser: MachineUser;
  token: PlatformAccessToken;
};

/** All input for the create `MachineUser` mutation. */
export type CreateMachineUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `MachineUser` to be created by this mutation. */
  machineUser: MachineUserInput;
};

/** The output of our create `MachineUser` mutation. */
export type CreateMachineUserPayload = {
  __typename?: 'CreateMachineUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `MachineUser` that was created by this mutation. */
  machineUser?: Maybe<MachineUser>;
  /** An edge for our `MachineUser`. May be used by Relay 1. */
  machineUserEdge?: Maybe<MachineUsersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `MachineUser` mutation. */
export type CreateMachineUserPayloadMachineUserEdgeArgs = {
  orderBy?: InputMaybe<Array<MachineUsersOrderBy>>;
};

/** All input for the create `MainService` mutation. */
export type CreateMainServiceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `MainService` to be created by this mutation. */
  mainService: MainServiceInput;
};

/** The output of our create `MainService` mutation. */
export type CreateMainServicePayload = {
  __typename?: 'CreateMainServicePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DataPoint` that is related to this `MainService`. */
  demand?: Maybe<DataPoint>;
  /** Reads a single `Facility` that is related to this `MainService`. */
  facility?: Maybe<Facility>;
  /** Reads a single `DataPoint` that is related to this `MainService`. */
  gridDemand?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `MainService`. */
  gridUsage?: Maybe<DataPoint>;
  /** The `MainService` that was created by this mutation. */
  mainService?: Maybe<MainService>;
  /** An edge for our `MainService`. May be used by Relay 1. */
  mainServiceEdge?: Maybe<MainServicesEdge>;
  /** Reads a single `DataPoint` that is related to this `MainService`. */
  meterDemand?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `MainService`. */
  meterUsage?: Maybe<DataPoint>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DataPoint` that is related to this `MainService`. */
  usage?: Maybe<DataPoint>;
};

/** The output of our create `MainService` mutation. */
export type CreateMainServicePayloadMainServiceEdgeArgs = {
  orderBy?: InputMaybe<Array<MainServicesOrderBy>>;
};

/** All input for the create `MeterCharge` mutation. */
export type CreateMeterChargeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `MeterCharge` to be created by this mutation. */
  meterCharge: MeterChargeInput;
};

/** The output of our create `MeterCharge` mutation. */
export type CreateMeterChargePayload = {
  __typename?: 'CreateMeterChargePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `MeterCharge` that was created by this mutation. */
  meterCharge?: Maybe<MeterCharge>;
  /** An edge for our `MeterCharge`. May be used by Relay 1. */
  meterChargeEdge?: Maybe<MeterChargesEdge>;
  /** Reads a single `MeterStatement` that is related to this `MeterCharge`. */
  meterStatement?: Maybe<MeterStatement>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `MeterCharge` mutation. */
export type CreateMeterChargePayloadMeterChargeEdgeArgs = {
  orderBy?: InputMaybe<Array<MeterChargesOrderBy>>;
};

/** All input for the create `MeterStatementHistory` mutation. */
export type CreateMeterStatementHistoryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `MeterStatementHistory` to be created by this mutation. */
  meterStatementHistory: MeterStatementHistoryInput;
};

/** The output of our create `MeterStatementHistory` mutation. */
export type CreateMeterStatementHistoryPayload = {
  __typename?: 'CreateMeterStatementHistoryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `MeterStatement` that is related to this `MeterStatementHistory`. */
  meterStatement?: Maybe<MeterStatement>;
  /** The `MeterStatementHistory` that was created by this mutation. */
  meterStatementHistory?: Maybe<MeterStatementHistory>;
  /** An edge for our `MeterStatementHistory`. May be used by Relay 1. */
  meterStatementHistoryEdge?: Maybe<MeterStatementHistoriesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `MeterStatementHistory` mutation. */
export type CreateMeterStatementHistoryPayloadMeterStatementHistoryEdgeArgs = {
  orderBy?: InputMaybe<Array<MeterStatementHistoriesOrderBy>>;
};

/** All input for the create `MeterStatement` mutation. */
export type CreateMeterStatementInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `MeterStatement` to be created by this mutation. */
  meterStatement: MeterStatementInput;
};

/** The output of our create `MeterStatement` mutation. */
export type CreateMeterStatementPayload = {
  __typename?: 'CreateMeterStatementPayload';
  /** Reads a single `AccountStatement` that is related to this `MeterStatement`. */
  accountStatement?: Maybe<AccountStatement>;
  /** Reads a single `AccountStatementPdf` that is related to this `MeterStatement`. */
  accountStatementPdf?: Maybe<AccountStatementPdf>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `MeterStatement` that was created by this mutation. */
  meterStatement?: Maybe<MeterStatement>;
  /** An edge for our `MeterStatement`. May be used by Relay 1. */
  meterStatementEdge?: Maybe<MeterStatementsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `UtilityMeter` that is related to this `MeterStatement`. */
  utilityMeter?: Maybe<UtilityMeter>;
};

/** The output of our create `MeterStatement` mutation. */
export type CreateMeterStatementPayloadMeterStatementEdgeArgs = {
  orderBy?: InputMaybe<Array<MeterStatementsOrderBy>>;
};

/** All input for the create `MeterUsage` mutation. */
export type CreateMeterUsageInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `MeterUsage` to be created by this mutation. */
  meterUsage: MeterUsageInput;
};

/** The output of our create `MeterUsage` mutation. */
export type CreateMeterUsagePayload = {
  __typename?: 'CreateMeterUsagePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `MeterStatement` that is related to this `MeterUsage`. */
  meterStatement?: Maybe<MeterStatement>;
  /** The `MeterUsage` that was created by this mutation. */
  meterUsage?: Maybe<MeterUsage>;
  /** An edge for our `MeterUsage`. May be used by Relay 1. */
  meterUsageEdge?: Maybe<MeterUsagesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `MeterUsage` mutation. */
export type CreateMeterUsagePayloadMeterUsageEdgeArgs = {
  orderBy?: InputMaybe<Array<MeterUsagesOrderBy>>;
};

/** All input for the create `MonitorDataPoint` mutation. */
export type CreateMonitorDataPointInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `MonitorDataPoint` to be created by this mutation. */
  monitorDataPoint: MonitorDataPointInput;
};

/** The output of our create `MonitorDataPoint` mutation. */
export type CreateMonitorDataPointPayload = {
  __typename?: 'CreateMonitorDataPointPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DataPoint` that is related to this `MonitorDataPoint`. */
  dataPoint?: Maybe<DataPoint>;
  /** Reads a single `Monitor` that is related to this `MonitorDataPoint`. */
  monitor?: Maybe<Monitor>;
  /** The `MonitorDataPoint` that was created by this mutation. */
  monitorDataPoint?: Maybe<MonitorDataPoint>;
  /** An edge for our `MonitorDataPoint`. May be used by Relay 1. */
  monitorDataPointEdge?: Maybe<MonitorDataPointsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `MonitorDataPoint` mutation. */
export type CreateMonitorDataPointPayloadMonitorDataPointEdgeArgs = {
  orderBy?: InputMaybe<Array<MonitorDataPointsOrderBy>>;
};

/** All input for the create `MonitorDetection` mutation. */
export type CreateMonitorDetectionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `MonitorDetection` to be created by this mutation. */
  monitorDetection: MonitorDetectionInput;
};

/** The output of our create `MonitorDetection` mutation. */
export type CreateMonitorDetectionPayload = {
  __typename?: 'CreateMonitorDetectionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Monitor` that is related to this `MonitorDetection`. */
  monitor?: Maybe<Monitor>;
  /** The `MonitorDetection` that was created by this mutation. */
  monitorDetection?: Maybe<MonitorDetection>;
  /** An edge for our `MonitorDetection`. May be used by Relay 1. */
  monitorDetectionEdge?: Maybe<MonitorDetectionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `MonitorDetection` mutation. */
export type CreateMonitorDetectionPayloadMonitorDetectionEdgeArgs = {
  orderBy?: InputMaybe<Array<MonitorDetectionsOrderBy>>;
};

/** All input for the create `Monitor` mutation. */
export type CreateMonitorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Monitor` to be created by this mutation. */
  monitor: MonitorInput;
};

/** The output of our create `Monitor` mutation. */
export type CreateMonitorPayload = {
  __typename?: 'CreateMonitorPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Monitor` that was created by this mutation. */
  monitor?: Maybe<Monitor>;
  /** An edge for our `Monitor`. May be used by Relay 1. */
  monitorEdge?: Maybe<MonitorsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `Monitor` mutation. */
export type CreateMonitorPayloadMonitorEdgeArgs = {
  orderBy?: InputMaybe<Array<MonitorsOrderBy>>;
};

/** All input for the create `OpportunityAttachment` mutation. */
export type CreateOpportunityAttachmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `OpportunityAttachment` to be created by this mutation. */
  opportunityAttachment: OpportunityAttachmentInput;
};

/** The output of our create `OpportunityAttachment` mutation. */
export type CreateOpportunityAttachmentPayload = {
  __typename?: 'CreateOpportunityAttachmentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Opportunity` that is related to this `OpportunityAttachment`. */
  opportunity?: Maybe<Opportunity>;
  /** The `OpportunityAttachment` that was created by this mutation. */
  opportunityAttachment?: Maybe<OpportunityAttachment>;
  /** An edge for our `OpportunityAttachment`. May be used by Relay 1. */
  opportunityAttachmentEdge?: Maybe<OpportunityAttachmentsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `OpportunityAttachment` mutation. */
export type CreateOpportunityAttachmentPayloadOpportunityAttachmentEdgeArgs = {
  orderBy?: InputMaybe<Array<OpportunityAttachmentsOrderBy>>;
};

/** All input for the create `Opportunity` mutation. */
export type CreateOpportunityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Opportunity` to be created by this mutation. */
  opportunity: OpportunityInput;
};

/** The output of our create `Opportunity` mutation. */
export type CreateOpportunityPayload = {
  __typename?: 'CreateOpportunityPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Facility` that is related to this `Opportunity`. */
  facility?: Maybe<Facility>;
  /** The `Opportunity` that was created by this mutation. */
  opportunity?: Maybe<Opportunity>;
  /** An edge for our `Opportunity`. May be used by Relay 1. */
  opportunityEdge?: Maybe<OpportunitiesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `Opportunity` mutation. */
export type CreateOpportunityPayloadOpportunityEdgeArgs = {
  orderBy?: InputMaybe<Array<OpportunitiesOrderBy>>;
};

/** All input for the create `PalletHistory` mutation. */
export type CreatePalletHistoryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `PalletHistory` to be created by this mutation. */
  palletHistory: PalletHistoryInput;
};

/** The output of our create `PalletHistory` mutation. */
export type CreatePalletHistoryPayload = {
  __typename?: 'CreatePalletHistoryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `PalletHistory` that was created by this mutation. */
  palletHistory?: Maybe<PalletHistory>;
  /** An edge for our `PalletHistory`. May be used by Relay 1. */
  palletHistoryEdge?: Maybe<PalletHistoriesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `PalletHistory` mutation. */
export type CreatePalletHistoryPayloadPalletHistoryEdgeArgs = {
  orderBy?: InputMaybe<Array<PalletHistoriesOrderBy>>;
};

/** All input for the create `Pallet` mutation. */
export type CreatePalletInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Pallet` to be created by this mutation. */
  pallet: PalletInput;
};

/** All input for the create `PalletLocation` mutation. */
export type CreatePalletLocationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `PalletLocation` to be created by this mutation. */
  palletLocation: PalletLocationInput;
};

/** The output of our create `PalletLocation` mutation. */
export type CreatePalletLocationPayload = {
  __typename?: 'CreatePalletLocationPayload';
  /** Reads a single `BuildingArea` that is related to this `PalletLocation`. */
  buildingArea?: Maybe<BuildingArea>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Facility` that is related to this `PalletLocation`. */
  facility?: Maybe<Facility>;
  /** The `PalletLocation` that was created by this mutation. */
  palletLocation?: Maybe<PalletLocation>;
  /** An edge for our `PalletLocation`. May be used by Relay 1. */
  palletLocationEdge?: Maybe<PalletLocationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `PalletLocation` mutation. */
export type CreatePalletLocationPayloadPalletLocationEdgeArgs = {
  orderBy?: InputMaybe<Array<PalletLocationsOrderBy>>;
};

/** The output of our create `Pallet` mutation. */
export type CreatePalletPayload = {
  __typename?: 'CreatePalletPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Pallet` that was created by this mutation. */
  pallet?: Maybe<Pallet>;
  /** An edge for our `Pallet`. May be used by Relay 1. */
  palletEdge?: Maybe<PalletsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `Pallet` mutation. */
export type CreatePalletPayloadPalletEdgeArgs = {
  orderBy?: InputMaybe<Array<PalletsOrderBy>>;
};

/** All input for the create `PricingNode` mutation. */
export type CreatePricingNodeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `PricingNode` to be created by this mutation. */
  pricingNode: PricingNodeInput;
};

/** The output of our create `PricingNode` mutation. */
export type CreatePricingNodePayload = {
  __typename?: 'CreatePricingNodePayload';
  /** Reads a single `BalancingAuthority` that is related to this `PricingNode`. */
  balancingAuthority?: Maybe<BalancingAuthority>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `PricingNode` that was created by this mutation. */
  pricingNode?: Maybe<PricingNode>;
  /** An edge for our `PricingNode`. May be used by Relay 1. */
  pricingNodeEdge?: Maybe<PricingNodesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `PricingNode` mutation. */
export type CreatePricingNodePayloadPricingNodeEdgeArgs = {
  orderBy?: InputMaybe<Array<PricingNodesOrderBy>>;
};

/** All input for the create `Product` mutation. */
export type CreateProductInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Product` to be created by this mutation. */
  product: ProductInput;
};

/** The output of our create `Product` mutation. */
export type CreateProductPayload = {
  __typename?: 'CreateProductPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Facility` that is related to this `Product`. */
  facility?: Maybe<Facility>;
  /** The `Product` that was created by this mutation. */
  product?: Maybe<Product>;
  /** An edge for our `Product`. May be used by Relay 1. */
  productEdge?: Maybe<ProductsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `Product` mutation. */
export type CreateProductPayloadProductEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};

/** All input for the create `ProgramEnrollment` mutation. */
export type CreateProgramEnrollmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `ProgramEnrollment` to be created by this mutation. */
  programEnrollment: ProgramEnrollmentInput;
};

/** The output of our create `ProgramEnrollment` mutation. */
export type CreateProgramEnrollmentPayload = {
  __typename?: 'CreateProgramEnrollmentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Program` that is related to this `ProgramEnrollment`. */
  program?: Maybe<Program>;
  /** The `ProgramEnrollment` that was created by this mutation. */
  programEnrollment?: Maybe<ProgramEnrollment>;
  /** An edge for our `ProgramEnrollment`. May be used by Relay 1. */
  programEnrollmentEdge?: Maybe<ProgramEnrollmentsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `ProgramEnrollment` mutation. */
export type CreateProgramEnrollmentPayloadProgramEnrollmentEdgeArgs = {
  orderBy?: InputMaybe<Array<ProgramEnrollmentsOrderBy>>;
};

/** All input for the create `Program` mutation. */
export type CreateProgramInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Program` to be created by this mutation. */
  program: ProgramInput;
};

/** The output of our create `Program` mutation. */
export type CreateProgramPayload = {
  __typename?: 'CreateProgramPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Program` that was created by this mutation. */
  program?: Maybe<Program>;
  /** An edge for our `Program`. May be used by Relay 1. */
  programEdge?: Maybe<ProgramsEdge>;
  /** Reads a single `ProjectType` that is related to this `Program`. */
  projectType?: Maybe<ProjectType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Timezone` that is related to this `Program`. */
  timezone?: Maybe<Timezone>;
};

/** The output of our create `Program` mutation. */
export type CreateProgramPayloadProgramEdgeArgs = {
  orderBy?: InputMaybe<Array<ProgramsOrderBy>>;
};

/** All input for the create `ProjectComponent` mutation. */
export type CreateProjectComponentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `ProjectComponent` to be created by this mutation. */
  projectComponent: ProjectComponentInput;
};

/** The output of our create `ProjectComponent` mutation. */
export type CreateProjectComponentPayload = {
  __typename?: 'CreateProjectComponentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Component` that is related to this `ProjectComponent`. */
  component?: Maybe<Component>;
  /** Reads a single `Project` that is related to this `ProjectComponent`. */
  project?: Maybe<Project>;
  /** The `ProjectComponent` that was created by this mutation. */
  projectComponent?: Maybe<ProjectComponent>;
  /** An edge for our `ProjectComponent`. May be used by Relay 1. */
  projectComponentEdge?: Maybe<ProjectComponentsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `ProjectComponent` mutation. */
export type CreateProjectComponentPayloadProjectComponentEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectComponentsOrderBy>>;
};

/** All input for the create `ProjectEnrollmentDataPointGroup` mutation. */
export type CreateProjectEnrollmentDataPointGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `ProjectEnrollmentDataPointGroup` to be created by this mutation. */
  projectEnrollmentDataPointGroup: ProjectEnrollmentDataPointGroupInput;
};

/** The output of our create `ProjectEnrollmentDataPointGroup` mutation. */
export type CreateProjectEnrollmentDataPointGroupPayload = {
  __typename?: 'CreateProjectEnrollmentDataPointGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `ProjectEnrollmentDataPointGroup` that was created by this mutation. */
  projectEnrollmentDataPointGroup?: Maybe<ProjectEnrollmentDataPointGroup>;
  /** An edge for our `ProjectEnrollmentDataPointGroup`. May be used by Relay 1. */
  projectEnrollmentDataPointGroupEdge?: Maybe<ProjectEnrollmentDataPointGroupsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `ProjectEnrollmentDataPointGroup` mutation. */
export type CreateProjectEnrollmentDataPointGroupPayloadProjectEnrollmentDataPointGroupEdgeArgs =
  {
    orderBy?: InputMaybe<Array<ProjectEnrollmentDataPointGroupsOrderBy>>;
  };

/** All input for the create `ProjectEnrollmentDataPoint` mutation. */
export type CreateProjectEnrollmentDataPointInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `ProjectEnrollmentDataPoint` to be created by this mutation. */
  projectEnrollmentDataPoint: ProjectEnrollmentDataPointInput;
};

/** The output of our create `ProjectEnrollmentDataPoint` mutation. */
export type CreateProjectEnrollmentDataPointPayload = {
  __typename?: 'CreateProjectEnrollmentDataPointPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DataPoint` that is related to this `ProjectEnrollmentDataPoint`. */
  dataPoint?: Maybe<DataPoint>;
  /** Reads a single `ProjectEnrollmentDataPointGroup` that is related to this `ProjectEnrollmentDataPoint`. */
  group?: Maybe<ProjectEnrollmentDataPointGroup>;
  /** Reads a single `DataPoint` that is related to this `ProjectEnrollmentDataPoint`. */
  profileDataPoint?: Maybe<DataPoint>;
  /** Reads a single `ProjectEnrollment` that is related to this `ProjectEnrollmentDataPoint`. */
  projectEnrollment?: Maybe<ProjectEnrollment>;
  /** The `ProjectEnrollmentDataPoint` that was created by this mutation. */
  projectEnrollmentDataPoint?: Maybe<ProjectEnrollmentDataPoint>;
  /** An edge for our `ProjectEnrollmentDataPoint`. May be used by Relay 1. */
  projectEnrollmentDataPointEdge?: Maybe<ProjectEnrollmentDataPointsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `ProjectEnrollmentDataPoint` mutation. */
export type CreateProjectEnrollmentDataPointPayloadProjectEnrollmentDataPointEdgeArgs =
  {
    orderBy?: InputMaybe<Array<ProjectEnrollmentDataPointsOrderBy>>;
  };

/** All input for the create `ProjectEnrollment` mutation. */
export type CreateProjectEnrollmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `ProjectEnrollment` to be created by this mutation. */
  projectEnrollment: ProjectEnrollmentInput;
};

/** The output of our create `ProjectEnrollment` mutation. */
export type CreateProjectEnrollmentPayload = {
  __typename?: 'CreateProjectEnrollmentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `ProgramEnrollment` that is related to this `ProjectEnrollment`. */
  programEnrollment?: Maybe<ProgramEnrollment>;
  /** Reads a single `Project` that is related to this `ProjectEnrollment`. */
  project?: Maybe<Project>;
  /** The `ProjectEnrollment` that was created by this mutation. */
  projectEnrollment?: Maybe<ProjectEnrollment>;
  /** An edge for our `ProjectEnrollment`. May be used by Relay 1. */
  projectEnrollmentEdge?: Maybe<ProjectEnrollmentsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `ProjectEnrollment` mutation. */
export type CreateProjectEnrollmentPayloadProjectEnrollmentEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectEnrollmentsOrderBy>>;
};

/** All input for the create `Project` mutation. */
export type CreateProjectInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Project` to be created by this mutation. */
  project: ProjectInput;
};

/** The output of our create `Project` mutation. */
export type CreateProjectPayload = {
  __typename?: 'CreateProjectPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Facility` that is related to this `Project`. */
  facility?: Maybe<Facility>;
  /** Reads a single `Program` that is related to this `Project`. */
  program?: Maybe<Program>;
  /** The `Project` that was created by this mutation. */
  project?: Maybe<Project>;
  /** An edge for our `Project`. May be used by Relay 1. */
  projectEdge?: Maybe<ProjectsEdge>;
  /** Reads a single `ProjectType` that is related to this `Project`. */
  projectType?: Maybe<ProjectType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `Project` mutation. */
export type CreateProjectPayloadProjectEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectsOrderBy>>;
};

/** All input for the create `ProjectWatcher` mutation. */
export type CreateProjectWatcherInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `ProjectWatcher` to be created by this mutation. */
  projectWatcher: ProjectWatcherInput;
};

/** The output of our create `ProjectWatcher` mutation. */
export type CreateProjectWatcherPayload = {
  __typename?: 'CreateProjectWatcherPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Project` that is related to this `ProjectWatcher`. */
  project?: Maybe<Project>;
  /** The `ProjectWatcher` that was created by this mutation. */
  projectWatcher?: Maybe<ProjectWatcher>;
  /** An edge for our `ProjectWatcher`. May be used by Relay 1. */
  projectWatcherEdge?: Maybe<ProjectWatchersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `ProjectWatcher`. */
  user?: Maybe<User>;
};

/** The output of our create `ProjectWatcher` mutation. */
export type CreateProjectWatcherPayloadProjectWatcherEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectWatchersOrderBy>>;
};

/** All input for the create `RefrigerationSystem` mutation. */
export type CreateRefrigerationSystemInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `RefrigerationSystem` to be created by this mutation. */
  refrigerationSystem: RefrigerationSystemInput;
};

/** The output of our create `RefrigerationSystem` mutation. */
export type CreateRefrigerationSystemPayload = {
  __typename?: 'CreateRefrigerationSystemPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Facility` that is related to this `RefrigerationSystem`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Refrigerant` that is related to this `RefrigerationSystem`. */
  refrigerant?: Maybe<Refrigerant>;
  /** The `RefrigerationSystem` that was created by this mutation. */
  refrigerationSystem?: Maybe<RefrigerationSystem>;
  /** An edge for our `RefrigerationSystem`. May be used by Relay 1. */
  refrigerationSystemEdge?: Maybe<RefrigerationSystemsEdge>;
};

/** The output of our create `RefrigerationSystem` mutation. */
export type CreateRefrigerationSystemPayloadRefrigerationSystemEdgeArgs = {
  orderBy?: InputMaybe<Array<RefrigerationSystemsOrderBy>>;
};

/** All input for the create `ReportExecution` mutation. */
export type CreateReportExecutionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `ReportExecution` to be created by this mutation. */
  reportExecution: ReportExecutionInput;
};

/** The output of our create `ReportExecution` mutation. */
export type CreateReportExecutionPayload = {
  __typename?: 'CreateReportExecutionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Report` that is related to this `ReportExecution`. */
  report?: Maybe<Report>;
  /** Reads a single `ReportAutomation` that is related to this `ReportExecution`. */
  reportAutomation?: Maybe<ReportAutomation>;
  /** The `ReportExecution` that was created by this mutation. */
  reportExecution?: Maybe<ReportExecution>;
  /** An edge for our `ReportExecution`. May be used by Relay 1. */
  reportExecutionEdge?: Maybe<ReportExecutionsEdge>;
};

/** The output of our create `ReportExecution` mutation. */
export type CreateReportExecutionPayloadReportExecutionEdgeArgs = {
  orderBy?: InputMaybe<Array<ReportExecutionsOrderBy>>;
};

/** All input for the create `SavingsEventDatum` mutation. */
export type CreateSavingsEventDatumInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `SavingsEventDatum` to be created by this mutation. */
  savingsEventDatum: SavingsEventDatumInput;
};

/** The output of our create `SavingsEventDatum` mutation. */
export type CreateSavingsEventDatumPayload = {
  __typename?: 'CreateSavingsEventDatumPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SavingsEvent` that is related to this `SavingsEventDatum`. */
  savingsEvent?: Maybe<SavingsEvent>;
  /** The `SavingsEventDatum` that was created by this mutation. */
  savingsEventDatum?: Maybe<SavingsEventDatum>;
  /** An edge for our `SavingsEventDatum`. May be used by Relay 1. */
  savingsEventDatumEdge?: Maybe<SavingsEventDataEdge>;
};

/** The output of our create `SavingsEventDatum` mutation. */
export type CreateSavingsEventDatumPayloadSavingsEventDatumEdgeArgs = {
  orderBy?: InputMaybe<Array<SavingsEventDataOrderBy>>;
};

/** All input for the create `SavingsEvent` mutation. */
export type CreateSavingsEventInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `SavingsEvent` to be created by this mutation. */
  savingsEvent: SavingsEventInput;
};

/** The output of our create `SavingsEvent` mutation. */
export type CreateSavingsEventPayload = {
  __typename?: 'CreateSavingsEventPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Project` that is related to this `SavingsEvent`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SavingsEvent` that was created by this mutation. */
  savingsEvent?: Maybe<SavingsEvent>;
  /** An edge for our `SavingsEvent`. May be used by Relay 1. */
  savingsEventEdge?: Maybe<SavingsEventsEdge>;
};

/** The output of our create `SavingsEvent` mutation. */
export type CreateSavingsEventPayloadSavingsEventEdgeArgs = {
  orderBy?: InputMaybe<Array<SavingsEventsOrderBy>>;
};

/** All input for the create `SpaceActivity` mutation. */
export type CreateSpaceActivityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `SpaceActivity` to be created by this mutation. */
  spaceActivity: SpaceActivityInput;
};

/** The output of our create `SpaceActivity` mutation. */
export type CreateSpaceActivityPayload = {
  __typename?: 'CreateSpaceActivityPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Space` that is related to this `SpaceActivity`. */
  space?: Maybe<Space>;
  /** The `SpaceActivity` that was created by this mutation. */
  spaceActivity?: Maybe<SpaceActivity>;
  /** An edge for our `SpaceActivity`. May be used by Relay 1. */
  spaceActivityEdge?: Maybe<SpaceActivitiesEdge>;
};

/** The output of our create `SpaceActivity` mutation. */
export type CreateSpaceActivityPayloadSpaceActivityEdgeArgs = {
  orderBy?: InputMaybe<Array<SpaceActivitiesOrderBy>>;
};

/** All input for the create `Submeter` mutation. */
export type CreateSubmeterInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Submeter` to be created by this mutation. */
  submeter: SubmeterInput;
};

/** The output of our create `Submeter` mutation. */
export type CreateSubmeterPayload = {
  __typename?: 'CreateSubmeterPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DataPoint` that is related to this `Submeter`. */
  demand?: Maybe<DataPoint>;
  /** Reads a single `Facility` that is related to this `Submeter`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Submeter` that was created by this mutation. */
  submeter?: Maybe<Submeter>;
  /** An edge for our `Submeter`. May be used by Relay 1. */
  submeterEdge?: Maybe<SubmetersEdge>;
  /** Reads a single `DataPoint` that is related to this `Submeter`. */
  usage?: Maybe<DataPoint>;
  /** Reads a single `UtilityMeter` that is related to this `Submeter`. */
  utilityMeter?: Maybe<UtilityMeter>;
};

/** The output of our create `Submeter` mutation. */
export type CreateSubmeterPayloadSubmeterEdgeArgs = {
  orderBy?: InputMaybe<Array<SubmetersOrderBy>>;
};

/** All input for the create `SubmeterSession` mutation. */
export type CreateSubmeterSessionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `SubmeterSession` to be created by this mutation. */
  submeterSession: SubmeterSessionInput;
};

/** The output of our create `SubmeterSession` mutation. */
export type CreateSubmeterSessionPayload = {
  __typename?: 'CreateSubmeterSessionPayload';
  /** Reads a single `BillableCustomer` that is related to this `SubmeterSession`. */
  associatedCustomer?: Maybe<BillableCustomer>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Submeter` that is related to this `SubmeterSession`. */
  submeter?: Maybe<Submeter>;
  /** The `SubmeterSession` that was created by this mutation. */
  submeterSession?: Maybe<SubmeterSession>;
  /** An edge for our `SubmeterSession`. May be used by Relay 1. */
  submeterSessionEdge?: Maybe<SubmeterSessionsEdge>;
};

/** The output of our create `SubmeterSession` mutation. */
export type CreateSubmeterSessionPayloadSubmeterSessionEdgeArgs = {
  orderBy?: InputMaybe<Array<SubmeterSessionsOrderBy>>;
};

/** All input for the create `SuctionGroupCompressor` mutation. */
export type CreateSuctionGroupCompressorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `SuctionGroupCompressor` to be created by this mutation. */
  suctionGroupCompressor: SuctionGroupCompressorInput;
};

/** The output of our create `SuctionGroupCompressor` mutation. */
export type CreateSuctionGroupCompressorPayload = {
  __typename?: 'CreateSuctionGroupCompressorPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Compressor` that is related to this `SuctionGroupCompressor`. */
  compressor?: Maybe<Compressor>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SuctionGroup` that is related to this `SuctionGroupCompressor`. */
  suctionGroup?: Maybe<SuctionGroup>;
  /** The `SuctionGroupCompressor` that was created by this mutation. */
  suctionGroupCompressor?: Maybe<SuctionGroupCompressor>;
  /** An edge for our `SuctionGroupCompressor`. May be used by Relay 1. */
  suctionGroupCompressorEdge?: Maybe<SuctionGroupCompressorsEdge>;
};

/** The output of our create `SuctionGroupCompressor` mutation. */
export type CreateSuctionGroupCompressorPayloadSuctionGroupCompressorEdgeArgs =
  {
    orderBy?: InputMaybe<Array<SuctionGroupCompressorsOrderBy>>;
  };

/** All input for the create `SuctionGroup` mutation. */
export type CreateSuctionGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `SuctionGroup` to be created by this mutation. */
  suctionGroup: SuctionGroupInput;
};

/** The output of our create `SuctionGroup` mutation. */
export type CreateSuctionGroupPayload = {
  __typename?: 'CreateSuctionGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RefrigerationSystem` that is related to this `SuctionGroup`. */
  refrigerationSystem?: Maybe<RefrigerationSystem>;
  /** The `SuctionGroup` that was created by this mutation. */
  suctionGroup?: Maybe<SuctionGroup>;
  /** An edge for our `SuctionGroup`. May be used by Relay 1. */
  suctionGroupEdge?: Maybe<SuctionGroupsEdge>;
  /** Reads a single `DataPoint` that is related to this `SuctionGroup`. */
  suctionPressure?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `SuctionGroup`. */
  suctionPressureSetpoint?: Maybe<DataPoint>;
};

/** The output of our create `SuctionGroup` mutation. */
export type CreateSuctionGroupPayloadSuctionGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<SuctionGroupsOrderBy>>;
};

/** All input for the create `SuctionHeader` mutation. */
export type CreateSuctionHeaderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `SuctionHeader` to be created by this mutation. */
  suctionHeader: SuctionHeaderInput;
};

/** The output of our create `SuctionHeader` mutation. */
export type CreateSuctionHeaderPayload = {
  __typename?: 'CreateSuctionHeaderPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RefrigerationSystem` that is related to this `SuctionHeader`. */
  refrigerationSystem?: Maybe<RefrigerationSystem>;
  /** Reads a single `SuctionGroup` that is related to this `SuctionHeader`. */
  suctionGroup?: Maybe<SuctionGroup>;
  /** The `SuctionHeader` that was created by this mutation. */
  suctionHeader?: Maybe<SuctionHeader>;
  /** An edge for our `SuctionHeader`. May be used by Relay 1. */
  suctionHeaderEdge?: Maybe<SuctionHeadersEdge>;
};

/** The output of our create `SuctionHeader` mutation. */
export type CreateSuctionHeaderPayloadSuctionHeaderEdgeArgs = {
  orderBy?: InputMaybe<Array<SuctionHeadersOrderBy>>;
};

/** All input for the create `SuctionHeadersCompressor` mutation. */
export type CreateSuctionHeadersCompressorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `SuctionHeadersCompressor` to be created by this mutation. */
  suctionHeadersCompressor: SuctionHeadersCompressorInput;
};

/** The output of our create `SuctionHeadersCompressor` mutation. */
export type CreateSuctionHeadersCompressorPayload = {
  __typename?: 'CreateSuctionHeadersCompressorPayload';
  /** Reads a single `DataPoint` that is related to this `SuctionHeadersCompressor`. */
  active?: Maybe<DataPoint>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Compressor` that is related to this `SuctionHeadersCompressor`. */
  compressor?: Maybe<Compressor>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SuctionHeader` that is related to this `SuctionHeadersCompressor`. */
  suctionHeader?: Maybe<SuctionHeader>;
  /** The `SuctionHeadersCompressor` that was created by this mutation. */
  suctionHeadersCompressor?: Maybe<SuctionHeadersCompressor>;
  /** An edge for our `SuctionHeadersCompressor`. May be used by Relay 1. */
  suctionHeadersCompressorEdge?: Maybe<SuctionHeadersCompressorsEdge>;
};

/** The output of our create `SuctionHeadersCompressor` mutation. */
export type CreateSuctionHeadersCompressorPayloadSuctionHeadersCompressorEdgeArgs =
  {
    orderBy?: InputMaybe<Array<SuctionHeadersCompressorsOrderBy>>;
  };

/** All input for the create `SuggestionActivityLog` mutation. */
export type CreateSuggestionActivityLogInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `SuggestionActivityLog` to be created by this mutation. */
  suggestionActivityLog: SuggestionActivityLogInput;
};

/** The output of our create `SuggestionActivityLog` mutation. */
export type CreateSuggestionActivityLogPayload = {
  __typename?: 'CreateSuggestionActivityLogPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Suggestion` that is related to this `SuggestionActivityLog`. */
  suggestion?: Maybe<Suggestion>;
  /** The `SuggestionActivityLog` that was created by this mutation. */
  suggestionActivityLog?: Maybe<SuggestionActivityLog>;
  /** An edge for our `SuggestionActivityLog`. May be used by Relay 1. */
  suggestionActivityLogEdge?: Maybe<SuggestionActivityLogsEdge>;
};

/** The output of our create `SuggestionActivityLog` mutation. */
export type CreateSuggestionActivityLogPayloadSuggestionActivityLogEdgeArgs = {
  orderBy?: InputMaybe<Array<SuggestionActivityLogsOrderBy>>;
};

/** All input for the create `SuggestionControlEvent` mutation. */
export type CreateSuggestionControlEventInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `SuggestionControlEvent` to be created by this mutation. */
  suggestionControlEvent: SuggestionControlEventInput;
};

/** The output of our create `SuggestionControlEvent` mutation. */
export type CreateSuggestionControlEventPayload = {
  __typename?: 'CreateSuggestionControlEventPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `ControlEvent` that is related to this `SuggestionControlEvent`. */
  controlEvent?: Maybe<ControlEvent>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Suggestion` that is related to this `SuggestionControlEvent`. */
  suggestion?: Maybe<Suggestion>;
  /** The `SuggestionControlEvent` that was created by this mutation. */
  suggestionControlEvent?: Maybe<SuggestionControlEvent>;
};

/** All input for the create `Suggestion` mutation. */
export type CreateSuggestionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Suggestion` to be created by this mutation. */
  suggestion: SuggestionInput;
};

/** The output of our create `Suggestion` mutation. */
export type CreateSuggestionPayload = {
  __typename?: 'CreateSuggestionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Project` that is related to this `Suggestion`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Suggestion` that was created by this mutation. */
  suggestion?: Maybe<Suggestion>;
  /** An edge for our `Suggestion`. May be used by Relay 1. */
  suggestionEdge?: Maybe<SuggestionsEdge>;
};

/** The output of our create `Suggestion` mutation. */
export type CreateSuggestionPayloadSuggestionEdgeArgs = {
  orderBy?: InputMaybe<Array<SuggestionsOrderBy>>;
};

/** All input for the create `TemperatureSensor` mutation. */
export type CreateTemperatureSensorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `TemperatureSensor` to be created by this mutation. */
  temperatureSensor: TemperatureSensorInput;
};

/** The output of our create `TemperatureSensor` mutation. */
export type CreateTemperatureSensorPayload = {
  __typename?: 'CreateTemperatureSensorPayload';
  /** Reads a single `DataPoint` that is related to this `TemperatureSensor`. */
  battery?: Maybe<DataPoint>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Facility` that is related to this `TemperatureSensor`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DataPoint` that is related to this `TemperatureSensor`. */
  signal?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `TemperatureSensor`. */
  temperature?: Maybe<DataPoint>;
  /** The `TemperatureSensor` that was created by this mutation. */
  temperatureSensor?: Maybe<TemperatureSensor>;
  /** An edge for our `TemperatureSensor`. May be used by Relay 1. */
  temperatureSensorEdge?: Maybe<TemperatureSensorsEdge>;
};

/** The output of our create `TemperatureSensor` mutation. */
export type CreateTemperatureSensorPayloadTemperatureSensorEdgeArgs = {
  orderBy?: InputMaybe<Array<TemperatureSensorsOrderBy>>;
};

/** All input for the create `TrailerAudit` mutation. */
export type CreateTrailerAuditInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `TrailerAudit` to be created by this mutation. */
  trailerAudit: TrailerAuditInput;
};

/** The output of our create `TrailerAudit` mutation. */
export type CreateTrailerAuditPayload = {
  __typename?: 'CreateTrailerAuditPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Trailer` that is related to this `TrailerAudit`. */
  trailer?: Maybe<Trailer>;
  /** The `TrailerAudit` that was created by this mutation. */
  trailerAudit?: Maybe<TrailerAudit>;
  /** An edge for our `TrailerAudit`. May be used by Relay 1. */
  trailerAuditEdge?: Maybe<TrailerAuditsEdge>;
  /** Reads a single `User` that is related to this `TrailerAudit`. */
  userByAuditUser?: Maybe<User>;
  /** Reads a single `Yard` that is related to this `TrailerAudit`. */
  yard?: Maybe<Yard>;
};

/** The output of our create `TrailerAudit` mutation. */
export type CreateTrailerAuditPayloadTrailerAuditEdgeArgs = {
  orderBy?: InputMaybe<Array<TrailerAuditsOrderBy>>;
};

/** All input for the create `Trailer` mutation. */
export type CreateTrailerInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Trailer` to be created by this mutation. */
  trailer: TrailerInput;
};

/** The output of our create `Trailer` mutation. */
export type CreateTrailerPayload = {
  __typename?: 'CreateTrailerPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Trailer` that was created by this mutation. */
  trailer?: Maybe<Trailer>;
  /** An edge for our `Trailer`. May be used by Relay 1. */
  trailerEdge?: Maybe<TrailersEdge>;
};

/** The output of our create `Trailer` mutation. */
export type CreateTrailerPayloadTrailerEdgeArgs = {
  orderBy?: InputMaybe<Array<TrailersOrderBy>>;
};

/** All input for the create `TrailerPosition` mutation. */
export type CreateTrailerPositionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `TrailerPosition` to be created by this mutation. */
  trailerPosition: TrailerPositionInput;
};

/** The output of our create `TrailerPosition` mutation. */
export type CreateTrailerPositionPayload = {
  __typename?: 'CreateTrailerPositionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Facility` that is related to this `TrailerPosition`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DataPoint` that is related to this `TrailerPosition`. */
  trailerIsPresent?: Maybe<DataPoint>;
  /** The `TrailerPosition` that was created by this mutation. */
  trailerPosition?: Maybe<TrailerPosition>;
  /** An edge for our `TrailerPosition`. May be used by Relay 1. */
  trailerPositionEdge?: Maybe<TrailerPositionsEdge>;
};

/** The output of our create `TrailerPosition` mutation. */
export type CreateTrailerPositionPayloadTrailerPositionEdgeArgs = {
  orderBy?: InputMaybe<Array<TrailerPositionsOrderBy>>;
};

export type CreateUserAccessTokenInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  expiresAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export type CreateUserAccessTokenPayload = CreateAccessTokenPayload & {
  __typename?: 'CreateUserAccessTokenPayload';
  accessKey: Scalars['String']['output'];
  clientMutationId?: Maybe<Scalars['String']['output']>;
  token: PlatformAccessToken;
  user: User;
};

/** All input for the create `UtilityAccount` mutation. */
export type CreateUtilityAccountInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `UtilityAccount` to be created by this mutation. */
  utilityAccount: UtilityAccountInput;
};

/** The output of our create `UtilityAccount` mutation. */
export type CreateUtilityAccountPayload = {
  __typename?: 'CreateUtilityAccountPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UtilityAccount` that was created by this mutation. */
  utilityAccount?: Maybe<UtilityAccount>;
  /** An edge for our `UtilityAccount`. May be used by Relay 1. */
  utilityAccountEdge?: Maybe<UtilityAccountsEdge>;
  /** Reads a single `UtilityCredential` that is related to this `UtilityAccount`. */
  utilityCredential?: Maybe<UtilityCredential>;
  /** Reads a single `UtilityProvider` that is related to this `UtilityAccount`. */
  utilityProvider?: Maybe<UtilityProvider>;
};

/** The output of our create `UtilityAccount` mutation. */
export type CreateUtilityAccountPayloadUtilityAccountEdgeArgs = {
  orderBy?: InputMaybe<Array<UtilityAccountsOrderBy>>;
};

/** All input for the create `UtilityCredentialFacility` mutation. */
export type CreateUtilityCredentialFacilityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `UtilityCredentialFacility` to be created by this mutation. */
  utilityCredentialFacility: UtilityCredentialFacilityInput;
};

/** The output of our create `UtilityCredentialFacility` mutation. */
export type CreateUtilityCredentialFacilityPayload = {
  __typename?: 'CreateUtilityCredentialFacilityPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Facility` that is related to this `UtilityCredentialFacility`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `UtilityCredential` that is related to this `UtilityCredentialFacility`. */
  utilityCredential?: Maybe<UtilityCredential>;
  /** The `UtilityCredentialFacility` that was created by this mutation. */
  utilityCredentialFacility?: Maybe<UtilityCredentialFacility>;
  /** An edge for our `UtilityCredentialFacility`. May be used by Relay 1. */
  utilityCredentialFacilityEdge?: Maybe<UtilityCredentialFacilitiesEdge>;
};

/** The output of our create `UtilityCredentialFacility` mutation. */
export type CreateUtilityCredentialFacilityPayloadUtilityCredentialFacilityEdgeArgs =
  {
    orderBy?: InputMaybe<Array<UtilityCredentialFacilitiesOrderBy>>;
  };

/** All input for the create `UtilityCredential` mutation. */
export type CreateUtilityCredentialInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `UtilityCredential` to be created by this mutation. */
  utilityCredential: UtilityCredentialInput;
};

/** The output of our create `UtilityCredential` mutation. */
export type CreateUtilityCredentialPayload = {
  __typename?: 'CreateUtilityCredentialPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UtilityCredential` that was created by this mutation. */
  utilityCredential?: Maybe<UtilityCredential>;
  /** An edge for our `UtilityCredential`. May be used by Relay 1. */
  utilityCredentialEdge?: Maybe<UtilityCredentialsEdge>;
  /** Reads a single `UtilityProvider` that is related to this `UtilityCredential`. */
  utilityProvider?: Maybe<UtilityProvider>;
};

/** The output of our create `UtilityCredential` mutation. */
export type CreateUtilityCredentialPayloadUtilityCredentialEdgeArgs = {
  orderBy?: InputMaybe<Array<UtilityCredentialsOrderBy>>;
};

/** All input for the create `UtilityFileUpload` mutation. */
export type CreateUtilityFileUploadInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `UtilityFileUpload` to be created by this mutation. */
  utilityFileUpload: UtilityFileUploadInput;
};

/** The output of our create `UtilityFileUpload` mutation. */
export type CreateUtilityFileUploadPayload = {
  __typename?: 'CreateUtilityFileUploadPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UtilityFileUpload` that was created by this mutation. */
  utilityFileUpload?: Maybe<UtilityFileUpload>;
  /** An edge for our `UtilityFileUpload`. May be used by Relay 1. */
  utilityFileUploadEdge?: Maybe<UtilityFileUploadsEdge>;
};

/** The output of our create `UtilityFileUpload` mutation. */
export type CreateUtilityFileUploadPayloadUtilityFileUploadEdgeArgs = {
  orderBy?: InputMaybe<Array<UtilityFileUploadsOrderBy>>;
};

/** All input for the create `UtilityMeter` mutation. */
export type CreateUtilityMeterInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `UtilityMeter` to be created by this mutation. */
  utilityMeter: UtilityMeterInput;
};

/** The output of our create `UtilityMeter` mutation. */
export type CreateUtilityMeterPayload = {
  __typename?: 'CreateUtilityMeterPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Facility` that is related to this `UtilityMeter`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `UtilityAccount` that is related to this `UtilityMeter`. */
  utilityAccount?: Maybe<UtilityAccount>;
  /** The `UtilityMeter` that was created by this mutation. */
  utilityMeter?: Maybe<UtilityMeter>;
  /** An edge for our `UtilityMeter`. May be used by Relay 1. */
  utilityMeterEdge?: Maybe<UtilityMetersEdge>;
};

/** The output of our create `UtilityMeter` mutation. */
export type CreateUtilityMeterPayloadUtilityMeterEdgeArgs = {
  orderBy?: InputMaybe<Array<UtilityMetersOrderBy>>;
};

/** All input for the create `UtilityPendingMeter` mutation. */
export type CreateUtilityPendingMeterInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `UtilityPendingMeter` to be created by this mutation. */
  utilityPendingMeter: UtilityPendingMeterInput;
};

/** The output of our create `UtilityPendingMeter` mutation. */
export type CreateUtilityPendingMeterPayload = {
  __typename?: 'CreateUtilityPendingMeterPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Facility` that is related to this `UtilityPendingMeter`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `UtilityCredential` that is related to this `UtilityPendingMeter`. */
  utilityCredential?: Maybe<UtilityCredential>;
  /** The `UtilityPendingMeter` that was created by this mutation. */
  utilityPendingMeter?: Maybe<UtilityPendingMeter>;
  /** An edge for our `UtilityPendingMeter`. May be used by Relay 1. */
  utilityPendingMeterEdge?: Maybe<UtilityPendingMetersEdge>;
};

/** The output of our create `UtilityPendingMeter` mutation. */
export type CreateUtilityPendingMeterPayloadUtilityPendingMeterEdgeArgs = {
  orderBy?: InputMaybe<Array<UtilityPendingMetersOrderBy>>;
};

/** All input for the create `UtilityProvider` mutation. */
export type CreateUtilityProviderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `UtilityProvider` to be created by this mutation. */
  utilityProvider: UtilityProviderInput;
};

/** The output of our create `UtilityProvider` mutation. */
export type CreateUtilityProviderPayload = {
  __typename?: 'CreateUtilityProviderPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UtilityProvider` that was created by this mutation. */
  utilityProvider?: Maybe<UtilityProvider>;
  /** An edge for our `UtilityProvider`. May be used by Relay 1. */
  utilityProviderEdge?: Maybe<UtilityProvidersEdge>;
};

/** The output of our create `UtilityProvider` mutation. */
export type CreateUtilityProviderPayloadUtilityProviderEdgeArgs = {
  orderBy?: InputMaybe<Array<UtilityProvidersOrderBy>>;
};

/** All input for the create `VendorUser` mutation. */
export type CreateVendorUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `VendorUser` to be created by this mutation. */
  vendorUser: VendorUserInput;
};

/** All input for the create `VendorUserMachineUser` mutation. */
export type CreateVendorUserMachineUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `VendorUserMachineUser` to be created by this mutation. */
  vendorUserMachineUser: VendorUserMachineUserInput;
};

/** The output of our create `VendorUserMachineUser` mutation. */
export type CreateVendorUserMachineUserPayload = {
  __typename?: 'CreateVendorUserMachineUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `VendorUserMachineUser` that was created by this mutation. */
  vendorUserMachineUser?: Maybe<VendorUserMachineUser>;
};

/** The output of our create `VendorUser` mutation. */
export type CreateVendorUserPayload = {
  __typename?: 'CreateVendorUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `VendorUser` that was created by this mutation. */
  vendorUser?: Maybe<VendorUser>;
  /** An edge for our `VendorUser`. May be used by Relay 1. */
  vendorUserEdge?: Maybe<VendorUsersEdge>;
};

/** The output of our create `VendorUser` mutation. */
export type CreateVendorUserPayloadVendorUserEdgeArgs = {
  orderBy?: InputMaybe<Array<VendorUsersOrderBy>>;
};

/** All input for the create `Vessel` mutation. */
export type CreateVesselInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Vessel` to be created by this mutation. */
  vessel: VesselInput;
};

/** The output of our create `Vessel` mutation. */
export type CreateVesselPayload = {
  __typename?: 'CreateVesselPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DataPoint` that is related to this `Vessel`. */
  level?: Maybe<DataPoint>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RefrigerationSystem` that is related to this `Vessel`. */
  refrigerationSystem?: Maybe<RefrigerationSystem>;
  /** Reads a single `SuctionGroup` that is related to this `Vessel`. */
  suctionGroup?: Maybe<SuctionGroup>;
  /** The `Vessel` that was created by this mutation. */
  vessel?: Maybe<Vessel>;
  /** An edge for our `Vessel`. May be used by Relay 1. */
  vesselEdge?: Maybe<VesselsEdge>;
};

/** The output of our create `Vessel` mutation. */
export type CreateVesselPayloadVesselEdgeArgs = {
  orderBy?: InputMaybe<Array<VesselsOrderBy>>;
};

/** All input for the create `VirtualPointInterval` mutation. */
export type CreateVirtualPointIntervalInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `VirtualPointInterval` to be created by this mutation. */
  virtualPointInterval: VirtualPointIntervalInput;
};

/** The output of our create `VirtualPointInterval` mutation. */
export type CreateVirtualPointIntervalPayload = {
  __typename?: 'CreateVirtualPointIntervalPayload';
  /** Reads a single `DataPoint` that is related to this `VirtualPointInterval`. */
  child?: Maybe<DataPoint>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DataPoint` that is related to this `VirtualPointInterval`. */
  parent?: Maybe<DataPoint>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `VirtualPointInterval` that was created by this mutation. */
  virtualPointInterval?: Maybe<VirtualPointInterval>;
  /** An edge for our `VirtualPointInterval`. May be used by Relay 1. */
  virtualPointIntervalEdge?: Maybe<VirtualPointIntervalsEdge>;
};

/** The output of our create `VirtualPointInterval` mutation. */
export type CreateVirtualPointIntervalPayloadVirtualPointIntervalEdgeArgs = {
  orderBy?: InputMaybe<Array<VirtualPointIntervalsOrderBy>>;
};

export type Customer = Node & {
  __typename?: 'Customer';
  /** The time at which the record was created */
  createdAt: Scalars['Datetime']['output'];
  /** The unique local (facility-level) identifier of the customer */
  customerCode?: Maybe<Scalars['String']['output']>;
  /** The globally unique external deletion identifier of the record. Sometimes this is different from sourceId due to change tracking semantics */
  deleteId?: Maybe<Scalars['String']['output']>;
  /** The time at which the record was deleted */
  deletedAt?: Maybe<Scalars['Datetime']['output']>;
  /** Reads a single `Facility` that is related to this `Customer`. */
  facility?: Maybe<Facility>;
  /** The originating facility of the customer record */
  facilityId?: Maybe<Scalars['Int']['output']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['BigInt']['output'];
  /** The name of the customer */
  name?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `Product`. */
  products: ProductsConnection;
  /** A readable, short name of the customer */
  shortName?: Maybe<Scalars['String']['output']>;
  /** The globally unique external identifier of the record from the original source system */
  sourceId: Scalars['String']['output'];
  /** The time at which the record was updated */
  updatedAt: Scalars['Datetime']['output'];
  /** The version of the record */
  version?: Maybe<Scalars['BigInt']['output']>;
};

export type CustomerProductsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<ProductFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** A customer billing rate */
export type CustomerBillingRate = Node & {
  __typename?: 'CustomerBillingRate';
  /** The time when this record was created */
  createdAt: Scalars['Datetime']['output'];
  /** Reads a single `BillableCustomer` that is related to this `CustomerBillingRate`. */
  customer?: Maybe<BillableCustomer>;
  /** The customer this rate belongs to */
  customerId: Scalars['Int']['output'];
  /** The date when this rate becomes effective */
  effectiveStart: Scalars['Datetime']['output'];
  /** The internal ID of this customer rate */
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The value of this rate */
  rate: Scalars['BigFloat']['output'];
  /** The time when this record was updated */
  updatedAt: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `CustomerBillingRate` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type CustomerBillingRateCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `customerId` field. */
  customerId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `effectiveStart` field. */
  effectiveStart?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rate` field. */
  rate?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `CustomerBillingRate` object types. All fields are combined with a logical ‘and.’ */
export type CustomerBillingRateFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CustomerBillingRateFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `customerId` field. */
  customerId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `effectiveStart` field. */
  effectiveStart?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CustomerBillingRateFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CustomerBillingRateFilter>>;
  /** Filter by the object’s `rate` field. */
  rate?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `CustomerBillingRate` */
export type CustomerBillingRateInput = {
  /** Mutates a `BillableCustomer` as part of the payload */
  billableCustomer?: InputMaybe<BillableCustomerInput>;
  /** The customer this rate belongs to */
  customerId?: InputMaybe<Scalars['Int']['input']>;
  /** The date when this rate becomes effective */
  effectiveStart: Scalars['Datetime']['input'];
  /** The value of this rate */
  rate: Scalars['BigFloat']['input'];
};

/** Represents an update to a `CustomerBillingRate`. Fields that are set will be updated. */
export type CustomerBillingRatePatch = {
  /** The customer this rate belongs to */
  customerId?: InputMaybe<Scalars['Int']['input']>;
  /** The date when this rate becomes effective */
  effectiveStart?: InputMaybe<Scalars['Datetime']['input']>;
  /** The value of this rate */
  rate?: InputMaybe<Scalars['BigFloat']['input']>;
};

/** A connection to a list of `CustomerBillingRate` values. */
export type CustomerBillingRatesConnection = {
  __typename?: 'CustomerBillingRatesConnection';
  /** A list of edges which contains the `CustomerBillingRate` and cursor to aid in pagination. */
  edges: Array<CustomerBillingRatesEdge>;
  /** A list of `CustomerBillingRate` objects. */
  nodes: Array<CustomerBillingRate>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CustomerBillingRate` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CustomerBillingRate` edge in the connection. */
export type CustomerBillingRatesEdge = {
  __typename?: 'CustomerBillingRatesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CustomerBillingRate` at the end of the edge. */
  node: CustomerBillingRate;
};

/** Methods to use when ordering `CustomerBillingRate`. */
export enum CustomerBillingRatesOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  CUSTOMER_ID_ASC = 'CUSTOMER_ID_ASC',
  CUSTOMER_ID_DESC = 'CUSTOMER_ID_DESC',
  EFFECTIVE_START_ASC = 'EFFECTIVE_START_ASC',
  EFFECTIVE_START_DESC = 'EFFECTIVE_START_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  RATE_ASC = 'RATE_ASC',
  RATE_DESC = 'RATE_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/**
 * A condition to be used against `Customer` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type CustomerCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `customerCode` field. */
  customerCode?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `deleteId` field. */
  deleteId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `shortName` field. */
  shortName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `sourceId` field. */
  sourceId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `version` field. */
  version?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A filter to be used against `Customer` object types. All fields are combined with a logical ‘and.’ */
export type CustomerFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CustomerFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `customerCode` field. */
  customerCode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `deleteId` field. */
  deleteId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CustomerFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CustomerFilter>>;
  /** Filter by the object’s `shortName` field. */
  shortName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `sourceId` field. */
  sourceId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `version` field. */
  version?: InputMaybe<BigIntFilter>;
};

/** An input for mutations affecting `Customer` */
export type CustomerInput = {
  /** The unique local (facility-level) identifier of the customer */
  customerCode?: InputMaybe<Scalars['String']['input']>;
  /** The originating facility of the customer record */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** The name of the customer */
  name?: InputMaybe<Scalars['String']['input']>;
  /** A readable, short name of the customer */
  shortName?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique external identifier of the record from the original source system */
  sourceId: Scalars['String']['input'];
};

/** A integration provider profile for the current tenant. */
export type CustomerIntegration = Node & {
  __typename?: 'CustomerIntegration';
  /** The specific configuration for this integration. Its schema should adhere to the config_schema spec in the related integration provider. */
  config: Scalars['JSON']['output'];
  /** The time the record was created. */
  createdAt: Scalars['Datetime']['output'];
  /** The actor who created this integration. */
  createdBy?: Maybe<Actor>;
  /** Reads a single `CustomerIntegrationCredential` that is related to this `CustomerIntegration`. */
  credentials?: Maybe<CustomerIntegrationCredential>;
  /** Any error message captured during the last synchronization with the integration provider. */
  error?: Maybe<Scalars['JSON']['output']>;
  /** The internal identifier of the customer integration. */
  id: Scalars['Int']['output'];
  /** Reads a single `IntegrationProvider` that is related to this `CustomerIntegration`. */
  integrationProvider?: Maybe<IntegrationProvider>;
  /** The provider for this customer integration. */
  integrationProviderId: Scalars['Int']['output'];
  /** The time when this was last synchronized with the integration provider. */
  lastSyncAt?: Maybe<Scalars['Datetime']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The current status of this integration. */
  status: CustomerIntegrationStatus;
  /** The time the record was updated. */
  updatedAt: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `CustomerIntegration` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type CustomerIntegrationCondition = {
  /** Checks for equality with the object’s `config` field. */
  config?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdBy` field. */
  createdBy?: InputMaybe<ActorInput>;
  /** Checks for equality with the object’s `error` field. */
  error?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `integrationProviderId` field. */
  integrationProviderId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `lastSyncAt` field. */
  lastSyncAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<CustomerIntegrationStatus>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A credential for a customer integration. */
export type CustomerIntegrationCredential = Node & {
  __typename?: 'CustomerIntegrationCredential';
  /** The time the record was created. */
  createdAt: Scalars['Datetime']['output'];
  /** The actor who created this credential. */
  createdBy?: Maybe<Actor>;
  /** Reads a single `CustomerIntegration` that is related to this `CustomerIntegrationCredential`. */
  customerIntegration?: Maybe<CustomerIntegration>;
  /** The customer integration that owns this credential. */
  customerIntegrationId: Scalars['Int']['output'];
  /** The time when this credential will expire and likely need to be refreshed. */
  expiresAt?: Maybe<Scalars['Datetime']['output']>;
  /** The internal identifier of the credential. */
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The time the record was updated. */
  updatedAt: Scalars['Datetime']['output'];
  value?: Maybe<Scalars['JSON']['output']>;
};

/**
 * A condition to be used against `CustomerIntegrationCredential` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type CustomerIntegrationCredentialCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdBy` field. */
  createdBy?: InputMaybe<ActorInput>;
  /** Checks for equality with the object’s `customerIntegrationId` field. */
  customerIntegrationId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `expiresAt` field. */
  expiresAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `CustomerIntegrationCredential` object types. All fields are combined with a logical ‘and.’ */
export type CustomerIntegrationCredentialFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CustomerIntegrationCredentialFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdBy` field. */
  createdBy?: InputMaybe<ActorFilter>;
  /** Filter by the object’s `customerIntegrationId` field. */
  customerIntegrationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `expiresAt` field. */
  expiresAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CustomerIntegrationCredentialFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CustomerIntegrationCredentialFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** A connection to a list of `CustomerIntegrationCredential` values. */
export type CustomerIntegrationCredentialsConnection = {
  __typename?: 'CustomerIntegrationCredentialsConnection';
  /** A list of edges which contains the `CustomerIntegrationCredential` and cursor to aid in pagination. */
  edges: Array<CustomerIntegrationCredentialsEdge>;
  /** A list of `CustomerIntegrationCredential` objects. */
  nodes: Array<CustomerIntegrationCredential>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CustomerIntegrationCredential` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CustomerIntegrationCredential` edge in the connection. */
export type CustomerIntegrationCredentialsEdge = {
  __typename?: 'CustomerIntegrationCredentialsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CustomerIntegrationCredential` at the end of the edge. */
  node: CustomerIntegrationCredential;
};

/** Methods to use when ordering `CustomerIntegrationCredential`. */
export enum CustomerIntegrationCredentialsOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  CREATED_BY_ASC = 'CREATED_BY_ASC',
  CREATED_BY_DESC = 'CREATED_BY_DESC',
  CUSTOMER_INTEGRATION_ID_ASC = 'CUSTOMER_INTEGRATION_ID_ASC',
  CUSTOMER_INTEGRATION_ID_DESC = 'CUSTOMER_INTEGRATION_ID_DESC',
  EXPIRES_AT_ASC = 'EXPIRES_AT_ASC',
  EXPIRES_AT_DESC = 'EXPIRES_AT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** A filter to be used against `CustomerIntegration` object types. All fields are combined with a logical ‘and.’ */
export type CustomerIntegrationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CustomerIntegrationFilter>>;
  /** Filter by the object’s `config` field. */
  config?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdBy` field. */
  createdBy?: InputMaybe<ActorFilter>;
  /** Filter by the object’s `error` field. */
  error?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `integrationProviderId` field. */
  integrationProviderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `lastSyncAt` field. */
  lastSyncAt?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CustomerIntegrationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CustomerIntegrationFilter>>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<CustomerIntegrationStatusFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

export enum CustomerIntegrationStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  PENDING = 'PENDING'
}

/** A filter to be used against CustomerIntegrationStatus fields. All fields are combined with a logical ‘and.’ */
export type CustomerIntegrationStatusFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<CustomerIntegrationStatus>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<CustomerIntegrationStatus>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<CustomerIntegrationStatus>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<CustomerIntegrationStatus>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<CustomerIntegrationStatus>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<CustomerIntegrationStatus>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<CustomerIntegrationStatus>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<CustomerIntegrationStatus>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<CustomerIntegrationStatus>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<CustomerIntegrationStatus>>;
};

/** A connection to a list of `CustomerIntegration` values. */
export type CustomerIntegrationsConnection = {
  __typename?: 'CustomerIntegrationsConnection';
  /** A list of edges which contains the `CustomerIntegration` and cursor to aid in pagination. */
  edges: Array<CustomerIntegrationsEdge>;
  /** A list of `CustomerIntegration` objects. */
  nodes: Array<CustomerIntegration>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CustomerIntegration` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CustomerIntegration` edge in the connection. */
export type CustomerIntegrationsEdge = {
  __typename?: 'CustomerIntegrationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CustomerIntegration` at the end of the edge. */
  node: CustomerIntegration;
};

/** Methods to use when ordering `CustomerIntegration`. */
export enum CustomerIntegrationsOrderBy {
  CONFIG_ASC = 'CONFIG_ASC',
  CONFIG_DESC = 'CONFIG_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  CREATED_BY_ASC = 'CREATED_BY_ASC',
  CREATED_BY_DESC = 'CREATED_BY_DESC',
  ERROR_ASC = 'ERROR_ASC',
  ERROR_DESC = 'ERROR_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  INTEGRATION_PROVIDER_ID_ASC = 'INTEGRATION_PROVIDER_ID_ASC',
  INTEGRATION_PROVIDER_ID_DESC = 'INTEGRATION_PROVIDER_ID_DESC',
  LAST_SYNC_AT_ASC = 'LAST_SYNC_AT_ASC',
  LAST_SYNC_AT_DESC = 'LAST_SYNC_AT_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  STATUS_ASC = 'STATUS_ASC',
  STATUS_DESC = 'STATUS_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** Represents an update to a `Customer`. Fields that are set will be updated. */
export type CustomerPatch = {
  /** The unique local (facility-level) identifier of the customer */
  customerCode?: InputMaybe<Scalars['String']['input']>;
  /** The originating facility of the customer record */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** The name of the customer */
  name?: InputMaybe<Scalars['String']['input']>;
  /** A readable, short name of the customer */
  shortName?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique external identifier of the record from the original source system */
  sourceId?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `Customer` values. */
export type CustomersConnection = {
  __typename?: 'CustomersConnection';
  /** A list of edges which contains the `Customer` and cursor to aid in pagination. */
  edges: Array<CustomersEdge>;
  /** A list of `Customer` objects. */
  nodes: Array<Customer>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Customer` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Customer` edge in the connection. */
export type CustomersEdge = {
  __typename?: 'CustomersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Customer` at the end of the edge. */
  node: Customer;
};

/** Methods to use when ordering `Customer`. */
export enum CustomersOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  CUSTOMER_CODE_ASC = 'CUSTOMER_CODE_ASC',
  CUSTOMER_CODE_DESC = 'CUSTOMER_CODE_DESC',
  DELETED_AT_ASC = 'DELETED_AT_ASC',
  DELETED_AT_DESC = 'DELETED_AT_DESC',
  DELETE_ID_ASC = 'DELETE_ID_ASC',
  DELETE_ID_DESC = 'DELETE_ID_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  SHORT_NAME_ASC = 'SHORT_NAME_ASC',
  SHORT_NAME_DESC = 'SHORT_NAME_DESC',
  SOURCE_ID_ASC = 'SOURCE_ID_ASC',
  SOURCE_ID_DESC = 'SOURCE_ID_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  VERSION_ASC = 'VERSION_ASC',
  VERSION_DESC = 'VERSION_DESC'
}

export type Dashboard = Node & {
  __typename?: 'Dashboard';
  config: Scalars['JSON']['output'];
  createdAt: Scalars['Datetime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Facility` that is related to this `Dashboard`. */
  facility?: Maybe<Facility>;
  facilityId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  updatedAt: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `Dashboard` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type DashboardCondition = {
  /** Checks for equality with the object’s `config` field. */
  config?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `Dashboard` object types. All fields are combined with a logical ‘and.’ */
export type DashboardFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DashboardFilter>>;
  /** Filter by the object’s `config` field. */
  config?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DashboardFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DashboardFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `Dashboard` */
export type DashboardInput = {
  config?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

/** Represents an update to a `Dashboard`. Fields that are set will be updated. */
export type DashboardPatch = {
  config?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `Dashboard` values. */
export type DashboardsConnection = {
  __typename?: 'DashboardsConnection';
  /** A list of edges which contains the `Dashboard` and cursor to aid in pagination. */
  edges: Array<DashboardsEdge>;
  /** A list of `Dashboard` objects. */
  nodes: Array<Dashboard>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Dashboard` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Dashboard` edge in the connection. */
export type DashboardsEdge = {
  __typename?: 'DashboardsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Dashboard` at the end of the edge. */
  node: Dashboard;
};

/** Methods to use when ordering `Dashboard`. */
export enum DashboardsOrderBy {
  CONFIG_ASC = 'CONFIG_ASC',
  CONFIG_DESC = 'CONFIG_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** This represents the data points for a data source. */
export type DataPoint = Node & {
  __typename?: 'DataPoint';
  /** The human readable name of the data point. */
  alias: Scalars['String']['output'];
  /** Returns a list of all downstream dependencies for a data point. */
  allDependencies: DataPointsConnection;
  /** Returns a list of all upstream dependents for a data point. */
  allDependents: DataPointsConnection;
  /** Reads and enables pagination through a set of `Blast`. */
  blastsByStateId: BlastsConnection;
  /** Reads and enables pagination through a set of `Compressor`. */
  compressorsByOnStatusId: CompressorsConnection;
  /** Reads and enables pagination through a set of `Compressor`. */
  compressorsBySuctionPressureSetpointDeviationId: CompressorsConnection;
  createdAt: Scalars['Datetime']['output'];
  /** Aggregates a data point for the specified filter expression */
  data?: Maybe<MetricDataConnection>;
  /** Reads a single `DataSource` that is related to this `DataPoint`. */
  dataSource?: Maybe<DataSource>;
  /**
   * Returns the associated data source.
   * @deprecated Use dataSource
   */
  dataSourceByDataSourceName?: Maybe<DataSource>;
  /** Returns the associated data source display name. */
  dataSourceDisplayName?: Maybe<Scalars['String']['output']>;
  dataSourceName: Scalars['String']['output'];
  /** The data type of the data point. */
  dataType?: Maybe<Scalars['String']['output']>;
  /** Returns a list of direct dependencies for a data point. */
  dependencies: DataPointsConnection;
  /** Returns a list of direct dependents for a data point. */
  dependents: DataPointsConnection;
  /** The description of the data point. */
  description?: Maybe<Scalars['String']['output']>;
  /** The expression of the data point. */
  expression?: Maybe<Scalars['String']['output']>;
  /** The threshold used to determine the health of a given data point. */
  freshnessThresholdSeconds?: Maybe<Scalars['Int']['output']>;
  /** Reads and enables pagination through a set of `Gateway`. */
  gatewaysByStatusId: GatewaysConnection;
  /** Returns whether or not the data point has an alignment correction. */
  hasAlignmentCorrection?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['BigInt']['output'];
  /** @deprecated Use `dataPoint.type` instead. */
  isComposite?: Maybe<Scalars['Boolean']['output']>;
  /** Where the data point`s data originates from. */
  locationType?: Maybe<Scalars['String']['output']>;
  /** The maximum sampling rate, in seconds, to use when accessing a point's data. */
  maxSamplingWindow?: Maybe<Scalars['Int']['output']>;
  /** The minimum sampling rate, in seconds, to use when accessing a point's data. */
  minSamplingWindow?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The child point intervals for a VIRTUAL data point. */
  pointIntervals: VirtualPointIntervalsConnection;
  /** Returns raw data for the given data point, if applicable. */
  rawData?: Maybe<MetricDataConnection>;
  /** Indicates that the stream of data is a metered / right aligned periodic aggregate. */
  rightAligned?: Maybe<Scalars['Boolean']['output']>;
  /** Reads and enables pagination through a set of `SuctionHeadersCompressor`. */
  suctionHeadersCompressorsByActiveId: SuctionHeadersCompressorsConnection;
  /** The type of data stream a point represents. */
  type: DataPointType;
  /** The units of thee data point. */
  units?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Datetime']['output'];
};

/** This represents the data points for a data source. */
export type DataPointAllDependenciesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<DataPointFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** This represents the data points for a data source. */
export type DataPointAllDependentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<DataPointFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** This represents the data points for a data source. */
export type DataPointBlastsByStateIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BlastCondition>;
  filter?: InputMaybe<BlastFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BlastsOrderBy>>;
};

/** This represents the data points for a data source. */
export type DataPointCompressorsByOnStatusIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CompressorCondition>;
  filter?: InputMaybe<CompressorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CompressorsOrderBy>>;
};

/** This represents the data points for a data source. */
export type DataPointCompressorsBySuctionPressureSetpointDeviationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CompressorCondition>;
  filter?: InputMaybe<CompressorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CompressorsOrderBy>>;
};

/** This represents the data points for a data source. */
export type DataPointDataArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** This represents the data points for a data source. */
export type DataPointDependenciesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<DataPointFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** This represents the data points for a data source. */
export type DataPointDependentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<DataPointFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** This represents the data points for a data source. */
export type DataPointGatewaysByStatusIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GatewayCondition>;
  filter?: InputMaybe<GatewayFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GatewaysOrderBy>>;
};

/** This represents the data points for a data source. */
export type DataPointPointIntervalsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<VirtualPointIntervalFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** This represents the data points for a data source. */
export type DataPointRawDataArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
};

/** This represents the data points for a data source. */
export type DataPointSuctionHeadersCompressorsByActiveIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SuctionHeadersCompressorCondition>;
  filter?: InputMaybe<SuctionHeadersCompressorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SuctionHeadersCompressorsOrderBy>>;
};

/**
 * A condition to be used against `DataPoint` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type DataPointCondition = {
  /** Checks for equality with the object’s `alias` field. */
  alias?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `dataSourceName` field. */
  dataSourceName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `dataType` field. */
  dataType?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `expression` field. */
  expression?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `formattedExpression` field. */
  formattedExpression?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `freshnessThresholdSeconds` field. */
  freshnessThresholdSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `hasAlignmentCorrection` field. */
  hasAlignmentCorrection?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `locationType` field. */
  locationType?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `maxSamplingWindow` field. */
  maxSamplingWindow?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `minSamplingWindow` field. */
  minSamplingWindow?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `rightAligned` field. */
  rightAligned?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<DataPointType>;
  /** Checks for equality with the object’s `units` field. */
  units?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `DataPoint` object types. All fields are combined with a logical ‘and.’ */
export type DataPointFilter = {
  /** Filter by the object’s `alias` field. */
  alias?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DataPointFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dataSourceDisplayName` field. */
  dataSourceDisplayName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `dataSourceName` field. */
  dataSourceName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `dataType` field. */
  dataType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `expression` field. */
  expression?: InputMaybe<StringFilter>;
  /** Filter by the object’s `formattedExpression` field. */
  formattedExpression?: InputMaybe<StringFilter>;
  /** Filter by the object’s `freshnessThresholdSeconds` field. */
  freshnessThresholdSeconds?: InputMaybe<IntFilter>;
  /** Filter by the object’s `hasAlignmentCorrection` field. */
  hasAlignmentCorrection?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `isComposite` field. */
  isComposite?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `locationType` field. */
  locationType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `maxSamplingWindow` field. */
  maxSamplingWindow?: InputMaybe<IntFilter>;
  /** Filter by the object’s `minSamplingWindow` field. */
  minSamplingWindow?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DataPointFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DataPointFilter>>;
  /** Filter by the object’s `rightAligned` field. */
  rightAligned?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<DataPointTypeFilter>;
  /** Filter by the object’s `units` field. */
  units?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `DataPoint` */
export type DataPointInput = {
  /** The human readable name of the data point. */
  alias: Scalars['String']['input'];
  /** Mutates a `DataSource` as part of the payload */
  dataSource?: InputMaybe<DataSourceInput>;
  dataSourceName?: InputMaybe<Scalars['String']['input']>;
  /** The data type of the data point. */
  dataType?: InputMaybe<Scalars['String']['input']>;
  /** The description of the data point. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The expression of the data point. */
  expression?: InputMaybe<Scalars['String']['input']>;
  /** The threshold used to determine the health of a given data point. */
  freshnessThresholdSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** Where the data point`s data originates from. */
  locationType?: InputMaybe<Scalars['String']['input']>;
  /** The maximum sampling rate, in seconds, to use when accessing a point's data. */
  maxSamplingWindow?: InputMaybe<Scalars['Int']['input']>;
  /** The minimum sampling rate, in seconds, to use when accessing a point's data. */
  minSamplingWindow?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  /** Indicates that the stream of data is a metered / right aligned periodic aggregate. */
  rightAligned?: InputMaybe<Scalars['Boolean']['input']>;
  /** The type of data stream a point represents. */
  type?: InputMaybe<DataPointType>;
  /** The units of thee data point. */
  units?: InputMaybe<Scalars['String']['input']>;
};

/** Represents an update to a `DataPoint`. Fields that are set will be updated. */
export type DataPointPatch = {
  /** The human readable name of the data point. */
  alias?: InputMaybe<Scalars['String']['input']>;
  /** The data type of the data point. */
  dataType?: InputMaybe<Scalars['String']['input']>;
  /** The description of the data point. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The expression of the data point. */
  expression?: InputMaybe<Scalars['String']['input']>;
  /** The threshold used to determine the health of a given data point. */
  freshnessThresholdSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** Where the data point`s data originates from. */
  locationType?: InputMaybe<Scalars['String']['input']>;
  /** The maximum sampling rate, in seconds, to use when accessing a point's data. */
  maxSamplingWindow?: InputMaybe<Scalars['Int']['input']>;
  /** The minimum sampling rate, in seconds, to use when accessing a point's data. */
  minSamplingWindow?: InputMaybe<Scalars['Int']['input']>;
  /** Indicates that the stream of data is a metered / right aligned periodic aggregate. */
  rightAligned?: InputMaybe<Scalars['Boolean']['input']>;
  /** The type of data stream a point represents. */
  type?: InputMaybe<DataPointType>;
  /** The units of thee data point. */
  units?: InputMaybe<Scalars['String']['input']>;
};

/** Well-known tags for identifying special data points */
export type DataPointTag = Node & {
  __typename?: 'DataPointTag';
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  updatedAt: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `DataPointTag` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type DataPointTagCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `DataPointTag` object types. All fields are combined with a logical ‘and.’ */
export type DataPointTagFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DataPointTagFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DataPointTagFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DataPointTagFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** A connection to a list of `DataPointTag` values. */
export type DataPointTagsConnection = {
  __typename?: 'DataPointTagsConnection';
  /** A list of edges which contains the `DataPointTag` and cursor to aid in pagination. */
  edges: Array<DataPointTagsEdge>;
  /** A list of `DataPointTag` objects. */
  nodes: Array<DataPointTag>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DataPointTag` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `DataPointTag` edge in the connection. */
export type DataPointTagsEdge = {
  __typename?: 'DataPointTagsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `DataPointTag` at the end of the edge. */
  node: DataPointTag;
};

/** Methods to use when ordering `DataPointTag`. */
export enum DataPointTagsOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

export enum DataPointType {
  COMPOSITE = 'COMPOSITE',
  RAW = 'RAW',
  VIRTUAL = 'VIRTUAL'
}

/** A filter to be used against DataPointType fields. All fields are combined with a logical ‘and.’ */
export type DataPointTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<DataPointType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<DataPointType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<DataPointType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<DataPointType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<DataPointType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<DataPointType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<DataPointType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<DataPointType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<DataPointType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<DataPointType>>;
};

/** A connection to a list of `DataPoint` values. */
export type DataPointsConnection = {
  __typename?: 'DataPointsConnection';
  /** A list of edges which contains the `DataPoint` and cursor to aid in pagination. */
  edges: Array<DataPointsEdge>;
  /** A list of `DataPoint` objects. */
  nodes: Array<DataPoint>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DataPoint` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `DataPoint` edge in the connection. */
export type DataPointsEdge = {
  __typename?: 'DataPointsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `DataPoint` at the end of the edge. */
  node: DataPoint;
};

/** Methods to use when ordering `DataPoint`. */
export enum DataPointsOrderBy {
  ALIAS_ASC = 'ALIAS_ASC',
  ALIAS_DESC = 'ALIAS_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DATA_SOURCE_NAME_ASC = 'DATA_SOURCE_NAME_ASC',
  DATA_SOURCE_NAME_DESC = 'DATA_SOURCE_NAME_DESC',
  DATA_TYPE_ASC = 'DATA_TYPE_ASC',
  DATA_TYPE_DESC = 'DATA_TYPE_DESC',
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  EXPRESSION_ASC = 'EXPRESSION_ASC',
  EXPRESSION_DESC = 'EXPRESSION_DESC',
  FORMATTED_EXPRESSION_ASC = 'FORMATTED_EXPRESSION_ASC',
  FORMATTED_EXPRESSION_DESC = 'FORMATTED_EXPRESSION_DESC',
  FRESHNESS_THRESHOLD_SECONDS_ASC = 'FRESHNESS_THRESHOLD_SECONDS_ASC',
  FRESHNESS_THRESHOLD_SECONDS_DESC = 'FRESHNESS_THRESHOLD_SECONDS_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LOCATION_TYPE_ASC = 'LOCATION_TYPE_ASC',
  LOCATION_TYPE_DESC = 'LOCATION_TYPE_DESC',
  MAX_SAMPLING_WINDOW_ASC = 'MAX_SAMPLING_WINDOW_ASC',
  MAX_SAMPLING_WINDOW_DESC = 'MAX_SAMPLING_WINDOW_DESC',
  MIN_SAMPLING_WINDOW_ASC = 'MIN_SAMPLING_WINDOW_ASC',
  MIN_SAMPLING_WINDOW_DESC = 'MIN_SAMPLING_WINDOW_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  RIGHT_ALIGNED_ASC = 'RIGHT_ALIGNED_ASC',
  RIGHT_ALIGNED_DESC = 'RIGHT_ALIGNED_DESC',
  TYPE_ASC = 'TYPE_ASC',
  TYPE_DESC = 'TYPE_DESC',
  UNITS_ASC = 'UNITS_ASC',
  UNITS_DESC = 'UNITS_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** This represents the iot data sources. */
export type DataSource = Node & {
  __typename?: 'DataSource';
  /** A human-readable name for this data source */
  alias?: Maybe<Scalars['String']['output']>;
  /** The time the data source was created. */
  createdAt: Scalars['Datetime']['output'];
  /** The threshold used to determine the health of a given data source from the freshness of its data points. */
  criticalThreshold?: Maybe<Scalars['Float']['output']>;
  /** Reads and enables pagination through a set of `DataPoint`. */
  dataPoints: DataPointsConnection;
  /**
   * Returns the associated data points.
   * @deprecated Use dataPoints
   */
  dataPointsByDataSourceName: DataPointsConnection;
  /** The description of the data source. */
  description?: Maybe<Scalars['String']['output']>;
  /** Returns the alias, if set, or the name of this data source */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `Facility`. */
  facilities: FacilitiesConnection;
  /** Reads and enables pagination through a set of `FacilityDataSource`. */
  facilityDataSourcesByDataSourceName: FacilityDataSourcesConnection;
  /** The threshold used to determine the liveness of a given data source. */
  livenessThresholdSeconds?: Maybe<Scalars['Int']['output']>;
  /** The data source name. */
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The time the data source was updated. */
  updatedAt: Scalars['Datetime']['output'];
};

/** This represents the iot data sources. */
export type DataSourceDataPointsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DataPointCondition>;
  filter?: InputMaybe<DataPointFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataPointsOrderBy>>;
};

/** This represents the iot data sources. */
export type DataSourceDataPointsByDataSourceNameArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<DataPointFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** This represents the iot data sources. */
export type DataSourceFacilitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<FacilityFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** This represents the iot data sources. */
export type DataSourceFacilityDataSourcesByDataSourceNameArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FacilityDataSourceCondition>;
  filter?: InputMaybe<FacilityDataSourceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FacilityDataSourcesOrderBy>>;
};

/**
 * A condition to be used against `DataSource` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type DataSourceCondition = {
  /** Checks for equality with the object’s `alias` field. */
  alias?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `criticalThreshold` field. */
  criticalThreshold?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `livenessThresholdSeconds` field. */
  livenessThresholdSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `DataSource` object types. All fields are combined with a logical ‘and.’ */
export type DataSourceFilter = {
  /** Filter by the object’s `alias` field. */
  alias?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DataSourceFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `criticalThreshold` field. */
  criticalThreshold?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `displayName` field. */
  displayName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `livenessThresholdSeconds` field. */
  livenessThresholdSeconds?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DataSourceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DataSourceFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `DataSource` */
export type DataSourceInput = {
  /** A human-readable name for this data source */
  alias?: InputMaybe<Scalars['String']['input']>;
  /** The threshold used to determine the health of a given data source from the freshness of its data points. */
  criticalThreshold?: InputMaybe<Scalars['Float']['input']>;
  /** The description of the data source. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The threshold used to determine the liveness of a given data source. */
  livenessThresholdSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** The data source name. */
  name: Scalars['String']['input'];
};

/** A connection to a list of `DataSource` values. */
export type DataSourcesConnection = {
  __typename?: 'DataSourcesConnection';
  /** A list of edges which contains the `DataSource` and cursor to aid in pagination. */
  edges: Array<DataSourcesEdge>;
  /** A list of `DataSource` objects. */
  nodes: Array<DataSource>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DataSource` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `DataSource` edge in the connection. */
export type DataSourcesEdge = {
  __typename?: 'DataSourcesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `DataSource` at the end of the edge. */
  node: DataSource;
};

/** Methods to use when ordering `DataSource`. */
export enum DataSourcesOrderBy {
  ALIAS_ASC = 'ALIAS_ASC',
  ALIAS_DESC = 'ALIAS_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  CRITICAL_THRESHOLD_ASC = 'CRITICAL_THRESHOLD_ASC',
  CRITICAL_THRESHOLD_DESC = 'CRITICAL_THRESHOLD_DESC',
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  DISPLAY_NAME_ASC = 'DISPLAY_NAME_ASC',
  DISPLAY_NAME_DESC = 'DISPLAY_NAME_DESC',
  LIVENESS_THRESHOLD_SECONDS_ASC = 'LIVENESS_THRESHOLD_SECONDS_ASC',
  LIVENESS_THRESHOLD_SECONDS_DESC = 'LIVENESS_THRESHOLD_SECONDS_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** A filter to be used against Date fields. All fields are combined with a logical ‘and.’ */
export type DateFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Date']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Date']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Date']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Date']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Date']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Date']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Date']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Date']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Date']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Date']['input']>>;
};

/** A filter to be used against Datetime fields. All fields are combined with a logical ‘and.’ */
export type DatetimeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Datetime']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Datetime']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Datetime']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Datetime']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Datetime']['input']>>;
};

/** All input for the `deleteAccountCharge` mutation. */
export type DeleteAccountChargeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** The output of our `deleteAccountCharge` mutation. */
export type DeleteAccountChargePayload = {
  __typename?: 'DeleteAccountChargePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `deleteAccountStatement` mutation. */
export type DeleteAccountStatementInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** The output of our `deleteAccountStatement` mutation. */
export type DeleteAccountStatementPayload = {
  __typename?: 'DeleteAccountStatementPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `deleteAccountStatementPdf` mutation. */
export type DeleteAccountStatementPdfInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** The output of our `deleteAccountStatementPdf` mutation. */
export type DeleteAccountStatementPdfPayload = {
  __typename?: 'DeleteAccountStatementPdfPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `deleteAssessment` mutation. */
export type DeleteAssessmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifier of the assessment. */
  id: Scalars['Int']['input'];
};

/** The output of our delete `Assessment` mutation. */
export type DeleteAssessmentPayload = {
  __typename?: 'DeleteAssessmentPayload';
  /** The `Assessment` that was deleted by this mutation. */
  assessment?: Maybe<Assessment>;
  /** An edge for our `Assessment`. May be used by Relay 1. */
  assessmentEdge?: Maybe<AssessmentsEdge>;
  /** Reads a single `AssessmentType` that is related to this `Assessment`. */
  assessmentType?: Maybe<AssessmentType>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedAssessmentNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `MonitoredAsset` that is related to this `Assessment`. */
  monitoredAsset?: Maybe<MonitoredAsset>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `Assessment` mutation. */
export type DeleteAssessmentPayloadAssessmentEdgeArgs = {
  orderBy?: InputMaybe<Array<AssessmentsOrderBy>>;
};

/** All input for the `deleteAssessmentTypeBySlug` mutation. */
export type DeleteAssessmentTypeBySlugInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The unique slug used to reference the assessment type. */
  slug: Scalars['String']['input'];
};

/** All input for the `deleteAssessmentType` mutation. */
export type DeleteAssessmentTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifier of the assessment type. */
  id: Scalars['Int']['input'];
};

/** The output of our delete `AssessmentType` mutation. */
export type DeleteAssessmentTypePayload = {
  __typename?: 'DeleteAssessmentTypePayload';
  /** The `AssessmentType` that was deleted by this mutation. */
  assessmentType?: Maybe<AssessmentType>;
  /** An edge for our `AssessmentType`. May be used by Relay 1. */
  assessmentTypeEdge?: Maybe<AssessmentTypesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedAssessmentTypeNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SoftwarePackage` that is related to this `AssessmentType`. */
  softwarePackage?: Maybe<SoftwarePackage>;
};

/** The output of our delete `AssessmentType` mutation. */
export type DeleteAssessmentTypePayloadAssessmentTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<AssessmentTypesOrderBy>>;
};

/** All input for the `deleteBalancingAuthorityBySlug` mutation. */
export type DeleteBalancingAuthorityBySlugInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The slug identifier of the balancing authority. */
  slug: Scalars['String']['input'];
};

/** All input for the `deleteBalancingAuthority` mutation. */
export type DeleteBalancingAuthorityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifer of the balancing authority. */
  id: Scalars['Int']['input'];
};

/** The output of our delete `BalancingAuthority` mutation. */
export type DeleteBalancingAuthorityPayload = {
  __typename?: 'DeleteBalancingAuthorityPayload';
  /** The `BalancingAuthority` that was deleted by this mutation. */
  balancingAuthority?: Maybe<BalancingAuthority>;
  /** An edge for our `BalancingAuthority`. May be used by Relay 1. */
  balancingAuthorityEdge?: Maybe<BalancingAuthoritiesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedBalancingAuthorityNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `BalancingAuthority` mutation. */
export type DeleteBalancingAuthorityPayloadBalancingAuthorityEdgeArgs = {
  orderBy?: InputMaybe<Array<BalancingAuthoritiesOrderBy>>;
};

/** All input for the `deleteBlastByLabelAndFacilityId` mutation. */
export type DeleteBlastByLabelAndFacilityIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The facility a blast is within */
  facilityId: Scalars['Int']['input'];
  /** The unique local (facility-level) human-readable label of the blast */
  label: Scalars['String']['input'];
};

/** All input for the `deleteBlastEvaporator` mutation. */
export type DeleteBlastEvaporatorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['Int']['input'];
};

/** The output of our delete `BlastEvaporator` mutation. */
export type DeleteBlastEvaporatorPayload = {
  __typename?: 'DeleteBlastEvaporatorPayload';
  /** Reads a single `Blast` that is related to this `BlastEvaporator`. */
  blast?: Maybe<Blast>;
  /** The `BlastEvaporator` that was deleted by this mutation. */
  blastEvaporator?: Maybe<BlastEvaporator>;
  /** An edge for our `BlastEvaporator`. May be used by Relay 1. */
  blastEvaporatorEdge?: Maybe<BlastEvaporatorsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedBlastEvaporatorNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Evaporator` that is related to this `BlastEvaporator`. */
  evaporator?: Maybe<Evaporator>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `BlastEvaporator` mutation. */
export type DeleteBlastEvaporatorPayloadBlastEvaporatorEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastEvaporatorsOrderBy>>;
};

/** All input for the `deleteBlast` mutation. */
export type DeleteBlastInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['Int']['input'];
};

/** All input for the `deleteBlastPallet` mutation. */
export type DeleteBlastPalletInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['Int']['input'];
};

/** All input for the `deleteBlastPalletLocation` mutation. */
export type DeleteBlastPalletLocationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['Int']['input'];
};

/** The output of our delete `BlastPalletLocation` mutation. */
export type DeleteBlastPalletLocationPayload = {
  __typename?: 'DeleteBlastPalletLocationPayload';
  /** Reads a single `Blast` that is related to this `BlastPalletLocation`. */
  blast?: Maybe<Blast>;
  /** The `BlastPalletLocation` that was deleted by this mutation. */
  blastPalletLocation?: Maybe<BlastPalletLocation>;
  /** An edge for our `BlastPalletLocation`. May be used by Relay 1. */
  blastPalletLocationEdge?: Maybe<BlastPalletLocationsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedBlastPalletLocationNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `PalletLocation` that is related to this `BlastPalletLocation`. */
  palletLocation?: Maybe<PalletLocation>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `BlastPalletLocation` mutation. */
export type DeleteBlastPalletLocationPayloadBlastPalletLocationEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastPalletLocationsOrderBy>>;
};

/** The output of our delete `BlastPallet` mutation. */
export type DeleteBlastPalletPayload = {
  __typename?: 'DeleteBlastPalletPayload';
  /** Reads a single `Blast` that is related to this `BlastPallet`. */
  blast?: Maybe<Blast>;
  /** The `BlastPallet` that was deleted by this mutation. */
  blastPallet?: Maybe<BlastPallet>;
  /** An edge for our `BlastPallet`. May be used by Relay 1. */
  blastPalletEdge?: Maybe<BlastPalletsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedBlastPalletNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Pallet` that is related to this `BlastPallet`. */
  pallet?: Maybe<Pallet>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `BlastPallet` mutation. */
export type DeleteBlastPalletPayloadBlastPalletEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastPalletsOrderBy>>;
};

/** The output of our delete `Blast` mutation. */
export type DeleteBlastPayload = {
  __typename?: 'DeleteBlastPayload';
  /** Reads a single `DataPoint` that is related to this `Blast`. */
  actualUtilization?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Blast`. */
  automationState?: Maybe<DataPoint>;
  /** The `Blast` that was deleted by this mutation. */
  blast?: Maybe<Blast>;
  /** An edge for our `Blast`. May be used by Relay 1. */
  blastEdge?: Maybe<BlastsEdge>;
  /** Reads a single `BlastType` that is related to this `Blast`. */
  blastType?: Maybe<BlastType>;
  /** Reads a single `BuildingArea` that is related to this `Blast`. */
  buildingArea?: Maybe<BuildingArea>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Component` that is related to this `Blast`. */
  component?: Maybe<Component>;
  deletedBlastNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Facility` that is related to this `Blast`. */
  facility?: Maybe<Facility>;
  /** Reads a single `DataPoint` that is related to this `Blast`. */
  idealUtilization?: Maybe<DataPoint>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DataPoint` that is related to this `Blast`. */
  stagingTimer?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Blast`. */
  state?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Blast`. */
  timer?: Maybe<DataPoint>;
};

/** The output of our delete `Blast` mutation. */
export type DeleteBlastPayloadBlastEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastsOrderBy>>;
};

/** All input for the `deleteBlastRotationAlert` mutation. */
export type DeleteBlastRotationAlertInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifer of the blast rotation alert */
  id: Scalars['Int']['input'];
};

/** The output of our delete `BlastRotationAlert` mutation. */
export type DeleteBlastRotationAlertPayload = {
  __typename?: 'DeleteBlastRotationAlertPayload';
  /** Reads a single `BlastRotation` that is related to this `BlastRotationAlert`. */
  blastRotation?: Maybe<BlastRotation>;
  /** The `BlastRotationAlert` that was deleted by this mutation. */
  blastRotationAlert?: Maybe<BlastRotationAlert>;
  /** An edge for our `BlastRotationAlert`. May be used by Relay 1. */
  blastRotationAlertEdge?: Maybe<BlastRotationAlertsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedBlastRotationAlertNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `BlastRotationAlert` mutation. */
export type DeleteBlastRotationAlertPayloadBlastRotationAlertEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastRotationAlertsOrderBy>>;
};

/** All input for the `deleteBlastRotationEventLogByBlastRotationIdAndDescriptionAndBlastRotationEventTypeId` mutation. */
export type DeleteBlastRotationEventLogByBlastRotationIdAndDescriptionAndBlastRotationEventTypeIdInput =
  {
    /** The type of event for this record */
    blastRotationEventTypeId: Scalars['String']['input'];
    /** The associated blast rotation */
    blastRotationId: Scalars['Int']['input'];
    /**
     * An arbitrary string value with no semantic meaning. Will be included in the
     * payload verbatim. May be used to track mutations by the client.
     */
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** A short description of the event */
    description: Scalars['String']['input'];
  };

/** All input for the `deleteBlastRotationEventLog` mutation. */
export type DeleteBlastRotationEventLogInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['Int']['input'];
};

/** The output of our delete `BlastRotationEventLog` mutation. */
export type DeleteBlastRotationEventLogPayload = {
  __typename?: 'DeleteBlastRotationEventLogPayload';
  /** Reads a single `BlastRotation` that is related to this `BlastRotationEventLog`. */
  blastRotation?: Maybe<BlastRotation>;
  /** The `BlastRotationEventLog` that was deleted by this mutation. */
  blastRotationEventLog?: Maybe<BlastRotationEventLog>;
  /** An edge for our `BlastRotationEventLog`. May be used by Relay 1. */
  blastRotationEventLogEdge?: Maybe<BlastRotationEventLogsEdge>;
  /** Reads a single `BlastRotationEventType` that is related to this `BlastRotationEventLog`. */
  blastRotationEventType?: Maybe<BlastRotationEventType>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedBlastRotationEventLogNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `BlastRotationEventLog` mutation. */
export type DeleteBlastRotationEventLogPayloadBlastRotationEventLogEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastRotationEventLogsOrderBy>>;
};

/** All input for the `deleteBlastRotationEventType` mutation. */
export type DeleteBlastRotationEventTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** A unique, readable type of event that can occur within a blast rotation */
  eventType: Scalars['String']['input'];
};

/** The output of our delete `BlastRotationEventType` mutation. */
export type DeleteBlastRotationEventTypePayload = {
  __typename?: 'DeleteBlastRotationEventTypePayload';
  /** The `BlastRotationEventType` that was deleted by this mutation. */
  blastRotationEventType?: Maybe<BlastRotationEventType>;
  /** An edge for our `BlastRotationEventType`. May be used by Relay 1. */
  blastRotationEventTypeEdge?: Maybe<BlastRotationEventTypesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedBlastRotationEventTypeNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `BlastRotationEventType` mutation. */
export type DeleteBlastRotationEventTypePayloadBlastRotationEventTypeEdgeArgs =
  {
    orderBy?: InputMaybe<Array<BlastRotationEventTypesOrderBy>>;
  };

/** All input for the `deleteBlastRotation` mutation. */
export type DeleteBlastRotationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['Int']['input'];
};

/** All input for the `deleteBlastRotationPalletByBlastRotationIdAndPalletId` mutation. */
export type DeleteBlastRotationPalletByBlastRotationIdAndPalletIdInput = {
  /** The associated blast rotation */
  blastRotationId: Scalars['Int']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The associated pallet */
  palletId: Scalars['Int']['input'];
};

/** All input for the `deleteBlastRotationPallet` mutation. */
export type DeleteBlastRotationPalletInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['Int']['input'];
};

/** The output of our delete `BlastRotationPallet` mutation. */
export type DeleteBlastRotationPalletPayload = {
  __typename?: 'DeleteBlastRotationPalletPayload';
  /** Reads a single `BlastRotation` that is related to this `BlastRotationPallet`. */
  blastRotation?: Maybe<BlastRotation>;
  /** The `BlastRotationPallet` that was deleted by this mutation. */
  blastRotationPallet?: Maybe<BlastRotationPallet>;
  /** An edge for our `BlastRotationPallet`. May be used by Relay 1. */
  blastRotationPalletEdge?: Maybe<BlastRotationPalletsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedBlastRotationPalletNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Pallet` that is related to this `BlastRotationPallet`. */
  pallet?: Maybe<Pallet>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `BlastRotationPallet` mutation. */
export type DeleteBlastRotationPalletPayloadBlastRotationPalletEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastRotationPalletsOrderBy>>;
};

/** The output of our delete `BlastRotation` mutation. */
export type DeleteBlastRotationPayload = {
  __typename?: 'DeleteBlastRotationPayload';
  /** Reads a single `Blast` that is related to this `BlastRotation`. */
  blast?: Maybe<Blast>;
  /** The `BlastRotation` that was deleted by this mutation. */
  blastRotation?: Maybe<BlastRotation>;
  /** An edge for our `BlastRotation`. May be used by Relay 1. */
  blastRotationEdge?: Maybe<BlastRotationsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedBlastRotationNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `BlastRotation` mutation. */
export type DeleteBlastRotationPayloadBlastRotationEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastRotationsOrderBy>>;
};

/** All input for the `deleteBlastType` mutation. */
export type DeleteBlastTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['Int']['input'];
};

/** The output of our delete `BlastType` mutation. */
export type DeleteBlastTypePayload = {
  __typename?: 'DeleteBlastTypePayload';
  /** The `BlastType` that was deleted by this mutation. */
  blastType?: Maybe<BlastType>;
  /** An edge for our `BlastType`. May be used by Relay 1. */
  blastTypeEdge?: Maybe<BlastTypesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedBlastTypeNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `BlastType` mutation. */
export type DeleteBlastTypePayloadBlastTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastTypesOrderBy>>;
};

/** All input for the `deleteBuildingAreaByFacilityIdAndLabel` mutation. */
export type DeleteBuildingAreaByFacilityIdAndLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** This represents the facility that the building area belongs to. */
  facilityId: Scalars['Int']['input'];
  /** Human-readable label for the building area. */
  label: Scalars['String']['input'];
};

/** All input for the `deleteBuildingAreaComplianceGroupByBuildingAreaIdAndComplianceType` mutation. */
export type DeleteBuildingAreaComplianceGroupByBuildingAreaIdAndComplianceTypeInput =
  {
    /** The building area the compliance group applies to */
    buildingAreaId: Scalars['Int']['input'];
    /**
     * An arbitrary string value with no semantic meaning. Will be included in the
     * payload verbatim. May be used to track mutations by the client.
     */
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** The type of compliance group for this relationship */
    complianceType: ComplianceType;
  };

/** All input for the `deleteBuildingAreaComplianceGroup` mutation. */
export type DeleteBuildingAreaComplianceGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the building area compliance group */
  id: Scalars['Int']['input'];
};

/** The output of our delete `BuildingAreaComplianceGroup` mutation. */
export type DeleteBuildingAreaComplianceGroupPayload = {
  __typename?: 'DeleteBuildingAreaComplianceGroupPayload';
  /** Reads a single `BuildingArea` that is related to this `BuildingAreaComplianceGroup`. */
  buildingArea?: Maybe<BuildingArea>;
  /** The `BuildingAreaComplianceGroup` that was deleted by this mutation. */
  buildingAreaComplianceGroup?: Maybe<BuildingAreaComplianceGroup>;
  /** An edge for our `BuildingAreaComplianceGroup`. May be used by Relay 1. */
  buildingAreaComplianceGroupEdge?: Maybe<BuildingAreaComplianceGroupsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `ComplianceGroup` that is related to this `BuildingAreaComplianceGroup`. */
  complianceGroup?: Maybe<ComplianceGroup>;
  deletedBuildingAreaComplianceGroupNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `BuildingAreaComplianceGroup` mutation. */
export type DeleteBuildingAreaComplianceGroupPayloadBuildingAreaComplianceGroupEdgeArgs =
  {
    orderBy?: InputMaybe<Array<BuildingAreaComplianceGroupsOrderBy>>;
  };

/** All input for the `deleteBuildingArea` mutation. */
export type DeleteBuildingAreaInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** The output of our delete `BuildingArea` mutation. */
export type DeleteBuildingAreaPayload = {
  __typename?: 'DeleteBuildingAreaPayload';
  /** The `BuildingArea` that was deleted by this mutation. */
  buildingArea?: Maybe<BuildingArea>;
  /** An edge for our `BuildingArea`. May be used by Relay 1. */
  buildingAreaEdge?: Maybe<BuildingAreasEdge>;
  /** Reads a single `BuildingAreaType` that is related to this `BuildingArea`. */
  buildingAreaType?: Maybe<BuildingAreaType>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedBuildingAreaNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Facility` that is related to this `BuildingArea`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `BuildingArea` mutation. */
export type DeleteBuildingAreaPayloadBuildingAreaEdgeArgs = {
  orderBy?: InputMaybe<Array<BuildingAreasOrderBy>>;
};

/** All input for the `deleteBuildingAreaType` mutation. */
export type DeleteBuildingAreaTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The short name of the building area type. */
  type: Scalars['String']['input'];
};

/** The output of our delete `BuildingAreaType` mutation. */
export type DeleteBuildingAreaTypePayload = {
  __typename?: 'DeleteBuildingAreaTypePayload';
  /** The `BuildingAreaType` that was deleted by this mutation. */
  buildingAreaType?: Maybe<BuildingAreaType>;
  /** An edge for our `BuildingAreaType`. May be used by Relay 1. */
  buildingAreaTypeEdge?: Maybe<BuildingAreaTypesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedBuildingAreaTypeNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `BuildingAreaType` mutation. */
export type DeleteBuildingAreaTypePayloadBuildingAreaTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<BuildingAreaTypesOrderBy>>;
};

/** All input for the `deleteChart` mutation. */
export type DeleteChartInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** The output of our delete `Chart` mutation. */
export type DeleteChartPayload = {
  __typename?: 'DeleteChartPayload';
  /** The `Chart` that was deleted by this mutation. */
  chart?: Maybe<Chart>;
  /** An edge for our `Chart`. May be used by Relay 1. */
  chartEdge?: Maybe<ChartsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedChartNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Facility` that is related to this `Chart`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `Chart` mutation. */
export type DeleteChartPayloadChartEdgeArgs = {
  orderBy?: InputMaybe<Array<ChartsOrderBy>>;
};

/** All input for the `deleteCheckBySlug` mutation. */
export type DeleteCheckBySlugInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The unique key of the check. */
  slug: Scalars['String']['input'];
};

/** All input for the `deleteCheck` mutation. */
export type DeleteCheckInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifier of the check */
  id: Scalars['Int']['input'];
};

/** All input for the `deleteCheckMonitorByMonitorId` mutation. */
export type DeleteCheckMonitorByMonitorIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The monitor. */
  monitorId: Scalars['Int']['input'];
};

/** All input for the `deleteCheckMonitor` mutation. */
export type DeleteCheckMonitorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** The output of our delete `CheckMonitor` mutation. */
export type DeleteCheckMonitorPayload = {
  __typename?: 'DeleteCheckMonitorPayload';
  /** Reads a single `Check` that is related to this `CheckMonitor`. */
  check?: Maybe<Check>;
  /** The `CheckMonitor` that was deleted by this mutation. */
  checkMonitor?: Maybe<CheckMonitor>;
  /** An edge for our `CheckMonitor`. May be used by Relay 1. */
  checkMonitorEdge?: Maybe<CheckMonitorsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedCheckMonitorNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Facility` that is related to this `CheckMonitor`. */
  facility?: Maybe<Facility>;
  /** Reads a single `Monitor` that is related to this `CheckMonitor`. */
  monitor?: Maybe<Monitor>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `CheckMonitor` mutation. */
export type DeleteCheckMonitorPayloadCheckMonitorEdgeArgs = {
  orderBy?: InputMaybe<Array<CheckMonitorsOrderBy>>;
};

/** The output of our delete `Check` mutation. */
export type DeleteCheckPayload = {
  __typename?: 'DeleteCheckPayload';
  /** The `Check` that was deleted by this mutation. */
  check?: Maybe<Check>;
  /** An edge for our `Check`. May be used by Relay 1. */
  checkEdge?: Maybe<ChecksEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedCheckNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Severity` that is related to this `Check`. */
  severity?: Maybe<Severity>;
  /** Reads a single `SoftwarePackage` that is related to this `Check`. */
  softwarePackage?: Maybe<SoftwarePackage>;
};

/** The output of our delete `Check` mutation. */
export type DeleteCheckPayloadCheckEdgeArgs = {
  orderBy?: InputMaybe<Array<ChecksOrderBy>>;
};

/** All input for the `deleteClassificationByAssessmentTypeIdAndName` mutation. */
export type DeleteClassificationByAssessmentTypeIdAndNameInput = {
  /** References the assessment type this classification is associated with. */
  assessmentTypeId: Scalars['Int']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The name of the classification. */
  name: Scalars['String']['input'];
};

/** All input for the `deleteClassification` mutation. */
export type DeleteClassificationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifier of the classification. */
  id: Scalars['Int']['input'];
};

/** The output of our delete `Classification` mutation. */
export type DeleteClassificationPayload = {
  __typename?: 'DeleteClassificationPayload';
  /** Reads a single `AssessmentType` that is related to this `Classification`. */
  assessmentType?: Maybe<AssessmentType>;
  /** The `Classification` that was deleted by this mutation. */
  classification?: Maybe<Classification>;
  /** An edge for our `Classification`. May be used by Relay 1. */
  classificationEdge?: Maybe<ClassificationsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedClassificationNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `Classification` mutation. */
export type DeleteClassificationPayloadClassificationEdgeArgs = {
  orderBy?: InputMaybe<Array<ClassificationsOrderBy>>;
};

/** All input for the `deleteClassificationResultByAssessmentIdAndClassificationId` mutation. */
export type DeleteClassificationResultByAssessmentIdAndClassificationIdInput = {
  /** References the assessment in which this classification was found. */
  assessmentId: Scalars['Int']['input'];
  /** References the classification that was triggered. */
  classificationId: Scalars['Int']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** All input for the `deleteClassificationResult` mutation. */
export type DeleteClassificationResultInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifier of the classification result. */
  id: Scalars['Int']['input'];
};

/** The output of our delete `ClassificationResult` mutation. */
export type DeleteClassificationResultPayload = {
  __typename?: 'DeleteClassificationResultPayload';
  /** Reads a single `Assessment` that is related to this `ClassificationResult`. */
  assessment?: Maybe<Assessment>;
  /** Reads a single `Classification` that is related to this `ClassificationResult`. */
  classification?: Maybe<Classification>;
  /** The `ClassificationResult` that was deleted by this mutation. */
  classificationResult?: Maybe<ClassificationResult>;
  /** An edge for our `ClassificationResult`. May be used by Relay 1. */
  classificationResultEdge?: Maybe<ClassificationResultsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedClassificationResultNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `ClassificationResult` mutation. */
export type DeleteClassificationResultPayloadClassificationResultEdgeArgs = {
  orderBy?: InputMaybe<Array<ClassificationResultsOrderBy>>;
};

/** All input for the `deleteComplianceGroupByLabel` mutation. */
export type DeleteComplianceGroupByLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The unique label of the compliance group (ex: Freezer, Cooler, Ice Cream Freezer) */
  label: Scalars['String']['input'];
};

/** All input for the `deleteComplianceGroup` mutation. */
export type DeleteComplianceGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the compliance group */
  id: Scalars['Int']['input'];
};

/** The output of our delete `ComplianceGroup` mutation. */
export type DeleteComplianceGroupPayload = {
  __typename?: 'DeleteComplianceGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `ComplianceGroup` that was deleted by this mutation. */
  complianceGroup?: Maybe<ComplianceGroup>;
  /** An edge for our `ComplianceGroup`. May be used by Relay 1. */
  complianceGroupEdge?: Maybe<ComplianceGroupsEdge>;
  deletedComplianceGroupNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `ComplianceGroup` mutation. */
export type DeleteComplianceGroupPayloadComplianceGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<ComplianceGroupsOrderBy>>;
};

/** All input for the `deleteComplianceRangeByComplianceGroupIdAndLabel` mutation. */
export type DeleteComplianceRangeByComplianceGroupIdAndLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The group this compliance range belongs to */
  complianceGroupId: Scalars['Int']['input'];
  /** The unique label of the compliance range (ex: Out of Compliance, Above Compliance) */
  label: Scalars['String']['input'];
};

/** All input for the `deleteComplianceRange` mutation. */
export type DeleteComplianceRangeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the compliance range */
  id: Scalars['Int']['input'];
};

/** The output of our delete `ComplianceRange` mutation. */
export type DeleteComplianceRangePayload = {
  __typename?: 'DeleteComplianceRangePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `ComplianceGroup` that is related to this `ComplianceRange`. */
  complianceGroup?: Maybe<ComplianceGroup>;
  /** The `ComplianceRange` that was deleted by this mutation. */
  complianceRange?: Maybe<ComplianceRange>;
  /** An edge for our `ComplianceRange`. May be used by Relay 1. */
  complianceRangeEdge?: Maybe<ComplianceRangesEdge>;
  deletedComplianceRangeNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `ComplianceRange` mutation. */
export type DeleteComplianceRangePayloadComplianceRangeEdgeArgs = {
  orderBy?: InputMaybe<Array<ComplianceRangesOrderBy>>;
};

/** All input for the `deleteComponent` mutation. */
export type DeleteComponentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifier of the component */
  id: Scalars['Int']['input'];
};

/** The output of our delete `Component` mutation. */
export type DeleteComponentPayload = {
  __typename?: 'DeleteComponentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Component` that was deleted by this mutation. */
  component?: Maybe<Component>;
  /** An edge for our `Component`. May be used by Relay 1. */
  componentEdge?: Maybe<ComponentsEdge>;
  deletedComponentNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Facility` that is related to this `Component`. */
  facility?: Maybe<Facility>;
  /** Reads a single `MachineUser` that is related to this `Component`. */
  machineUser?: Maybe<MachineUser>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `Component` mutation. */
export type DeleteComponentPayloadComponentEdgeArgs = {
  orderBy?: InputMaybe<Array<ComponentsOrderBy>>;
};

/** All input for the `deleteCompressorByFacilityIdAndLabel` mutation. */
export type DeleteCompressorByFacilityIdAndLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The facility a compressor is installed within */
  facilityId: Scalars['Int']['input'];
  /** A human-readable label for a compressor */
  label: Scalars['String']['input'];
};

/** All input for the `deleteCompressor` mutation. */
export type DeleteCompressorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the compressor. */
  id: Scalars['Int']['input'];
};

/** The output of our delete `Compressor` mutation. */
export type DeleteCompressorPayload = {
  __typename?: 'DeleteCompressorPayload';
  /** Reads a single `BuildingArea` that is related to this `Compressor`. */
  buildingArea?: Maybe<BuildingArea>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  capacity?: Maybe<DataPoint>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Compressor` that was deleted by this mutation. */
  compressor?: Maybe<Compressor>;
  /** An edge for our `Compressor`. May be used by Relay 1. */
  compressorEdge?: Maybe<CompressorsEdge>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  controlMode?: Maybe<DataPoint>;
  deletedCompressorNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  differentialPressure?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  dischargePressure?: Maybe<DataPoint>;
  /** Reads a single `Facility` that is related to this `Compressor`. */
  facility?: Maybe<Facility>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  kwDemand?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  motorAmps?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  motorState?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  oilPressure?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  oilTemperature?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  onStatus?: Maybe<DataPoint>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RefrigerationSystem` that is related to this `Compressor`. */
  refrigerationSystem?: Maybe<RefrigerationSystem>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  runtimeHours?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  setpoint?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  slideValvePosition?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  state?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  suctionPressure?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  suctionPressureSetpointDeviation?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  suctionTemperature?: Maybe<DataPoint>;
};

/** The output of our delete `Compressor` mutation. */
export type DeleteCompressorPayloadCompressorEdgeArgs = {
  orderBy?: InputMaybe<Array<CompressorsOrderBy>>;
};

/** All input for the `deleteControlEvent` mutation. */
export type DeleteControlEventInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifier of the control event */
  id: Scalars['Int']['input'];
};

/** All input for the `deleteControlEventLog` mutation. */
export type DeleteControlEventLogInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifier of the control event log entry */
  id: Scalars['Int']['input'];
};

/** The output of our delete `ControlEventLog` mutation. */
export type DeleteControlEventLogPayload = {
  __typename?: 'DeleteControlEventLogPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `ControlEvent` that is related to this `ControlEventLog`. */
  controlEvent?: Maybe<ControlEvent>;
  /** The `ControlEventLog` that was deleted by this mutation. */
  controlEventLog?: Maybe<ControlEventLog>;
  /** An edge for our `ControlEventLog`. May be used by Relay 1. */
  controlEventLogEdge?: Maybe<ControlEventLogsEdge>;
  deletedControlEventLogNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `ControlEventLog` mutation. */
export type DeleteControlEventLogPayloadControlEventLogEdgeArgs = {
  orderBy?: InputMaybe<Array<ControlEventLogsOrderBy>>;
};

/** The output of our delete `ControlEvent` mutation. */
export type DeleteControlEventPayload = {
  __typename?: 'DeleteControlEventPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Component` that is related to this `ControlEvent`. */
  component?: Maybe<Component>;
  /** The `ControlEvent` that was deleted by this mutation. */
  controlEvent?: Maybe<ControlEvent>;
  /** An edge for our `ControlEvent`. May be used by Relay 1. */
  controlEventEdge?: Maybe<ControlEventsEdge>;
  deletedControlEventNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `ControlEvent` mutation. */
export type DeleteControlEventPayloadControlEventEdgeArgs = {
  orderBy?: InputMaybe<Array<ControlEventsOrderBy>>;
};

/** All input for the `deleteCustomerBySourceId` mutation. */
export type DeleteCustomerBySourceIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique external identifier of the record from the original source system */
  sourceId: Scalars['String']['input'];
};

/** All input for the `deleteCustomer` mutation. */
export type DeleteCustomerInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `Customer` mutation. */
export type DeleteCustomerPayload = {
  __typename?: 'DeleteCustomerPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Customer` that was deleted by this mutation. */
  customer?: Maybe<Customer>;
  /** An edge for our `Customer`. May be used by Relay 1. */
  customerEdge?: Maybe<CustomersEdge>;
  deletedCustomerNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Facility` that is related to this `Customer`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `Customer` mutation. */
export type DeleteCustomerPayloadCustomerEdgeArgs = {
  orderBy?: InputMaybe<Array<CustomersOrderBy>>;
};

/** All input for the `deleteDashboard` mutation. */
export type DeleteDashboardInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** The output of our delete `Dashboard` mutation. */
export type DeleteDashboardPayload = {
  __typename?: 'DeleteDashboardPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Dashboard` that was deleted by this mutation. */
  dashboard?: Maybe<Dashboard>;
  /** An edge for our `Dashboard`. May be used by Relay 1. */
  dashboardEdge?: Maybe<DashboardsEdge>;
  deletedDashboardNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Facility` that is related to this `Dashboard`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `Dashboard` mutation. */
export type DeleteDashboardPayloadDashboardEdgeArgs = {
  orderBy?: InputMaybe<Array<DashboardsOrderBy>>;
};

/** All input for the `deleteDataPointByDataSourceNameAndName` mutation. */
export type DeleteDataPointByDataSourceNameAndNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dataSourceName: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

/** All input for the `deleteDataPoint` mutation. */
export type DeleteDataPointInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `DataPoint` mutation. */
export type DeleteDataPointPayload = {
  __typename?: 'DeleteDataPointPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `DataPoint` that was deleted by this mutation. */
  dataPoint?: Maybe<DataPoint>;
  /** An edge for our `DataPoint`. May be used by Relay 1. */
  dataPointEdge?: Maybe<DataPointsEdge>;
  /** Reads a single `DataSource` that is related to this `DataPoint`. */
  dataSource?: Maybe<DataSource>;
  deletedDataPointNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `DataPoint` mutation. */
export type DeleteDataPointPayloadDataPointEdgeArgs = {
  orderBy?: InputMaybe<Array<DataPointsOrderBy>>;
};

/** All input for the `deleteDataSource` mutation. */
export type DeleteDataSourceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The data source name. */
  name: Scalars['String']['input'];
};

/** The output of our delete `DataSource` mutation. */
export type DeleteDataSourcePayload = {
  __typename?: 'DeleteDataSourcePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `DataSource` that was deleted by this mutation. */
  dataSource?: Maybe<DataSource>;
  /** An edge for our `DataSource`. May be used by Relay 1. */
  dataSourceEdge?: Maybe<DataSourcesEdge>;
  deletedDataSourceNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `DataSource` mutation. */
export type DeleteDataSourcePayloadDataSourceEdgeArgs = {
  orderBy?: InputMaybe<Array<DataSourcesOrderBy>>;
};

/** All input for the `deleteDependencyByPath` mutation. */
export type DeleteDependencyByPathInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  path: Scalars['String']['input'];
};

/** All input for the `deleteDependency` mutation. */
export type DeleteDependencyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `Dependency` mutation. */
export type DeleteDependencyPayload = {
  __typename?: 'DeleteDependencyPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedDependencyNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `Dependency` that was deleted by this mutation. */
  dependency?: Maybe<Dependency>;
  /** An edge for our `Dependency`. May be used by Relay 1. */
  dependencyEdge?: Maybe<DependenciesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `Dependency` mutation. */
export type DeleteDependencyPayloadDependencyEdgeArgs = {
  orderBy?: InputMaybe<Array<DependenciesOrderBy>>;
};

/** All input for the `deleteDischargeHeaderByRefrigerationSystemIdAndLabel` mutation. */
export type DeleteDischargeHeaderByRefrigerationSystemIdAndLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The display label of the discharge header. */
  label: Scalars['String']['input'];
  /** References the refrigeration system this discharge header belongs to. */
  refrigerationSystemId: Scalars['Int']['input'];
};

/** All input for the `deleteDischargeHeader` mutation. */
export type DeleteDischargeHeaderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The unique identifier for the discharge header. */
  id: Scalars['Int']['input'];
};

/** The output of our delete `DischargeHeader` mutation. */
export type DeleteDischargeHeaderPayload = {
  __typename?: 'DeleteDischargeHeaderPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedDischargeHeaderNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `DischargeHeader` that was deleted by this mutation. */
  dischargeHeader?: Maybe<DischargeHeader>;
  /** An edge for our `DischargeHeader`. May be used by Relay 1. */
  dischargeHeaderEdge?: Maybe<DischargeHeadersEdge>;
  /** Reads a single `DataPoint` that is related to this `DischargeHeader`. */
  dischargePressure?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `DischargeHeader`. */
  dischargePressureSetpoint?: Maybe<DataPoint>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RefrigerationSystem` that is related to this `DischargeHeader`. */
  refrigerationSystem?: Maybe<RefrigerationSystem>;
};

/** The output of our delete `DischargeHeader` mutation. */
export type DeleteDischargeHeaderPayloadDischargeHeaderEdgeArgs = {
  orderBy?: InputMaybe<Array<DischargeHeadersOrderBy>>;
};

/** All input for the `deleteDoorByFacilityIdAndLabel` mutation. */
export type DeleteDoorByFacilityIdAndLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The facility where the door is located */
  facilityId: Scalars['Int']['input'];
  /** The Human-readable label for the door */
  label: Scalars['String']['input'];
};

/** All input for the `deleteDoor` mutation. */
export type DeleteDoorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the door */
  id: Scalars['Int']['input'];
};

/** The output of our delete `Door` mutation. */
export type DeleteDoorPayload = {
  __typename?: 'DeleteDoorPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedDoorNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `Door` that was deleted by this mutation. */
  door?: Maybe<Door>;
  /** An edge for our `Door`. May be used by Relay 1. */
  doorEdge?: Maybe<DoorsEdge>;
  /** Reads a single `DataPoint` that is related to this `Door`. */
  doorState?: Maybe<DataPoint>;
  /** Reads a single `Facility` that is related to this `Door`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `Door` mutation. */
export type DeleteDoorPayloadDoorEdgeArgs = {
  orderBy?: InputMaybe<Array<DoorsOrderBy>>;
};

/** All input for the `deleteElectricalCircuit` mutation. */
export type DeleteElectricalCircuitInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifier of the record. */
  id: Scalars['Int']['input'];
};

/** The output of our delete `ElectricalCircuit` mutation. */
export type DeleteElectricalCircuitPayload = {
  __typename?: 'DeleteElectricalCircuitPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedElectricalCircuitNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `ElectricalCircuit` that was deleted by this mutation. */
  electricalCircuit?: Maybe<ElectricalCircuit>;
  /** An edge for our `ElectricalCircuit`. May be used by Relay 1. */
  electricalCircuitEdge?: Maybe<ElectricalCircuitsEdge>;
  /** Reads a single `ElectricalMeteringPoint` that is related to this `ElectricalCircuit`. */
  electricalMeteringPoint?: Maybe<ElectricalMeteringPoint>;
  /** Reads a single `ElectricalPanel` that is related to this `ElectricalCircuit`. */
  electricalPanel?: Maybe<ElectricalPanel>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `ElectricalCircuit` mutation. */
export type DeleteElectricalCircuitPayloadElectricalCircuitEdgeArgs = {
  orderBy?: InputMaybe<Array<ElectricalCircuitsOrderBy>>;
};

/** All input for the `deleteElectricalMeteringPoint` mutation. */
export type DeleteElectricalMeteringPointInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifier of the record. */
  id: Scalars['Int']['input'];
};

/** The output of our delete `ElectricalMeteringPoint` mutation. */
export type DeleteElectricalMeteringPointPayload = {
  __typename?: 'DeleteElectricalMeteringPointPayload';
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  apparentPower?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  apparentPowerPhaseA?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  apparentPowerPhaseB?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  apparentPowerPhaseC?: Maybe<DataPoint>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  crestFactorPhaseA?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  crestFactorPhaseB?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  crestFactorPhaseC?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  cumulativeKwh?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  current?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  currentAmplitudeImbalance?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  currentAverage?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  currentThdAverage?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  currentThdPhaseA?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  currentThdPhaseB?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  currentThdPhaseC?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  currentUnbalanceFactor?: Maybe<DataPoint>;
  deletedElectricalMeteringPointNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  demandPhaseA?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  demandPhaseB?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  demandPhaseC?: Maybe<DataPoint>;
  /** The `ElectricalMeteringPoint` that was deleted by this mutation. */
  electricalMeteringPoint?: Maybe<ElectricalMeteringPoint>;
  /** An edge for our `ElectricalMeteringPoint`. May be used by Relay 1. */
  electricalMeteringPointEdge?: Maybe<ElectricalMeteringPointsEdge>;
  /** Reads a single `Facility` that is related to this `ElectricalMeteringPoint`. */
  facility?: Maybe<Facility>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  frequency?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  frequencyDeviation?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  generatedEnergy?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  kwDemand?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  lineToLineDeviationAverage?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  lineToLineVoltage?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  lineToLineVoltageAb?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  lineToLineVoltageBc?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  lineToLineVoltageCa?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  lineToNeutralDeviationAverage?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  lineToNeutralVoltage?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  lineToNeutralVoltageA?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  lineToNeutralVoltageB?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  lineToNeutralVoltageC?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  netEnergy?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  neutralCurrent?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  phaseACurrent?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  phaseACurrentDeviation?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  phaseAVoltage?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  phaseAVoltageDeviation?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  phaseBCurrent?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  phaseBCurrentDeviation?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  phaseBVoltage?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  phaseBVoltageDeviation?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  phaseCCurrent?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  phaseCCurrentDeviation?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  phaseCVoltage?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  phaseCVoltageDeviation?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  powerFactor?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  powerFactorPhaseA?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  powerFactorPhaseB?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  powerFactorPhaseC?: Maybe<DataPoint>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  reactivePower?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  reactivePowerPhaseA?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  reactivePowerPhaseB?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  reactivePowerPhaseC?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  totalEnergy?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  voltageAmplitudeImbalance?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  voltageAverage?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  voltageThdAverage?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  voltageThdPhaseA?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  voltageThdPhaseB?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  voltageThdPhaseC?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  voltageUnbalanceFactor?: Maybe<DataPoint>;
};

/** The output of our delete `ElectricalMeteringPoint` mutation. */
export type DeleteElectricalMeteringPointPayloadElectricalMeteringPointEdgeArgs =
  {
    orderBy?: InputMaybe<Array<ElectricalMeteringPointsOrderBy>>;
  };

/** All input for the `deleteElectricalPanelByElectricalMeteringPointId` mutation. */
export type DeleteElectricalPanelByElectricalMeteringPointIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The electrical metering point where this panel is monitored. */
  electricalMeteringPointId: Scalars['Int']['input'];
};

/** All input for the `deleteElectricalPanel` mutation. */
export type DeleteElectricalPanelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifier of the record. */
  id: Scalars['Int']['input'];
};

/** The output of our delete `ElectricalPanel` mutation. */
export type DeleteElectricalPanelPayload = {
  __typename?: 'DeleteElectricalPanelPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedElectricalPanelNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `ElectricalMeteringPoint` that is related to this `ElectricalPanel`. */
  electricalMeteringPoint?: Maybe<ElectricalMeteringPoint>;
  /** The `ElectricalPanel` that was deleted by this mutation. */
  electricalPanel?: Maybe<ElectricalPanel>;
  /** An edge for our `ElectricalPanel`. May be used by Relay 1. */
  electricalPanelEdge?: Maybe<ElectricalPanelsEdge>;
  /** Reads a single `Facility` that is related to this `ElectricalPanel`. */
  facility?: Maybe<Facility>;
  /** Reads a single `ElectricalCircuit` that is related to this `ElectricalPanel`. */
  parentCircuit?: Maybe<ElectricalCircuit>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `ElectricalPanel` mutation. */
export type DeleteElectricalPanelPayloadElectricalPanelEdgeArgs = {
  orderBy?: InputMaybe<Array<ElectricalPanelsOrderBy>>;
};

/** All input for the `deleteEvaporatorByFacilityIdAndLabel` mutation. */
export type DeleteEvaporatorByFacilityIdAndLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The facility an evaporator is installed within */
  facilityId: Scalars['Int']['input'];
  /** A human-readable label */
  label: Scalars['String']['input'];
};

/** All input for the `deleteEvaporator` mutation. */
export type DeleteEvaporatorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the evaporator */
  id: Scalars['Int']['input'];
};

/** The output of our delete `Evaporator` mutation. */
export type DeleteEvaporatorPayload = {
  __typename?: 'DeleteEvaporatorPayload';
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  ammoniaState?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  bleedSolenoid?: Maybe<DataPoint>;
  /** Reads a single `BuildingArea` that is related to this `Evaporator`. */
  buildingArea?: Maybe<BuildingArea>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  defrostState?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  defrostTemperature?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  defrostTimer?: Maybe<DataPoint>;
  deletedEvaporatorNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  differentialAirTemperature?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  estimatedKwDemand?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  evapState?: Maybe<DataPoint>;
  /** The `Evaporator` that was deleted by this mutation. */
  evaporator?: Maybe<Evaporator>;
  /** An edge for our `Evaporator`. May be used by Relay 1. */
  evaporatorEdge?: Maybe<EvaporatorsEdge>;
  /** Reads a single `Facility` that is related to this `Evaporator`. */
  facility?: Maybe<Facility>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  fanState?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  fanTimer?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  hotGasSolenoid?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  liquidFeedRuntime?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  liquidFeedRuntimeSetpoint?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  liquidSolenoid?: Maybe<DataPoint>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RefrigerationSystem` that is related to this `Evaporator`. */
  refrigerationSystem?: Maybe<RefrigerationSystem>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  returnAirTemperature?: Maybe<DataPoint>;
  /** Reads a single `SuctionHeader` that is related to this `Evaporator`. */
  returnSuctionHeader?: Maybe<SuctionHeader>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  setpoint?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  softHotGasSolenoid?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  suctionPressure?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  suctionSolenoid?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  suctionTemperature?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  supplyAirTemperature?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  zoneTemperature?: Maybe<DataPoint>;
};

/** The output of our delete `Evaporator` mutation. */
export type DeleteEvaporatorPayloadEvaporatorEdgeArgs = {
  orderBy?: InputMaybe<Array<EvaporatorsOrderBy>>;
};

/** All input for the `deleteFacilityBySlug` mutation. */
export type DeleteFacilityBySlugInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The facility’s slug. */
  slug: Scalars['String']['input'];
};

/** All input for the `deleteFacilityCheckByFacilityIdAndCheckId` mutation. */
export type DeleteFacilityCheckByFacilityIdAndCheckIdInput = {
  /** The check. */
  checkId: Scalars['Int']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The facility. */
  facilityId: Scalars['Int']['input'];
};

/** All input for the `deleteFacilityCheck` mutation. */
export type DeleteFacilityCheckInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifier of the facility check */
  id: Scalars['Int']['input'];
};

/** The output of our delete `FacilityCheck` mutation. */
export type DeleteFacilityCheckPayload = {
  __typename?: 'DeleteFacilityCheckPayload';
  /** Reads a single `Check` that is related to this `FacilityCheck`. */
  check?: Maybe<Check>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedFacilityCheckNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Facility` that is related to this `FacilityCheck`. */
  facility?: Maybe<Facility>;
  /** The `FacilityCheck` that was deleted by this mutation. */
  facilityCheck?: Maybe<FacilityCheck>;
  /** An edge for our `FacilityCheck`. May be used by Relay 1. */
  facilityCheckEdge?: Maybe<FacilityChecksEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `FacilityCheck` mutation. */
export type DeleteFacilityCheckPayloadFacilityCheckEdgeArgs = {
  orderBy?: InputMaybe<Array<FacilityChecksOrderBy>>;
};

/** All input for the `deleteFacilityCheckUser` mutation. */
export type DeleteFacilityCheckUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The facility check. */
  facilityCheckId: Scalars['Int']['input'];
  /** The user. */
  userId: Scalars['String']['input'];
};

/** The output of our delete `FacilityCheckUser` mutation. */
export type DeleteFacilityCheckUserPayload = {
  __typename?: 'DeleteFacilityCheckUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedFacilityCheckUserNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `FacilityCheckUser` that was deleted by this mutation. */
  facilityCheckUser?: Maybe<FacilityCheckUser>;
  /** An edge for our `FacilityCheckUser`. May be used by Relay 1. */
  facilityCheckUserEdge?: Maybe<FacilityCheckUsersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `FacilityCheckUser`. */
  user?: Maybe<User>;
};

/** The output of our delete `FacilityCheckUser` mutation. */
export type DeleteFacilityCheckUserPayloadFacilityCheckUserEdgeArgs = {
  orderBy?: InputMaybe<Array<FacilityCheckUsersOrderBy>>;
};

/** All input for the `deleteFacilityConfig` mutation. */
export type DeleteFacilityConfigInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `deleteFacilityConfig` mutation. */
export type DeleteFacilityConfigPayload = {
  __typename?: 'DeleteFacilityConfigPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `deleteFacilityDataSource` mutation. */
export type DeleteFacilityDataSourceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The data source for the facility. */
  dataSourceName: Scalars['String']['input'];
  /** The facility id for the data source. */
  facilityId: Scalars['Int']['input'];
};

/** The output of our delete `FacilityDataSource` mutation. */
export type DeleteFacilityDataSourcePayload = {
  __typename?: 'DeleteFacilityDataSourcePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DataSource` that is related to this `FacilityDataSource`. */
  dataSourceByDataSourceName?: Maybe<DataSource>;
  deletedFacilityDataSourceNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Facility` that is related to this `FacilityDataSource`. */
  facility?: Maybe<Facility>;
  /** The `FacilityDataSource` that was deleted by this mutation. */
  facilityDataSource?: Maybe<FacilityDataSource>;
  /** An edge for our `FacilityDataSource`. May be used by Relay 1. */
  facilityDataSourceEdge?: Maybe<FacilityDataSourcesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `FacilityDataSource` mutation. */
export type DeleteFacilityDataSourcePayloadFacilityDataSourceEdgeArgs = {
  orderBy?: InputMaybe<Array<FacilityDataSourcesOrderBy>>;
};

/** All input for the `deleteFacilityDocument` mutation. */
export type DeleteFacilityDocumentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** The output of our `deleteFacilityDocument` mutation. */
export type DeleteFacilityDocumentPayload = {
  __typename?: 'DeleteFacilityDocumentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `deleteFacilityGroup` mutation. */
export type DeleteFacilityGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The facility group’s id. */
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `FacilityGroup` mutation. */
export type DeleteFacilityGroupPayload = {
  __typename?: 'DeleteFacilityGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedFacilityGroupNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `FacilityGroup` that was deleted by this mutation. */
  facilityGroup?: Maybe<FacilityGroup>;
  /** An edge for our `FacilityGroup`. May be used by Relay 1. */
  facilityGroupEdge?: Maybe<FacilityGroupsEdge>;
  /** Reads a single `FacilityGroup` that is related to this `FacilityGroup`. */
  parent?: Maybe<FacilityGroup>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `FacilityGroup` mutation. */
export type DeleteFacilityGroupPayloadFacilityGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<FacilityGroupsOrderBy>>;
};

/** All input for the `deleteFacilityGroupsLinker` mutation. */
export type DeleteFacilityGroupsLinkerInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  facilityGroupingId: Scalars['BigInt']['input'];
  facilityId: Scalars['Int']['input'];
};

/** The output of our delete `FacilityGroupsLinker` mutation. */
export type DeleteFacilityGroupsLinkerPayload = {
  __typename?: 'DeleteFacilityGroupsLinkerPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedFacilityGroupsLinkerNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Facility` that is related to this `FacilityGroupsLinker`. */
  facility?: Maybe<Facility>;
  /** Reads a single `FacilityGroup` that is related to this `FacilityGroupsLinker`. */
  facilityGrouping?: Maybe<FacilityGroup>;
  /** The `FacilityGroupsLinker` that was deleted by this mutation. */
  facilityGroupsLinker?: Maybe<FacilityGroupsLinker>;
  /** An edge for our `FacilityGroupsLinker`. May be used by Relay 1. */
  facilityGroupsLinkerEdge?: Maybe<FacilityGroupsLinkersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `FacilityGroupsLinker` mutation. */
export type DeleteFacilityGroupsLinkerPayloadFacilityGroupsLinkerEdgeArgs = {
  orderBy?: InputMaybe<Array<FacilityGroupsLinkersOrderBy>>;
};

/** All input for the `deleteFacility` mutation. */
export type DeleteFacilityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The primary unique identifier for the facility. */
  id: Scalars['Int']['input'];
};

/** The output of our delete `Facility` mutation. */
export type DeleteFacilityPayload = {
  __typename?: 'DeleteFacilityPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedFacilityNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `Facility` that was deleted by this mutation. */
  facility?: Maybe<Facility>;
  /** An edge for our `Facility`. May be used by Relay 1. */
  facilityEdge?: Maybe<FacilitiesEdge>;
  /** Reads a single `PricingNode` that is related to this `Facility`. */
  pricingNode?: Maybe<PricingNode>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Timezone` that is related to this `Facility`. */
  timezone?: Maybe<Timezone>;
  /** Reads a single `UnitGroup` that is related to this `Facility`. */
  unitGroupItem?: Maybe<UnitGroup>;
};

/** The output of our delete `Facility` mutation. */
export type DeleteFacilityPayloadFacilityEdgeArgs = {
  orderBy?: InputMaybe<Array<FacilitiesOrderBy>>;
};

/** All input for the `deleteFacilitySoftwarePackageByFacilityIdAndSoftwarePackageId` mutation. */
export type DeleteFacilitySoftwarePackageByFacilityIdAndSoftwarePackageIdInput =
  {
    /**
     * An arbitrary string value with no semantic meaning. Will be included in the
     * payload verbatim. May be used to track mutations by the client.
     */
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** The facility using the software package. */
    facilityId: Scalars['Int']['input'];
    /** The enabled software package. */
    softwarePackageId: Scalars['Int']['input'];
  };

/** All input for the `deleteFacilitySoftwarePackage` mutation. */
export type DeleteFacilitySoftwarePackageInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifer of the record. */
  id: Scalars['Int']['input'];
};

/** The output of our delete `FacilitySoftwarePackage` mutation. */
export type DeleteFacilitySoftwarePackagePayload = {
  __typename?: 'DeleteFacilitySoftwarePackagePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedFacilitySoftwarePackageNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Facility` that is related to this `FacilitySoftwarePackage`. */
  facility?: Maybe<Facility>;
  /** The `FacilitySoftwarePackage` that was deleted by this mutation. */
  facilitySoftwarePackage?: Maybe<FacilitySoftwarePackage>;
  /** An edge for our `FacilitySoftwarePackage`. May be used by Relay 1. */
  facilitySoftwarePackageEdge?: Maybe<FacilitySoftwarePackagesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SoftwarePackage` that is related to this `FacilitySoftwarePackage`. */
  softwarePackage?: Maybe<SoftwarePackage>;
};

/** The output of our delete `FacilitySoftwarePackage` mutation. */
export type DeleteFacilitySoftwarePackagePayloadFacilitySoftwarePackageEdgeArgs =
  {
    orderBy?: InputMaybe<Array<FacilitySoftwarePackagesOrderBy>>;
  };

/** All input for the `deleteFacilityTaggedDataPoint` mutation. */
export type DeleteFacilityTaggedDataPointInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** The output of our delete `FacilityTaggedDataPoint` mutation. */
export type DeleteFacilityTaggedDataPointPayload = {
  __typename?: 'DeleteFacilityTaggedDataPointPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DataPoint` that is related to this `FacilityTaggedDataPoint`. */
  dataPoint?: Maybe<DataPoint>;
  deletedFacilityTaggedDataPointNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Facility` that is related to this `FacilityTaggedDataPoint`. */
  facility?: Maybe<Facility>;
  /** The `FacilityTaggedDataPoint` that was deleted by this mutation. */
  facilityTaggedDataPoint?: Maybe<FacilityTaggedDataPoint>;
  /** An edge for our `FacilityTaggedDataPoint`. May be used by Relay 1. */
  facilityTaggedDataPointEdge?: Maybe<FacilityTaggedDataPointsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DataPointTag` that is related to this `FacilityTaggedDataPoint`. */
  tag?: Maybe<DataPointTag>;
};

/** The output of our delete `FacilityTaggedDataPoint` mutation. */
export type DeleteFacilityTaggedDataPointPayloadFacilityTaggedDataPointEdgeArgs =
  {
    orderBy?: InputMaybe<Array<FacilityTaggedDataPointsOrderBy>>;
  };

/** All input for the `deleteGatewayByFacilityIdAndHardwareId` mutation. */
export type DeleteGatewayByFacilityIdAndHardwareIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The facility where the gateway is installed. */
  facilityId: Scalars['Int']['input'];
  /** The hardware ID for the gateway. */
  hardwareId: Scalars['String']['input'];
};

/** All input for the `deleteGatewayByFacilityIdAndLabel` mutation. */
export type DeleteGatewayByFacilityIdAndLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The facility where the gateway is installed. */
  facilityId: Scalars['Int']['input'];
  /** The human-readable label for the gateway. */
  label: Scalars['String']['input'];
};

/** All input for the `deleteGateway` mutation. */
export type DeleteGatewayInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifier of the gateway. */
  id: Scalars['Int']['input'];
};

/** The output of our delete `Gateway` mutation. */
export type DeleteGatewayPayload = {
  __typename?: 'DeleteGatewayPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedGatewayNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Facility` that is related to this `Gateway`. */
  facility?: Maybe<Facility>;
  /** The `Gateway` that was deleted by this mutation. */
  gateway?: Maybe<Gateway>;
  /** An edge for our `Gateway`. May be used by Relay 1. */
  gatewayEdge?: Maybe<GatewaysEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DataPoint` that is related to this `Gateway`. */
  status?: Maybe<DataPoint>;
};

/** The output of our delete `Gateway` mutation. */
export type DeleteGatewayPayloadGatewayEdgeArgs = {
  orderBy?: InputMaybe<Array<GatewaysOrderBy>>;
};

/** All input for the `deleteInboundOutboundLoadBySourceId` mutation. */
export type DeleteInboundOutboundLoadBySourceIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique external identifier of the record from the original source system */
  sourceId: Scalars['String']['input'];
};

/** All input for the `deleteInboundOutboundLoad` mutation. */
export type DeleteInboundOutboundLoadInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `InboundOutboundLoad` mutation. */
export type DeleteInboundOutboundLoadPayload = {
  __typename?: 'DeleteInboundOutboundLoadPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedInboundOutboundLoadNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Facility` that is related to this `InboundOutboundLoad`. */
  facility?: Maybe<Facility>;
  /** The `InboundOutboundLoad` that was deleted by this mutation. */
  inboundOutboundLoad?: Maybe<InboundOutboundLoad>;
  /** An edge for our `InboundOutboundLoad`. May be used by Relay 1. */
  inboundOutboundLoadEdge?: Maybe<InboundOutboundLoadsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `InboundOutboundLoad` mutation. */
export type DeleteInboundOutboundLoadPayloadInboundOutboundLoadEdgeArgs = {
  orderBy?: InputMaybe<Array<InboundOutboundLoadsOrderBy>>;
};

/** All input for the `deleteIncidentByCheckMonitorIdAndMonitorDetectionId` mutation. */
export type DeleteIncidentByCheckMonitorIdAndMonitorDetectionIdInput = {
  /** The check monitor. */
  checkMonitorId: Scalars['Int']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The monitor detection. */
  monitorDetectionId: Scalars['BigInt']['input'];
};

/** All input for the `deleteIncident` mutation. */
export type DeleteIncidentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifier of the incident. */
  id: Scalars['Int']['input'];
};

/** All input for the `deleteIncidentLogByIncidentIdAndEventAndTime` mutation. */
export type DeleteIncidentLogByIncidentIdAndEventAndTimeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The type of event for the log. */
  event: Scalars['String']['input'];
  /** The incident. */
  incidentId: Scalars['Int']['input'];
  /** The time when the log occurred. */
  time: Scalars['Datetime']['input'];
};

/** The output of our delete `IncidentLog` mutation. */
export type DeleteIncidentLogPayload = {
  __typename?: 'DeleteIncidentLogPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedIncidentLogNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Incident` that is related to this `IncidentLog`. */
  incident?: Maybe<Incident>;
  /** The `IncidentLog` that was deleted by this mutation. */
  incidentLog?: Maybe<IncidentLog>;
  /** An edge for our `IncidentLog`. May be used by Relay 1. */
  incidentLogEdge?: Maybe<IncidentLogsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `IncidentLog` mutation. */
export type DeleteIncidentLogPayloadIncidentLogEdgeArgs = {
  orderBy?: InputMaybe<Array<IncidentLogsOrderBy>>;
};

/** The output of our delete `Incident` mutation. */
export type DeleteIncidentPayload = {
  __typename?: 'DeleteIncidentPayload';
  /** Reads a single `CheckMonitor` that is related to this `Incident`. */
  checkMonitor?: Maybe<CheckMonitor>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedIncidentNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `Incident` that was deleted by this mutation. */
  incident?: Maybe<Incident>;
  /** An edge for our `Incident`. May be used by Relay 1. */
  incidentEdge?: Maybe<IncidentsEdge>;
  /** Reads a single `MonitorDetection` that is related to this `Incident`. */
  monitorDetection?: Maybe<MonitorDetection>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `Incident` mutation. */
export type DeleteIncidentPayloadIncidentEdgeArgs = {
  orderBy?: InputMaybe<Array<IncidentsOrderBy>>;
};

/** All input for the `deleteLiquidHeaderByRefrigerationSystemIdAndLabel` mutation. */
export type DeleteLiquidHeaderByRefrigerationSystemIdAndLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The display label of the liquid header. */
  label: Scalars['String']['input'];
  /** References the refrigeration system this liquid header belongs to. */
  refrigerationSystemId: Scalars['Int']['input'];
};

/** All input for the `deleteLiquidHeader` mutation. */
export type DeleteLiquidHeaderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The unique identifier for the liquid header. */
  id: Scalars['Int']['input'];
};

/** The output of our delete `LiquidHeader` mutation. */
export type DeleteLiquidHeaderPayload = {
  __typename?: 'DeleteLiquidHeaderPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedLiquidHeaderNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `LiquidHeader` that was deleted by this mutation. */
  liquidHeader?: Maybe<LiquidHeader>;
  /** An edge for our `LiquidHeader`. May be used by Relay 1. */
  liquidHeaderEdge?: Maybe<LiquidHeadersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RefrigerationSystem` that is related to this `LiquidHeader`. */
  refrigerationSystem?: Maybe<RefrigerationSystem>;
  /** Reads a single `Vessel` that is related to this `LiquidHeader`. */
  vessel?: Maybe<Vessel>;
};

/** The output of our delete `LiquidHeader` mutation. */
export type DeleteLiquidHeaderPayloadLiquidHeaderEdgeArgs = {
  orderBy?: InputMaybe<Array<LiquidHeadersOrderBy>>;
};

/** All input for the `deleteLiquidHeadersEvaporatorByLiquidHeaderIdAndEvaporatorId` mutation. */
export type DeleteLiquidHeadersEvaporatorByLiquidHeaderIdAndEvaporatorIdInput =
  {
    /**
     * An arbitrary string value with no semantic meaning. Will be included in the
     * payload verbatim. May be used to track mutations by the client.
     */
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** References the evaporator connection */
    evaporatorId: Scalars['Int']['input'];
    /** References the liquid header connection */
    liquidHeaderId: Scalars['Int']['input'];
  };

/** All input for the `deleteLiquidHeadersEvaporator` mutation. */
export type DeleteLiquidHeadersEvaporatorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** The output of our delete `LiquidHeadersEvaporator` mutation. */
export type DeleteLiquidHeadersEvaporatorPayload = {
  __typename?: 'DeleteLiquidHeadersEvaporatorPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedLiquidHeadersEvaporatorNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Evaporator` that is related to this `LiquidHeadersEvaporator`. */
  evaporator?: Maybe<Evaporator>;
  /** Reads a single `LiquidHeader` that is related to this `LiquidHeadersEvaporator`. */
  liquidHeader?: Maybe<LiquidHeader>;
  /** The `LiquidHeadersEvaporator` that was deleted by this mutation. */
  liquidHeadersEvaporator?: Maybe<LiquidHeadersEvaporator>;
  /** An edge for our `LiquidHeadersEvaporator`. May be used by Relay 1. */
  liquidHeadersEvaporatorEdge?: Maybe<LiquidHeadersEvaporatorsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `LiquidHeadersEvaporator` mutation. */
export type DeleteLiquidHeadersEvaporatorPayloadLiquidHeadersEvaporatorEdgeArgs =
  {
    orderBy?: InputMaybe<Array<LiquidHeadersEvaporatorsOrderBy>>;
  };

/** All input for the `deleteMachineUser` mutation. */
export type DeleteMachineUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifier of the machine user. */
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `MachineUser` mutation. */
export type DeleteMachineUserPayload = {
  __typename?: 'DeleteMachineUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedMachineUserNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `MachineUser` that was deleted by this mutation. */
  machineUser?: Maybe<MachineUser>;
  /** An edge for our `MachineUser`. May be used by Relay 1. */
  machineUserEdge?: Maybe<MachineUsersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `MachineUser` mutation. */
export type DeleteMachineUserPayloadMachineUserEdgeArgs = {
  orderBy?: InputMaybe<Array<MachineUsersOrderBy>>;
};

/** All input for the `deleteMainServiceByFacilityIdAndName` mutation. */
export type DeleteMainServiceByFacilityIdAndNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The facility this main service belongs to */
  facilityId: Scalars['Int']['input'];
  /** The name for this main service */
  name: Scalars['String']['input'];
};

/** All input for the `deleteMainServiceByFacilityIdAndUsageDataPointIdAndDemandDataPointId` mutation. */
export type DeleteMainServiceByFacilityIdAndUsageDataPointIdAndDemandDataPointIdInput =
  {
    /**
     * An arbitrary string value with no semantic meaning. Will be included in the
     * payload verbatim. May be used to track mutations by the client.
     */
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** The demand data point that represents this main service's contribution to/from the facility */
    demandDataPointId: Scalars['Int']['input'];
    /** The facility this main service belongs to */
    facilityId: Scalars['Int']['input'];
    /** The usage data point that represents this main service's contribution to/from the facility */
    usageDataPointId: Scalars['Int']['input'];
  };

/** All input for the `deleteMainService` mutation. */
export type DeleteMainServiceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the main service */
  id: Scalars['Int']['input'];
};

/** The output of our delete `MainService` mutation. */
export type DeleteMainServicePayload = {
  __typename?: 'DeleteMainServicePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedMainServiceNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `DataPoint` that is related to this `MainService`. */
  demand?: Maybe<DataPoint>;
  /** Reads a single `Facility` that is related to this `MainService`. */
  facility?: Maybe<Facility>;
  /** Reads a single `DataPoint` that is related to this `MainService`. */
  gridDemand?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `MainService`. */
  gridUsage?: Maybe<DataPoint>;
  /** The `MainService` that was deleted by this mutation. */
  mainService?: Maybe<MainService>;
  /** An edge for our `MainService`. May be used by Relay 1. */
  mainServiceEdge?: Maybe<MainServicesEdge>;
  /** Reads a single `DataPoint` that is related to this `MainService`. */
  meterDemand?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `MainService`. */
  meterUsage?: Maybe<DataPoint>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DataPoint` that is related to this `MainService`. */
  usage?: Maybe<DataPoint>;
};

/** The output of our delete `MainService` mutation. */
export type DeleteMainServicePayloadMainServiceEdgeArgs = {
  orderBy?: InputMaybe<Array<MainServicesOrderBy>>;
};

/** All input for the `deleteMeterCharge` mutation. */
export type DeleteMeterChargeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** The output of our `deleteMeterCharge` mutation. */
export type DeleteMeterChargePayload = {
  __typename?: 'DeleteMeterChargePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `deleteMeterStatement` mutation. */
export type DeleteMeterStatementInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** The output of our `deleteMeterStatement` mutation. */
export type DeleteMeterStatementPayload = {
  __typename?: 'DeleteMeterStatementPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `deleteMeterUsage` mutation. */
export type DeleteMeterUsageInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** The output of our `deleteMeterUsage` mutation. */
export type DeleteMeterUsagePayload = {
  __typename?: 'DeleteMeterUsagePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `deleteMonitorAttribute` mutation. */
export type DeleteMonitorAttributeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The attribute key. */
  key: Scalars['String']['input'];
  /** The monitor associated with this attribute. */
  monitorId: Scalars['Int']['input'];
};

/** The output of our delete `MonitorAttribute` mutation. */
export type DeleteMonitorAttributePayload = {
  __typename?: 'DeleteMonitorAttributePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedMonitorAttributeNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Monitor` that is related to this `MonitorAttribute`. */
  monitor?: Maybe<Monitor>;
  /** The `MonitorAttribute` that was deleted by this mutation. */
  monitorAttribute?: Maybe<MonitorAttribute>;
  /** An edge for our `MonitorAttribute`. May be used by Relay 1. */
  monitorAttributeEdge?: Maybe<MonitorAttributesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `MonitorAttribute` mutation. */
export type DeleteMonitorAttributePayloadMonitorAttributeEdgeArgs = {
  orderBy?: InputMaybe<Array<MonitorAttributesOrderBy>>;
};

/** All input for the `deleteMonitorDataPoint` mutation. */
export type DeleteMonitorDataPointInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The associated data point. */
  dataPointId: Scalars['Int']['input'];
  /** The associated monitor. */
  monitorId: Scalars['Int']['input'];
};

/** The output of our delete `MonitorDataPoint` mutation. */
export type DeleteMonitorDataPointPayload = {
  __typename?: 'DeleteMonitorDataPointPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DataPoint` that is related to this `MonitorDataPoint`. */
  dataPoint?: Maybe<DataPoint>;
  deletedMonitorDataPointNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Monitor` that is related to this `MonitorDataPoint`. */
  monitor?: Maybe<Monitor>;
  /** The `MonitorDataPoint` that was deleted by this mutation. */
  monitorDataPoint?: Maybe<MonitorDataPoint>;
  /** An edge for our `MonitorDataPoint`. May be used by Relay 1. */
  monitorDataPointEdge?: Maybe<MonitorDataPointsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `MonitorDataPoint` mutation. */
export type DeleteMonitorDataPointPayloadMonitorDataPointEdgeArgs = {
  orderBy?: InputMaybe<Array<MonitorDataPointsOrderBy>>;
};

/** All input for the `deleteMonitorDetection` mutation. */
export type DeleteMonitorDetectionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifer of the detected event. */
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `MonitorDetection` mutation. */
export type DeleteMonitorDetectionPayload = {
  __typename?: 'DeleteMonitorDetectionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedMonitorDetectionNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Monitor` that is related to this `MonitorDetection`. */
  monitor?: Maybe<Monitor>;
  /** The `MonitorDetection` that was deleted by this mutation. */
  monitorDetection?: Maybe<MonitorDetection>;
  /** An edge for our `MonitorDetection`. May be used by Relay 1. */
  monitorDetectionEdge?: Maybe<MonitorDetectionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `MonitorDetection` mutation. */
export type DeleteMonitorDetectionPayloadMonitorDetectionEdgeArgs = {
  orderBy?: InputMaybe<Array<MonitorDetectionsOrderBy>>;
};

/** All input for the `deleteMonitor` mutation. */
export type DeleteMonitorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifer of the monitor. */
  id: Scalars['Int']['input'];
};

/** The output of our delete `Monitor` mutation. */
export type DeleteMonitorPayload = {
  __typename?: 'DeleteMonitorPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedMonitorNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `Monitor` that was deleted by this mutation. */
  monitor?: Maybe<Monitor>;
  /** An edge for our `Monitor`. May be used by Relay 1. */
  monitorEdge?: Maybe<MonitorsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `Monitor` mutation. */
export type DeleteMonitorPayloadMonitorEdgeArgs = {
  orderBy?: InputMaybe<Array<MonitorsOrderBy>>;
};

/** All input for the `deleteMonitoredAsset` mutation. */
export type DeleteMonitoredAssetInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifier of the monitored asset. */
  id: Scalars['Int']['input'];
};

/** The output of our delete `MonitoredAsset` mutation. */
export type DeleteMonitoredAssetPayload = {
  __typename?: 'DeleteMonitoredAssetPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedMonitoredAssetNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `MonitoredAsset` that was deleted by this mutation. */
  monitoredAsset?: Maybe<MonitoredAsset>;
  /** An edge for our `MonitoredAsset`. May be used by Relay 1. */
  monitoredAssetEdge?: Maybe<MonitoredAssetsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `MonitoredAsset` mutation. */
export type DeleteMonitoredAssetPayloadMonitoredAssetEdgeArgs = {
  orderBy?: InputMaybe<Array<MonitoredAssetsOrderBy>>;
};

/** All input for the `deleteOpportunityAttachment` mutation. */
export type DeleteOpportunityAttachmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifier of the opportunity attachment. */
  id: Scalars['Int']['input'];
};

/** The output of our delete `OpportunityAttachment` mutation. */
export type DeleteOpportunityAttachmentPayload = {
  __typename?: 'DeleteOpportunityAttachmentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedOpportunityAttachmentNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Opportunity` that is related to this `OpportunityAttachment`. */
  opportunity?: Maybe<Opportunity>;
  /** The `OpportunityAttachment` that was deleted by this mutation. */
  opportunityAttachment?: Maybe<OpportunityAttachment>;
  /** An edge for our `OpportunityAttachment`. May be used by Relay 1. */
  opportunityAttachmentEdge?: Maybe<OpportunityAttachmentsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `OpportunityAttachment` mutation. */
export type DeleteOpportunityAttachmentPayloadOpportunityAttachmentEdgeArgs = {
  orderBy?: InputMaybe<Array<OpportunityAttachmentsOrderBy>>;
};

/** All input for the `deleteOpportunity` mutation. */
export type DeleteOpportunityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifier of the opportunity. */
  id: Scalars['Int']['input'];
};

/** The output of our delete `Opportunity` mutation. */
export type DeleteOpportunityPayload = {
  __typename?: 'DeleteOpportunityPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedOpportunityNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Facility` that is related to this `Opportunity`. */
  facility?: Maybe<Facility>;
  /** The `Opportunity` that was deleted by this mutation. */
  opportunity?: Maybe<Opportunity>;
  /** An edge for our `Opportunity`. May be used by Relay 1. */
  opportunityEdge?: Maybe<OpportunitiesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `Opportunity` mutation. */
export type DeleteOpportunityPayloadOpportunityEdgeArgs = {
  orderBy?: InputMaybe<Array<OpportunitiesOrderBy>>;
};

/** All input for the `deletePalletBySourceId` mutation. */
export type DeletePalletBySourceIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique external identifier of the record from the original source system */
  sourceId: Scalars['String']['input'];
};

/** All input for the `deletePalletHistoryBySourceId` mutation. */
export type DeletePalletHistoryBySourceIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique external identifier of the record from the original source system */
  sourceId: Scalars['String']['input'];
};

/** All input for the `deletePalletHistory` mutation. */
export type DeletePalletHistoryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `PalletHistory` mutation. */
export type DeletePalletHistoryPayload = {
  __typename?: 'DeletePalletHistoryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedPalletHistoryNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `PalletHistory` that was deleted by this mutation. */
  palletHistory?: Maybe<PalletHistory>;
  /** An edge for our `PalletHistory`. May be used by Relay 1. */
  palletHistoryEdge?: Maybe<PalletHistoriesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `PalletHistory` mutation. */
export type DeletePalletHistoryPayloadPalletHistoryEdgeArgs = {
  orderBy?: InputMaybe<Array<PalletHistoriesOrderBy>>;
};

/** All input for the `deletePallet` mutation. */
export type DeletePalletInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['BigInt']['input'];
};

/** All input for the `deletePalletLocationBySourceId` mutation. */
export type DeletePalletLocationBySourceIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique external identifier of the record from the original source system */
  sourceId: Scalars['String']['input'];
};

/** All input for the `deletePalletLocation` mutation. */
export type DeletePalletLocationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `PalletLocation` mutation. */
export type DeletePalletLocationPayload = {
  __typename?: 'DeletePalletLocationPayload';
  /** Reads a single `BuildingArea` that is related to this `PalletLocation`. */
  buildingArea?: Maybe<BuildingArea>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedPalletLocationNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Facility` that is related to this `PalletLocation`. */
  facility?: Maybe<Facility>;
  /** The `PalletLocation` that was deleted by this mutation. */
  palletLocation?: Maybe<PalletLocation>;
  /** An edge for our `PalletLocation`. May be used by Relay 1. */
  palletLocationEdge?: Maybe<PalletLocationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `PalletLocation` mutation. */
export type DeletePalletLocationPayloadPalletLocationEdgeArgs = {
  orderBy?: InputMaybe<Array<PalletLocationsOrderBy>>;
};

/** The output of our delete `Pallet` mutation. */
export type DeletePalletPayload = {
  __typename?: 'DeletePalletPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedPalletNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `Pallet` that was deleted by this mutation. */
  pallet?: Maybe<Pallet>;
  /** An edge for our `Pallet`. May be used by Relay 1. */
  palletEdge?: Maybe<PalletsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `Pallet` mutation. */
export type DeletePalletPayloadPalletEdgeArgs = {
  orderBy?: InputMaybe<Array<PalletsOrderBy>>;
};

export type DeletePhoneNumberInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type DeletePhoneNumberResponse = {
  __typename?: 'DeletePhoneNumberResponse';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user: User;
};

/** All input for the `deletePricingNode` mutation. */
export type DeletePricingNodeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifer of the pricing node. */
  id: Scalars['Int']['input'];
};

/** The output of our delete `PricingNode` mutation. */
export type DeletePricingNodePayload = {
  __typename?: 'DeletePricingNodePayload';
  /** Reads a single `BalancingAuthority` that is related to this `PricingNode`. */
  balancingAuthority?: Maybe<BalancingAuthority>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedPricingNodeNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `PricingNode` that was deleted by this mutation. */
  pricingNode?: Maybe<PricingNode>;
  /** An edge for our `PricingNode`. May be used by Relay 1. */
  pricingNodeEdge?: Maybe<PricingNodesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `PricingNode` mutation. */
export type DeletePricingNodePayloadPricingNodeEdgeArgs = {
  orderBy?: InputMaybe<Array<PricingNodesOrderBy>>;
};

/** All input for the `deleteProductBySourceId` mutation. */
export type DeleteProductBySourceIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique external identifier of the record from the original source system */
  sourceId: Scalars['String']['input'];
};

/** All input for the `deleteProduct` mutation. */
export type DeleteProductInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `Product` mutation. */
export type DeleteProductPayload = {
  __typename?: 'DeleteProductPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedProductNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Facility` that is related to this `Product`. */
  facility?: Maybe<Facility>;
  /** The `Product` that was deleted by this mutation. */
  product?: Maybe<Product>;
  /** An edge for our `Product`. May be used by Relay 1. */
  productEdge?: Maybe<ProductsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `Product` mutation. */
export type DeleteProductPayloadProductEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};

/** All input for the `deleteProgramByProjectTypeIdAndName` mutation. */
export type DeleteProgramByProjectTypeIdAndNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The name of the program. */
  name: Scalars['String']['input'];
  /** The id of the project type the program is associated with. */
  projectTypeId: Scalars['Int']['input'];
};

/** All input for the `deleteProgramConfig` mutation. */
export type DeleteProgramConfigInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  programId?: InputMaybe<Scalars['Int']['input']>;
};

/** The output of our `deleteProgramConfig` mutation. */
export type DeleteProgramConfigPayload = {
  __typename?: 'DeleteProgramConfigPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `deleteProgramEnrollmentByProgramIdAndName` mutation. */
export type DeleteProgramEnrollmentByProgramIdAndNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The name of this program enrollment. */
  name: Scalars['String']['input'];
  /** The program this program enrollment belongs to. */
  programId: Scalars['Int']['input'];
};

/** All input for the `deleteProgramEnrollment` mutation. */
export type DeleteProgramEnrollmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifer of the program enrollment. */
  id: Scalars['Int']['input'];
};

/** The output of our delete `ProgramEnrollment` mutation. */
export type DeleteProgramEnrollmentPayload = {
  __typename?: 'DeleteProgramEnrollmentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedProgramEnrollmentNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Program` that is related to this `ProgramEnrollment`. */
  program?: Maybe<Program>;
  /** The `ProgramEnrollment` that was deleted by this mutation. */
  programEnrollment?: Maybe<ProgramEnrollment>;
  /** An edge for our `ProgramEnrollment`. May be used by Relay 1. */
  programEnrollmentEdge?: Maybe<ProgramEnrollmentsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `ProgramEnrollment` mutation. */
export type DeleteProgramEnrollmentPayloadProgramEnrollmentEdgeArgs = {
  orderBy?: InputMaybe<Array<ProgramEnrollmentsOrderBy>>;
};

/** All input for the `deleteProgram` mutation. */
export type DeleteProgramInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifer of the program. */
  id: Scalars['Int']['input'];
};

/** The output of our delete `Program` mutation. */
export type DeleteProgramPayload = {
  __typename?: 'DeleteProgramPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedProgramNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `Program` that was deleted by this mutation. */
  program?: Maybe<Program>;
  /** An edge for our `Program`. May be used by Relay 1. */
  programEdge?: Maybe<ProgramsEdge>;
  /** Reads a single `ProjectType` that is related to this `Program`. */
  projectType?: Maybe<ProjectType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Timezone` that is related to this `Program`. */
  timezone?: Maybe<Timezone>;
};

/** The output of our delete `Program` mutation. */
export type DeleteProgramPayloadProgramEdgeArgs = {
  orderBy?: InputMaybe<Array<ProgramsOrderBy>>;
};

/** All input for the `deleteProjectByFacilityIdAndProgramId` mutation. */
export type DeleteProjectByFacilityIdAndProgramIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifier of the facility. */
  facilityId: Scalars['Int']['input'];
  /** The id of the program the project is associated with */
  programId: Scalars['Int']['input'];
};

/** All input for the `deleteProjectComponent` mutation. */
export type DeleteProjectComponentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  componentId: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
};

/** The output of our delete `ProjectComponent` mutation. */
export type DeleteProjectComponentPayload = {
  __typename?: 'DeleteProjectComponentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Component` that is related to this `ProjectComponent`. */
  component?: Maybe<Component>;
  deletedProjectComponentNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Project` that is related to this `ProjectComponent`. */
  project?: Maybe<Project>;
  /** The `ProjectComponent` that was deleted by this mutation. */
  projectComponent?: Maybe<ProjectComponent>;
  /** An edge for our `ProjectComponent`. May be used by Relay 1. */
  projectComponentEdge?: Maybe<ProjectComponentsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `ProjectComponent` mutation. */
export type DeleteProjectComponentPayloadProjectComponentEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectComponentsOrderBy>>;
};

/** All input for the `deleteProjectConfig` mutation. */
export type DeleteProjectConfigInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
};

/** The output of our `deleteProjectConfig` mutation. */
export type DeleteProjectConfigPayload = {
  __typename?: 'DeleteProjectConfigPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `deleteProjectEnrollmentByProjectIdAndProgramEnrollmentId` mutation. */
export type DeleteProjectEnrollmentByProjectIdAndProgramEnrollmentIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The program enrollment this project enrollment belongs to. */
  programEnrollmentId: Scalars['Int']['input'];
  /** The project this project enrollment belongs to. */
  projectId: Scalars['Int']['input'];
};

/** All input for the `deleteProjectEnrollmentDataPointByProjectEnrollmentIdAndDataPointId` mutation. */
export type DeleteProjectEnrollmentDataPointByProjectEnrollmentIdAndDataPointIdInput =
  {
    /**
     * An arbitrary string value with no semantic meaning. Will be included in the
     * payload verbatim. May be used to track mutations by the client.
     */
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** The data point being referenced. */
    dataPointId: Scalars['Int']['input'];
    /** The project enrollment this data point belongs to. */
    projectEnrollmentId: Scalars['Int']['input'];
  };

/** All input for the `deleteProjectEnrollmentDataPointGroup` mutation. */
export type DeleteProjectEnrollmentDataPointGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifer of the project enrollment. */
  id: Scalars['Int']['input'];
};

/** The output of our delete `ProjectEnrollmentDataPointGroup` mutation. */
export type DeleteProjectEnrollmentDataPointGroupPayload = {
  __typename?: 'DeleteProjectEnrollmentDataPointGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedProjectEnrollmentDataPointGroupNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `ProjectEnrollmentDataPointGroup` that was deleted by this mutation. */
  projectEnrollmentDataPointGroup?: Maybe<ProjectEnrollmentDataPointGroup>;
  /** An edge for our `ProjectEnrollmentDataPointGroup`. May be used by Relay 1. */
  projectEnrollmentDataPointGroupEdge?: Maybe<ProjectEnrollmentDataPointGroupsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `ProjectEnrollmentDataPointGroup` mutation. */
export type DeleteProjectEnrollmentDataPointGroupPayloadProjectEnrollmentDataPointGroupEdgeArgs =
  {
    orderBy?: InputMaybe<Array<ProjectEnrollmentDataPointGroupsOrderBy>>;
  };

/** All input for the `deleteProjectEnrollmentDataPoint` mutation. */
export type DeleteProjectEnrollmentDataPointInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifer of the project enrollment data point. */
  id: Scalars['Int']['input'];
};

/** The output of our delete `ProjectEnrollmentDataPoint` mutation. */
export type DeleteProjectEnrollmentDataPointPayload = {
  __typename?: 'DeleteProjectEnrollmentDataPointPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DataPoint` that is related to this `ProjectEnrollmentDataPoint`. */
  dataPoint?: Maybe<DataPoint>;
  deletedProjectEnrollmentDataPointNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `ProjectEnrollmentDataPointGroup` that is related to this `ProjectEnrollmentDataPoint`. */
  group?: Maybe<ProjectEnrollmentDataPointGroup>;
  /** Reads a single `DataPoint` that is related to this `ProjectEnrollmentDataPoint`. */
  profileDataPoint?: Maybe<DataPoint>;
  /** Reads a single `ProjectEnrollment` that is related to this `ProjectEnrollmentDataPoint`. */
  projectEnrollment?: Maybe<ProjectEnrollment>;
  /** The `ProjectEnrollmentDataPoint` that was deleted by this mutation. */
  projectEnrollmentDataPoint?: Maybe<ProjectEnrollmentDataPoint>;
  /** An edge for our `ProjectEnrollmentDataPoint`. May be used by Relay 1. */
  projectEnrollmentDataPointEdge?: Maybe<ProjectEnrollmentDataPointsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `ProjectEnrollmentDataPoint` mutation. */
export type DeleteProjectEnrollmentDataPointPayloadProjectEnrollmentDataPointEdgeArgs =
  {
    orderBy?: InputMaybe<Array<ProjectEnrollmentDataPointsOrderBy>>;
  };

/** All input for the `deleteProjectEnrollment` mutation. */
export type DeleteProjectEnrollmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifer of the project enrollment. */
  id: Scalars['Int']['input'];
};

/** The output of our delete `ProjectEnrollment` mutation. */
export type DeleteProjectEnrollmentPayload = {
  __typename?: 'DeleteProjectEnrollmentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedProjectEnrollmentNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `ProgramEnrollment` that is related to this `ProjectEnrollment`. */
  programEnrollment?: Maybe<ProgramEnrollment>;
  /** Reads a single `Project` that is related to this `ProjectEnrollment`. */
  project?: Maybe<Project>;
  /** The `ProjectEnrollment` that was deleted by this mutation. */
  projectEnrollment?: Maybe<ProjectEnrollment>;
  /** An edge for our `ProjectEnrollment`. May be used by Relay 1. */
  projectEnrollmentEdge?: Maybe<ProjectEnrollmentsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `ProjectEnrollment` mutation. */
export type DeleteProjectEnrollmentPayloadProjectEnrollmentEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectEnrollmentsOrderBy>>;
};

/** All input for the `deleteProject` mutation. */
export type DeleteProjectInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifier of the optimization project. */
  id: Scalars['Int']['input'];
};

/** The output of our delete `Project` mutation. */
export type DeleteProjectPayload = {
  __typename?: 'DeleteProjectPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedProjectNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Facility` that is related to this `Project`. */
  facility?: Maybe<Facility>;
  /** Reads a single `Program` that is related to this `Project`. */
  program?: Maybe<Program>;
  /** The `Project` that was deleted by this mutation. */
  project?: Maybe<Project>;
  /** An edge for our `Project`. May be used by Relay 1. */
  projectEdge?: Maybe<ProjectsEdge>;
  /** Reads a single `ProjectType` that is related to this `Project`. */
  projectType?: Maybe<ProjectType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `Project` mutation. */
export type DeleteProjectPayloadProjectEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectsOrderBy>>;
};

/** All input for the `deleteProjectWatcher` mutation. */
export type DeleteProjectWatcherInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['Int']['input'];
  userId: Scalars['String']['input'];
};

/** The output of our delete `ProjectWatcher` mutation. */
export type DeleteProjectWatcherPayload = {
  __typename?: 'DeleteProjectWatcherPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedProjectWatcherNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Project` that is related to this `ProjectWatcher`. */
  project?: Maybe<Project>;
  /** The `ProjectWatcher` that was deleted by this mutation. */
  projectWatcher?: Maybe<ProjectWatcher>;
  /** An edge for our `ProjectWatcher`. May be used by Relay 1. */
  projectWatcherEdge?: Maybe<ProjectWatchersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `ProjectWatcher`. */
  user?: Maybe<User>;
};

/** The output of our delete `ProjectWatcher` mutation. */
export type DeleteProjectWatcherPayloadProjectWatcherEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectWatchersOrderBy>>;
};

/** All input for the `deleteRefrigerationSystemByFacilityIdAndLabel` mutation. */
export type DeleteRefrigerationSystemByFacilityIdAndLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** References the facility this refrigeration system belongs to. */
  facilityId: Scalars['Int']['input'];
  /** The display label of the refrigeration system. */
  label: Scalars['String']['input'];
};

/** All input for the `deleteRefrigerationSystem` mutation. */
export type DeleteRefrigerationSystemInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The unique identifier for the refrigeration system. */
  id: Scalars['Int']['input'];
};

/** The output of our delete `RefrigerationSystem` mutation. */
export type DeleteRefrigerationSystemPayload = {
  __typename?: 'DeleteRefrigerationSystemPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedRefrigerationSystemNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Facility` that is related to this `RefrigerationSystem`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Refrigerant` that is related to this `RefrigerationSystem`. */
  refrigerant?: Maybe<Refrigerant>;
  /** The `RefrigerationSystem` that was deleted by this mutation. */
  refrigerationSystem?: Maybe<RefrigerationSystem>;
  /** An edge for our `RefrigerationSystem`. May be used by Relay 1. */
  refrigerationSystemEdge?: Maybe<RefrigerationSystemsEdge>;
};

/** The output of our delete `RefrigerationSystem` mutation. */
export type DeleteRefrigerationSystemPayloadRefrigerationSystemEdgeArgs = {
  orderBy?: InputMaybe<Array<RefrigerationSystemsOrderBy>>;
};

/** All input for the `deleteSavingsEventByProjectIdAndStartTimeAndEndTime` mutation. */
export type DeleteSavingsEventByProjectIdAndStartTimeAndEndTimeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The time that the savings_event ended */
  endTime: Scalars['Datetime']['input'];
  /** This maps the savings_event to a project */
  projectId: Scalars['Int']['input'];
  /** The time that the savings_event started */
  startTime: Scalars['Datetime']['input'];
};

/** All input for the `deleteSavingsEventDatumBySavingsEventIdAndLabel` mutation. */
export type DeleteSavingsEventDatumBySavingsEventIdAndLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** This column represents the attribute being recorded. */
  label: Scalars['String']['input'];
  /** This savings event this data belongs to. */
  savingsEventId: Scalars['Int']['input'];
};

/** All input for the `deleteSavingsEventDatum` mutation. */
export type DeleteSavingsEventDatumInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifer of the savings event data. */
  id: Scalars['Int']['input'];
};

/** The output of our delete `SavingsEventDatum` mutation. */
export type DeleteSavingsEventDatumPayload = {
  __typename?: 'DeleteSavingsEventDatumPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedSavingsEventDatumNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SavingsEvent` that is related to this `SavingsEventDatum`. */
  savingsEvent?: Maybe<SavingsEvent>;
  /** The `SavingsEventDatum` that was deleted by this mutation. */
  savingsEventDatum?: Maybe<SavingsEventDatum>;
  /** An edge for our `SavingsEventDatum`. May be used by Relay 1. */
  savingsEventDatumEdge?: Maybe<SavingsEventDataEdge>;
};

/** The output of our delete `SavingsEventDatum` mutation. */
export type DeleteSavingsEventDatumPayloadSavingsEventDatumEdgeArgs = {
  orderBy?: InputMaybe<Array<SavingsEventDataOrderBy>>;
};

/** All input for the `deleteSavingsEvent` mutation. */
export type DeleteSavingsEventInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** The output of our delete `SavingsEvent` mutation. */
export type DeleteSavingsEventPayload = {
  __typename?: 'DeleteSavingsEventPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedSavingsEventNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Project` that is related to this `SavingsEvent`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SavingsEvent` that was deleted by this mutation. */
  savingsEvent?: Maybe<SavingsEvent>;
  /** An edge for our `SavingsEvent`. May be used by Relay 1. */
  savingsEventEdge?: Maybe<SavingsEventsEdge>;
};

/** The output of our delete `SavingsEvent` mutation. */
export type DeleteSavingsEventPayloadSavingsEventEdgeArgs = {
  orderBy?: InputMaybe<Array<SavingsEventsOrderBy>>;
};

/** All input for the `deleteSubmeterSessionBySubmeterIdAndStartTime` mutation. */
export type DeleteSubmeterSessionBySubmeterIdAndStartTimeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The beginning of this session */
  startTime: Scalars['Datetime']['input'];
  /** The submeter this session belongs to */
  submeterId: Scalars['Int']['input'];
};

/** All input for the `deleteSubmeterSession` mutation. */
export type DeleteSubmeterSessionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The internal ID of this submeter session */
  id: Scalars['Int']['input'];
};

/** The output of our delete `SubmeterSession` mutation. */
export type DeleteSubmeterSessionPayload = {
  __typename?: 'DeleteSubmeterSessionPayload';
  /** Reads a single `BillableCustomer` that is related to this `SubmeterSession`. */
  associatedCustomer?: Maybe<BillableCustomer>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedSubmeterSessionNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Submeter` that is related to this `SubmeterSession`. */
  submeter?: Maybe<Submeter>;
  /** The `SubmeterSession` that was deleted by this mutation. */
  submeterSession?: Maybe<SubmeterSession>;
  /** An edge for our `SubmeterSession`. May be used by Relay 1. */
  submeterSessionEdge?: Maybe<SubmeterSessionsEdge>;
};

/** The output of our delete `SubmeterSession` mutation. */
export type DeleteSubmeterSessionPayloadSubmeterSessionEdgeArgs = {
  orderBy?: InputMaybe<Array<SubmeterSessionsOrderBy>>;
};

/** All input for the `deleteSuctionGroupByRefrigerationSystemIdAndLabel` mutation. */
export type DeleteSuctionGroupByRefrigerationSystemIdAndLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The display label of the suction group. */
  label: Scalars['String']['input'];
  /** References the refrigeration system this suction group belongs to. */
  refrigerationSystemId: Scalars['Int']['input'];
};

/** All input for the `deleteSuctionGroupCompressorBySuctionGroupIdAndCompressorId` mutation. */
export type DeleteSuctionGroupCompressorBySuctionGroupIdAndCompressorIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** References the compressor connection */
  compressorId: Scalars['Int']['input'];
  /** References the suction group connection */
  suctionGroupId: Scalars['Int']['input'];
};

/** All input for the `deleteSuctionGroupCompressor` mutation. */
export type DeleteSuctionGroupCompressorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** The output of our delete `SuctionGroupCompressor` mutation. */
export type DeleteSuctionGroupCompressorPayload = {
  __typename?: 'DeleteSuctionGroupCompressorPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Compressor` that is related to this `SuctionGroupCompressor`. */
  compressor?: Maybe<Compressor>;
  deletedSuctionGroupCompressorNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SuctionGroup` that is related to this `SuctionGroupCompressor`. */
  suctionGroup?: Maybe<SuctionGroup>;
  /** The `SuctionGroupCompressor` that was deleted by this mutation. */
  suctionGroupCompressor?: Maybe<SuctionGroupCompressor>;
  /** An edge for our `SuctionGroupCompressor`. May be used by Relay 1. */
  suctionGroupCompressorEdge?: Maybe<SuctionGroupCompressorsEdge>;
};

/** The output of our delete `SuctionGroupCompressor` mutation. */
export type DeleteSuctionGroupCompressorPayloadSuctionGroupCompressorEdgeArgs =
  {
    orderBy?: InputMaybe<Array<SuctionGroupCompressorsOrderBy>>;
  };

/** All input for the `deleteSuctionGroup` mutation. */
export type DeleteSuctionGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The unique identifier for the suction group. */
  id: Scalars['Int']['input'];
};

/** The output of our delete `SuctionGroup` mutation. */
export type DeleteSuctionGroupPayload = {
  __typename?: 'DeleteSuctionGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedSuctionGroupNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RefrigerationSystem` that is related to this `SuctionGroup`. */
  refrigerationSystem?: Maybe<RefrigerationSystem>;
  /** The `SuctionGroup` that was deleted by this mutation. */
  suctionGroup?: Maybe<SuctionGroup>;
  /** An edge for our `SuctionGroup`. May be used by Relay 1. */
  suctionGroupEdge?: Maybe<SuctionGroupsEdge>;
  /** Reads a single `DataPoint` that is related to this `SuctionGroup`. */
  suctionPressure?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `SuctionGroup`. */
  suctionPressureSetpoint?: Maybe<DataPoint>;
};

/** The output of our delete `SuctionGroup` mutation. */
export type DeleteSuctionGroupPayloadSuctionGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<SuctionGroupsOrderBy>>;
};

/** All input for the `deleteSuctionHeaderByRefrigerationSystemIdAndLabel` mutation. */
export type DeleteSuctionHeaderByRefrigerationSystemIdAndLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The display label of the suction header. */
  label: Scalars['String']['input'];
  /** References the refrigeration system this suction header belongs to. */
  refrigerationSystemId: Scalars['Int']['input'];
};

/** All input for the `deleteSuctionHeader` mutation. */
export type DeleteSuctionHeaderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The unique identifier for the suction header. */
  id: Scalars['Int']['input'];
};

/** The output of our delete `SuctionHeader` mutation. */
export type DeleteSuctionHeaderPayload = {
  __typename?: 'DeleteSuctionHeaderPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedSuctionHeaderNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RefrigerationSystem` that is related to this `SuctionHeader`. */
  refrigerationSystem?: Maybe<RefrigerationSystem>;
  /** Reads a single `SuctionGroup` that is related to this `SuctionHeader`. */
  suctionGroup?: Maybe<SuctionGroup>;
  /** The `SuctionHeader` that was deleted by this mutation. */
  suctionHeader?: Maybe<SuctionHeader>;
  /** An edge for our `SuctionHeader`. May be used by Relay 1. */
  suctionHeaderEdge?: Maybe<SuctionHeadersEdge>;
};

/** The output of our delete `SuctionHeader` mutation. */
export type DeleteSuctionHeaderPayloadSuctionHeaderEdgeArgs = {
  orderBy?: InputMaybe<Array<SuctionHeadersOrderBy>>;
};

/** All input for the `deleteSuctionHeadersCompressorBySuctionHeaderIdAndCompressorId` mutation. */
export type DeleteSuctionHeadersCompressorBySuctionHeaderIdAndCompressorIdInput =
  {
    /**
     * An arbitrary string value with no semantic meaning. Will be included in the
     * payload verbatim. May be used to track mutations by the client.
     */
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** References the compressor connection */
    compressorId: Scalars['Int']['input'];
    /** References the suction header connection */
    suctionHeaderId: Scalars['Int']['input'];
  };

/** All input for the `deleteSuctionHeadersCompressor` mutation. */
export type DeleteSuctionHeadersCompressorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** The output of our delete `SuctionHeadersCompressor` mutation. */
export type DeleteSuctionHeadersCompressorPayload = {
  __typename?: 'DeleteSuctionHeadersCompressorPayload';
  /** Reads a single `DataPoint` that is related to this `SuctionHeadersCompressor`. */
  active?: Maybe<DataPoint>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Compressor` that is related to this `SuctionHeadersCompressor`. */
  compressor?: Maybe<Compressor>;
  deletedSuctionHeadersCompressorNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SuctionHeader` that is related to this `SuctionHeadersCompressor`. */
  suctionHeader?: Maybe<SuctionHeader>;
  /** The `SuctionHeadersCompressor` that was deleted by this mutation. */
  suctionHeadersCompressor?: Maybe<SuctionHeadersCompressor>;
  /** An edge for our `SuctionHeadersCompressor`. May be used by Relay 1. */
  suctionHeadersCompressorEdge?: Maybe<SuctionHeadersCompressorsEdge>;
};

/** The output of our delete `SuctionHeadersCompressor` mutation. */
export type DeleteSuctionHeadersCompressorPayloadSuctionHeadersCompressorEdgeArgs =
  {
    orderBy?: InputMaybe<Array<SuctionHeadersCompressorsOrderBy>>;
  };

/** All input for the `deleteSuggestionControlEventByControlEventId` mutation. */
export type DeleteSuggestionControlEventByControlEventIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  controlEventId: Scalars['Int']['input'];
};

/** All input for the `deleteSuggestionControlEvent` mutation. */
export type DeleteSuggestionControlEventInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  controlEventId: Scalars['Int']['input'];
  suggestionId: Scalars['Int']['input'];
};

/** The output of our delete `SuggestionControlEvent` mutation. */
export type DeleteSuggestionControlEventPayload = {
  __typename?: 'DeleteSuggestionControlEventPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `ControlEvent` that is related to this `SuggestionControlEvent`. */
  controlEvent?: Maybe<ControlEvent>;
  deletedSuggestionControlEventNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Suggestion` that is related to this `SuggestionControlEvent`. */
  suggestion?: Maybe<Suggestion>;
  /** The `SuggestionControlEvent` that was deleted by this mutation. */
  suggestionControlEvent?: Maybe<SuggestionControlEvent>;
};

/** All input for the `deleteTemperatureSensorByFacilityIdAndHardwareId` mutation. */
export type DeleteTemperatureSensorByFacilityIdAndHardwareIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The facility where the temperature sensor is installed */
  facilityId: Scalars['Int']['input'];
  /** The hardware ID for the sensor. */
  hardwareId: Scalars['String']['input'];
};

/** All input for the `deleteTemperatureSensorByFacilityIdAndLabel` mutation. */
export type DeleteTemperatureSensorByFacilityIdAndLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The facility where the temperature sensor is installed */
  facilityId: Scalars['Int']['input'];
  /** The Human-readable label for the sensor */
  label: Scalars['String']['input'];
};

/** All input for the `deleteTemperatureSensor` mutation. */
export type DeleteTemperatureSensorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the temperature sensor */
  id: Scalars['Int']['input'];
};

/** The output of our delete `TemperatureSensor` mutation. */
export type DeleteTemperatureSensorPayload = {
  __typename?: 'DeleteTemperatureSensorPayload';
  /** Reads a single `DataPoint` that is related to this `TemperatureSensor`. */
  battery?: Maybe<DataPoint>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedTemperatureSensorNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Facility` that is related to this `TemperatureSensor`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DataPoint` that is related to this `TemperatureSensor`. */
  signal?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `TemperatureSensor`. */
  temperature?: Maybe<DataPoint>;
  /** The `TemperatureSensor` that was deleted by this mutation. */
  temperatureSensor?: Maybe<TemperatureSensor>;
  /** An edge for our `TemperatureSensor`. May be used by Relay 1. */
  temperatureSensorEdge?: Maybe<TemperatureSensorsEdge>;
};

/** The output of our delete `TemperatureSensor` mutation. */
export type DeleteTemperatureSensorPayloadTemperatureSensorEdgeArgs = {
  orderBy?: InputMaybe<Array<TemperatureSensorsOrderBy>>;
};

/** All input for the `deleteTrailerAudit` mutation. */
export type DeleteTrailerAuditInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The internal ID of this trailer audit */
  id: Scalars['BigInt']['input'];
};

/** The output of our delete `TrailerAudit` mutation. */
export type DeleteTrailerAuditPayload = {
  __typename?: 'DeleteTrailerAuditPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedTrailerAuditNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Trailer` that is related to this `TrailerAudit`. */
  trailer?: Maybe<Trailer>;
  /** The `TrailerAudit` that was deleted by this mutation. */
  trailerAudit?: Maybe<TrailerAudit>;
  /** An edge for our `TrailerAudit`. May be used by Relay 1. */
  trailerAuditEdge?: Maybe<TrailerAuditsEdge>;
  /** Reads a single `User` that is related to this `TrailerAudit`. */
  userByAuditUser?: Maybe<User>;
  /** Reads a single `Yard` that is related to this `TrailerAudit`. */
  yard?: Maybe<Yard>;
};

/** The output of our delete `TrailerAudit` mutation. */
export type DeleteTrailerAuditPayloadTrailerAuditEdgeArgs = {
  orderBy?: InputMaybe<Array<TrailerAuditsOrderBy>>;
};

/** All input for the `deleteTrailerPositionByFacilityIdAndLabel` mutation. */
export type DeleteTrailerPositionByFacilityIdAndLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The facility where the trailer position is located */
  facilityId: Scalars['Int']['input'];
  /** The Human-readable label for the trailer position */
  label: Scalars['String']['input'];
};

/** All input for the `deleteTrailerPosition` mutation. */
export type DeleteTrailerPositionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the trailer position */
  id: Scalars['Int']['input'];
};

/** The output of our delete `TrailerPosition` mutation. */
export type DeleteTrailerPositionPayload = {
  __typename?: 'DeleteTrailerPositionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedTrailerPositionNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Facility` that is related to this `TrailerPosition`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DataPoint` that is related to this `TrailerPosition`. */
  trailerIsPresent?: Maybe<DataPoint>;
  /** The `TrailerPosition` that was deleted by this mutation. */
  trailerPosition?: Maybe<TrailerPosition>;
  /** An edge for our `TrailerPosition`. May be used by Relay 1. */
  trailerPositionEdge?: Maybe<TrailerPositionsEdge>;
};

/** The output of our delete `TrailerPosition` mutation. */
export type DeleteTrailerPositionPayloadTrailerPositionEdgeArgs = {
  orderBy?: InputMaybe<Array<TrailerPositionsOrderBy>>;
};

/** All input for the `deleteUser` mutation. */
export type DeleteUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The primary unique identifier of the user. */
  id: Scalars['String']['input'];
};

/** The output of our delete `User` mutation. */
export type DeleteUserPayload = {
  __typename?: 'DeleteUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedUserNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `User` that was deleted by this mutation. */
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
};

/** The output of our delete `User` mutation. */
export type DeleteUserPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** All input for the `deleteUtilityAccount` mutation. */
export type DeleteUtilityAccountInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** The output of our `deleteUtilityAccount` mutation. */
export type DeleteUtilityAccountPayload = {
  __typename?: 'DeleteUtilityAccountPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `deleteUtilityCredentialByIntegrationAndIntegrationKey` mutation. */
export type DeleteUtilityCredentialByIntegrationAndIntegrationKeyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The type of integration used for acquiring the utility data. */
  integration: UtilityIntegration;
  /** The identifier of this record as indicated by the integration. */
  integrationKey: Scalars['String']['input'];
};

/** All input for the `deleteUtilityCredentialFacilityByUtilityCredentialIdAndFacilityId` mutation. */
export type DeleteUtilityCredentialFacilityByUtilityCredentialIdAndFacilityIdInput =
  {
    /**
     * An arbitrary string value with no semantic meaning. Will be included in the
     * payload verbatim. May be used to track mutations by the client.
     */
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** The facility associated to the utility credential. */
    facilityId: Scalars['Int']['input'];
    /** The utility credential associated to the facility. */
    utilityCredentialId: Scalars['Int']['input'];
  };

/** All input for the `deleteUtilityCredentialFacility` mutation. */
export type DeleteUtilityCredentialFacilityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The internal identifier of the record. */
  id: Scalars['Int']['input'];
};

/** The output of our delete `UtilityCredentialFacility` mutation. */
export type DeleteUtilityCredentialFacilityPayload = {
  __typename?: 'DeleteUtilityCredentialFacilityPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedUtilityCredentialFacilityNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Facility` that is related to this `UtilityCredentialFacility`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `UtilityCredential` that is related to this `UtilityCredentialFacility`. */
  utilityCredential?: Maybe<UtilityCredential>;
  /** The `UtilityCredentialFacility` that was deleted by this mutation. */
  utilityCredentialFacility?: Maybe<UtilityCredentialFacility>;
  /** An edge for our `UtilityCredentialFacility`. May be used by Relay 1. */
  utilityCredentialFacilityEdge?: Maybe<UtilityCredentialFacilitiesEdge>;
};

/** The output of our delete `UtilityCredentialFacility` mutation. */
export type DeleteUtilityCredentialFacilityPayloadUtilityCredentialFacilityEdgeArgs =
  {
    orderBy?: InputMaybe<Array<UtilityCredentialFacilitiesOrderBy>>;
  };

/** All input for the `deleteUtilityCredential` mutation. */
export type DeleteUtilityCredentialInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The internal identifer of the record. */
  id: Scalars['Int']['input'];
};

/** The output of our delete `UtilityCredential` mutation. */
export type DeleteUtilityCredentialPayload = {
  __typename?: 'DeleteUtilityCredentialPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedUtilityCredentialNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UtilityCredential` that was deleted by this mutation. */
  utilityCredential?: Maybe<UtilityCredential>;
  /** An edge for our `UtilityCredential`. May be used by Relay 1. */
  utilityCredentialEdge?: Maybe<UtilityCredentialsEdge>;
  /** Reads a single `UtilityProvider` that is related to this `UtilityCredential`. */
  utilityProvider?: Maybe<UtilityProvider>;
};

/** The output of our delete `UtilityCredential` mutation. */
export type DeleteUtilityCredentialPayloadUtilityCredentialEdgeArgs = {
  orderBy?: InputMaybe<Array<UtilityCredentialsOrderBy>>;
};

/** All input for the `deleteUtilityFileUploadByIntegrationAndIntegrationKey` mutation. */
export type DeleteUtilityFileUploadByIntegrationAndIntegrationKeyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The type of integration to which this file was uploaded. */
  integration: UtilityIntegration;
  /** The identifier of this record as indicated by the integration. */
  integrationKey: Scalars['String']['input'];
};

/** All input for the `deleteUtilityFileUpload` mutation. */
export type DeleteUtilityFileUploadInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The internal identifier of the record. */
  id: Scalars['Int']['input'];
};

/** The output of our delete `UtilityFileUpload` mutation. */
export type DeleteUtilityFileUploadPayload = {
  __typename?: 'DeleteUtilityFileUploadPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedUtilityFileUploadNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UtilityFileUpload` that was deleted by this mutation. */
  utilityFileUpload?: Maybe<UtilityFileUpload>;
  /** An edge for our `UtilityFileUpload`. May be used by Relay 1. */
  utilityFileUploadEdge?: Maybe<UtilityFileUploadsEdge>;
};

/** The output of our delete `UtilityFileUpload` mutation. */
export type DeleteUtilityFileUploadPayloadUtilityFileUploadEdgeArgs = {
  orderBy?: InputMaybe<Array<UtilityFileUploadsOrderBy>>;
};

/** All input for the `deleteUtilityMeter` mutation. */
export type DeleteUtilityMeterInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** The output of our `deleteUtilityMeter` mutation. */
export type DeleteUtilityMeterPayload = {
  __typename?: 'DeleteUtilityMeterPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `deleteUtilityPendingMeterByIntegrationAndIntegrationKey` mutation. */
export type DeleteUtilityPendingMeterByIntegrationAndIntegrationKeyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The type of integration that discovered this meter. */
  integration: UtilityIntegration;
  /** The identifier of this record as indicated by the integration. */
  integrationKey: Scalars['String']['input'];
};

/** All input for the `deleteUtilityPendingMeter` mutation. */
export type DeleteUtilityPendingMeterInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The internal identifer of the record. */
  id: Scalars['Int']['input'];
};

/** The output of our delete `UtilityPendingMeter` mutation. */
export type DeleteUtilityPendingMeterPayload = {
  __typename?: 'DeleteUtilityPendingMeterPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedUtilityPendingMeterNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Facility` that is related to this `UtilityPendingMeter`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `UtilityCredential` that is related to this `UtilityPendingMeter`. */
  utilityCredential?: Maybe<UtilityCredential>;
  /** The `UtilityPendingMeter` that was deleted by this mutation. */
  utilityPendingMeter?: Maybe<UtilityPendingMeter>;
  /** An edge for our `UtilityPendingMeter`. May be used by Relay 1. */
  utilityPendingMeterEdge?: Maybe<UtilityPendingMetersEdge>;
};

/** The output of our delete `UtilityPendingMeter` mutation. */
export type DeleteUtilityPendingMeterPayloadUtilityPendingMeterEdgeArgs = {
  orderBy?: InputMaybe<Array<UtilityPendingMetersOrderBy>>;
};

/** All input for the `deleteUtilityProviderByName` mutation. */
export type DeleteUtilityProviderByNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The name of the provider. */
  name: Scalars['String']['input'];
};

/** All input for the `deleteUtilityProvider` mutation. */
export type DeleteUtilityProviderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The primary unique identifier for the provider. */
  id: Scalars['Int']['input'];
};

/** The output of our delete `UtilityProvider` mutation. */
export type DeleteUtilityProviderPayload = {
  __typename?: 'DeleteUtilityProviderPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedUtilityProviderNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UtilityProvider` that was deleted by this mutation. */
  utilityProvider?: Maybe<UtilityProvider>;
  /** An edge for our `UtilityProvider`. May be used by Relay 1. */
  utilityProviderEdge?: Maybe<UtilityProvidersEdge>;
};

/** The output of our delete `UtilityProvider` mutation. */
export type DeleteUtilityProviderPayloadUtilityProviderEdgeArgs = {
  orderBy?: InputMaybe<Array<UtilityProvidersOrderBy>>;
};

/** All input for the `deleteVendorUserByEmail` mutation. */
export type DeleteVendorUserByEmailInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The email of the vendor user. */
  email: Scalars['String']['input'];
};

/** All input for the `deleteVendorUser` mutation. */
export type DeleteVendorUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the vendor user. */
  id: Scalars['Int']['input'];
};

/** All input for the `deleteVendorUserMachineUserByMachineUserId` mutation. */
export type DeleteVendorUserMachineUserByMachineUserIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The machine user associated with the vendor user. */
  machineUserId: Scalars['BigInt']['input'];
};

/** All input for the `deleteVendorUserMachineUser` mutation. */
export type DeleteVendorUserMachineUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The machine user associated with the vendor user. */
  machineUserId: Scalars['BigInt']['input'];
  /** The id of the vendor user. */
  vendorUserId: Scalars['Int']['input'];
};

/** The output of our delete `VendorUserMachineUser` mutation. */
export type DeleteVendorUserMachineUserPayload = {
  __typename?: 'DeleteVendorUserMachineUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedVendorUserMachineUserNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `VendorUserMachineUser` that was deleted by this mutation. */
  vendorUserMachineUser?: Maybe<VendorUserMachineUser>;
};

/** The output of our delete `VendorUser` mutation. */
export type DeleteVendorUserPayload = {
  __typename?: 'DeleteVendorUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedVendorUserNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `VendorUser` that was deleted by this mutation. */
  vendorUser?: Maybe<VendorUser>;
  /** An edge for our `VendorUser`. May be used by Relay 1. */
  vendorUserEdge?: Maybe<VendorUsersEdge>;
};

/** The output of our delete `VendorUser` mutation. */
export type DeleteVendorUserPayloadVendorUserEdgeArgs = {
  orderBy?: InputMaybe<Array<VendorUsersOrderBy>>;
};

/** All input for the `deleteVesselByRefrigerationSystemIdAndLabel` mutation. */
export type DeleteVesselByRefrigerationSystemIdAndLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The label for the vessel. */
  label: Scalars['String']['input'];
  /** References the refrigeration system this vessel is located in. */
  refrigerationSystemId: Scalars['Int']['input'];
};

/** All input for the `deleteVessel` mutation. */
export type DeleteVesselInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The unique identifier for the vessel. */
  id: Scalars['Int']['input'];
};

/** The output of our delete `Vessel` mutation. */
export type DeleteVesselPayload = {
  __typename?: 'DeleteVesselPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedVesselNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `DataPoint` that is related to this `Vessel`. */
  level?: Maybe<DataPoint>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RefrigerationSystem` that is related to this `Vessel`. */
  refrigerationSystem?: Maybe<RefrigerationSystem>;
  /** Reads a single `SuctionGroup` that is related to this `Vessel`. */
  suctionGroup?: Maybe<SuctionGroup>;
  /** The `Vessel` that was deleted by this mutation. */
  vessel?: Maybe<Vessel>;
  /** An edge for our `Vessel`. May be used by Relay 1. */
  vesselEdge?: Maybe<VesselsEdge>;
};

/** The output of our delete `Vessel` mutation. */
export type DeleteVesselPayloadVesselEdgeArgs = {
  orderBy?: InputMaybe<Array<VesselsOrderBy>>;
};

/** All input for the `deleteVirtualPointInterval` mutation. */
export type DeleteVirtualPointIntervalInput = {
  /** The id of the child data point. */
  childId: Scalars['BigInt']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the VIRTUAL data point. */
  parentId: Scalars['BigInt']['input'];
};

/** The output of our delete `VirtualPointInterval` mutation. */
export type DeleteVirtualPointIntervalPayload = {
  __typename?: 'DeleteVirtualPointIntervalPayload';
  /** Reads a single `DataPoint` that is related to this `VirtualPointInterval`. */
  child?: Maybe<DataPoint>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedVirtualPointIntervalNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `DataPoint` that is related to this `VirtualPointInterval`. */
  parent?: Maybe<DataPoint>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `VirtualPointInterval` that was deleted by this mutation. */
  virtualPointInterval?: Maybe<VirtualPointInterval>;
  /** An edge for our `VirtualPointInterval`. May be used by Relay 1. */
  virtualPointIntervalEdge?: Maybe<VirtualPointIntervalsEdge>;
};

/** The output of our delete `VirtualPointInterval` mutation. */
export type DeleteVirtualPointIntervalPayloadVirtualPointIntervalEdgeArgs = {
  orderBy?: InputMaybe<Array<VirtualPointIntervalsOrderBy>>;
};

export enum DemandProfileMethodologyType {
  ROLLING_AVERAGE = 'ROLLING_AVERAGE',
  YEAR_TO_DATE_MAX = 'YEAR_TO_DATE_MAX'
}

/** A filter to be used against DemandProfileMethodologyType fields. All fields are combined with a logical ‘and.’ */
export type DemandProfileMethodologyTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<DemandProfileMethodologyType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<DemandProfileMethodologyType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<DemandProfileMethodologyType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<DemandProfileMethodologyType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<DemandProfileMethodologyType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<DemandProfileMethodologyType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<DemandProfileMethodologyType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<DemandProfileMethodologyType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<DemandProfileMethodologyType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<DemandProfileMethodologyType>>;
};

/** A connection to a list of `Dependency` values. */
export type DependenciesConnection = {
  __typename?: 'DependenciesConnection';
  /** A list of edges which contains the `Dependency` and cursor to aid in pagination. */
  edges: Array<DependenciesEdge>;
  /** A list of `Dependency` objects. */
  nodes: Array<Dependency>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Dependency` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Dependency` edge in the connection. */
export type DependenciesEdge = {
  __typename?: 'DependenciesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Dependency` at the end of the edge. */
  node: Dependency;
};

/** Methods to use when ordering `Dependency`. */
export enum DependenciesOrderBy {
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PATH_ASC = 'PATH_ASC',
  PATH_DESC = 'PATH_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  TYPE_ASC = 'TYPE_ASC',
  TYPE_DESC = 'TYPE_DESC'
}

export type Dependency = Node & {
  __typename?: 'Dependency';
  id: Scalars['BigInt']['output'];
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  path: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/**
 * A condition to be used against `Dependency` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type DependencyCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `path` field. */
  path?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `Dependency` object types. All fields are combined with a logical ‘and.’ */
export type DependencyFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DependencyFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DependencyFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DependencyFilter>>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `Dependency` */
export type DependencyInput = {
  name: Scalars['String']['input'];
  path: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

/** Represents an update to a `Dependency`. Fields that are set will be updated. */
export type DependencyPatch = {
  name?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type DerivedDataPoint = {
  __typename?: 'DerivedDataPoint';
  /** The data type of the data point */
  dataType: Scalars['String']['output'];
  /** The associated category of the data point */
  derivedCategory: Scalars['String']['output'];
  /** The associated field name of the data point */
  derivedFieldName: Scalars['String']['output'];
  /** The derived label of the data point */
  derivedLabel?: Maybe<Scalars['String']['output']>;
  /** The description of the data point */
  description: Scalars['String']['output'];
  /** Whether the derived connection is active or not */
  isConnected: Scalars['Boolean']['output'];
  /** The derived units of the data point */
  units: Scalars['String']['output'];
};

export type DerivedStatementDate = {
  __typename?: 'DerivedStatementDate';
  statementDate?: Maybe<Scalars['Date']['output']>;
  statementMonth?: Maybe<Scalars['Int']['output']>;
  statementYear?: Maybe<Scalars['Int']['output']>;
};

/** Representation of a physical discharge header in a refrigeration system. */
export type DischargeHeader = Node & {
  __typename?: 'DischargeHeader';
  /** The time the record was created. */
  createdAt: Scalars['Datetime']['output'];
  /** Reads a single `DataPoint` that is related to this `DischargeHeader`. */
  dischargePressure?: Maybe<DataPoint>;
  /** The discharge pressure value for the discharge header. */
  dischargePressureId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `DischargeHeader`. */
  dischargePressureSetpoint?: Maybe<DataPoint>;
  /** The setpoint pressure for the discharge header. */
  dischargePressureSetpointId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for the discharge header. */
  id: Scalars['Int']['output'];
  /** The display label of the discharge header. */
  label: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `RefrigerationSystem` that is related to this `DischargeHeader`. */
  refrigerationSystem?: Maybe<RefrigerationSystem>;
  /** References the refrigeration system this discharge header belongs to. */
  refrigerationSystemId: Scalars['Int']['output'];
  /** The time the record was last updated. */
  updatedAt: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `DischargeHeader` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type DischargeHeaderCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `dischargePressureId` field. */
  dischargePressureId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `dischargePressureSetpointId` field. */
  dischargePressureSetpointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `label` field. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `refrigerationSystemId` field. */
  refrigerationSystemId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `DischargeHeader` object types. All fields are combined with a logical ‘and.’ */
export type DischargeHeaderFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DischargeHeaderFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dischargePressureId` field. */
  dischargePressureId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `dischargePressureSetpointId` field. */
  dischargePressureSetpointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `label` field. */
  label?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DischargeHeaderFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DischargeHeaderFilter>>;
  /** Filter by the object’s `refrigerationSystemId` field. */
  refrigerationSystemId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `DischargeHeader` */
export type DischargeHeaderInput = {
  /** Mutates a `DataPoint` as part of the payload */
  dataPoint?: InputMaybe<DataPointInput>;
  /** The discharge pressure value for the discharge header. */
  dischargePressureId?: InputMaybe<Scalars['Int']['input']>;
  /** The setpoint pressure for the discharge header. */
  dischargePressureSetpointId?: InputMaybe<Scalars['Int']['input']>;
  /** The unique identifier for the discharge header. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** The display label of the discharge header. */
  label: Scalars['String']['input'];
  /** Mutates a `RefrigerationSystem` as part of the payload */
  refrigerationSystem?: InputMaybe<RefrigerationSystemInput>;
  /** References the refrigeration system this discharge header belongs to. */
  refrigerationSystemId?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents an update to a `DischargeHeader`. Fields that are set will be updated. */
export type DischargeHeaderPatch = {
  /** The discharge pressure value for the discharge header. */
  dischargePressureId?: InputMaybe<Scalars['Int']['input']>;
  /** The setpoint pressure for the discharge header. */
  dischargePressureSetpointId?: InputMaybe<Scalars['Int']['input']>;
  /** The unique identifier for the discharge header. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** The display label of the discharge header. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** References the refrigeration system this discharge header belongs to. */
  refrigerationSystemId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `DischargeHeader` values. */
export type DischargeHeadersConnection = {
  __typename?: 'DischargeHeadersConnection';
  /** Returns the aggregate dischargePressure timeseries data for the DischargeHeadersConnection  */
  dischargePressure?: Maybe<MetricDataConnection>;
  /** Returns the aggregate dischargePressureSetpoint timeseries data for the DischargeHeadersConnection  */
  dischargePressureSetpoint?: Maybe<MetricDataConnection>;
  /** A list of edges which contains the `DischargeHeader` and cursor to aid in pagination. */
  edges: Array<DischargeHeadersEdge>;
  /** A list of `DischargeHeader` objects. */
  nodes: Array<DischargeHeader>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DischargeHeader` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A connection to a list of `DischargeHeader` values. */
export type DischargeHeadersConnectionDischargePressureArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `DischargeHeader` values. */
export type DischargeHeadersConnectionDischargePressureSetpointArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A `DischargeHeader` edge in the connection. */
export type DischargeHeadersEdge = {
  __typename?: 'DischargeHeadersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `DischargeHeader` at the end of the edge. */
  node: DischargeHeader;
};

/** Methods to use when ordering `DischargeHeader`. */
export enum DischargeHeadersOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DISCHARGE_PRESSURE_ID_ASC = 'DISCHARGE_PRESSURE_ID_ASC',
  DISCHARGE_PRESSURE_ID_DESC = 'DISCHARGE_PRESSURE_ID_DESC',
  DISCHARGE_PRESSURE_SETPOINT_ID_ASC = 'DISCHARGE_PRESSURE_SETPOINT_ID_ASC',
  DISCHARGE_PRESSURE_SETPOINT_ID_DESC = 'DISCHARGE_PRESSURE_SETPOINT_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LABEL_ASC = 'LABEL_ASC',
  LABEL_DESC = 'LABEL_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  REFRIGERATION_SYSTEM_ID_ASC = 'REFRIGERATION_SYSTEM_ID_ASC',
  REFRIGERATION_SYSTEM_ID_DESC = 'REFRIGERATION_SYSTEM_ID_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** This represents a physical location of a door in a facility */
export type Door = Node & {
  __typename?: 'Door';
  /** The time at which the Door was created */
  createdAt: Scalars['Datetime']['output'];
  /** Reads a single `DataPoint` that is related to this `Door`. */
  doorState?: Maybe<DataPoint>;
  /** The state of the door indicating whether the door is open or closed */
  doorStateId?: Maybe<Scalars['BigInt']['output']>;
  /** Reads a single `Facility` that is related to this `Door`. */
  facility?: Maybe<Facility>;
  /** The facility where the door is located */
  facilityId?: Maybe<Scalars['Int']['output']>;
  /** The GIS geometry specifies the physical location of the door */
  geometry?: Maybe<GeometryInterface>;
  /** The id of the door */
  id: Scalars['Int']['output'];
  /** The Human-readable label for the door */
  label: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The time at which the Door was updated */
  updatedAt: Scalars['Datetime']['output'];
};

/** A condition to be used against `Door` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type DoorCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `doorStateId` field. */
  doorStateId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `geometry` field. */
  geometry?: InputMaybe<Scalars['GeoJSON']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `label` field. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `Door` object types. All fields are combined with a logical ‘and.’ */
export type DoorFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DoorFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `doorStateId` field. */
  doorStateId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `label` field. */
  label?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DoorFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DoorFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `Door` */
export type DoorInput = {
  /** Mutates a `DataPoint` as part of the payload */
  dataPoint?: InputMaybe<DataPointInput>;
  /** The state of the door indicating whether the door is open or closed */
  doorStateId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The facility where the door is located */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** The GIS geometry specifies the physical location of the door */
  geometry?: InputMaybe<Scalars['GeoJSON']['input']>;
  /** The Human-readable label for the door */
  label: Scalars['String']['input'];
};

/** Represents an update to a `Door`. Fields that are set will be updated. */
export type DoorPatch = {
  /** The state of the door indicating whether the door is open or closed */
  doorStateId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The facility where the door is located */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** The GIS geometry specifies the physical location of the door */
  geometry?: InputMaybe<Scalars['GeoJSON']['input']>;
  /** The Human-readable label for the door */
  label?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `Door` values. */
export type DoorsConnection = {
  __typename?: 'DoorsConnection';
  /** Returns the aggregate doorState timeseries data for the DoorsConnection  */
  doorState?: Maybe<MetricDataConnection>;
  /** A list of edges which contains the `Door` and cursor to aid in pagination. */
  edges: Array<DoorsEdge>;
  /** A list of `Door` objects. */
  nodes: Array<Door>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Door` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A connection to a list of `Door` values. */
export type DoorsConnectionDoorStateArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A `Door` edge in the connection. */
export type DoorsEdge = {
  __typename?: 'DoorsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Door` at the end of the edge. */
  node: Door;
};

/** Methods to use when ordering `Door`. */
export enum DoorsOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DOOR_STATE_ID_ASC = 'DOOR_STATE_ID_ASC',
  DOOR_STATE_ID_DESC = 'DOOR_STATE_ID_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  GEOMETRY_ASC = 'GEOMETRY_ASC',
  GEOMETRY_DESC = 'GEOMETRY_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LABEL_ASC = 'LABEL_ASC',
  LABEL_DESC = 'LABEL_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** A truck driver */
export type Driver = Node & {
  __typename?: 'Driver';
  /** The external messaging service conversion ID */
  conversationId?: Maybe<Scalars['String']['output']>;
  /** The time when this record was created */
  createdAt: Scalars['Datetime']['output'];
  /** The first name of the driver */
  firstName?: Maybe<Scalars['String']['output']>;
  /** The internal ID of this driver */
  id: Scalars['Int']['output'];
  /** The last name of the driver */
  lastName?: Maybe<Scalars['String']['output']>;
  /** The license country of the driver */
  licenseCountry?: Maybe<Country>;
  /** The license number of the driver */
  licenseNumber?: Maybe<Scalars['String']['output']>;
  /** The state of the driver license */
  licenseState?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The phone number of the driver */
  phoneNumber: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `TrailerAppointment`. */
  trailerAppointments: TrailerAppointmentsConnection;
  /** The time when this record was last updated */
  updatedAt: Scalars['Datetime']['output'];
};

/** A truck driver */
export type DriverTrailerAppointmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TrailerAppointmentCondition>;
  filter?: InputMaybe<TrailerAppointmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TrailerAppointmentsOrderBy>>;
};

/** A condition to be used against `Driver` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type DriverCondition = {
  /** Checks for equality with the object’s `conversationId` field. */
  conversationId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `firstName` field. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `lastName` field. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `licenseCountry` field. */
  licenseCountry?: InputMaybe<Country>;
  /** Checks for equality with the object’s `licenseNumber` field. */
  licenseNumber?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `licenseState` field. */
  licenseState?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `phoneNumber` field. */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `Driver` object types. All fields are combined with a logical ‘and.’ */
export type DriverFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DriverFilter>>;
  /** Filter by the object’s `conversationId` field. */
  conversationId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `firstName` field. */
  firstName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `lastName` field. */
  lastName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `licenseCountry` field. */
  licenseCountry?: InputMaybe<CountryFilter>;
  /** Filter by the object’s `licenseNumber` field. */
  licenseNumber?: InputMaybe<StringFilter>;
  /** Filter by the object’s `licenseState` field. */
  licenseState?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DriverFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DriverFilter>>;
  /** Filter by the object’s `phoneNumber` field. */
  phoneNumber?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `Driver` */
export type DriverInput = {
  /** The first name of the driver */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** The last name of the driver */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** The license country of the driver */
  licenseCountry?: InputMaybe<Country>;
  /** The license number of the driver */
  licenseNumber?: InputMaybe<Scalars['String']['input']>;
  /** The state of the driver license */
  licenseState?: InputMaybe<Scalars['String']['input']>;
  /** The phone number of the driver */
  phoneNumber: Scalars['String']['input'];
};

/** Represents an update to a `Driver`. Fields that are set will be updated. */
export type DriverPatch = {
  /** The external messaging service conversion ID */
  conversationId?: InputMaybe<Scalars['String']['input']>;
  /** The first name of the driver */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** The last name of the driver */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** The license country of the driver */
  licenseCountry?: InputMaybe<Country>;
  /** The license number of the driver */
  licenseNumber?: InputMaybe<Scalars['String']['input']>;
  /** The state of the driver license */
  licenseState?: InputMaybe<Scalars['String']['input']>;
  /** The phone number of the driver */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `Driver` values. */
export type DriversConnection = {
  __typename?: 'DriversConnection';
  /** A list of edges which contains the `Driver` and cursor to aid in pagination. */
  edges: Array<DriversEdge>;
  /** A list of `Driver` objects. */
  nodes: Array<Driver>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Driver` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Driver` edge in the connection. */
export type DriversEdge = {
  __typename?: 'DriversEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Driver` at the end of the edge. */
  node: Driver;
};

/** Methods to use when ordering `Driver`. */
export enum DriversOrderBy {
  CONVERSATION_ID_ASC = 'CONVERSATION_ID_ASC',
  CONVERSATION_ID_DESC = 'CONVERSATION_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  FIRST_NAME_ASC = 'FIRST_NAME_ASC',
  FIRST_NAME_DESC = 'FIRST_NAME_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LAST_NAME_ASC = 'LAST_NAME_ASC',
  LAST_NAME_DESC = 'LAST_NAME_DESC',
  LICENSE_COUNTRY_ASC = 'LICENSE_COUNTRY_ASC',
  LICENSE_COUNTRY_DESC = 'LICENSE_COUNTRY_DESC',
  LICENSE_NUMBER_ASC = 'LICENSE_NUMBER_ASC',
  LICENSE_NUMBER_DESC = 'LICENSE_NUMBER_DESC',
  LICENSE_STATE_ASC = 'LICENSE_STATE_ASC',
  LICENSE_STATE_DESC = 'LICENSE_STATE_DESC',
  NATURAL = 'NATURAL',
  PHONE_NUMBER_ASC = 'PHONE_NUMBER_ASC',
  PHONE_NUMBER_DESC = 'PHONE_NUMBER_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** An electrical circuit. */
export type ElectricalCircuit = Node & {
  __typename?: 'ElectricalCircuit';
  /** Breaker size for this circuit. */
  breakerSizeAmps?: Maybe<Scalars['Float']['output']>;
  /** Reads and enables pagination through a set of `ElectricalPanel`. */
  childPanels: ElectricalPanelsConnection;
  /** The time at which the record was created */
  createdAt: Scalars['Datetime']['output'];
  /** Description or purpose of the circuit. */
  description?: Maybe<Scalars['String']['output']>;
  /** Reads a single `ElectricalMeteringPoint` that is related to this `ElectricalCircuit`. */
  electricalMeteringPoint?: Maybe<ElectricalMeteringPoint>;
  /** The metering point associated with this circuit. */
  electricalMeteringPointId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `ElectricalPanel` that is related to this `ElectricalCircuit`. */
  electricalPanel?: Maybe<ElectricalPanel>;
  /** The panel in which this circuit is housed. */
  electricalPanelId?: Maybe<Scalars['Int']['output']>;
  /** The associated facility ID of the electrical circuit */
  facilityId?: Maybe<Scalars['Int']['output']>;
  /** The identifier of the record. */
  id: Scalars['Int']['output'];
  /** Indicates if the circuit is used for capacitive load. */
  isCapacitor?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if the circuit supports a motor load. */
  isMotorLoad?: Maybe<Scalars['Boolean']['output']>;
  /** The type of load this circuit supplies. */
  loadType: EnumElectricLoadTypes;
  /** The name or label identifying the electrical circuit. */
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The time at which the record was last updated */
  updatedAt: Scalars['Datetime']['output'];
};

/** An electrical circuit. */
export type ElectricalCircuitChildPanelsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ElectricalPanelCondition>;
  filter?: InputMaybe<ElectricalPanelFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ElectricalPanelsOrderBy>>;
};

/**
 * A condition to be used against `ElectricalCircuit` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ElectricalCircuitCondition = {
  /** Checks for equality with the object’s `breakerSizeAmps` field. */
  breakerSizeAmps?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `electricalMeteringPointId` field. */
  electricalMeteringPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `electricalPanelId` field. */
  electricalPanelId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `isCapacitor` field. */
  isCapacitor?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `isMotorLoad` field. */
  isMotorLoad?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `loadType` field. */
  loadType?: InputMaybe<EnumElectricLoadTypes>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `ElectricalCircuit` object types. All fields are combined with a logical ‘and.’ */
export type ElectricalCircuitFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ElectricalCircuitFilter>>;
  /** Filter by the object’s `breakerSizeAmps` field. */
  breakerSizeAmps?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `electricalMeteringPointId` field. */
  electricalMeteringPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `electricalPanelId` field. */
  electricalPanelId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isCapacitor` field. */
  isCapacitor?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isMotorLoad` field. */
  isMotorLoad?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `loadType` field. */
  loadType?: InputMaybe<EnumElectricLoadTypesFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ElectricalCircuitFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ElectricalCircuitFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `ElectricalCircuit` */
export type ElectricalCircuitInput = {
  /** Breaker size for this circuit. */
  breakerSizeAmps?: InputMaybe<Scalars['Float']['input']>;
  /** Description or purpose of the circuit. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Mutates a `ElectricalMeteringPoint` as part of the payload */
  electricalMeteringPoint?: InputMaybe<ElectricalMeteringPointInput>;
  /** The metering point associated with this circuit. */
  electricalMeteringPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Mutates a `ElectricalPanel` as part of the payload */
  electricalPanel?: InputMaybe<ElectricalPanelInput>;
  /** The panel in which this circuit is housed. */
  electricalPanelId?: InputMaybe<Scalars['Int']['input']>;
  /** Indicates if the circuit is used for capacitive load. */
  isCapacitor?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates if the circuit supports a motor load. */
  isMotorLoad?: InputMaybe<Scalars['Boolean']['input']>;
  /** The type of load this circuit supplies. */
  loadType?: InputMaybe<EnumElectricLoadTypes>;
  /** The name or label identifying the electrical circuit. */
  name: Scalars['String']['input'];
};

/** Represents an update to a `ElectricalCircuit`. Fields that are set will be updated. */
export type ElectricalCircuitPatch = {
  /** Breaker size for this circuit. */
  breakerSizeAmps?: InputMaybe<Scalars['Float']['input']>;
  /** Description or purpose of the circuit. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The metering point associated with this circuit. */
  electricalMeteringPointId?: InputMaybe<Scalars['Int']['input']>;
  /** The panel in which this circuit is housed. */
  electricalPanelId?: InputMaybe<Scalars['Int']['input']>;
  /** Indicates if the circuit is used for capacitive load. */
  isCapacitor?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates if the circuit supports a motor load. */
  isMotorLoad?: InputMaybe<Scalars['Boolean']['input']>;
  /** The type of load this circuit supplies. */
  loadType?: InputMaybe<EnumElectricLoadTypes>;
  /** The name or label identifying the electrical circuit. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `ElectricalCircuit` values. */
export type ElectricalCircuitsConnection = {
  __typename?: 'ElectricalCircuitsConnection';
  /** A list of edges which contains the `ElectricalCircuit` and cursor to aid in pagination. */
  edges: Array<ElectricalCircuitsEdge>;
  /** A list of `ElectricalCircuit` objects. */
  nodes: Array<ElectricalCircuit>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ElectricalCircuit` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ElectricalCircuit` edge in the connection. */
export type ElectricalCircuitsEdge = {
  __typename?: 'ElectricalCircuitsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ElectricalCircuit` at the end of the edge. */
  node: ElectricalCircuit;
};

/** Methods to use when ordering `ElectricalCircuit`. */
export enum ElectricalCircuitsOrderBy {
  BREAKER_SIZE_AMPS_ASC = 'BREAKER_SIZE_AMPS_ASC',
  BREAKER_SIZE_AMPS_DESC = 'BREAKER_SIZE_AMPS_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  ELECTRICAL_METERING_POINT_ID_ASC = 'ELECTRICAL_METERING_POINT_ID_ASC',
  ELECTRICAL_METERING_POINT_ID_DESC = 'ELECTRICAL_METERING_POINT_ID_DESC',
  ELECTRICAL_PANEL_ID_ASC = 'ELECTRICAL_PANEL_ID_ASC',
  ELECTRICAL_PANEL_ID_DESC = 'ELECTRICAL_PANEL_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  IS_CAPACITOR_ASC = 'IS_CAPACITOR_ASC',
  IS_CAPACITOR_DESC = 'IS_CAPACITOR_DESC',
  IS_MOTOR_LOAD_ASC = 'IS_MOTOR_LOAD_ASC',
  IS_MOTOR_LOAD_DESC = 'IS_MOTOR_LOAD_DESC',
  LOAD_TYPE_ASC = 'LOAD_TYPE_ASC',
  LOAD_TYPE_DESC = 'LOAD_TYPE_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** A set of electrical metering points. */
export type ElectricalMeteringPoint = Node & {
  __typename?: 'ElectricalMeteringPoint';
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  apparentPower?: Maybe<DataPoint>;
  /** Total apparent power (kVA) across all phases. */
  apparentPowerDataPointId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  apparentPowerPhaseA?: Maybe<DataPoint>;
  /** Apparent power on Phase A. */
  apparentPowerPhaseADataPointId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  apparentPowerPhaseB?: Maybe<DataPoint>;
  /** Apparent power on Phase B. */
  apparentPowerPhaseBDataPointId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  apparentPowerPhaseC?: Maybe<DataPoint>;
  /** Apparent power on Phase C. */
  apparentPowerPhaseCDataPointId?: Maybe<Scalars['Int']['output']>;
  assetFacilityId?: Maybe<Scalars['Int']['output']>;
  assetName?: Maybe<Scalars['String']['output']>;
  /** The time at which the record was created */
  createdAt: Scalars['Datetime']['output'];
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  crestFactorPhaseA?: Maybe<DataPoint>;
  /** Ratio of peak to RMS current on Phase A. */
  crestFactorPhaseADataPointId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  crestFactorPhaseB?: Maybe<DataPoint>;
  /** Ratio of peak to RMS current on Phase B. */
  crestFactorPhaseBDataPointId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  crestFactorPhaseC?: Maybe<DataPoint>;
  /** Ratio of peak to RMS current on Phase C. */
  crestFactorPhaseCDataPointId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  cumulativeKwh?: Maybe<DataPoint>;
  /** Total energy consumed over time, in kilowatt-hours. */
  cumulativeKwhDataPointId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  current?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  currentAmplitudeImbalance?: Maybe<DataPoint>;
  /** Current amplitude imbalance between phases. */
  currentAmplitudeImbalanceDataPointId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  currentAverage?: Maybe<DataPoint>;
  /** Average current across all phases. */
  currentAverageDataPointId?: Maybe<Scalars['Int']['output']>;
  /** Average current across all phases, in amperes. */
  currentDataPointId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  currentThdAverage?: Maybe<DataPoint>;
  /** Average Total Harmonic Distortion (THD) of current across all phases. */
  currentThdAverageDataPointId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  currentThdPhaseA?: Maybe<DataPoint>;
  /** Current THD on Phase A. */
  currentThdPhaseADataPointId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  currentThdPhaseB?: Maybe<DataPoint>;
  /** Current THD on Phase B. */
  currentThdPhaseBDataPointId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  currentThdPhaseC?: Maybe<DataPoint>;
  /** Current THD on Phase C. */
  currentThdPhaseCDataPointId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  currentUnbalanceFactor?: Maybe<DataPoint>;
  /** Ratio indicating current unbalance between phases, accounting for phase angle. */
  currentUnbalanceFactorDataPointId?: Maybe<Scalars['Int']['output']>;
  /** A list of data sources that are associated with this electrical metering point. */
  dataSources?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  demandPhaseA?: Maybe<DataPoint>;
  /** Real power demand on Phase A. */
  demandPhaseADataPointId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  demandPhaseB?: Maybe<DataPoint>;
  /** Real power demand on Phase B. */
  demandPhaseBDataPointId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  demandPhaseC?: Maybe<DataPoint>;
  /** Real power demand on Phase C. */
  demandPhaseCDataPointId?: Maybe<Scalars['Int']['output']>;
  /** Reads and enables pagination through a set of `ElectricalCircuit`. */
  electricalCircuits: ElectricalCircuitsConnection;
  /** Reads a single `ElectricalPanel` that is related to this `ElectricalMeteringPoint`. */
  electricalPanel?: Maybe<ElectricalPanel>;
  /** Reads a single `Facility` that is related to this `ElectricalMeteringPoint`. */
  facility?: Maybe<Facility>;
  facilityId: Scalars['Int']['output'];
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  frequency?: Maybe<DataPoint>;
  /** Electrical frequency. */
  frequencyDataPointId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  frequencyDeviation?: Maybe<DataPoint>;
  /** Electrical Frequency deviation from nominal value. */
  frequencyDeviationDataPointId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  generatedEnergy?: Maybe<DataPoint>;
  /** Energy generated in kWh. */
  generatedEnergyDataPointId?: Maybe<Scalars['Int']['output']>;
  /** The identifier of the record. */
  id: Scalars['Int']['output'];
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  kwDemand?: Maybe<DataPoint>;
  /** Real power demand in kilowatts. */
  kwDemandDataPointId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  lineToLineDeviationAverage?: Maybe<DataPoint>;
  /** Average Line-to-Line voltage deviation from nominal value. */
  lineToLineDeviationAverageDataPointId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  lineToLineVoltage?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  lineToLineVoltageAb?: Maybe<DataPoint>;
  /** Voltage between Phase A and B. */
  lineToLineVoltageAbDataPointId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  lineToLineVoltageBc?: Maybe<DataPoint>;
  /** Voltage between Phase B and C. */
  lineToLineVoltageBcDataPointId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  lineToLineVoltageCa?: Maybe<DataPoint>;
  /** Voltage between Phase C and A. */
  lineToLineVoltageCaDataPointId?: Maybe<Scalars['Int']['output']>;
  /** Average voltage between phases. */
  lineToLineVoltageDataPointId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  lineToNeutralDeviationAverage?: Maybe<DataPoint>;
  /** Average Line-to-Neutral voltage deviation from nominal value. */
  lineToNeutralDeviationAverageDataPointId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  lineToNeutralVoltage?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  lineToNeutralVoltageA?: Maybe<DataPoint>;
  /** Voltage from Phase A to neutral. */
  lineToNeutralVoltageADataPointId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  lineToNeutralVoltageB?: Maybe<DataPoint>;
  /** Voltage from Phase B to neutral. */
  lineToNeutralVoltageBDataPointId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  lineToNeutralVoltageC?: Maybe<DataPoint>;
  /** Voltage from Phase C to neutral. */
  lineToNeutralVoltageCDataPointId?: Maybe<Scalars['Int']['output']>;
  /** Average voltage from each phase to neutral. */
  lineToNeutralVoltageDataPointId?: Maybe<Scalars['Int']['output']>;
  /** The related monitored asset. */
  monitoredAsset?: Maybe<MonitoredAsset>;
  /** Label identifying the monitored equipment (e.g., panel or circuit name). */
  monitoredEquipmentLabel: Scalars['String']['output'];
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  netEnergy?: Maybe<DataPoint>;
  /** Net energy consumed (consumption minus generation), in kWh. */
  netEnergyDataPointId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  neutralCurrent?: Maybe<DataPoint>;
  /** Current measured on the neutral line. */
  neutralCurrentDataPointId?: Maybe<Scalars['Int']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  phaseACurrent?: Maybe<DataPoint>;
  /** Current measured on Phase A. */
  phaseACurrentDataPointId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  phaseACurrentDeviation?: Maybe<DataPoint>;
  /** Current deviation on Phase A from average across all phases. */
  phaseACurrentDeviationDataPointId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  phaseAVoltage?: Maybe<DataPoint>;
  /** Voltage measured on Phase A. */
  phaseAVoltageDataPointId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  phaseAVoltageDeviation?: Maybe<DataPoint>;
  /** Voltage deviation on Phase A from average across all phases. */
  phaseAVoltageDeviationDataPointId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  phaseBCurrent?: Maybe<DataPoint>;
  /** Current measured on Phase B. */
  phaseBCurrentDataPointId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  phaseBCurrentDeviation?: Maybe<DataPoint>;
  /** Current deviation on Phase B from average across all phases. */
  phaseBCurrentDeviationDataPointId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  phaseBVoltage?: Maybe<DataPoint>;
  /** Voltage measured on Phase B. */
  phaseBVoltageDataPointId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  phaseBVoltageDeviation?: Maybe<DataPoint>;
  /** Voltage deviation on Phase B from average across all phases. */
  phaseBVoltageDeviationDataPointId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  phaseCCurrent?: Maybe<DataPoint>;
  /** Current measured on Phase C. */
  phaseCCurrentDataPointId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  phaseCCurrentDeviation?: Maybe<DataPoint>;
  /** Current deviation on Phase C from average across all phases. */
  phaseCCurrentDeviationDataPointId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  phaseCVoltage?: Maybe<DataPoint>;
  /** Voltage measured on Phase C. */
  phaseCVoltageDataPointId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  phaseCVoltageDeviation?: Maybe<DataPoint>;
  /** Voltage deviation on Phase C from average across all phases. */
  phaseCVoltageDeviationDataPointId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  powerFactor?: Maybe<DataPoint>;
  /** Ratio of real to apparent power; indicates efficiency. */
  powerFactorDataPointId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  powerFactorPhaseA?: Maybe<DataPoint>;
  /** Power factor measured on Phase A. */
  powerFactorPhaseADataPointId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  powerFactorPhaseB?: Maybe<DataPoint>;
  /** Power factor measured on Phase B. */
  powerFactorPhaseBDataPointId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  powerFactorPhaseC?: Maybe<DataPoint>;
  /** Power factor measured on Phase C. */
  powerFactorPhaseCDataPointId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  reactivePower?: Maybe<DataPoint>;
  /** Total reactive power, in kVAR. */
  reactivePowerDataPointId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  reactivePowerPhaseA?: Maybe<DataPoint>;
  /** Reactive power on Phase A. */
  reactivePowerPhaseADataPointId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  reactivePowerPhaseB?: Maybe<DataPoint>;
  /** Reactive power on Phase B. */
  reactivePowerPhaseBDataPointId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  reactivePowerPhaseC?: Maybe<DataPoint>;
  /** Reactive power on Phase C. */
  reactivePowerPhaseCDataPointId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  totalEnergy?: Maybe<DataPoint>;
  /** Total measured energy, summing imported and generated energy. */
  totalEnergyDataPointId?: Maybe<Scalars['Int']['output']>;
  /** The time at which the record was last updated */
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  voltageAmplitudeImbalance?: Maybe<DataPoint>;
  /** Voltage amplitude imbalance between phases. */
  voltageAmplitudeImbalanceDataPointId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  voltageAverage?: Maybe<DataPoint>;
  /** Average voltage across all phases. */
  voltageAverageDataPointId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  voltageThdAverage?: Maybe<DataPoint>;
  /** Average voltage THD across all phases. */
  voltageThdAverageDataPointId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  voltageThdPhaseA?: Maybe<DataPoint>;
  /** Voltage THD on Phase A. */
  voltageThdPhaseADataPointId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  voltageThdPhaseB?: Maybe<DataPoint>;
  /** Voltage THD on Phase B. */
  voltageThdPhaseBDataPointId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  voltageThdPhaseC?: Maybe<DataPoint>;
  /** Voltage THD on Phase C. */
  voltageThdPhaseCDataPointId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  voltageUnbalanceFactor?: Maybe<DataPoint>;
  /** Ratio indicating voltage unbalance between phases, accounting for phase angle. */
  voltageUnbalanceFactorDataPointId?: Maybe<Scalars['Int']['output']>;
};

/** A set of electrical metering points. */
export type ElectricalMeteringPointElectricalCircuitsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ElectricalCircuitCondition>;
  filter?: InputMaybe<ElectricalCircuitFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ElectricalCircuitsOrderBy>>;
};

/**
 * A condition to be used against `ElectricalMeteringPoint` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type ElectricalMeteringPointCondition = {
  /** Checks for equality with the object’s `apparentPowerDataPointId` field. */
  apparentPowerDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `apparentPowerPhaseADataPointId` field. */
  apparentPowerPhaseADataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `apparentPowerPhaseBDataPointId` field. */
  apparentPowerPhaseBDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `apparentPowerPhaseCDataPointId` field. */
  apparentPowerPhaseCDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `crestFactorPhaseADataPointId` field. */
  crestFactorPhaseADataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `crestFactorPhaseBDataPointId` field. */
  crestFactorPhaseBDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `crestFactorPhaseCDataPointId` field. */
  crestFactorPhaseCDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `cumulativeKwhDataPointId` field. */
  cumulativeKwhDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `currentAmplitudeImbalanceDataPointId` field. */
  currentAmplitudeImbalanceDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `currentAverageDataPointId` field. */
  currentAverageDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `currentDataPointId` field. */
  currentDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `currentThdAverageDataPointId` field. */
  currentThdAverageDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `currentThdPhaseADataPointId` field. */
  currentThdPhaseADataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `currentThdPhaseBDataPointId` field. */
  currentThdPhaseBDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `currentThdPhaseCDataPointId` field. */
  currentThdPhaseCDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `currentUnbalanceFactorDataPointId` field. */
  currentUnbalanceFactorDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `demandPhaseADataPointId` field. */
  demandPhaseADataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `demandPhaseBDataPointId` field. */
  demandPhaseBDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `demandPhaseCDataPointId` field. */
  demandPhaseCDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `frequencyDataPointId` field. */
  frequencyDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `frequencyDeviationDataPointId` field. */
  frequencyDeviationDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `generatedEnergyDataPointId` field. */
  generatedEnergyDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `kwDemandDataPointId` field. */
  kwDemandDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `lineToLineDeviationAverageDataPointId` field. */
  lineToLineDeviationAverageDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `lineToLineVoltageAbDataPointId` field. */
  lineToLineVoltageAbDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `lineToLineVoltageBcDataPointId` field. */
  lineToLineVoltageBcDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `lineToLineVoltageCaDataPointId` field. */
  lineToLineVoltageCaDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `lineToLineVoltageDataPointId` field. */
  lineToLineVoltageDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `lineToNeutralDeviationAverageDataPointId` field. */
  lineToNeutralDeviationAverageDataPointId?: InputMaybe<
    Scalars['Int']['input']
  >;
  /** Checks for equality with the object’s `lineToNeutralVoltageADataPointId` field. */
  lineToNeutralVoltageADataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `lineToNeutralVoltageBDataPointId` field. */
  lineToNeutralVoltageBDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `lineToNeutralVoltageCDataPointId` field. */
  lineToNeutralVoltageCDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `lineToNeutralVoltageDataPointId` field. */
  lineToNeutralVoltageDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `monitoredEquipmentLabel` field. */
  monitoredEquipmentLabel?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `netEnergyDataPointId` field. */
  netEnergyDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `neutralCurrentDataPointId` field. */
  neutralCurrentDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `phaseACurrentDataPointId` field. */
  phaseACurrentDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `phaseACurrentDeviationDataPointId` field. */
  phaseACurrentDeviationDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `phaseAVoltageDataPointId` field. */
  phaseAVoltageDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `phaseAVoltageDeviationDataPointId` field. */
  phaseAVoltageDeviationDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `phaseBCurrentDataPointId` field. */
  phaseBCurrentDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `phaseBCurrentDeviationDataPointId` field. */
  phaseBCurrentDeviationDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `phaseBVoltageDataPointId` field. */
  phaseBVoltageDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `phaseBVoltageDeviationDataPointId` field. */
  phaseBVoltageDeviationDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `phaseCCurrentDataPointId` field. */
  phaseCCurrentDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `phaseCCurrentDeviationDataPointId` field. */
  phaseCCurrentDeviationDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `phaseCVoltageDataPointId` field. */
  phaseCVoltageDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `phaseCVoltageDeviationDataPointId` field. */
  phaseCVoltageDeviationDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `powerFactorDataPointId` field. */
  powerFactorDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `powerFactorPhaseADataPointId` field. */
  powerFactorPhaseADataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `powerFactorPhaseBDataPointId` field. */
  powerFactorPhaseBDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `powerFactorPhaseCDataPointId` field. */
  powerFactorPhaseCDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `reactivePowerDataPointId` field. */
  reactivePowerDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `reactivePowerPhaseADataPointId` field. */
  reactivePowerPhaseADataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `reactivePowerPhaseBDataPointId` field. */
  reactivePowerPhaseBDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `reactivePowerPhaseCDataPointId` field. */
  reactivePowerPhaseCDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `totalEnergyDataPointId` field. */
  totalEnergyDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `voltageAmplitudeImbalanceDataPointId` field. */
  voltageAmplitudeImbalanceDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `voltageAverageDataPointId` field. */
  voltageAverageDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `voltageThdAverageDataPointId` field. */
  voltageThdAverageDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `voltageThdPhaseADataPointId` field. */
  voltageThdPhaseADataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `voltageThdPhaseBDataPointId` field. */
  voltageThdPhaseBDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `voltageThdPhaseCDataPointId` field. */
  voltageThdPhaseCDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `voltageUnbalanceFactorDataPointId` field. */
  voltageUnbalanceFactorDataPointId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `ElectricalMeteringPoint` object types. All fields are combined with a logical ‘and.’ */
export type ElectricalMeteringPointFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ElectricalMeteringPointFilter>>;
  /** Filter by the object’s `apparentPowerDataPointId` field. */
  apparentPowerDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `apparentPowerPhaseADataPointId` field. */
  apparentPowerPhaseADataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `apparentPowerPhaseBDataPointId` field. */
  apparentPowerPhaseBDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `apparentPowerPhaseCDataPointId` field. */
  apparentPowerPhaseCDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `assetFacilityId` field. */
  assetFacilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `assetName` field. */
  assetName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `crestFactorPhaseADataPointId` field. */
  crestFactorPhaseADataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `crestFactorPhaseBDataPointId` field. */
  crestFactorPhaseBDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `crestFactorPhaseCDataPointId` field. */
  crestFactorPhaseCDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `cumulativeKwhDataPointId` field. */
  cumulativeKwhDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `currentAmplitudeImbalanceDataPointId` field. */
  currentAmplitudeImbalanceDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `currentAverageDataPointId` field. */
  currentAverageDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `currentDataPointId` field. */
  currentDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `currentThdAverageDataPointId` field. */
  currentThdAverageDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `currentThdPhaseADataPointId` field. */
  currentThdPhaseADataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `currentThdPhaseBDataPointId` field. */
  currentThdPhaseBDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `currentThdPhaseCDataPointId` field. */
  currentThdPhaseCDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `currentUnbalanceFactorDataPointId` field. */
  currentUnbalanceFactorDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `dataSources` field. */
  dataSources?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `demandPhaseADataPointId` field. */
  demandPhaseADataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `demandPhaseBDataPointId` field. */
  demandPhaseBDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `demandPhaseCDataPointId` field. */
  demandPhaseCDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `frequencyDataPointId` field. */
  frequencyDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `frequencyDeviationDataPointId` field. */
  frequencyDeviationDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `generatedEnergyDataPointId` field. */
  generatedEnergyDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `kwDemandDataPointId` field. */
  kwDemandDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `lineToLineDeviationAverageDataPointId` field. */
  lineToLineDeviationAverageDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `lineToLineVoltageAbDataPointId` field. */
  lineToLineVoltageAbDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `lineToLineVoltageBcDataPointId` field. */
  lineToLineVoltageBcDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `lineToLineVoltageCaDataPointId` field. */
  lineToLineVoltageCaDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `lineToLineVoltageDataPointId` field. */
  lineToLineVoltageDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `lineToNeutralDeviationAverageDataPointId` field. */
  lineToNeutralDeviationAverageDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `lineToNeutralVoltageADataPointId` field. */
  lineToNeutralVoltageADataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `lineToNeutralVoltageBDataPointId` field. */
  lineToNeutralVoltageBDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `lineToNeutralVoltageCDataPointId` field. */
  lineToNeutralVoltageCDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `lineToNeutralVoltageDataPointId` field. */
  lineToNeutralVoltageDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `monitoredEquipmentLabel` field. */
  monitoredEquipmentLabel?: InputMaybe<StringFilter>;
  /** Filter by the object’s `netEnergyDataPointId` field. */
  netEnergyDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `neutralCurrentDataPointId` field. */
  neutralCurrentDataPointId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ElectricalMeteringPointFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ElectricalMeteringPointFilter>>;
  /** Filter by the object’s `phaseACurrentDataPointId` field. */
  phaseACurrentDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `phaseACurrentDeviationDataPointId` field. */
  phaseACurrentDeviationDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `phaseAVoltageDataPointId` field. */
  phaseAVoltageDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `phaseAVoltageDeviationDataPointId` field. */
  phaseAVoltageDeviationDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `phaseBCurrentDataPointId` field. */
  phaseBCurrentDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `phaseBCurrentDeviationDataPointId` field. */
  phaseBCurrentDeviationDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `phaseBVoltageDataPointId` field. */
  phaseBVoltageDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `phaseBVoltageDeviationDataPointId` field. */
  phaseBVoltageDeviationDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `phaseCCurrentDataPointId` field. */
  phaseCCurrentDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `phaseCCurrentDeviationDataPointId` field. */
  phaseCCurrentDeviationDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `phaseCVoltageDataPointId` field. */
  phaseCVoltageDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `phaseCVoltageDeviationDataPointId` field. */
  phaseCVoltageDeviationDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `powerFactorDataPointId` field. */
  powerFactorDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `powerFactorPhaseADataPointId` field. */
  powerFactorPhaseADataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `powerFactorPhaseBDataPointId` field. */
  powerFactorPhaseBDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `powerFactorPhaseCDataPointId` field. */
  powerFactorPhaseCDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `reactivePowerDataPointId` field. */
  reactivePowerDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `reactivePowerPhaseADataPointId` field. */
  reactivePowerPhaseADataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `reactivePowerPhaseBDataPointId` field. */
  reactivePowerPhaseBDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `reactivePowerPhaseCDataPointId` field. */
  reactivePowerPhaseCDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `totalEnergyDataPointId` field. */
  totalEnergyDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `voltageAmplitudeImbalanceDataPointId` field. */
  voltageAmplitudeImbalanceDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `voltageAverageDataPointId` field. */
  voltageAverageDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `voltageThdAverageDataPointId` field. */
  voltageThdAverageDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `voltageThdPhaseADataPointId` field. */
  voltageThdPhaseADataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `voltageThdPhaseBDataPointId` field. */
  voltageThdPhaseBDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `voltageThdPhaseCDataPointId` field. */
  voltageThdPhaseCDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `voltageUnbalanceFactorDataPointId` field. */
  voltageUnbalanceFactorDataPointId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `ElectricalMeteringPoint` */
export type ElectricalMeteringPointInput = {
  /** Total apparent power (kVA) across all phases. */
  apparentPowerDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Apparent power on Phase A. */
  apparentPowerPhaseADataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Apparent power on Phase B. */
  apparentPowerPhaseBDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Apparent power on Phase C. */
  apparentPowerPhaseCDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Ratio of peak to RMS current on Phase A. */
  crestFactorPhaseADataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Ratio of peak to RMS current on Phase B. */
  crestFactorPhaseBDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Ratio of peak to RMS current on Phase C. */
  crestFactorPhaseCDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Total energy consumed over time, in kilowatt-hours. */
  cumulativeKwhDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Current amplitude imbalance between phases. */
  currentAmplitudeImbalanceDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Average current across all phases. */
  currentAverageDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Average current across all phases, in amperes. */
  currentDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Average Total Harmonic Distortion (THD) of current across all phases. */
  currentThdAverageDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Current THD on Phase A. */
  currentThdPhaseADataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Current THD on Phase B. */
  currentThdPhaseBDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Current THD on Phase C. */
  currentThdPhaseCDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Ratio indicating current unbalance between phases, accounting for phase angle. */
  currentUnbalanceFactorDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Mutates a `DataPoint` as part of the payload */
  dataPoint?: InputMaybe<DataPointInput>;
  /** Real power demand on Phase A. */
  demandPhaseADataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Real power demand on Phase B. */
  demandPhaseBDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Real power demand on Phase C. */
  demandPhaseCDataPointId?: InputMaybe<Scalars['Int']['input']>;
  facilityId: Scalars['Int']['input'];
  /** Electrical frequency. */
  frequencyDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Electrical Frequency deviation from nominal value. */
  frequencyDeviationDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Energy generated in kWh. */
  generatedEnergyDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Real power demand in kilowatts. */
  kwDemandDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Average Line-to-Line voltage deviation from nominal value. */
  lineToLineDeviationAverageDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Voltage between Phase A and B. */
  lineToLineVoltageAbDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Voltage between Phase B and C. */
  lineToLineVoltageBcDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Voltage between Phase C and A. */
  lineToLineVoltageCaDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Average voltage between phases. */
  lineToLineVoltageDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Average Line-to-Neutral voltage deviation from nominal value. */
  lineToNeutralDeviationAverageDataPointId?: InputMaybe<
    Scalars['Int']['input']
  >;
  /** Voltage from Phase A to neutral. */
  lineToNeutralVoltageADataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Voltage from Phase B to neutral. */
  lineToNeutralVoltageBDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Voltage from Phase C to neutral. */
  lineToNeutralVoltageCDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Average voltage from each phase to neutral. */
  lineToNeutralVoltageDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Label identifying the monitored equipment (e.g., panel or circuit name). */
  monitoredEquipmentLabel: Scalars['String']['input'];
  /** Net energy consumed (consumption minus generation), in kWh. */
  netEnergyDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Current measured on the neutral line. */
  neutralCurrentDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Current measured on Phase A. */
  phaseACurrentDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Current deviation on Phase A from average across all phases. */
  phaseACurrentDeviationDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Voltage measured on Phase A. */
  phaseAVoltageDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Voltage deviation on Phase A from average across all phases. */
  phaseAVoltageDeviationDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Current measured on Phase B. */
  phaseBCurrentDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Current deviation on Phase B from average across all phases. */
  phaseBCurrentDeviationDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Voltage measured on Phase B. */
  phaseBVoltageDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Voltage deviation on Phase B from average across all phases. */
  phaseBVoltageDeviationDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Current measured on Phase C. */
  phaseCCurrentDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Current deviation on Phase C from average across all phases. */
  phaseCCurrentDeviationDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Voltage measured on Phase C. */
  phaseCVoltageDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Voltage deviation on Phase C from average across all phases. */
  phaseCVoltageDeviationDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Ratio of real to apparent power; indicates efficiency. */
  powerFactorDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Power factor measured on Phase A. */
  powerFactorPhaseADataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Power factor measured on Phase B. */
  powerFactorPhaseBDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Power factor measured on Phase C. */
  powerFactorPhaseCDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Total reactive power, in kVAR. */
  reactivePowerDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Reactive power on Phase A. */
  reactivePowerPhaseADataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Reactive power on Phase B. */
  reactivePowerPhaseBDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Reactive power on Phase C. */
  reactivePowerPhaseCDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Total measured energy, summing imported and generated energy. */
  totalEnergyDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Voltage amplitude imbalance between phases. */
  voltageAmplitudeImbalanceDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Average voltage across all phases. */
  voltageAverageDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Average voltage THD across all phases. */
  voltageThdAverageDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Voltage THD on Phase A. */
  voltageThdPhaseADataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Voltage THD on Phase B. */
  voltageThdPhaseBDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Voltage THD on Phase C. */
  voltageThdPhaseCDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Ratio indicating voltage unbalance between phases, accounting for phase angle. */
  voltageUnbalanceFactorDataPointId?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents an update to a `ElectricalMeteringPoint`. Fields that are set will be updated. */
export type ElectricalMeteringPointPatch = {
  /** Total apparent power (kVA) across all phases. */
  apparentPowerDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Apparent power on Phase A. */
  apparentPowerPhaseADataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Apparent power on Phase B. */
  apparentPowerPhaseBDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Apparent power on Phase C. */
  apparentPowerPhaseCDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Ratio of peak to RMS current on Phase A. */
  crestFactorPhaseADataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Ratio of peak to RMS current on Phase B. */
  crestFactorPhaseBDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Ratio of peak to RMS current on Phase C. */
  crestFactorPhaseCDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Total energy consumed over time, in kilowatt-hours. */
  cumulativeKwhDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Current amplitude imbalance between phases. */
  currentAmplitudeImbalanceDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Average current across all phases. */
  currentAverageDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Average current across all phases, in amperes. */
  currentDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Average Total Harmonic Distortion (THD) of current across all phases. */
  currentThdAverageDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Current THD on Phase A. */
  currentThdPhaseADataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Current THD on Phase B. */
  currentThdPhaseBDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Current THD on Phase C. */
  currentThdPhaseCDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Ratio indicating current unbalance between phases, accounting for phase angle. */
  currentUnbalanceFactorDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Real power demand on Phase A. */
  demandPhaseADataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Real power demand on Phase B. */
  demandPhaseBDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Real power demand on Phase C. */
  demandPhaseCDataPointId?: InputMaybe<Scalars['Int']['input']>;
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** Electrical frequency. */
  frequencyDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Electrical Frequency deviation from nominal value. */
  frequencyDeviationDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Energy generated in kWh. */
  generatedEnergyDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Real power demand in kilowatts. */
  kwDemandDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Average Line-to-Line voltage deviation from nominal value. */
  lineToLineDeviationAverageDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Voltage between Phase A and B. */
  lineToLineVoltageAbDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Voltage between Phase B and C. */
  lineToLineVoltageBcDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Voltage between Phase C and A. */
  lineToLineVoltageCaDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Average voltage between phases. */
  lineToLineVoltageDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Average Line-to-Neutral voltage deviation from nominal value. */
  lineToNeutralDeviationAverageDataPointId?: InputMaybe<
    Scalars['Int']['input']
  >;
  /** Voltage from Phase A to neutral. */
  lineToNeutralVoltageADataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Voltage from Phase B to neutral. */
  lineToNeutralVoltageBDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Voltage from Phase C to neutral. */
  lineToNeutralVoltageCDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Average voltage from each phase to neutral. */
  lineToNeutralVoltageDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Label identifying the monitored equipment (e.g., panel or circuit name). */
  monitoredEquipmentLabel?: InputMaybe<Scalars['String']['input']>;
  /** Net energy consumed (consumption minus generation), in kWh. */
  netEnergyDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Current measured on the neutral line. */
  neutralCurrentDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Current measured on Phase A. */
  phaseACurrentDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Current deviation on Phase A from average across all phases. */
  phaseACurrentDeviationDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Voltage measured on Phase A. */
  phaseAVoltageDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Voltage deviation on Phase A from average across all phases. */
  phaseAVoltageDeviationDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Current measured on Phase B. */
  phaseBCurrentDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Current deviation on Phase B from average across all phases. */
  phaseBCurrentDeviationDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Voltage measured on Phase B. */
  phaseBVoltageDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Voltage deviation on Phase B from average across all phases. */
  phaseBVoltageDeviationDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Current measured on Phase C. */
  phaseCCurrentDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Current deviation on Phase C from average across all phases. */
  phaseCCurrentDeviationDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Voltage measured on Phase C. */
  phaseCVoltageDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Voltage deviation on Phase C from average across all phases. */
  phaseCVoltageDeviationDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Ratio of real to apparent power; indicates efficiency. */
  powerFactorDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Power factor measured on Phase A. */
  powerFactorPhaseADataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Power factor measured on Phase B. */
  powerFactorPhaseBDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Power factor measured on Phase C. */
  powerFactorPhaseCDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Total reactive power, in kVAR. */
  reactivePowerDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Reactive power on Phase A. */
  reactivePowerPhaseADataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Reactive power on Phase B. */
  reactivePowerPhaseBDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Reactive power on Phase C. */
  reactivePowerPhaseCDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Total measured energy, summing imported and generated energy. */
  totalEnergyDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Voltage amplitude imbalance between phases. */
  voltageAmplitudeImbalanceDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Average voltage across all phases. */
  voltageAverageDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Average voltage THD across all phases. */
  voltageThdAverageDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Voltage THD on Phase A. */
  voltageThdPhaseADataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Voltage THD on Phase B. */
  voltageThdPhaseBDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Voltage THD on Phase C. */
  voltageThdPhaseCDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Ratio indicating voltage unbalance between phases, accounting for phase angle. */
  voltageUnbalanceFactorDataPointId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnection = {
  __typename?: 'ElectricalMeteringPointsConnection';
  /** Returns the aggregate apparentPower timeseries data for the ElectricalMeteringPointsConnection  */
  apparentPower?: Maybe<MetricDataConnection>;
  /** Returns the aggregate apparentPowerPhaseA timeseries data for the ElectricalMeteringPointsConnection  */
  apparentPowerPhaseA?: Maybe<MetricDataConnection>;
  /** Returns the aggregate apparentPowerPhaseB timeseries data for the ElectricalMeteringPointsConnection  */
  apparentPowerPhaseB?: Maybe<MetricDataConnection>;
  /** Returns the aggregate apparentPowerPhaseC timeseries data for the ElectricalMeteringPointsConnection  */
  apparentPowerPhaseC?: Maybe<MetricDataConnection>;
  /** Returns the aggregate crestFactorPhaseA timeseries data for the ElectricalMeteringPointsConnection  */
  crestFactorPhaseA?: Maybe<MetricDataConnection>;
  /** Returns the aggregate crestFactorPhaseB timeseries data for the ElectricalMeteringPointsConnection  */
  crestFactorPhaseB?: Maybe<MetricDataConnection>;
  /** Returns the aggregate crestFactorPhaseC timeseries data for the ElectricalMeteringPointsConnection  */
  crestFactorPhaseC?: Maybe<MetricDataConnection>;
  /** Returns the aggregate cumulativeKwh timeseries data for the ElectricalMeteringPointsConnection  */
  cumulativeKwh?: Maybe<MetricDataConnection>;
  /** Returns the aggregate current timeseries data for the ElectricalMeteringPointsConnection  */
  current?: Maybe<MetricDataConnection>;
  /** Returns the aggregate currentAmplitudeImbalance timeseries data for the ElectricalMeteringPointsConnection  */
  currentAmplitudeImbalance?: Maybe<MetricDataConnection>;
  /** Returns the aggregate currentAverage timeseries data for the ElectricalMeteringPointsConnection  */
  currentAverage?: Maybe<MetricDataConnection>;
  /** Returns the aggregate currentThdAverage timeseries data for the ElectricalMeteringPointsConnection  */
  currentThdAverage?: Maybe<MetricDataConnection>;
  /** Returns the aggregate currentThdPhaseA timeseries data for the ElectricalMeteringPointsConnection  */
  currentThdPhaseA?: Maybe<MetricDataConnection>;
  /** Returns the aggregate currentThdPhaseB timeseries data for the ElectricalMeteringPointsConnection  */
  currentThdPhaseB?: Maybe<MetricDataConnection>;
  /** Returns the aggregate currentThdPhaseC timeseries data for the ElectricalMeteringPointsConnection  */
  currentThdPhaseC?: Maybe<MetricDataConnection>;
  /** Returns the aggregate currentUnbalanceFactor timeseries data for the ElectricalMeteringPointsConnection  */
  currentUnbalanceFactor?: Maybe<MetricDataConnection>;
  /** Returns the aggregate demandPhaseA timeseries data for the ElectricalMeteringPointsConnection  */
  demandPhaseA?: Maybe<MetricDataConnection>;
  /** Returns the aggregate demandPhaseB timeseries data for the ElectricalMeteringPointsConnection  */
  demandPhaseB?: Maybe<MetricDataConnection>;
  /** Returns the aggregate demandPhaseC timeseries data for the ElectricalMeteringPointsConnection  */
  demandPhaseC?: Maybe<MetricDataConnection>;
  /** A list of edges which contains the `ElectricalMeteringPoint` and cursor to aid in pagination. */
  edges: Array<ElectricalMeteringPointsEdge>;
  /** Returns the aggregate frequency timeseries data for the ElectricalMeteringPointsConnection  */
  frequency?: Maybe<MetricDataConnection>;
  /** Returns the aggregate frequencyDeviation timeseries data for the ElectricalMeteringPointsConnection  */
  frequencyDeviation?: Maybe<MetricDataConnection>;
  /** Returns the aggregate generatedEnergy timeseries data for the ElectricalMeteringPointsConnection  */
  generatedEnergy?: Maybe<MetricDataConnection>;
  /** Returns the aggregate kwDemand timeseries data for the ElectricalMeteringPointsConnection  */
  kwDemand?: Maybe<MetricDataConnection>;
  /** Returns the aggregate lineToLineDeviationAverage timeseries data for the ElectricalMeteringPointsConnection  */
  lineToLineDeviationAverage?: Maybe<MetricDataConnection>;
  /** Returns the aggregate lineToLineVoltage timeseries data for the ElectricalMeteringPointsConnection  */
  lineToLineVoltage?: Maybe<MetricDataConnection>;
  /** Returns the aggregate lineToLineVoltageAb timeseries data for the ElectricalMeteringPointsConnection  */
  lineToLineVoltageAb?: Maybe<MetricDataConnection>;
  /** Returns the aggregate lineToLineVoltageBc timeseries data for the ElectricalMeteringPointsConnection  */
  lineToLineVoltageBc?: Maybe<MetricDataConnection>;
  /** Returns the aggregate lineToLineVoltageCa timeseries data for the ElectricalMeteringPointsConnection  */
  lineToLineVoltageCa?: Maybe<MetricDataConnection>;
  /** Returns the aggregate lineToNeutralDeviationAverage timeseries data for the ElectricalMeteringPointsConnection  */
  lineToNeutralDeviationAverage?: Maybe<MetricDataConnection>;
  /** Returns the aggregate lineToNeutralVoltage timeseries data for the ElectricalMeteringPointsConnection  */
  lineToNeutralVoltage?: Maybe<MetricDataConnection>;
  /** Returns the aggregate lineToNeutralVoltageA timeseries data for the ElectricalMeteringPointsConnection  */
  lineToNeutralVoltageA?: Maybe<MetricDataConnection>;
  /** Returns the aggregate lineToNeutralVoltageB timeseries data for the ElectricalMeteringPointsConnection  */
  lineToNeutralVoltageB?: Maybe<MetricDataConnection>;
  /** Returns the aggregate lineToNeutralVoltageC timeseries data for the ElectricalMeteringPointsConnection  */
  lineToNeutralVoltageC?: Maybe<MetricDataConnection>;
  /** Returns the aggregate netEnergy timeseries data for the ElectricalMeteringPointsConnection  */
  netEnergy?: Maybe<MetricDataConnection>;
  /** Returns the aggregate neutralCurrent timeseries data for the ElectricalMeteringPointsConnection  */
  neutralCurrent?: Maybe<MetricDataConnection>;
  /** A list of `ElectricalMeteringPoint` objects. */
  nodes: Array<ElectricalMeteringPoint>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Returns the aggregate phaseACurrent timeseries data for the ElectricalMeteringPointsConnection  */
  phaseACurrent?: Maybe<MetricDataConnection>;
  /** Returns the aggregate phaseACurrentDeviation timeseries data for the ElectricalMeteringPointsConnection  */
  phaseACurrentDeviation?: Maybe<MetricDataConnection>;
  /** Returns the aggregate phaseAVoltage timeseries data for the ElectricalMeteringPointsConnection  */
  phaseAVoltage?: Maybe<MetricDataConnection>;
  /** Returns the aggregate phaseAVoltageDeviation timeseries data for the ElectricalMeteringPointsConnection  */
  phaseAVoltageDeviation?: Maybe<MetricDataConnection>;
  /** Returns the aggregate phaseBCurrent timeseries data for the ElectricalMeteringPointsConnection  */
  phaseBCurrent?: Maybe<MetricDataConnection>;
  /** Returns the aggregate phaseBCurrentDeviation timeseries data for the ElectricalMeteringPointsConnection  */
  phaseBCurrentDeviation?: Maybe<MetricDataConnection>;
  /** Returns the aggregate phaseBVoltage timeseries data for the ElectricalMeteringPointsConnection  */
  phaseBVoltage?: Maybe<MetricDataConnection>;
  /** Returns the aggregate phaseBVoltageDeviation timeseries data for the ElectricalMeteringPointsConnection  */
  phaseBVoltageDeviation?: Maybe<MetricDataConnection>;
  /** Returns the aggregate phaseCCurrent timeseries data for the ElectricalMeteringPointsConnection  */
  phaseCCurrent?: Maybe<MetricDataConnection>;
  /** Returns the aggregate phaseCCurrentDeviation timeseries data for the ElectricalMeteringPointsConnection  */
  phaseCCurrentDeviation?: Maybe<MetricDataConnection>;
  /** Returns the aggregate phaseCVoltage timeseries data for the ElectricalMeteringPointsConnection  */
  phaseCVoltage?: Maybe<MetricDataConnection>;
  /** Returns the aggregate phaseCVoltageDeviation timeseries data for the ElectricalMeteringPointsConnection  */
  phaseCVoltageDeviation?: Maybe<MetricDataConnection>;
  /** Returns the aggregate powerFactor timeseries data for the ElectricalMeteringPointsConnection  */
  powerFactor?: Maybe<MetricDataConnection>;
  /** Returns the aggregate powerFactorPhaseA timeseries data for the ElectricalMeteringPointsConnection  */
  powerFactorPhaseA?: Maybe<MetricDataConnection>;
  /** Returns the aggregate powerFactorPhaseB timeseries data for the ElectricalMeteringPointsConnection  */
  powerFactorPhaseB?: Maybe<MetricDataConnection>;
  /** Returns the aggregate powerFactorPhaseC timeseries data for the ElectricalMeteringPointsConnection  */
  powerFactorPhaseC?: Maybe<MetricDataConnection>;
  /** Returns the aggregate reactivePower timeseries data for the ElectricalMeteringPointsConnection  */
  reactivePower?: Maybe<MetricDataConnection>;
  /** Returns the aggregate reactivePowerPhaseA timeseries data for the ElectricalMeteringPointsConnection  */
  reactivePowerPhaseA?: Maybe<MetricDataConnection>;
  /** Returns the aggregate reactivePowerPhaseB timeseries data for the ElectricalMeteringPointsConnection  */
  reactivePowerPhaseB?: Maybe<MetricDataConnection>;
  /** Returns the aggregate reactivePowerPhaseC timeseries data for the ElectricalMeteringPointsConnection  */
  reactivePowerPhaseC?: Maybe<MetricDataConnection>;
  /** The count of *all* `ElectricalMeteringPoint` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
  /** Returns the aggregate totalEnergy timeseries data for the ElectricalMeteringPointsConnection  */
  totalEnergy?: Maybe<MetricDataConnection>;
  /** Returns the aggregate voltageAmplitudeImbalance timeseries data for the ElectricalMeteringPointsConnection  */
  voltageAmplitudeImbalance?: Maybe<MetricDataConnection>;
  /** Returns the aggregate voltageAverage timeseries data for the ElectricalMeteringPointsConnection  */
  voltageAverage?: Maybe<MetricDataConnection>;
  /** Returns the aggregate voltageThdAverage timeseries data for the ElectricalMeteringPointsConnection  */
  voltageThdAverage?: Maybe<MetricDataConnection>;
  /** Returns the aggregate voltageThdPhaseA timeseries data for the ElectricalMeteringPointsConnection  */
  voltageThdPhaseA?: Maybe<MetricDataConnection>;
  /** Returns the aggregate voltageThdPhaseB timeseries data for the ElectricalMeteringPointsConnection  */
  voltageThdPhaseB?: Maybe<MetricDataConnection>;
  /** Returns the aggregate voltageThdPhaseC timeseries data for the ElectricalMeteringPointsConnection  */
  voltageThdPhaseC?: Maybe<MetricDataConnection>;
  /** Returns the aggregate voltageUnbalanceFactor timeseries data for the ElectricalMeteringPointsConnection  */
  voltageUnbalanceFactor?: Maybe<MetricDataConnection>;
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionApparentPowerArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionApparentPowerPhaseAArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionApparentPowerPhaseBArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionApparentPowerPhaseCArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionCrestFactorPhaseAArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionCrestFactorPhaseBArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionCrestFactorPhaseCArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionCumulativeKwhArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionCurrentArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionCurrentAmplitudeImbalanceArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionCurrentAverageArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionCurrentThdAverageArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionCurrentThdPhaseAArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionCurrentThdPhaseBArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionCurrentThdPhaseCArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionCurrentUnbalanceFactorArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionDemandPhaseAArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionDemandPhaseBArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionDemandPhaseCArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionFrequencyArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionFrequencyDeviationArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionGeneratedEnergyArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionKwDemandArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionLineToLineDeviationAverageArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionLineToLineVoltageArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionLineToLineVoltageAbArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionLineToLineVoltageBcArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionLineToLineVoltageCaArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionLineToNeutralDeviationAverageArgs =
  {
    after?: InputMaybe<Scalars['Cursor']['input']>;
    aggregation?: MetricDataAggregationMethod;
    before?: InputMaybe<Scalars['Cursor']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    from: Scalars['String']['input'];
    last?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    orderBy?: MetricDataOrderBy;
    samplingWindow?: InputMaybe<Scalars['String']['input']>;
    timezone?: InputMaybe<Scalars['String']['input']>;
    to: Scalars['String']['input'];
    unit?: InputMaybe<Scalars['String']['input']>;
    window?: Scalars['String']['input'];
  };

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionLineToNeutralVoltageArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionLineToNeutralVoltageAArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionLineToNeutralVoltageBArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionLineToNeutralVoltageCArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionNetEnergyArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionNeutralCurrentArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionPhaseACurrentArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionPhaseACurrentDeviationArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionPhaseAVoltageArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionPhaseAVoltageDeviationArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionPhaseBCurrentArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionPhaseBCurrentDeviationArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionPhaseBVoltageArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionPhaseBVoltageDeviationArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionPhaseCCurrentArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionPhaseCCurrentDeviationArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionPhaseCVoltageArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionPhaseCVoltageDeviationArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionPowerFactorArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionPowerFactorPhaseAArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionPowerFactorPhaseBArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionPowerFactorPhaseCArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionReactivePowerArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionReactivePowerPhaseAArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionReactivePowerPhaseBArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionReactivePowerPhaseCArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionTotalEnergyArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionVoltageAmplitudeImbalanceArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionVoltageAverageArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionVoltageThdAverageArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionVoltageThdPhaseAArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionVoltageThdPhaseBArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionVoltageThdPhaseCArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ElectricalMeteringPoint` values. */
export type ElectricalMeteringPointsConnectionVoltageUnbalanceFactorArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A `ElectricalMeteringPoint` edge in the connection. */
export type ElectricalMeteringPointsEdge = {
  __typename?: 'ElectricalMeteringPointsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ElectricalMeteringPoint` at the end of the edge. */
  node: ElectricalMeteringPoint;
};

/** Methods to use when ordering `ElectricalMeteringPoint`. */
export enum ElectricalMeteringPointsOrderBy {
  APPARENT_POWER_DATA_POINT_ID_ASC = 'APPARENT_POWER_DATA_POINT_ID_ASC',
  APPARENT_POWER_DATA_POINT_ID_DESC = 'APPARENT_POWER_DATA_POINT_ID_DESC',
  APPARENT_POWER_PHASE_A_DATA_POINT_ID_ASC = 'APPARENT_POWER_PHASE_A_DATA_POINT_ID_ASC',
  APPARENT_POWER_PHASE_A_DATA_POINT_ID_DESC = 'APPARENT_POWER_PHASE_A_DATA_POINT_ID_DESC',
  APPARENT_POWER_PHASE_B_DATA_POINT_ID_ASC = 'APPARENT_POWER_PHASE_B_DATA_POINT_ID_ASC',
  APPARENT_POWER_PHASE_B_DATA_POINT_ID_DESC = 'APPARENT_POWER_PHASE_B_DATA_POINT_ID_DESC',
  APPARENT_POWER_PHASE_C_DATA_POINT_ID_ASC = 'APPARENT_POWER_PHASE_C_DATA_POINT_ID_ASC',
  APPARENT_POWER_PHASE_C_DATA_POINT_ID_DESC = 'APPARENT_POWER_PHASE_C_DATA_POINT_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  CREST_FACTOR_PHASE_A_DATA_POINT_ID_ASC = 'CREST_FACTOR_PHASE_A_DATA_POINT_ID_ASC',
  CREST_FACTOR_PHASE_A_DATA_POINT_ID_DESC = 'CREST_FACTOR_PHASE_A_DATA_POINT_ID_DESC',
  CREST_FACTOR_PHASE_B_DATA_POINT_ID_ASC = 'CREST_FACTOR_PHASE_B_DATA_POINT_ID_ASC',
  CREST_FACTOR_PHASE_B_DATA_POINT_ID_DESC = 'CREST_FACTOR_PHASE_B_DATA_POINT_ID_DESC',
  CREST_FACTOR_PHASE_C_DATA_POINT_ID_ASC = 'CREST_FACTOR_PHASE_C_DATA_POINT_ID_ASC',
  CREST_FACTOR_PHASE_C_DATA_POINT_ID_DESC = 'CREST_FACTOR_PHASE_C_DATA_POINT_ID_DESC',
  CUMULATIVE_KWH_DATA_POINT_ID_ASC = 'CUMULATIVE_KWH_DATA_POINT_ID_ASC',
  CUMULATIVE_KWH_DATA_POINT_ID_DESC = 'CUMULATIVE_KWH_DATA_POINT_ID_DESC',
  CURRENT_AMPLITUDE_IMBALANCE_DATA_POINT_ID_ASC = 'CURRENT_AMPLITUDE_IMBALANCE_DATA_POINT_ID_ASC',
  CURRENT_AMPLITUDE_IMBALANCE_DATA_POINT_ID_DESC = 'CURRENT_AMPLITUDE_IMBALANCE_DATA_POINT_ID_DESC',
  CURRENT_AVERAGE_DATA_POINT_ID_ASC = 'CURRENT_AVERAGE_DATA_POINT_ID_ASC',
  CURRENT_AVERAGE_DATA_POINT_ID_DESC = 'CURRENT_AVERAGE_DATA_POINT_ID_DESC',
  CURRENT_DATA_POINT_ID_ASC = 'CURRENT_DATA_POINT_ID_ASC',
  CURRENT_DATA_POINT_ID_DESC = 'CURRENT_DATA_POINT_ID_DESC',
  CURRENT_THD_AVERAGE_DATA_POINT_ID_ASC = 'CURRENT_THD_AVERAGE_DATA_POINT_ID_ASC',
  CURRENT_THD_AVERAGE_DATA_POINT_ID_DESC = 'CURRENT_THD_AVERAGE_DATA_POINT_ID_DESC',
  CURRENT_THD_PHASE_A_DATA_POINT_ID_ASC = 'CURRENT_THD_PHASE_A_DATA_POINT_ID_ASC',
  CURRENT_THD_PHASE_A_DATA_POINT_ID_DESC = 'CURRENT_THD_PHASE_A_DATA_POINT_ID_DESC',
  CURRENT_THD_PHASE_B_DATA_POINT_ID_ASC = 'CURRENT_THD_PHASE_B_DATA_POINT_ID_ASC',
  CURRENT_THD_PHASE_B_DATA_POINT_ID_DESC = 'CURRENT_THD_PHASE_B_DATA_POINT_ID_DESC',
  CURRENT_THD_PHASE_C_DATA_POINT_ID_ASC = 'CURRENT_THD_PHASE_C_DATA_POINT_ID_ASC',
  CURRENT_THD_PHASE_C_DATA_POINT_ID_DESC = 'CURRENT_THD_PHASE_C_DATA_POINT_ID_DESC',
  CURRENT_UNBALANCE_FACTOR_DATA_POINT_ID_ASC = 'CURRENT_UNBALANCE_FACTOR_DATA_POINT_ID_ASC',
  CURRENT_UNBALANCE_FACTOR_DATA_POINT_ID_DESC = 'CURRENT_UNBALANCE_FACTOR_DATA_POINT_ID_DESC',
  DEMAND_PHASE_A_DATA_POINT_ID_ASC = 'DEMAND_PHASE_A_DATA_POINT_ID_ASC',
  DEMAND_PHASE_A_DATA_POINT_ID_DESC = 'DEMAND_PHASE_A_DATA_POINT_ID_DESC',
  DEMAND_PHASE_B_DATA_POINT_ID_ASC = 'DEMAND_PHASE_B_DATA_POINT_ID_ASC',
  DEMAND_PHASE_B_DATA_POINT_ID_DESC = 'DEMAND_PHASE_B_DATA_POINT_ID_DESC',
  DEMAND_PHASE_C_DATA_POINT_ID_ASC = 'DEMAND_PHASE_C_DATA_POINT_ID_ASC',
  DEMAND_PHASE_C_DATA_POINT_ID_DESC = 'DEMAND_PHASE_C_DATA_POINT_ID_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  FREQUENCY_DATA_POINT_ID_ASC = 'FREQUENCY_DATA_POINT_ID_ASC',
  FREQUENCY_DATA_POINT_ID_DESC = 'FREQUENCY_DATA_POINT_ID_DESC',
  FREQUENCY_DEVIATION_DATA_POINT_ID_ASC = 'FREQUENCY_DEVIATION_DATA_POINT_ID_ASC',
  FREQUENCY_DEVIATION_DATA_POINT_ID_DESC = 'FREQUENCY_DEVIATION_DATA_POINT_ID_DESC',
  GENERATED_ENERGY_DATA_POINT_ID_ASC = 'GENERATED_ENERGY_DATA_POINT_ID_ASC',
  GENERATED_ENERGY_DATA_POINT_ID_DESC = 'GENERATED_ENERGY_DATA_POINT_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  KW_DEMAND_DATA_POINT_ID_ASC = 'KW_DEMAND_DATA_POINT_ID_ASC',
  KW_DEMAND_DATA_POINT_ID_DESC = 'KW_DEMAND_DATA_POINT_ID_DESC',
  LINE_TO_LINE_DEVIATION_AVERAGE_DATA_POINT_ID_ASC = 'LINE_TO_LINE_DEVIATION_AVERAGE_DATA_POINT_ID_ASC',
  LINE_TO_LINE_DEVIATION_AVERAGE_DATA_POINT_ID_DESC = 'LINE_TO_LINE_DEVIATION_AVERAGE_DATA_POINT_ID_DESC',
  LINE_TO_LINE_VOLTAGE_AB_DATA_POINT_ID_ASC = 'LINE_TO_LINE_VOLTAGE_AB_DATA_POINT_ID_ASC',
  LINE_TO_LINE_VOLTAGE_AB_DATA_POINT_ID_DESC = 'LINE_TO_LINE_VOLTAGE_AB_DATA_POINT_ID_DESC',
  LINE_TO_LINE_VOLTAGE_BC_DATA_POINT_ID_ASC = 'LINE_TO_LINE_VOLTAGE_BC_DATA_POINT_ID_ASC',
  LINE_TO_LINE_VOLTAGE_BC_DATA_POINT_ID_DESC = 'LINE_TO_LINE_VOLTAGE_BC_DATA_POINT_ID_DESC',
  LINE_TO_LINE_VOLTAGE_CA_DATA_POINT_ID_ASC = 'LINE_TO_LINE_VOLTAGE_CA_DATA_POINT_ID_ASC',
  LINE_TO_LINE_VOLTAGE_CA_DATA_POINT_ID_DESC = 'LINE_TO_LINE_VOLTAGE_CA_DATA_POINT_ID_DESC',
  LINE_TO_LINE_VOLTAGE_DATA_POINT_ID_ASC = 'LINE_TO_LINE_VOLTAGE_DATA_POINT_ID_ASC',
  LINE_TO_LINE_VOLTAGE_DATA_POINT_ID_DESC = 'LINE_TO_LINE_VOLTAGE_DATA_POINT_ID_DESC',
  LINE_TO_NEUTRAL_DEVIATION_AVERAGE_DATA_POINT_ID_ASC = 'LINE_TO_NEUTRAL_DEVIATION_AVERAGE_DATA_POINT_ID_ASC',
  LINE_TO_NEUTRAL_DEVIATION_AVERAGE_DATA_POINT_ID_DESC = 'LINE_TO_NEUTRAL_DEVIATION_AVERAGE_DATA_POINT_ID_DESC',
  LINE_TO_NEUTRAL_VOLTAGE_A_DATA_POINT_ID_ASC = 'LINE_TO_NEUTRAL_VOLTAGE_A_DATA_POINT_ID_ASC',
  LINE_TO_NEUTRAL_VOLTAGE_A_DATA_POINT_ID_DESC = 'LINE_TO_NEUTRAL_VOLTAGE_A_DATA_POINT_ID_DESC',
  LINE_TO_NEUTRAL_VOLTAGE_B_DATA_POINT_ID_ASC = 'LINE_TO_NEUTRAL_VOLTAGE_B_DATA_POINT_ID_ASC',
  LINE_TO_NEUTRAL_VOLTAGE_B_DATA_POINT_ID_DESC = 'LINE_TO_NEUTRAL_VOLTAGE_B_DATA_POINT_ID_DESC',
  LINE_TO_NEUTRAL_VOLTAGE_C_DATA_POINT_ID_ASC = 'LINE_TO_NEUTRAL_VOLTAGE_C_DATA_POINT_ID_ASC',
  LINE_TO_NEUTRAL_VOLTAGE_C_DATA_POINT_ID_DESC = 'LINE_TO_NEUTRAL_VOLTAGE_C_DATA_POINT_ID_DESC',
  LINE_TO_NEUTRAL_VOLTAGE_DATA_POINT_ID_ASC = 'LINE_TO_NEUTRAL_VOLTAGE_DATA_POINT_ID_ASC',
  LINE_TO_NEUTRAL_VOLTAGE_DATA_POINT_ID_DESC = 'LINE_TO_NEUTRAL_VOLTAGE_DATA_POINT_ID_DESC',
  MONITORED_EQUIPMENT_LABEL_ASC = 'MONITORED_EQUIPMENT_LABEL_ASC',
  MONITORED_EQUIPMENT_LABEL_DESC = 'MONITORED_EQUIPMENT_LABEL_DESC',
  NATURAL = 'NATURAL',
  NET_ENERGY_DATA_POINT_ID_ASC = 'NET_ENERGY_DATA_POINT_ID_ASC',
  NET_ENERGY_DATA_POINT_ID_DESC = 'NET_ENERGY_DATA_POINT_ID_DESC',
  NEUTRAL_CURRENT_DATA_POINT_ID_ASC = 'NEUTRAL_CURRENT_DATA_POINT_ID_ASC',
  NEUTRAL_CURRENT_DATA_POINT_ID_DESC = 'NEUTRAL_CURRENT_DATA_POINT_ID_DESC',
  PHASE_A_CURRENT_DATA_POINT_ID_ASC = 'PHASE_A_CURRENT_DATA_POINT_ID_ASC',
  PHASE_A_CURRENT_DATA_POINT_ID_DESC = 'PHASE_A_CURRENT_DATA_POINT_ID_DESC',
  PHASE_A_CURRENT_DEVIATION_DATA_POINT_ID_ASC = 'PHASE_A_CURRENT_DEVIATION_DATA_POINT_ID_ASC',
  PHASE_A_CURRENT_DEVIATION_DATA_POINT_ID_DESC = 'PHASE_A_CURRENT_DEVIATION_DATA_POINT_ID_DESC',
  PHASE_A_VOLTAGE_DATA_POINT_ID_ASC = 'PHASE_A_VOLTAGE_DATA_POINT_ID_ASC',
  PHASE_A_VOLTAGE_DATA_POINT_ID_DESC = 'PHASE_A_VOLTAGE_DATA_POINT_ID_DESC',
  PHASE_A_VOLTAGE_DEVIATION_DATA_POINT_ID_ASC = 'PHASE_A_VOLTAGE_DEVIATION_DATA_POINT_ID_ASC',
  PHASE_A_VOLTAGE_DEVIATION_DATA_POINT_ID_DESC = 'PHASE_A_VOLTAGE_DEVIATION_DATA_POINT_ID_DESC',
  PHASE_B_CURRENT_DATA_POINT_ID_ASC = 'PHASE_B_CURRENT_DATA_POINT_ID_ASC',
  PHASE_B_CURRENT_DATA_POINT_ID_DESC = 'PHASE_B_CURRENT_DATA_POINT_ID_DESC',
  PHASE_B_CURRENT_DEVIATION_DATA_POINT_ID_ASC = 'PHASE_B_CURRENT_DEVIATION_DATA_POINT_ID_ASC',
  PHASE_B_CURRENT_DEVIATION_DATA_POINT_ID_DESC = 'PHASE_B_CURRENT_DEVIATION_DATA_POINT_ID_DESC',
  PHASE_B_VOLTAGE_DATA_POINT_ID_ASC = 'PHASE_B_VOLTAGE_DATA_POINT_ID_ASC',
  PHASE_B_VOLTAGE_DATA_POINT_ID_DESC = 'PHASE_B_VOLTAGE_DATA_POINT_ID_DESC',
  PHASE_B_VOLTAGE_DEVIATION_DATA_POINT_ID_ASC = 'PHASE_B_VOLTAGE_DEVIATION_DATA_POINT_ID_ASC',
  PHASE_B_VOLTAGE_DEVIATION_DATA_POINT_ID_DESC = 'PHASE_B_VOLTAGE_DEVIATION_DATA_POINT_ID_DESC',
  PHASE_C_CURRENT_DATA_POINT_ID_ASC = 'PHASE_C_CURRENT_DATA_POINT_ID_ASC',
  PHASE_C_CURRENT_DATA_POINT_ID_DESC = 'PHASE_C_CURRENT_DATA_POINT_ID_DESC',
  PHASE_C_CURRENT_DEVIATION_DATA_POINT_ID_ASC = 'PHASE_C_CURRENT_DEVIATION_DATA_POINT_ID_ASC',
  PHASE_C_CURRENT_DEVIATION_DATA_POINT_ID_DESC = 'PHASE_C_CURRENT_DEVIATION_DATA_POINT_ID_DESC',
  PHASE_C_VOLTAGE_DATA_POINT_ID_ASC = 'PHASE_C_VOLTAGE_DATA_POINT_ID_ASC',
  PHASE_C_VOLTAGE_DATA_POINT_ID_DESC = 'PHASE_C_VOLTAGE_DATA_POINT_ID_DESC',
  PHASE_C_VOLTAGE_DEVIATION_DATA_POINT_ID_ASC = 'PHASE_C_VOLTAGE_DEVIATION_DATA_POINT_ID_ASC',
  PHASE_C_VOLTAGE_DEVIATION_DATA_POINT_ID_DESC = 'PHASE_C_VOLTAGE_DEVIATION_DATA_POINT_ID_DESC',
  POWER_FACTOR_DATA_POINT_ID_ASC = 'POWER_FACTOR_DATA_POINT_ID_ASC',
  POWER_FACTOR_DATA_POINT_ID_DESC = 'POWER_FACTOR_DATA_POINT_ID_DESC',
  POWER_FACTOR_PHASE_A_DATA_POINT_ID_ASC = 'POWER_FACTOR_PHASE_A_DATA_POINT_ID_ASC',
  POWER_FACTOR_PHASE_A_DATA_POINT_ID_DESC = 'POWER_FACTOR_PHASE_A_DATA_POINT_ID_DESC',
  POWER_FACTOR_PHASE_B_DATA_POINT_ID_ASC = 'POWER_FACTOR_PHASE_B_DATA_POINT_ID_ASC',
  POWER_FACTOR_PHASE_B_DATA_POINT_ID_DESC = 'POWER_FACTOR_PHASE_B_DATA_POINT_ID_DESC',
  POWER_FACTOR_PHASE_C_DATA_POINT_ID_ASC = 'POWER_FACTOR_PHASE_C_DATA_POINT_ID_ASC',
  POWER_FACTOR_PHASE_C_DATA_POINT_ID_DESC = 'POWER_FACTOR_PHASE_C_DATA_POINT_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  REACTIVE_POWER_DATA_POINT_ID_ASC = 'REACTIVE_POWER_DATA_POINT_ID_ASC',
  REACTIVE_POWER_DATA_POINT_ID_DESC = 'REACTIVE_POWER_DATA_POINT_ID_DESC',
  REACTIVE_POWER_PHASE_A_DATA_POINT_ID_ASC = 'REACTIVE_POWER_PHASE_A_DATA_POINT_ID_ASC',
  REACTIVE_POWER_PHASE_A_DATA_POINT_ID_DESC = 'REACTIVE_POWER_PHASE_A_DATA_POINT_ID_DESC',
  REACTIVE_POWER_PHASE_B_DATA_POINT_ID_ASC = 'REACTIVE_POWER_PHASE_B_DATA_POINT_ID_ASC',
  REACTIVE_POWER_PHASE_B_DATA_POINT_ID_DESC = 'REACTIVE_POWER_PHASE_B_DATA_POINT_ID_DESC',
  REACTIVE_POWER_PHASE_C_DATA_POINT_ID_ASC = 'REACTIVE_POWER_PHASE_C_DATA_POINT_ID_ASC',
  REACTIVE_POWER_PHASE_C_DATA_POINT_ID_DESC = 'REACTIVE_POWER_PHASE_C_DATA_POINT_ID_DESC',
  TOTAL_ENERGY_DATA_POINT_ID_ASC = 'TOTAL_ENERGY_DATA_POINT_ID_ASC',
  TOTAL_ENERGY_DATA_POINT_ID_DESC = 'TOTAL_ENERGY_DATA_POINT_ID_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  VOLTAGE_AMPLITUDE_IMBALANCE_DATA_POINT_ID_ASC = 'VOLTAGE_AMPLITUDE_IMBALANCE_DATA_POINT_ID_ASC',
  VOLTAGE_AMPLITUDE_IMBALANCE_DATA_POINT_ID_DESC = 'VOLTAGE_AMPLITUDE_IMBALANCE_DATA_POINT_ID_DESC',
  VOLTAGE_AVERAGE_DATA_POINT_ID_ASC = 'VOLTAGE_AVERAGE_DATA_POINT_ID_ASC',
  VOLTAGE_AVERAGE_DATA_POINT_ID_DESC = 'VOLTAGE_AVERAGE_DATA_POINT_ID_DESC',
  VOLTAGE_THD_AVERAGE_DATA_POINT_ID_ASC = 'VOLTAGE_THD_AVERAGE_DATA_POINT_ID_ASC',
  VOLTAGE_THD_AVERAGE_DATA_POINT_ID_DESC = 'VOLTAGE_THD_AVERAGE_DATA_POINT_ID_DESC',
  VOLTAGE_THD_PHASE_A_DATA_POINT_ID_ASC = 'VOLTAGE_THD_PHASE_A_DATA_POINT_ID_ASC',
  VOLTAGE_THD_PHASE_A_DATA_POINT_ID_DESC = 'VOLTAGE_THD_PHASE_A_DATA_POINT_ID_DESC',
  VOLTAGE_THD_PHASE_B_DATA_POINT_ID_ASC = 'VOLTAGE_THD_PHASE_B_DATA_POINT_ID_ASC',
  VOLTAGE_THD_PHASE_B_DATA_POINT_ID_DESC = 'VOLTAGE_THD_PHASE_B_DATA_POINT_ID_DESC',
  VOLTAGE_THD_PHASE_C_DATA_POINT_ID_ASC = 'VOLTAGE_THD_PHASE_C_DATA_POINT_ID_ASC',
  VOLTAGE_THD_PHASE_C_DATA_POINT_ID_DESC = 'VOLTAGE_THD_PHASE_C_DATA_POINT_ID_DESC',
  VOLTAGE_UNBALANCE_FACTOR_DATA_POINT_ID_ASC = 'VOLTAGE_UNBALANCE_FACTOR_DATA_POINT_ID_ASC',
  VOLTAGE_UNBALANCE_FACTOR_DATA_POINT_ID_DESC = 'VOLTAGE_UNBALANCE_FACTOR_DATA_POINT_ID_DESC'
}

/** An electrical panel. */
export type ElectricalPanel = Node & {
  __typename?: 'ElectricalPanel';
  /** Reads and enables pagination through a set of `ElectricalCircuit`. */
  circuits: ElectricalCircuitsConnection;
  /** The time at which the record was created */
  createdAt: Scalars['Datetime']['output'];
  /** Reads a single `ElectricalMeteringPoint` that is related to this `ElectricalPanel`. */
  electricalMeteringPoint?: Maybe<ElectricalMeteringPoint>;
  /** The electrical metering point where this panel is monitored. */
  electricalMeteringPointId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `Facility` that is related to this `ElectricalPanel`. */
  facility?: Maybe<Facility>;
  /** The facility to which this panel belongs. */
  facilityId: Scalars['Int']['output'];
  /** The identifier of the record. */
  id: Scalars['Int']['output'];
  /** Voltage configuration for Line-to-line voltage of the panel. */
  lineToLineVoltage?: Maybe<Scalars['BigFloat']['output']>;
  /** Voltage configuration for Line-to-neutral voltage of the panel. */
  lineToNeutralVoltage?: Maybe<Scalars['BigFloat']['output']>;
  /** Type of panel or equipment being powered. */
  loadType: EnumElectricLoadTypes;
  /** The name or label identifying the electrical panel. */
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Optional notes or comments associated with the panel. */
  notes?: Maybe<Scalars['String']['output']>;
  /** Reads a single `ElectricalCircuit` that is related to this `ElectricalPanel`. */
  parentCircuit?: Maybe<ElectricalCircuit>;
  /** The circuit in a parent panel that supplies power to this subpanel. */
  parentElectricalCircuitId?: Maybe<Scalars['Int']['output']>;
  /** Amperage rating of the panel. */
  ratedAmperage?: Maybe<Scalars['Float']['output']>;
  /** The time at which the record was last updated */
  updatedAt: Scalars['Datetime']['output'];
  /** The utility meter associated with this panel. */
  utilityMeterId?: Maybe<Scalars['Int']['output']>;
};

/** An electrical panel. */
export type ElectricalPanelCircuitsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ElectricalCircuitCondition>;
  filter?: InputMaybe<ElectricalCircuitFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ElectricalCircuitsOrderBy>>;
};

/**
 * A condition to be used against `ElectricalPanel` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ElectricalPanelCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `electricalMeteringPointId` field. */
  electricalMeteringPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `lineToLineVoltage` field. */
  lineToLineVoltage?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `lineToNeutralVoltage` field. */
  lineToNeutralVoltage?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `loadType` field. */
  loadType?: InputMaybe<EnumElectricLoadTypes>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `notes` field. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `parentElectricalCircuitId` field. */
  parentElectricalCircuitId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `ratedAmperage` field. */
  ratedAmperage?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `utilityMeterId` field. */
  utilityMeterId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `ElectricalPanel` object types. All fields are combined with a logical ‘and.’ */
export type ElectricalPanelFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ElectricalPanelFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `electricalMeteringPointId` field. */
  electricalMeteringPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `lineToLineVoltage` field. */
  lineToLineVoltage?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `lineToNeutralVoltage` field. */
  lineToNeutralVoltage?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `loadType` field. */
  loadType?: InputMaybe<EnumElectricLoadTypesFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ElectricalPanelFilter>;
  /** Filter by the object’s `notes` field. */
  notes?: InputMaybe<StringFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ElectricalPanelFilter>>;
  /** Filter by the object’s `parentElectricalCircuitId` field. */
  parentElectricalCircuitId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `ratedAmperage` field. */
  ratedAmperage?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `utilityMeterId` field. */
  utilityMeterId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `ElectricalPanel` */
export type ElectricalPanelInput = {
  /** Mutates a `ElectricalMeteringPoint` as part of the payload */
  electricalMeteringPoint?: InputMaybe<ElectricalMeteringPointInput>;
  /** The electrical metering point where this panel is monitored. */
  electricalMeteringPointId?: InputMaybe<Scalars['Int']['input']>;
  /** The facility to which this panel belongs. */
  facilityId: Scalars['Int']['input'];
  /** Voltage configuration for Line-to-line voltage of the panel. */
  lineToLineVoltage?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Voltage configuration for Line-to-neutral voltage of the panel. */
  lineToNeutralVoltage?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Type of panel or equipment being powered. */
  loadType?: InputMaybe<EnumElectricLoadTypes>;
  /** The name or label identifying the electrical panel. */
  name: Scalars['String']['input'];
  /** Optional notes or comments associated with the panel. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** The circuit in a parent panel that supplies power to this subpanel. */
  parentElectricalCircuitId?: InputMaybe<Scalars['Int']['input']>;
  /** Amperage rating of the panel. */
  ratedAmperage?: InputMaybe<Scalars['Float']['input']>;
  /** The utility meter associated with this panel. */
  utilityMeterId?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents an update to a `ElectricalPanel`. Fields that are set will be updated. */
export type ElectricalPanelPatch = {
  /** The electrical metering point where this panel is monitored. */
  electricalMeteringPointId?: InputMaybe<Scalars['Int']['input']>;
  /** The facility to which this panel belongs. */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** Voltage configuration for Line-to-line voltage of the panel. */
  lineToLineVoltage?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Voltage configuration for Line-to-neutral voltage of the panel. */
  lineToNeutralVoltage?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Type of panel or equipment being powered. */
  loadType?: InputMaybe<EnumElectricLoadTypes>;
  /** The name or label identifying the electrical panel. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Optional notes or comments associated with the panel. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** The circuit in a parent panel that supplies power to this subpanel. */
  parentElectricalCircuitId?: InputMaybe<Scalars['Int']['input']>;
  /** Amperage rating of the panel. */
  ratedAmperage?: InputMaybe<Scalars['Float']['input']>;
  /** The utility meter associated with this panel. */
  utilityMeterId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `ElectricalPanel` values. */
export type ElectricalPanelsConnection = {
  __typename?: 'ElectricalPanelsConnection';
  /** A list of edges which contains the `ElectricalPanel` and cursor to aid in pagination. */
  edges: Array<ElectricalPanelsEdge>;
  /** A list of `ElectricalPanel` objects. */
  nodes: Array<ElectricalPanel>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ElectricalPanel` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ElectricalPanel` edge in the connection. */
export type ElectricalPanelsEdge = {
  __typename?: 'ElectricalPanelsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ElectricalPanel` at the end of the edge. */
  node: ElectricalPanel;
};

/** Methods to use when ordering `ElectricalPanel`. */
export enum ElectricalPanelsOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  ELECTRICAL_METERING_POINT_ID_ASC = 'ELECTRICAL_METERING_POINT_ID_ASC',
  ELECTRICAL_METERING_POINT_ID_DESC = 'ELECTRICAL_METERING_POINT_ID_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LINE_TO_LINE_VOLTAGE_ASC = 'LINE_TO_LINE_VOLTAGE_ASC',
  LINE_TO_LINE_VOLTAGE_DESC = 'LINE_TO_LINE_VOLTAGE_DESC',
  LINE_TO_NEUTRAL_VOLTAGE_ASC = 'LINE_TO_NEUTRAL_VOLTAGE_ASC',
  LINE_TO_NEUTRAL_VOLTAGE_DESC = 'LINE_TO_NEUTRAL_VOLTAGE_DESC',
  LOAD_TYPE_ASC = 'LOAD_TYPE_ASC',
  LOAD_TYPE_DESC = 'LOAD_TYPE_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  NOTES_ASC = 'NOTES_ASC',
  NOTES_DESC = 'NOTES_DESC',
  PARENT_ELECTRICAL_CIRCUIT_ID_ASC = 'PARENT_ELECTRICAL_CIRCUIT_ID_ASC',
  PARENT_ELECTRICAL_CIRCUIT_ID_DESC = 'PARENT_ELECTRICAL_CIRCUIT_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  RATED_AMPERAGE_ASC = 'RATED_AMPERAGE_ASC',
  RATED_AMPERAGE_DESC = 'RATED_AMPERAGE_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  UTILITY_METER_ID_ASC = 'UTILITY_METER_ID_ASC',
  UTILITY_METER_ID_DESC = 'UTILITY_METER_ID_DESC'
}

export enum EnumBlastRotationAlertLevel {
  ALERT = 'ALERT',
  WARNING = 'WARNING'
}

/** A filter to be used against EnumBlastRotationAlertLevel fields. All fields are combined with a logical ‘and.’ */
export type EnumBlastRotationAlertLevelFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<EnumBlastRotationAlertLevel>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<EnumBlastRotationAlertLevel>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<EnumBlastRotationAlertLevel>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<EnumBlastRotationAlertLevel>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<EnumBlastRotationAlertLevel>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<EnumBlastRotationAlertLevel>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<EnumBlastRotationAlertLevel>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<EnumBlastRotationAlertLevel>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<EnumBlastRotationAlertLevel>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<EnumBlastRotationAlertLevel>>;
};

export enum EnumElectricLoadTypes {
  BREAKER = 'BREAKER',
  BUS = 'BUS',
  CAPACITOR = 'CAPACITOR',
  DRIVE = 'DRIVE',
  GENERATOR = 'GENERATOR',
  INDUCTOR = 'INDUCTOR',
  METER = 'METER',
  MOTOR = 'MOTOR',
  OTHER = 'OTHER',
  PANEL = 'PANEL',
  RELAY = 'RELAY',
  SWITCHGEAR = 'SWITCHGEAR',
  TRANSFORMER = 'TRANSFORMER',
  UNKNOWN = 'UNKNOWN'
}

/** A filter to be used against EnumElectricLoadTypes fields. All fields are combined with a logical ‘and.’ */
export type EnumElectricLoadTypesFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<EnumElectricLoadTypes>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<EnumElectricLoadTypes>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<EnumElectricLoadTypes>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<EnumElectricLoadTypes>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<EnumElectricLoadTypes>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<EnumElectricLoadTypes>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<EnumElectricLoadTypes>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<EnumElectricLoadTypes>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<EnumElectricLoadTypes>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<EnumElectricLoadTypes>>;
};

/** This represents an evaporator that exists in a facility */
export type Evaporator = Node & {
  __typename?: 'Evaporator';
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  ammoniaState?: Maybe<DataPoint>;
  /** The ammonia state value */
  ammoniaStateId?: Maybe<Scalars['BigInt']['output']>;
  /** Reads and enables pagination through a set of `BlastEvaporator`. */
  blastEvaporators: BlastEvaporatorsConnection;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  bleedSolenoid?: Maybe<DataPoint>;
  /** The bleed solenoid */
  bleedSolenoidId?: Maybe<Scalars['BigInt']['output']>;
  /** Reads a single `BuildingArea` that is related to this `Evaporator`. */
  buildingArea?: Maybe<BuildingArea>;
  /** The associated area of within a building */
  buildingAreaId?: Maybe<Scalars['Int']['output']>;
  /** The time at which the Evaporator was created. */
  createdAt: Scalars['Datetime']['output'];
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  defrostState?: Maybe<DataPoint>;
  /** The defrost state value */
  defrostStateId?: Maybe<Scalars['BigInt']['output']>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  defrostTemperature?: Maybe<DataPoint>;
  /** The defrost temperature */
  defrostTemperatureId?: Maybe<Scalars['BigInt']['output']>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  defrostTimer?: Maybe<DataPoint>;
  /** The defrost time */
  defrostTimerId?: Maybe<Scalars['BigInt']['output']>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  differentialAirTemperature?: Maybe<DataPoint>;
  /** The differential air temperature */
  differentialAirTemperatureId?: Maybe<Scalars['BigInt']['output']>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  estimatedKwDemand?: Maybe<DataPoint>;
  /** The estimated kw demand (evaluated from compressor demand) */
  estimatedKwDemandId?: Maybe<Scalars['BigInt']['output']>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  evapState?: Maybe<DataPoint>;
  /** The state of the evap */
  evapStateId?: Maybe<Scalars['BigInt']['output']>;
  /** Reads a single `Facility` that is related to this `Evaporator`. */
  facility?: Maybe<Facility>;
  /** The facility an evaporator is installed within */
  facilityId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  fanState?: Maybe<DataPoint>;
  /** The fan state */
  fanStateId?: Maybe<Scalars['BigInt']['output']>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  fanTimer?: Maybe<DataPoint>;
  /** The fan timer */
  fanTimerId?: Maybe<Scalars['BigInt']['output']>;
  /** The geocoded location of an evaporator */
  geometry?: Maybe<GeometryInterface>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  hotGasSolenoid?: Maybe<DataPoint>;
  /** The hot gas solenoid */
  hotGasSolenoidId?: Maybe<Scalars['BigInt']['output']>;
  /** The id of the evaporator */
  id: Scalars['Int']['output'];
  /** A human-readable label */
  label: Scalars['String']['output'];
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  liquidFeedRuntime?: Maybe<DataPoint>;
  /** The liquid feed runtime */
  liquidFeedRuntimeId?: Maybe<Scalars['BigInt']['output']>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  liquidFeedRuntimeSetpoint?: Maybe<DataPoint>;
  /** The liquid feed runtime setpoint */
  liquidFeedRuntimeSetpointId?: Maybe<Scalars['BigInt']['output']>;
  /** Reads and enables pagination through a set of `LiquidHeadersEvaporator`. */
  liquidHeadersEvaporators: LiquidHeadersEvaporatorsConnection;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  liquidSolenoid?: Maybe<DataPoint>;
  /** The liquid solenoid state */
  liquidSolenoidId?: Maybe<Scalars['BigInt']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The rated refrigeration capacity of the evaporator (constant) */
  ratedTonnage?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `RefrigerationSystem` that is related to this `Evaporator`. */
  refrigerationSystem?: Maybe<RefrigerationSystem>;
  /** References the refrigeration system this evaporator belongs to */
  refrigerationSystemId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  returnAirTemperature?: Maybe<DataPoint>;
  /** The return air temperature */
  returnAirTemperatureId?: Maybe<Scalars['BigInt']['output']>;
  /** Reads a single `SuctionHeader` that is related to this `Evaporator`. */
  returnSuctionHeader?: Maybe<SuctionHeader>;
  /** Represents the active suction header for the evaporator */
  returnSuctionHeaderId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  setpoint?: Maybe<DataPoint>;
  /** The setpoint value */
  setpointId?: Maybe<Scalars['BigInt']['output']>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  softHotGasSolenoid?: Maybe<DataPoint>;
  /** The soft hot gas solenoid */
  softHotGasSolenoidId?: Maybe<Scalars['BigInt']['output']>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  suctionPressure?: Maybe<DataPoint>;
  /** References the suction pressure datapoint for the evaporator */
  suctionPressureId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  suctionSolenoid?: Maybe<DataPoint>;
  /** The suction solenoid */
  suctionSolenoidId?: Maybe<Scalars['BigInt']['output']>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  suctionTemperature?: Maybe<DataPoint>;
  /** The suction temperature */
  suctionTemperatureId?: Maybe<Scalars['BigInt']['output']>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  supplyAirTemperature?: Maybe<DataPoint>;
  /** The supply air temperature, which is air temperature going out of the evaporator */
  supplyAirTemperatureId?: Maybe<Scalars['BigInt']['output']>;
  /** The time at which the Evaporator was updated. */
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  zoneTemperature?: Maybe<DataPoint>;
  /** The zone temperature, or the best available representation of air temperature in the evaporator cooling zone */
  zoneTemperatureId?: Maybe<Scalars['BigInt']['output']>;
};

/** This represents an evaporator that exists in a facility */
export type EvaporatorBlastEvaporatorsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BlastEvaporatorCondition>;
  filter?: InputMaybe<BlastEvaporatorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BlastEvaporatorsOrderBy>>;
};

/** This represents an evaporator that exists in a facility */
export type EvaporatorLiquidHeadersEvaporatorsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LiquidHeadersEvaporatorCondition>;
  filter?: InputMaybe<LiquidHeadersEvaporatorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiquidHeadersEvaporatorsOrderBy>>;
};

/**
 * A condition to be used against `Evaporator` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type EvaporatorCondition = {
  /** Checks for equality with the object’s `ammoniaStateId` field. */
  ammoniaStateId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `bleedSolenoidId` field. */
  bleedSolenoidId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `buildingAreaId` field. */
  buildingAreaId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `defrostStateId` field. */
  defrostStateId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `defrostTemperatureId` field. */
  defrostTemperatureId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `defrostTimerId` field. */
  defrostTimerId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `differentialAirTemperatureId` field. */
  differentialAirTemperatureId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `estimatedKwDemandId` field. */
  estimatedKwDemandId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `evapStateId` field. */
  evapStateId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `fanStateId` field. */
  fanStateId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `fanTimerId` field. */
  fanTimerId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `geometry` field. */
  geometry?: InputMaybe<Scalars['GeoJSON']['input']>;
  /** Checks for equality with the object’s `hotGasSolenoidId` field. */
  hotGasSolenoidId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `label` field. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `liquidFeedRuntimeId` field. */
  liquidFeedRuntimeId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `liquidFeedRuntimeSetpointId` field. */
  liquidFeedRuntimeSetpointId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `liquidSolenoidId` field. */
  liquidSolenoidId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `ratedTonnage` field. */
  ratedTonnage?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `refrigerationSystemId` field. */
  refrigerationSystemId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `returnAirTemperatureId` field. */
  returnAirTemperatureId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `returnSuctionHeaderId` field. */
  returnSuctionHeaderId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `setpointId` field. */
  setpointId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `softHotGasSolenoidId` field. */
  softHotGasSolenoidId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `suctionPressureId` field. */
  suctionPressureId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `suctionSolenoidId` field. */
  suctionSolenoidId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `suctionTemperatureId` field. */
  suctionTemperatureId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `supplyAirTemperatureId` field. */
  supplyAirTemperatureId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `zoneTemperatureId` field. */
  zoneTemperatureId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A filter to be used against `Evaporator` object types. All fields are combined with a logical ‘and.’ */
export type EvaporatorFilter = {
  /** Filter by the object’s `ammoniaStateId` field. */
  ammoniaStateId?: InputMaybe<BigIntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<EvaporatorFilter>>;
  /** Filter by the object’s `bleedSolenoidId` field. */
  bleedSolenoidId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `buildingAreaId` field. */
  buildingAreaId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `defrostStateId` field. */
  defrostStateId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `defrostTemperatureId` field. */
  defrostTemperatureId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `defrostTimerId` field. */
  defrostTimerId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `differentialAirTemperatureId` field. */
  differentialAirTemperatureId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `estimatedKwDemandId` field. */
  estimatedKwDemandId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `evapStateId` field. */
  evapStateId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `fanStateId` field. */
  fanStateId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `fanTimerId` field. */
  fanTimerId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `hotGasSolenoidId` field. */
  hotGasSolenoidId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `label` field. */
  label?: InputMaybe<StringFilter>;
  /** Filter by the object’s `liquidFeedRuntimeId` field. */
  liquidFeedRuntimeId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `liquidFeedRuntimeSetpointId` field. */
  liquidFeedRuntimeSetpointId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `liquidSolenoidId` field. */
  liquidSolenoidId?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<EvaporatorFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<EvaporatorFilter>>;
  /** Filter by the object’s `ratedTonnage` field. */
  ratedTonnage?: InputMaybe<IntFilter>;
  /** Filter by the object’s `refrigerationSystemId` field. */
  refrigerationSystemId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `returnAirTemperatureId` field. */
  returnAirTemperatureId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `returnSuctionHeaderId` field. */
  returnSuctionHeaderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `setpointId` field. */
  setpointId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `softHotGasSolenoidId` field. */
  softHotGasSolenoidId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `suctionPressureId` field. */
  suctionPressureId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `suctionSolenoidId` field. */
  suctionSolenoidId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `suctionTemperatureId` field. */
  suctionTemperatureId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `supplyAirTemperatureId` field. */
  supplyAirTemperatureId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `zoneTemperatureId` field. */
  zoneTemperatureId?: InputMaybe<BigIntFilter>;
};

/** An input for mutations affecting `Evaporator` */
export type EvaporatorInput = {
  /** The ammonia state value */
  ammoniaStateId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The bleed solenoid */
  bleedSolenoidId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Mutates a `BuildingArea` as part of the payload */
  buildingArea?: InputMaybe<BuildingAreaInput>;
  /** The associated area of within a building */
  buildingAreaId?: InputMaybe<Scalars['Int']['input']>;
  /** Mutates a `DataPoint` as part of the payload */
  dataPoint?: InputMaybe<DataPointInput>;
  /** The defrost state value */
  defrostStateId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The defrost temperature */
  defrostTemperatureId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The defrost time */
  defrostTimerId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The differential air temperature */
  differentialAirTemperatureId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The estimated kw demand (evaluated from compressor demand) */
  estimatedKwDemandId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The state of the evap */
  evapStateId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The facility an evaporator is installed within */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** The fan state */
  fanStateId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The fan timer */
  fanTimerId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The geocoded location of an evaporator */
  geometry?: InputMaybe<Scalars['GeoJSON']['input']>;
  /** The hot gas solenoid */
  hotGasSolenoidId?: InputMaybe<Scalars['BigInt']['input']>;
  /** A human-readable label */
  label: Scalars['String']['input'];
  /** The liquid feed runtime */
  liquidFeedRuntimeId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The liquid feed runtime setpoint */
  liquidFeedRuntimeSetpointId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The liquid solenoid state */
  liquidSolenoidId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The rated refrigeration capacity of the evaporator (constant) */
  ratedTonnage?: InputMaybe<Scalars['Int']['input']>;
  /** Mutates a `RefrigerationSystem` as part of the payload */
  refrigerationSystem?: InputMaybe<RefrigerationSystemInput>;
  /** References the refrigeration system this evaporator belongs to */
  refrigerationSystemId?: InputMaybe<Scalars['Int']['input']>;
  /** The return air temperature */
  returnAirTemperatureId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Represents the active suction header for the evaporator */
  returnSuctionHeaderId?: InputMaybe<Scalars['Int']['input']>;
  /** The setpoint value */
  setpointId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The soft hot gas solenoid */
  softHotGasSolenoidId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Mutates a `SuctionHeader` as part of the payload */
  suctionHeader?: InputMaybe<SuctionHeaderInput>;
  /** References the suction pressure datapoint for the evaporator */
  suctionPressureId?: InputMaybe<Scalars['Int']['input']>;
  /** The suction solenoid */
  suctionSolenoidId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The suction temperature */
  suctionTemperatureId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The supply air temperature, which is air temperature going out of the evaporator */
  supplyAirTemperatureId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The zone temperature, or the best available representation of air temperature in the evaporator cooling zone */
  zoneTemperatureId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** Represents an update to a `Evaporator`. Fields that are set will be updated. */
export type EvaporatorPatch = {
  /** The ammonia state value */
  ammoniaStateId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The bleed solenoid */
  bleedSolenoidId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The associated area of within a building */
  buildingAreaId?: InputMaybe<Scalars['Int']['input']>;
  /** The defrost state value */
  defrostStateId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The defrost temperature */
  defrostTemperatureId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The defrost time */
  defrostTimerId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The differential air temperature */
  differentialAirTemperatureId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The estimated kw demand (evaluated from compressor demand) */
  estimatedKwDemandId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The state of the evap */
  evapStateId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The facility an evaporator is installed within */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** The fan state */
  fanStateId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The fan timer */
  fanTimerId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The geocoded location of an evaporator */
  geometry?: InputMaybe<Scalars['GeoJSON']['input']>;
  /** The hot gas solenoid */
  hotGasSolenoidId?: InputMaybe<Scalars['BigInt']['input']>;
  /** A human-readable label */
  label?: InputMaybe<Scalars['String']['input']>;
  /** The liquid feed runtime */
  liquidFeedRuntimeId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The liquid feed runtime setpoint */
  liquidFeedRuntimeSetpointId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The liquid solenoid state */
  liquidSolenoidId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The rated refrigeration capacity of the evaporator (constant) */
  ratedTonnage?: InputMaybe<Scalars['Int']['input']>;
  /** References the refrigeration system this evaporator belongs to */
  refrigerationSystemId?: InputMaybe<Scalars['Int']['input']>;
  /** The return air temperature */
  returnAirTemperatureId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Represents the active suction header for the evaporator */
  returnSuctionHeaderId?: InputMaybe<Scalars['Int']['input']>;
  /** The setpoint value */
  setpointId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The soft hot gas solenoid */
  softHotGasSolenoidId?: InputMaybe<Scalars['BigInt']['input']>;
  /** References the suction pressure datapoint for the evaporator */
  suctionPressureId?: InputMaybe<Scalars['Int']['input']>;
  /** The suction solenoid */
  suctionSolenoidId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The suction temperature */
  suctionTemperatureId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The supply air temperature, which is air temperature going out of the evaporator */
  supplyAirTemperatureId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The zone temperature, or the best available representation of air temperature in the evaporator cooling zone */
  zoneTemperatureId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A connection to a list of `Evaporator` values. */
export type EvaporatorsConnection = {
  __typename?: 'EvaporatorsConnection';
  /** Returns the aggregate ammoniaState timeseries data for the EvaporatorsConnection  */
  ammoniaState?: Maybe<MetricDataConnection>;
  /** Returns the aggregate bleedSolenoid timeseries data for the EvaporatorsConnection  */
  bleedSolenoid?: Maybe<MetricDataConnection>;
  /** Returns the aggregate defrostState timeseries data for the EvaporatorsConnection  */
  defrostState?: Maybe<MetricDataConnection>;
  /** Returns the aggregate defrostTemperature timeseries data for the EvaporatorsConnection  */
  defrostTemperature?: Maybe<MetricDataConnection>;
  /** Returns the aggregate defrostTimer timeseries data for the EvaporatorsConnection  */
  defrostTimer?: Maybe<MetricDataConnection>;
  /** Returns the aggregate differentialAirTemperature timeseries data for the EvaporatorsConnection  */
  differentialAirTemperature?: Maybe<MetricDataConnection>;
  /** A list of edges which contains the `Evaporator` and cursor to aid in pagination. */
  edges: Array<EvaporatorsEdge>;
  /** Returns the aggregate estimatedKwDemand timeseries data for the EvaporatorsConnection  */
  estimatedKwDemand?: Maybe<MetricDataConnection>;
  /** Returns the aggregate evapState timeseries data for the EvaporatorsConnection  */
  evapState?: Maybe<MetricDataConnection>;
  /** Returns the aggregate fanState timeseries data for the EvaporatorsConnection  */
  fanState?: Maybe<MetricDataConnection>;
  /** Returns the aggregate fanTimer timeseries data for the EvaporatorsConnection  */
  fanTimer?: Maybe<MetricDataConnection>;
  /** Returns the aggregate hotGasSolenoid timeseries data for the EvaporatorsConnection  */
  hotGasSolenoid?: Maybe<MetricDataConnection>;
  /** Returns the aggregate liquidFeedRuntime timeseries data for the EvaporatorsConnection  */
  liquidFeedRuntime?: Maybe<MetricDataConnection>;
  /** Returns the aggregate liquidFeedRuntimeSetpoint timeseries data for the EvaporatorsConnection  */
  liquidFeedRuntimeSetpoint?: Maybe<MetricDataConnection>;
  /** Returns the aggregate liquidSolenoid timeseries data for the EvaporatorsConnection  */
  liquidSolenoid?: Maybe<MetricDataConnection>;
  /** A list of `Evaporator` objects. */
  nodes: Array<Evaporator>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Returns the aggregate returnAirTemperature timeseries data for the EvaporatorsConnection  */
  returnAirTemperature?: Maybe<MetricDataConnection>;
  /** Returns the aggregate setpoint timeseries data for the EvaporatorsConnection  */
  setpoint?: Maybe<MetricDataConnection>;
  /** Returns the aggregate softHotGasSolenoid timeseries data for the EvaporatorsConnection  */
  softHotGasSolenoid?: Maybe<MetricDataConnection>;
  /** Returns the aggregate suctionPressure timeseries data for the EvaporatorsConnection  */
  suctionPressure?: Maybe<MetricDataConnection>;
  /** Returns the aggregate suctionSolenoid timeseries data for the EvaporatorsConnection  */
  suctionSolenoid?: Maybe<MetricDataConnection>;
  /** Returns the aggregate suctionTemperature timeseries data for the EvaporatorsConnection  */
  suctionTemperature?: Maybe<MetricDataConnection>;
  /** Returns the aggregate supplyAirTemperature timeseries data for the EvaporatorsConnection  */
  supplyAirTemperature?: Maybe<MetricDataConnection>;
  /** The count of *all* `Evaporator` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
  /** Returns the aggregate zoneTemperature timeseries data for the EvaporatorsConnection  */
  zoneTemperature?: Maybe<MetricDataConnection>;
};

/** A connection to a list of `Evaporator` values. */
export type EvaporatorsConnectionAmmoniaStateArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Evaporator` values. */
export type EvaporatorsConnectionBleedSolenoidArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Evaporator` values. */
export type EvaporatorsConnectionDefrostStateArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Evaporator` values. */
export type EvaporatorsConnectionDefrostTemperatureArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Evaporator` values. */
export type EvaporatorsConnectionDefrostTimerArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Evaporator` values. */
export type EvaporatorsConnectionDifferentialAirTemperatureArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Evaporator` values. */
export type EvaporatorsConnectionEstimatedKwDemandArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Evaporator` values. */
export type EvaporatorsConnectionEvapStateArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Evaporator` values. */
export type EvaporatorsConnectionFanStateArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Evaporator` values. */
export type EvaporatorsConnectionFanTimerArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Evaporator` values. */
export type EvaporatorsConnectionHotGasSolenoidArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Evaporator` values. */
export type EvaporatorsConnectionLiquidFeedRuntimeArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Evaporator` values. */
export type EvaporatorsConnectionLiquidFeedRuntimeSetpointArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Evaporator` values. */
export type EvaporatorsConnectionLiquidSolenoidArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Evaporator` values. */
export type EvaporatorsConnectionReturnAirTemperatureArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Evaporator` values. */
export type EvaporatorsConnectionSetpointArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Evaporator` values. */
export type EvaporatorsConnectionSoftHotGasSolenoidArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Evaporator` values. */
export type EvaporatorsConnectionSuctionPressureArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Evaporator` values. */
export type EvaporatorsConnectionSuctionSolenoidArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Evaporator` values. */
export type EvaporatorsConnectionSuctionTemperatureArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Evaporator` values. */
export type EvaporatorsConnectionSupplyAirTemperatureArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Evaporator` values. */
export type EvaporatorsConnectionZoneTemperatureArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A `Evaporator` edge in the connection. */
export type EvaporatorsEdge = {
  __typename?: 'EvaporatorsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Evaporator` at the end of the edge. */
  node: Evaporator;
};

/** Methods to use when ordering `Evaporator`. */
export enum EvaporatorsOrderBy {
  AMMONIA_STATE_ID_ASC = 'AMMONIA_STATE_ID_ASC',
  AMMONIA_STATE_ID_DESC = 'AMMONIA_STATE_ID_DESC',
  BLEED_SOLENOID_ID_ASC = 'BLEED_SOLENOID_ID_ASC',
  BLEED_SOLENOID_ID_DESC = 'BLEED_SOLENOID_ID_DESC',
  BUILDING_AREA_ID_ASC = 'BUILDING_AREA_ID_ASC',
  BUILDING_AREA_ID_DESC = 'BUILDING_AREA_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DEFROST_STATE_ID_ASC = 'DEFROST_STATE_ID_ASC',
  DEFROST_STATE_ID_DESC = 'DEFROST_STATE_ID_DESC',
  DEFROST_TEMPERATURE_ID_ASC = 'DEFROST_TEMPERATURE_ID_ASC',
  DEFROST_TEMPERATURE_ID_DESC = 'DEFROST_TEMPERATURE_ID_DESC',
  DEFROST_TIMER_ID_ASC = 'DEFROST_TIMER_ID_ASC',
  DEFROST_TIMER_ID_DESC = 'DEFROST_TIMER_ID_DESC',
  DIFFERENTIAL_AIR_TEMPERATURE_ID_ASC = 'DIFFERENTIAL_AIR_TEMPERATURE_ID_ASC',
  DIFFERENTIAL_AIR_TEMPERATURE_ID_DESC = 'DIFFERENTIAL_AIR_TEMPERATURE_ID_DESC',
  ESTIMATED_KW_DEMAND_ID_ASC = 'ESTIMATED_KW_DEMAND_ID_ASC',
  ESTIMATED_KW_DEMAND_ID_DESC = 'ESTIMATED_KW_DEMAND_ID_DESC',
  EVAP_STATE_ID_ASC = 'EVAP_STATE_ID_ASC',
  EVAP_STATE_ID_DESC = 'EVAP_STATE_ID_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  FAN_STATE_ID_ASC = 'FAN_STATE_ID_ASC',
  FAN_STATE_ID_DESC = 'FAN_STATE_ID_DESC',
  FAN_TIMER_ID_ASC = 'FAN_TIMER_ID_ASC',
  FAN_TIMER_ID_DESC = 'FAN_TIMER_ID_DESC',
  GEOMETRY_ASC = 'GEOMETRY_ASC',
  GEOMETRY_DESC = 'GEOMETRY_DESC',
  HOT_GAS_SOLENOID_ID_ASC = 'HOT_GAS_SOLENOID_ID_ASC',
  HOT_GAS_SOLENOID_ID_DESC = 'HOT_GAS_SOLENOID_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LABEL_ASC = 'LABEL_ASC',
  LABEL_DESC = 'LABEL_DESC',
  LIQUID_FEED_RUNTIME_ID_ASC = 'LIQUID_FEED_RUNTIME_ID_ASC',
  LIQUID_FEED_RUNTIME_ID_DESC = 'LIQUID_FEED_RUNTIME_ID_DESC',
  LIQUID_FEED_RUNTIME_SETPOINT_ID_ASC = 'LIQUID_FEED_RUNTIME_SETPOINT_ID_ASC',
  LIQUID_FEED_RUNTIME_SETPOINT_ID_DESC = 'LIQUID_FEED_RUNTIME_SETPOINT_ID_DESC',
  LIQUID_SOLENOID_ID_ASC = 'LIQUID_SOLENOID_ID_ASC',
  LIQUID_SOLENOID_ID_DESC = 'LIQUID_SOLENOID_ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  RATED_TONNAGE_ASC = 'RATED_TONNAGE_ASC',
  RATED_TONNAGE_DESC = 'RATED_TONNAGE_DESC',
  REFRIGERATION_SYSTEM_ID_ASC = 'REFRIGERATION_SYSTEM_ID_ASC',
  REFRIGERATION_SYSTEM_ID_DESC = 'REFRIGERATION_SYSTEM_ID_DESC',
  RETURN_AIR_TEMPERATURE_ID_ASC = 'RETURN_AIR_TEMPERATURE_ID_ASC',
  RETURN_AIR_TEMPERATURE_ID_DESC = 'RETURN_AIR_TEMPERATURE_ID_DESC',
  RETURN_SUCTION_HEADER_ID_ASC = 'RETURN_SUCTION_HEADER_ID_ASC',
  RETURN_SUCTION_HEADER_ID_DESC = 'RETURN_SUCTION_HEADER_ID_DESC',
  SETPOINT_ID_ASC = 'SETPOINT_ID_ASC',
  SETPOINT_ID_DESC = 'SETPOINT_ID_DESC',
  SOFT_HOT_GAS_SOLENOID_ID_ASC = 'SOFT_HOT_GAS_SOLENOID_ID_ASC',
  SOFT_HOT_GAS_SOLENOID_ID_DESC = 'SOFT_HOT_GAS_SOLENOID_ID_DESC',
  SUCTION_PRESSURE_ID_ASC = 'SUCTION_PRESSURE_ID_ASC',
  SUCTION_PRESSURE_ID_DESC = 'SUCTION_PRESSURE_ID_DESC',
  SUCTION_SOLENOID_ID_ASC = 'SUCTION_SOLENOID_ID_ASC',
  SUCTION_SOLENOID_ID_DESC = 'SUCTION_SOLENOID_ID_DESC',
  SUCTION_TEMPERATURE_ID_ASC = 'SUCTION_TEMPERATURE_ID_ASC',
  SUCTION_TEMPERATURE_ID_DESC = 'SUCTION_TEMPERATURE_ID_DESC',
  SUPPLY_AIR_TEMPERATURE_ID_ASC = 'SUPPLY_AIR_TEMPERATURE_ID_ASC',
  SUPPLY_AIR_TEMPERATURE_ID_DESC = 'SUPPLY_AIR_TEMPERATURE_ID_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  ZONE_TEMPERATURE_ID_ASC = 'ZONE_TEMPERATURE_ID_ASC',
  ZONE_TEMPERATURE_ID_DESC = 'ZONE_TEMPERATURE_ID_DESC'
}

/** An event */
export type Event = Node & {
  __typename?: 'Event';
  /** The associated action. */
  action?: Maybe<Scalars['String']['output']>;
  /** The actor that triggered the event. */
  actor?: Maybe<Actor>;
  /** The time the event was created. */
  createdAt: Scalars['Datetime']['output'];
  event: Scalars['JSON']['output'];
  /** Reads a single `EventType` that is related to this `Event`. */
  eventTypeByType?: Maybe<EventType>;
  /** Reads a single `Facility` that is related to this `Event`. */
  facility?: Maybe<Facility>;
  /** The associated Facility. */
  facilityId?: Maybe<Scalars['Int']['output']>;
  /** The identifier of the event. */
  id: Scalars['BigInt']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The type of event. */
  type: Scalars['String']['output'];
};

/** Handler for events. */
export type EventHandler = Node & {
  __typename?: 'EventHandler';
  /** The name of the event handler. */
  handler: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
};

/** Event metadata for specific handlers. */
export type EventHandlerMetadatum = Node & {
  __typename?: 'EventHandlerMetadatum';
  event: Scalars['JSON']['output'];
  /** Reads a single `EventHandler` that is related to this `EventHandlerMetadatum`. */
  eventHandlerByHandler?: Maybe<EventHandler>;
  /** Reads a single `EventType` that is related to this `EventHandlerMetadatum`. */
  eventTypeByType?: Maybe<EventType>;
  /** The event handler. */
  handler: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The type of event. */
  type: Scalars['String']['output'];
};

/** Type of event that user can subscribe to. */
export type EventType = Node & {
  __typename?: 'EventType';
  /** The name of the event type. */
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
};

/** A connection to a list of `Facility` values. */
export type FacilitiesConnection = {
  __typename?: 'FacilitiesConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<FacilityAggregates>;
  /** The dayahead rate for the associated pricing node. */
  dayaheadRate?: Maybe<MetricDataConnection>;
  /** A list of edges which contains the `Facility` and cursor to aid in pagination. */
  edges: Array<FacilitiesEdge>;
  /** The average carbon emissions from all grid generators serving this facility at a given time. */
  emissionsAverageRate?: Maybe<MetricDataConnection>;
  /** The carbon emissions impact of an added or avoided unit of electricity at this facility's grid connection. */
  emissionsMarginalRate?: Maybe<MetricDataConnection>;
  /** The grid demand value for the associated balancing authority. */
  gridDemand?: Maybe<MetricDataConnection>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<FacilityAggregates>>;
  /** Aggregates a metric by label for the specified filter expression. */
  metricData?: Maybe<MetricDataConnection>;
  /** A list of `Facility` objects. */
  nodes: Array<Facility>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The realtime rate for the associated pricing node. */
  realtimeRate?: Maybe<MetricDataConnection>;
  /** The count of *all* `Facility` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
  /** The hourly cloud cover reading for the associated location. */
  weatherCloudCover?: Maybe<MetricDataConnection>;
  /** The hourly outside dewpoint reading for the associated location. */
  weatherDewpoint?: Maybe<MetricDataConnection>;
  /** The hourly outside humidity reading for the associated location. */
  weatherHumidity?: Maybe<MetricDataConnection>;
  /** The hourly outside solar energy reading for the associated location. */
  weatherSolarEnergy?: Maybe<MetricDataConnection>;
  /** The hourly outside solar radiation reading for the associated location. */
  weatherSolarRadiation?: Maybe<MetricDataConnection>;
  /** The hourly outside temperature reading for the associated location. */
  weatherTemperature?: Maybe<MetricDataConnection>;
  /** The hourly wet-bulb thermometer reading for the associated location. */
  weatherTemperatureWetBulb?: Maybe<MetricDataConnection>;
  /** The difference between the hourly wet-bulb and dry-bulb values. */
  weatherTemperatureWetBulbDepression?: Maybe<MetricDataConnection>;
  /** The hourly visibility reading for the associated location. */
  weatherVisibility?: Maybe<MetricDataConnection>;
};

/** A connection to a list of `Facility` values. */
export type FacilitiesConnectionDayaheadRateArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Facility` values. */
export type FacilitiesConnectionEmissionsAverageRateArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Facility` values. */
export type FacilitiesConnectionEmissionsMarginalRateArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Facility` values. */
export type FacilitiesConnectionGridDemandArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Facility` values. */
export type FacilitiesConnectionGroupedAggregatesArgs = {
  groupBy: Array<FacilitiesGroupBy>;
  having?: InputMaybe<FacilitiesHavingInput>;
};

/** A connection to a list of `Facility` values. */
export type FacilitiesConnectionMetricDataArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Facility` values. */
export type FacilitiesConnectionRealtimeRateArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Facility` values. */
export type FacilitiesConnectionWeatherCloudCoverArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Facility` values. */
export type FacilitiesConnectionWeatherDewpointArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Facility` values. */
export type FacilitiesConnectionWeatherHumidityArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Facility` values. */
export type FacilitiesConnectionWeatherSolarEnergyArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Facility` values. */
export type FacilitiesConnectionWeatherSolarRadiationArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Facility` values. */
export type FacilitiesConnectionWeatherTemperatureArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Facility` values. */
export type FacilitiesConnectionWeatherTemperatureWetBulbArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Facility` values. */
export type FacilitiesConnectionWeatherTemperatureWetBulbDepressionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Facility` values. */
export type FacilitiesConnectionWeatherVisibilityArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A `Facility` edge in the connection. */
export type FacilitiesEdge = {
  __typename?: 'FacilitiesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Facility` at the end of the edge. */
  node: Facility;
};

/** Grouping methods for `Facility` for usage during aggregation. */
export enum FacilitiesGroupBy {
  ADDRESS = 'ADDRESS',
  ADDRESS_DISTINCT = 'ADDRESS_DISTINCT',
  BONUS_LTR = 'BONUS_LTR',
  BONUS_LTR_DISTINCT = 'BONUS_LTR_DISTINCT',
  CITY = 'CITY',
  CITY_DISTINCT = 'CITY_DISTINCT',
  COMMODITY = 'COMMODITY',
  COMMODITY_DISTINCT = 'COMMODITY_DISTINCT',
  CONTXT_9249 = 'CONTXT_9249',
  CONTXT_9249_DISTINCT = 'CONTXT_9249_DISTINCT',
  COST_CENTER = 'COST_CENTER',
  COST_CENTER_DISTINCT = 'COST_CENTER_DISTINCT',
  COUNTRY = 'COUNTRY',
  COUNTRY_DISTINCT = 'COUNTRY_DISTINCT',
  CREATED_AT = 'CREATED_AT',
  CREATED_AT_DISTINCT = 'CREATED_AT_DISTINCT',
  CREATED_AT_TRUNCATED_TO_DAY = 'CREATED_AT_TRUNCATED_TO_DAY',
  CREATED_AT_TRUNCATED_TO_HOUR = 'CREATED_AT_TRUNCATED_TO_HOUR',
  CUSTOMER_LOCATION_ID = 'CUSTOMER_LOCATION_ID',
  CUSTOMER_LOCATION_ID_DISTINCT = 'CUSTOMER_LOCATION_ID_DISTINCT',
  DATATYPE_1_TEST = 'DATATYPE_1_TEST',
  DATATYPE_1_TEST_DISTINCT = 'DATATYPE_1_TEST_DISTINCT',
  DATATYPE_1_TEST_TRUNCATED_TO_DAY = 'DATATYPE_1_TEST_TRUNCATED_TO_DAY',
  DATATYPE_1_TEST_TRUNCATED_TO_HOUR = 'DATATYPE_1_TEST_TRUNCATED_TO_HOUR',
  DATA_TYPE_2_TEST = 'DATA_TYPE_2_TEST',
  DATA_TYPE_2_TEST_DISTINCT = 'DATA_TYPE_2_TEST_DISTINCT',
  DATA_TYPE_3_TEST = 'DATA_TYPE_3_TEST',
  DATA_TYPE_3_TEST_DISTINCT = 'DATA_TYPE_3_TEST_DISTINCT',
  FACILITY_CONTACTS = 'FACILITY_CONTACTS',
  FACILITY_CONTACTS_DISTINCT = 'FACILITY_CONTACTS_DISTINCT',
  FLOOR_PLAN_GEOMETRY = 'FLOOR_PLAN_GEOMETRY',
  FLOOR_PLAN_GEOMETRY_DISTINCT = 'FLOOR_PLAN_GEOMETRY_DISTINCT',
  GEOMETRY = 'GEOMETRY',
  GEOMETRY_DISTINCT = 'GEOMETRY_DISTINCT',
  GO_LIVE_DATE = 'GO_LIVE_DATE',
  GO_LIVE_DATE_DISTINCT = 'GO_LIVE_DATE_DISTINCT',
  GO_LIVE_DATE_TRUNCATED_TO_DAY = 'GO_LIVE_DATE_TRUNCATED_TO_DAY',
  GO_LIVE_DATE_TRUNCATED_TO_HOUR = 'GO_LIVE_DATE_TRUNCATED_TO_HOUR',
  LATITUDE = 'LATITUDE',
  LATITUDE_DISTINCT = 'LATITUDE_DISTINCT',
  LINK_ACTIVE = 'LINK_ACTIVE',
  LINK_ACTIVE_DISTINCT = 'LINK_ACTIVE_DISTINCT',
  LONGITUDE = 'LONGITUDE',
  LONGITUDE_DISTINCT = 'LONGITUDE_DISTINCT',
  METRICS_ONE_ACTIVE = 'METRICS_ONE_ACTIVE',
  METRICS_ONE_ACTIVE_DISTINCT = 'METRICS_ONE_ACTIVE_DISTINCT',
  NAME = 'NAME',
  NAME_DISTINCT = 'NAME_DISTINCT',
  NOTE = 'NOTE',
  NOTE_DISTINCT = 'NOTE_DISTINCT',
  N_SIGHT_2_ACTIVE = 'N_SIGHT_2_ACTIVE',
  N_SIGHT_2_ACTIVE_DISTINCT = 'N_SIGHT_2_ACTIVE_DISTINCT',
  N_SIGHT_ACTIVE = 'N_SIGHT_ACTIVE',
  N_SIGHT_ACTIVE_DISTINCT = 'N_SIGHT_ACTIVE_DISTINCT',
  PRE_BONUS_EBITDA = 'PRE_BONUS_EBITDA',
  PRE_BONUS_EBITDA_DISTINCT = 'PRE_BONUS_EBITDA_DISTINCT',
  PRICING_NODE_ID = 'PRICING_NODE_ID',
  PRICING_NODE_ID_DISTINCT = 'PRICING_NODE_ID_DISTINCT',
  REAL_TIME_ENABLED = 'REAL_TIME_ENABLED',
  REAL_TIME_ENABLED_DISTINCT = 'REAL_TIME_ENABLED_DISTINCT',
  REFRIGERATIONVENDOR = 'REFRIGERATIONVENDOR',
  REFRIGERATIONVENDOR_DISTINCT = 'REFRIGERATIONVENDOR_DISTINCT',
  REFRIGERATION_CONTROL_SYSTEM_VENDOR = 'REFRIGERATION_CONTROL_SYSTEM_VENDOR',
  REFRIGERATION_CONTROL_SYSTEM_VENDOR_DISTINCT = 'REFRIGERATION_CONTROL_SYSTEM_VENDOR_DISTINCT',
  RETIRED_AT = 'RETIRED_AT',
  RETIRED_AT_DISTINCT = 'RETIRED_AT_DISTINCT',
  RETIRED_AT_TRUNCATED_TO_DAY = 'RETIRED_AT_TRUNCATED_TO_DAY',
  RETIRED_AT_TRUNCATED_TO_HOUR = 'RETIRED_AT_TRUNCATED_TO_HOUR',
  STATE = 'STATE',
  STATE_DISTINCT = 'STATE_DISTINCT',
  SUPPRESSE_FINANCIALS = 'SUPPRESSE_FINANCIALS',
  SUPPRESSE_FINANCIALS_DISTINCT = 'SUPPRESSE_FINANCIALS_DISTINCT',
  TAT_ATTRIBUTE = 'TAT_ATTRIBUTE',
  TAT_ATTRIBUTE_DISTINCT = 'TAT_ATTRIBUTE_DISTINCT',
  TIMEZONE_NAME = 'TIMEZONE_NAME',
  TIMEZONE_NAME_DISTINCT = 'TIMEZONE_NAME_DISTINCT',
  TYPE = 'TYPE',
  TYPE_DISTINCT = 'TYPE_DISTINCT',
  UNIT_GROUP = 'UNIT_GROUP',
  UNIT_GROUP_DISTINCT = 'UNIT_GROUP_DISTINCT',
  UPDATED_AT = 'UPDATED_AT',
  UPDATED_AT_DISTINCT = 'UPDATED_AT_DISTINCT',
  UPDATED_AT_TRUNCATED_TO_DAY = 'UPDATED_AT_TRUNCATED_TO_DAY',
  UPDATED_AT_TRUNCATED_TO_HOUR = 'UPDATED_AT_TRUNCATED_TO_HOUR',
  WMS = 'WMS',
  WMS_DISTINCT = 'WMS_DISTINCT',
  ZIP = 'ZIP',
  ZIP_DISTINCT = 'ZIP_DISTINCT'
}

export type FacilitiesHavingAverageFacilitiesActiveMeterDatesCountArgsInput = {
  from?: InputMaybe<Scalars['String']['input']>;
  meterServiceTypes?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type FacilitiesHavingAverageFacilitiesActiveMeterDatesCountInput = {
  args?: InputMaybe<FacilitiesHavingAverageFacilitiesActiveMeterDatesCountArgsInput>;
  filter?: InputMaybe<HavingIntFilter>;
};

export type FacilitiesHavingAverageInput = {
  activeMeterDatesCount?: InputMaybe<FacilitiesHavingAverageFacilitiesActiveMeterDatesCountInput>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  customerLocationId?: InputMaybe<HavingIntFilter>;
  dataType2Test?: InputMaybe<HavingFloatFilter>;
  dataType3Test?: InputMaybe<HavingIntFilter>;
  datatype1Test?: InputMaybe<HavingDatetimeFilter>;
  goLiveDate?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingIntFilter>;
  latitude?: InputMaybe<HavingFloatFilter>;
  longitude?: InputMaybe<HavingFloatFilter>;
  pricingNodeId?: InputMaybe<HavingIntFilter>;
  retiredAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type FacilitiesHavingDistinctCountFacilitiesActiveMeterDatesCountArgsInput =
  {
    from?: InputMaybe<Scalars['String']['input']>;
    meterServiceTypes?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
    to?: InputMaybe<Scalars['String']['input']>;
  };

export type FacilitiesHavingDistinctCountFacilitiesActiveMeterDatesCountInput =
  {
    args?: InputMaybe<FacilitiesHavingDistinctCountFacilitiesActiveMeterDatesCountArgsInput>;
    filter?: InputMaybe<HavingIntFilter>;
  };

export type FacilitiesHavingDistinctCountInput = {
  activeMeterDatesCount?: InputMaybe<FacilitiesHavingDistinctCountFacilitiesActiveMeterDatesCountInput>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  customerLocationId?: InputMaybe<HavingIntFilter>;
  dataType2Test?: InputMaybe<HavingFloatFilter>;
  dataType3Test?: InputMaybe<HavingIntFilter>;
  datatype1Test?: InputMaybe<HavingDatetimeFilter>;
  goLiveDate?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingIntFilter>;
  latitude?: InputMaybe<HavingFloatFilter>;
  longitude?: InputMaybe<HavingFloatFilter>;
  pricingNodeId?: InputMaybe<HavingIntFilter>;
  retiredAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type FacilitiesHavingDistinctFacilitiesActiveMeterDatesCountArgsInput = {
  from?: InputMaybe<Scalars['String']['input']>;
  meterServiceTypes?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type FacilitiesHavingDistinctFacilitiesActiveMeterDatesCountInput = {
  args?: InputMaybe<FacilitiesHavingDistinctFacilitiesActiveMeterDatesCountArgsInput>;
  filter?: InputMaybe<HavingIntFilter>;
};

export type FacilitiesHavingDistinctInput = {
  activeMeterDatesCount?: InputMaybe<FacilitiesHavingDistinctFacilitiesActiveMeterDatesCountInput>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  customerLocationId?: InputMaybe<HavingIntFilter>;
  dataType2Test?: InputMaybe<HavingFloatFilter>;
  dataType3Test?: InputMaybe<HavingIntFilter>;
  datatype1Test?: InputMaybe<HavingDatetimeFilter>;
  goLiveDate?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingIntFilter>;
  latitude?: InputMaybe<HavingFloatFilter>;
  longitude?: InputMaybe<HavingFloatFilter>;
  pricingNodeId?: InputMaybe<HavingIntFilter>;
  retiredAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `Facility` aggregates. */
export type FacilitiesHavingInput = {
  AND?: InputMaybe<Array<FacilitiesHavingInput>>;
  OR?: InputMaybe<Array<FacilitiesHavingInput>>;
  average?: InputMaybe<FacilitiesHavingAverageInput>;
  distinct?: InputMaybe<FacilitiesHavingDistinctInput>;
  distinctCount?: InputMaybe<FacilitiesHavingDistinctCountInput>;
  max?: InputMaybe<FacilitiesHavingMaxInput>;
  min?: InputMaybe<FacilitiesHavingMinInput>;
  stddevPopulation?: InputMaybe<FacilitiesHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<FacilitiesHavingStddevSampleInput>;
  sum?: InputMaybe<FacilitiesHavingSumInput>;
  variancePopulation?: InputMaybe<FacilitiesHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<FacilitiesHavingVarianceSampleInput>;
};

export type FacilitiesHavingMaxFacilitiesActiveMeterDatesCountArgsInput = {
  from?: InputMaybe<Scalars['String']['input']>;
  meterServiceTypes?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type FacilitiesHavingMaxFacilitiesActiveMeterDatesCountInput = {
  args?: InputMaybe<FacilitiesHavingMaxFacilitiesActiveMeterDatesCountArgsInput>;
  filter?: InputMaybe<HavingIntFilter>;
};

export type FacilitiesHavingMaxInput = {
  activeMeterDatesCount?: InputMaybe<FacilitiesHavingMaxFacilitiesActiveMeterDatesCountInput>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  customerLocationId?: InputMaybe<HavingIntFilter>;
  dataType2Test?: InputMaybe<HavingFloatFilter>;
  dataType3Test?: InputMaybe<HavingIntFilter>;
  datatype1Test?: InputMaybe<HavingDatetimeFilter>;
  goLiveDate?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingIntFilter>;
  latitude?: InputMaybe<HavingFloatFilter>;
  longitude?: InputMaybe<HavingFloatFilter>;
  pricingNodeId?: InputMaybe<HavingIntFilter>;
  retiredAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type FacilitiesHavingMinFacilitiesActiveMeterDatesCountArgsInput = {
  from?: InputMaybe<Scalars['String']['input']>;
  meterServiceTypes?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type FacilitiesHavingMinFacilitiesActiveMeterDatesCountInput = {
  args?: InputMaybe<FacilitiesHavingMinFacilitiesActiveMeterDatesCountArgsInput>;
  filter?: InputMaybe<HavingIntFilter>;
};

export type FacilitiesHavingMinInput = {
  activeMeterDatesCount?: InputMaybe<FacilitiesHavingMinFacilitiesActiveMeterDatesCountInput>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  customerLocationId?: InputMaybe<HavingIntFilter>;
  dataType2Test?: InputMaybe<HavingFloatFilter>;
  dataType3Test?: InputMaybe<HavingIntFilter>;
  datatype1Test?: InputMaybe<HavingDatetimeFilter>;
  goLiveDate?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingIntFilter>;
  latitude?: InputMaybe<HavingFloatFilter>;
  longitude?: InputMaybe<HavingFloatFilter>;
  pricingNodeId?: InputMaybe<HavingIntFilter>;
  retiredAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type FacilitiesHavingStddevPopulationFacilitiesActiveMeterDatesCountArgsInput =
  {
    from?: InputMaybe<Scalars['String']['input']>;
    meterServiceTypes?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
    to?: InputMaybe<Scalars['String']['input']>;
  };

export type FacilitiesHavingStddevPopulationFacilitiesActiveMeterDatesCountInput =
  {
    args?: InputMaybe<FacilitiesHavingStddevPopulationFacilitiesActiveMeterDatesCountArgsInput>;
    filter?: InputMaybe<HavingIntFilter>;
  };

export type FacilitiesHavingStddevPopulationInput = {
  activeMeterDatesCount?: InputMaybe<FacilitiesHavingStddevPopulationFacilitiesActiveMeterDatesCountInput>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  customerLocationId?: InputMaybe<HavingIntFilter>;
  dataType2Test?: InputMaybe<HavingFloatFilter>;
  dataType3Test?: InputMaybe<HavingIntFilter>;
  datatype1Test?: InputMaybe<HavingDatetimeFilter>;
  goLiveDate?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingIntFilter>;
  latitude?: InputMaybe<HavingFloatFilter>;
  longitude?: InputMaybe<HavingFloatFilter>;
  pricingNodeId?: InputMaybe<HavingIntFilter>;
  retiredAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type FacilitiesHavingStddevSampleFacilitiesActiveMeterDatesCountArgsInput =
  {
    from?: InputMaybe<Scalars['String']['input']>;
    meterServiceTypes?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
    to?: InputMaybe<Scalars['String']['input']>;
  };

export type FacilitiesHavingStddevSampleFacilitiesActiveMeterDatesCountInput = {
  args?: InputMaybe<FacilitiesHavingStddevSampleFacilitiesActiveMeterDatesCountArgsInput>;
  filter?: InputMaybe<HavingIntFilter>;
};

export type FacilitiesHavingStddevSampleInput = {
  activeMeterDatesCount?: InputMaybe<FacilitiesHavingStddevSampleFacilitiesActiveMeterDatesCountInput>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  customerLocationId?: InputMaybe<HavingIntFilter>;
  dataType2Test?: InputMaybe<HavingFloatFilter>;
  dataType3Test?: InputMaybe<HavingIntFilter>;
  datatype1Test?: InputMaybe<HavingDatetimeFilter>;
  goLiveDate?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingIntFilter>;
  latitude?: InputMaybe<HavingFloatFilter>;
  longitude?: InputMaybe<HavingFloatFilter>;
  pricingNodeId?: InputMaybe<HavingIntFilter>;
  retiredAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type FacilitiesHavingSumFacilitiesActiveMeterDatesCountArgsInput = {
  from?: InputMaybe<Scalars['String']['input']>;
  meterServiceTypes?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type FacilitiesHavingSumFacilitiesActiveMeterDatesCountInput = {
  args?: InputMaybe<FacilitiesHavingSumFacilitiesActiveMeterDatesCountArgsInput>;
  filter?: InputMaybe<HavingIntFilter>;
};

export type FacilitiesHavingSumInput = {
  activeMeterDatesCount?: InputMaybe<FacilitiesHavingSumFacilitiesActiveMeterDatesCountInput>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  customerLocationId?: InputMaybe<HavingIntFilter>;
  dataType2Test?: InputMaybe<HavingFloatFilter>;
  dataType3Test?: InputMaybe<HavingIntFilter>;
  datatype1Test?: InputMaybe<HavingDatetimeFilter>;
  goLiveDate?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingIntFilter>;
  latitude?: InputMaybe<HavingFloatFilter>;
  longitude?: InputMaybe<HavingFloatFilter>;
  pricingNodeId?: InputMaybe<HavingIntFilter>;
  retiredAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type FacilitiesHavingVariancePopulationFacilitiesActiveMeterDatesCountArgsInput =
  {
    from?: InputMaybe<Scalars['String']['input']>;
    meterServiceTypes?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
    to?: InputMaybe<Scalars['String']['input']>;
  };

export type FacilitiesHavingVariancePopulationFacilitiesActiveMeterDatesCountInput =
  {
    args?: InputMaybe<FacilitiesHavingVariancePopulationFacilitiesActiveMeterDatesCountArgsInput>;
    filter?: InputMaybe<HavingIntFilter>;
  };

export type FacilitiesHavingVariancePopulationInput = {
  activeMeterDatesCount?: InputMaybe<FacilitiesHavingVariancePopulationFacilitiesActiveMeterDatesCountInput>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  customerLocationId?: InputMaybe<HavingIntFilter>;
  dataType2Test?: InputMaybe<HavingFloatFilter>;
  dataType3Test?: InputMaybe<HavingIntFilter>;
  datatype1Test?: InputMaybe<HavingDatetimeFilter>;
  goLiveDate?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingIntFilter>;
  latitude?: InputMaybe<HavingFloatFilter>;
  longitude?: InputMaybe<HavingFloatFilter>;
  pricingNodeId?: InputMaybe<HavingIntFilter>;
  retiredAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type FacilitiesHavingVarianceSampleFacilitiesActiveMeterDatesCountArgsInput =
  {
    from?: InputMaybe<Scalars['String']['input']>;
    meterServiceTypes?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
    to?: InputMaybe<Scalars['String']['input']>;
  };

export type FacilitiesHavingVarianceSampleFacilitiesActiveMeterDatesCountInput =
  {
    args?: InputMaybe<FacilitiesHavingVarianceSampleFacilitiesActiveMeterDatesCountArgsInput>;
    filter?: InputMaybe<HavingIntFilter>;
  };

export type FacilitiesHavingVarianceSampleInput = {
  activeMeterDatesCount?: InputMaybe<FacilitiesHavingVarianceSampleFacilitiesActiveMeterDatesCountInput>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  customerLocationId?: InputMaybe<HavingIntFilter>;
  dataType2Test?: InputMaybe<HavingFloatFilter>;
  dataType3Test?: InputMaybe<HavingIntFilter>;
  datatype1Test?: InputMaybe<HavingDatetimeFilter>;
  goLiveDate?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingIntFilter>;
  latitude?: InputMaybe<HavingFloatFilter>;
  longitude?: InputMaybe<HavingFloatFilter>;
  pricingNodeId?: InputMaybe<HavingIntFilter>;
  retiredAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Methods to use when ordering `Facility`. */
export enum FacilitiesOrderBy {
  ADDRESS_ASC = 'ADDRESS_ASC',
  ADDRESS_DESC = 'ADDRESS_DESC',
  BONUS_LTR_ASC = 'BONUS_LTR_ASC',
  BONUS_LTR_DESC = 'BONUS_LTR_DESC',
  CITY_ASC = 'CITY_ASC',
  CITY_DESC = 'CITY_DESC',
  COMMODITY_ASC = 'COMMODITY_ASC',
  COMMODITY_DESC = 'COMMODITY_DESC',
  CONTXT_9249_ASC = 'CONTXT_9249_ASC',
  CONTXT_9249_DESC = 'CONTXT_9249_DESC',
  COST_CENTER_ASC = 'COST_CENTER_ASC',
  COST_CENTER_DESC = 'COST_CENTER_DESC',
  COUNTRY_ASC = 'COUNTRY_ASC',
  COUNTRY_DESC = 'COUNTRY_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  CUSTOMER_LOCATION_ID_ASC = 'CUSTOMER_LOCATION_ID_ASC',
  CUSTOMER_LOCATION_ID_DESC = 'CUSTOMER_LOCATION_ID_DESC',
  DATATYPE_1_TEST_ASC = 'DATATYPE_1_TEST_ASC',
  DATATYPE_1_TEST_DESC = 'DATATYPE_1_TEST_DESC',
  DATA_TYPE_2_TEST_ASC = 'DATA_TYPE_2_TEST_ASC',
  DATA_TYPE_2_TEST_DESC = 'DATA_TYPE_2_TEST_DESC',
  DATA_TYPE_3_TEST_ASC = 'DATA_TYPE_3_TEST_ASC',
  DATA_TYPE_3_TEST_DESC = 'DATA_TYPE_3_TEST_DESC',
  FACILITY_CONTACTS_ASC = 'FACILITY_CONTACTS_ASC',
  FACILITY_CONTACTS_DESC = 'FACILITY_CONTACTS_DESC',
  FLOOR_PLAN_GEOMETRY_ASC = 'FLOOR_PLAN_GEOMETRY_ASC',
  FLOOR_PLAN_GEOMETRY_DESC = 'FLOOR_PLAN_GEOMETRY_DESC',
  GEOMETRY_ASC = 'GEOMETRY_ASC',
  GEOMETRY_DESC = 'GEOMETRY_DESC',
  GO_LIVE_DATE_ASC = 'GO_LIVE_DATE_ASC',
  GO_LIVE_DATE_DESC = 'GO_LIVE_DATE_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LATITUDE_ASC = 'LATITUDE_ASC',
  LATITUDE_DESC = 'LATITUDE_DESC',
  LINK_ACTIVE_ASC = 'LINK_ACTIVE_ASC',
  LINK_ACTIVE_DESC = 'LINK_ACTIVE_DESC',
  LONGITUDE_ASC = 'LONGITUDE_ASC',
  LONGITUDE_DESC = 'LONGITUDE_DESC',
  METRICS_ONE_ACTIVE_ASC = 'METRICS_ONE_ACTIVE_ASC',
  METRICS_ONE_ACTIVE_DESC = 'METRICS_ONE_ACTIVE_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  NOTE_ASC = 'NOTE_ASC',
  NOTE_DESC = 'NOTE_DESC',
  N_SIGHT_2_ACTIVE_ASC = 'N_SIGHT_2_ACTIVE_ASC',
  N_SIGHT_2_ACTIVE_DESC = 'N_SIGHT_2_ACTIVE_DESC',
  N_SIGHT_ACTIVE_ASC = 'N_SIGHT_ACTIVE_ASC',
  N_SIGHT_ACTIVE_DESC = 'N_SIGHT_ACTIVE_DESC',
  OPPORTUNITIES_AVERAGE_CREATED_AT_ASC = 'OPPORTUNITIES_AVERAGE_CREATED_AT_ASC',
  OPPORTUNITIES_AVERAGE_CREATED_AT_DESC = 'OPPORTUNITIES_AVERAGE_CREATED_AT_DESC',
  OPPORTUNITIES_AVERAGE_DESCRIPTION_ASC = 'OPPORTUNITIES_AVERAGE_DESCRIPTION_ASC',
  OPPORTUNITIES_AVERAGE_DESCRIPTION_DESC = 'OPPORTUNITIES_AVERAGE_DESCRIPTION_DESC',
  OPPORTUNITIES_AVERAGE_EXPECTED_OUTCOME_ASC = 'OPPORTUNITIES_AVERAGE_EXPECTED_OUTCOME_ASC',
  OPPORTUNITIES_AVERAGE_EXPECTED_OUTCOME_DESC = 'OPPORTUNITIES_AVERAGE_EXPECTED_OUTCOME_DESC',
  OPPORTUNITIES_AVERAGE_EXPECTED_SAVINGS_DEMAND_ASC = 'OPPORTUNITIES_AVERAGE_EXPECTED_SAVINGS_DEMAND_ASC',
  OPPORTUNITIES_AVERAGE_EXPECTED_SAVINGS_DEMAND_DESC = 'OPPORTUNITIES_AVERAGE_EXPECTED_SAVINGS_DEMAND_DESC',
  OPPORTUNITIES_AVERAGE_EXPECTED_SAVINGS_ENERGY_ASC = 'OPPORTUNITIES_AVERAGE_EXPECTED_SAVINGS_ENERGY_ASC',
  OPPORTUNITIES_AVERAGE_EXPECTED_SAVINGS_ENERGY_DESC = 'OPPORTUNITIES_AVERAGE_EXPECTED_SAVINGS_ENERGY_DESC',
  OPPORTUNITIES_AVERAGE_EXPECTED_SAVINGS_MONETARY_ASC = 'OPPORTUNITIES_AVERAGE_EXPECTED_SAVINGS_MONETARY_ASC',
  OPPORTUNITIES_AVERAGE_EXPECTED_SAVINGS_MONETARY_DESC = 'OPPORTUNITIES_AVERAGE_EXPECTED_SAVINGS_MONETARY_DESC',
  OPPORTUNITIES_AVERAGE_FACILITY_ID_ASC = 'OPPORTUNITIES_AVERAGE_FACILITY_ID_ASC',
  OPPORTUNITIES_AVERAGE_FACILITY_ID_DESC = 'OPPORTUNITIES_AVERAGE_FACILITY_ID_DESC',
  OPPORTUNITIES_AVERAGE_ID_ASC = 'OPPORTUNITIES_AVERAGE_ID_ASC',
  OPPORTUNITIES_AVERAGE_ID_DESC = 'OPPORTUNITIES_AVERAGE_ID_DESC',
  OPPORTUNITIES_AVERAGE_PROCEDURE_ASC = 'OPPORTUNITIES_AVERAGE_PROCEDURE_ASC',
  OPPORTUNITIES_AVERAGE_PROCEDURE_DESC = 'OPPORTUNITIES_AVERAGE_PROCEDURE_DESC',
  OPPORTUNITIES_AVERAGE_STATE_ASC = 'OPPORTUNITIES_AVERAGE_STATE_ASC',
  OPPORTUNITIES_AVERAGE_STATE_DESC = 'OPPORTUNITIES_AVERAGE_STATE_DESC',
  OPPORTUNITIES_AVERAGE_TAGS_ASC = 'OPPORTUNITIES_AVERAGE_TAGS_ASC',
  OPPORTUNITIES_AVERAGE_TAGS_DESC = 'OPPORTUNITIES_AVERAGE_TAGS_DESC',
  OPPORTUNITIES_AVERAGE_TITLE_ASC = 'OPPORTUNITIES_AVERAGE_TITLE_ASC',
  OPPORTUNITIES_AVERAGE_TITLE_DESC = 'OPPORTUNITIES_AVERAGE_TITLE_DESC',
  OPPORTUNITIES_AVERAGE_UPDATED_AT_ASC = 'OPPORTUNITIES_AVERAGE_UPDATED_AT_ASC',
  OPPORTUNITIES_AVERAGE_UPDATED_AT_DESC = 'OPPORTUNITIES_AVERAGE_UPDATED_AT_DESC',
  OPPORTUNITIES_COUNT_ASC = 'OPPORTUNITIES_COUNT_ASC',
  OPPORTUNITIES_COUNT_DESC = 'OPPORTUNITIES_COUNT_DESC',
  OPPORTUNITIES_DISTINCT_COUNT_CREATED_AT_ASC = 'OPPORTUNITIES_DISTINCT_COUNT_CREATED_AT_ASC',
  OPPORTUNITIES_DISTINCT_COUNT_CREATED_AT_DESC = 'OPPORTUNITIES_DISTINCT_COUNT_CREATED_AT_DESC',
  OPPORTUNITIES_DISTINCT_COUNT_DESCRIPTION_ASC = 'OPPORTUNITIES_DISTINCT_COUNT_DESCRIPTION_ASC',
  OPPORTUNITIES_DISTINCT_COUNT_DESCRIPTION_DESC = 'OPPORTUNITIES_DISTINCT_COUNT_DESCRIPTION_DESC',
  OPPORTUNITIES_DISTINCT_COUNT_EXPECTED_OUTCOME_ASC = 'OPPORTUNITIES_DISTINCT_COUNT_EXPECTED_OUTCOME_ASC',
  OPPORTUNITIES_DISTINCT_COUNT_EXPECTED_OUTCOME_DESC = 'OPPORTUNITIES_DISTINCT_COUNT_EXPECTED_OUTCOME_DESC',
  OPPORTUNITIES_DISTINCT_COUNT_EXPECTED_SAVINGS_DEMAND_ASC = 'OPPORTUNITIES_DISTINCT_COUNT_EXPECTED_SAVINGS_DEMAND_ASC',
  OPPORTUNITIES_DISTINCT_COUNT_EXPECTED_SAVINGS_DEMAND_DESC = 'OPPORTUNITIES_DISTINCT_COUNT_EXPECTED_SAVINGS_DEMAND_DESC',
  OPPORTUNITIES_DISTINCT_COUNT_EXPECTED_SAVINGS_ENERGY_ASC = 'OPPORTUNITIES_DISTINCT_COUNT_EXPECTED_SAVINGS_ENERGY_ASC',
  OPPORTUNITIES_DISTINCT_COUNT_EXPECTED_SAVINGS_ENERGY_DESC = 'OPPORTUNITIES_DISTINCT_COUNT_EXPECTED_SAVINGS_ENERGY_DESC',
  OPPORTUNITIES_DISTINCT_COUNT_EXPECTED_SAVINGS_MONETARY_ASC = 'OPPORTUNITIES_DISTINCT_COUNT_EXPECTED_SAVINGS_MONETARY_ASC',
  OPPORTUNITIES_DISTINCT_COUNT_EXPECTED_SAVINGS_MONETARY_DESC = 'OPPORTUNITIES_DISTINCT_COUNT_EXPECTED_SAVINGS_MONETARY_DESC',
  OPPORTUNITIES_DISTINCT_COUNT_FACILITY_ID_ASC = 'OPPORTUNITIES_DISTINCT_COUNT_FACILITY_ID_ASC',
  OPPORTUNITIES_DISTINCT_COUNT_FACILITY_ID_DESC = 'OPPORTUNITIES_DISTINCT_COUNT_FACILITY_ID_DESC',
  OPPORTUNITIES_DISTINCT_COUNT_ID_ASC = 'OPPORTUNITIES_DISTINCT_COUNT_ID_ASC',
  OPPORTUNITIES_DISTINCT_COUNT_ID_DESC = 'OPPORTUNITIES_DISTINCT_COUNT_ID_DESC',
  OPPORTUNITIES_DISTINCT_COUNT_PROCEDURE_ASC = 'OPPORTUNITIES_DISTINCT_COUNT_PROCEDURE_ASC',
  OPPORTUNITIES_DISTINCT_COUNT_PROCEDURE_DESC = 'OPPORTUNITIES_DISTINCT_COUNT_PROCEDURE_DESC',
  OPPORTUNITIES_DISTINCT_COUNT_STATE_ASC = 'OPPORTUNITIES_DISTINCT_COUNT_STATE_ASC',
  OPPORTUNITIES_DISTINCT_COUNT_STATE_DESC = 'OPPORTUNITIES_DISTINCT_COUNT_STATE_DESC',
  OPPORTUNITIES_DISTINCT_COUNT_TAGS_ASC = 'OPPORTUNITIES_DISTINCT_COUNT_TAGS_ASC',
  OPPORTUNITIES_DISTINCT_COUNT_TAGS_DESC = 'OPPORTUNITIES_DISTINCT_COUNT_TAGS_DESC',
  OPPORTUNITIES_DISTINCT_COUNT_TITLE_ASC = 'OPPORTUNITIES_DISTINCT_COUNT_TITLE_ASC',
  OPPORTUNITIES_DISTINCT_COUNT_TITLE_DESC = 'OPPORTUNITIES_DISTINCT_COUNT_TITLE_DESC',
  OPPORTUNITIES_DISTINCT_COUNT_UPDATED_AT_ASC = 'OPPORTUNITIES_DISTINCT_COUNT_UPDATED_AT_ASC',
  OPPORTUNITIES_DISTINCT_COUNT_UPDATED_AT_DESC = 'OPPORTUNITIES_DISTINCT_COUNT_UPDATED_AT_DESC',
  OPPORTUNITIES_DISTINCT_CREATED_AT_ASC = 'OPPORTUNITIES_DISTINCT_CREATED_AT_ASC',
  OPPORTUNITIES_DISTINCT_CREATED_AT_DESC = 'OPPORTUNITIES_DISTINCT_CREATED_AT_DESC',
  OPPORTUNITIES_DISTINCT_DESCRIPTION_ASC = 'OPPORTUNITIES_DISTINCT_DESCRIPTION_ASC',
  OPPORTUNITIES_DISTINCT_DESCRIPTION_DESC = 'OPPORTUNITIES_DISTINCT_DESCRIPTION_DESC',
  OPPORTUNITIES_DISTINCT_EXPECTED_OUTCOME_ASC = 'OPPORTUNITIES_DISTINCT_EXPECTED_OUTCOME_ASC',
  OPPORTUNITIES_DISTINCT_EXPECTED_OUTCOME_DESC = 'OPPORTUNITIES_DISTINCT_EXPECTED_OUTCOME_DESC',
  OPPORTUNITIES_DISTINCT_EXPECTED_SAVINGS_DEMAND_ASC = 'OPPORTUNITIES_DISTINCT_EXPECTED_SAVINGS_DEMAND_ASC',
  OPPORTUNITIES_DISTINCT_EXPECTED_SAVINGS_DEMAND_DESC = 'OPPORTUNITIES_DISTINCT_EXPECTED_SAVINGS_DEMAND_DESC',
  OPPORTUNITIES_DISTINCT_EXPECTED_SAVINGS_ENERGY_ASC = 'OPPORTUNITIES_DISTINCT_EXPECTED_SAVINGS_ENERGY_ASC',
  OPPORTUNITIES_DISTINCT_EXPECTED_SAVINGS_ENERGY_DESC = 'OPPORTUNITIES_DISTINCT_EXPECTED_SAVINGS_ENERGY_DESC',
  OPPORTUNITIES_DISTINCT_EXPECTED_SAVINGS_MONETARY_ASC = 'OPPORTUNITIES_DISTINCT_EXPECTED_SAVINGS_MONETARY_ASC',
  OPPORTUNITIES_DISTINCT_EXPECTED_SAVINGS_MONETARY_DESC = 'OPPORTUNITIES_DISTINCT_EXPECTED_SAVINGS_MONETARY_DESC',
  OPPORTUNITIES_DISTINCT_FACILITY_ID_ASC = 'OPPORTUNITIES_DISTINCT_FACILITY_ID_ASC',
  OPPORTUNITIES_DISTINCT_FACILITY_ID_DESC = 'OPPORTUNITIES_DISTINCT_FACILITY_ID_DESC',
  OPPORTUNITIES_DISTINCT_ID_ASC = 'OPPORTUNITIES_DISTINCT_ID_ASC',
  OPPORTUNITIES_DISTINCT_ID_DESC = 'OPPORTUNITIES_DISTINCT_ID_DESC',
  OPPORTUNITIES_DISTINCT_PROCEDURE_ASC = 'OPPORTUNITIES_DISTINCT_PROCEDURE_ASC',
  OPPORTUNITIES_DISTINCT_PROCEDURE_DESC = 'OPPORTUNITIES_DISTINCT_PROCEDURE_DESC',
  OPPORTUNITIES_DISTINCT_STATE_ASC = 'OPPORTUNITIES_DISTINCT_STATE_ASC',
  OPPORTUNITIES_DISTINCT_STATE_DESC = 'OPPORTUNITIES_DISTINCT_STATE_DESC',
  OPPORTUNITIES_DISTINCT_TAGS_ASC = 'OPPORTUNITIES_DISTINCT_TAGS_ASC',
  OPPORTUNITIES_DISTINCT_TAGS_DESC = 'OPPORTUNITIES_DISTINCT_TAGS_DESC',
  OPPORTUNITIES_DISTINCT_TITLE_ASC = 'OPPORTUNITIES_DISTINCT_TITLE_ASC',
  OPPORTUNITIES_DISTINCT_TITLE_DESC = 'OPPORTUNITIES_DISTINCT_TITLE_DESC',
  OPPORTUNITIES_DISTINCT_UPDATED_AT_ASC = 'OPPORTUNITIES_DISTINCT_UPDATED_AT_ASC',
  OPPORTUNITIES_DISTINCT_UPDATED_AT_DESC = 'OPPORTUNITIES_DISTINCT_UPDATED_AT_DESC',
  OPPORTUNITIES_MAX_CREATED_AT_ASC = 'OPPORTUNITIES_MAX_CREATED_AT_ASC',
  OPPORTUNITIES_MAX_CREATED_AT_DESC = 'OPPORTUNITIES_MAX_CREATED_AT_DESC',
  OPPORTUNITIES_MAX_DESCRIPTION_ASC = 'OPPORTUNITIES_MAX_DESCRIPTION_ASC',
  OPPORTUNITIES_MAX_DESCRIPTION_DESC = 'OPPORTUNITIES_MAX_DESCRIPTION_DESC',
  OPPORTUNITIES_MAX_EXPECTED_OUTCOME_ASC = 'OPPORTUNITIES_MAX_EXPECTED_OUTCOME_ASC',
  OPPORTUNITIES_MAX_EXPECTED_OUTCOME_DESC = 'OPPORTUNITIES_MAX_EXPECTED_OUTCOME_DESC',
  OPPORTUNITIES_MAX_EXPECTED_SAVINGS_DEMAND_ASC = 'OPPORTUNITIES_MAX_EXPECTED_SAVINGS_DEMAND_ASC',
  OPPORTUNITIES_MAX_EXPECTED_SAVINGS_DEMAND_DESC = 'OPPORTUNITIES_MAX_EXPECTED_SAVINGS_DEMAND_DESC',
  OPPORTUNITIES_MAX_EXPECTED_SAVINGS_ENERGY_ASC = 'OPPORTUNITIES_MAX_EXPECTED_SAVINGS_ENERGY_ASC',
  OPPORTUNITIES_MAX_EXPECTED_SAVINGS_ENERGY_DESC = 'OPPORTUNITIES_MAX_EXPECTED_SAVINGS_ENERGY_DESC',
  OPPORTUNITIES_MAX_EXPECTED_SAVINGS_MONETARY_ASC = 'OPPORTUNITIES_MAX_EXPECTED_SAVINGS_MONETARY_ASC',
  OPPORTUNITIES_MAX_EXPECTED_SAVINGS_MONETARY_DESC = 'OPPORTUNITIES_MAX_EXPECTED_SAVINGS_MONETARY_DESC',
  OPPORTUNITIES_MAX_FACILITY_ID_ASC = 'OPPORTUNITIES_MAX_FACILITY_ID_ASC',
  OPPORTUNITIES_MAX_FACILITY_ID_DESC = 'OPPORTUNITIES_MAX_FACILITY_ID_DESC',
  OPPORTUNITIES_MAX_ID_ASC = 'OPPORTUNITIES_MAX_ID_ASC',
  OPPORTUNITIES_MAX_ID_DESC = 'OPPORTUNITIES_MAX_ID_DESC',
  OPPORTUNITIES_MAX_PROCEDURE_ASC = 'OPPORTUNITIES_MAX_PROCEDURE_ASC',
  OPPORTUNITIES_MAX_PROCEDURE_DESC = 'OPPORTUNITIES_MAX_PROCEDURE_DESC',
  OPPORTUNITIES_MAX_STATE_ASC = 'OPPORTUNITIES_MAX_STATE_ASC',
  OPPORTUNITIES_MAX_STATE_DESC = 'OPPORTUNITIES_MAX_STATE_DESC',
  OPPORTUNITIES_MAX_TAGS_ASC = 'OPPORTUNITIES_MAX_TAGS_ASC',
  OPPORTUNITIES_MAX_TAGS_DESC = 'OPPORTUNITIES_MAX_TAGS_DESC',
  OPPORTUNITIES_MAX_TITLE_ASC = 'OPPORTUNITIES_MAX_TITLE_ASC',
  OPPORTUNITIES_MAX_TITLE_DESC = 'OPPORTUNITIES_MAX_TITLE_DESC',
  OPPORTUNITIES_MAX_UPDATED_AT_ASC = 'OPPORTUNITIES_MAX_UPDATED_AT_ASC',
  OPPORTUNITIES_MAX_UPDATED_AT_DESC = 'OPPORTUNITIES_MAX_UPDATED_AT_DESC',
  OPPORTUNITIES_MIN_CREATED_AT_ASC = 'OPPORTUNITIES_MIN_CREATED_AT_ASC',
  OPPORTUNITIES_MIN_CREATED_AT_DESC = 'OPPORTUNITIES_MIN_CREATED_AT_DESC',
  OPPORTUNITIES_MIN_DESCRIPTION_ASC = 'OPPORTUNITIES_MIN_DESCRIPTION_ASC',
  OPPORTUNITIES_MIN_DESCRIPTION_DESC = 'OPPORTUNITIES_MIN_DESCRIPTION_DESC',
  OPPORTUNITIES_MIN_EXPECTED_OUTCOME_ASC = 'OPPORTUNITIES_MIN_EXPECTED_OUTCOME_ASC',
  OPPORTUNITIES_MIN_EXPECTED_OUTCOME_DESC = 'OPPORTUNITIES_MIN_EXPECTED_OUTCOME_DESC',
  OPPORTUNITIES_MIN_EXPECTED_SAVINGS_DEMAND_ASC = 'OPPORTUNITIES_MIN_EXPECTED_SAVINGS_DEMAND_ASC',
  OPPORTUNITIES_MIN_EXPECTED_SAVINGS_DEMAND_DESC = 'OPPORTUNITIES_MIN_EXPECTED_SAVINGS_DEMAND_DESC',
  OPPORTUNITIES_MIN_EXPECTED_SAVINGS_ENERGY_ASC = 'OPPORTUNITIES_MIN_EXPECTED_SAVINGS_ENERGY_ASC',
  OPPORTUNITIES_MIN_EXPECTED_SAVINGS_ENERGY_DESC = 'OPPORTUNITIES_MIN_EXPECTED_SAVINGS_ENERGY_DESC',
  OPPORTUNITIES_MIN_EXPECTED_SAVINGS_MONETARY_ASC = 'OPPORTUNITIES_MIN_EXPECTED_SAVINGS_MONETARY_ASC',
  OPPORTUNITIES_MIN_EXPECTED_SAVINGS_MONETARY_DESC = 'OPPORTUNITIES_MIN_EXPECTED_SAVINGS_MONETARY_DESC',
  OPPORTUNITIES_MIN_FACILITY_ID_ASC = 'OPPORTUNITIES_MIN_FACILITY_ID_ASC',
  OPPORTUNITIES_MIN_FACILITY_ID_DESC = 'OPPORTUNITIES_MIN_FACILITY_ID_DESC',
  OPPORTUNITIES_MIN_ID_ASC = 'OPPORTUNITIES_MIN_ID_ASC',
  OPPORTUNITIES_MIN_ID_DESC = 'OPPORTUNITIES_MIN_ID_DESC',
  OPPORTUNITIES_MIN_PROCEDURE_ASC = 'OPPORTUNITIES_MIN_PROCEDURE_ASC',
  OPPORTUNITIES_MIN_PROCEDURE_DESC = 'OPPORTUNITIES_MIN_PROCEDURE_DESC',
  OPPORTUNITIES_MIN_STATE_ASC = 'OPPORTUNITIES_MIN_STATE_ASC',
  OPPORTUNITIES_MIN_STATE_DESC = 'OPPORTUNITIES_MIN_STATE_DESC',
  OPPORTUNITIES_MIN_TAGS_ASC = 'OPPORTUNITIES_MIN_TAGS_ASC',
  OPPORTUNITIES_MIN_TAGS_DESC = 'OPPORTUNITIES_MIN_TAGS_DESC',
  OPPORTUNITIES_MIN_TITLE_ASC = 'OPPORTUNITIES_MIN_TITLE_ASC',
  OPPORTUNITIES_MIN_TITLE_DESC = 'OPPORTUNITIES_MIN_TITLE_DESC',
  OPPORTUNITIES_MIN_UPDATED_AT_ASC = 'OPPORTUNITIES_MIN_UPDATED_AT_ASC',
  OPPORTUNITIES_MIN_UPDATED_AT_DESC = 'OPPORTUNITIES_MIN_UPDATED_AT_DESC',
  OPPORTUNITIES_STDDEV_POPULATION_CREATED_AT_ASC = 'OPPORTUNITIES_STDDEV_POPULATION_CREATED_AT_ASC',
  OPPORTUNITIES_STDDEV_POPULATION_CREATED_AT_DESC = 'OPPORTUNITIES_STDDEV_POPULATION_CREATED_AT_DESC',
  OPPORTUNITIES_STDDEV_POPULATION_DESCRIPTION_ASC = 'OPPORTUNITIES_STDDEV_POPULATION_DESCRIPTION_ASC',
  OPPORTUNITIES_STDDEV_POPULATION_DESCRIPTION_DESC = 'OPPORTUNITIES_STDDEV_POPULATION_DESCRIPTION_DESC',
  OPPORTUNITIES_STDDEV_POPULATION_EXPECTED_OUTCOME_ASC = 'OPPORTUNITIES_STDDEV_POPULATION_EXPECTED_OUTCOME_ASC',
  OPPORTUNITIES_STDDEV_POPULATION_EXPECTED_OUTCOME_DESC = 'OPPORTUNITIES_STDDEV_POPULATION_EXPECTED_OUTCOME_DESC',
  OPPORTUNITIES_STDDEV_POPULATION_EXPECTED_SAVINGS_DEMAND_ASC = 'OPPORTUNITIES_STDDEV_POPULATION_EXPECTED_SAVINGS_DEMAND_ASC',
  OPPORTUNITIES_STDDEV_POPULATION_EXPECTED_SAVINGS_DEMAND_DESC = 'OPPORTUNITIES_STDDEV_POPULATION_EXPECTED_SAVINGS_DEMAND_DESC',
  OPPORTUNITIES_STDDEV_POPULATION_EXPECTED_SAVINGS_ENERGY_ASC = 'OPPORTUNITIES_STDDEV_POPULATION_EXPECTED_SAVINGS_ENERGY_ASC',
  OPPORTUNITIES_STDDEV_POPULATION_EXPECTED_SAVINGS_ENERGY_DESC = 'OPPORTUNITIES_STDDEV_POPULATION_EXPECTED_SAVINGS_ENERGY_DESC',
  OPPORTUNITIES_STDDEV_POPULATION_EXPECTED_SAVINGS_MONETARY_ASC = 'OPPORTUNITIES_STDDEV_POPULATION_EXPECTED_SAVINGS_MONETARY_ASC',
  OPPORTUNITIES_STDDEV_POPULATION_EXPECTED_SAVINGS_MONETARY_DESC = 'OPPORTUNITIES_STDDEV_POPULATION_EXPECTED_SAVINGS_MONETARY_DESC',
  OPPORTUNITIES_STDDEV_POPULATION_FACILITY_ID_ASC = 'OPPORTUNITIES_STDDEV_POPULATION_FACILITY_ID_ASC',
  OPPORTUNITIES_STDDEV_POPULATION_FACILITY_ID_DESC = 'OPPORTUNITIES_STDDEV_POPULATION_FACILITY_ID_DESC',
  OPPORTUNITIES_STDDEV_POPULATION_ID_ASC = 'OPPORTUNITIES_STDDEV_POPULATION_ID_ASC',
  OPPORTUNITIES_STDDEV_POPULATION_ID_DESC = 'OPPORTUNITIES_STDDEV_POPULATION_ID_DESC',
  OPPORTUNITIES_STDDEV_POPULATION_PROCEDURE_ASC = 'OPPORTUNITIES_STDDEV_POPULATION_PROCEDURE_ASC',
  OPPORTUNITIES_STDDEV_POPULATION_PROCEDURE_DESC = 'OPPORTUNITIES_STDDEV_POPULATION_PROCEDURE_DESC',
  OPPORTUNITIES_STDDEV_POPULATION_STATE_ASC = 'OPPORTUNITIES_STDDEV_POPULATION_STATE_ASC',
  OPPORTUNITIES_STDDEV_POPULATION_STATE_DESC = 'OPPORTUNITIES_STDDEV_POPULATION_STATE_DESC',
  OPPORTUNITIES_STDDEV_POPULATION_TAGS_ASC = 'OPPORTUNITIES_STDDEV_POPULATION_TAGS_ASC',
  OPPORTUNITIES_STDDEV_POPULATION_TAGS_DESC = 'OPPORTUNITIES_STDDEV_POPULATION_TAGS_DESC',
  OPPORTUNITIES_STDDEV_POPULATION_TITLE_ASC = 'OPPORTUNITIES_STDDEV_POPULATION_TITLE_ASC',
  OPPORTUNITIES_STDDEV_POPULATION_TITLE_DESC = 'OPPORTUNITIES_STDDEV_POPULATION_TITLE_DESC',
  OPPORTUNITIES_STDDEV_POPULATION_UPDATED_AT_ASC = 'OPPORTUNITIES_STDDEV_POPULATION_UPDATED_AT_ASC',
  OPPORTUNITIES_STDDEV_POPULATION_UPDATED_AT_DESC = 'OPPORTUNITIES_STDDEV_POPULATION_UPDATED_AT_DESC',
  OPPORTUNITIES_STDDEV_SAMPLE_CREATED_AT_ASC = 'OPPORTUNITIES_STDDEV_SAMPLE_CREATED_AT_ASC',
  OPPORTUNITIES_STDDEV_SAMPLE_CREATED_AT_DESC = 'OPPORTUNITIES_STDDEV_SAMPLE_CREATED_AT_DESC',
  OPPORTUNITIES_STDDEV_SAMPLE_DESCRIPTION_ASC = 'OPPORTUNITIES_STDDEV_SAMPLE_DESCRIPTION_ASC',
  OPPORTUNITIES_STDDEV_SAMPLE_DESCRIPTION_DESC = 'OPPORTUNITIES_STDDEV_SAMPLE_DESCRIPTION_DESC',
  OPPORTUNITIES_STDDEV_SAMPLE_EXPECTED_OUTCOME_ASC = 'OPPORTUNITIES_STDDEV_SAMPLE_EXPECTED_OUTCOME_ASC',
  OPPORTUNITIES_STDDEV_SAMPLE_EXPECTED_OUTCOME_DESC = 'OPPORTUNITIES_STDDEV_SAMPLE_EXPECTED_OUTCOME_DESC',
  OPPORTUNITIES_STDDEV_SAMPLE_EXPECTED_SAVINGS_DEMAND_ASC = 'OPPORTUNITIES_STDDEV_SAMPLE_EXPECTED_SAVINGS_DEMAND_ASC',
  OPPORTUNITIES_STDDEV_SAMPLE_EXPECTED_SAVINGS_DEMAND_DESC = 'OPPORTUNITIES_STDDEV_SAMPLE_EXPECTED_SAVINGS_DEMAND_DESC',
  OPPORTUNITIES_STDDEV_SAMPLE_EXPECTED_SAVINGS_ENERGY_ASC = 'OPPORTUNITIES_STDDEV_SAMPLE_EXPECTED_SAVINGS_ENERGY_ASC',
  OPPORTUNITIES_STDDEV_SAMPLE_EXPECTED_SAVINGS_ENERGY_DESC = 'OPPORTUNITIES_STDDEV_SAMPLE_EXPECTED_SAVINGS_ENERGY_DESC',
  OPPORTUNITIES_STDDEV_SAMPLE_EXPECTED_SAVINGS_MONETARY_ASC = 'OPPORTUNITIES_STDDEV_SAMPLE_EXPECTED_SAVINGS_MONETARY_ASC',
  OPPORTUNITIES_STDDEV_SAMPLE_EXPECTED_SAVINGS_MONETARY_DESC = 'OPPORTUNITIES_STDDEV_SAMPLE_EXPECTED_SAVINGS_MONETARY_DESC',
  OPPORTUNITIES_STDDEV_SAMPLE_FACILITY_ID_ASC = 'OPPORTUNITIES_STDDEV_SAMPLE_FACILITY_ID_ASC',
  OPPORTUNITIES_STDDEV_SAMPLE_FACILITY_ID_DESC = 'OPPORTUNITIES_STDDEV_SAMPLE_FACILITY_ID_DESC',
  OPPORTUNITIES_STDDEV_SAMPLE_ID_ASC = 'OPPORTUNITIES_STDDEV_SAMPLE_ID_ASC',
  OPPORTUNITIES_STDDEV_SAMPLE_ID_DESC = 'OPPORTUNITIES_STDDEV_SAMPLE_ID_DESC',
  OPPORTUNITIES_STDDEV_SAMPLE_PROCEDURE_ASC = 'OPPORTUNITIES_STDDEV_SAMPLE_PROCEDURE_ASC',
  OPPORTUNITIES_STDDEV_SAMPLE_PROCEDURE_DESC = 'OPPORTUNITIES_STDDEV_SAMPLE_PROCEDURE_DESC',
  OPPORTUNITIES_STDDEV_SAMPLE_STATE_ASC = 'OPPORTUNITIES_STDDEV_SAMPLE_STATE_ASC',
  OPPORTUNITIES_STDDEV_SAMPLE_STATE_DESC = 'OPPORTUNITIES_STDDEV_SAMPLE_STATE_DESC',
  OPPORTUNITIES_STDDEV_SAMPLE_TAGS_ASC = 'OPPORTUNITIES_STDDEV_SAMPLE_TAGS_ASC',
  OPPORTUNITIES_STDDEV_SAMPLE_TAGS_DESC = 'OPPORTUNITIES_STDDEV_SAMPLE_TAGS_DESC',
  OPPORTUNITIES_STDDEV_SAMPLE_TITLE_ASC = 'OPPORTUNITIES_STDDEV_SAMPLE_TITLE_ASC',
  OPPORTUNITIES_STDDEV_SAMPLE_TITLE_DESC = 'OPPORTUNITIES_STDDEV_SAMPLE_TITLE_DESC',
  OPPORTUNITIES_STDDEV_SAMPLE_UPDATED_AT_ASC = 'OPPORTUNITIES_STDDEV_SAMPLE_UPDATED_AT_ASC',
  OPPORTUNITIES_STDDEV_SAMPLE_UPDATED_AT_DESC = 'OPPORTUNITIES_STDDEV_SAMPLE_UPDATED_AT_DESC',
  OPPORTUNITIES_SUM_CREATED_AT_ASC = 'OPPORTUNITIES_SUM_CREATED_AT_ASC',
  OPPORTUNITIES_SUM_CREATED_AT_DESC = 'OPPORTUNITIES_SUM_CREATED_AT_DESC',
  OPPORTUNITIES_SUM_DESCRIPTION_ASC = 'OPPORTUNITIES_SUM_DESCRIPTION_ASC',
  OPPORTUNITIES_SUM_DESCRIPTION_DESC = 'OPPORTUNITIES_SUM_DESCRIPTION_DESC',
  OPPORTUNITIES_SUM_EXPECTED_OUTCOME_ASC = 'OPPORTUNITIES_SUM_EXPECTED_OUTCOME_ASC',
  OPPORTUNITIES_SUM_EXPECTED_OUTCOME_DESC = 'OPPORTUNITIES_SUM_EXPECTED_OUTCOME_DESC',
  OPPORTUNITIES_SUM_EXPECTED_SAVINGS_DEMAND_ASC = 'OPPORTUNITIES_SUM_EXPECTED_SAVINGS_DEMAND_ASC',
  OPPORTUNITIES_SUM_EXPECTED_SAVINGS_DEMAND_DESC = 'OPPORTUNITIES_SUM_EXPECTED_SAVINGS_DEMAND_DESC',
  OPPORTUNITIES_SUM_EXPECTED_SAVINGS_ENERGY_ASC = 'OPPORTUNITIES_SUM_EXPECTED_SAVINGS_ENERGY_ASC',
  OPPORTUNITIES_SUM_EXPECTED_SAVINGS_ENERGY_DESC = 'OPPORTUNITIES_SUM_EXPECTED_SAVINGS_ENERGY_DESC',
  OPPORTUNITIES_SUM_EXPECTED_SAVINGS_MONETARY_ASC = 'OPPORTUNITIES_SUM_EXPECTED_SAVINGS_MONETARY_ASC',
  OPPORTUNITIES_SUM_EXPECTED_SAVINGS_MONETARY_DESC = 'OPPORTUNITIES_SUM_EXPECTED_SAVINGS_MONETARY_DESC',
  OPPORTUNITIES_SUM_FACILITY_ID_ASC = 'OPPORTUNITIES_SUM_FACILITY_ID_ASC',
  OPPORTUNITIES_SUM_FACILITY_ID_DESC = 'OPPORTUNITIES_SUM_FACILITY_ID_DESC',
  OPPORTUNITIES_SUM_ID_ASC = 'OPPORTUNITIES_SUM_ID_ASC',
  OPPORTUNITIES_SUM_ID_DESC = 'OPPORTUNITIES_SUM_ID_DESC',
  OPPORTUNITIES_SUM_PROCEDURE_ASC = 'OPPORTUNITIES_SUM_PROCEDURE_ASC',
  OPPORTUNITIES_SUM_PROCEDURE_DESC = 'OPPORTUNITIES_SUM_PROCEDURE_DESC',
  OPPORTUNITIES_SUM_STATE_ASC = 'OPPORTUNITIES_SUM_STATE_ASC',
  OPPORTUNITIES_SUM_STATE_DESC = 'OPPORTUNITIES_SUM_STATE_DESC',
  OPPORTUNITIES_SUM_TAGS_ASC = 'OPPORTUNITIES_SUM_TAGS_ASC',
  OPPORTUNITIES_SUM_TAGS_DESC = 'OPPORTUNITIES_SUM_TAGS_DESC',
  OPPORTUNITIES_SUM_TITLE_ASC = 'OPPORTUNITIES_SUM_TITLE_ASC',
  OPPORTUNITIES_SUM_TITLE_DESC = 'OPPORTUNITIES_SUM_TITLE_DESC',
  OPPORTUNITIES_SUM_UPDATED_AT_ASC = 'OPPORTUNITIES_SUM_UPDATED_AT_ASC',
  OPPORTUNITIES_SUM_UPDATED_AT_DESC = 'OPPORTUNITIES_SUM_UPDATED_AT_DESC',
  OPPORTUNITIES_VARIANCE_POPULATION_CREATED_AT_ASC = 'OPPORTUNITIES_VARIANCE_POPULATION_CREATED_AT_ASC',
  OPPORTUNITIES_VARIANCE_POPULATION_CREATED_AT_DESC = 'OPPORTUNITIES_VARIANCE_POPULATION_CREATED_AT_DESC',
  OPPORTUNITIES_VARIANCE_POPULATION_DESCRIPTION_ASC = 'OPPORTUNITIES_VARIANCE_POPULATION_DESCRIPTION_ASC',
  OPPORTUNITIES_VARIANCE_POPULATION_DESCRIPTION_DESC = 'OPPORTUNITIES_VARIANCE_POPULATION_DESCRIPTION_DESC',
  OPPORTUNITIES_VARIANCE_POPULATION_EXPECTED_OUTCOME_ASC = 'OPPORTUNITIES_VARIANCE_POPULATION_EXPECTED_OUTCOME_ASC',
  OPPORTUNITIES_VARIANCE_POPULATION_EXPECTED_OUTCOME_DESC = 'OPPORTUNITIES_VARIANCE_POPULATION_EXPECTED_OUTCOME_DESC',
  OPPORTUNITIES_VARIANCE_POPULATION_EXPECTED_SAVINGS_DEMAND_ASC = 'OPPORTUNITIES_VARIANCE_POPULATION_EXPECTED_SAVINGS_DEMAND_ASC',
  OPPORTUNITIES_VARIANCE_POPULATION_EXPECTED_SAVINGS_DEMAND_DESC = 'OPPORTUNITIES_VARIANCE_POPULATION_EXPECTED_SAVINGS_DEMAND_DESC',
  OPPORTUNITIES_VARIANCE_POPULATION_EXPECTED_SAVINGS_ENERGY_ASC = 'OPPORTUNITIES_VARIANCE_POPULATION_EXPECTED_SAVINGS_ENERGY_ASC',
  OPPORTUNITIES_VARIANCE_POPULATION_EXPECTED_SAVINGS_ENERGY_DESC = 'OPPORTUNITIES_VARIANCE_POPULATION_EXPECTED_SAVINGS_ENERGY_DESC',
  OPPORTUNITIES_VARIANCE_POPULATION_EXPECTED_SAVINGS_MONETARY_ASC = 'OPPORTUNITIES_VARIANCE_POPULATION_EXPECTED_SAVINGS_MONETARY_ASC',
  OPPORTUNITIES_VARIANCE_POPULATION_EXPECTED_SAVINGS_MONETARY_DESC = 'OPPORTUNITIES_VARIANCE_POPULATION_EXPECTED_SAVINGS_MONETARY_DESC',
  OPPORTUNITIES_VARIANCE_POPULATION_FACILITY_ID_ASC = 'OPPORTUNITIES_VARIANCE_POPULATION_FACILITY_ID_ASC',
  OPPORTUNITIES_VARIANCE_POPULATION_FACILITY_ID_DESC = 'OPPORTUNITIES_VARIANCE_POPULATION_FACILITY_ID_DESC',
  OPPORTUNITIES_VARIANCE_POPULATION_ID_ASC = 'OPPORTUNITIES_VARIANCE_POPULATION_ID_ASC',
  OPPORTUNITIES_VARIANCE_POPULATION_ID_DESC = 'OPPORTUNITIES_VARIANCE_POPULATION_ID_DESC',
  OPPORTUNITIES_VARIANCE_POPULATION_PROCEDURE_ASC = 'OPPORTUNITIES_VARIANCE_POPULATION_PROCEDURE_ASC',
  OPPORTUNITIES_VARIANCE_POPULATION_PROCEDURE_DESC = 'OPPORTUNITIES_VARIANCE_POPULATION_PROCEDURE_DESC',
  OPPORTUNITIES_VARIANCE_POPULATION_STATE_ASC = 'OPPORTUNITIES_VARIANCE_POPULATION_STATE_ASC',
  OPPORTUNITIES_VARIANCE_POPULATION_STATE_DESC = 'OPPORTUNITIES_VARIANCE_POPULATION_STATE_DESC',
  OPPORTUNITIES_VARIANCE_POPULATION_TAGS_ASC = 'OPPORTUNITIES_VARIANCE_POPULATION_TAGS_ASC',
  OPPORTUNITIES_VARIANCE_POPULATION_TAGS_DESC = 'OPPORTUNITIES_VARIANCE_POPULATION_TAGS_DESC',
  OPPORTUNITIES_VARIANCE_POPULATION_TITLE_ASC = 'OPPORTUNITIES_VARIANCE_POPULATION_TITLE_ASC',
  OPPORTUNITIES_VARIANCE_POPULATION_TITLE_DESC = 'OPPORTUNITIES_VARIANCE_POPULATION_TITLE_DESC',
  OPPORTUNITIES_VARIANCE_POPULATION_UPDATED_AT_ASC = 'OPPORTUNITIES_VARIANCE_POPULATION_UPDATED_AT_ASC',
  OPPORTUNITIES_VARIANCE_POPULATION_UPDATED_AT_DESC = 'OPPORTUNITIES_VARIANCE_POPULATION_UPDATED_AT_DESC',
  OPPORTUNITIES_VARIANCE_SAMPLE_CREATED_AT_ASC = 'OPPORTUNITIES_VARIANCE_SAMPLE_CREATED_AT_ASC',
  OPPORTUNITIES_VARIANCE_SAMPLE_CREATED_AT_DESC = 'OPPORTUNITIES_VARIANCE_SAMPLE_CREATED_AT_DESC',
  OPPORTUNITIES_VARIANCE_SAMPLE_DESCRIPTION_ASC = 'OPPORTUNITIES_VARIANCE_SAMPLE_DESCRIPTION_ASC',
  OPPORTUNITIES_VARIANCE_SAMPLE_DESCRIPTION_DESC = 'OPPORTUNITIES_VARIANCE_SAMPLE_DESCRIPTION_DESC',
  OPPORTUNITIES_VARIANCE_SAMPLE_EXPECTED_OUTCOME_ASC = 'OPPORTUNITIES_VARIANCE_SAMPLE_EXPECTED_OUTCOME_ASC',
  OPPORTUNITIES_VARIANCE_SAMPLE_EXPECTED_OUTCOME_DESC = 'OPPORTUNITIES_VARIANCE_SAMPLE_EXPECTED_OUTCOME_DESC',
  OPPORTUNITIES_VARIANCE_SAMPLE_EXPECTED_SAVINGS_DEMAND_ASC = 'OPPORTUNITIES_VARIANCE_SAMPLE_EXPECTED_SAVINGS_DEMAND_ASC',
  OPPORTUNITIES_VARIANCE_SAMPLE_EXPECTED_SAVINGS_DEMAND_DESC = 'OPPORTUNITIES_VARIANCE_SAMPLE_EXPECTED_SAVINGS_DEMAND_DESC',
  OPPORTUNITIES_VARIANCE_SAMPLE_EXPECTED_SAVINGS_ENERGY_ASC = 'OPPORTUNITIES_VARIANCE_SAMPLE_EXPECTED_SAVINGS_ENERGY_ASC',
  OPPORTUNITIES_VARIANCE_SAMPLE_EXPECTED_SAVINGS_ENERGY_DESC = 'OPPORTUNITIES_VARIANCE_SAMPLE_EXPECTED_SAVINGS_ENERGY_DESC',
  OPPORTUNITIES_VARIANCE_SAMPLE_EXPECTED_SAVINGS_MONETARY_ASC = 'OPPORTUNITIES_VARIANCE_SAMPLE_EXPECTED_SAVINGS_MONETARY_ASC',
  OPPORTUNITIES_VARIANCE_SAMPLE_EXPECTED_SAVINGS_MONETARY_DESC = 'OPPORTUNITIES_VARIANCE_SAMPLE_EXPECTED_SAVINGS_MONETARY_DESC',
  OPPORTUNITIES_VARIANCE_SAMPLE_FACILITY_ID_ASC = 'OPPORTUNITIES_VARIANCE_SAMPLE_FACILITY_ID_ASC',
  OPPORTUNITIES_VARIANCE_SAMPLE_FACILITY_ID_DESC = 'OPPORTUNITIES_VARIANCE_SAMPLE_FACILITY_ID_DESC',
  OPPORTUNITIES_VARIANCE_SAMPLE_ID_ASC = 'OPPORTUNITIES_VARIANCE_SAMPLE_ID_ASC',
  OPPORTUNITIES_VARIANCE_SAMPLE_ID_DESC = 'OPPORTUNITIES_VARIANCE_SAMPLE_ID_DESC',
  OPPORTUNITIES_VARIANCE_SAMPLE_PROCEDURE_ASC = 'OPPORTUNITIES_VARIANCE_SAMPLE_PROCEDURE_ASC',
  OPPORTUNITIES_VARIANCE_SAMPLE_PROCEDURE_DESC = 'OPPORTUNITIES_VARIANCE_SAMPLE_PROCEDURE_DESC',
  OPPORTUNITIES_VARIANCE_SAMPLE_STATE_ASC = 'OPPORTUNITIES_VARIANCE_SAMPLE_STATE_ASC',
  OPPORTUNITIES_VARIANCE_SAMPLE_STATE_DESC = 'OPPORTUNITIES_VARIANCE_SAMPLE_STATE_DESC',
  OPPORTUNITIES_VARIANCE_SAMPLE_TAGS_ASC = 'OPPORTUNITIES_VARIANCE_SAMPLE_TAGS_ASC',
  OPPORTUNITIES_VARIANCE_SAMPLE_TAGS_DESC = 'OPPORTUNITIES_VARIANCE_SAMPLE_TAGS_DESC',
  OPPORTUNITIES_VARIANCE_SAMPLE_TITLE_ASC = 'OPPORTUNITIES_VARIANCE_SAMPLE_TITLE_ASC',
  OPPORTUNITIES_VARIANCE_SAMPLE_TITLE_DESC = 'OPPORTUNITIES_VARIANCE_SAMPLE_TITLE_DESC',
  OPPORTUNITIES_VARIANCE_SAMPLE_UPDATED_AT_ASC = 'OPPORTUNITIES_VARIANCE_SAMPLE_UPDATED_AT_ASC',
  OPPORTUNITIES_VARIANCE_SAMPLE_UPDATED_AT_DESC = 'OPPORTUNITIES_VARIANCE_SAMPLE_UPDATED_AT_DESC',
  PRE_BONUS_EBITDA_ASC = 'PRE_BONUS_EBITDA_ASC',
  PRE_BONUS_EBITDA_DESC = 'PRE_BONUS_EBITDA_DESC',
  PRICING_NODE_ID_ASC = 'PRICING_NODE_ID_ASC',
  PRICING_NODE_ID_DESC = 'PRICING_NODE_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  REAL_TIME_ENABLED_ASC = 'REAL_TIME_ENABLED_ASC',
  REAL_TIME_ENABLED_DESC = 'REAL_TIME_ENABLED_DESC',
  REFRIGERATIONVENDOR_ASC = 'REFRIGERATIONVENDOR_ASC',
  REFRIGERATIONVENDOR_DESC = 'REFRIGERATIONVENDOR_DESC',
  REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  RETIRED_AT_ASC = 'RETIRED_AT_ASC',
  RETIRED_AT_DESC = 'RETIRED_AT_DESC',
  SLUG_ASC = 'SLUG_ASC',
  SLUG_DESC = 'SLUG_DESC',
  STATE_ASC = 'STATE_ASC',
  STATE_DESC = 'STATE_DESC',
  SUPPRESSE_FINANCIALS_ASC = 'SUPPRESSE_FINANCIALS_ASC',
  SUPPRESSE_FINANCIALS_DESC = 'SUPPRESSE_FINANCIALS_DESC',
  TAT_ATTRIBUTE_ASC = 'TAT_ATTRIBUTE_ASC',
  TAT_ATTRIBUTE_DESC = 'TAT_ATTRIBUTE_DESC',
  TIMEZONE_NAME_ASC = 'TIMEZONE_NAME_ASC',
  TIMEZONE_NAME_DESC = 'TIMEZONE_NAME_DESC',
  TYPE_ASC = 'TYPE_ASC',
  TYPE_DESC = 'TYPE_DESC',
  UNIT_GROUP_ASC = 'UNIT_GROUP_ASC',
  UNIT_GROUP_DESC = 'UNIT_GROUP_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  UTILITY_BILL_CURRENCY_ASC = 'UTILITY_BILL_CURRENCY_ASC',
  UTILITY_BILL_CURRENCY_DESC = 'UTILITY_BILL_CURRENCY_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_STATEMENT_PDF_ID_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_STATEMENT_PDF_ID_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_STATEMENT_PDF_ID_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_STATEMENT_PDF_ID_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_COUNT_ASC = 'UTILITY_METER_STATEMENTS_COUNT_ASC',
  UTILITY_METER_STATEMENTS_COUNT_DESC = 'UTILITY_METER_STATEMENTS_COUNT_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_STATEMENT_PDF_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_STATEMENT_PDF_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_STATEMENT_PDF_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_STATEMENT_PDF_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_STATEMENT_PDF_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_STATEMENT_PDF_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_STATEMENT_PDF_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_STATEMENT_PDF_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_MAX_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_MAX_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_MAX_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_MAX_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_MAX_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_MAX_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_MAX_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_MAX_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_MAX_ACCOUNT_STATEMENT_PDF_ID_ASC = 'UTILITY_METER_STATEMENTS_MAX_ACCOUNT_STATEMENT_PDF_ID_ASC',
  UTILITY_METER_STATEMENTS_MAX_ACCOUNT_STATEMENT_PDF_ID_DESC = 'UTILITY_METER_STATEMENTS_MAX_ACCOUNT_STATEMENT_PDF_ID_DESC',
  UTILITY_METER_STATEMENTS_MAX_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_MAX_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_MAX_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_MAX_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_MAX_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_MAX_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_MAX_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_MAX_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_MAX_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_MAX_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_MAX_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_MAX_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_MAX_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_MAX_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_MAX_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_MAX_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_MAX_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_MAX_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_MAX_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_MAX_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_MAX_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_MAX_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_MAX_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_MAX_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_MAX_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_MAX_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_MAX_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_MAX_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_MAX_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_MAX_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_MAX_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_MAX_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_MAX_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_MAX_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_MAX_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_MAX_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_MAX_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_MAX_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_MAX_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_MAX_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_MAX_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_MAX_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_MAX_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_MAX_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_MAX_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_MAX_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_MAX_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_MAX_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_MAX_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_MAX_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_MAX_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_MAX_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_MAX_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_MAX_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_MAX_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_MAX_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_MAX_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_MAX_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_MAX_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_MAX_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_MAX_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_MAX_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_MAX_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_MAX_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_MAX_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_MAX_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_MAX_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_MAX_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_MAX_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_MAX_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_MAX_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_MAX_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_MAX_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_MAX_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_MAX_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_MAX_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_MIN_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_MIN_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_MIN_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_MIN_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_MIN_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_MIN_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_MIN_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_MIN_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_MIN_ACCOUNT_STATEMENT_PDF_ID_ASC = 'UTILITY_METER_STATEMENTS_MIN_ACCOUNT_STATEMENT_PDF_ID_ASC',
  UTILITY_METER_STATEMENTS_MIN_ACCOUNT_STATEMENT_PDF_ID_DESC = 'UTILITY_METER_STATEMENTS_MIN_ACCOUNT_STATEMENT_PDF_ID_DESC',
  UTILITY_METER_STATEMENTS_MIN_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_MIN_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_MIN_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_MIN_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_MIN_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_MIN_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_MIN_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_MIN_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_MIN_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_MIN_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_MIN_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_MIN_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_MIN_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_MIN_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_MIN_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_MIN_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_MIN_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_MIN_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_MIN_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_MIN_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_MIN_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_MIN_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_MIN_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_MIN_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_MIN_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_MIN_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_MIN_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_MIN_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_MIN_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_MIN_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_MIN_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_MIN_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_MIN_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_MIN_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_MIN_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_MIN_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_MIN_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_MIN_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_MIN_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_MIN_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_MIN_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_MIN_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_MIN_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_MIN_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_MIN_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_MIN_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_MIN_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_MIN_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_MIN_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_MIN_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_MIN_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_MIN_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_MIN_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_MIN_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_MIN_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_MIN_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_MIN_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_MIN_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_MIN_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_MIN_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_MIN_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_MIN_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_MIN_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_MIN_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_MIN_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_MIN_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_MIN_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_MIN_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_MIN_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_MIN_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_MIN_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_MIN_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_MIN_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_MIN_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_MIN_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_MIN_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_STATEMENT_PDF_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_STATEMENT_PDF_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_STATEMENT_PDF_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_STATEMENT_PDF_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_PDF_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_PDF_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_PDF_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_PDF_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_SUM_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_SUM_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_SUM_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_SUM_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_SUM_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_SUM_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_SUM_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_SUM_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_SUM_ACCOUNT_STATEMENT_PDF_ID_ASC = 'UTILITY_METER_STATEMENTS_SUM_ACCOUNT_STATEMENT_PDF_ID_ASC',
  UTILITY_METER_STATEMENTS_SUM_ACCOUNT_STATEMENT_PDF_ID_DESC = 'UTILITY_METER_STATEMENTS_SUM_ACCOUNT_STATEMENT_PDF_ID_DESC',
  UTILITY_METER_STATEMENTS_SUM_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_SUM_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_SUM_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_SUM_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_SUM_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_SUM_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_SUM_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_SUM_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_SUM_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_SUM_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_SUM_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_SUM_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_SUM_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_SUM_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_SUM_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_SUM_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_SUM_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_SUM_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_SUM_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_SUM_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_SUM_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_SUM_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_SUM_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_SUM_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_SUM_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_SUM_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_SUM_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_SUM_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_SUM_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_SUM_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_SUM_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_SUM_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_SUM_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_SUM_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_SUM_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_SUM_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_SUM_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_SUM_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_SUM_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_SUM_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_SUM_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_SUM_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_SUM_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_SUM_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_SUM_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_SUM_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_SUM_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_SUM_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_SUM_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_SUM_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_SUM_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_SUM_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_SUM_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_SUM_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_SUM_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_SUM_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_SUM_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_SUM_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_SUM_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_SUM_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_SUM_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_SUM_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_SUM_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_SUM_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_SUM_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_SUM_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_SUM_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_SUM_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_SUM_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_SUM_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_SUM_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_SUM_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_SUM_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_SUM_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_SUM_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_SUM_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_PDF_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_PDF_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_PDF_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_PDF_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_PDF_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_PDF_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_PDF_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_PDF_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_DEMAND_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_DEMAND_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_DEMAND_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_DEMAND_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_DEMAND_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_DEMAND_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_DEMAND_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_DEMAND_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_EXPORT_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_EXPORT_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_EXPORT_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_EXPORT_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_IMPORT_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_IMPORT_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_IMPORT_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_IMPORT_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_USAGE_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_USAGE_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_USAGE_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_USAGE_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BLENDED_RATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BLENDED_RATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BLENDED_RATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BLENDED_RATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_CREDITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_CREDITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_CREDITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_CREDITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_END_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_END_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_END_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_END_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_FEES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_FEES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_FEES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_FEES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_LOAD_FACTOR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_LOAD_FACTOR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_LOAD_FACTOR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_LOAD_FACTOR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_NET_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_NET_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_NET_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_NET_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_PERCENT_CHANGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_PERCENT_CHANGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_PERCENT_CHANGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_PERCENT_CHANGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_PROVIDER_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_PROVIDER_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_PROVIDER_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_PROVIDER_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_START_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_START_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_START_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_START_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_TAXES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_TAXES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_TAXES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_TAXES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_COUNT_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_COUNT_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_COUNT_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_COUNT_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_DEMAND_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_DEMAND_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_DEMAND_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_DEMAND_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_DEMAND_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_DEMAND_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_DEMAND_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_DEMAND_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_EXPORT_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_EXPORT_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_EXPORT_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_EXPORT_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_IMPORT_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_IMPORT_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_IMPORT_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_IMPORT_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_USAGE_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_USAGE_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_USAGE_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_USAGE_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BLENDED_RATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BLENDED_RATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BLENDED_RATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BLENDED_RATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_DEMAND_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_DEMAND_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_DEMAND_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_DEMAND_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_DEMAND_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_DEMAND_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_DEMAND_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_DEMAND_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_EXPORT_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_EXPORT_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_EXPORT_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_EXPORT_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_IMPORT_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_IMPORT_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_IMPORT_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_IMPORT_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_USAGE_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_USAGE_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_USAGE_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_USAGE_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BLENDED_RATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BLENDED_RATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BLENDED_RATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BLENDED_RATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_CREDITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_CREDITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_CREDITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_CREDITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_END_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_END_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_END_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_END_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_FEES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_FEES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_FEES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_FEES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_LOAD_FACTOR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_LOAD_FACTOR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_LOAD_FACTOR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_LOAD_FACTOR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_NET_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_NET_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_NET_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_NET_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_PERCENT_CHANGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_PERCENT_CHANGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_PERCENT_CHANGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_PERCENT_CHANGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_PROVIDER_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_PROVIDER_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_PROVIDER_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_PROVIDER_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_START_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_START_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_START_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_START_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_TAXES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_TAXES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_TAXES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_TAXES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_CREDITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_CREDITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_CREDITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_CREDITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_END_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_END_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_END_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_END_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_FEES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_FEES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_FEES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_FEES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_LOAD_FACTOR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_LOAD_FACTOR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_LOAD_FACTOR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_LOAD_FACTOR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_NET_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_NET_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_NET_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_NET_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_PERCENT_CHANGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_PERCENT_CHANGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_PERCENT_CHANGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_PERCENT_CHANGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_PROVIDER_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_PROVIDER_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_PROVIDER_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_PROVIDER_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_START_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_START_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_START_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_START_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_TAXES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_TAXES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_TAXES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_TAXES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_DEMAND_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_DEMAND_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_DEMAND_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_DEMAND_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_DEMAND_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_DEMAND_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_DEMAND_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_DEMAND_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_EXPORT_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_EXPORT_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_EXPORT_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_EXPORT_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_IMPORT_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_IMPORT_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_IMPORT_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_IMPORT_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_USAGE_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_USAGE_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_USAGE_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_USAGE_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BLENDED_RATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BLENDED_RATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BLENDED_RATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BLENDED_RATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_CREDITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_CREDITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_CREDITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_CREDITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_END_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_END_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_END_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_END_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_FEES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_FEES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_FEES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_FEES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_LOAD_FACTOR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_LOAD_FACTOR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_LOAD_FACTOR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_LOAD_FACTOR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_NET_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_NET_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_NET_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_NET_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_PERCENT_CHANGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_PERCENT_CHANGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_PERCENT_CHANGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_PERCENT_CHANGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_PROVIDER_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_PROVIDER_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_PROVIDER_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_PROVIDER_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_START_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_START_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_START_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_START_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_TAXES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_TAXES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_TAXES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_TAXES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_DEMAND_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_DEMAND_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_DEMAND_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_DEMAND_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_DEMAND_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_DEMAND_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_DEMAND_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_DEMAND_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_EXPORT_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_EXPORT_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_EXPORT_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_EXPORT_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_IMPORT_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_IMPORT_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_IMPORT_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_IMPORT_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_USAGE_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_USAGE_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_USAGE_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_USAGE_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BLENDED_RATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BLENDED_RATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BLENDED_RATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BLENDED_RATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_CREDITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_CREDITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_CREDITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_CREDITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_END_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_END_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_END_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_END_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_FEES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_FEES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_FEES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_FEES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_LOAD_FACTOR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_LOAD_FACTOR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_LOAD_FACTOR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_LOAD_FACTOR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_NET_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_NET_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_NET_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_NET_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_PERCENT_CHANGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_PERCENT_CHANGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_PERCENT_CHANGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_PERCENT_CHANGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_PROVIDER_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_PROVIDER_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_PROVIDER_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_PROVIDER_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_START_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_START_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_START_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_START_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_TAXES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_TAXES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_TAXES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_TAXES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_DEMAND_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_DEMAND_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_DEMAND_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_DEMAND_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_DEMAND_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_DEMAND_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_DEMAND_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_DEMAND_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_EXPORT_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_EXPORT_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_EXPORT_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_EXPORT_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_IMPORT_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_IMPORT_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_IMPORT_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_IMPORT_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_USAGE_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_USAGE_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_USAGE_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_USAGE_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BLENDED_RATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BLENDED_RATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BLENDED_RATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BLENDED_RATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_CREDITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_CREDITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_CREDITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_CREDITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_END_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_END_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_END_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_END_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_FEES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_FEES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_FEES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_FEES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_LOAD_FACTOR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_LOAD_FACTOR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_LOAD_FACTOR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_LOAD_FACTOR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_NET_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_NET_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_NET_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_NET_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_PERCENT_CHANGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_PERCENT_CHANGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_PERCENT_CHANGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_PERCENT_CHANGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_PROVIDER_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_PROVIDER_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_PROVIDER_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_PROVIDER_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_START_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_START_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_START_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_START_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_TAXES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_TAXES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_TAXES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_TAXES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_DEMAND_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_DEMAND_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_DEMAND_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_DEMAND_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_DEMAND_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_DEMAND_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_DEMAND_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_DEMAND_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_EXPORT_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_EXPORT_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_EXPORT_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_EXPORT_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_IMPORT_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_IMPORT_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_IMPORT_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_IMPORT_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_USAGE_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_USAGE_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_USAGE_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_USAGE_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BLENDED_RATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BLENDED_RATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BLENDED_RATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BLENDED_RATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CREDITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CREDITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CREDITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CREDITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_END_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_END_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_END_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_END_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_FEES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_FEES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_FEES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_FEES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_LOAD_FACTOR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_LOAD_FACTOR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_LOAD_FACTOR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_LOAD_FACTOR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_NET_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_NET_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_NET_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_NET_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PERCENT_CHANGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PERCENT_CHANGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PERCENT_CHANGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PERCENT_CHANGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PROVIDER_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PROVIDER_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PROVIDER_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PROVIDER_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_START_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_START_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_START_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_START_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_TAXES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_TAXES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_TAXES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_TAXES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_DEMAND_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_DEMAND_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_DEMAND_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_DEMAND_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_DEMAND_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_DEMAND_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_DEMAND_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_DEMAND_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_EXPORT_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_EXPORT_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_EXPORT_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_EXPORT_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_IMPORT_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_IMPORT_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_IMPORT_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_IMPORT_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_USAGE_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_USAGE_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_USAGE_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_USAGE_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BLENDED_RATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BLENDED_RATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BLENDED_RATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BLENDED_RATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_CREDITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_CREDITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_CREDITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_CREDITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_END_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_END_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_END_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_END_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_FEES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_FEES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_FEES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_FEES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_LOAD_FACTOR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_LOAD_FACTOR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_LOAD_FACTOR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_LOAD_FACTOR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_NET_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_NET_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_NET_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_NET_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_PERCENT_CHANGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_PERCENT_CHANGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_PERCENT_CHANGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_PERCENT_CHANGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_PROVIDER_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_PROVIDER_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_PROVIDER_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_PROVIDER_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_START_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_START_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_START_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_START_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_TAXES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_TAXES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_TAXES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_TAXES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_DEMAND_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_DEMAND_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_DEMAND_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_DEMAND_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_DEMAND_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_DEMAND_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_DEMAND_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_DEMAND_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_EXPORT_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_EXPORT_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_EXPORT_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_EXPORT_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_IMPORT_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_IMPORT_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_IMPORT_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_IMPORT_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_USAGE_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_USAGE_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_USAGE_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_USAGE_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BLENDED_RATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BLENDED_RATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BLENDED_RATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BLENDED_RATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CREDITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CREDITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CREDITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CREDITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_END_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_END_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_END_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_END_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_FEES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_FEES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_FEES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_FEES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_LOAD_FACTOR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_LOAD_FACTOR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_LOAD_FACTOR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_LOAD_FACTOR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_NET_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_NET_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_NET_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_NET_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PERCENT_CHANGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PERCENT_CHANGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PERCENT_CHANGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PERCENT_CHANGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PROVIDER_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PROVIDER_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PROVIDER_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PROVIDER_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_START_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_START_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_START_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_START_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_TAXES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_TAXES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_TAXES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_TAXES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_DEMAND_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_DEMAND_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_DEMAND_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_DEMAND_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_DEMAND_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_DEMAND_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_DEMAND_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_DEMAND_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_EXPORT_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_EXPORT_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_EXPORT_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_EXPORT_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_IMPORT_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_IMPORT_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_IMPORT_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_IMPORT_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_USAGE_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_USAGE_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_USAGE_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_USAGE_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BLENDED_RATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BLENDED_RATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BLENDED_RATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BLENDED_RATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CREDITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CREDITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CREDITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CREDITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_END_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_END_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_END_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_END_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_FEES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_FEES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_FEES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_FEES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_LOAD_FACTOR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_LOAD_FACTOR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_LOAD_FACTOR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_LOAD_FACTOR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_NET_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_NET_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_NET_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_NET_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PERCENT_CHANGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PERCENT_CHANGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PERCENT_CHANGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PERCENT_CHANGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PROVIDER_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PROVIDER_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PROVIDER_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PROVIDER_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_START_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_START_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_START_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_START_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_TAXES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_TAXES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_TAXES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_TAXES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_UTILITY_METER_ID_DESC',
  WMS_ASC = 'WMS_ASC',
  WMS_DESC = 'WMS_DESC',
  ZIP_ASC = 'ZIP_ASC',
  ZIP_DESC = 'ZIP_DESC'
}

/** A connection to a list of `FacilitiesUtilityBillingOverallCoverageByStatementMonthRecord` values. */
export type FacilitiesUtilityBillingOverallCoverageByStatementMonthConnection =
  {
    __typename?: 'FacilitiesUtilityBillingOverallCoverageByStatementMonthConnection';
    /**
     * A list of edges which contains the
     * `FacilitiesUtilityBillingOverallCoverageByStatementMonthRecord` and cursor to
     * aid in pagination.
     */
    edges: Array<FacilitiesUtilityBillingOverallCoverageByStatementMonthEdge>;
    /** A list of `FacilitiesUtilityBillingOverallCoverageByStatementMonthRecord` objects. */
    nodes: Array<FacilitiesUtilityBillingOverallCoverageByStatementMonthRecord>;
    /** The count of *all* `FacilitiesUtilityBillingOverallCoverageByStatementMonthRecord` you could get from the connection. */
    totalCount: Scalars['Int']['output'];
  };

/** A `FacilitiesUtilityBillingOverallCoverageByStatementMonthRecord` edge in the connection. */
export type FacilitiesUtilityBillingOverallCoverageByStatementMonthEdge = {
  __typename?: 'FacilitiesUtilityBillingOverallCoverageByStatementMonthEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `FacilitiesUtilityBillingOverallCoverageByStatementMonthRecord` at the end of the edge. */
  node: FacilitiesUtilityBillingOverallCoverageByStatementMonthRecord;
};

/** The return type of our `utilityBillingOverallCoverageByStatementMonth` query. */
export type FacilitiesUtilityBillingOverallCoverageByStatementMonthRecord = {
  __typename?: 'FacilitiesUtilityBillingOverallCoverageByStatementMonthRecord';
  month?: Maybe<Scalars['Date']['output']>;
  numAnticipated?: Maybe<Scalars['Int']['output']>;
  numExpected?: Maybe<Scalars['Int']['output']>;
  numManualUpload?: Maybe<Scalars['Int']['output']>;
  numPresent?: Maybe<Scalars['Int']['output']>;
  numValidated?: Maybe<Scalars['Int']['output']>;
};

/** A filter to be used against `FacilitiesUtilityBillingOverallCoverageByStatementMonthRecord` object types. All fields are combined with a logical ‘and.’ */
export type FacilitiesUtilityBillingOverallCoverageByStatementMonthRecordFilter =
  {
    /** Checks for all expressions in this list. */
    and?: InputMaybe<
      Array<FacilitiesUtilityBillingOverallCoverageByStatementMonthRecordFilter>
    >;
    /** Filter by the object’s `month` field. */
    month?: InputMaybe<DateFilter>;
    /** Negates the expression. */
    not?: InputMaybe<FacilitiesUtilityBillingOverallCoverageByStatementMonthRecordFilter>;
    /** Filter by the object’s `numAnticipated` field. */
    numAnticipated?: InputMaybe<IntFilter>;
    /** Filter by the object’s `numExpected` field. */
    numExpected?: InputMaybe<IntFilter>;
    /** Filter by the object’s `numManualUpload` field. */
    numManualUpload?: InputMaybe<IntFilter>;
    /** Filter by the object’s `numPresent` field. */
    numPresent?: InputMaybe<IntFilter>;
    /** Filter by the object’s `numValidated` field. */
    numValidated?: InputMaybe<IntFilter>;
    /** Checks for any expressions in this list. */
    or?: InputMaybe<
      Array<FacilitiesUtilityBillingOverallCoverageByStatementMonthRecordFilter>
    >;
  };

/** A connection to a list of `FacilitiesUtilityBillingOverallCoverageRecord` values. */
export type FacilitiesUtilityBillingOverallCoverageConnection = {
  __typename?: 'FacilitiesUtilityBillingOverallCoverageConnection';
  /** A list of edges which contains the `FacilitiesUtilityBillingOverallCoverageRecord` and cursor to aid in pagination. */
  edges: Array<FacilitiesUtilityBillingOverallCoverageEdge>;
  /** A list of `FacilitiesUtilityBillingOverallCoverageRecord` objects. */
  nodes: Array<FacilitiesUtilityBillingOverallCoverageRecord>;
  /** The count of *all* `FacilitiesUtilityBillingOverallCoverageRecord` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `FacilitiesUtilityBillingOverallCoverageRecord` edge in the connection. */
export type FacilitiesUtilityBillingOverallCoverageEdge = {
  __typename?: 'FacilitiesUtilityBillingOverallCoverageEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `FacilitiesUtilityBillingOverallCoverageRecord` at the end of the edge. */
  node: FacilitiesUtilityBillingOverallCoverageRecord;
};

/** The return type of our `utilityBillingOverallCoverage` query. */
export type FacilitiesUtilityBillingOverallCoverageRecord = {
  __typename?: 'FacilitiesUtilityBillingOverallCoverageRecord';
  day?: Maybe<Scalars['Date']['output']>;
  numAnticipated?: Maybe<Scalars['Int']['output']>;
  numExpected?: Maybe<Scalars['Int']['output']>;
  numManualUpload?: Maybe<Scalars['Int']['output']>;
  numPresent?: Maybe<Scalars['Int']['output']>;
  numValidated?: Maybe<Scalars['Int']['output']>;
};

/** A filter to be used against `FacilitiesUtilityBillingOverallCoverageRecord` object types. All fields are combined with a logical ‘and.’ */
export type FacilitiesUtilityBillingOverallCoverageRecordFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FacilitiesUtilityBillingOverallCoverageRecordFilter>>;
  /** Filter by the object’s `day` field. */
  day?: InputMaybe<DateFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FacilitiesUtilityBillingOverallCoverageRecordFilter>;
  /** Filter by the object’s `numAnticipated` field. */
  numAnticipated?: InputMaybe<IntFilter>;
  /** Filter by the object’s `numExpected` field. */
  numExpected?: InputMaybe<IntFilter>;
  /** Filter by the object’s `numManualUpload` field. */
  numManualUpload?: InputMaybe<IntFilter>;
  /** Filter by the object’s `numPresent` field. */
  numPresent?: InputMaybe<IntFilter>;
  /** Filter by the object’s `numValidated` field. */
  numValidated?: InputMaybe<IntFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FacilitiesUtilityBillingOverallCoverageRecordFilter>>;
};

/** A connection to a list of `FacilitiesUtilityMonthlyBillingOverallCoverageRecord` values. */
export type FacilitiesUtilityMonthlyBillingOverallCoverageConnection = {
  __typename?: 'FacilitiesUtilityMonthlyBillingOverallCoverageConnection';
  /** A list of edges which contains the `FacilitiesUtilityMonthlyBillingOverallCoverageRecord` and cursor to aid in pagination. */
  edges: Array<FacilitiesUtilityMonthlyBillingOverallCoverageEdge>;
  /** A list of `FacilitiesUtilityMonthlyBillingOverallCoverageRecord` objects. */
  nodes: Array<FacilitiesUtilityMonthlyBillingOverallCoverageRecord>;
  /** The count of *all* `FacilitiesUtilityMonthlyBillingOverallCoverageRecord` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `FacilitiesUtilityMonthlyBillingOverallCoverageRecord` edge in the connection. */
export type FacilitiesUtilityMonthlyBillingOverallCoverageEdge = {
  __typename?: 'FacilitiesUtilityMonthlyBillingOverallCoverageEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `FacilitiesUtilityMonthlyBillingOverallCoverageRecord` at the end of the edge. */
  node: FacilitiesUtilityMonthlyBillingOverallCoverageRecord;
};

/** The return type of our `utilityMonthlyBillingOverallCoverage` query. */
export type FacilitiesUtilityMonthlyBillingOverallCoverageRecord = {
  __typename?: 'FacilitiesUtilityMonthlyBillingOverallCoverageRecord';
  month?: Maybe<Scalars['Date']['output']>;
  numAnticipated?: Maybe<Scalars['Int']['output']>;
  numExpected?: Maybe<Scalars['Int']['output']>;
  numManualUpload?: Maybe<Scalars['Int']['output']>;
  numPresent?: Maybe<Scalars['Int']['output']>;
  numValidated?: Maybe<Scalars['Int']['output']>;
  percentPresent?: Maybe<Scalars['Float']['output']>;
};

/** A filter to be used against `FacilitiesUtilityMonthlyBillingOverallCoverageRecord` object types. All fields are combined with a logical ‘and.’ */
export type FacilitiesUtilityMonthlyBillingOverallCoverageRecordFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<
    Array<FacilitiesUtilityMonthlyBillingOverallCoverageRecordFilter>
  >;
  /** Filter by the object’s `month` field. */
  month?: InputMaybe<DateFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FacilitiesUtilityMonthlyBillingOverallCoverageRecordFilter>;
  /** Filter by the object’s `numAnticipated` field. */
  numAnticipated?: InputMaybe<IntFilter>;
  /** Filter by the object’s `numExpected` field. */
  numExpected?: InputMaybe<IntFilter>;
  /** Filter by the object’s `numManualUpload` field. */
  numManualUpload?: InputMaybe<IntFilter>;
  /** Filter by the object’s `numPresent` field. */
  numPresent?: InputMaybe<IntFilter>;
  /** Filter by the object’s `numValidated` field. */
  numValidated?: InputMaybe<IntFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<
    Array<FacilitiesUtilityMonthlyBillingOverallCoverageRecordFilter>
  >;
  /** Filter by the object’s `percentPresent` field. */
  percentPresent?: InputMaybe<FloatFilter>;
};

/** A facility. */
export type Facility = Asset &
  Node & {
    __typename?: 'Facility';
    /** Reads and enables pagination through a set of `AccountStatement`. */
    accountStatements: AccountStatementsConnection;
    /** Returns the active communication for the facility, if one exists. */
    activeCommunication?: Maybe<FacilityCommunication>;
    /** The number of days we have active utility meters for a given serive type and time range. */
    activeMeterDatesCount?: Maybe<Scalars['Int']['output']>;
    /** Returns a rollup of account statements for a given facility where there are active meter_statements. */
    activeUtilityAccountStatementRollups: UtilityAccountStatementRollupsConnection;
    /** Returns a summary of account statements for a given facility where there are active meter_statements. */
    activeUtilityAccountStatements: UtilityAccountStatementsConnection;
    /** The facility’s street address. */
    address?: Maybe<Scalars['String']['output']>;
    /** Reads and enables pagination through a set of `BlastRotation`. */
    blastRotations: BlastRotationsConnection;
    /** Reads and enables pagination through a set of `Blast`. */
    blasts: BlastsConnection;
    /** Bonus LTR */
    bonusLtr: Scalars['Boolean']['output'];
    /** Reads and enables pagination through a set of `BuildingArea`. */
    buildingAreas: BuildingAreasConnection;
    /** Reads and enables pagination through a set of `Chart`. */
    charts: ChartsConnection;
    /** Reads and enables pagination through a set of `CheckMonitor`. */
    checkMonitors: CheckMonitorsConnection;
    /** The facility’s city. */
    city?: Maybe<Scalars['String']['output']>;
    /** Type of Commodity */
    commodity?: Maybe<Scalars['String']['output']>;
    /** Reads and enables pagination through a set of `FacilityCommunication`. */
    communications: FacilityCommunicationsConnection;
    /** Reads and enables pagination through a set of `Component`. */
    components: ComponentsConnection;
    /** Reads and enables pagination through a set of `Compressor`. */
    compressor: CompressorsConnection;
    /** Serialized configuration for the facility */
    config?: Maybe<Scalars['JSON']['output']>;
    /** Reads and enables pagination through a set of `FacilityConfig`. */
    configs: FacilityConfigsConnection;
    /** CONTXT-9249 testing */
    contxt9249?: Maybe<Scalars['String']['output']>;
    /** Cost Center */
    costCenter?: Maybe<Scalars['String']['output']>;
    country: Country;
    /** The time this facility was created. */
    createdAt?: Maybe<Scalars['Datetime']['output']>;
    /** Customer Location ID  */
    customerLocationId?: Maybe<Scalars['Int']['output']>;
    /** Reads and enables pagination through a set of `Customer`. */
    customers: CustomersConnection;
    /** Reads and enables pagination through a set of `Dashboard`. */
    dashboards: DashboardsConnection;
    /** Reads and enables pagination through a set of `DataSource`. */
    dataSources: DataSourcesConnection;
    /** DataType2Test */
    dataType2Test?: Maybe<Scalars['Float']['output']>;
    /** dataType3Test */
    dataType3Test?: Maybe<Scalars['Int']['output']>;
    /** Datatype1Test */
    datatype1Test?: Maybe<Scalars['Datetime']['output']>;
    /** The dayahead rate for the associated pricing node. */
    dayaheadRate?: Maybe<MetricDataConnection>;
    /** Returns the derived data point configuration for this connection */
    dayaheadRateDataPoint?: Maybe<DerivedDataPoint>;
    /** Reads and enables pagination through a set of `Door`. */
    door: DoorsConnection;
    /** Reads and enables pagination through a set of `ElectricalMeteringPoint`. */
    electricalMeteringPoints: ElectricalMeteringPointsConnection;
    /** Reads and enables pagination through a set of `ElectricalPanel`. */
    electricalPanels: ElectricalPanelsConnection;
    /** The average carbon emissions from all grid generators serving this facility at a given time. */
    emissionsAverageRate?: Maybe<MetricDataConnection>;
    /** Returns the derived data point configuration for this connection */
    emissionsAverageRateDataPoint?: Maybe<DerivedDataPoint>;
    /** The carbon emissions impact of an added or avoided unit of electricity at this facility's grid connection. */
    emissionsMarginalRate?: Maybe<MetricDataConnection>;
    /** Returns the derived data point configuration for this connection */
    emissionsMarginalRateDataPoint?: Maybe<DerivedDataPoint>;
    /** Reads and enables pagination through a set of `Evaporator`. */
    evaporator: EvaporatorsConnection;
    /** Reads and enables pagination through a set of `FacilityCheck`. */
    facilityChecks: FacilityChecksConnection;
    /** User contacts for facility */
    facilityContacts?: Maybe<Scalars['String']['output']>;
    /** Reads and enables pagination through a set of `FacilityDataSource`. */
    facilityDataSources: FacilityDataSourcesConnection;
    /** Reads and enables pagination through a set of `FacilityDocument`. */
    facilityDocuments: FacilityDocumentsConnection;
    /** Reads and enables pagination through a set of `FacilityGroup`. */
    facilityGroups: FacilityGroupsConnection;
    /** Reads and enables pagination through a set of `FacilityGroupsLinker`. */
    facilityGroupsLinkers: FacilityGroupsLinkersConnection;
    /** Reads and enables pagination through a set of `FacilityUtilityAccount`. */
    facilityUtilityAccounts: FacilityUtilityAccountsConnection;
    /** The default floor plan document for the facility. */
    floorPlan?: Maybe<FacilityDocument>;
    /** The GIS geometry and metadata which specifies how the floor plan document should be displayed on a map. */
    floorPlanGeometry?: Maybe<GeometryMetadatum>;
    /** Reads and enables pagination through a set of `Gateway`. */
    gateways: GatewaysConnection;
    geometry?: Maybe<GeometryInterface>;
    /** Go-Live Date */
    goLiveDate?: Maybe<Scalars['Datetime']['output']>;
    /** The grid demand value for the associated balancing authority. */
    gridDemand?: Maybe<MetricDataConnection>;
    /** Returns the derived data point configuration for this connection */
    gridDemandDataPoint?: Maybe<DerivedDataPoint>;
    /** Returns true if the facility has a matching AMI demand field for every AMI usage field. */
    hasAMI?: Maybe<Scalars['Boolean']['output']>;
    /** Whether or not the facility has solar provisioned, either through utility meters or main services. */
    hasSolar?: Maybe<Scalars['Boolean']['output']>;
    /** The primary unique identifier for the facility. */
    id: Scalars['Int']['output'];
    /** Reads and enables pagination through a set of `InboundOutboundLoad`. */
    inboundOutboundLoads: InboundOutboundLoadsConnection;
    /** Facility Latitude */
    latitude?: Maybe<Scalars['Float']['output']>;
    /** Link Active */
    linkActive: Scalars['Boolean']['output'];
    /** Facility Longitude */
    longitude?: Maybe<Scalars['Float']['output']>;
    /** Reads and enables pagination through a set of `MainService`. */
    mainServices: MainServicesConnection;
    /** Aggregates a metric by label for the specified filter expression. */
    metricData?: Maybe<MetricDataConnection>;
    metricLabels: Array<MetricLabel>;
    /** metricsOne Active */
    metricsOneActive: Scalars['Boolean']['output'];
    /** Returns all monitors for the facility. */
    monitors: MonitorsConnection;
    mutableMetricData?: Maybe<MetricDataConnection>;
    /** Enabled in nSight. */
    nSight2Active: Scalars['Boolean']['output'];
    /** nSight Active */
    nSightActive: Scalars['Boolean']['output'];
    /** The facility’s name. */
    name: Scalars['String']['output'];
    /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
    nodeId: Scalars['ID']['output'];
    /** The note of Facility */
    note?: Maybe<Scalars['String']['output']>;
    /** Reads and enables pagination through a set of `Opportunity`. */
    opportunities: OpportunitiesConnection;
    /** Reads and enables pagination through a set of `PalletLocation`. */
    palletLocations: PalletLocationsConnection;
    /** Available permissions for the Facility. */
    permissions?: Maybe<FacilityPermissions>;
    /** Pre-Bonus EBITDA */
    preBonusEbitda: Scalars['Boolean']['output'];
    /** Reads a single `PricingNode` that is related to this `Facility`. */
    pricingNode?: Maybe<PricingNode>;
    /** The id of the pricing node the facility is associated with. */
    pricingNodeId?: Maybe<Scalars['Int']['output']>;
    /** Reads and enables pagination through a set of `Product`. */
    products: ProductsConnection;
    /** Reads and enables pagination through a set of `Project`. */
    projects: ProjectsConnection;
    /** Flag to use real-time data or just utility data */
    realTimeEnabled: Scalars['Boolean']['output'];
    /** The realtime rate for the associated pricing node. */
    realtimeRate?: Maybe<MetricDataConnection>;
    /** Returns the derived data point configuration for this connection */
    realtimeRateDataPoint?: Maybe<DerivedDataPoint>;
    /** same desc */
    refrigerationControlSystemVendor?: Maybe<Scalars['String']['output']>;
    /** Reads and enables pagination through a set of `RefrigerationSystem`. */
    refrigerationSystems: RefrigerationSystemsConnection;
    /** refrigeration control system vendor */
    refrigerationvendor?: Maybe<Scalars['String']['output']>;
    /** The time a facility was retired. This allows us to leave the facility enabled for nsight kpis when it was active, while hiding it after the facility was retired (sold / closed) */
    retiredAt?: Maybe<Scalars['Datetime']['output']>;
    /** The facility’s slug. */
    slug: Scalars['String']['output'];
    /** Returns the slugs of the software packages associated with the facility. */
    softwarePackageSlugs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /** Reads and enables pagination through a set of `FacilitySoftwarePackage`. */
    softwarePackages: FacilitySoftwarePackagesConnection;
    /** The facility’s state. */
    state?: Maybe<Scalars['String']['output']>;
    /** Reads and enables pagination through a set of `Submeter`. */
    submeters: SubmetersConnection;
    /** Suppresse Financials */
    suppresseFinancials: Scalars['Boolean']['output'];
    /** Reads and enables pagination through a set of `FacilityTaggedDataPoint`. */
    taggedDataPoints: FacilityTaggedDataPointsConnection;
    /** tatAttribute */
    tatAttribute?: Maybe<Scalars['String']['output']>;
    /** Reads and enables pagination through a set of `TemperatureSensor`. */
    temperatureSensor: TemperatureSensorsConnection;
    /** Reads a single `Timezone` that is related to this `Facility`. */
    timezone?: Maybe<Timezone>;
    /** The name of the timezone for the facility. */
    timezoneName?: Maybe<Scalars['String']['output']>;
    /** Reads and enables pagination through a set of `TrailerPosition`. */
    trailerPosition: TrailerPositionsConnection;
    /** Type of Facility (e.g. "Managed") */
    type?: Maybe<Scalars['String']['output']>;
    /** The unit grouping of the facility. */
    unitGroup?: Maybe<Scalars['String']['output']>;
    /**
     * The unit group of the facility.
     * @deprecated true
     */
    unitGroupByUnitGroup?: Maybe<UnitGroup>;
    /** Reads a single `UnitGroup` that is related to this `Facility`. */
    unitGroupItem?: Maybe<UnitGroup>;
    /** The time this facility was updated. */
    updatedAt?: Maybe<Scalars['Datetime']['output']>;
    /** Returns a rollup of account statements for a given facility. */
    utilityAccountStatementRollups: UtilityAccountStatementRollupsConnection;
    /** Returns a top level of account statements for a given facility. */
    utilityAccountStatements: UtilityAccountStatementsConnection;
    /** Returns a set of distinct utility accounts for a given facility. */
    utilityAccounts: UtilityAccountsConnection;
    /** Returns the currency used when ingesting utility bills */
    utilityBillCurrency?: Maybe<Scalars['String']['output']>;
    /** Returns a set of days and counts of a given facilitys consolidated meters, with optional service_type filter. */
    utilityBillingOverallCoverage: FacilitiesUtilityBillingOverallCoverageConnection;
    /**
     * Returns a set of days and counts of a given facilitys consolidated meters for a given year and optional service_type.
     * @deprecated true
     */
    utilityBillingOverallCoverageByStatementMonth: FacilitiesUtilityBillingOverallCoverageByStatementMonthConnection;
    /** Reads and enables pagination through a set of `UtilityCredentialFacility`. */
    utilityCredentialFacilities: UtilityCredentialFacilitiesConnection;
    /** The distinct service types for a facility's active utility meters. */
    utilityMeterServiceTypes?: Maybe<Array<Maybe<UtilityMeterServiceType>>>;
    /** Reads and enables pagination through a set of `UtilityMeterStatementRollup`. */
    utilityMeterStatementRollups: UtilityMeterStatementRollupsConnection;
    /** Reads and enables pagination through a set of `UtilityMeterStatement`. */
    utilityMeterStatements: UtilityMeterStatementsConnection;
    /** Reads and enables pagination through a set of `UtilityMeter`. */
    utilityMeters: UtilityMetersConnection;
    /** Returns a set of months and counts of a given facilitys consolidated meters for a given optional service_type. */
    utilityMonthlyBillingOverallCoverage: FacilitiesUtilityMonthlyBillingOverallCoverageConnection;
    /** Reads and enables pagination through a set of `UtilityPendingMeter`. */
    utilityPendingMeters: UtilityPendingMetersConnection;
    /** The hourly cloud cover reading for the associated location. */
    weatherCloudCover?: Maybe<MetricDataConnection>;
    /** Returns the derived data point configuration for this connection */
    weatherCloudCoverDataPoint?: Maybe<DerivedDataPoint>;
    /** The hourly outside dewpoint reading for the associated location. */
    weatherDewpoint?: Maybe<MetricDataConnection>;
    /** Returns the derived data point configuration for this connection */
    weatherDewpointDataPoint?: Maybe<DerivedDataPoint>;
    /** The hourly outside humidity reading for the associated location. */
    weatherHumidity?: Maybe<MetricDataConnection>;
    /** Returns the derived data point configuration for this connection */
    weatherHumidityDataPoint?: Maybe<DerivedDataPoint>;
    /** The hourly outside solar energy reading for the associated location. */
    weatherSolarEnergy?: Maybe<MetricDataConnection>;
    /** Returns the derived data point configuration for this connection */
    weatherSolarEnergyDataPoint?: Maybe<DerivedDataPoint>;
    /** The hourly outside solar radiation reading for the associated location. */
    weatherSolarRadiation?: Maybe<MetricDataConnection>;
    /** Returns the derived data point configuration for this connection */
    weatherSolarRadiationDataPoint?: Maybe<DerivedDataPoint>;
    /** The hourly outside temperature reading for the associated location. */
    weatherTemperature?: Maybe<MetricDataConnection>;
    /** Returns the derived data point configuration for this connection */
    weatherTemperatureDataPoint?: Maybe<DerivedDataPoint>;
    /** The hourly wet-bulb thermometer reading for the associated location. */
    weatherTemperatureWetBulb?: Maybe<MetricDataConnection>;
    /** Returns the derived data point configuration for this connection */
    weatherTemperatureWetBulbDataPoint?: Maybe<DerivedDataPoint>;
    /** The difference between the hourly wet-bulb and dry-bulb values. */
    weatherTemperatureWetBulbDepression?: Maybe<MetricDataConnection>;
    /** Returns the derived data point configuration for this connection */
    weatherTemperatureWetBulbDepressionDataPoint?: Maybe<DerivedDataPoint>;
    /** The hourly visibility reading for the associated location. */
    weatherVisibility?: Maybe<MetricDataConnection>;
    /** Returns the derived data point configuration for this connection */
    weatherVisibilityDataPoint?: Maybe<DerivedDataPoint>;
    /** Type of Warehouse Management System */
    wms?: Maybe<Scalars['String']['output']>;
    /** Reads a single `Yard` that is related to this `Facility`. */
    yard?: Maybe<Yard>;
    /** The facility’s zip code. */
    zip?: Maybe<Scalars['String']['output']>;
  };

/** A facility. */
export type FacilityAccountStatementsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<AccountStatementFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** A facility. */
export type FacilityActiveMeterDatesCountArgs = {
  from?: InputMaybe<Scalars['String']['input']>;
  meterServiceTypes?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
  to?: InputMaybe<Scalars['String']['input']>;
};

/** A facility. */
export type FacilityActiveUtilityAccountStatementRollupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<UtilityAccountStatementRollupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** A facility. */
export type FacilityActiveUtilityAccountStatementsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<UtilityAccountStatementFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** A facility. */
export type FacilityBlastRotationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<BlastRotationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BlastRotationsOrderBy>>;
};

/** A facility. */
export type FacilityBlastsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BlastCondition>;
  filter?: InputMaybe<BlastFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BlastsOrderBy>>;
};

/** A facility. */
export type FacilityBuildingAreasArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BuildingAreaCondition>;
  filter?: InputMaybe<BuildingAreaFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BuildingAreasOrderBy>>;
};

/** A facility. */
export type FacilityChartsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ChartCondition>;
  filter?: InputMaybe<ChartFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChartsOrderBy>>;
};

/** A facility. */
export type FacilityCheckMonitorsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CheckMonitorCondition>;
  filter?: InputMaybe<CheckMonitorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CheckMonitorsOrderBy>>;
};

/** A facility. */
export type FacilityCommunicationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FacilityCommunicationCondition>;
  filter?: InputMaybe<FacilityCommunicationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FacilityCommunicationsOrderBy>>;
};

/** A facility. */
export type FacilityComponentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ComponentCondition>;
  filter?: InputMaybe<ComponentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ComponentsOrderBy>>;
};

/** A facility. */
export type FacilityCompressorArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CompressorCondition>;
  filter?: InputMaybe<CompressorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CompressorsOrderBy>>;
};

/** A facility. */
export type FacilityConfigsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FacilityConfigCondition>;
  filter?: InputMaybe<FacilityConfigFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FacilityConfigsOrderBy>>;
};

/** A facility. */
export type FacilityCustomersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CustomerCondition>;
  filter?: InputMaybe<CustomerFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CustomersOrderBy>>;
};

/** A facility. */
export type FacilityDashboardsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DashboardCondition>;
  filter?: InputMaybe<DashboardFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DashboardsOrderBy>>;
};

/** A facility. */
export type FacilityDataSourcesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<DataSourceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** A facility. */
export type FacilityDayaheadRateArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A facility. */
export type FacilityDoorArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DoorCondition>;
  filter?: InputMaybe<DoorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DoorsOrderBy>>;
};

/** A facility. */
export type FacilityElectricalMeteringPointsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ElectricalMeteringPointCondition>;
  filter?: InputMaybe<ElectricalMeteringPointFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ElectricalMeteringPointsOrderBy>>;
};

/** A facility. */
export type FacilityElectricalPanelsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ElectricalPanelCondition>;
  filter?: InputMaybe<ElectricalPanelFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ElectricalPanelsOrderBy>>;
};

/** A facility. */
export type FacilityEmissionsAverageRateArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A facility. */
export type FacilityEmissionsMarginalRateArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A facility. */
export type FacilityEvaporatorArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EvaporatorCondition>;
  filter?: InputMaybe<EvaporatorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvaporatorsOrderBy>>;
};

/** A facility. */
export type FacilityFacilityChecksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FacilityCheckCondition>;
  filter?: InputMaybe<FacilityCheckFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FacilityChecksOrderBy>>;
};

/** A facility. */
export type FacilityFacilityDataSourcesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FacilityDataSourceCondition>;
  filter?: InputMaybe<FacilityDataSourceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FacilityDataSourcesOrderBy>>;
};

/** A facility. */
export type FacilityFacilityDocumentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FacilityDocumentCondition>;
  filter?: InputMaybe<FacilityDocumentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FacilityDocumentsOrderBy>>;
};

/** A facility. */
export type FacilityFacilityGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<FacilityGroupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** A facility. */
export type FacilityFacilityGroupsLinkersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FacilityGroupsLinkerCondition>;
  filter?: InputMaybe<FacilityGroupsLinkerFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FacilityGroupsLinkersOrderBy>>;
};

/** A facility. */
export type FacilityFacilityUtilityAccountsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FacilityUtilityAccountCondition>;
  filter?: InputMaybe<FacilityUtilityAccountFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FacilityUtilityAccountsOrderBy>>;
};

/** A facility. */
export type FacilityGatewaysArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GatewayCondition>;
  filter?: InputMaybe<GatewayFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GatewaysOrderBy>>;
};

/** A facility. */
export type FacilityGridDemandArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A facility. */
export type FacilityInboundOutboundLoadsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<InboundOutboundLoadCondition>;
  filter?: InputMaybe<InboundOutboundLoadFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InboundOutboundLoadsOrderBy>>;
};

/** A facility. */
export type FacilityMainServicesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MainServiceCondition>;
  filter?: InputMaybe<MainServiceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MainServicesOrderBy>>;
};

/** A facility. */
export type FacilityMetricDataArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: InputMaybe<MetricDataAggregationMethod>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A facility. */
export type FacilityMetricLabelsArgs = {
  mutableOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A facility. */
export type FacilityMonitorsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<MonitorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** A facility. */
export type FacilityMutableMetricDataArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  to?: InputMaybe<Scalars['String']['input']>;
};

/** A facility. */
export type FacilityOpportunitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OpportunityCondition>;
  filter?: InputMaybe<OpportunityFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OpportunitiesOrderBy>>;
};

/** A facility. */
export type FacilityPalletLocationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PalletLocationCondition>;
  filter?: InputMaybe<PalletLocationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PalletLocationsOrderBy>>;
};

/** A facility. */
export type FacilityProductsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProductCondition>;
  filter?: InputMaybe<ProductFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};

/** A facility. */
export type FacilityProjectsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProjectCondition>;
  filter?: InputMaybe<ProjectFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProjectsOrderBy>>;
};

/** A facility. */
export type FacilityRealtimeRateArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A facility. */
export type FacilityRefrigerationSystemsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RefrigerationSystemCondition>;
  filter?: InputMaybe<RefrigerationSystemFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RefrigerationSystemsOrderBy>>;
};

/** A facility. */
export type FacilitySoftwarePackageSlugsArgs = {
  enabledOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A facility. */
export type FacilitySoftwarePackagesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FacilitySoftwarePackageCondition>;
  filter?: InputMaybe<FacilitySoftwarePackageFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FacilitySoftwarePackagesOrderBy>>;
};

/** A facility. */
export type FacilitySubmetersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SubmeterCondition>;
  filter?: InputMaybe<SubmeterFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SubmetersOrderBy>>;
};

/** A facility. */
export type FacilityTaggedDataPointsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FacilityTaggedDataPointCondition>;
  filter?: InputMaybe<FacilityTaggedDataPointFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FacilityTaggedDataPointsOrderBy>>;
};

/** A facility. */
export type FacilityTemperatureSensorArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TemperatureSensorCondition>;
  filter?: InputMaybe<TemperatureSensorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TemperatureSensorsOrderBy>>;
};

/** A facility. */
export type FacilityTrailerPositionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TrailerPositionCondition>;
  filter?: InputMaybe<TrailerPositionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TrailerPositionsOrderBy>>;
};

/** A facility. */
export type FacilityUtilityAccountStatementRollupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<UtilityAccountStatementRollupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** A facility. */
export type FacilityUtilityAccountStatementsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<UtilityAccountStatementFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** A facility. */
export type FacilityUtilityAccountsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<UtilityAccountFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** A facility. */
export type FacilityUtilityBillingOverallCoverageArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<FacilitiesUtilityBillingOverallCoverageRecordFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  svcType?: InputMaybe<UtilityMeterServiceType>;
};

/** A facility. */
export type FacilityUtilityBillingOverallCoverageByStatementMonthArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<FacilitiesUtilityBillingOverallCoverageByStatementMonthRecordFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  svcType?: InputMaybe<UtilityMeterServiceType>;
};

/** A facility. */
export type FacilityUtilityCredentialFacilitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UtilityCredentialFacilityCondition>;
  filter?: InputMaybe<UtilityCredentialFacilityFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UtilityCredentialFacilitiesOrderBy>>;
};

/** A facility. */
export type FacilityUtilityMeterStatementRollupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UtilityMeterStatementRollupCondition>;
  filter?: InputMaybe<UtilityMeterStatementRollupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UtilityMeterStatementRollupsOrderBy>>;
};

/** A facility. */
export type FacilityUtilityMeterStatementsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UtilityMeterStatementCondition>;
  filter?: InputMaybe<UtilityMeterStatementFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UtilityMeterStatementsOrderBy>>;
};

/** A facility. */
export type FacilityUtilityMetersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UtilityMeterCondition>;
  filter?: InputMaybe<UtilityMeterFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UtilityMetersOrderBy>>;
};

/** A facility. */
export type FacilityUtilityMonthlyBillingOverallCoverageArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<FacilitiesUtilityMonthlyBillingOverallCoverageRecordFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  svcType?: InputMaybe<UtilityMeterServiceType>;
};

/** A facility. */
export type FacilityUtilityPendingMetersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UtilityPendingMeterCondition>;
  filter?: InputMaybe<UtilityPendingMeterFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UtilityPendingMetersOrderBy>>;
};

/** A facility. */
export type FacilityWeatherCloudCoverArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A facility. */
export type FacilityWeatherDewpointArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A facility. */
export type FacilityWeatherHumidityArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A facility. */
export type FacilityWeatherSolarEnergyArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A facility. */
export type FacilityWeatherSolarRadiationArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A facility. */
export type FacilityWeatherTemperatureArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A facility. */
export type FacilityWeatherTemperatureWetBulbArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A facility. */
export type FacilityWeatherTemperatureWetBulbDepressionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A facility. */
export type FacilityWeatherVisibilityArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

export type FacilityAggregates = {
  __typename?: 'FacilityAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<FacilityAverageAggregates>;
  /** Distinct aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinct?: Maybe<FacilityDistinctAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<FacilityDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<FacilityMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<FacilityMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<FacilityStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<FacilityStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<FacilitySumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<FacilityVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<FacilityVarianceSampleAggregates>;
};

export type FacilityAverageAggregates = {
  __typename?: 'FacilityAverageAggregates';
  /**
   * Mean average of this field across the matching connection.
   *
   * ---
   *
   * The number of days we have active utility meters for a given serive type and time range.
   */
  activeMeterDatesCount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of customerLocationId across the matching connection */
  customerLocationId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of dataType2Test across the matching connection */
  dataType2Test?: Maybe<Scalars['Float']['output']>;
  /** Mean average of dataType3Test across the matching connection */
  dataType3Test?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of latitude across the matching connection */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** Mean average of longitude across the matching connection */
  longitude?: Maybe<Scalars['Float']['output']>;
  /** Mean average of pricingNodeId across the matching connection */
  pricingNodeId?: Maybe<Scalars['BigFloat']['output']>;
};

export type FacilityAverageAggregatesActiveMeterDatesCountArgs = {
  from?: InputMaybe<Scalars['String']['input']>;
  meterServiceTypes?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
  to?: InputMaybe<Scalars['String']['input']>;
};

/** Ties a check to a facility. */
export type FacilityCheck = Node & {
  __typename?: 'FacilityCheck';
  /** Reads a single `Check` that is related to this `FacilityCheck`. */
  check?: Maybe<Check>;
  /** Returns the attributes associated with the related check. */
  checkAttributes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The check. */
  checkId: Scalars['Int']['output'];
  /** Returns the check monitors associated with this check. */
  checkMonitors: CheckMonitorsConnection;
  /** Returns the check slug associated with the facility check. */
  checkSlug?: Maybe<Scalars['String']['output']>;
  /** Indicates if incidents produced from the related check require a closure message before closing. */
  closureMessageRequired?: Maybe<Scalars['Boolean']['output']>;
  /** The time the record was created. */
  createdAt: Scalars['Datetime']['output'];
  /** Reads a single `Facility` that is related to this `FacilityCheck`. */
  facility?: Maybe<Facility>;
  /** The facility. */
  facilityId: Scalars['Int']['output'];
  /** The identifier of the facility check */
  id: Scalars['Int']['output'];
  /** Returns the incidents associated with a given facility check. */
  incidents: IncidentsConnection;
  /** Indicates if incidents can be produced from the related check. */
  incidentsEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The slug of the associated software package. */
  softwarePackageSlug?: Maybe<Scalars['String']['output']>;
  /** The time the record was updated. */
  updatedAt: Scalars['Datetime']['output'];
  /** Returns the users associated with a given facility check. */
  users: UsersConnection;
};

/** Ties a check to a facility. */
export type FacilityCheckCheckMonitorsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<CheckMonitorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Ties a check to a facility. */
export type FacilityCheckIncidentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<IncidentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Ties a check to a facility. */
export type FacilityCheckUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * A condition to be used against `FacilityCheck` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type FacilityCheckCondition = {
  /** Checks for equality with the object’s `checkId` field. */
  checkId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `checkSlug` field. */
  checkSlug?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `softwarePackageSlug` field. */
  softwarePackageSlug?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `FacilityCheck` object types. All fields are combined with a logical ‘and.’ */
export type FacilityCheckFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FacilityCheckFilter>>;
  /** Filter by the object’s `checkAttributes` field. */
  checkAttributes?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `checkId` field. */
  checkId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `checkSlug` field. */
  checkSlug?: InputMaybe<StringFilter>;
  /** Filter by the object’s `closureMessageRequired` field. */
  closureMessageRequired?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `incidentsEnabled` field. */
  incidentsEnabled?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FacilityCheckFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FacilityCheckFilter>>;
  /** Filter by the object’s `softwarePackageSlug` field. */
  softwarePackageSlug?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `FacilityCheck` */
export type FacilityCheckInput = {
  /** The check. */
  checkId: Scalars['Int']['input'];
  /** The facility. */
  facilityId: Scalars['Int']['input'];
};

/** Represents an update to a `FacilityCheck`. Fields that are set will be updated. */
export type FacilityCheckPatch = {
  /** The check. */
  checkId?: InputMaybe<Scalars['Int']['input']>;
  /** The facility. */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
};

/** Ties a user to a facility check. */
export type FacilityCheckUser = Node & {
  __typename?: 'FacilityCheckUser';
  /** The time the record was created. */
  createdAt: Scalars['Datetime']['output'];
  /** The facility check. */
  facilityCheckId: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The time the record was updated. */
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `FacilityCheckUser`. */
  user?: Maybe<User>;
  /** The user. */
  userId: Scalars['String']['output'];
};

/**
 * A condition to be used against `FacilityCheckUser` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type FacilityCheckUserCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `facilityCheckId` field. */
  facilityCheckId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `FacilityCheckUser` object types. All fields are combined with a logical ‘and.’ */
export type FacilityCheckUserFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FacilityCheckUserFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `facilityCheckId` field. */
  facilityCheckId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FacilityCheckUserFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FacilityCheckUserFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `FacilityCheckUser` */
export type FacilityCheckUserInput = {
  /** The facility check. */
  facilityCheckId: Scalars['Int']['input'];
  /** The user. */
  userId: Scalars['String']['input'];
};

/** A connection to a list of `FacilityCheckUser` values. */
export type FacilityCheckUsersConnection = {
  __typename?: 'FacilityCheckUsersConnection';
  /** A list of edges which contains the `FacilityCheckUser` and cursor to aid in pagination. */
  edges: Array<FacilityCheckUsersEdge>;
  /** A list of `FacilityCheckUser` objects. */
  nodes: Array<FacilityCheckUser>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FacilityCheckUser` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `FacilityCheckUser` edge in the connection. */
export type FacilityCheckUsersEdge = {
  __typename?: 'FacilityCheckUsersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `FacilityCheckUser` at the end of the edge. */
  node: FacilityCheckUser;
};

/** Methods to use when ordering `FacilityCheckUser`. */
export enum FacilityCheckUsersOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  FACILITY_CHECK_ID_ASC = 'FACILITY_CHECK_ID_ASC',
  FACILITY_CHECK_ID_DESC = 'FACILITY_CHECK_ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC'
}

/** A connection to a list of `FacilityCheck` values. */
export type FacilityChecksConnection = {
  __typename?: 'FacilityChecksConnection';
  /** A list of edges which contains the `FacilityCheck` and cursor to aid in pagination. */
  edges: Array<FacilityChecksEdge>;
  /** A list of `FacilityCheck` objects. */
  nodes: Array<FacilityCheck>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FacilityCheck` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `FacilityCheck` edge in the connection. */
export type FacilityChecksEdge = {
  __typename?: 'FacilityChecksEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `FacilityCheck` at the end of the edge. */
  node: FacilityCheck;
};

/** Methods to use when ordering `FacilityCheck`. */
export enum FacilityChecksOrderBy {
  CHECK_ID_ASC = 'CHECK_ID_ASC',
  CHECK_ID_DESC = 'CHECK_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** A communication associated with the facility. */
export type FacilityCommunication = Node & {
  __typename?: 'FacilityCommunication';
  /** The time the communication was cleared. */
  clearedAt?: Maybe<Scalars['Datetime']['output']>;
  /** The time the communication was created. */
  createdAt: Scalars['Datetime']['output'];
  /** Reads a single `Facility` that is related to this `FacilityCommunication`. */
  facility?: Maybe<Facility>;
  /** The associated facility. */
  facilityId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** Whether the communication is cleared or active. */
  isCleared?: Maybe<Scalars['Boolean']['output']>;
  /** The message. */
  message: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The time the communication was updated. */
  updatedAt: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `FacilityCommunication` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type FacilityCommunicationCondition = {
  /** Checks for equality with the object’s `clearedAt` field. */
  clearedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `message` field. */
  message?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `FacilityCommunication` object types. All fields are combined with a logical ‘and.’ */
export type FacilityCommunicationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FacilityCommunicationFilter>>;
  /** Filter by the object’s `clearedAt` field. */
  clearedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isCleared` field. */
  isCleared?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `message` field. */
  message?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FacilityCommunicationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FacilityCommunicationFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `FacilityCommunication` */
export type FacilityCommunicationInput = {
  /** The associated facility. */
  facilityId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  /** The message. */
  message: Scalars['String']['input'];
};

/** A connection to a list of `FacilityCommunication` values. */
export type FacilityCommunicationsConnection = {
  __typename?: 'FacilityCommunicationsConnection';
  /** A list of edges which contains the `FacilityCommunication` and cursor to aid in pagination. */
  edges: Array<FacilityCommunicationsEdge>;
  /** A list of `FacilityCommunication` objects. */
  nodes: Array<FacilityCommunication>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FacilityCommunication` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `FacilityCommunication` edge in the connection. */
export type FacilityCommunicationsEdge = {
  __typename?: 'FacilityCommunicationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `FacilityCommunication` at the end of the edge. */
  node: FacilityCommunication;
};

/** Methods to use when ordering `FacilityCommunication`. */
export enum FacilityCommunicationsOrderBy {
  CLEARED_AT_ASC = 'CLEARED_AT_ASC',
  CLEARED_AT_DESC = 'CLEARED_AT_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  MESSAGE_ASC = 'MESSAGE_ASC',
  MESSAGE_DESC = 'MESSAGE_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/**
 * A condition to be used against `Facility` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type FacilityCondition = {
  /** Checks for equality with the object’s `address` field. */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `bonusLtr` field. */
  bonusLtr?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `city` field. */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `commodity` field. */
  commodity?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `config` field. */
  config?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `contxt9249` field. */
  contxt9249?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `costCenter` field. */
  costCenter?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `country` field. */
  country?: InputMaybe<Country>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `customerLocationId` field. */
  customerLocationId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `dataType2Test` field. */
  dataType2Test?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `dataType3Test` field. */
  dataType3Test?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `datatype1Test` field. */
  datatype1Test?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `facilityContacts` field. */
  facilityContacts?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `floorPlanGeometry` field. */
  floorPlanGeometry?: InputMaybe<GeometryMetadatumInput>;
  /** Checks for equality with the object’s `geometry` field. */
  geometry?: InputMaybe<Scalars['GeoJSON']['input']>;
  /** Checks for equality with the object’s `goLiveDate` field. */
  goLiveDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `hasAMI` field. */
  hasAMI?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `hasSolar` field. */
  hasSolar?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `latitude` field. */
  latitude?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `linkActive` field. */
  linkActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `longitude` field. */
  longitude?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `metricsOneActive` field. */
  metricsOneActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `nSight2Active` field. */
  nSight2Active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `nSightActive` field. */
  nSightActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `note` field. */
  note?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `preBonusEbitda` field. */
  preBonusEbitda?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `pricingNodeId` field. */
  pricingNodeId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `realTimeEnabled` field. */
  realTimeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `refrigerationControlSystemVendor` field. */
  refrigerationControlSystemVendor?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `refrigerationvendor` field. */
  refrigerationvendor?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `retiredAt` field. */
  retiredAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `slug` field. */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `state` field. */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `suppresseFinancials` field. */
  suppresseFinancials?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `tatAttribute` field. */
  tatAttribute?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `timezoneName` field. */
  timezoneName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `unitGroup` field. */
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `wms` field. */
  wms?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `zip` field. */
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type FacilityConfig = Node & {
  __typename?: 'FacilityConfig';
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  /** Reads a single `Facility` that is related to this `FacilityConfig`. */
  facility?: Maybe<Facility>;
  facilityId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  key?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  value?: Maybe<Scalars['JSON']['output']>;
};

/**
 * A condition to be used against `FacilityConfig` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type FacilityConfigCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `key` field. */
  key?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['JSON']['input']>;
};

/** A filter to be used against `FacilityConfig` object types. All fields are combined with a logical ‘and.’ */
export type FacilityConfigFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FacilityConfigFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `key` field. */
  key?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FacilityConfigFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FacilityConfigFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<JsonFilter>;
};

/** A connection to a list of `FacilityConfig` values. */
export type FacilityConfigsConnection = {
  __typename?: 'FacilityConfigsConnection';
  /** A list of edges which contains the `FacilityConfig` and cursor to aid in pagination. */
  edges: Array<FacilityConfigsEdge>;
  /** A list of `FacilityConfig` objects. */
  nodes: Array<FacilityConfig>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FacilityConfig` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `FacilityConfig` edge in the connection. */
export type FacilityConfigsEdge = {
  __typename?: 'FacilityConfigsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `FacilityConfig` at the end of the edge. */
  node: FacilityConfig;
};

/** Methods to use when ordering `FacilityConfig`. */
export enum FacilityConfigsOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  KEY_ASC = 'KEY_ASC',
  KEY_DESC = 'KEY_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  VALUE_ASC = 'VALUE_ASC',
  VALUE_DESC = 'VALUE_DESC'
}

/** This maps facilities to one or more data sources. */
export type FacilityDataSource = Node & {
  __typename?: 'FacilityDataSource';
  /** Reads a single `DataSource` that is related to this `FacilityDataSource`. */
  dataSourceByDataSourceName?: Maybe<DataSource>;
  /** The data source for the facility. */
  dataSourceName: Scalars['String']['output'];
  /** Reads a single `Facility` that is related to this `FacilityDataSource`. */
  facility?: Maybe<Facility>;
  /** The facility id for the data source. */
  facilityId: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
};

/**
 * A condition to be used against `FacilityDataSource` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type FacilityDataSourceCondition = {
  /** Checks for equality with the object’s `dataSourceName` field. */
  dataSourceName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `FacilityDataSource` object types. All fields are combined with a logical ‘and.’ */
export type FacilityDataSourceFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FacilityDataSourceFilter>>;
  /** Filter by the object’s `dataSourceName` field. */
  dataSourceName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FacilityDataSourceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FacilityDataSourceFilter>>;
};

/** An input for mutations affecting `FacilityDataSource` */
export type FacilityDataSourceInput = {
  /** Mutates a `DataSource` as part of the payload */
  dataSource?: InputMaybe<DataSourceInput>;
  /** The data source for the facility. */
  dataSourceName?: InputMaybe<Scalars['String']['input']>;
  /** The facility id for the data source. */
  facilityId: Scalars['Int']['input'];
};

/** A connection to a list of `FacilityDataSource` values. */
export type FacilityDataSourcesConnection = {
  __typename?: 'FacilityDataSourcesConnection';
  /** A list of edges which contains the `FacilityDataSource` and cursor to aid in pagination. */
  edges: Array<FacilityDataSourcesEdge>;
  /** A list of `FacilityDataSource` objects. */
  nodes: Array<FacilityDataSource>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FacilityDataSource` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `FacilityDataSource` edge in the connection. */
export type FacilityDataSourcesEdge = {
  __typename?: 'FacilityDataSourcesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `FacilityDataSource` at the end of the edge. */
  node: FacilityDataSource;
};

/** Methods to use when ordering `FacilityDataSource`. */
export enum FacilityDataSourcesOrderBy {
  DATA_SOURCE_NAME_ASC = 'DATA_SOURCE_NAME_ASC',
  DATA_SOURCE_NAME_DESC = 'DATA_SOURCE_NAME_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

export type FacilityDistinctAggregates = {
  __typename?: 'FacilityDistinctAggregates';
  /**
   * Distinct of this field across the matching connection.
   *
   * ---
   *
   * Returns the active communication for the facility, if one exists.
   */
  activeCommunication?: Maybe<Scalars['JSON']['output']>;
  /**
   * Distinct of this field across the matching connection.
   *
   * ---
   *
   * The number of days we have active utility meters for a given serive type and time range.
   */
  activeMeterDatesCount?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Distinct of address across the matching connection */
  address?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Distinct of bonusLtr across the matching connection */
  bonusLtr?: Maybe<Scalars['JSON']['output']>;
  /** Distinct of city across the matching connection */
  city?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Distinct of commodity across the matching connection */
  commodity?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /**
   * Distinct of this field across the matching connection.
   *
   * ---
   *
   * Serialized configuration for the facility
   */
  config?: Maybe<Scalars['JSON']['output']>;
  /** Distinct of contxt9249 across the matching connection */
  contxt9249?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Distinct of costCenter across the matching connection */
  costCenter?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Distinct of country across the matching connection */
  country?: Maybe<Scalars['JSON']['output']>;
  /** Distinct of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['JSON']['output']>;
  /** Distinct of customerLocationId across the matching connection */
  customerLocationId?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Distinct of dataType2Test across the matching connection */
  dataType2Test?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Distinct of dataType3Test across the matching connection */
  dataType3Test?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Distinct of datatype1Test across the matching connection */
  datatype1Test?: Maybe<Scalars['JSON']['output']>;
  /** Distinct of facilityContacts across the matching connection */
  facilityContacts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /**
   * Distinct of this field across the matching connection.
   *
   * ---
   *
   * The default floor plan document for the facility.
   */
  floorPlan?: Maybe<Scalars['JSON']['output']>;
  /** Distinct of floorPlanGeometry across the matching connection */
  floorPlanGeometry?: Maybe<Scalars['JSON']['output']>;
  /** Distinct of geometry across the matching connection */
  geometry?: Maybe<Scalars['JSON']['output']>;
  /** Distinct of goLiveDate across the matching connection */
  goLiveDate?: Maybe<Scalars['JSON']['output']>;
  /**
   * Distinct of this field across the matching connection.
   *
   * ---
   *
   * Returns true if the facility has a matching AMI demand field for every AMI usage field.
   */
  hasAMI?: Maybe<Scalars['JSON']['output']>;
  /**
   * Distinct of this field across the matching connection.
   *
   * ---
   *
   * Whether or not the facility has solar provisioned, either through utility meters or main services.
   */
  hasSolar?: Maybe<Scalars['JSON']['output']>;
  /** Distinct of id across the matching connection */
  id?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Distinct of latitude across the matching connection */
  latitude?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Distinct of linkActive across the matching connection */
  linkActive?: Maybe<Scalars['JSON']['output']>;
  /** Distinct of longitude across the matching connection */
  longitude?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Distinct of metricsOneActive across the matching connection */
  metricsOneActive?: Maybe<Scalars['JSON']['output']>;
  /** Distinct of nSight2Active across the matching connection */
  nSight2Active?: Maybe<Scalars['JSON']['output']>;
  /** Distinct of nSightActive across the matching connection */
  nSightActive?: Maybe<Scalars['JSON']['output']>;
  /** Distinct of name across the matching connection */
  name?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Distinct of note across the matching connection */
  note?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Distinct of preBonusEbitda across the matching connection */
  preBonusEbitda?: Maybe<Scalars['JSON']['output']>;
  /** Distinct of pricingNodeId across the matching connection */
  pricingNodeId?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Distinct of realTimeEnabled across the matching connection */
  realTimeEnabled?: Maybe<Scalars['JSON']['output']>;
  /** Distinct of refrigerationControlSystemVendor across the matching connection */
  refrigerationControlSystemVendor?: Maybe<
    Array<Maybe<Scalars['String']['output']>>
  >;
  /** Distinct of refrigerationvendor across the matching connection */
  refrigerationvendor?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Distinct of retiredAt across the matching connection */
  retiredAt?: Maybe<Scalars['JSON']['output']>;
  /** Distinct of slug across the matching connection */
  slug?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /**
   * Distinct of this field across the matching connection.
   *
   * ---
   *
   * Returns the slugs of the software packages associated with the facility.
   */
  softwarePackageSlugs?: Maybe<Scalars['JSON']['output']>;
  /** Distinct of state across the matching connection */
  state?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Distinct of suppresseFinancials across the matching connection */
  suppresseFinancials?: Maybe<Scalars['JSON']['output']>;
  /** Distinct of tatAttribute across the matching connection */
  tatAttribute?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Distinct of timezoneName across the matching connection */
  timezoneName?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Distinct of type across the matching connection */
  type?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Distinct of unitGroup across the matching connection */
  unitGroup?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /**
   * Distinct of this field across the matching connection.
   *
   * ---
   *
   * The unit group of the facility.
   * @deprecated true
   */
  unitGroupByUnitGroup?: Maybe<Scalars['JSON']['output']>;
  /** Distinct of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['JSON']['output']>;
  /**
   * Distinct of this field across the matching connection.
   *
   * ---
   *
   * Returns the currency used when ingesting utility bills
   */
  utilityBillCurrency?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /**
   * Distinct of this field across the matching connection.
   *
   * ---
   *
   * The distinct service types for a facility's active utility meters.
   */
  utilityMeterServiceTypes?: Maybe<Scalars['JSON']['output']>;
  /** Distinct of wms across the matching connection */
  wms?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Distinct of zip across the matching connection */
  zip?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type FacilityDistinctAggregatesActiveMeterDatesCountArgs = {
  from?: InputMaybe<Scalars['String']['input']>;
  meterServiceTypes?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type FacilityDistinctAggregatesSoftwarePackageSlugsArgs = {
  enabledOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FacilityDistinctCountAggregates = {
  __typename?: 'FacilityDistinctCountAggregates';
  /**
   * Distinct count of this field across the matching connection.
   *
   * ---
   *
   * Returns the active communication for the facility, if one exists.
   */
  activeCommunication?: Maybe<Scalars['BigInt']['output']>;
  /**
   * Distinct count of this field across the matching connection.
   *
   * ---
   *
   * The number of days we have active utility meters for a given serive type and time range.
   */
  activeMeterDatesCount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of address across the matching connection */
  address?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of bonusLtr across the matching connection */
  bonusLtr?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of city across the matching connection */
  city?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of commodity across the matching connection */
  commodity?: Maybe<Scalars['BigInt']['output']>;
  /**
   * Distinct count of this field across the matching connection.
   *
   * ---
   *
   * Serialized configuration for the facility
   */
  config?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of contxt9249 across the matching connection */
  contxt9249?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of costCenter across the matching connection */
  costCenter?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of country across the matching connection */
  country?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of customerLocationId across the matching connection */
  customerLocationId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of dataType2Test across the matching connection */
  dataType2Test?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of dataType3Test across the matching connection */
  dataType3Test?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of datatype1Test across the matching connection */
  datatype1Test?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of facilityContacts across the matching connection */
  facilityContacts?: Maybe<Scalars['BigInt']['output']>;
  /**
   * Distinct count of this field across the matching connection.
   *
   * ---
   *
   * The default floor plan document for the facility.
   */
  floorPlan?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of floorPlanGeometry across the matching connection */
  floorPlanGeometry?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of geometry across the matching connection */
  geometry?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of goLiveDate across the matching connection */
  goLiveDate?: Maybe<Scalars['BigInt']['output']>;
  /**
   * Distinct count of this field across the matching connection.
   *
   * ---
   *
   * Returns true if the facility has a matching AMI demand field for every AMI usage field.
   */
  hasAMI?: Maybe<Scalars['BigInt']['output']>;
  /**
   * Distinct count of this field across the matching connection.
   *
   * ---
   *
   * Whether or not the facility has solar provisioned, either through utility meters or main services.
   */
  hasSolar?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of latitude across the matching connection */
  latitude?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of linkActive across the matching connection */
  linkActive?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of longitude across the matching connection */
  longitude?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of metricsOneActive across the matching connection */
  metricsOneActive?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of nSight2Active across the matching connection */
  nSight2Active?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of nSightActive across the matching connection */
  nSightActive?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of name across the matching connection */
  name?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of note across the matching connection */
  note?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of preBonusEbitda across the matching connection */
  preBonusEbitda?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of pricingNodeId across the matching connection */
  pricingNodeId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of realTimeEnabled across the matching connection */
  realTimeEnabled?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of refrigerationControlSystemVendor across the matching connection */
  refrigerationControlSystemVendor?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of refrigerationvendor across the matching connection */
  refrigerationvendor?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of retiredAt across the matching connection */
  retiredAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of slug across the matching connection */
  slug?: Maybe<Scalars['BigInt']['output']>;
  /**
   * Distinct count of this field across the matching connection.
   *
   * ---
   *
   * Returns the slugs of the software packages associated with the facility.
   */
  softwarePackageSlugs?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of state across the matching connection */
  state?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of suppresseFinancials across the matching connection */
  suppresseFinancials?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of tatAttribute across the matching connection */
  tatAttribute?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of timezoneName across the matching connection */
  timezoneName?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of type across the matching connection */
  type?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of unitGroup across the matching connection */
  unitGroup?: Maybe<Scalars['BigInt']['output']>;
  /**
   * Distinct count of this field across the matching connection.
   *
   * ---
   *
   * The unit group of the facility.
   * @deprecated true
   */
  unitGroupByUnitGroup?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
  /**
   * Distinct count of this field across the matching connection.
   *
   * ---
   *
   * Returns the currency used when ingesting utility bills
   */
  utilityBillCurrency?: Maybe<Scalars['BigInt']['output']>;
  /**
   * Distinct count of this field across the matching connection.
   *
   * ---
   *
   * The distinct service types for a facility's active utility meters.
   */
  utilityMeterServiceTypes?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of wms across the matching connection */
  wms?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of zip across the matching connection */
  zip?: Maybe<Scalars['BigInt']['output']>;
};

export type FacilityDistinctCountAggregatesActiveMeterDatesCountArgs = {
  from?: InputMaybe<Scalars['String']['input']>;
  meterServiceTypes?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type FacilityDistinctCountAggregatesSoftwarePackageSlugsArgs = {
  enabledOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A facility document is a file associated with a specific facility. */
export type FacilityDocument = Node & {
  __typename?: 'FacilityDocument';
  /** The time at which the record was created */
  createdAt: Scalars['Datetime']['output'];
  /** The time when this record was deleted */
  deletedAt?: Maybe<Scalars['Datetime']['output']>;
  /** The description of the facility document. */
  description?: Maybe<Scalars['String']['output']>;
  /** The type of the facility document. */
  documentType: Scalars['String']['output'];
  /** Reads a single `Facility` that is related to this `FacilityDocument`. */
  facility?: Maybe<Facility>;
  /** The identifier of the facility associated with the document. */
  facilityId?: Maybe<Scalars['Int']['output']>;
  /** The file extension of the facility document. */
  fileExtension: Scalars['String']['output'];
  /** The identifier of the facility document. */
  id: Scalars['Int']['output'];
  /** Designates this document as the default for its facility and document type. */
  isDefault: Scalars['Boolean']['output'];
  /** The display name of the facility document. */
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The file path of the facility document. */
  path: Scalars['String']['output'];
  /** The relative path for the file. */
  serverPath: Scalars['String']['output'];
  /** Reads a single `SoftwarePackage` that is related to this `FacilityDocument`. */
  softwarePackage?: Maybe<SoftwarePackage>;
  /** The identifier of the software package associated with the document. */
  softwarePackageId?: Maybe<Scalars['Int']['output']>;
  /** The time at which the record was last updated */
  updatedAt: Scalars['Datetime']['output'];
  /** The presigned URI for the file. */
  uri: Scalars['String']['output'];
};

/**
 * A condition to be used against `FacilityDocument` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type FacilityDocumentCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `documentType` field. */
  documentType?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `fileExtension` field. */
  fileExtension?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `isDefault` field. */
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `path` field. */
  path?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `softwarePackageId` field. */
  softwarePackageId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `FacilityDocument` object types. All fields are combined with a logical ‘and.’ */
export type FacilityDocumentFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FacilityDocumentFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `documentType` field. */
  documentType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `fileExtension` field. */
  fileExtension?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isDefault` field. */
  isDefault?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FacilityDocumentFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FacilityDocumentFilter>>;
  /** Filter by the object’s `path` field. */
  path?: InputMaybe<StringFilter>;
  /** Filter by the object’s `softwarePackageId` field. */
  softwarePackageId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `FacilityDocument` */
export type FacilityDocumentInput = {
  /** The description of the facility document. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The type of the facility document. */
  documentType: Scalars['String']['input'];
  /** The identifier of the facility associated with the document. */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** The file extension of the facility document. */
  fileExtension: Scalars['String']['input'];
  /** Designates this document as the default for its facility and document type. */
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** The display name of the facility document. */
  name: Scalars['String']['input'];
  /** The file path of the facility document. */
  path?: InputMaybe<Scalars['Upload']['input']>;
  /** The identifier of the software package associated with the document. */
  softwarePackageId?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents an update to a `FacilityDocument`. Fields that are set will be updated. */
export type FacilityDocumentPatch = {
  /** The description of the facility document. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Designates this document as the default for its facility and document type. */
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A connection to a list of `FacilityDocument` values. */
export type FacilityDocumentsConnection = {
  __typename?: 'FacilityDocumentsConnection';
  /** A list of edges which contains the `FacilityDocument` and cursor to aid in pagination. */
  edges: Array<FacilityDocumentsEdge>;
  /** A list of `FacilityDocument` objects. */
  nodes: Array<FacilityDocument>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FacilityDocument` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `FacilityDocument` edge in the connection. */
export type FacilityDocumentsEdge = {
  __typename?: 'FacilityDocumentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `FacilityDocument` at the end of the edge. */
  node: FacilityDocument;
};

/** Methods to use when ordering `FacilityDocument`. */
export enum FacilityDocumentsOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DELETED_AT_ASC = 'DELETED_AT_ASC',
  DELETED_AT_DESC = 'DELETED_AT_DESC',
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  DOCUMENT_TYPE_ASC = 'DOCUMENT_TYPE_ASC',
  DOCUMENT_TYPE_DESC = 'DOCUMENT_TYPE_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  FILE_EXTENSION_ASC = 'FILE_EXTENSION_ASC',
  FILE_EXTENSION_DESC = 'FILE_EXTENSION_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  IS_DEFAULT_ASC = 'IS_DEFAULT_ASC',
  IS_DEFAULT_DESC = 'IS_DEFAULT_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PATH_ASC = 'PATH_ASC',
  PATH_DESC = 'PATH_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  SOFTWARE_PACKAGE_ID_ASC = 'SOFTWARE_PACKAGE_ID_ASC',
  SOFTWARE_PACKAGE_ID_DESC = 'SOFTWARE_PACKAGE_ID_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** A filter to be used against `Facility` object types. All fields are combined with a logical ‘and.’ */
export type FacilityFilter = {
  /** Filter by the object’s `address` field. */
  address?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FacilityFilter>>;
  /** Filter by the object’s `bonusLtr` field. */
  bonusLtr?: InputMaybe<BooleanFilter>;
  /** Filter by the permission can_admin */
  canAdmin?: InputMaybe<PermissionBooleanFilter>;
  /** Filter by the object’s `city` field. */
  city?: InputMaybe<StringFilter>;
  /** Filter by the object’s `commodity` field. */
  commodity?: InputMaybe<StringFilter>;
  /** Filter by the object’s `config` field. */
  config?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `contxt9249` field. */
  contxt9249?: InputMaybe<StringFilter>;
  /** Filter by the object’s `costCenter` field. */
  costCenter?: InputMaybe<StringFilter>;
  /** Filter by the object’s `country` field. */
  country?: InputMaybe<CountryFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `customerLocationId` field. */
  customerLocationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `dataType2Test` field. */
  dataType2Test?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `dataType3Test` field. */
  dataType3Test?: InputMaybe<IntFilter>;
  /** Filter by the object’s `datatype1Test` field. */
  datatype1Test?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `facilityContacts` field. */
  facilityContacts?: InputMaybe<StringFilter>;
  /** Filter by the object’s `floorPlanGeometry` field. */
  floorPlanGeometry?: InputMaybe<GeometryMetadatumFilter>;
  /** Filter by the object’s `goLiveDate` field. */
  goLiveDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `hasAMI` field. */
  hasAMI?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `hasSolar` field. */
  hasSolar?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `latitude` field. */
  latitude?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `linkActive` field. */
  linkActive?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `longitude` field. */
  longitude?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `metricsOneActive` field. */
  metricsOneActive?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `nSight2Active` field. */
  nSight2Active?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `nSightActive` field. */
  nSightActive?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FacilityFilter>;
  /** Filter by the object’s `note` field. */
  note?: InputMaybe<StringFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FacilityFilter>>;
  /** Filter by the object’s `preBonusEbitda` field. */
  preBonusEbitda?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `pricingNodeId` field. */
  pricingNodeId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `realTimeEnabled` field. */
  realTimeEnabled?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `refrigerationControlSystemVendor` field. */
  refrigerationControlSystemVendor?: InputMaybe<StringFilter>;
  /** Filter by the object’s `refrigerationvendor` field. */
  refrigerationvendor?: InputMaybe<StringFilter>;
  /** Filter by the object’s `retiredAt` field. */
  retiredAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `slug` field. */
  slug?: InputMaybe<StringFilter>;
  /** Filter by the object’s `softwarePackageSlugs` field. */
  softwarePackageSlugs?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `state` field. */
  state?: InputMaybe<StringFilter>;
  /** Filter by the object’s `suppresseFinancials` field. */
  suppresseFinancials?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `tatAttribute` field. */
  tatAttribute?: InputMaybe<StringFilter>;
  /** Filter by the object’s `timezoneName` field. */
  timezoneName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<StringFilter>;
  /** Filter by the object’s `unitGroup` field. */
  unitGroup?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `utilityBillCurrency` field. */
  utilityBillCurrency?: InputMaybe<StringFilter>;
  /** Filter by the object’s `utilityMeterServiceTypes` field. */
  utilityMeterServiceTypes?: InputMaybe<UtilityMeterServiceTypeListFilter>;
  /** Filter by the object’s `wms` field. */
  wms?: InputMaybe<StringFilter>;
  /** Filter by the object’s `zip` field. */
  zip?: InputMaybe<StringFilter>;
};

/** A grouping of facilities. */
export type FacilityGroup = Node & {
  __typename?: 'FacilityGroup';
  /** Reads and enables pagination through a set of `Facility`. */
  allFacilities: FacilitiesConnection;
  /** Reads and enables pagination through a set of `FacilityGroup`. */
  childFacilityGroups: FacilityGroupsConnection;
  /** Reads and enables pagination through a set of `Facility`. */
  facilities: FacilitiesConnection;
  /** Reads and enables pagination through a set of `FacilityGroupsLinker`. */
  facilityGroupsLinkersByFacilityGroupingId: FacilityGroupsLinkersConnection;
  /** The facility group’s id. */
  id: Scalars['BigInt']['output'];
  /** The facility group’s name. */
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `FacilityGroup` that is related to this `FacilityGroup`. */
  parent?: Maybe<FacilityGroup>;
  /** The id of the facility group’s parent node. */
  parentId?: Maybe<Scalars['BigInt']['output']>;
};

/** A grouping of facilities. */
export type FacilityGroupAllFacilitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<FacilityFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** A grouping of facilities. */
export type FacilityGroupChildFacilityGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FacilityGroupCondition>;
  filter?: InputMaybe<FacilityGroupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FacilityGroupsOrderBy>>;
};

/** A grouping of facilities. */
export type FacilityGroupFacilitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<FacilityFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** A grouping of facilities. */
export type FacilityGroupFacilityGroupsLinkersByFacilityGroupingIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FacilityGroupsLinkerCondition>;
  filter?: InputMaybe<FacilityGroupsLinkerFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FacilityGroupsLinkersOrderBy>>;
};

/**
 * A condition to be used against `FacilityGroup` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type FacilityGroupCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `parentId` field. */
  parentId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A filter to be used against `FacilityGroup` object types. All fields are combined with a logical ‘and.’ */
export type FacilityGroupFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FacilityGroupFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FacilityGroupFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FacilityGroupFilter>>;
  /** Filter by the object’s `parentId` field. */
  parentId?: InputMaybe<BigIntFilter>;
};

/** An input for mutations affecting `FacilityGroup` */
export type FacilityGroupInput = {
  /** The facility group’s name. */
  name: Scalars['String']['input'];
  /** The id of the facility group’s parent node. */
  parentId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** Represents an update to a `FacilityGroup`. Fields that are set will be updated. */
export type FacilityGroupPatch = {
  /** The facility group’s name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The id of the facility group’s parent node. */
  parentId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A connection to a list of `FacilityGroup` values. */
export type FacilityGroupsConnection = {
  __typename?: 'FacilityGroupsConnection';
  /** A list of edges which contains the `FacilityGroup` and cursor to aid in pagination. */
  edges: Array<FacilityGroupsEdge>;
  /** A list of `FacilityGroup` objects. */
  nodes: Array<FacilityGroup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FacilityGroup` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `FacilityGroup` edge in the connection. */
export type FacilityGroupsEdge = {
  __typename?: 'FacilityGroupsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `FacilityGroup` at the end of the edge. */
  node: FacilityGroup;
};

export type FacilityGroupsLinker = Node & {
  __typename?: 'FacilityGroupsLinker';
  /** Reads a single `Facility` that is related to this `FacilityGroupsLinker`. */
  facility?: Maybe<Facility>;
  /** Reads a single `FacilityGroup` that is related to this `FacilityGroupsLinker`. */
  facilityGrouping?: Maybe<FacilityGroup>;
  facilityGroupingId: Scalars['BigInt']['output'];
  facilityId: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
};

/**
 * A condition to be used against `FacilityGroupsLinker` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type FacilityGroupsLinkerCondition = {
  /** Checks for equality with the object’s `facilityGroupingId` field. */
  facilityGroupingId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `FacilityGroupsLinker` object types. All fields are combined with a logical ‘and.’ */
export type FacilityGroupsLinkerFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FacilityGroupsLinkerFilter>>;
  /** Filter by the object’s `facilityGroupingId` field. */
  facilityGroupingId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FacilityGroupsLinkerFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FacilityGroupsLinkerFilter>>;
};

/** An input for mutations affecting `FacilityGroupsLinker` */
export type FacilityGroupsLinkerInput = {
  /** Mutates a `FacilityGroup` as part of the payload */
  facilityGroup?: InputMaybe<FacilityGroupInput>;
  facilityGroupingId?: InputMaybe<Scalars['BigInt']['input']>;
  facilityId: Scalars['Int']['input'];
};

/** Represents an update to a `FacilityGroupsLinker`. Fields that are set will be updated. */
export type FacilityGroupsLinkerPatch = {
  facilityGroupingId?: InputMaybe<Scalars['BigInt']['input']>;
  facilityId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `FacilityGroupsLinker` values. */
export type FacilityGroupsLinkersConnection = {
  __typename?: 'FacilityGroupsLinkersConnection';
  /** A list of edges which contains the `FacilityGroupsLinker` and cursor to aid in pagination. */
  edges: Array<FacilityGroupsLinkersEdge>;
  /** A list of `FacilityGroupsLinker` objects. */
  nodes: Array<FacilityGroupsLinker>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FacilityGroupsLinker` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `FacilityGroupsLinker` edge in the connection. */
export type FacilityGroupsLinkersEdge = {
  __typename?: 'FacilityGroupsLinkersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `FacilityGroupsLinker` at the end of the edge. */
  node: FacilityGroupsLinker;
};

/** Methods to use when ordering `FacilityGroupsLinker`. */
export enum FacilityGroupsLinkersOrderBy {
  FACILITY_GROUPING_ID_ASC = 'FACILITY_GROUPING_ID_ASC',
  FACILITY_GROUPING_ID_DESC = 'FACILITY_GROUPING_ID_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

/** Methods to use when ordering `FacilityGroup`. */
export enum FacilityGroupsOrderBy {
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PARENT_ID_ASC = 'PARENT_ID_ASC',
  PARENT_ID_DESC = 'PARENT_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

/** An input for mutations affecting `Facility` */
export type FacilityInput = {
  /** The facility’s street address. */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Bonus LTR */
  bonusLtr?: InputMaybe<Scalars['Boolean']['input']>;
  /** The facility’s city. */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Type of Commodity */
  commodity?: InputMaybe<Scalars['String']['input']>;
  /** CONTXT-9249 testing */
  contxt9249?: InputMaybe<Scalars['String']['input']>;
  /** Cost Center */
  costCenter?: InputMaybe<Scalars['String']['input']>;
  country: Country;
  /** The time this facility was created. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Customer Location ID  */
  customerLocationId?: InputMaybe<Scalars['Int']['input']>;
  /** DataType2Test */
  dataType2Test?: InputMaybe<Scalars['Float']['input']>;
  /** dataType3Test */
  dataType3Test?: InputMaybe<Scalars['Int']['input']>;
  /** Datatype1Test */
  datatype1Test?: InputMaybe<Scalars['Datetime']['input']>;
  /** User contacts for facility */
  facilityContacts?: InputMaybe<Scalars['String']['input']>;
  /** The GIS geometry and metadata which specifies how the floor plan document should be displayed on a map. */
  floorPlanGeometry?: InputMaybe<GeometryMetadatumInput>;
  geometry?: InputMaybe<Scalars['GeoJSON']['input']>;
  /** Go-Live Date */
  goLiveDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** The primary unique identifier for the facility. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Facility Latitude */
  latitude?: InputMaybe<Scalars['Float']['input']>;
  /** Link Active */
  linkActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Facility Longitude */
  longitude?: InputMaybe<Scalars['Float']['input']>;
  /** metricsOne Active */
  metricsOneActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enabled in nSight. */
  nSight2Active?: InputMaybe<Scalars['Boolean']['input']>;
  /** nSight Active */
  nSightActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** The facility’s name. */
  name: Scalars['String']['input'];
  /** The note of Facility */
  note?: InputMaybe<Scalars['String']['input']>;
  /** Pre-Bonus EBITDA */
  preBonusEbitda?: InputMaybe<Scalars['Boolean']['input']>;
  /** Mutates a `PricingNode` as part of the payload */
  pricingNode?: InputMaybe<PricingNodeInput>;
  /** The id of the pricing node the facility is associated with. */
  pricingNodeId?: InputMaybe<Scalars['Int']['input']>;
  /** Flag to use real-time data or just utility data */
  realTimeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** same desc */
  refrigerationControlSystemVendor?: InputMaybe<Scalars['String']['input']>;
  /** refrigeration control system vendor */
  refrigerationvendor?: InputMaybe<Scalars['String']['input']>;
  /** The time a facility was retired. This allows us to leave the facility enabled for nsight kpis when it was active, while hiding it after the facility was retired (sold / closed) */
  retiredAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** The facility’s slug. */
  slug: Scalars['String']['input'];
  /** The facility’s state. */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Suppresse Financials */
  suppresseFinancials?: InputMaybe<Scalars['Boolean']['input']>;
  /** tatAttribute */
  tatAttribute?: InputMaybe<Scalars['String']['input']>;
  /** The name of the timezone for the facility. */
  timezoneName?: InputMaybe<Scalars['String']['input']>;
  /** Type of Facility (e.g. "Managed") */
  type?: InputMaybe<Scalars['String']['input']>;
  /** The unit grouping of the facility. */
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  /** The time this facility was updated. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Type of Warehouse Management System */
  wms?: InputMaybe<Scalars['String']['input']>;
  /** The facility’s zip code. */
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type FacilityMaxAggregates = {
  __typename?: 'FacilityMaxAggregates';
  /**
   * Maximum of this field across the matching connection.
   *
   * ---
   *
   * The number of days we have active utility meters for a given serive type and time range.
   */
  activeMeterDatesCount?: Maybe<Scalars['Int']['output']>;
  /** Maximum of customerLocationId across the matching connection */
  customerLocationId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of dataType2Test across the matching connection */
  dataType2Test?: Maybe<Scalars['Float']['output']>;
  /** Maximum of dataType3Test across the matching connection */
  dataType3Test?: Maybe<Scalars['Int']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of latitude across the matching connection */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** Maximum of longitude across the matching connection */
  longitude?: Maybe<Scalars['Float']['output']>;
  /** Maximum of pricingNodeId across the matching connection */
  pricingNodeId?: Maybe<Scalars['Int']['output']>;
};

export type FacilityMaxAggregatesActiveMeterDatesCountArgs = {
  from?: InputMaybe<Scalars['String']['input']>;
  meterServiceTypes?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type FacilityMinAggregates = {
  __typename?: 'FacilityMinAggregates';
  /**
   * Minimum of this field across the matching connection.
   *
   * ---
   *
   * The number of days we have active utility meters for a given serive type and time range.
   */
  activeMeterDatesCount?: Maybe<Scalars['Int']['output']>;
  /** Minimum of customerLocationId across the matching connection */
  customerLocationId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of dataType2Test across the matching connection */
  dataType2Test?: Maybe<Scalars['Float']['output']>;
  /** Minimum of dataType3Test across the matching connection */
  dataType3Test?: Maybe<Scalars['Int']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of latitude across the matching connection */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** Minimum of longitude across the matching connection */
  longitude?: Maybe<Scalars['Float']['output']>;
  /** Minimum of pricingNodeId across the matching connection */
  pricingNodeId?: Maybe<Scalars['Int']['output']>;
};

export type FacilityMinAggregatesActiveMeterDatesCountArgs = {
  from?: InputMaybe<Scalars['String']['input']>;
  meterServiceTypes?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
  to?: InputMaybe<Scalars['String']['input']>;
};

/** Represents an update to a `Facility`. Fields that are set will be updated. */
export type FacilityPatch = {
  /** The facility’s street address. */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Bonus LTR */
  bonusLtr?: InputMaybe<Scalars['Boolean']['input']>;
  /** The facility’s city. */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Type of Commodity */
  commodity?: InputMaybe<Scalars['String']['input']>;
  /** CONTXT-9249 testing */
  contxt9249?: InputMaybe<Scalars['String']['input']>;
  /** Cost Center */
  costCenter?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Country>;
  /** The time this facility was created. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Customer Location ID  */
  customerLocationId?: InputMaybe<Scalars['Int']['input']>;
  /** DataType2Test */
  dataType2Test?: InputMaybe<Scalars['Float']['input']>;
  /** dataType3Test */
  dataType3Test?: InputMaybe<Scalars['Int']['input']>;
  /** Datatype1Test */
  datatype1Test?: InputMaybe<Scalars['Datetime']['input']>;
  /** User contacts for facility */
  facilityContacts?: InputMaybe<Scalars['String']['input']>;
  /** The GIS geometry and metadata which specifies how the floor plan document should be displayed on a map. */
  floorPlanGeometry?: InputMaybe<GeometryMetadatumInput>;
  geometry?: InputMaybe<Scalars['GeoJSON']['input']>;
  /** Go-Live Date */
  goLiveDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** The primary unique identifier for the facility. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Facility Latitude */
  latitude?: InputMaybe<Scalars['Float']['input']>;
  /** Link Active */
  linkActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Facility Longitude */
  longitude?: InputMaybe<Scalars['Float']['input']>;
  /** metricsOne Active */
  metricsOneActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enabled in nSight. */
  nSight2Active?: InputMaybe<Scalars['Boolean']['input']>;
  /** nSight Active */
  nSightActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** The facility’s name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The note of Facility */
  note?: InputMaybe<Scalars['String']['input']>;
  /** Pre-Bonus EBITDA */
  preBonusEbitda?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the pricing node the facility is associated with. */
  pricingNodeId?: InputMaybe<Scalars['Int']['input']>;
  /** Flag to use real-time data or just utility data */
  realTimeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** same desc */
  refrigerationControlSystemVendor?: InputMaybe<Scalars['String']['input']>;
  /** refrigeration control system vendor */
  refrigerationvendor?: InputMaybe<Scalars['String']['input']>;
  /** The time a facility was retired. This allows us to leave the facility enabled for nsight kpis when it was active, while hiding it after the facility was retired (sold / closed) */
  retiredAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** The facility’s slug. */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** The facility’s state. */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Suppresse Financials */
  suppresseFinancials?: InputMaybe<Scalars['Boolean']['input']>;
  /** tatAttribute */
  tatAttribute?: InputMaybe<Scalars['String']['input']>;
  /** The name of the timezone for the facility. */
  timezoneName?: InputMaybe<Scalars['String']['input']>;
  /** Type of Facility (e.g. "Managed") */
  type?: InputMaybe<Scalars['String']['input']>;
  /** The unit grouping of the facility. */
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  /** The time this facility was updated. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Type of Warehouse Management System */
  wms?: InputMaybe<Scalars['String']['input']>;
  /** The facility’s zip code. */
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** Permissive capabilities on a Facility. */
export type FacilityPermissions = {
  __typename?: 'FacilityPermissions';
  /** Whether a user can administer a facility. */
  canAdmin: Scalars['Boolean']['output'];
};

/** A software package enabled for a given facilty. */
export type FacilitySoftwarePackage = Node & {
  __typename?: 'FacilitySoftwarePackage';
  /** The time at which the record was created */
  createdAt: Scalars['Datetime']['output'];
  /** Reads a single `Facility` that is related to this `FacilitySoftwarePackage`. */
  facility?: Maybe<Facility>;
  /** The facility using the software package. */
  facilityId: Scalars['Int']['output'];
  /** The identifer of the record. */
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Available permissions for the FacilitySoftwarePackage. */
  permissions?: Maybe<FacilitySoftwarePackagePermissions>;
  /** Reads a single `SoftwarePackage` that is related to this `FacilitySoftwarePackage`. */
  softwarePackage?: Maybe<SoftwarePackage>;
  /** The enabled software package. */
  softwarePackageId: Scalars['Int']['output'];
  /** The current state of the software package. */
  state: FacilitySoftwarePackageState;
  /** The time at which the record was last updated */
  updatedAt: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `FacilitySoftwarePackage` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type FacilitySoftwarePackageCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `softwarePackageId` field. */
  softwarePackageId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `state` field. */
  state?: InputMaybe<FacilitySoftwarePackageState>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `FacilitySoftwarePackage` object types. All fields are combined with a logical ‘and.’ */
export type FacilitySoftwarePackageFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FacilitySoftwarePackageFilter>>;
  /** Filter by the permission can_write */
  canWrite?: InputMaybe<PermissionBooleanFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FacilitySoftwarePackageFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FacilitySoftwarePackageFilter>>;
  /** Filter by the object’s `softwarePackageId` field. */
  softwarePackageId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `state` field. */
  state?: InputMaybe<FacilitySoftwarePackageStateFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `FacilitySoftwarePackage` */
export type FacilitySoftwarePackageInput = {
  /** The facility using the software package. */
  facilityId: Scalars['Int']['input'];
  /** The enabled software package. */
  softwarePackageId: Scalars['Int']['input'];
  /** The current state of the software package. */
  state?: InputMaybe<FacilitySoftwarePackageState>;
};

/** Represents an update to a `FacilitySoftwarePackage`. Fields that are set will be updated. */
export type FacilitySoftwarePackagePatch = {
  /** The current state of the software package. */
  state?: InputMaybe<FacilitySoftwarePackageState>;
};

/** Permissive capabilities on a FacilitySoftwarePackage. */
export type FacilitySoftwarePackagePermissions = {
  __typename?: 'FacilitySoftwarePackagePermissions';
  /** Whether the current user can write facility_software_packages */
  canWrite: Scalars['Boolean']['output'];
};

export enum FacilitySoftwarePackageState {
  INSTALLING_HARDWARE = 'INSTALLING_HARDWARE',
  PREVIEW = 'PREVIEW',
  RELEASED = 'RELEASED',
  SETUP = 'SETUP'
}

/** A filter to be used against FacilitySoftwarePackageState fields. All fields are combined with a logical ‘and.’ */
export type FacilitySoftwarePackageStateFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<FacilitySoftwarePackageState>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<FacilitySoftwarePackageState>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<FacilitySoftwarePackageState>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<FacilitySoftwarePackageState>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<FacilitySoftwarePackageState>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<FacilitySoftwarePackageState>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<FacilitySoftwarePackageState>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<FacilitySoftwarePackageState>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<FacilitySoftwarePackageState>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<FacilitySoftwarePackageState>>;
};

/** A connection to a list of `FacilitySoftwarePackage` values. */
export type FacilitySoftwarePackagesConnection = {
  __typename?: 'FacilitySoftwarePackagesConnection';
  /** A list of edges which contains the `FacilitySoftwarePackage` and cursor to aid in pagination. */
  edges: Array<FacilitySoftwarePackagesEdge>;
  /** A list of `FacilitySoftwarePackage` objects. */
  nodes: Array<FacilitySoftwarePackage>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FacilitySoftwarePackage` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `FacilitySoftwarePackage` edge in the connection. */
export type FacilitySoftwarePackagesEdge = {
  __typename?: 'FacilitySoftwarePackagesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `FacilitySoftwarePackage` at the end of the edge. */
  node: FacilitySoftwarePackage;
};

/** Methods to use when ordering `FacilitySoftwarePackage`. */
export enum FacilitySoftwarePackagesOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  SOFTWARE_PACKAGE_ID_ASC = 'SOFTWARE_PACKAGE_ID_ASC',
  SOFTWARE_PACKAGE_ID_DESC = 'SOFTWARE_PACKAGE_ID_DESC',
  STATE_ASC = 'STATE_ASC',
  STATE_DESC = 'STATE_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

export type FacilityStddevPopulationAggregates = {
  __typename?: 'FacilityStddevPopulationAggregates';
  /**
   * Population standard deviation of this field across the matching connection.
   *
   * ---
   *
   * The number of days we have active utility meters for a given serive type and time range.
   */
  activeMeterDatesCount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of customerLocationId across the matching connection */
  customerLocationId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of dataType2Test across the matching connection */
  dataType2Test?: Maybe<Scalars['Float']['output']>;
  /** Population standard deviation of dataType3Test across the matching connection */
  dataType3Test?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of latitude across the matching connection */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** Population standard deviation of longitude across the matching connection */
  longitude?: Maybe<Scalars['Float']['output']>;
  /** Population standard deviation of pricingNodeId across the matching connection */
  pricingNodeId?: Maybe<Scalars['BigFloat']['output']>;
};

export type FacilityStddevPopulationAggregatesActiveMeterDatesCountArgs = {
  from?: InputMaybe<Scalars['String']['input']>;
  meterServiceTypes?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type FacilityStddevSampleAggregates = {
  __typename?: 'FacilityStddevSampleAggregates';
  /**
   * Sample standard deviation of this field across the matching connection.
   *
   * ---
   *
   * The number of days we have active utility meters for a given serive type and time range.
   */
  activeMeterDatesCount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of customerLocationId across the matching connection */
  customerLocationId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of dataType2Test across the matching connection */
  dataType2Test?: Maybe<Scalars['Float']['output']>;
  /** Sample standard deviation of dataType3Test across the matching connection */
  dataType3Test?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of latitude across the matching connection */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** Sample standard deviation of longitude across the matching connection */
  longitude?: Maybe<Scalars['Float']['output']>;
  /** Sample standard deviation of pricingNodeId across the matching connection */
  pricingNodeId?: Maybe<Scalars['BigFloat']['output']>;
};

export type FacilityStddevSampleAggregatesActiveMeterDatesCountArgs = {
  from?: InputMaybe<Scalars['String']['input']>;
  meterServiceTypes?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type FacilitySumAggregates = {
  __typename?: 'FacilitySumAggregates';
  /**
   * Sum of this field across the matching connection.
   *
   * ---
   *
   * The number of days we have active utility meters for a given serive type and time range.
   */
  activeMeterDatesCount?: Maybe<Scalars['BigInt']['output']>;
  /** Sum of customerLocationId across the matching connection */
  customerLocationId: Scalars['BigInt']['output'];
  /** Sum of dataType2Test across the matching connection */
  dataType2Test: Scalars['Float']['output'];
  /** Sum of dataType3Test across the matching connection */
  dataType3Test: Scalars['BigInt']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of latitude across the matching connection */
  latitude: Scalars['Float']['output'];
  /** Sum of longitude across the matching connection */
  longitude: Scalars['Float']['output'];
  /** Sum of pricingNodeId across the matching connection */
  pricingNodeId: Scalars['BigInt']['output'];
};

export type FacilitySumAggregatesActiveMeterDatesCountArgs = {
  from?: InputMaybe<Scalars['String']['input']>;
  meterServiceTypes?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
  to?: InputMaybe<Scalars['String']['input']>;
};

/** Tags for specific data points at a facility */
export type FacilityTaggedDataPoint = Node & {
  __typename?: 'FacilityTaggedDataPoint';
  createdAt: Scalars['Datetime']['output'];
  /** Reads a single `DataPoint` that is related to this `FacilityTaggedDataPoint`. */
  dataPoint?: Maybe<DataPoint>;
  dataPointId: Scalars['BigInt']['output'];
  /** Reads a single `Facility` that is related to this `FacilityTaggedDataPoint`. */
  facility?: Maybe<Facility>;
  facilityId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `DataPointTag` that is related to this `FacilityTaggedDataPoint`. */
  tag?: Maybe<DataPointTag>;
  tagId: Scalars['Int']['output'];
  tagName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `FacilityTaggedDataPoint` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type FacilityTaggedDataPointCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `dataPointId` field. */
  dataPointId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `tagId` field. */
  tagId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `tagName` field. */
  tagName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `FacilityTaggedDataPoint` object types. All fields are combined with a logical ‘and.’ */
export type FacilityTaggedDataPointFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FacilityTaggedDataPointFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dataPointId` field. */
  dataPointId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FacilityTaggedDataPointFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FacilityTaggedDataPointFilter>>;
  /** Filter by the object’s `tagId` field. */
  tagId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `tagName` field. */
  tagName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `FacilityTaggedDataPoint` */
export type FacilityTaggedDataPointInput = {
  /** Mutates a `DataPoint` as part of the payload */
  dataPoint?: InputMaybe<DataPointInput>;
  dataPointId?: InputMaybe<Scalars['BigInt']['input']>;
  facilityId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  tagId: Scalars['Int']['input'];
};

/** Represents an update to a `FacilityTaggedDataPoint`. Fields that are set will be updated. */
export type FacilityTaggedDataPointPatch = {
  dataPointId?: InputMaybe<Scalars['BigInt']['input']>;
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tagId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `FacilityTaggedDataPoint` values. */
export type FacilityTaggedDataPointsConnection = {
  __typename?: 'FacilityTaggedDataPointsConnection';
  /** Returns the aggregate data timeseries data for the FacilityTaggedDataPointsConnection  */
  data?: Maybe<MetricDataConnection>;
  /** A list of edges which contains the `FacilityTaggedDataPoint` and cursor to aid in pagination. */
  edges: Array<FacilityTaggedDataPointsEdge>;
  /** A list of `FacilityTaggedDataPoint` objects. */
  nodes: Array<FacilityTaggedDataPoint>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FacilityTaggedDataPoint` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A connection to a list of `FacilityTaggedDataPoint` values. */
export type FacilityTaggedDataPointsConnectionDataArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A `FacilityTaggedDataPoint` edge in the connection. */
export type FacilityTaggedDataPointsEdge = {
  __typename?: 'FacilityTaggedDataPointsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `FacilityTaggedDataPoint` at the end of the edge. */
  node: FacilityTaggedDataPoint;
};

/** Methods to use when ordering `FacilityTaggedDataPoint`. */
export enum FacilityTaggedDataPointsOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DATA_POINT_ID_ASC = 'DATA_POINT_ID_ASC',
  DATA_POINT_ID_DESC = 'DATA_POINT_ID_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  TAG_ID_ASC = 'TAG_ID_ASC',
  TAG_ID_DESC = 'TAG_ID_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** Mapping of facilities to their utility accounts. */
export type FacilityUtilityAccount = Node & {
  __typename?: 'FacilityUtilityAccount';
  /** The Adjustment for a facility utility account. */
  adjustment?: Maybe<MetricDataConnection>;
  /** Returns the derived data point configuration for this connection */
  adjustmentDataPoint?: Maybe<DerivedDataPoint>;
  /** The Annual Demand for a facility utility account. */
  annualDemand?: Maybe<MetricDataConnection>;
  /** Returns the derived data point configuration for this connection */
  annualDemandDataPoint?: Maybe<DerivedDataPoint>;
  assetFacilityId?: Maybe<Scalars['Int']['output']>;
  assetName?: Maybe<Scalars['String']['output']>;
  /** The Assistance Programs for a facility utility account. */
  assistancePrograms?: Maybe<MetricDataConnection>;
  /** Returns the derived data point configuration for this connection */
  assistanceProgramsDataPoint?: Maybe<DerivedDataPoint>;
  /** The Base Fee for a facility utility account. */
  baseFee?: Maybe<MetricDataConnection>;
  /** Returns the derived data point configuration for this connection */
  baseFeeDataPoint?: Maybe<DerivedDataPoint>;
  /** The Block Charge for a facility utility account. */
  blockCharge?: Maybe<MetricDataConnection>;
  /** Returns the derived data point configuration for this connection */
  blockChargeDataPoint?: Maybe<DerivedDataPoint>;
  /** The Capacity Charge for a facility utility account. */
  capacityCharge?: Maybe<MetricDataConnection>;
  /** Returns the derived data point configuration for this connection */
  capacityChargeDataPoint?: Maybe<DerivedDataPoint>;
  /** Returns the per-month total charges broken down by category label for a given facility utility account. */
  catChargesByStatementYearMonth: FacilityUtilityAccountsCatChargesByStatementYearMonthConnection;
  /** The Credit for a facility utility account. */
  credit?: Maybe<MetricDataConnection>;
  /** Returns the derived data point configuration for this connection */
  creditDataPoint?: Maybe<DerivedDataPoint>;
  /** The Delivery and System for a facility utility account. */
  deliveryAndSystem?: Maybe<MetricDataConnection>;
  /** Returns the derived data point configuration for this connection */
  deliveryAndSystemDataPoint?: Maybe<DerivedDataPoint>;
  /** The Demand Charge for a facility utility account. */
  demandCharge?: Maybe<MetricDataConnection>;
  /** Returns the derived data point configuration for this connection */
  demandChargeDataPoint?: Maybe<DerivedDataPoint>;
  /** The Demand Charge (Monthly Max) for a facility utility account. */
  demandChargeMonthlyMax?: Maybe<MetricDataConnection>;
  /** Returns the derived data point configuration for this connection */
  demandChargeMonthlyMaxDataPoint?: Maybe<DerivedDataPoint>;
  /** The Demand Mid-Peak for a facility utility account. */
  demandMidPeak?: Maybe<MetricDataConnection>;
  /** Returns the derived data point configuration for this connection */
  demandMidPeakDataPoint?: Maybe<DerivedDataPoint>;
  /** The Demand Off-Peak for a facility utility account. */
  demandOffPeak?: Maybe<MetricDataConnection>;
  /** Returns the derived data point configuration for this connection */
  demandOffPeakDataPoint?: Maybe<DerivedDataPoint>;
  /** The Demand On-Peak for a facility utility account. */
  demandOnPeak?: Maybe<MetricDataConnection>;
  /** Returns the derived data point configuration for this connection */
  demandOnPeakDataPoint?: Maybe<DerivedDataPoint>;
  /** The Demand Response for a facility utility account. */
  demandResponse?: Maybe<MetricDataConnection>;
  /** Returns the derived data point configuration for this connection */
  demandResponseDataPoint?: Maybe<DerivedDataPoint>;
  /** The Distribution for a facility utility account. */
  distribution?: Maybe<MetricDataConnection>;
  /** Returns the derived data point configuration for this connection */
  distributionDataPoint?: Maybe<DerivedDataPoint>;
  /** The Energy Charge for a facility utility account. */
  energyCharge?: Maybe<MetricDataConnection>;
  /** Returns the derived data point configuration for this connection */
  energyChargeDataPoint?: Maybe<DerivedDataPoint>;
  /** The Exemption for a facility utility account. */
  exemption?: Maybe<MetricDataConnection>;
  /** Returns the derived data point configuration for this connection */
  exemptionDataPoint?: Maybe<DerivedDataPoint>;
  /** Reads a single `Facility` that is related to this `FacilityUtilityAccount`. */
  facility?: Maybe<Facility>;
  /** The id of the related facility. */
  facilityId: Scalars['Int']['output'];
  /** The Fee for a facility utility account. */
  fee?: Maybe<MetricDataConnection>;
  /** Returns the derived data point configuration for this connection */
  feeDataPoint?: Maybe<DerivedDataPoint>;
  /** The Fuel Charge for a facility utility account. */
  fuelCharge?: Maybe<MetricDataConnection>;
  /** Returns the derived data point configuration for this connection */
  fuelChargeDataPoint?: Maybe<DerivedDataPoint>;
  /** Primary key. */
  id: Scalars['Int']['output'];
  /** The Locational Marginal Price Adder for a facility utility account. */
  locationalMarginalPriceAdder?: Maybe<MetricDataConnection>;
  /** Returns the derived data point configuration for this connection */
  locationalMarginalPriceAdderDataPoint?: Maybe<DerivedDataPoint>;
  /** The Miscellaneous Gross Receipts Tax for a facility utility account. */
  miscellaneousGrossReceiptsTax?: Maybe<MetricDataConnection>;
  /** Returns the derived data point configuration for this connection */
  miscellaneousGrossReceiptsTaxDataPoint?: Maybe<DerivedDataPoint>;
  /** The related monitored asset. */
  monitoredAsset?: Maybe<MonitoredAsset>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The Nuclear for a facility utility account. */
  nuclear?: Maybe<MetricDataConnection>;
  /** Returns the derived data point configuration for this connection */
  nuclearDataPoint?: Maybe<DerivedDataPoint>;
  /** The Pass-Through for a facility utility account. */
  passthrough?: Maybe<MetricDataConnection>;
  /** Returns the derived data point configuration for this connection */
  passthroughDataPoint?: Maybe<DerivedDataPoint>;
  /** The Peak for a facility utility account. */
  peak?: Maybe<MetricDataConnection>;
  /** Returns the derived data point configuration for this connection */
  peakDataPoint?: Maybe<DerivedDataPoint>;
  /** The Power Factor for a facility utility account. */
  powerFactor?: Maybe<MetricDataConnection>;
  /** Returns the derived data point configuration for this connection */
  powerFactorDataPoint?: Maybe<DerivedDataPoint>;
  /** The Reactive Demand for a facility utility account. */
  reactiveDemand?: Maybe<MetricDataConnection>;
  /** Returns the derived data point configuration for this connection */
  reactiveDemandDataPoint?: Maybe<DerivedDataPoint>;
  /** The Renewable and Environmental for a facility utility account. */
  renewableAndEnvironmental?: Maybe<MetricDataConnection>;
  /** Returns the derived data point configuration for this connection */
  renewableAndEnvironmentalDataPoint?: Maybe<DerivedDataPoint>;
  /** The Riders and Surcharges for a facility utility account. */
  ridersAndSurcharges?: Maybe<MetricDataConnection>;
  /** Returns the derived data point configuration for this connection */
  ridersAndSurchargesDataPoint?: Maybe<DerivedDataPoint>;
  /** The Sales Tax for a facility utility account. */
  salesTax?: Maybe<MetricDataConnection>;
  /** Returns the derived data point configuration for this connection */
  salesTaxDataPoint?: Maybe<DerivedDataPoint>;
  /** The Seasonal On-Peak Demand for a facility utility account. */
  seasonalOnPeakDemand?: Maybe<MetricDataConnection>;
  /** Returns the derived data point configuration for this connection */
  seasonalOnPeakDemandDataPoint?: Maybe<DerivedDataPoint>;
  /** The Tax for a facility utility account. */
  tax?: Maybe<MetricDataConnection>;
  /** Returns the derived data point configuration for this connection */
  taxDataPoint?: Maybe<DerivedDataPoint>;
  /** The Total Demand for a facility utility account. */
  totalDemand?: Maybe<MetricDataConnection>;
  /** Returns the derived data point configuration for this connection */
  totalDemandDataPoint?: Maybe<DerivedDataPoint>;
  /** The Total Usage for a facility utility account. */
  totalUsage?: Maybe<MetricDataConnection>;
  /** Returns the derived data point configuration for this connection */
  totalUsageDataPoint?: Maybe<DerivedDataPoint>;
  /** The Transmission for a facility utility account. */
  transmission?: Maybe<MetricDataConnection>;
  /** Returns the derived data point configuration for this connection */
  transmissionDataPoint?: Maybe<DerivedDataPoint>;
  /** The Unknown for a facility utility account. */
  unknown?: Maybe<MetricDataConnection>;
  /** The Unknown Credits for a facility utility account. */
  unknownCredits?: Maybe<MetricDataConnection>;
  /** Returns the derived data point configuration for this connection */
  unknownCreditsDataPoint?: Maybe<DerivedDataPoint>;
  /** Returns the derived data point configuration for this connection */
  unknownDataPoint?: Maybe<DerivedDataPoint>;
  /** The Unknown Demand for a facility utility account. */
  unknownDemand?: Maybe<MetricDataConnection>;
  /** Returns the derived data point configuration for this connection */
  unknownDemandDataPoint?: Maybe<DerivedDataPoint>;
  /** The Unknown Fees for a facility utility account. */
  unknownFees?: Maybe<MetricDataConnection>;
  /** Returns the derived data point configuration for this connection */
  unknownFeesDataPoint?: Maybe<DerivedDataPoint>;
  /** The Unknown Taxes for a facility utility account. */
  unknownTaxes?: Maybe<MetricDataConnection>;
  /** Returns the derived data point configuration for this connection */
  unknownTaxesDataPoint?: Maybe<DerivedDataPoint>;
  /** The Unknown Usage for a facility utility account. */
  unknownUsage?: Maybe<MetricDataConnection>;
  /** Returns the derived data point configuration for this connection */
  unknownUsageDataPoint?: Maybe<DerivedDataPoint>;
  /** The Usage Charge Total for a facility utility account. */
  usageChargeTotal?: Maybe<MetricDataConnection>;
  /** Returns the derived data point configuration for this connection */
  usageChargeTotalDataPoint?: Maybe<DerivedDataPoint>;
  /** The Usage Mid-Peak for a facility utility account. */
  usageMidPeak?: Maybe<MetricDataConnection>;
  /** Returns the derived data point configuration for this connection */
  usageMidPeakDataPoint?: Maybe<DerivedDataPoint>;
  /** The Usage Off-Peak for a facility utility account. */
  usageOffPeak?: Maybe<MetricDataConnection>;
  /** Returns the derived data point configuration for this connection */
  usageOffPeakDataPoint?: Maybe<DerivedDataPoint>;
  /** The Usage On-Peak for a facility utility account. */
  usageOnPeak?: Maybe<MetricDataConnection>;
  /** Returns the derived data point configuration for this connection */
  usageOnPeakDataPoint?: Maybe<DerivedDataPoint>;
  /** The Usage Super Off-Peak for a facility utility account. */
  usageSuperOffPeak?: Maybe<MetricDataConnection>;
  /** Returns the derived data point configuration for this connection */
  usageSuperOffPeakDataPoint?: Maybe<DerivedDataPoint>;
  /** The Usage Surcharge for a facility utility account. */
  usageSurcharge?: Maybe<MetricDataConnection>;
  /** Returns the derived data point configuration for this connection */
  usageSurchargeDataPoint?: Maybe<DerivedDataPoint>;
  /** Reads a single `UtilityAccount` that is related to this `FacilityUtilityAccount`. */
  utilityAccount?: Maybe<UtilityAccount>;
  /** The id of the related utility account. */
  utilityAccountId: Scalars['Int']['output'];
};

/** Mapping of facilities to their utility accounts. */
export type FacilityUtilityAccountAdjustmentArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** Mapping of facilities to their utility accounts. */
export type FacilityUtilityAccountAnnualDemandArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** Mapping of facilities to their utility accounts. */
export type FacilityUtilityAccountAssistanceProgramsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** Mapping of facilities to their utility accounts. */
export type FacilityUtilityAccountBaseFeeArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** Mapping of facilities to their utility accounts. */
export type FacilityUtilityAccountBlockChargeArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** Mapping of facilities to their utility accounts. */
export type FacilityUtilityAccountCapacityChargeArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** Mapping of facilities to their utility accounts. */
export type FacilityUtilityAccountCatChargesByStatementYearMonthArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<FacilityUtilityAccountsCatChargesByStatementYearMonthRecordFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['Date']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};

/** Mapping of facilities to their utility accounts. */
export type FacilityUtilityAccountCreditArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** Mapping of facilities to their utility accounts. */
export type FacilityUtilityAccountDeliveryAndSystemArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** Mapping of facilities to their utility accounts. */
export type FacilityUtilityAccountDemandChargeArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** Mapping of facilities to their utility accounts. */
export type FacilityUtilityAccountDemandChargeMonthlyMaxArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** Mapping of facilities to their utility accounts. */
export type FacilityUtilityAccountDemandMidPeakArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** Mapping of facilities to their utility accounts. */
export type FacilityUtilityAccountDemandOffPeakArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** Mapping of facilities to their utility accounts. */
export type FacilityUtilityAccountDemandOnPeakArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** Mapping of facilities to their utility accounts. */
export type FacilityUtilityAccountDemandResponseArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** Mapping of facilities to their utility accounts. */
export type FacilityUtilityAccountDistributionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** Mapping of facilities to their utility accounts. */
export type FacilityUtilityAccountEnergyChargeArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** Mapping of facilities to their utility accounts. */
export type FacilityUtilityAccountExemptionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** Mapping of facilities to their utility accounts. */
export type FacilityUtilityAccountFeeArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** Mapping of facilities to their utility accounts. */
export type FacilityUtilityAccountFuelChargeArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** Mapping of facilities to their utility accounts. */
export type FacilityUtilityAccountLocationalMarginalPriceAdderArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** Mapping of facilities to their utility accounts. */
export type FacilityUtilityAccountMiscellaneousGrossReceiptsTaxArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** Mapping of facilities to their utility accounts. */
export type FacilityUtilityAccountNuclearArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** Mapping of facilities to their utility accounts. */
export type FacilityUtilityAccountPassthroughArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** Mapping of facilities to their utility accounts. */
export type FacilityUtilityAccountPeakArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** Mapping of facilities to their utility accounts. */
export type FacilityUtilityAccountPowerFactorArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** Mapping of facilities to their utility accounts. */
export type FacilityUtilityAccountReactiveDemandArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** Mapping of facilities to their utility accounts. */
export type FacilityUtilityAccountRenewableAndEnvironmentalArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** Mapping of facilities to their utility accounts. */
export type FacilityUtilityAccountRidersAndSurchargesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** Mapping of facilities to their utility accounts. */
export type FacilityUtilityAccountSalesTaxArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** Mapping of facilities to their utility accounts. */
export type FacilityUtilityAccountSeasonalOnPeakDemandArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** Mapping of facilities to their utility accounts. */
export type FacilityUtilityAccountTaxArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** Mapping of facilities to their utility accounts. */
export type FacilityUtilityAccountTotalDemandArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** Mapping of facilities to their utility accounts. */
export type FacilityUtilityAccountTotalUsageArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** Mapping of facilities to their utility accounts. */
export type FacilityUtilityAccountTransmissionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** Mapping of facilities to their utility accounts. */
export type FacilityUtilityAccountUnknownArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** Mapping of facilities to their utility accounts. */
export type FacilityUtilityAccountUnknownCreditsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** Mapping of facilities to their utility accounts. */
export type FacilityUtilityAccountUnknownDemandArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** Mapping of facilities to their utility accounts. */
export type FacilityUtilityAccountUnknownFeesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** Mapping of facilities to their utility accounts. */
export type FacilityUtilityAccountUnknownTaxesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** Mapping of facilities to their utility accounts. */
export type FacilityUtilityAccountUnknownUsageArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** Mapping of facilities to their utility accounts. */
export type FacilityUtilityAccountUsageChargeTotalArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** Mapping of facilities to their utility accounts. */
export type FacilityUtilityAccountUsageMidPeakArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** Mapping of facilities to their utility accounts. */
export type FacilityUtilityAccountUsageOffPeakArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** Mapping of facilities to their utility accounts. */
export type FacilityUtilityAccountUsageOnPeakArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** Mapping of facilities to their utility accounts. */
export type FacilityUtilityAccountUsageSuperOffPeakArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** Mapping of facilities to their utility accounts. */
export type FacilityUtilityAccountUsageSurchargeArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/**
 * A condition to be used against `FacilityUtilityAccount` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type FacilityUtilityAccountCondition = {
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `utilityAccountId` field. */
  utilityAccountId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `FacilityUtilityAccount` object types. All fields are combined with a logical ‘and.’ */
export type FacilityUtilityAccountFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FacilityUtilityAccountFilter>>;
  /** Filter by the object’s `assetFacilityId` field. */
  assetFacilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `assetName` field. */
  assetName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FacilityUtilityAccountFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FacilityUtilityAccountFilter>>;
  /** Filter by the object’s `utilityAccountId` field. */
  utilityAccountId?: InputMaybe<IntFilter>;
};

/** A connection to a list of `FacilityUtilityAccountsCatChargesByStatementYearMonthRecord` values. */
export type FacilityUtilityAccountsCatChargesByStatementYearMonthConnection = {
  __typename?: 'FacilityUtilityAccountsCatChargesByStatementYearMonthConnection';
  /**
   * A list of edges which contains the
   * `FacilityUtilityAccountsCatChargesByStatementYearMonthRecord` and cursor to
   * aid in pagination.
   */
  edges: Array<FacilityUtilityAccountsCatChargesByStatementYearMonthEdge>;
  /** A list of `FacilityUtilityAccountsCatChargesByStatementYearMonthRecord` objects. */
  nodes: Array<FacilityUtilityAccountsCatChargesByStatementYearMonthRecord>;
  /** The count of *all* `FacilityUtilityAccountsCatChargesByStatementYearMonthRecord` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `FacilityUtilityAccountsCatChargesByStatementYearMonthRecord` edge in the connection. */
export type FacilityUtilityAccountsCatChargesByStatementYearMonthEdge = {
  __typename?: 'FacilityUtilityAccountsCatChargesByStatementYearMonthEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `FacilityUtilityAccountsCatChargesByStatementYearMonthRecord` at the end of the edge. */
  node: FacilityUtilityAccountsCatChargesByStatementYearMonthRecord;
};

/** The return type of our `catChargesByStatementYearMonth` query. */
export type FacilityUtilityAccountsCatChargesByStatementYearMonthRecord = {
  __typename?: 'FacilityUtilityAccountsCatChargesByStatementYearMonthRecord';
  category?: Maybe<Scalars['String']['output']>;
  displayCategory?: Maybe<Scalars['String']['output']>;
  statementYearMonth?: Maybe<Scalars['Date']['output']>;
  totalNormalized?: Maybe<Scalars['Float']['output']>;
  totalRaw?: Maybe<Scalars['Float']['output']>;
};

/** A filter to be used against `FacilityUtilityAccountsCatChargesByStatementYearMonthRecord` object types. All fields are combined with a logical ‘and.’ */
export type FacilityUtilityAccountsCatChargesByStatementYearMonthRecordFilter =
  {
    /** Checks for all expressions in this list. */
    and?: InputMaybe<
      Array<FacilityUtilityAccountsCatChargesByStatementYearMonthRecordFilter>
    >;
    /** Filter by the object’s `category` field. */
    category?: InputMaybe<StringFilter>;
    /** Filter by the object’s `displayCategory` field. */
    displayCategory?: InputMaybe<StringFilter>;
    /** Negates the expression. */
    not?: InputMaybe<FacilityUtilityAccountsCatChargesByStatementYearMonthRecordFilter>;
    /** Checks for any expressions in this list. */
    or?: InputMaybe<
      Array<FacilityUtilityAccountsCatChargesByStatementYearMonthRecordFilter>
    >;
    /** Filter by the object’s `statementYearMonth` field. */
    statementYearMonth?: InputMaybe<DateFilter>;
    /** Filter by the object’s `totalNormalized` field. */
    totalNormalized?: InputMaybe<FloatFilter>;
    /** Filter by the object’s `totalRaw` field. */
    totalRaw?: InputMaybe<FloatFilter>;
  };

/** A connection to a list of `FacilityUtilityAccount` values. */
export type FacilityUtilityAccountsConnection = {
  __typename?: 'FacilityUtilityAccountsConnection';
  /** The Adjustment for a facility utility account. */
  adjustment?: Maybe<MetricDataConnection>;
  /** The Annual Demand for a facility utility account. */
  annualDemand?: Maybe<MetricDataConnection>;
  /** The Assistance Programs for a facility utility account. */
  assistancePrograms?: Maybe<MetricDataConnection>;
  /** The Base Fee for a facility utility account. */
  baseFee?: Maybe<MetricDataConnection>;
  /** The Block Charge for a facility utility account. */
  blockCharge?: Maybe<MetricDataConnection>;
  /** The Capacity Charge for a facility utility account. */
  capacityCharge?: Maybe<MetricDataConnection>;
  /** The Credit for a facility utility account. */
  credit?: Maybe<MetricDataConnection>;
  /** The Delivery and System for a facility utility account. */
  deliveryAndSystem?: Maybe<MetricDataConnection>;
  /** The Demand Charge for a facility utility account. */
  demandCharge?: Maybe<MetricDataConnection>;
  /** The Demand Charge (Monthly Max) for a facility utility account. */
  demandChargeMonthlyMax?: Maybe<MetricDataConnection>;
  /** The Demand Mid-Peak for a facility utility account. */
  demandMidPeak?: Maybe<MetricDataConnection>;
  /** The Demand Off-Peak for a facility utility account. */
  demandOffPeak?: Maybe<MetricDataConnection>;
  /** The Demand On-Peak for a facility utility account. */
  demandOnPeak?: Maybe<MetricDataConnection>;
  /** The Demand Response for a facility utility account. */
  demandResponse?: Maybe<MetricDataConnection>;
  /** The Distribution for a facility utility account. */
  distribution?: Maybe<MetricDataConnection>;
  /** A list of edges which contains the `FacilityUtilityAccount` and cursor to aid in pagination. */
  edges: Array<FacilityUtilityAccountsEdge>;
  /** The Energy Charge for a facility utility account. */
  energyCharge?: Maybe<MetricDataConnection>;
  /** The Exemption for a facility utility account. */
  exemption?: Maybe<MetricDataConnection>;
  /** The Fee for a facility utility account. */
  fee?: Maybe<MetricDataConnection>;
  /** The Fuel Charge for a facility utility account. */
  fuelCharge?: Maybe<MetricDataConnection>;
  /** The Locational Marginal Price Adder for a facility utility account. */
  locationalMarginalPriceAdder?: Maybe<MetricDataConnection>;
  /** The Miscellaneous Gross Receipts Tax for a facility utility account. */
  miscellaneousGrossReceiptsTax?: Maybe<MetricDataConnection>;
  /** A list of `FacilityUtilityAccount` objects. */
  nodes: Array<FacilityUtilityAccount>;
  /** The Nuclear for a facility utility account. */
  nuclear?: Maybe<MetricDataConnection>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The Pass-Through for a facility utility account. */
  passthrough?: Maybe<MetricDataConnection>;
  /** The Peak for a facility utility account. */
  peak?: Maybe<MetricDataConnection>;
  /** The Power Factor for a facility utility account. */
  powerFactor?: Maybe<MetricDataConnection>;
  /** The Reactive Demand for a facility utility account. */
  reactiveDemand?: Maybe<MetricDataConnection>;
  /** The Renewable and Environmental for a facility utility account. */
  renewableAndEnvironmental?: Maybe<MetricDataConnection>;
  /** The Riders and Surcharges for a facility utility account. */
  ridersAndSurcharges?: Maybe<MetricDataConnection>;
  /** The Sales Tax for a facility utility account. */
  salesTax?: Maybe<MetricDataConnection>;
  /** The Seasonal On-Peak Demand for a facility utility account. */
  seasonalOnPeakDemand?: Maybe<MetricDataConnection>;
  /** The Tax for a facility utility account. */
  tax?: Maybe<MetricDataConnection>;
  /** The count of *all* `FacilityUtilityAccount` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
  /** The Total Demand for a facility utility account. */
  totalDemand?: Maybe<MetricDataConnection>;
  /** The Total Usage for a facility utility account. */
  totalUsage?: Maybe<MetricDataConnection>;
  /** The Transmission for a facility utility account. */
  transmission?: Maybe<MetricDataConnection>;
  /** The Unknown for a facility utility account. */
  unknown?: Maybe<MetricDataConnection>;
  /** The Unknown Credits for a facility utility account. */
  unknownCredits?: Maybe<MetricDataConnection>;
  /** The Unknown Demand for a facility utility account. */
  unknownDemand?: Maybe<MetricDataConnection>;
  /** The Unknown Fees for a facility utility account. */
  unknownFees?: Maybe<MetricDataConnection>;
  /** The Unknown Taxes for a facility utility account. */
  unknownTaxes?: Maybe<MetricDataConnection>;
  /** The Unknown Usage for a facility utility account. */
  unknownUsage?: Maybe<MetricDataConnection>;
  /** The Usage Charge Total for a facility utility account. */
  usageChargeTotal?: Maybe<MetricDataConnection>;
  /** The Usage Mid-Peak for a facility utility account. */
  usageMidPeak?: Maybe<MetricDataConnection>;
  /** The Usage Off-Peak for a facility utility account. */
  usageOffPeak?: Maybe<MetricDataConnection>;
  /** The Usage On-Peak for a facility utility account. */
  usageOnPeak?: Maybe<MetricDataConnection>;
  /** The Usage Super Off-Peak for a facility utility account. */
  usageSuperOffPeak?: Maybe<MetricDataConnection>;
  /** The Usage Surcharge for a facility utility account. */
  usageSurcharge?: Maybe<MetricDataConnection>;
};

/** A connection to a list of `FacilityUtilityAccount` values. */
export type FacilityUtilityAccountsConnectionAdjustmentArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `FacilityUtilityAccount` values. */
export type FacilityUtilityAccountsConnectionAnnualDemandArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `FacilityUtilityAccount` values. */
export type FacilityUtilityAccountsConnectionAssistanceProgramsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `FacilityUtilityAccount` values. */
export type FacilityUtilityAccountsConnectionBaseFeeArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `FacilityUtilityAccount` values. */
export type FacilityUtilityAccountsConnectionBlockChargeArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `FacilityUtilityAccount` values. */
export type FacilityUtilityAccountsConnectionCapacityChargeArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `FacilityUtilityAccount` values. */
export type FacilityUtilityAccountsConnectionCreditArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `FacilityUtilityAccount` values. */
export type FacilityUtilityAccountsConnectionDeliveryAndSystemArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `FacilityUtilityAccount` values. */
export type FacilityUtilityAccountsConnectionDemandChargeArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `FacilityUtilityAccount` values. */
export type FacilityUtilityAccountsConnectionDemandChargeMonthlyMaxArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `FacilityUtilityAccount` values. */
export type FacilityUtilityAccountsConnectionDemandMidPeakArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `FacilityUtilityAccount` values. */
export type FacilityUtilityAccountsConnectionDemandOffPeakArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `FacilityUtilityAccount` values. */
export type FacilityUtilityAccountsConnectionDemandOnPeakArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `FacilityUtilityAccount` values. */
export type FacilityUtilityAccountsConnectionDemandResponseArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `FacilityUtilityAccount` values. */
export type FacilityUtilityAccountsConnectionDistributionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `FacilityUtilityAccount` values. */
export type FacilityUtilityAccountsConnectionEnergyChargeArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `FacilityUtilityAccount` values. */
export type FacilityUtilityAccountsConnectionExemptionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `FacilityUtilityAccount` values. */
export type FacilityUtilityAccountsConnectionFeeArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `FacilityUtilityAccount` values. */
export type FacilityUtilityAccountsConnectionFuelChargeArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `FacilityUtilityAccount` values. */
export type FacilityUtilityAccountsConnectionLocationalMarginalPriceAdderArgs =
  {
    after?: InputMaybe<Scalars['Cursor']['input']>;
    aggregation?: MetricDataAggregationMethod;
    before?: InputMaybe<Scalars['Cursor']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    from: Scalars['String']['input'];
    last?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    orderBy?: MetricDataOrderBy;
    samplingWindow?: InputMaybe<Scalars['String']['input']>;
    timezone?: InputMaybe<Scalars['String']['input']>;
    to: Scalars['String']['input'];
    unit?: InputMaybe<Scalars['String']['input']>;
    unitGroup?: InputMaybe<Scalars['String']['input']>;
    window?: Scalars['String']['input'];
  };

/** A connection to a list of `FacilityUtilityAccount` values. */
export type FacilityUtilityAccountsConnectionMiscellaneousGrossReceiptsTaxArgs =
  {
    after?: InputMaybe<Scalars['Cursor']['input']>;
    aggregation?: MetricDataAggregationMethod;
    before?: InputMaybe<Scalars['Cursor']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    from: Scalars['String']['input'];
    last?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    orderBy?: MetricDataOrderBy;
    samplingWindow?: InputMaybe<Scalars['String']['input']>;
    timezone?: InputMaybe<Scalars['String']['input']>;
    to: Scalars['String']['input'];
    unit?: InputMaybe<Scalars['String']['input']>;
    unitGroup?: InputMaybe<Scalars['String']['input']>;
    window?: Scalars['String']['input'];
  };

/** A connection to a list of `FacilityUtilityAccount` values. */
export type FacilityUtilityAccountsConnectionNuclearArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `FacilityUtilityAccount` values. */
export type FacilityUtilityAccountsConnectionPassthroughArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `FacilityUtilityAccount` values. */
export type FacilityUtilityAccountsConnectionPeakArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `FacilityUtilityAccount` values. */
export type FacilityUtilityAccountsConnectionPowerFactorArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `FacilityUtilityAccount` values. */
export type FacilityUtilityAccountsConnectionReactiveDemandArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `FacilityUtilityAccount` values. */
export type FacilityUtilityAccountsConnectionRenewableAndEnvironmentalArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `FacilityUtilityAccount` values. */
export type FacilityUtilityAccountsConnectionRidersAndSurchargesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `FacilityUtilityAccount` values. */
export type FacilityUtilityAccountsConnectionSalesTaxArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `FacilityUtilityAccount` values. */
export type FacilityUtilityAccountsConnectionSeasonalOnPeakDemandArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `FacilityUtilityAccount` values. */
export type FacilityUtilityAccountsConnectionTaxArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `FacilityUtilityAccount` values. */
export type FacilityUtilityAccountsConnectionTotalDemandArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `FacilityUtilityAccount` values. */
export type FacilityUtilityAccountsConnectionTotalUsageArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `FacilityUtilityAccount` values. */
export type FacilityUtilityAccountsConnectionTransmissionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `FacilityUtilityAccount` values. */
export type FacilityUtilityAccountsConnectionUnknownArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `FacilityUtilityAccount` values. */
export type FacilityUtilityAccountsConnectionUnknownCreditsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `FacilityUtilityAccount` values. */
export type FacilityUtilityAccountsConnectionUnknownDemandArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `FacilityUtilityAccount` values. */
export type FacilityUtilityAccountsConnectionUnknownFeesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `FacilityUtilityAccount` values. */
export type FacilityUtilityAccountsConnectionUnknownTaxesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `FacilityUtilityAccount` values. */
export type FacilityUtilityAccountsConnectionUnknownUsageArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `FacilityUtilityAccount` values. */
export type FacilityUtilityAccountsConnectionUsageChargeTotalArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `FacilityUtilityAccount` values. */
export type FacilityUtilityAccountsConnectionUsageMidPeakArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `FacilityUtilityAccount` values. */
export type FacilityUtilityAccountsConnectionUsageOffPeakArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `FacilityUtilityAccount` values. */
export type FacilityUtilityAccountsConnectionUsageOnPeakArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `FacilityUtilityAccount` values. */
export type FacilityUtilityAccountsConnectionUsageSuperOffPeakArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `FacilityUtilityAccount` values. */
export type FacilityUtilityAccountsConnectionUsageSurchargeArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A `FacilityUtilityAccount` edge in the connection. */
export type FacilityUtilityAccountsEdge = {
  __typename?: 'FacilityUtilityAccountsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `FacilityUtilityAccount` at the end of the edge. */
  node: FacilityUtilityAccount;
};

/** Methods to use when ordering `FacilityUtilityAccount`. */
export enum FacilityUtilityAccountsOrderBy {
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UTILITY_ACCOUNT_ID_ASC = 'UTILITY_ACCOUNT_ID_ASC',
  UTILITY_ACCOUNT_ID_DESC = 'UTILITY_ACCOUNT_ID_DESC'
}

export type FacilityVariancePopulationAggregates = {
  __typename?: 'FacilityVariancePopulationAggregates';
  /**
   * Population variance of this field across the matching connection.
   *
   * ---
   *
   * The number of days we have active utility meters for a given serive type and time range.
   */
  activeMeterDatesCount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of customerLocationId across the matching connection */
  customerLocationId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of dataType2Test across the matching connection */
  dataType2Test?: Maybe<Scalars['Float']['output']>;
  /** Population variance of dataType3Test across the matching connection */
  dataType3Test?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of latitude across the matching connection */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** Population variance of longitude across the matching connection */
  longitude?: Maybe<Scalars['Float']['output']>;
  /** Population variance of pricingNodeId across the matching connection */
  pricingNodeId?: Maybe<Scalars['BigFloat']['output']>;
};

export type FacilityVariancePopulationAggregatesActiveMeterDatesCountArgs = {
  from?: InputMaybe<Scalars['String']['input']>;
  meterServiceTypes?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type FacilityVarianceSampleAggregates = {
  __typename?: 'FacilityVarianceSampleAggregates';
  /**
   * Sample variance of this field across the matching connection.
   *
   * ---
   *
   * The number of days we have active utility meters for a given serive type and time range.
   */
  activeMeterDatesCount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of customerLocationId across the matching connection */
  customerLocationId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of dataType2Test across the matching connection */
  dataType2Test?: Maybe<Scalars['Float']['output']>;
  /** Sample variance of dataType3Test across the matching connection */
  dataType3Test?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of latitude across the matching connection */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** Sample variance of longitude across the matching connection */
  longitude?: Maybe<Scalars['Float']['output']>;
  /** Sample variance of pricingNodeId across the matching connection */
  pricingNodeId?: Maybe<Scalars['BigFloat']['output']>;
};

export type FacilityVarianceSampleAggregatesActiveMeterDatesCountArgs = {
  from?: InputMaybe<Scalars['String']['input']>;
  meterServiceTypes?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type FleetAppointmentInput = {
  appointmentTime: Scalars['Datetime']['input'];
  confirmationId: Scalars['String']['input'];
  loadType: LoadType;
  orderType: OrderType;
};

export type FleetCheckInInput = {
  appointment: FleetAppointmentInput;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  driver?: InputMaybe<FleetDriverInput>;
  spaceId: Scalars['Int']['input'];
  trailer: FleetTrailerInput;
  yardId: Scalars['Int']['input'];
};

export type FleetCheckInPayload = {
  __typename?: 'FleetCheckInPayload';
  appointment: Appointment;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  driver?: Maybe<Driver>;
  space: Space;
  trailer: Trailer;
  trailerAppointment: TrailerAppointment;
};

export type FleetCheckOutInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  trailerAppointmentId: Scalars['Int']['input'];
  yardId: Scalars['Int']['input'];
};

export type FleetCheckOutPayload = {
  __typename?: 'FleetCheckOutPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  trailerAppointment?: Maybe<TrailerAppointment>;
};

export type FleetDriverInput = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  licenseCountry: Scalars['String']['input'];
  licenseNumber: Scalars['String']['input'];
  licenseState: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type FleetTrailerInput = {
  carrierCode: Scalars['String']['input'];
  carrierTrailerNumber: Scalars['String']['input'];
  dotNumber?: InputMaybe<Scalars['String']['input']>;
  powerSource?: InputMaybe<TrailerPowerSource>;
  supportEtru?: InputMaybe<Scalars['Boolean']['input']>;
  truMake?: InputMaybe<Scalars['String']['input']>;
  truModel?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against Float fields. All fields are combined with a logical ‘and.’ */
export type FloatFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Float']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Float']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Float']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Float']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Float']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Float']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Float']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

/** A gateway device at a facility used to connect other hardware. */
export type Gateway = Node & {
  __typename?: 'Gateway';
  /** Date and time when this gateway was created. */
  createdAt: Scalars['Datetime']['output'];
  /** Reads a single `Facility` that is related to this `Gateway`. */
  facility?: Maybe<Facility>;
  /** The facility where the gateway is installed. */
  facilityId?: Maybe<Scalars['Int']['output']>;
  /** The GIS geometry specifies the physical location of where the gateway is installed. */
  geometry?: Maybe<GeometryInterface>;
  /** The hardware ID for the gateway. */
  hardwareId?: Maybe<Scalars['String']['output']>;
  /** The identifier of the gateway. */
  id: Scalars['Int']['output'];
  /** The human-readable label for the gateway. */
  label: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `DataPoint` that is related to this `Gateway`. */
  status?: Maybe<DataPoint>;
  /** The gateway status. */
  statusId?: Maybe<Scalars['BigInt']['output']>;
  /** Date and time when this gateway was updated. */
  updatedAt: Scalars['Datetime']['output'];
};

/** A condition to be used against `Gateway` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type GatewayCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `geometry` field. */
  geometry?: InputMaybe<Scalars['GeoJSON']['input']>;
  /** Checks for equality with the object’s `hardwareId` field. */
  hardwareId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `label` field. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `statusId` field. */
  statusId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `Gateway` object types. All fields are combined with a logical ‘and.’ */
export type GatewayFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GatewayFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `hardwareId` field. */
  hardwareId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `label` field. */
  label?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GatewayFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GatewayFilter>>;
  /** Filter by the object’s `statusId` field. */
  statusId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `Gateway` */
export type GatewayInput = {
  /** Mutates a `DataPoint` as part of the payload */
  dataPoint?: InputMaybe<DataPointInput>;
  /** The facility where the gateway is installed. */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** The GIS geometry specifies the physical location of where the gateway is installed. */
  geometry?: InputMaybe<Scalars['GeoJSON']['input']>;
  /** The hardware ID for the gateway. */
  hardwareId?: InputMaybe<Scalars['String']['input']>;
  /** The human-readable label for the gateway. */
  label: Scalars['String']['input'];
  /** The gateway status. */
  statusId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** Represents an update to a `Gateway`. Fields that are set will be updated. */
export type GatewayPatch = {
  /** The facility where the gateway is installed. */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** The GIS geometry specifies the physical location of where the gateway is installed. */
  geometry?: InputMaybe<Scalars['GeoJSON']['input']>;
  /** The hardware ID for the gateway. */
  hardwareId?: InputMaybe<Scalars['String']['input']>;
  /** The human-readable label for the gateway. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** The gateway status. */
  statusId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A connection to a list of `Gateway` values. */
export type GatewaysConnection = {
  __typename?: 'GatewaysConnection';
  /** A list of edges which contains the `Gateway` and cursor to aid in pagination. */
  edges: Array<GatewaysEdge>;
  /** A list of `Gateway` objects. */
  nodes: Array<Gateway>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Returns the aggregate status timeseries data for the GatewaysConnection  */
  status?: Maybe<MetricDataConnection>;
  /** The count of *all* `Gateway` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A connection to a list of `Gateway` values. */
export type GatewaysConnectionStatusArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A `Gateway` edge in the connection. */
export type GatewaysEdge = {
  __typename?: 'GatewaysEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Gateway` at the end of the edge. */
  node: Gateway;
};

/** Methods to use when ordering `Gateway`. */
export enum GatewaysOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  GEOMETRY_ASC = 'GEOMETRY_ASC',
  GEOMETRY_DESC = 'GEOMETRY_DESC',
  HARDWARE_ID_ASC = 'HARDWARE_ID_ASC',
  HARDWARE_ID_DESC = 'HARDWARE_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LABEL_ASC = 'LABEL_ASC',
  LABEL_DESC = 'LABEL_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  STATUS_ID_ASC = 'STATUS_ID_ASC',
  STATUS_ID_DESC = 'STATUS_ID_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** All geometry XY types implement this interface */
export type GeometryGeometry = {
  /** Converts the object to GeoJSON */
  geojson?: Maybe<Scalars['GeoJSON']['output']>;
  /** Spatial reference identifier (SRID) */
  srid: Scalars['Int']['output'];
};

export type GeometryGeometryCollection = GeometryGeometry &
  GeometryInterface & {
    __typename?: 'GeometryGeometryCollection';
    geojson?: Maybe<Scalars['GeoJSON']['output']>;
    geometries?: Maybe<Array<Maybe<GeometryGeometry>>>;
    srid: Scalars['Int']['output'];
  };

export type GeometryGeometryCollectionM = GeometryGeometryM &
  GeometryInterface & {
    __typename?: 'GeometryGeometryCollectionM';
    geojson?: Maybe<Scalars['GeoJSON']['output']>;
    geometries?: Maybe<Array<Maybe<GeometryGeometryM>>>;
    srid: Scalars['Int']['output'];
  };

export type GeometryGeometryCollectionZ = GeometryGeometryZ &
  GeometryInterface & {
    __typename?: 'GeometryGeometryCollectionZ';
    geojson?: Maybe<Scalars['GeoJSON']['output']>;
    geometries?: Maybe<Array<Maybe<GeometryGeometryZ>>>;
    srid: Scalars['Int']['output'];
  };

export type GeometryGeometryCollectionZm = GeometryGeometryZm &
  GeometryInterface & {
    __typename?: 'GeometryGeometryCollectionZM';
    geojson?: Maybe<Scalars['GeoJSON']['output']>;
    geometries?: Maybe<Array<Maybe<GeometryGeometryZm>>>;
    srid: Scalars['Int']['output'];
  };

/** All geometry XYM types implement this interface */
export type GeometryGeometryM = {
  /** Converts the object to GeoJSON */
  geojson?: Maybe<Scalars['GeoJSON']['output']>;
  /** Spatial reference identifier (SRID) */
  srid: Scalars['Int']['output'];
};

/** All geometry XYZ types implement this interface */
export type GeometryGeometryZ = {
  /** Converts the object to GeoJSON */
  geojson?: Maybe<Scalars['GeoJSON']['output']>;
  /** Spatial reference identifier (SRID) */
  srid: Scalars['Int']['output'];
};

/** All geometry XYZM types implement this interface */
export type GeometryGeometryZm = {
  /** Converts the object to GeoJSON */
  geojson?: Maybe<Scalars['GeoJSON']['output']>;
  /** Spatial reference identifier (SRID) */
  srid: Scalars['Int']['output'];
};

/** All geometry types implement this interface */
export type GeometryInterface = {
  /** Converts the object to GeoJSON */
  geojson?: Maybe<Scalars['GeoJSON']['output']>;
  /** Spatial reference identifier (SRID) */
  srid: Scalars['Int']['output'];
};

export type GeometryLineString = GeometryGeometry &
  GeometryInterface & {
    __typename?: 'GeometryLineString';
    geojson?: Maybe<Scalars['GeoJSON']['output']>;
    points?: Maybe<Array<Maybe<GeometryPoint>>>;
    srid: Scalars['Int']['output'];
  };

export type GeometryLineStringM = GeometryGeometryM &
  GeometryInterface & {
    __typename?: 'GeometryLineStringM';
    geojson?: Maybe<Scalars['GeoJSON']['output']>;
    points?: Maybe<Array<Maybe<GeometryPointM>>>;
    srid: Scalars['Int']['output'];
  };

export type GeometryLineStringZ = GeometryGeometryZ &
  GeometryInterface & {
    __typename?: 'GeometryLineStringZ';
    geojson?: Maybe<Scalars['GeoJSON']['output']>;
    points?: Maybe<Array<Maybe<GeometryPointZ>>>;
    srid: Scalars['Int']['output'];
  };

export type GeometryLineStringZm = GeometryGeometryZm &
  GeometryInterface & {
    __typename?: 'GeometryLineStringZM';
    geojson?: Maybe<Scalars['GeoJSON']['output']>;
    points?: Maybe<Array<Maybe<GeometryPointZm>>>;
    srid: Scalars['Int']['output'];
  };

/** Represents GIS geometry and additional metadata. */
export type GeometryMetadatum = {
  __typename?: 'GeometryMetadatum';
  geometry?: Maybe<GeometryInterface>;
  metadata?: Maybe<Scalars['JSON']['output']>;
};

/** A filter to be used against `GeometryMetadatum` object types. All fields are combined with a logical ‘and.’ */
export type GeometryMetadatumFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GeometryMetadatumFilter>>;
  /** Filter by the object’s `metadata` field. */
  metadata?: InputMaybe<JsonFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GeometryMetadatumFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GeometryMetadatumFilter>>;
};

/** An input for mutations affecting `GeometryMetadatum` */
export type GeometryMetadatumInput = {
  geometry?: InputMaybe<Scalars['GeoJSON']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
};

export type GeometryMultiLineString = GeometryGeometry &
  GeometryInterface & {
    __typename?: 'GeometryMultiLineString';
    geojson?: Maybe<Scalars['GeoJSON']['output']>;
    lines?: Maybe<Array<Maybe<GeometryLineString>>>;
    srid: Scalars['Int']['output'];
  };

export type GeometryMultiLineStringM = GeometryGeometryM &
  GeometryInterface & {
    __typename?: 'GeometryMultiLineStringM';
    geojson?: Maybe<Scalars['GeoJSON']['output']>;
    lines?: Maybe<Array<Maybe<GeometryLineStringM>>>;
    srid: Scalars['Int']['output'];
  };

export type GeometryMultiLineStringZ = GeometryGeometryZ &
  GeometryInterface & {
    __typename?: 'GeometryMultiLineStringZ';
    geojson?: Maybe<Scalars['GeoJSON']['output']>;
    lines?: Maybe<Array<Maybe<GeometryLineStringZ>>>;
    srid: Scalars['Int']['output'];
  };

export type GeometryMultiLineStringZm = GeometryGeometryZm &
  GeometryInterface & {
    __typename?: 'GeometryMultiLineStringZM';
    geojson?: Maybe<Scalars['GeoJSON']['output']>;
    lines?: Maybe<Array<Maybe<GeometryLineStringZm>>>;
    srid: Scalars['Int']['output'];
  };

export type GeometryMultiPoint = GeometryGeometry &
  GeometryInterface & {
    __typename?: 'GeometryMultiPoint';
    geojson?: Maybe<Scalars['GeoJSON']['output']>;
    points?: Maybe<Array<Maybe<GeometryPoint>>>;
    srid: Scalars['Int']['output'];
  };

export type GeometryMultiPointM = GeometryGeometryM &
  GeometryInterface & {
    __typename?: 'GeometryMultiPointM';
    geojson?: Maybe<Scalars['GeoJSON']['output']>;
    points?: Maybe<Array<Maybe<GeometryPointM>>>;
    srid: Scalars['Int']['output'];
  };

export type GeometryMultiPointZ = GeometryGeometryZ &
  GeometryInterface & {
    __typename?: 'GeometryMultiPointZ';
    geojson?: Maybe<Scalars['GeoJSON']['output']>;
    points?: Maybe<Array<Maybe<GeometryPointZ>>>;
    srid: Scalars['Int']['output'];
  };

export type GeometryMultiPointZm = GeometryGeometryZm &
  GeometryInterface & {
    __typename?: 'GeometryMultiPointZM';
    geojson?: Maybe<Scalars['GeoJSON']['output']>;
    points?: Maybe<Array<Maybe<GeometryPointZm>>>;
    srid: Scalars['Int']['output'];
  };

export type GeometryMultiPolygon = GeometryGeometry &
  GeometryInterface & {
    __typename?: 'GeometryMultiPolygon';
    geojson?: Maybe<Scalars['GeoJSON']['output']>;
    polygons?: Maybe<Array<Maybe<GeometryPolygon>>>;
    srid: Scalars['Int']['output'];
  };

export type GeometryMultiPolygonM = GeometryGeometryM &
  GeometryInterface & {
    __typename?: 'GeometryMultiPolygonM';
    geojson?: Maybe<Scalars['GeoJSON']['output']>;
    polygons?: Maybe<Array<Maybe<GeometryPolygonM>>>;
    srid: Scalars['Int']['output'];
  };

export type GeometryMultiPolygonZ = GeometryGeometryZ &
  GeometryInterface & {
    __typename?: 'GeometryMultiPolygonZ';
    geojson?: Maybe<Scalars['GeoJSON']['output']>;
    polygons?: Maybe<Array<Maybe<GeometryPolygonZ>>>;
    srid: Scalars['Int']['output'];
  };

export type GeometryMultiPolygonZm = GeometryGeometryZm &
  GeometryInterface & {
    __typename?: 'GeometryMultiPolygonZM';
    geojson?: Maybe<Scalars['GeoJSON']['output']>;
    polygons?: Maybe<Array<Maybe<GeometryPolygonZm>>>;
    srid: Scalars['Int']['output'];
  };

export type GeometryPoint = GeometryGeometry &
  GeometryInterface & {
    __typename?: 'GeometryPoint';
    geojson?: Maybe<Scalars['GeoJSON']['output']>;
    srid: Scalars['Int']['output'];
    x: Scalars['Float']['output'];
    y: Scalars['Float']['output'];
  };

export type GeometryPointM = GeometryGeometryM &
  GeometryInterface & {
    __typename?: 'GeometryPointM';
    geojson?: Maybe<Scalars['GeoJSON']['output']>;
    srid: Scalars['Int']['output'];
    x: Scalars['Float']['output'];
    y: Scalars['Float']['output'];
  };

export type GeometryPointZ = GeometryGeometryZ &
  GeometryInterface & {
    __typename?: 'GeometryPointZ';
    geojson?: Maybe<Scalars['GeoJSON']['output']>;
    srid: Scalars['Int']['output'];
    x: Scalars['Float']['output'];
    y: Scalars['Float']['output'];
    z: Scalars['Float']['output'];
  };

export type GeometryPointZm = GeometryGeometryZm &
  GeometryInterface & {
    __typename?: 'GeometryPointZM';
    geojson?: Maybe<Scalars['GeoJSON']['output']>;
    srid: Scalars['Int']['output'];
    x: Scalars['Float']['output'];
    y: Scalars['Float']['output'];
    z: Scalars['Float']['output'];
  };

export type GeometryPolygon = GeometryGeometry &
  GeometryInterface & {
    __typename?: 'GeometryPolygon';
    exterior?: Maybe<GeometryLineString>;
    geojson?: Maybe<Scalars['GeoJSON']['output']>;
    interiors?: Maybe<Array<Maybe<GeometryLineString>>>;
    srid: Scalars['Int']['output'];
  };

export type GeometryPolygonM = GeometryGeometryM &
  GeometryInterface & {
    __typename?: 'GeometryPolygonM';
    exterior?: Maybe<GeometryLineStringM>;
    geojson?: Maybe<Scalars['GeoJSON']['output']>;
    interiors?: Maybe<Array<Maybe<GeometryLineStringM>>>;
    srid: Scalars['Int']['output'];
  };

export type GeometryPolygonZ = GeometryGeometryZ &
  GeometryInterface & {
    __typename?: 'GeometryPolygonZ';
    exterior?: Maybe<GeometryLineStringZ>;
    geojson?: Maybe<Scalars['GeoJSON']['output']>;
    interiors?: Maybe<Array<Maybe<GeometryLineStringZ>>>;
    srid: Scalars['Int']['output'];
  };

export type GeometryPolygonZm = GeometryGeometryZm &
  GeometryInterface & {
    __typename?: 'GeometryPolygonZM';
    exterior?: Maybe<GeometryLineStringZm>;
    geojson?: Maybe<Scalars['GeoJSON']['output']>;
    interiors?: Maybe<Array<Maybe<GeometryLineStringZm>>>;
    srid: Scalars['Int']['output'];
  };

/** A `JSON` edge in the connection. */
export type GroupingEdge = {
  __typename?: 'GroupingEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `JSON` at the end of the edge. */
  node?: Maybe<Scalars['JSON']['output']>;
};

/** A connection to a list of `JSON` values. */
export type GroupingsConnection = {
  __typename?: 'GroupingsConnection';
  /** A list of edges which contains the `JSON` and cursor to aid in pagination. */
  edges: Array<GroupingEdge>;
  /** A list of `JSON` objects. */
  nodes: Array<Maybe<Scalars['JSON']['output']>>;
  /** The count of *all* `JSON` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A connection to a list of `JSON` values. */
export type GroupingsWithFacilitiesConnection = {
  __typename?: 'GroupingsWithFacilitiesConnection';
  /** A list of edges which contains the `JSON` and cursor to aid in pagination. */
  edges: Array<GroupingsWithFacilityEdge>;
  /** A list of `JSON` objects. */
  nodes: Array<Maybe<Scalars['JSON']['output']>>;
  /** The count of *all* `JSON` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `JSON` edge in the connection. */
export type GroupingsWithFacilityEdge = {
  __typename?: 'GroupingsWithFacilityEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `JSON` at the end of the edge. */
  node?: Maybe<Scalars['JSON']['output']>;
};

export type HavingBigfloatFilter = {
  equalTo?: InputMaybe<Scalars['BigFloat']['input']>;
  greaterThan?: InputMaybe<Scalars['BigFloat']['input']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['BigFloat']['input']>;
  lessThan?: InputMaybe<Scalars['BigFloat']['input']>;
  lessThanOrEqualTo?: InputMaybe<Scalars['BigFloat']['input']>;
  notEqualTo?: InputMaybe<Scalars['BigFloat']['input']>;
};

export type HavingBigintFilter = {
  equalTo?: InputMaybe<Scalars['BigInt']['input']>;
  greaterThan?: InputMaybe<Scalars['BigInt']['input']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  lessThan?: InputMaybe<Scalars['BigInt']['input']>;
  lessThanOrEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  notEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
};

export type HavingDatetimeFilter = {
  equalTo?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  lessThan?: InputMaybe<Scalars['Datetime']['input']>;
  lessThanOrEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  notEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
};

export type HavingFloatFilter = {
  equalTo?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['Float']['input']>;
  lessThan?: InputMaybe<Scalars['Float']['input']>;
  lessThanOrEqualTo?: InputMaybe<Scalars['Float']['input']>;
  notEqualTo?: InputMaybe<Scalars['Float']['input']>;
};

export type HavingIntFilter = {
  equalTo?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  notEqualTo?: InputMaybe<Scalars['Int']['input']>;
};

export type Health = {
  __typename?: 'Health';
  id: Scalars['String']['output'];
};

export type Identity = {
  authorizationType: Scalars['String']['output'];
  id: Scalars['String']['output'];
  signature: Scalars['String']['output'];
  type: AccessTokenType;
};

/** An inbound or outbound load */
export type InboundOutboundLoad = Node & {
  __typename?: 'InboundOutboundLoad';
  /** The time when the order occurred */
  appointmentTime?: Maybe<Scalars['Datetime']['output']>;
  /** The unique reference number for the load */
  confirmationId?: Maybe<Scalars['String']['output']>;
  /** The time at which the record was created */
  createdAt: Scalars['Datetime']['output'];
  /** The globally unique external deletion identifier of the record. Sometimes this is different from sourceId due to change tracking semantics */
  deleteId?: Maybe<Scalars['String']['output']>;
  /** The time at which the record was deleted */
  deletedAt?: Maybe<Scalars['Datetime']['output']>;
  /** Reads a single `Facility` that is related to this `InboundOutboundLoad`. */
  facility?: Maybe<Facility>;
  /** The facility where the order occurred */
  facilityId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['BigInt']['output'];
  /** The direction of load */
  isInbound: Scalars['Boolean']['output'];
  /** The type of load */
  loadType?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The globally unique external identifier of the record from the original source system */
  sourceId: Scalars['String']['output'];
  /** The time at which the record was updated */
  updatedAt: Scalars['Datetime']['output'];
  /** The version of the record */
  version?: Maybe<Scalars['BigInt']['output']>;
};

/**
 * A condition to be used against `InboundOutboundLoad` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type InboundOutboundLoadCondition = {
  /** Checks for equality with the object’s `appointmentTime` field. */
  appointmentTime?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `confirmationId` field. */
  confirmationId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `deleteId` field. */
  deleteId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `isInbound` field. */
  isInbound?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `loadType` field. */
  loadType?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `sourceId` field. */
  sourceId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `version` field. */
  version?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A filter to be used against `InboundOutboundLoad` object types. All fields are combined with a logical ‘and.’ */
export type InboundOutboundLoadFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<InboundOutboundLoadFilter>>;
  /** Filter by the object’s `appointmentTime` field. */
  appointmentTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `confirmationId` field. */
  confirmationId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deleteId` field. */
  deleteId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `isInbound` field. */
  isInbound?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `loadType` field. */
  loadType?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<InboundOutboundLoadFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<InboundOutboundLoadFilter>>;
  /** Filter by the object’s `sourceId` field. */
  sourceId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `version` field. */
  version?: InputMaybe<BigIntFilter>;
};

/** An input for mutations affecting `InboundOutboundLoad` */
export type InboundOutboundLoadInput = {
  /** The time when the order occurred */
  appointmentTime?: InputMaybe<Scalars['Datetime']['input']>;
  /** The unique reference number for the load */
  confirmationId?: InputMaybe<Scalars['String']['input']>;
  /** The facility where the order occurred */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** The direction of load */
  isInbound: Scalars['Boolean']['input'];
  /** The type of load */
  loadType?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique external identifier of the record from the original source system */
  sourceId: Scalars['String']['input'];
};

/** Represents an update to a `InboundOutboundLoad`. Fields that are set will be updated. */
export type InboundOutboundLoadPatch = {
  /** The time when the order occurred */
  appointmentTime?: InputMaybe<Scalars['Datetime']['input']>;
  /** The unique reference number for the load */
  confirmationId?: InputMaybe<Scalars['String']['input']>;
  /** The facility where the order occurred */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** The direction of load */
  isInbound?: InputMaybe<Scalars['Boolean']['input']>;
  /** The type of load */
  loadType?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique external identifier of the record from the original source system */
  sourceId?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `InboundOutboundLoad` values. */
export type InboundOutboundLoadsConnection = {
  __typename?: 'InboundOutboundLoadsConnection';
  /** A list of edges which contains the `InboundOutboundLoad` and cursor to aid in pagination. */
  edges: Array<InboundOutboundLoadsEdge>;
  /** A list of `InboundOutboundLoad` objects. */
  nodes: Array<InboundOutboundLoad>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `InboundOutboundLoad` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `InboundOutboundLoad` edge in the connection. */
export type InboundOutboundLoadsEdge = {
  __typename?: 'InboundOutboundLoadsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `InboundOutboundLoad` at the end of the edge. */
  node: InboundOutboundLoad;
};

/** Methods to use when ordering `InboundOutboundLoad`. */
export enum InboundOutboundLoadsOrderBy {
  APPOINTMENT_TIME_ASC = 'APPOINTMENT_TIME_ASC',
  APPOINTMENT_TIME_DESC = 'APPOINTMENT_TIME_DESC',
  CONFIRMATION_ID_ASC = 'CONFIRMATION_ID_ASC',
  CONFIRMATION_ID_DESC = 'CONFIRMATION_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DELETED_AT_ASC = 'DELETED_AT_ASC',
  DELETED_AT_DESC = 'DELETED_AT_DESC',
  DELETE_ID_ASC = 'DELETE_ID_ASC',
  DELETE_ID_DESC = 'DELETE_ID_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  IS_INBOUND_ASC = 'IS_INBOUND_ASC',
  IS_INBOUND_DESC = 'IS_INBOUND_DESC',
  LOAD_TYPE_ASC = 'LOAD_TYPE_ASC',
  LOAD_TYPE_DESC = 'LOAD_TYPE_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  SOURCE_ID_ASC = 'SOURCE_ID_ASC',
  SOURCE_ID_DESC = 'SOURCE_ID_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  VERSION_ASC = 'VERSION_ASC',
  VERSION_DESC = 'VERSION_DESC'
}

/** An incident tracks when a check contains one or more monitors that had a detection. */
export type Incident = Node & {
  __typename?: 'Incident';
  /** When the incident was acknowledged. */
  acknowledgedAt?: Maybe<Scalars['Datetime']['output']>;
  /** Who acknowledged the incident. */
  acknowledgedBy?: Maybe<Actor>;
  /** Returns the check associated with a given incident. */
  check?: Maybe<Check>;
  /** Returns the id of the check associated with a given incident. */
  checkId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `CheckMonitor` that is related to this `Incident`. */
  checkMonitor?: Maybe<CheckMonitor>;
  /** The check monitor. */
  checkMonitorId: Scalars['Int']['output'];
  /** Returns the name of the check associated with a given incident. */
  checkName?: Maybe<Scalars['String']['output']>;
  /** When the incident was closed. */
  closedAt?: Maybe<Scalars['Datetime']['output']>;
  closedBy?: Maybe<Actor>;
  /** A message describing how the incident was resolved. */
  closureMessage?: Maybe<Scalars['String']['output']>;
  /** The time the record was created. */
  createdAt: Scalars['Datetime']['output'];
  /** Returns the facility associated with a given incident. */
  facility?: Maybe<Facility>;
  /** Returns the facility ID associated with a given incident. */
  facilityId?: Maybe<Scalars['Int']['output']>;
  /** Returns the name of the facility associated with a given incident. */
  facilityName?: Maybe<Scalars['String']['output']>;
  /** Returns the first time when a reminder is expected for the incident, if any. */
  firstExpectedReminderTime?: Maybe<Scalars['Datetime']['output']>;
  /** The identifier of the incident. */
  id: Scalars['Int']['output'];
  /** Reads and enables pagination through a set of `IncidentLog`. */
  incidentLogs: IncidentLogsConnection;
  /** Indicates if the incident is active. */
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether reminders will be sent while the incident is active. */
  isSilenced: Scalars['Boolean']['output'];
  /** Returns the monitor associated with a given incident. */
  monitor?: Maybe<Monitor>;
  /** Reads a single `MonitorDetection` that is related to this `Incident`. */
  monitorDetection?: Maybe<MonitorDetection>;
  /** The monitor detection. */
  monitorDetectionId: Scalars['BigInt']['output'];
  /** Returns the name of the monitor associated with a given incident. */
  monitorName?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** When the incident was resolved. */
  resolvedAt?: Maybe<Scalars['Datetime']['output']>;
  /** Returns the status of the incident. */
  status?: Maybe<IncidentStatusType>;
  /** When the incident was triggered. */
  triggeredAt: Scalars['Datetime']['output'];
  /** The time the record was updated. */
  updatedAt: Scalars['Datetime']['output'];
};

/** An incident tracks when a check contains one or more monitors that had a detection. */
export type IncidentIncidentLogsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<IncidentLogCondition>;
  filter?: InputMaybe<IncidentLogFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IncidentLogsOrderBy>>;
};

/**
 * A condition to be used against `Incident` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type IncidentCondition = {
  /** Checks for equality with the object’s `acknowledgedAt` field. */
  acknowledgedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `acknowledgedBy` field. */
  acknowledgedBy?: InputMaybe<ActorInput>;
  /** Checks for equality with the object’s `checkId` field. */
  checkId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `checkMonitorId` field. */
  checkMonitorId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `checkName` field. */
  checkName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `closedAt` field. */
  closedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `closedBy` field. */
  closedBy?: InputMaybe<ActorInput>;
  /** Checks for equality with the object’s `closureMessage` field. */
  closureMessage?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `facilityName` field. */
  facilityName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `firstExpectedReminderTime` field. */
  firstExpectedReminderTime?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `isSilenced` field. */
  isSilenced?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `monitorDetectionId` field. */
  monitorDetectionId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `monitorName` field. */
  monitorName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `resolvedAt` field. */
  resolvedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<IncidentStatusType>;
  /** Checks for equality with the object’s `triggeredAt` field. */
  triggeredAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `Incident` object types. All fields are combined with a logical ‘and.’ */
export type IncidentFilter = {
  /** Filter by the object’s `acknowledgedAt` field. */
  acknowledgedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `acknowledgedBy` field. */
  acknowledgedBy?: InputMaybe<ActorFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<IncidentFilter>>;
  /** Filter by the object’s `checkId` field. */
  checkId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `checkMonitorId` field. */
  checkMonitorId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `checkName` field. */
  checkName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `closedAt` field. */
  closedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `closedBy` field. */
  closedBy?: InputMaybe<ActorFilter>;
  /** Filter by the object’s `closureMessage` field. */
  closureMessage?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `facilityName` field. */
  facilityName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `firstExpectedReminderTime` field. */
  firstExpectedReminderTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isActive` field. */
  isActive?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isSilenced` field. */
  isSilenced?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `monitorDetectionId` field. */
  monitorDetectionId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `monitorName` field. */
  monitorName?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<IncidentFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<IncidentFilter>>;
  /** Filter by the object’s `resolvedAt` field. */
  resolvedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<IncidentStatusTypeFilter>;
  /** Filter by the object’s `triggeredAt` field. */
  triggeredAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `Incident` */
export type IncidentInput = {
  /** When the incident was acknowledged. */
  acknowledgedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** The check monitor. */
  checkMonitorId: Scalars['Int']['input'];
  /** When the incident was closed. */
  closedAt?: InputMaybe<Scalars['Datetime']['input']>;
  closedBy?: InputMaybe<ActorInput>;
  /** A message describing how the incident was resolved. */
  closureMessage?: InputMaybe<Scalars['String']['input']>;
  /** Indicates whether reminders will be sent while the incident is active. */
  isSilenced?: InputMaybe<Scalars['Boolean']['input']>;
  /** The monitor detection. */
  monitorDetectionId: Scalars['BigInt']['input'];
  /** When the incident was resolved. */
  resolvedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** When the incident was triggered. */
  triggeredAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A log of transitions and events for an incident, such acknowledgement, notifications sent, etc. */
export type IncidentLog = {
  __typename?: 'IncidentLog';
  /** Who created the record. */
  actor: Actor;
  /** The type of event for the log. */
  event: Scalars['String']['output'];
  /** Reads a single `Incident` that is related to this `IncidentLog`. */
  incident?: Maybe<Incident>;
  /** The incident. */
  incidentId: Scalars['Int']['output'];
  /** Additional information about the log. */
  metadata: Scalars['JSON']['output'];
  /** The time when the log occurred. */
  time: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `IncidentLog` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type IncidentLogCondition = {
  /** Checks for equality with the object’s `actor` field. */
  actor?: InputMaybe<ActorInput>;
  /** Checks for equality with the object’s `event` field. */
  event?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `incidentId` field. */
  incidentId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `metadata` field. */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `time` field. */
  time?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `IncidentLog` object types. All fields are combined with a logical ‘and.’ */
export type IncidentLogFilter = {
  /** Filter by the object’s `actor` field. */
  actor?: InputMaybe<ActorFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<IncidentLogFilter>>;
  /** Filter by the object’s `event` field. */
  event?: InputMaybe<StringFilter>;
  /** Filter by the object’s `incidentId` field. */
  incidentId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `metadata` field. */
  metadata?: InputMaybe<JsonFilter>;
  /** Negates the expression. */
  not?: InputMaybe<IncidentLogFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<IncidentLogFilter>>;
  /** Filter by the object’s `time` field. */
  time?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `IncidentLog` */
export type IncidentLogInput = {
  /** The type of event for the log. */
  event: Scalars['String']['input'];
  /** The incident. */
  incidentId: Scalars['Int']['input'];
  /** Additional information about the log. */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** The time when the log occurred. */
  time?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A connection to a list of `IncidentLog` values. */
export type IncidentLogsConnection = {
  __typename?: 'IncidentLogsConnection';
  /** A list of edges which contains the `IncidentLog` and cursor to aid in pagination. */
  edges: Array<IncidentLogsEdge>;
  /** A list of `IncidentLog` objects. */
  nodes: Array<IncidentLog>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `IncidentLog` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `IncidentLog` edge in the connection. */
export type IncidentLogsEdge = {
  __typename?: 'IncidentLogsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `IncidentLog` at the end of the edge. */
  node: IncidentLog;
};

/** Methods to use when ordering `IncidentLog`. */
export enum IncidentLogsOrderBy {
  ACTOR_ASC = 'ACTOR_ASC',
  ACTOR_DESC = 'ACTOR_DESC',
  EVENT_ASC = 'EVENT_ASC',
  EVENT_DESC = 'EVENT_DESC',
  INCIDENT_ID_ASC = 'INCIDENT_ID_ASC',
  INCIDENT_ID_DESC = 'INCIDENT_ID_DESC',
  METADATA_ASC = 'METADATA_ASC',
  METADATA_DESC = 'METADATA_DESC',
  NATURAL = 'NATURAL',
  TIME_ASC = 'TIME_ASC',
  TIME_DESC = 'TIME_DESC'
}

/** Represents an update to a `Incident`. Fields that are set will be updated. */
export type IncidentPatch = {
  /** When the incident was acknowledged. */
  acknowledgedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** The check monitor. */
  checkMonitorId?: InputMaybe<Scalars['Int']['input']>;
  /** When the incident was closed. */
  closedAt?: InputMaybe<Scalars['Datetime']['input']>;
  closedBy?: InputMaybe<ActorInput>;
  /** A message describing how the incident was resolved. */
  closureMessage?: InputMaybe<Scalars['String']['input']>;
  /** Indicates whether reminders will be sent while the incident is active. */
  isSilenced?: InputMaybe<Scalars['Boolean']['input']>;
  /** The monitor detection. */
  monitorDetectionId?: InputMaybe<Scalars['BigInt']['input']>;
  /** When the incident was resolved. */
  resolvedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** When the incident was triggered. */
  triggeredAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export enum IncidentStatusType {
  ACKNOWLEDGED = 'ACKNOWLEDGED',
  ACTIVE = 'ACTIVE',
  CLOSED = 'CLOSED',
  RESOLVED = 'RESOLVED'
}

/** A filter to be used against IncidentStatusType fields. All fields are combined with a logical ‘and.’ */
export type IncidentStatusTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<IncidentStatusType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<IncidentStatusType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<IncidentStatusType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<IncidentStatusType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<IncidentStatusType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<IncidentStatusType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<IncidentStatusType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<IncidentStatusType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<IncidentStatusType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<IncidentStatusType>>;
};

/** A connection to a list of `Incident` values. */
export type IncidentsConnection = {
  __typename?: 'IncidentsConnection';
  /** A list of edges which contains the `Incident` and cursor to aid in pagination. */
  edges: Array<IncidentsEdge>;
  /** A list of `Incident` objects. */
  nodes: Array<Incident>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Incident` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Incident` edge in the connection. */
export type IncidentsEdge = {
  __typename?: 'IncidentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Incident` at the end of the edge. */
  node: Incident;
};

/** Methods to use when ordering `Incident`. */
export enum IncidentsOrderBy {
  ACKNOWLEDGED_AT_ASC = 'ACKNOWLEDGED_AT_ASC',
  ACKNOWLEDGED_AT_DESC = 'ACKNOWLEDGED_AT_DESC',
  ACKNOWLEDGED_BY_ASC = 'ACKNOWLEDGED_BY_ASC',
  ACKNOWLEDGED_BY_DESC = 'ACKNOWLEDGED_BY_DESC',
  CHECK_MONITOR_ID_ASC = 'CHECK_MONITOR_ID_ASC',
  CHECK_MONITOR_ID_DESC = 'CHECK_MONITOR_ID_DESC',
  CHECK_NAME_ASC = 'CHECK_NAME_ASC',
  CHECK_NAME_DESC = 'CHECK_NAME_DESC',
  CLOSED_AT_ASC = 'CLOSED_AT_ASC',
  CLOSED_AT_DESC = 'CLOSED_AT_DESC',
  CLOSED_BY_ASC = 'CLOSED_BY_ASC',
  CLOSED_BY_DESC = 'CLOSED_BY_DESC',
  CLOSURE_MESSAGE_ASC = 'CLOSURE_MESSAGE_ASC',
  CLOSURE_MESSAGE_DESC = 'CLOSURE_MESSAGE_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  FACILITY_NAME_ASC = 'FACILITY_NAME_ASC',
  FACILITY_NAME_DESC = 'FACILITY_NAME_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  IS_SILENCED_ASC = 'IS_SILENCED_ASC',
  IS_SILENCED_DESC = 'IS_SILENCED_DESC',
  MONITOR_DETECTION_ID_ASC = 'MONITOR_DETECTION_ID_ASC',
  MONITOR_DETECTION_ID_DESC = 'MONITOR_DETECTION_ID_DESC',
  MONITOR_NAME_ASC = 'MONITOR_NAME_ASC',
  MONITOR_NAME_DESC = 'MONITOR_NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  RESOLVED_AT_ASC = 'RESOLVED_AT_ASC',
  RESOLVED_AT_DESC = 'RESOLVED_AT_DESC',
  STATUS_ASC = 'STATUS_ASC',
  STATUS_DESC = 'STATUS_DESC',
  TRIGGERED_AT_ASC = 'TRIGGERED_AT_ASC',
  TRIGGERED_AT_DESC = 'TRIGGERED_AT_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

export type InputFacilityMetricData = {
  data: Scalars['JSON']['input'];
  facilityId: Scalars['Int']['input'];
  label: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  time: Scalars['Datetime']['input'];
};

export type InputMetricData = {
  data: Scalars['JSON']['input'];
  label: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  sourceId: Scalars['String']['input'];
  time: Scalars['Datetime']['input'];
};

/** A filter to be used against Int fields. All fields are combined with a logical ‘and.’ */
export type IntFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Int']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Int']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** A filter to be used against Int List fields. All fields are combined with a logical ‘and.’ */
export type IntListFilter = {
  /** Any array item is equal to the specified value. */
  anyEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Any array item is greater than the specified value. */
  anyGreaterThan?: InputMaybe<Scalars['Int']['input']>;
  /** Any array item is greater than or equal to the specified value. */
  anyGreaterThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Any array item is less than the specified value. */
  anyLessThan?: InputMaybe<Scalars['Int']['input']>;
  /** Any array item is less than or equal to the specified value. */
  anyLessThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Any array item is not equal to the specified value. */
  anyNotEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Contained by the specified list of values. */
  containedBy?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Contains the specified list of values. */
  contains?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Overlaps the specified list of values. */
  overlaps?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

/** An integration provider. */
export type IntegrationProvider = Node & {
  __typename?: 'IntegrationProvider';
  /** General configurations specific to this integration provider. */
  authConfig: Scalars['JSON']['output'];
  /** The authentication type utilized by this integration provider. */
  authType: AuthType;
  /** A JSONSchema that defines the per-customer configurations supported by this integration provider. */
  configSchema: Scalars['JSON']['output'];
  /** The time the record was created. */
  createdAt: Scalars['Datetime']['output'];
  /** Reads a single `CustomerIntegration` that is related to this `IntegrationProvider`. */
  customerIntegration?: Maybe<CustomerIntegration>;
  /** The display name of the integration provider. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The internal identifier of the integration provider. */
  id: Scalars['Int']['output'];
  /** The unique name of the integration provider. */
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The time the record was updated. */
  updatedAt: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `IntegrationProvider` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type IntegrationProviderCondition = {
  /** Checks for equality with the object’s `authConfig` field. */
  authConfig?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `authType` field. */
  authType?: InputMaybe<AuthType>;
  /** Checks for equality with the object’s `configSchema` field. */
  configSchema?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `displayName` field. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `IntegrationProvider` object types. All fields are combined with a logical ‘and.’ */
export type IntegrationProviderFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<IntegrationProviderFilter>>;
  /** Filter by the object’s `authConfig` field. */
  authConfig?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `authType` field. */
  authType?: InputMaybe<AuthTypeFilter>;
  /** Filter by the object’s `configSchema` field. */
  configSchema?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `displayName` field. */
  displayName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<IntegrationProviderFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<IntegrationProviderFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** A connection to a list of `IntegrationProvider` values. */
export type IntegrationProvidersConnection = {
  __typename?: 'IntegrationProvidersConnection';
  /** A list of edges which contains the `IntegrationProvider` and cursor to aid in pagination. */
  edges: Array<IntegrationProvidersEdge>;
  /** A list of `IntegrationProvider` objects. */
  nodes: Array<IntegrationProvider>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `IntegrationProvider` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `IntegrationProvider` edge in the connection. */
export type IntegrationProvidersEdge = {
  __typename?: 'IntegrationProvidersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `IntegrationProvider` at the end of the edge. */
  node: IntegrationProvider;
};

/** Methods to use when ordering `IntegrationProvider`. */
export enum IntegrationProvidersOrderBy {
  AUTH_CONFIG_ASC = 'AUTH_CONFIG_ASC',
  AUTH_CONFIG_DESC = 'AUTH_CONFIG_DESC',
  AUTH_TYPE_ASC = 'AUTH_TYPE_ASC',
  AUTH_TYPE_DESC = 'AUTH_TYPE_DESC',
  CONFIG_SCHEMA_ASC = 'CONFIG_SCHEMA_ASC',
  CONFIG_SCHEMA_DESC = 'CONFIG_SCHEMA_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DISPLAY_NAME_ASC = 'DISPLAY_NAME_ASC',
  DISPLAY_NAME_DESC = 'DISPLAY_NAME_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

export enum IntegrationType {
  UTILITY_BILLING = 'UTILITY_BILLING'
}

/** An interval of time that has passed where the smallest distinct unit is a second. */
export type Interval = {
  __typename?: 'Interval';
  /** A quantity of days. */
  days?: Maybe<Scalars['Int']['output']>;
  /** A quantity of hours. */
  hours?: Maybe<Scalars['Int']['output']>;
  /** A quantity of minutes. */
  minutes?: Maybe<Scalars['Int']['output']>;
  /** A quantity of months. */
  months?: Maybe<Scalars['Int']['output']>;
  /**
   * A quantity of seconds. This is the only non-integer field, as all the other
   * fields will dump their overflow into a smaller unit of time. Intervals don’t
   * have a smaller unit than seconds.
   */
  seconds?: Maybe<Scalars['Float']['output']>;
  /** A quantity of years. */
  years?: Maybe<Scalars['Int']['output']>;
};

/** A filter to be used against Interval fields. All fields are combined with a logical ‘and.’ */
export type IntervalFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<IntervalInput>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<IntervalInput>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<IntervalInput>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<IntervalInput>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<IntervalInput>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<IntervalInput>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<IntervalInput>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<IntervalInput>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<IntervalInput>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<IntervalInput>>;
};

/** An interval of time that has passed where the smallest distinct unit is a second. */
export type IntervalInput = {
  /** A quantity of days. */
  days?: InputMaybe<Scalars['Int']['input']>;
  /** A quantity of hours. */
  hours?: InputMaybe<Scalars['Int']['input']>;
  /** A quantity of minutes. */
  minutes?: InputMaybe<Scalars['Int']['input']>;
  /** A quantity of months. */
  months?: InputMaybe<Scalars['Int']['input']>;
  /**
   * A quantity of seconds. This is the only non-integer field, as all the other
   * fields will dump their overflow into a smaller unit of time. Intervals don’t
   * have a smaller unit than seconds.
   */
  seconds?: InputMaybe<Scalars['Float']['input']>;
  /** A quantity of years. */
  years?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against JSON fields. All fields are combined with a logical ‘and.’ */
export type JsonFilter = {
  /** Contained by the specified JSON. */
  containedBy?: InputMaybe<Scalars['JSON']['input']>;
  /** Contains the specified JSON. */
  contains?: InputMaybe<Scalars['JSON']['input']>;
  /** Contains all of the specified keys. */
  containsAllKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains any of the specified keys. */
  containsAnyKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains the specified key. */
  containsKey?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['JSON']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['JSON']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['JSON']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['JSON']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['JSON']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
};

/** A filter to be used against JSON List fields. All fields are combined with a logical ‘and.’ */
export type JsonListFilter = {
  /** Any array item is equal to the specified value. */
  anyEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Any array item is greater than the specified value. */
  anyGreaterThan?: InputMaybe<Scalars['JSON']['input']>;
  /** Any array item is greater than or equal to the specified value. */
  anyGreaterThanOrEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Any array item is less than the specified value. */
  anyLessThan?: InputMaybe<Scalars['JSON']['input']>;
  /** Any array item is less than or equal to the specified value. */
  anyLessThanOrEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Any array item is not equal to the specified value. */
  anyNotEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Contained by the specified list of values. */
  containedBy?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  /** Contains the specified list of values. */
  contains?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<
    Array<InputMaybe<Scalars['JSON']['input']>>
  >;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  /** Overlaps the specified list of values. */
  overlaps?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};

/** Representation of a physical liquid header in a refrigeration system. */
export type LiquidHeader = Node & {
  __typename?: 'LiquidHeader';
  /** The time the record was created. */
  createdAt: Scalars['Datetime']['output'];
  /** The design pressure (psig) for the liquid header. */
  designPressurePsig?: Maybe<Scalars['BigFloat']['output']>;
  /** The design temperature (F) for the liquid header. */
  designTempF?: Maybe<Scalars['BigFloat']['output']>;
  /** The unique identifier for the liquid header. */
  id: Scalars['Int']['output'];
  /** The display label of the liquid header. */
  label: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `LiquidHeadersEvaporator`. */
  liquidHeadersEvaporators: LiquidHeadersEvaporatorsConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `RefrigerationSystem` that is related to this `LiquidHeader`. */
  refrigerationSystem?: Maybe<RefrigerationSystem>;
  /** References the refrigeration system this liquid header belongs to. */
  refrigerationSystemId: Scalars['Int']['output'];
  /** The time the record was last updated. */
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `Vessel` that is related to this `LiquidHeader`. */
  vessel?: Maybe<Vessel>;
  /** References the vessel this liquid header piped from */
  vesselId: Scalars['Int']['output'];
};

/** Representation of a physical liquid header in a refrigeration system. */
export type LiquidHeaderLiquidHeadersEvaporatorsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LiquidHeadersEvaporatorCondition>;
  filter?: InputMaybe<LiquidHeadersEvaporatorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiquidHeadersEvaporatorsOrderBy>>;
};

/**
 * A condition to be used against `LiquidHeader` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type LiquidHeaderCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `designPressurePsig` field. */
  designPressurePsig?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `designTempF` field. */
  designTempF?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `label` field. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `refrigerationSystemId` field. */
  refrigerationSystemId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `vesselId` field. */
  vesselId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `LiquidHeader` object types. All fields are combined with a logical ‘and.’ */
export type LiquidHeaderFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LiquidHeaderFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `designPressurePsig` field. */
  designPressurePsig?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `designTempF` field. */
  designTempF?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `label` field. */
  label?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LiquidHeaderFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LiquidHeaderFilter>>;
  /** Filter by the object’s `refrigerationSystemId` field. */
  refrigerationSystemId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `vesselId` field. */
  vesselId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `LiquidHeader` */
export type LiquidHeaderInput = {
  /** The design pressure (psig) for the liquid header. */
  designPressurePsig?: InputMaybe<Scalars['BigFloat']['input']>;
  /** The design temperature (F) for the liquid header. */
  designTempF?: InputMaybe<Scalars['BigFloat']['input']>;
  /** The unique identifier for the liquid header. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** The display label of the liquid header. */
  label: Scalars['String']['input'];
  /** Mutates a `RefrigerationSystem` as part of the payload */
  refrigerationSystem?: InputMaybe<RefrigerationSystemInput>;
  /** References the refrigeration system this liquid header belongs to. */
  refrigerationSystemId?: InputMaybe<Scalars['Int']['input']>;
  /** Mutates a `Vessel` as part of the payload */
  vessel?: InputMaybe<VesselInput>;
  /** References the vessel this liquid header piped from */
  vesselId?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents an update to a `LiquidHeader`. Fields that are set will be updated. */
export type LiquidHeaderPatch = {
  /** The design pressure (psig) for the liquid header. */
  designPressurePsig?: InputMaybe<Scalars['BigFloat']['input']>;
  /** The design temperature (F) for the liquid header. */
  designTempF?: InputMaybe<Scalars['BigFloat']['input']>;
  /** The unique identifier for the liquid header. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** The display label of the liquid header. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** References the refrigeration system this liquid header belongs to. */
  refrigerationSystemId?: InputMaybe<Scalars['Int']['input']>;
  /** References the vessel this liquid header piped from */
  vesselId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `LiquidHeader` values. */
export type LiquidHeadersConnection = {
  __typename?: 'LiquidHeadersConnection';
  /** A list of edges which contains the `LiquidHeader` and cursor to aid in pagination. */
  edges: Array<LiquidHeadersEdge>;
  /** A list of `LiquidHeader` objects. */
  nodes: Array<LiquidHeader>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LiquidHeader` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `LiquidHeader` edge in the connection. */
export type LiquidHeadersEdge = {
  __typename?: 'LiquidHeadersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `LiquidHeader` at the end of the edge. */
  node: LiquidHeader;
};

/** Representation of a physical connection between liquid headers and evaporators */
export type LiquidHeadersEvaporator = Node & {
  __typename?: 'LiquidHeadersEvaporator';
  /** The time the record was created. */
  createdAt: Scalars['Datetime']['output'];
  /** Reads a single `Evaporator` that is related to this `LiquidHeadersEvaporator`. */
  evaporator?: Maybe<Evaporator>;
  /** References the evaporator connection */
  evaporatorId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  /** Reads a single `LiquidHeader` that is related to this `LiquidHeadersEvaporator`. */
  liquidHeader?: Maybe<LiquidHeader>;
  /** References the liquid header connection */
  liquidHeaderId?: Maybe<Scalars['Int']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The time the record was last updated. */
  updatedAt: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `LiquidHeadersEvaporator` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type LiquidHeadersEvaporatorCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `evaporatorId` field. */
  evaporatorId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `liquidHeaderId` field. */
  liquidHeaderId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `LiquidHeadersEvaporator` object types. All fields are combined with a logical ‘and.’ */
export type LiquidHeadersEvaporatorFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LiquidHeadersEvaporatorFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `evaporatorId` field. */
  evaporatorId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `liquidHeaderId` field. */
  liquidHeaderId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LiquidHeadersEvaporatorFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LiquidHeadersEvaporatorFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `LiquidHeadersEvaporator` */
export type LiquidHeadersEvaporatorInput = {
  /** Mutates a `Evaporator` as part of the payload */
  evaporator?: InputMaybe<EvaporatorInput>;
  /** References the evaporator connection */
  evaporatorId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Mutates a `LiquidHeader` as part of the payload */
  liquidHeader?: InputMaybe<LiquidHeaderInput>;
  /** References the liquid header connection */
  liquidHeaderId?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents an update to a `LiquidHeadersEvaporator`. Fields that are set will be updated. */
export type LiquidHeadersEvaporatorPatch = {
  /** References the evaporator connection */
  evaporatorId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** References the liquid header connection */
  liquidHeaderId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `LiquidHeadersEvaporator` values. */
export type LiquidHeadersEvaporatorsConnection = {
  __typename?: 'LiquidHeadersEvaporatorsConnection';
  /** A list of edges which contains the `LiquidHeadersEvaporator` and cursor to aid in pagination. */
  edges: Array<LiquidHeadersEvaporatorsEdge>;
  /** A list of `LiquidHeadersEvaporator` objects. */
  nodes: Array<LiquidHeadersEvaporator>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LiquidHeadersEvaporator` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `LiquidHeadersEvaporator` edge in the connection. */
export type LiquidHeadersEvaporatorsEdge = {
  __typename?: 'LiquidHeadersEvaporatorsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `LiquidHeadersEvaporator` at the end of the edge. */
  node: LiquidHeadersEvaporator;
};

/** Methods to use when ordering `LiquidHeadersEvaporator`. */
export enum LiquidHeadersEvaporatorsOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  EVAPORATOR_ID_ASC = 'EVAPORATOR_ID_ASC',
  EVAPORATOR_ID_DESC = 'EVAPORATOR_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LIQUID_HEADER_ID_ASC = 'LIQUID_HEADER_ID_ASC',
  LIQUID_HEADER_ID_DESC = 'LIQUID_HEADER_ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** Methods to use when ordering `LiquidHeader`. */
export enum LiquidHeadersOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DESIGN_PRESSURE_PSIG_ASC = 'DESIGN_PRESSURE_PSIG_ASC',
  DESIGN_PRESSURE_PSIG_DESC = 'DESIGN_PRESSURE_PSIG_DESC',
  DESIGN_TEMP_F_ASC = 'DESIGN_TEMP_F_ASC',
  DESIGN_TEMP_F_DESC = 'DESIGN_TEMP_F_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LABEL_ASC = 'LABEL_ASC',
  LABEL_DESC = 'LABEL_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  REFRIGERATION_SYSTEM_ID_ASC = 'REFRIGERATION_SYSTEM_ID_ASC',
  REFRIGERATION_SYSTEM_ID_DESC = 'REFRIGERATION_SYSTEM_ID_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  VESSEL_ID_ASC = 'VESSEL_ID_ASC',
  VESSEL_ID_DESC = 'VESSEL_ID_DESC'
}

export enum LoadType {
  DROP = 'DROP',
  LIVE = 'LIVE'
}

/** A filter to be used against LoadType fields. All fields are combined with a logical ‘and.’ */
export type LoadTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<LoadType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<LoadType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<LoadType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<LoadType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<LoadType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<LoadType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<LoadType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<LoadType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<LoadType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<LoadType>>;
};

export type MachineIdentity = Identity & {
  __typename?: 'MachineIdentity';
  authorizationType: Scalars['String']['output'];
  id: Scalars['String']['output'];
  machineUser: MachineUser;
  signature: Scalars['String']['output'];
  type: AccessTokenType;
};

/** Machine accounts that have their own set of access/permissions. */
export type MachineUser = Node & {
  __typename?: 'MachineUser';
  /** Returns the machine user`s access tokens. */
  accessTokens: PlatformAccessTokensConnection;
  capabilities: Array<PlatformCapabilityAccess>;
  /** Reads and enables pagination through a set of `Component`. */
  components: ComponentsConnection;
  /** The date the machine user was created at. */
  createdAt: Scalars['Datetime']['output'];
  createdBy: Scalars['String']['output'];
  creator?: Maybe<User>;
  description: Scalars['String']['output'];
  /** The identifier of the machine user. */
  id: Scalars['BigInt']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Available permissions for the MachineUser. */
  permissions?: Maybe<MachineUserPermissions>;
  /** The date the machine user was updated at. */
  updatedAt: Scalars['Datetime']['output'];
  vendorUser?: Maybe<VendorUser>;
  /** Reads and enables pagination through a set of `VendorUser`. */
  vendorUsers: VendorUsersConnection;
};

/** Machine accounts that have their own set of access/permissions. */
export type MachineUserAccessTokensArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<PlatformAccessTokenFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Machine accounts that have their own set of access/permissions. */
export type MachineUserCapabilitiesArgs = {
  canRead?: InputMaybe<Scalars['Boolean']['input']>;
  canWrite?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Machine accounts that have their own set of access/permissions. */
export type MachineUserComponentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ComponentCondition>;
  filter?: InputMaybe<ComponentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ComponentsOrderBy>>;
};

/** Machine accounts that have their own set of access/permissions. */
export type MachineUserVendorUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<VendorUserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * A condition to be used against `MachineUser` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type MachineUserCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdBy` field. */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `MachineUser` object types. All fields are combined with a logical ‘and.’ */
export type MachineUserFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MachineUserFilter>>;
  /** Filter by the permission can_write */
  canWrite?: InputMaybe<PermissionBooleanFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdBy` field. */
  createdBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MachineUserFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MachineUserFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `MachineUser` */
export type MachineUserInput = {
  /** The date the machine user was created at. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  /** The date the machine user was updated at. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** Represents an update to a `MachineUser`. Fields that are set will be updated. */
export type MachineUserPatch = {
  /** The date the machine user was created at. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** The date the machine user was updated at. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** Permissive capabilities on a MachineUser. */
export type MachineUserPermissions = {
  __typename?: 'MachineUserPermissions';
  /** Whether a user can edit a machine user */
  canWrite: Scalars['Boolean']['output'];
};

/** A connection to a list of `MachineUser` values. */
export type MachineUsersConnection = {
  __typename?: 'MachineUsersConnection';
  /** A list of edges which contains the `MachineUser` and cursor to aid in pagination. */
  edges: Array<MachineUsersEdge>;
  /** A list of `MachineUser` objects. */
  nodes: Array<MachineUser>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MachineUser` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `MachineUser` edge in the connection. */
export type MachineUsersEdge = {
  __typename?: 'MachineUsersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `MachineUser` at the end of the edge. */
  node: MachineUser;
};

/** Methods to use when ordering `MachineUser`. */
export enum MachineUsersOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  CREATED_BY_ASC = 'CREATED_BY_ASC',
  CREATED_BY_DESC = 'CREATED_BY_DESC',
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** This represents one or more main meters at a facility */
export type MainService = Node & {
  __typename?: 'MainService';
  /** The time at which the main service was created */
  createdAt: Scalars['Datetime']['output'];
  /** Reads a single `DataPoint` that is related to this `MainService`. */
  demand?: Maybe<DataPoint>;
  /** The demand data point that represents this main service's contribution to/from the facility */
  demandDataPointId?: Maybe<Scalars['Int']['output']>;
  /** Used to indicate whether this main service contributes to carbon reporting based on its location in the facility. */
  excludeCarbon?: Maybe<Scalars['Boolean']['output']>;
  /** Reads a single `Facility` that is related to this `MainService`. */
  facility?: Maybe<Facility>;
  /** The facility this main service belongs to */
  facilityId: Scalars['Int']['output'];
  /** Reads a single `DataPoint` that is related to this `MainService`. */
  gridDemand?: Maybe<DataPoint>;
  /** The demand data point that represents this main service's contribution to/from the grid */
  gridDemandDataPointId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `MainService`. */
  gridUsage?: Maybe<DataPoint>;
  /** The usage data point that represents this main service's contribution to/from the grid */
  gridUsageDataPointId?: Maybe<Scalars['Int']['output']>;
  /** The id of the main service */
  id: Scalars['Int']['output'];
  /** Reads a single `DataPoint` that is related to this `MainService`. */
  meterDemand?: Maybe<DataPoint>;
  /** The original meter demand datapoint for this main service */
  meterDemandDataPointId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `MainService`. */
  meterUsage?: Maybe<DataPoint>;
  /** The original meter usage datapoint for this main service */
  meterUsageDataPointId?: Maybe<Scalars['Int']['output']>;
  /** The name for this main service */
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The specific type of this main service */
  type: MainServicesType;
  /** The time at which the main service was last updated */
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `DataPoint` that is related to this `MainService`. */
  usage?: Maybe<DataPoint>;
  /** The usage data point that represents this main service's contribution to/from the facility */
  usageDataPointId?: Maybe<Scalars['Int']['output']>;
};

/**
 * A condition to be used against `MainService` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type MainServiceCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `demandDataPointId` field. */
  demandDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `excludeCarbon` field. */
  excludeCarbon?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `gridDemandDataPointId` field. */
  gridDemandDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `gridUsageDataPointId` field. */
  gridUsageDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `meterDemandDataPointId` field. */
  meterDemandDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `meterUsageDataPointId` field. */
  meterUsageDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<MainServicesType>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `usageDataPointId` field. */
  usageDataPointId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `MainService` object types. All fields are combined with a logical ‘and.’ */
export type MainServiceFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MainServiceFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `demandDataPointId` field. */
  demandDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `excludeCarbon` field. */
  excludeCarbon?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `gridDemandDataPointId` field. */
  gridDemandDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `gridUsageDataPointId` field. */
  gridUsageDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `meterDemandDataPointId` field. */
  meterDemandDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `meterUsageDataPointId` field. */
  meterUsageDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MainServiceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MainServiceFilter>>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<MainServicesTypeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `usageDataPointId` field. */
  usageDataPointId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `MainService` */
export type MainServiceInput = {
  /** Mutates a `DataPoint` as part of the payload */
  dataPoint?: InputMaybe<DataPointInput>;
  /** The demand data point that represents this main service's contribution to/from the facility */
  demandDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Used to indicate whether this main service contributes to carbon reporting based on its location in the facility. */
  excludeCarbon?: InputMaybe<Scalars['Boolean']['input']>;
  /** The facility this main service belongs to */
  facilityId: Scalars['Int']['input'];
  /** The demand data point that represents this main service's contribution to/from the grid */
  gridDemandDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** The usage data point that represents this main service's contribution to/from the grid */
  gridUsageDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** The original meter demand datapoint for this main service */
  meterDemandDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** The original meter usage datapoint for this main service */
  meterUsageDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** The name for this main service */
  name: Scalars['String']['input'];
  /** The specific type of this main service */
  type: MainServicesType;
  /** The usage data point that represents this main service's contribution to/from the facility */
  usageDataPointId?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents an update to a `MainService`. Fields that are set will be updated. */
export type MainServicePatch = {
  /** The demand data point that represents this main service's contribution to/from the facility */
  demandDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Used to indicate whether this main service contributes to carbon reporting based on its location in the facility. */
  excludeCarbon?: InputMaybe<Scalars['Boolean']['input']>;
  /** The facility this main service belongs to */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** The demand data point that represents this main service's contribution to/from the grid */
  gridDemandDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** The usage data point that represents this main service's contribution to/from the grid */
  gridUsageDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** The original meter demand datapoint for this main service */
  meterDemandDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** The original meter usage datapoint for this main service */
  meterUsageDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** The name for this main service */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The specific type of this main service */
  type?: InputMaybe<MainServicesType>;
  /** The usage data point that represents this main service's contribution to/from the facility */
  usageDataPointId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `MainService` values. */
export type MainServicesConnection = {
  __typename?: 'MainServicesConnection';
  /** Returns the aggregate demand timeseries data for the MainServicesConnection  */
  demand?: Maybe<MetricDataConnection>;
  /** A list of edges which contains the `MainService` and cursor to aid in pagination. */
  edges: Array<MainServicesEdge>;
  /** Returns the aggregate gridDemand timeseries data for the MainServicesConnection  */
  gridDemand?: Maybe<MetricDataConnection>;
  /** Returns the aggregate gridUsage timeseries data for the MainServicesConnection  */
  gridUsage?: Maybe<MetricDataConnection>;
  /** Returns the aggregate meterDemand timeseries data for the MainServicesConnection  */
  meterDemand?: Maybe<MetricDataConnection>;
  /** Returns the aggregate meterUsage timeseries data for the MainServicesConnection  */
  meterUsage?: Maybe<MetricDataConnection>;
  /** A list of `MainService` objects. */
  nodes: Array<MainService>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MainService` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
  /** Returns the aggregate usage timeseries data for the MainServicesConnection  */
  usage?: Maybe<MetricDataConnection>;
};

/** A connection to a list of `MainService` values. */
export type MainServicesConnectionDemandArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `MainService` values. */
export type MainServicesConnectionGridDemandArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `MainService` values. */
export type MainServicesConnectionGridUsageArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `MainService` values. */
export type MainServicesConnectionMeterDemandArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `MainService` values. */
export type MainServicesConnectionMeterUsageArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `MainService` values. */
export type MainServicesConnectionUsageArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A `MainService` edge in the connection. */
export type MainServicesEdge = {
  __typename?: 'MainServicesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `MainService` at the end of the edge. */
  node: MainService;
};

/** Methods to use when ordering `MainService`. */
export enum MainServicesOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DEMAND_DATA_POINT_ID_ASC = 'DEMAND_DATA_POINT_ID_ASC',
  DEMAND_DATA_POINT_ID_DESC = 'DEMAND_DATA_POINT_ID_DESC',
  EXCLUDE_CARBON_ASC = 'EXCLUDE_CARBON_ASC',
  EXCLUDE_CARBON_DESC = 'EXCLUDE_CARBON_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  GRID_DEMAND_DATA_POINT_ID_ASC = 'GRID_DEMAND_DATA_POINT_ID_ASC',
  GRID_DEMAND_DATA_POINT_ID_DESC = 'GRID_DEMAND_DATA_POINT_ID_DESC',
  GRID_USAGE_DATA_POINT_ID_ASC = 'GRID_USAGE_DATA_POINT_ID_ASC',
  GRID_USAGE_DATA_POINT_ID_DESC = 'GRID_USAGE_DATA_POINT_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  METER_DEMAND_DATA_POINT_ID_ASC = 'METER_DEMAND_DATA_POINT_ID_ASC',
  METER_DEMAND_DATA_POINT_ID_DESC = 'METER_DEMAND_DATA_POINT_ID_DESC',
  METER_USAGE_DATA_POINT_ID_ASC = 'METER_USAGE_DATA_POINT_ID_ASC',
  METER_USAGE_DATA_POINT_ID_DESC = 'METER_USAGE_DATA_POINT_ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  TYPE_ASC = 'TYPE_ASC',
  TYPE_DESC = 'TYPE_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  USAGE_DATA_POINT_ID_ASC = 'USAGE_DATA_POINT_ID_ASC',
  USAGE_DATA_POINT_ID_DESC = 'USAGE_DATA_POINT_ID_DESC'
}

export enum MainServicesType {
  AIRFLOW_ELECTRIC_HIGH = 'AIRFLOW_ELECTRIC_HIGH',
  AIRFLOW_ELECTRIC_LOW = 'AIRFLOW_ELECTRIC_LOW',
  AIRFLOW_HIGH = 'AIRFLOW_HIGH',
  AIRFLOW_LOW = 'AIRFLOW_LOW',
  ELECTRIC = 'ELECTRIC',
  GAS = 'GAS',
  SOLAR = 'SOLAR',
  WATER = 'WATER'
}

/** A filter to be used against MainServicesType fields. All fields are combined with a logical ‘and.’ */
export type MainServicesTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<MainServicesType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<MainServicesType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<MainServicesType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<MainServicesType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<MainServicesType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<MainServicesType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<MainServicesType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<MainServicesType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<MainServicesType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<MainServicesType>>;
};

export type MarkTrailerAppointmentReadyInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  trailerAppointmentId: Scalars['Int']['input'];
  yardId: Scalars['Int']['input'];
};

export type MarkTrailerAppointmentReadyPayload = {
  __typename?: 'MarkTrailerAppointmentReadyPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  trailerAppointment?: Maybe<TrailerAppointment>;
};

export type MessageAccessTokenPayload = {
  __typename?: 'MessageAccessTokenPayload';
  token?: Maybe<Scalars['String']['output']>;
};

export type MeterCharge = Node & {
  __typename?: 'MeterCharge';
  /** The category of the charge. */
  category: UtilityMeterChargeCategory;
  /** The time this charge was created. */
  createdAt: Scalars['Datetime']['output'];
  /** The time the charge was deleted. */
  deletedAt?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['Int']['output'];
  /** This is set by the extraction process. */
  label: Scalars['String']['output'];
  /** Returns the category of the label associated with this meter charge. */
  labelCategory?: Maybe<ChargeLabelCategory>;
  /** Returns the display category or category of the label associated with this meter charge. */
  labelCategoryName?: Maybe<Scalars['String']['output']>;
  /** This is used to further distinguish otherwise duplicate rows that need to be present. */
  lineNumber: Scalars['Int']['output'];
  /** Additional attributes for this meter charge */
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** Reads a single `MeterStatement` that is related to this `MeterCharge`. */
  meterStatement?: Maybe<MeterStatement>;
  meterStatementId: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  overrideAt?: Maybe<Scalars['Datetime']['output']>;
  /** The rate per unit used for calculating the charge value */
  rate?: Maybe<Scalars['Float']['output']>;
  /** The time this charge was updated. */
  updatedAt: Scalars['Datetime']['output'];
  /** The value of the charge. */
  value: Scalars['Float']['output'];
};

/**
 * A condition to be used against `MeterCharge` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type MeterChargeCondition = {
  /** Checks for equality with the object’s `category` field. */
  category?: InputMaybe<UtilityMeterChargeCategory>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `lineNumber` field. */
  lineNumber?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `metadata` field. */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `meterStatementId` field. */
  meterStatementId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `normalizedValue` field. */
  normalizedValue?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `overrideAt` field. */
  overrideAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `rate` field. */
  rate?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `MeterCharge` object types. All fields are combined with a logical ‘and.’ */
export type MeterChargeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MeterChargeFilter>>;
  /** Filter by the object’s `category` field. */
  category?: InputMaybe<UtilityMeterChargeCategoryFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object's `label` field. */
  label?: InputMaybe<StringFilter>;
  /** Filter by the object’s `labelCategoryName` field. */
  labelCategoryName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `lineNumber` field. */
  lineNumber?: InputMaybe<IntFilter>;
  /** Filter by the object’s `metadata` field. */
  metadata?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `meterStatementId` field. */
  meterStatementId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `normalizedValue` field. */
  normalizedValue?: InputMaybe<FloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MeterChargeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MeterChargeFilter>>;
  /** Filter by the object’s `overrideAt` field. */
  overrideAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `rate` field. */
  rate?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object's `value` field. */
  value?: InputMaybe<FloatFilter>;
};

/** An input for mutations affecting `MeterCharge` */
export type MeterChargeInput = {
  /** The category of the charge. */
  category: UtilityMeterChargeCategory;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** This is set by the extraction process. */
  label: Scalars['String']['input'];
  /** This is used to further distinguish otherwise duplicate rows that need to be present. */
  lineNumber?: InputMaybe<Scalars['Int']['input']>;
  /** Additional attributes for this meter charge */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** Mutates a `MeterStatement` as part of the payload */
  meterStatement?: InputMaybe<MeterStatementInput>;
  meterStatementId?: InputMaybe<Scalars['Int']['input']>;
  /** The rate per unit used for calculating the charge value */
  rate?: InputMaybe<Scalars['Float']['input']>;
  /** The value of the charge. */
  value: Scalars['Float']['input'];
};

/** Represents an update to a `MeterCharge`. Fields that are set will be updated. */
export type MeterChargePatch = {
  /** Overrides the label. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Overrides the value. */
  value?: InputMaybe<Scalars['Float']['input']>;
};

/** A connection to a list of `MeterCharge` values. */
export type MeterChargesConnection = {
  __typename?: 'MeterChargesConnection';
  /** A list of edges which contains the `MeterCharge` and cursor to aid in pagination. */
  edges: Array<MeterChargesEdge>;
  /** A list of `MeterCharge` objects. */
  nodes: Array<MeterCharge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MeterCharge` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `MeterCharge` edge in the connection. */
export type MeterChargesEdge = {
  __typename?: 'MeterChargesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `MeterCharge` at the end of the edge. */
  node: MeterCharge;
};

/** Mapping of a meter_charge to a charge_label_category with optional model version and actor metadata. */
export type MeterChargesLabelCategory = Node & {
  __typename?: 'MeterChargesLabelCategory';
  /** Reads a single `ChargeLabelCategory` that is related to this `MeterChargesLabelCategory`. */
  chargeLabelCategory?: Maybe<ChargeLabelCategory>;
  /** Foreign key to public.charge_label_categories.id. */
  chargeLabelCategoryId: Scalars['Int']['output'];
  /** The time the mapping was created. */
  createdAt: Scalars['Datetime']['output'];
  /** Primary key. */
  id: Scalars['Int']['output'];
  /** Reads a single `MeterCharge` that is related to this `MeterChargesLabelCategory`. */
  meterCharge?: Maybe<MeterCharge>;
  /** Foreign key to public.meter_charges.id. */
  meterChargeId: Scalars['Int']['output'];
  /** Identifier of the model version used when assigning this category (nullable). */
  modelVersion?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The time the mapping was last updated. */
  updatedAt: Scalars['Datetime']['output'];
  /** Actor (user or machine) who last updated this mapping. */
  updatedBy?: Maybe<Actor>;
};

/** Methods to use when ordering `MeterCharge`. */
export enum MeterChargesOrderBy {
  CATEGORY_ASC = 'CATEGORY_ASC',
  CATEGORY_DESC = 'CATEGORY_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DELETED_AT_ASC = 'DELETED_AT_ASC',
  DELETED_AT_DESC = 'DELETED_AT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LABEL_ASC = 'LABEL_ASC',
  LABEL_DESC = 'LABEL_DESC',
  LINE_NUMBER_ASC = 'LINE_NUMBER_ASC',
  LINE_NUMBER_DESC = 'LINE_NUMBER_DESC',
  METADATA_ASC = 'METADATA_ASC',
  METADATA_DESC = 'METADATA_DESC',
  METER_STATEMENT_ID_ASC = 'METER_STATEMENT_ID_ASC',
  METER_STATEMENT_ID_DESC = 'METER_STATEMENT_ID_DESC',
  NATURAL = 'NATURAL',
  NORMALIZED_VALUE_ASC = 'NORMALIZED_VALUE_ASC',
  NORMALIZED_VALUE_DESC = 'NORMALIZED_VALUE_DESC',
  OVERRIDE_AT_ASC = 'OVERRIDE_AT_ASC',
  OVERRIDE_AT_DESC = 'OVERRIDE_AT_DESC',
  OVERRIDE_LABEL_ASC = 'OVERRIDE_LABEL_ASC',
  OVERRIDE_LABEL_DESC = 'OVERRIDE_LABEL_DESC',
  OVERRIDE_VALUE_ASC = 'OVERRIDE_VALUE_ASC',
  OVERRIDE_VALUE_DESC = 'OVERRIDE_VALUE_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  RATE_ASC = 'RATE_ASC',
  RATE_DESC = 'RATE_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  VALUE_ASC = 'VALUE_ASC',
  VALUE_DESC = 'VALUE_DESC'
}

export type MeterStatement = Node & {
  __typename?: 'MeterStatement';
  /** Reads a single `AccountStatement` that is related to this `MeterStatement`. */
  accountStatement?: Maybe<AccountStatement>;
  accountStatementId: Scalars['Int']['output'];
  /** Reads a single `AccountStatementPdf` that is related to this `MeterStatement`. */
  accountStatementPdf?: Maybe<AccountStatementPdf>;
  /** The PDF for this meter statement */
  accountStatementPdfId?: Maybe<Scalars['Int']['output']>;
  /** The charges for the meter statement */
  charges: MeterStatementsChargesConnection;
  /** The time this statement was created. */
  createdAt: Scalars['Datetime']['output'];
  /** The original currency code. */
  currencyCode: Scalars['String']['output'];
  /** Returns the deleted_at column of this record or its parent(s) */
  deletedAt?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['Int']['output'];
  integrationKey?: Maybe<Scalars['String']['output']>;
  /** The end interval of the meter statement. */
  intervalEnd: Scalars['Date']['output'];
  /** The start interval of the meter statement. */
  intervalStart: Scalars['Date']['output'];
  isAdjustment: Scalars['Boolean']['output'];
  isValidated: Scalars['Boolean']['output'];
  manualUpload: Scalars['Boolean']['output'];
  maxDemand?: Maybe<Scalars['Float']['output']>;
  metadata: Scalars['JSON']['output'];
  /** Reads and enables pagination through a set of `MeterCharge`. */
  meterCharges: MeterChargesConnection;
  /** Reads and enables pagination through a set of `MeterStatementHistory`. */
  meterStatementHistories: MeterStatementHistoriesConnection;
  /** Reads and enables pagination through a set of `MeterUsage`. */
  meterUsages: MeterUsagesConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The statements normalized charges. */
  normalizedCharges: MeterStatementsNormalizedChargesConnection;
  normalizedTotalCharges?: Maybe<Scalars['Float']['output']>;
  overrideAt?: Maybe<Scalars['Datetime']['output']>;
  /** Overrides the normalized month of the account_statement. */
  overrideStatementMonth?: Maybe<Scalars['Int']['output']>;
  /** Overrides the normalized year of the account_statement. */
  overrideStatementYear?: Maybe<Scalars['Int']['output']>;
  /**
   * Returns the PDF Link for the given meter statement.
   * @deprecated Use path property on the associated accountStatementPdf
   */
  pdfLink?: Maybe<Scalars['String']['output']>;
  /**
   * Returns the PDF URI for the given meter statement.
   * @deprecated Use uri property on the associated accountStatementPdf
   */
  pdfUri?: Maybe<Scalars['String']['output']>;
  /** This applies to max of meter_usages whose category is "demand" and units is this value. */
  primaryDemandUnits?: Maybe<Scalars['String']['output']>;
  /** This applies to sums of meter_usages whose category is "usage" and units is this value. */
  primaryUsageUnits?: Maybe<Scalars['String']['output']>;
  /** The date the statement was issued on. */
  statementDate: Scalars['Date']['output'];
  statementMonth?: Maybe<Scalars['Int']['output']>;
  statementYear?: Maybe<Scalars['Int']['output']>;
  /** Returns the first day of the statement month and year as a date. */
  statementYearMonth?: Maybe<Scalars['Date']['output']>;
  totalCharges?: Maybe<Scalars['Float']['output']>;
  totalUsage?: Maybe<Scalars['Float']['output']>;
  /** The time this statement was updated. */
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `UtilityMeter` that is related to this `MeterStatement`. */
  utilityMeter?: Maybe<UtilityMeter>;
  utilityMeterId: Scalars['Int']['output'];
  /** Reads a single `UtilityMeterStatement` that is related to this `MeterStatement`. */
  utilityMeterStatement?: Maybe<UtilityMeterStatement>;
  /** Reads a single `UtilityMeterStatementRollup` that is related to this `MeterStatement`. */
  utilityMeterStatementRollup?: Maybe<UtilityMeterStatementRollup>;
};

export type MeterStatementChargesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<MeterStatementsChargesRecordFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type MeterStatementMeterChargesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MeterChargeCondition>;
  filter?: InputMaybe<MeterChargeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MeterChargesOrderBy>>;
};

export type MeterStatementMeterStatementHistoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MeterStatementHistoryCondition>;
  filter?: InputMaybe<MeterStatementHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MeterStatementHistoriesOrderBy>>;
};

export type MeterStatementMeterUsagesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MeterUsageCondition>;
  filter?: InputMaybe<MeterUsageFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MeterUsagesOrderBy>>;
};

export type MeterStatementNormalizedChargesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<MeterStatementsNormalizedChargesRecordFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * A condition to be used against `MeterStatement` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type MeterStatementCondition = {
  /** Checks for equality with the object’s `accountStatementId` field. */
  accountStatementId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `accountStatementPdfId` field. */
  accountStatementPdfId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `integrationKey` field. */
  integrationKey?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `intervalEnd` field. */
  intervalEnd?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `intervalStart` field. */
  intervalStart?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `isAdjustment` field. */
  isAdjustment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `isValidated` field. */
  isValidated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `manualUpload` field. */
  manualUpload?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `metadata` field. */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `normalizedCurrencyCode` field. */
  normalizedCurrencyCode?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `overrideAt` field. */
  overrideAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `overrideStatementMonth` field. */
  overrideStatementMonth?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `overrideStatementYear` field. */
  overrideStatementYear?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `statementDate` field. */
  statementDate?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `utilityMeterId` field. */
  utilityMeterId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `MeterStatement` object types. All fields are combined with a logical ‘and.’ */
export type MeterStatementFilter = {
  /** Filter by the object’s `accountStatementId` field. */
  accountStatementId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `accountStatementPdfId` field. */
  accountStatementPdfId?: InputMaybe<IntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MeterStatementFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object's `currencyCode` field. */
  currencyCode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `integrationKey` field. */
  integrationKey?: InputMaybe<StringFilter>;
  /** Filter by the object’s `intervalEnd` field. */
  intervalEnd?: InputMaybe<DateFilter>;
  /** Filter by the object’s `intervalStart` field. */
  intervalStart?: InputMaybe<DateFilter>;
  /** Filter by the object’s `isAdjustment` field. */
  isAdjustment?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isValidated` field. */
  isValidated?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `manualUpload` field. */
  manualUpload?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `maxDemand` field. */
  maxDemand?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `metadata` field. */
  metadata?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `normalizedCurrencyCode` field. */
  normalizedCurrencyCode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `normalizedTotalCharges` field. */
  normalizedTotalCharges?: InputMaybe<FloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MeterStatementFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MeterStatementFilter>>;
  /** Filter by the object’s `overrideAt` field. */
  overrideAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `overrideStatementMonth` field. */
  overrideStatementMonth?: InputMaybe<IntFilter>;
  /** Filter by the object’s `overrideStatementYear` field. */
  overrideStatementYear?: InputMaybe<IntFilter>;
  /** Filter by the object's `primaryDemandUnits` field. */
  primaryDemandUnits?: InputMaybe<StringFilter>;
  /** Filter by the object's `primaryUsageUnits` field. */
  primaryUsageUnits?: InputMaybe<StringFilter>;
  /** Filter by the object’s `statementDate` field. */
  statementDate?: InputMaybe<DateFilter>;
  /** Filter by the object’s `statementMonth` field. */
  statementMonth?: InputMaybe<IntFilter>;
  /** Filter by the object’s `statementYear` field. */
  statementYear?: InputMaybe<IntFilter>;
  /** Filter by the object’s `statementYearMonth` field. */
  statementYearMonth?: InputMaybe<DateFilter>;
  /** Filter by the object’s `totalCharges` field. */
  totalCharges?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `totalUsage` field. */
  totalUsage?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `utilityMeterId` field. */
  utilityMeterId?: InputMaybe<IntFilter>;
};

/** A connection to a list of `MeterStatementHistory` values. */
export type MeterStatementHistoriesConnection = {
  __typename?: 'MeterStatementHistoriesConnection';
  /** A list of edges which contains the `MeterStatementHistory` and cursor to aid in pagination. */
  edges: Array<MeterStatementHistoriesEdge>;
  /** A list of `MeterStatementHistory` objects. */
  nodes: Array<MeterStatementHistory>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MeterStatementHistory` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `MeterStatementHistory` edge in the connection. */
export type MeterStatementHistoriesEdge = {
  __typename?: 'MeterStatementHistoriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `MeterStatementHistory` at the end of the edge. */
  node: MeterStatementHistory;
};

/** Methods to use when ordering `MeterStatementHistory`. */
export enum MeterStatementHistoriesOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  METER_STATEMENT_ID_ASC = 'METER_STATEMENT_ID_ASC',
  METER_STATEMENT_ID_DESC = 'METER_STATEMENT_ID_DESC',
  NATURAL = 'NATURAL'
}

export type MeterStatementHistory = {
  __typename?: 'MeterStatementHistory';
  /** The time this statement was created. */
  createdAt: Scalars['Datetime']['output'];
  description: Scalars['String']['output'];
  /** Reads a single `MeterStatement` that is related to this `MeterStatementHistory`. */
  meterStatement?: Maybe<MeterStatement>;
  meterStatementId: Scalars['Int']['output'];
};

/**
 * A condition to be used against `MeterStatementHistory` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type MeterStatementHistoryCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `meterStatementId` field. */
  meterStatementId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `MeterStatementHistory` object types. All fields are combined with a logical ‘and.’ */
export type MeterStatementHistoryFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MeterStatementHistoryFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `meterStatementId` field. */
  meterStatementId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MeterStatementHistoryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MeterStatementHistoryFilter>>;
};

/** An input for mutations affecting `MeterStatementHistory` */
export type MeterStatementHistoryInput = {
  description: Scalars['String']['input'];
  /** Mutates a `MeterStatement` as part of the payload */
  meterStatement?: InputMaybe<MeterStatementInput>;
  meterStatementId?: InputMaybe<Scalars['Int']['input']>;
};

/** An input for mutations affecting `MeterStatement` */
export type MeterStatementInput = {
  /** Mutates a `AccountStatement` as part of the payload */
  accountStatement?: InputMaybe<AccountStatementInput>;
  accountStatementId?: InputMaybe<Scalars['Int']['input']>;
  /** Mutates a `AccountStatementPdf` as part of the payload */
  accountStatementPdf?: InputMaybe<AccountStatementPdfInput>;
  /** The PDF for this meter statement */
  accountStatementPdfId?: InputMaybe<Scalars['Int']['input']>;
  /** The original currency code. */
  currencyCode: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  integrationKey?: InputMaybe<Scalars['String']['input']>;
  /** The end interval of the meter statement. */
  intervalEnd: Scalars['Date']['input'];
  /** The start interval of the meter statement. */
  intervalStart: Scalars['Date']['input'];
  isAdjustment?: InputMaybe<Scalars['Boolean']['input']>;
  isValidated?: InputMaybe<Scalars['Boolean']['input']>;
  manualUpload?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** This applies to max of meter_usages whose category is "demand" and units is this value. */
  primaryDemandUnits?: InputMaybe<Scalars['String']['input']>;
  /** This applies to sums of meter_usages whose category is "usage" and units is this value. */
  primaryUsageUnits?: InputMaybe<Scalars['String']['input']>;
  /** The date the statement was issued on. */
  statementDate: Scalars['Date']['input'];
  /** Mutates a `UtilityMeter` as part of the payload */
  utilityMeter?: InputMaybe<UtilityMeterInput>;
  utilityMeterId?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents an update to a `MeterStatement`. Fields that are set will be updated. */
export type MeterStatementPatch = {
  /** The PDF for this meter statement */
  accountStatementPdfId?: InputMaybe<Scalars['Int']['input']>;
  /** Overrides the original currency code. */
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  /** The end interval of the meter statement. */
  intervalEnd?: InputMaybe<Scalars['Date']['input']>;
  /** The start interval of the meter statement. */
  intervalStart?: InputMaybe<Scalars['Date']['input']>;
  isAdjustment?: InputMaybe<Scalars['Boolean']['input']>;
  isValidated?: InputMaybe<Scalars['Boolean']['input']>;
  manualUpload?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** Overrides the normalized month of the account_statement. */
  overrideStatementMonth?: InputMaybe<Scalars['Int']['input']>;
  /** Overrides the normalized year of the account_statement. */
  overrideStatementYear?: InputMaybe<Scalars['Int']['input']>;
  /** This overrides the primary demand units. */
  primaryDemandUnits?: InputMaybe<Scalars['String']['input']>;
  /** This overrides the primary usage units. */
  primaryUsageUnits?: InputMaybe<Scalars['String']['input']>;
  utilityMeterId?: InputMaybe<Scalars['Int']['input']>;
};

/** A `MeterStatementsChargesRecord` edge in the connection. */
export type MeterStatementsChargeEdge = {
  __typename?: 'MeterStatementsChargeEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `MeterStatementsChargesRecord` at the end of the edge. */
  node: MeterStatementsChargesRecord;
};

/** A connection to a list of `MeterStatementsChargesRecord` values. */
export type MeterStatementsChargesConnection = {
  __typename?: 'MeterStatementsChargesConnection';
  /** A list of edges which contains the `MeterStatementsChargesRecord` and cursor to aid in pagination. */
  edges: Array<MeterStatementsChargeEdge>;
  /** A list of `MeterStatementsChargesRecord` objects. */
  nodes: Array<MeterStatementsChargesRecord>;
  /** The count of *all* `MeterStatementsChargesRecord` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** The return type of our `charges` query. */
export type MeterStatementsChargesRecord = {
  __typename?: 'MeterStatementsChargesRecord';
  category?: Maybe<UtilityMeterChargeCategory>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** A filter to be used against `MeterStatementsChargesRecord` object types. All fields are combined with a logical ‘and.’ */
export type MeterStatementsChargesRecordFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MeterStatementsChargesRecordFilter>>;
  /** Filter by the object’s `category` field. */
  category?: InputMaybe<UtilityMeterChargeCategoryFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MeterStatementsChargesRecordFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MeterStatementsChargesRecordFilter>>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<FloatFilter>;
};

/** A connection to a list of `MeterStatement` values. */
export type MeterStatementsConnection = {
  __typename?: 'MeterStatementsConnection';
  /** A list of edges which contains the `MeterStatement` and cursor to aid in pagination. */
  edges: Array<MeterStatementsEdge>;
  /** A list of `MeterStatement` objects. */
  nodes: Array<MeterStatement>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MeterStatement` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `MeterStatement` edge in the connection. */
export type MeterStatementsEdge = {
  __typename?: 'MeterStatementsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `MeterStatement` at the end of the edge. */
  node: MeterStatement;
};

/** A `MeterStatementsNormalizedChargesRecord` edge in the connection. */
export type MeterStatementsNormalizedChargeEdge = {
  __typename?: 'MeterStatementsNormalizedChargeEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `MeterStatementsNormalizedChargesRecord` at the end of the edge. */
  node: MeterStatementsNormalizedChargesRecord;
};

/** A connection to a list of `MeterStatementsNormalizedChargesRecord` values. */
export type MeterStatementsNormalizedChargesConnection = {
  __typename?: 'MeterStatementsNormalizedChargesConnection';
  /** A list of edges which contains the `MeterStatementsNormalizedChargesRecord` and cursor to aid in pagination. */
  edges: Array<MeterStatementsNormalizedChargeEdge>;
  /** A list of `MeterStatementsNormalizedChargesRecord` objects. */
  nodes: Array<MeterStatementsNormalizedChargesRecord>;
  /** The count of *all* `MeterStatementsNormalizedChargesRecord` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** The return type of our `normalizedCharges` query. */
export type MeterStatementsNormalizedChargesRecord = {
  __typename?: 'MeterStatementsNormalizedChargesRecord';
  category?: Maybe<UtilityMeterChargeCategory>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** A filter to be used against `MeterStatementsNormalizedChargesRecord` object types. All fields are combined with a logical ‘and.’ */
export type MeterStatementsNormalizedChargesRecordFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MeterStatementsNormalizedChargesRecordFilter>>;
  /** Filter by the object’s `category` field. */
  category?: InputMaybe<UtilityMeterChargeCategoryFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MeterStatementsNormalizedChargesRecordFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MeterStatementsNormalizedChargesRecordFilter>>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<FloatFilter>;
};

/** Methods to use when ordering `MeterStatement`. */
export enum MeterStatementsOrderBy {
  ACCOUNT_STATEMENT_ID_ASC = 'ACCOUNT_STATEMENT_ID_ASC',
  ACCOUNT_STATEMENT_ID_DESC = 'ACCOUNT_STATEMENT_ID_DESC',
  ACCOUNT_STATEMENT_PDF_ID_ASC = 'ACCOUNT_STATEMENT_PDF_ID_ASC',
  ACCOUNT_STATEMENT_PDF_ID_DESC = 'ACCOUNT_STATEMENT_PDF_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  CURRENCY_CODE_ASC = 'CURRENCY_CODE_ASC',
  CURRENCY_CODE_DESC = 'CURRENCY_CODE_DESC',
  DELETED_AT_ASC = 'DELETED_AT_ASC',
  DELETED_AT_DESC = 'DELETED_AT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  INTEGRATION_KEY_ASC = 'INTEGRATION_KEY_ASC',
  INTEGRATION_KEY_DESC = 'INTEGRATION_KEY_DESC',
  INTERVAL_END_ASC = 'INTERVAL_END_ASC',
  INTERVAL_END_DESC = 'INTERVAL_END_DESC',
  INTERVAL_START_ASC = 'INTERVAL_START_ASC',
  INTERVAL_START_DESC = 'INTERVAL_START_DESC',
  IS_ADJUSTMENT_ASC = 'IS_ADJUSTMENT_ASC',
  IS_ADJUSTMENT_DESC = 'IS_ADJUSTMENT_DESC',
  IS_VALIDATED_ASC = 'IS_VALIDATED_ASC',
  IS_VALIDATED_DESC = 'IS_VALIDATED_DESC',
  MANUAL_UPLOAD_ASC = 'MANUAL_UPLOAD_ASC',
  MANUAL_UPLOAD_DESC = 'MANUAL_UPLOAD_DESC',
  METADATA_ASC = 'METADATA_ASC',
  METADATA_DESC = 'METADATA_DESC',
  NATURAL = 'NATURAL',
  NORMALIZED_CURRENCY_CODE_ASC = 'NORMALIZED_CURRENCY_CODE_ASC',
  NORMALIZED_CURRENCY_CODE_DESC = 'NORMALIZED_CURRENCY_CODE_DESC',
  OVERRIDE_AT_ASC = 'OVERRIDE_AT_ASC',
  OVERRIDE_AT_DESC = 'OVERRIDE_AT_DESC',
  OVERRIDE_CURRENCY_CODE_ASC = 'OVERRIDE_CURRENCY_CODE_ASC',
  OVERRIDE_CURRENCY_CODE_DESC = 'OVERRIDE_CURRENCY_CODE_DESC',
  OVERRIDE_PRIMARY_DEMAND_UNITS_ASC = 'OVERRIDE_PRIMARY_DEMAND_UNITS_ASC',
  OVERRIDE_PRIMARY_DEMAND_UNITS_DESC = 'OVERRIDE_PRIMARY_DEMAND_UNITS_DESC',
  OVERRIDE_PRIMARY_USAGE_UNITS_ASC = 'OVERRIDE_PRIMARY_USAGE_UNITS_ASC',
  OVERRIDE_PRIMARY_USAGE_UNITS_DESC = 'OVERRIDE_PRIMARY_USAGE_UNITS_DESC',
  OVERRIDE_STATEMENT_MONTH_ASC = 'OVERRIDE_STATEMENT_MONTH_ASC',
  OVERRIDE_STATEMENT_MONTH_DESC = 'OVERRIDE_STATEMENT_MONTH_DESC',
  OVERRIDE_STATEMENT_YEAR_ASC = 'OVERRIDE_STATEMENT_YEAR_ASC',
  OVERRIDE_STATEMENT_YEAR_DESC = 'OVERRIDE_STATEMENT_YEAR_DESC',
  PRIMARY_DEMAND_UNITS_ASC = 'PRIMARY_DEMAND_UNITS_ASC',
  PRIMARY_DEMAND_UNITS_DESC = 'PRIMARY_DEMAND_UNITS_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  PRIMARY_USAGE_UNITS_ASC = 'PRIMARY_USAGE_UNITS_ASC',
  PRIMARY_USAGE_UNITS_DESC = 'PRIMARY_USAGE_UNITS_DESC',
  STATEMENT_DATE_ASC = 'STATEMENT_DATE_ASC',
  STATEMENT_DATE_DESC = 'STATEMENT_DATE_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  UTILITY_METER_ID_ASC = 'UTILITY_METER_ID_ASC',
  UTILITY_METER_ID_DESC = 'UTILITY_METER_ID_DESC'
}

export type MeterUsage = Node & {
  __typename?: 'MeterUsage';
  /** The category of the usage. */
  category: UtilityMeterUsageCategory;
  /** The time this usage was created. */
  createdAt: Scalars['Datetime']['output'];
  /** The time the usage was deleted. */
  deletedAt?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['Int']['output'];
  /** Indicates if the usage was for import (typically for grid), or export (typically from solar or generator). */
  isExport: Scalars['Boolean']['output'];
  /** This is set by the extraction process. */
  label: Scalars['String']['output'];
  /** This is used to further distinguish otherwise duplicate rows that need to be present. */
  lineNumber: Scalars['Int']['output'];
  /** This is set by the extraction process */
  metadata: Scalars['JSON']['output'];
  /** Reads a single `MeterStatement` that is related to this `MeterUsage`. */
  meterStatement?: Maybe<MeterStatement>;
  meterStatementId: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  overrideAt?: Maybe<Scalars['Datetime']['output']>;
  /** This is set by the extraction process. */
  units: Scalars['String']['output'];
  /** The time this usage was updated. */
  updatedAt: Scalars['Datetime']['output'];
  /** This is set by the extraction process. */
  value: Scalars['Float']['output'];
};

/**
 * A condition to be used against `MeterUsage` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type MeterUsageCondition = {
  /** Checks for equality with the object’s `category` field. */
  category?: InputMaybe<UtilityMeterUsageCategory>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `isExport` field. */
  isExport?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `lineNumber` field. */
  lineNumber?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `metadata` field. */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `meterStatementId` field. */
  meterStatementId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `overrideAt` field. */
  overrideAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `MeterUsage` object types. All fields are combined with a logical ‘and.’ */
export type MeterUsageFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MeterUsageFilter>>;
  /** Filter by the object’s `category` field. */
  category?: InputMaybe<UtilityMeterUsageCategoryFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isExport` field. */
  isExport?: InputMaybe<BooleanFilter>;
  /** Filter by the object's `label` field. */
  label?: InputMaybe<StringFilter>;
  /** Filter by the object’s `lineNumber` field. */
  lineNumber?: InputMaybe<IntFilter>;
  /** Filter by the object’s `metadata` field. */
  metadata?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `meterStatementId` field. */
  meterStatementId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MeterUsageFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MeterUsageFilter>>;
  /** Filter by the object’s `overrideAt` field. */
  overrideAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object's `units` field. */
  units?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object's `value` field. */
  value?: InputMaybe<FloatFilter>;
};

/** An input for mutations affecting `MeterUsage` */
export type MeterUsageInput = {
  /** The category of the usage. */
  category: UtilityMeterUsageCategory;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Indicates if the usage was for import (typically for grid), or export (typically from solar or generator). */
  isExport?: InputMaybe<Scalars['Boolean']['input']>;
  /** This is set by the extraction process. */
  label: Scalars['String']['input'];
  /** This is used to further distinguish otherwise duplicate rows that need to be present. */
  lineNumber: Scalars['Int']['input'];
  /** This is set by the extraction process */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** Mutates a `MeterStatement` as part of the payload */
  meterStatement?: InputMaybe<MeterStatementInput>;
  meterStatementId?: InputMaybe<Scalars['Int']['input']>;
  /** This is set by the extraction process. */
  units: Scalars['String']['input'];
  /** This is set by the extraction process. */
  value: Scalars['Float']['input'];
};

/** Represents an update to a `MeterUsage`. Fields that are set will be updated. */
export type MeterUsagePatch = {
  /** Indicates if the usage was for import (typically for grid), or export (typically from solar or generator). */
  isExport?: InputMaybe<Scalars['Boolean']['input']>;
  /** This overrides the label. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** This is set by the extraction process */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** This overrides the units. */
  units?: InputMaybe<Scalars['String']['input']>;
  /** This overrides the value. */
  value?: InputMaybe<Scalars['Float']['input']>;
};

/** A connection to a list of `MeterUsage` values. */
export type MeterUsagesConnection = {
  __typename?: 'MeterUsagesConnection';
  /** A list of edges which contains the `MeterUsage` and cursor to aid in pagination. */
  edges: Array<MeterUsagesEdge>;
  /** A list of `MeterUsage` objects. */
  nodes: Array<MeterUsage>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MeterUsage` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `MeterUsage` edge in the connection. */
export type MeterUsagesEdge = {
  __typename?: 'MeterUsagesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `MeterUsage` at the end of the edge. */
  node: MeterUsage;
};

/** Methods to use when ordering `MeterUsage`. */
export enum MeterUsagesOrderBy {
  CATEGORY_ASC = 'CATEGORY_ASC',
  CATEGORY_DESC = 'CATEGORY_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DELETED_AT_ASC = 'DELETED_AT_ASC',
  DELETED_AT_DESC = 'DELETED_AT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  IS_EXPORT_ASC = 'IS_EXPORT_ASC',
  IS_EXPORT_DESC = 'IS_EXPORT_DESC',
  LABEL_ASC = 'LABEL_ASC',
  LABEL_DESC = 'LABEL_DESC',
  LINE_NUMBER_ASC = 'LINE_NUMBER_ASC',
  LINE_NUMBER_DESC = 'LINE_NUMBER_DESC',
  METADATA_ASC = 'METADATA_ASC',
  METADATA_DESC = 'METADATA_DESC',
  METER_STATEMENT_ID_ASC = 'METER_STATEMENT_ID_ASC',
  METER_STATEMENT_ID_DESC = 'METER_STATEMENT_ID_DESC',
  NATURAL = 'NATURAL',
  OVERRIDE_AT_ASC = 'OVERRIDE_AT_ASC',
  OVERRIDE_AT_DESC = 'OVERRIDE_AT_DESC',
  OVERRIDE_LABEL_ASC = 'OVERRIDE_LABEL_ASC',
  OVERRIDE_LABEL_DESC = 'OVERRIDE_LABEL_DESC',
  OVERRIDE_UNITS_ASC = 'OVERRIDE_UNITS_ASC',
  OVERRIDE_UNITS_DESC = 'OVERRIDE_UNITS_DESC',
  OVERRIDE_VALUE_ASC = 'OVERRIDE_VALUE_ASC',
  OVERRIDE_VALUE_DESC = 'OVERRIDE_VALUE_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UNITS_ASC = 'UNITS_ASC',
  UNITS_DESC = 'UNITS_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  VALUE_ASC = 'VALUE_ASC',
  VALUE_DESC = 'VALUE_DESC'
}

export type MetricAggregate = {
  __typename?: 'MetricAggregate';
  AVG?: Maybe<Scalars['JSON']['output']>;
  COUNT?: Maybe<Scalars['JSON']['output']>;
  FIRST?: Maybe<Scalars['JSON']['output']>;
  LAST?: Maybe<Scalars['JSON']['output']>;
  MAX?: Maybe<Scalars['JSON']['output']>;
  MEDIAN?: Maybe<Scalars['JSON']['output']>;
  MIN?: Maybe<Scalars['JSON']['output']>;
  SUM?: Maybe<Scalars['JSON']['output']>;
};

export type MetricData = Node & {
  __typename?: 'MetricData';
  data: Scalars['JSON']['output'];
  label: Scalars['String']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  nodeId: Scalars['ID']['output'];
  sourceId: Scalars['String']['output'];
  time: Scalars['String']['output'];
};

export type MetricDataMetadataArgs = {
  drillIn?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum MetricDataAggregationMethod {
  AVG = 'AVG',
  COUNT = 'COUNT',
  FIRST = 'FIRST',
  LAST = 'LAST',
  MAX = 'MAX',
  MEDIAN = 'MEDIAN',
  MIN = 'MIN',
  SUM = 'SUM'
}

export type MetricDataConnection = {
  __typename?: 'MetricDataConnection';
  aggregates?: Maybe<MetricAggregate>;
  edges: Array<MetricDataEdge>;
  explain?: Maybe<MetricDataExplain>;
  nodes: Array<MetricData>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MetricDataEdge = {
  __typename?: 'MetricDataEdge';
  cursor?: Maybe<Scalars['Cursor']['output']>;
  node: MetricData;
};

export type MetricDataExplain = {
  __typename?: 'MetricDataExplain';
  containsNulls: Scalars['Boolean']['output'];
  timezone?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

export enum MetricDataOrderBy {
  TIME_ASC = 'TIME_ASC',
  TIME_DESC = 'TIME_DESC'
}

export enum MetricDatatype {
  BOOLEAN = 'BOOLEAN',
  FLOAT = 'FLOAT',
  INT = 'INT',
  LONG = 'LONG',
  NUMERIC = 'NUMERIC',
  TEXT = 'TEXT'
}

/** A filter to be used against MetricDatatype fields. All fields are combined with a logical ‘and.’ */
export type MetricDatatypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<MetricDatatype>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<MetricDatatype>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<MetricDatatype>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<MetricDatatype>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<MetricDatatype>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<MetricDatatype>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<MetricDatatype>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<MetricDatatype>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<MetricDatatype>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<MetricDatatype>>;
};

export type MetricLabel = Node & {
  __typename?: 'MetricLabel';
  label: Scalars['String']['output'];
  nodeId: Scalars['ID']['output'];
  sourceId: Scalars['String']['output'];
};

/** A connection to a list of `MetricMetadatum` values. */
export type MetricMetadataConnection = {
  __typename?: 'MetricMetadataConnection';
  /** A list of edges which contains the `MetricMetadatum` and cursor to aid in pagination. */
  edges: Array<MetricMetadataEdge>;
  /** A list of `MetricMetadatum` objects. */
  nodes: Array<MetricMetadatum>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MetricMetadatum` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `MetricMetadatum` edge in the connection. */
export type MetricMetadataEdge = {
  __typename?: 'MetricMetadataEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `MetricMetadatum` at the end of the edge. */
  node: MetricMetadatum;
};

/** Methods to use when ordering `MetricMetadatum`. */
export enum MetricMetadataOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DATA_TYPE_ASC = 'DATA_TYPE_ASC',
  DATA_TYPE_DESC = 'DATA_TYPE_DESC',
  EXPRESSION_ASC = 'EXPRESSION_ASC',
  EXPRESSION_DESC = 'EXPRESSION_DESC',
  HUMAN_LABEL_ASC = 'HUMAN_LABEL_ASC',
  HUMAN_LABEL_DESC = 'HUMAN_LABEL_DESC',
  IS_COMPOSITE_ASC = 'IS_COMPOSITE_ASC',
  IS_COMPOSITE_DESC = 'IS_COMPOSITE_DESC',
  IS_INTERNAL_ASC = 'IS_INTERNAL_ASC',
  IS_INTERNAL_DESC = 'IS_INTERNAL_DESC',
  IS_SPARSE_ASC = 'IS_SPARSE_ASC',
  IS_SPARSE_DESC = 'IS_SPARSE_DESC',
  LABEL_ASC = 'LABEL_ASC',
  LABEL_DESC = 'LABEL_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  TABLE_ASC = 'TABLE_ASC',
  TABLE_DESC = 'TABLE_DESC',
  UNIT_ASC = 'UNIT_ASC',
  UNIT_DESC = 'UNIT_DESC',
  UNIT_DIMENSION_ASC = 'UNIT_DIMENSION_ASC',
  UNIT_DIMENSION_DESC = 'UNIT_DIMENSION_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** Metadata describing a given metric by label. */
export type MetricMetadatum = Node & {
  __typename?: 'MetricMetadatum';
  /** Returns a list of all downstream dependencies for a metric. */
  allDependencies: MetricMetadataConnection;
  /** Returns a list of all upstream dependents for a metric. */
  allDependents: MetricMetadataConnection;
  /** The time the metric metadata was created. */
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  /** The data type of the metric. */
  dataType?: Maybe<MetricDatatype>;
  /** Returns a list of direct dependencies for a metric. */
  dependencies: MetricMetadataConnection;
  /** Returns a flattened list of direct dependencies for a metric. */
  dependencyList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Returns a list of direct dependents for a metric. */
  dependents: MetricMetadataConnection;
  /** Returns a flattened list of direct dependents for a metric. */
  dependentsList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The query expression used to derive the metric. */
  expression?: Maybe<Scalars['String']['output']>;
  /** The human-readable label of the metric. */
  humanLabel: Scalars['String']['output'];
  /** A flag that indicates the metric will be computed using other metrics. */
  isComposite?: Maybe<Scalars['Boolean']['output']>;
  /** A flag that indicates  the metric is precalculated internally. */
  isInternal?: Maybe<Scalars['Boolean']['output']>;
  /** A flag that indicates the metric should be interpolated when used. */
  isSparse?: Maybe<Scalars['Boolean']['output']>;
  /** The label of the metric. */
  label: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The underlining table that stores the data stream of the metric. */
  table: Scalars['String']['output'];
  /** The default unit that describes the raw data stream of the metric. */
  unit: Scalars['String']['output'];
  /** The unit dimension of the metric. */
  unitDimension: Scalars['String']['output'];
  /** The time the metric metadata was updated. */
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
};

/** Metadata describing a given metric by label. */
export type MetricMetadatumAllDependenciesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<MetricMetadatumFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Metadata describing a given metric by label. */
export type MetricMetadatumAllDependentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<MetricMetadatumFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Metadata describing a given metric by label. */
export type MetricMetadatumDependenciesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<MetricMetadatumFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Metadata describing a given metric by label. */
export type MetricMetadatumDependentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<MetricMetadatumFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * A condition to be used against `MetricMetadatum` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type MetricMetadatumCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `dataType` field. */
  dataType?: InputMaybe<MetricDatatype>;
  /** Checks for equality with the object’s `expression` field. */
  expression?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `humanLabel` field. */
  humanLabel?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `isComposite` field. */
  isComposite?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `isInternal` field. */
  isInternal?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `isSparse` field. */
  isSparse?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `label` field. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `table` field. */
  table?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `unit` field. */
  unit?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `unitDimension` field. */
  unitDimension?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `MetricMetadatum` object types. All fields are combined with a logical ‘and.’ */
export type MetricMetadatumFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MetricMetadatumFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dataType` field. */
  dataType?: InputMaybe<MetricDatatypeFilter>;
  /** Filter by the object’s `dependencyList` field. */
  dependencyList?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `dependentsList` field. */
  dependentsList?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `expression` field. */
  expression?: InputMaybe<StringFilter>;
  /** Filter by the object’s `humanLabel` field. */
  humanLabel?: InputMaybe<StringFilter>;
  /** Filter by the object’s `isComposite` field. */
  isComposite?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isInternal` field. */
  isInternal?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isSparse` field. */
  isSparse?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `label` field. */
  label?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MetricMetadatumFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MetricMetadatumFilter>>;
  /** Filter by the object’s `table` field. */
  table?: InputMaybe<StringFilter>;
  /** Filter by the object’s `unit` field. */
  unit?: InputMaybe<StringFilter>;
  /** Filter by the object’s `unitDimension` field. */
  unitDimension?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** Module Extension that can be enabled for each tenant environment */
export enum ModuleExtension {
  etru_core = 'etru_core',
  fleet = 'fleet',
  refrigeration = 'refrigeration',
  warehousing = 'warehousing'
}

/** A monitor used to track a data point and detect when a condition is met. */
export type Monitor = Node & {
  __typename?: 'Monitor';
  /** The aggregation method for the data point. */
  aggregationMethod?: Maybe<MetricDataAggregationMethod>;
  /** Reads and enables pagination through a set of `MonitorAttribute`. */
  attributes: MonitorAttributesConnection;
  /** Returns the check associated with the given monitor. */
  check?: Maybe<Check>;
  /** Returns the id of the check associated with the given monitor. */
  checkId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `CheckMonitor` that is related to this `Monitor`. */
  checkMonitor?: Maybe<CheckMonitor>;
  /** Returns the name of the check associated with the given monitor. */
  checkName?: Maybe<Scalars['String']['output']>;
  /** The condition to evaluate the value against. */
  condition: ThresholdCondition;
  /** The time the monitor was created. */
  createdAt: Scalars['Datetime']['output'];
  /** Aggregates a data point for the specified filter expression */
  data?: Maybe<MetricDataConnection>;
  /** Returns the list of data point ids for the given monitor. */
  dataPointIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Returns the direct list of data points for the given monitor. */
  dataPoints: DataPointsConnection;
  /** The description of the monitor. */
  description?: Maybe<Scalars['String']['output']>;
  detectionCount?: Maybe<Scalars['Int']['output']>;
  detectionDurationSeconds?: Maybe<Scalars['Int']['output']>;
  /** Reads and enables pagination through a set of `MonitorDetection`. */
  detections: MonitorDetectionsConnection;
  /** Reads and enables pagination through a set of `MonitorEnabledUserSubscription`. */
  enabledUserSubscriptions: MonitorEnabledUserSubscriptionsConnection;
  /** Aggregates a data point for the specified filter expression */
  evaluate?: Maybe<MetricDataConnection>;
  /** Returns all facilities for the monitor. */
  facilities: FacilitiesConnection;
  /** Returns all facility ids for the monitor. */
  facilityIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Returns a comma-separated list of facility names for the monitor. */
  facilityNames?: Maybe<Scalars['String']['output']>;
  /** The identifer of the monitor. */
  id: Scalars['Int']['output'];
  /** Indicates whether the monitor is enabled or disabled. */
  isEnabled: Scalars['Boolean']['output'];
  /** Returns whether the monitor is actively monitoring data points. */
  isMonitoring?: Maybe<Scalars['Boolean']['output']>;
  /** Returns whether the monitor is currently in a triggered state. */
  isTriggered?: Maybe<Scalars['Boolean']['output']>;
  /** Returns the start time of the last detection, if any. */
  lastDetectedStartTime?: Maybe<Scalars['Datetime']['output']>;
  /** The merged attributes of the related monitor. */
  mergedAttributes?: Maybe<Scalars['JSON']['output']>;
  /** Reads and enables pagination through a set of `MonitorDataPoint`. */
  monitorDataPoints: MonitorDataPointsConnection;
  /** The type of monitor. */
  monitorType: MonitorType;
  /** The name of the monitor is. */
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Returns the number of detections over the last 1 day for the given monitor. */
  oneDayDetectionCount?: Maybe<Scalars['Int']['output']>;
  /** Returns the total duration of all detections over the last day for the given monitor. */
  oneDayDetectionDurationSeconds?: Maybe<Scalars['Int']['output']>;
  /** The Return-to-Normal (RTN) duration that a trigger condition must meet to resolve (default: instant). */
  rtnDuration?: Maybe<Interval>;
  /** Returns the total seconds for the interval field rtnDuration */
  rtnDurationSeconds?: Maybe<Scalars['Int']['output']>;
  /** The Return-to-Normal (RTN) value that a trigger condition must meet to resolve (default: thresholdValue). */
  rtnValue?: Maybe<Scalars['JSON']['output']>;
  /** The sampling window interval of the underlying data point (defaults to window interval). */
  samplingWindow?: Maybe<Interval>;
  /** Returns the total seconds for the interval field samplingWindow */
  samplingWindowSeconds?: Maybe<Scalars['Int']['output']>;
  /** Returns the number of detections over the last 7 days for the given monitor. */
  sevenDayDetectionCount?: Maybe<Scalars['Int']['output']>;
  /** Returns the total duration of all detections over the last 7 days for the given monitor. */
  sevenDayDetectionDurationSeconds?: Maybe<Scalars['Int']['output']>;
  /** Returns the slugs of the software packages associated with the check. */
  softwarePackageSlugs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Returns whether the monitor is enabled and monitoring. */
  status?: Maybe<MonitorStatusType>;
  /** Returns the number of detections over the last 30 days for the given monitor. */
  thirtyDayDetectionCount?: Maybe<Scalars['Int']['output']>;
  /** Returns the total duration of all detections over the last 30 days for the given monitor. */
  thirtyDayDetectionDurationSeconds?: Maybe<Scalars['Int']['output']>;
  /** The duration interval that the monitor condition must be valid. */
  thresholdDuration: Interval;
  /** Returns the total seconds for the interval field thresholdDuration */
  thresholdDurationSeconds: Scalars['Int']['output'];
  /** The threshold value that the underlying data point evaluates against. */
  thresholdValue: Scalars['JSON']['output'];
  /** The time the monitor was updated. */
  updatedAt: Scalars['Datetime']['output'];
  /** The bucket window interval used to monitor the data point. */
  window: Interval;
  /** Returns the total seconds for the interval field window */
  windowSeconds: Scalars['Int']['output'];
};

/** A monitor used to track a data point and detect when a condition is met. */
export type MonitorAttributesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MonitorAttributeCondition>;
  filter?: InputMaybe<MonitorAttributeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MonitorAttributesOrderBy>>;
};

/** A monitor used to track a data point and detect when a condition is met. */
export type MonitorDataArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  to: Scalars['String']['input'];
};

/** A monitor used to track a data point and detect when a condition is met. */
export type MonitorDataPointsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<DataPointFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** A monitor used to track a data point and detect when a condition is met. */
export type MonitorDetectionCountArgs = {
  from?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};

/** A monitor used to track a data point and detect when a condition is met. */
export type MonitorDetectionDurationSecondsArgs = {
  from: Scalars['Datetime']['input'];
  to?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A monitor used to track a data point and detect when a condition is met. */
export type MonitorDetectionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MonitorDetectionCondition>;
  filter?: InputMaybe<MonitorDetectionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MonitorDetectionsOrderBy>>;
};

/** A monitor used to track a data point and detect when a condition is met. */
export type MonitorEnabledUserSubscriptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MonitorEnabledUserSubscriptionCondition>;
  filter?: InputMaybe<MonitorEnabledUserSubscriptionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MonitorEnabledUserSubscriptionsOrderBy>>;
};

/** A monitor used to track a data point and detect when a condition is met. */
export type MonitorEvaluateArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  assumeActiveDetection?: Scalars['Boolean']['input'];
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  resultOutput?: MonitorResultOuput;
  to: Scalars['String']['input'];
};

/** A monitor used to track a data point and detect when a condition is met. */
export type MonitorFacilitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<FacilityFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** A monitor used to track a data point and detect when a condition is met. */
export type MonitorMonitorDataPointsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MonitorDataPointCondition>;
  filter?: InputMaybe<MonitorDataPointFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MonitorDataPointsOrderBy>>;
};

/** A monitor used to track a data point and detect when a condition is met. */
export type MonitorSoftwarePackageSlugsArgs = {
  enabledOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An attribute associated with a monitor. */
export type MonitorAttribute = Node & {
  __typename?: 'MonitorAttribute';
  /** The time the record was created. */
  createdAt: Scalars['Datetime']['output'];
  /** The actor responsible for creating the record. */
  createdBy?: Maybe<Actor>;
  /** The attribute key. */
  key: Scalars['String']['output'];
  /** Reads a single `Monitor` that is related to this `MonitorAttribute`. */
  monitor?: Maybe<Monitor>;
  /** The monitor associated with this attribute. */
  monitorId: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The time the record was updated. */
  updatedAt: Scalars['Datetime']['output'];
  /** The value of this monitor attribute. */
  value: Scalars['String']['output'];
};

/**
 * A condition to be used against `MonitorAttribute` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type MonitorAttributeCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdBy` field. */
  createdBy?: InputMaybe<ActorInput>;
  /** Checks for equality with the object’s `key` field. */
  key?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `monitorId` field. */
  monitorId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `MonitorAttribute` object types. All fields are combined with a logical ‘and.’ */
export type MonitorAttributeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MonitorAttributeFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdBy` field. */
  createdBy?: InputMaybe<ActorFilter>;
  /** Filter by the object’s `key` field. */
  key?: InputMaybe<StringFilter>;
  /** Filter by the object’s `monitor` relation. */
  monitor?: InputMaybe<MonitorFilter>;
  /** Filter by the object’s `monitorId` field. */
  monitorId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MonitorAttributeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MonitorAttributeFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `MonitorAttribute` */
export type MonitorAttributeInput = {
  /** The attribute key. */
  key: Scalars['String']['input'];
  /** The monitor associated with this attribute. */
  monitorId: Scalars['Int']['input'];
  /** The value of this monitor attribute. */
  value: Scalars['String']['input'];
};

/** A connection to a list of `MonitorAttribute` values. */
export type MonitorAttributesConnection = {
  __typename?: 'MonitorAttributesConnection';
  /** A list of edges which contains the `MonitorAttribute` and cursor to aid in pagination. */
  edges: Array<MonitorAttributesEdge>;
  /** A list of `MonitorAttribute` objects. */
  nodes: Array<MonitorAttribute>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MonitorAttribute` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `MonitorAttribute` edge in the connection. */
export type MonitorAttributesEdge = {
  __typename?: 'MonitorAttributesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `MonitorAttribute` at the end of the edge. */
  node: MonitorAttribute;
};

/** Methods to use when ordering `MonitorAttribute`. */
export enum MonitorAttributesOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  CREATED_BY_ASC = 'CREATED_BY_ASC',
  CREATED_BY_DESC = 'CREATED_BY_DESC',
  KEY_ASC = 'KEY_ASC',
  KEY_DESC = 'KEY_DESC',
  MONITOR_ID_ASC = 'MONITOR_ID_ASC',
  MONITOR_ID_DESC = 'MONITOR_ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  VALUE_ASC = 'VALUE_ASC',
  VALUE_DESC = 'VALUE_DESC'
}

/** A condition to be used against `Monitor` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type MonitorCondition = {
  /** Checks for equality with the object’s `aggregationMethod` field. */
  aggregationMethod?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `checkId` field. */
  checkId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `condition` field. */
  condition?: InputMaybe<ThresholdCondition>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `isEnabled` field. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `mergedAttributes` field. */
  mergedAttributes?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `monitorType` field. */
  monitorType?: InputMaybe<MonitorType>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `rtnDuration` field. */
  rtnDuration?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `rtnValue` field. */
  rtnValue?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `samplingWindow` field. */
  samplingWindow?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<MonitorStatusType>;
  /** Checks for equality with the object’s `thresholdDuration` field. */
  thresholdDuration?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `thresholdValue` field. */
  thresholdValue?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `window` field. */
  window?: InputMaybe<IntervalInput>;
};

export type MonitorDataPoint = Node & {
  __typename?: 'MonitorDataPoint';
  /** The time the monitor was created. */
  createdAt: Scalars['Datetime']['output'];
  /** Reads a single `DataPoint` that is related to this `MonitorDataPoint`. */
  dataPoint?: Maybe<DataPoint>;
  /** The associated data point. */
  dataPointId: Scalars['Int']['output'];
  /** Reads a single `Monitor` that is related to this `MonitorDataPoint`. */
  monitor?: Maybe<Monitor>;
  /** The associated monitor. */
  monitorId: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
};

/**
 * A condition to be used against `MonitorDataPoint` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type MonitorDataPointCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `dataPointId` field. */
  dataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `monitorId` field. */
  monitorId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `MonitorDataPoint` object types. All fields are combined with a logical ‘and.’ */
export type MonitorDataPointFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MonitorDataPointFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dataPointId` field. */
  dataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `monitorId` field. */
  monitorId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MonitorDataPointFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MonitorDataPointFilter>>;
};

/** An input for mutations affecting `MonitorDataPoint` */
export type MonitorDataPointInput = {
  /** Mutates a `DataPoint` as part of the payload */
  dataPoint?: InputMaybe<DataPointInput>;
  /** The associated data point. */
  dataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** The associated monitor. */
  monitorId: Scalars['Int']['input'];
};

/** Represents an update to a `MonitorDataPoint`. Fields that are set will be updated. */
export type MonitorDataPointPatch = {
  /** The associated data point. */
  dataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** The associated monitor. */
  monitorId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `MonitorDataPoint` values. */
export type MonitorDataPointsConnection = {
  __typename?: 'MonitorDataPointsConnection';
  /** Returns the aggregate data timeseries data for the MonitorDataPointsConnection  */
  data?: Maybe<MetricDataConnection>;
  /** A list of edges which contains the `MonitorDataPoint` and cursor to aid in pagination. */
  edges: Array<MonitorDataPointsEdge>;
  /** A list of `MonitorDataPoint` objects. */
  nodes: Array<MonitorDataPoint>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MonitorDataPoint` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A connection to a list of `MonitorDataPoint` values. */
export type MonitorDataPointsConnectionDataArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A `MonitorDataPoint` edge in the connection. */
export type MonitorDataPointsEdge = {
  __typename?: 'MonitorDataPointsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `MonitorDataPoint` at the end of the edge. */
  node: MonitorDataPoint;
};

/** Methods to use when ordering `MonitorDataPoint`. */
export enum MonitorDataPointsOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DATA_POINT_ID_ASC = 'DATA_POINT_ID_ASC',
  DATA_POINT_ID_DESC = 'DATA_POINT_ID_DESC',
  MONITOR_ID_ASC = 'MONITOR_ID_ASC',
  MONITOR_ID_DESC = 'MONITOR_ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

/** A detection event associated with a data point monitor condition. */
export type MonitorDetection = Node & {
  __typename?: 'MonitorDetection';
  /** The time the detected event was created. */
  createdAt: Scalars['Datetime']['output'];
  /** Returns the duration, in seconds, of the detection event. */
  durationSeconds?: Maybe<Scalars['Int']['output']>;
  /** The end time of the detection. */
  endTime?: Maybe<Scalars['Datetime']['output']>;
  /** The identifer of the detected event. */
  id: Scalars['BigInt']['output'];
  /** Reads and enables pagination through a set of `Incident`. */
  incidents: IncidentsConnection;
  /** Reads a single `Monitor` that is related to this `MonitorDetection`. */
  monitor?: Maybe<Monitor>;
  /** The associated monitor. */
  monitorId: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The start time of the detection. */
  startTime: Scalars['Datetime']['output'];
  tripValue?: Maybe<Scalars['JSON']['output']>;
  /** The time the detected event was updated. */
  updatedAt: Scalars['Datetime']['output'];
};

/** A detection event associated with a data point monitor condition. */
export type MonitorDetectionIncidentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<IncidentCondition>;
  filter?: InputMaybe<IncidentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IncidentsOrderBy>>;
};

export type MonitorDetectionAggregates = {
  __typename?: 'MonitorDetectionAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<MonitorDetectionAverageAggregates>;
  /** Distinct aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinct?: Maybe<MonitorDetectionDistinctAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<MonitorDetectionDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<MonitorDetectionMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<MonitorDetectionMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<MonitorDetectionStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<MonitorDetectionStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<MonitorDetectionSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<MonitorDetectionVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<MonitorDetectionVarianceSampleAggregates>;
};

export type MonitorDetectionAverageAggregates = {
  __typename?: 'MonitorDetectionAverageAggregates';
  /**
   * Mean average of this field across the matching connection.
   *
   * ---
   *
   * Returns the duration, in seconds, of the detection event.
   */
  durationSeconds?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of monitorId across the matching connection */
  monitorId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `MonitorDetection` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type MonitorDetectionCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `endTime` field. */
  endTime?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `monitorId` field. */
  monitorId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `startTime` field. */
  startTime?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `tripValue` field. */
  tripValue?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export type MonitorDetectionDistinctAggregates = {
  __typename?: 'MonitorDetectionDistinctAggregates';
  /** Distinct of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['JSON']['output']>;
  /** Distinct of duration across the matching connection */
  duration?: Maybe<Scalars['JSON']['output']>;
  /**
   * Distinct of this field across the matching connection.
   *
   * ---
   *
   * Returns the duration, in seconds, of the detection event.
   */
  durationSeconds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Distinct of endTime across the matching connection */
  endTime?: Maybe<Scalars['JSON']['output']>;
  /** Distinct of id across the matching connection */
  id?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Distinct of monitorId across the matching connection */
  monitorId?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Distinct of startTime across the matching connection */
  startTime?: Maybe<Scalars['JSON']['output']>;
  /** Distinct of tripValue across the matching connection */
  tripValue?: Maybe<Scalars['JSON']['output']>;
  /** Distinct of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['JSON']['output']>;
};

export type MonitorDetectionDistinctCountAggregates = {
  __typename?: 'MonitorDetectionDistinctCountAggregates';
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of duration across the matching connection */
  duration?: Maybe<Scalars['BigInt']['output']>;
  /**
   * Distinct count of this field across the matching connection.
   *
   * ---
   *
   * Returns the duration, in seconds, of the detection event.
   */
  durationSeconds?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of endTime across the matching connection */
  endTime?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of monitorId across the matching connection */
  monitorId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of startTime across the matching connection */
  startTime?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of tripValue across the matching connection */
  tripValue?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `MonitorDetection` object types. All fields are combined with a logical ‘and.’ */
export type MonitorDetectionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MonitorDetectionFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `durationSeconds` field. */
  durationSeconds?: InputMaybe<IntFilter>;
  /** Filter by the object’s `endTime` field. */
  endTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `monitorId` field. */
  monitorId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MonitorDetectionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MonitorDetectionFilter>>;
  /** Filter by the object’s `startTime` field. */
  startTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `tripValue` field. */
  tripValue?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `MonitorDetection` */
export type MonitorDetectionInput = {
  /** The end time of the detection. */
  endTime?: InputMaybe<Scalars['Datetime']['input']>;
  /** The associated monitor. */
  monitorId: Scalars['Int']['input'];
  /** The start time of the detection. */
  startTime: Scalars['Datetime']['input'];
  tripValue?: InputMaybe<Scalars['JSON']['input']>;
};

export type MonitorDetectionMaxAggregates = {
  __typename?: 'MonitorDetectionMaxAggregates';
  /**
   * Maximum of this field across the matching connection.
   *
   * ---
   *
   * Returns the duration, in seconds, of the detection event.
   */
  durationSeconds?: Maybe<Scalars['Int']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of monitorId across the matching connection */
  monitorId?: Maybe<Scalars['Int']['output']>;
};

export type MonitorDetectionMinAggregates = {
  __typename?: 'MonitorDetectionMinAggregates';
  /**
   * Minimum of this field across the matching connection.
   *
   * ---
   *
   * Returns the duration, in seconds, of the detection event.
   */
  durationSeconds?: Maybe<Scalars['Int']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of monitorId across the matching connection */
  monitorId?: Maybe<Scalars['Int']['output']>;
};

/** Represents an update to a `MonitorDetection`. Fields that are set will be updated. */
export type MonitorDetectionPatch = {
  /** The end time of the detection. */
  endTime?: InputMaybe<Scalars['Datetime']['input']>;
  /** The associated monitor. */
  monitorId?: InputMaybe<Scalars['Int']['input']>;
  /** The start time of the detection. */
  startTime?: InputMaybe<Scalars['Datetime']['input']>;
  tripValue?: InputMaybe<Scalars['JSON']['input']>;
};

export type MonitorDetectionStddevPopulationAggregates = {
  __typename?: 'MonitorDetectionStddevPopulationAggregates';
  /**
   * Population standard deviation of this field across the matching connection.
   *
   * ---
   *
   * Returns the duration, in seconds, of the detection event.
   */
  durationSeconds?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of monitorId across the matching connection */
  monitorId?: Maybe<Scalars['BigFloat']['output']>;
};

export type MonitorDetectionStddevSampleAggregates = {
  __typename?: 'MonitorDetectionStddevSampleAggregates';
  /**
   * Sample standard deviation of this field across the matching connection.
   *
   * ---
   *
   * Returns the duration, in seconds, of the detection event.
   */
  durationSeconds?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of monitorId across the matching connection */
  monitorId?: Maybe<Scalars['BigFloat']['output']>;
};

export type MonitorDetectionSumAggregates = {
  __typename?: 'MonitorDetectionSumAggregates';
  /**
   * Sum of this field across the matching connection.
   *
   * ---
   *
   * Returns the duration, in seconds, of the detection event.
   */
  durationSeconds?: Maybe<Scalars['BigInt']['output']>;
  /** Sum of id across the matching connection */
  id: Scalars['BigFloat']['output'];
  /** Sum of monitorId across the matching connection */
  monitorId: Scalars['BigInt']['output'];
};

/** A connection to a list of `MonitorDetectionSummary` values. */
export type MonitorDetectionSummariesConnection = {
  __typename?: 'MonitorDetectionSummariesConnection';
  /** A list of edges which contains the `MonitorDetectionSummary` and cursor to aid in pagination. */
  edges: Array<MonitorDetectionSummariesEdge>;
  /** A list of `MonitorDetectionSummary` objects. */
  nodes: Array<MonitorDetectionSummary>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MonitorDetectionSummary` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `MonitorDetectionSummary` edge in the connection. */
export type MonitorDetectionSummariesEdge = {
  __typename?: 'MonitorDetectionSummariesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `MonitorDetectionSummary` at the end of the edge. */
  node: MonitorDetectionSummary;
};

/** Methods to use when ordering `MonitorDetectionSummary`. */
export enum MonitorDetectionSummariesOrderBy {
  ATTRIBUTES_ASC = 'ATTRIBUTES_ASC',
  ATTRIBUTES_DESC = 'ATTRIBUTES_DESC',
  CHECK_ID_ASC = 'CHECK_ID_ASC',
  CHECK_ID_DESC = 'CHECK_ID_DESC',
  CHECK_NAME_ASC = 'CHECK_NAME_ASC',
  CHECK_NAME_DESC = 'CHECK_NAME_DESC',
  DETECTION_COUNT_ASC = 'DETECTION_COUNT_ASC',
  DETECTION_COUNT_DESC = 'DETECTION_COUNT_DESC',
  DETECTION_DURATION_PERCENT_ASC = 'DETECTION_DURATION_PERCENT_ASC',
  DETECTION_DURATION_PERCENT_DESC = 'DETECTION_DURATION_PERCENT_DESC',
  FACILITY_IDS_ASC = 'FACILITY_IDS_ASC',
  FACILITY_IDS_DESC = 'FACILITY_IDS_DESC',
  FACILITY_NAMES_ASC = 'FACILITY_NAMES_ASC',
  FACILITY_NAMES_DESC = 'FACILITY_NAMES_DESC',
  MONITOR_DESCRIPTION_ASC = 'MONITOR_DESCRIPTION_ASC',
  MONITOR_DESCRIPTION_DESC = 'MONITOR_DESCRIPTION_DESC',
  MONITOR_ID_ASC = 'MONITOR_ID_ASC',
  MONITOR_ID_DESC = 'MONITOR_ID_DESC',
  MONITOR_NAME_ASC = 'MONITOR_NAME_ASC',
  MONITOR_NAME_DESC = 'MONITOR_NAME_DESC',
  NATURAL = 'NATURAL',
  STATUS_ASC = 'STATUS_ASC',
  STATUS_DESC = 'STATUS_DESC'
}

/** Special table type to allow querying using the function monitor_detection_summaries_by_timeframe */
export type MonitorDetectionSummary = {
  __typename?: 'MonitorDetectionSummary';
  attributes: Scalars['JSON']['output'];
  checkId?: Maybe<Scalars['Int']['output']>;
  checkName?: Maybe<Scalars['String']['output']>;
  detectionCount: Scalars['Int']['output'];
  detectionDurationPercent: Scalars['Float']['output'];
  facilityIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  facilityNames?: Maybe<Scalars['String']['output']>;
  monitorDescription?: Maybe<Scalars['String']['output']>;
  monitorId: Scalars['Int']['output'];
  monitorName: Scalars['String']['output'];
  status: MonitorStatusType;
};

/** A filter to be used against `MonitorDetectionSummary` object types. All fields are combined with a logical ‘and.’ */
export type MonitorDetectionSummaryFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MonitorDetectionSummaryFilter>>;
  /** Filter by the object’s `attributes` field. */
  attributes?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `checkId` field. */
  checkId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `checkName` field. */
  checkName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `detectionCount` field. */
  detectionCount?: InputMaybe<IntFilter>;
  /** Filter by the object’s `detectionDurationPercent` field. */
  detectionDurationPercent?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `facilityIds` field. */
  facilityIds?: InputMaybe<IntListFilter>;
  /** Filter by the object’s `facilityNames` field. */
  facilityNames?: InputMaybe<StringFilter>;
  /** Filter by the object’s `monitorDescription` field. */
  monitorDescription?: InputMaybe<StringFilter>;
  /** Filter by the object’s `monitorId` field. */
  monitorId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `monitorName` field. */
  monitorName?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MonitorDetectionSummaryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MonitorDetectionSummaryFilter>>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<MonitorStatusTypeFilter>;
};

export type MonitorDetectionVariancePopulationAggregates = {
  __typename?: 'MonitorDetectionVariancePopulationAggregates';
  /**
   * Population variance of this field across the matching connection.
   *
   * ---
   *
   * Returns the duration, in seconds, of the detection event.
   */
  durationSeconds?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of monitorId across the matching connection */
  monitorId?: Maybe<Scalars['BigFloat']['output']>;
};

export type MonitorDetectionVarianceSampleAggregates = {
  __typename?: 'MonitorDetectionVarianceSampleAggregates';
  /**
   * Sample variance of this field across the matching connection.
   *
   * ---
   *
   * Returns the duration, in seconds, of the detection event.
   */
  durationSeconds?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of monitorId across the matching connection */
  monitorId?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `MonitorDetection` values. */
export type MonitorDetectionsConnection = {
  __typename?: 'MonitorDetectionsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<MonitorDetectionAggregates>;
  /** A list of edges which contains the `MonitorDetection` and cursor to aid in pagination. */
  edges: Array<MonitorDetectionsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<MonitorDetectionAggregates>>;
  /** A list of `MonitorDetection` objects. */
  nodes: Array<MonitorDetection>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MonitorDetection` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A connection to a list of `MonitorDetection` values. */
export type MonitorDetectionsConnectionGroupedAggregatesArgs = {
  groupBy: Array<MonitorDetectionsGroupBy>;
  having?: InputMaybe<MonitorDetectionsHavingInput>;
};

/** A `MonitorDetection` edge in the connection. */
export type MonitorDetectionsEdge = {
  __typename?: 'MonitorDetectionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `MonitorDetection` at the end of the edge. */
  node: MonitorDetection;
};

/** Grouping methods for `MonitorDetection` for usage during aggregation. */
export enum MonitorDetectionsGroupBy {
  CREATED_AT = 'CREATED_AT',
  CREATED_AT_DISTINCT = 'CREATED_AT_DISTINCT',
  CREATED_AT_TRUNCATED_TO_DAY = 'CREATED_AT_TRUNCATED_TO_DAY',
  CREATED_AT_TRUNCATED_TO_HOUR = 'CREATED_AT_TRUNCATED_TO_HOUR',
  END_TIME = 'END_TIME',
  END_TIME_DISTINCT = 'END_TIME_DISTINCT',
  END_TIME_TRUNCATED_TO_DAY = 'END_TIME_TRUNCATED_TO_DAY',
  END_TIME_TRUNCATED_TO_HOUR = 'END_TIME_TRUNCATED_TO_HOUR',
  MONITOR_ID = 'MONITOR_ID',
  MONITOR_ID_DISTINCT = 'MONITOR_ID_DISTINCT',
  START_TIME = 'START_TIME',
  START_TIME_DISTINCT = 'START_TIME_DISTINCT',
  START_TIME_TRUNCATED_TO_DAY = 'START_TIME_TRUNCATED_TO_DAY',
  START_TIME_TRUNCATED_TO_HOUR = 'START_TIME_TRUNCATED_TO_HOUR',
  TRIP_VALUE = 'TRIP_VALUE',
  TRIP_VALUE_DISTINCT = 'TRIP_VALUE_DISTINCT',
  UPDATED_AT = 'UPDATED_AT',
  UPDATED_AT_DISTINCT = 'UPDATED_AT_DISTINCT',
  UPDATED_AT_TRUNCATED_TO_DAY = 'UPDATED_AT_TRUNCATED_TO_DAY',
  UPDATED_AT_TRUNCATED_TO_HOUR = 'UPDATED_AT_TRUNCATED_TO_HOUR'
}

export type MonitorDetectionsHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  durationSeconds?: InputMaybe<MonitorDetectionsHavingAverageMonitorDetectionsDurationSecondsInput>;
  endTime?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  monitorId?: InputMaybe<HavingIntFilter>;
  startTime?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type MonitorDetectionsHavingAverageMonitorDetectionsDurationSecondsInput =
  {
    filter?: InputMaybe<HavingIntFilter>;
  };

export type MonitorDetectionsHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  durationSeconds?: InputMaybe<MonitorDetectionsHavingDistinctCountMonitorDetectionsDurationSecondsInput>;
  endTime?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  monitorId?: InputMaybe<HavingIntFilter>;
  startTime?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type MonitorDetectionsHavingDistinctCountMonitorDetectionsDurationSecondsInput =
  {
    filter?: InputMaybe<HavingIntFilter>;
  };

export type MonitorDetectionsHavingDistinctInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  durationSeconds?: InputMaybe<MonitorDetectionsHavingDistinctMonitorDetectionsDurationSecondsInput>;
  endTime?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  monitorId?: InputMaybe<HavingIntFilter>;
  startTime?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type MonitorDetectionsHavingDistinctMonitorDetectionsDurationSecondsInput =
  {
    filter?: InputMaybe<HavingIntFilter>;
  };

/** Conditions for `MonitorDetection` aggregates. */
export type MonitorDetectionsHavingInput = {
  AND?: InputMaybe<Array<MonitorDetectionsHavingInput>>;
  OR?: InputMaybe<Array<MonitorDetectionsHavingInput>>;
  average?: InputMaybe<MonitorDetectionsHavingAverageInput>;
  distinct?: InputMaybe<MonitorDetectionsHavingDistinctInput>;
  distinctCount?: InputMaybe<MonitorDetectionsHavingDistinctCountInput>;
  max?: InputMaybe<MonitorDetectionsHavingMaxInput>;
  min?: InputMaybe<MonitorDetectionsHavingMinInput>;
  stddevPopulation?: InputMaybe<MonitorDetectionsHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<MonitorDetectionsHavingStddevSampleInput>;
  sum?: InputMaybe<MonitorDetectionsHavingSumInput>;
  variancePopulation?: InputMaybe<MonitorDetectionsHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<MonitorDetectionsHavingVarianceSampleInput>;
};

export type MonitorDetectionsHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  durationSeconds?: InputMaybe<MonitorDetectionsHavingMaxMonitorDetectionsDurationSecondsInput>;
  endTime?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  monitorId?: InputMaybe<HavingIntFilter>;
  startTime?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type MonitorDetectionsHavingMaxMonitorDetectionsDurationSecondsInput = {
  filter?: InputMaybe<HavingIntFilter>;
};

export type MonitorDetectionsHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  durationSeconds?: InputMaybe<MonitorDetectionsHavingMinMonitorDetectionsDurationSecondsInput>;
  endTime?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  monitorId?: InputMaybe<HavingIntFilter>;
  startTime?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type MonitorDetectionsHavingMinMonitorDetectionsDurationSecondsInput = {
  filter?: InputMaybe<HavingIntFilter>;
};

export type MonitorDetectionsHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  durationSeconds?: InputMaybe<MonitorDetectionsHavingStddevPopulationMonitorDetectionsDurationSecondsInput>;
  endTime?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  monitorId?: InputMaybe<HavingIntFilter>;
  startTime?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type MonitorDetectionsHavingStddevPopulationMonitorDetectionsDurationSecondsInput =
  {
    filter?: InputMaybe<HavingIntFilter>;
  };

export type MonitorDetectionsHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  durationSeconds?: InputMaybe<MonitorDetectionsHavingStddevSampleMonitorDetectionsDurationSecondsInput>;
  endTime?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  monitorId?: InputMaybe<HavingIntFilter>;
  startTime?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type MonitorDetectionsHavingStddevSampleMonitorDetectionsDurationSecondsInput =
  {
    filter?: InputMaybe<HavingIntFilter>;
  };

export type MonitorDetectionsHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  durationSeconds?: InputMaybe<MonitorDetectionsHavingSumMonitorDetectionsDurationSecondsInput>;
  endTime?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  monitorId?: InputMaybe<HavingIntFilter>;
  startTime?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type MonitorDetectionsHavingSumMonitorDetectionsDurationSecondsInput = {
  filter?: InputMaybe<HavingIntFilter>;
};

export type MonitorDetectionsHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  durationSeconds?: InputMaybe<MonitorDetectionsHavingVariancePopulationMonitorDetectionsDurationSecondsInput>;
  endTime?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  monitorId?: InputMaybe<HavingIntFilter>;
  startTime?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type MonitorDetectionsHavingVariancePopulationMonitorDetectionsDurationSecondsInput =
  {
    filter?: InputMaybe<HavingIntFilter>;
  };

export type MonitorDetectionsHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  durationSeconds?: InputMaybe<MonitorDetectionsHavingVarianceSampleMonitorDetectionsDurationSecondsInput>;
  endTime?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  monitorId?: InputMaybe<HavingIntFilter>;
  startTime?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type MonitorDetectionsHavingVarianceSampleMonitorDetectionsDurationSecondsInput =
  {
    filter?: InputMaybe<HavingIntFilter>;
  };

/** Methods to use when ordering `MonitorDetection`. */
export enum MonitorDetectionsOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  END_TIME_ASC = 'END_TIME_ASC',
  END_TIME_DESC = 'END_TIME_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  MONITOR_ID_ASC = 'MONITOR_ID_ASC',
  MONITOR_ID_DESC = 'MONITOR_ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  START_TIME_ASC = 'START_TIME_ASC',
  START_TIME_DESC = 'START_TIME_DESC',
  TRIP_VALUE_ASC = 'TRIP_VALUE_ASC',
  TRIP_VALUE_DESC = 'TRIP_VALUE_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** The enabled user subscriptions for each monitor. */
export type MonitorEnabledUserSubscription = {
  __typename?: 'MonitorEnabledUserSubscription';
  enabledChannels?: Maybe<Array<Maybe<UserSubscriptionChannel>>>;
  /** Reads a single `Monitor` that is related to this `MonitorEnabledUserSubscription`. */
  monitor?: Maybe<Monitor>;
  monitorId?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  /** Reads a single `User` that is related to this `MonitorEnabledUserSubscription`. */
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};

/**
 * A condition to be used against `MonitorEnabledUserSubscription` object types.
 * All fields are tested for equality and combined with a logical ‘and.’
 */
export type MonitorEnabledUserSubscriptionCondition = {
  /** Checks for equality with the object’s `enabledChannels` field. */
  enabledChannels?: InputMaybe<Array<InputMaybe<UserSubscriptionChannel>>>;
  /** Checks for equality with the object’s `monitorId` field. */
  monitorId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `MonitorEnabledUserSubscription` object types. All fields are combined with a logical ‘and.’ */
export type MonitorEnabledUserSubscriptionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MonitorEnabledUserSubscriptionFilter>>;
  /** Filter by the object’s `enabledChannels` field. */
  enabledChannels?: InputMaybe<UserSubscriptionChannelListFilter>;
  /** Filter by the object’s `monitorId` field. */
  monitorId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MonitorEnabledUserSubscriptionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MonitorEnabledUserSubscriptionFilter>>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<StringFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<StringFilter>;
};

/** A connection to a list of `MonitorEnabledUserSubscription` values. */
export type MonitorEnabledUserSubscriptionsConnection = {
  __typename?: 'MonitorEnabledUserSubscriptionsConnection';
  /** A list of edges which contains the `MonitorEnabledUserSubscription` and cursor to aid in pagination. */
  edges: Array<MonitorEnabledUserSubscriptionsEdge>;
  /** A list of `MonitorEnabledUserSubscription` objects. */
  nodes: Array<MonitorEnabledUserSubscription>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MonitorEnabledUserSubscription` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `MonitorEnabledUserSubscription` edge in the connection. */
export type MonitorEnabledUserSubscriptionsEdge = {
  __typename?: 'MonitorEnabledUserSubscriptionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `MonitorEnabledUserSubscription` at the end of the edge. */
  node: MonitorEnabledUserSubscription;
};

/** Methods to use when ordering `MonitorEnabledUserSubscription`. */
export enum MonitorEnabledUserSubscriptionsOrderBy {
  ENABLED_CHANNELS_ASC = 'ENABLED_CHANNELS_ASC',
  ENABLED_CHANNELS_DESC = 'ENABLED_CHANNELS_DESC',
  MONITOR_ID_ASC = 'MONITOR_ID_ASC',
  MONITOR_ID_DESC = 'MONITOR_ID_DESC',
  NATURAL = 'NATURAL',
  TYPE_ASC = 'TYPE_ASC',
  TYPE_DESC = 'TYPE_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC'
}

/** A filter to be used against `Monitor` object types. All fields are combined with a logical ‘and.’ */
export type MonitorFilter = {
  /** Filter by the object’s `aggregationMethod` field. */
  aggregationMethod?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MonitorFilter>>;
  /** Filter by the object’s `attributes` relation. */
  attributes?: InputMaybe<MonitorToManyMonitorAttributeFilter>;
  /** Some related `attributes` exist. */
  attributesExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `checkId` field. */
  checkId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `checkName` field. */
  checkName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `condition` field. */
  condition?: InputMaybe<ThresholdConditionFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dataPointIds` field. */
  dataPointIds?: InputMaybe<IntListFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `facilityIds` field. */
  facilityIds?: InputMaybe<IntListFilter>;
  /** Filter by the object’s `facilityNames` field. */
  facilityNames?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isEnabled` field. */
  isEnabled?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isMonitoring` field. */
  isMonitoring?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isTriggered` field. */
  isTriggered?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `lastDetectedStartTime` field. */
  lastDetectedStartTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `mergedAttributes` field. */
  mergedAttributes?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `monitorType` field. */
  monitorType?: InputMaybe<MonitorTypeFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MonitorFilter>;
  /** Filter by the object’s `oneDayDetectionCount` field. */
  oneDayDetectionCount?: InputMaybe<IntFilter>;
  /** Filter by the object’s `oneDayDetectionDurationSeconds` field. */
  oneDayDetectionDurationSeconds?: InputMaybe<IntFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MonitorFilter>>;
  /** Filter by the object’s `rtnDuration` field. */
  rtnDuration?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `rtnValue` field. */
  rtnValue?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `samplingWindow` field. */
  samplingWindow?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `sevenDayDetectionCount` field. */
  sevenDayDetectionCount?: InputMaybe<IntFilter>;
  /** Filter by the object’s `sevenDayDetectionDurationSeconds` field. */
  sevenDayDetectionDurationSeconds?: InputMaybe<IntFilter>;
  /** Filter by the object’s `softwarePackageSlugs` field. */
  softwarePackageSlugs?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<MonitorStatusTypeFilter>;
  /** Filter by the object’s `thirtyDayDetectionCount` field. */
  thirtyDayDetectionCount?: InputMaybe<IntFilter>;
  /** Filter by the object’s `thirtyDayDetectionDurationSeconds` field. */
  thirtyDayDetectionDurationSeconds?: InputMaybe<IntFilter>;
  /** Filter by the object’s `thresholdDuration` field. */
  thresholdDuration?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `thresholdValue` field. */
  thresholdValue?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `window` field. */
  window?: InputMaybe<IntervalFilter>;
};

/** An input for mutations affecting `Monitor` */
export type MonitorInput = {
  /** The aggregation method for the data point. */
  aggregationMethod?: InputMaybe<MetricDataAggregationMethod>;
  /** Attributes to set/replace */
  attributes?: InputMaybe<Array<AttributePairInput>>;
  /** The condition to evaluate the value against. */
  condition?: InputMaybe<ThresholdCondition>;
  /** The data points to monitor */
  dataPointIds?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  /** The description of the monitor. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Indicates whether the monitor is enabled or disabled. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the monitor is. */
  name: Scalars['String']['input'];
  /** The Return-to-Normal (RTN) duration that a trigger condition must meet to resolve (default: instant). */
  rtnDuration?: InputMaybe<IntervalInput>;
  /** The Return-to-Normal (RTN) value that a trigger condition must meet to resolve (default: thresholdValue). */
  rtnValue?: InputMaybe<Scalars['JSON']['input']>;
  /** The sampling window interval of the underlying data point (defaults to window interval). */
  samplingWindow?: InputMaybe<IntervalInput>;
  /** The duration interval that the monitor condition must be valid. */
  thresholdDuration?: InputMaybe<IntervalInput>;
  /** The threshold value that the underlying data point evaluates against. */
  thresholdValue: Scalars['JSON']['input'];
  /** The bucket window interval used to monitor the data point. */
  window?: InputMaybe<IntervalInput>;
};

/** Represents an update to a `Monitor`. Fields that are set will be updated. */
export type MonitorPatch = {
  /** The aggregation method for the data point. */
  aggregationMethod?: InputMaybe<MetricDataAggregationMethod>;
  /** Attributes to set/replace */
  attributes?: InputMaybe<Array<AttributePairInput>>;
  /** The condition to evaluate the value against. */
  condition?: InputMaybe<ThresholdCondition>;
  /** The data points to monitor */
  dataPointIds?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  /** The description of the monitor. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Indicates whether the monitor is enabled or disabled. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the monitor is. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The Return-to-Normal (RTN) duration that a trigger condition must meet to resolve (default: instant). */
  rtnDuration?: InputMaybe<IntervalInput>;
  /** The Return-to-Normal (RTN) value that a trigger condition must meet to resolve (default: thresholdValue). */
  rtnValue?: InputMaybe<Scalars['JSON']['input']>;
  /** The sampling window interval of the underlying data point (defaults to window interval). */
  samplingWindow?: InputMaybe<IntervalInput>;
  /** The duration interval that the monitor condition must be valid. */
  thresholdDuration?: InputMaybe<IntervalInput>;
  /** The threshold value that the underlying data point evaluates against. */
  thresholdValue?: InputMaybe<Scalars['JSON']['input']>;
  /** The bucket window interval used to monitor the data point. */
  window?: InputMaybe<IntervalInput>;
};

export enum MonitorResultOuput {
  CONDITION_MET = 'CONDITION_MET',
  FULL_SERIES = 'FULL_SERIES',
  INFLECTION_POINTS = 'INFLECTION_POINTS'
}

export enum MonitorStatusType {
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED',
  TRIGGERED = 'TRIGGERED'
}

/** A filter to be used against MonitorStatusType fields. All fields are combined with a logical ‘and.’ */
export type MonitorStatusTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<MonitorStatusType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<MonitorStatusType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<MonitorStatusType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<MonitorStatusType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<MonitorStatusType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<MonitorStatusType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<MonitorStatusType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<MonitorStatusType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<MonitorStatusType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<MonitorStatusType>>;
};

/** A filter to be used against many `MonitorAttribute` object types. All fields are combined with a logical ‘and.’ */
export type MonitorToManyMonitorAttributeFilter = {
  /** Every related `MonitorAttribute` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MonitorAttributeFilter>;
  /** No related `MonitorAttribute` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MonitorAttributeFilter>;
  /** Some related `MonitorAttribute` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MonitorAttributeFilter>;
};

export enum MonitorType {
  THRESHOLD = 'THRESHOLD'
}

/** A filter to be used against MonitorType fields. All fields are combined with a logical ‘and.’ */
export type MonitorTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<MonitorType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<MonitorType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<MonitorType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<MonitorType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<MonitorType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<MonitorType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<MonitorType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<MonitorType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<MonitorType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<MonitorType>>;
};

/** Represents an abstracted reference to equipment monitored by the platform, used for cross-schema asset tracking. */
export type MonitoredAsset = Node & {
  __typename?: 'MonitoredAsset';
  /** Reads and enables pagination through a set of `Assessment`. */
  assessments: AssessmentsConnection;
  /** The primary key of the referenced asset in its source table. */
  assetId: Scalars['Int']['output'];
  /** The related Compressor. */
  compressor?: Maybe<Compressor>;
  /** The time the record was created. */
  createdAt: Scalars['Datetime']['output'];
  /** The related Electrical Metering. */
  electricalMeteringPoint?: Maybe<ElectricalMeteringPoint>;
  /** The associated facility of the monitored asset */
  facility?: Maybe<Facility>;
  /** The associated facility ID of the monitored asset */
  facilityId?: Maybe<Scalars['Int']['output']>;
  /** The related Facility Utility Account. */
  facilityUtilityAccount?: Maybe<FacilityUtilityAccount>;
  /** The identifier of the monitored asset. */
  id: Scalars['Int']['output'];
  /** Reads and enables pagination through a set of `MonitoredAssetsLatestAssessment`. */
  latestAssessments: MonitoredAssetsLatestAssessmentsConnection;
  /** The name of the monitored asset */
  name?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The related Temperature Sensor. */
  temperatureSensor?: Maybe<TemperatureSensor>;
  /** The type of the monitored asset. */
  type?: Maybe<Scalars['String']['output']>;
  /** The time the record was last updated. */
  updatedAt: Scalars['Datetime']['output'];
};

/** Represents an abstracted reference to equipment monitored by the platform, used for cross-schema asset tracking. */
export type MonitoredAssetAssessmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AssessmentCondition>;
  filter?: InputMaybe<AssessmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AssessmentsOrderBy>>;
};

/** Represents an abstracted reference to equipment monitored by the platform, used for cross-schema asset tracking. */
export type MonitoredAssetLatestAssessmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MonitoredAssetsLatestAssessmentCondition>;
  filter?: InputMaybe<MonitoredAssetsLatestAssessmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MonitoredAssetsLatestAssessmentsOrderBy>>;
};

/**
 * A condition to be used against `MonitoredAsset` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type MonitoredAssetCondition = {
  /** Checks for equality with the object’s `assetId` field. */
  assetId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `MonitoredAsset` object types. All fields are combined with a logical ‘and.’ */
export type MonitoredAssetFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MonitoredAssetFilter>>;
  /** Filter by the object’s `assetId` field. */
  assetId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MonitoredAssetFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MonitoredAssetFilter>>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** A list of known asset types. */
export type MonitoredAssetType = {
  __typename?: 'MonitoredAssetType';
  label?: Maybe<Scalars['String']['output']>;
  typeName?: Maybe<Scalars['String']['output']>;
};

/**
 * A condition to be used against `MonitoredAssetType` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type MonitoredAssetTypeCondition = {
  /** Checks for equality with the object’s `label` field. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `typeName` field. */
  typeName?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `MonitoredAssetType` object types. All fields are combined with a logical ‘and.’ */
export type MonitoredAssetTypeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MonitoredAssetTypeFilter>>;
  /** Filter by the object’s `label` field. */
  label?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MonitoredAssetTypeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MonitoredAssetTypeFilter>>;
  /** Filter by the object’s `typeName` field. */
  typeName?: InputMaybe<StringFilter>;
};

/** A connection to a list of `MonitoredAssetType` values. */
export type MonitoredAssetTypesConnection = {
  __typename?: 'MonitoredAssetTypesConnection';
  /** A list of edges which contains the `MonitoredAssetType` and cursor to aid in pagination. */
  edges: Array<MonitoredAssetTypesEdge>;
  /** A list of `MonitoredAssetType` objects. */
  nodes: Array<MonitoredAssetType>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MonitoredAssetType` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `MonitoredAssetType` edge in the connection. */
export type MonitoredAssetTypesEdge = {
  __typename?: 'MonitoredAssetTypesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `MonitoredAssetType` at the end of the edge. */
  node: MonitoredAssetType;
};

/** Methods to use when ordering `MonitoredAssetType`. */
export enum MonitoredAssetTypesOrderBy {
  LABEL_ASC = 'LABEL_ASC',
  LABEL_DESC = 'LABEL_DESC',
  NATURAL = 'NATURAL',
  TYPE_NAME_ASC = 'TYPE_NAME_ASC',
  TYPE_NAME_DESC = 'TYPE_NAME_DESC'
}

/** A connection to a list of `MonitoredAsset` values. */
export type MonitoredAssetsConnection = {
  __typename?: 'MonitoredAssetsConnection';
  /** A list of edges which contains the `MonitoredAsset` and cursor to aid in pagination. */
  edges: Array<MonitoredAssetsEdge>;
  /** A list of `MonitoredAsset` objects. */
  nodes: Array<MonitoredAsset>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MonitoredAsset` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `MonitoredAsset` edge in the connection. */
export type MonitoredAssetsEdge = {
  __typename?: 'MonitoredAssetsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `MonitoredAsset` at the end of the edge. */
  node: MonitoredAsset;
};

export type MonitoredAssetsLatestAssessment = {
  __typename?: 'MonitoredAssetsLatestAssessment';
  analysisEnd?: Maybe<Scalars['Date']['output']>;
  analysisStart?: Maybe<Scalars['Date']['output']>;
  /** Reads a single `Assessment` that is related to this `MonitoredAssetsLatestAssessment`. */
  assessment?: Maybe<Assessment>;
  assessmentId?: Maybe<Scalars['Int']['output']>;
  assessmentScore?: Maybe<Scalars['BigFloat']['output']>;
  /** Reads a single `AssessmentType` that is related to this `MonitoredAssetsLatestAssessment`. */
  assessmentType?: Maybe<AssessmentType>;
  assessmentTypeId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `Facility` that is related to this `MonitoredAssetsLatestAssessment`. */
  facility?: Maybe<Facility>;
  facilityId?: Maybe<Scalars['Int']['output']>;
  isSignificant?: Maybe<Scalars['Boolean']['output']>;
  /** Reads a single `MonitoredAsset` that is related to this `MonitoredAssetsLatestAssessment`. */
  monitoredAsset?: Maybe<MonitoredAsset>;
  monitoredAssetId?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Assessment` that is related to this `MonitoredAssetsLatestAssessment`. */
  previousAssessment?: Maybe<Assessment>;
  previousAssessmentId?: Maybe<Scalars['Int']['output']>;
  previousScore?: Maybe<Scalars['BigFloat']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/**
 * A condition to be used against `MonitoredAssetsLatestAssessment` object types.
 * All fields are tested for equality and combined with a logical ‘and.’
 */
export type MonitoredAssetsLatestAssessmentCondition = {
  /** Checks for equality with the object’s `analysisEnd` field. */
  analysisEnd?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `analysisStart` field. */
  analysisStart?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `assessmentId` field. */
  assessmentId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `assessmentScore` field. */
  assessmentScore?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `assessmentTypeId` field. */
  assessmentTypeId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `isSignificant` field. */
  isSignificant?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `monitoredAssetId` field. */
  monitoredAssetId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `previousAssessmentId` field. */
  previousAssessmentId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `previousScore` field. */
  previousScore?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `MonitoredAssetsLatestAssessment` object types. All fields are combined with a logical ‘and.’ */
export type MonitoredAssetsLatestAssessmentFilter = {
  /** Filter by the object’s `analysisEnd` field. */
  analysisEnd?: InputMaybe<DateFilter>;
  /** Filter by the object’s `analysisStart` field. */
  analysisStart?: InputMaybe<DateFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MonitoredAssetsLatestAssessmentFilter>>;
  /** Filter by the object’s `assessmentId` field. */
  assessmentId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `assessmentScore` field. */
  assessmentScore?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `assessmentTypeId` field. */
  assessmentTypeId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isSignificant` field. */
  isSignificant?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `monitoredAssetId` field. */
  monitoredAssetId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MonitoredAssetsLatestAssessmentFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MonitoredAssetsLatestAssessmentFilter>>;
  /** Filter by the object’s `previousAssessmentId` field. */
  previousAssessmentId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `previousScore` field. */
  previousScore?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<StringFilter>;
};

/** A connection to a list of `MonitoredAssetsLatestAssessment` values. */
export type MonitoredAssetsLatestAssessmentsConnection = {
  __typename?: 'MonitoredAssetsLatestAssessmentsConnection';
  /** A list of edges which contains the `MonitoredAssetsLatestAssessment` and cursor to aid in pagination. */
  edges: Array<MonitoredAssetsLatestAssessmentsEdge>;
  /** A list of `MonitoredAssetsLatestAssessment` objects. */
  nodes: Array<MonitoredAssetsLatestAssessment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MonitoredAssetsLatestAssessment` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `MonitoredAssetsLatestAssessment` edge in the connection. */
export type MonitoredAssetsLatestAssessmentsEdge = {
  __typename?: 'MonitoredAssetsLatestAssessmentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `MonitoredAssetsLatestAssessment` at the end of the edge. */
  node: MonitoredAssetsLatestAssessment;
};

/** Methods to use when ordering `MonitoredAssetsLatestAssessment`. */
export enum MonitoredAssetsLatestAssessmentsOrderBy {
  ANALYSIS_END_ASC = 'ANALYSIS_END_ASC',
  ANALYSIS_END_DESC = 'ANALYSIS_END_DESC',
  ANALYSIS_START_ASC = 'ANALYSIS_START_ASC',
  ANALYSIS_START_DESC = 'ANALYSIS_START_DESC',
  ASSESSMENT_ID_ASC = 'ASSESSMENT_ID_ASC',
  ASSESSMENT_ID_DESC = 'ASSESSMENT_ID_DESC',
  ASSESSMENT_SCORE_ASC = 'ASSESSMENT_SCORE_ASC',
  ASSESSMENT_SCORE_DESC = 'ASSESSMENT_SCORE_DESC',
  ASSESSMENT_TYPE_ID_ASC = 'ASSESSMENT_TYPE_ID_ASC',
  ASSESSMENT_TYPE_ID_DESC = 'ASSESSMENT_TYPE_ID_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  IS_SIGNIFICANT_ASC = 'IS_SIGNIFICANT_ASC',
  IS_SIGNIFICANT_DESC = 'IS_SIGNIFICANT_DESC',
  MONITORED_ASSET_ID_ASC = 'MONITORED_ASSET_ID_ASC',
  MONITORED_ASSET_ID_DESC = 'MONITORED_ASSET_ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PREVIOUS_ASSESSMENT_ID_ASC = 'PREVIOUS_ASSESSMENT_ID_ASC',
  PREVIOUS_ASSESSMENT_ID_DESC = 'PREVIOUS_ASSESSMENT_ID_DESC',
  PREVIOUS_SCORE_ASC = 'PREVIOUS_SCORE_ASC',
  PREVIOUS_SCORE_DESC = 'PREVIOUS_SCORE_DESC',
  TYPE_ASC = 'TYPE_ASC',
  TYPE_DESC = 'TYPE_DESC'
}

/** Methods to use when ordering `MonitoredAsset`. */
export enum MonitoredAssetsOrderBy {
  ASSET_ID_ASC = 'ASSET_ID_ASC',
  ASSET_ID_DESC = 'ASSET_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** A connection to a list of `Monitor` values. */
export type MonitorsConnection = {
  __typename?: 'MonitorsConnection';
  /** The duration in seconds for the given monitors */
  detectionDurationSeconds: Scalars['Int']['output'];
  /** A list of edges which contains the `Monitor` and cursor to aid in pagination. */
  edges: Array<MonitorsEdge>;
  /** A list of `Monitor` objects. */
  nodes: Array<Monitor>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Monitor` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A connection to a list of `Monitor` values. */
export type MonitorsConnectionDetectionDurationSecondsArgs = {
  from: Scalars['Datetime']['input'];
  to?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A `Monitor` edge in the connection. */
export type MonitorsEdge = {
  __typename?: 'MonitorsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Monitor` at the end of the edge. */
  node: Monitor;
};

/** Methods to use when ordering `Monitor`. */
export enum MonitorsOrderBy {
  AGGREGATION_METHOD_ASC = 'AGGREGATION_METHOD_ASC',
  AGGREGATION_METHOD_DESC = 'AGGREGATION_METHOD_DESC',
  CHECK_NAME_ASC = 'CHECK_NAME_ASC',
  CHECK_NAME_DESC = 'CHECK_NAME_DESC',
  CONDITION_ASC = 'CONDITION_ASC',
  CONDITION_DESC = 'CONDITION_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  DETECTIONS_AVERAGE_CREATED_AT_ASC = 'DETECTIONS_AVERAGE_CREATED_AT_ASC',
  DETECTIONS_AVERAGE_CREATED_AT_DESC = 'DETECTIONS_AVERAGE_CREATED_AT_DESC',
  DETECTIONS_AVERAGE_DURATION_ASC = 'DETECTIONS_AVERAGE_DURATION_ASC',
  DETECTIONS_AVERAGE_DURATION_DESC = 'DETECTIONS_AVERAGE_DURATION_DESC',
  DETECTIONS_AVERAGE_END_TIME_ASC = 'DETECTIONS_AVERAGE_END_TIME_ASC',
  DETECTIONS_AVERAGE_END_TIME_DESC = 'DETECTIONS_AVERAGE_END_TIME_DESC',
  DETECTIONS_AVERAGE_ID_ASC = 'DETECTIONS_AVERAGE_ID_ASC',
  DETECTIONS_AVERAGE_ID_DESC = 'DETECTIONS_AVERAGE_ID_DESC',
  DETECTIONS_AVERAGE_MONITOR_ID_ASC = 'DETECTIONS_AVERAGE_MONITOR_ID_ASC',
  DETECTIONS_AVERAGE_MONITOR_ID_DESC = 'DETECTIONS_AVERAGE_MONITOR_ID_DESC',
  DETECTIONS_AVERAGE_START_TIME_ASC = 'DETECTIONS_AVERAGE_START_TIME_ASC',
  DETECTIONS_AVERAGE_START_TIME_DESC = 'DETECTIONS_AVERAGE_START_TIME_DESC',
  DETECTIONS_AVERAGE_TRIP_VALUE_ASC = 'DETECTIONS_AVERAGE_TRIP_VALUE_ASC',
  DETECTIONS_AVERAGE_TRIP_VALUE_DESC = 'DETECTIONS_AVERAGE_TRIP_VALUE_DESC',
  DETECTIONS_AVERAGE_UPDATED_AT_ASC = 'DETECTIONS_AVERAGE_UPDATED_AT_ASC',
  DETECTIONS_AVERAGE_UPDATED_AT_DESC = 'DETECTIONS_AVERAGE_UPDATED_AT_DESC',
  DETECTIONS_COUNT_ASC = 'DETECTIONS_COUNT_ASC',
  DETECTIONS_COUNT_DESC = 'DETECTIONS_COUNT_DESC',
  DETECTIONS_DISTINCT_COUNT_CREATED_AT_ASC = 'DETECTIONS_DISTINCT_COUNT_CREATED_AT_ASC',
  DETECTIONS_DISTINCT_COUNT_CREATED_AT_DESC = 'DETECTIONS_DISTINCT_COUNT_CREATED_AT_DESC',
  DETECTIONS_DISTINCT_COUNT_DURATION_ASC = 'DETECTIONS_DISTINCT_COUNT_DURATION_ASC',
  DETECTIONS_DISTINCT_COUNT_DURATION_DESC = 'DETECTIONS_DISTINCT_COUNT_DURATION_DESC',
  DETECTIONS_DISTINCT_COUNT_END_TIME_ASC = 'DETECTIONS_DISTINCT_COUNT_END_TIME_ASC',
  DETECTIONS_DISTINCT_COUNT_END_TIME_DESC = 'DETECTIONS_DISTINCT_COUNT_END_TIME_DESC',
  DETECTIONS_DISTINCT_COUNT_ID_ASC = 'DETECTIONS_DISTINCT_COUNT_ID_ASC',
  DETECTIONS_DISTINCT_COUNT_ID_DESC = 'DETECTIONS_DISTINCT_COUNT_ID_DESC',
  DETECTIONS_DISTINCT_COUNT_MONITOR_ID_ASC = 'DETECTIONS_DISTINCT_COUNT_MONITOR_ID_ASC',
  DETECTIONS_DISTINCT_COUNT_MONITOR_ID_DESC = 'DETECTIONS_DISTINCT_COUNT_MONITOR_ID_DESC',
  DETECTIONS_DISTINCT_COUNT_START_TIME_ASC = 'DETECTIONS_DISTINCT_COUNT_START_TIME_ASC',
  DETECTIONS_DISTINCT_COUNT_START_TIME_DESC = 'DETECTIONS_DISTINCT_COUNT_START_TIME_DESC',
  DETECTIONS_DISTINCT_COUNT_TRIP_VALUE_ASC = 'DETECTIONS_DISTINCT_COUNT_TRIP_VALUE_ASC',
  DETECTIONS_DISTINCT_COUNT_TRIP_VALUE_DESC = 'DETECTIONS_DISTINCT_COUNT_TRIP_VALUE_DESC',
  DETECTIONS_DISTINCT_COUNT_UPDATED_AT_ASC = 'DETECTIONS_DISTINCT_COUNT_UPDATED_AT_ASC',
  DETECTIONS_DISTINCT_COUNT_UPDATED_AT_DESC = 'DETECTIONS_DISTINCT_COUNT_UPDATED_AT_DESC',
  DETECTIONS_DISTINCT_CREATED_AT_ASC = 'DETECTIONS_DISTINCT_CREATED_AT_ASC',
  DETECTIONS_DISTINCT_CREATED_AT_DESC = 'DETECTIONS_DISTINCT_CREATED_AT_DESC',
  DETECTIONS_DISTINCT_DURATION_ASC = 'DETECTIONS_DISTINCT_DURATION_ASC',
  DETECTIONS_DISTINCT_DURATION_DESC = 'DETECTIONS_DISTINCT_DURATION_DESC',
  DETECTIONS_DISTINCT_END_TIME_ASC = 'DETECTIONS_DISTINCT_END_TIME_ASC',
  DETECTIONS_DISTINCT_END_TIME_DESC = 'DETECTIONS_DISTINCT_END_TIME_DESC',
  DETECTIONS_DISTINCT_ID_ASC = 'DETECTIONS_DISTINCT_ID_ASC',
  DETECTIONS_DISTINCT_ID_DESC = 'DETECTIONS_DISTINCT_ID_DESC',
  DETECTIONS_DISTINCT_MONITOR_ID_ASC = 'DETECTIONS_DISTINCT_MONITOR_ID_ASC',
  DETECTIONS_DISTINCT_MONITOR_ID_DESC = 'DETECTIONS_DISTINCT_MONITOR_ID_DESC',
  DETECTIONS_DISTINCT_START_TIME_ASC = 'DETECTIONS_DISTINCT_START_TIME_ASC',
  DETECTIONS_DISTINCT_START_TIME_DESC = 'DETECTIONS_DISTINCT_START_TIME_DESC',
  DETECTIONS_DISTINCT_TRIP_VALUE_ASC = 'DETECTIONS_DISTINCT_TRIP_VALUE_ASC',
  DETECTIONS_DISTINCT_TRIP_VALUE_DESC = 'DETECTIONS_DISTINCT_TRIP_VALUE_DESC',
  DETECTIONS_DISTINCT_UPDATED_AT_ASC = 'DETECTIONS_DISTINCT_UPDATED_AT_ASC',
  DETECTIONS_DISTINCT_UPDATED_AT_DESC = 'DETECTIONS_DISTINCT_UPDATED_AT_DESC',
  DETECTIONS_MAX_CREATED_AT_ASC = 'DETECTIONS_MAX_CREATED_AT_ASC',
  DETECTIONS_MAX_CREATED_AT_DESC = 'DETECTIONS_MAX_CREATED_AT_DESC',
  DETECTIONS_MAX_DURATION_ASC = 'DETECTIONS_MAX_DURATION_ASC',
  DETECTIONS_MAX_DURATION_DESC = 'DETECTIONS_MAX_DURATION_DESC',
  DETECTIONS_MAX_END_TIME_ASC = 'DETECTIONS_MAX_END_TIME_ASC',
  DETECTIONS_MAX_END_TIME_DESC = 'DETECTIONS_MAX_END_TIME_DESC',
  DETECTIONS_MAX_ID_ASC = 'DETECTIONS_MAX_ID_ASC',
  DETECTIONS_MAX_ID_DESC = 'DETECTIONS_MAX_ID_DESC',
  DETECTIONS_MAX_MONITOR_ID_ASC = 'DETECTIONS_MAX_MONITOR_ID_ASC',
  DETECTIONS_MAX_MONITOR_ID_DESC = 'DETECTIONS_MAX_MONITOR_ID_DESC',
  DETECTIONS_MAX_START_TIME_ASC = 'DETECTIONS_MAX_START_TIME_ASC',
  DETECTIONS_MAX_START_TIME_DESC = 'DETECTIONS_MAX_START_TIME_DESC',
  DETECTIONS_MAX_TRIP_VALUE_ASC = 'DETECTIONS_MAX_TRIP_VALUE_ASC',
  DETECTIONS_MAX_TRIP_VALUE_DESC = 'DETECTIONS_MAX_TRIP_VALUE_DESC',
  DETECTIONS_MAX_UPDATED_AT_ASC = 'DETECTIONS_MAX_UPDATED_AT_ASC',
  DETECTIONS_MAX_UPDATED_AT_DESC = 'DETECTIONS_MAX_UPDATED_AT_DESC',
  DETECTIONS_MIN_CREATED_AT_ASC = 'DETECTIONS_MIN_CREATED_AT_ASC',
  DETECTIONS_MIN_CREATED_AT_DESC = 'DETECTIONS_MIN_CREATED_AT_DESC',
  DETECTIONS_MIN_DURATION_ASC = 'DETECTIONS_MIN_DURATION_ASC',
  DETECTIONS_MIN_DURATION_DESC = 'DETECTIONS_MIN_DURATION_DESC',
  DETECTIONS_MIN_END_TIME_ASC = 'DETECTIONS_MIN_END_TIME_ASC',
  DETECTIONS_MIN_END_TIME_DESC = 'DETECTIONS_MIN_END_TIME_DESC',
  DETECTIONS_MIN_ID_ASC = 'DETECTIONS_MIN_ID_ASC',
  DETECTIONS_MIN_ID_DESC = 'DETECTIONS_MIN_ID_DESC',
  DETECTIONS_MIN_MONITOR_ID_ASC = 'DETECTIONS_MIN_MONITOR_ID_ASC',
  DETECTIONS_MIN_MONITOR_ID_DESC = 'DETECTIONS_MIN_MONITOR_ID_DESC',
  DETECTIONS_MIN_START_TIME_ASC = 'DETECTIONS_MIN_START_TIME_ASC',
  DETECTIONS_MIN_START_TIME_DESC = 'DETECTIONS_MIN_START_TIME_DESC',
  DETECTIONS_MIN_TRIP_VALUE_ASC = 'DETECTIONS_MIN_TRIP_VALUE_ASC',
  DETECTIONS_MIN_TRIP_VALUE_DESC = 'DETECTIONS_MIN_TRIP_VALUE_DESC',
  DETECTIONS_MIN_UPDATED_AT_ASC = 'DETECTIONS_MIN_UPDATED_AT_ASC',
  DETECTIONS_MIN_UPDATED_AT_DESC = 'DETECTIONS_MIN_UPDATED_AT_DESC',
  DETECTIONS_STDDEV_POPULATION_CREATED_AT_ASC = 'DETECTIONS_STDDEV_POPULATION_CREATED_AT_ASC',
  DETECTIONS_STDDEV_POPULATION_CREATED_AT_DESC = 'DETECTIONS_STDDEV_POPULATION_CREATED_AT_DESC',
  DETECTIONS_STDDEV_POPULATION_DURATION_ASC = 'DETECTIONS_STDDEV_POPULATION_DURATION_ASC',
  DETECTIONS_STDDEV_POPULATION_DURATION_DESC = 'DETECTIONS_STDDEV_POPULATION_DURATION_DESC',
  DETECTIONS_STDDEV_POPULATION_END_TIME_ASC = 'DETECTIONS_STDDEV_POPULATION_END_TIME_ASC',
  DETECTIONS_STDDEV_POPULATION_END_TIME_DESC = 'DETECTIONS_STDDEV_POPULATION_END_TIME_DESC',
  DETECTIONS_STDDEV_POPULATION_ID_ASC = 'DETECTIONS_STDDEV_POPULATION_ID_ASC',
  DETECTIONS_STDDEV_POPULATION_ID_DESC = 'DETECTIONS_STDDEV_POPULATION_ID_DESC',
  DETECTIONS_STDDEV_POPULATION_MONITOR_ID_ASC = 'DETECTIONS_STDDEV_POPULATION_MONITOR_ID_ASC',
  DETECTIONS_STDDEV_POPULATION_MONITOR_ID_DESC = 'DETECTIONS_STDDEV_POPULATION_MONITOR_ID_DESC',
  DETECTIONS_STDDEV_POPULATION_START_TIME_ASC = 'DETECTIONS_STDDEV_POPULATION_START_TIME_ASC',
  DETECTIONS_STDDEV_POPULATION_START_TIME_DESC = 'DETECTIONS_STDDEV_POPULATION_START_TIME_DESC',
  DETECTIONS_STDDEV_POPULATION_TRIP_VALUE_ASC = 'DETECTIONS_STDDEV_POPULATION_TRIP_VALUE_ASC',
  DETECTIONS_STDDEV_POPULATION_TRIP_VALUE_DESC = 'DETECTIONS_STDDEV_POPULATION_TRIP_VALUE_DESC',
  DETECTIONS_STDDEV_POPULATION_UPDATED_AT_ASC = 'DETECTIONS_STDDEV_POPULATION_UPDATED_AT_ASC',
  DETECTIONS_STDDEV_POPULATION_UPDATED_AT_DESC = 'DETECTIONS_STDDEV_POPULATION_UPDATED_AT_DESC',
  DETECTIONS_STDDEV_SAMPLE_CREATED_AT_ASC = 'DETECTIONS_STDDEV_SAMPLE_CREATED_AT_ASC',
  DETECTIONS_STDDEV_SAMPLE_CREATED_AT_DESC = 'DETECTIONS_STDDEV_SAMPLE_CREATED_AT_DESC',
  DETECTIONS_STDDEV_SAMPLE_DURATION_ASC = 'DETECTIONS_STDDEV_SAMPLE_DURATION_ASC',
  DETECTIONS_STDDEV_SAMPLE_DURATION_DESC = 'DETECTIONS_STDDEV_SAMPLE_DURATION_DESC',
  DETECTIONS_STDDEV_SAMPLE_END_TIME_ASC = 'DETECTIONS_STDDEV_SAMPLE_END_TIME_ASC',
  DETECTIONS_STDDEV_SAMPLE_END_TIME_DESC = 'DETECTIONS_STDDEV_SAMPLE_END_TIME_DESC',
  DETECTIONS_STDDEV_SAMPLE_ID_ASC = 'DETECTIONS_STDDEV_SAMPLE_ID_ASC',
  DETECTIONS_STDDEV_SAMPLE_ID_DESC = 'DETECTIONS_STDDEV_SAMPLE_ID_DESC',
  DETECTIONS_STDDEV_SAMPLE_MONITOR_ID_ASC = 'DETECTIONS_STDDEV_SAMPLE_MONITOR_ID_ASC',
  DETECTIONS_STDDEV_SAMPLE_MONITOR_ID_DESC = 'DETECTIONS_STDDEV_SAMPLE_MONITOR_ID_DESC',
  DETECTIONS_STDDEV_SAMPLE_START_TIME_ASC = 'DETECTIONS_STDDEV_SAMPLE_START_TIME_ASC',
  DETECTIONS_STDDEV_SAMPLE_START_TIME_DESC = 'DETECTIONS_STDDEV_SAMPLE_START_TIME_DESC',
  DETECTIONS_STDDEV_SAMPLE_TRIP_VALUE_ASC = 'DETECTIONS_STDDEV_SAMPLE_TRIP_VALUE_ASC',
  DETECTIONS_STDDEV_SAMPLE_TRIP_VALUE_DESC = 'DETECTIONS_STDDEV_SAMPLE_TRIP_VALUE_DESC',
  DETECTIONS_STDDEV_SAMPLE_UPDATED_AT_ASC = 'DETECTIONS_STDDEV_SAMPLE_UPDATED_AT_ASC',
  DETECTIONS_STDDEV_SAMPLE_UPDATED_AT_DESC = 'DETECTIONS_STDDEV_SAMPLE_UPDATED_AT_DESC',
  DETECTIONS_SUM_CREATED_AT_ASC = 'DETECTIONS_SUM_CREATED_AT_ASC',
  DETECTIONS_SUM_CREATED_AT_DESC = 'DETECTIONS_SUM_CREATED_AT_DESC',
  DETECTIONS_SUM_DURATION_ASC = 'DETECTIONS_SUM_DURATION_ASC',
  DETECTIONS_SUM_DURATION_DESC = 'DETECTIONS_SUM_DURATION_DESC',
  DETECTIONS_SUM_END_TIME_ASC = 'DETECTIONS_SUM_END_TIME_ASC',
  DETECTIONS_SUM_END_TIME_DESC = 'DETECTIONS_SUM_END_TIME_DESC',
  DETECTIONS_SUM_ID_ASC = 'DETECTIONS_SUM_ID_ASC',
  DETECTIONS_SUM_ID_DESC = 'DETECTIONS_SUM_ID_DESC',
  DETECTIONS_SUM_MONITOR_ID_ASC = 'DETECTIONS_SUM_MONITOR_ID_ASC',
  DETECTIONS_SUM_MONITOR_ID_DESC = 'DETECTIONS_SUM_MONITOR_ID_DESC',
  DETECTIONS_SUM_START_TIME_ASC = 'DETECTIONS_SUM_START_TIME_ASC',
  DETECTIONS_SUM_START_TIME_DESC = 'DETECTIONS_SUM_START_TIME_DESC',
  DETECTIONS_SUM_TRIP_VALUE_ASC = 'DETECTIONS_SUM_TRIP_VALUE_ASC',
  DETECTIONS_SUM_TRIP_VALUE_DESC = 'DETECTIONS_SUM_TRIP_VALUE_DESC',
  DETECTIONS_SUM_UPDATED_AT_ASC = 'DETECTIONS_SUM_UPDATED_AT_ASC',
  DETECTIONS_SUM_UPDATED_AT_DESC = 'DETECTIONS_SUM_UPDATED_AT_DESC',
  DETECTIONS_VARIANCE_POPULATION_CREATED_AT_ASC = 'DETECTIONS_VARIANCE_POPULATION_CREATED_AT_ASC',
  DETECTIONS_VARIANCE_POPULATION_CREATED_AT_DESC = 'DETECTIONS_VARIANCE_POPULATION_CREATED_AT_DESC',
  DETECTIONS_VARIANCE_POPULATION_DURATION_ASC = 'DETECTIONS_VARIANCE_POPULATION_DURATION_ASC',
  DETECTIONS_VARIANCE_POPULATION_DURATION_DESC = 'DETECTIONS_VARIANCE_POPULATION_DURATION_DESC',
  DETECTIONS_VARIANCE_POPULATION_END_TIME_ASC = 'DETECTIONS_VARIANCE_POPULATION_END_TIME_ASC',
  DETECTIONS_VARIANCE_POPULATION_END_TIME_DESC = 'DETECTIONS_VARIANCE_POPULATION_END_TIME_DESC',
  DETECTIONS_VARIANCE_POPULATION_ID_ASC = 'DETECTIONS_VARIANCE_POPULATION_ID_ASC',
  DETECTIONS_VARIANCE_POPULATION_ID_DESC = 'DETECTIONS_VARIANCE_POPULATION_ID_DESC',
  DETECTIONS_VARIANCE_POPULATION_MONITOR_ID_ASC = 'DETECTIONS_VARIANCE_POPULATION_MONITOR_ID_ASC',
  DETECTIONS_VARIANCE_POPULATION_MONITOR_ID_DESC = 'DETECTIONS_VARIANCE_POPULATION_MONITOR_ID_DESC',
  DETECTIONS_VARIANCE_POPULATION_START_TIME_ASC = 'DETECTIONS_VARIANCE_POPULATION_START_TIME_ASC',
  DETECTIONS_VARIANCE_POPULATION_START_TIME_DESC = 'DETECTIONS_VARIANCE_POPULATION_START_TIME_DESC',
  DETECTIONS_VARIANCE_POPULATION_TRIP_VALUE_ASC = 'DETECTIONS_VARIANCE_POPULATION_TRIP_VALUE_ASC',
  DETECTIONS_VARIANCE_POPULATION_TRIP_VALUE_DESC = 'DETECTIONS_VARIANCE_POPULATION_TRIP_VALUE_DESC',
  DETECTIONS_VARIANCE_POPULATION_UPDATED_AT_ASC = 'DETECTIONS_VARIANCE_POPULATION_UPDATED_AT_ASC',
  DETECTIONS_VARIANCE_POPULATION_UPDATED_AT_DESC = 'DETECTIONS_VARIANCE_POPULATION_UPDATED_AT_DESC',
  DETECTIONS_VARIANCE_SAMPLE_CREATED_AT_ASC = 'DETECTIONS_VARIANCE_SAMPLE_CREATED_AT_ASC',
  DETECTIONS_VARIANCE_SAMPLE_CREATED_AT_DESC = 'DETECTIONS_VARIANCE_SAMPLE_CREATED_AT_DESC',
  DETECTIONS_VARIANCE_SAMPLE_DURATION_ASC = 'DETECTIONS_VARIANCE_SAMPLE_DURATION_ASC',
  DETECTIONS_VARIANCE_SAMPLE_DURATION_DESC = 'DETECTIONS_VARIANCE_SAMPLE_DURATION_DESC',
  DETECTIONS_VARIANCE_SAMPLE_END_TIME_ASC = 'DETECTIONS_VARIANCE_SAMPLE_END_TIME_ASC',
  DETECTIONS_VARIANCE_SAMPLE_END_TIME_DESC = 'DETECTIONS_VARIANCE_SAMPLE_END_TIME_DESC',
  DETECTIONS_VARIANCE_SAMPLE_ID_ASC = 'DETECTIONS_VARIANCE_SAMPLE_ID_ASC',
  DETECTIONS_VARIANCE_SAMPLE_ID_DESC = 'DETECTIONS_VARIANCE_SAMPLE_ID_DESC',
  DETECTIONS_VARIANCE_SAMPLE_MONITOR_ID_ASC = 'DETECTIONS_VARIANCE_SAMPLE_MONITOR_ID_ASC',
  DETECTIONS_VARIANCE_SAMPLE_MONITOR_ID_DESC = 'DETECTIONS_VARIANCE_SAMPLE_MONITOR_ID_DESC',
  DETECTIONS_VARIANCE_SAMPLE_START_TIME_ASC = 'DETECTIONS_VARIANCE_SAMPLE_START_TIME_ASC',
  DETECTIONS_VARIANCE_SAMPLE_START_TIME_DESC = 'DETECTIONS_VARIANCE_SAMPLE_START_TIME_DESC',
  DETECTIONS_VARIANCE_SAMPLE_TRIP_VALUE_ASC = 'DETECTIONS_VARIANCE_SAMPLE_TRIP_VALUE_ASC',
  DETECTIONS_VARIANCE_SAMPLE_TRIP_VALUE_DESC = 'DETECTIONS_VARIANCE_SAMPLE_TRIP_VALUE_DESC',
  DETECTIONS_VARIANCE_SAMPLE_UPDATED_AT_ASC = 'DETECTIONS_VARIANCE_SAMPLE_UPDATED_AT_ASC',
  DETECTIONS_VARIANCE_SAMPLE_UPDATED_AT_DESC = 'DETECTIONS_VARIANCE_SAMPLE_UPDATED_AT_DESC',
  FACILITY_NAMES_ASC = 'FACILITY_NAMES_ASC',
  FACILITY_NAMES_DESC = 'FACILITY_NAMES_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  IS_ENABLED_ASC = 'IS_ENABLED_ASC',
  IS_ENABLED_DESC = 'IS_ENABLED_DESC',
  IS_TRIGGERED_ASC = 'IS_TRIGGERED_ASC',
  IS_TRIGGERED_DESC = 'IS_TRIGGERED_DESC',
  LAST_DETECTED_START_TIME_ASC = 'LAST_DETECTED_START_TIME_ASC',
  LAST_DETECTED_START_TIME_DESC = 'LAST_DETECTED_START_TIME_DESC',
  MONITOR_TYPE_ASC = 'MONITOR_TYPE_ASC',
  MONITOR_TYPE_DESC = 'MONITOR_TYPE_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  ONE_DAY_DETECTION_COUNT_ASC = 'ONE_DAY_DETECTION_COUNT_ASC',
  ONE_DAY_DETECTION_COUNT_DESC = 'ONE_DAY_DETECTION_COUNT_DESC',
  ONE_DAY_DETECTION_DURATION_SECONDS_ASC = 'ONE_DAY_DETECTION_DURATION_SECONDS_ASC',
  ONE_DAY_DETECTION_DURATION_SECONDS_DESC = 'ONE_DAY_DETECTION_DURATION_SECONDS_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  RTN_DURATION_ASC = 'RTN_DURATION_ASC',
  RTN_DURATION_DESC = 'RTN_DURATION_DESC',
  RTN_VALUE_ASC = 'RTN_VALUE_ASC',
  RTN_VALUE_DESC = 'RTN_VALUE_DESC',
  SAMPLING_WINDOW_ASC = 'SAMPLING_WINDOW_ASC',
  SAMPLING_WINDOW_DESC = 'SAMPLING_WINDOW_DESC',
  SEVEN_DAY_DETECTION_COUNT_ASC = 'SEVEN_DAY_DETECTION_COUNT_ASC',
  SEVEN_DAY_DETECTION_COUNT_DESC = 'SEVEN_DAY_DETECTION_COUNT_DESC',
  SEVEN_DAY_DETECTION_DURATION_SECONDS_ASC = 'SEVEN_DAY_DETECTION_DURATION_SECONDS_ASC',
  SEVEN_DAY_DETECTION_DURATION_SECONDS_DESC = 'SEVEN_DAY_DETECTION_DURATION_SECONDS_DESC',
  STATUS_ASC = 'STATUS_ASC',
  STATUS_DESC = 'STATUS_DESC',
  THIRTY_DAY_DETECTION_COUNT_ASC = 'THIRTY_DAY_DETECTION_COUNT_ASC',
  THIRTY_DAY_DETECTION_COUNT_DESC = 'THIRTY_DAY_DETECTION_COUNT_DESC',
  THIRTY_DAY_DETECTION_DURATION_SECONDS_ASC = 'THIRTY_DAY_DETECTION_DURATION_SECONDS_ASC',
  THIRTY_DAY_DETECTION_DURATION_SECONDS_DESC = 'THIRTY_DAY_DETECTION_DURATION_SECONDS_DESC',
  THRESHOLD_DURATION_ASC = 'THRESHOLD_DURATION_ASC',
  THRESHOLD_DURATION_DESC = 'THRESHOLD_DURATION_DESC',
  THRESHOLD_VALUE_ASC = 'THRESHOLD_VALUE_ASC',
  THRESHOLD_VALUE_DESC = 'THRESHOLD_VALUE_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  WINDOW_ASC = 'WINDOW_ASC',
  WINDOW_DESC = 'WINDOW_DESC'
}

/** The root mutation type which contains root level fields which mutate data. */
export type Mutation = {
  __typename?: 'Mutation';
  acknowledgeControlEvent?: Maybe<ControlEvent>;
  /** Custom mutation for acknowledging an incident. */
  acknowledgeIncident?: Maybe<AcknowledgeIncidentPayload>;
  acknowledgeSuggestion?: Maybe<Suggestion>;
  /** Adds the facility as a favorite for the user. */
  addFavoriteFacility?: Maybe<AddFavoriteFacilityPayload>;
  /** Adds a child dependency to the specific metric */
  addMetricMetadataDependency?: Maybe<AddMetricMetadataDependencyPayload>;
  addProjectController?: Maybe<AddProjectControllerPayload>;
  addReportManager?: Maybe<AddReportManagerPayload>;
  assignSpace?: Maybe<AssignSpacePayload>;
  /** Clears the facility communication. */
  clearFacilityCommunication?: Maybe<ClearFacilityCommunicationPayload>;
  clearSpace?: Maybe<ClearSpacePayload>;
  /** Custom mutation for closing an incident. */
  closeIncident?: Maybe<CloseIncidentPayload>;
  closeStaleDriverConversations?: Maybe<CloseStaleDriverConversationsPayload>;
  /** Creates a single `AccountCharge`. */
  createAccountCharge?: Maybe<CreateAccountChargePayload>;
  /** Creates a single `AccountStatement`. */
  createAccountStatement?: Maybe<CreateAccountStatementPayload>;
  /** Creates a single `AccountStatementHistory`. */
  createAccountStatementHistory?: Maybe<CreateAccountStatementHistoryPayload>;
  /** Creates a single `AccountStatementPdf`. */
  createAccountStatementPdf?: Maybe<CreateAccountStatementPdfPayload>;
  /** Creates a single `Assessment`. */
  createAssessment?: Maybe<CreateAssessmentPayload>;
  /** Creates a single `AssessmentType`. */
  createAssessmentType?: Maybe<CreateAssessmentTypePayload>;
  /** Creates a single `BalancingAuthority`. */
  createBalancingAuthority?: Maybe<CreateBalancingAuthorityPayload>;
  /** Creates a single `BillableCustomer`. */
  createBillableCustomer?: Maybe<CreateBillableCustomerPayload>;
  /** Creates a single `Blast`. */
  createBlast?: Maybe<CreateBlastPayload>;
  /** Creates a single `BlastEvaporator`. */
  createBlastEvaporator?: Maybe<CreateBlastEvaporatorPayload>;
  /** Creates a single `BlastPallet`. */
  createBlastPallet?: Maybe<CreateBlastPalletPayload>;
  /** Creates a single `BlastPalletLocation`. */
  createBlastPalletLocation?: Maybe<CreateBlastPalletLocationPayload>;
  /** Creates a single `BlastRotation`. */
  createBlastRotation?: Maybe<CreateBlastRotationPayload>;
  /** Creates a single `BlastRotationAlert`. */
  createBlastRotationAlert?: Maybe<CreateBlastRotationAlertPayload>;
  /** Creates a single `BlastRotationEventLog`. */
  createBlastRotationEventLog?: Maybe<CreateBlastRotationEventLogPayload>;
  /** Creates a single `BlastRotationEventType`. */
  createBlastRotationEventType?: Maybe<CreateBlastRotationEventTypePayload>;
  /** Creates a single `BlastRotationPallet`. */
  createBlastRotationPallet?: Maybe<CreateBlastRotationPalletPayload>;
  /** Creates a single `BlastType`. */
  createBlastType?: Maybe<CreateBlastTypePayload>;
  /** Creates a single `BuildingArea`. */
  createBuildingArea?: Maybe<CreateBuildingAreaPayload>;
  /** Creates a single `BuildingAreaComplianceGroup`. */
  createBuildingAreaComplianceGroup?: Maybe<CreateBuildingAreaComplianceGroupPayload>;
  /** Creates a single `BuildingAreaType`. */
  createBuildingAreaType?: Maybe<CreateBuildingAreaTypePayload>;
  /** Creates a single `Chart`. */
  createChart?: Maybe<CreateChartPayload>;
  /** Creates a single `Check`. */
  createCheck?: Maybe<CreateCheckPayload>;
  /** Creates a single `CheckMonitor`. */
  createCheckMonitor?: Maybe<CreateCheckMonitorPayload>;
  /** Creates a single `Classification`. */
  createClassification?: Maybe<CreateClassificationPayload>;
  /** Creates a single `ClassificationResult`. */
  createClassificationResult?: Maybe<CreateClassificationResultPayload>;
  /** Creates a single `ComplianceGroup`. */
  createComplianceGroup?: Maybe<CreateComplianceGroupPayload>;
  /** Creates a single `ComplianceRange`. */
  createComplianceRange?: Maybe<CreateComplianceRangePayload>;
  /** Creates a single `Component`. */
  createComponent?: Maybe<CreateComponentPayload>;
  /** Creates a single `Compressor`. */
  createCompressor?: Maybe<CreateCompressorPayload>;
  /** Creates a single `ControlEvent`. */
  createControlEvent?: Maybe<CreateControlEventPayload>;
  /** Creates a single `ControlEventLog`. */
  createControlEventLog?: Maybe<CreateControlEventLogPayload>;
  /** Creates a single `Customer`. */
  createCustomer?: Maybe<CreateCustomerPayload>;
  /** Creates a single `CustomerBillingRate`. */
  createCustomerBillingRate?: Maybe<CreateCustomerBillingRatePayload>;
  createCustomerIntegrationCredential?: Maybe<CreateCustomerIntegrationCredentialPayload>;
  /** Creates a single `Dashboard`. */
  createDashboard?: Maybe<CreateDashboardPayload>;
  /** Creates a single `DataPoint`. */
  createDataPoint?: Maybe<CreateDataPointPayload>;
  /** Creates a single `DataSource`. */
  createDataSource?: Maybe<CreateDataSourcePayload>;
  /** Creates a single `Dependency`. */
  createDependency?: Maybe<CreateDependencyPayload>;
  /** Creates a single `DischargeHeader`. */
  createDischargeHeader?: Maybe<CreateDischargeHeaderPayload>;
  /** Creates a single `Door`. */
  createDoor?: Maybe<CreateDoorPayload>;
  /** Creates a single `Driver`. */
  createDriver?: Maybe<CreateDriverPayload>;
  /** Creates a single `ElectricalCircuit`. */
  createElectricalCircuit?: Maybe<CreateElectricalCircuitPayload>;
  /** Creates a single `ElectricalMeteringPoint`. */
  createElectricalMeteringPoint?: Maybe<CreateElectricalMeteringPointPayload>;
  /** Creates a single `ElectricalPanel`. */
  createElectricalPanel?: Maybe<CreateElectricalPanelPayload>;
  /** Creates a single `Evaporator`. */
  createEvaporator?: Maybe<CreateEvaporatorPayload>;
  /** Creates a single `Facility`. */
  createFacility?: Maybe<CreateFacilityPayload>;
  /** Creates a single `FacilityCheck`. */
  createFacilityCheck?: Maybe<CreateFacilityCheckPayload>;
  /** Creates a single `FacilityCommunication`. */
  createFacilityCommunication?: Maybe<CreateFacilityCommunicationPayload>;
  /** Creates a single `FacilityDataSource`. */
  createFacilityDataSource?: Maybe<CreateFacilityDataSourcePayload>;
  /** Creates a single `FacilityDocument`. */
  createFacilityDocument?: Maybe<CreateFacilityDocumentPayload>;
  /** Creates a single `FacilityGroup`. */
  createFacilityGroup?: Maybe<CreateFacilityGroupPayload>;
  /** Creates a single `FacilityGroupsLinker`. */
  createFacilityGroupsLinker?: Maybe<CreateFacilityGroupsLinkerPayload>;
  /** Creates a single `FacilitySoftwarePackage`. */
  createFacilitySoftwarePackage?: Maybe<CreateFacilitySoftwarePackagePayload>;
  /** Creates a single `FacilityTaggedDataPoint`. */
  createFacilityTaggedDataPoint?: Maybe<CreateFacilityTaggedDataPointPayload>;
  /** Creates a single `Gateway`. */
  createGateway?: Maybe<CreateGatewayPayload>;
  /** Creates a single `InboundOutboundLoad`. */
  createInboundOutboundLoad?: Maybe<CreateInboundOutboundLoadPayload>;
  /** Creates a single `Incident`. */
  createIncident?: Maybe<CreateIncidentPayload>;
  /** Creates a single `IncidentLog`. */
  createIncidentLog?: Maybe<CreateIncidentLogPayload>;
  /** Creates a single `LiquidHeader`. */
  createLiquidHeader?: Maybe<CreateLiquidHeaderPayload>;
  /** Creates a single `LiquidHeadersEvaporator`. */
  createLiquidHeadersEvaporator?: Maybe<CreateLiquidHeadersEvaporatorPayload>;
  createMachineAccessToken?: Maybe<CreateMachineAccessTokenPayload>;
  /** Creates a single `MachineUser`. */
  createMachineUser?: Maybe<CreateMachineUserPayload>;
  /** Creates a single `MainService`. */
  createMainService?: Maybe<CreateMainServicePayload>;
  /** Creates a single `MeterCharge`. */
  createMeterCharge?: Maybe<CreateMeterChargePayload>;
  /** Creates a single `MeterStatement`. */
  createMeterStatement?: Maybe<CreateMeterStatementPayload>;
  /** Creates a single `MeterStatementHistory`. */
  createMeterStatementHistory?: Maybe<CreateMeterStatementHistoryPayload>;
  /** Creates a single `MeterUsage`. */
  createMeterUsage?: Maybe<CreateMeterUsagePayload>;
  /** Creates a single `Monitor`. */
  createMonitor?: Maybe<CreateMonitorPayload>;
  /** Creates a single `MonitorDataPoint`. */
  createMonitorDataPoint?: Maybe<CreateMonitorDataPointPayload>;
  /** Creates a single `MonitorDetection`. */
  createMonitorDetection?: Maybe<CreateMonitorDetectionPayload>;
  /** Creates a single `Opportunity`. */
  createOpportunity?: Maybe<CreateOpportunityPayload>;
  /** Creates a single `OpportunityAttachment`. */
  createOpportunityAttachment?: Maybe<CreateOpportunityAttachmentPayload>;
  /** Creates a single `Pallet`. */
  createPallet?: Maybe<CreatePalletPayload>;
  /** Creates a single `PalletHistory`. */
  createPalletHistory?: Maybe<CreatePalletHistoryPayload>;
  /** Creates a single `PalletLocation`. */
  createPalletLocation?: Maybe<CreatePalletLocationPayload>;
  /** Creates a single `PricingNode`. */
  createPricingNode?: Maybe<CreatePricingNodePayload>;
  /** Creates a single `Product`. */
  createProduct?: Maybe<CreateProductPayload>;
  /** Creates a single `Program`. */
  createProgram?: Maybe<CreateProgramPayload>;
  /** Creates a single `ProgramEnrollment`. */
  createProgramEnrollment?: Maybe<CreateProgramEnrollmentPayload>;
  /** Creates a single `Project`. */
  createProject?: Maybe<CreateProjectPayload>;
  /** Creates a single `ProjectComponent`. */
  createProjectComponent?: Maybe<CreateProjectComponentPayload>;
  /** Creates a single `ProjectEnrollment`. */
  createProjectEnrollment?: Maybe<CreateProjectEnrollmentPayload>;
  /** Creates a single `ProjectEnrollmentDataPoint`. */
  createProjectEnrollmentDataPoint?: Maybe<CreateProjectEnrollmentDataPointPayload>;
  /** Creates a single `ProjectEnrollmentDataPointGroup`. */
  createProjectEnrollmentDataPointGroup?: Maybe<CreateProjectEnrollmentDataPointGroupPayload>;
  /** Creates a single `ProjectWatcher`. */
  createProjectWatcher?: Maybe<CreateProjectWatcherPayload>;
  /** Creates a single `RefrigerationSystem`. */
  createRefrigerationSystem?: Maybe<CreateRefrigerationSystemPayload>;
  /** Creates a single `ReportExecution`. */
  createReportExecution?: Maybe<CreateReportExecutionPayload>;
  /** Creates a single `SavingsEvent`. */
  createSavingsEvent?: Maybe<CreateSavingsEventPayload>;
  /** Creates a single `SavingsEventDatum`. */
  createSavingsEventDatum?: Maybe<CreateSavingsEventDatumPayload>;
  /** Creates a single `SpaceActivity`. */
  createSpaceActivity?: Maybe<CreateSpaceActivityPayload>;
  /** Creates a single `Submeter`. */
  createSubmeter?: Maybe<CreateSubmeterPayload>;
  /** Creates a single `SubmeterSession`. */
  createSubmeterSession?: Maybe<CreateSubmeterSessionPayload>;
  /** Creates a single `SuctionGroup`. */
  createSuctionGroup?: Maybe<CreateSuctionGroupPayload>;
  /** Creates a single `SuctionGroupCompressor`. */
  createSuctionGroupCompressor?: Maybe<CreateSuctionGroupCompressorPayload>;
  /** Creates a single `SuctionHeader`. */
  createSuctionHeader?: Maybe<CreateSuctionHeaderPayload>;
  /** Creates a single `SuctionHeadersCompressor`. */
  createSuctionHeadersCompressor?: Maybe<CreateSuctionHeadersCompressorPayload>;
  /** Creates a single `Suggestion`. */
  createSuggestion?: Maybe<CreateSuggestionPayload>;
  /** Creates a single `SuggestionActivityLog`. */
  createSuggestionActivityLog?: Maybe<CreateSuggestionActivityLogPayload>;
  /** Creates a single `SuggestionControlEvent`. */
  createSuggestionControlEvent?: Maybe<CreateSuggestionControlEventPayload>;
  /** Creates a single `TemperatureSensor`. */
  createTemperatureSensor?: Maybe<CreateTemperatureSensorPayload>;
  /** Creates a single `Trailer`. */
  createTrailer?: Maybe<CreateTrailerPayload>;
  /** Creates a single `TrailerAudit`. */
  createTrailerAudit?: Maybe<CreateTrailerAuditPayload>;
  /** Creates a single `TrailerPosition`. */
  createTrailerPosition?: Maybe<CreateTrailerPositionPayload>;
  createUserAccessToken?: Maybe<CreateUserAccessTokenPayload>;
  /** Creates a single `UtilityAccount`. */
  createUtilityAccount?: Maybe<CreateUtilityAccountPayload>;
  /** Creates a single `UtilityCredential`. */
  createUtilityCredential?: Maybe<CreateUtilityCredentialPayload>;
  /** Creates a single `UtilityCredentialFacility`. */
  createUtilityCredentialFacility?: Maybe<CreateUtilityCredentialFacilityPayload>;
  /** Creates a single `UtilityFileUpload`. */
  createUtilityFileUpload?: Maybe<CreateUtilityFileUploadPayload>;
  /** Creates a single `UtilityMeter`. */
  createUtilityMeter?: Maybe<CreateUtilityMeterPayload>;
  /** Creates a single `UtilityPendingMeter`. */
  createUtilityPendingMeter?: Maybe<CreateUtilityPendingMeterPayload>;
  /** Creates a single `UtilityProvider`. */
  createUtilityProvider?: Maybe<CreateUtilityProviderPayload>;
  /** Creates a single `VendorUser`. */
  createVendorUser?: Maybe<CreateVendorUserPayload>;
  /** Creates a single `VendorUserMachineUser`. */
  createVendorUserMachineUser?: Maybe<CreateVendorUserMachineUserPayload>;
  /** Creates a single `Vessel`. */
  createVessel?: Maybe<CreateVesselPayload>;
  /** Creates a single `VirtualPointInterval`. */
  createVirtualPointInterval?: Maybe<CreateVirtualPointIntervalPayload>;
  /** Paranoid deletes a account charge. */
  deleteAccountCharge?: Maybe<DeleteAccountChargePayload>;
  /** Paranoid deletes a account statement. */
  deleteAccountStatement?: Maybe<DeleteAccountStatementPayload>;
  /** Paranoid deletes a account statement pdf. */
  deleteAccountStatementPdf?: Maybe<DeleteAccountStatementPdfPayload>;
  /** Deletes a single `Assessment` using a unique key. */
  deleteAssessment?: Maybe<DeleteAssessmentPayload>;
  /** Deletes a single `AssessmentType` using a unique key. */
  deleteAssessmentType?: Maybe<DeleteAssessmentTypePayload>;
  /** Deletes a single `AssessmentType` using a unique key. */
  deleteAssessmentTypeBySlug?: Maybe<DeleteAssessmentTypePayload>;
  /** Deletes a single `BalancingAuthority` using a unique key. */
  deleteBalancingAuthority?: Maybe<DeleteBalancingAuthorityPayload>;
  /** Deletes a single `BalancingAuthority` using a unique key. */
  deleteBalancingAuthorityBySlug?: Maybe<DeleteBalancingAuthorityPayload>;
  /** Deletes a single `Blast` using a unique key. */
  deleteBlast?: Maybe<DeleteBlastPayload>;
  /** Deletes a single `Blast` using a unique key. */
  deleteBlastByLabelAndFacilityId?: Maybe<DeleteBlastPayload>;
  /** Deletes a single `BlastEvaporator` using a unique key. */
  deleteBlastEvaporator?: Maybe<DeleteBlastEvaporatorPayload>;
  /** Deletes a single `BlastPallet` using a unique key. */
  deleteBlastPallet?: Maybe<DeleteBlastPalletPayload>;
  /** Deletes a single `BlastPalletLocation` using a unique key. */
  deleteBlastPalletLocation?: Maybe<DeleteBlastPalletLocationPayload>;
  /** Deletes a single `BlastRotation` using a unique key. */
  deleteBlastRotation?: Maybe<DeleteBlastRotationPayload>;
  /** Deletes a single `BlastRotationAlert` using a unique key. */
  deleteBlastRotationAlert?: Maybe<DeleteBlastRotationAlertPayload>;
  /** Deletes a single `BlastRotationEventLog` using a unique key. */
  deleteBlastRotationEventLog?: Maybe<DeleteBlastRotationEventLogPayload>;
  /** Deletes a single `BlastRotationEventLog` using a unique key. */
  deleteBlastRotationEventLogByBlastRotationIdAndDescriptionAndBlastRotationEventTypeId?: Maybe<DeleteBlastRotationEventLogPayload>;
  /** Deletes a single `BlastRotationEventType` using a unique key. */
  deleteBlastRotationEventType?: Maybe<DeleteBlastRotationEventTypePayload>;
  /** Deletes a single `BlastRotationPallet` using a unique key. */
  deleteBlastRotationPallet?: Maybe<DeleteBlastRotationPalletPayload>;
  /** Deletes a single `BlastRotationPallet` using a unique key. */
  deleteBlastRotationPalletByBlastRotationIdAndPalletId?: Maybe<DeleteBlastRotationPalletPayload>;
  /** Deletes a single `BlastType` using a unique key. */
  deleteBlastType?: Maybe<DeleteBlastTypePayload>;
  /** Deletes a single `BuildingArea` using a unique key. */
  deleteBuildingArea?: Maybe<DeleteBuildingAreaPayload>;
  /** Deletes a single `BuildingArea` using a unique key. */
  deleteBuildingAreaByFacilityIdAndLabel?: Maybe<DeleteBuildingAreaPayload>;
  /** Deletes a single `BuildingAreaComplianceGroup` using a unique key. */
  deleteBuildingAreaComplianceGroup?: Maybe<DeleteBuildingAreaComplianceGroupPayload>;
  /** Deletes a single `BuildingAreaComplianceGroup` using a unique key. */
  deleteBuildingAreaComplianceGroupByBuildingAreaIdAndComplianceType?: Maybe<DeleteBuildingAreaComplianceGroupPayload>;
  /** Deletes a single `BuildingAreaType` using a unique key. */
  deleteBuildingAreaType?: Maybe<DeleteBuildingAreaTypePayload>;
  /** Deletes a single `Chart` using a unique key. */
  deleteChart?: Maybe<DeleteChartPayload>;
  /** Deletes a single `Check` using a unique key. */
  deleteCheck?: Maybe<DeleteCheckPayload>;
  /** Deletes a single `Check` using a unique key. */
  deleteCheckBySlug?: Maybe<DeleteCheckPayload>;
  /** Deletes a single `CheckMonitor` using a unique key. */
  deleteCheckMonitor?: Maybe<DeleteCheckMonitorPayload>;
  /** Deletes a single `CheckMonitor` using a unique key. */
  deleteCheckMonitorByMonitorId?: Maybe<DeleteCheckMonitorPayload>;
  /** Deletes a single `Classification` using a unique key. */
  deleteClassification?: Maybe<DeleteClassificationPayload>;
  /** Deletes a single `Classification` using a unique key. */
  deleteClassificationByAssessmentTypeIdAndName?: Maybe<DeleteClassificationPayload>;
  /** Deletes a single `ClassificationResult` using a unique key. */
  deleteClassificationResult?: Maybe<DeleteClassificationResultPayload>;
  /** Deletes a single `ClassificationResult` using a unique key. */
  deleteClassificationResultByAssessmentIdAndClassificationId?: Maybe<DeleteClassificationResultPayload>;
  /** Deletes a single `ComplianceGroup` using a unique key. */
  deleteComplianceGroup?: Maybe<DeleteComplianceGroupPayload>;
  /** Deletes a single `ComplianceGroup` using a unique key. */
  deleteComplianceGroupByLabel?: Maybe<DeleteComplianceGroupPayload>;
  /** Deletes a single `ComplianceRange` using a unique key. */
  deleteComplianceRange?: Maybe<DeleteComplianceRangePayload>;
  /** Deletes a single `ComplianceRange` using a unique key. */
  deleteComplianceRangeByComplianceGroupIdAndLabel?: Maybe<DeleteComplianceRangePayload>;
  /** Deletes a single `Component` using a unique key. */
  deleteComponent?: Maybe<DeleteComponentPayload>;
  /** Deletes a single `Compressor` using a unique key. */
  deleteCompressor?: Maybe<DeleteCompressorPayload>;
  /** Deletes a single `Compressor` using a unique key. */
  deleteCompressorByFacilityIdAndLabel?: Maybe<DeleteCompressorPayload>;
  /** Deletes a single `ControlEvent` using a unique key. */
  deleteControlEvent?: Maybe<DeleteControlEventPayload>;
  /** Deletes a single `ControlEventLog` using a unique key. */
  deleteControlEventLog?: Maybe<DeleteControlEventLogPayload>;
  /** Deletes a single `Customer` using a unique key. */
  deleteCustomer?: Maybe<DeleteCustomerPayload>;
  /** Deletes a single `Customer` using a unique key. */
  deleteCustomerBySourceId?: Maybe<DeleteCustomerPayload>;
  /** Deletes a single `Dashboard` using a unique key. */
  deleteDashboard?: Maybe<DeleteDashboardPayload>;
  /** Deletes a single `DataPoint` using a unique key. */
  deleteDataPoint?: Maybe<DeleteDataPointPayload>;
  /** Deletes a single `DataPoint` using a unique key. */
  deleteDataPointByDataSourceNameAndName?: Maybe<DeleteDataPointPayload>;
  /** Deletes a single `DataSource` using a unique key. */
  deleteDataSource?: Maybe<DeleteDataSourcePayload>;
  /** Deletes a single `Dependency` using a unique key. */
  deleteDependency?: Maybe<DeleteDependencyPayload>;
  /** Deletes a single `Dependency` using a unique key. */
  deleteDependencyByPath?: Maybe<DeleteDependencyPayload>;
  /** Deletes a single `DischargeHeader` using a unique key. */
  deleteDischargeHeader?: Maybe<DeleteDischargeHeaderPayload>;
  /** Deletes a single `DischargeHeader` using a unique key. */
  deleteDischargeHeaderByRefrigerationSystemIdAndLabel?: Maybe<DeleteDischargeHeaderPayload>;
  /** Deletes a single `Door` using a unique key. */
  deleteDoor?: Maybe<DeleteDoorPayload>;
  /** Deletes a single `Door` using a unique key. */
  deleteDoorByFacilityIdAndLabel?: Maybe<DeleteDoorPayload>;
  /** Deletes a single `ElectricalCircuit` using a unique key. */
  deleteElectricalCircuit?: Maybe<DeleteElectricalCircuitPayload>;
  /** Deletes a single `ElectricalMeteringPoint` using a unique key. */
  deleteElectricalMeteringPoint?: Maybe<DeleteElectricalMeteringPointPayload>;
  /** Deletes a single `ElectricalPanel` using a unique key. */
  deleteElectricalPanel?: Maybe<DeleteElectricalPanelPayload>;
  /** Deletes a single `ElectricalPanel` using a unique key. */
  deleteElectricalPanelByElectricalMeteringPointId?: Maybe<DeleteElectricalPanelPayload>;
  /** Deletes a single `Evaporator` using a unique key. */
  deleteEvaporator?: Maybe<DeleteEvaporatorPayload>;
  /** Deletes a single `Evaporator` using a unique key. */
  deleteEvaporatorByFacilityIdAndLabel?: Maybe<DeleteEvaporatorPayload>;
  /** Deletes a single `Facility` using a unique key. */
  deleteFacility?: Maybe<DeleteFacilityPayload>;
  /** Deletes a single `Facility` using a unique key. */
  deleteFacilityBySlug?: Maybe<DeleteFacilityPayload>;
  /** Deletes a single `FacilityCheck` using a unique key. */
  deleteFacilityCheck?: Maybe<DeleteFacilityCheckPayload>;
  /** Deletes a single `FacilityCheck` using a unique key. */
  deleteFacilityCheckByFacilityIdAndCheckId?: Maybe<DeleteFacilityCheckPayload>;
  /** Deletes a single `FacilityCheckUser` using a unique key. */
  deleteFacilityCheckUser?: Maybe<DeleteFacilityCheckUserPayload>;
  /** Removes a config from the specified facility */
  deleteFacilityConfig?: Maybe<DeleteFacilityConfigPayload>;
  /** Deletes a single `FacilityDataSource` using a unique key. */
  deleteFacilityDataSource?: Maybe<DeleteFacilityDataSourcePayload>;
  /** Paranoid deletes a facility document. */
  deleteFacilityDocument?: Maybe<DeleteFacilityDocumentPayload>;
  /** Deletes a single `FacilityGroup` using a unique key. */
  deleteFacilityGroup?: Maybe<DeleteFacilityGroupPayload>;
  /** Deletes a single `FacilityGroupsLinker` using a unique key. */
  deleteFacilityGroupsLinker?: Maybe<DeleteFacilityGroupsLinkerPayload>;
  deleteFacilityMutableMetricData?: Maybe<Scalars['Int']['output']>;
  /** Deletes a single `FacilitySoftwarePackage` using a unique key. */
  deleteFacilitySoftwarePackage?: Maybe<DeleteFacilitySoftwarePackagePayload>;
  /** Deletes a single `FacilitySoftwarePackage` using a unique key. */
  deleteFacilitySoftwarePackageByFacilityIdAndSoftwarePackageId?: Maybe<DeleteFacilitySoftwarePackagePayload>;
  /** Deletes a single `FacilityTaggedDataPoint` using a unique key. */
  deleteFacilityTaggedDataPoint?: Maybe<DeleteFacilityTaggedDataPointPayload>;
  /** Deletes a single `Gateway` using a unique key. */
  deleteGateway?: Maybe<DeleteGatewayPayload>;
  /** Deletes a single `Gateway` using a unique key. */
  deleteGatewayByFacilityIdAndHardwareId?: Maybe<DeleteGatewayPayload>;
  /** Deletes a single `Gateway` using a unique key. */
  deleteGatewayByFacilityIdAndLabel?: Maybe<DeleteGatewayPayload>;
  /** Deletes a single `InboundOutboundLoad` using a unique key. */
  deleteInboundOutboundLoad?: Maybe<DeleteInboundOutboundLoadPayload>;
  /** Deletes a single `InboundOutboundLoad` using a unique key. */
  deleteInboundOutboundLoadBySourceId?: Maybe<DeleteInboundOutboundLoadPayload>;
  /** Deletes a single `Incident` using a unique key. */
  deleteIncident?: Maybe<DeleteIncidentPayload>;
  /** Deletes a single `Incident` using a unique key. */
  deleteIncidentByCheckMonitorIdAndMonitorDetectionId?: Maybe<DeleteIncidentPayload>;
  /** Deletes a single `IncidentLog` using a unique key. */
  deleteIncidentLogByIncidentIdAndEventAndTime?: Maybe<DeleteIncidentLogPayload>;
  /** Deletes a single `LiquidHeader` using a unique key. */
  deleteLiquidHeader?: Maybe<DeleteLiquidHeaderPayload>;
  /** Deletes a single `LiquidHeader` using a unique key. */
  deleteLiquidHeaderByRefrigerationSystemIdAndLabel?: Maybe<DeleteLiquidHeaderPayload>;
  /** Deletes a single `LiquidHeadersEvaporator` using a unique key. */
  deleteLiquidHeadersEvaporator?: Maybe<DeleteLiquidHeadersEvaporatorPayload>;
  /** Deletes a single `LiquidHeadersEvaporator` using a unique key. */
  deleteLiquidHeadersEvaporatorByLiquidHeaderIdAndEvaporatorId?: Maybe<DeleteLiquidHeadersEvaporatorPayload>;
  /** Deletes a single `MachineUser` using a unique key. */
  deleteMachineUser?: Maybe<DeleteMachineUserPayload>;
  /** Deletes a single `MainService` using a unique key. */
  deleteMainService?: Maybe<DeleteMainServicePayload>;
  /** Deletes a single `MainService` using a unique key. */
  deleteMainServiceByFacilityIdAndName?: Maybe<DeleteMainServicePayload>;
  /** Deletes a single `MainService` using a unique key. */
  deleteMainServiceByFacilityIdAndUsageDataPointIdAndDemandDataPointId?: Maybe<DeleteMainServicePayload>;
  /** Paranoid deletes a meter charge. */
  deleteMeterCharge?: Maybe<DeleteMeterChargePayload>;
  /** Paranoid deletes a meter statement. */
  deleteMeterStatement?: Maybe<DeleteMeterStatementPayload>;
  /** Paranoid deletes a utility meter usage. */
  deleteMeterUsage?: Maybe<DeleteMeterUsagePayload>;
  /** Deletes a single `Monitor` using a unique key. */
  deleteMonitor?: Maybe<DeleteMonitorPayload>;
  /** Deletes a single `MonitorAttribute` using a unique key. */
  deleteMonitorAttribute?: Maybe<DeleteMonitorAttributePayload>;
  /** Deletes a single `MonitorDataPoint` using a unique key. */
  deleteMonitorDataPoint?: Maybe<DeleteMonitorDataPointPayload>;
  /** Deletes a single `MonitorDetection` using a unique key. */
  deleteMonitorDetection?: Maybe<DeleteMonitorDetectionPayload>;
  /** Deletes a single `MonitoredAsset` using a unique key. */
  deleteMonitoredAsset?: Maybe<DeleteMonitoredAssetPayload>;
  deleteMutableMetricData?: Maybe<Scalars['Int']['output']>;
  /** Deletes a single `Opportunity` using a unique key. */
  deleteOpportunity?: Maybe<DeleteOpportunityPayload>;
  /** Deletes a single `OpportunityAttachment` using a unique key. */
  deleteOpportunityAttachment?: Maybe<DeleteOpportunityAttachmentPayload>;
  /** Deletes a single `Pallet` using a unique key. */
  deletePallet?: Maybe<DeletePalletPayload>;
  /** Deletes a single `Pallet` using a unique key. */
  deletePalletBySourceId?: Maybe<DeletePalletPayload>;
  /** Deletes a single `PalletHistory` using a unique key. */
  deletePalletHistory?: Maybe<DeletePalletHistoryPayload>;
  /** Deletes a single `PalletHistory` using a unique key. */
  deletePalletHistoryBySourceId?: Maybe<DeletePalletHistoryPayload>;
  /** Deletes a single `PalletLocation` using a unique key. */
  deletePalletLocation?: Maybe<DeletePalletLocationPayload>;
  /** Deletes a single `PalletLocation` using a unique key. */
  deletePalletLocationBySourceId?: Maybe<DeletePalletLocationPayload>;
  deletePhoneNumber: DeletePhoneNumberResponse;
  /** Deletes a single `PricingNode` using a unique key. */
  deletePricingNode?: Maybe<DeletePricingNodePayload>;
  /** Deletes a single `Product` using a unique key. */
  deleteProduct?: Maybe<DeleteProductPayload>;
  /** Deletes a single `Product` using a unique key. */
  deleteProductBySourceId?: Maybe<DeleteProductPayload>;
  /** Deletes a single `Program` using a unique key. */
  deleteProgram?: Maybe<DeleteProgramPayload>;
  /** Deletes a single `Program` using a unique key. */
  deleteProgramByProjectTypeIdAndName?: Maybe<DeleteProgramPayload>;
  /** Removes a config from the specified program */
  deleteProgramConfig?: Maybe<DeleteProgramConfigPayload>;
  /** Deletes a single `ProgramEnrollment` using a unique key. */
  deleteProgramEnrollment?: Maybe<DeleteProgramEnrollmentPayload>;
  /** Deletes a single `ProgramEnrollment` using a unique key. */
  deleteProgramEnrollmentByProgramIdAndName?: Maybe<DeleteProgramEnrollmentPayload>;
  /** Deletes a single `Project` using a unique key. */
  deleteProject?: Maybe<DeleteProjectPayload>;
  /** Deletes a single `Project` using a unique key. */
  deleteProjectByFacilityIdAndProgramId?: Maybe<DeleteProjectPayload>;
  /** Deletes a single `ProjectComponent` using a unique key. */
  deleteProjectComponent?: Maybe<DeleteProjectComponentPayload>;
  /** Removes a config from the specified project */
  deleteProjectConfig?: Maybe<DeleteProjectConfigPayload>;
  /** Deletes a single `ProjectEnrollment` using a unique key. */
  deleteProjectEnrollment?: Maybe<DeleteProjectEnrollmentPayload>;
  /** Deletes a single `ProjectEnrollment` using a unique key. */
  deleteProjectEnrollmentByProjectIdAndProgramEnrollmentId?: Maybe<DeleteProjectEnrollmentPayload>;
  /** Deletes a single `ProjectEnrollmentDataPoint` using a unique key. */
  deleteProjectEnrollmentDataPoint?: Maybe<DeleteProjectEnrollmentDataPointPayload>;
  /** Deletes a single `ProjectEnrollmentDataPoint` using a unique key. */
  deleteProjectEnrollmentDataPointByProjectEnrollmentIdAndDataPointId?: Maybe<DeleteProjectEnrollmentDataPointPayload>;
  /** Deletes a single `ProjectEnrollmentDataPointGroup` using a unique key. */
  deleteProjectEnrollmentDataPointGroup?: Maybe<DeleteProjectEnrollmentDataPointGroupPayload>;
  /** Deletes a single `ProjectWatcher` using a unique key. */
  deleteProjectWatcher?: Maybe<DeleteProjectWatcherPayload>;
  /** Deletes a single `RefrigerationSystem` using a unique key. */
  deleteRefrigerationSystem?: Maybe<DeleteRefrigerationSystemPayload>;
  /** Deletes a single `RefrigerationSystem` using a unique key. */
  deleteRefrigerationSystemByFacilityIdAndLabel?: Maybe<DeleteRefrigerationSystemPayload>;
  /** Deletes a single `SavingsEvent` using a unique key. */
  deleteSavingsEvent?: Maybe<DeleteSavingsEventPayload>;
  /** Deletes a single `SavingsEvent` using a unique key. */
  deleteSavingsEventByProjectIdAndStartTimeAndEndTime?: Maybe<DeleteSavingsEventPayload>;
  /** Deletes a single `SavingsEventDatum` using a unique key. */
  deleteSavingsEventDatum?: Maybe<DeleteSavingsEventDatumPayload>;
  /** Deletes a single `SavingsEventDatum` using a unique key. */
  deleteSavingsEventDatumBySavingsEventIdAndLabel?: Maybe<DeleteSavingsEventDatumPayload>;
  /** Deletes a single `SubmeterSession` using a unique key. */
  deleteSubmeterSession?: Maybe<DeleteSubmeterSessionPayload>;
  /** Deletes a single `SubmeterSession` using a unique key. */
  deleteSubmeterSessionBySubmeterIdAndStartTime?: Maybe<DeleteSubmeterSessionPayload>;
  /** Deletes a single `SuctionGroup` using a unique key. */
  deleteSuctionGroup?: Maybe<DeleteSuctionGroupPayload>;
  /** Deletes a single `SuctionGroup` using a unique key. */
  deleteSuctionGroupByRefrigerationSystemIdAndLabel?: Maybe<DeleteSuctionGroupPayload>;
  /** Deletes a single `SuctionGroupCompressor` using a unique key. */
  deleteSuctionGroupCompressor?: Maybe<DeleteSuctionGroupCompressorPayload>;
  /** Deletes a single `SuctionGroupCompressor` using a unique key. */
  deleteSuctionGroupCompressorBySuctionGroupIdAndCompressorId?: Maybe<DeleteSuctionGroupCompressorPayload>;
  /** Deletes a single `SuctionHeader` using a unique key. */
  deleteSuctionHeader?: Maybe<DeleteSuctionHeaderPayload>;
  /** Deletes a single `SuctionHeader` using a unique key. */
  deleteSuctionHeaderByRefrigerationSystemIdAndLabel?: Maybe<DeleteSuctionHeaderPayload>;
  /** Deletes a single `SuctionHeadersCompressor` using a unique key. */
  deleteSuctionHeadersCompressor?: Maybe<DeleteSuctionHeadersCompressorPayload>;
  /** Deletes a single `SuctionHeadersCompressor` using a unique key. */
  deleteSuctionHeadersCompressorBySuctionHeaderIdAndCompressorId?: Maybe<DeleteSuctionHeadersCompressorPayload>;
  /** Deletes a single `SuggestionControlEvent` using a unique key. */
  deleteSuggestionControlEvent?: Maybe<DeleteSuggestionControlEventPayload>;
  /** Deletes a single `SuggestionControlEvent` using a unique key. */
  deleteSuggestionControlEventByControlEventId?: Maybe<DeleteSuggestionControlEventPayload>;
  /** Deletes a single `TemperatureSensor` using a unique key. */
  deleteTemperatureSensor?: Maybe<DeleteTemperatureSensorPayload>;
  /** Deletes a single `TemperatureSensor` using a unique key. */
  deleteTemperatureSensorByFacilityIdAndHardwareId?: Maybe<DeleteTemperatureSensorPayload>;
  /** Deletes a single `TemperatureSensor` using a unique key. */
  deleteTemperatureSensorByFacilityIdAndLabel?: Maybe<DeleteTemperatureSensorPayload>;
  /** Deletes a single `TrailerAudit` using a unique key. */
  deleteTrailerAudit?: Maybe<DeleteTrailerAuditPayload>;
  /** Deletes a single `TrailerPosition` using a unique key. */
  deleteTrailerPosition?: Maybe<DeleteTrailerPositionPayload>;
  /** Deletes a single `TrailerPosition` using a unique key. */
  deleteTrailerPositionByFacilityIdAndLabel?: Maybe<DeleteTrailerPositionPayload>;
  /** Deletes a single `User` using a unique key. */
  deleteUser?: Maybe<DeleteUserPayload>;
  /** Paranoid deletes a utility account. */
  deleteUtilityAccount?: Maybe<DeleteUtilityAccountPayload>;
  /** Deletes a single `UtilityCredential` using a unique key. */
  deleteUtilityCredential?: Maybe<DeleteUtilityCredentialPayload>;
  /** Deletes a single `UtilityCredential` using a unique key. */
  deleteUtilityCredentialByIntegrationAndIntegrationKey?: Maybe<DeleteUtilityCredentialPayload>;
  /** Deletes a single `UtilityCredentialFacility` using a unique key. */
  deleteUtilityCredentialFacility?: Maybe<DeleteUtilityCredentialFacilityPayload>;
  /** Deletes a single `UtilityCredentialFacility` using a unique key. */
  deleteUtilityCredentialFacilityByUtilityCredentialIdAndFacilityId?: Maybe<DeleteUtilityCredentialFacilityPayload>;
  /** Deletes a single `UtilityFileUpload` using a unique key. */
  deleteUtilityFileUpload?: Maybe<DeleteUtilityFileUploadPayload>;
  /** Deletes a single `UtilityFileUpload` using a unique key. */
  deleteUtilityFileUploadByIntegrationAndIntegrationKey?: Maybe<DeleteUtilityFileUploadPayload>;
  /** Paranoid deletes a utility meter. */
  deleteUtilityMeter?: Maybe<DeleteUtilityMeterPayload>;
  /** Deletes a single `UtilityPendingMeter` using a unique key. */
  deleteUtilityPendingMeter?: Maybe<DeleteUtilityPendingMeterPayload>;
  /** Deletes a single `UtilityPendingMeter` using a unique key. */
  deleteUtilityPendingMeterByIntegrationAndIntegrationKey?: Maybe<DeleteUtilityPendingMeterPayload>;
  /** Deletes a single `UtilityProvider` using a unique key. */
  deleteUtilityProvider?: Maybe<DeleteUtilityProviderPayload>;
  /** Deletes a single `UtilityProvider` using a unique key. */
  deleteUtilityProviderByName?: Maybe<DeleteUtilityProviderPayload>;
  /** Deletes a single `VendorUser` using a unique key. */
  deleteVendorUser?: Maybe<DeleteVendorUserPayload>;
  /** Deletes a single `VendorUser` using a unique key. */
  deleteVendorUserByEmail?: Maybe<DeleteVendorUserPayload>;
  /** Deletes a single `VendorUserMachineUser` using a unique key. */
  deleteVendorUserMachineUser?: Maybe<DeleteVendorUserMachineUserPayload>;
  /** Deletes a single `VendorUserMachineUser` using a unique key. */
  deleteVendorUserMachineUserByMachineUserId?: Maybe<DeleteVendorUserMachineUserPayload>;
  /** Deletes a single `Vessel` using a unique key. */
  deleteVessel?: Maybe<DeleteVesselPayload>;
  /** Deletes a single `Vessel` using a unique key. */
  deleteVesselByRefrigerationSystemIdAndLabel?: Maybe<DeleteVesselPayload>;
  /** Deletes a single `VirtualPointInterval` using a unique key. */
  deleteVirtualPointInterval?: Maybe<DeleteVirtualPointIntervalPayload>;
  extend?: Maybe<Scalars['Boolean']['output']>;
  fleetCheckIn?: Maybe<FleetCheckInPayload>;
  fleetCheckOut?: Maybe<FleetCheckOutPayload>;
  invokeIntegration?: Maybe<Scalars['JSON']['output']>;
  /** Updates the readyAt timestamp for a trailer appointment, signaling that the trailer is no longer waitlisted and is ready to begin work on fulfilling its order */
  markTrailerAppointmentReady?: Maybe<MarkTrailerAppointmentReadyPayload>;
  patchControlEventRemoteMetadata?: Maybe<PatchControlEventRemoteMetadataPayload>;
  /** Custom mutation for provisioning electrical metering points and panels for a list of facilities. */
  provisionElectricalMeteringPointsAndPanels?: Maybe<ProvisionElectricalMeteringPointsAndPanelsPayload>;
  reflowSubmeterSessions?: Maybe<ReflowSubmeterSessionsPayload>;
  regenerateAccessToken?: Maybe<CreateAccessTokenPayload>;
  registerProjectUsers?: Maybe<RegisterProjectUsersPayload>;
  /** Remove a charge label mapping for an account_charge */
  removeAccountChargeLabelCategory?: Maybe<RemoveAccountChargeLabelCategoryPayload>;
  /** Removes the facility as a favorite for the user. */
  removeFavoriteFacility?: Maybe<RemoveFavoriteFacilityPayload>;
  /** Remove a charge label mapping for a meter_charge */
  removeMeterChargeLabelCategory?: Maybe<RemoveMeterChargeLabelCategoryPayload>;
  /** Removes a child dependency from the specific metric */
  removeMetricMetadataDependency?: Maybe<RemoveMetricMetadataDependencyPayload>;
  removeProjectController?: Maybe<RemoveProjectControllerPayload>;
  removeReportManager?: Maybe<RemoveReportManagerPayload>;
  /** Custom mutation for assigning a meter_statement and its account_statement to a new meter and its account, respectively */
  reparentMeterStatement?: Maybe<ReparentMeterStatementPayload>;
  /** Replaces account statement pdf for all meter statements or just those which match the given statement year and month. */
  replaceAccountStatementPdf?: Maybe<ReplaceAccountStatementPdfPayload>;
  revokeAccessToken?: Maybe<Scalars['Boolean']['output']>;
  runReport?: Maybe<ReportExecution>;
  /** Upsert an account_charge label category for an account_charge */
  setAccountChargeLabelCategory?: Maybe<SetAccountChargeLabelCategoryPayload>;
  /** Sets the given Facility Document as the default for the document's type, replacing current default if one exists. */
  setDefaultFacilityDocument?: Maybe<SetDefaultFacilityDocumentPayload>;
  /** Adds or updates a config on the specified facility */
  setFacilityConfig?: Maybe<SetFacilityConfigPayload>;
  setMachineUserCapability?: Maybe<SetMachineUserCapabilityPayload>;
  /** Upsert a meter_charge label category for a meter_charge */
  setMeterChargeLabelCategory?: Maybe<SetMeterChargeLabelCategoryPayload>;
  /** Adds or updates a config on the specified program */
  setProgramConfig?: Maybe<SetProgramConfigPayload>;
  /** Adds or updates a config on the specified project */
  setProjectConfig?: Maybe<SetProjectConfigPayload>;
  startCustomerIntegration?: Maybe<StartCustomerIntegrationPayload>;
  transitionControlEvent?: Maybe<ControlEvent>;
  /** Transitions an opportunity to a new state. */
  transitionOpportunity?: Maybe<TransitionOpportunityPayload>;
  triggerPhoneNumberVerification: VerifyPhoneNumberResponse;
  /** Updates a single `AccountCharge` using a unique key and a patch. */
  updateAccountCharge?: Maybe<UpdateAccountChargePayload>;
  /** Updates a single `AccountStatement` using a unique key and a patch. */
  updateAccountStatement?: Maybe<UpdateAccountStatementPayload>;
  /** Updates a single `Assessment` using a unique key and a patch. */
  updateAssessment?: Maybe<UpdateAssessmentPayload>;
  /** Updates a single `AssessmentType` using a unique key and a patch. */
  updateAssessmentType?: Maybe<UpdateAssessmentTypePayload>;
  /** Updates a single `AssessmentType` using a unique key and a patch. */
  updateAssessmentTypeBySlug?: Maybe<UpdateAssessmentTypePayload>;
  /** Updates a single `BalancingAuthority` using a unique key and a patch. */
  updateBalancingAuthority?: Maybe<UpdateBalancingAuthorityPayload>;
  /** Updates a single `BalancingAuthority` using a unique key and a patch. */
  updateBalancingAuthorityBySlug?: Maybe<UpdateBalancingAuthorityPayload>;
  /** Updates a single `BillableCustomer` using a unique key and a patch. */
  updateBillableCustomer?: Maybe<UpdateBillableCustomerPayload>;
  /** Updates a single `BillableCustomer` using a unique key and a patch. */
  updateBillableCustomerByCarrierCode?: Maybe<UpdateBillableCustomerPayload>;
  /** Updates a single `Blast` using a unique key and a patch. */
  updateBlast?: Maybe<UpdateBlastPayload>;
  /** Updates a single `Blast` using a unique key and a patch. */
  updateBlastByLabelAndFacilityId?: Maybe<UpdateBlastPayload>;
  /** Updates a single `BlastEvaporator` using a unique key and a patch. */
  updateBlastEvaporator?: Maybe<UpdateBlastEvaporatorPayload>;
  /** Updates a single `BlastPallet` using a unique key and a patch. */
  updateBlastPallet?: Maybe<UpdateBlastPalletPayload>;
  /** Updates a single `BlastPalletLocation` using a unique key and a patch. */
  updateBlastPalletLocation?: Maybe<UpdateBlastPalletLocationPayload>;
  /** Updates a single `BlastRotation` using a unique key and a patch. */
  updateBlastRotation?: Maybe<UpdateBlastRotationPayload>;
  /** Updates a single `BlastRotationAlert` using a unique key and a patch. */
  updateBlastRotationAlert?: Maybe<UpdateBlastRotationAlertPayload>;
  /** Updates a single `BlastRotationEventLog` using a unique key and a patch. */
  updateBlastRotationEventLog?: Maybe<UpdateBlastRotationEventLogPayload>;
  /** Updates a single `BlastRotationEventLog` using a unique key and a patch. */
  updateBlastRotationEventLogByBlastRotationIdAndDescriptionAndBlastRotationEventTypeId?: Maybe<UpdateBlastRotationEventLogPayload>;
  /** Updates a single `BlastRotationEventType` using a unique key and a patch. */
  updateBlastRotationEventType?: Maybe<UpdateBlastRotationEventTypePayload>;
  /** Updates a single `BlastRotationPallet` using a unique key and a patch. */
  updateBlastRotationPallet?: Maybe<UpdateBlastRotationPalletPayload>;
  /** Updates a single `BlastRotationPallet` using a unique key and a patch. */
  updateBlastRotationPalletByBlastRotationIdAndPalletId?: Maybe<UpdateBlastRotationPalletPayload>;
  /** Updates a single `BlastType` using a unique key and a patch. */
  updateBlastType?: Maybe<UpdateBlastTypePayload>;
  /** Updates a single `BuildingArea` using a unique key and a patch. */
  updateBuildingArea?: Maybe<UpdateBuildingAreaPayload>;
  /** Updates a single `BuildingArea` using a unique key and a patch. */
  updateBuildingAreaByFacilityIdAndLabel?: Maybe<UpdateBuildingAreaPayload>;
  /** Updates a single `BuildingAreaComplianceGroup` using a unique key and a patch. */
  updateBuildingAreaComplianceGroup?: Maybe<UpdateBuildingAreaComplianceGroupPayload>;
  /** Updates a single `BuildingAreaComplianceGroup` using a unique key and a patch. */
  updateBuildingAreaComplianceGroupByBuildingAreaIdAndComplianceType?: Maybe<UpdateBuildingAreaComplianceGroupPayload>;
  /** Updates a single `BuildingAreaType` using a unique key and a patch. */
  updateBuildingAreaType?: Maybe<UpdateBuildingAreaTypePayload>;
  /** Updates a single `Chart` using a unique key and a patch. */
  updateChart?: Maybe<UpdateChartPayload>;
  /** Updates a single `Check` using a unique key and a patch. */
  updateCheck?: Maybe<UpdateCheckPayload>;
  /** Updates a single `Check` using a unique key and a patch. */
  updateCheckBySlug?: Maybe<UpdateCheckPayload>;
  /** Updates a single `CheckMonitor` using a unique key and a patch. */
  updateCheckMonitor?: Maybe<UpdateCheckMonitorPayload>;
  /** Updates a single `CheckMonitor` using a unique key and a patch. */
  updateCheckMonitorByMonitorId?: Maybe<UpdateCheckMonitorPayload>;
  /** Updates a single `Classification` using a unique key and a patch. */
  updateClassification?: Maybe<UpdateClassificationPayload>;
  /** Updates a single `Classification` using a unique key and a patch. */
  updateClassificationByAssessmentTypeIdAndName?: Maybe<UpdateClassificationPayload>;
  /** Updates a single `ClassificationResult` using a unique key and a patch. */
  updateClassificationResult?: Maybe<UpdateClassificationResultPayload>;
  /** Updates a single `ClassificationResult` using a unique key and a patch. */
  updateClassificationResultByAssessmentIdAndClassificationId?: Maybe<UpdateClassificationResultPayload>;
  /** Updates a single `ComplianceGroup` using a unique key and a patch. */
  updateComplianceGroup?: Maybe<UpdateComplianceGroupPayload>;
  /** Updates a single `ComplianceGroup` using a unique key and a patch. */
  updateComplianceGroupByLabel?: Maybe<UpdateComplianceGroupPayload>;
  /** Updates a single `ComplianceRange` using a unique key and a patch. */
  updateComplianceRange?: Maybe<UpdateComplianceRangePayload>;
  /** Updates a single `ComplianceRange` using a unique key and a patch. */
  updateComplianceRangeByComplianceGroupIdAndLabel?: Maybe<UpdateComplianceRangePayload>;
  /** Updates a single `Component` using a unique key and a patch. */
  updateComponent?: Maybe<UpdateComponentPayload>;
  /** Updates a single `Compressor` using a unique key and a patch. */
  updateCompressor?: Maybe<UpdateCompressorPayload>;
  /** Updates a single `Compressor` using a unique key and a patch. */
  updateCompressorByFacilityIdAndLabel?: Maybe<UpdateCompressorPayload>;
  /** Updates a single `ControlEvent` using a unique key and a patch. */
  updateControlEvent?: Maybe<UpdateControlEventPayload>;
  /** Updates a single `ControlEventLog` using a unique key and a patch. */
  updateControlEventLog?: Maybe<UpdateControlEventLogPayload>;
  /** Updates a single `Customer` using a unique key and a patch. */
  updateCustomer?: Maybe<UpdateCustomerPayload>;
  /** Updates a single `CustomerBillingRate` using a unique key and a patch. */
  updateCustomerBillingRate?: Maybe<UpdateCustomerBillingRatePayload>;
  /** Updates a single `CustomerBillingRate` using a unique key and a patch. */
  updateCustomerBillingRateByCustomerIdAndEffectiveStart?: Maybe<UpdateCustomerBillingRatePayload>;
  /** Updates a single `Customer` using a unique key and a patch. */
  updateCustomerBySourceId?: Maybe<UpdateCustomerPayload>;
  /** Updates a single `Dashboard` using a unique key and a patch. */
  updateDashboard?: Maybe<UpdateDashboardPayload>;
  /** Updates a single `DataPoint` using a unique key and a patch. */
  updateDataPoint?: Maybe<UpdateDataPointPayload>;
  /** Updates a single `DataPoint` using a unique key and a patch. */
  updateDataPointByDataSourceNameAndName?: Maybe<UpdateDataPointPayload>;
  /** Updates a single `Dependency` using a unique key and a patch. */
  updateDependency?: Maybe<UpdateDependencyPayload>;
  /** Updates a single `Dependency` using a unique key and a patch. */
  updateDependencyByPath?: Maybe<UpdateDependencyPayload>;
  /** Updates a single `DischargeHeader` using a unique key and a patch. */
  updateDischargeHeader?: Maybe<UpdateDischargeHeaderPayload>;
  /** Updates a single `DischargeHeader` using a unique key and a patch. */
  updateDischargeHeaderByRefrigerationSystemIdAndLabel?: Maybe<UpdateDischargeHeaderPayload>;
  /** Updates a single `Door` using a unique key and a patch. */
  updateDoor?: Maybe<UpdateDoorPayload>;
  /** Updates a single `Door` using a unique key and a patch. */
  updateDoorByFacilityIdAndLabel?: Maybe<UpdateDoorPayload>;
  /** Updates a single `Driver` using a unique key and a patch. */
  updateDriver?: Maybe<UpdateDriverPayload>;
  /** Updates a single `Driver` using a unique key and a patch. */
  updateDriverByConversationId?: Maybe<UpdateDriverPayload>;
  /** Updates a single `Driver` using a unique key and a patch. */
  updateDriverByPhoneNumber?: Maybe<UpdateDriverPayload>;
  /** Updates a single `ElectricalCircuit` using a unique key and a patch. */
  updateElectricalCircuit?: Maybe<UpdateElectricalCircuitPayload>;
  /** Updates a single `ElectricalMeteringPoint` using a unique key and a patch. */
  updateElectricalMeteringPoint?: Maybe<UpdateElectricalMeteringPointPayload>;
  /** Updates a single `ElectricalPanel` using a unique key and a patch. */
  updateElectricalPanel?: Maybe<UpdateElectricalPanelPayload>;
  /** Updates a single `ElectricalPanel` using a unique key and a patch. */
  updateElectricalPanelByElectricalMeteringPointId?: Maybe<UpdateElectricalPanelPayload>;
  /** Updates a single `Evaporator` using a unique key and a patch. */
  updateEvaporator?: Maybe<UpdateEvaporatorPayload>;
  /** Updates a single `Evaporator` using a unique key and a patch. */
  updateEvaporatorByFacilityIdAndLabel?: Maybe<UpdateEvaporatorPayload>;
  /** Updates a single `Facility` using a unique key and a patch. */
  updateFacility?: Maybe<UpdateFacilityPayload>;
  /** Updates a single `Facility` using a unique key and a patch. */
  updateFacilityBySlug?: Maybe<UpdateFacilityPayload>;
  /** Updates a single `FacilityCheck` using a unique key and a patch. */
  updateFacilityCheck?: Maybe<UpdateFacilityCheckPayload>;
  /** Updates a single `FacilityCheck` using a unique key and a patch. */
  updateFacilityCheckByFacilityIdAndCheckId?: Maybe<UpdateFacilityCheckPayload>;
  /** Updates a single `FacilityDocument` using a unique key and a patch. */
  updateFacilityDocument?: Maybe<UpdateFacilityDocumentPayload>;
  /** Updates a single `FacilityGroup` using a unique key and a patch. */
  updateFacilityGroup?: Maybe<UpdateFacilityGroupPayload>;
  /** Updates a single `FacilityGroupsLinker` using a unique key and a patch. */
  updateFacilityGroupsLinker?: Maybe<UpdateFacilityGroupsLinkerPayload>;
  updateFacilityMutableMetricData?: Maybe<Scalars['Int']['output']>;
  /** Updates a single `FacilitySoftwarePackage` using a unique key and a patch. */
  updateFacilitySoftwarePackage?: Maybe<UpdateFacilitySoftwarePackagePayload>;
  /** Updates a single `FacilitySoftwarePackage` using a unique key and a patch. */
  updateFacilitySoftwarePackageByFacilityIdAndSoftwarePackageId?: Maybe<UpdateFacilitySoftwarePackagePayload>;
  /** Updates a single `FacilityTaggedDataPoint` using a unique key and a patch. */
  updateFacilityTaggedDataPoint?: Maybe<UpdateFacilityTaggedDataPointPayload>;
  /** Updates a single `Gateway` using a unique key and a patch. */
  updateGateway?: Maybe<UpdateGatewayPayload>;
  /** Updates a single `Gateway` using a unique key and a patch. */
  updateGatewayByFacilityIdAndHardwareId?: Maybe<UpdateGatewayPayload>;
  /** Updates a single `Gateway` using a unique key and a patch. */
  updateGatewayByFacilityIdAndLabel?: Maybe<UpdateGatewayPayload>;
  /** Updates a single `InboundOutboundLoad` using a unique key and a patch. */
  updateInboundOutboundLoad?: Maybe<UpdateInboundOutboundLoadPayload>;
  /** Updates a single `InboundOutboundLoad` using a unique key and a patch. */
  updateInboundOutboundLoadBySourceId?: Maybe<UpdateInboundOutboundLoadPayload>;
  /** Updates a single `Incident` using a unique key and a patch. */
  updateIncident?: Maybe<UpdateIncidentPayload>;
  /** Updates a single `Incident` using a unique key and a patch. */
  updateIncidentByCheckMonitorIdAndMonitorDetectionId?: Maybe<UpdateIncidentPayload>;
  /** Updates a single `LiquidHeader` using a unique key and a patch. */
  updateLiquidHeader?: Maybe<UpdateLiquidHeaderPayload>;
  /** Updates a single `LiquidHeader` using a unique key and a patch. */
  updateLiquidHeaderByRefrigerationSystemIdAndLabel?: Maybe<UpdateLiquidHeaderPayload>;
  /** Updates a single `LiquidHeadersEvaporator` using a unique key and a patch. */
  updateLiquidHeadersEvaporator?: Maybe<UpdateLiquidHeadersEvaporatorPayload>;
  /** Updates a single `LiquidHeadersEvaporator` using a unique key and a patch. */
  updateLiquidHeadersEvaporatorByLiquidHeaderIdAndEvaporatorId?: Maybe<UpdateLiquidHeadersEvaporatorPayload>;
  /** Updates a single `MachineUser` using a unique key and a patch. */
  updateMachineUser?: Maybe<UpdateMachineUserPayload>;
  /** Updates a single `MainService` using a unique key and a patch. */
  updateMainService?: Maybe<UpdateMainServicePayload>;
  /** Updates a single `MainService` using a unique key and a patch. */
  updateMainServiceByFacilityIdAndName?: Maybe<UpdateMainServicePayload>;
  /** Updates a single `MainService` using a unique key and a patch. */
  updateMainServiceByFacilityIdAndUsageDataPointIdAndDemandDataPointId?: Maybe<UpdateMainServicePayload>;
  /** Updates a single `MeterCharge` using a unique key and a patch. */
  updateMeterCharge?: Maybe<UpdateMeterChargePayload>;
  /** Updates a single `MeterStatement` using a unique key and a patch. */
  updateMeterStatement?: Maybe<UpdateMeterStatementPayload>;
  /** Updates a single `MeterUsage` using a unique key and a patch. */
  updateMeterUsage?: Maybe<UpdateMeterUsagePayload>;
  /** Updates a single `Monitor` using a unique key and a patch. */
  updateMonitor?: Maybe<UpdateMonitorPayload>;
  /** Updates a single `MonitorDataPoint` using a unique key and a patch. */
  updateMonitorDataPoint?: Maybe<UpdateMonitorDataPointPayload>;
  /** Updates a single `MonitorDetection` using a unique key and a patch. */
  updateMonitorDetection?: Maybe<UpdateMonitorDetectionPayload>;
  updateMutableMetricData?: Maybe<Scalars['Int']['output']>;
  /** Updates a single `Opportunity` using a unique key and a patch. */
  updateOpportunity?: Maybe<UpdateOpportunityPayload>;
  /** Updates a single `OpportunityAttachment` using a unique key and a patch. */
  updateOpportunityAttachment?: Maybe<UpdateOpportunityAttachmentPayload>;
  /** Updates a single `Pallet` using a unique key and a patch. */
  updatePallet?: Maybe<UpdatePalletPayload>;
  /** Updates a single `Pallet` using a unique key and a patch. */
  updatePalletBySourceId?: Maybe<UpdatePalletPayload>;
  /** Updates a single `PalletHistory` using a unique key and a patch. */
  updatePalletHistory?: Maybe<UpdatePalletHistoryPayload>;
  /** Updates a single `PalletHistory` using a unique key and a patch. */
  updatePalletHistoryBySourceId?: Maybe<UpdatePalletHistoryPayload>;
  /** Updates a single `PalletLocation` using a unique key and a patch. */
  updatePalletLocation?: Maybe<UpdatePalletLocationPayload>;
  /** Updates a single `PalletLocation` using a unique key and a patch. */
  updatePalletLocationBySourceId?: Maybe<UpdatePalletLocationPayload>;
  updatePhoneNumber: UpdatePhoneNumberResponse;
  /** Updates a single `PricingNode` using a unique key and a patch. */
  updatePricingNode?: Maybe<UpdatePricingNodePayload>;
  /** Updates a single `Product` using a unique key and a patch. */
  updateProduct?: Maybe<UpdateProductPayload>;
  /** Updates a single `Product` using a unique key and a patch. */
  updateProductBySourceId?: Maybe<UpdateProductPayload>;
  /** Updates a single `Program` using a unique key and a patch. */
  updateProgram?: Maybe<UpdateProgramPayload>;
  /** Updates a single `Program` using a unique key and a patch. */
  updateProgramByProjectTypeIdAndName?: Maybe<UpdateProgramPayload>;
  /** Updates a single `ProgramEnrollment` using a unique key and a patch. */
  updateProgramEnrollment?: Maybe<UpdateProgramEnrollmentPayload>;
  /** Updates a single `ProgramEnrollment` using a unique key and a patch. */
  updateProgramEnrollmentByProgramIdAndName?: Maybe<UpdateProgramEnrollmentPayload>;
  /** Updates a single `Project` using a unique key and a patch. */
  updateProject?: Maybe<UpdateProjectPayload>;
  /** Updates a single `Project` using a unique key and a patch. */
  updateProjectByFacilityIdAndProgramId?: Maybe<UpdateProjectPayload>;
  /** Updates a single `ProjectComponent` using a unique key and a patch. */
  updateProjectComponent?: Maybe<UpdateProjectComponentPayload>;
  /** Updates a single `ProjectEnrollment` using a unique key and a patch. */
  updateProjectEnrollment?: Maybe<UpdateProjectEnrollmentPayload>;
  /** Updates a single `ProjectEnrollment` using a unique key and a patch. */
  updateProjectEnrollmentByProjectIdAndProgramEnrollmentId?: Maybe<UpdateProjectEnrollmentPayload>;
  /** Updates a single `ProjectEnrollmentDataPoint` using a unique key and a patch. */
  updateProjectEnrollmentDataPoint?: Maybe<UpdateProjectEnrollmentDataPointPayload>;
  /** Updates a single `ProjectEnrollmentDataPoint` using a unique key and a patch. */
  updateProjectEnrollmentDataPointByProjectEnrollmentIdAndDataPointId?: Maybe<UpdateProjectEnrollmentDataPointPayload>;
  /** Updates a single `ProjectEnrollmentDataPointGroup` using a unique key and a patch. */
  updateProjectEnrollmentDataPointGroup?: Maybe<UpdateProjectEnrollmentDataPointGroupPayload>;
  /** Updates a single `ProjectWatcher` using a unique key and a patch. */
  updateProjectWatcher?: Maybe<UpdateProjectWatcherPayload>;
  /** Updates a single `RefrigerationSystem` using a unique key and a patch. */
  updateRefrigerationSystem?: Maybe<UpdateRefrigerationSystemPayload>;
  /** Updates a single `RefrigerationSystem` using a unique key and a patch. */
  updateRefrigerationSystemByFacilityIdAndLabel?: Maybe<UpdateRefrigerationSystemPayload>;
  /** Updates a single `Report` using a unique key and a patch. */
  updateReport?: Maybe<UpdateReportPayload>;
  /** Updates a single `Report` using a unique key and a patch. */
  updateReportByLabel?: Maybe<UpdateReportPayload>;
  /** Updates a single `ReportExecution` using a unique key and a patch. */
  updateReportExecution?: Maybe<UpdateReportExecutionPayload>;
  /** Updates a single `SavingsEvent` using a unique key and a patch. */
  updateSavingsEvent?: Maybe<UpdateSavingsEventPayload>;
  /** Updates a single `SavingsEvent` using a unique key and a patch. */
  updateSavingsEventByProjectIdAndStartTimeAndEndTime?: Maybe<UpdateSavingsEventPayload>;
  /** Updates a single `SavingsEventDatum` using a unique key and a patch. */
  updateSavingsEventDatum?: Maybe<UpdateSavingsEventDatumPayload>;
  /** Updates a single `SavingsEventDatum` using a unique key and a patch. */
  updateSavingsEventDatumBySavingsEventIdAndLabel?: Maybe<UpdateSavingsEventDatumPayload>;
  /** Updates a single `Severity` using a unique key and a patch. */
  updateSeverity?: Maybe<UpdateSeverityPayload>;
  /** Updates a single `Severity` using a unique key and a patch. */
  updateSeverityByName?: Maybe<UpdateSeverityPayload>;
  /** Updates a single `Severity` using a unique key and a patch. */
  updateSeverityBySlug?: Maybe<UpdateSeverityPayload>;
  /** Updates a single `Submeter` using a unique key and a patch. */
  updateSubmeter?: Maybe<UpdateSubmeterPayload>;
  /** Updates a single `SubmeterSession` using a unique key and a patch. */
  updateSubmeterSession?: Maybe<UpdateSubmeterSessionPayload>;
  /** Updates a single `SubmeterSession` using a unique key and a patch. */
  updateSubmeterSessionBySubmeterIdAndStartTime?: Maybe<UpdateSubmeterSessionPayload>;
  /** Updates a single `SuctionGroup` using a unique key and a patch. */
  updateSuctionGroup?: Maybe<UpdateSuctionGroupPayload>;
  /** Updates a single `SuctionGroup` using a unique key and a patch. */
  updateSuctionGroupByRefrigerationSystemIdAndLabel?: Maybe<UpdateSuctionGroupPayload>;
  /** Updates a single `SuctionGroupCompressor` using a unique key and a patch. */
  updateSuctionGroupCompressor?: Maybe<UpdateSuctionGroupCompressorPayload>;
  /** Updates a single `SuctionGroupCompressor` using a unique key and a patch. */
  updateSuctionGroupCompressorBySuctionGroupIdAndCompressorId?: Maybe<UpdateSuctionGroupCompressorPayload>;
  /** Updates a single `SuctionHeader` using a unique key and a patch. */
  updateSuctionHeader?: Maybe<UpdateSuctionHeaderPayload>;
  /** Updates a single `SuctionHeader` using a unique key and a patch. */
  updateSuctionHeaderByRefrigerationSystemIdAndLabel?: Maybe<UpdateSuctionHeaderPayload>;
  /** Updates a single `SuctionHeadersCompressor` using a unique key and a patch. */
  updateSuctionHeadersCompressor?: Maybe<UpdateSuctionHeadersCompressorPayload>;
  /** Updates a single `SuctionHeadersCompressor` using a unique key and a patch. */
  updateSuctionHeadersCompressorBySuctionHeaderIdAndCompressorId?: Maybe<UpdateSuctionHeadersCompressorPayload>;
  /** Updates a single `Suggestion` using a unique key and a patch. */
  updateSuggestion?: Maybe<UpdateSuggestionPayload>;
  /** Updates a single `SuggestionControlEvent` using a unique key and a patch. */
  updateSuggestionControlEvent?: Maybe<UpdateSuggestionControlEventPayload>;
  /** Updates a single `SuggestionControlEvent` using a unique key and a patch. */
  updateSuggestionControlEventByControlEventId?: Maybe<UpdateSuggestionControlEventPayload>;
  /** Updates a single `TemperatureSensor` using a unique key and a patch. */
  updateTemperatureSensor?: Maybe<UpdateTemperatureSensorPayload>;
  /** Updates a single `TemperatureSensor` using a unique key and a patch. */
  updateTemperatureSensorByFacilityIdAndHardwareId?: Maybe<UpdateTemperatureSensorPayload>;
  /** Updates a single `TemperatureSensor` using a unique key and a patch. */
  updateTemperatureSensorByFacilityIdAndLabel?: Maybe<UpdateTemperatureSensorPayload>;
  /** Updates a single `Trailer` using a unique key and a patch. */
  updateTrailer?: Maybe<UpdateTrailerPayload>;
  /** Updates the trailer and/or driver for trailer appointment. */
  updateTrailerAppointment?: Maybe<UpdateTrailerAppointmentPayload>;
  /** Updates a single `TrailerAudit` using a unique key and a patch. */
  updateTrailerAudit?: Maybe<UpdateTrailerAuditPayload>;
  /** Updates a single `Trailer` using a unique key and a patch. */
  updateTrailerByCarrierCodeAndCarrierTrailerNumber?: Maybe<UpdateTrailerPayload>;
  /** Updates a single `TrailerPosition` using a unique key and a patch. */
  updateTrailerPosition?: Maybe<UpdateTrailerPositionPayload>;
  /** Updates a single `TrailerPosition` using a unique key and a patch. */
  updateTrailerPositionByFacilityIdAndLabel?: Maybe<UpdateTrailerPositionPayload>;
  /** Updates a single `User` using a unique key and a patch. */
  updateUser?: Maybe<UpdateUserPayload>;
  /** Updates a single `UtilityAccount` using a unique key and a patch. */
  updateUtilityAccount?: Maybe<UpdateUtilityAccountPayload>;
  /** Updates a single `UtilityCredential` using a unique key and a patch. */
  updateUtilityCredential?: Maybe<UpdateUtilityCredentialPayload>;
  /** Updates a single `UtilityCredential` using a unique key and a patch. */
  updateUtilityCredentialByIntegrationAndIntegrationKey?: Maybe<UpdateUtilityCredentialPayload>;
  /** Updates a single `UtilityFileUpload` using a unique key and a patch. */
  updateUtilityFileUpload?: Maybe<UpdateUtilityFileUploadPayload>;
  /** Updates a single `UtilityFileUpload` using a unique key and a patch. */
  updateUtilityFileUploadByIntegrationAndIntegrationKey?: Maybe<UpdateUtilityFileUploadPayload>;
  /** Updates a single `UtilityMeter` using a unique key and a patch. */
  updateUtilityMeter?: Maybe<UpdateUtilityMeterPayload>;
  /** Updates a single `UtilityPendingMeter` using a unique key and a patch. */
  updateUtilityPendingMeter?: Maybe<UpdateUtilityPendingMeterPayload>;
  /** Updates a single `UtilityPendingMeter` using a unique key and a patch. */
  updateUtilityPendingMeterByIntegrationAndIntegrationKey?: Maybe<UpdateUtilityPendingMeterPayload>;
  /** Updates a single `UtilityProvider` using a unique key and a patch. */
  updateUtilityProvider?: Maybe<UpdateUtilityProviderPayload>;
  /** Updates a single `UtilityProvider` using a unique key and a patch. */
  updateUtilityProviderByName?: Maybe<UpdateUtilityProviderPayload>;
  /** Updates a single `VendorUser` using a unique key and a patch. */
  updateVendorUser?: Maybe<UpdateVendorUserPayload>;
  /** Updates a single `VendorUser` using a unique key and a patch. */
  updateVendorUserByEmail?: Maybe<UpdateVendorUserPayload>;
  /** Updates a single `VendorUserMachineUser` using a unique key and a patch. */
  updateVendorUserMachineUser?: Maybe<UpdateVendorUserMachineUserPayload>;
  /** Updates a single `VendorUserMachineUser` using a unique key and a patch. */
  updateVendorUserMachineUserByMachineUserId?: Maybe<UpdateVendorUserMachineUserPayload>;
  /** Updates a single `Vessel` using a unique key and a patch. */
  updateVessel?: Maybe<UpdateVesselPayload>;
  /** Updates a single `Vessel` using a unique key and a patch. */
  updateVesselByRefrigerationSystemIdAndLabel?: Maybe<UpdateVesselPayload>;
  /** Updates a single `VirtualPointInterval` using a unique key and a patch. */
  updateVirtualPointInterval?: Maybe<UpdateVirtualPointIntervalPayload>;
  /** Upserts a single `AccountCharge`. */
  upsertAccountCharge?: Maybe<UpsertAccountChargePayload>;
  /** Upserts a single `AccountStatement`. */
  upsertAccountStatement?: Maybe<UpsertAccountStatementPayload>;
  /** Upserts a single `AccountStatementPdf`. */
  upsertAccountStatementPdf?: Maybe<UpsertAccountStatementPdfPayload>;
  /** Upserts a single `Assessment`. */
  upsertAssessment?: Maybe<UpsertAssessmentPayload>;
  /** Upserts a single `BalancingAuthority`. */
  upsertBalancingAuthority?: Maybe<UpsertBalancingAuthorityPayload>;
  /** Upserts a single `BillableCustomer`. */
  upsertBillableCustomer?: Maybe<UpsertBillableCustomerPayload>;
  /** Upserts a single `Blast`. */
  upsertBlast?: Maybe<UpsertBlastPayload>;
  /** Upserts a single `BlastEvaporator`. */
  upsertBlastEvaporator?: Maybe<UpsertBlastEvaporatorPayload>;
  /** Upserts a single `BlastPallet`. */
  upsertBlastPallet?: Maybe<UpsertBlastPalletPayload>;
  /** Upserts a single `BlastPalletLocation`. */
  upsertBlastPalletLocation?: Maybe<UpsertBlastPalletLocationPayload>;
  /** Upserts a single `BlastRotation`. */
  upsertBlastRotation?: Maybe<UpsertBlastRotationPayload>;
  /** Upserts a single `BlastRotationAlert`. */
  upsertBlastRotationAlert?: Maybe<UpsertBlastRotationAlertPayload>;
  /** Upserts a single `BlastRotationEventLog`. */
  upsertBlastRotationEventLog?: Maybe<UpsertBlastRotationEventLogPayload>;
  /** Upserts a single `BlastRotationEventType`. */
  upsertBlastRotationEventType?: Maybe<UpsertBlastRotationEventTypePayload>;
  /** Upserts a single `BlastRotationPallet`. */
  upsertBlastRotationPallet?: Maybe<UpsertBlastRotationPalletPayload>;
  /** Upserts a single `BlastType`. */
  upsertBlastType?: Maybe<UpsertBlastTypePayload>;
  /** Upserts a single `BuildingArea`. */
  upsertBuildingArea?: Maybe<UpsertBuildingAreaPayload>;
  /** Upserts a single `BuildingAreaComplianceGroup`. */
  upsertBuildingAreaComplianceGroup?: Maybe<UpsertBuildingAreaComplianceGroupPayload>;
  /** Upserts a single `BuildingAreaType`. */
  upsertBuildingAreaType?: Maybe<UpsertBuildingAreaTypePayload>;
  /** Upserts a single `Chart`. */
  upsertChart?: Maybe<UpsertChartPayload>;
  /** Upserts a single `ClassificationResult`. */
  upsertClassificationResult?: Maybe<UpsertClassificationResultPayload>;
  /** Upserts a single `ComplianceGroup`. */
  upsertComplianceGroup?: Maybe<UpsertComplianceGroupPayload>;
  /** Upserts a single `ComplianceRange`. */
  upsertComplianceRange?: Maybe<UpsertComplianceRangePayload>;
  /** Upserts a single `Compressor`. */
  upsertCompressor?: Maybe<UpsertCompressorPayload>;
  /** Upserts a single `Customer`. */
  upsertCustomer?: Maybe<UpsertCustomerPayload>;
  /** Upserts a single `CustomerBillingRate`. */
  upsertCustomerBillingRate?: Maybe<UpsertCustomerBillingRatePayload>;
  /** Upserts a single `Dashboard`. */
  upsertDashboard?: Maybe<UpsertDashboardPayload>;
  /** Upserts a single `DataPoint`. */
  upsertDataPoint?: Maybe<UpsertDataPointPayload>;
  /** Upserts a single `Dependency`. */
  upsertDependency?: Maybe<UpsertDependencyPayload>;
  /** Upserts a single `DischargeHeader`. */
  upsertDischargeHeader?: Maybe<UpsertDischargeHeaderPayload>;
  /** Upserts a single `Door`. */
  upsertDoor?: Maybe<UpsertDoorPayload>;
  /** Upserts a single `Driver`. */
  upsertDriver?: Maybe<UpsertDriverPayload>;
  /** Upserts a single `ElectricalCircuit`. */
  upsertElectricalCircuit?: Maybe<UpsertElectricalCircuitPayload>;
  /** Upserts a single `ElectricalMeteringPoint`. */
  upsertElectricalMeteringPoint?: Maybe<UpsertElectricalMeteringPointPayload>;
  /** Upserts a single `ElectricalPanel`. */
  upsertElectricalPanel?: Maybe<UpsertElectricalPanelPayload>;
  /** Upserts a single `Evaporator`. */
  upsertEvaporator?: Maybe<UpsertEvaporatorPayload>;
  /** Upserts a single `FacilityCheckUser`. */
  upsertFacilityCheckUser?: Maybe<UpsertFacilityCheckUserPayload>;
  /** Upserts a single `FacilitySoftwarePackage`. */
  upsertFacilitySoftwarePackage?: Maybe<UpsertFacilitySoftwarePackagePayload>;
  /** Upserts a single `FacilityTaggedDataPoint`. */
  upsertFacilityTaggedDataPoint?: Maybe<UpsertFacilityTaggedDataPointPayload>;
  /** Upserts a single `Gateway`. */
  upsertGateway?: Maybe<UpsertGatewayPayload>;
  /** Upserts a single `InboundOutboundLoad`. */
  upsertInboundOutboundLoad?: Maybe<UpsertInboundOutboundLoadPayload>;
  upsertIntegrationUtilityProvider?: Maybe<UpsertIntegrationUtilityProviderPayload>;
  /** Upserts a single `LiquidHeader`. */
  upsertLiquidHeader?: Maybe<UpsertLiquidHeaderPayload>;
  /** Upserts a single `LiquidHeadersEvaporator`. */
  upsertLiquidHeadersEvaporator?: Maybe<UpsertLiquidHeadersEvaporatorPayload>;
  /** Upserts a single `MachineUser`. */
  upsertMachineUser?: Maybe<UpsertMachineUserPayload>;
  /** Upserts a single `MainService`. */
  upsertMainService?: Maybe<UpsertMainServicePayload>;
  /** Upserts a single `MeterCharge`. */
  upsertMeterCharge?: Maybe<UpsertMeterChargePayload>;
  /** Upserts a single `MeterStatement`. */
  upsertMeterStatement?: Maybe<UpsertMeterStatementPayload>;
  /** Upserts a single `MeterUsage`. */
  upsertMeterUsage?: Maybe<UpsertMeterUsagePayload>;
  /** Upserts a single `MonitorAttribute`. */
  upsertMonitorAttribute?: Maybe<UpsertMonitorAttributePayload>;
  /** Upserts a single `MonitorDataPoint`. */
  upsertMonitorDataPoint?: Maybe<UpsertMonitorDataPointPayload>;
  /** Upserts a monitored asset. */
  upsertMonitoredAsset?: Maybe<UpsertMonitoredAssetPayload>;
  /** Upserts a single `Pallet`. */
  upsertPallet?: Maybe<UpsertPalletPayload>;
  /** Upserts a single `PalletHistory`. */
  upsertPalletHistory?: Maybe<UpsertPalletHistoryPayload>;
  /** Upserts a single `PalletLocation`. */
  upsertPalletLocation?: Maybe<UpsertPalletLocationPayload>;
  /** Upserts a single `PricingNode`. */
  upsertPricingNode?: Maybe<UpsertPricingNodePayload>;
  /** Upserts a single `Product`. */
  upsertProduct?: Maybe<UpsertProductPayload>;
  /** Upserts a single `Program`. */
  upsertProgram?: Maybe<UpsertProgramPayload>;
  /** Upserts a single `ProgramEnrollment`. */
  upsertProgramEnrollment?: Maybe<UpsertProgramEnrollmentPayload>;
  /** Upserts a single `ProjectComponent`. */
  upsertProjectComponent?: Maybe<UpsertProjectComponentPayload>;
  /** Upserts a single `ProjectEnrollment`. */
  upsertProjectEnrollment?: Maybe<UpsertProjectEnrollmentPayload>;
  /** Upserts a single `ProjectEnrollmentDataPoint`. */
  upsertProjectEnrollmentDataPoint?: Maybe<UpsertProjectEnrollmentDataPointPayload>;
  /** Upserts a single `ProjectEnrollmentDataPointGroup`. */
  upsertProjectEnrollmentDataPointGroup?: Maybe<UpsertProjectEnrollmentDataPointGroupPayload>;
  upsertProjectSubscription?: Maybe<UpsertProjectSubscriptionPayload>;
  /** Upserts a single `ProjectWatcher`. */
  upsertProjectWatcher?: Maybe<UpsertProjectWatcherPayload>;
  /** Upserts a single `RefrigerationSystem`. */
  upsertRefrigerationSystem?: Maybe<UpsertRefrigerationSystemPayload>;
  /** Upserts a single `ReportExecution`. */
  upsertReportExecution?: Maybe<UpsertReportExecutionPayload>;
  /** Upserts a single `ReportQuery`. */
  upsertReportQuery?: Maybe<UpsertReportQueryPayload>;
  /** Upserts a single `SavingsEvent`. */
  upsertSavingsEvent?: Maybe<UpsertSavingsEventPayload>;
  /** Upserts a single `SavingsEventDatum`. */
  upsertSavingsEventDatum?: Maybe<UpsertSavingsEventDatumPayload>;
  /** Upserts a single `Submeter`. */
  upsertSubmeter?: Maybe<UpsertSubmeterPayload>;
  /** Upserts a single `SubmeterSession`. */
  upsertSubmeterSession?: Maybe<UpsertSubmeterSessionPayload>;
  /** Upserts a single `SuctionGroup`. */
  upsertSuctionGroup?: Maybe<UpsertSuctionGroupPayload>;
  /** Upserts a single `SuctionGroupCompressor`. */
  upsertSuctionGroupCompressor?: Maybe<UpsertSuctionGroupCompressorPayload>;
  /** Upserts a single `SuctionHeader`. */
  upsertSuctionHeader?: Maybe<UpsertSuctionHeaderPayload>;
  /** Upserts a single `SuctionHeadersCompressor`. */
  upsertSuctionHeadersCompressor?: Maybe<UpsertSuctionHeadersCompressorPayload>;
  /** Upserts a single `SuggestionControlEvent`. */
  upsertSuggestionControlEvent?: Maybe<UpsertSuggestionControlEventPayload>;
  /** Upserts a single `TemperatureSensor`. */
  upsertTemperatureSensor?: Maybe<UpsertTemperatureSensorPayload>;
  /** Upserts a single `Trailer`. */
  upsertTrailer?: Maybe<UpsertTrailerPayload>;
  /** Upserts a single `TrailerAudit`. */
  upsertTrailerAudit?: Maybe<UpsertTrailerAuditPayload>;
  /** Upserts a single `TrailerPosition`. */
  upsertTrailerPosition?: Maybe<UpsertTrailerPositionPayload>;
  upsertUrjanetUtilityProvider?: Maybe<UpsertUrjanetUtilityProviderPayload>;
  /** Upserts a single `UtilityAccount`. */
  upsertUtilityAccount?: Maybe<UpsertUtilityAccountPayload>;
  /** Upserts a single `UtilityCredential`. */
  upsertUtilityCredential?: Maybe<UpsertUtilityCredentialPayload>;
  /** Upserts a single `UtilityCredentialFacility`. */
  upsertUtilityCredentialFacility?: Maybe<UpsertUtilityCredentialFacilityPayload>;
  /** Upserts a single `UtilityFileUpload`. */
  upsertUtilityFileUpload?: Maybe<UpsertUtilityFileUploadPayload>;
  /** Upserts a single `UtilityMeter`. */
  upsertUtilityMeter?: Maybe<UpsertUtilityMeterPayload>;
  /** Upserts a single `UtilityPendingMeter`. */
  upsertUtilityPendingMeter?: Maybe<UpsertUtilityPendingMeterPayload>;
  /** Upserts a single `UtilityProvider`. */
  upsertUtilityProvider?: Maybe<UpsertUtilityProviderPayload>;
  /** Upserts a single `VendorUserMachineUser`. */
  upsertVendorUserMachineUser?: Maybe<UpsertVendorUserMachineUserPayload>;
  /** Upserts a single `Vessel`. */
  upsertVessel?: Maybe<UpsertVesselPayload>;
  /** Upserts a single `VirtualPointInterval`. */
  upsertVirtualPointInterval?: Maybe<UpsertVirtualPointIntervalPayload>;
  withdrawSuggestion?: Maybe<Suggestion>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationAcknowledgeControlEventArgs = {
  input: AcknowledgeControlEventInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationAcknowledgeIncidentArgs = {
  input: AcknowledgeIncidentInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationAcknowledgeSuggestionArgs = {
  input: AcknowledgeSuggestionInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationAddFavoriteFacilityArgs = {
  input: AddFavoriteFacilityInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationAddMetricMetadataDependencyArgs = {
  input: AddMetricMetadataDependencyInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationAddProjectControllerArgs = {
  input: AddProjectControllerInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationAddReportManagerArgs = {
  input: AddReportManagerInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationAssignSpaceArgs = {
  input: AssignSpaceInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationClearFacilityCommunicationArgs = {
  input: ClearFacilityCommunicationInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationClearSpaceArgs = {
  input: ClearSpaceInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCloseIncidentArgs = {
  input: CloseIncidentInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAccountChargeArgs = {
  input: CreateAccountChargeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAccountStatementArgs = {
  input: CreateAccountStatementInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAccountStatementHistoryArgs = {
  input: CreateAccountStatementHistoryInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAccountStatementPdfArgs = {
  input: CreateAccountStatementPdfInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAssessmentArgs = {
  input: CreateAssessmentInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAssessmentTypeArgs = {
  input: CreateAssessmentTypeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBalancingAuthorityArgs = {
  input: CreateBalancingAuthorityInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBillableCustomerArgs = {
  input: CreateBillableCustomerInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBlastArgs = {
  input: CreateBlastInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBlastEvaporatorArgs = {
  input: CreateBlastEvaporatorInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBlastPalletArgs = {
  input: CreateBlastPalletInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBlastPalletLocationArgs = {
  input: CreateBlastPalletLocationInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBlastRotationArgs = {
  input: CreateBlastRotationInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBlastRotationAlertArgs = {
  input: CreateBlastRotationAlertInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBlastRotationEventLogArgs = {
  input: CreateBlastRotationEventLogInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBlastRotationEventTypeArgs = {
  input: CreateBlastRotationEventTypeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBlastRotationPalletArgs = {
  input: CreateBlastRotationPalletInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBlastTypeArgs = {
  input: CreateBlastTypeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBuildingAreaArgs = {
  input: CreateBuildingAreaInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBuildingAreaComplianceGroupArgs = {
  input: CreateBuildingAreaComplianceGroupInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBuildingAreaTypeArgs = {
  input: CreateBuildingAreaTypeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateChartArgs = {
  input: CreateChartInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCheckArgs = {
  input: CreateCheckInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCheckMonitorArgs = {
  input: CreateCheckMonitorInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateClassificationArgs = {
  input: CreateClassificationInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateClassificationResultArgs = {
  input: CreateClassificationResultInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateComplianceGroupArgs = {
  input: CreateComplianceGroupInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateComplianceRangeArgs = {
  input: CreateComplianceRangeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateComponentArgs = {
  input: CreateComponentInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCompressorArgs = {
  input: CreateCompressorInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateControlEventArgs = {
  input: CreateControlEventInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateControlEventLogArgs = {
  input: CreateControlEventLogInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCustomerArgs = {
  input: CreateCustomerInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCustomerBillingRateArgs = {
  input: CreateCustomerBillingRateInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCustomerIntegrationCredentialArgs = {
  input: CreateCustomerIntegrationCredentialInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDashboardArgs = {
  input: CreateDashboardInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDataPointArgs = {
  input: CreateDataPointInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDataSourceArgs = {
  input: CreateDataSourceInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDependencyArgs = {
  input: CreateDependencyInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDischargeHeaderArgs = {
  input: CreateDischargeHeaderInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDoorArgs = {
  input: CreateDoorInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDriverArgs = {
  input: CreateDriverInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateElectricalCircuitArgs = {
  input: CreateElectricalCircuitInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateElectricalMeteringPointArgs = {
  input: CreateElectricalMeteringPointInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateElectricalPanelArgs = {
  input: CreateElectricalPanelInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateEvaporatorArgs = {
  input: CreateEvaporatorInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateFacilityArgs = {
  input: CreateFacilityInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateFacilityCheckArgs = {
  input: CreateFacilityCheckInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateFacilityCommunicationArgs = {
  input: CreateFacilityCommunicationInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateFacilityDataSourceArgs = {
  input: CreateFacilityDataSourceInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateFacilityDocumentArgs = {
  input: CreateFacilityDocumentInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateFacilityGroupArgs = {
  input: CreateFacilityGroupInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateFacilityGroupsLinkerArgs = {
  input: CreateFacilityGroupsLinkerInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateFacilitySoftwarePackageArgs = {
  input: CreateFacilitySoftwarePackageInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateFacilityTaggedDataPointArgs = {
  input: CreateFacilityTaggedDataPointInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateGatewayArgs = {
  input: CreateGatewayInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateInboundOutboundLoadArgs = {
  input: CreateInboundOutboundLoadInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateIncidentArgs = {
  input: CreateIncidentInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateIncidentLogArgs = {
  input: CreateIncidentLogInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLiquidHeaderArgs = {
  input: CreateLiquidHeaderInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLiquidHeadersEvaporatorArgs = {
  input: CreateLiquidHeadersEvaporatorInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateMachineAccessTokenArgs = {
  input: CreateMachineAccessTokenInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateMachineUserArgs = {
  input: CreateMachineUserInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateMainServiceArgs = {
  input: CreateMainServiceInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateMeterChargeArgs = {
  input: CreateMeterChargeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateMeterStatementArgs = {
  input: CreateMeterStatementInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateMeterStatementHistoryArgs = {
  input: CreateMeterStatementHistoryInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateMeterUsageArgs = {
  input: CreateMeterUsageInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateMonitorArgs = {
  input: CreateMonitorInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateMonitorDataPointArgs = {
  input: CreateMonitorDataPointInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateMonitorDetectionArgs = {
  input: CreateMonitorDetectionInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateOpportunityArgs = {
  input: CreateOpportunityInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateOpportunityAttachmentArgs = {
  input: CreateOpportunityAttachmentInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePalletArgs = {
  input: CreatePalletInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePalletHistoryArgs = {
  input: CreatePalletHistoryInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePalletLocationArgs = {
  input: CreatePalletLocationInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePricingNodeArgs = {
  input: CreatePricingNodeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateProductArgs = {
  input: CreateProductInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateProgramArgs = {
  input: CreateProgramInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateProgramEnrollmentArgs = {
  input: CreateProgramEnrollmentInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateProjectArgs = {
  input: CreateProjectInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateProjectComponentArgs = {
  input: CreateProjectComponentInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateProjectEnrollmentArgs = {
  input: CreateProjectEnrollmentInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateProjectEnrollmentDataPointArgs = {
  input: CreateProjectEnrollmentDataPointInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateProjectEnrollmentDataPointGroupArgs = {
  input: CreateProjectEnrollmentDataPointGroupInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateProjectWatcherArgs = {
  input: CreateProjectWatcherInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRefrigerationSystemArgs = {
  input: CreateRefrigerationSystemInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateReportExecutionArgs = {
  input: CreateReportExecutionInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSavingsEventArgs = {
  input: CreateSavingsEventInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSavingsEventDatumArgs = {
  input: CreateSavingsEventDatumInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSpaceActivityArgs = {
  input: CreateSpaceActivityInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSubmeterArgs = {
  input: CreateSubmeterInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSubmeterSessionArgs = {
  input: CreateSubmeterSessionInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSuctionGroupArgs = {
  input: CreateSuctionGroupInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSuctionGroupCompressorArgs = {
  input: CreateSuctionGroupCompressorInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSuctionHeaderArgs = {
  input: CreateSuctionHeaderInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSuctionHeadersCompressorArgs = {
  input: CreateSuctionHeadersCompressorInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSuggestionArgs = {
  input: CreateSuggestionInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSuggestionActivityLogArgs = {
  input: CreateSuggestionActivityLogInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSuggestionControlEventArgs = {
  input: CreateSuggestionControlEventInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTemperatureSensorArgs = {
  input: CreateTemperatureSensorInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTrailerArgs = {
  input: CreateTrailerInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTrailerAuditArgs = {
  input: CreateTrailerAuditInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTrailerPositionArgs = {
  input: CreateTrailerPositionInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserAccessTokenArgs = {
  input: CreateUserAccessTokenInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUtilityAccountArgs = {
  input: CreateUtilityAccountInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUtilityCredentialArgs = {
  input: CreateUtilityCredentialInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUtilityCredentialFacilityArgs = {
  input: CreateUtilityCredentialFacilityInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUtilityFileUploadArgs = {
  input: CreateUtilityFileUploadInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUtilityMeterArgs = {
  input: CreateUtilityMeterInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUtilityPendingMeterArgs = {
  input: CreateUtilityPendingMeterInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUtilityProviderArgs = {
  input: CreateUtilityProviderInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateVendorUserArgs = {
  input: CreateVendorUserInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateVendorUserMachineUserArgs = {
  input: CreateVendorUserMachineUserInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateVesselArgs = {
  input: CreateVesselInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateVirtualPointIntervalArgs = {
  input: CreateVirtualPointIntervalInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAccountChargeArgs = {
  input: DeleteAccountChargeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAccountStatementArgs = {
  input: DeleteAccountStatementInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAccountStatementPdfArgs = {
  input: DeleteAccountStatementPdfInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAssessmentArgs = {
  input: DeleteAssessmentInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAssessmentTypeArgs = {
  input: DeleteAssessmentTypeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAssessmentTypeBySlugArgs = {
  input: DeleteAssessmentTypeBySlugInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBalancingAuthorityArgs = {
  input: DeleteBalancingAuthorityInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBalancingAuthorityBySlugArgs = {
  input: DeleteBalancingAuthorityBySlugInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBlastArgs = {
  input: DeleteBlastInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBlastByLabelAndFacilityIdArgs = {
  input: DeleteBlastByLabelAndFacilityIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBlastEvaporatorArgs = {
  input: DeleteBlastEvaporatorInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBlastPalletArgs = {
  input: DeleteBlastPalletInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBlastPalletLocationArgs = {
  input: DeleteBlastPalletLocationInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBlastRotationArgs = {
  input: DeleteBlastRotationInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBlastRotationAlertArgs = {
  input: DeleteBlastRotationAlertInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBlastRotationEventLogArgs = {
  input: DeleteBlastRotationEventLogInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBlastRotationEventLogByBlastRotationIdAndDescriptionAndBlastRotationEventTypeIdArgs =
  {
    input: DeleteBlastRotationEventLogByBlastRotationIdAndDescriptionAndBlastRotationEventTypeIdInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBlastRotationEventTypeArgs = {
  input: DeleteBlastRotationEventTypeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBlastRotationPalletArgs = {
  input: DeleteBlastRotationPalletInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBlastRotationPalletByBlastRotationIdAndPalletIdArgs =
  {
    input: DeleteBlastRotationPalletByBlastRotationIdAndPalletIdInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBlastTypeArgs = {
  input: DeleteBlastTypeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBuildingAreaArgs = {
  input: DeleteBuildingAreaInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBuildingAreaByFacilityIdAndLabelArgs = {
  input: DeleteBuildingAreaByFacilityIdAndLabelInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBuildingAreaComplianceGroupArgs = {
  input: DeleteBuildingAreaComplianceGroupInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBuildingAreaComplianceGroupByBuildingAreaIdAndComplianceTypeArgs =
  {
    input: DeleteBuildingAreaComplianceGroupByBuildingAreaIdAndComplianceTypeInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBuildingAreaTypeArgs = {
  input: DeleteBuildingAreaTypeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteChartArgs = {
  input: DeleteChartInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCheckArgs = {
  input: DeleteCheckInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCheckBySlugArgs = {
  input: DeleteCheckBySlugInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCheckMonitorArgs = {
  input: DeleteCheckMonitorInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCheckMonitorByMonitorIdArgs = {
  input: DeleteCheckMonitorByMonitorIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteClassificationArgs = {
  input: DeleteClassificationInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteClassificationByAssessmentTypeIdAndNameArgs = {
  input: DeleteClassificationByAssessmentTypeIdAndNameInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteClassificationResultArgs = {
  input: DeleteClassificationResultInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteClassificationResultByAssessmentIdAndClassificationIdArgs =
  {
    input: DeleteClassificationResultByAssessmentIdAndClassificationIdInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteComplianceGroupArgs = {
  input: DeleteComplianceGroupInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteComplianceGroupByLabelArgs = {
  input: DeleteComplianceGroupByLabelInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteComplianceRangeArgs = {
  input: DeleteComplianceRangeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteComplianceRangeByComplianceGroupIdAndLabelArgs = {
  input: DeleteComplianceRangeByComplianceGroupIdAndLabelInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteComponentArgs = {
  input: DeleteComponentInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCompressorArgs = {
  input: DeleteCompressorInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCompressorByFacilityIdAndLabelArgs = {
  input: DeleteCompressorByFacilityIdAndLabelInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteControlEventArgs = {
  input: DeleteControlEventInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteControlEventLogArgs = {
  input: DeleteControlEventLogInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCustomerArgs = {
  input: DeleteCustomerInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCustomerBySourceIdArgs = {
  input: DeleteCustomerBySourceIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDashboardArgs = {
  input: DeleteDashboardInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDataPointArgs = {
  input: DeleteDataPointInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDataPointByDataSourceNameAndNameArgs = {
  input: DeleteDataPointByDataSourceNameAndNameInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDataSourceArgs = {
  input: DeleteDataSourceInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDependencyArgs = {
  input: DeleteDependencyInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDependencyByPathArgs = {
  input: DeleteDependencyByPathInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDischargeHeaderArgs = {
  input: DeleteDischargeHeaderInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDischargeHeaderByRefrigerationSystemIdAndLabelArgs = {
  input: DeleteDischargeHeaderByRefrigerationSystemIdAndLabelInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDoorArgs = {
  input: DeleteDoorInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDoorByFacilityIdAndLabelArgs = {
  input: DeleteDoorByFacilityIdAndLabelInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteElectricalCircuitArgs = {
  input: DeleteElectricalCircuitInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteElectricalMeteringPointArgs = {
  input: DeleteElectricalMeteringPointInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteElectricalPanelArgs = {
  input: DeleteElectricalPanelInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteElectricalPanelByElectricalMeteringPointIdArgs = {
  input: DeleteElectricalPanelByElectricalMeteringPointIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteEvaporatorArgs = {
  input: DeleteEvaporatorInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteEvaporatorByFacilityIdAndLabelArgs = {
  input: DeleteEvaporatorByFacilityIdAndLabelInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFacilityArgs = {
  input: DeleteFacilityInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFacilityBySlugArgs = {
  input: DeleteFacilityBySlugInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFacilityCheckArgs = {
  input: DeleteFacilityCheckInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFacilityCheckByFacilityIdAndCheckIdArgs = {
  input: DeleteFacilityCheckByFacilityIdAndCheckIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFacilityCheckUserArgs = {
  input: DeleteFacilityCheckUserInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFacilityConfigArgs = {
  input: DeleteFacilityConfigInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFacilityDataSourceArgs = {
  input: DeleteFacilityDataSourceInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFacilityDocumentArgs = {
  input: DeleteFacilityDocumentInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFacilityGroupArgs = {
  input: DeleteFacilityGroupInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFacilityGroupsLinkerArgs = {
  input: DeleteFacilityGroupsLinkerInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFacilityMutableMetricDataArgs = {
  facilityId: Scalars['Int']['input'];
  from?: InputMaybe<Scalars['Datetime']['input']>;
  label: Scalars['String']['input'];
  to?: InputMaybe<Scalars['Datetime']['input']>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFacilitySoftwarePackageArgs = {
  input: DeleteFacilitySoftwarePackageInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFacilitySoftwarePackageByFacilityIdAndSoftwarePackageIdArgs =
  {
    input: DeleteFacilitySoftwarePackageByFacilityIdAndSoftwarePackageIdInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFacilityTaggedDataPointArgs = {
  input: DeleteFacilityTaggedDataPointInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteGatewayArgs = {
  input: DeleteGatewayInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteGatewayByFacilityIdAndHardwareIdArgs = {
  input: DeleteGatewayByFacilityIdAndHardwareIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteGatewayByFacilityIdAndLabelArgs = {
  input: DeleteGatewayByFacilityIdAndLabelInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteInboundOutboundLoadArgs = {
  input: DeleteInboundOutboundLoadInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteInboundOutboundLoadBySourceIdArgs = {
  input: DeleteInboundOutboundLoadBySourceIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteIncidentArgs = {
  input: DeleteIncidentInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteIncidentByCheckMonitorIdAndMonitorDetectionIdArgs = {
  input: DeleteIncidentByCheckMonitorIdAndMonitorDetectionIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteIncidentLogByIncidentIdAndEventAndTimeArgs = {
  input: DeleteIncidentLogByIncidentIdAndEventAndTimeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLiquidHeaderArgs = {
  input: DeleteLiquidHeaderInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLiquidHeaderByRefrigerationSystemIdAndLabelArgs = {
  input: DeleteLiquidHeaderByRefrigerationSystemIdAndLabelInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLiquidHeadersEvaporatorArgs = {
  input: DeleteLiquidHeadersEvaporatorInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLiquidHeadersEvaporatorByLiquidHeaderIdAndEvaporatorIdArgs =
  {
    input: DeleteLiquidHeadersEvaporatorByLiquidHeaderIdAndEvaporatorIdInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMachineUserArgs = {
  input: DeleteMachineUserInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMainServiceArgs = {
  input: DeleteMainServiceInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMainServiceByFacilityIdAndNameArgs = {
  input: DeleteMainServiceByFacilityIdAndNameInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMainServiceByFacilityIdAndUsageDataPointIdAndDemandDataPointIdArgs =
  {
    input: DeleteMainServiceByFacilityIdAndUsageDataPointIdAndDemandDataPointIdInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMeterChargeArgs = {
  input: DeleteMeterChargeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMeterStatementArgs = {
  input: DeleteMeterStatementInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMeterUsageArgs = {
  input: DeleteMeterUsageInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMonitorArgs = {
  input: DeleteMonitorInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMonitorAttributeArgs = {
  input: DeleteMonitorAttributeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMonitorDataPointArgs = {
  input: DeleteMonitorDataPointInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMonitorDetectionArgs = {
  input: DeleteMonitorDetectionInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMonitoredAssetArgs = {
  input: DeleteMonitoredAssetInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMutableMetricDataArgs = {
  from?: InputMaybe<Scalars['Datetime']['input']>;
  label: Scalars['String']['input'];
  sourceId?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['Datetime']['input']>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOpportunityArgs = {
  input: DeleteOpportunityInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOpportunityAttachmentArgs = {
  input: DeleteOpportunityAttachmentInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePalletArgs = {
  input: DeletePalletInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePalletBySourceIdArgs = {
  input: DeletePalletBySourceIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePalletHistoryArgs = {
  input: DeletePalletHistoryInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePalletHistoryBySourceIdArgs = {
  input: DeletePalletHistoryBySourceIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePalletLocationArgs = {
  input: DeletePalletLocationInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePalletLocationBySourceIdArgs = {
  input: DeletePalletLocationBySourceIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePhoneNumberArgs = {
  input?: InputMaybe<DeletePhoneNumberInput>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePricingNodeArgs = {
  input: DeletePricingNodeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProductArgs = {
  input: DeleteProductInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProductBySourceIdArgs = {
  input: DeleteProductBySourceIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProgramArgs = {
  input: DeleteProgramInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProgramByProjectTypeIdAndNameArgs = {
  input: DeleteProgramByProjectTypeIdAndNameInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProgramConfigArgs = {
  input: DeleteProgramConfigInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProgramEnrollmentArgs = {
  input: DeleteProgramEnrollmentInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProgramEnrollmentByProgramIdAndNameArgs = {
  input: DeleteProgramEnrollmentByProgramIdAndNameInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProjectArgs = {
  input: DeleteProjectInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProjectByFacilityIdAndProgramIdArgs = {
  input: DeleteProjectByFacilityIdAndProgramIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProjectComponentArgs = {
  input: DeleteProjectComponentInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProjectConfigArgs = {
  input: DeleteProjectConfigInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProjectEnrollmentArgs = {
  input: DeleteProjectEnrollmentInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProjectEnrollmentByProjectIdAndProgramEnrollmentIdArgs =
  {
    input: DeleteProjectEnrollmentByProjectIdAndProgramEnrollmentIdInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProjectEnrollmentDataPointArgs = {
  input: DeleteProjectEnrollmentDataPointInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProjectEnrollmentDataPointByProjectEnrollmentIdAndDataPointIdArgs =
  {
    input: DeleteProjectEnrollmentDataPointByProjectEnrollmentIdAndDataPointIdInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProjectEnrollmentDataPointGroupArgs = {
  input: DeleteProjectEnrollmentDataPointGroupInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProjectWatcherArgs = {
  input: DeleteProjectWatcherInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRefrigerationSystemArgs = {
  input: DeleteRefrigerationSystemInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRefrigerationSystemByFacilityIdAndLabelArgs = {
  input: DeleteRefrigerationSystemByFacilityIdAndLabelInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSavingsEventArgs = {
  input: DeleteSavingsEventInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSavingsEventByProjectIdAndStartTimeAndEndTimeArgs = {
  input: DeleteSavingsEventByProjectIdAndStartTimeAndEndTimeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSavingsEventDatumArgs = {
  input: DeleteSavingsEventDatumInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSavingsEventDatumBySavingsEventIdAndLabelArgs = {
  input: DeleteSavingsEventDatumBySavingsEventIdAndLabelInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSubmeterSessionArgs = {
  input: DeleteSubmeterSessionInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSubmeterSessionBySubmeterIdAndStartTimeArgs = {
  input: DeleteSubmeterSessionBySubmeterIdAndStartTimeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSuctionGroupArgs = {
  input: DeleteSuctionGroupInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSuctionGroupByRefrigerationSystemIdAndLabelArgs = {
  input: DeleteSuctionGroupByRefrigerationSystemIdAndLabelInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSuctionGroupCompressorArgs = {
  input: DeleteSuctionGroupCompressorInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSuctionGroupCompressorBySuctionGroupIdAndCompressorIdArgs =
  {
    input: DeleteSuctionGroupCompressorBySuctionGroupIdAndCompressorIdInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSuctionHeaderArgs = {
  input: DeleteSuctionHeaderInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSuctionHeaderByRefrigerationSystemIdAndLabelArgs = {
  input: DeleteSuctionHeaderByRefrigerationSystemIdAndLabelInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSuctionHeadersCompressorArgs = {
  input: DeleteSuctionHeadersCompressorInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSuctionHeadersCompressorBySuctionHeaderIdAndCompressorIdArgs =
  {
    input: DeleteSuctionHeadersCompressorBySuctionHeaderIdAndCompressorIdInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSuggestionControlEventArgs = {
  input: DeleteSuggestionControlEventInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSuggestionControlEventByControlEventIdArgs = {
  input: DeleteSuggestionControlEventByControlEventIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTemperatureSensorArgs = {
  input: DeleteTemperatureSensorInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTemperatureSensorByFacilityIdAndHardwareIdArgs = {
  input: DeleteTemperatureSensorByFacilityIdAndHardwareIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTemperatureSensorByFacilityIdAndLabelArgs = {
  input: DeleteTemperatureSensorByFacilityIdAndLabelInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTrailerAuditArgs = {
  input: DeleteTrailerAuditInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTrailerPositionArgs = {
  input: DeleteTrailerPositionInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTrailerPositionByFacilityIdAndLabelArgs = {
  input: DeleteTrailerPositionByFacilityIdAndLabelInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserArgs = {
  input: DeleteUserInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUtilityAccountArgs = {
  input: DeleteUtilityAccountInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUtilityCredentialArgs = {
  input: DeleteUtilityCredentialInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUtilityCredentialByIntegrationAndIntegrationKeyArgs =
  {
    input: DeleteUtilityCredentialByIntegrationAndIntegrationKeyInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUtilityCredentialFacilityArgs = {
  input: DeleteUtilityCredentialFacilityInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUtilityCredentialFacilityByUtilityCredentialIdAndFacilityIdArgs =
  {
    input: DeleteUtilityCredentialFacilityByUtilityCredentialIdAndFacilityIdInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUtilityFileUploadArgs = {
  input: DeleteUtilityFileUploadInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUtilityFileUploadByIntegrationAndIntegrationKeyArgs =
  {
    input: DeleteUtilityFileUploadByIntegrationAndIntegrationKeyInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUtilityMeterArgs = {
  input: DeleteUtilityMeterInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUtilityPendingMeterArgs = {
  input: DeleteUtilityPendingMeterInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUtilityPendingMeterByIntegrationAndIntegrationKeyArgs =
  {
    input: DeleteUtilityPendingMeterByIntegrationAndIntegrationKeyInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUtilityProviderArgs = {
  input: DeleteUtilityProviderInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUtilityProviderByNameArgs = {
  input: DeleteUtilityProviderByNameInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVendorUserArgs = {
  input: DeleteVendorUserInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVendorUserByEmailArgs = {
  input: DeleteVendorUserByEmailInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVendorUserMachineUserArgs = {
  input: DeleteVendorUserMachineUserInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVendorUserMachineUserByMachineUserIdArgs = {
  input: DeleteVendorUserMachineUserByMachineUserIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVesselArgs = {
  input: DeleteVesselInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVesselByRefrigerationSystemIdAndLabelArgs = {
  input: DeleteVesselByRefrigerationSystemIdAndLabelInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVirtualPointIntervalArgs = {
  input: DeleteVirtualPointIntervalInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationExtendArgs = {
  failOnExists?: InputMaybe<Scalars['Boolean']['input']>;
  payload: Scalars['String']['input'];
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationFleetCheckInArgs = {
  input: FleetCheckInInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationFleetCheckOutArgs = {
  input: FleetCheckOutInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationInvokeIntegrationArgs = {
  files?: InputMaybe<Array<Scalars['Upload']['input']>>;
  integration: Scalars['String']['input'];
  integrationType: IntegrationType;
  payload?: InputMaybe<Scalars['JSON']['input']>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationMarkTrailerAppointmentReadyArgs = {
  input: MarkTrailerAppointmentReadyInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationPatchControlEventRemoteMetadataArgs = {
  input: PatchControlEventRemoteMetadataInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationProvisionElectricalMeteringPointsAndPanelsArgs = {
  input: ProvisionElectricalMeteringPointsAndPanelsInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationReflowSubmeterSessionsArgs = {
  input: ReflowSubmeterSessionsInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationRegenerateAccessTokenArgs = {
  input: RegenerateAccessTokenInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationRegisterProjectUsersArgs = {
  input: RegisterProjectUsersInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationRemoveAccountChargeLabelCategoryArgs = {
  input: RemoveAccountChargeLabelCategoryInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationRemoveFavoriteFacilityArgs = {
  input: RemoveFavoriteFacilityInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationRemoveMeterChargeLabelCategoryArgs = {
  input: RemoveMeterChargeLabelCategoryInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationRemoveMetricMetadataDependencyArgs = {
  input: RemoveMetricMetadataDependencyInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationRemoveProjectControllerArgs = {
  input: RemoveProjectControllerInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationRemoveReportManagerArgs = {
  input: RemoveReportManagerInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationReparentMeterStatementArgs = {
  input: ReparentMeterStatementInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationReplaceAccountStatementPdfArgs = {
  input: ReplaceAccountStatementPdfInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationRevokeAccessTokenArgs = {
  input: RevokeAccessTokenInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationRunReportArgs = {
  parameters?: InputMaybe<Scalars['JSON']['input']>;
  reportId: Scalars['Int']['input'];
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetAccountChargeLabelCategoryArgs = {
  input: SetAccountChargeLabelCategoryInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetDefaultFacilityDocumentArgs = {
  input: SetDefaultFacilityDocumentInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetFacilityConfigArgs = {
  input: SetFacilityConfigInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetMachineUserCapabilityArgs = {
  input: SetMachineUserCapabilityInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetMeterChargeLabelCategoryArgs = {
  input: SetMeterChargeLabelCategoryInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetProgramConfigArgs = {
  input: SetProgramConfigInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetProjectConfigArgs = {
  input: SetProjectConfigInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationStartCustomerIntegrationArgs = {
  input: StartCustomerIntegrationInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationTransitionControlEventArgs = {
  input: TransitionControlEventInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationTransitionOpportunityArgs = {
  input: TransitionOpportunityInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationTriggerPhoneNumberVerificationArgs = {
  input: VerifyPhoneNumberInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAccountChargeArgs = {
  input: UpdateAccountChargeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAccountStatementArgs = {
  input: UpdateAccountStatementInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAssessmentArgs = {
  input: UpdateAssessmentInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAssessmentTypeArgs = {
  input: UpdateAssessmentTypeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAssessmentTypeBySlugArgs = {
  input: UpdateAssessmentTypeBySlugInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBalancingAuthorityArgs = {
  input: UpdateBalancingAuthorityInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBalancingAuthorityBySlugArgs = {
  input: UpdateBalancingAuthorityBySlugInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBillableCustomerArgs = {
  input: UpdateBillableCustomerInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBillableCustomerByCarrierCodeArgs = {
  input: UpdateBillableCustomerByCarrierCodeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBlastArgs = {
  input: UpdateBlastInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBlastByLabelAndFacilityIdArgs = {
  input: UpdateBlastByLabelAndFacilityIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBlastEvaporatorArgs = {
  input: UpdateBlastEvaporatorInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBlastPalletArgs = {
  input: UpdateBlastPalletInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBlastPalletLocationArgs = {
  input: UpdateBlastPalletLocationInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBlastRotationArgs = {
  input: UpdateBlastRotationInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBlastRotationAlertArgs = {
  input: UpdateBlastRotationAlertInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBlastRotationEventLogArgs = {
  input: UpdateBlastRotationEventLogInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBlastRotationEventLogByBlastRotationIdAndDescriptionAndBlastRotationEventTypeIdArgs =
  {
    input: UpdateBlastRotationEventLogByBlastRotationIdAndDescriptionAndBlastRotationEventTypeIdInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBlastRotationEventTypeArgs = {
  input: UpdateBlastRotationEventTypeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBlastRotationPalletArgs = {
  input: UpdateBlastRotationPalletInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBlastRotationPalletByBlastRotationIdAndPalletIdArgs =
  {
    input: UpdateBlastRotationPalletByBlastRotationIdAndPalletIdInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBlastTypeArgs = {
  input: UpdateBlastTypeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBuildingAreaArgs = {
  input: UpdateBuildingAreaInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBuildingAreaByFacilityIdAndLabelArgs = {
  input: UpdateBuildingAreaByFacilityIdAndLabelInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBuildingAreaComplianceGroupArgs = {
  input: UpdateBuildingAreaComplianceGroupInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBuildingAreaComplianceGroupByBuildingAreaIdAndComplianceTypeArgs =
  {
    input: UpdateBuildingAreaComplianceGroupByBuildingAreaIdAndComplianceTypeInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBuildingAreaTypeArgs = {
  input: UpdateBuildingAreaTypeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateChartArgs = {
  input: UpdateChartInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCheckArgs = {
  input: UpdateCheckInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCheckBySlugArgs = {
  input: UpdateCheckBySlugInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCheckMonitorArgs = {
  input: UpdateCheckMonitorInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCheckMonitorByMonitorIdArgs = {
  input: UpdateCheckMonitorByMonitorIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateClassificationArgs = {
  input: UpdateClassificationInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateClassificationByAssessmentTypeIdAndNameArgs = {
  input: UpdateClassificationByAssessmentTypeIdAndNameInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateClassificationResultArgs = {
  input: UpdateClassificationResultInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateClassificationResultByAssessmentIdAndClassificationIdArgs =
  {
    input: UpdateClassificationResultByAssessmentIdAndClassificationIdInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateComplianceGroupArgs = {
  input: UpdateComplianceGroupInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateComplianceGroupByLabelArgs = {
  input: UpdateComplianceGroupByLabelInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateComplianceRangeArgs = {
  input: UpdateComplianceRangeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateComplianceRangeByComplianceGroupIdAndLabelArgs = {
  input: UpdateComplianceRangeByComplianceGroupIdAndLabelInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateComponentArgs = {
  input: UpdateComponentInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCompressorArgs = {
  input: UpdateCompressorInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCompressorByFacilityIdAndLabelArgs = {
  input: UpdateCompressorByFacilityIdAndLabelInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateControlEventArgs = {
  input: UpdateControlEventInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateControlEventLogArgs = {
  input: UpdateControlEventLogInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCustomerArgs = {
  input: UpdateCustomerInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCustomerBillingRateArgs = {
  input: UpdateCustomerBillingRateInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCustomerBillingRateByCustomerIdAndEffectiveStartArgs =
  {
    input: UpdateCustomerBillingRateByCustomerIdAndEffectiveStartInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCustomerBySourceIdArgs = {
  input: UpdateCustomerBySourceIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDashboardArgs = {
  input: UpdateDashboardInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDataPointArgs = {
  input: UpdateDataPointInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDataPointByDataSourceNameAndNameArgs = {
  input: UpdateDataPointByDataSourceNameAndNameInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDependencyArgs = {
  input: UpdateDependencyInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDependencyByPathArgs = {
  input: UpdateDependencyByPathInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDischargeHeaderArgs = {
  input: UpdateDischargeHeaderInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDischargeHeaderByRefrigerationSystemIdAndLabelArgs = {
  input: UpdateDischargeHeaderByRefrigerationSystemIdAndLabelInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDoorArgs = {
  input: UpdateDoorInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDoorByFacilityIdAndLabelArgs = {
  input: UpdateDoorByFacilityIdAndLabelInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDriverArgs = {
  input: UpdateDriverInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDriverByConversationIdArgs = {
  input: UpdateDriverByConversationIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDriverByPhoneNumberArgs = {
  input: UpdateDriverByPhoneNumberInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateElectricalCircuitArgs = {
  input: UpdateElectricalCircuitInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateElectricalMeteringPointArgs = {
  input: UpdateElectricalMeteringPointInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateElectricalPanelArgs = {
  input: UpdateElectricalPanelInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateElectricalPanelByElectricalMeteringPointIdArgs = {
  input: UpdateElectricalPanelByElectricalMeteringPointIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEvaporatorArgs = {
  input: UpdateEvaporatorInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEvaporatorByFacilityIdAndLabelArgs = {
  input: UpdateEvaporatorByFacilityIdAndLabelInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFacilityArgs = {
  input: UpdateFacilityInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFacilityBySlugArgs = {
  input: UpdateFacilityBySlugInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFacilityCheckArgs = {
  input: UpdateFacilityCheckInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFacilityCheckByFacilityIdAndCheckIdArgs = {
  input: UpdateFacilityCheckByFacilityIdAndCheckIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFacilityDocumentArgs = {
  input: UpdateFacilityDocumentInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFacilityGroupArgs = {
  input: UpdateFacilityGroupInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFacilityGroupsLinkerArgs = {
  input: UpdateFacilityGroupsLinkerInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFacilityMutableMetricDataArgs = {
  deleteExisting?: InputMaybe<Scalars['Boolean']['input']>;
  metricData: Array<InputFacilityMetricData>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFacilitySoftwarePackageArgs = {
  input: UpdateFacilitySoftwarePackageInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFacilitySoftwarePackageByFacilityIdAndSoftwarePackageIdArgs =
  {
    input: UpdateFacilitySoftwarePackageByFacilityIdAndSoftwarePackageIdInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFacilityTaggedDataPointArgs = {
  input: UpdateFacilityTaggedDataPointInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateGatewayArgs = {
  input: UpdateGatewayInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateGatewayByFacilityIdAndHardwareIdArgs = {
  input: UpdateGatewayByFacilityIdAndHardwareIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateGatewayByFacilityIdAndLabelArgs = {
  input: UpdateGatewayByFacilityIdAndLabelInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateInboundOutboundLoadArgs = {
  input: UpdateInboundOutboundLoadInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateInboundOutboundLoadBySourceIdArgs = {
  input: UpdateInboundOutboundLoadBySourceIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateIncidentArgs = {
  input: UpdateIncidentInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateIncidentByCheckMonitorIdAndMonitorDetectionIdArgs = {
  input: UpdateIncidentByCheckMonitorIdAndMonitorDetectionIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLiquidHeaderArgs = {
  input: UpdateLiquidHeaderInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLiquidHeaderByRefrigerationSystemIdAndLabelArgs = {
  input: UpdateLiquidHeaderByRefrigerationSystemIdAndLabelInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLiquidHeadersEvaporatorArgs = {
  input: UpdateLiquidHeadersEvaporatorInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLiquidHeadersEvaporatorByLiquidHeaderIdAndEvaporatorIdArgs =
  {
    input: UpdateLiquidHeadersEvaporatorByLiquidHeaderIdAndEvaporatorIdInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMachineUserArgs = {
  input: UpdateMachineUserInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMainServiceArgs = {
  input: UpdateMainServiceInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMainServiceByFacilityIdAndNameArgs = {
  input: UpdateMainServiceByFacilityIdAndNameInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMainServiceByFacilityIdAndUsageDataPointIdAndDemandDataPointIdArgs =
  {
    input: UpdateMainServiceByFacilityIdAndUsageDataPointIdAndDemandDataPointIdInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMeterChargeArgs = {
  input: UpdateMeterChargeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMeterStatementArgs = {
  input: UpdateMeterStatementInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMeterUsageArgs = {
  input: UpdateMeterUsageInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMonitorArgs = {
  input: UpdateMonitorInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMonitorDataPointArgs = {
  input: UpdateMonitorDataPointInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMonitorDetectionArgs = {
  input: UpdateMonitorDetectionInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMutableMetricDataArgs = {
  deleteExisting?: InputMaybe<Scalars['Boolean']['input']>;
  metricData: Array<InputMetricData>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOpportunityArgs = {
  input: UpdateOpportunityInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOpportunityAttachmentArgs = {
  input: UpdateOpportunityAttachmentInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePalletArgs = {
  input: UpdatePalletInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePalletBySourceIdArgs = {
  input: UpdatePalletBySourceIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePalletHistoryArgs = {
  input: UpdatePalletHistoryInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePalletHistoryBySourceIdArgs = {
  input: UpdatePalletHistoryBySourceIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePalletLocationArgs = {
  input: UpdatePalletLocationInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePalletLocationBySourceIdArgs = {
  input: UpdatePalletLocationBySourceIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePhoneNumberArgs = {
  input: UpdatePhoneNumberInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePricingNodeArgs = {
  input: UpdatePricingNodeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProductArgs = {
  input: UpdateProductInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProductBySourceIdArgs = {
  input: UpdateProductBySourceIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProgramArgs = {
  input: UpdateProgramInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProgramByProjectTypeIdAndNameArgs = {
  input: UpdateProgramByProjectTypeIdAndNameInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProgramEnrollmentArgs = {
  input: UpdateProgramEnrollmentInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProgramEnrollmentByProgramIdAndNameArgs = {
  input: UpdateProgramEnrollmentByProgramIdAndNameInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProjectArgs = {
  input: UpdateProjectInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProjectByFacilityIdAndProgramIdArgs = {
  input: UpdateProjectByFacilityIdAndProgramIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProjectComponentArgs = {
  input: UpdateProjectComponentInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProjectEnrollmentArgs = {
  input: UpdateProjectEnrollmentInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProjectEnrollmentByProjectIdAndProgramEnrollmentIdArgs =
  {
    input: UpdateProjectEnrollmentByProjectIdAndProgramEnrollmentIdInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProjectEnrollmentDataPointArgs = {
  input: UpdateProjectEnrollmentDataPointInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProjectEnrollmentDataPointByProjectEnrollmentIdAndDataPointIdArgs =
  {
    input: UpdateProjectEnrollmentDataPointByProjectEnrollmentIdAndDataPointIdInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProjectEnrollmentDataPointGroupArgs = {
  input: UpdateProjectEnrollmentDataPointGroupInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProjectWatcherArgs = {
  input: UpdateProjectWatcherInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRefrigerationSystemArgs = {
  input: UpdateRefrigerationSystemInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRefrigerationSystemByFacilityIdAndLabelArgs = {
  input: UpdateRefrigerationSystemByFacilityIdAndLabelInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateReportArgs = {
  input: UpdateReportInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateReportByLabelArgs = {
  input: UpdateReportByLabelInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateReportExecutionArgs = {
  input: UpdateReportExecutionInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSavingsEventArgs = {
  input: UpdateSavingsEventInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSavingsEventByProjectIdAndStartTimeAndEndTimeArgs = {
  input: UpdateSavingsEventByProjectIdAndStartTimeAndEndTimeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSavingsEventDatumArgs = {
  input: UpdateSavingsEventDatumInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSavingsEventDatumBySavingsEventIdAndLabelArgs = {
  input: UpdateSavingsEventDatumBySavingsEventIdAndLabelInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSeverityArgs = {
  input: UpdateSeverityInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSeverityByNameArgs = {
  input: UpdateSeverityByNameInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSeverityBySlugArgs = {
  input: UpdateSeverityBySlugInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSubmeterArgs = {
  input: UpdateSubmeterInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSubmeterSessionArgs = {
  input: UpdateSubmeterSessionInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSubmeterSessionBySubmeterIdAndStartTimeArgs = {
  input: UpdateSubmeterSessionBySubmeterIdAndStartTimeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSuctionGroupArgs = {
  input: UpdateSuctionGroupInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSuctionGroupByRefrigerationSystemIdAndLabelArgs = {
  input: UpdateSuctionGroupByRefrigerationSystemIdAndLabelInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSuctionGroupCompressorArgs = {
  input: UpdateSuctionGroupCompressorInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSuctionGroupCompressorBySuctionGroupIdAndCompressorIdArgs =
  {
    input: UpdateSuctionGroupCompressorBySuctionGroupIdAndCompressorIdInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSuctionHeaderArgs = {
  input: UpdateSuctionHeaderInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSuctionHeaderByRefrigerationSystemIdAndLabelArgs = {
  input: UpdateSuctionHeaderByRefrigerationSystemIdAndLabelInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSuctionHeadersCompressorArgs = {
  input: UpdateSuctionHeadersCompressorInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSuctionHeadersCompressorBySuctionHeaderIdAndCompressorIdArgs =
  {
    input: UpdateSuctionHeadersCompressorBySuctionHeaderIdAndCompressorIdInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSuggestionArgs = {
  input: UpdateSuggestionInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSuggestionControlEventArgs = {
  input: UpdateSuggestionControlEventInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSuggestionControlEventByControlEventIdArgs = {
  input: UpdateSuggestionControlEventByControlEventIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTemperatureSensorArgs = {
  input: UpdateTemperatureSensorInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTemperatureSensorByFacilityIdAndHardwareIdArgs = {
  input: UpdateTemperatureSensorByFacilityIdAndHardwareIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTemperatureSensorByFacilityIdAndLabelArgs = {
  input: UpdateTemperatureSensorByFacilityIdAndLabelInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTrailerArgs = {
  input: UpdateTrailerInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTrailerAppointmentArgs = {
  input: UpdateTrailerAppointmentInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTrailerAuditArgs = {
  input: UpdateTrailerAuditInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTrailerByCarrierCodeAndCarrierTrailerNumberArgs = {
  input: UpdateTrailerByCarrierCodeAndCarrierTrailerNumberInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTrailerPositionArgs = {
  input: UpdateTrailerPositionInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTrailerPositionByFacilityIdAndLabelArgs = {
  input: UpdateTrailerPositionByFacilityIdAndLabelInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUtilityAccountArgs = {
  input: UpdateUtilityAccountInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUtilityCredentialArgs = {
  input: UpdateUtilityCredentialInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUtilityCredentialByIntegrationAndIntegrationKeyArgs =
  {
    input: UpdateUtilityCredentialByIntegrationAndIntegrationKeyInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUtilityFileUploadArgs = {
  input: UpdateUtilityFileUploadInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUtilityFileUploadByIntegrationAndIntegrationKeyArgs =
  {
    input: UpdateUtilityFileUploadByIntegrationAndIntegrationKeyInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUtilityMeterArgs = {
  input: UpdateUtilityMeterInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUtilityPendingMeterArgs = {
  input: UpdateUtilityPendingMeterInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUtilityPendingMeterByIntegrationAndIntegrationKeyArgs =
  {
    input: UpdateUtilityPendingMeterByIntegrationAndIntegrationKeyInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUtilityProviderArgs = {
  input: UpdateUtilityProviderInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUtilityProviderByNameArgs = {
  input: UpdateUtilityProviderByNameInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVendorUserArgs = {
  input: UpdateVendorUserInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVendorUserByEmailArgs = {
  input: UpdateVendorUserByEmailInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVendorUserMachineUserArgs = {
  input: UpdateVendorUserMachineUserInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVendorUserMachineUserByMachineUserIdArgs = {
  input: UpdateVendorUserMachineUserByMachineUserIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVesselArgs = {
  input: UpdateVesselInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVesselByRefrigerationSystemIdAndLabelArgs = {
  input: UpdateVesselByRefrigerationSystemIdAndLabelInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVirtualPointIntervalArgs = {
  input: UpdateVirtualPointIntervalInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertAccountChargeArgs = {
  input: UpsertAccountChargeInput;
  where?: InputMaybe<UpsertAccountChargeWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertAccountStatementArgs = {
  input: UpsertAccountStatementInput;
  where?: InputMaybe<UpsertAccountStatementWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertAccountStatementPdfArgs = {
  input: UpsertAccountStatementPdfInput;
  where?: InputMaybe<UpsertAccountStatementPdfWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertAssessmentArgs = {
  input: UpsertAssessmentInput;
  where?: InputMaybe<UpsertAssessmentWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertBalancingAuthorityArgs = {
  input: UpsertBalancingAuthorityInput;
  where?: InputMaybe<UpsertBalancingAuthorityWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertBillableCustomerArgs = {
  input: UpsertBillableCustomerInput;
  where?: InputMaybe<UpsertBillableCustomerWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertBlastArgs = {
  input: UpsertBlastInput;
  where?: InputMaybe<UpsertBlastWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertBlastEvaporatorArgs = {
  input: UpsertBlastEvaporatorInput;
  where?: InputMaybe<UpsertBlastEvaporatorWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertBlastPalletArgs = {
  input: UpsertBlastPalletInput;
  where?: InputMaybe<UpsertBlastPalletWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertBlastPalletLocationArgs = {
  input: UpsertBlastPalletLocationInput;
  where?: InputMaybe<UpsertBlastPalletLocationWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertBlastRotationArgs = {
  input: UpsertBlastRotationInput;
  where?: InputMaybe<UpsertBlastRotationWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertBlastRotationAlertArgs = {
  input: UpsertBlastRotationAlertInput;
  where?: InputMaybe<UpsertBlastRotationAlertWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertBlastRotationEventLogArgs = {
  input: UpsertBlastRotationEventLogInput;
  where?: InputMaybe<UpsertBlastRotationEventLogWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertBlastRotationEventTypeArgs = {
  input: UpsertBlastRotationEventTypeInput;
  where?: InputMaybe<UpsertBlastRotationEventTypeWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertBlastRotationPalletArgs = {
  input: UpsertBlastRotationPalletInput;
  where?: InputMaybe<UpsertBlastRotationPalletWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertBlastTypeArgs = {
  input: UpsertBlastTypeInput;
  where?: InputMaybe<UpsertBlastTypeWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertBuildingAreaArgs = {
  input: UpsertBuildingAreaInput;
  where?: InputMaybe<UpsertBuildingAreaWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertBuildingAreaComplianceGroupArgs = {
  input: UpsertBuildingAreaComplianceGroupInput;
  where?: InputMaybe<UpsertBuildingAreaComplianceGroupWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertBuildingAreaTypeArgs = {
  input: UpsertBuildingAreaTypeInput;
  where?: InputMaybe<UpsertBuildingAreaTypeWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertChartArgs = {
  input: UpsertChartInput;
  where?: InputMaybe<UpsertChartWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertClassificationResultArgs = {
  input: UpsertClassificationResultInput;
  where?: InputMaybe<UpsertClassificationResultWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertComplianceGroupArgs = {
  input: UpsertComplianceGroupInput;
  where?: InputMaybe<UpsertComplianceGroupWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertComplianceRangeArgs = {
  input: UpsertComplianceRangeInput;
  where?: InputMaybe<UpsertComplianceRangeWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertCompressorArgs = {
  input: UpsertCompressorInput;
  where?: InputMaybe<UpsertCompressorWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertCustomerArgs = {
  input: UpsertCustomerInput;
  where?: InputMaybe<UpsertCustomerWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertCustomerBillingRateArgs = {
  input: UpsertCustomerBillingRateInput;
  where?: InputMaybe<UpsertCustomerBillingRateWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertDashboardArgs = {
  input: UpsertDashboardInput;
  where?: InputMaybe<UpsertDashboardWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertDataPointArgs = {
  input: UpsertDataPointInput;
  where?: InputMaybe<UpsertDataPointWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertDependencyArgs = {
  input: UpsertDependencyInput;
  where?: InputMaybe<UpsertDependencyWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertDischargeHeaderArgs = {
  input: UpsertDischargeHeaderInput;
  where?: InputMaybe<UpsertDischargeHeaderWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertDoorArgs = {
  input: UpsertDoorInput;
  where?: InputMaybe<UpsertDoorWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertDriverArgs = {
  input: UpsertDriverInput;
  where?: InputMaybe<UpsertDriverWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertElectricalCircuitArgs = {
  input: UpsertElectricalCircuitInput;
  where?: InputMaybe<UpsertElectricalCircuitWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertElectricalMeteringPointArgs = {
  input: UpsertElectricalMeteringPointInput;
  where?: InputMaybe<UpsertElectricalMeteringPointWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertElectricalPanelArgs = {
  input: UpsertElectricalPanelInput;
  where?: InputMaybe<UpsertElectricalPanelWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertEvaporatorArgs = {
  input: UpsertEvaporatorInput;
  where?: InputMaybe<UpsertEvaporatorWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertFacilityCheckUserArgs = {
  input: UpsertFacilityCheckUserInput;
  where?: InputMaybe<UpsertFacilityCheckUserWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertFacilitySoftwarePackageArgs = {
  input: UpsertFacilitySoftwarePackageInput;
  where?: InputMaybe<UpsertFacilitySoftwarePackageWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertFacilityTaggedDataPointArgs = {
  input: UpsertFacilityTaggedDataPointInput;
  where?: InputMaybe<UpsertFacilityTaggedDataPointWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertGatewayArgs = {
  input: UpsertGatewayInput;
  where?: InputMaybe<UpsertGatewayWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertInboundOutboundLoadArgs = {
  input: UpsertInboundOutboundLoadInput;
  where?: InputMaybe<UpsertInboundOutboundLoadWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertIntegrationUtilityProviderArgs = {
  input: UpsertIntegrationUtilityProviderInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertLiquidHeaderArgs = {
  input: UpsertLiquidHeaderInput;
  where?: InputMaybe<UpsertLiquidHeaderWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertLiquidHeadersEvaporatorArgs = {
  input: UpsertLiquidHeadersEvaporatorInput;
  where?: InputMaybe<UpsertLiquidHeadersEvaporatorWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertMachineUserArgs = {
  input: UpsertMachineUserInput;
  where?: InputMaybe<UpsertMachineUserWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertMainServiceArgs = {
  input: UpsertMainServiceInput;
  where?: InputMaybe<UpsertMainServiceWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertMeterChargeArgs = {
  input: UpsertMeterChargeInput;
  where?: InputMaybe<UpsertMeterChargeWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertMeterStatementArgs = {
  input: UpsertMeterStatementInput;
  where?: InputMaybe<UpsertMeterStatementWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertMeterUsageArgs = {
  input: UpsertMeterUsageInput;
  where?: InputMaybe<UpsertMeterUsageWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertMonitorAttributeArgs = {
  input: UpsertMonitorAttributeInput;
  where?: InputMaybe<UpsertMonitorAttributeWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertMonitorDataPointArgs = {
  input: UpsertMonitorDataPointInput;
  where?: InputMaybe<UpsertMonitorDataPointWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertMonitoredAssetArgs = {
  input: UpsertMonitoredAssetInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertPalletArgs = {
  input: UpsertPalletInput;
  where?: InputMaybe<UpsertPalletWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertPalletHistoryArgs = {
  input: UpsertPalletHistoryInput;
  where?: InputMaybe<UpsertPalletHistoryWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertPalletLocationArgs = {
  input: UpsertPalletLocationInput;
  where?: InputMaybe<UpsertPalletLocationWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertPricingNodeArgs = {
  input: UpsertPricingNodeInput;
  where?: InputMaybe<UpsertPricingNodeWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertProductArgs = {
  input: UpsertProductInput;
  where?: InputMaybe<UpsertProductWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertProgramArgs = {
  input: UpsertProgramInput;
  where?: InputMaybe<UpsertProgramWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertProgramEnrollmentArgs = {
  input: UpsertProgramEnrollmentInput;
  where?: InputMaybe<UpsertProgramEnrollmentWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertProjectComponentArgs = {
  input: UpsertProjectComponentInput;
  where?: InputMaybe<UpsertProjectComponentWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertProjectEnrollmentArgs = {
  input: UpsertProjectEnrollmentInput;
  where?: InputMaybe<UpsertProjectEnrollmentWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertProjectEnrollmentDataPointArgs = {
  input: UpsertProjectEnrollmentDataPointInput;
  where?: InputMaybe<UpsertProjectEnrollmentDataPointWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertProjectEnrollmentDataPointGroupArgs = {
  input: UpsertProjectEnrollmentDataPointGroupInput;
  where?: InputMaybe<UpsertProjectEnrollmentDataPointGroupWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertProjectSubscriptionArgs = {
  input: UpsertProjectSubscriptionInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertProjectWatcherArgs = {
  input: UpsertProjectWatcherInput;
  where?: InputMaybe<UpsertProjectWatcherWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertRefrigerationSystemArgs = {
  input: UpsertRefrigerationSystemInput;
  where?: InputMaybe<UpsertRefrigerationSystemWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertReportExecutionArgs = {
  input: UpsertReportExecutionInput;
  where?: InputMaybe<UpsertReportExecutionWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertReportQueryArgs = {
  input: UpsertReportQueryInput;
  where?: InputMaybe<UpsertReportQueryWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertSavingsEventArgs = {
  input: UpsertSavingsEventInput;
  where?: InputMaybe<UpsertSavingsEventWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertSavingsEventDatumArgs = {
  input: UpsertSavingsEventDatumInput;
  where?: InputMaybe<UpsertSavingsEventDatumWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertSubmeterArgs = {
  input: UpsertSubmeterInput;
  where?: InputMaybe<UpsertSubmeterWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertSubmeterSessionArgs = {
  input: UpsertSubmeterSessionInput;
  where?: InputMaybe<UpsertSubmeterSessionWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertSuctionGroupArgs = {
  input: UpsertSuctionGroupInput;
  where?: InputMaybe<UpsertSuctionGroupWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertSuctionGroupCompressorArgs = {
  input: UpsertSuctionGroupCompressorInput;
  where?: InputMaybe<UpsertSuctionGroupCompressorWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertSuctionHeaderArgs = {
  input: UpsertSuctionHeaderInput;
  where?: InputMaybe<UpsertSuctionHeaderWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertSuctionHeadersCompressorArgs = {
  input: UpsertSuctionHeadersCompressorInput;
  where?: InputMaybe<UpsertSuctionHeadersCompressorWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertSuggestionControlEventArgs = {
  input: UpsertSuggestionControlEventInput;
  where?: InputMaybe<UpsertSuggestionControlEventWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertTemperatureSensorArgs = {
  input: UpsertTemperatureSensorInput;
  where?: InputMaybe<UpsertTemperatureSensorWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertTrailerArgs = {
  input: UpsertTrailerInput;
  where?: InputMaybe<UpsertTrailerWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertTrailerAuditArgs = {
  input: UpsertTrailerAuditInput;
  where?: InputMaybe<UpsertTrailerAuditWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertTrailerPositionArgs = {
  input: UpsertTrailerPositionInput;
  where?: InputMaybe<UpsertTrailerPositionWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertUrjanetUtilityProviderArgs = {
  input: UpsertUrjanetUtilityProviderInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertUtilityAccountArgs = {
  input: UpsertUtilityAccountInput;
  where?: InputMaybe<UpsertUtilityAccountWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertUtilityCredentialArgs = {
  input: UpsertUtilityCredentialInput;
  where?: InputMaybe<UpsertUtilityCredentialWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertUtilityCredentialFacilityArgs = {
  input: UpsertUtilityCredentialFacilityInput;
  where?: InputMaybe<UpsertUtilityCredentialFacilityWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertUtilityFileUploadArgs = {
  input: UpsertUtilityFileUploadInput;
  where?: InputMaybe<UpsertUtilityFileUploadWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertUtilityMeterArgs = {
  input: UpsertUtilityMeterInput;
  where?: InputMaybe<UpsertUtilityMeterWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertUtilityPendingMeterArgs = {
  input: UpsertUtilityPendingMeterInput;
  where?: InputMaybe<UpsertUtilityPendingMeterWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertUtilityProviderArgs = {
  input: UpsertUtilityProviderInput;
  where?: InputMaybe<UpsertUtilityProviderWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertVendorUserMachineUserArgs = {
  input: UpsertVendorUserMachineUserInput;
  where?: InputMaybe<UpsertVendorUserMachineUserWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertVesselArgs = {
  input: UpsertVesselInput;
  where?: InputMaybe<UpsertVesselWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertVirtualPointIntervalArgs = {
  input: UpsertVirtualPointIntervalInput;
  where?: InputMaybe<UpsertVirtualPointIntervalWhere>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationWithdrawSuggestionArgs = {
  input: WithdrawSuggestionInput;
};

/** An object with a globally unique `ID`. */
export type Node = {
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
};

/** A connection to a list of `Opportunity` values. */
export type OpportunitiesConnection = {
  __typename?: 'OpportunitiesConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<OpportunityAggregates>;
  /** A list of edges which contains the `Opportunity` and cursor to aid in pagination. */
  edges: Array<OpportunitiesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<OpportunityAggregates>>;
  /** A list of `Opportunity` objects. */
  nodes: Array<Opportunity>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Opportunity` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A connection to a list of `Opportunity` values. */
export type OpportunitiesConnectionGroupedAggregatesArgs = {
  groupBy: Array<OpportunitiesGroupBy>;
  having?: InputMaybe<OpportunitiesHavingInput>;
};

/** A `Opportunity` edge in the connection. */
export type OpportunitiesEdge = {
  __typename?: 'OpportunitiesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Opportunity` at the end of the edge. */
  node: Opportunity;
};

/** Grouping methods for `Opportunity` for usage during aggregation. */
export enum OpportunitiesGroupBy {
  CREATED_AT = 'CREATED_AT',
  CREATED_AT_DISTINCT = 'CREATED_AT_DISTINCT',
  CREATED_AT_TRUNCATED_TO_DAY = 'CREATED_AT_TRUNCATED_TO_DAY',
  CREATED_AT_TRUNCATED_TO_HOUR = 'CREATED_AT_TRUNCATED_TO_HOUR',
  DESCRIPTION = 'DESCRIPTION',
  DESCRIPTION_DISTINCT = 'DESCRIPTION_DISTINCT',
  EXPECTED_OUTCOME = 'EXPECTED_OUTCOME',
  EXPECTED_OUTCOME_DISTINCT = 'EXPECTED_OUTCOME_DISTINCT',
  EXPECTED_SAVINGS_DEMAND = 'EXPECTED_SAVINGS_DEMAND',
  EXPECTED_SAVINGS_DEMAND_DISTINCT = 'EXPECTED_SAVINGS_DEMAND_DISTINCT',
  EXPECTED_SAVINGS_ENERGY = 'EXPECTED_SAVINGS_ENERGY',
  EXPECTED_SAVINGS_ENERGY_DISTINCT = 'EXPECTED_SAVINGS_ENERGY_DISTINCT',
  EXPECTED_SAVINGS_MONETARY = 'EXPECTED_SAVINGS_MONETARY',
  EXPECTED_SAVINGS_MONETARY_DISTINCT = 'EXPECTED_SAVINGS_MONETARY_DISTINCT',
  FACILITY_ID = 'FACILITY_ID',
  FACILITY_ID_DISTINCT = 'FACILITY_ID_DISTINCT',
  PROCEDURE = 'PROCEDURE',
  PROCEDURE_DISTINCT = 'PROCEDURE_DISTINCT',
  STATE = 'STATE',
  STATE_DISTINCT = 'STATE_DISTINCT',
  TAGS = 'TAGS',
  TAGS_DISTINCT = 'TAGS_DISTINCT',
  TITLE = 'TITLE',
  TITLE_DISTINCT = 'TITLE_DISTINCT',
  UPDATED_AT = 'UPDATED_AT',
  UPDATED_AT_DISTINCT = 'UPDATED_AT_DISTINCT',
  UPDATED_AT_TRUNCATED_TO_DAY = 'UPDATED_AT_TRUNCATED_TO_DAY',
  UPDATED_AT_TRUNCATED_TO_HOUR = 'UPDATED_AT_TRUNCATED_TO_HOUR'
}

export type OpportunitiesHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  expectedSavingsDemand?: InputMaybe<HavingBigfloatFilter>;
  expectedSavingsEnergy?: InputMaybe<HavingBigfloatFilter>;
  expectedSavingsMonetary?: InputMaybe<HavingBigfloatFilter>;
  facilityId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type OpportunitiesHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  expectedSavingsDemand?: InputMaybe<HavingBigfloatFilter>;
  expectedSavingsEnergy?: InputMaybe<HavingBigfloatFilter>;
  expectedSavingsMonetary?: InputMaybe<HavingBigfloatFilter>;
  facilityId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type OpportunitiesHavingDistinctInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  expectedSavingsDemand?: InputMaybe<HavingBigfloatFilter>;
  expectedSavingsEnergy?: InputMaybe<HavingBigfloatFilter>;
  expectedSavingsMonetary?: InputMaybe<HavingBigfloatFilter>;
  facilityId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `Opportunity` aggregates. */
export type OpportunitiesHavingInput = {
  AND?: InputMaybe<Array<OpportunitiesHavingInput>>;
  OR?: InputMaybe<Array<OpportunitiesHavingInput>>;
  average?: InputMaybe<OpportunitiesHavingAverageInput>;
  distinct?: InputMaybe<OpportunitiesHavingDistinctInput>;
  distinctCount?: InputMaybe<OpportunitiesHavingDistinctCountInput>;
  max?: InputMaybe<OpportunitiesHavingMaxInput>;
  min?: InputMaybe<OpportunitiesHavingMinInput>;
  stddevPopulation?: InputMaybe<OpportunitiesHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<OpportunitiesHavingStddevSampleInput>;
  sum?: InputMaybe<OpportunitiesHavingSumInput>;
  variancePopulation?: InputMaybe<OpportunitiesHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<OpportunitiesHavingVarianceSampleInput>;
};

export type OpportunitiesHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  expectedSavingsDemand?: InputMaybe<HavingBigfloatFilter>;
  expectedSavingsEnergy?: InputMaybe<HavingBigfloatFilter>;
  expectedSavingsMonetary?: InputMaybe<HavingBigfloatFilter>;
  facilityId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type OpportunitiesHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  expectedSavingsDemand?: InputMaybe<HavingBigfloatFilter>;
  expectedSavingsEnergy?: InputMaybe<HavingBigfloatFilter>;
  expectedSavingsMonetary?: InputMaybe<HavingBigfloatFilter>;
  facilityId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type OpportunitiesHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  expectedSavingsDemand?: InputMaybe<HavingBigfloatFilter>;
  expectedSavingsEnergy?: InputMaybe<HavingBigfloatFilter>;
  expectedSavingsMonetary?: InputMaybe<HavingBigfloatFilter>;
  facilityId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type OpportunitiesHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  expectedSavingsDemand?: InputMaybe<HavingBigfloatFilter>;
  expectedSavingsEnergy?: InputMaybe<HavingBigfloatFilter>;
  expectedSavingsMonetary?: InputMaybe<HavingBigfloatFilter>;
  facilityId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type OpportunitiesHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  expectedSavingsDemand?: InputMaybe<HavingBigfloatFilter>;
  expectedSavingsEnergy?: InputMaybe<HavingBigfloatFilter>;
  expectedSavingsMonetary?: InputMaybe<HavingBigfloatFilter>;
  facilityId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type OpportunitiesHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  expectedSavingsDemand?: InputMaybe<HavingBigfloatFilter>;
  expectedSavingsEnergy?: InputMaybe<HavingBigfloatFilter>;
  expectedSavingsMonetary?: InputMaybe<HavingBigfloatFilter>;
  facilityId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type OpportunitiesHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  expectedSavingsDemand?: InputMaybe<HavingBigfloatFilter>;
  expectedSavingsEnergy?: InputMaybe<HavingBigfloatFilter>;
  expectedSavingsMonetary?: InputMaybe<HavingBigfloatFilter>;
  facilityId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Methods to use when ordering `Opportunity`. */
export enum OpportunitiesOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  EXPECTED_OUTCOME_ASC = 'EXPECTED_OUTCOME_ASC',
  EXPECTED_OUTCOME_DESC = 'EXPECTED_OUTCOME_DESC',
  EXPECTED_SAVINGS_DEMAND_ASC = 'EXPECTED_SAVINGS_DEMAND_ASC',
  EXPECTED_SAVINGS_DEMAND_DESC = 'EXPECTED_SAVINGS_DEMAND_DESC',
  EXPECTED_SAVINGS_ENERGY_ASC = 'EXPECTED_SAVINGS_ENERGY_ASC',
  EXPECTED_SAVINGS_ENERGY_DESC = 'EXPECTED_SAVINGS_ENERGY_DESC',
  EXPECTED_SAVINGS_MONETARY_ASC = 'EXPECTED_SAVINGS_MONETARY_ASC',
  EXPECTED_SAVINGS_MONETARY_DESC = 'EXPECTED_SAVINGS_MONETARY_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  PROCEDURE_ASC = 'PROCEDURE_ASC',
  PROCEDURE_DESC = 'PROCEDURE_DESC',
  STATE_ASC = 'STATE_ASC',
  STATE_DESC = 'STATE_DESC',
  TAGS_ASC = 'TAGS_ASC',
  TAGS_DESC = 'TAGS_DESC',
  TITLE_ASC = 'TITLE_ASC',
  TITLE_DESC = 'TITLE_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** An opportunity for energy savings at a facility. */
export type Opportunity = Node & {
  __typename?: 'Opportunity';
  /** Reads and enables pagination through a set of `OpportunityAttachment`. */
  attachments: OpportunityAttachmentsConnection;
  /** The time the opportunity was created. */
  createdAt: Scalars['Datetime']['output'];
  /** The description of the opportunity. */
  description?: Maybe<Scalars['String']['output']>;
  /** The expected outcome of the opportunity. */
  expectedOutcome?: Maybe<Scalars['String']['output']>;
  /** The expected demand savings of the opportunity. */
  expectedSavingsDemand?: Maybe<Scalars['BigFloat']['output']>;
  /** The expected energy savings of the opportunity. */
  expectedSavingsEnergy?: Maybe<Scalars['BigFloat']['output']>;
  /** The expected monetary savings of the opportunity. */
  expectedSavingsMonetary?: Maybe<Scalars['BigFloat']['output']>;
  /** Reads a single `Facility` that is related to this `Opportunity`. */
  facility?: Maybe<Facility>;
  /** The facility associated with this opportunity. */
  facilityId: Scalars['Int']['output'];
  /** The identifier of the opportunity. */
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Available permissions for the Opportunity. */
  permissions?: Maybe<OpportunityPermissions>;
  /** The procedure to implement the opportunity. */
  procedure?: Maybe<Scalars['String']['output']>;
  state: OpportunityState;
  /** Tags associated with the opportunity. */
  tags: Array<Maybe<Scalars['String']['output']>>;
  /** The title of the opportunity. */
  title: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `OpportunityTransition`. */
  transitions: OpportunityTransitionsConnection;
  /** The time the opportunity was updated. */
  updatedAt: Scalars['Datetime']['output'];
};

/** An opportunity for energy savings at a facility. */
export type OpportunityAttachmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OpportunityAttachmentCondition>;
  filter?: InputMaybe<OpportunityAttachmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OpportunityAttachmentsOrderBy>>;
};

/** An opportunity for energy savings at a facility. */
export type OpportunityTransitionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OpportunityTransitionCondition>;
  filter?: InputMaybe<OpportunityTransitionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OpportunityTransitionsOrderBy>>;
};

export type OpportunityAggregates = {
  __typename?: 'OpportunityAggregates';
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<OpportunitySumAggregates>;
};

/** An attachment to an opportunity. */
export type OpportunityAttachment = Node & {
  __typename?: 'OpportunityAttachment';
  /** The time the opportunity attachment was created. */
  createdAt: Scalars['Datetime']['output'];
  /** The extension of the file. */
  fileExtension: Scalars['String']['output'];
  /** The name of the file. */
  fileName: Scalars['String']['output'];
  /** The identifier of the opportunity attachment. */
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Opportunity` that is related to this `OpportunityAttachment`. */
  opportunity?: Maybe<Opportunity>;
  /** The opportunity associated with this attachment. */
  opportunityId?: Maybe<Scalars['Int']['output']>;
  /** The path to the file. */
  path: Scalars['String']['output'];
  /** Available permissions for the OpportunityAttachment. */
  permissions?: Maybe<OpportunityAttachmentPermissions>;
  /** The relative path for the file. */
  serverPath: Scalars['String']['output'];
  /** The time the opportunity attachment was updated. */
  updatedAt: Scalars['Datetime']['output'];
  /** The presigned URI for the file. */
  uri: Scalars['String']['output'];
};

/**
 * A condition to be used against `OpportunityAttachment` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type OpportunityAttachmentCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `fileExtension` field. */
  fileExtension?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `fileName` field. */
  fileName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `opportunityId` field. */
  opportunityId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `path` field. */
  path?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `OpportunityAttachment` object types. All fields are combined with a logical ‘and.’ */
export type OpportunityAttachmentFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<OpportunityAttachmentFilter>>;
  /** Filter by the permission can_write */
  canWrite?: InputMaybe<PermissionBooleanFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `fileExtension` field. */
  fileExtension?: InputMaybe<StringFilter>;
  /** Filter by the object’s `fileName` field. */
  fileName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<OpportunityAttachmentFilter>;
  /** Filter by the object’s `opportunityId` field. */
  opportunityId?: InputMaybe<IntFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<OpportunityAttachmentFilter>>;
  /** Filter by the object’s `path` field. */
  path?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `OpportunityAttachment` */
export type OpportunityAttachmentInput = {
  /** The extension of the file. */
  fileExtension: Scalars['String']['input'];
  /** The name of the file. */
  fileName: Scalars['String']['input'];
  /** Mutates a `Opportunity` as part of the payload */
  opportunity?: InputMaybe<OpportunityInput>;
  /** The opportunity associated with this attachment. */
  opportunityId?: InputMaybe<Scalars['Int']['input']>;
  /** The path to the file. */
  path?: InputMaybe<Scalars['Upload']['input']>;
};

/** Represents an update to a `OpportunityAttachment`. Fields that are set will be updated. */
export type OpportunityAttachmentPatch = {
  /** The opportunity associated with this attachment. */
  opportunityId?: InputMaybe<Scalars['Int']['input']>;
  /** The path to the file. */
  path?: InputMaybe<Scalars['Upload']['input']>;
};

/** Permissive capabilities on a OpportunityAttachment. */
export type OpportunityAttachmentPermissions = {
  __typename?: 'OpportunityAttachmentPermissions';
  /** Whether the current user can create an attachment for the opportunity */
  canWrite: Scalars['Boolean']['output'];
};

/** A connection to a list of `OpportunityAttachment` values. */
export type OpportunityAttachmentsConnection = {
  __typename?: 'OpportunityAttachmentsConnection';
  /** A list of edges which contains the `OpportunityAttachment` and cursor to aid in pagination. */
  edges: Array<OpportunityAttachmentsEdge>;
  /** A list of `OpportunityAttachment` objects. */
  nodes: Array<OpportunityAttachment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `OpportunityAttachment` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `OpportunityAttachment` edge in the connection. */
export type OpportunityAttachmentsEdge = {
  __typename?: 'OpportunityAttachmentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `OpportunityAttachment` at the end of the edge. */
  node: OpportunityAttachment;
};

/** Methods to use when ordering `OpportunityAttachment`. */
export enum OpportunityAttachmentsOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  FILE_EXTENSION_ASC = 'FILE_EXTENSION_ASC',
  FILE_EXTENSION_DESC = 'FILE_EXTENSION_DESC',
  FILE_NAME_ASC = 'FILE_NAME_ASC',
  FILE_NAME_DESC = 'FILE_NAME_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  OPPORTUNITY_ID_ASC = 'OPPORTUNITY_ID_ASC',
  OPPORTUNITY_ID_DESC = 'OPPORTUNITY_ID_DESC',
  PATH_ASC = 'PATH_ASC',
  PATH_DESC = 'PATH_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/**
 * A condition to be used against `Opportunity` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type OpportunityCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `expectedOutcome` field. */
  expectedOutcome?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `expectedSavingsDemand` field. */
  expectedSavingsDemand?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `expectedSavingsEnergy` field. */
  expectedSavingsEnergy?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `expectedSavingsMonetary` field. */
  expectedSavingsMonetary?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `procedure` field. */
  procedure?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `state` field. */
  state?: InputMaybe<OpportunityState>;
  /** Checks for equality with the object’s `tags` field. */
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Checks for equality with the object’s `title` field. */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `Opportunity` object types. All fields are combined with a logical ‘and.’ */
export type OpportunityFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<OpportunityFilter>>;
  /** Filter by the permission can_write */
  canWrite?: InputMaybe<PermissionBooleanFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `expectedOutcome` field. */
  expectedOutcome?: InputMaybe<StringFilter>;
  /** Filter by the object’s `expectedSavingsDemand` field. */
  expectedSavingsDemand?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `expectedSavingsEnergy` field. */
  expectedSavingsEnergy?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `expectedSavingsMonetary` field. */
  expectedSavingsMonetary?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<OpportunityFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<OpportunityFilter>>;
  /** Filter by the object’s `procedure` field. */
  procedure?: InputMaybe<StringFilter>;
  /** Filter by the object’s `state` field. */
  state?: InputMaybe<OpportunityStateFilter>;
  /** Filter by the object’s `tags` field. */
  tags?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `title` field. */
  title?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `Opportunity` */
export type OpportunityInput = {
  attachmentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** The description of the opportunity. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The expected outcome of the opportunity. */
  expectedOutcome?: InputMaybe<Scalars['String']['input']>;
  /** The expected demand savings of the opportunity. */
  expectedSavingsDemand?: InputMaybe<Scalars['BigFloat']['input']>;
  /** The expected energy savings of the opportunity. */
  expectedSavingsEnergy?: InputMaybe<Scalars['BigFloat']['input']>;
  /** The expected monetary savings of the opportunity. */
  expectedSavingsMonetary?: InputMaybe<Scalars['BigFloat']['input']>;
  /** The facility associated with this opportunity. */
  facilityId: Scalars['Int']['input'];
  /** The procedure to implement the opportunity. */
  procedure?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<OpportunityState>;
  /** Tags associated with the opportunity. */
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** The title of the opportunity. */
  title: Scalars['String']['input'];
};

/** Represents an update to a `Opportunity`. Fields that are set will be updated. */
export type OpportunityPatch = {
  /** The description of the opportunity. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The expected outcome of the opportunity. */
  expectedOutcome?: InputMaybe<Scalars['String']['input']>;
  /** The expected demand savings of the opportunity. */
  expectedSavingsDemand?: InputMaybe<Scalars['BigFloat']['input']>;
  /** The expected energy savings of the opportunity. */
  expectedSavingsEnergy?: InputMaybe<Scalars['BigFloat']['input']>;
  /** The expected monetary savings of the opportunity. */
  expectedSavingsMonetary?: InputMaybe<Scalars['BigFloat']['input']>;
  /** The facility associated with this opportunity. */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  newAttachmentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** The procedure to implement the opportunity. */
  procedure?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<OpportunityState>;
  /** Tags associated with the opportunity. */
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** The title of the opportunity. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Permissive capabilities on a Opportunity. */
export type OpportunityPermissions = {
  __typename?: 'OpportunityPermissions';
  /** Whether the current user can create an opportunity */
  canWrite: Scalars['Boolean']['output'];
};

export enum OpportunityState {
  ACCEPTED = 'ACCEPTED',
  DRAFT = 'DRAFT',
  IMPLEMENTED = 'IMPLEMENTED',
  IN_REVIEW = 'IN_REVIEW',
  REJECTED = 'REJECTED'
}

/** A filter to be used against OpportunityState fields. All fields are combined with a logical ‘and.’ */
export type OpportunityStateFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<OpportunityState>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<OpportunityState>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<OpportunityState>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<OpportunityState>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<OpportunityState>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<OpportunityState>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<OpportunityState>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<OpportunityState>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<OpportunityState>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<OpportunityState>>;
};

export type OpportunitySumAggregates = {
  __typename?: 'OpportunitySumAggregates';
  /** Sum of expectedSavingsDemand across the matching connection */
  expectedSavingsDemand: Scalars['BigFloat']['output'];
  /** Sum of expectedSavingsEnergy across the matching connection */
  expectedSavingsEnergy: Scalars['BigFloat']['output'];
  /** Sum of expectedSavingsMonetary across the matching connection */
  expectedSavingsMonetary: Scalars['BigFloat']['output'];
};

/** A `String` edge in the connection. */
export type OpportunityTagEdge = {
  __typename?: 'OpportunityTagEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `String` at the end of the edge. */
  node?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of `String` values. */
export type OpportunityTagsConnection = {
  __typename?: 'OpportunityTagsConnection';
  /** A list of edges which contains the `String` and cursor to aid in pagination. */
  edges: Array<OpportunityTagEdge>;
  /** A list of `String` objects. */
  nodes: Array<Maybe<Scalars['String']['output']>>;
  /** The count of *all* `String` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A transition of an opportunity to a new state. */
export type OpportunityTransition = Node & {
  __typename?: 'OpportunityTransition';
  /** The time the opportunity transition was created. */
  createdAt: Scalars['Datetime']['output'];
  /** The identifier of the opportunity transition. */
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Opportunity` that is related to this `OpportunityTransition`. */
  opportunity?: Maybe<Opportunity>;
  /** The opportunity associated with this transition. */
  opportunityId: Scalars['Int']['output'];
  /** The new state of the opportunity. */
  state: OpportunityState;
};

/**
 * A condition to be used against `OpportunityTransition` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type OpportunityTransitionCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `opportunityId` field. */
  opportunityId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `state` field. */
  state?: InputMaybe<OpportunityState>;
};

/** A filter to be used against `OpportunityTransition` object types. All fields are combined with a logical ‘and.’ */
export type OpportunityTransitionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<OpportunityTransitionFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<OpportunityTransitionFilter>;
  /** Filter by the object’s `opportunityId` field. */
  opportunityId?: InputMaybe<IntFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<OpportunityTransitionFilter>>;
  /** Filter by the object’s `state` field. */
  state?: InputMaybe<OpportunityStateFilter>;
};

/** A connection to a list of `OpportunityTransition` values. */
export type OpportunityTransitionsConnection = {
  __typename?: 'OpportunityTransitionsConnection';
  /** A list of edges which contains the `OpportunityTransition` and cursor to aid in pagination. */
  edges: Array<OpportunityTransitionsEdge>;
  /** A list of `OpportunityTransition` objects. */
  nodes: Array<OpportunityTransition>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `OpportunityTransition` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `OpportunityTransition` edge in the connection. */
export type OpportunityTransitionsEdge = {
  __typename?: 'OpportunityTransitionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `OpportunityTransition` at the end of the edge. */
  node: OpportunityTransition;
};

/** Methods to use when ordering `OpportunityTransition`. */
export enum OpportunityTransitionsOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  OPPORTUNITY_ID_ASC = 'OPPORTUNITY_ID_ASC',
  OPPORTUNITY_ID_DESC = 'OPPORTUNITY_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  STATE_ASC = 'STATE_ASC',
  STATE_DESC = 'STATE_DESC'
}

export enum OrderType {
  LOAD = 'LOAD',
  UNLOAD = 'UNLOAD'
}

/** A filter to be used against OrderType fields. All fields are combined with a logical ‘and.’ */
export type OrderTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<OrderType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<OrderType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<OrderType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<OrderType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<OrderType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<OrderType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<OrderType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<OrderType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<OrderType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<OrderType>>;
};

export type Organization = {
  __typename?: 'Organization';
  permissions: OrganizationPermissions;
  slug: Scalars['String']['output'];
  unitGroupItem: UnitGroup;
};

export type OrganizationPermissions = {
  __typename?: 'OrganizationPermissions';
  canAdmin: Scalars['Boolean']['output'];
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['Cursor']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['Cursor']['output']>;
};

export type Pallet = Node & {
  __typename?: 'Pallet';
  /** An alternate pallet code that could be sourced from other codes */
  alternatePalletCode?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `BlastPallet`. */
  blastPallets: BlastPalletsConnection;
  /** Reads and enables pagination through a set of `BlastRotationPallet`. */
  blastRotationPallets: BlastRotationPalletsConnection;
  /** The time at which the record was created */
  createdAt: Scalars['Datetime']['output'];
  /** The current number of product cases on a pallet */
  currentProductQuantity?: Maybe<Scalars['Int']['output']>;
  /** The globally unique external deletion identifier of the record. Sometimes this is different from sourceId due to change tracking semantics */
  deleteId?: Maybe<Scalars['String']['output']>;
  /** The time at which the record was deleted */
  deletedAt?: Maybe<Scalars['Datetime']['output']>;
  /** The date the pallet was emptied or left the warehouse */
  depletedDate?: Maybe<Scalars['Datetime']['output']>;
  /** The originating facility of the pallet record */
  facilityId?: Maybe<Scalars['Int']['output']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['BigInt']['output'];
  /** The inventory status of a pallet -- expected, in the warehouse, etc. */
  inventoryStatus?: Maybe<Scalars['String']['output']>;
  /** Boolean value indicated if the pallet is empty or left the facility */
  isDepleted?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<PalletLocation>;
  /** Metadata information for a pallet */
  metadata: Scalars['JSON']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The original number of product cases (or other UOM) that were on a pallet when brought into the facility */
  originalProductQuantity?: Maybe<Scalars['Int']['output']>;
  /** The primary pallet code (not globally unique) of the pallet. Also known as the pallet license plate number */
  palletCode?: Maybe<Scalars['String']['output']>;
  /** The number of pallets a record corresponds to. In some cases, a single pallet record is used for multiple pallets */
  palletCount?: Maybe<Scalars['Int']['output']>;
  /** The location of a pallet within the facility */
  palletLocationSourceId?: Maybe<Scalars['String']['output']>;
  /** The date the pallet was received by the warehouse */
  palletReceivedDate?: Maybe<Scalars['Datetime']['output']>;
  product?: Maybe<Product>;
  /** The product a pallet has on it */
  productSourceId?: Maybe<Scalars['String']['output']>;
  /** The globally unique external identifier of the record from the original source system */
  sourceId: Scalars['String']['output'];
  /** The time at which the record was updated */
  updatedAt: Scalars['Datetime']['output'];
  /** The version of the record */
  version?: Maybe<Scalars['BigInt']['output']>;
};

export type PalletBlastPalletsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BlastPalletCondition>;
  filter?: InputMaybe<BlastPalletFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BlastPalletsOrderBy>>;
};

export type PalletBlastRotationPalletsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BlastRotationPalletCondition>;
  filter?: InputMaybe<BlastRotationPalletFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BlastRotationPalletsOrderBy>>;
};

/** A condition to be used against `Pallet` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type PalletCondition = {
  /** Checks for equality with the object’s `alternatePalletCode` field. */
  alternatePalletCode?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `currentProductQuantity` field. */
  currentProductQuantity?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `deleteId` field. */
  deleteId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `depletedDate` field. */
  depletedDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `inventoryStatus` field. */
  inventoryStatus?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `isDepleted` field. */
  isDepleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `metadata` field. */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `originalProductQuantity` field. */
  originalProductQuantity?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `palletCode` field. */
  palletCode?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `palletCount` field. */
  palletCount?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `palletLocationSourceId` field. */
  palletLocationSourceId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `palletReceivedDate` field. */
  palletReceivedDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `productSourceId` field. */
  productSourceId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `sourceId` field. */
  sourceId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `version` field. */
  version?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A filter to be used against `Pallet` object types. All fields are combined with a logical ‘and.’ */
export type PalletFilter = {
  /** Filter by the object’s `alternatePalletCode` field. */
  alternatePalletCode?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PalletFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `currentProductQuantity` field. */
  currentProductQuantity?: InputMaybe<IntFilter>;
  /** Filter by the object’s `deleteId` field. */
  deleteId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `depletedDate` field. */
  depletedDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `inventoryStatus` field. */
  inventoryStatus?: InputMaybe<StringFilter>;
  /** Filter by the object’s `isDepleted` field. */
  isDepleted?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `metadata` field. */
  metadata?: InputMaybe<JsonFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PalletFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PalletFilter>>;
  /** Filter by the object’s `originalProductQuantity` field. */
  originalProductQuantity?: InputMaybe<IntFilter>;
  /** Filter by the object’s `palletCode` field. */
  palletCode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `palletCount` field. */
  palletCount?: InputMaybe<IntFilter>;
  /** Filter by the object’s `palletLocationSourceId` field. */
  palletLocationSourceId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `palletReceivedDate` field. */
  palletReceivedDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `productSourceId` field. */
  productSourceId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `sourceId` field. */
  sourceId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `version` field. */
  version?: InputMaybe<BigIntFilter>;
};

/** A connection to a list of `PalletHistory` values. */
export type PalletHistoriesConnection = {
  __typename?: 'PalletHistoriesConnection';
  /** A list of edges which contains the `PalletHistory` and cursor to aid in pagination. */
  edges: Array<PalletHistoriesEdge>;
  /** A list of `PalletHistory` objects. */
  nodes: Array<PalletHistory>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PalletHistory` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `PalletHistory` edge in the connection. */
export type PalletHistoriesEdge = {
  __typename?: 'PalletHistoriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `PalletHistory` at the end of the edge. */
  node: PalletHistory;
};

/** Methods to use when ordering `PalletHistory`. */
export enum PalletHistoriesOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DELETED_AT_ASC = 'DELETED_AT_ASC',
  DELETED_AT_DESC = 'DELETED_AT_DESC',
  DELETE_ID_ASC = 'DELETE_ID_ASC',
  DELETE_ID_DESC = 'DELETE_ID_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  FROM_PALLET_LOCATION_CODE_ASC = 'FROM_PALLET_LOCATION_CODE_ASC',
  FROM_PALLET_LOCATION_CODE_DESC = 'FROM_PALLET_LOCATION_CODE_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  PALLET_CODE_ASC = 'PALLET_CODE_ASC',
  PALLET_CODE_DESC = 'PALLET_CODE_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  QUANTITY_ASC = 'QUANTITY_ASC',
  QUANTITY_DESC = 'QUANTITY_DESC',
  SOURCE_ID_ASC = 'SOURCE_ID_ASC',
  SOURCE_ID_DESC = 'SOURCE_ID_DESC',
  TO_PALLET_LOCATION_CODE_ASC = 'TO_PALLET_LOCATION_CODE_ASC',
  TO_PALLET_LOCATION_CODE_DESC = 'TO_PALLET_LOCATION_CODE_DESC',
  TRANSACTION_DATE_ASC = 'TRANSACTION_DATE_ASC',
  TRANSACTION_DATE_DESC = 'TRANSACTION_DATE_DESC',
  TRANSACTION_TYPE_ASC = 'TRANSACTION_TYPE_ASC',
  TRANSACTION_TYPE_DESC = 'TRANSACTION_TYPE_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  VERSION_ASC = 'VERSION_ASC',
  VERSION_DESC = 'VERSION_DESC'
}

export type PalletHistory = Node & {
  __typename?: 'PalletHistory';
  /** The time at which the record was created */
  createdAt: Scalars['Datetime']['output'];
  /** The globally unique external deletion identifier of the record. Sometimes this is different from sourceId due to change tracking semantics */
  deleteId?: Maybe<Scalars['String']['output']>;
  /** The time at which the record was deleted */
  deletedAt?: Maybe<Scalars['Datetime']['output']>;
  /** The originating facility of the history record */
  facilityId?: Maybe<Scalars['Int']['output']>;
  /** If moving locations, this is the location it is being moved from */
  fromPalletLocationCode?: Maybe<Scalars['String']['output']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['BigInt']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The unique local (facility-level) identifier of the pallet. Note this is not the pallet_source_id */
  palletCode?: Maybe<Scalars['String']['output']>;
  /** The quantity of the product UOM this transaction applies to */
  quantity?: Maybe<Scalars['Int']['output']>;
  /** The globally unique external identifier of the record from the original source system */
  sourceId: Scalars['String']['output'];
  /** If moving locations, this is the location it is being moved to */
  toPalletLocationCode?: Maybe<Scalars['String']['output']>;
  /** The timestamp of the pallet event */
  transactionDate?: Maybe<Scalars['Datetime']['output']>;
  /** The type of pallet event / transaction for this record */
  transactionType?: Maybe<Scalars['String']['output']>;
  /** The time at which the record was updated */
  updatedAt: Scalars['Datetime']['output'];
  /** The version of the record */
  version?: Maybe<Scalars['BigInt']['output']>;
};

/**
 * A condition to be used against `PalletHistory` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PalletHistoryCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `deleteId` field. */
  deleteId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `fromPalletLocationCode` field. */
  fromPalletLocationCode?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `palletCode` field. */
  palletCode?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `quantity` field. */
  quantity?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `sourceId` field. */
  sourceId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `toPalletLocationCode` field. */
  toPalletLocationCode?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `transactionDate` field. */
  transactionDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `transactionType` field. */
  transactionType?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `version` field. */
  version?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A filter to be used against `PalletHistory` object types. All fields are combined with a logical ‘and.’ */
export type PalletHistoryFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PalletHistoryFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deleteId` field. */
  deleteId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `fromPalletLocationCode` field. */
  fromPalletLocationCode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PalletHistoryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PalletHistoryFilter>>;
  /** Filter by the object’s `palletCode` field. */
  palletCode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `quantity` field. */
  quantity?: InputMaybe<IntFilter>;
  /** Filter by the object’s `sourceId` field. */
  sourceId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `toPalletLocationCode` field. */
  toPalletLocationCode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `transactionDate` field. */
  transactionDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `transactionType` field. */
  transactionType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `version` field. */
  version?: InputMaybe<BigIntFilter>;
};

/** An input for mutations affecting `PalletHistory` */
export type PalletHistoryInput = {
  /** The originating facility of the history record */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** If moving locations, this is the location it is being moved from */
  fromPalletLocationCode?: InputMaybe<Scalars['String']['input']>;
  /** The unique local (facility-level) identifier of the pallet. Note this is not the pallet_source_id */
  palletCode?: InputMaybe<Scalars['String']['input']>;
  /** The quantity of the product UOM this transaction applies to */
  quantity?: InputMaybe<Scalars['Int']['input']>;
  /** The globally unique external identifier of the record from the original source system */
  sourceId: Scalars['String']['input'];
  /** If moving locations, this is the location it is being moved to */
  toPalletLocationCode?: InputMaybe<Scalars['String']['input']>;
  /** The timestamp of the pallet event */
  transactionDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** The type of pallet event / transaction for this record */
  transactionType?: InputMaybe<Scalars['String']['input']>;
};

/** Represents an update to a `PalletHistory`. Fields that are set will be updated. */
export type PalletHistoryPatch = {
  /** The originating facility of the history record */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** If moving locations, this is the location it is being moved from */
  fromPalletLocationCode?: InputMaybe<Scalars['String']['input']>;
  /** The unique local (facility-level) identifier of the pallet. Note this is not the pallet_source_id */
  palletCode?: InputMaybe<Scalars['String']['input']>;
  /** The quantity of the product UOM this transaction applies to */
  quantity?: InputMaybe<Scalars['Int']['input']>;
  /** The globally unique external identifier of the record from the original source system */
  sourceId?: InputMaybe<Scalars['String']['input']>;
  /** If moving locations, this is the location it is being moved to */
  toPalletLocationCode?: InputMaybe<Scalars['String']['input']>;
  /** The timestamp of the pallet event */
  transactionDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** The type of pallet event / transaction for this record */
  transactionType?: InputMaybe<Scalars['String']['input']>;
};

/** An input for mutations affecting `Pallet` */
export type PalletInput = {
  /** An alternate pallet code that could be sourced from other codes */
  alternatePalletCode?: InputMaybe<Scalars['String']['input']>;
  /** The current number of product cases on a pallet */
  currentProductQuantity?: InputMaybe<Scalars['Int']['input']>;
  /** The date the pallet was emptied or left the warehouse */
  depletedDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** The originating facility of the pallet record */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** The inventory status of a pallet -- expected, in the warehouse, etc. */
  inventoryStatus?: InputMaybe<Scalars['String']['input']>;
  /** Boolean value indicated if the pallet is empty or left the facility */
  isDepleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Metadata information for a pallet */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** The original number of product cases (or other UOM) that were on a pallet when brought into the facility */
  originalProductQuantity?: InputMaybe<Scalars['Int']['input']>;
  /** The primary pallet code (not globally unique) of the pallet. Also known as the pallet license plate number */
  palletCode?: InputMaybe<Scalars['String']['input']>;
  /** The number of pallets a record corresponds to. In some cases, a single pallet record is used for multiple pallets */
  palletCount?: InputMaybe<Scalars['Int']['input']>;
  /** The location of a pallet within the facility */
  palletLocationSourceId?: InputMaybe<Scalars['String']['input']>;
  /** The date the pallet was received by the warehouse */
  palletReceivedDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** The product a pallet has on it */
  productSourceId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique external identifier of the record from the original source system */
  sourceId: Scalars['String']['input'];
};

export type PalletLocation = Node & {
  __typename?: 'PalletLocation';
  /** The aisle the location is located on */
  aisle?: Maybe<Scalars['String']['output']>;
  /** The bay the location is located within */
  bay?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `BlastPalletLocation`. */
  blastPalletLocations: BlastPalletLocationsConnection;
  /** Reads a single `BuildingArea` that is related to this `PalletLocation`. */
  buildingArea?: Maybe<BuildingArea>;
  /** The associated building area */
  buildingAreaId?: Maybe<Scalars['Int']['output']>;
  /** The time at which the record was created */
  createdAt: Scalars['Datetime']['output'];
  /** The globally unique external deletion identifier of the record. Sometimes this is different from sourceId due to change tracking semantics */
  deleteId?: Maybe<Scalars['String']['output']>;
  /** The time at which the record was deleted */
  deletedAt?: Maybe<Scalars['Datetime']['output']>;
  /** Reads a single `Facility` that is related to this `PalletLocation`. */
  facility?: Maybe<Facility>;
  /** The facility of the location record */
  facilityId?: Maybe<Scalars['Int']['output']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['BigInt']['output'];
  /** The maximum number of pallets that can be stored at this location */
  maxPallets?: Maybe<Scalars['Int']['output']>;
  /** The name / descriptor of the location */
  name?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The type of the room the location is within */
  roomType?: Maybe<Scalars['String']['output']>;
  /** The globally unique external identifier of the record from the original source system */
  sourceId: Scalars['String']['output'];
  /** The time at which the record was updated */
  updatedAt: Scalars['Datetime']['output'];
  /** The version of the record */
  version?: Maybe<Scalars['BigInt']['output']>;
};

export type PalletLocationBlastPalletLocationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BlastPalletLocationCondition>;
  filter?: InputMaybe<BlastPalletLocationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BlastPalletLocationsOrderBy>>;
};

/**
 * A condition to be used against `PalletLocation` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PalletLocationCondition = {
  /** Checks for equality with the object’s `aisle` field. */
  aisle?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `bay` field. */
  bay?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `buildingAreaId` field. */
  buildingAreaId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `deleteId` field. */
  deleteId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `maxPallets` field. */
  maxPallets?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `roomType` field. */
  roomType?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `sourceId` field. */
  sourceId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `version` field. */
  version?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A filter to be used against `PalletLocation` object types. All fields are combined with a logical ‘and.’ */
export type PalletLocationFilter = {
  /** Filter by the object’s `aisle` field. */
  aisle?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PalletLocationFilter>>;
  /** Filter by the object’s `bay` field. */
  bay?: InputMaybe<StringFilter>;
  /** Filter by the object’s `buildingAreaId` field. */
  buildingAreaId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deleteId` field. */
  deleteId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `maxPallets` field. */
  maxPallets?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PalletLocationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PalletLocationFilter>>;
  /** Filter by the object’s `roomType` field. */
  roomType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `sourceId` field. */
  sourceId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `version` field. */
  version?: InputMaybe<BigIntFilter>;
};

/** An input for mutations affecting `PalletLocation` */
export type PalletLocationInput = {
  /** The aisle the location is located on */
  aisle?: InputMaybe<Scalars['String']['input']>;
  /** The bay the location is located within */
  bay?: InputMaybe<Scalars['String']['input']>;
  /** Mutates a `BuildingArea` as part of the payload */
  buildingArea?: InputMaybe<BuildingAreaInput>;
  /** The associated building area */
  buildingAreaId?: InputMaybe<Scalars['Int']['input']>;
  /** The facility of the location record */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** The maximum number of pallets that can be stored at this location */
  maxPallets?: InputMaybe<Scalars['Int']['input']>;
  /** The name / descriptor of the location */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The type of the room the location is within */
  roomType?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique external identifier of the record from the original source system */
  sourceId: Scalars['String']['input'];
};

/** Represents an update to a `PalletLocation`. Fields that are set will be updated. */
export type PalletLocationPatch = {
  /** The aisle the location is located on */
  aisle?: InputMaybe<Scalars['String']['input']>;
  /** The bay the location is located within */
  bay?: InputMaybe<Scalars['String']['input']>;
  /** The associated building area */
  buildingAreaId?: InputMaybe<Scalars['Int']['input']>;
  /** The facility of the location record */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** The maximum number of pallets that can be stored at this location */
  maxPallets?: InputMaybe<Scalars['Int']['input']>;
  /** The name / descriptor of the location */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The type of the room the location is within */
  roomType?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique external identifier of the record from the original source system */
  sourceId?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `PalletLocation` values. */
export type PalletLocationsConnection = {
  __typename?: 'PalletLocationsConnection';
  /** A list of edges which contains the `PalletLocation` and cursor to aid in pagination. */
  edges: Array<PalletLocationsEdge>;
  /** A list of `PalletLocation` objects. */
  nodes: Array<PalletLocation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PalletLocation` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `PalletLocation` edge in the connection. */
export type PalletLocationsEdge = {
  __typename?: 'PalletLocationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `PalletLocation` at the end of the edge. */
  node: PalletLocation;
};

/** Methods to use when ordering `PalletLocation`. */
export enum PalletLocationsOrderBy {
  AISLE_ASC = 'AISLE_ASC',
  AISLE_DESC = 'AISLE_DESC',
  BAY_ASC = 'BAY_ASC',
  BAY_DESC = 'BAY_DESC',
  BUILDING_AREA_ID_ASC = 'BUILDING_AREA_ID_ASC',
  BUILDING_AREA_ID_DESC = 'BUILDING_AREA_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DELETED_AT_ASC = 'DELETED_AT_ASC',
  DELETED_AT_DESC = 'DELETED_AT_DESC',
  DELETE_ID_ASC = 'DELETE_ID_ASC',
  DELETE_ID_DESC = 'DELETE_ID_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  MAX_PALLETS_ASC = 'MAX_PALLETS_ASC',
  MAX_PALLETS_DESC = 'MAX_PALLETS_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOM_TYPE_ASC = 'ROOM_TYPE_ASC',
  ROOM_TYPE_DESC = 'ROOM_TYPE_DESC',
  SOURCE_ID_ASC = 'SOURCE_ID_ASC',
  SOURCE_ID_DESC = 'SOURCE_ID_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  VERSION_ASC = 'VERSION_ASC',
  VERSION_DESC = 'VERSION_DESC'
}

/** Represents an update to a `Pallet`. Fields that are set will be updated. */
export type PalletPatch = {
  /** An alternate pallet code that could be sourced from other codes */
  alternatePalletCode?: InputMaybe<Scalars['String']['input']>;
  /** The current number of product cases on a pallet */
  currentProductQuantity?: InputMaybe<Scalars['Int']['input']>;
  /** The date the pallet was emptied or left the warehouse */
  depletedDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** The originating facility of the pallet record */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** The inventory status of a pallet -- expected, in the warehouse, etc. */
  inventoryStatus?: InputMaybe<Scalars['String']['input']>;
  /** Boolean value indicated if the pallet is empty or left the facility */
  isDepleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Metadata information for a pallet */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** The original number of product cases (or other UOM) that were on a pallet when brought into the facility */
  originalProductQuantity?: InputMaybe<Scalars['Int']['input']>;
  /** The primary pallet code (not globally unique) of the pallet. Also known as the pallet license plate number */
  palletCode?: InputMaybe<Scalars['String']['input']>;
  /** The number of pallets a record corresponds to. In some cases, a single pallet record is used for multiple pallets */
  palletCount?: InputMaybe<Scalars['Int']['input']>;
  /** The location of a pallet within the facility */
  palletLocationSourceId?: InputMaybe<Scalars['String']['input']>;
  /** The date the pallet was received by the warehouse */
  palletReceivedDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** The product a pallet has on it */
  productSourceId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique external identifier of the record from the original source system */
  sourceId?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `Pallet` values. */
export type PalletsConnection = {
  __typename?: 'PalletsConnection';
  /** A list of edges which contains the `Pallet` and cursor to aid in pagination. */
  edges: Array<PalletsEdge>;
  /** A list of `Pallet` objects. */
  nodes: Array<Pallet>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Pallet` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Pallet` edge in the connection. */
export type PalletsEdge = {
  __typename?: 'PalletsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Pallet` at the end of the edge. */
  node: Pallet;
};

/** Methods to use when ordering `Pallet`. */
export enum PalletsOrderBy {
  ALTERNATE_PALLET_CODE_ASC = 'ALTERNATE_PALLET_CODE_ASC',
  ALTERNATE_PALLET_CODE_DESC = 'ALTERNATE_PALLET_CODE_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  CURRENT_PRODUCT_QUANTITY_ASC = 'CURRENT_PRODUCT_QUANTITY_ASC',
  CURRENT_PRODUCT_QUANTITY_DESC = 'CURRENT_PRODUCT_QUANTITY_DESC',
  DELETED_AT_ASC = 'DELETED_AT_ASC',
  DELETED_AT_DESC = 'DELETED_AT_DESC',
  DELETE_ID_ASC = 'DELETE_ID_ASC',
  DELETE_ID_DESC = 'DELETE_ID_DESC',
  DEPLETED_DATE_ASC = 'DEPLETED_DATE_ASC',
  DEPLETED_DATE_DESC = 'DEPLETED_DATE_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  INVENTORY_STATUS_ASC = 'INVENTORY_STATUS_ASC',
  INVENTORY_STATUS_DESC = 'INVENTORY_STATUS_DESC',
  IS_DEPLETED_ASC = 'IS_DEPLETED_ASC',
  IS_DEPLETED_DESC = 'IS_DEPLETED_DESC',
  METADATA_ASC = 'METADATA_ASC',
  METADATA_DESC = 'METADATA_DESC',
  NATURAL = 'NATURAL',
  ORIGINAL_PRODUCT_QUANTITY_ASC = 'ORIGINAL_PRODUCT_QUANTITY_ASC',
  ORIGINAL_PRODUCT_QUANTITY_DESC = 'ORIGINAL_PRODUCT_QUANTITY_DESC',
  PALLET_CODE_ASC = 'PALLET_CODE_ASC',
  PALLET_CODE_DESC = 'PALLET_CODE_DESC',
  PALLET_COUNT_ASC = 'PALLET_COUNT_ASC',
  PALLET_COUNT_DESC = 'PALLET_COUNT_DESC',
  PALLET_LOCATION_SOURCE_ID_ASC = 'PALLET_LOCATION_SOURCE_ID_ASC',
  PALLET_LOCATION_SOURCE_ID_DESC = 'PALLET_LOCATION_SOURCE_ID_DESC',
  PALLET_RECEIVED_DATE_ASC = 'PALLET_RECEIVED_DATE_ASC',
  PALLET_RECEIVED_DATE_DESC = 'PALLET_RECEIVED_DATE_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  PRODUCT_SOURCE_ID_ASC = 'PRODUCT_SOURCE_ID_ASC',
  PRODUCT_SOURCE_ID_DESC = 'PRODUCT_SOURCE_ID_DESC',
  SOURCE_ID_ASC = 'SOURCE_ID_ASC',
  SOURCE_ID_DESC = 'SOURCE_ID_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  VERSION_ASC = 'VERSION_ASC',
  VERSION_DESC = 'VERSION_DESC'
}

/** The log of trailer parking sessions at a given yard space */
export type ParkSession = Node & {
  __typename?: 'ParkSession';
  /** The time when this record was created */
  createdAt: Scalars['Datetime']['output'];
  /** The time when the parking session ended. If not set, the session is still active */
  endTime?: Maybe<Scalars['Datetime']['output']>;
  /** The internal ID of this parking session */
  id: Scalars['BigInt']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Space` that is related to this `ParkSession`. */
  space?: Maybe<Space>;
  /** The yard space where the trailer is parked */
  spaceId: Scalars['Int']['output'];
  /** The time when the parking session started */
  startTime: Scalars['Datetime']['output'];
  /** Reads a single `Trailer` that is related to this `ParkSession`. */
  trailer?: Maybe<Trailer>;
  /** The trailer that is parked in this session */
  trailerId: Scalars['Int']['output'];
  /** The time when this record was last updated */
  updatedAt: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `ParkSession` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ParkSessionCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `endTime` field. */
  endTime?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `spaceId` field. */
  spaceId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `startTime` field. */
  startTime?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `trailerId` field. */
  trailerId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `ParkSession` object types. All fields are combined with a logical ‘and.’ */
export type ParkSessionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ParkSessionFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `endTime` field. */
  endTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ParkSessionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ParkSessionFilter>>;
  /** Filter by the object’s `spaceId` field. */
  spaceId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `startTime` field. */
  startTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `trailerId` field. */
  trailerId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** A connection to a list of `ParkSession` values. */
export type ParkSessionsConnection = {
  __typename?: 'ParkSessionsConnection';
  /** A list of edges which contains the `ParkSession` and cursor to aid in pagination. */
  edges: Array<ParkSessionsEdge>;
  /** A list of `ParkSession` objects. */
  nodes: Array<ParkSession>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ParkSession` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ParkSession` edge in the connection. */
export type ParkSessionsEdge = {
  __typename?: 'ParkSessionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ParkSession` at the end of the edge. */
  node: ParkSession;
};

/** Methods to use when ordering `ParkSession`. */
export enum ParkSessionsOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  END_TIME_ASC = 'END_TIME_ASC',
  END_TIME_DESC = 'END_TIME_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  SPACE_ID_ASC = 'SPACE_ID_ASC',
  SPACE_ID_DESC = 'SPACE_ID_DESC',
  START_TIME_ASC = 'START_TIME_ASC',
  START_TIME_DESC = 'START_TIME_DESC',
  TRAILER_ID_ASC = 'TRAILER_ID_ASC',
  TRAILER_ID_DESC = 'TRAILER_ID_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** All input for the `patchControlEventRemoteMetadata` mutation. */
export type PatchControlEventRemoteMetadataInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  controlEventId: Scalars['Int']['input'];
  patchedMetadata: Scalars['JSON']['input'];
};

/** The output of our `patchControlEventRemoteMetadata` mutation. */
export type PatchControlEventRemoteMetadataPayload = {
  __typename?: 'PatchControlEventRemoteMetadataPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Component` that is related to this `ControlEvent`. */
  component?: Maybe<Component>;
  controlEvent?: Maybe<ControlEvent>;
  /** An edge for our `ControlEvent`. May be used by Relay 1. */
  controlEventEdge?: Maybe<ControlEventsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our `patchControlEventRemoteMetadata` mutation. */
export type PatchControlEventRemoteMetadataPayloadControlEventEdgeArgs = {
  orderBy?: InputMaybe<Array<ControlEventsOrderBy>>;
};

/** A filter to be used against boolean permission fields. */
export type PermissionBooleanFilter = {
  equalTo?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Represents an access token for a given type. */
export type PlatformAccessToken = {
  __typename?: 'PlatformAccessToken';
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['Datetime']['output']>;
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Returns the associated machine user if this is a machine user access token. */
  machineUser?: Maybe<MachineUser>;
  ownerId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AccessTokenType>;
  /** Returns the associated user if this is a user access token. */
  user?: Maybe<User>;
};

/**
 * A condition to be used against `PlatformAccessToken` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type PlatformAccessTokenCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `expiresAt` field. */
  expiresAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `ownerId` field. */
  ownerId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<AccessTokenType>;
};

/** A filter to be used against `PlatformAccessToken` object types. All fields are combined with a logical ‘and.’ */
export type PlatformAccessTokenFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PlatformAccessTokenFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `expiresAt` field. */
  expiresAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PlatformAccessTokenFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PlatformAccessTokenFilter>>;
  /** Filter by the object’s `ownerId` field. */
  ownerId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<AccessTokenTypeFilter>;
};

/** A connection to a list of `PlatformAccessToken` values. */
export type PlatformAccessTokensConnection = {
  __typename?: 'PlatformAccessTokensConnection';
  /** A list of edges which contains the `PlatformAccessToken` and cursor to aid in pagination. */
  edges: Array<PlatformAccessTokensEdge>;
  /** A list of `PlatformAccessToken` objects. */
  nodes: Array<PlatformAccessToken>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PlatformAccessToken` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `PlatformAccessToken` edge in the connection. */
export type PlatformAccessTokensEdge = {
  __typename?: 'PlatformAccessTokensEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `PlatformAccessToken` at the end of the edge. */
  node: PlatformAccessToken;
};

/** Methods to use when ordering `PlatformAccessToken`. */
export enum PlatformAccessTokensOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  EXPIRES_AT_ASC = 'EXPIRES_AT_ASC',
  EXPIRES_AT_DESC = 'EXPIRES_AT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  OWNER_ID_ASC = 'OWNER_ID_ASC',
  OWNER_ID_DESC = 'OWNER_ID_DESC',
  TYPE_ASC = 'TYPE_ASC',
  TYPE_DESC = 'TYPE_DESC'
}

export enum PlatformCapability {
  BASE = 'BASE',
  ETRU_CORE = 'ETRU_CORE',
  FLEET = 'FLEET',
  IOT = 'IOT',
  METRIC = 'METRIC',
  REFRIGERATION = 'REFRIGERATION',
  SUGGESTION = 'SUGGESTION',
  UTILITY = 'UTILITY',
  WMS = 'WMS'
}

export type PlatformCapabilityAccess = {
  __typename?: 'PlatformCapabilityAccess';
  canRead: Scalars['Boolean']['output'];
  canWrite: Scalars['Boolean']['output'];
  capability: PlatformCapability;
};

export type PlatformCapabilityAccessDefinition = {
  capability: PlatformCapability;
  enableRead: Scalars['Boolean']['input'];
  enableWrite: Scalars['Boolean']['input'];
};

/** Platform errors that can be received as part of query/mutation responses */
export enum PlatformError {
  /** An error occurred while handling the data request. */
  BAD_DATA_ERROR = 'BAD_DATA_ERROR',
  /** The GraphQL request contains a format error. */
  BAD_REQUEST_ERROR = 'BAD_REQUEST_ERROR',
  /** An entity already exists for the given parameters. */
  DUPLICATE_ENTRY_ERROR = 'DUPLICATE_ENTRY_ERROR',
  /** An fleet messaging error has occured. */
  FLEET_SMS_ERROR = 'FLEET_SMS_ERROR',
  /** The request cannot be completed due to incompatible data. */
  INCOMPATIBLE_DATA_ERROR = 'INCOMPATIBLE_DATA_ERROR',
  /** An internal server error has occurred. */
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  /** One or more input values are invalid. */
  INVALID_INPUT_ERROR = 'INVALID_INPUT_ERROR',
  /** One or more integration configuration parameters were not valid. */
  INVALID_INTEGRATION_CONFIGURATION_PARAMETERS = 'INVALID_INTEGRATION_CONFIGURATION_PARAMETERS',
  /** One or more report parameters were not valid. */
  INVALID_REPORT_PARAMETERS = 'INVALID_REPORT_PARAMETERS',
  /** Entity not found. */
  NOT_FOUND_ERROR = 'NOT_FOUND_ERROR',
  /** Amount of data requested supercedes allowed amount - try again with pagination. */
  REQUEST_LIMIT_ERROR = 'REQUEST_LIMIT_ERROR',
  /** An error occured while validating phone number. */
  SMS_VALIDATION_ERROR = 'SMS_VALIDATION_ERROR',
  /** Error requesting data within allowed time range - try again with a smaller range or subset. */
  TIMEOUT_ERROR = 'TIMEOUT_ERROR',
  /** Unauthorized */
  UNAUTHORIZED_ERROR = 'UNAUTHORIZED_ERROR',
  /** An unknown server error has occurred. */
  UNKNOWN_ERROR = 'UNKNOWN_ERROR'
}

/** A pricing node in a balancing authority. */
export type PricingNode = Node & {
  __typename?: 'PricingNode';
  /** Reads a single `BalancingAuthority` that is related to this `PricingNode`. */
  balancingAuthority?: Maybe<BalancingAuthority>;
  /** The id of the balancing authority the pricing node is associated with. */
  balancingAuthorityId: Scalars['Int']['output'];
  /** The time the pricing node was created. */
  createdAt: Scalars['Datetime']['output'];
  /** The dayahead rate for the associated pricing node. */
  dayaheadRate?: Maybe<MetricDataConnection>;
  /** Returns the derived data point configuration for this connection */
  dayaheadRateDataPoint?: Maybe<DerivedDataPoint>;
  /** Reads and enables pagination through a set of `Facility`. */
  facilities: FacilitiesConnection;
  /** The geometry information of the pricing node. */
  geometry?: Maybe<GeometryInterface>;
  /** The grid demand value for the associated balancing authority. */
  gridDemand?: Maybe<MetricDataConnection>;
  /** Returns the derived data point configuration for this connection */
  gridDemandDataPoint?: Maybe<DerivedDataPoint>;
  /** The identifer of the pricing node. */
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The realtime rate for the associated pricing node. */
  realtimeRate?: Maybe<MetricDataConnection>;
  /** Returns the derived data point configuration for this connection */
  realtimeRateDataPoint?: Maybe<DerivedDataPoint>;
  /** The name of the pricing node. */
  slug: Scalars['String']['output'];
  /** The time the pricing node was updated. */
  updatedAt: Scalars['Datetime']['output'];
};

/** A pricing node in a balancing authority. */
export type PricingNodeDayaheadRateArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A pricing node in a balancing authority. */
export type PricingNodeFacilitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FacilityCondition>;
  filter?: InputMaybe<FacilityFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FacilitiesOrderBy>>;
};

/** A pricing node in a balancing authority. */
export type PricingNodeGridDemandArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A pricing node in a balancing authority. */
export type PricingNodeRealtimeRateArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/**
 * A condition to be used against `PricingNode` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type PricingNodeCondition = {
  /** Checks for equality with the object’s `balancingAuthorityId` field. */
  balancingAuthorityId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `geometry` field. */
  geometry?: InputMaybe<Scalars['GeoJSON']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `slug` field. */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `PricingNode` object types. All fields are combined with a logical ‘and.’ */
export type PricingNodeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PricingNodeFilter>>;
  /** Filter by the object’s `balancingAuthorityId` field. */
  balancingAuthorityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PricingNodeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PricingNodeFilter>>;
  /** Filter by the object’s `slug` field. */
  slug?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `PricingNode` */
export type PricingNodeInput = {
  /** Mutates a `BalancingAuthority` as part of the payload */
  balancingAuthority?: InputMaybe<BalancingAuthorityInput>;
  /** The id of the balancing authority the pricing node is associated with. */
  balancingAuthorityId?: InputMaybe<Scalars['Int']['input']>;
  /** The geometry information of the pricing node. */
  geometry?: InputMaybe<Scalars['GeoJSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** The name of the pricing node. */
  slug: Scalars['String']['input'];
};

/** Represents an update to a `PricingNode`. Fields that are set will be updated. */
export type PricingNodePatch = {
  /** The id of the balancing authority the pricing node is associated with. */
  balancingAuthorityId?: InputMaybe<Scalars['Int']['input']>;
  /** The geometry information of the pricing node. */
  geometry?: InputMaybe<Scalars['GeoJSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** The name of the pricing node. */
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `PricingNode` values. */
export type PricingNodesConnection = {
  __typename?: 'PricingNodesConnection';
  /** The dayahead rate for the associated pricing node. */
  dayaheadRate?: Maybe<MetricDataConnection>;
  /** A list of edges which contains the `PricingNode` and cursor to aid in pagination. */
  edges: Array<PricingNodesEdge>;
  /** The grid demand value for the associated balancing authority. */
  gridDemand?: Maybe<MetricDataConnection>;
  /** A list of `PricingNode` objects. */
  nodes: Array<PricingNode>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The realtime rate for the associated pricing node. */
  realtimeRate?: Maybe<MetricDataConnection>;
  /** The count of *all* `PricingNode` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A connection to a list of `PricingNode` values. */
export type PricingNodesConnectionDayaheadRateArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `PricingNode` values. */
export type PricingNodesConnectionGridDemandArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `PricingNode` values. */
export type PricingNodesConnectionRealtimeRateArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A `PricingNode` edge in the connection. */
export type PricingNodesEdge = {
  __typename?: 'PricingNodesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `PricingNode` at the end of the edge. */
  node: PricingNode;
};

/** Methods to use when ordering `PricingNode`. */
export enum PricingNodesOrderBy {
  BALANCING_AUTHORITY_ID_ASC = 'BALANCING_AUTHORITY_ID_ASC',
  BALANCING_AUTHORITY_ID_DESC = 'BALANCING_AUTHORITY_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  FACILITIES_AVERAGE_ADDRESS_ASC = 'FACILITIES_AVERAGE_ADDRESS_ASC',
  FACILITIES_AVERAGE_ADDRESS_DESC = 'FACILITIES_AVERAGE_ADDRESS_DESC',
  FACILITIES_AVERAGE_BONUS_LTR_ASC = 'FACILITIES_AVERAGE_BONUS_LTR_ASC',
  FACILITIES_AVERAGE_BONUS_LTR_DESC = 'FACILITIES_AVERAGE_BONUS_LTR_DESC',
  FACILITIES_AVERAGE_CITY_ASC = 'FACILITIES_AVERAGE_CITY_ASC',
  FACILITIES_AVERAGE_CITY_DESC = 'FACILITIES_AVERAGE_CITY_DESC',
  FACILITIES_AVERAGE_COMMODITY_ASC = 'FACILITIES_AVERAGE_COMMODITY_ASC',
  FACILITIES_AVERAGE_COMMODITY_DESC = 'FACILITIES_AVERAGE_COMMODITY_DESC',
  FACILITIES_AVERAGE_CONTXT_9249_ASC = 'FACILITIES_AVERAGE_CONTXT_9249_ASC',
  FACILITIES_AVERAGE_CONTXT_9249_DESC = 'FACILITIES_AVERAGE_CONTXT_9249_DESC',
  FACILITIES_AVERAGE_COST_CENTER_ASC = 'FACILITIES_AVERAGE_COST_CENTER_ASC',
  FACILITIES_AVERAGE_COST_CENTER_DESC = 'FACILITIES_AVERAGE_COST_CENTER_DESC',
  FACILITIES_AVERAGE_COUNTRY_ASC = 'FACILITIES_AVERAGE_COUNTRY_ASC',
  FACILITIES_AVERAGE_COUNTRY_DESC = 'FACILITIES_AVERAGE_COUNTRY_DESC',
  FACILITIES_AVERAGE_CREATED_AT_ASC = 'FACILITIES_AVERAGE_CREATED_AT_ASC',
  FACILITIES_AVERAGE_CREATED_AT_DESC = 'FACILITIES_AVERAGE_CREATED_AT_DESC',
  FACILITIES_AVERAGE_CUSTOMER_LOCATION_ID_ASC = 'FACILITIES_AVERAGE_CUSTOMER_LOCATION_ID_ASC',
  FACILITIES_AVERAGE_CUSTOMER_LOCATION_ID_DESC = 'FACILITIES_AVERAGE_CUSTOMER_LOCATION_ID_DESC',
  FACILITIES_AVERAGE_DATATYPE_1_TEST_ASC = 'FACILITIES_AVERAGE_DATATYPE_1_TEST_ASC',
  FACILITIES_AVERAGE_DATATYPE_1_TEST_DESC = 'FACILITIES_AVERAGE_DATATYPE_1_TEST_DESC',
  FACILITIES_AVERAGE_DATA_TYPE_2_TEST_ASC = 'FACILITIES_AVERAGE_DATA_TYPE_2_TEST_ASC',
  FACILITIES_AVERAGE_DATA_TYPE_2_TEST_DESC = 'FACILITIES_AVERAGE_DATA_TYPE_2_TEST_DESC',
  FACILITIES_AVERAGE_DATA_TYPE_3_TEST_ASC = 'FACILITIES_AVERAGE_DATA_TYPE_3_TEST_ASC',
  FACILITIES_AVERAGE_DATA_TYPE_3_TEST_DESC = 'FACILITIES_AVERAGE_DATA_TYPE_3_TEST_DESC',
  FACILITIES_AVERAGE_FACILITY_CONTACTS_ASC = 'FACILITIES_AVERAGE_FACILITY_CONTACTS_ASC',
  FACILITIES_AVERAGE_FACILITY_CONTACTS_DESC = 'FACILITIES_AVERAGE_FACILITY_CONTACTS_DESC',
  FACILITIES_AVERAGE_FLOOR_PLAN_GEOMETRY_ASC = 'FACILITIES_AVERAGE_FLOOR_PLAN_GEOMETRY_ASC',
  FACILITIES_AVERAGE_FLOOR_PLAN_GEOMETRY_DESC = 'FACILITIES_AVERAGE_FLOOR_PLAN_GEOMETRY_DESC',
  FACILITIES_AVERAGE_GEOMETRY_ASC = 'FACILITIES_AVERAGE_GEOMETRY_ASC',
  FACILITIES_AVERAGE_GEOMETRY_DESC = 'FACILITIES_AVERAGE_GEOMETRY_DESC',
  FACILITIES_AVERAGE_GO_LIVE_DATE_ASC = 'FACILITIES_AVERAGE_GO_LIVE_DATE_ASC',
  FACILITIES_AVERAGE_GO_LIVE_DATE_DESC = 'FACILITIES_AVERAGE_GO_LIVE_DATE_DESC',
  FACILITIES_AVERAGE_ID_ASC = 'FACILITIES_AVERAGE_ID_ASC',
  FACILITIES_AVERAGE_ID_DESC = 'FACILITIES_AVERAGE_ID_DESC',
  FACILITIES_AVERAGE_LATITUDE_ASC = 'FACILITIES_AVERAGE_LATITUDE_ASC',
  FACILITIES_AVERAGE_LATITUDE_DESC = 'FACILITIES_AVERAGE_LATITUDE_DESC',
  FACILITIES_AVERAGE_LINK_ACTIVE_ASC = 'FACILITIES_AVERAGE_LINK_ACTIVE_ASC',
  FACILITIES_AVERAGE_LINK_ACTIVE_DESC = 'FACILITIES_AVERAGE_LINK_ACTIVE_DESC',
  FACILITIES_AVERAGE_LONGITUDE_ASC = 'FACILITIES_AVERAGE_LONGITUDE_ASC',
  FACILITIES_AVERAGE_LONGITUDE_DESC = 'FACILITIES_AVERAGE_LONGITUDE_DESC',
  FACILITIES_AVERAGE_METRICS_ONE_ACTIVE_ASC = 'FACILITIES_AVERAGE_METRICS_ONE_ACTIVE_ASC',
  FACILITIES_AVERAGE_METRICS_ONE_ACTIVE_DESC = 'FACILITIES_AVERAGE_METRICS_ONE_ACTIVE_DESC',
  FACILITIES_AVERAGE_NAME_ASC = 'FACILITIES_AVERAGE_NAME_ASC',
  FACILITIES_AVERAGE_NAME_DESC = 'FACILITIES_AVERAGE_NAME_DESC',
  FACILITIES_AVERAGE_NOTE_ASC = 'FACILITIES_AVERAGE_NOTE_ASC',
  FACILITIES_AVERAGE_NOTE_DESC = 'FACILITIES_AVERAGE_NOTE_DESC',
  FACILITIES_AVERAGE_N_SIGHT_2_ACTIVE_ASC = 'FACILITIES_AVERAGE_N_SIGHT_2_ACTIVE_ASC',
  FACILITIES_AVERAGE_N_SIGHT_2_ACTIVE_DESC = 'FACILITIES_AVERAGE_N_SIGHT_2_ACTIVE_DESC',
  FACILITIES_AVERAGE_N_SIGHT_ACTIVE_ASC = 'FACILITIES_AVERAGE_N_SIGHT_ACTIVE_ASC',
  FACILITIES_AVERAGE_N_SIGHT_ACTIVE_DESC = 'FACILITIES_AVERAGE_N_SIGHT_ACTIVE_DESC',
  FACILITIES_AVERAGE_PRE_BONUS_EBITDA_ASC = 'FACILITIES_AVERAGE_PRE_BONUS_EBITDA_ASC',
  FACILITIES_AVERAGE_PRE_BONUS_EBITDA_DESC = 'FACILITIES_AVERAGE_PRE_BONUS_EBITDA_DESC',
  FACILITIES_AVERAGE_PRICING_NODE_ID_ASC = 'FACILITIES_AVERAGE_PRICING_NODE_ID_ASC',
  FACILITIES_AVERAGE_PRICING_NODE_ID_DESC = 'FACILITIES_AVERAGE_PRICING_NODE_ID_DESC',
  FACILITIES_AVERAGE_REAL_TIME_ENABLED_ASC = 'FACILITIES_AVERAGE_REAL_TIME_ENABLED_ASC',
  FACILITIES_AVERAGE_REAL_TIME_ENABLED_DESC = 'FACILITIES_AVERAGE_REAL_TIME_ENABLED_DESC',
  FACILITIES_AVERAGE_REFRIGERATIONVENDOR_ASC = 'FACILITIES_AVERAGE_REFRIGERATIONVENDOR_ASC',
  FACILITIES_AVERAGE_REFRIGERATIONVENDOR_DESC = 'FACILITIES_AVERAGE_REFRIGERATIONVENDOR_DESC',
  FACILITIES_AVERAGE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'FACILITIES_AVERAGE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  FACILITIES_AVERAGE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'FACILITIES_AVERAGE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  FACILITIES_AVERAGE_RETIRED_AT_ASC = 'FACILITIES_AVERAGE_RETIRED_AT_ASC',
  FACILITIES_AVERAGE_RETIRED_AT_DESC = 'FACILITIES_AVERAGE_RETIRED_AT_DESC',
  FACILITIES_AVERAGE_SLUG_ASC = 'FACILITIES_AVERAGE_SLUG_ASC',
  FACILITIES_AVERAGE_SLUG_DESC = 'FACILITIES_AVERAGE_SLUG_DESC',
  FACILITIES_AVERAGE_STATE_ASC = 'FACILITIES_AVERAGE_STATE_ASC',
  FACILITIES_AVERAGE_STATE_DESC = 'FACILITIES_AVERAGE_STATE_DESC',
  FACILITIES_AVERAGE_SUPPRESSE_FINANCIALS_ASC = 'FACILITIES_AVERAGE_SUPPRESSE_FINANCIALS_ASC',
  FACILITIES_AVERAGE_SUPPRESSE_FINANCIALS_DESC = 'FACILITIES_AVERAGE_SUPPRESSE_FINANCIALS_DESC',
  FACILITIES_AVERAGE_TAT_ATTRIBUTE_ASC = 'FACILITIES_AVERAGE_TAT_ATTRIBUTE_ASC',
  FACILITIES_AVERAGE_TAT_ATTRIBUTE_DESC = 'FACILITIES_AVERAGE_TAT_ATTRIBUTE_DESC',
  FACILITIES_AVERAGE_TIMEZONE_NAME_ASC = 'FACILITIES_AVERAGE_TIMEZONE_NAME_ASC',
  FACILITIES_AVERAGE_TIMEZONE_NAME_DESC = 'FACILITIES_AVERAGE_TIMEZONE_NAME_DESC',
  FACILITIES_AVERAGE_TYPE_ASC = 'FACILITIES_AVERAGE_TYPE_ASC',
  FACILITIES_AVERAGE_TYPE_DESC = 'FACILITIES_AVERAGE_TYPE_DESC',
  FACILITIES_AVERAGE_UNIT_GROUP_ASC = 'FACILITIES_AVERAGE_UNIT_GROUP_ASC',
  FACILITIES_AVERAGE_UNIT_GROUP_DESC = 'FACILITIES_AVERAGE_UNIT_GROUP_DESC',
  FACILITIES_AVERAGE_UPDATED_AT_ASC = 'FACILITIES_AVERAGE_UPDATED_AT_ASC',
  FACILITIES_AVERAGE_UPDATED_AT_DESC = 'FACILITIES_AVERAGE_UPDATED_AT_DESC',
  FACILITIES_AVERAGE_WMS_ASC = 'FACILITIES_AVERAGE_WMS_ASC',
  FACILITIES_AVERAGE_WMS_DESC = 'FACILITIES_AVERAGE_WMS_DESC',
  FACILITIES_AVERAGE_ZIP_ASC = 'FACILITIES_AVERAGE_ZIP_ASC',
  FACILITIES_AVERAGE_ZIP_DESC = 'FACILITIES_AVERAGE_ZIP_DESC',
  FACILITIES_COUNT_ASC = 'FACILITIES_COUNT_ASC',
  FACILITIES_COUNT_DESC = 'FACILITIES_COUNT_DESC',
  FACILITIES_DISTINCT_ADDRESS_ASC = 'FACILITIES_DISTINCT_ADDRESS_ASC',
  FACILITIES_DISTINCT_ADDRESS_DESC = 'FACILITIES_DISTINCT_ADDRESS_DESC',
  FACILITIES_DISTINCT_BONUS_LTR_ASC = 'FACILITIES_DISTINCT_BONUS_LTR_ASC',
  FACILITIES_DISTINCT_BONUS_LTR_DESC = 'FACILITIES_DISTINCT_BONUS_LTR_DESC',
  FACILITIES_DISTINCT_CITY_ASC = 'FACILITIES_DISTINCT_CITY_ASC',
  FACILITIES_DISTINCT_CITY_DESC = 'FACILITIES_DISTINCT_CITY_DESC',
  FACILITIES_DISTINCT_COMMODITY_ASC = 'FACILITIES_DISTINCT_COMMODITY_ASC',
  FACILITIES_DISTINCT_COMMODITY_DESC = 'FACILITIES_DISTINCT_COMMODITY_DESC',
  FACILITIES_DISTINCT_CONTXT_9249_ASC = 'FACILITIES_DISTINCT_CONTXT_9249_ASC',
  FACILITIES_DISTINCT_CONTXT_9249_DESC = 'FACILITIES_DISTINCT_CONTXT_9249_DESC',
  FACILITIES_DISTINCT_COST_CENTER_ASC = 'FACILITIES_DISTINCT_COST_CENTER_ASC',
  FACILITIES_DISTINCT_COST_CENTER_DESC = 'FACILITIES_DISTINCT_COST_CENTER_DESC',
  FACILITIES_DISTINCT_COUNTRY_ASC = 'FACILITIES_DISTINCT_COUNTRY_ASC',
  FACILITIES_DISTINCT_COUNTRY_DESC = 'FACILITIES_DISTINCT_COUNTRY_DESC',
  FACILITIES_DISTINCT_COUNT_ADDRESS_ASC = 'FACILITIES_DISTINCT_COUNT_ADDRESS_ASC',
  FACILITIES_DISTINCT_COUNT_ADDRESS_DESC = 'FACILITIES_DISTINCT_COUNT_ADDRESS_DESC',
  FACILITIES_DISTINCT_COUNT_BONUS_LTR_ASC = 'FACILITIES_DISTINCT_COUNT_BONUS_LTR_ASC',
  FACILITIES_DISTINCT_COUNT_BONUS_LTR_DESC = 'FACILITIES_DISTINCT_COUNT_BONUS_LTR_DESC',
  FACILITIES_DISTINCT_COUNT_CITY_ASC = 'FACILITIES_DISTINCT_COUNT_CITY_ASC',
  FACILITIES_DISTINCT_COUNT_CITY_DESC = 'FACILITIES_DISTINCT_COUNT_CITY_DESC',
  FACILITIES_DISTINCT_COUNT_COMMODITY_ASC = 'FACILITIES_DISTINCT_COUNT_COMMODITY_ASC',
  FACILITIES_DISTINCT_COUNT_COMMODITY_DESC = 'FACILITIES_DISTINCT_COUNT_COMMODITY_DESC',
  FACILITIES_DISTINCT_COUNT_CONTXT_9249_ASC = 'FACILITIES_DISTINCT_COUNT_CONTXT_9249_ASC',
  FACILITIES_DISTINCT_COUNT_CONTXT_9249_DESC = 'FACILITIES_DISTINCT_COUNT_CONTXT_9249_DESC',
  FACILITIES_DISTINCT_COUNT_COST_CENTER_ASC = 'FACILITIES_DISTINCT_COUNT_COST_CENTER_ASC',
  FACILITIES_DISTINCT_COUNT_COST_CENTER_DESC = 'FACILITIES_DISTINCT_COUNT_COST_CENTER_DESC',
  FACILITIES_DISTINCT_COUNT_COUNTRY_ASC = 'FACILITIES_DISTINCT_COUNT_COUNTRY_ASC',
  FACILITIES_DISTINCT_COUNT_COUNTRY_DESC = 'FACILITIES_DISTINCT_COUNT_COUNTRY_DESC',
  FACILITIES_DISTINCT_COUNT_CREATED_AT_ASC = 'FACILITIES_DISTINCT_COUNT_CREATED_AT_ASC',
  FACILITIES_DISTINCT_COUNT_CREATED_AT_DESC = 'FACILITIES_DISTINCT_COUNT_CREATED_AT_DESC',
  FACILITIES_DISTINCT_COUNT_CUSTOMER_LOCATION_ID_ASC = 'FACILITIES_DISTINCT_COUNT_CUSTOMER_LOCATION_ID_ASC',
  FACILITIES_DISTINCT_COUNT_CUSTOMER_LOCATION_ID_DESC = 'FACILITIES_DISTINCT_COUNT_CUSTOMER_LOCATION_ID_DESC',
  FACILITIES_DISTINCT_COUNT_DATATYPE_1_TEST_ASC = 'FACILITIES_DISTINCT_COUNT_DATATYPE_1_TEST_ASC',
  FACILITIES_DISTINCT_COUNT_DATATYPE_1_TEST_DESC = 'FACILITIES_DISTINCT_COUNT_DATATYPE_1_TEST_DESC',
  FACILITIES_DISTINCT_COUNT_DATA_TYPE_2_TEST_ASC = 'FACILITIES_DISTINCT_COUNT_DATA_TYPE_2_TEST_ASC',
  FACILITIES_DISTINCT_COUNT_DATA_TYPE_2_TEST_DESC = 'FACILITIES_DISTINCT_COUNT_DATA_TYPE_2_TEST_DESC',
  FACILITIES_DISTINCT_COUNT_DATA_TYPE_3_TEST_ASC = 'FACILITIES_DISTINCT_COUNT_DATA_TYPE_3_TEST_ASC',
  FACILITIES_DISTINCT_COUNT_DATA_TYPE_3_TEST_DESC = 'FACILITIES_DISTINCT_COUNT_DATA_TYPE_3_TEST_DESC',
  FACILITIES_DISTINCT_COUNT_FACILITY_CONTACTS_ASC = 'FACILITIES_DISTINCT_COUNT_FACILITY_CONTACTS_ASC',
  FACILITIES_DISTINCT_COUNT_FACILITY_CONTACTS_DESC = 'FACILITIES_DISTINCT_COUNT_FACILITY_CONTACTS_DESC',
  FACILITIES_DISTINCT_COUNT_FLOOR_PLAN_GEOMETRY_ASC = 'FACILITIES_DISTINCT_COUNT_FLOOR_PLAN_GEOMETRY_ASC',
  FACILITIES_DISTINCT_COUNT_FLOOR_PLAN_GEOMETRY_DESC = 'FACILITIES_DISTINCT_COUNT_FLOOR_PLAN_GEOMETRY_DESC',
  FACILITIES_DISTINCT_COUNT_GEOMETRY_ASC = 'FACILITIES_DISTINCT_COUNT_GEOMETRY_ASC',
  FACILITIES_DISTINCT_COUNT_GEOMETRY_DESC = 'FACILITIES_DISTINCT_COUNT_GEOMETRY_DESC',
  FACILITIES_DISTINCT_COUNT_GO_LIVE_DATE_ASC = 'FACILITIES_DISTINCT_COUNT_GO_LIVE_DATE_ASC',
  FACILITIES_DISTINCT_COUNT_GO_LIVE_DATE_DESC = 'FACILITIES_DISTINCT_COUNT_GO_LIVE_DATE_DESC',
  FACILITIES_DISTINCT_COUNT_ID_ASC = 'FACILITIES_DISTINCT_COUNT_ID_ASC',
  FACILITIES_DISTINCT_COUNT_ID_DESC = 'FACILITIES_DISTINCT_COUNT_ID_DESC',
  FACILITIES_DISTINCT_COUNT_LATITUDE_ASC = 'FACILITIES_DISTINCT_COUNT_LATITUDE_ASC',
  FACILITIES_DISTINCT_COUNT_LATITUDE_DESC = 'FACILITIES_DISTINCT_COUNT_LATITUDE_DESC',
  FACILITIES_DISTINCT_COUNT_LINK_ACTIVE_ASC = 'FACILITIES_DISTINCT_COUNT_LINK_ACTIVE_ASC',
  FACILITIES_DISTINCT_COUNT_LINK_ACTIVE_DESC = 'FACILITIES_DISTINCT_COUNT_LINK_ACTIVE_DESC',
  FACILITIES_DISTINCT_COUNT_LONGITUDE_ASC = 'FACILITIES_DISTINCT_COUNT_LONGITUDE_ASC',
  FACILITIES_DISTINCT_COUNT_LONGITUDE_DESC = 'FACILITIES_DISTINCT_COUNT_LONGITUDE_DESC',
  FACILITIES_DISTINCT_COUNT_METRICS_ONE_ACTIVE_ASC = 'FACILITIES_DISTINCT_COUNT_METRICS_ONE_ACTIVE_ASC',
  FACILITIES_DISTINCT_COUNT_METRICS_ONE_ACTIVE_DESC = 'FACILITIES_DISTINCT_COUNT_METRICS_ONE_ACTIVE_DESC',
  FACILITIES_DISTINCT_COUNT_NAME_ASC = 'FACILITIES_DISTINCT_COUNT_NAME_ASC',
  FACILITIES_DISTINCT_COUNT_NAME_DESC = 'FACILITIES_DISTINCT_COUNT_NAME_DESC',
  FACILITIES_DISTINCT_COUNT_NOTE_ASC = 'FACILITIES_DISTINCT_COUNT_NOTE_ASC',
  FACILITIES_DISTINCT_COUNT_NOTE_DESC = 'FACILITIES_DISTINCT_COUNT_NOTE_DESC',
  FACILITIES_DISTINCT_COUNT_N_SIGHT_2_ACTIVE_ASC = 'FACILITIES_DISTINCT_COUNT_N_SIGHT_2_ACTIVE_ASC',
  FACILITIES_DISTINCT_COUNT_N_SIGHT_2_ACTIVE_DESC = 'FACILITIES_DISTINCT_COUNT_N_SIGHT_2_ACTIVE_DESC',
  FACILITIES_DISTINCT_COUNT_N_SIGHT_ACTIVE_ASC = 'FACILITIES_DISTINCT_COUNT_N_SIGHT_ACTIVE_ASC',
  FACILITIES_DISTINCT_COUNT_N_SIGHT_ACTIVE_DESC = 'FACILITIES_DISTINCT_COUNT_N_SIGHT_ACTIVE_DESC',
  FACILITIES_DISTINCT_COUNT_PRE_BONUS_EBITDA_ASC = 'FACILITIES_DISTINCT_COUNT_PRE_BONUS_EBITDA_ASC',
  FACILITIES_DISTINCT_COUNT_PRE_BONUS_EBITDA_DESC = 'FACILITIES_DISTINCT_COUNT_PRE_BONUS_EBITDA_DESC',
  FACILITIES_DISTINCT_COUNT_PRICING_NODE_ID_ASC = 'FACILITIES_DISTINCT_COUNT_PRICING_NODE_ID_ASC',
  FACILITIES_DISTINCT_COUNT_PRICING_NODE_ID_DESC = 'FACILITIES_DISTINCT_COUNT_PRICING_NODE_ID_DESC',
  FACILITIES_DISTINCT_COUNT_REAL_TIME_ENABLED_ASC = 'FACILITIES_DISTINCT_COUNT_REAL_TIME_ENABLED_ASC',
  FACILITIES_DISTINCT_COUNT_REAL_TIME_ENABLED_DESC = 'FACILITIES_DISTINCT_COUNT_REAL_TIME_ENABLED_DESC',
  FACILITIES_DISTINCT_COUNT_REFRIGERATIONVENDOR_ASC = 'FACILITIES_DISTINCT_COUNT_REFRIGERATIONVENDOR_ASC',
  FACILITIES_DISTINCT_COUNT_REFRIGERATIONVENDOR_DESC = 'FACILITIES_DISTINCT_COUNT_REFRIGERATIONVENDOR_DESC',
  FACILITIES_DISTINCT_COUNT_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'FACILITIES_DISTINCT_COUNT_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  FACILITIES_DISTINCT_COUNT_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'FACILITIES_DISTINCT_COUNT_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  FACILITIES_DISTINCT_COUNT_RETIRED_AT_ASC = 'FACILITIES_DISTINCT_COUNT_RETIRED_AT_ASC',
  FACILITIES_DISTINCT_COUNT_RETIRED_AT_DESC = 'FACILITIES_DISTINCT_COUNT_RETIRED_AT_DESC',
  FACILITIES_DISTINCT_COUNT_SLUG_ASC = 'FACILITIES_DISTINCT_COUNT_SLUG_ASC',
  FACILITIES_DISTINCT_COUNT_SLUG_DESC = 'FACILITIES_DISTINCT_COUNT_SLUG_DESC',
  FACILITIES_DISTINCT_COUNT_STATE_ASC = 'FACILITIES_DISTINCT_COUNT_STATE_ASC',
  FACILITIES_DISTINCT_COUNT_STATE_DESC = 'FACILITIES_DISTINCT_COUNT_STATE_DESC',
  FACILITIES_DISTINCT_COUNT_SUPPRESSE_FINANCIALS_ASC = 'FACILITIES_DISTINCT_COUNT_SUPPRESSE_FINANCIALS_ASC',
  FACILITIES_DISTINCT_COUNT_SUPPRESSE_FINANCIALS_DESC = 'FACILITIES_DISTINCT_COUNT_SUPPRESSE_FINANCIALS_DESC',
  FACILITIES_DISTINCT_COUNT_TAT_ATTRIBUTE_ASC = 'FACILITIES_DISTINCT_COUNT_TAT_ATTRIBUTE_ASC',
  FACILITIES_DISTINCT_COUNT_TAT_ATTRIBUTE_DESC = 'FACILITIES_DISTINCT_COUNT_TAT_ATTRIBUTE_DESC',
  FACILITIES_DISTINCT_COUNT_TIMEZONE_NAME_ASC = 'FACILITIES_DISTINCT_COUNT_TIMEZONE_NAME_ASC',
  FACILITIES_DISTINCT_COUNT_TIMEZONE_NAME_DESC = 'FACILITIES_DISTINCT_COUNT_TIMEZONE_NAME_DESC',
  FACILITIES_DISTINCT_COUNT_TYPE_ASC = 'FACILITIES_DISTINCT_COUNT_TYPE_ASC',
  FACILITIES_DISTINCT_COUNT_TYPE_DESC = 'FACILITIES_DISTINCT_COUNT_TYPE_DESC',
  FACILITIES_DISTINCT_COUNT_UNIT_GROUP_ASC = 'FACILITIES_DISTINCT_COUNT_UNIT_GROUP_ASC',
  FACILITIES_DISTINCT_COUNT_UNIT_GROUP_DESC = 'FACILITIES_DISTINCT_COUNT_UNIT_GROUP_DESC',
  FACILITIES_DISTINCT_COUNT_UPDATED_AT_ASC = 'FACILITIES_DISTINCT_COUNT_UPDATED_AT_ASC',
  FACILITIES_DISTINCT_COUNT_UPDATED_AT_DESC = 'FACILITIES_DISTINCT_COUNT_UPDATED_AT_DESC',
  FACILITIES_DISTINCT_COUNT_WMS_ASC = 'FACILITIES_DISTINCT_COUNT_WMS_ASC',
  FACILITIES_DISTINCT_COUNT_WMS_DESC = 'FACILITIES_DISTINCT_COUNT_WMS_DESC',
  FACILITIES_DISTINCT_COUNT_ZIP_ASC = 'FACILITIES_DISTINCT_COUNT_ZIP_ASC',
  FACILITIES_DISTINCT_COUNT_ZIP_DESC = 'FACILITIES_DISTINCT_COUNT_ZIP_DESC',
  FACILITIES_DISTINCT_CREATED_AT_ASC = 'FACILITIES_DISTINCT_CREATED_AT_ASC',
  FACILITIES_DISTINCT_CREATED_AT_DESC = 'FACILITIES_DISTINCT_CREATED_AT_DESC',
  FACILITIES_DISTINCT_CUSTOMER_LOCATION_ID_ASC = 'FACILITIES_DISTINCT_CUSTOMER_LOCATION_ID_ASC',
  FACILITIES_DISTINCT_CUSTOMER_LOCATION_ID_DESC = 'FACILITIES_DISTINCT_CUSTOMER_LOCATION_ID_DESC',
  FACILITIES_DISTINCT_DATATYPE_1_TEST_ASC = 'FACILITIES_DISTINCT_DATATYPE_1_TEST_ASC',
  FACILITIES_DISTINCT_DATATYPE_1_TEST_DESC = 'FACILITIES_DISTINCT_DATATYPE_1_TEST_DESC',
  FACILITIES_DISTINCT_DATA_TYPE_2_TEST_ASC = 'FACILITIES_DISTINCT_DATA_TYPE_2_TEST_ASC',
  FACILITIES_DISTINCT_DATA_TYPE_2_TEST_DESC = 'FACILITIES_DISTINCT_DATA_TYPE_2_TEST_DESC',
  FACILITIES_DISTINCT_DATA_TYPE_3_TEST_ASC = 'FACILITIES_DISTINCT_DATA_TYPE_3_TEST_ASC',
  FACILITIES_DISTINCT_DATA_TYPE_3_TEST_DESC = 'FACILITIES_DISTINCT_DATA_TYPE_3_TEST_DESC',
  FACILITIES_DISTINCT_FACILITY_CONTACTS_ASC = 'FACILITIES_DISTINCT_FACILITY_CONTACTS_ASC',
  FACILITIES_DISTINCT_FACILITY_CONTACTS_DESC = 'FACILITIES_DISTINCT_FACILITY_CONTACTS_DESC',
  FACILITIES_DISTINCT_FLOOR_PLAN_GEOMETRY_ASC = 'FACILITIES_DISTINCT_FLOOR_PLAN_GEOMETRY_ASC',
  FACILITIES_DISTINCT_FLOOR_PLAN_GEOMETRY_DESC = 'FACILITIES_DISTINCT_FLOOR_PLAN_GEOMETRY_DESC',
  FACILITIES_DISTINCT_GEOMETRY_ASC = 'FACILITIES_DISTINCT_GEOMETRY_ASC',
  FACILITIES_DISTINCT_GEOMETRY_DESC = 'FACILITIES_DISTINCT_GEOMETRY_DESC',
  FACILITIES_DISTINCT_GO_LIVE_DATE_ASC = 'FACILITIES_DISTINCT_GO_LIVE_DATE_ASC',
  FACILITIES_DISTINCT_GO_LIVE_DATE_DESC = 'FACILITIES_DISTINCT_GO_LIVE_DATE_DESC',
  FACILITIES_DISTINCT_ID_ASC = 'FACILITIES_DISTINCT_ID_ASC',
  FACILITIES_DISTINCT_ID_DESC = 'FACILITIES_DISTINCT_ID_DESC',
  FACILITIES_DISTINCT_LATITUDE_ASC = 'FACILITIES_DISTINCT_LATITUDE_ASC',
  FACILITIES_DISTINCT_LATITUDE_DESC = 'FACILITIES_DISTINCT_LATITUDE_DESC',
  FACILITIES_DISTINCT_LINK_ACTIVE_ASC = 'FACILITIES_DISTINCT_LINK_ACTIVE_ASC',
  FACILITIES_DISTINCT_LINK_ACTIVE_DESC = 'FACILITIES_DISTINCT_LINK_ACTIVE_DESC',
  FACILITIES_DISTINCT_LONGITUDE_ASC = 'FACILITIES_DISTINCT_LONGITUDE_ASC',
  FACILITIES_DISTINCT_LONGITUDE_DESC = 'FACILITIES_DISTINCT_LONGITUDE_DESC',
  FACILITIES_DISTINCT_METRICS_ONE_ACTIVE_ASC = 'FACILITIES_DISTINCT_METRICS_ONE_ACTIVE_ASC',
  FACILITIES_DISTINCT_METRICS_ONE_ACTIVE_DESC = 'FACILITIES_DISTINCT_METRICS_ONE_ACTIVE_DESC',
  FACILITIES_DISTINCT_NAME_ASC = 'FACILITIES_DISTINCT_NAME_ASC',
  FACILITIES_DISTINCT_NAME_DESC = 'FACILITIES_DISTINCT_NAME_DESC',
  FACILITIES_DISTINCT_NOTE_ASC = 'FACILITIES_DISTINCT_NOTE_ASC',
  FACILITIES_DISTINCT_NOTE_DESC = 'FACILITIES_DISTINCT_NOTE_DESC',
  FACILITIES_DISTINCT_N_SIGHT_2_ACTIVE_ASC = 'FACILITIES_DISTINCT_N_SIGHT_2_ACTIVE_ASC',
  FACILITIES_DISTINCT_N_SIGHT_2_ACTIVE_DESC = 'FACILITIES_DISTINCT_N_SIGHT_2_ACTIVE_DESC',
  FACILITIES_DISTINCT_N_SIGHT_ACTIVE_ASC = 'FACILITIES_DISTINCT_N_SIGHT_ACTIVE_ASC',
  FACILITIES_DISTINCT_N_SIGHT_ACTIVE_DESC = 'FACILITIES_DISTINCT_N_SIGHT_ACTIVE_DESC',
  FACILITIES_DISTINCT_PRE_BONUS_EBITDA_ASC = 'FACILITIES_DISTINCT_PRE_BONUS_EBITDA_ASC',
  FACILITIES_DISTINCT_PRE_BONUS_EBITDA_DESC = 'FACILITIES_DISTINCT_PRE_BONUS_EBITDA_DESC',
  FACILITIES_DISTINCT_PRICING_NODE_ID_ASC = 'FACILITIES_DISTINCT_PRICING_NODE_ID_ASC',
  FACILITIES_DISTINCT_PRICING_NODE_ID_DESC = 'FACILITIES_DISTINCT_PRICING_NODE_ID_DESC',
  FACILITIES_DISTINCT_REAL_TIME_ENABLED_ASC = 'FACILITIES_DISTINCT_REAL_TIME_ENABLED_ASC',
  FACILITIES_DISTINCT_REAL_TIME_ENABLED_DESC = 'FACILITIES_DISTINCT_REAL_TIME_ENABLED_DESC',
  FACILITIES_DISTINCT_REFRIGERATIONVENDOR_ASC = 'FACILITIES_DISTINCT_REFRIGERATIONVENDOR_ASC',
  FACILITIES_DISTINCT_REFRIGERATIONVENDOR_DESC = 'FACILITIES_DISTINCT_REFRIGERATIONVENDOR_DESC',
  FACILITIES_DISTINCT_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'FACILITIES_DISTINCT_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  FACILITIES_DISTINCT_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'FACILITIES_DISTINCT_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  FACILITIES_DISTINCT_RETIRED_AT_ASC = 'FACILITIES_DISTINCT_RETIRED_AT_ASC',
  FACILITIES_DISTINCT_RETIRED_AT_DESC = 'FACILITIES_DISTINCT_RETIRED_AT_DESC',
  FACILITIES_DISTINCT_SLUG_ASC = 'FACILITIES_DISTINCT_SLUG_ASC',
  FACILITIES_DISTINCT_SLUG_DESC = 'FACILITIES_DISTINCT_SLUG_DESC',
  FACILITIES_DISTINCT_STATE_ASC = 'FACILITIES_DISTINCT_STATE_ASC',
  FACILITIES_DISTINCT_STATE_DESC = 'FACILITIES_DISTINCT_STATE_DESC',
  FACILITIES_DISTINCT_SUPPRESSE_FINANCIALS_ASC = 'FACILITIES_DISTINCT_SUPPRESSE_FINANCIALS_ASC',
  FACILITIES_DISTINCT_SUPPRESSE_FINANCIALS_DESC = 'FACILITIES_DISTINCT_SUPPRESSE_FINANCIALS_DESC',
  FACILITIES_DISTINCT_TAT_ATTRIBUTE_ASC = 'FACILITIES_DISTINCT_TAT_ATTRIBUTE_ASC',
  FACILITIES_DISTINCT_TAT_ATTRIBUTE_DESC = 'FACILITIES_DISTINCT_TAT_ATTRIBUTE_DESC',
  FACILITIES_DISTINCT_TIMEZONE_NAME_ASC = 'FACILITIES_DISTINCT_TIMEZONE_NAME_ASC',
  FACILITIES_DISTINCT_TIMEZONE_NAME_DESC = 'FACILITIES_DISTINCT_TIMEZONE_NAME_DESC',
  FACILITIES_DISTINCT_TYPE_ASC = 'FACILITIES_DISTINCT_TYPE_ASC',
  FACILITIES_DISTINCT_TYPE_DESC = 'FACILITIES_DISTINCT_TYPE_DESC',
  FACILITIES_DISTINCT_UNIT_GROUP_ASC = 'FACILITIES_DISTINCT_UNIT_GROUP_ASC',
  FACILITIES_DISTINCT_UNIT_GROUP_DESC = 'FACILITIES_DISTINCT_UNIT_GROUP_DESC',
  FACILITIES_DISTINCT_UPDATED_AT_ASC = 'FACILITIES_DISTINCT_UPDATED_AT_ASC',
  FACILITIES_DISTINCT_UPDATED_AT_DESC = 'FACILITIES_DISTINCT_UPDATED_AT_DESC',
  FACILITIES_DISTINCT_WMS_ASC = 'FACILITIES_DISTINCT_WMS_ASC',
  FACILITIES_DISTINCT_WMS_DESC = 'FACILITIES_DISTINCT_WMS_DESC',
  FACILITIES_DISTINCT_ZIP_ASC = 'FACILITIES_DISTINCT_ZIP_ASC',
  FACILITIES_DISTINCT_ZIP_DESC = 'FACILITIES_DISTINCT_ZIP_DESC',
  FACILITIES_MAX_ADDRESS_ASC = 'FACILITIES_MAX_ADDRESS_ASC',
  FACILITIES_MAX_ADDRESS_DESC = 'FACILITIES_MAX_ADDRESS_DESC',
  FACILITIES_MAX_BONUS_LTR_ASC = 'FACILITIES_MAX_BONUS_LTR_ASC',
  FACILITIES_MAX_BONUS_LTR_DESC = 'FACILITIES_MAX_BONUS_LTR_DESC',
  FACILITIES_MAX_CITY_ASC = 'FACILITIES_MAX_CITY_ASC',
  FACILITIES_MAX_CITY_DESC = 'FACILITIES_MAX_CITY_DESC',
  FACILITIES_MAX_COMMODITY_ASC = 'FACILITIES_MAX_COMMODITY_ASC',
  FACILITIES_MAX_COMMODITY_DESC = 'FACILITIES_MAX_COMMODITY_DESC',
  FACILITIES_MAX_CONTXT_9249_ASC = 'FACILITIES_MAX_CONTXT_9249_ASC',
  FACILITIES_MAX_CONTXT_9249_DESC = 'FACILITIES_MAX_CONTXT_9249_DESC',
  FACILITIES_MAX_COST_CENTER_ASC = 'FACILITIES_MAX_COST_CENTER_ASC',
  FACILITIES_MAX_COST_CENTER_DESC = 'FACILITIES_MAX_COST_CENTER_DESC',
  FACILITIES_MAX_COUNTRY_ASC = 'FACILITIES_MAX_COUNTRY_ASC',
  FACILITIES_MAX_COUNTRY_DESC = 'FACILITIES_MAX_COUNTRY_DESC',
  FACILITIES_MAX_CREATED_AT_ASC = 'FACILITIES_MAX_CREATED_AT_ASC',
  FACILITIES_MAX_CREATED_AT_DESC = 'FACILITIES_MAX_CREATED_AT_DESC',
  FACILITIES_MAX_CUSTOMER_LOCATION_ID_ASC = 'FACILITIES_MAX_CUSTOMER_LOCATION_ID_ASC',
  FACILITIES_MAX_CUSTOMER_LOCATION_ID_DESC = 'FACILITIES_MAX_CUSTOMER_LOCATION_ID_DESC',
  FACILITIES_MAX_DATATYPE_1_TEST_ASC = 'FACILITIES_MAX_DATATYPE_1_TEST_ASC',
  FACILITIES_MAX_DATATYPE_1_TEST_DESC = 'FACILITIES_MAX_DATATYPE_1_TEST_DESC',
  FACILITIES_MAX_DATA_TYPE_2_TEST_ASC = 'FACILITIES_MAX_DATA_TYPE_2_TEST_ASC',
  FACILITIES_MAX_DATA_TYPE_2_TEST_DESC = 'FACILITIES_MAX_DATA_TYPE_2_TEST_DESC',
  FACILITIES_MAX_DATA_TYPE_3_TEST_ASC = 'FACILITIES_MAX_DATA_TYPE_3_TEST_ASC',
  FACILITIES_MAX_DATA_TYPE_3_TEST_DESC = 'FACILITIES_MAX_DATA_TYPE_3_TEST_DESC',
  FACILITIES_MAX_FACILITY_CONTACTS_ASC = 'FACILITIES_MAX_FACILITY_CONTACTS_ASC',
  FACILITIES_MAX_FACILITY_CONTACTS_DESC = 'FACILITIES_MAX_FACILITY_CONTACTS_DESC',
  FACILITIES_MAX_FLOOR_PLAN_GEOMETRY_ASC = 'FACILITIES_MAX_FLOOR_PLAN_GEOMETRY_ASC',
  FACILITIES_MAX_FLOOR_PLAN_GEOMETRY_DESC = 'FACILITIES_MAX_FLOOR_PLAN_GEOMETRY_DESC',
  FACILITIES_MAX_GEOMETRY_ASC = 'FACILITIES_MAX_GEOMETRY_ASC',
  FACILITIES_MAX_GEOMETRY_DESC = 'FACILITIES_MAX_GEOMETRY_DESC',
  FACILITIES_MAX_GO_LIVE_DATE_ASC = 'FACILITIES_MAX_GO_LIVE_DATE_ASC',
  FACILITIES_MAX_GO_LIVE_DATE_DESC = 'FACILITIES_MAX_GO_LIVE_DATE_DESC',
  FACILITIES_MAX_ID_ASC = 'FACILITIES_MAX_ID_ASC',
  FACILITIES_MAX_ID_DESC = 'FACILITIES_MAX_ID_DESC',
  FACILITIES_MAX_LATITUDE_ASC = 'FACILITIES_MAX_LATITUDE_ASC',
  FACILITIES_MAX_LATITUDE_DESC = 'FACILITIES_MAX_LATITUDE_DESC',
  FACILITIES_MAX_LINK_ACTIVE_ASC = 'FACILITIES_MAX_LINK_ACTIVE_ASC',
  FACILITIES_MAX_LINK_ACTIVE_DESC = 'FACILITIES_MAX_LINK_ACTIVE_DESC',
  FACILITIES_MAX_LONGITUDE_ASC = 'FACILITIES_MAX_LONGITUDE_ASC',
  FACILITIES_MAX_LONGITUDE_DESC = 'FACILITIES_MAX_LONGITUDE_DESC',
  FACILITIES_MAX_METRICS_ONE_ACTIVE_ASC = 'FACILITIES_MAX_METRICS_ONE_ACTIVE_ASC',
  FACILITIES_MAX_METRICS_ONE_ACTIVE_DESC = 'FACILITIES_MAX_METRICS_ONE_ACTIVE_DESC',
  FACILITIES_MAX_NAME_ASC = 'FACILITIES_MAX_NAME_ASC',
  FACILITIES_MAX_NAME_DESC = 'FACILITIES_MAX_NAME_DESC',
  FACILITIES_MAX_NOTE_ASC = 'FACILITIES_MAX_NOTE_ASC',
  FACILITIES_MAX_NOTE_DESC = 'FACILITIES_MAX_NOTE_DESC',
  FACILITIES_MAX_N_SIGHT_2_ACTIVE_ASC = 'FACILITIES_MAX_N_SIGHT_2_ACTIVE_ASC',
  FACILITIES_MAX_N_SIGHT_2_ACTIVE_DESC = 'FACILITIES_MAX_N_SIGHT_2_ACTIVE_DESC',
  FACILITIES_MAX_N_SIGHT_ACTIVE_ASC = 'FACILITIES_MAX_N_SIGHT_ACTIVE_ASC',
  FACILITIES_MAX_N_SIGHT_ACTIVE_DESC = 'FACILITIES_MAX_N_SIGHT_ACTIVE_DESC',
  FACILITIES_MAX_PRE_BONUS_EBITDA_ASC = 'FACILITIES_MAX_PRE_BONUS_EBITDA_ASC',
  FACILITIES_MAX_PRE_BONUS_EBITDA_DESC = 'FACILITIES_MAX_PRE_BONUS_EBITDA_DESC',
  FACILITIES_MAX_PRICING_NODE_ID_ASC = 'FACILITIES_MAX_PRICING_NODE_ID_ASC',
  FACILITIES_MAX_PRICING_NODE_ID_DESC = 'FACILITIES_MAX_PRICING_NODE_ID_DESC',
  FACILITIES_MAX_REAL_TIME_ENABLED_ASC = 'FACILITIES_MAX_REAL_TIME_ENABLED_ASC',
  FACILITIES_MAX_REAL_TIME_ENABLED_DESC = 'FACILITIES_MAX_REAL_TIME_ENABLED_DESC',
  FACILITIES_MAX_REFRIGERATIONVENDOR_ASC = 'FACILITIES_MAX_REFRIGERATIONVENDOR_ASC',
  FACILITIES_MAX_REFRIGERATIONVENDOR_DESC = 'FACILITIES_MAX_REFRIGERATIONVENDOR_DESC',
  FACILITIES_MAX_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'FACILITIES_MAX_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  FACILITIES_MAX_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'FACILITIES_MAX_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  FACILITIES_MAX_RETIRED_AT_ASC = 'FACILITIES_MAX_RETIRED_AT_ASC',
  FACILITIES_MAX_RETIRED_AT_DESC = 'FACILITIES_MAX_RETIRED_AT_DESC',
  FACILITIES_MAX_SLUG_ASC = 'FACILITIES_MAX_SLUG_ASC',
  FACILITIES_MAX_SLUG_DESC = 'FACILITIES_MAX_SLUG_DESC',
  FACILITIES_MAX_STATE_ASC = 'FACILITIES_MAX_STATE_ASC',
  FACILITIES_MAX_STATE_DESC = 'FACILITIES_MAX_STATE_DESC',
  FACILITIES_MAX_SUPPRESSE_FINANCIALS_ASC = 'FACILITIES_MAX_SUPPRESSE_FINANCIALS_ASC',
  FACILITIES_MAX_SUPPRESSE_FINANCIALS_DESC = 'FACILITIES_MAX_SUPPRESSE_FINANCIALS_DESC',
  FACILITIES_MAX_TAT_ATTRIBUTE_ASC = 'FACILITIES_MAX_TAT_ATTRIBUTE_ASC',
  FACILITIES_MAX_TAT_ATTRIBUTE_DESC = 'FACILITIES_MAX_TAT_ATTRIBUTE_DESC',
  FACILITIES_MAX_TIMEZONE_NAME_ASC = 'FACILITIES_MAX_TIMEZONE_NAME_ASC',
  FACILITIES_MAX_TIMEZONE_NAME_DESC = 'FACILITIES_MAX_TIMEZONE_NAME_DESC',
  FACILITIES_MAX_TYPE_ASC = 'FACILITIES_MAX_TYPE_ASC',
  FACILITIES_MAX_TYPE_DESC = 'FACILITIES_MAX_TYPE_DESC',
  FACILITIES_MAX_UNIT_GROUP_ASC = 'FACILITIES_MAX_UNIT_GROUP_ASC',
  FACILITIES_MAX_UNIT_GROUP_DESC = 'FACILITIES_MAX_UNIT_GROUP_DESC',
  FACILITIES_MAX_UPDATED_AT_ASC = 'FACILITIES_MAX_UPDATED_AT_ASC',
  FACILITIES_MAX_UPDATED_AT_DESC = 'FACILITIES_MAX_UPDATED_AT_DESC',
  FACILITIES_MAX_WMS_ASC = 'FACILITIES_MAX_WMS_ASC',
  FACILITIES_MAX_WMS_DESC = 'FACILITIES_MAX_WMS_DESC',
  FACILITIES_MAX_ZIP_ASC = 'FACILITIES_MAX_ZIP_ASC',
  FACILITIES_MAX_ZIP_DESC = 'FACILITIES_MAX_ZIP_DESC',
  FACILITIES_MIN_ADDRESS_ASC = 'FACILITIES_MIN_ADDRESS_ASC',
  FACILITIES_MIN_ADDRESS_DESC = 'FACILITIES_MIN_ADDRESS_DESC',
  FACILITIES_MIN_BONUS_LTR_ASC = 'FACILITIES_MIN_BONUS_LTR_ASC',
  FACILITIES_MIN_BONUS_LTR_DESC = 'FACILITIES_MIN_BONUS_LTR_DESC',
  FACILITIES_MIN_CITY_ASC = 'FACILITIES_MIN_CITY_ASC',
  FACILITIES_MIN_CITY_DESC = 'FACILITIES_MIN_CITY_DESC',
  FACILITIES_MIN_COMMODITY_ASC = 'FACILITIES_MIN_COMMODITY_ASC',
  FACILITIES_MIN_COMMODITY_DESC = 'FACILITIES_MIN_COMMODITY_DESC',
  FACILITIES_MIN_CONTXT_9249_ASC = 'FACILITIES_MIN_CONTXT_9249_ASC',
  FACILITIES_MIN_CONTXT_9249_DESC = 'FACILITIES_MIN_CONTXT_9249_DESC',
  FACILITIES_MIN_COST_CENTER_ASC = 'FACILITIES_MIN_COST_CENTER_ASC',
  FACILITIES_MIN_COST_CENTER_DESC = 'FACILITIES_MIN_COST_CENTER_DESC',
  FACILITIES_MIN_COUNTRY_ASC = 'FACILITIES_MIN_COUNTRY_ASC',
  FACILITIES_MIN_COUNTRY_DESC = 'FACILITIES_MIN_COUNTRY_DESC',
  FACILITIES_MIN_CREATED_AT_ASC = 'FACILITIES_MIN_CREATED_AT_ASC',
  FACILITIES_MIN_CREATED_AT_DESC = 'FACILITIES_MIN_CREATED_AT_DESC',
  FACILITIES_MIN_CUSTOMER_LOCATION_ID_ASC = 'FACILITIES_MIN_CUSTOMER_LOCATION_ID_ASC',
  FACILITIES_MIN_CUSTOMER_LOCATION_ID_DESC = 'FACILITIES_MIN_CUSTOMER_LOCATION_ID_DESC',
  FACILITIES_MIN_DATATYPE_1_TEST_ASC = 'FACILITIES_MIN_DATATYPE_1_TEST_ASC',
  FACILITIES_MIN_DATATYPE_1_TEST_DESC = 'FACILITIES_MIN_DATATYPE_1_TEST_DESC',
  FACILITIES_MIN_DATA_TYPE_2_TEST_ASC = 'FACILITIES_MIN_DATA_TYPE_2_TEST_ASC',
  FACILITIES_MIN_DATA_TYPE_2_TEST_DESC = 'FACILITIES_MIN_DATA_TYPE_2_TEST_DESC',
  FACILITIES_MIN_DATA_TYPE_3_TEST_ASC = 'FACILITIES_MIN_DATA_TYPE_3_TEST_ASC',
  FACILITIES_MIN_DATA_TYPE_3_TEST_DESC = 'FACILITIES_MIN_DATA_TYPE_3_TEST_DESC',
  FACILITIES_MIN_FACILITY_CONTACTS_ASC = 'FACILITIES_MIN_FACILITY_CONTACTS_ASC',
  FACILITIES_MIN_FACILITY_CONTACTS_DESC = 'FACILITIES_MIN_FACILITY_CONTACTS_DESC',
  FACILITIES_MIN_FLOOR_PLAN_GEOMETRY_ASC = 'FACILITIES_MIN_FLOOR_PLAN_GEOMETRY_ASC',
  FACILITIES_MIN_FLOOR_PLAN_GEOMETRY_DESC = 'FACILITIES_MIN_FLOOR_PLAN_GEOMETRY_DESC',
  FACILITIES_MIN_GEOMETRY_ASC = 'FACILITIES_MIN_GEOMETRY_ASC',
  FACILITIES_MIN_GEOMETRY_DESC = 'FACILITIES_MIN_GEOMETRY_DESC',
  FACILITIES_MIN_GO_LIVE_DATE_ASC = 'FACILITIES_MIN_GO_LIVE_DATE_ASC',
  FACILITIES_MIN_GO_LIVE_DATE_DESC = 'FACILITIES_MIN_GO_LIVE_DATE_DESC',
  FACILITIES_MIN_ID_ASC = 'FACILITIES_MIN_ID_ASC',
  FACILITIES_MIN_ID_DESC = 'FACILITIES_MIN_ID_DESC',
  FACILITIES_MIN_LATITUDE_ASC = 'FACILITIES_MIN_LATITUDE_ASC',
  FACILITIES_MIN_LATITUDE_DESC = 'FACILITIES_MIN_LATITUDE_DESC',
  FACILITIES_MIN_LINK_ACTIVE_ASC = 'FACILITIES_MIN_LINK_ACTIVE_ASC',
  FACILITIES_MIN_LINK_ACTIVE_DESC = 'FACILITIES_MIN_LINK_ACTIVE_DESC',
  FACILITIES_MIN_LONGITUDE_ASC = 'FACILITIES_MIN_LONGITUDE_ASC',
  FACILITIES_MIN_LONGITUDE_DESC = 'FACILITIES_MIN_LONGITUDE_DESC',
  FACILITIES_MIN_METRICS_ONE_ACTIVE_ASC = 'FACILITIES_MIN_METRICS_ONE_ACTIVE_ASC',
  FACILITIES_MIN_METRICS_ONE_ACTIVE_DESC = 'FACILITIES_MIN_METRICS_ONE_ACTIVE_DESC',
  FACILITIES_MIN_NAME_ASC = 'FACILITIES_MIN_NAME_ASC',
  FACILITIES_MIN_NAME_DESC = 'FACILITIES_MIN_NAME_DESC',
  FACILITIES_MIN_NOTE_ASC = 'FACILITIES_MIN_NOTE_ASC',
  FACILITIES_MIN_NOTE_DESC = 'FACILITIES_MIN_NOTE_DESC',
  FACILITIES_MIN_N_SIGHT_2_ACTIVE_ASC = 'FACILITIES_MIN_N_SIGHT_2_ACTIVE_ASC',
  FACILITIES_MIN_N_SIGHT_2_ACTIVE_DESC = 'FACILITIES_MIN_N_SIGHT_2_ACTIVE_DESC',
  FACILITIES_MIN_N_SIGHT_ACTIVE_ASC = 'FACILITIES_MIN_N_SIGHT_ACTIVE_ASC',
  FACILITIES_MIN_N_SIGHT_ACTIVE_DESC = 'FACILITIES_MIN_N_SIGHT_ACTIVE_DESC',
  FACILITIES_MIN_PRE_BONUS_EBITDA_ASC = 'FACILITIES_MIN_PRE_BONUS_EBITDA_ASC',
  FACILITIES_MIN_PRE_BONUS_EBITDA_DESC = 'FACILITIES_MIN_PRE_BONUS_EBITDA_DESC',
  FACILITIES_MIN_PRICING_NODE_ID_ASC = 'FACILITIES_MIN_PRICING_NODE_ID_ASC',
  FACILITIES_MIN_PRICING_NODE_ID_DESC = 'FACILITIES_MIN_PRICING_NODE_ID_DESC',
  FACILITIES_MIN_REAL_TIME_ENABLED_ASC = 'FACILITIES_MIN_REAL_TIME_ENABLED_ASC',
  FACILITIES_MIN_REAL_TIME_ENABLED_DESC = 'FACILITIES_MIN_REAL_TIME_ENABLED_DESC',
  FACILITIES_MIN_REFRIGERATIONVENDOR_ASC = 'FACILITIES_MIN_REFRIGERATIONVENDOR_ASC',
  FACILITIES_MIN_REFRIGERATIONVENDOR_DESC = 'FACILITIES_MIN_REFRIGERATIONVENDOR_DESC',
  FACILITIES_MIN_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'FACILITIES_MIN_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  FACILITIES_MIN_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'FACILITIES_MIN_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  FACILITIES_MIN_RETIRED_AT_ASC = 'FACILITIES_MIN_RETIRED_AT_ASC',
  FACILITIES_MIN_RETIRED_AT_DESC = 'FACILITIES_MIN_RETIRED_AT_DESC',
  FACILITIES_MIN_SLUG_ASC = 'FACILITIES_MIN_SLUG_ASC',
  FACILITIES_MIN_SLUG_DESC = 'FACILITIES_MIN_SLUG_DESC',
  FACILITIES_MIN_STATE_ASC = 'FACILITIES_MIN_STATE_ASC',
  FACILITIES_MIN_STATE_DESC = 'FACILITIES_MIN_STATE_DESC',
  FACILITIES_MIN_SUPPRESSE_FINANCIALS_ASC = 'FACILITIES_MIN_SUPPRESSE_FINANCIALS_ASC',
  FACILITIES_MIN_SUPPRESSE_FINANCIALS_DESC = 'FACILITIES_MIN_SUPPRESSE_FINANCIALS_DESC',
  FACILITIES_MIN_TAT_ATTRIBUTE_ASC = 'FACILITIES_MIN_TAT_ATTRIBUTE_ASC',
  FACILITIES_MIN_TAT_ATTRIBUTE_DESC = 'FACILITIES_MIN_TAT_ATTRIBUTE_DESC',
  FACILITIES_MIN_TIMEZONE_NAME_ASC = 'FACILITIES_MIN_TIMEZONE_NAME_ASC',
  FACILITIES_MIN_TIMEZONE_NAME_DESC = 'FACILITIES_MIN_TIMEZONE_NAME_DESC',
  FACILITIES_MIN_TYPE_ASC = 'FACILITIES_MIN_TYPE_ASC',
  FACILITIES_MIN_TYPE_DESC = 'FACILITIES_MIN_TYPE_DESC',
  FACILITIES_MIN_UNIT_GROUP_ASC = 'FACILITIES_MIN_UNIT_GROUP_ASC',
  FACILITIES_MIN_UNIT_GROUP_DESC = 'FACILITIES_MIN_UNIT_GROUP_DESC',
  FACILITIES_MIN_UPDATED_AT_ASC = 'FACILITIES_MIN_UPDATED_AT_ASC',
  FACILITIES_MIN_UPDATED_AT_DESC = 'FACILITIES_MIN_UPDATED_AT_DESC',
  FACILITIES_MIN_WMS_ASC = 'FACILITIES_MIN_WMS_ASC',
  FACILITIES_MIN_WMS_DESC = 'FACILITIES_MIN_WMS_DESC',
  FACILITIES_MIN_ZIP_ASC = 'FACILITIES_MIN_ZIP_ASC',
  FACILITIES_MIN_ZIP_DESC = 'FACILITIES_MIN_ZIP_DESC',
  FACILITIES_STDDEV_POPULATION_ADDRESS_ASC = 'FACILITIES_STDDEV_POPULATION_ADDRESS_ASC',
  FACILITIES_STDDEV_POPULATION_ADDRESS_DESC = 'FACILITIES_STDDEV_POPULATION_ADDRESS_DESC',
  FACILITIES_STDDEV_POPULATION_BONUS_LTR_ASC = 'FACILITIES_STDDEV_POPULATION_BONUS_LTR_ASC',
  FACILITIES_STDDEV_POPULATION_BONUS_LTR_DESC = 'FACILITIES_STDDEV_POPULATION_BONUS_LTR_DESC',
  FACILITIES_STDDEV_POPULATION_CITY_ASC = 'FACILITIES_STDDEV_POPULATION_CITY_ASC',
  FACILITIES_STDDEV_POPULATION_CITY_DESC = 'FACILITIES_STDDEV_POPULATION_CITY_DESC',
  FACILITIES_STDDEV_POPULATION_COMMODITY_ASC = 'FACILITIES_STDDEV_POPULATION_COMMODITY_ASC',
  FACILITIES_STDDEV_POPULATION_COMMODITY_DESC = 'FACILITIES_STDDEV_POPULATION_COMMODITY_DESC',
  FACILITIES_STDDEV_POPULATION_CONTXT_9249_ASC = 'FACILITIES_STDDEV_POPULATION_CONTXT_9249_ASC',
  FACILITIES_STDDEV_POPULATION_CONTXT_9249_DESC = 'FACILITIES_STDDEV_POPULATION_CONTXT_9249_DESC',
  FACILITIES_STDDEV_POPULATION_COST_CENTER_ASC = 'FACILITIES_STDDEV_POPULATION_COST_CENTER_ASC',
  FACILITIES_STDDEV_POPULATION_COST_CENTER_DESC = 'FACILITIES_STDDEV_POPULATION_COST_CENTER_DESC',
  FACILITIES_STDDEV_POPULATION_COUNTRY_ASC = 'FACILITIES_STDDEV_POPULATION_COUNTRY_ASC',
  FACILITIES_STDDEV_POPULATION_COUNTRY_DESC = 'FACILITIES_STDDEV_POPULATION_COUNTRY_DESC',
  FACILITIES_STDDEV_POPULATION_CREATED_AT_ASC = 'FACILITIES_STDDEV_POPULATION_CREATED_AT_ASC',
  FACILITIES_STDDEV_POPULATION_CREATED_AT_DESC = 'FACILITIES_STDDEV_POPULATION_CREATED_AT_DESC',
  FACILITIES_STDDEV_POPULATION_CUSTOMER_LOCATION_ID_ASC = 'FACILITIES_STDDEV_POPULATION_CUSTOMER_LOCATION_ID_ASC',
  FACILITIES_STDDEV_POPULATION_CUSTOMER_LOCATION_ID_DESC = 'FACILITIES_STDDEV_POPULATION_CUSTOMER_LOCATION_ID_DESC',
  FACILITIES_STDDEV_POPULATION_DATATYPE_1_TEST_ASC = 'FACILITIES_STDDEV_POPULATION_DATATYPE_1_TEST_ASC',
  FACILITIES_STDDEV_POPULATION_DATATYPE_1_TEST_DESC = 'FACILITIES_STDDEV_POPULATION_DATATYPE_1_TEST_DESC',
  FACILITIES_STDDEV_POPULATION_DATA_TYPE_2_TEST_ASC = 'FACILITIES_STDDEV_POPULATION_DATA_TYPE_2_TEST_ASC',
  FACILITIES_STDDEV_POPULATION_DATA_TYPE_2_TEST_DESC = 'FACILITIES_STDDEV_POPULATION_DATA_TYPE_2_TEST_DESC',
  FACILITIES_STDDEV_POPULATION_DATA_TYPE_3_TEST_ASC = 'FACILITIES_STDDEV_POPULATION_DATA_TYPE_3_TEST_ASC',
  FACILITIES_STDDEV_POPULATION_DATA_TYPE_3_TEST_DESC = 'FACILITIES_STDDEV_POPULATION_DATA_TYPE_3_TEST_DESC',
  FACILITIES_STDDEV_POPULATION_FACILITY_CONTACTS_ASC = 'FACILITIES_STDDEV_POPULATION_FACILITY_CONTACTS_ASC',
  FACILITIES_STDDEV_POPULATION_FACILITY_CONTACTS_DESC = 'FACILITIES_STDDEV_POPULATION_FACILITY_CONTACTS_DESC',
  FACILITIES_STDDEV_POPULATION_FLOOR_PLAN_GEOMETRY_ASC = 'FACILITIES_STDDEV_POPULATION_FLOOR_PLAN_GEOMETRY_ASC',
  FACILITIES_STDDEV_POPULATION_FLOOR_PLAN_GEOMETRY_DESC = 'FACILITIES_STDDEV_POPULATION_FLOOR_PLAN_GEOMETRY_DESC',
  FACILITIES_STDDEV_POPULATION_GEOMETRY_ASC = 'FACILITIES_STDDEV_POPULATION_GEOMETRY_ASC',
  FACILITIES_STDDEV_POPULATION_GEOMETRY_DESC = 'FACILITIES_STDDEV_POPULATION_GEOMETRY_DESC',
  FACILITIES_STDDEV_POPULATION_GO_LIVE_DATE_ASC = 'FACILITIES_STDDEV_POPULATION_GO_LIVE_DATE_ASC',
  FACILITIES_STDDEV_POPULATION_GO_LIVE_DATE_DESC = 'FACILITIES_STDDEV_POPULATION_GO_LIVE_DATE_DESC',
  FACILITIES_STDDEV_POPULATION_ID_ASC = 'FACILITIES_STDDEV_POPULATION_ID_ASC',
  FACILITIES_STDDEV_POPULATION_ID_DESC = 'FACILITIES_STDDEV_POPULATION_ID_DESC',
  FACILITIES_STDDEV_POPULATION_LATITUDE_ASC = 'FACILITIES_STDDEV_POPULATION_LATITUDE_ASC',
  FACILITIES_STDDEV_POPULATION_LATITUDE_DESC = 'FACILITIES_STDDEV_POPULATION_LATITUDE_DESC',
  FACILITIES_STDDEV_POPULATION_LINK_ACTIVE_ASC = 'FACILITIES_STDDEV_POPULATION_LINK_ACTIVE_ASC',
  FACILITIES_STDDEV_POPULATION_LINK_ACTIVE_DESC = 'FACILITIES_STDDEV_POPULATION_LINK_ACTIVE_DESC',
  FACILITIES_STDDEV_POPULATION_LONGITUDE_ASC = 'FACILITIES_STDDEV_POPULATION_LONGITUDE_ASC',
  FACILITIES_STDDEV_POPULATION_LONGITUDE_DESC = 'FACILITIES_STDDEV_POPULATION_LONGITUDE_DESC',
  FACILITIES_STDDEV_POPULATION_METRICS_ONE_ACTIVE_ASC = 'FACILITIES_STDDEV_POPULATION_METRICS_ONE_ACTIVE_ASC',
  FACILITIES_STDDEV_POPULATION_METRICS_ONE_ACTIVE_DESC = 'FACILITIES_STDDEV_POPULATION_METRICS_ONE_ACTIVE_DESC',
  FACILITIES_STDDEV_POPULATION_NAME_ASC = 'FACILITIES_STDDEV_POPULATION_NAME_ASC',
  FACILITIES_STDDEV_POPULATION_NAME_DESC = 'FACILITIES_STDDEV_POPULATION_NAME_DESC',
  FACILITIES_STDDEV_POPULATION_NOTE_ASC = 'FACILITIES_STDDEV_POPULATION_NOTE_ASC',
  FACILITIES_STDDEV_POPULATION_NOTE_DESC = 'FACILITIES_STDDEV_POPULATION_NOTE_DESC',
  FACILITIES_STDDEV_POPULATION_N_SIGHT_2_ACTIVE_ASC = 'FACILITIES_STDDEV_POPULATION_N_SIGHT_2_ACTIVE_ASC',
  FACILITIES_STDDEV_POPULATION_N_SIGHT_2_ACTIVE_DESC = 'FACILITIES_STDDEV_POPULATION_N_SIGHT_2_ACTIVE_DESC',
  FACILITIES_STDDEV_POPULATION_N_SIGHT_ACTIVE_ASC = 'FACILITIES_STDDEV_POPULATION_N_SIGHT_ACTIVE_ASC',
  FACILITIES_STDDEV_POPULATION_N_SIGHT_ACTIVE_DESC = 'FACILITIES_STDDEV_POPULATION_N_SIGHT_ACTIVE_DESC',
  FACILITIES_STDDEV_POPULATION_PRE_BONUS_EBITDA_ASC = 'FACILITIES_STDDEV_POPULATION_PRE_BONUS_EBITDA_ASC',
  FACILITIES_STDDEV_POPULATION_PRE_BONUS_EBITDA_DESC = 'FACILITIES_STDDEV_POPULATION_PRE_BONUS_EBITDA_DESC',
  FACILITIES_STDDEV_POPULATION_PRICING_NODE_ID_ASC = 'FACILITIES_STDDEV_POPULATION_PRICING_NODE_ID_ASC',
  FACILITIES_STDDEV_POPULATION_PRICING_NODE_ID_DESC = 'FACILITIES_STDDEV_POPULATION_PRICING_NODE_ID_DESC',
  FACILITIES_STDDEV_POPULATION_REAL_TIME_ENABLED_ASC = 'FACILITIES_STDDEV_POPULATION_REAL_TIME_ENABLED_ASC',
  FACILITIES_STDDEV_POPULATION_REAL_TIME_ENABLED_DESC = 'FACILITIES_STDDEV_POPULATION_REAL_TIME_ENABLED_DESC',
  FACILITIES_STDDEV_POPULATION_REFRIGERATIONVENDOR_ASC = 'FACILITIES_STDDEV_POPULATION_REFRIGERATIONVENDOR_ASC',
  FACILITIES_STDDEV_POPULATION_REFRIGERATIONVENDOR_DESC = 'FACILITIES_STDDEV_POPULATION_REFRIGERATIONVENDOR_DESC',
  FACILITIES_STDDEV_POPULATION_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'FACILITIES_STDDEV_POPULATION_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  FACILITIES_STDDEV_POPULATION_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'FACILITIES_STDDEV_POPULATION_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  FACILITIES_STDDEV_POPULATION_RETIRED_AT_ASC = 'FACILITIES_STDDEV_POPULATION_RETIRED_AT_ASC',
  FACILITIES_STDDEV_POPULATION_RETIRED_AT_DESC = 'FACILITIES_STDDEV_POPULATION_RETIRED_AT_DESC',
  FACILITIES_STDDEV_POPULATION_SLUG_ASC = 'FACILITIES_STDDEV_POPULATION_SLUG_ASC',
  FACILITIES_STDDEV_POPULATION_SLUG_DESC = 'FACILITIES_STDDEV_POPULATION_SLUG_DESC',
  FACILITIES_STDDEV_POPULATION_STATE_ASC = 'FACILITIES_STDDEV_POPULATION_STATE_ASC',
  FACILITIES_STDDEV_POPULATION_STATE_DESC = 'FACILITIES_STDDEV_POPULATION_STATE_DESC',
  FACILITIES_STDDEV_POPULATION_SUPPRESSE_FINANCIALS_ASC = 'FACILITIES_STDDEV_POPULATION_SUPPRESSE_FINANCIALS_ASC',
  FACILITIES_STDDEV_POPULATION_SUPPRESSE_FINANCIALS_DESC = 'FACILITIES_STDDEV_POPULATION_SUPPRESSE_FINANCIALS_DESC',
  FACILITIES_STDDEV_POPULATION_TAT_ATTRIBUTE_ASC = 'FACILITIES_STDDEV_POPULATION_TAT_ATTRIBUTE_ASC',
  FACILITIES_STDDEV_POPULATION_TAT_ATTRIBUTE_DESC = 'FACILITIES_STDDEV_POPULATION_TAT_ATTRIBUTE_DESC',
  FACILITIES_STDDEV_POPULATION_TIMEZONE_NAME_ASC = 'FACILITIES_STDDEV_POPULATION_TIMEZONE_NAME_ASC',
  FACILITIES_STDDEV_POPULATION_TIMEZONE_NAME_DESC = 'FACILITIES_STDDEV_POPULATION_TIMEZONE_NAME_DESC',
  FACILITIES_STDDEV_POPULATION_TYPE_ASC = 'FACILITIES_STDDEV_POPULATION_TYPE_ASC',
  FACILITIES_STDDEV_POPULATION_TYPE_DESC = 'FACILITIES_STDDEV_POPULATION_TYPE_DESC',
  FACILITIES_STDDEV_POPULATION_UNIT_GROUP_ASC = 'FACILITIES_STDDEV_POPULATION_UNIT_GROUP_ASC',
  FACILITIES_STDDEV_POPULATION_UNIT_GROUP_DESC = 'FACILITIES_STDDEV_POPULATION_UNIT_GROUP_DESC',
  FACILITIES_STDDEV_POPULATION_UPDATED_AT_ASC = 'FACILITIES_STDDEV_POPULATION_UPDATED_AT_ASC',
  FACILITIES_STDDEV_POPULATION_UPDATED_AT_DESC = 'FACILITIES_STDDEV_POPULATION_UPDATED_AT_DESC',
  FACILITIES_STDDEV_POPULATION_WMS_ASC = 'FACILITIES_STDDEV_POPULATION_WMS_ASC',
  FACILITIES_STDDEV_POPULATION_WMS_DESC = 'FACILITIES_STDDEV_POPULATION_WMS_DESC',
  FACILITIES_STDDEV_POPULATION_ZIP_ASC = 'FACILITIES_STDDEV_POPULATION_ZIP_ASC',
  FACILITIES_STDDEV_POPULATION_ZIP_DESC = 'FACILITIES_STDDEV_POPULATION_ZIP_DESC',
  FACILITIES_STDDEV_SAMPLE_ADDRESS_ASC = 'FACILITIES_STDDEV_SAMPLE_ADDRESS_ASC',
  FACILITIES_STDDEV_SAMPLE_ADDRESS_DESC = 'FACILITIES_STDDEV_SAMPLE_ADDRESS_DESC',
  FACILITIES_STDDEV_SAMPLE_BONUS_LTR_ASC = 'FACILITIES_STDDEV_SAMPLE_BONUS_LTR_ASC',
  FACILITIES_STDDEV_SAMPLE_BONUS_LTR_DESC = 'FACILITIES_STDDEV_SAMPLE_BONUS_LTR_DESC',
  FACILITIES_STDDEV_SAMPLE_CITY_ASC = 'FACILITIES_STDDEV_SAMPLE_CITY_ASC',
  FACILITIES_STDDEV_SAMPLE_CITY_DESC = 'FACILITIES_STDDEV_SAMPLE_CITY_DESC',
  FACILITIES_STDDEV_SAMPLE_COMMODITY_ASC = 'FACILITIES_STDDEV_SAMPLE_COMMODITY_ASC',
  FACILITIES_STDDEV_SAMPLE_COMMODITY_DESC = 'FACILITIES_STDDEV_SAMPLE_COMMODITY_DESC',
  FACILITIES_STDDEV_SAMPLE_CONTXT_9249_ASC = 'FACILITIES_STDDEV_SAMPLE_CONTXT_9249_ASC',
  FACILITIES_STDDEV_SAMPLE_CONTXT_9249_DESC = 'FACILITIES_STDDEV_SAMPLE_CONTXT_9249_DESC',
  FACILITIES_STDDEV_SAMPLE_COST_CENTER_ASC = 'FACILITIES_STDDEV_SAMPLE_COST_CENTER_ASC',
  FACILITIES_STDDEV_SAMPLE_COST_CENTER_DESC = 'FACILITIES_STDDEV_SAMPLE_COST_CENTER_DESC',
  FACILITIES_STDDEV_SAMPLE_COUNTRY_ASC = 'FACILITIES_STDDEV_SAMPLE_COUNTRY_ASC',
  FACILITIES_STDDEV_SAMPLE_COUNTRY_DESC = 'FACILITIES_STDDEV_SAMPLE_COUNTRY_DESC',
  FACILITIES_STDDEV_SAMPLE_CREATED_AT_ASC = 'FACILITIES_STDDEV_SAMPLE_CREATED_AT_ASC',
  FACILITIES_STDDEV_SAMPLE_CREATED_AT_DESC = 'FACILITIES_STDDEV_SAMPLE_CREATED_AT_DESC',
  FACILITIES_STDDEV_SAMPLE_CUSTOMER_LOCATION_ID_ASC = 'FACILITIES_STDDEV_SAMPLE_CUSTOMER_LOCATION_ID_ASC',
  FACILITIES_STDDEV_SAMPLE_CUSTOMER_LOCATION_ID_DESC = 'FACILITIES_STDDEV_SAMPLE_CUSTOMER_LOCATION_ID_DESC',
  FACILITIES_STDDEV_SAMPLE_DATATYPE_1_TEST_ASC = 'FACILITIES_STDDEV_SAMPLE_DATATYPE_1_TEST_ASC',
  FACILITIES_STDDEV_SAMPLE_DATATYPE_1_TEST_DESC = 'FACILITIES_STDDEV_SAMPLE_DATATYPE_1_TEST_DESC',
  FACILITIES_STDDEV_SAMPLE_DATA_TYPE_2_TEST_ASC = 'FACILITIES_STDDEV_SAMPLE_DATA_TYPE_2_TEST_ASC',
  FACILITIES_STDDEV_SAMPLE_DATA_TYPE_2_TEST_DESC = 'FACILITIES_STDDEV_SAMPLE_DATA_TYPE_2_TEST_DESC',
  FACILITIES_STDDEV_SAMPLE_DATA_TYPE_3_TEST_ASC = 'FACILITIES_STDDEV_SAMPLE_DATA_TYPE_3_TEST_ASC',
  FACILITIES_STDDEV_SAMPLE_DATA_TYPE_3_TEST_DESC = 'FACILITIES_STDDEV_SAMPLE_DATA_TYPE_3_TEST_DESC',
  FACILITIES_STDDEV_SAMPLE_FACILITY_CONTACTS_ASC = 'FACILITIES_STDDEV_SAMPLE_FACILITY_CONTACTS_ASC',
  FACILITIES_STDDEV_SAMPLE_FACILITY_CONTACTS_DESC = 'FACILITIES_STDDEV_SAMPLE_FACILITY_CONTACTS_DESC',
  FACILITIES_STDDEV_SAMPLE_FLOOR_PLAN_GEOMETRY_ASC = 'FACILITIES_STDDEV_SAMPLE_FLOOR_PLAN_GEOMETRY_ASC',
  FACILITIES_STDDEV_SAMPLE_FLOOR_PLAN_GEOMETRY_DESC = 'FACILITIES_STDDEV_SAMPLE_FLOOR_PLAN_GEOMETRY_DESC',
  FACILITIES_STDDEV_SAMPLE_GEOMETRY_ASC = 'FACILITIES_STDDEV_SAMPLE_GEOMETRY_ASC',
  FACILITIES_STDDEV_SAMPLE_GEOMETRY_DESC = 'FACILITIES_STDDEV_SAMPLE_GEOMETRY_DESC',
  FACILITIES_STDDEV_SAMPLE_GO_LIVE_DATE_ASC = 'FACILITIES_STDDEV_SAMPLE_GO_LIVE_DATE_ASC',
  FACILITIES_STDDEV_SAMPLE_GO_LIVE_DATE_DESC = 'FACILITIES_STDDEV_SAMPLE_GO_LIVE_DATE_DESC',
  FACILITIES_STDDEV_SAMPLE_ID_ASC = 'FACILITIES_STDDEV_SAMPLE_ID_ASC',
  FACILITIES_STDDEV_SAMPLE_ID_DESC = 'FACILITIES_STDDEV_SAMPLE_ID_DESC',
  FACILITIES_STDDEV_SAMPLE_LATITUDE_ASC = 'FACILITIES_STDDEV_SAMPLE_LATITUDE_ASC',
  FACILITIES_STDDEV_SAMPLE_LATITUDE_DESC = 'FACILITIES_STDDEV_SAMPLE_LATITUDE_DESC',
  FACILITIES_STDDEV_SAMPLE_LINK_ACTIVE_ASC = 'FACILITIES_STDDEV_SAMPLE_LINK_ACTIVE_ASC',
  FACILITIES_STDDEV_SAMPLE_LINK_ACTIVE_DESC = 'FACILITIES_STDDEV_SAMPLE_LINK_ACTIVE_DESC',
  FACILITIES_STDDEV_SAMPLE_LONGITUDE_ASC = 'FACILITIES_STDDEV_SAMPLE_LONGITUDE_ASC',
  FACILITIES_STDDEV_SAMPLE_LONGITUDE_DESC = 'FACILITIES_STDDEV_SAMPLE_LONGITUDE_DESC',
  FACILITIES_STDDEV_SAMPLE_METRICS_ONE_ACTIVE_ASC = 'FACILITIES_STDDEV_SAMPLE_METRICS_ONE_ACTIVE_ASC',
  FACILITIES_STDDEV_SAMPLE_METRICS_ONE_ACTIVE_DESC = 'FACILITIES_STDDEV_SAMPLE_METRICS_ONE_ACTIVE_DESC',
  FACILITIES_STDDEV_SAMPLE_NAME_ASC = 'FACILITIES_STDDEV_SAMPLE_NAME_ASC',
  FACILITIES_STDDEV_SAMPLE_NAME_DESC = 'FACILITIES_STDDEV_SAMPLE_NAME_DESC',
  FACILITIES_STDDEV_SAMPLE_NOTE_ASC = 'FACILITIES_STDDEV_SAMPLE_NOTE_ASC',
  FACILITIES_STDDEV_SAMPLE_NOTE_DESC = 'FACILITIES_STDDEV_SAMPLE_NOTE_DESC',
  FACILITIES_STDDEV_SAMPLE_N_SIGHT_2_ACTIVE_ASC = 'FACILITIES_STDDEV_SAMPLE_N_SIGHT_2_ACTIVE_ASC',
  FACILITIES_STDDEV_SAMPLE_N_SIGHT_2_ACTIVE_DESC = 'FACILITIES_STDDEV_SAMPLE_N_SIGHT_2_ACTIVE_DESC',
  FACILITIES_STDDEV_SAMPLE_N_SIGHT_ACTIVE_ASC = 'FACILITIES_STDDEV_SAMPLE_N_SIGHT_ACTIVE_ASC',
  FACILITIES_STDDEV_SAMPLE_N_SIGHT_ACTIVE_DESC = 'FACILITIES_STDDEV_SAMPLE_N_SIGHT_ACTIVE_DESC',
  FACILITIES_STDDEV_SAMPLE_PRE_BONUS_EBITDA_ASC = 'FACILITIES_STDDEV_SAMPLE_PRE_BONUS_EBITDA_ASC',
  FACILITIES_STDDEV_SAMPLE_PRE_BONUS_EBITDA_DESC = 'FACILITIES_STDDEV_SAMPLE_PRE_BONUS_EBITDA_DESC',
  FACILITIES_STDDEV_SAMPLE_PRICING_NODE_ID_ASC = 'FACILITIES_STDDEV_SAMPLE_PRICING_NODE_ID_ASC',
  FACILITIES_STDDEV_SAMPLE_PRICING_NODE_ID_DESC = 'FACILITIES_STDDEV_SAMPLE_PRICING_NODE_ID_DESC',
  FACILITIES_STDDEV_SAMPLE_REAL_TIME_ENABLED_ASC = 'FACILITIES_STDDEV_SAMPLE_REAL_TIME_ENABLED_ASC',
  FACILITIES_STDDEV_SAMPLE_REAL_TIME_ENABLED_DESC = 'FACILITIES_STDDEV_SAMPLE_REAL_TIME_ENABLED_DESC',
  FACILITIES_STDDEV_SAMPLE_REFRIGERATIONVENDOR_ASC = 'FACILITIES_STDDEV_SAMPLE_REFRIGERATIONVENDOR_ASC',
  FACILITIES_STDDEV_SAMPLE_REFRIGERATIONVENDOR_DESC = 'FACILITIES_STDDEV_SAMPLE_REFRIGERATIONVENDOR_DESC',
  FACILITIES_STDDEV_SAMPLE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'FACILITIES_STDDEV_SAMPLE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  FACILITIES_STDDEV_SAMPLE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'FACILITIES_STDDEV_SAMPLE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  FACILITIES_STDDEV_SAMPLE_RETIRED_AT_ASC = 'FACILITIES_STDDEV_SAMPLE_RETIRED_AT_ASC',
  FACILITIES_STDDEV_SAMPLE_RETIRED_AT_DESC = 'FACILITIES_STDDEV_SAMPLE_RETIRED_AT_DESC',
  FACILITIES_STDDEV_SAMPLE_SLUG_ASC = 'FACILITIES_STDDEV_SAMPLE_SLUG_ASC',
  FACILITIES_STDDEV_SAMPLE_SLUG_DESC = 'FACILITIES_STDDEV_SAMPLE_SLUG_DESC',
  FACILITIES_STDDEV_SAMPLE_STATE_ASC = 'FACILITIES_STDDEV_SAMPLE_STATE_ASC',
  FACILITIES_STDDEV_SAMPLE_STATE_DESC = 'FACILITIES_STDDEV_SAMPLE_STATE_DESC',
  FACILITIES_STDDEV_SAMPLE_SUPPRESSE_FINANCIALS_ASC = 'FACILITIES_STDDEV_SAMPLE_SUPPRESSE_FINANCIALS_ASC',
  FACILITIES_STDDEV_SAMPLE_SUPPRESSE_FINANCIALS_DESC = 'FACILITIES_STDDEV_SAMPLE_SUPPRESSE_FINANCIALS_DESC',
  FACILITIES_STDDEV_SAMPLE_TAT_ATTRIBUTE_ASC = 'FACILITIES_STDDEV_SAMPLE_TAT_ATTRIBUTE_ASC',
  FACILITIES_STDDEV_SAMPLE_TAT_ATTRIBUTE_DESC = 'FACILITIES_STDDEV_SAMPLE_TAT_ATTRIBUTE_DESC',
  FACILITIES_STDDEV_SAMPLE_TIMEZONE_NAME_ASC = 'FACILITIES_STDDEV_SAMPLE_TIMEZONE_NAME_ASC',
  FACILITIES_STDDEV_SAMPLE_TIMEZONE_NAME_DESC = 'FACILITIES_STDDEV_SAMPLE_TIMEZONE_NAME_DESC',
  FACILITIES_STDDEV_SAMPLE_TYPE_ASC = 'FACILITIES_STDDEV_SAMPLE_TYPE_ASC',
  FACILITIES_STDDEV_SAMPLE_TYPE_DESC = 'FACILITIES_STDDEV_SAMPLE_TYPE_DESC',
  FACILITIES_STDDEV_SAMPLE_UNIT_GROUP_ASC = 'FACILITIES_STDDEV_SAMPLE_UNIT_GROUP_ASC',
  FACILITIES_STDDEV_SAMPLE_UNIT_GROUP_DESC = 'FACILITIES_STDDEV_SAMPLE_UNIT_GROUP_DESC',
  FACILITIES_STDDEV_SAMPLE_UPDATED_AT_ASC = 'FACILITIES_STDDEV_SAMPLE_UPDATED_AT_ASC',
  FACILITIES_STDDEV_SAMPLE_UPDATED_AT_DESC = 'FACILITIES_STDDEV_SAMPLE_UPDATED_AT_DESC',
  FACILITIES_STDDEV_SAMPLE_WMS_ASC = 'FACILITIES_STDDEV_SAMPLE_WMS_ASC',
  FACILITIES_STDDEV_SAMPLE_WMS_DESC = 'FACILITIES_STDDEV_SAMPLE_WMS_DESC',
  FACILITIES_STDDEV_SAMPLE_ZIP_ASC = 'FACILITIES_STDDEV_SAMPLE_ZIP_ASC',
  FACILITIES_STDDEV_SAMPLE_ZIP_DESC = 'FACILITIES_STDDEV_SAMPLE_ZIP_DESC',
  FACILITIES_SUM_ADDRESS_ASC = 'FACILITIES_SUM_ADDRESS_ASC',
  FACILITIES_SUM_ADDRESS_DESC = 'FACILITIES_SUM_ADDRESS_DESC',
  FACILITIES_SUM_BONUS_LTR_ASC = 'FACILITIES_SUM_BONUS_LTR_ASC',
  FACILITIES_SUM_BONUS_LTR_DESC = 'FACILITIES_SUM_BONUS_LTR_DESC',
  FACILITIES_SUM_CITY_ASC = 'FACILITIES_SUM_CITY_ASC',
  FACILITIES_SUM_CITY_DESC = 'FACILITIES_SUM_CITY_DESC',
  FACILITIES_SUM_COMMODITY_ASC = 'FACILITIES_SUM_COMMODITY_ASC',
  FACILITIES_SUM_COMMODITY_DESC = 'FACILITIES_SUM_COMMODITY_DESC',
  FACILITIES_SUM_CONTXT_9249_ASC = 'FACILITIES_SUM_CONTXT_9249_ASC',
  FACILITIES_SUM_CONTXT_9249_DESC = 'FACILITIES_SUM_CONTXT_9249_DESC',
  FACILITIES_SUM_COST_CENTER_ASC = 'FACILITIES_SUM_COST_CENTER_ASC',
  FACILITIES_SUM_COST_CENTER_DESC = 'FACILITIES_SUM_COST_CENTER_DESC',
  FACILITIES_SUM_COUNTRY_ASC = 'FACILITIES_SUM_COUNTRY_ASC',
  FACILITIES_SUM_COUNTRY_DESC = 'FACILITIES_SUM_COUNTRY_DESC',
  FACILITIES_SUM_CREATED_AT_ASC = 'FACILITIES_SUM_CREATED_AT_ASC',
  FACILITIES_SUM_CREATED_AT_DESC = 'FACILITIES_SUM_CREATED_AT_DESC',
  FACILITIES_SUM_CUSTOMER_LOCATION_ID_ASC = 'FACILITIES_SUM_CUSTOMER_LOCATION_ID_ASC',
  FACILITIES_SUM_CUSTOMER_LOCATION_ID_DESC = 'FACILITIES_SUM_CUSTOMER_LOCATION_ID_DESC',
  FACILITIES_SUM_DATATYPE_1_TEST_ASC = 'FACILITIES_SUM_DATATYPE_1_TEST_ASC',
  FACILITIES_SUM_DATATYPE_1_TEST_DESC = 'FACILITIES_SUM_DATATYPE_1_TEST_DESC',
  FACILITIES_SUM_DATA_TYPE_2_TEST_ASC = 'FACILITIES_SUM_DATA_TYPE_2_TEST_ASC',
  FACILITIES_SUM_DATA_TYPE_2_TEST_DESC = 'FACILITIES_SUM_DATA_TYPE_2_TEST_DESC',
  FACILITIES_SUM_DATA_TYPE_3_TEST_ASC = 'FACILITIES_SUM_DATA_TYPE_3_TEST_ASC',
  FACILITIES_SUM_DATA_TYPE_3_TEST_DESC = 'FACILITIES_SUM_DATA_TYPE_3_TEST_DESC',
  FACILITIES_SUM_FACILITY_CONTACTS_ASC = 'FACILITIES_SUM_FACILITY_CONTACTS_ASC',
  FACILITIES_SUM_FACILITY_CONTACTS_DESC = 'FACILITIES_SUM_FACILITY_CONTACTS_DESC',
  FACILITIES_SUM_FLOOR_PLAN_GEOMETRY_ASC = 'FACILITIES_SUM_FLOOR_PLAN_GEOMETRY_ASC',
  FACILITIES_SUM_FLOOR_PLAN_GEOMETRY_DESC = 'FACILITIES_SUM_FLOOR_PLAN_GEOMETRY_DESC',
  FACILITIES_SUM_GEOMETRY_ASC = 'FACILITIES_SUM_GEOMETRY_ASC',
  FACILITIES_SUM_GEOMETRY_DESC = 'FACILITIES_SUM_GEOMETRY_DESC',
  FACILITIES_SUM_GO_LIVE_DATE_ASC = 'FACILITIES_SUM_GO_LIVE_DATE_ASC',
  FACILITIES_SUM_GO_LIVE_DATE_DESC = 'FACILITIES_SUM_GO_LIVE_DATE_DESC',
  FACILITIES_SUM_ID_ASC = 'FACILITIES_SUM_ID_ASC',
  FACILITIES_SUM_ID_DESC = 'FACILITIES_SUM_ID_DESC',
  FACILITIES_SUM_LATITUDE_ASC = 'FACILITIES_SUM_LATITUDE_ASC',
  FACILITIES_SUM_LATITUDE_DESC = 'FACILITIES_SUM_LATITUDE_DESC',
  FACILITIES_SUM_LINK_ACTIVE_ASC = 'FACILITIES_SUM_LINK_ACTIVE_ASC',
  FACILITIES_SUM_LINK_ACTIVE_DESC = 'FACILITIES_SUM_LINK_ACTIVE_DESC',
  FACILITIES_SUM_LONGITUDE_ASC = 'FACILITIES_SUM_LONGITUDE_ASC',
  FACILITIES_SUM_LONGITUDE_DESC = 'FACILITIES_SUM_LONGITUDE_DESC',
  FACILITIES_SUM_METRICS_ONE_ACTIVE_ASC = 'FACILITIES_SUM_METRICS_ONE_ACTIVE_ASC',
  FACILITIES_SUM_METRICS_ONE_ACTIVE_DESC = 'FACILITIES_SUM_METRICS_ONE_ACTIVE_DESC',
  FACILITIES_SUM_NAME_ASC = 'FACILITIES_SUM_NAME_ASC',
  FACILITIES_SUM_NAME_DESC = 'FACILITIES_SUM_NAME_DESC',
  FACILITIES_SUM_NOTE_ASC = 'FACILITIES_SUM_NOTE_ASC',
  FACILITIES_SUM_NOTE_DESC = 'FACILITIES_SUM_NOTE_DESC',
  FACILITIES_SUM_N_SIGHT_2_ACTIVE_ASC = 'FACILITIES_SUM_N_SIGHT_2_ACTIVE_ASC',
  FACILITIES_SUM_N_SIGHT_2_ACTIVE_DESC = 'FACILITIES_SUM_N_SIGHT_2_ACTIVE_DESC',
  FACILITIES_SUM_N_SIGHT_ACTIVE_ASC = 'FACILITIES_SUM_N_SIGHT_ACTIVE_ASC',
  FACILITIES_SUM_N_SIGHT_ACTIVE_DESC = 'FACILITIES_SUM_N_SIGHT_ACTIVE_DESC',
  FACILITIES_SUM_PRE_BONUS_EBITDA_ASC = 'FACILITIES_SUM_PRE_BONUS_EBITDA_ASC',
  FACILITIES_SUM_PRE_BONUS_EBITDA_DESC = 'FACILITIES_SUM_PRE_BONUS_EBITDA_DESC',
  FACILITIES_SUM_PRICING_NODE_ID_ASC = 'FACILITIES_SUM_PRICING_NODE_ID_ASC',
  FACILITIES_SUM_PRICING_NODE_ID_DESC = 'FACILITIES_SUM_PRICING_NODE_ID_DESC',
  FACILITIES_SUM_REAL_TIME_ENABLED_ASC = 'FACILITIES_SUM_REAL_TIME_ENABLED_ASC',
  FACILITIES_SUM_REAL_TIME_ENABLED_DESC = 'FACILITIES_SUM_REAL_TIME_ENABLED_DESC',
  FACILITIES_SUM_REFRIGERATIONVENDOR_ASC = 'FACILITIES_SUM_REFRIGERATIONVENDOR_ASC',
  FACILITIES_SUM_REFRIGERATIONVENDOR_DESC = 'FACILITIES_SUM_REFRIGERATIONVENDOR_DESC',
  FACILITIES_SUM_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'FACILITIES_SUM_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  FACILITIES_SUM_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'FACILITIES_SUM_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  FACILITIES_SUM_RETIRED_AT_ASC = 'FACILITIES_SUM_RETIRED_AT_ASC',
  FACILITIES_SUM_RETIRED_AT_DESC = 'FACILITIES_SUM_RETIRED_AT_DESC',
  FACILITIES_SUM_SLUG_ASC = 'FACILITIES_SUM_SLUG_ASC',
  FACILITIES_SUM_SLUG_DESC = 'FACILITIES_SUM_SLUG_DESC',
  FACILITIES_SUM_STATE_ASC = 'FACILITIES_SUM_STATE_ASC',
  FACILITIES_SUM_STATE_DESC = 'FACILITIES_SUM_STATE_DESC',
  FACILITIES_SUM_SUPPRESSE_FINANCIALS_ASC = 'FACILITIES_SUM_SUPPRESSE_FINANCIALS_ASC',
  FACILITIES_SUM_SUPPRESSE_FINANCIALS_DESC = 'FACILITIES_SUM_SUPPRESSE_FINANCIALS_DESC',
  FACILITIES_SUM_TAT_ATTRIBUTE_ASC = 'FACILITIES_SUM_TAT_ATTRIBUTE_ASC',
  FACILITIES_SUM_TAT_ATTRIBUTE_DESC = 'FACILITIES_SUM_TAT_ATTRIBUTE_DESC',
  FACILITIES_SUM_TIMEZONE_NAME_ASC = 'FACILITIES_SUM_TIMEZONE_NAME_ASC',
  FACILITIES_SUM_TIMEZONE_NAME_DESC = 'FACILITIES_SUM_TIMEZONE_NAME_DESC',
  FACILITIES_SUM_TYPE_ASC = 'FACILITIES_SUM_TYPE_ASC',
  FACILITIES_SUM_TYPE_DESC = 'FACILITIES_SUM_TYPE_DESC',
  FACILITIES_SUM_UNIT_GROUP_ASC = 'FACILITIES_SUM_UNIT_GROUP_ASC',
  FACILITIES_SUM_UNIT_GROUP_DESC = 'FACILITIES_SUM_UNIT_GROUP_DESC',
  FACILITIES_SUM_UPDATED_AT_ASC = 'FACILITIES_SUM_UPDATED_AT_ASC',
  FACILITIES_SUM_UPDATED_AT_DESC = 'FACILITIES_SUM_UPDATED_AT_DESC',
  FACILITIES_SUM_WMS_ASC = 'FACILITIES_SUM_WMS_ASC',
  FACILITIES_SUM_WMS_DESC = 'FACILITIES_SUM_WMS_DESC',
  FACILITIES_SUM_ZIP_ASC = 'FACILITIES_SUM_ZIP_ASC',
  FACILITIES_SUM_ZIP_DESC = 'FACILITIES_SUM_ZIP_DESC',
  FACILITIES_VARIANCE_POPULATION_ADDRESS_ASC = 'FACILITIES_VARIANCE_POPULATION_ADDRESS_ASC',
  FACILITIES_VARIANCE_POPULATION_ADDRESS_DESC = 'FACILITIES_VARIANCE_POPULATION_ADDRESS_DESC',
  FACILITIES_VARIANCE_POPULATION_BONUS_LTR_ASC = 'FACILITIES_VARIANCE_POPULATION_BONUS_LTR_ASC',
  FACILITIES_VARIANCE_POPULATION_BONUS_LTR_DESC = 'FACILITIES_VARIANCE_POPULATION_BONUS_LTR_DESC',
  FACILITIES_VARIANCE_POPULATION_CITY_ASC = 'FACILITIES_VARIANCE_POPULATION_CITY_ASC',
  FACILITIES_VARIANCE_POPULATION_CITY_DESC = 'FACILITIES_VARIANCE_POPULATION_CITY_DESC',
  FACILITIES_VARIANCE_POPULATION_COMMODITY_ASC = 'FACILITIES_VARIANCE_POPULATION_COMMODITY_ASC',
  FACILITIES_VARIANCE_POPULATION_COMMODITY_DESC = 'FACILITIES_VARIANCE_POPULATION_COMMODITY_DESC',
  FACILITIES_VARIANCE_POPULATION_CONTXT_9249_ASC = 'FACILITIES_VARIANCE_POPULATION_CONTXT_9249_ASC',
  FACILITIES_VARIANCE_POPULATION_CONTXT_9249_DESC = 'FACILITIES_VARIANCE_POPULATION_CONTXT_9249_DESC',
  FACILITIES_VARIANCE_POPULATION_COST_CENTER_ASC = 'FACILITIES_VARIANCE_POPULATION_COST_CENTER_ASC',
  FACILITIES_VARIANCE_POPULATION_COST_CENTER_DESC = 'FACILITIES_VARIANCE_POPULATION_COST_CENTER_DESC',
  FACILITIES_VARIANCE_POPULATION_COUNTRY_ASC = 'FACILITIES_VARIANCE_POPULATION_COUNTRY_ASC',
  FACILITIES_VARIANCE_POPULATION_COUNTRY_DESC = 'FACILITIES_VARIANCE_POPULATION_COUNTRY_DESC',
  FACILITIES_VARIANCE_POPULATION_CREATED_AT_ASC = 'FACILITIES_VARIANCE_POPULATION_CREATED_AT_ASC',
  FACILITIES_VARIANCE_POPULATION_CREATED_AT_DESC = 'FACILITIES_VARIANCE_POPULATION_CREATED_AT_DESC',
  FACILITIES_VARIANCE_POPULATION_CUSTOMER_LOCATION_ID_ASC = 'FACILITIES_VARIANCE_POPULATION_CUSTOMER_LOCATION_ID_ASC',
  FACILITIES_VARIANCE_POPULATION_CUSTOMER_LOCATION_ID_DESC = 'FACILITIES_VARIANCE_POPULATION_CUSTOMER_LOCATION_ID_DESC',
  FACILITIES_VARIANCE_POPULATION_DATATYPE_1_TEST_ASC = 'FACILITIES_VARIANCE_POPULATION_DATATYPE_1_TEST_ASC',
  FACILITIES_VARIANCE_POPULATION_DATATYPE_1_TEST_DESC = 'FACILITIES_VARIANCE_POPULATION_DATATYPE_1_TEST_DESC',
  FACILITIES_VARIANCE_POPULATION_DATA_TYPE_2_TEST_ASC = 'FACILITIES_VARIANCE_POPULATION_DATA_TYPE_2_TEST_ASC',
  FACILITIES_VARIANCE_POPULATION_DATA_TYPE_2_TEST_DESC = 'FACILITIES_VARIANCE_POPULATION_DATA_TYPE_2_TEST_DESC',
  FACILITIES_VARIANCE_POPULATION_DATA_TYPE_3_TEST_ASC = 'FACILITIES_VARIANCE_POPULATION_DATA_TYPE_3_TEST_ASC',
  FACILITIES_VARIANCE_POPULATION_DATA_TYPE_3_TEST_DESC = 'FACILITIES_VARIANCE_POPULATION_DATA_TYPE_3_TEST_DESC',
  FACILITIES_VARIANCE_POPULATION_FACILITY_CONTACTS_ASC = 'FACILITIES_VARIANCE_POPULATION_FACILITY_CONTACTS_ASC',
  FACILITIES_VARIANCE_POPULATION_FACILITY_CONTACTS_DESC = 'FACILITIES_VARIANCE_POPULATION_FACILITY_CONTACTS_DESC',
  FACILITIES_VARIANCE_POPULATION_FLOOR_PLAN_GEOMETRY_ASC = 'FACILITIES_VARIANCE_POPULATION_FLOOR_PLAN_GEOMETRY_ASC',
  FACILITIES_VARIANCE_POPULATION_FLOOR_PLAN_GEOMETRY_DESC = 'FACILITIES_VARIANCE_POPULATION_FLOOR_PLAN_GEOMETRY_DESC',
  FACILITIES_VARIANCE_POPULATION_GEOMETRY_ASC = 'FACILITIES_VARIANCE_POPULATION_GEOMETRY_ASC',
  FACILITIES_VARIANCE_POPULATION_GEOMETRY_DESC = 'FACILITIES_VARIANCE_POPULATION_GEOMETRY_DESC',
  FACILITIES_VARIANCE_POPULATION_GO_LIVE_DATE_ASC = 'FACILITIES_VARIANCE_POPULATION_GO_LIVE_DATE_ASC',
  FACILITIES_VARIANCE_POPULATION_GO_LIVE_DATE_DESC = 'FACILITIES_VARIANCE_POPULATION_GO_LIVE_DATE_DESC',
  FACILITIES_VARIANCE_POPULATION_ID_ASC = 'FACILITIES_VARIANCE_POPULATION_ID_ASC',
  FACILITIES_VARIANCE_POPULATION_ID_DESC = 'FACILITIES_VARIANCE_POPULATION_ID_DESC',
  FACILITIES_VARIANCE_POPULATION_LATITUDE_ASC = 'FACILITIES_VARIANCE_POPULATION_LATITUDE_ASC',
  FACILITIES_VARIANCE_POPULATION_LATITUDE_DESC = 'FACILITIES_VARIANCE_POPULATION_LATITUDE_DESC',
  FACILITIES_VARIANCE_POPULATION_LINK_ACTIVE_ASC = 'FACILITIES_VARIANCE_POPULATION_LINK_ACTIVE_ASC',
  FACILITIES_VARIANCE_POPULATION_LINK_ACTIVE_DESC = 'FACILITIES_VARIANCE_POPULATION_LINK_ACTIVE_DESC',
  FACILITIES_VARIANCE_POPULATION_LONGITUDE_ASC = 'FACILITIES_VARIANCE_POPULATION_LONGITUDE_ASC',
  FACILITIES_VARIANCE_POPULATION_LONGITUDE_DESC = 'FACILITIES_VARIANCE_POPULATION_LONGITUDE_DESC',
  FACILITIES_VARIANCE_POPULATION_METRICS_ONE_ACTIVE_ASC = 'FACILITIES_VARIANCE_POPULATION_METRICS_ONE_ACTIVE_ASC',
  FACILITIES_VARIANCE_POPULATION_METRICS_ONE_ACTIVE_DESC = 'FACILITIES_VARIANCE_POPULATION_METRICS_ONE_ACTIVE_DESC',
  FACILITIES_VARIANCE_POPULATION_NAME_ASC = 'FACILITIES_VARIANCE_POPULATION_NAME_ASC',
  FACILITIES_VARIANCE_POPULATION_NAME_DESC = 'FACILITIES_VARIANCE_POPULATION_NAME_DESC',
  FACILITIES_VARIANCE_POPULATION_NOTE_ASC = 'FACILITIES_VARIANCE_POPULATION_NOTE_ASC',
  FACILITIES_VARIANCE_POPULATION_NOTE_DESC = 'FACILITIES_VARIANCE_POPULATION_NOTE_DESC',
  FACILITIES_VARIANCE_POPULATION_N_SIGHT_2_ACTIVE_ASC = 'FACILITIES_VARIANCE_POPULATION_N_SIGHT_2_ACTIVE_ASC',
  FACILITIES_VARIANCE_POPULATION_N_SIGHT_2_ACTIVE_DESC = 'FACILITIES_VARIANCE_POPULATION_N_SIGHT_2_ACTIVE_DESC',
  FACILITIES_VARIANCE_POPULATION_N_SIGHT_ACTIVE_ASC = 'FACILITIES_VARIANCE_POPULATION_N_SIGHT_ACTIVE_ASC',
  FACILITIES_VARIANCE_POPULATION_N_SIGHT_ACTIVE_DESC = 'FACILITIES_VARIANCE_POPULATION_N_SIGHT_ACTIVE_DESC',
  FACILITIES_VARIANCE_POPULATION_PRE_BONUS_EBITDA_ASC = 'FACILITIES_VARIANCE_POPULATION_PRE_BONUS_EBITDA_ASC',
  FACILITIES_VARIANCE_POPULATION_PRE_BONUS_EBITDA_DESC = 'FACILITIES_VARIANCE_POPULATION_PRE_BONUS_EBITDA_DESC',
  FACILITIES_VARIANCE_POPULATION_PRICING_NODE_ID_ASC = 'FACILITIES_VARIANCE_POPULATION_PRICING_NODE_ID_ASC',
  FACILITIES_VARIANCE_POPULATION_PRICING_NODE_ID_DESC = 'FACILITIES_VARIANCE_POPULATION_PRICING_NODE_ID_DESC',
  FACILITIES_VARIANCE_POPULATION_REAL_TIME_ENABLED_ASC = 'FACILITIES_VARIANCE_POPULATION_REAL_TIME_ENABLED_ASC',
  FACILITIES_VARIANCE_POPULATION_REAL_TIME_ENABLED_DESC = 'FACILITIES_VARIANCE_POPULATION_REAL_TIME_ENABLED_DESC',
  FACILITIES_VARIANCE_POPULATION_REFRIGERATIONVENDOR_ASC = 'FACILITIES_VARIANCE_POPULATION_REFRIGERATIONVENDOR_ASC',
  FACILITIES_VARIANCE_POPULATION_REFRIGERATIONVENDOR_DESC = 'FACILITIES_VARIANCE_POPULATION_REFRIGERATIONVENDOR_DESC',
  FACILITIES_VARIANCE_POPULATION_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'FACILITIES_VARIANCE_POPULATION_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  FACILITIES_VARIANCE_POPULATION_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'FACILITIES_VARIANCE_POPULATION_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  FACILITIES_VARIANCE_POPULATION_RETIRED_AT_ASC = 'FACILITIES_VARIANCE_POPULATION_RETIRED_AT_ASC',
  FACILITIES_VARIANCE_POPULATION_RETIRED_AT_DESC = 'FACILITIES_VARIANCE_POPULATION_RETIRED_AT_DESC',
  FACILITIES_VARIANCE_POPULATION_SLUG_ASC = 'FACILITIES_VARIANCE_POPULATION_SLUG_ASC',
  FACILITIES_VARIANCE_POPULATION_SLUG_DESC = 'FACILITIES_VARIANCE_POPULATION_SLUG_DESC',
  FACILITIES_VARIANCE_POPULATION_STATE_ASC = 'FACILITIES_VARIANCE_POPULATION_STATE_ASC',
  FACILITIES_VARIANCE_POPULATION_STATE_DESC = 'FACILITIES_VARIANCE_POPULATION_STATE_DESC',
  FACILITIES_VARIANCE_POPULATION_SUPPRESSE_FINANCIALS_ASC = 'FACILITIES_VARIANCE_POPULATION_SUPPRESSE_FINANCIALS_ASC',
  FACILITIES_VARIANCE_POPULATION_SUPPRESSE_FINANCIALS_DESC = 'FACILITIES_VARIANCE_POPULATION_SUPPRESSE_FINANCIALS_DESC',
  FACILITIES_VARIANCE_POPULATION_TAT_ATTRIBUTE_ASC = 'FACILITIES_VARIANCE_POPULATION_TAT_ATTRIBUTE_ASC',
  FACILITIES_VARIANCE_POPULATION_TAT_ATTRIBUTE_DESC = 'FACILITIES_VARIANCE_POPULATION_TAT_ATTRIBUTE_DESC',
  FACILITIES_VARIANCE_POPULATION_TIMEZONE_NAME_ASC = 'FACILITIES_VARIANCE_POPULATION_TIMEZONE_NAME_ASC',
  FACILITIES_VARIANCE_POPULATION_TIMEZONE_NAME_DESC = 'FACILITIES_VARIANCE_POPULATION_TIMEZONE_NAME_DESC',
  FACILITIES_VARIANCE_POPULATION_TYPE_ASC = 'FACILITIES_VARIANCE_POPULATION_TYPE_ASC',
  FACILITIES_VARIANCE_POPULATION_TYPE_DESC = 'FACILITIES_VARIANCE_POPULATION_TYPE_DESC',
  FACILITIES_VARIANCE_POPULATION_UNIT_GROUP_ASC = 'FACILITIES_VARIANCE_POPULATION_UNIT_GROUP_ASC',
  FACILITIES_VARIANCE_POPULATION_UNIT_GROUP_DESC = 'FACILITIES_VARIANCE_POPULATION_UNIT_GROUP_DESC',
  FACILITIES_VARIANCE_POPULATION_UPDATED_AT_ASC = 'FACILITIES_VARIANCE_POPULATION_UPDATED_AT_ASC',
  FACILITIES_VARIANCE_POPULATION_UPDATED_AT_DESC = 'FACILITIES_VARIANCE_POPULATION_UPDATED_AT_DESC',
  FACILITIES_VARIANCE_POPULATION_WMS_ASC = 'FACILITIES_VARIANCE_POPULATION_WMS_ASC',
  FACILITIES_VARIANCE_POPULATION_WMS_DESC = 'FACILITIES_VARIANCE_POPULATION_WMS_DESC',
  FACILITIES_VARIANCE_POPULATION_ZIP_ASC = 'FACILITIES_VARIANCE_POPULATION_ZIP_ASC',
  FACILITIES_VARIANCE_POPULATION_ZIP_DESC = 'FACILITIES_VARIANCE_POPULATION_ZIP_DESC',
  FACILITIES_VARIANCE_SAMPLE_ADDRESS_ASC = 'FACILITIES_VARIANCE_SAMPLE_ADDRESS_ASC',
  FACILITIES_VARIANCE_SAMPLE_ADDRESS_DESC = 'FACILITIES_VARIANCE_SAMPLE_ADDRESS_DESC',
  FACILITIES_VARIANCE_SAMPLE_BONUS_LTR_ASC = 'FACILITIES_VARIANCE_SAMPLE_BONUS_LTR_ASC',
  FACILITIES_VARIANCE_SAMPLE_BONUS_LTR_DESC = 'FACILITIES_VARIANCE_SAMPLE_BONUS_LTR_DESC',
  FACILITIES_VARIANCE_SAMPLE_CITY_ASC = 'FACILITIES_VARIANCE_SAMPLE_CITY_ASC',
  FACILITIES_VARIANCE_SAMPLE_CITY_DESC = 'FACILITIES_VARIANCE_SAMPLE_CITY_DESC',
  FACILITIES_VARIANCE_SAMPLE_COMMODITY_ASC = 'FACILITIES_VARIANCE_SAMPLE_COMMODITY_ASC',
  FACILITIES_VARIANCE_SAMPLE_COMMODITY_DESC = 'FACILITIES_VARIANCE_SAMPLE_COMMODITY_DESC',
  FACILITIES_VARIANCE_SAMPLE_CONTXT_9249_ASC = 'FACILITIES_VARIANCE_SAMPLE_CONTXT_9249_ASC',
  FACILITIES_VARIANCE_SAMPLE_CONTXT_9249_DESC = 'FACILITIES_VARIANCE_SAMPLE_CONTXT_9249_DESC',
  FACILITIES_VARIANCE_SAMPLE_COST_CENTER_ASC = 'FACILITIES_VARIANCE_SAMPLE_COST_CENTER_ASC',
  FACILITIES_VARIANCE_SAMPLE_COST_CENTER_DESC = 'FACILITIES_VARIANCE_SAMPLE_COST_CENTER_DESC',
  FACILITIES_VARIANCE_SAMPLE_COUNTRY_ASC = 'FACILITIES_VARIANCE_SAMPLE_COUNTRY_ASC',
  FACILITIES_VARIANCE_SAMPLE_COUNTRY_DESC = 'FACILITIES_VARIANCE_SAMPLE_COUNTRY_DESC',
  FACILITIES_VARIANCE_SAMPLE_CREATED_AT_ASC = 'FACILITIES_VARIANCE_SAMPLE_CREATED_AT_ASC',
  FACILITIES_VARIANCE_SAMPLE_CREATED_AT_DESC = 'FACILITIES_VARIANCE_SAMPLE_CREATED_AT_DESC',
  FACILITIES_VARIANCE_SAMPLE_CUSTOMER_LOCATION_ID_ASC = 'FACILITIES_VARIANCE_SAMPLE_CUSTOMER_LOCATION_ID_ASC',
  FACILITIES_VARIANCE_SAMPLE_CUSTOMER_LOCATION_ID_DESC = 'FACILITIES_VARIANCE_SAMPLE_CUSTOMER_LOCATION_ID_DESC',
  FACILITIES_VARIANCE_SAMPLE_DATATYPE_1_TEST_ASC = 'FACILITIES_VARIANCE_SAMPLE_DATATYPE_1_TEST_ASC',
  FACILITIES_VARIANCE_SAMPLE_DATATYPE_1_TEST_DESC = 'FACILITIES_VARIANCE_SAMPLE_DATATYPE_1_TEST_DESC',
  FACILITIES_VARIANCE_SAMPLE_DATA_TYPE_2_TEST_ASC = 'FACILITIES_VARIANCE_SAMPLE_DATA_TYPE_2_TEST_ASC',
  FACILITIES_VARIANCE_SAMPLE_DATA_TYPE_2_TEST_DESC = 'FACILITIES_VARIANCE_SAMPLE_DATA_TYPE_2_TEST_DESC',
  FACILITIES_VARIANCE_SAMPLE_DATA_TYPE_3_TEST_ASC = 'FACILITIES_VARIANCE_SAMPLE_DATA_TYPE_3_TEST_ASC',
  FACILITIES_VARIANCE_SAMPLE_DATA_TYPE_3_TEST_DESC = 'FACILITIES_VARIANCE_SAMPLE_DATA_TYPE_3_TEST_DESC',
  FACILITIES_VARIANCE_SAMPLE_FACILITY_CONTACTS_ASC = 'FACILITIES_VARIANCE_SAMPLE_FACILITY_CONTACTS_ASC',
  FACILITIES_VARIANCE_SAMPLE_FACILITY_CONTACTS_DESC = 'FACILITIES_VARIANCE_SAMPLE_FACILITY_CONTACTS_DESC',
  FACILITIES_VARIANCE_SAMPLE_FLOOR_PLAN_GEOMETRY_ASC = 'FACILITIES_VARIANCE_SAMPLE_FLOOR_PLAN_GEOMETRY_ASC',
  FACILITIES_VARIANCE_SAMPLE_FLOOR_PLAN_GEOMETRY_DESC = 'FACILITIES_VARIANCE_SAMPLE_FLOOR_PLAN_GEOMETRY_DESC',
  FACILITIES_VARIANCE_SAMPLE_GEOMETRY_ASC = 'FACILITIES_VARIANCE_SAMPLE_GEOMETRY_ASC',
  FACILITIES_VARIANCE_SAMPLE_GEOMETRY_DESC = 'FACILITIES_VARIANCE_SAMPLE_GEOMETRY_DESC',
  FACILITIES_VARIANCE_SAMPLE_GO_LIVE_DATE_ASC = 'FACILITIES_VARIANCE_SAMPLE_GO_LIVE_DATE_ASC',
  FACILITIES_VARIANCE_SAMPLE_GO_LIVE_DATE_DESC = 'FACILITIES_VARIANCE_SAMPLE_GO_LIVE_DATE_DESC',
  FACILITIES_VARIANCE_SAMPLE_ID_ASC = 'FACILITIES_VARIANCE_SAMPLE_ID_ASC',
  FACILITIES_VARIANCE_SAMPLE_ID_DESC = 'FACILITIES_VARIANCE_SAMPLE_ID_DESC',
  FACILITIES_VARIANCE_SAMPLE_LATITUDE_ASC = 'FACILITIES_VARIANCE_SAMPLE_LATITUDE_ASC',
  FACILITIES_VARIANCE_SAMPLE_LATITUDE_DESC = 'FACILITIES_VARIANCE_SAMPLE_LATITUDE_DESC',
  FACILITIES_VARIANCE_SAMPLE_LINK_ACTIVE_ASC = 'FACILITIES_VARIANCE_SAMPLE_LINK_ACTIVE_ASC',
  FACILITIES_VARIANCE_SAMPLE_LINK_ACTIVE_DESC = 'FACILITIES_VARIANCE_SAMPLE_LINK_ACTIVE_DESC',
  FACILITIES_VARIANCE_SAMPLE_LONGITUDE_ASC = 'FACILITIES_VARIANCE_SAMPLE_LONGITUDE_ASC',
  FACILITIES_VARIANCE_SAMPLE_LONGITUDE_DESC = 'FACILITIES_VARIANCE_SAMPLE_LONGITUDE_DESC',
  FACILITIES_VARIANCE_SAMPLE_METRICS_ONE_ACTIVE_ASC = 'FACILITIES_VARIANCE_SAMPLE_METRICS_ONE_ACTIVE_ASC',
  FACILITIES_VARIANCE_SAMPLE_METRICS_ONE_ACTIVE_DESC = 'FACILITIES_VARIANCE_SAMPLE_METRICS_ONE_ACTIVE_DESC',
  FACILITIES_VARIANCE_SAMPLE_NAME_ASC = 'FACILITIES_VARIANCE_SAMPLE_NAME_ASC',
  FACILITIES_VARIANCE_SAMPLE_NAME_DESC = 'FACILITIES_VARIANCE_SAMPLE_NAME_DESC',
  FACILITIES_VARIANCE_SAMPLE_NOTE_ASC = 'FACILITIES_VARIANCE_SAMPLE_NOTE_ASC',
  FACILITIES_VARIANCE_SAMPLE_NOTE_DESC = 'FACILITIES_VARIANCE_SAMPLE_NOTE_DESC',
  FACILITIES_VARIANCE_SAMPLE_N_SIGHT_2_ACTIVE_ASC = 'FACILITIES_VARIANCE_SAMPLE_N_SIGHT_2_ACTIVE_ASC',
  FACILITIES_VARIANCE_SAMPLE_N_SIGHT_2_ACTIVE_DESC = 'FACILITIES_VARIANCE_SAMPLE_N_SIGHT_2_ACTIVE_DESC',
  FACILITIES_VARIANCE_SAMPLE_N_SIGHT_ACTIVE_ASC = 'FACILITIES_VARIANCE_SAMPLE_N_SIGHT_ACTIVE_ASC',
  FACILITIES_VARIANCE_SAMPLE_N_SIGHT_ACTIVE_DESC = 'FACILITIES_VARIANCE_SAMPLE_N_SIGHT_ACTIVE_DESC',
  FACILITIES_VARIANCE_SAMPLE_PRE_BONUS_EBITDA_ASC = 'FACILITIES_VARIANCE_SAMPLE_PRE_BONUS_EBITDA_ASC',
  FACILITIES_VARIANCE_SAMPLE_PRE_BONUS_EBITDA_DESC = 'FACILITIES_VARIANCE_SAMPLE_PRE_BONUS_EBITDA_DESC',
  FACILITIES_VARIANCE_SAMPLE_PRICING_NODE_ID_ASC = 'FACILITIES_VARIANCE_SAMPLE_PRICING_NODE_ID_ASC',
  FACILITIES_VARIANCE_SAMPLE_PRICING_NODE_ID_DESC = 'FACILITIES_VARIANCE_SAMPLE_PRICING_NODE_ID_DESC',
  FACILITIES_VARIANCE_SAMPLE_REAL_TIME_ENABLED_ASC = 'FACILITIES_VARIANCE_SAMPLE_REAL_TIME_ENABLED_ASC',
  FACILITIES_VARIANCE_SAMPLE_REAL_TIME_ENABLED_DESC = 'FACILITIES_VARIANCE_SAMPLE_REAL_TIME_ENABLED_DESC',
  FACILITIES_VARIANCE_SAMPLE_REFRIGERATIONVENDOR_ASC = 'FACILITIES_VARIANCE_SAMPLE_REFRIGERATIONVENDOR_ASC',
  FACILITIES_VARIANCE_SAMPLE_REFRIGERATIONVENDOR_DESC = 'FACILITIES_VARIANCE_SAMPLE_REFRIGERATIONVENDOR_DESC',
  FACILITIES_VARIANCE_SAMPLE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'FACILITIES_VARIANCE_SAMPLE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  FACILITIES_VARIANCE_SAMPLE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'FACILITIES_VARIANCE_SAMPLE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  FACILITIES_VARIANCE_SAMPLE_RETIRED_AT_ASC = 'FACILITIES_VARIANCE_SAMPLE_RETIRED_AT_ASC',
  FACILITIES_VARIANCE_SAMPLE_RETIRED_AT_DESC = 'FACILITIES_VARIANCE_SAMPLE_RETIRED_AT_DESC',
  FACILITIES_VARIANCE_SAMPLE_SLUG_ASC = 'FACILITIES_VARIANCE_SAMPLE_SLUG_ASC',
  FACILITIES_VARIANCE_SAMPLE_SLUG_DESC = 'FACILITIES_VARIANCE_SAMPLE_SLUG_DESC',
  FACILITIES_VARIANCE_SAMPLE_STATE_ASC = 'FACILITIES_VARIANCE_SAMPLE_STATE_ASC',
  FACILITIES_VARIANCE_SAMPLE_STATE_DESC = 'FACILITIES_VARIANCE_SAMPLE_STATE_DESC',
  FACILITIES_VARIANCE_SAMPLE_SUPPRESSE_FINANCIALS_ASC = 'FACILITIES_VARIANCE_SAMPLE_SUPPRESSE_FINANCIALS_ASC',
  FACILITIES_VARIANCE_SAMPLE_SUPPRESSE_FINANCIALS_DESC = 'FACILITIES_VARIANCE_SAMPLE_SUPPRESSE_FINANCIALS_DESC',
  FACILITIES_VARIANCE_SAMPLE_TAT_ATTRIBUTE_ASC = 'FACILITIES_VARIANCE_SAMPLE_TAT_ATTRIBUTE_ASC',
  FACILITIES_VARIANCE_SAMPLE_TAT_ATTRIBUTE_DESC = 'FACILITIES_VARIANCE_SAMPLE_TAT_ATTRIBUTE_DESC',
  FACILITIES_VARIANCE_SAMPLE_TIMEZONE_NAME_ASC = 'FACILITIES_VARIANCE_SAMPLE_TIMEZONE_NAME_ASC',
  FACILITIES_VARIANCE_SAMPLE_TIMEZONE_NAME_DESC = 'FACILITIES_VARIANCE_SAMPLE_TIMEZONE_NAME_DESC',
  FACILITIES_VARIANCE_SAMPLE_TYPE_ASC = 'FACILITIES_VARIANCE_SAMPLE_TYPE_ASC',
  FACILITIES_VARIANCE_SAMPLE_TYPE_DESC = 'FACILITIES_VARIANCE_SAMPLE_TYPE_DESC',
  FACILITIES_VARIANCE_SAMPLE_UNIT_GROUP_ASC = 'FACILITIES_VARIANCE_SAMPLE_UNIT_GROUP_ASC',
  FACILITIES_VARIANCE_SAMPLE_UNIT_GROUP_DESC = 'FACILITIES_VARIANCE_SAMPLE_UNIT_GROUP_DESC',
  FACILITIES_VARIANCE_SAMPLE_UPDATED_AT_ASC = 'FACILITIES_VARIANCE_SAMPLE_UPDATED_AT_ASC',
  FACILITIES_VARIANCE_SAMPLE_UPDATED_AT_DESC = 'FACILITIES_VARIANCE_SAMPLE_UPDATED_AT_DESC',
  FACILITIES_VARIANCE_SAMPLE_WMS_ASC = 'FACILITIES_VARIANCE_SAMPLE_WMS_ASC',
  FACILITIES_VARIANCE_SAMPLE_WMS_DESC = 'FACILITIES_VARIANCE_SAMPLE_WMS_DESC',
  FACILITIES_VARIANCE_SAMPLE_ZIP_ASC = 'FACILITIES_VARIANCE_SAMPLE_ZIP_ASC',
  FACILITIES_VARIANCE_SAMPLE_ZIP_DESC = 'FACILITIES_VARIANCE_SAMPLE_ZIP_DESC',
  GEOMETRY_ASC = 'GEOMETRY_ASC',
  GEOMETRY_DESC = 'GEOMETRY_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  SLUG_ASC = 'SLUG_ASC',
  SLUG_DESC = 'SLUG_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

export type Product = Node & {
  __typename?: 'Product';
  /** Reads and enables pagination through a set of `Pallet`. */
  availablePallets: PalletsConnection;
  /** A readable category of the product */
  category?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Datetime']['output'];
  customer?: Maybe<Customer>;
  /** The source ID of the customer this product belongs to */
  customerSourceId?: Maybe<Scalars['String']['output']>;
  /** The globally unique external deletion identifier of the record. Sometimes this is different from sourceId due to change tracking semantics */
  deleteId?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['Datetime']['output']>;
  /** The product description */
  description?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Facility` that is related to this `Product`. */
  facility?: Maybe<Facility>;
  /** The originating facility of the product record */
  facilityId?: Maybe<Scalars['Int']['output']>;
  /** The total weight of each case, including the tare weight */
  grossWeight?: Maybe<Scalars['Float']['output']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['BigInt']['output'];
  /** The ideal blast-freezing hours for the referenced product */
  idealBlastHours?: Maybe<Scalars['Float']['output']>;
  /** The total weight of each case minus the tare weight */
  netWeight?: Maybe<Scalars['Float']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The unique local (facility-level) identifier of the product */
  productCode?: Maybe<Scalars['String']['output']>;
  /** Unit of measure for the product (cases, barrels, etc.) */
  productUom?: Maybe<Scalars['String']['output']>;
  /** The number of cases (or other product unit of measure) on a single pallet */
  quantity?: Maybe<Scalars['Int']['output']>;
  /** The type of room this product should be stored within */
  roomType?: Maybe<Scalars['String']['output']>;
  /** A readable, short description of the product */
  shortName?: Maybe<Scalars['String']['output']>;
  /** The globally unique external identifier of the record from the original source system */
  sourceId: Scalars['String']['output'];
  updatedAt: Scalars['Datetime']['output'];
  /** The version of the record */
  version?: Maybe<Scalars['BigInt']['output']>;
  /** Unit of measure for weight (lbs, kg) */
  weightUom?: Maybe<Scalars['String']['output']>;
};

export type ProductAvailablePalletsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<PalletFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** A condition to be used against `Product` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type ProductCondition = {
  /** Checks for equality with the object’s `category` field. */
  category?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `customerSourceId` field. */
  customerSourceId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `deleteId` field. */
  deleteId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `grossWeight` field. */
  grossWeight?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `idealBlastHours` field. */
  idealBlastHours?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `netWeight` field. */
  netWeight?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `productCode` field. */
  productCode?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `productUom` field. */
  productUom?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `quantity` field. */
  quantity?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `roomType` field. */
  roomType?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `shortName` field. */
  shortName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `sourceId` field. */
  sourceId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `version` field. */
  version?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `weightUom` field. */
  weightUom?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `Product` object types. All fields are combined with a logical ‘and.’ */
export type ProductFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProductFilter>>;
  /** Filter by the object’s `category` field. */
  category?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `customerSourceId` field. */
  customerSourceId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `deleteId` field. */
  deleteId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `grossWeight` field. */
  grossWeight?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `idealBlastHours` field. */
  idealBlastHours?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `netWeight` field. */
  netWeight?: InputMaybe<FloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProductFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProductFilter>>;
  /** Filter by the object’s `productCode` field. */
  productCode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `productUom` field. */
  productUom?: InputMaybe<StringFilter>;
  /** Filter by the object’s `quantity` field. */
  quantity?: InputMaybe<IntFilter>;
  /** Filter by the object’s `roomType` field. */
  roomType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `shortName` field. */
  shortName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `sourceId` field. */
  sourceId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `version` field. */
  version?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `weightUom` field. */
  weightUom?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `Product` */
export type ProductInput = {
  /** A readable category of the product */
  category?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** The source ID of the customer this product belongs to */
  customerSourceId?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** The product description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The originating facility of the product record */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** The total weight of each case, including the tare weight */
  grossWeight?: InputMaybe<Scalars['Float']['input']>;
  /** The ideal blast-freezing hours for the referenced product */
  idealBlastHours?: InputMaybe<Scalars['Float']['input']>;
  /** The total weight of each case minus the tare weight */
  netWeight?: InputMaybe<Scalars['Float']['input']>;
  /** The unique local (facility-level) identifier of the product */
  productCode?: InputMaybe<Scalars['String']['input']>;
  /** Unit of measure for the product (cases, barrels, etc.) */
  productUom?: InputMaybe<Scalars['String']['input']>;
  /** The number of cases (or other product unit of measure) on a single pallet */
  quantity?: InputMaybe<Scalars['Int']['input']>;
  /** The type of room this product should be stored within */
  roomType?: InputMaybe<Scalars['String']['input']>;
  /** A readable, short description of the product */
  shortName?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique external identifier of the record from the original source system */
  sourceId: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Unit of measure for weight (lbs, kg) */
  weightUom?: InputMaybe<Scalars['String']['input']>;
};

/** Represents an update to a `Product`. Fields that are set will be updated. */
export type ProductPatch = {
  /** A readable category of the product */
  category?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** The source ID of the customer this product belongs to */
  customerSourceId?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** The product description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The originating facility of the product record */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** The total weight of each case, including the tare weight */
  grossWeight?: InputMaybe<Scalars['Float']['input']>;
  /** The ideal blast-freezing hours for the referenced product */
  idealBlastHours?: InputMaybe<Scalars['Float']['input']>;
  /** The total weight of each case minus the tare weight */
  netWeight?: InputMaybe<Scalars['Float']['input']>;
  /** The unique local (facility-level) identifier of the product */
  productCode?: InputMaybe<Scalars['String']['input']>;
  /** Unit of measure for the product (cases, barrels, etc.) */
  productUom?: InputMaybe<Scalars['String']['input']>;
  /** The number of cases (or other product unit of measure) on a single pallet */
  quantity?: InputMaybe<Scalars['Int']['input']>;
  /** The type of room this product should be stored within */
  roomType?: InputMaybe<Scalars['String']['input']>;
  /** A readable, short description of the product */
  shortName?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique external identifier of the record from the original source system */
  sourceId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Unit of measure for weight (lbs, kg) */
  weightUom?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `Product` values. */
export type ProductsConnection = {
  __typename?: 'ProductsConnection';
  /** A list of edges which contains the `Product` and cursor to aid in pagination. */
  edges: Array<ProductsEdge>;
  /** A list of `Product` objects. */
  nodes: Array<Product>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Product` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Product` edge in the connection. */
export type ProductsEdge = {
  __typename?: 'ProductsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Product` at the end of the edge. */
  node: Product;
};

/** Methods to use when ordering `Product`. */
export enum ProductsOrderBy {
  CATEGORY_ASC = 'CATEGORY_ASC',
  CATEGORY_DESC = 'CATEGORY_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  CUSTOMER_SOURCE_ID_ASC = 'CUSTOMER_SOURCE_ID_ASC',
  CUSTOMER_SOURCE_ID_DESC = 'CUSTOMER_SOURCE_ID_DESC',
  DELETED_AT_ASC = 'DELETED_AT_ASC',
  DELETED_AT_DESC = 'DELETED_AT_DESC',
  DELETE_ID_ASC = 'DELETE_ID_ASC',
  DELETE_ID_DESC = 'DELETE_ID_DESC',
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  GROSS_WEIGHT_ASC = 'GROSS_WEIGHT_ASC',
  GROSS_WEIGHT_DESC = 'GROSS_WEIGHT_DESC',
  IDEAL_BLAST_HOURS_ASC = 'IDEAL_BLAST_HOURS_ASC',
  IDEAL_BLAST_HOURS_DESC = 'IDEAL_BLAST_HOURS_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  NET_WEIGHT_ASC = 'NET_WEIGHT_ASC',
  NET_WEIGHT_DESC = 'NET_WEIGHT_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  PRODUCT_CODE_ASC = 'PRODUCT_CODE_ASC',
  PRODUCT_CODE_DESC = 'PRODUCT_CODE_DESC',
  PRODUCT_UOM_ASC = 'PRODUCT_UOM_ASC',
  PRODUCT_UOM_DESC = 'PRODUCT_UOM_DESC',
  QUANTITY_ASC = 'QUANTITY_ASC',
  QUANTITY_DESC = 'QUANTITY_DESC',
  ROOM_TYPE_ASC = 'ROOM_TYPE_ASC',
  ROOM_TYPE_DESC = 'ROOM_TYPE_DESC',
  SHORT_NAME_ASC = 'SHORT_NAME_ASC',
  SHORT_NAME_DESC = 'SHORT_NAME_DESC',
  SOURCE_ID_ASC = 'SOURCE_ID_ASC',
  SOURCE_ID_DESC = 'SOURCE_ID_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  VERSION_ASC = 'VERSION_ASC',
  VERSION_DESC = 'VERSION_DESC',
  WEIGHT_UOM_ASC = 'WEIGHT_UOM_ASC',
  WEIGHT_UOM_DESC = 'WEIGHT_UOM_DESC'
}

/** A program describes sub types of project types. */
export type Program = Node & {
  __typename?: 'Program';
  balancingAuthoritySlug?: Maybe<Scalars['String']['output']>;
  /** Serialized configuration for the program */
  config?: Maybe<Scalars['JSON']['output']>;
  /** Reads and enables pagination through a set of `ProgramConfig`. */
  configs: ProgramConfigsConnection;
  /** The time the program was created. */
  createdAt: Scalars['Datetime']['output'];
  /** Demand Peaks for CP Program */
  demandPeaks?: Maybe<MetricDataConnection>;
  /** Returns the derived data point configuration for this connection */
  demandPeaksDataPoint?: Maybe<DerivedDataPoint>;
  /** The description of the program. */
  description?: Maybe<Scalars['String']['output']>;
  /** The grid demand value for the associated balancing authority. */
  gridDemand?: Maybe<MetricDataConnection>;
  /** Returns the derived data point configuration for this connection */
  gridDemandDataPoint?: Maybe<DerivedDataPoint>;
  /** The identifer of the program. */
  id: Scalars['Int']['output'];
  /** Indicates if suggestions will be created by automation when criteria is met. */
  isAutocreateSuggestions: Scalars['Boolean']['output'];
  /** The name of the program. */
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Normalized program identifier slug derived from the name used for consistent program matching and lookups. */
  normalizedSlug?: Maybe<Scalars['String']['output']>;
  /** Peak Alerts for CP Program */
  peakAlerts?: Maybe<MetricDataConnection>;
  /** Returns the derived data point configuration for this connection */
  peakAlertsDataPoint?: Maybe<DerivedDataPoint>;
  /** Reads and enables pagination through a set of `ProgramEnrollment`. */
  programEnrollments: ProgramEnrollmentsConnection;
  /** Reads a single `ProjectType` that is related to this `Program`. */
  projectType?: Maybe<ProjectType>;
  /** The id of the project type the program is associated with. */
  projectTypeId: Scalars['Int']['output'];
  /** Reads and enables pagination through a set of `Project`. */
  projects: ProjectsConnection;
  /** Returns savings event data for a given program, label and time range. */
  savingsEventsData: ProgramsSavingsEventsDataConnection;
  /** Reads a single `Timezone` that is related to this `Program`. */
  timezone?: Maybe<Timezone>;
  /** The timezone this program is based in. */
  timezoneName: Scalars['String']['output'];
  /** The time the program was updated. */
  updatedAt: Scalars['Datetime']['output'];
};

/** A program describes sub types of project types. */
export type ProgramConfigsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProgramConfigCondition>;
  filter?: InputMaybe<ProgramConfigFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProgramConfigsOrderBy>>;
};

/** A program describes sub types of project types. */
export type ProgramDemandPeaksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A program describes sub types of project types. */
export type ProgramGridDemandArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A program describes sub types of project types. */
export type ProgramPeakAlertsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A program describes sub types of project types. */
export type ProgramProgramEnrollmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProgramEnrollmentCondition>;
  filter?: InputMaybe<ProgramEnrollmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProgramEnrollmentsOrderBy>>;
};

/** A program describes sub types of project types. */
export type ProgramProjectsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProjectCondition>;
  filter?: InputMaybe<ProjectFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProjectsOrderBy>>;
};

/** A program describes sub types of project types. */
export type ProgramSavingsEventsDataArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  facilityIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  filter?: InputMaybe<ProgramsSavingsEventsDataRecordFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['Datetime']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['Datetime']['input']>;
  windowUnit?: InputMaybe<Scalars['String']['input']>;
};

/** A condition to be used against `Program` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type ProgramCondition = {
  /** Checks for equality with the object’s `config` field. */
  config?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `isAutocreateSuggestions` field. */
  isAutocreateSuggestions?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `normalizedSlug` field. */
  normalizedSlug?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `projectTypeId` field. */
  projectTypeId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `timezoneName` field. */
  timezoneName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export type ProgramConfig = Node & {
  __typename?: 'ProgramConfig';
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['Int']['output'];
  key?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Program` that is related to this `ProgramConfig`. */
  program?: Maybe<Program>;
  programId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  value?: Maybe<Scalars['JSON']['output']>;
};

/**
 * A condition to be used against `ProgramConfig` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ProgramConfigCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `key` field. */
  key?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `programId` field. */
  programId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['JSON']['input']>;
};

/** A filter to be used against `ProgramConfig` object types. All fields are combined with a logical ‘and.’ */
export type ProgramConfigFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProgramConfigFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `key` field. */
  key?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProgramConfigFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProgramConfigFilter>>;
  /** Filter by the object’s `programId` field. */
  programId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<JsonFilter>;
};

/** A connection to a list of `ProgramConfig` values. */
export type ProgramConfigsConnection = {
  __typename?: 'ProgramConfigsConnection';
  /** A list of edges which contains the `ProgramConfig` and cursor to aid in pagination. */
  edges: Array<ProgramConfigsEdge>;
  /** A list of `ProgramConfig` objects. */
  nodes: Array<ProgramConfig>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProgramConfig` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ProgramConfig` edge in the connection. */
export type ProgramConfigsEdge = {
  __typename?: 'ProgramConfigsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ProgramConfig` at the end of the edge. */
  node: ProgramConfig;
};

/** Methods to use when ordering `ProgramConfig`. */
export enum ProgramConfigsOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  KEY_ASC = 'KEY_ASC',
  KEY_DESC = 'KEY_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  PROGRAM_ID_ASC = 'PROGRAM_ID_ASC',
  PROGRAM_ID_DESC = 'PROGRAM_ID_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  VALUE_ASC = 'VALUE_ASC',
  VALUE_DESC = 'VALUE_DESC'
}

/** Tracks enrollment periods for a program. */
export type ProgramEnrollment = Node & {
  __typename?: 'ProgramEnrollment';
  createdAt: Scalars['Datetime']['output'];
  /** The end date of the enrollment period. */
  endDate: Scalars['Datetime']['output'];
  /** The identifer of the program enrollment. */
  id: Scalars['Int']['output'];
  /** The name of this program enrollment. */
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Program` that is related to this `ProgramEnrollment`. */
  program?: Maybe<Program>;
  /** The program this program enrollment belongs to. */
  programId: Scalars['Int']['output'];
  /** Reads and enables pagination through a set of `ProjectEnrollment`. */
  projectEnrollments: ProjectEnrollmentsConnection;
  /** The start date of the enrollment period. */
  startDate: Scalars['Datetime']['output'];
  updatedAt: Scalars['Datetime']['output'];
};

/** Tracks enrollment periods for a program. */
export type ProgramEnrollmentProjectEnrollmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProjectEnrollmentCondition>;
  filter?: InputMaybe<ProjectEnrollmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProjectEnrollmentsOrderBy>>;
};

/**
 * A condition to be used against `ProgramEnrollment` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ProgramEnrollmentCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `endDate` field. */
  endDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `programId` field. */
  programId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `startDate` field. */
  startDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `ProgramEnrollment` object types. All fields are combined with a logical ‘and.’ */
export type ProgramEnrollmentFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProgramEnrollmentFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `endDate` field. */
  endDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProgramEnrollmentFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProgramEnrollmentFilter>>;
  /** Filter by the object’s `programId` field. */
  programId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `startDate` field. */
  startDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `ProgramEnrollment` */
export type ProgramEnrollmentInput = {
  /** The end date of the enrollment period. */
  endDate: Scalars['Datetime']['input'];
  /** The name of this program enrollment. */
  name: Scalars['String']['input'];
  /** Mutates a `Program` as part of the payload */
  program?: InputMaybe<ProgramInput>;
  /** The program this program enrollment belongs to. */
  programId?: InputMaybe<Scalars['Int']['input']>;
  /** The start date of the enrollment period. */
  startDate: Scalars['Datetime']['input'];
};

/** Represents an update to a `ProgramEnrollment`. Fields that are set will be updated. */
export type ProgramEnrollmentPatch = {
  /** The end date of the enrollment period. */
  endDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** The name of this program enrollment. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The start date of the enrollment period. */
  startDate?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A connection to a list of `ProgramEnrollment` values. */
export type ProgramEnrollmentsConnection = {
  __typename?: 'ProgramEnrollmentsConnection';
  /** A list of edges which contains the `ProgramEnrollment` and cursor to aid in pagination. */
  edges: Array<ProgramEnrollmentsEdge>;
  /** A list of `ProgramEnrollment` objects. */
  nodes: Array<ProgramEnrollment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProgramEnrollment` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ProgramEnrollment` edge in the connection. */
export type ProgramEnrollmentsEdge = {
  __typename?: 'ProgramEnrollmentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ProgramEnrollment` at the end of the edge. */
  node: ProgramEnrollment;
};

/** Methods to use when ordering `ProgramEnrollment`. */
export enum ProgramEnrollmentsOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  END_DATE_ASC = 'END_DATE_ASC',
  END_DATE_DESC = 'END_DATE_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  PROGRAM_ID_ASC = 'PROGRAM_ID_ASC',
  PROGRAM_ID_DESC = 'PROGRAM_ID_DESC',
  START_DATE_ASC = 'START_DATE_ASC',
  START_DATE_DESC = 'START_DATE_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** A filter to be used against `Program` object types. All fields are combined with a logical ‘and.’ */
export type ProgramFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProgramFilter>>;
  /** Filter by the object’s `balancingAuthoritySlug` field. */
  balancingAuthoritySlug?: InputMaybe<StringFilter>;
  /** Filter by the object’s `config` field. */
  config?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isAutocreateSuggestions` field. */
  isAutocreateSuggestions?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Filter by the object’s `normalizedSlug` field. */
  normalizedSlug?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProgramFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProgramFilter>>;
  /** Filter by the object’s `projectTypeId` field. */
  projectTypeId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `timezoneName` field. */
  timezoneName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `Program` */
export type ProgramInput = {
  /** The description of the program. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Indicates if suggestions will be created by automation when criteria is met. */
  isAutocreateSuggestions?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the program. */
  name: Scalars['String']['input'];
  /** The id of the project type the program is associated with. */
  projectTypeId: Scalars['Int']['input'];
};

/** Represents an update to a `Program`. Fields that are set will be updated. */
export type ProgramPatch = {
  /** The description of the program. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Indicates if suggestions will be created by automation when criteria is met. */
  isAutocreateSuggestions?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the program. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The id of the project type the program is associated with. */
  projectTypeId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `Program` values. */
export type ProgramsConnection = {
  __typename?: 'ProgramsConnection';
  /** Demand Peaks for CP Program */
  demandPeaks?: Maybe<MetricDataConnection>;
  /** A list of edges which contains the `Program` and cursor to aid in pagination. */
  edges: Array<ProgramsEdge>;
  /** The grid demand value for the associated balancing authority. */
  gridDemand?: Maybe<MetricDataConnection>;
  /** A list of `Program` objects. */
  nodes: Array<Program>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Peak Alerts for CP Program */
  peakAlerts?: Maybe<MetricDataConnection>;
  /** The count of *all* `Program` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A connection to a list of `Program` values. */
export type ProgramsConnectionDemandPeaksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Program` values. */
export type ProgramsConnectionGridDemandArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Program` values. */
export type ProgramsConnectionPeakAlertsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A `Program` edge in the connection. */
export type ProgramsEdge = {
  __typename?: 'ProgramsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Program` at the end of the edge. */
  node: Program;
};

/** Methods to use when ordering `Program`. */
export enum ProgramsOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  IS_AUTOCREATE_SUGGESTIONS_ASC = 'IS_AUTOCREATE_SUGGESTIONS_ASC',
  IS_AUTOCREATE_SUGGESTIONS_DESC = 'IS_AUTOCREATE_SUGGESTIONS_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  NORMALIZED_SLUG_ASC = 'NORMALIZED_SLUG_ASC',
  NORMALIZED_SLUG_DESC = 'NORMALIZED_SLUG_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  PROJECT_TYPE_ID_ASC = 'PROJECT_TYPE_ID_ASC',
  PROJECT_TYPE_ID_DESC = 'PROJECT_TYPE_ID_DESC',
  TIMEZONE_NAME_ASC = 'TIMEZONE_NAME_ASC',
  TIMEZONE_NAME_DESC = 'TIMEZONE_NAME_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** A connection to a list of `ProgramsSavingsEventsDataRecord` values. */
export type ProgramsSavingsEventsDataConnection = {
  __typename?: 'ProgramsSavingsEventsDataConnection';
  /** A list of edges which contains the `ProgramsSavingsEventsDataRecord` and cursor to aid in pagination. */
  edges: Array<ProgramsSavingsEventsDatumEdge>;
  /** A list of `ProgramsSavingsEventsDataRecord` objects. */
  nodes: Array<ProgramsSavingsEventsDataRecord>;
  /** The count of *all* `ProgramsSavingsEventsDataRecord` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** The return type of our `savingsEventsData` query. */
export type ProgramsSavingsEventsDataRecord = {
  __typename?: 'ProgramsSavingsEventsDataRecord';
  data?: Maybe<Scalars['Float']['output']>;
  time?: Maybe<Scalars['Datetime']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

/** A filter to be used against `ProgramsSavingsEventsDataRecord` object types. All fields are combined with a logical ‘and.’ */
export type ProgramsSavingsEventsDataRecordFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProgramsSavingsEventsDataRecordFilter>>;
  /** Filter by the object’s `data` field. */
  data?: InputMaybe<FloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProgramsSavingsEventsDataRecordFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProgramsSavingsEventsDataRecordFilter>>;
  /** Filter by the object’s `time` field. */
  time?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `unit` field. */
  unit?: InputMaybe<StringFilter>;
};

/** A `ProgramsSavingsEventsDataRecord` edge in the connection. */
export type ProgramsSavingsEventsDatumEdge = {
  __typename?: 'ProgramsSavingsEventsDatumEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ProgramsSavingsEventsDataRecord` at the end of the edge. */
  node: ProgramsSavingsEventsDataRecord;
};

export type Project = Node & {
  __typename?: 'Project';
  /** The threshold in minutes that will be applied to a suggestion start time to restrict acknowledgements. */
  acknowledgementWindowThreshold: Scalars['Int']['output'];
  /** Whether suggestions for this project will be auto-acknowledged. */
  autoAcknowledge: Scalars['Boolean']['output'];
  /** Reads and enables pagination through a set of `Component`. */
  components: ComponentsConnection;
  /** Serialized configuration for the project */
  config?: Maybe<Scalars['JSON']['output']>;
  /** Reads and enables pagination through a set of `ProjectConfig`. */
  configs: ProjectConfigsConnection;
  /** Returns the control type of a project. */
  controlType?: Maybe<ControlType>;
  controllers: UsersConnection;
  /** The time the project was created. */
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  /** The current Project Enrollment associated with the project. */
  currentEnrollment?: Maybe<ProjectEnrollment>;
  /** The description of optimization project. */
  description?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `ProjectEnabledUserSubscription`. */
  enabledUserSubscriptions: ProjectEnabledUserSubscriptionsConnection;
  /** The date in which the optimization project ends. */
  endDate?: Maybe<Scalars['Date']['output']>;
  /** The timeout in seconds before which a control event will need to complete. */
  endTimeout: Scalars['Int']['output'];
  /** Reads a single `Facility` that is related to this `Project`. */
  facility?: Maybe<Facility>;
  /** The identifier of the facility. */
  facilityId: Scalars['Int']['output'];
  /** Facility Name */
  facilityName?: Maybe<Scalars['String']['output']>;
  /** The identifier of the optimization project. */
  id: Scalars['Int']['output'];
  /** Is current user is watching project. */
  isWatching?: Maybe<Scalars['Boolean']['output']>;
  /** The name of optimization project. */
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Peak Alerts for CP Program */
  peakAlerts?: Maybe<MetricDataConnection>;
  /** Returns the derived data point configuration for this connection */
  peakAlertsDataPoint?: Maybe<DerivedDataPoint>;
  /** Available permissions for the Project. */
  permissions?: Maybe<ProjectPermissions>;
  /** Reads a single `Program` that is related to this `Project`. */
  program?: Maybe<Program>;
  /** The id of the program the project is associated with */
  programId: Scalars['Int']['output'];
  /** The name of the program */
  programName?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `ProjectComponent`. */
  projectComponents: ProjectComponentsConnection;
  /** Reads and enables pagination through a set of `ProjectEnrollment`. */
  projectEnrollments: ProjectEnrollmentsConnection;
  /** Reads a single `ProjectType` that is related to this `Project`. */
  projectType?: Maybe<ProjectType>;
  /** The type of optimization project. */
  projectTypeId: Scalars['Int']['output'];
  /** The name of the project type */
  projectTypeName?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `ProjectWatcher`. */
  projectWatchers: ProjectWatchersConnection;
  /**
   * Aggregates a metric by label for the specified filter expression.
   * @deprecated Use `savingsEventsData` instead.
   */
  savingsEventData?: Maybe<MetricDataConnection>;
  /** Reads and enables pagination through a set of `SavingsEvent`. */
  savingsEvents: SavingsEventsConnection;
  /** Returns savings event data for a given project, label and time range. */
  savingsEventsData: ProjectsSavingsEventsDataConnection;
  /** The date in which the optimization project starts. */
  startDate?: Maybe<Scalars['Date']['output']>;
  /** The timeout in seconds before which a control event will need to start. */
  startTimeout: Scalars['Int']['output'];
  /** Returns a distinct list of enabled subscription channels for the current user scoped to the project. */
  subscribedChannels?: Maybe<Array<Maybe<UserSubscriptionChannel>>>;
  /** Returns the current user subscriptions scoped to the project. */
  subscriptions: UserSubscriptionsConnection;
  /** Reads and enables pagination through a set of `Suggestion`. */
  suggestions: SuggestionsConnection;
  /** The time the project was updated . */
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  /**
   * Returns all user subscriptions scoped to the project.
   * @deprecated Please use enabledUserSubscriptions
   */
  userSubscriptions: UserSubscriptionsConnection;
  /** Reads and enables pagination through a set of `User`. */
  watchers: UsersConnection;
};

export type ProjectComponentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<ComponentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ProjectConfigsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProjectConfigCondition>;
  filter?: InputMaybe<ProjectConfigFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProjectConfigsOrderBy>>;
};

export type ProjectControllersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserCondition>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

export type ProjectEnabledUserSubscriptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProjectEnabledUserSubscriptionCondition>;
  filter?: InputMaybe<ProjectEnabledUserSubscriptionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProjectEnabledUserSubscriptionsOrderBy>>;
};

export type ProjectPeakAlertsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

export type ProjectProjectComponentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProjectComponentCondition>;
  filter?: InputMaybe<ProjectComponentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProjectComponentsOrderBy>>;
};

export type ProjectProjectEnrollmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProjectEnrollmentCondition>;
  filter?: InputMaybe<ProjectEnrollmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProjectEnrollmentsOrderBy>>;
};

export type ProjectProjectWatchersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProjectWatcherCondition>;
  filter?: InputMaybe<ProjectWatcherFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProjectWatchersOrderBy>>;
};

export type ProjectSavingsEventDataArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: InputMaybe<MetricDataAggregationMethod>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  label: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

export type ProjectSavingsEventsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SavingsEventCondition>;
  filter?: InputMaybe<SavingsEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SavingsEventsOrderBy>>;
};

export type ProjectSavingsEventsDataArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<ProjectsSavingsEventsDataRecordFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['Datetime']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['Datetime']['input']>;
  windowUnit?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectSubscriptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<UserSubscriptionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ProjectSuggestionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SuggestionCondition>;
  filter?: InputMaybe<SuggestionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SuggestionsOrderBy>>;
};

export type ProjectUserSubscriptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<UserSubscriptionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ProjectWatchersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ProjectComponent = Node & {
  __typename?: 'ProjectComponent';
  /** Reads a single `Component` that is related to this `ProjectComponent`. */
  component?: Maybe<Component>;
  componentId: Scalars['Int']['output'];
  /** A scheme name to be associated with the control for this project component. */
  controlScheme?: Maybe<Scalars['String']['output']>;
  /** The maximum duration, in seconds, that a control event can be scheduled. This value will also be the default when related suggestions have no end time. */
  maximumControlDuration?: Maybe<Scalars['Int']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Project` that is related to this `ProjectComponent`. */
  project?: Maybe<Project>;
  projectId: Scalars['Int']['output'];
  /** The duration in seconds before an event start time that the component will start. */
  startupOffset: Scalars['Int']['output'];
};

/**
 * A condition to be used against `ProjectComponent` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ProjectComponentCondition = {
  /** Checks for equality with the object’s `componentId` field. */
  componentId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `controlScheme` field. */
  controlScheme?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `maximumControlDuration` field. */
  maximumControlDuration?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `startupOffset` field. */
  startupOffset?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `ProjectComponent` object types. All fields are combined with a logical ‘and.’ */
export type ProjectComponentFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProjectComponentFilter>>;
  /** Filter by the object’s `componentId` field. */
  componentId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `controlScheme` field. */
  controlScheme?: InputMaybe<StringFilter>;
  /** Filter by the object’s `maximumControlDuration` field. */
  maximumControlDuration?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProjectComponentFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProjectComponentFilter>>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `startupOffset` field. */
  startupOffset?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `ProjectComponent` */
export type ProjectComponentInput = {
  componentId: Scalars['Int']['input'];
  /** A scheme name to be associated with the control for this project component. */
  controlScheme?: InputMaybe<Scalars['String']['input']>;
  /** The maximum duration, in seconds, that a control event can be scheduled. This value will also be the default when related suggestions have no end time. */
  maximumControlDuration?: InputMaybe<Scalars['Int']['input']>;
  projectId: Scalars['Int']['input'];
  /** The duration in seconds before an event start time that the component will start. */
  startupOffset?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents an update to a `ProjectComponent`. Fields that are set will be updated. */
export type ProjectComponentPatch = {
  componentId?: InputMaybe<Scalars['Int']['input']>;
  /** A scheme name to be associated with the control for this project component. */
  controlScheme?: InputMaybe<Scalars['String']['input']>;
  /** The maximum duration, in seconds, that a control event can be scheduled. This value will also be the default when related suggestions have no end time. */
  maximumControlDuration?: InputMaybe<Scalars['Int']['input']>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
  /** The duration in seconds before an event start time that the component will start. */
  startupOffset?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `ProjectComponent` values. */
export type ProjectComponentsConnection = {
  __typename?: 'ProjectComponentsConnection';
  /** A list of edges which contains the `ProjectComponent` and cursor to aid in pagination. */
  edges: Array<ProjectComponentsEdge>;
  /** A list of `ProjectComponent` objects. */
  nodes: Array<ProjectComponent>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProjectComponent` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ProjectComponent` edge in the connection. */
export type ProjectComponentsEdge = {
  __typename?: 'ProjectComponentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ProjectComponent` at the end of the edge. */
  node: ProjectComponent;
};

/** Methods to use when ordering `ProjectComponent`. */
export enum ProjectComponentsOrderBy {
  COMPONENT_ID_ASC = 'COMPONENT_ID_ASC',
  COMPONENT_ID_DESC = 'COMPONENT_ID_DESC',
  CONTROL_SCHEME_ASC = 'CONTROL_SCHEME_ASC',
  CONTROL_SCHEME_DESC = 'CONTROL_SCHEME_DESC',
  MAXIMUM_CONTROL_DURATION_ASC = 'MAXIMUM_CONTROL_DURATION_ASC',
  MAXIMUM_CONTROL_DURATION_DESC = 'MAXIMUM_CONTROL_DURATION_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  PROJECT_ID_ASC = 'PROJECT_ID_ASC',
  PROJECT_ID_DESC = 'PROJECT_ID_DESC',
  STARTUP_OFFSET_ASC = 'STARTUP_OFFSET_ASC',
  STARTUP_OFFSET_DESC = 'STARTUP_OFFSET_DESC'
}

/** A condition to be used against `Project` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type ProjectCondition = {
  /** Checks for equality with the object’s `acknowledgementWindowThreshold` field. */
  acknowledgementWindowThreshold?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `autoAcknowledge` field. */
  autoAcknowledge?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `config` field. */
  config?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `endDate` field. */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `endTimeout` field. */
  endTimeout?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `programId` field. */
  programId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `projectTypeId` field. */
  projectTypeId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `startDate` field. */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `startTimeout` field. */
  startTimeout?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export type ProjectConfig = Node & {
  __typename?: 'ProjectConfig';
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['Int']['output'];
  key?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Project` that is related to this `ProjectConfig`. */
  project?: Maybe<Project>;
  projectId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  value?: Maybe<Scalars['JSON']['output']>;
};

/**
 * A condition to be used against `ProjectConfig` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ProjectConfigCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `key` field. */
  key?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['JSON']['input']>;
};

/** A filter to be used against `ProjectConfig` object types. All fields are combined with a logical ‘and.’ */
export type ProjectConfigFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProjectConfigFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `key` field. */
  key?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProjectConfigFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProjectConfigFilter>>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<JsonFilter>;
};

/** A connection to a list of `ProjectConfig` values. */
export type ProjectConfigsConnection = {
  __typename?: 'ProjectConfigsConnection';
  /** A list of edges which contains the `ProjectConfig` and cursor to aid in pagination. */
  edges: Array<ProjectConfigsEdge>;
  /** A list of `ProjectConfig` objects. */
  nodes: Array<ProjectConfig>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProjectConfig` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ProjectConfig` edge in the connection. */
export type ProjectConfigsEdge = {
  __typename?: 'ProjectConfigsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ProjectConfig` at the end of the edge. */
  node: ProjectConfig;
};

/** Methods to use when ordering `ProjectConfig`. */
export enum ProjectConfigsOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  KEY_ASC = 'KEY_ASC',
  KEY_DESC = 'KEY_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  PROJECT_ID_ASC = 'PROJECT_ID_ASC',
  PROJECT_ID_DESC = 'PROJECT_ID_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  VALUE_ASC = 'VALUE_ASC',
  VALUE_DESC = 'VALUE_DESC'
}

/** The enabled user subscriptions for each project. */
export type ProjectEnabledUserSubscription = {
  __typename?: 'ProjectEnabledUserSubscription';
  enabledChannels?: Maybe<Array<Maybe<UserSubscriptionChannel>>>;
  /** Reads a single `Project` that is related to this `ProjectEnabledUserSubscription`. */
  project?: Maybe<Project>;
  projectId?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  /** Reads a single `User` that is related to this `ProjectEnabledUserSubscription`. */
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};

/**
 * A condition to be used against `ProjectEnabledUserSubscription` object types.
 * All fields are tested for equality and combined with a logical ‘and.’
 */
export type ProjectEnabledUserSubscriptionCondition = {
  /** Checks for equality with the object’s `enabledChannels` field. */
  enabledChannels?: InputMaybe<Array<InputMaybe<UserSubscriptionChannel>>>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `ProjectEnabledUserSubscription` object types. All fields are combined with a logical ‘and.’ */
export type ProjectEnabledUserSubscriptionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProjectEnabledUserSubscriptionFilter>>;
  /** Filter by the object’s `enabledChannels` field. */
  enabledChannels?: InputMaybe<UserSubscriptionChannelListFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProjectEnabledUserSubscriptionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProjectEnabledUserSubscriptionFilter>>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<StringFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<StringFilter>;
};

/** A connection to a list of `ProjectEnabledUserSubscription` values. */
export type ProjectEnabledUserSubscriptionsConnection = {
  __typename?: 'ProjectEnabledUserSubscriptionsConnection';
  /** A list of edges which contains the `ProjectEnabledUserSubscription` and cursor to aid in pagination. */
  edges: Array<ProjectEnabledUserSubscriptionsEdge>;
  /** A list of `ProjectEnabledUserSubscription` objects. */
  nodes: Array<ProjectEnabledUserSubscription>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProjectEnabledUserSubscription` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ProjectEnabledUserSubscription` edge in the connection. */
export type ProjectEnabledUserSubscriptionsEdge = {
  __typename?: 'ProjectEnabledUserSubscriptionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ProjectEnabledUserSubscription` at the end of the edge. */
  node: ProjectEnabledUserSubscription;
};

/** Methods to use when ordering `ProjectEnabledUserSubscription`. */
export enum ProjectEnabledUserSubscriptionsOrderBy {
  ENABLED_CHANNELS_ASC = 'ENABLED_CHANNELS_ASC',
  ENABLED_CHANNELS_DESC = 'ENABLED_CHANNELS_DESC',
  NATURAL = 'NATURAL',
  PROJECT_ID_ASC = 'PROJECT_ID_ASC',
  PROJECT_ID_DESC = 'PROJECT_ID_DESC',
  TYPE_ASC = 'TYPE_ASC',
  TYPE_DESC = 'TYPE_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC'
}

/** Tracks enrollment periods for a project. */
export type ProjectEnrollment = Node & {
  __typename?: 'ProjectEnrollment';
  createdAt: Scalars['Datetime']['output'];
  /** Reads and enables pagination through a set of `ProjectEnrollmentDataPoint`. */
  dataPoints: ProjectEnrollmentDataPointsConnection;
  /** The methodology used to calculate profile or baseline demand. */
  demandProfileMethodology: DemandProfileMethodologyType;
  /** The end date of the program enrollment associated with the project enrollment. */
  endDate?: Maybe<Scalars['Datetime']['output']>;
  /** The identifer of the project enrollment. */
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `ProgramEnrollment` that is related to this `ProjectEnrollment`. */
  programEnrollment?: Maybe<ProgramEnrollment>;
  /** The program enrollment this project enrollment belongs to. */
  programEnrollmentId: Scalars['Int']['output'];
  /** Reads a single `Project` that is related to this `ProjectEnrollment`. */
  project?: Maybe<Project>;
  /** The project this project enrollment belongs to. */
  projectId: Scalars['Int']['output'];
  /** The start date of the program enrollment associated with the project enrollment. */
  startDate?: Maybe<Scalars['Datetime']['output']>;
  updatedAt: Scalars['Datetime']['output'];
};

/** Tracks enrollment periods for a project. */
export type ProjectEnrollmentDataPointsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProjectEnrollmentDataPointCondition>;
  filter?: InputMaybe<ProjectEnrollmentDataPointFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProjectEnrollmentDataPointsOrderBy>>;
};

/**
 * A condition to be used against `ProjectEnrollment` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ProjectEnrollmentCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `demandProfileMethodology` field. */
  demandProfileMethodology?: InputMaybe<DemandProfileMethodologyType>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `programEnrollmentId` field. */
  programEnrollmentId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** Tracks data points associated with enrollments. */
export type ProjectEnrollmentDataPoint = Node & {
  __typename?: 'ProjectEnrollmentDataPoint';
  /** This allows data point names to be overwritten. */
  alias?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Datetime']['output'];
  /** Reads a single `DataPoint` that is related to this `ProjectEnrollmentDataPoint`. */
  dataPoint?: Maybe<DataPoint>;
  /** The data point being referenced. */
  dataPointId: Scalars['Int']['output'];
  /** Reads a single `ProjectEnrollmentDataPointGroup` that is related to this `ProjectEnrollmentDataPoint`. */
  group?: Maybe<ProjectEnrollmentDataPointGroup>;
  /** The identifer of the project enrollment data point. */
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `DataPoint` that is related to this `ProjectEnrollmentDataPoint`. */
  profileDataPoint?: Maybe<DataPoint>;
  /** The data point being referenced for calculating profile demand, if different from the normal data point. */
  profileDataPointId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `ProjectEnrollment` that is related to this `ProjectEnrollmentDataPoint`. */
  projectEnrollment?: Maybe<ProjectEnrollment>;
  /** The group this data point belongs to. */
  projectEnrollmentDataPointGroupId?: Maybe<Scalars['Int']['output']>;
  /** The project enrollment this data point belongs to. */
  projectEnrollmentId: Scalars['Int']['output'];
  /** The rate(s) associated with the data point. */
  rate: Scalars['JSON']['output'];
  /** The target value for the data point during a savings event. */
  target?: Maybe<Scalars['BigFloat']['output']>;
  updatedAt: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `ProjectEnrollmentDataPoint` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type ProjectEnrollmentDataPointCondition = {
  /** Checks for equality with the object’s `alias` field. */
  alias?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `dataPointId` field. */
  dataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `profileDataPointId` field. */
  profileDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `projectEnrollmentDataPointGroupId` field. */
  projectEnrollmentDataPointGroupId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `projectEnrollmentId` field. */
  projectEnrollmentId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rate` field. */
  rate?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `target` field. */
  target?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `ProjectEnrollmentDataPoint` object types. All fields are combined with a logical ‘and.’ */
export type ProjectEnrollmentDataPointFilter = {
  /** Filter by the object’s `alias` field. */
  alias?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProjectEnrollmentDataPointFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dataPointId` field. */
  dataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProjectEnrollmentDataPointFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProjectEnrollmentDataPointFilter>>;
  /** Filter by the object’s `profileDataPointId` field. */
  profileDataPointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `projectEnrollmentDataPointGroupId` field. */
  projectEnrollmentDataPointGroupId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `projectEnrollmentId` field. */
  projectEnrollmentId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rate` field. */
  rate?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `target` field. */
  target?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** Allows grouping enrollment data points. */
export type ProjectEnrollmentDataPointGroup = Node & {
  __typename?: 'ProjectEnrollmentDataPointGroup';
  createdAt: Scalars['Datetime']['output'];
  /** The description of the data point group. */
  description?: Maybe<Scalars['String']['output']>;
  /** The identifer of the project enrollment. */
  id: Scalars['Int']['output'];
  /** The label of the data point group. */
  label: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `ProjectEnrollmentDataPoint`. */
  projectEnrollmentDataPoints: ProjectEnrollmentDataPointsConnection;
  updatedAt: Scalars['Datetime']['output'];
};

/** Allows grouping enrollment data points. */
export type ProjectEnrollmentDataPointGroupProjectEnrollmentDataPointsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProjectEnrollmentDataPointCondition>;
  filter?: InputMaybe<ProjectEnrollmentDataPointFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProjectEnrollmentDataPointsOrderBy>>;
};

/**
 * A condition to be used against `ProjectEnrollmentDataPointGroup` object types.
 * All fields are tested for equality and combined with a logical ‘and.’
 */
export type ProjectEnrollmentDataPointGroupCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `label` field. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `ProjectEnrollmentDataPointGroup` object types. All fields are combined with a logical ‘and.’ */
export type ProjectEnrollmentDataPointGroupFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProjectEnrollmentDataPointGroupFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `label` field. */
  label?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProjectEnrollmentDataPointGroupFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProjectEnrollmentDataPointGroupFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `ProjectEnrollmentDataPointGroup` */
export type ProjectEnrollmentDataPointGroupInput = {
  /** The description of the data point group. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The label of the data point group. */
  label: Scalars['String']['input'];
};

/** Represents an update to a `ProjectEnrollmentDataPointGroup`. Fields that are set will be updated. */
export type ProjectEnrollmentDataPointGroupPatch = {
  /** The description of the data point group. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The label of the data point group. */
  label?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `ProjectEnrollmentDataPointGroup` values. */
export type ProjectEnrollmentDataPointGroupsConnection = {
  __typename?: 'ProjectEnrollmentDataPointGroupsConnection';
  /** A list of edges which contains the `ProjectEnrollmentDataPointGroup` and cursor to aid in pagination. */
  edges: Array<ProjectEnrollmentDataPointGroupsEdge>;
  /** A list of `ProjectEnrollmentDataPointGroup` objects. */
  nodes: Array<ProjectEnrollmentDataPointGroup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProjectEnrollmentDataPointGroup` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ProjectEnrollmentDataPointGroup` edge in the connection. */
export type ProjectEnrollmentDataPointGroupsEdge = {
  __typename?: 'ProjectEnrollmentDataPointGroupsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ProjectEnrollmentDataPointGroup` at the end of the edge. */
  node: ProjectEnrollmentDataPointGroup;
};

/** Methods to use when ordering `ProjectEnrollmentDataPointGroup`. */
export enum ProjectEnrollmentDataPointGroupsOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LABEL_ASC = 'LABEL_ASC',
  LABEL_DESC = 'LABEL_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** An input for mutations affecting `ProjectEnrollmentDataPoint` */
export type ProjectEnrollmentDataPointInput = {
  /** This allows data point names to be overwritten. */
  alias?: InputMaybe<Scalars['String']['input']>;
  /** Mutates a `DataPoint` as part of the payload */
  dataPoint?: InputMaybe<DataPointInput>;
  /** The data point being referenced. */
  dataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** The data point being referenced for calculating profile demand, if different from the normal data point. */
  profileDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** Mutates a `ProjectEnrollment` as part of the payload */
  projectEnrollment?: InputMaybe<ProjectEnrollmentInput>;
  /** Mutates a `ProjectEnrollmentDataPointGroup` as part of the payload */
  projectEnrollmentDataPointGroup?: InputMaybe<ProjectEnrollmentDataPointGroupInput>;
  /** The group this data point belongs to. */
  projectEnrollmentDataPointGroupId?: InputMaybe<Scalars['Int']['input']>;
  /** The project enrollment this data point belongs to. */
  projectEnrollmentId?: InputMaybe<Scalars['Int']['input']>;
  /** The rate(s) associated with the data point. */
  rate?: InputMaybe<Scalars['JSON']['input']>;
  /** The target value for the data point during a savings event. */
  target?: InputMaybe<Scalars['BigFloat']['input']>;
};

/** Represents an update to a `ProjectEnrollmentDataPoint`. Fields that are set will be updated. */
export type ProjectEnrollmentDataPointPatch = {
  /** This allows data point names to be overwritten. */
  alias?: InputMaybe<Scalars['String']['input']>;
  /** The data point being referenced for calculating profile demand, if different from the normal data point. */
  profileDataPointId?: InputMaybe<Scalars['Int']['input']>;
  /** The rate(s) associated with the data point. */
  rate?: InputMaybe<Scalars['JSON']['input']>;
  /** The target value for the data point during a savings event. */
  target?: InputMaybe<Scalars['BigFloat']['input']>;
};

/** A connection to a list of `ProjectEnrollmentDataPoint` values. */
export type ProjectEnrollmentDataPointsConnection = {
  __typename?: 'ProjectEnrollmentDataPointsConnection';
  /** Returns the aggregate data timeseries data for the ProjectEnrollmentDataPointsConnection  */
  data?: Maybe<MetricDataConnection>;
  /** A list of edges which contains the `ProjectEnrollmentDataPoint` and cursor to aid in pagination. */
  edges: Array<ProjectEnrollmentDataPointsEdge>;
  /** A list of `ProjectEnrollmentDataPoint` objects. */
  nodes: Array<ProjectEnrollmentDataPoint>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Returns the aggregate profileDataPoint timeseries data for the ProjectEnrollmentDataPointsConnection  */
  profileDataPoint?: Maybe<MetricDataConnection>;
  /** The count of *all* `ProjectEnrollmentDataPoint` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A connection to a list of `ProjectEnrollmentDataPoint` values. */
export type ProjectEnrollmentDataPointsConnectionDataArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `ProjectEnrollmentDataPoint` values. */
export type ProjectEnrollmentDataPointsConnectionProfileDataPointArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A `ProjectEnrollmentDataPoint` edge in the connection. */
export type ProjectEnrollmentDataPointsEdge = {
  __typename?: 'ProjectEnrollmentDataPointsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ProjectEnrollmentDataPoint` at the end of the edge. */
  node: ProjectEnrollmentDataPoint;
};

/** Methods to use when ordering `ProjectEnrollmentDataPoint`. */
export enum ProjectEnrollmentDataPointsOrderBy {
  ALIAS_ASC = 'ALIAS_ASC',
  ALIAS_DESC = 'ALIAS_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DATA_POINT_ID_ASC = 'DATA_POINT_ID_ASC',
  DATA_POINT_ID_DESC = 'DATA_POINT_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  PROFILE_DATA_POINT_ID_ASC = 'PROFILE_DATA_POINT_ID_ASC',
  PROFILE_DATA_POINT_ID_DESC = 'PROFILE_DATA_POINT_ID_DESC',
  PROJECT_ENROLLMENT_DATA_POINT_GROUP_ID_ASC = 'PROJECT_ENROLLMENT_DATA_POINT_GROUP_ID_ASC',
  PROJECT_ENROLLMENT_DATA_POINT_GROUP_ID_DESC = 'PROJECT_ENROLLMENT_DATA_POINT_GROUP_ID_DESC',
  PROJECT_ENROLLMENT_ID_ASC = 'PROJECT_ENROLLMENT_ID_ASC',
  PROJECT_ENROLLMENT_ID_DESC = 'PROJECT_ENROLLMENT_ID_DESC',
  RATE_ASC = 'RATE_ASC',
  RATE_DESC = 'RATE_DESC',
  TARGET_ASC = 'TARGET_ASC',
  TARGET_DESC = 'TARGET_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** A filter to be used against `ProjectEnrollment` object types. All fields are combined with a logical ‘and.’ */
export type ProjectEnrollmentFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProjectEnrollmentFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `demandProfileMethodology` field. */
  demandProfileMethodology?: InputMaybe<DemandProfileMethodologyTypeFilter>;
  /** Filter by the object’s `endDate` field. */
  endDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProjectEnrollmentFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProjectEnrollmentFilter>>;
  /** Filter by the object’s `programEnrollmentId` field. */
  programEnrollmentId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `startDate` field. */
  startDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `ProjectEnrollment` */
export type ProjectEnrollmentInput = {
  /** The methodology used to calculate profile or baseline demand. */
  demandProfileMethodology?: InputMaybe<DemandProfileMethodologyType>;
  /** Mutates a `ProgramEnrollment` as part of the payload */
  programEnrollment?: InputMaybe<ProgramEnrollmentInput>;
  /** The program enrollment this project enrollment belongs to. */
  programEnrollmentId?: InputMaybe<Scalars['Int']['input']>;
  /** The project this project enrollment belongs to. */
  projectId: Scalars['Int']['input'];
};

/** Represents an update to a `ProjectEnrollment`. Fields that are set will be updated. */
export type ProjectEnrollmentPatch = {
  /** The methodology used to calculate profile or baseline demand. */
  demandProfileMethodology?: InputMaybe<DemandProfileMethodologyType>;
};

/** A connection to a list of `ProjectEnrollment` values. */
export type ProjectEnrollmentsConnection = {
  __typename?: 'ProjectEnrollmentsConnection';
  /** A list of edges which contains the `ProjectEnrollment` and cursor to aid in pagination. */
  edges: Array<ProjectEnrollmentsEdge>;
  /** A list of `ProjectEnrollment` objects. */
  nodes: Array<ProjectEnrollment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProjectEnrollment` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ProjectEnrollment` edge in the connection. */
export type ProjectEnrollmentsEdge = {
  __typename?: 'ProjectEnrollmentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ProjectEnrollment` at the end of the edge. */
  node: ProjectEnrollment;
};

/** Methods to use when ordering `ProjectEnrollment`. */
export enum ProjectEnrollmentsOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DEMAND_PROFILE_METHODOLOGY_ASC = 'DEMAND_PROFILE_METHODOLOGY_ASC',
  DEMAND_PROFILE_METHODOLOGY_DESC = 'DEMAND_PROFILE_METHODOLOGY_DESC',
  END_DATE_ASC = 'END_DATE_ASC',
  END_DATE_DESC = 'END_DATE_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  PROGRAM_ENROLLMENT_ID_ASC = 'PROGRAM_ENROLLMENT_ID_ASC',
  PROGRAM_ENROLLMENT_ID_DESC = 'PROGRAM_ENROLLMENT_ID_DESC',
  PROJECT_ID_ASC = 'PROJECT_ID_ASC',
  PROJECT_ID_DESC = 'PROJECT_ID_DESC',
  START_DATE_ASC = 'START_DATE_ASC',
  START_DATE_DESC = 'START_DATE_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** A filter to be used against `Project` object types. All fields are combined with a logical ‘and.’ */
export type ProjectFilter = {
  /** Filter by the object’s `acknowledgementWindowThreshold` field. */
  acknowledgementWindowThreshold?: InputMaybe<IntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProjectFilter>>;
  /** Filter by the object’s `autoAcknowledge` field. */
  autoAcknowledge?: InputMaybe<BooleanFilter>;
  /** Filter by the permission can_control */
  canControl?: InputMaybe<PermissionBooleanFilter>;
  /** Filter by the object’s `config` field. */
  config?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `controlType` field. */
  controlType?: InputMaybe<ControlTypeFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `endDate` field. */
  endDate?: InputMaybe<DateFilter>;
  /** Filter by the object’s `endTimeout` field. */
  endTimeout?: InputMaybe<IntFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `facilityName` field. */
  facilityName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isWatching` field. */
  isWatching?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProjectFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProjectFilter>>;
  /** Filter by the object’s `programId` field. */
  programId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `programName` field. */
  programName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `projectTypeId` field. */
  projectTypeId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `projectTypeName` field. */
  projectTypeName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `startDate` field. */
  startDate?: InputMaybe<DateFilter>;
  /** Filter by the object’s `startTimeout` field. */
  startTimeout?: InputMaybe<IntFilter>;
  /** Filter by the object’s `subscribedChannels` field. */
  subscribedChannels?: InputMaybe<UserSubscriptionChannelListFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `Project` */
export type ProjectInput = {
  /** The threshold in minutes that will be applied to a suggestion start time to restrict acknowledgements. */
  acknowledgementWindowThreshold?: InputMaybe<Scalars['Int']['input']>;
  /** Whether suggestions for this project will be auto-acknowledged. */
  autoAcknowledge?: InputMaybe<Scalars['Boolean']['input']>;
  /** The description of optimization project. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The date in which the optimization project ends. */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /** The timeout in seconds before which a control event will need to complete. */
  endTimeout?: InputMaybe<Scalars['Int']['input']>;
  /** The identifier of the facility. */
  facilityId: Scalars['Int']['input'];
  /** The name of optimization project. */
  name: Scalars['String']['input'];
  /** Mutates a `Program` as part of the payload */
  program?: InputMaybe<ProgramInput>;
  /** The id of the program the project is associated with */
  programId?: InputMaybe<Scalars['Int']['input']>;
  /** The type of optimization project. */
  projectTypeId: Scalars['Int']['input'];
  /** The date in which the optimization project starts. */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  /** The timeout in seconds before which a control event will need to start. */
  startTimeout?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents an update to a `Project`. Fields that are set will be updated. */
export type ProjectPatch = {
  /** The threshold in minutes that will be applied to a suggestion start time to restrict acknowledgements. */
  acknowledgementWindowThreshold?: InputMaybe<Scalars['Int']['input']>;
  /** Whether suggestions for this project will be auto-acknowledged. */
  autoAcknowledge?: InputMaybe<Scalars['Boolean']['input']>;
  /** The description of optimization project. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The date in which the optimization project ends. */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /** The timeout in seconds before which a control event will need to complete. */
  endTimeout?: InputMaybe<Scalars['Int']['input']>;
  /** The identifier of the facility. */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** The name of optimization project. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The id of the program the project is associated with */
  programId?: InputMaybe<Scalars['Int']['input']>;
  /** The type of optimization project. */
  projectTypeId?: InputMaybe<Scalars['Int']['input']>;
  /** The date in which the optimization project starts. */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  /** The timeout in seconds before which a control event will need to start. */
  startTimeout?: InputMaybe<Scalars['Int']['input']>;
};

/** Permissive capabilities on a Project. */
export type ProjectPermissions = {
  __typename?: 'ProjectPermissions';
  /** Whether a user can approve and/or transition suggestions in the project. */
  canControl: Scalars['Boolean']['output'];
};

/** Type of optimization project that can be associated to a facility. */
export type ProjectType = Node & {
  __typename?: 'ProjectType';
  /** The description of the project type */
  description?: Maybe<Scalars['String']['output']>;
  /** The identifier of the project type */
  id: Scalars['Int']['output'];
  /** The name of the project type */
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `Program`. */
  programs: ProgramsConnection;
  /** Reads and enables pagination through a set of `Project`. */
  projects: ProjectsConnection;
};

/** Type of optimization project that can be associated to a facility. */
export type ProjectTypeProgramsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProgramCondition>;
  filter?: InputMaybe<ProgramFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProgramsOrderBy>>;
};

/** Type of optimization project that can be associated to a facility. */
export type ProjectTypeProjectsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProjectCondition>;
  filter?: InputMaybe<ProjectFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProjectsOrderBy>>;
};

/**
 * A condition to be used against `ProjectType` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ProjectTypeCondition = {
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `ProjectType` object types. All fields are combined with a logical ‘and.’ */
export type ProjectTypeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProjectTypeFilter>>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProjectTypeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProjectTypeFilter>>;
};

/** A connection to a list of `ProjectType` values. */
export type ProjectTypesConnection = {
  __typename?: 'ProjectTypesConnection';
  /** A list of edges which contains the `ProjectType` and cursor to aid in pagination. */
  edges: Array<ProjectTypesEdge>;
  /** A list of `ProjectType` objects. */
  nodes: Array<ProjectType>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProjectType` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ProjectType` edge in the connection. */
export type ProjectTypesEdge = {
  __typename?: 'ProjectTypesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ProjectType` at the end of the edge. */
  node: ProjectType;
};

/** Methods to use when ordering `ProjectType`. */
export enum ProjectTypesOrderBy {
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

export type ProjectWatcher = Node & {
  __typename?: 'ProjectWatcher';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Project` that is related to this `ProjectWatcher`. */
  project?: Maybe<Project>;
  projectId: Scalars['Int']['output'];
  subscribedChannels?: Maybe<Array<Maybe<UserSubscriptionChannel>>>;
  /** Reads a single `User` that is related to this `ProjectWatcher`. */
  user?: Maybe<User>;
  userId: Scalars['String']['output'];
};

/**
 * A condition to be used against `ProjectWatcher` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ProjectWatcherCondition = {
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `ProjectWatcher` object types. All fields are combined with a logical ‘and.’ */
export type ProjectWatcherFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProjectWatcherFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<ProjectWatcherFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProjectWatcherFilter>>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `subscribedChannels` field. */
  subscribedChannels?: InputMaybe<UserSubscriptionChannelListFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `ProjectWatcher` */
export type ProjectWatcherInput = {
  projectId: Scalars['Int']['input'];
  userId: Scalars['String']['input'];
};

/** Represents an update to a `ProjectWatcher`. Fields that are set will be updated. */
export type ProjectWatcherPatch = {
  projectId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `ProjectWatcher` values. */
export type ProjectWatchersConnection = {
  __typename?: 'ProjectWatchersConnection';
  /** A list of edges which contains the `ProjectWatcher` and cursor to aid in pagination. */
  edges: Array<ProjectWatchersEdge>;
  /** A list of `ProjectWatcher` objects. */
  nodes: Array<ProjectWatcher>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProjectWatcher` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ProjectWatcher` edge in the connection. */
export type ProjectWatchersEdge = {
  __typename?: 'ProjectWatchersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ProjectWatcher` at the end of the edge. */
  node: ProjectWatcher;
};

/** Methods to use when ordering `ProjectWatcher`. */
export enum ProjectWatchersOrderBy {
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  PROJECT_ID_ASC = 'PROJECT_ID_ASC',
  PROJECT_ID_DESC = 'PROJECT_ID_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC'
}

/** A connection to a list of `Project` values. */
export type ProjectsConnection = {
  __typename?: 'ProjectsConnection';
  /** A list of edges which contains the `Project` and cursor to aid in pagination. */
  edges: Array<ProjectsEdge>;
  /** A list of `Project` objects. */
  nodes: Array<Project>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Peak Alerts for CP Program */
  peakAlerts?: Maybe<MetricDataConnection>;
  /**
   * Aggregates a metric by label for the specified filter expression.
   * @deprecated Use `savingsEventsData` instead.
   */
  savingsEventData?: Maybe<MetricDataConnection>;
  /** The count of *all* `Project` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A connection to a list of `Project` values. */
export type ProjectsConnectionPeakAlertsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Project` values. */
export type ProjectsConnectionSavingsEventDataArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A `Project` edge in the connection. */
export type ProjectsEdge = {
  __typename?: 'ProjectsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Project` at the end of the edge. */
  node: Project;
};

/** Methods to use when ordering `Project`. */
export enum ProjectsOrderBy {
  ACKNOWLEDGEMENT_WINDOW_THRESHOLD_ASC = 'ACKNOWLEDGEMENT_WINDOW_THRESHOLD_ASC',
  ACKNOWLEDGEMENT_WINDOW_THRESHOLD_DESC = 'ACKNOWLEDGEMENT_WINDOW_THRESHOLD_DESC',
  AUTO_ACKNOWLEDGE_ASC = 'AUTO_ACKNOWLEDGE_ASC',
  AUTO_ACKNOWLEDGE_DESC = 'AUTO_ACKNOWLEDGE_DESC',
  CONTROL_TYPE_ASC = 'CONTROL_TYPE_ASC',
  CONTROL_TYPE_DESC = 'CONTROL_TYPE_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  END_DATE_ASC = 'END_DATE_ASC',
  END_DATE_DESC = 'END_DATE_DESC',
  END_TIMEOUT_ASC = 'END_TIMEOUT_ASC',
  END_TIMEOUT_DESC = 'END_TIMEOUT_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  FACILITY_NAME_ASC = 'FACILITY_NAME_ASC',
  FACILITY_NAME_DESC = 'FACILITY_NAME_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  IS_WATCHING_ASC = 'IS_WATCHING_ASC',
  IS_WATCHING_DESC = 'IS_WATCHING_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  PROGRAM_ID_ASC = 'PROGRAM_ID_ASC',
  PROGRAM_ID_DESC = 'PROGRAM_ID_DESC',
  PROGRAM_NAME_ASC = 'PROGRAM_NAME_ASC',
  PROGRAM_NAME_DESC = 'PROGRAM_NAME_DESC',
  PROJECT_TYPE_ID_ASC = 'PROJECT_TYPE_ID_ASC',
  PROJECT_TYPE_ID_DESC = 'PROJECT_TYPE_ID_DESC',
  PROJECT_TYPE_NAME_ASC = 'PROJECT_TYPE_NAME_ASC',
  PROJECT_TYPE_NAME_DESC = 'PROJECT_TYPE_NAME_DESC',
  START_DATE_ASC = 'START_DATE_ASC',
  START_DATE_DESC = 'START_DATE_DESC',
  START_TIMEOUT_ASC = 'START_TIMEOUT_ASC',
  START_TIMEOUT_DESC = 'START_TIMEOUT_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** A connection to a list of `ProjectsSavingsEventsDataRecord` values. */
export type ProjectsSavingsEventsDataConnection = {
  __typename?: 'ProjectsSavingsEventsDataConnection';
  /** A list of edges which contains the `ProjectsSavingsEventsDataRecord` and cursor to aid in pagination. */
  edges: Array<ProjectsSavingsEventsDatumEdge>;
  /** A list of `ProjectsSavingsEventsDataRecord` objects. */
  nodes: Array<ProjectsSavingsEventsDataRecord>;
  /** The count of *all* `ProjectsSavingsEventsDataRecord` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** The return type of our `savingsEventsData` query. */
export type ProjectsSavingsEventsDataRecord = {
  __typename?: 'ProjectsSavingsEventsDataRecord';
  data?: Maybe<Scalars['Float']['output']>;
  time?: Maybe<Scalars['Datetime']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

/** A filter to be used against `ProjectsSavingsEventsDataRecord` object types. All fields are combined with a logical ‘and.’ */
export type ProjectsSavingsEventsDataRecordFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProjectsSavingsEventsDataRecordFilter>>;
  /** Filter by the object’s `data` field. */
  data?: InputMaybe<FloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProjectsSavingsEventsDataRecordFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProjectsSavingsEventsDataRecordFilter>>;
  /** Filter by the object’s `time` field. */
  time?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `unit` field. */
  unit?: InputMaybe<StringFilter>;
};

/** A `ProjectsSavingsEventsDataRecord` edge in the connection. */
export type ProjectsSavingsEventsDatumEdge = {
  __typename?: 'ProjectsSavingsEventsDatumEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ProjectsSavingsEventsDataRecord` at the end of the edge. */
  node: ProjectsSavingsEventsDataRecord;
};

/** All input for the `provisionElectricalMeteringPointsAndPanels` mutation. */
export type ProvisionElectricalMeteringPointsAndPanelsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  facilityIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

/** The output of our `provisionElectricalMeteringPointsAndPanels` mutation. */
export type ProvisionElectricalMeteringPointsAndPanelsPayload = {
  __typename?: 'ProvisionElectricalMeteringPointsAndPanelsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The root query type which gives access points into the data universe. */
export type Query = Node & {
  __typename?: 'Query';
  accountCharge?: Maybe<AccountCharge>;
  /** Reads a single `AccountCharge` using its globally unique `ID`. */
  accountChargeByNodeId?: Maybe<AccountCharge>;
  /** Reads and enables pagination through a set of `AccountCharge`. */
  accountCharges?: Maybe<AccountChargesConnection>;
  accountStatement?: Maybe<AccountStatement>;
  /** Reads a single `AccountStatement` using its globally unique `ID`. */
  accountStatementByNodeId?: Maybe<AccountStatement>;
  /** Reads and enables pagination through a set of `AccountStatementHistory`. */
  accountStatementHistories?: Maybe<AccountStatementHistoriesConnection>;
  accountStatementPdf?: Maybe<AccountStatementPdf>;
  accountStatementPdfByAccountStatementIdAndFileKey?: Maybe<AccountStatementPdf>;
  /** Reads a single `AccountStatementPdf` using its globally unique `ID`. */
  accountStatementPdfByNodeId?: Maybe<AccountStatementPdf>;
  /** Reads and enables pagination through a set of `AccountStatementPdf`. */
  accountStatementPdfs?: Maybe<AccountStatementPdfsConnection>;
  /** Reads and enables pagination through a set of `AccountStatement`. */
  accountStatements?: Maybe<AccountStatementsConnection>;
  /** Evalute an adhoc monitor */
  adhocMonitor?: Maybe<AdhocMonitor>;
  appointment?: Maybe<Appointment>;
  /** Reads a single `Appointment` using its globally unique `ID`. */
  appointmentByNodeId?: Maybe<Appointment>;
  appointmentByYardIdAndConfirmationId?: Maybe<Appointment>;
  /** Reads and enables pagination through a set of `Appointment`. */
  appointments?: Maybe<AppointmentsConnection>;
  assessment?: Maybe<Assessment>;
  /** Reads a single `Assessment` using its globally unique `ID`. */
  assessmentByNodeId?: Maybe<Assessment>;
  assessmentType?: Maybe<AssessmentType>;
  /** Reads a single `AssessmentType` using its globally unique `ID`. */
  assessmentTypeByNodeId?: Maybe<AssessmentType>;
  assessmentTypeBySlug?: Maybe<AssessmentType>;
  /** Reads and enables pagination through a set of `AssessmentType`. */
  assessmentTypes?: Maybe<AssessmentTypesConnection>;
  /** Reads and enables pagination through a set of `Assessment`. */
  assessments?: Maybe<AssessmentsConnection>;
  /** Reads and enables pagination through a set of `BalancingAuthority`. */
  balancingAuthorities?: Maybe<BalancingAuthoritiesConnection>;
  balancingAuthority?: Maybe<BalancingAuthority>;
  /** Reads a single `BalancingAuthority` using its globally unique `ID`. */
  balancingAuthorityByNodeId?: Maybe<BalancingAuthority>;
  balancingAuthorityBySlug?: Maybe<BalancingAuthority>;
  billableCustomer?: Maybe<BillableCustomer>;
  billableCustomerByCarrierCode?: Maybe<BillableCustomer>;
  /** Reads a single `BillableCustomer` using its globally unique `ID`. */
  billableCustomerByNodeId?: Maybe<BillableCustomer>;
  /** Reads and enables pagination through a set of `BillableCustomer`. */
  billableCustomers?: Maybe<BillableCustomersConnection>;
  blast?: Maybe<Blast>;
  blastByLabelAndFacilityId?: Maybe<Blast>;
  /** Reads a single `Blast` using its globally unique `ID`. */
  blastByNodeId?: Maybe<Blast>;
  blastEvaporator?: Maybe<BlastEvaporator>;
  /** Reads a single `BlastEvaporator` using its globally unique `ID`. */
  blastEvaporatorByNodeId?: Maybe<BlastEvaporator>;
  /** Reads and enables pagination through a set of `BlastEvaporator`. */
  blastEvaporators?: Maybe<BlastEvaporatorsConnection>;
  blastPallet?: Maybe<BlastPallet>;
  /** Reads a single `BlastPallet` using its globally unique `ID`. */
  blastPalletByNodeId?: Maybe<BlastPallet>;
  blastPalletLocation?: Maybe<BlastPalletLocation>;
  /** Reads a single `BlastPalletLocation` using its globally unique `ID`. */
  blastPalletLocationByNodeId?: Maybe<BlastPalletLocation>;
  /** Reads and enables pagination through a set of `BlastPalletLocation`. */
  blastPalletLocations?: Maybe<BlastPalletLocationsConnection>;
  /** Reads and enables pagination through a set of `BlastPallet`. */
  blastPallets?: Maybe<BlastPalletsConnection>;
  blastRotation?: Maybe<BlastRotation>;
  blastRotationAlert?: Maybe<BlastRotationAlert>;
  /** Reads a single `BlastRotationAlert` using its globally unique `ID`. */
  blastRotationAlertByNodeId?: Maybe<BlastRotationAlert>;
  /** Reads and enables pagination through a set of `BlastRotationAlert`. */
  blastRotationAlerts?: Maybe<BlastRotationAlertsConnection>;
  /** Reads a single `BlastRotation` using its globally unique `ID`. */
  blastRotationByNodeId?: Maybe<BlastRotation>;
  blastRotationEventLog?: Maybe<BlastRotationEventLog>;
  blastRotationEventLogByBlastRotationIdAndDescriptionAndBlastRotationEventTypeId?: Maybe<BlastRotationEventLog>;
  /** Reads a single `BlastRotationEventLog` using its globally unique `ID`. */
  blastRotationEventLogByNodeId?: Maybe<BlastRotationEventLog>;
  /** Reads and enables pagination through a set of `BlastRotationEventLog`. */
  blastRotationEventLogs?: Maybe<BlastRotationEventLogsConnection>;
  blastRotationEventType?: Maybe<BlastRotationEventType>;
  /** Reads a single `BlastRotationEventType` using its globally unique `ID`. */
  blastRotationEventTypeByNodeId?: Maybe<BlastRotationEventType>;
  /** Reads and enables pagination through a set of `BlastRotationEventType`. */
  blastRotationEventTypes?: Maybe<BlastRotationEventTypesConnection>;
  blastRotationPallet?: Maybe<BlastRotationPallet>;
  blastRotationPalletByBlastRotationIdAndPalletId?: Maybe<BlastRotationPallet>;
  /** Reads a single `BlastRotationPallet` using its globally unique `ID`. */
  blastRotationPalletByNodeId?: Maybe<BlastRotationPallet>;
  /** Reads and enables pagination through a set of `BlastRotationPallet`. */
  blastRotationPallets?: Maybe<BlastRotationPalletsConnection>;
  /** Reads and enables pagination through a set of `BlastRotation`. */
  blastRotations?: Maybe<BlastRotationsConnection>;
  blastType?: Maybe<BlastType>;
  /** Reads a single `BlastType` using its globally unique `ID`. */
  blastTypeByNodeId?: Maybe<BlastType>;
  /** Reads and enables pagination through a set of `BlastType`. */
  blastTypes?: Maybe<BlastTypesConnection>;
  /** Reads and enables pagination through a set of `Blast`. */
  blasts?: Maybe<BlastsConnection>;
  buildingArea?: Maybe<BuildingArea>;
  buildingAreaByFacilityIdAndLabel?: Maybe<BuildingArea>;
  /** Reads a single `BuildingArea` using its globally unique `ID`. */
  buildingAreaByNodeId?: Maybe<BuildingArea>;
  buildingAreaComplianceGroup?: Maybe<BuildingAreaComplianceGroup>;
  buildingAreaComplianceGroupByBuildingAreaIdAndComplianceType?: Maybe<BuildingAreaComplianceGroup>;
  /** Reads a single `BuildingAreaComplianceGroup` using its globally unique `ID`. */
  buildingAreaComplianceGroupByNodeId?: Maybe<BuildingAreaComplianceGroup>;
  /** Reads and enables pagination through a set of `BuildingAreaComplianceGroup`. */
  buildingAreaComplianceGroups?: Maybe<BuildingAreaComplianceGroupsConnection>;
  buildingAreaType?: Maybe<BuildingAreaType>;
  /** Reads a single `BuildingAreaType` using its globally unique `ID`. */
  buildingAreaTypeByNodeId?: Maybe<BuildingAreaType>;
  /** Reads and enables pagination through a set of `BuildingAreaType`. */
  buildingAreaTypes?: Maybe<BuildingAreaTypesConnection>;
  /** Reads and enables pagination through a set of `BuildingArea`. */
  buildingAreas?: Maybe<BuildingAreasConnection>;
  /** Reads and enables pagination through a set of `ChargeLabelCategory`. */
  chargeLabelCategories?: Maybe<ChargeLabelCategoriesConnection>;
  chargeLabelCategory?: Maybe<ChargeLabelCategory>;
  chargeLabelCategoryByCategory?: Maybe<ChargeLabelCategory>;
  /** Reads a single `ChargeLabelCategory` using its globally unique `ID`. */
  chargeLabelCategoryByNodeId?: Maybe<ChargeLabelCategory>;
  chart?: Maybe<Chart>;
  /** Reads a single `Chart` using its globally unique `ID`. */
  chartByNodeId?: Maybe<Chart>;
  /** Reads and enables pagination through a set of `Chart`. */
  charts?: Maybe<ChartsConnection>;
  check?: Maybe<Check>;
  /** Reads a single `Check` using its globally unique `ID`. */
  checkByNodeId?: Maybe<Check>;
  checkBySlug?: Maybe<Check>;
  checkMonitor?: Maybe<CheckMonitor>;
  checkMonitorByMonitorId?: Maybe<CheckMonitor>;
  /** Reads a single `CheckMonitor` using its globally unique `ID`. */
  checkMonitorByNodeId?: Maybe<CheckMonitor>;
  /** Reads and enables pagination through a set of `CheckMonitor`. */
  checkMonitors?: Maybe<CheckMonitorsConnection>;
  /** Reads and enables pagination through a set of `Check`. */
  checks?: Maybe<ChecksConnection>;
  classification?: Maybe<Classification>;
  classificationByAssessmentTypeIdAndName?: Maybe<Classification>;
  /** Reads a single `Classification` using its globally unique `ID`. */
  classificationByNodeId?: Maybe<Classification>;
  classificationResult?: Maybe<ClassificationResult>;
  classificationResultByAssessmentIdAndClassificationId?: Maybe<ClassificationResult>;
  /** Reads a single `ClassificationResult` using its globally unique `ID`. */
  classificationResultByNodeId?: Maybe<ClassificationResult>;
  /** Reads and enables pagination through a set of `ClassificationResult`. */
  classificationResults?: Maybe<ClassificationResultsConnection>;
  /** Reads and enables pagination through a set of `Classification`. */
  classifications?: Maybe<ClassificationsConnection>;
  complianceGroup?: Maybe<ComplianceGroup>;
  complianceGroupByLabel?: Maybe<ComplianceGroup>;
  /** Reads a single `ComplianceGroup` using its globally unique `ID`. */
  complianceGroupByNodeId?: Maybe<ComplianceGroup>;
  /** Reads and enables pagination through a set of `ComplianceGroup`. */
  complianceGroups?: Maybe<ComplianceGroupsConnection>;
  complianceRange?: Maybe<ComplianceRange>;
  complianceRangeByComplianceGroupIdAndLabel?: Maybe<ComplianceRange>;
  /** Reads a single `ComplianceRange` using its globally unique `ID`. */
  complianceRangeByNodeId?: Maybe<ComplianceRange>;
  /** Reads and enables pagination through a set of `ComplianceRange`. */
  complianceRanges?: Maybe<ComplianceRangesConnection>;
  component?: Maybe<Component>;
  /** Reads a single `Component` using its globally unique `ID`. */
  componentByNodeId?: Maybe<Component>;
  /** Reads and enables pagination through a set of `Component`. */
  components?: Maybe<ComponentsConnection>;
  compressor?: Maybe<Compressor>;
  compressorByFacilityIdAndLabel?: Maybe<Compressor>;
  /** Reads a single `Compressor` using its globally unique `ID`. */
  compressorByNodeId?: Maybe<Compressor>;
  /** Reads and enables pagination through a set of `Compressor`. */
  compressors?: Maybe<CompressorsConnection>;
  controlEvent?: Maybe<ControlEvent>;
  /** Reads a single `ControlEvent` using its globally unique `ID`. */
  controlEventByNodeId?: Maybe<ControlEvent>;
  controlEventLog?: Maybe<ControlEventLog>;
  /** Reads a single `ControlEventLog` using its globally unique `ID`. */
  controlEventLogByNodeId?: Maybe<ControlEventLog>;
  /** Reads a single `ControlEventStateTransition` using its globally unique `ID`. */
  controlEventStateTransitionByNodeId?: Maybe<ControlEventStateTransition>;
  /** Reads and enables pagination through a set of `ControlEvent`. */
  controlEvents?: Maybe<ControlEventsConnection>;
  currentIdentity?: Maybe<Identity>;
  customer?: Maybe<Customer>;
  customerBillingRate?: Maybe<CustomerBillingRate>;
  customerBillingRateByCustomerIdAndEffectiveStart?: Maybe<CustomerBillingRate>;
  /** Reads a single `CustomerBillingRate` using its globally unique `ID`. */
  customerBillingRateByNodeId?: Maybe<CustomerBillingRate>;
  /** Reads and enables pagination through a set of `CustomerBillingRate`. */
  customerBillingRates?: Maybe<CustomerBillingRatesConnection>;
  /** Reads a single `Customer` using its globally unique `ID`. */
  customerByNodeId?: Maybe<Customer>;
  customerBySourceId?: Maybe<Customer>;
  customerIntegration?: Maybe<CustomerIntegration>;
  customerIntegrationByIntegrationProviderId?: Maybe<CustomerIntegration>;
  /** Reads a single `CustomerIntegration` using its globally unique `ID`. */
  customerIntegrationByNodeId?: Maybe<CustomerIntegration>;
  customerIntegrationCredential?: Maybe<CustomerIntegrationCredential>;
  /** Reads a single `CustomerIntegrationCredential` using its globally unique `ID`. */
  customerIntegrationCredentialByNodeId?: Maybe<CustomerIntegrationCredential>;
  /** Reads and enables pagination through a set of `CustomerIntegrationCredential`. */
  customerIntegrationCredentials?: Maybe<CustomerIntegrationCredentialsConnection>;
  /** Reads and enables pagination through a set of `CustomerIntegration`. */
  customerIntegrations?: Maybe<CustomerIntegrationsConnection>;
  /** Reads and enables pagination through a set of `Customer`. */
  customers?: Maybe<CustomersConnection>;
  dashboard?: Maybe<Dashboard>;
  /** Reads a single `Dashboard` using its globally unique `ID`. */
  dashboardByNodeId?: Maybe<Dashboard>;
  /** Reads and enables pagination through a set of `Dashboard`. */
  dashboards?: Maybe<DashboardsConnection>;
  dataPoint?: Maybe<DataPoint>;
  dataPointById?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` using its globally unique `ID`. */
  dataPointByNodeId?: Maybe<DataPoint>;
  dataPointTag?: Maybe<DataPointTag>;
  /** Reads a single `DataPointTag` using its globally unique `ID`. */
  dataPointTagByNodeId?: Maybe<DataPointTag>;
  /** Reads and enables pagination through a set of `DataPointTag`. */
  dataPointTags?: Maybe<DataPointTagsConnection>;
  /** Reads and enables pagination through a set of `DataPoint`. */
  dataPoints?: Maybe<DataPointsConnection>;
  dataSource?: Maybe<DataSource>;
  /** Reads a single `DataSource` using its globally unique `ID`. */
  dataSourceByNodeId?: Maybe<DataSource>;
  /** Reads and enables pagination through a set of `DataSource`. */
  dataSources?: Maybe<DataSourcesConnection>;
  /** Reads and enables pagination through a set of `Dependency`. */
  dependencies?: Maybe<DependenciesConnection>;
  dependency?: Maybe<Dependency>;
  /** Reads a single `Dependency` using its globally unique `ID`. */
  dependencyByNodeId?: Maybe<Dependency>;
  dependencyByPath?: Maybe<Dependency>;
  /** Returns the derived statement date for the interval */
  deriveStatementDate?: Maybe<DerivedStatementDate>;
  dischargeHeader?: Maybe<DischargeHeader>;
  /** Reads a single `DischargeHeader` using its globally unique `ID`. */
  dischargeHeaderByNodeId?: Maybe<DischargeHeader>;
  dischargeHeaderByRefrigerationSystemIdAndLabel?: Maybe<DischargeHeader>;
  /** Reads and enables pagination through a set of `DischargeHeader`. */
  dischargeHeaders?: Maybe<DischargeHeadersConnection>;
  door?: Maybe<Door>;
  doorByFacilityIdAndLabel?: Maybe<Door>;
  /** Reads a single `Door` using its globally unique `ID`. */
  doorByNodeId?: Maybe<Door>;
  /** Reads and enables pagination through a set of `Door`. */
  doors?: Maybe<DoorsConnection>;
  driver?: Maybe<Driver>;
  driverByConversationId?: Maybe<Driver>;
  /** Reads a single `Driver` using its globally unique `ID`. */
  driverByNodeId?: Maybe<Driver>;
  driverByPhoneNumber?: Maybe<Driver>;
  /** Reads and enables pagination through a set of `Driver`. */
  drivers?: Maybe<DriversConnection>;
  electricalCircuit?: Maybe<ElectricalCircuit>;
  /** Reads a single `ElectricalCircuit` using its globally unique `ID`. */
  electricalCircuitByNodeId?: Maybe<ElectricalCircuit>;
  /** Reads and enables pagination through a set of `ElectricalCircuit`. */
  electricalCircuits?: Maybe<ElectricalCircuitsConnection>;
  electricalMeteringPoint?: Maybe<ElectricalMeteringPoint>;
  /** Reads a single `ElectricalMeteringPoint` using its globally unique `ID`. */
  electricalMeteringPointByNodeId?: Maybe<ElectricalMeteringPoint>;
  /** Reads and enables pagination through a set of `ElectricalMeteringPoint`. */
  electricalMeteringPoints?: Maybe<ElectricalMeteringPointsConnection>;
  electricalPanel?: Maybe<ElectricalPanel>;
  electricalPanelByElectricalMeteringPointId?: Maybe<ElectricalPanel>;
  /** Reads a single `ElectricalPanel` using its globally unique `ID`. */
  electricalPanelByNodeId?: Maybe<ElectricalPanel>;
  /** Reads and enables pagination through a set of `ElectricalPanel`. */
  electricalPanels?: Maybe<ElectricalPanelsConnection>;
  /**
   * Returns a list enabled module extensions
   * @deprecated Use softwarePackages(filter: {isEnabled: {equalTo: true}})...
   */
  enabledModuleExtensions?: Maybe<Array<Maybe<ModuleExtension>>>;
  evaporator?: Maybe<Evaporator>;
  evaporatorByFacilityIdAndLabel?: Maybe<Evaporator>;
  /** Reads a single `Evaporator` using its globally unique `ID`. */
  evaporatorByNodeId?: Maybe<Evaporator>;
  /** Reads and enables pagination through a set of `Evaporator`. */
  evaporators?: Maybe<EvaporatorsConnection>;
  event?: Maybe<Event>;
  /** Reads a single `Event` using its globally unique `ID`. */
  eventByNodeId?: Maybe<Event>;
  eventHandler?: Maybe<EventHandler>;
  /** Reads a single `EventHandler` using its globally unique `ID`. */
  eventHandlerByNodeId?: Maybe<EventHandler>;
  eventHandlerMetadatum?: Maybe<EventHandlerMetadatum>;
  /** Reads a single `EventHandlerMetadatum` using its globally unique `ID`. */
  eventHandlerMetadatumByNodeId?: Maybe<EventHandlerMetadatum>;
  eventType?: Maybe<EventType>;
  /** Reads a single `EventType` using its globally unique `ID`. */
  eventTypeByNodeId?: Maybe<EventType>;
  /** Reads and enables pagination through a set of `Facility`. */
  facilities?: Maybe<FacilitiesConnection>;
  facility?: Maybe<Facility>;
  /** Reads a single `Facility` using its globally unique `ID`. */
  facilityByNodeId?: Maybe<Facility>;
  facilityBySlug?: Maybe<Facility>;
  facilityCheck?: Maybe<FacilityCheck>;
  facilityCheckByFacilityIdAndCheckId?: Maybe<FacilityCheck>;
  /** Reads a single `FacilityCheck` using its globally unique `ID`. */
  facilityCheckByNodeId?: Maybe<FacilityCheck>;
  facilityCheckUser?: Maybe<FacilityCheckUser>;
  /** Reads a single `FacilityCheckUser` using its globally unique `ID`. */
  facilityCheckUserByNodeId?: Maybe<FacilityCheckUser>;
  /** Reads and enables pagination through a set of `FacilityCheckUser`. */
  facilityCheckUsers?: Maybe<FacilityCheckUsersConnection>;
  /** Reads and enables pagination through a set of `FacilityCheck`. */
  facilityChecks?: Maybe<FacilityChecksConnection>;
  facilityCommunication?: Maybe<FacilityCommunication>;
  /** Reads a single `FacilityCommunication` using its globally unique `ID`. */
  facilityCommunicationByNodeId?: Maybe<FacilityCommunication>;
  /** Reads and enables pagination through a set of `FacilityCommunication`. */
  facilityCommunications?: Maybe<FacilityCommunicationsConnection>;
  facilityConfig?: Maybe<FacilityConfig>;
  /** Reads a single `FacilityConfig` using its globally unique `ID`. */
  facilityConfigByNodeId?: Maybe<FacilityConfig>;
  /** Reads and enables pagination through a set of `FacilityConfig`. */
  facilityConfigs?: Maybe<FacilityConfigsConnection>;
  facilityDataSource?: Maybe<FacilityDataSource>;
  /** Reads a single `FacilityDataSource` using its globally unique `ID`. */
  facilityDataSourceByNodeId?: Maybe<FacilityDataSource>;
  /** Reads and enables pagination through a set of `FacilityDataSource`. */
  facilityDataSources?: Maybe<FacilityDataSourcesConnection>;
  facilityDocument?: Maybe<FacilityDocument>;
  /** Reads a single `FacilityDocument` using its globally unique `ID`. */
  facilityDocumentByNodeId?: Maybe<FacilityDocument>;
  /** Reads and enables pagination through a set of `FacilityDocument`. */
  facilityDocuments?: Maybe<FacilityDocumentsConnection>;
  facilityGroup?: Maybe<FacilityGroup>;
  /** Reads a single `FacilityGroup` using its globally unique `ID`. */
  facilityGroupByNodeId?: Maybe<FacilityGroup>;
  /** Reads and enables pagination through a set of `FacilityGroup`. */
  facilityGroups?: Maybe<FacilityGroupsConnection>;
  facilityGroupsLinker?: Maybe<FacilityGroupsLinker>;
  /** Reads a single `FacilityGroupsLinker` using its globally unique `ID`. */
  facilityGroupsLinkerByNodeId?: Maybe<FacilityGroupsLinker>;
  /** Reads and enables pagination through a set of `FacilityGroupsLinker`. */
  facilityGroupsLinkers?: Maybe<FacilityGroupsLinkersConnection>;
  facilitySoftwarePackage?: Maybe<FacilitySoftwarePackage>;
  facilitySoftwarePackageByFacilityIdAndSoftwarePackageId?: Maybe<FacilitySoftwarePackage>;
  /** Reads a single `FacilitySoftwarePackage` using its globally unique `ID`. */
  facilitySoftwarePackageByNodeId?: Maybe<FacilitySoftwarePackage>;
  /** Reads and enables pagination through a set of `FacilitySoftwarePackage`. */
  facilitySoftwarePackages?: Maybe<FacilitySoftwarePackagesConnection>;
  facilityTaggedDataPoint?: Maybe<FacilityTaggedDataPoint>;
  /** Reads a single `FacilityTaggedDataPoint` using its globally unique `ID`. */
  facilityTaggedDataPointByNodeId?: Maybe<FacilityTaggedDataPoint>;
  /** Reads and enables pagination through a set of `FacilityTaggedDataPoint`. */
  facilityTaggedDataPoints?: Maybe<FacilityTaggedDataPointsConnection>;
  facilityUtilityAccount?: Maybe<FacilityUtilityAccount>;
  facilityUtilityAccountByFacilityIdAndUtilityAccountId?: Maybe<FacilityUtilityAccount>;
  /** Reads a single `FacilityUtilityAccount` using its globally unique `ID`. */
  facilityUtilityAccountByNodeId?: Maybe<FacilityUtilityAccount>;
  /** Reads and enables pagination through a set of `FacilityUtilityAccount`. */
  facilityUtilityAccounts?: Maybe<FacilityUtilityAccountsConnection>;
  gateway?: Maybe<Gateway>;
  gatewayByFacilityIdAndHardwareId?: Maybe<Gateway>;
  gatewayByFacilityIdAndLabel?: Maybe<Gateway>;
  /** Reads a single `Gateway` using its globally unique `ID`. */
  gatewayByNodeId?: Maybe<Gateway>;
  /** Reads and enables pagination through a set of `Gateway`. */
  gateways?: Maybe<GatewaysConnection>;
  getMessageAccessToken?: Maybe<MessageAccessTokenPayload>;
  /** A json object of all facility groups built from the root. */
  groupings?: Maybe<GroupingsConnection>;
  /** A json object of all facility groups with their facilities built from the root and all ungrouped facilities */
  groupingsWithFacilities?: Maybe<GroupingsWithFacilitiesConnection>;
  inboundOutboundLoad?: Maybe<InboundOutboundLoad>;
  /** Reads a single `InboundOutboundLoad` using its globally unique `ID`. */
  inboundOutboundLoadByNodeId?: Maybe<InboundOutboundLoad>;
  inboundOutboundLoadBySourceId?: Maybe<InboundOutboundLoad>;
  /** Reads and enables pagination through a set of `InboundOutboundLoad`. */
  inboundOutboundLoads?: Maybe<InboundOutboundLoadsConnection>;
  incident?: Maybe<Incident>;
  incidentByCheckMonitorIdAndMonitorDetectionId?: Maybe<Incident>;
  /** Reads a single `Incident` using its globally unique `ID`. */
  incidentByNodeId?: Maybe<Incident>;
  incidentLogByIncidentIdAndEventAndTime?: Maybe<IncidentLog>;
  /** Reads and enables pagination through a set of `IncidentLog`. */
  incidentLogs?: Maybe<IncidentLogsConnection>;
  /** Reads and enables pagination through a set of `Incident`. */
  incidents?: Maybe<IncidentsConnection>;
  integrationProvider?: Maybe<IntegrationProvider>;
  integrationProviderByName?: Maybe<IntegrationProvider>;
  /** Reads a single `IntegrationProvider` using its globally unique `ID`. */
  integrationProviderByNodeId?: Maybe<IntegrationProvider>;
  /** Reads and enables pagination through a set of `IntegrationProvider`. */
  integrationProviders?: Maybe<IntegrationProvidersConnection>;
  liquidHeader?: Maybe<LiquidHeader>;
  /** Reads a single `LiquidHeader` using its globally unique `ID`. */
  liquidHeaderByNodeId?: Maybe<LiquidHeader>;
  liquidHeaderByRefrigerationSystemIdAndLabel?: Maybe<LiquidHeader>;
  /** Reads and enables pagination through a set of `LiquidHeader`. */
  liquidHeaders?: Maybe<LiquidHeadersConnection>;
  liquidHeadersEvaporator?: Maybe<LiquidHeadersEvaporator>;
  liquidHeadersEvaporatorByLiquidHeaderIdAndEvaporatorId?: Maybe<LiquidHeadersEvaporator>;
  /** Reads a single `LiquidHeadersEvaporator` using its globally unique `ID`. */
  liquidHeadersEvaporatorByNodeId?: Maybe<LiquidHeadersEvaporator>;
  /** Reads and enables pagination through a set of `LiquidHeadersEvaporator`. */
  liquidHeadersEvaporators?: Maybe<LiquidHeadersEvaporatorsConnection>;
  machineUser?: Maybe<MachineUser>;
  /** Reads a single `MachineUser` using its globally unique `ID`. */
  machineUserByNodeId?: Maybe<MachineUser>;
  /** Reads and enables pagination through a set of `MachineUser`. */
  machineUsers?: Maybe<MachineUsersConnection>;
  mainService?: Maybe<MainService>;
  mainServiceByFacilityIdAndName?: Maybe<MainService>;
  mainServiceByFacilityIdAndUsageDataPointIdAndDemandDataPointId?: Maybe<MainService>;
  /** Reads a single `MainService` using its globally unique `ID`. */
  mainServiceByNodeId?: Maybe<MainService>;
  /** Reads and enables pagination through a set of `MainService`. */
  mainServices?: Maybe<MainServicesConnection>;
  meterCharge?: Maybe<MeterCharge>;
  /** Reads a single `MeterCharge` using its globally unique `ID`. */
  meterChargeByNodeId?: Maybe<MeterCharge>;
  /** Reads and enables pagination through a set of `MeterCharge`. */
  meterCharges?: Maybe<MeterChargesConnection>;
  meterStatement?: Maybe<MeterStatement>;
  /** Reads a single `MeterStatement` using its globally unique `ID`. */
  meterStatementByNodeId?: Maybe<MeterStatement>;
  /** Reads and enables pagination through a set of `MeterStatementHistory`. */
  meterStatementHistories?: Maybe<MeterStatementHistoriesConnection>;
  /** @deprecated Use pdfUri property on the statement */
  meterStatementPdf?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `MeterStatement`. */
  meterStatements?: Maybe<MeterStatementsConnection>;
  meterUsage?: Maybe<MeterUsage>;
  /** Reads a single `MeterUsage` using its globally unique `ID`. */
  meterUsageByNodeId?: Maybe<MeterUsage>;
  /** Reads and enables pagination through a set of `MeterUsage`. */
  meterUsages?: Maybe<MeterUsagesConnection>;
  /** @deprecated Use `sourceData` for IoT time series data. */
  metricData?: Maybe<MetricDataConnection>;
  /** @deprecated Use `sourceLabels` for IoT device name and field discovery. */
  metricLabels: Array<MetricLabel>;
  /** Reads and enables pagination through a set of `MetricMetadatum`. */
  metricMetadata?: Maybe<MetricMetadataConnection>;
  metricMetadatum?: Maybe<MetricMetadatum>;
  /** Reads a single `MetricMetadatum` using its globally unique `ID`. */
  metricMetadatumByNodeId?: Maybe<MetricMetadatum>;
  /**
   * Returns a list of known module extensions
   * @deprecated Use softwarePackages
   */
  moduleExtensions?: Maybe<Array<ModuleExtension>>;
  monitor?: Maybe<Monitor>;
  monitorAttribute?: Maybe<MonitorAttribute>;
  /** Reads a single `MonitorAttribute` using its globally unique `ID`. */
  monitorAttributeByNodeId?: Maybe<MonitorAttribute>;
  /** Reads and enables pagination through a set of `MonitorAttribute`. */
  monitorAttributes?: Maybe<MonitorAttributesConnection>;
  /** Reads a single `Monitor` using its globally unique `ID`. */
  monitorByNodeId?: Maybe<Monitor>;
  monitorDataPoint?: Maybe<MonitorDataPoint>;
  /** Reads a single `MonitorDataPoint` using its globally unique `ID`. */
  monitorDataPointByNodeId?: Maybe<MonitorDataPoint>;
  /** Reads and enables pagination through a set of `MonitorDataPoint`. */
  monitorDataPoints?: Maybe<MonitorDataPointsConnection>;
  monitorDetection?: Maybe<MonitorDetection>;
  /** Reads a single `MonitorDetection` using its globally unique `ID`. */
  monitorDetectionByNodeId?: Maybe<MonitorDetection>;
  /** Reads and enables pagination through a set of `MonitorDetectionSummary`. */
  monitorDetectionSummariesByTimeframe?: Maybe<MonitorDetectionSummariesConnection>;
  /** Reads and enables pagination through a set of `MonitorDetection`. */
  monitorDetections?: Maybe<MonitorDetectionsConnection>;
  /** Reads and enables pagination through a set of `MonitorEnabledUserSubscription`. */
  monitorEnabledUserSubscriptions?: Maybe<MonitorEnabledUserSubscriptionsConnection>;
  monitoredAsset?: Maybe<MonitoredAsset>;
  /** Reads a single `MonitoredAsset` using its globally unique `ID`. */
  monitoredAssetByNodeId?: Maybe<MonitoredAsset>;
  /** Reads and enables pagination through a set of `MonitoredAssetType`. */
  monitoredAssetTypes?: Maybe<MonitoredAssetTypesConnection>;
  /** Reads and enables pagination through a set of `MonitoredAsset`. */
  monitoredAssets?: Maybe<MonitoredAssetsConnection>;
  /** Reads and enables pagination through a set of `MonitoredAssetsLatestAssessment`. */
  monitoredAssetsLatestAssessments?: Maybe<MonitoredAssetsLatestAssessmentsConnection>;
  /** Reads and enables pagination through a set of `Monitor`. */
  monitors?: Maybe<MonitorsConnection>;
  /** Fetches an object given its globally unique `ID`. */
  node?: Maybe<Node>;
  /** The root query type must be a `Node` to work well with Relay 1 mutations. This just resolves to `query`. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `Opportunity`. */
  opportunities?: Maybe<OpportunitiesConnection>;
  opportunity?: Maybe<Opportunity>;
  opportunityAttachment?: Maybe<OpportunityAttachment>;
  /** Reads a single `OpportunityAttachment` using its globally unique `ID`. */
  opportunityAttachmentByNodeId?: Maybe<OpportunityAttachment>;
  /** Reads a single `Opportunity` using its globally unique `ID`. */
  opportunityByNodeId?: Maybe<Opportunity>;
  /** Returns a distinct list of all opportunity tags. */
  opportunityTags?: Maybe<OpportunityTagsConnection>;
  opportunityTransition?: Maybe<OpportunityTransition>;
  /** Reads a single `OpportunityTransition` using its globally unique `ID`. */
  opportunityTransitionByNodeId?: Maybe<OpportunityTransition>;
  /** Reads and enables pagination through a set of `OpportunityTransition`. */
  opportunityTransitions?: Maybe<OpportunityTransitionsConnection>;
  organization: Organization;
  pallet?: Maybe<Pallet>;
  /** Reads a single `Pallet` using its globally unique `ID`. */
  palletByNodeId?: Maybe<Pallet>;
  palletBySourceId?: Maybe<Pallet>;
  /** Reads and enables pagination through a set of `PalletHistory`. */
  palletHistories?: Maybe<PalletHistoriesConnection>;
  palletHistory?: Maybe<PalletHistory>;
  /** Reads a single `PalletHistory` using its globally unique `ID`. */
  palletHistoryByNodeId?: Maybe<PalletHistory>;
  palletHistoryBySourceId?: Maybe<PalletHistory>;
  palletLocation?: Maybe<PalletLocation>;
  /** Reads a single `PalletLocation` using its globally unique `ID`. */
  palletLocationByNodeId?: Maybe<PalletLocation>;
  palletLocationBySourceId?: Maybe<PalletLocation>;
  /** Reads and enables pagination through a set of `PalletLocation`. */
  palletLocations?: Maybe<PalletLocationsConnection>;
  /** Reads and enables pagination through a set of `Pallet`. */
  pallets?: Maybe<PalletsConnection>;
  parkSession?: Maybe<ParkSession>;
  /** Reads a single `ParkSession` using its globally unique `ID`. */
  parkSessionByNodeId?: Maybe<ParkSession>;
  /** Reads and enables pagination through a set of `ParkSession`. */
  parkSessions?: Maybe<ParkSessionsConnection>;
  /** Reads and enables pagination through a set of `PlatformAccessToken`. */
  platformAccessTokens?: Maybe<PlatformAccessTokensConnection>;
  /** Returns a list of known platform errors */
  platformErrors: Array<PlatformError>;
  pricingNode?: Maybe<PricingNode>;
  /** Reads a single `PricingNode` using its globally unique `ID`. */
  pricingNodeByNodeId?: Maybe<PricingNode>;
  /** Reads and enables pagination through a set of `PricingNode`. */
  pricingNodes?: Maybe<PricingNodesConnection>;
  product?: Maybe<Product>;
  /** Reads a single `Product` using its globally unique `ID`. */
  productByNodeId?: Maybe<Product>;
  productBySourceId?: Maybe<Product>;
  /** Reads and enables pagination through a set of `Product`. */
  products?: Maybe<ProductsConnection>;
  /** Returns the current user`s profile. */
  profile?: Maybe<User>;
  program?: Maybe<Program>;
  /** Reads a single `Program` using its globally unique `ID`. */
  programByNodeId?: Maybe<Program>;
  programByProjectTypeIdAndName?: Maybe<Program>;
  programConfig?: Maybe<ProgramConfig>;
  /** Reads a single `ProgramConfig` using its globally unique `ID`. */
  programConfigByNodeId?: Maybe<ProgramConfig>;
  /** Reads and enables pagination through a set of `ProgramConfig`. */
  programConfigs?: Maybe<ProgramConfigsConnection>;
  programEnrollment?: Maybe<ProgramEnrollment>;
  /** Reads a single `ProgramEnrollment` using its globally unique `ID`. */
  programEnrollmentByNodeId?: Maybe<ProgramEnrollment>;
  programEnrollmentByProgramIdAndName?: Maybe<ProgramEnrollment>;
  /** Reads and enables pagination through a set of `ProgramEnrollment`. */
  programEnrollments?: Maybe<ProgramEnrollmentsConnection>;
  /** Reads and enables pagination through a set of `Program`. */
  programs?: Maybe<ProgramsConnection>;
  project?: Maybe<Project>;
  projectByFacilityIdAndProgramId?: Maybe<Project>;
  /** Reads a single `Project` using its globally unique `ID`. */
  projectByNodeId?: Maybe<Project>;
  projectComponent?: Maybe<ProjectComponent>;
  /** Reads a single `ProjectComponent` using its globally unique `ID`. */
  projectComponentByNodeId?: Maybe<ProjectComponent>;
  projectConfig?: Maybe<ProjectConfig>;
  /** Reads a single `ProjectConfig` using its globally unique `ID`. */
  projectConfigByNodeId?: Maybe<ProjectConfig>;
  /** Reads and enables pagination through a set of `ProjectConfig`. */
  projectConfigs?: Maybe<ProjectConfigsConnection>;
  /** Reads and enables pagination through a set of `ProjectEnabledUserSubscription`. */
  projectEnabledUserSubscriptions?: Maybe<ProjectEnabledUserSubscriptionsConnection>;
  projectEnrollment?: Maybe<ProjectEnrollment>;
  /** Reads a single `ProjectEnrollment` using its globally unique `ID`. */
  projectEnrollmentByNodeId?: Maybe<ProjectEnrollment>;
  projectEnrollmentByProjectIdAndProgramEnrollmentId?: Maybe<ProjectEnrollment>;
  projectEnrollmentDataPoint?: Maybe<ProjectEnrollmentDataPoint>;
  /** Reads a single `ProjectEnrollmentDataPoint` using its globally unique `ID`. */
  projectEnrollmentDataPointByNodeId?: Maybe<ProjectEnrollmentDataPoint>;
  projectEnrollmentDataPointByProjectEnrollmentIdAndDataPointId?: Maybe<ProjectEnrollmentDataPoint>;
  projectEnrollmentDataPointGroup?: Maybe<ProjectEnrollmentDataPointGroup>;
  /** Reads a single `ProjectEnrollmentDataPointGroup` using its globally unique `ID`. */
  projectEnrollmentDataPointGroupByNodeId?: Maybe<ProjectEnrollmentDataPointGroup>;
  /** Reads and enables pagination through a set of `ProjectEnrollmentDataPointGroup`. */
  projectEnrollmentDataPointGroups?: Maybe<ProjectEnrollmentDataPointGroupsConnection>;
  /** Reads and enables pagination through a set of `ProjectEnrollmentDataPoint`. */
  projectEnrollmentDataPoints?: Maybe<ProjectEnrollmentDataPointsConnection>;
  /** Reads and enables pagination through a set of `ProjectEnrollment`. */
  projectEnrollments?: Maybe<ProjectEnrollmentsConnection>;
  projectType?: Maybe<ProjectType>;
  projectTypeByName?: Maybe<ProjectType>;
  /** Reads a single `ProjectType` using its globally unique `ID`. */
  projectTypeByNodeId?: Maybe<ProjectType>;
  /** Reads and enables pagination through a set of `ProjectType`. */
  projectTypes?: Maybe<ProjectTypesConnection>;
  projectWatcher?: Maybe<ProjectWatcher>;
  /** Reads a single `ProjectWatcher` using its globally unique `ID`. */
  projectWatcherByNodeId?: Maybe<ProjectWatcher>;
  /** Reads and enables pagination through a set of `ProjectWatcher`. */
  projectWatchers?: Maybe<ProjectWatchersConnection>;
  /** Reads and enables pagination through a set of `Project`. */
  projects?: Maybe<ProjectsConnection>;
  /**
   * Exposes the root query type nested one level down. This is helpful for Relay 1
   * which can only query top level fields if they are in a particular form.
   */
  query: Query;
  refrigerant?: Maybe<Refrigerant>;
  /** Reads a single `Refrigerant` using its globally unique `ID`. */
  refrigerantByNodeId?: Maybe<Refrigerant>;
  /** Reads and enables pagination through a set of `Refrigerant`. */
  refrigerants?: Maybe<RefrigerantsConnection>;
  refrigerationSystem?: Maybe<RefrigerationSystem>;
  refrigerationSystemByFacilityIdAndLabel?: Maybe<RefrigerationSystem>;
  /** Reads a single `RefrigerationSystem` using its globally unique `ID`. */
  refrigerationSystemByNodeId?: Maybe<RefrigerationSystem>;
  /** Reads and enables pagination through a set of `RefrigerationSystem`. */
  refrigerationSystems?: Maybe<RefrigerationSystemsConnection>;
  report?: Maybe<Report>;
  reportAutomation?: Maybe<ReportAutomation>;
  /** Reads a single `ReportAutomation` using its globally unique `ID`. */
  reportAutomationByNodeId?: Maybe<ReportAutomation>;
  /** Reads and enables pagination through a set of `ReportAutomation`. */
  reportAutomations?: Maybe<ReportAutomationsConnection>;
  reportByLabel?: Maybe<Report>;
  /** Reads a single `Report` using its globally unique `ID`. */
  reportByNodeId?: Maybe<Report>;
  reportExecution?: Maybe<ReportExecution>;
  /** Reads a single `ReportExecution` using its globally unique `ID`. */
  reportExecutionByNodeId?: Maybe<ReportExecution>;
  /** Reads and enables pagination through a set of `ReportExecution`. */
  reportExecutions?: Maybe<ReportExecutionsConnection>;
  /** Reads and enables pagination through a set of `ReportQuery`. */
  reportQueries?: Maybe<ReportQueriesConnection>;
  reportQuery?: Maybe<ReportQuery>;
  /** Reads a single `ReportQuery` using its globally unique `ID`. */
  reportQueryByNodeId?: Maybe<ReportQuery>;
  reportQueryByReportIdAndLabel?: Maybe<ReportQuery>;
  /** Reads and enables pagination through a set of `Report`. */
  reports?: Maybe<ReportsConnection>;
  savingsEvent?: Maybe<SavingsEvent>;
  /** Reads a single `SavingsEvent` using its globally unique `ID`. */
  savingsEventByNodeId?: Maybe<SavingsEvent>;
  savingsEventByProjectIdAndStartTimeAndEndTime?: Maybe<SavingsEvent>;
  /** Reads and enables pagination through a set of `SavingsEventDatum`. */
  savingsEventData?: Maybe<SavingsEventDataConnection>;
  savingsEventDatum?: Maybe<SavingsEventDatum>;
  /** Reads a single `SavingsEventDatum` using its globally unique `ID`. */
  savingsEventDatumByNodeId?: Maybe<SavingsEventDatum>;
  savingsEventDatumBySavingsEventIdAndLabel?: Maybe<SavingsEventDatum>;
  /** Reads and enables pagination through a set of `SavingsEvent`. */
  savingsEvents?: Maybe<SavingsEventsConnection>;
  /** Reads and enables pagination through a set of `Severity`. */
  severities?: Maybe<SeveritiesConnection>;
  severity?: Maybe<Severity>;
  severityByName?: Maybe<Severity>;
  /** Reads a single `Severity` using its globally unique `ID`. */
  severityByNodeId?: Maybe<Severity>;
  severityBySlug?: Maybe<Severity>;
  softwarePackage?: Maybe<SoftwarePackage>;
  /** Reads a single `SoftwarePackage` using its globally unique `ID`. */
  softwarePackageByNodeId?: Maybe<SoftwarePackage>;
  softwarePackageBySlug?: Maybe<SoftwarePackage>;
  /** Reads and enables pagination through a set of `SoftwarePackage`. */
  softwarePackages?: Maybe<SoftwarePackagesConnection>;
  sourceData?: Maybe<MetricDataConnection>;
  sourceLabels: Array<SourceLabel>;
  space?: Maybe<Space>;
  /** Reads and enables pagination through a set of `SpaceActivity`. */
  spaceActivities?: Maybe<SpaceActivitiesConnection>;
  spaceActivity?: Maybe<SpaceActivity>;
  /** Reads a single `SpaceActivity` using its globally unique `ID`. */
  spaceActivityByNodeId?: Maybe<SpaceActivity>;
  /** Reads a single `Space` using its globally unique `ID`. */
  spaceByNodeId?: Maybe<Space>;
  spaceBySpaceCategoryIdAndNumber?: Maybe<Space>;
  /** Reads and enables pagination through a set of `SpaceCategory`. */
  spaceCategories?: Maybe<SpaceCategoriesConnection>;
  spaceCategory?: Maybe<SpaceCategory>;
  /** Reads a single `SpaceCategory` using its globally unique `ID`. */
  spaceCategoryByNodeId?: Maybe<SpaceCategory>;
  spaceCategoryByYardIdAndName?: Maybe<SpaceCategory>;
  /** Reads and enables pagination through a set of `Space`. */
  spaces?: Maybe<SpacesConnection>;
  submeter?: Maybe<Submeter>;
  /** Reads a single `Submeter` using its globally unique `ID`. */
  submeterByNodeId?: Maybe<Submeter>;
  submeterSession?: Maybe<SubmeterSession>;
  /** Reads a single `SubmeterSession` using its globally unique `ID`. */
  submeterSessionByNodeId?: Maybe<SubmeterSession>;
  submeterSessionBySubmeterIdAndStartTime?: Maybe<SubmeterSession>;
  /** Reads and enables pagination through a set of `SubmeterSession`. */
  submeterSessions?: Maybe<SubmeterSessionsConnection>;
  /** Reads and enables pagination through a set of `Submeter`. */
  submeters?: Maybe<SubmetersConnection>;
  suctionGroup?: Maybe<SuctionGroup>;
  /** Reads a single `SuctionGroup` using its globally unique `ID`. */
  suctionGroupByNodeId?: Maybe<SuctionGroup>;
  suctionGroupByRefrigerationSystemIdAndLabel?: Maybe<SuctionGroup>;
  suctionGroupCompressor?: Maybe<SuctionGroupCompressor>;
  /** Reads a single `SuctionGroupCompressor` using its globally unique `ID`. */
  suctionGroupCompressorByNodeId?: Maybe<SuctionGroupCompressor>;
  suctionGroupCompressorBySuctionGroupIdAndCompressorId?: Maybe<SuctionGroupCompressor>;
  /** Reads and enables pagination through a set of `SuctionGroupCompressor`. */
  suctionGroupCompressors?: Maybe<SuctionGroupCompressorsConnection>;
  /** Reads and enables pagination through a set of `SuctionGroup`. */
  suctionGroups?: Maybe<SuctionGroupsConnection>;
  suctionHeader?: Maybe<SuctionHeader>;
  /** Reads a single `SuctionHeader` using its globally unique `ID`. */
  suctionHeaderByNodeId?: Maybe<SuctionHeader>;
  suctionHeaderByRefrigerationSystemIdAndLabel?: Maybe<SuctionHeader>;
  /** Reads and enables pagination through a set of `SuctionHeader`. */
  suctionHeaders?: Maybe<SuctionHeadersConnection>;
  suctionHeadersCompressor?: Maybe<SuctionHeadersCompressor>;
  /** Reads a single `SuctionHeadersCompressor` using its globally unique `ID`. */
  suctionHeadersCompressorByNodeId?: Maybe<SuctionHeadersCompressor>;
  suctionHeadersCompressorBySuctionHeaderIdAndCompressorId?: Maybe<SuctionHeadersCompressor>;
  /** Reads and enables pagination through a set of `SuctionHeadersCompressor`. */
  suctionHeadersCompressors?: Maybe<SuctionHeadersCompressorsConnection>;
  suggestion?: Maybe<Suggestion>;
  /** Reads and enables pagination through a set of `SuggestionActivityLog`. */
  suggestionActivityLogs?: Maybe<SuggestionActivityLogsConnection>;
  /** Reads a single `Suggestion` using its globally unique `ID`. */
  suggestionByNodeId?: Maybe<Suggestion>;
  suggestionControlEvent?: Maybe<SuggestionControlEvent>;
  suggestionControlEventByControlEventId?: Maybe<SuggestionControlEvent>;
  /** Reads a single `SuggestionControlEvent` using its globally unique `ID`. */
  suggestionControlEventByNodeId?: Maybe<SuggestionControlEvent>;
  /** Reads and enables pagination through a set of `Suggestion`. */
  suggestions?: Maybe<SuggestionsConnection>;
  temperatureSensor?: Maybe<TemperatureSensor>;
  temperatureSensorByFacilityIdAndHardwareId?: Maybe<TemperatureSensor>;
  temperatureSensorByFacilityIdAndLabel?: Maybe<TemperatureSensor>;
  /** Reads a single `TemperatureSensor` using its globally unique `ID`. */
  temperatureSensorByNodeId?: Maybe<TemperatureSensor>;
  /** Reads and enables pagination through a set of `TemperatureSensor`. */
  temperatureSensors?: Maybe<TemperatureSensorsConnection>;
  timezone?: Maybe<Timezone>;
  /** Reads a single `Timezone` using its globally unique `ID`. */
  timezoneByNodeId?: Maybe<Timezone>;
  /** Reads and enables pagination through a set of `Timezone`. */
  timezones?: Maybe<TimezonesConnection>;
  trailer?: Maybe<Trailer>;
  trailerAppointment?: Maybe<TrailerAppointment>;
  trailerAppointmentByAppointmentId?: Maybe<TrailerAppointment>;
  /** Reads a single `TrailerAppointment` using its globally unique `ID`. */
  trailerAppointmentByNodeId?: Maybe<TrailerAppointment>;
  /** Reads and enables pagination through a set of `TrailerAppointment`. */
  trailerAppointments?: Maybe<TrailerAppointmentsConnection>;
  trailerAudit?: Maybe<TrailerAudit>;
  /** Reads a single `TrailerAudit` using its globally unique `ID`. */
  trailerAuditByNodeId?: Maybe<TrailerAudit>;
  /** Reads and enables pagination through a set of `TrailerAudit`. */
  trailerAudits?: Maybe<TrailerAuditsConnection>;
  trailerByCarrierCodeAndCarrierTrailerNumber?: Maybe<Trailer>;
  /** Reads a single `Trailer` using its globally unique `ID`. */
  trailerByNodeId?: Maybe<Trailer>;
  trailerPosition?: Maybe<TrailerPosition>;
  trailerPositionByFacilityIdAndLabel?: Maybe<TrailerPosition>;
  /** Reads a single `TrailerPosition` using its globally unique `ID`. */
  trailerPositionByNodeId?: Maybe<TrailerPosition>;
  /** Reads and enables pagination through a set of `TrailerPosition`. */
  trailerPositions?: Maybe<TrailerPositionsConnection>;
  /** Reads and enables pagination through a set of `Trailer`. */
  trailers?: Maybe<TrailersConnection>;
  unitDimension?: Maybe<UnitDimension>;
  /** Reads a single `UnitDimension` using its globally unique `ID`. */
  unitDimensionByNodeId?: Maybe<UnitDimension>;
  /** Reads and enables pagination through a set of `UnitDimension`. */
  unitDimensions?: Maybe<UnitDimensionsConnection>;
  unitGroup?: Maybe<UnitGroup>;
  /** Reads a single `UnitGroup` using its globally unique `ID`. */
  unitGroupByNodeId?: Maybe<UnitGroup>;
  unitGroupDimension?: Maybe<UnitGroupDimension>;
  /** Reads a single `UnitGroupDimension` using its globally unique `ID`. */
  unitGroupDimensionByNodeId?: Maybe<UnitGroupDimension>;
  /** Reads and enables pagination through a set of `UnitGroupDimension`. */
  unitGroupDimensions?: Maybe<UnitGroupDimensionsConnection>;
  /** Reads and enables pagination through a set of `UnitGroup`. */
  unitGroups?: Maybe<UnitGroupsConnection>;
  user?: Maybe<User>;
  /** Reads a single `User` using its globally unique `ID`. */
  userByNodeId?: Maybe<User>;
  /** Reads and enables pagination through a set of `User`. */
  users?: Maybe<UsersConnection>;
  utilityAccount?: Maybe<UtilityAccount>;
  /** Reads a single `UtilityAccount` using its globally unique `ID`. */
  utilityAccountByNodeId?: Maybe<UtilityAccount>;
  utilityAccountStatement?: Maybe<UtilityAccountStatement>;
  /** Reads a single `UtilityAccountStatement` using its globally unique `ID`. */
  utilityAccountStatementByNodeId?: Maybe<UtilityAccountStatement>;
  utilityAccountStatementRollup?: Maybe<UtilityAccountStatementRollup>;
  /** Reads a single `UtilityAccountStatementRollup` using its globally unique `ID`. */
  utilityAccountStatementRollupByNodeId?: Maybe<UtilityAccountStatementRollup>;
  /** Reads and enables pagination through a set of `UtilityAccountStatementRollup`. */
  utilityAccountStatementRollups?: Maybe<UtilityAccountStatementRollupsConnection>;
  /** Reads and enables pagination through a set of `UtilityAccountStatement`. */
  utilityAccountStatements?: Maybe<UtilityAccountStatementsConnection>;
  /** Reads and enables pagination through a set of `UtilityAccount`. */
  utilityAccounts?: Maybe<UtilityAccountsConnection>;
  utilityCredential?: Maybe<UtilityCredential>;
  utilityCredentialByIntegrationAndIntegrationKey?: Maybe<UtilityCredential>;
  /** Reads a single `UtilityCredential` using its globally unique `ID`. */
  utilityCredentialByNodeId?: Maybe<UtilityCredential>;
  /** Reads and enables pagination through a set of `UtilityCredentialFacility`. */
  utilityCredentialFacilities?: Maybe<UtilityCredentialFacilitiesConnection>;
  utilityCredentialFacility?: Maybe<UtilityCredentialFacility>;
  /** Reads a single `UtilityCredentialFacility` using its globally unique `ID`. */
  utilityCredentialFacilityByNodeId?: Maybe<UtilityCredentialFacility>;
  utilityCredentialFacilityByUtilityCredentialIdAndFacilityId?: Maybe<UtilityCredentialFacility>;
  /** Reads and enables pagination through a set of `UtilityCredential`. */
  utilityCredentials?: Maybe<UtilityCredentialsConnection>;
  utilityFileUpload?: Maybe<UtilityFileUpload>;
  utilityFileUploadByIntegrationAndIntegrationKey?: Maybe<UtilityFileUpload>;
  /** Reads a single `UtilityFileUpload` using its globally unique `ID`. */
  utilityFileUploadByNodeId?: Maybe<UtilityFileUpload>;
  /** Reads and enables pagination through a set of `UtilityFileUpload`. */
  utilityFileUploads?: Maybe<UtilityFileUploadsConnection>;
  utilityMeter?: Maybe<UtilityMeter>;
  /** Reads a single `UtilityMeter` using its globally unique `ID`. */
  utilityMeterByNodeId?: Maybe<UtilityMeter>;
  utilityMeterStatement?: Maybe<UtilityMeterStatement>;
  /** Reads a single `UtilityMeterStatement` using its globally unique `ID`. */
  utilityMeterStatementByNodeId?: Maybe<UtilityMeterStatement>;
  utilityMeterStatementRollup?: Maybe<UtilityMeterStatementRollup>;
  /** Reads a single `UtilityMeterStatementRollup` using its globally unique `ID`. */
  utilityMeterStatementRollupByNodeId?: Maybe<UtilityMeterStatementRollup>;
  /** Reads and enables pagination through a set of `UtilityMeterStatementRollup`. */
  utilityMeterStatementRollups?: Maybe<UtilityMeterStatementRollupsConnection>;
  /** Reads and enables pagination through a set of `UtilityMeterStatement`. */
  utilityMeterStatements?: Maybe<UtilityMeterStatementsConnection>;
  /** Reads and enables pagination through a set of `UtilityMeter`. */
  utilityMeters?: Maybe<UtilityMetersConnection>;
  utilityPendingMeter?: Maybe<UtilityPendingMeter>;
  utilityPendingMeterByIntegrationAndIntegrationKey?: Maybe<UtilityPendingMeter>;
  /** Reads a single `UtilityPendingMeter` using its globally unique `ID`. */
  utilityPendingMeterByNodeId?: Maybe<UtilityPendingMeter>;
  /** Reads and enables pagination through a set of `UtilityPendingMeter`. */
  utilityPendingMeters?: Maybe<UtilityPendingMetersConnection>;
  utilityProvider?: Maybe<UtilityProvider>;
  utilityProviderByName?: Maybe<UtilityProvider>;
  /** Reads a single `UtilityProvider` using its globally unique `ID`. */
  utilityProviderByNodeId?: Maybe<UtilityProvider>;
  /** Reads and enables pagination through a set of `UtilityProvider`. */
  utilityProviders?: Maybe<UtilityProvidersConnection>;
  vendorUser?: Maybe<VendorUser>;
  vendorUserByEmail?: Maybe<VendorUser>;
  /** Reads a single `VendorUser` using its globally unique `ID`. */
  vendorUserByNodeId?: Maybe<VendorUser>;
  vendorUserMachineUser?: Maybe<VendorUserMachineUser>;
  vendorUserMachineUserByMachineUserId?: Maybe<VendorUserMachineUser>;
  /** Reads a single `VendorUserMachineUser` using its globally unique `ID`. */
  vendorUserMachineUserByNodeId?: Maybe<VendorUserMachineUser>;
  /** Reads and enables pagination through a set of `VendorUser`. */
  vendorUsers?: Maybe<VendorUsersConnection>;
  vessel?: Maybe<Vessel>;
  /** Reads a single `Vessel` using its globally unique `ID`. */
  vesselByNodeId?: Maybe<Vessel>;
  vesselByRefrigerationSystemIdAndLabel?: Maybe<Vessel>;
  /** Reads and enables pagination through a set of `Vessel`. */
  vessels?: Maybe<VesselsConnection>;
  virtualPointInterval?: Maybe<VirtualPointInterval>;
  /** Reads a single `VirtualPointInterval` using its globally unique `ID`. */
  virtualPointIntervalByNodeId?: Maybe<VirtualPointInterval>;
  /** Reads and enables pagination through a set of `VirtualPointInterval`. */
  virtualPointIntervals?: Maybe<VirtualPointIntervalsConnection>;
  yard?: Maybe<Yard>;
  yardByFacilityId?: Maybe<Yard>;
  /** Reads a single `Yard` using its globally unique `ID`. */
  yardByNodeId?: Maybe<Yard>;
  /** Reads and enables pagination through a set of `Yard`. */
  yards?: Maybe<YardsConnection>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAccountChargeArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryAccountChargeByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryAccountChargesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AccountChargeCondition>;
  filter?: InputMaybe<AccountChargeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountChargesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAccountStatementArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryAccountStatementByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryAccountStatementHistoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AccountStatementHistoryCondition>;
  filter?: InputMaybe<AccountStatementHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountStatementHistoriesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAccountStatementPdfArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryAccountStatementPdfByAccountStatementIdAndFileKeyArgs = {
  accountStatementId: Scalars['Int']['input'];
  fileKey: Scalars['String']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryAccountStatementPdfByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryAccountStatementPdfsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AccountStatementPdfCondition>;
  filter?: InputMaybe<AccountStatementPdfFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountStatementPdfsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAccountStatementsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AccountStatementCondition>;
  filter?: InputMaybe<AccountStatementFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountStatementsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAdhocMonitorArgs = {
  monitor: AdhocMonitorInput;
};

/** The root query type which gives access points into the data universe. */
export type QueryAppointmentArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryAppointmentByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryAppointmentByYardIdAndConfirmationIdArgs = {
  confirmationId: Scalars['String']['input'];
  yardId: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryAppointmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AppointmentCondition>;
  filter?: InputMaybe<AppointmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AppointmentsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAssessmentArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryAssessmentByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryAssessmentTypeArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryAssessmentTypeByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryAssessmentTypeBySlugArgs = {
  slug: Scalars['String']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryAssessmentTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AssessmentTypeCondition>;
  filter?: InputMaybe<AssessmentTypeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AssessmentTypesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAssessmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AssessmentCondition>;
  filter?: InputMaybe<AssessmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AssessmentsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryBalancingAuthoritiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BalancingAuthorityCondition>;
  filter?: InputMaybe<BalancingAuthorityFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BalancingAuthoritiesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryBalancingAuthorityArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBalancingAuthorityByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBalancingAuthorityBySlugArgs = {
  slug: Scalars['String']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBillableCustomerArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBillableCustomerByCarrierCodeArgs = {
  carrierCode: Scalars['String']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBillableCustomerByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBillableCustomersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BillableCustomerCondition>;
  filter?: InputMaybe<BillableCustomerFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BillableCustomersOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastByLabelAndFacilityIdArgs = {
  facilityId: Scalars['Int']['input'];
  label: Scalars['String']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastEvaporatorArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastEvaporatorByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastEvaporatorsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BlastEvaporatorCondition>;
  filter?: InputMaybe<BlastEvaporatorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BlastEvaporatorsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastPalletArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastPalletByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastPalletLocationArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastPalletLocationByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastPalletLocationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BlastPalletLocationCondition>;
  filter?: InputMaybe<BlastPalletLocationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BlastPalletLocationsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastPalletsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BlastPalletCondition>;
  filter?: InputMaybe<BlastPalletFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BlastPalletsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastRotationArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastRotationAlertArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastRotationAlertByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastRotationAlertsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BlastRotationAlertCondition>;
  filter?: InputMaybe<BlastRotationAlertFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BlastRotationAlertsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastRotationByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastRotationEventLogArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastRotationEventLogByBlastRotationIdAndDescriptionAndBlastRotationEventTypeIdArgs =
  {
    blastRotationEventTypeId: Scalars['String']['input'];
    blastRotationId: Scalars['Int']['input'];
    description: Scalars['String']['input'];
  };

/** The root query type which gives access points into the data universe. */
export type QueryBlastRotationEventLogByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastRotationEventLogsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BlastRotationEventLogCondition>;
  filter?: InputMaybe<BlastRotationEventLogFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BlastRotationEventLogsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastRotationEventTypeArgs = {
  eventType: Scalars['String']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastRotationEventTypeByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastRotationEventTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BlastRotationEventTypeCondition>;
  filter?: InputMaybe<BlastRotationEventTypeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BlastRotationEventTypesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastRotationPalletArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastRotationPalletByBlastRotationIdAndPalletIdArgs = {
  blastRotationId: Scalars['Int']['input'];
  palletId: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastRotationPalletByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastRotationPalletsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BlastRotationPalletCondition>;
  filter?: InputMaybe<BlastRotationPalletFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BlastRotationPalletsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastRotationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BlastRotationCondition>;
  filter?: InputMaybe<BlastRotationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BlastRotationsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastTypeArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastTypeByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BlastTypeCondition>;
  filter?: InputMaybe<BlastTypeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BlastTypesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryBlastsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BlastCondition>;
  filter?: InputMaybe<BlastFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BlastsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryBuildingAreaArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBuildingAreaByFacilityIdAndLabelArgs = {
  facilityId: Scalars['Int']['input'];
  label: Scalars['String']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBuildingAreaByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBuildingAreaComplianceGroupArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBuildingAreaComplianceGroupByBuildingAreaIdAndComplianceTypeArgs =
  {
    buildingAreaId: Scalars['Int']['input'];
    complianceType: ComplianceType;
  };

/** The root query type which gives access points into the data universe. */
export type QueryBuildingAreaComplianceGroupByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBuildingAreaComplianceGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BuildingAreaComplianceGroupCondition>;
  filter?: InputMaybe<BuildingAreaComplianceGroupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BuildingAreaComplianceGroupsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryBuildingAreaTypeArgs = {
  type: Scalars['String']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBuildingAreaTypeByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryBuildingAreaTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BuildingAreaTypeCondition>;
  filter?: InputMaybe<BuildingAreaTypeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BuildingAreaTypesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryBuildingAreasArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BuildingAreaCondition>;
  filter?: InputMaybe<BuildingAreaFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BuildingAreasOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryChargeLabelCategoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ChargeLabelCategoryCondition>;
  filter?: InputMaybe<ChargeLabelCategoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChargeLabelCategoriesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryChargeLabelCategoryArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryChargeLabelCategoryByCategoryArgs = {
  category: Scalars['String']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryChargeLabelCategoryByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryChartArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryChartByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryChartsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ChartCondition>;
  filter?: InputMaybe<ChartFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChartsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryCheckArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryCheckByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryCheckBySlugArgs = {
  slug: Scalars['String']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryCheckMonitorArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryCheckMonitorByMonitorIdArgs = {
  monitorId: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryCheckMonitorByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryCheckMonitorsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CheckMonitorCondition>;
  filter?: InputMaybe<CheckMonitorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CheckMonitorsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryChecksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CheckCondition>;
  filter?: InputMaybe<CheckFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChecksOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryClassificationArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryClassificationByAssessmentTypeIdAndNameArgs = {
  assessmentTypeId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryClassificationByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryClassificationResultArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryClassificationResultByAssessmentIdAndClassificationIdArgs = {
  assessmentId: Scalars['Int']['input'];
  classificationId: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryClassificationResultByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryClassificationResultsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ClassificationResultCondition>;
  filter?: InputMaybe<ClassificationResultFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ClassificationResultsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryClassificationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ClassificationCondition>;
  filter?: InputMaybe<ClassificationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ClassificationsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryComplianceGroupArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryComplianceGroupByLabelArgs = {
  label: Scalars['String']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryComplianceGroupByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryComplianceGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ComplianceGroupCondition>;
  filter?: InputMaybe<ComplianceGroupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ComplianceGroupsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryComplianceRangeArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryComplianceRangeByComplianceGroupIdAndLabelArgs = {
  complianceGroupId: Scalars['Int']['input'];
  label: Scalars['String']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryComplianceRangeByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryComplianceRangesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ComplianceRangeCondition>;
  filter?: InputMaybe<ComplianceRangeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ComplianceRangesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryComponentArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryComponentByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryComponentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ComponentCondition>;
  filter?: InputMaybe<ComponentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ComponentsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryCompressorArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryCompressorByFacilityIdAndLabelArgs = {
  facilityId: Scalars['Int']['input'];
  label: Scalars['String']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryCompressorByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryCompressorsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CompressorCondition>;
  filter?: InputMaybe<CompressorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CompressorsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryControlEventArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryControlEventByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryControlEventLogArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryControlEventLogByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryControlEventStateTransitionByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryControlEventsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ControlEventCondition>;
  filter?: InputMaybe<ControlEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ControlEventsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryCustomerArgs = {
  id: Scalars['BigInt']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryCustomerBillingRateArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryCustomerBillingRateByCustomerIdAndEffectiveStartArgs = {
  customerId: Scalars['Int']['input'];
  effectiveStart: Scalars['Datetime']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryCustomerBillingRateByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryCustomerBillingRatesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CustomerBillingRateCondition>;
  filter?: InputMaybe<CustomerBillingRateFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CustomerBillingRatesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryCustomerByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryCustomerBySourceIdArgs = {
  sourceId: Scalars['String']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryCustomerIntegrationArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryCustomerIntegrationByIntegrationProviderIdArgs = {
  integrationProviderId: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryCustomerIntegrationByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryCustomerIntegrationCredentialArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryCustomerIntegrationCredentialByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryCustomerIntegrationCredentialsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CustomerIntegrationCredentialCondition>;
  filter?: InputMaybe<CustomerIntegrationCredentialFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CustomerIntegrationCredentialsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryCustomerIntegrationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CustomerIntegrationCondition>;
  filter?: InputMaybe<CustomerIntegrationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CustomerIntegrationsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryCustomersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CustomerCondition>;
  filter?: InputMaybe<CustomerFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CustomersOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryDashboardArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryDashboardByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryDashboardsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DashboardCondition>;
  filter?: InputMaybe<DashboardFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DashboardsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryDataPointArgs = {
  dataSourceName: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryDataPointByIdArgs = {
  id: Scalars['BigInt']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryDataPointByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryDataPointTagArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryDataPointTagByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryDataPointTagsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DataPointTagCondition>;
  filter?: InputMaybe<DataPointTagFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataPointTagsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryDataPointsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DataPointCondition>;
  filter?: InputMaybe<DataPointFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataPointsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryDataSourceArgs = {
  name: Scalars['String']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryDataSourceByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryDataSourcesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DataSourceCondition>;
  filter?: InputMaybe<DataSourceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataSourcesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryDependenciesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DependencyCondition>;
  filter?: InputMaybe<DependencyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DependenciesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryDependencyArgs = {
  id: Scalars['BigInt']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryDependencyByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryDependencyByPathArgs = {
  path: Scalars['String']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryDeriveStatementDateArgs = {
  intervalBegin: Scalars['Date']['input'];
  intervalEnd: Scalars['Date']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryDischargeHeaderArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryDischargeHeaderByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryDischargeHeaderByRefrigerationSystemIdAndLabelArgs = {
  label: Scalars['String']['input'];
  refrigerationSystemId: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryDischargeHeadersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DischargeHeaderCondition>;
  filter?: InputMaybe<DischargeHeaderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DischargeHeadersOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryDoorArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryDoorByFacilityIdAndLabelArgs = {
  facilityId: Scalars['Int']['input'];
  label: Scalars['String']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryDoorByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryDoorsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DoorCondition>;
  filter?: InputMaybe<DoorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DoorsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryDriverArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryDriverByConversationIdArgs = {
  conversationId: Scalars['String']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryDriverByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryDriverByPhoneNumberArgs = {
  phoneNumber: Scalars['String']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryDriversArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DriverCondition>;
  filter?: InputMaybe<DriverFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DriversOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryElectricalCircuitArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryElectricalCircuitByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryElectricalCircuitsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ElectricalCircuitCondition>;
  filter?: InputMaybe<ElectricalCircuitFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ElectricalCircuitsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryElectricalMeteringPointArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryElectricalMeteringPointByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryElectricalMeteringPointsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ElectricalMeteringPointCondition>;
  filter?: InputMaybe<ElectricalMeteringPointFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ElectricalMeteringPointsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryElectricalPanelArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryElectricalPanelByElectricalMeteringPointIdArgs = {
  electricalMeteringPointId: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryElectricalPanelByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryElectricalPanelsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ElectricalPanelCondition>;
  filter?: InputMaybe<ElectricalPanelFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ElectricalPanelsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryEvaporatorArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryEvaporatorByFacilityIdAndLabelArgs = {
  facilityId: Scalars['Int']['input'];
  label: Scalars['String']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryEvaporatorByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryEvaporatorsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EvaporatorCondition>;
  filter?: InputMaybe<EvaporatorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvaporatorsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryEventArgs = {
  id: Scalars['BigInt']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryEventByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryEventHandlerArgs = {
  handler: Scalars['String']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryEventHandlerByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryEventHandlerMetadatumArgs = {
  handler: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryEventHandlerMetadatumByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryEventTypeArgs = {
  name: Scalars['String']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryEventTypeByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FacilityCondition>;
  filter?: InputMaybe<FacilityFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FacilitiesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilityArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilityByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilityBySlugArgs = {
  slug: Scalars['String']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilityCheckArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilityCheckByFacilityIdAndCheckIdArgs = {
  checkId: Scalars['Int']['input'];
  facilityId: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilityCheckByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilityCheckUserArgs = {
  facilityCheckId: Scalars['Int']['input'];
  userId: Scalars['String']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilityCheckUserByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilityCheckUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FacilityCheckUserCondition>;
  filter?: InputMaybe<FacilityCheckUserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FacilityCheckUsersOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilityChecksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FacilityCheckCondition>;
  filter?: InputMaybe<FacilityCheckFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FacilityChecksOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilityCommunicationArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilityCommunicationByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilityCommunicationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FacilityCommunicationCondition>;
  filter?: InputMaybe<FacilityCommunicationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FacilityCommunicationsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilityConfigArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilityConfigByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilityConfigsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FacilityConfigCondition>;
  filter?: InputMaybe<FacilityConfigFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FacilityConfigsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilityDataSourceArgs = {
  dataSourceName: Scalars['String']['input'];
  facilityId: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilityDataSourceByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilityDataSourcesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FacilityDataSourceCondition>;
  filter?: InputMaybe<FacilityDataSourceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FacilityDataSourcesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilityDocumentArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilityDocumentByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilityDocumentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FacilityDocumentCondition>;
  filter?: InputMaybe<FacilityDocumentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FacilityDocumentsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilityGroupArgs = {
  id: Scalars['BigInt']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilityGroupByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilityGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FacilityGroupCondition>;
  filter?: InputMaybe<FacilityGroupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FacilityGroupsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilityGroupsLinkerArgs = {
  facilityGroupingId: Scalars['BigInt']['input'];
  facilityId: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilityGroupsLinkerByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilityGroupsLinkersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FacilityGroupsLinkerCondition>;
  filter?: InputMaybe<FacilityGroupsLinkerFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FacilityGroupsLinkersOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilitySoftwarePackageArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilitySoftwarePackageByFacilityIdAndSoftwarePackageIdArgs = {
  facilityId: Scalars['Int']['input'];
  softwarePackageId: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilitySoftwarePackageByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilitySoftwarePackagesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FacilitySoftwarePackageCondition>;
  filter?: InputMaybe<FacilitySoftwarePackageFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FacilitySoftwarePackagesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilityTaggedDataPointArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilityTaggedDataPointByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilityTaggedDataPointsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FacilityTaggedDataPointCondition>;
  filter?: InputMaybe<FacilityTaggedDataPointFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FacilityTaggedDataPointsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilityUtilityAccountArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilityUtilityAccountByFacilityIdAndUtilityAccountIdArgs = {
  facilityId: Scalars['Int']['input'];
  utilityAccountId: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilityUtilityAccountByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryFacilityUtilityAccountsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FacilityUtilityAccountCondition>;
  filter?: InputMaybe<FacilityUtilityAccountFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FacilityUtilityAccountsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryGatewayArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryGatewayByFacilityIdAndHardwareIdArgs = {
  facilityId: Scalars['Int']['input'];
  hardwareId: Scalars['String']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryGatewayByFacilityIdAndLabelArgs = {
  facilityId: Scalars['Int']['input'];
  label: Scalars['String']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryGatewayByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryGatewaysArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GatewayCondition>;
  filter?: InputMaybe<GatewayFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GatewaysOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryGetMessageAccessTokenArgs = {
  yardId: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryGroupingsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<JsonFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** The root query type which gives access points into the data universe. */
export type QueryGroupingsWithFacilitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  facilityFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filter?: InputMaybe<JsonFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** The root query type which gives access points into the data universe. */
export type QueryInboundOutboundLoadArgs = {
  id: Scalars['BigInt']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryInboundOutboundLoadByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryInboundOutboundLoadBySourceIdArgs = {
  sourceId: Scalars['String']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryInboundOutboundLoadsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<InboundOutboundLoadCondition>;
  filter?: InputMaybe<InboundOutboundLoadFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InboundOutboundLoadsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryIncidentArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryIncidentByCheckMonitorIdAndMonitorDetectionIdArgs = {
  checkMonitorId: Scalars['Int']['input'];
  monitorDetectionId: Scalars['BigInt']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryIncidentByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryIncidentLogByIncidentIdAndEventAndTimeArgs = {
  event: Scalars['String']['input'];
  incidentId: Scalars['Int']['input'];
  time: Scalars['Datetime']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryIncidentLogsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<IncidentLogCondition>;
  filter?: InputMaybe<IncidentLogFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IncidentLogsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryIncidentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<IncidentCondition>;
  filter?: InputMaybe<IncidentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IncidentsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryIntegrationProviderArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryIntegrationProviderByNameArgs = {
  name: Scalars['String']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryIntegrationProviderByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryIntegrationProvidersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<IntegrationProviderCondition>;
  filter?: InputMaybe<IntegrationProviderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IntegrationProvidersOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryLiquidHeaderArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryLiquidHeaderByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryLiquidHeaderByRefrigerationSystemIdAndLabelArgs = {
  label: Scalars['String']['input'];
  refrigerationSystemId: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryLiquidHeadersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LiquidHeaderCondition>;
  filter?: InputMaybe<LiquidHeaderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiquidHeadersOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryLiquidHeadersEvaporatorArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryLiquidHeadersEvaporatorByLiquidHeaderIdAndEvaporatorIdArgs = {
  evaporatorId: Scalars['Int']['input'];
  liquidHeaderId: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryLiquidHeadersEvaporatorByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryLiquidHeadersEvaporatorsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LiquidHeadersEvaporatorCondition>;
  filter?: InputMaybe<LiquidHeadersEvaporatorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiquidHeadersEvaporatorsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryMachineUserArgs = {
  id: Scalars['BigInt']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryMachineUserByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryMachineUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MachineUserCondition>;
  filter?: InputMaybe<MachineUserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MachineUsersOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryMainServiceArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryMainServiceByFacilityIdAndNameArgs = {
  facilityId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryMainServiceByFacilityIdAndUsageDataPointIdAndDemandDataPointIdArgs =
  {
    demandDataPointId: Scalars['Int']['input'];
    facilityId: Scalars['Int']['input'];
    usageDataPointId: Scalars['Int']['input'];
  };

/** The root query type which gives access points into the data universe. */
export type QueryMainServiceByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryMainServicesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MainServiceCondition>;
  filter?: InputMaybe<MainServiceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MainServicesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryMeterChargeArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryMeterChargeByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryMeterChargesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MeterChargeCondition>;
  filter?: InputMaybe<MeterChargeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MeterChargesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryMeterStatementArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryMeterStatementByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryMeterStatementHistoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MeterStatementHistoryCondition>;
  filter?: InputMaybe<MeterStatementHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MeterStatementHistoriesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryMeterStatementPdfArgs = {
  id: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryMeterStatementsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MeterStatementCondition>;
  filter?: InputMaybe<MeterStatementFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MeterStatementsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryMeterUsageArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryMeterUsageByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryMeterUsagesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MeterUsageCondition>;
  filter?: InputMaybe<MeterUsageFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MeterUsagesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryMetricDataArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: InputMaybe<MetricDataAggregationMethod>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  sourceId: Scalars['String']['input'];
  to?: InputMaybe<Scalars['String']['input']>;
  window?: InputMaybe<Scalars['String']['input']>;
};

/** The root query type which gives access points into the data universe. */
export type QueryMetricMetadataArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MetricMetadatumCondition>;
  filter?: InputMaybe<MetricMetadatumFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetricMetadataOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryMetricMetadatumArgs = {
  label: Scalars['String']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryMetricMetadatumByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryMonitorArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryMonitorAttributeArgs = {
  key: Scalars['String']['input'];
  monitorId: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryMonitorAttributeByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryMonitorAttributesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MonitorAttributeCondition>;
  filter?: InputMaybe<MonitorAttributeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MonitorAttributesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryMonitorByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryMonitorDataPointArgs = {
  dataPointId: Scalars['Int']['input'];
  monitorId: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryMonitorDataPointByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryMonitorDataPointsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MonitorDataPointCondition>;
  filter?: InputMaybe<MonitorDataPointFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MonitorDataPointsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryMonitorDetectionArgs = {
  id: Scalars['BigInt']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryMonitorDetectionByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryMonitorDetectionSummariesByTimeframeArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  facilityIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  filter?: InputMaybe<MonitorDetectionSummaryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['Datetime']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MonitorDetectionSummariesOrderBy>>;
  to?: InputMaybe<Scalars['Datetime']['input']>;
};

/** The root query type which gives access points into the data universe. */
export type QueryMonitorDetectionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MonitorDetectionCondition>;
  filter?: InputMaybe<MonitorDetectionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MonitorDetectionsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryMonitorEnabledUserSubscriptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MonitorEnabledUserSubscriptionCondition>;
  filter?: InputMaybe<MonitorEnabledUserSubscriptionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MonitorEnabledUserSubscriptionsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryMonitoredAssetArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryMonitoredAssetByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryMonitoredAssetTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MonitoredAssetTypeCondition>;
  filter?: InputMaybe<MonitoredAssetTypeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MonitoredAssetTypesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryMonitoredAssetsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MonitoredAssetCondition>;
  filter?: InputMaybe<MonitoredAssetFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MonitoredAssetsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryMonitoredAssetsLatestAssessmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MonitoredAssetsLatestAssessmentCondition>;
  filter?: InputMaybe<MonitoredAssetsLatestAssessmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MonitoredAssetsLatestAssessmentsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryMonitorsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MonitorCondition>;
  filter?: InputMaybe<MonitorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MonitorsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryNodeArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryOpportunitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OpportunityCondition>;
  filter?: InputMaybe<OpportunityFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OpportunitiesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryOpportunityArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryOpportunityAttachmentArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryOpportunityAttachmentByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryOpportunityByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryOpportunityTagsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<StringFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** The root query type which gives access points into the data universe. */
export type QueryOpportunityTransitionArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryOpportunityTransitionByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryOpportunityTransitionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OpportunityTransitionCondition>;
  filter?: InputMaybe<OpportunityTransitionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OpportunityTransitionsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryPalletArgs = {
  id: Scalars['BigInt']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryPalletByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryPalletBySourceIdArgs = {
  sourceId: Scalars['String']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryPalletHistoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PalletHistoryCondition>;
  filter?: InputMaybe<PalletHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PalletHistoriesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryPalletHistoryArgs = {
  id: Scalars['BigInt']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryPalletHistoryByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryPalletHistoryBySourceIdArgs = {
  sourceId: Scalars['String']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryPalletLocationArgs = {
  id: Scalars['BigInt']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryPalletLocationByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryPalletLocationBySourceIdArgs = {
  sourceId: Scalars['String']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryPalletLocationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PalletLocationCondition>;
  filter?: InputMaybe<PalletLocationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PalletLocationsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryPalletsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PalletCondition>;
  filter?: InputMaybe<PalletFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PalletsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryParkSessionArgs = {
  id: Scalars['BigInt']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryParkSessionByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryParkSessionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ParkSessionCondition>;
  filter?: InputMaybe<ParkSessionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ParkSessionsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryPlatformAccessTokensArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PlatformAccessTokenCondition>;
  filter?: InputMaybe<PlatformAccessTokenFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PlatformAccessTokensOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryPricingNodeArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryPricingNodeByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryPricingNodesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PricingNodeCondition>;
  filter?: InputMaybe<PricingNodeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PricingNodesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryProductArgs = {
  id: Scalars['BigInt']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryProductByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryProductBySourceIdArgs = {
  sourceId: Scalars['String']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryProductsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProductCondition>;
  filter?: InputMaybe<ProductFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryProgramArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryProgramByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryProgramByProjectTypeIdAndNameArgs = {
  name: Scalars['String']['input'];
  projectTypeId: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryProgramConfigArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryProgramConfigByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryProgramConfigsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProgramConfigCondition>;
  filter?: InputMaybe<ProgramConfigFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProgramConfigsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryProgramEnrollmentArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryProgramEnrollmentByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryProgramEnrollmentByProgramIdAndNameArgs = {
  name: Scalars['String']['input'];
  programId: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryProgramEnrollmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProgramEnrollmentCondition>;
  filter?: InputMaybe<ProgramEnrollmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProgramEnrollmentsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryProgramsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProgramCondition>;
  filter?: InputMaybe<ProgramFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProgramsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryProjectArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryProjectByFacilityIdAndProgramIdArgs = {
  facilityId: Scalars['Int']['input'];
  programId: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryProjectByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryProjectComponentArgs = {
  componentId: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryProjectComponentByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryProjectConfigArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryProjectConfigByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryProjectConfigsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProjectConfigCondition>;
  filter?: InputMaybe<ProjectConfigFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProjectConfigsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryProjectEnabledUserSubscriptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProjectEnabledUserSubscriptionCondition>;
  filter?: InputMaybe<ProjectEnabledUserSubscriptionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProjectEnabledUserSubscriptionsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryProjectEnrollmentArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryProjectEnrollmentByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryProjectEnrollmentByProjectIdAndProgramEnrollmentIdArgs = {
  programEnrollmentId: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryProjectEnrollmentDataPointArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryProjectEnrollmentDataPointByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryProjectEnrollmentDataPointByProjectEnrollmentIdAndDataPointIdArgs =
  {
    dataPointId: Scalars['Int']['input'];
    projectEnrollmentId: Scalars['Int']['input'];
  };

/** The root query type which gives access points into the data universe. */
export type QueryProjectEnrollmentDataPointGroupArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryProjectEnrollmentDataPointGroupByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryProjectEnrollmentDataPointGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProjectEnrollmentDataPointGroupCondition>;
  filter?: InputMaybe<ProjectEnrollmentDataPointGroupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProjectEnrollmentDataPointGroupsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryProjectEnrollmentDataPointsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProjectEnrollmentDataPointCondition>;
  filter?: InputMaybe<ProjectEnrollmentDataPointFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProjectEnrollmentDataPointsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryProjectEnrollmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProjectEnrollmentCondition>;
  filter?: InputMaybe<ProjectEnrollmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProjectEnrollmentsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryProjectTypeArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryProjectTypeByNameArgs = {
  name: Scalars['String']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryProjectTypeByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryProjectTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProjectTypeCondition>;
  filter?: InputMaybe<ProjectTypeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProjectTypesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryProjectWatcherArgs = {
  projectId: Scalars['Int']['input'];
  userId: Scalars['String']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryProjectWatcherByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryProjectWatchersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProjectWatcherCondition>;
  filter?: InputMaybe<ProjectWatcherFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProjectWatchersOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryProjectsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProjectCondition>;
  filter?: InputMaybe<ProjectFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProjectsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryRefrigerantArgs = {
  code: Scalars['String']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryRefrigerantByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryRefrigerantsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RefrigerantCondition>;
  filter?: InputMaybe<RefrigerantFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RefrigerantsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryRefrigerationSystemArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryRefrigerationSystemByFacilityIdAndLabelArgs = {
  facilityId: Scalars['Int']['input'];
  label: Scalars['String']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryRefrigerationSystemByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryRefrigerationSystemsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RefrigerationSystemCondition>;
  filter?: InputMaybe<RefrigerationSystemFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RefrigerationSystemsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryReportArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryReportAutomationArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryReportAutomationByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryReportAutomationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ReportAutomationCondition>;
  filter?: InputMaybe<ReportAutomationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ReportAutomationsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryReportByLabelArgs = {
  label: Scalars['String']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryReportByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryReportExecutionArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryReportExecutionByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryReportExecutionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ReportExecutionCondition>;
  filter?: InputMaybe<ReportExecutionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ReportExecutionsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryReportQueriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ReportQueryCondition>;
  filter?: InputMaybe<ReportQueryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ReportQueriesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryReportQueryArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryReportQueryByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryReportQueryByReportIdAndLabelArgs = {
  label: Scalars['String']['input'];
  reportId: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryReportsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ReportCondition>;
  filter?: InputMaybe<ReportFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ReportsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QuerySavingsEventArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QuerySavingsEventByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QuerySavingsEventByProjectIdAndStartTimeAndEndTimeArgs = {
  endTime: Scalars['Datetime']['input'];
  projectId: Scalars['Int']['input'];
  startTime: Scalars['Datetime']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QuerySavingsEventDataArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SavingsEventDatumCondition>;
  filter?: InputMaybe<SavingsEventDatumFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SavingsEventDataOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QuerySavingsEventDatumArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QuerySavingsEventDatumByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QuerySavingsEventDatumBySavingsEventIdAndLabelArgs = {
  label: Scalars['String']['input'];
  savingsEventId: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QuerySavingsEventsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SavingsEventCondition>;
  filter?: InputMaybe<SavingsEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SavingsEventsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QuerySeveritiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SeverityCondition>;
  filter?: InputMaybe<SeverityFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SeveritiesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QuerySeverityArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QuerySeverityByNameArgs = {
  name: Scalars['String']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QuerySeverityByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QuerySeverityBySlugArgs = {
  slug: Scalars['String']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QuerySoftwarePackageArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QuerySoftwarePackageByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QuerySoftwarePackageBySlugArgs = {
  slug: Scalars['String']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QuerySoftwarePackagesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SoftwarePackageCondition>;
  filter?: InputMaybe<SoftwarePackageFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SoftwarePackagesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QuerySourceDataArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: InputMaybe<MetricDataAggregationMethod>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  sourceId: Scalars['String']['input'];
  to?: InputMaybe<Scalars['String']['input']>;
  window?: InputMaybe<Scalars['String']['input']>;
};

/** The root query type which gives access points into the data universe. */
export type QuerySpaceArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QuerySpaceActivitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SpaceActivityCondition>;
  filter?: InputMaybe<SpaceActivityFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SpaceActivitiesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QuerySpaceActivityArgs = {
  id: Scalars['BigInt']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QuerySpaceActivityByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QuerySpaceByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QuerySpaceBySpaceCategoryIdAndNumberArgs = {
  number: Scalars['Int']['input'];
  spaceCategoryId: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QuerySpaceCategoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SpaceCategoryCondition>;
  filter?: InputMaybe<SpaceCategoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SpaceCategoriesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QuerySpaceCategoryArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QuerySpaceCategoryByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QuerySpaceCategoryByYardIdAndNameArgs = {
  name: Scalars['String']['input'];
  yardId: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QuerySpacesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SpaceCondition>;
  filter?: InputMaybe<SpaceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SpacesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QuerySubmeterArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QuerySubmeterByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QuerySubmeterSessionArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QuerySubmeterSessionByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QuerySubmeterSessionBySubmeterIdAndStartTimeArgs = {
  startTime: Scalars['Datetime']['input'];
  submeterId: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QuerySubmeterSessionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SubmeterSessionCondition>;
  filter?: InputMaybe<SubmeterSessionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SubmeterSessionsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QuerySubmetersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SubmeterCondition>;
  filter?: InputMaybe<SubmeterFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SubmetersOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QuerySuctionGroupArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QuerySuctionGroupByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QuerySuctionGroupByRefrigerationSystemIdAndLabelArgs = {
  label: Scalars['String']['input'];
  refrigerationSystemId: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QuerySuctionGroupCompressorArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QuerySuctionGroupCompressorByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QuerySuctionGroupCompressorBySuctionGroupIdAndCompressorIdArgs = {
  compressorId: Scalars['Int']['input'];
  suctionGroupId: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QuerySuctionGroupCompressorsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SuctionGroupCompressorCondition>;
  filter?: InputMaybe<SuctionGroupCompressorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SuctionGroupCompressorsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QuerySuctionGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SuctionGroupCondition>;
  filter?: InputMaybe<SuctionGroupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SuctionGroupsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QuerySuctionHeaderArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QuerySuctionHeaderByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QuerySuctionHeaderByRefrigerationSystemIdAndLabelArgs = {
  label: Scalars['String']['input'];
  refrigerationSystemId: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QuerySuctionHeadersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SuctionHeaderCondition>;
  filter?: InputMaybe<SuctionHeaderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SuctionHeadersOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QuerySuctionHeadersCompressorArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QuerySuctionHeadersCompressorByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QuerySuctionHeadersCompressorBySuctionHeaderIdAndCompressorIdArgs =
  {
    compressorId: Scalars['Int']['input'];
    suctionHeaderId: Scalars['Int']['input'];
  };

/** The root query type which gives access points into the data universe. */
export type QuerySuctionHeadersCompressorsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SuctionHeadersCompressorCondition>;
  filter?: InputMaybe<SuctionHeadersCompressorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SuctionHeadersCompressorsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QuerySuggestionArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QuerySuggestionActivityLogsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SuggestionActivityLogCondition>;
  filter?: InputMaybe<SuggestionActivityLogFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SuggestionActivityLogsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QuerySuggestionByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QuerySuggestionControlEventArgs = {
  controlEventId: Scalars['Int']['input'];
  suggestionId: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QuerySuggestionControlEventByControlEventIdArgs = {
  controlEventId: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QuerySuggestionControlEventByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QuerySuggestionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SuggestionCondition>;
  filter?: InputMaybe<SuggestionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SuggestionsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryTemperatureSensorArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryTemperatureSensorByFacilityIdAndHardwareIdArgs = {
  facilityId: Scalars['Int']['input'];
  hardwareId: Scalars['String']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryTemperatureSensorByFacilityIdAndLabelArgs = {
  facilityId: Scalars['Int']['input'];
  label: Scalars['String']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryTemperatureSensorByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryTemperatureSensorsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TemperatureSensorCondition>;
  filter?: InputMaybe<TemperatureSensorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TemperatureSensorsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryTimezoneArgs = {
  name: Scalars['String']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryTimezoneByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryTimezonesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TimezoneCondition>;
  filter?: InputMaybe<TimezoneFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TimezonesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryTrailerArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryTrailerAppointmentArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryTrailerAppointmentByAppointmentIdArgs = {
  appointmentId: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryTrailerAppointmentByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryTrailerAppointmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TrailerAppointmentCondition>;
  filter?: InputMaybe<TrailerAppointmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TrailerAppointmentsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryTrailerAuditArgs = {
  id: Scalars['BigInt']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryTrailerAuditByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryTrailerAuditsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TrailerAuditCondition>;
  filter?: InputMaybe<TrailerAuditFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TrailerAuditsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryTrailerByCarrierCodeAndCarrierTrailerNumberArgs = {
  carrierCode: Scalars['String']['input'];
  carrierTrailerNumber: Scalars['String']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryTrailerByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryTrailerPositionArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryTrailerPositionByFacilityIdAndLabelArgs = {
  facilityId: Scalars['Int']['input'];
  label: Scalars['String']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryTrailerPositionByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryTrailerPositionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TrailerPositionCondition>;
  filter?: InputMaybe<TrailerPositionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TrailerPositionsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryTrailersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TrailerCondition>;
  filter?: InputMaybe<TrailerFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TrailersOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryUnitDimensionArgs = {
  name: Scalars['String']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUnitDimensionByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUnitDimensionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UnitDimensionCondition>;
  filter?: InputMaybe<UnitDimensionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UnitDimensionsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryUnitGroupArgs = {
  name: Scalars['String']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUnitGroupByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUnitGroupDimensionArgs = {
  unitDimension: Scalars['String']['input'];
  unitGroup: Scalars['String']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUnitGroupDimensionByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUnitGroupDimensionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UnitGroupDimensionCondition>;
  filter?: InputMaybe<UnitGroupDimensionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UnitGroupDimensionsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryUnitGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UnitGroupCondition>;
  filter?: InputMaybe<UnitGroupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UnitGroupsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryUserArgs = {
  id: Scalars['String']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUserByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserCondition>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryUtilityAccountArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUtilityAccountByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUtilityAccountStatementArgs = {
  accountStatementId: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUtilityAccountStatementByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUtilityAccountStatementRollupArgs = {
  accountStatementId: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUtilityAccountStatementRollupByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUtilityAccountStatementRollupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UtilityAccountStatementRollupCondition>;
  filter?: InputMaybe<UtilityAccountStatementRollupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UtilityAccountStatementRollupsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryUtilityAccountStatementsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UtilityAccountStatementCondition>;
  filter?: InputMaybe<UtilityAccountStatementFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UtilityAccountStatementsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryUtilityAccountsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UtilityAccountCondition>;
  filter?: InputMaybe<UtilityAccountFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UtilityAccountsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryUtilityCredentialArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUtilityCredentialByIntegrationAndIntegrationKeyArgs = {
  integration: UtilityIntegration;
  integrationKey: Scalars['String']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUtilityCredentialByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUtilityCredentialFacilitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UtilityCredentialFacilityCondition>;
  filter?: InputMaybe<UtilityCredentialFacilityFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UtilityCredentialFacilitiesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryUtilityCredentialFacilityArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUtilityCredentialFacilityByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUtilityCredentialFacilityByUtilityCredentialIdAndFacilityIdArgs =
  {
    facilityId: Scalars['Int']['input'];
    utilityCredentialId: Scalars['Int']['input'];
  };

/** The root query type which gives access points into the data universe. */
export type QueryUtilityCredentialsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UtilityCredentialCondition>;
  filter?: InputMaybe<UtilityCredentialFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UtilityCredentialsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryUtilityFileUploadArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUtilityFileUploadByIntegrationAndIntegrationKeyArgs = {
  integration: UtilityIntegration;
  integrationKey: Scalars['String']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUtilityFileUploadByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUtilityFileUploadsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UtilityFileUploadCondition>;
  filter?: InputMaybe<UtilityFileUploadFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UtilityFileUploadsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryUtilityMeterArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUtilityMeterByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUtilityMeterStatementArgs = {
  meterStatementId: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUtilityMeterStatementByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUtilityMeterStatementRollupArgs = {
  meterStatementId: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUtilityMeterStatementRollupByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUtilityMeterStatementRollupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UtilityMeterStatementRollupCondition>;
  filter?: InputMaybe<UtilityMeterStatementRollupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UtilityMeterStatementRollupsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryUtilityMeterStatementsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UtilityMeterStatementCondition>;
  filter?: InputMaybe<UtilityMeterStatementFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UtilityMeterStatementsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryUtilityMetersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UtilityMeterCondition>;
  filter?: InputMaybe<UtilityMeterFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UtilityMetersOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryUtilityPendingMeterArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUtilityPendingMeterByIntegrationAndIntegrationKeyArgs = {
  integration: UtilityIntegration;
  integrationKey: Scalars['String']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUtilityPendingMeterByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUtilityPendingMetersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UtilityPendingMeterCondition>;
  filter?: InputMaybe<UtilityPendingMeterFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UtilityPendingMetersOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryUtilityProviderArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUtilityProviderByNameArgs = {
  name: Scalars['String']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUtilityProviderByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUtilityProvidersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UtilityProviderCondition>;
  filter?: InputMaybe<UtilityProviderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UtilityProvidersOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryVendorUserArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryVendorUserByEmailArgs = {
  email: Scalars['String']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryVendorUserByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryVendorUserMachineUserArgs = {
  machineUserId: Scalars['BigInt']['input'];
  vendorUserId: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryVendorUserMachineUserByMachineUserIdArgs = {
  machineUserId: Scalars['BigInt']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryVendorUserMachineUserByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryVendorUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VendorUserCondition>;
  filter?: InputMaybe<VendorUserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VendorUsersOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryVesselArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryVesselByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryVesselByRefrigerationSystemIdAndLabelArgs = {
  label: Scalars['String']['input'];
  refrigerationSystemId: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryVesselsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VesselCondition>;
  filter?: InputMaybe<VesselFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VesselsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryVirtualPointIntervalArgs = {
  childId: Scalars['BigInt']['input'];
  parentId: Scalars['BigInt']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryVirtualPointIntervalByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryVirtualPointIntervalsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VirtualPointIntervalCondition>;
  filter?: InputMaybe<VirtualPointIntervalFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VirtualPointIntervalsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryYardArgs = {
  id: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryYardByFacilityIdArgs = {
  facilityId: Scalars['Int']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryYardByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};

/** The root query type which gives access points into the data universe. */
export type QueryYardsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<YardCondition>;
  filter?: InputMaybe<YardFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<YardsOrderBy>>;
};

export type ReflowSubmeterSessionsInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  from: Scalars['String']['input'];
  submeterId: Scalars['Int']['input'];
};

export type ReflowSubmeterSessionsPayload = {
  __typename?: 'ReflowSubmeterSessionsPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  submeter?: Maybe<Submeter>;
};

/** Defines a specific type of refrigerant used in refrigeration systems. */
export type Refrigerant = Node & {
  __typename?: 'Refrigerant';
  /** The category of the refrigerant. */
  category: Scalars['String']['output'];
  /** The unique code used to identify the refrigerant. */
  code: Scalars['String']['output'];
  /** The time the record was created. */
  createdAt: Scalars['Datetime']['output'];
  /** The display label of the refrigerant. */
  label: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `RefrigerationSystem`. */
  refrigerationSystems: RefrigerationSystemsConnection;
  /** The time the record was last updated. */
  updatedAt: Scalars['Datetime']['output'];
};

/** Defines a specific type of refrigerant used in refrigeration systems. */
export type RefrigerantRefrigerationSystemsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RefrigerationSystemCondition>;
  filter?: InputMaybe<RefrigerationSystemFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RefrigerationSystemsOrderBy>>;
};

/**
 * A condition to be used against `Refrigerant` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type RefrigerantCondition = {
  /** Checks for equality with the object’s `category` field. */
  category?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `code` field. */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `label` field. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `Refrigerant` object types. All fields are combined with a logical ‘and.’ */
export type RefrigerantFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RefrigerantFilter>>;
  /** Filter by the object’s `category` field. */
  category?: InputMaybe<StringFilter>;
  /** Filter by the object’s `code` field. */
  code?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `label` field. */
  label?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RefrigerantFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RefrigerantFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** A connection to a list of `Refrigerant` values. */
export type RefrigerantsConnection = {
  __typename?: 'RefrigerantsConnection';
  /** A list of edges which contains the `Refrigerant` and cursor to aid in pagination. */
  edges: Array<RefrigerantsEdge>;
  /** A list of `Refrigerant` objects. */
  nodes: Array<Refrigerant>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Refrigerant` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Refrigerant` edge in the connection. */
export type RefrigerantsEdge = {
  __typename?: 'RefrigerantsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Refrigerant` at the end of the edge. */
  node: Refrigerant;
};

/** Methods to use when ordering `Refrigerant`. */
export enum RefrigerantsOrderBy {
  CATEGORY_ASC = 'CATEGORY_ASC',
  CATEGORY_DESC = 'CATEGORY_DESC',
  CODE_ASC = 'CODE_ASC',
  CODE_DESC = 'CODE_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  LABEL_ASC = 'LABEL_ASC',
  LABEL_DESC = 'LABEL_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** Representation of a top-level refrigeration system in a facility. */
export type RefrigerationSystem = Node & {
  __typename?: 'RefrigerationSystem';
  /** Reads and enables pagination through a set of `Compressor`. */
  compressors: CompressorsConnection;
  /** The time the record was created. */
  createdAt: Scalars['Datetime']['output'];
  /** Reads and enables pagination through a set of `DischargeHeader`. */
  dischargeHeaders: DischargeHeadersConnection;
  /** Reads and enables pagination through a set of `Evaporator`. */
  evaporators: EvaporatorsConnection;
  /** Reads a single `Facility` that is related to this `RefrigerationSystem`. */
  facility?: Maybe<Facility>;
  /** References the facility this refrigeration system belongs to. */
  facilityId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for the refrigeration system. */
  id: Scalars['Int']['output'];
  /** The display label of the refrigeration system. */
  label: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `LiquidHeader`. */
  liquidHeaders: LiquidHeadersConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Refrigerant` that is related to this `RefrigerationSystem`. */
  refrigerant?: Maybe<Refrigerant>;
  /** References the refrigerant used in this refrigeration system. */
  refrigerantCode?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `SuctionGroup`. */
  suctionGroups: SuctionGroupsConnection;
  /** Reads and enables pagination through a set of `SuctionHeader`. */
  suctionHeaders: SuctionHeadersConnection;
  /** The time the record was last updated. */
  updatedAt: Scalars['Datetime']['output'];
  /** The name of the vendor for the refrigeration system. */
  vendorName: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `Vessel`. */
  vessels: VesselsConnection;
};

/** Representation of a top-level refrigeration system in a facility. */
export type RefrigerationSystemCompressorsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CompressorCondition>;
  filter?: InputMaybe<CompressorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CompressorsOrderBy>>;
};

/** Representation of a top-level refrigeration system in a facility. */
export type RefrigerationSystemDischargeHeadersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DischargeHeaderCondition>;
  filter?: InputMaybe<DischargeHeaderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DischargeHeadersOrderBy>>;
};

/** Representation of a top-level refrigeration system in a facility. */
export type RefrigerationSystemEvaporatorsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EvaporatorCondition>;
  filter?: InputMaybe<EvaporatorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvaporatorsOrderBy>>;
};

/** Representation of a top-level refrigeration system in a facility. */
export type RefrigerationSystemLiquidHeadersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LiquidHeaderCondition>;
  filter?: InputMaybe<LiquidHeaderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiquidHeadersOrderBy>>;
};

/** Representation of a top-level refrigeration system in a facility. */
export type RefrigerationSystemSuctionGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SuctionGroupCondition>;
  filter?: InputMaybe<SuctionGroupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SuctionGroupsOrderBy>>;
};

/** Representation of a top-level refrigeration system in a facility. */
export type RefrigerationSystemSuctionHeadersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SuctionHeaderCondition>;
  filter?: InputMaybe<SuctionHeaderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SuctionHeadersOrderBy>>;
};

/** Representation of a top-level refrigeration system in a facility. */
export type RefrigerationSystemVesselsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VesselCondition>;
  filter?: InputMaybe<VesselFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VesselsOrderBy>>;
};

/**
 * A condition to be used against `RefrigerationSystem` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type RefrigerationSystemCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `label` field. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `refrigerantCode` field. */
  refrigerantCode?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `vendorName` field. */
  vendorName?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `RefrigerationSystem` object types. All fields are combined with a logical ‘and.’ */
export type RefrigerationSystemFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RefrigerationSystemFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `label` field. */
  label?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RefrigerationSystemFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RefrigerationSystemFilter>>;
  /** Filter by the object’s `refrigerantCode` field. */
  refrigerantCode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `vendorName` field. */
  vendorName?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `RefrigerationSystem` */
export type RefrigerationSystemInput = {
  /** References the facility this refrigeration system belongs to. */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** The unique identifier for the refrigeration system. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** The display label of the refrigeration system. */
  label: Scalars['String']['input'];
  /** References the refrigerant used in this refrigeration system. */
  refrigerantCode?: InputMaybe<Scalars['String']['input']>;
  /** The name of the vendor for the refrigeration system. */
  vendorName: Scalars['String']['input'];
};

/** Represents an update to a `RefrigerationSystem`. Fields that are set will be updated. */
export type RefrigerationSystemPatch = {
  /** References the facility this refrigeration system belongs to. */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** The unique identifier for the refrigeration system. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** The display label of the refrigeration system. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** References the refrigerant used in this refrigeration system. */
  refrigerantCode?: InputMaybe<Scalars['String']['input']>;
  /** The name of the vendor for the refrigeration system. */
  vendorName?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `RefrigerationSystem` values. */
export type RefrigerationSystemsConnection = {
  __typename?: 'RefrigerationSystemsConnection';
  /** A list of edges which contains the `RefrigerationSystem` and cursor to aid in pagination. */
  edges: Array<RefrigerationSystemsEdge>;
  /** A list of `RefrigerationSystem` objects. */
  nodes: Array<RefrigerationSystem>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RefrigerationSystem` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `RefrigerationSystem` edge in the connection. */
export type RefrigerationSystemsEdge = {
  __typename?: 'RefrigerationSystemsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `RefrigerationSystem` at the end of the edge. */
  node: RefrigerationSystem;
};

/** Methods to use when ordering `RefrigerationSystem`. */
export enum RefrigerationSystemsOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LABEL_ASC = 'LABEL_ASC',
  LABEL_DESC = 'LABEL_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  REFRIGERANT_CODE_ASC = 'REFRIGERANT_CODE_ASC',
  REFRIGERANT_CODE_DESC = 'REFRIGERANT_CODE_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  VENDOR_NAME_ASC = 'VENDOR_NAME_ASC',
  VENDOR_NAME_DESC = 'VENDOR_NAME_DESC'
}

export type RegenerateAccessTokenInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

export type RegisterProjectUsersInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  forceNotify?: InputMaybe<Scalars['Boolean']['input']>;
  records: Array<BulkProjectUser>;
};

export type RegisterProjectUsersPayload = {
  __typename?: 'RegisterProjectUsersPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** All input for the `removeAccountChargeLabelCategory` mutation. */
export type RemoveAccountChargeLabelCategoryInput = {
  accountChargeId?: InputMaybe<Scalars['Int']['input']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `removeAccountChargeLabelCategory` mutation. */
export type RemoveAccountChargeLabelCategoryPayload = {
  __typename?: 'RemoveAccountChargeLabelCategoryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Array<AccountChargesLabelCategory>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `removeFavoriteFacility` mutation. */
export type RemoveFavoriteFacilityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  facilityId?: InputMaybe<Scalars['Int']['input']>;
};

/** The output of our `removeFavoriteFacility` mutation. */
export type RemoveFavoriteFacilityPayload = {
  __typename?: 'RemoveFavoriteFacilityPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
};

/** The output of our `removeFavoriteFacility` mutation. */
export type RemoveFavoriteFacilityPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** All input for the `removeMeterChargeLabelCategory` mutation. */
export type RemoveMeterChargeLabelCategoryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  meterChargeId?: InputMaybe<Scalars['Int']['input']>;
};

/** The output of our `removeMeterChargeLabelCategory` mutation. */
export type RemoveMeterChargeLabelCategoryPayload = {
  __typename?: 'RemoveMeterChargeLabelCategoryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Array<MeterChargesLabelCategory>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `removeMetricMetadataDependency` mutation. */
export type RemoveMetricMetadataDependencyInput = {
  childMetric: Scalars['String']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  parentMetric: Scalars['String']['input'];
};

/** The output of our `removeMetricMetadataDependency` mutation. */
export type RemoveMetricMetadataDependencyPayload = {
  __typename?: 'RemoveMetricMetadataDependencyPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  metricMetadata?: Maybe<Array<MetricMetadatum>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type RemoveProjectControllerInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['Int']['input'];
  userId: Scalars['String']['input'];
};

export type RemoveProjectControllerPayload = {
  __typename?: 'RemoveProjectControllerPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  project: Project;
  user: User;
};

export type RemoveReportManagerInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  reportId: Scalars['Int']['input'];
  userId: Scalars['String']['input'];
};

export type RemoveReportManagerPayload = {
  __typename?: 'RemoveReportManagerPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  report: Report;
  user: User;
};

/** All input for the `reparentMeterStatement` mutation. */
export type ReparentMeterStatementInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  destAccountStatementId?: InputMaybe<Scalars['Int']['input']>;
  destUtilityMeterId?: InputMaybe<Scalars['Int']['input']>;
  meterStatementId?: InputMaybe<Scalars['Int']['input']>;
};

/** The output of our `reparentMeterStatement` mutation. */
export type ReparentMeterStatementPayload = {
  __typename?: 'ReparentMeterStatementPayload';
  /** Reads a single `AccountStatement` that is related to this `MeterStatement`. */
  accountStatement?: Maybe<AccountStatement>;
  /** Reads a single `AccountStatementPdf` that is related to this `MeterStatement`. */
  accountStatementPdf?: Maybe<AccountStatementPdf>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  meterStatement?: Maybe<MeterStatement>;
  /** An edge for our `MeterStatement`. May be used by Relay 1. */
  meterStatementEdge?: Maybe<MeterStatementsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `UtilityMeter` that is related to this `MeterStatement`. */
  utilityMeter?: Maybe<UtilityMeter>;
};

/** The output of our `reparentMeterStatement` mutation. */
export type ReparentMeterStatementPayloadMeterStatementEdgeArgs = {
  orderBy?: InputMaybe<Array<MeterStatementsOrderBy>>;
};

/** All input for the `replaceAccountStatementPdf` mutation. */
export type ReplaceAccountStatementPdfInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  newPdfId?: InputMaybe<Scalars['Int']['input']>;
  oldPdfId?: InputMaybe<Scalars['Int']['input']>;
  statementMonth?: InputMaybe<Scalars['Int']['input']>;
  statementYear?: InputMaybe<Scalars['Int']['input']>;
};

/** The output of our `replaceAccountStatementPdf` mutation. */
export type ReplaceAccountStatementPdfPayload = {
  __typename?: 'ReplaceAccountStatementPdfPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** Parent table for generic reports. This gives us a way to store and generate arbitrary reports for customers, both internal and external. */
export type Report = Node & {
  __typename?: 'Report';
  /** The time the report was created */
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  /** The description of the report */
  description: Scalars['String']['output'];
  /** Returns the estimated execution time of the report, in seconds. */
  estimatedExecutionTime?: Maybe<Scalars['BigFloat']['output']>;
  /** The id of the report */
  id: Scalars['Int']['output'];
  /** Whether the report is protected or not. */
  isProtected?: Maybe<Scalars['Boolean']['output']>;
  /** The json schema that describes the parameters for this report */
  jsonSchema: Scalars['JSON']['output'];
  /** The label of the report */
  label: Scalars['String']['output'];
  managers: UsersConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Available permissions for the Report. */
  permissions?: Maybe<ReportPermissions>;
  /** Reads and enables pagination through a set of `ReportAutomation`. */
  reportAutomations: ReportAutomationsConnection;
  /** Reads and enables pagination through a set of `ReportExecution`. */
  reportExecutions: ReportExecutionsConnection;
  /** Reads and enables pagination through a set of `ReportQuery`. */
  reportQueries: ReportQueriesConnection;
  /** The time the report was updated */
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
};

/** Parent table for generic reports. This gives us a way to store and generate arbitrary reports for customers, both internal and external. */
export type ReportManagersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserCondition>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** Parent table for generic reports. This gives us a way to store and generate arbitrary reports for customers, both internal and external. */
export type ReportReportAutomationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ReportAutomationCondition>;
  filter?: InputMaybe<ReportAutomationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ReportAutomationsOrderBy>>;
};

/** Parent table for generic reports. This gives us a way to store and generate arbitrary reports for customers, both internal and external. */
export type ReportReportExecutionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ReportExecutionCondition>;
  filter?: InputMaybe<ReportExecutionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ReportExecutionsOrderBy>>;
};

/** Parent table for generic reports. This gives us a way to store and generate arbitrary reports for customers, both internal and external. */
export type ReportReportQueriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ReportQueryCondition>;
  filter?: InputMaybe<ReportQueryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ReportQueriesOrderBy>>;
};

/** Defines a repeatable scheduled execution for a given report */
export type ReportAutomation = Node & {
  __typename?: 'ReportAutomation';
  /** The time the record was created */
  createdAt: Scalars['Datetime']['output'];
  /** The last date, if set, when this report should be automatically executed */
  endDate?: Maybe<Scalars['Date']['output']>;
  /** The id of the record */
  id: Scalars['Int']['output'];
  /** @filterable/nReturns the date when this automation should be executed */
  nextExecutionDate?: Maybe<Scalars['Date']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The expressions for generating parameters for the execution. The schema of the evaluated expressions must match the schema of the report */
  parameterExpressions: Scalars['JSON']['output'];
  /** Evaluates the parameter expressions for report execution */
  parameters?: Maybe<Scalars['JSON']['output']>;
  /** Reads a single `Report` that is related to this `ReportAutomation`. */
  report?: Maybe<Report>;
  /** Reads and enables pagination through a set of `ReportExecution`. */
  reportExecutions: ReportExecutionsConnection;
  /** The id of the report being automated */
  reportId: Scalars['Int']['output'];
  /** The period of execution. This is added to the start_date to determine successive executions */
  runInterval: Interval;
  /** Returns the total seconds for the interval field runInterval */
  runIntervalSeconds: Scalars['Int']['output'];
  /** The date when this report should first be automatically executed */
  startDate: Scalars['Date']['output'];
  /** The time the record was updated */
  updatedAt: Scalars['Datetime']['output'];
};

/** Defines a repeatable scheduled execution for a given report */
export type ReportAutomationReportExecutionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ReportExecutionCondition>;
  filter?: InputMaybe<ReportExecutionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ReportExecutionsOrderBy>>;
};

/**
 * A condition to be used against `ReportAutomation` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ReportAutomationCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `endDate` field. */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `parameterExpressions` field. */
  parameterExpressions?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `reportId` field. */
  reportId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `runInterval` field. */
  runInterval?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `startDate` field. */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `ReportAutomation` object types. All fields are combined with a logical ‘and.’ */
export type ReportAutomationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ReportAutomationFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `endDate` field. */
  endDate?: InputMaybe<DateFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `nextExecutionDate` field. */
  nextExecutionDate?: InputMaybe<DateFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ReportAutomationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ReportAutomationFilter>>;
  /** Filter by the object’s `parameterExpressions` field. */
  parameterExpressions?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `parameters` field. */
  parameters?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `reportId` field. */
  reportId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `runInterval` field. */
  runInterval?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `startDate` field. */
  startDate?: InputMaybe<DateFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** A connection to a list of `ReportAutomation` values. */
export type ReportAutomationsConnection = {
  __typename?: 'ReportAutomationsConnection';
  /** A list of edges which contains the `ReportAutomation` and cursor to aid in pagination. */
  edges: Array<ReportAutomationsEdge>;
  /** A list of `ReportAutomation` objects. */
  nodes: Array<ReportAutomation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ReportAutomation` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ReportAutomation` edge in the connection. */
export type ReportAutomationsEdge = {
  __typename?: 'ReportAutomationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ReportAutomation` at the end of the edge. */
  node: ReportAutomation;
};

/** Methods to use when ordering `ReportAutomation`. */
export enum ReportAutomationsOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  END_DATE_ASC = 'END_DATE_ASC',
  END_DATE_DESC = 'END_DATE_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  PARAMETER_EXPRESSIONS_ASC = 'PARAMETER_EXPRESSIONS_ASC',
  PARAMETER_EXPRESSIONS_DESC = 'PARAMETER_EXPRESSIONS_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  REPORT_ID_ASC = 'REPORT_ID_ASC',
  REPORT_ID_DESC = 'REPORT_ID_DESC',
  RUN_INTERVAL_ASC = 'RUN_INTERVAL_ASC',
  RUN_INTERVAL_DESC = 'RUN_INTERVAL_DESC',
  START_DATE_ASC = 'START_DATE_ASC',
  START_DATE_DESC = 'START_DATE_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** A condition to be used against `Report` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type ReportCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `defaultParams` field. */
  defaultParams?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `defaultParamsConfig` field. */
  defaultParamsConfig?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `isProtected` field. */
  isProtected?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `jsonSchema` field. */
  jsonSchema?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `label` field. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** Tracks status of all report executions. Stores reference to the resulting file when an execution is finished, as well as any errors encountered if applicable. */
export type ReportExecution = Node & {
  __typename?: 'ReportExecution';
  actor?: Maybe<Actor>;
  /** The timestamp when the report execution was completed */
  completedAt?: Maybe<Scalars['Datetime']['output']>;
  /** The time the record was created */
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  /** Any errors encountered during the report execution. */
  errors?: Maybe<Scalars['JSON']['output']>;
  /** The date when the report was executed */
  executionDate: Scalars['Date']['output'];
  /** The file path of the report execution result. */
  filePath?: Maybe<Scalars['String']['output']>;
  /** The id of the record */
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The parameters used for the report execution */
  parameters?: Maybe<Scalars['JSON']['output']>;
  /** Available permissions for the ReportExecution. */
  permissions?: Maybe<ReportExecutionPermissions>;
  /** Reads a single `Report` that is related to this `ReportExecution`. */
  report?: Maybe<Report>;
  /** Reads a single `ReportAutomation` that is related to this `ReportExecution`. */
  reportAutomation?: Maybe<ReportAutomation>;
  /** The id of the report automation, if any */
  reportAutomationId?: Maybe<Scalars['Int']['output']>;
  /** The id of the associated report. */
  reportId?: Maybe<Scalars['Int']['output']>;
  reportUri?: Maybe<Scalars['String']['output']>;
  /** The status of the report execution. */
  status: Scalars['String']['output'];
  /** The time the record was updated */
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
};

/**
 * A condition to be used against `ReportExecution` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ReportExecutionCondition = {
  /** Checks for equality with the object’s `actor` field. */
  actor?: InputMaybe<ActorInput>;
  /** Checks for equality with the object’s `completedAt` field. */
  completedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `errors` field. */
  errors?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `executionDate` field. */
  executionDate?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `filePath` field. */
  filePath?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `parameters` field. */
  parameters?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `reportAutomationId` field. */
  reportAutomationId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `reportId` field. */
  reportId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `ReportExecution` object types. All fields are combined with a logical ‘and.’ */
export type ReportExecutionFilter = {
  /** Filter by the object’s `actor` field. */
  actor?: InputMaybe<ActorFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ReportExecutionFilter>>;
  /** Filter by the permission can_write */
  canWrite?: InputMaybe<PermissionBooleanFilter>;
  /** Filter by the object’s `completedAt` field. */
  completedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `errors` field. */
  errors?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `executionDate` field. */
  executionDate?: InputMaybe<DateFilter>;
  /** Filter by the object’s `filePath` field. */
  filePath?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ReportExecutionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ReportExecutionFilter>>;
  /** Filter by the object’s `parameters` field. */
  parameters?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `reportAutomationId` field. */
  reportAutomationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `reportId` field. */
  reportId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `ReportExecution` */
export type ReportExecutionInput = {
  /** The timestamp when the report execution was completed */
  completedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Any errors encountered during the report execution. */
  errors?: InputMaybe<Scalars['JSON']['input']>;
  /** The date when the report was executed */
  executionDate?: InputMaybe<Scalars['Date']['input']>;
  /** The file path of the report execution result. */
  filePath?: InputMaybe<Scalars['String']['input']>;
  /** The parameters used for the report execution */
  parameters?: InputMaybe<Scalars['JSON']['input']>;
  /** The id of the report automation, if any */
  reportAutomationId?: InputMaybe<Scalars['Int']['input']>;
  /** The id of the associated report. */
  reportId?: InputMaybe<Scalars['Int']['input']>;
  /** The status of the report execution. */
  status: Scalars['String']['input'];
};

/** Represents an update to a `ReportExecution`. Fields that are set will be updated. */
export type ReportExecutionPatch = {
  /** The timestamp when the report execution was completed */
  completedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Any errors encountered during the report execution. */
  errors?: InputMaybe<Scalars['JSON']['input']>;
  /** The file path of the report execution result. */
  filePath?: InputMaybe<Scalars['String']['input']>;
  /** The id of the associated report. */
  reportId?: InputMaybe<Scalars['Int']['input']>;
  /** The status of the report execution. */
  status?: InputMaybe<Scalars['String']['input']>;
};

/** Permissive capabilities on a ReportExecution. */
export type ReportExecutionPermissions = {
  __typename?: 'ReportExecutionPermissions';
  /** Whether a user can write to the report execution. */
  canWrite: Scalars['Boolean']['output'];
};

/** A connection to a list of `ReportExecution` values. */
export type ReportExecutionsConnection = {
  __typename?: 'ReportExecutionsConnection';
  /** A list of edges which contains the `ReportExecution` and cursor to aid in pagination. */
  edges: Array<ReportExecutionsEdge>;
  /** A list of `ReportExecution` objects. */
  nodes: Array<ReportExecution>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ReportExecution` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ReportExecution` edge in the connection. */
export type ReportExecutionsEdge = {
  __typename?: 'ReportExecutionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ReportExecution` at the end of the edge. */
  node: ReportExecution;
};

/** Methods to use when ordering `ReportExecution`. */
export enum ReportExecutionsOrderBy {
  ACTOR_ASC = 'ACTOR_ASC',
  ACTOR_DESC = 'ACTOR_DESC',
  COMPLETED_AT_ASC = 'COMPLETED_AT_ASC',
  COMPLETED_AT_DESC = 'COMPLETED_AT_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  ERRORS_ASC = 'ERRORS_ASC',
  ERRORS_DESC = 'ERRORS_DESC',
  EXECUTION_DATE_ASC = 'EXECUTION_DATE_ASC',
  EXECUTION_DATE_DESC = 'EXECUTION_DATE_DESC',
  FILE_PATH_ASC = 'FILE_PATH_ASC',
  FILE_PATH_DESC = 'FILE_PATH_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  PARAMETERS_ASC = 'PARAMETERS_ASC',
  PARAMETERS_DESC = 'PARAMETERS_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  REPORT_AUTOMATION_ID_ASC = 'REPORT_AUTOMATION_ID_ASC',
  REPORT_AUTOMATION_ID_DESC = 'REPORT_AUTOMATION_ID_DESC',
  REPORT_ID_ASC = 'REPORT_ID_ASC',
  REPORT_ID_DESC = 'REPORT_ID_DESC',
  STATUS_ASC = 'STATUS_ASC',
  STATUS_DESC = 'STATUS_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** A filter to be used against `Report` object types. All fields are combined with a logical ‘and.’ */
export type ReportFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ReportFilter>>;
  /** Filter by the permission can_execute */
  canExecute?: InputMaybe<PermissionBooleanFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `defaultParams` field. */
  defaultParams?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `defaultParamsConfig` field. */
  defaultParamsConfig?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `estimatedExecutionTime` field. */
  estimatedExecutionTime?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isProtected` field. */
  isProtected?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `jsonSchema` field. */
  jsonSchema?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `label` field. */
  label?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ReportFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ReportFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** Represents an update to a `Report`. Fields that are set will be updated. */
export type ReportPatch = {
  /** Whether the report is protected or not. */
  isProtected?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Permissive capabilities on a Report. */
export type ReportPermissions = {
  __typename?: 'ReportPermissions';
  /** Whether a user can run the report */
  canExecute: Scalars['Boolean']['output'];
};

/** A connection to a list of `ReportQuery` values. */
export type ReportQueriesConnection = {
  __typename?: 'ReportQueriesConnection';
  /** A list of edges which contains the `ReportQuery` and cursor to aid in pagination. */
  edges: Array<ReportQueriesEdge>;
  /** A list of `ReportQuery` objects. */
  nodes: Array<ReportQuery>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ReportQuery` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ReportQuery` edge in the connection. */
export type ReportQueriesEdge = {
  __typename?: 'ReportQueriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ReportQuery` at the end of the edge. */
  node: ReportQuery;
};

/** Methods to use when ordering `ReportQuery`. */
export enum ReportQueriesOrderBy {
  CHUNK_DURATION_ASC = 'CHUNK_DURATION_ASC',
  CHUNK_DURATION_DESC = 'CHUNK_DURATION_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DB_TYPE_ASC = 'DB_TYPE_ASC',
  DB_TYPE_DESC = 'DB_TYPE_DESC',
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  EXPANDER_ASC = 'EXPANDER_ASC',
  EXPANDER_DESC = 'EXPANDER_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LABEL_ASC = 'LABEL_ASC',
  LABEL_DESC = 'LABEL_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  QUERY_ASC = 'QUERY_ASC',
  QUERY_DESC = 'QUERY_DESC',
  REPORT_ID_ASC = 'REPORT_ID_ASC',
  REPORT_ID_DESC = 'REPORT_ID_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

export type ReportQuery = Node & {
  __typename?: 'ReportQuery';
  /** Used to split the query into natural time-boundary chunks for simpler post-processing. */
  chunkDuration?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  /** The database the report query is associated with. */
  dbType: Scalars['String']['output'];
  /** The description of the report query. */
  description?: Maybe<Scalars['String']['output']>;
  /** Used to produced one or more parameterized versions of the final query. */
  expander?: Maybe<Scalars['String']['output']>;
  /** The id of the report query. */
  id: Scalars['Int']['output'];
  /** The label of the report query. */
  label: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The query to run. */
  query: Scalars['String']['output'];
  /** Reads a single `Report` that is related to this `ReportQuery`. */
  report?: Maybe<Report>;
  /** The id of the associated report. */
  reportId: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
};

/**
 * A condition to be used against `ReportQuery` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ReportQueryCondition = {
  /** Checks for equality with the object’s `chunkDuration` field. */
  chunkDuration?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `dbType` field. */
  dbType?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `expander` field. */
  expander?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `label` field. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `query` field. */
  query?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `reportId` field. */
  reportId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `ReportQuery` object types. All fields are combined with a logical ‘and.’ */
export type ReportQueryFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ReportQueryFilter>>;
  /** Filter by the object’s `chunkDuration` field. */
  chunkDuration?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dbType` field. */
  dbType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `expander` field. */
  expander?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `label` field. */
  label?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ReportQueryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ReportQueryFilter>>;
  /** Filter by the object’s `query` field. */
  query?: InputMaybe<StringFilter>;
  /** Filter by the object’s `reportId` field. */
  reportId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `ReportQuery` */
export type ReportQueryInput = {
  /** Used to split the query into natural time-boundary chunks for simpler post-processing. */
  chunkDuration?: InputMaybe<Scalars['String']['input']>;
  /** The database the report query is associated with. */
  dbType: Scalars['String']['input'];
  /** The description of the report query. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Used to produced one or more parameterized versions of the final query. */
  expander?: InputMaybe<Scalars['String']['input']>;
  /** The label of the report query. */
  label: Scalars['String']['input'];
  /** The query to run. */
  query: Scalars['String']['input'];
  /** The id of the associated report. */
  reportId: Scalars['Int']['input'];
};

/** A connection to a list of `Report` values. */
export type ReportsConnection = {
  __typename?: 'ReportsConnection';
  /** A list of edges which contains the `Report` and cursor to aid in pagination. */
  edges: Array<ReportsEdge>;
  /** A list of `Report` objects. */
  nodes: Array<Report>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Report` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Report` edge in the connection. */
export type ReportsEdge = {
  __typename?: 'ReportsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Report` at the end of the edge. */
  node: Report;
};

/** Methods to use when ordering `Report`. */
export enum ReportsOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DEFAULT_PARAMS_ASC = 'DEFAULT_PARAMS_ASC',
  DEFAULT_PARAMS_CONFIG_ASC = 'DEFAULT_PARAMS_CONFIG_ASC',
  DEFAULT_PARAMS_CONFIG_DESC = 'DEFAULT_PARAMS_CONFIG_DESC',
  DEFAULT_PARAMS_DESC = 'DEFAULT_PARAMS_DESC',
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  IS_PROTECTED_ASC = 'IS_PROTECTED_ASC',
  IS_PROTECTED_DESC = 'IS_PROTECTED_DESC',
  JSON_SCHEMA_ASC = 'JSON_SCHEMA_ASC',
  JSON_SCHEMA_DESC = 'JSON_SCHEMA_DESC',
  LABEL_ASC = 'LABEL_ASC',
  LABEL_DESC = 'LABEL_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

export type RevokeAccessTokenInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** This represents a period in time where an event happened that could realize savings, typically a load shed event. */
export type SavingsEvent = Node & {
  __typename?: 'SavingsEvent';
  /** The time the savings_event was created. */
  createdAt: Scalars['Datetime']['output'];
  /** The current Project Enrollment associated with the savings event. */
  currentEnrollment?: Maybe<ProjectEnrollment>;
  /** Reads and enables pagination through a set of `SavingsEventDatum`. */
  data: SavingsEventDataConnection;
  /** The time that the savings_event ended */
  endTime: Scalars['Datetime']['output'];
  id: Scalars['Int']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Project` that is related to this `SavingsEvent`. */
  project?: Maybe<Project>;
  /** This maps the savings_event to a project */
  projectId: Scalars['Int']['output'];
  /** The time that the savings_event started */
  startTime: Scalars['Datetime']['output'];
  /** Returns the associated suggestion for the savings event. */
  suggestion?: Maybe<Suggestion>;
  /** The time the savings_event was updated. */
  updatedAt: Scalars['Datetime']['output'];
};

/** This represents a period in time where an event happened that could realize savings, typically a load shed event. */
export type SavingsEventDataArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SavingsEventDatumCondition>;
  filter?: InputMaybe<SavingsEventDatumFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SavingsEventDataOrderBy>>;
};

/**
 * A condition to be used against `SavingsEvent` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type SavingsEventCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `endTime` field. */
  endTime?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `metadata` field. */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `startTime` field. */
  startTime?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A connection to a list of `SavingsEventDatum` values. */
export type SavingsEventDataConnection = {
  __typename?: 'SavingsEventDataConnection';
  /** A list of edges which contains the `SavingsEventDatum` and cursor to aid in pagination. */
  edges: Array<SavingsEventDataEdge>;
  /** A list of `SavingsEventDatum` objects. */
  nodes: Array<SavingsEventDatum>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SavingsEventDatum` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `SavingsEventDatum` edge in the connection. */
export type SavingsEventDataEdge = {
  __typename?: 'SavingsEventDataEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `SavingsEventDatum` at the end of the edge. */
  node: SavingsEventDatum;
};

/** Methods to use when ordering `SavingsEventDatum`. */
export enum SavingsEventDataOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DATA_ASC = 'DATA_ASC',
  DATA_DESC = 'DATA_DESC',
  HISTORY_ASC = 'HISTORY_ASC',
  HISTORY_DESC = 'HISTORY_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LABEL_ASC = 'LABEL_ASC',
  LABEL_DESC = 'LABEL_DESC',
  METADATA_ASC = 'METADATA_ASC',
  METADATA_DESC = 'METADATA_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  SAVINGS_EVENT_ID_ASC = 'SAVINGS_EVENT_ID_ASC',
  SAVINGS_EVENT_ID_DESC = 'SAVINGS_EVENT_ID_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** This table is for holding the savings event savings calculation data. This includes the savings values themselves, and any important data points used to calculate these. */
export type SavingsEventDatum = Node & {
  __typename?: 'SavingsEventDatum';
  /** The time the record was created. */
  createdAt: Scalars['Datetime']['output'];
  /** The value for the attribute being recorded. */
  data: Scalars['JSON']['output'];
  /** The history of changes to data and metadata. */
  history: Scalars['JSON']['output'];
  /** The identifer of the savings event data. */
  id: Scalars['Int']['output'];
  /** This column represents the attribute being recorded. */
  label: Scalars['String']['output'];
  /** Any extra values for the attribute being recorded. */
  metadata: Scalars['JSON']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `SavingsEvent` that is related to this `SavingsEventDatum`. */
  savingsEvent?: Maybe<SavingsEvent>;
  /** This savings event this data belongs to. */
  savingsEventId: Scalars['Int']['output'];
  /** The time the record was updated. */
  updatedAt: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `SavingsEventDatum` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type SavingsEventDatumCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `data` field. */
  data?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `history` field. */
  history?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `label` field. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `metadata` field. */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `savingsEventId` field. */
  savingsEventId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `SavingsEventDatum` object types. All fields are combined with a logical ‘and.’ */
export type SavingsEventDatumFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SavingsEventDatumFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `data` field. */
  data?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `history` field. */
  history?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `label` field. */
  label?: InputMaybe<StringFilter>;
  /** Filter by the object’s `metadata` field. */
  metadata?: InputMaybe<JsonFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SavingsEventDatumFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SavingsEventDatumFilter>>;
  /** Filter by the object’s `savingsEventId` field. */
  savingsEventId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `SavingsEventDatum` */
export type SavingsEventDatumInput = {
  /** The value for the attribute being recorded. */
  data: Scalars['JSON']['input'];
  /** This column represents the attribute being recorded. */
  label: Scalars['String']['input'];
  /** Any extra values for the attribute being recorded. */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** Mutates a `SavingsEvent` as part of the payload */
  savingsEvent?: InputMaybe<SavingsEventInput>;
  /** This savings event this data belongs to. */
  savingsEventId?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents an update to a `SavingsEventDatum`. Fields that are set will be updated. */
export type SavingsEventDatumPatch = {
  /** The value for the attribute being recorded. */
  data?: InputMaybe<Scalars['JSON']['input']>;
  /** This column represents the attribute being recorded. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Any extra values for the attribute being recorded. */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
};

/** A filter to be used against `SavingsEvent` object types. All fields are combined with a logical ‘and.’ */
export type SavingsEventFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SavingsEventFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `endTime` field. */
  endTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `metadata` field. */
  metadata?: InputMaybe<JsonFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SavingsEventFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SavingsEventFilter>>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `startTime` field. */
  startTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `SavingsEvent` */
export type SavingsEventInput = {
  /** The time that the savings_event ended */
  endTime: Scalars['Datetime']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** This maps the savings_event to a project */
  projectId: Scalars['Int']['input'];
  /** The time that the savings_event started */
  startTime: Scalars['Datetime']['input'];
};

/** Represents an update to a `SavingsEvent`. Fields that are set will be updated. */
export type SavingsEventPatch = {
  /** The time that the savings_event ended */
  endTime?: InputMaybe<Scalars['Datetime']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** This maps the savings_event to a project */
  projectId?: InputMaybe<Scalars['Int']['input']>;
  /** The time that the savings_event started */
  startTime?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A connection to a list of `SavingsEvent` values. */
export type SavingsEventsConnection = {
  __typename?: 'SavingsEventsConnection';
  /** A list of edges which contains the `SavingsEvent` and cursor to aid in pagination. */
  edges: Array<SavingsEventsEdge>;
  /** A list of `SavingsEvent` objects. */
  nodes: Array<SavingsEvent>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /**
   * Aggregates a metric by label for the specified filter expression.
   * @deprecated Use `savingsEventsData` instead.
   */
  savingsEventData?: Maybe<MetricDataConnection>;
  /** The count of *all* `SavingsEvent` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A connection to a list of `SavingsEvent` values. */
export type SavingsEventsConnectionSavingsEventDataArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A `SavingsEvent` edge in the connection. */
export type SavingsEventsEdge = {
  __typename?: 'SavingsEventsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `SavingsEvent` at the end of the edge. */
  node: SavingsEvent;
};

/** Methods to use when ordering `SavingsEvent`. */
export enum SavingsEventsOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  END_TIME_ASC = 'END_TIME_ASC',
  END_TIME_DESC = 'END_TIME_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  METADATA_ASC = 'METADATA_ASC',
  METADATA_DESC = 'METADATA_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  PROJECT_ID_ASC = 'PROJECT_ID_ASC',
  PROJECT_ID_DESC = 'PROJECT_ID_DESC',
  START_TIME_ASC = 'START_TIME_ASC',
  START_TIME_DESC = 'START_TIME_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** All input for the `setAccountChargeLabelCategory` mutation. */
export type SetAccountChargeLabelCategoryInput = {
  accountChargeId?: InputMaybe<Scalars['Int']['input']>;
  chargeLabelCategory?: InputMaybe<Scalars['String']['input']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  modelVersion?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `setAccountChargeLabelCategory` mutation. */
export type SetAccountChargeLabelCategoryPayload = {
  __typename?: 'SetAccountChargeLabelCategoryPayload';
  /** Reads a single `AccountCharge` that is related to this `AccountChargesLabelCategory`. */
  accountCharge?: Maybe<AccountCharge>;
  accountChargesLabelCategory?: Maybe<AccountChargesLabelCategory>;
  /** Reads a single `ChargeLabelCategory` that is related to this `AccountChargesLabelCategory`. */
  chargeLabelCategory?: Maybe<ChargeLabelCategory>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `setDefaultFacilityDocument` mutation. */
export type SetDefaultFacilityDocumentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  facilityDocumentId?: InputMaybe<Scalars['Int']['input']>;
};

/** The output of our `setDefaultFacilityDocument` mutation. */
export type SetDefaultFacilityDocumentPayload = {
  __typename?: 'SetDefaultFacilityDocumentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Facility` that is related to this `FacilityDocument`. */
  facility?: Maybe<Facility>;
  facilityDocument?: Maybe<FacilityDocument>;
  /** An edge for our `FacilityDocument`. May be used by Relay 1. */
  facilityDocumentEdge?: Maybe<FacilityDocumentsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SoftwarePackage` that is related to this `FacilityDocument`. */
  softwarePackage?: Maybe<SoftwarePackage>;
};

/** The output of our `setDefaultFacilityDocument` mutation. */
export type SetDefaultFacilityDocumentPayloadFacilityDocumentEdgeArgs = {
  orderBy?: InputMaybe<Array<FacilityDocumentsOrderBy>>;
};

/** All input for the `setFacilityConfig` mutation. */
export type SetFacilityConfigInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

/** The output of our `setFacilityConfig` mutation. */
export type SetFacilityConfigPayload = {
  __typename?: 'SetFacilityConfigPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Facility` that is related to this `FacilityConfig`. */
  facility?: Maybe<Facility>;
  facilityConfig?: Maybe<FacilityConfig>;
  /** An edge for our `FacilityConfig`. May be used by Relay 1. */
  facilityConfigEdge?: Maybe<FacilityConfigsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our `setFacilityConfig` mutation. */
export type SetFacilityConfigPayloadFacilityConfigEdgeArgs = {
  orderBy?: InputMaybe<Array<FacilityConfigsOrderBy>>;
};

export type SetMachineUserCapabilityInput = {
  capabilities: Array<PlatformCapabilityAccessDefinition>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  machineUserId: Scalars['Int']['input'];
};

export type SetMachineUserCapabilityPayload = {
  __typename?: 'SetMachineUserCapabilityPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  machineUser?: Maybe<MachineUser>;
};

/** All input for the `setMeterChargeLabelCategory` mutation. */
export type SetMeterChargeLabelCategoryInput = {
  chargeLabelCategory?: InputMaybe<Scalars['String']['input']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  meterChargeId?: InputMaybe<Scalars['Int']['input']>;
  modelVersion?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `setMeterChargeLabelCategory` mutation. */
export type SetMeterChargeLabelCategoryPayload = {
  __typename?: 'SetMeterChargeLabelCategoryPayload';
  /** Reads a single `ChargeLabelCategory` that is related to this `MeterChargesLabelCategory`. */
  chargeLabelCategory?: Maybe<ChargeLabelCategory>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `MeterCharge` that is related to this `MeterChargesLabelCategory`. */
  meterCharge?: Maybe<MeterCharge>;
  meterChargesLabelCategory?: Maybe<MeterChargesLabelCategory>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `setProgramConfig` mutation. */
export type SetProgramConfigInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  programId?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

/** The output of our `setProgramConfig` mutation. */
export type SetProgramConfigPayload = {
  __typename?: 'SetProgramConfigPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Program` that is related to this `ProgramConfig`. */
  program?: Maybe<Program>;
  programConfig?: Maybe<ProgramConfig>;
  /** An edge for our `ProgramConfig`. May be used by Relay 1. */
  programConfigEdge?: Maybe<ProgramConfigsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our `setProgramConfig` mutation. */
export type SetProgramConfigPayloadProgramConfigEdgeArgs = {
  orderBy?: InputMaybe<Array<ProgramConfigsOrderBy>>;
};

/** All input for the `setProjectConfig` mutation. */
export type SetProjectConfigInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

/** The output of our `setProjectConfig` mutation. */
export type SetProjectConfigPayload = {
  __typename?: 'SetProjectConfigPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Project` that is related to this `ProjectConfig`. */
  project?: Maybe<Project>;
  projectConfig?: Maybe<ProjectConfig>;
  /** An edge for our `ProjectConfig`. May be used by Relay 1. */
  projectConfigEdge?: Maybe<ProjectConfigsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our `setProjectConfig` mutation. */
export type SetProjectConfigPayloadProjectConfigEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectConfigsOrderBy>>;
};

/** A connection to a list of `Severity` values. */
export type SeveritiesConnection = {
  __typename?: 'SeveritiesConnection';
  /** A list of edges which contains the `Severity` and cursor to aid in pagination. */
  edges: Array<SeveritiesEdge>;
  /** A list of `Severity` objects. */
  nodes: Array<Severity>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Severity` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Severity` edge in the connection. */
export type SeveritiesEdge = {
  __typename?: 'SeveritiesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Severity` at the end of the edge. */
  node: Severity;
};

/** Methods to use when ordering `Severity`. */
export enum SeveritiesOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  SLUG_ASC = 'SLUG_ASC',
  SLUG_DESC = 'SLUG_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  VALUE_ASC = 'VALUE_ASC',
  VALUE_DESC = 'VALUE_DESC'
}

/** A level of severity for a check. */
export type Severity = Node & {
  __typename?: 'Severity';
  /** Reads and enables pagination through a set of `Check`. */
  checks: ChecksConnection;
  /** The time the record was created. */
  createdAt: Scalars['Datetime']['output'];
  /** The identifier of the severity. */
  id: Scalars['Int']['output'];
  /** The unique name of the severity. */
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The unique slug of the severity. */
  slug: Scalars['String']['output'];
  /** The time the record was updated. */
  updatedAt: Scalars['Datetime']['output'];
  /** The quantifiable value of the severity. */
  value: Scalars['Int']['output'];
};

/** A level of severity for a check. */
export type SeverityChecksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CheckCondition>;
  filter?: InputMaybe<CheckFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChecksOrderBy>>;
};

/**
 * A condition to be used against `Severity` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type SeverityCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `slug` field. */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `Severity` object types. All fields are combined with a logical ‘and.’ */
export type SeverityFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SeverityFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SeverityFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SeverityFilter>>;
  /** Filter by the object’s `slug` field. */
  slug?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<IntFilter>;
};

/** Represents an update to a `Severity`. Fields that are set will be updated. */
export type SeverityPatch = {
  /** The unique name of the severity. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A software package is a set of features that can be exposed to entities such as facilities. */
export type SoftwarePackage = Node & {
  __typename?: 'SoftwarePackage';
  /** Reads and enables pagination through a set of `AssessmentType`. */
  assessmentTypes: AssessmentTypesConnection;
  /** Reads and enables pagination through a set of `Check`. */
  checks: ChecksConnection;
  /** The time at which the record was created */
  createdAt: Scalars['Datetime']['output'];
  /** The description of the package. */
  description: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `FacilitySoftwarePackage`. */
  facilities: FacilitySoftwarePackagesConnection;
  /** Reads and enables pagination through a set of `FacilityDocument`. */
  facilityDocuments: FacilityDocumentsConnection;
  /** The identifer of the package. */
  id: Scalars['Int']['output'];
  /** Indicates if this package is enabled for this tenant. */
  isEnabled: Scalars['Boolean']['output'];
  /** The display name of the package. */
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Available permissions for the SoftwarePackage. */
  permissions?: Maybe<SoftwarePackagePermissions>;
  /** The unique code of the package. */
  slug: Scalars['String']['output'];
  /** The time at which the record was last updated */
  updatedAt: Scalars['Datetime']['output'];
};

/** A software package is a set of features that can be exposed to entities such as facilities. */
export type SoftwarePackageAssessmentTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AssessmentTypeCondition>;
  filter?: InputMaybe<AssessmentTypeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AssessmentTypesOrderBy>>;
};

/** A software package is a set of features that can be exposed to entities such as facilities. */
export type SoftwarePackageChecksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CheckCondition>;
  filter?: InputMaybe<CheckFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChecksOrderBy>>;
};

/** A software package is a set of features that can be exposed to entities such as facilities. */
export type SoftwarePackageFacilitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FacilitySoftwarePackageCondition>;
  filter?: InputMaybe<FacilitySoftwarePackageFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FacilitySoftwarePackagesOrderBy>>;
};

/** A software package is a set of features that can be exposed to entities such as facilities. */
export type SoftwarePackageFacilityDocumentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FacilityDocumentCondition>;
  filter?: InputMaybe<FacilityDocumentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FacilityDocumentsOrderBy>>;
};

/**
 * A condition to be used against `SoftwarePackage` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type SoftwarePackageCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `isEnabled` field. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `slug` field. */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `SoftwarePackage` object types. All fields are combined with a logical ‘and.’ */
export type SoftwarePackageFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SoftwarePackageFilter>>;
  /** Filter by the permission canManage */
  canManage?: InputMaybe<PermissionBooleanFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isEnabled` field. */
  isEnabled?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SoftwarePackageFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SoftwarePackageFilter>>;
  /** Filter by the object’s `slug` field. */
  slug?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** Permissive capabilities on a SoftwarePackage. */
export type SoftwarePackagePermissions = {
  __typename?: 'SoftwarePackagePermissions';
  /** Whether the current user can manage packages */
  canManage: Scalars['Boolean']['output'];
};

/** A connection to a list of `SoftwarePackage` values. */
export type SoftwarePackagesConnection = {
  __typename?: 'SoftwarePackagesConnection';
  /** A list of edges which contains the `SoftwarePackage` and cursor to aid in pagination. */
  edges: Array<SoftwarePackagesEdge>;
  /** A list of `SoftwarePackage` objects. */
  nodes: Array<SoftwarePackage>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SoftwarePackage` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `SoftwarePackage` edge in the connection. */
export type SoftwarePackagesEdge = {
  __typename?: 'SoftwarePackagesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `SoftwarePackage` at the end of the edge. */
  node: SoftwarePackage;
};

/** Methods to use when ordering `SoftwarePackage`. */
export enum SoftwarePackagesOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  IS_ENABLED_ASC = 'IS_ENABLED_ASC',
  IS_ENABLED_DESC = 'IS_ENABLED_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  SLUG_ASC = 'SLUG_ASC',
  SLUG_DESC = 'SLUG_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

export type SourceLabel = Node & {
  __typename?: 'SourceLabel';
  /** IoT device field name */
  label: Scalars['String']['output'];
  nodeId: Scalars['ID']['output'];
  /** IoT device name */
  sourceId: Scalars['String']['output'];
};

/** A space at a given yard */
export type Space = Node & {
  __typename?: 'Space';
  /** The time when this record was created */
  createdAt: Scalars['Datetime']['output'];
  /** Indicates if this space has an eTRU hookup */
  etruEnabled: Scalars['Boolean']['output'];
  /** The polygon defining the real-world area this space occupies */
  geometry: GeometryInterface;
  /** The internal ID of this space */
  id: Scalars['Int']['output'];
  /** Whether the space has a trailer plugged in or not */
  isCharging?: Maybe<Scalars['Boolean']['output']>;
  /** The name of the space */
  name?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The unique space number within the yard */
  number: Scalars['Int']['output'];
  /** Reads and enables pagination through a set of `ParkSession`. */
  parkSessions: ParkSessionsConnection;
  /** Reads and enables pagination through a set of `SpaceActivity`. */
  spaceActivities: SpaceActivitiesConnection;
  /** Reads a single `SpaceCategory` that is related to this `Space`. */
  spaceCategory?: Maybe<SpaceCategory>;
  /** The category of this yard space */
  spaceCategoryId: Scalars['Int']['output'];
  /** The time when this record was last updated */
  updatedAt: Scalars['Datetime']['output'];
};

/** A space at a given yard */
export type SpaceParkSessionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ParkSessionCondition>;
  filter?: InputMaybe<ParkSessionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ParkSessionsOrderBy>>;
};

/** A space at a given yard */
export type SpaceSpaceActivitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SpaceActivityCondition>;
  filter?: InputMaybe<SpaceActivityFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SpaceActivitiesOrderBy>>;
};

/** A connection to a list of `SpaceActivity` values. */
export type SpaceActivitiesConnection = {
  __typename?: 'SpaceActivitiesConnection';
  /** A list of edges which contains the `SpaceActivity` and cursor to aid in pagination. */
  edges: Array<SpaceActivitiesEdge>;
  /** A list of `SpaceActivity` objects. */
  nodes: Array<SpaceActivity>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SpaceActivity` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `SpaceActivity` edge in the connection. */
export type SpaceActivitiesEdge = {
  __typename?: 'SpaceActivitiesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `SpaceActivity` at the end of the edge. */
  node: SpaceActivity;
};

/** Methods to use when ordering `SpaceActivity`. */
export enum SpaceActivitiesOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  METADATA_ASC = 'METADATA_ASC',
  METADATA_DESC = 'METADATA_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  SPACE_ID_ASC = 'SPACE_ID_ASC',
  SPACE_ID_DESC = 'SPACE_ID_DESC',
  TIME_ASC = 'TIME_ASC',
  TIME_DESC = 'TIME_DESC',
  TYPE_ASC = 'TYPE_ASC',
  TYPE_DESC = 'TYPE_DESC'
}

/** The log of activity at a given yard space */
export type SpaceActivity = Node & {
  __typename?: 'SpaceActivity';
  /** The time when the activity happened */
  createdAt: Scalars['Datetime']['output'];
  /** The internal ID of this space activity */
  id: Scalars['BigInt']['output'];
  /** Additional information about the activity */
  metadata: Scalars['JSON']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Space` that is related to this `SpaceActivity`. */
  space?: Maybe<Space>;
  /** The yard space where the activity happened */
  spaceId: Scalars['Int']['output'];
  /** The time when the activity happened */
  time: Scalars['Datetime']['output'];
  /** The type of activity that happened */
  type: Scalars['String']['output'];
};

/**
 * A condition to be used against `SpaceActivity` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type SpaceActivityCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `metadata` field. */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `spaceId` field. */
  spaceId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `time` field. */
  time?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `SpaceActivity` object types. All fields are combined with a logical ‘and.’ */
export type SpaceActivityFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SpaceActivityFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `metadata` field. */
  metadata?: InputMaybe<JsonFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SpaceActivityFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SpaceActivityFilter>>;
  /** Filter by the object’s `spaceId` field. */
  spaceId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `time` field. */
  time?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `SpaceActivity` */
export type SpaceActivityInput = {
  /** The yard space where the activity happened */
  spaceId: Scalars['Int']['input'];
  /** The time when the activity happened */
  time: Scalars['Datetime']['input'];
  /** The type of activity that happened */
  type: Scalars['String']['input'];
};

/** A connection to a list of `SpaceCategory` values. */
export type SpaceCategoriesConnection = {
  __typename?: 'SpaceCategoriesConnection';
  /** A list of edges which contains the `SpaceCategory` and cursor to aid in pagination. */
  edges: Array<SpaceCategoriesEdge>;
  /** A list of `SpaceCategory` objects. */
  nodes: Array<SpaceCategory>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SpaceCategory` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `SpaceCategory` edge in the connection. */
export type SpaceCategoriesEdge = {
  __typename?: 'SpaceCategoriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `SpaceCategory` at the end of the edge. */
  node: SpaceCategory;
};

/** Methods to use when ordering `SpaceCategory`. */
export enum SpaceCategoriesOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  YARD_ID_ASC = 'YARD_ID_ASC',
  YARD_ID_DESC = 'YARD_ID_DESC'
}

/** A category for a given yard space */
export type SpaceCategory = Node & {
  __typename?: 'SpaceCategory';
  /** The time when this record was created */
  createdAt: Scalars['Datetime']['output'];
  /** The internal ID of this space category */
  id: Scalars['Int']['output'];
  /** The name of the space category */
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `Space`. */
  spaces: SpacesConnection;
  /** The time when this record was last updated */
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `Yard` that is related to this `SpaceCategory`. */
  yard?: Maybe<Yard>;
  /** The yard to which this space category belongs */
  yardId: Scalars['Int']['output'];
};

/** A category for a given yard space */
export type SpaceCategorySpacesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SpaceCondition>;
  filter?: InputMaybe<SpaceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SpacesOrderBy>>;
};

/**
 * A condition to be used against `SpaceCategory` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type SpaceCategoryCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `yardId` field. */
  yardId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `SpaceCategory` object types. All fields are combined with a logical ‘and.’ */
export type SpaceCategoryFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SpaceCategoryFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SpaceCategoryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SpaceCategoryFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `yardId` field. */
  yardId?: InputMaybe<IntFilter>;
};

/** A condition to be used against `Space` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type SpaceCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `etruEnabled` field. */
  etruEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `geometry` field. */
  geometry?: InputMaybe<Scalars['GeoJSON']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `number` field. */
  number?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `spaceCategoryId` field. */
  spaceCategoryId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `Space` object types. All fields are combined with a logical ‘and.’ */
export type SpaceFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SpaceFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `etruEnabled` field. */
  etruEnabled?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isCharging` field. */
  isCharging?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SpaceFilter>;
  /** Filter by the object’s `number` field. */
  number?: InputMaybe<IntFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SpaceFilter>>;
  /** Filter by the object’s `spaceCategoryId` field. */
  spaceCategoryId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** A connection to a list of `Space` values. */
export type SpacesConnection = {
  __typename?: 'SpacesConnection';
  /** A list of edges which contains the `Space` and cursor to aid in pagination. */
  edges: Array<SpacesEdge>;
  /** A list of `Space` objects. */
  nodes: Array<Space>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Space` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Space` edge in the connection. */
export type SpacesEdge = {
  __typename?: 'SpacesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Space` at the end of the edge. */
  node: Space;
};

/** Methods to use when ordering `Space`. */
export enum SpacesOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  ETRU_ENABLED_ASC = 'ETRU_ENABLED_ASC',
  ETRU_ENABLED_DESC = 'ETRU_ENABLED_DESC',
  GEOMETRY_ASC = 'GEOMETRY_ASC',
  GEOMETRY_DESC = 'GEOMETRY_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  NUMBER_ASC = 'NUMBER_ASC',
  NUMBER_DESC = 'NUMBER_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  SPACE_CATEGORY_ID_ASC = 'SPACE_CATEGORY_ID_ASC',
  SPACE_CATEGORY_ID_DESC = 'SPACE_CATEGORY_ID_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

export type StartCustomerIntegrationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<Scalars['JSON']['input']>;
  integrationProviderId: Scalars['Int']['input'];
  redirectURI: Scalars['String']['input'];
};

export type StartCustomerIntegrationPayload = {
  __typename?: 'StartCustomerIntegrationPayload';
  authUrl: Scalars['String']['output'];
  clientMutationId?: Maybe<Scalars['String']['output']>;
  customerIntegration: CustomerIntegration;
};

/** A filter to be used against String fields. All fields are combined with a logical ‘and.’ */
export type StringFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value, treating null like an ordinary value (case-insensitive). */
  distinctFromInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Ends with the specified string (case-sensitive). */
  endsWith?: InputMaybe<Scalars['String']['input']>;
  /** Ends with the specified string (case-insensitive). */
  endsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value (case-insensitive). */
  equalToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  /** Greater than the specified value (case-insensitive). */
  greaterThanInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Greater than or equal to the specified value (case-insensitive). */
  greaterThanOrEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Included in the specified list (case-insensitive). */
  inInsensitive?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains the specified string (case-sensitive). */
  includes?: InputMaybe<Scalars['String']['input']>;
  /** Contains the specified string (case-insensitive). */
  includesInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['String']['input']>;
  /** Less than the specified value (case-insensitive). */
  lessThanInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Less than or equal to the specified value (case-insensitive). */
  lessThanOrEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Matches the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  like?: InputMaybe<Scalars['String']['input']>;
  /** Matches the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  likeInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value, treating null like an ordinary value (case-insensitive). */
  notDistinctFromInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Does not end with the specified string (case-sensitive). */
  notEndsWith?: InputMaybe<Scalars['String']['input']>;
  /** Does not end with the specified string (case-insensitive). */
  notEndsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value (case-insensitive). */
  notEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Not included in the specified list (case-insensitive). */
  notInInsensitive?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Does not contain the specified string (case-sensitive). */
  notIncludes?: InputMaybe<Scalars['String']['input']>;
  /** Does not contain the specified string (case-insensitive). */
  notIncludesInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Does not match the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLike?: InputMaybe<Scalars['String']['input']>;
  /** Does not match the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLikeInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Does not start with the specified string (case-sensitive). */
  notStartsWith?: InputMaybe<Scalars['String']['input']>;
  /** Does not start with the specified string (case-insensitive). */
  notStartsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Starts with the specified string (case-sensitive). */
  startsWith?: InputMaybe<Scalars['String']['input']>;
  /** Starts with the specified string (case-insensitive). */
  startsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against String List fields. All fields are combined with a logical ‘and.’ */
export type StringListFilter = {
  /** Any array item is equal to the specified value. */
  anyEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Any array item is greater than the specified value. */
  anyGreaterThan?: InputMaybe<Scalars['String']['input']>;
  /** Any array item is greater than or equal to the specified value. */
  anyGreaterThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Any array item is less than the specified value. */
  anyLessThan?: InputMaybe<Scalars['String']['input']>;
  /** Any array item is less than or equal to the specified value. */
  anyLessThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Any array item is not equal to the specified value. */
  anyNotEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Contained by the specified list of values. */
  containedBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Contains the specified list of values. */
  contains?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>>
  >;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Overlaps the specified list of values. */
  overlaps?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** A submeter */
export type Submeter = Node & {
  __typename?: 'Submeter';
  /** The time when this record was created */
  createdAt: Scalars['Datetime']['output'];
  /** Reads a single `DataPoint` that is related to this `Submeter`. */
  demand?: Maybe<DataPoint>;
  /** The data point used for session detection that reports electricity demand in kW. */
  demandDataPointId: Scalars['BigInt']['output'];
  /** Unique identifier which maps a submeter to events sent from YMS integration. */
  eventId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Facility` that is related to this `Submeter`. */
  facility?: Maybe<Facility>;
  /** The facility for this submeter */
  facilityId: Scalars['Int']['output'];
  /** A fleet event for a given submeter. */
  fleetEvents?: Maybe<MetricDataConnection>;
  /** Returns the derived data point configuration for this connection */
  fleetEventsDataPoint?: Maybe<DerivedDataPoint>;
  /** The internal ID of this submeter */
  id: Scalars['Int']['output'];
  /** A label to describe this submeter */
  label?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The space for this submeter as specified by the YMS integration */
  spaceId: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `SubmeterSession`. */
  submeterSessions: SubmeterSessionsConnection;
  /** The time when this record was updated */
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `DataPoint` that is related to this `Submeter`. */
  usage?: Maybe<DataPoint>;
  /** The data point used for billing that reports electricity usage in kWh for . */
  usageDataPointId: Scalars['BigInt']['output'];
  /** Reads a single `UtilityMeter` that is related to this `Submeter`. */
  utilityMeter?: Maybe<UtilityMeter>;
  /** The actual utility meter where readings are collected */
  utilityMeterId: Scalars['Int']['output'];
  /** The yard as specified by the YMS integration */
  yardId: Scalars['String']['output'];
  /** The tenant identifier of the YMS integration */
  ymsTenant: Scalars['String']['output'];
};

/** A submeter */
export type SubmeterFleetEventsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  inheritTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A submeter */
export type SubmeterSubmeterSessionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SubmeterSessionCondition>;
  filter?: InputMaybe<SubmeterSessionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SubmeterSessionsOrderBy>>;
};

/**
 * A condition to be used against `Submeter` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type SubmeterCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `demandDataPointId` field. */
  demandDataPointId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `label` field. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `spaceId` field. */
  spaceId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `usageDataPointId` field. */
  usageDataPointId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `utilityMeterId` field. */
  utilityMeterId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `yardId` field. */
  yardId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `ymsTenant` field. */
  ymsTenant?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `Submeter` object types. All fields are combined with a logical ‘and.’ */
export type SubmeterFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SubmeterFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `demandDataPointId` field. */
  demandDataPointId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `eventId` field. */
  eventId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `label` field. */
  label?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SubmeterFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SubmeterFilter>>;
  /** Filter by the object’s `spaceId` field. */
  spaceId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `usageDataPointId` field. */
  usageDataPointId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `utilityMeterId` field. */
  utilityMeterId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `yardId` field. */
  yardId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `ymsTenant` field. */
  ymsTenant?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `Submeter` */
export type SubmeterInput = {
  /** Mutates a `DataPoint` as part of the payload */
  dataPoint?: InputMaybe<DataPointInput>;
  /** The data point used for session detection that reports electricity demand in kW. */
  demandDataPointId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The facility for this submeter */
  facilityId: Scalars['Int']['input'];
  /** A label to describe this submeter */
  label?: InputMaybe<Scalars['String']['input']>;
  /** The space for this submeter as specified by the YMS integration */
  spaceId: Scalars['String']['input'];
  /** The data point used for billing that reports electricity usage in kWh for . */
  usageDataPointId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Mutates a `UtilityMeter` as part of the payload */
  utilityMeter?: InputMaybe<UtilityMeterInput>;
  /** The actual utility meter where readings are collected */
  utilityMeterId?: InputMaybe<Scalars['Int']['input']>;
  /** The yard as specified by the YMS integration */
  yardId: Scalars['String']['input'];
  /** The tenant identifier of the YMS integration */
  ymsTenant: Scalars['String']['input'];
};

/** Represents an update to a `Submeter`. Fields that are set will be updated. */
export type SubmeterPatch = {
  /** The data point used for session detection that reports electricity demand in kW. */
  demandDataPointId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The facility for this submeter */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** A label to describe this submeter */
  label?: InputMaybe<Scalars['String']['input']>;
  /** The space for this submeter as specified by the YMS integration */
  spaceId?: InputMaybe<Scalars['String']['input']>;
  /** The data point used for billing that reports electricity usage in kWh for . */
  usageDataPointId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The actual utility meter where readings are collected */
  utilityMeterId?: InputMaybe<Scalars['Int']['input']>;
  /** The yard as specified by the YMS integration */
  yardId?: InputMaybe<Scalars['String']['input']>;
  /** The tenant identifier of the YMS integration */
  ymsTenant?: InputMaybe<Scalars['String']['input']>;
};

/** A submeter session */
export type SubmeterSession = Node & {
  __typename?: 'SubmeterSession';
  /** Reads a single `BillableCustomer` that is related to this `SubmeterSession`. */
  associatedCustomer?: Maybe<BillableCustomer>;
  /** The billable customer of this session */
  associatedCustomerId?: Maybe<Scalars['Int']['output']>;
  /** The time when this record was created */
  createdAt: Scalars['Datetime']['output'];
  /** The ending of this session */
  endTime: Scalars['Datetime']['output'];
  /** The internal ID of this submeter session */
  id: Scalars['Int']['output'];
  /** Indicates if an invoice has been created for this session */
  invoiceCreated: Scalars['Boolean']['output'];
  /** Additional information about this session */
  metadata: Scalars['JSON']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The beginning of this session */
  startTime: Scalars['Datetime']['output'];
  /** Reads a single `Submeter` that is related to this `SubmeterSession`. */
  submeter?: Maybe<Submeter>;
  /** The submeter this session belongs to */
  submeterId: Scalars['Int']['output'];
  /** The time when this record was updated */
  updatedAt: Scalars['Datetime']['output'];
  /** Aggregates a session's usage for the specified filter expression */
  usage?: Maybe<MetricDataConnection>;
};

/** A submeter session */
export type SubmeterSessionUsageArgs = {
  aggregation?: InputMaybe<MetricDataAggregationMethod>;
  orderBy?: MetricDataOrderBy;
};

/**
 * A condition to be used against `SubmeterSession` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type SubmeterSessionCondition = {
  /** Checks for equality with the object’s `associatedCustomerId` field. */
  associatedCustomerId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `endTime` field. */
  endTime?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `invoiceCreated` field. */
  invoiceCreated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `metadata` field. */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `startTime` field. */
  startTime?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `submeterId` field. */
  submeterId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `SubmeterSession` object types. All fields are combined with a logical ‘and.’ */
export type SubmeterSessionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SubmeterSessionFilter>>;
  /** Filter by the object’s `associatedCustomerId` field. */
  associatedCustomerId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `endTime` field. */
  endTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `invoiceCreated` field. */
  invoiceCreated?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `metadata` field. */
  metadata?: InputMaybe<JsonFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SubmeterSessionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SubmeterSessionFilter>>;
  /** Filter by the object’s `startTime` field. */
  startTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `submeterId` field. */
  submeterId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `SubmeterSession` */
export type SubmeterSessionInput = {
  /** The billable customer of this session */
  associatedCustomerId?: InputMaybe<Scalars['Int']['input']>;
  /** Mutates a `BillableCustomer` as part of the payload */
  billableCustomer?: InputMaybe<BillableCustomerInput>;
  /** The ending of this session */
  endTime: Scalars['Datetime']['input'];
  /** Indicates if an invoice has been created for this session */
  invoiceCreated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Additional information about this session */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** The beginning of this session */
  startTime: Scalars['Datetime']['input'];
  /** Mutates a `Submeter` as part of the payload */
  submeter?: InputMaybe<SubmeterInput>;
  /** The submeter this session belongs to */
  submeterId?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents an update to a `SubmeterSession`. Fields that are set will be updated. */
export type SubmeterSessionPatch = {
  /** The billable customer of this session */
  associatedCustomerId?: InputMaybe<Scalars['Int']['input']>;
  /** The ending of this session */
  endTime?: InputMaybe<Scalars['Datetime']['input']>;
  /** Indicates if an invoice has been created for this session */
  invoiceCreated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Additional information about this session */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** The beginning of this session */
  startTime?: InputMaybe<Scalars['Datetime']['input']>;
  /** The submeter this session belongs to */
  submeterId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `SubmeterSession` values. */
export type SubmeterSessionsConnection = {
  __typename?: 'SubmeterSessionsConnection';
  /** A list of edges which contains the `SubmeterSession` and cursor to aid in pagination. */
  edges: Array<SubmeterSessionsEdge>;
  /** A list of `SubmeterSession` objects. */
  nodes: Array<SubmeterSession>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SubmeterSession` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `SubmeterSession` edge in the connection. */
export type SubmeterSessionsEdge = {
  __typename?: 'SubmeterSessionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `SubmeterSession` at the end of the edge. */
  node: SubmeterSession;
};

/** Methods to use when ordering `SubmeterSession`. */
export enum SubmeterSessionsOrderBy {
  ASSOCIATED_CUSTOMER_ID_ASC = 'ASSOCIATED_CUSTOMER_ID_ASC',
  ASSOCIATED_CUSTOMER_ID_DESC = 'ASSOCIATED_CUSTOMER_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  END_TIME_ASC = 'END_TIME_ASC',
  END_TIME_DESC = 'END_TIME_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  INVOICE_CREATED_ASC = 'INVOICE_CREATED_ASC',
  INVOICE_CREATED_DESC = 'INVOICE_CREATED_DESC',
  METADATA_ASC = 'METADATA_ASC',
  METADATA_DESC = 'METADATA_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  START_TIME_ASC = 'START_TIME_ASC',
  START_TIME_DESC = 'START_TIME_DESC',
  SUBMETER_ID_ASC = 'SUBMETER_ID_ASC',
  SUBMETER_ID_DESC = 'SUBMETER_ID_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** A connection to a list of `Submeter` values. */
export type SubmetersConnection = {
  __typename?: 'SubmetersConnection';
  /** Returns the aggregate demand timeseries data for the SubmetersConnection  */
  demand?: Maybe<MetricDataConnection>;
  /** A list of edges which contains the `Submeter` and cursor to aid in pagination. */
  edges: Array<SubmetersEdge>;
  /** A fleet event for a given submeter. */
  fleetEvents?: Maybe<MetricDataConnection>;
  /** A list of `Submeter` objects. */
  nodes: Array<Submeter>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Submeter` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
  /** Returns the aggregate usage timeseries data for the SubmetersConnection  */
  usage?: Maybe<MetricDataConnection>;
};

/** A connection to a list of `Submeter` values. */
export type SubmetersConnectionDemandArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Submeter` values. */
export type SubmetersConnectionFleetEventsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `Submeter` values. */
export type SubmetersConnectionUsageArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A `Submeter` edge in the connection. */
export type SubmetersEdge = {
  __typename?: 'SubmetersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Submeter` at the end of the edge. */
  node: Submeter;
};

/** Methods to use when ordering `Submeter`. */
export enum SubmetersOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DEMAND_DATA_POINT_ID_ASC = 'DEMAND_DATA_POINT_ID_ASC',
  DEMAND_DATA_POINT_ID_DESC = 'DEMAND_DATA_POINT_ID_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LABEL_ASC = 'LABEL_ASC',
  LABEL_DESC = 'LABEL_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  SPACE_ID_ASC = 'SPACE_ID_ASC',
  SPACE_ID_DESC = 'SPACE_ID_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  USAGE_DATA_POINT_ID_ASC = 'USAGE_DATA_POINT_ID_ASC',
  USAGE_DATA_POINT_ID_DESC = 'USAGE_DATA_POINT_ID_DESC',
  UTILITY_METER_ID_ASC = 'UTILITY_METER_ID_ASC',
  UTILITY_METER_ID_DESC = 'UTILITY_METER_ID_DESC',
  YARD_ID_ASC = 'YARD_ID_ASC',
  YARD_ID_DESC = 'YARD_ID_DESC',
  YMS_TENANT_ASC = 'YMS_TENANT_ASC',
  YMS_TENANT_DESC = 'YMS_TENANT_DESC'
}

/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type Subscription = {
  __typename?: 'Subscription';
  yardUpdated?: Maybe<YardUpdatedPayload>;
};

/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type SubscriptionYardUpdatedArgs = {
  yardId: Scalars['Int']['input'];
};

/** A distinct suction group in a refrigeration system. */
export type SuctionGroup = Node & {
  __typename?: 'SuctionGroup';
  /** The time the record was created. */
  createdAt: Scalars['Datetime']['output'];
  /** Reads and enables pagination through a set of `Compressor`. */
  currentCompressors: CompressorsConnection;
  /** The unique identifier for the suction group. */
  id: Scalars['Int']['output'];
  /** The display label of the suction group. */
  label: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `RefrigerationSystem` that is related to this `SuctionGroup`. */
  refrigerationSystem?: Maybe<RefrigerationSystem>;
  /** References the refrigeration system this suction group belongs to. */
  refrigerationSystemId: Scalars['Int']['output'];
  /** Reads and enables pagination through a set of `SuctionGroupCompressor`. */
  suctionGroupCompressors: SuctionGroupCompressorsConnection;
  /** Reads and enables pagination through a set of `SuctionHeader`. */
  suctionHeaders: SuctionHeadersConnection;
  /** Reads a single `DataPoint` that is related to this `SuctionGroup`. */
  suctionPressure?: Maybe<DataPoint>;
  /** The suction pressure value for the suction group. */
  suctionPressureId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `DataPoint` that is related to this `SuctionGroup`. */
  suctionPressureSetpoint?: Maybe<DataPoint>;
  /** The setpoint pressure for the suction group. */
  suctionPressureSetpointId?: Maybe<Scalars['Int']['output']>;
  /** The time the record was last updated. */
  updatedAt: Scalars['Datetime']['output'];
  /** Reads and enables pagination through a set of `Vessel`. */
  vessels: VesselsConnection;
};

/** A distinct suction group in a refrigeration system. */
export type SuctionGroupCurrentCompressorsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<CompressorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** A distinct suction group in a refrigeration system. */
export type SuctionGroupSuctionGroupCompressorsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SuctionGroupCompressorCondition>;
  filter?: InputMaybe<SuctionGroupCompressorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SuctionGroupCompressorsOrderBy>>;
};

/** A distinct suction group in a refrigeration system. */
export type SuctionGroupSuctionHeadersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SuctionHeaderCondition>;
  filter?: InputMaybe<SuctionHeaderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SuctionHeadersOrderBy>>;
};

/** A distinct suction group in a refrigeration system. */
export type SuctionGroupVesselsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VesselCondition>;
  filter?: InputMaybe<VesselFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VesselsOrderBy>>;
};

/** Representation of the controls relationship between suction groups and compressors */
export type SuctionGroupCompressor = Node & {
  __typename?: 'SuctionGroupCompressor';
  /** Reads a single `Compressor` that is related to this `SuctionGroupCompressor`. */
  compressor?: Maybe<Compressor>;
  /** References the compressor connection */
  compressorId?: Maybe<Scalars['Int']['output']>;
  /** The time the record was created. */
  createdAt: Scalars['Datetime']['output'];
  /** The time when a compressor left the suction group */
  effectiveEnd?: Maybe<Scalars['Datetime']['output']>;
  /** The time when a compressor joined the suction group */
  effectiveStart: Scalars['Datetime']['output'];
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `SuctionGroup` that is related to this `SuctionGroupCompressor`. */
  suctionGroup?: Maybe<SuctionGroup>;
  /** References the suction group connection */
  suctionGroupId?: Maybe<Scalars['Int']['output']>;
  /** The time the record was last updated. */
  updatedAt: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `SuctionGroupCompressor` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type SuctionGroupCompressorCondition = {
  /** Checks for equality with the object’s `compressorId` field. */
  compressorId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `effectiveEnd` field. */
  effectiveEnd?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `effectiveStart` field. */
  effectiveStart?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `suctionGroupId` field. */
  suctionGroupId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `SuctionGroupCompressor` object types. All fields are combined with a logical ‘and.’ */
export type SuctionGroupCompressorFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SuctionGroupCompressorFilter>>;
  /** Filter by the object’s `compressorId` field. */
  compressorId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `effectiveEnd` field. */
  effectiveEnd?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `effectiveStart` field. */
  effectiveStart?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SuctionGroupCompressorFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SuctionGroupCompressorFilter>>;
  /** Filter by the object’s `suctionGroupId` field. */
  suctionGroupId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `SuctionGroupCompressor` */
export type SuctionGroupCompressorInput = {
  /** Mutates a `Compressor` as part of the payload */
  compressor?: InputMaybe<CompressorInput>;
  /** References the compressor connection */
  compressorId?: InputMaybe<Scalars['Int']['input']>;
  /** The time when a compressor left the suction group */
  effectiveEnd?: InputMaybe<Scalars['Datetime']['input']>;
  /** The time when a compressor joined the suction group */
  effectiveStart?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Mutates a `SuctionGroup` as part of the payload */
  suctionGroup?: InputMaybe<SuctionGroupInput>;
  /** References the suction group connection */
  suctionGroupId?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents an update to a `SuctionGroupCompressor`. Fields that are set will be updated. */
export type SuctionGroupCompressorPatch = {
  /** References the compressor connection */
  compressorId?: InputMaybe<Scalars['Int']['input']>;
  /** The time when a compressor left the suction group */
  effectiveEnd?: InputMaybe<Scalars['Datetime']['input']>;
  /** The time when a compressor joined the suction group */
  effectiveStart?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** References the suction group connection */
  suctionGroupId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `SuctionGroupCompressor` values. */
export type SuctionGroupCompressorsConnection = {
  __typename?: 'SuctionGroupCompressorsConnection';
  /** A list of edges which contains the `SuctionGroupCompressor` and cursor to aid in pagination. */
  edges: Array<SuctionGroupCompressorsEdge>;
  /** A list of `SuctionGroupCompressor` objects. */
  nodes: Array<SuctionGroupCompressor>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SuctionGroupCompressor` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `SuctionGroupCompressor` edge in the connection. */
export type SuctionGroupCompressorsEdge = {
  __typename?: 'SuctionGroupCompressorsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `SuctionGroupCompressor` at the end of the edge. */
  node: SuctionGroupCompressor;
};

/** Methods to use when ordering `SuctionGroupCompressor`. */
export enum SuctionGroupCompressorsOrderBy {
  COMPRESSOR_ID_ASC = 'COMPRESSOR_ID_ASC',
  COMPRESSOR_ID_DESC = 'COMPRESSOR_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  EFFECTIVE_END_ASC = 'EFFECTIVE_END_ASC',
  EFFECTIVE_END_DESC = 'EFFECTIVE_END_DESC',
  EFFECTIVE_START_ASC = 'EFFECTIVE_START_ASC',
  EFFECTIVE_START_DESC = 'EFFECTIVE_START_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  SUCTION_GROUP_ID_ASC = 'SUCTION_GROUP_ID_ASC',
  SUCTION_GROUP_ID_DESC = 'SUCTION_GROUP_ID_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/**
 * A condition to be used against `SuctionGroup` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type SuctionGroupCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `label` field. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `refrigerationSystemId` field. */
  refrigerationSystemId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `suctionPressureId` field. */
  suctionPressureId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `suctionPressureSetpointId` field. */
  suctionPressureSetpointId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `SuctionGroup` object types. All fields are combined with a logical ‘and.’ */
export type SuctionGroupFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SuctionGroupFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `label` field. */
  label?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SuctionGroupFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SuctionGroupFilter>>;
  /** Filter by the object’s `refrigerationSystemId` field. */
  refrigerationSystemId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `suctionPressureId` field. */
  suctionPressureId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `suctionPressureSetpointId` field. */
  suctionPressureSetpointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `SuctionGroup` */
export type SuctionGroupInput = {
  /** Mutates a `DataPoint` as part of the payload */
  dataPoint?: InputMaybe<DataPointInput>;
  /** The unique identifier for the suction group. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** The display label of the suction group. */
  label: Scalars['String']['input'];
  /** Mutates a `RefrigerationSystem` as part of the payload */
  refrigerationSystem?: InputMaybe<RefrigerationSystemInput>;
  /** References the refrigeration system this suction group belongs to. */
  refrigerationSystemId?: InputMaybe<Scalars['Int']['input']>;
  /** The suction pressure value for the suction group. */
  suctionPressureId?: InputMaybe<Scalars['Int']['input']>;
  /** The setpoint pressure for the suction group. */
  suctionPressureSetpointId?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents an update to a `SuctionGroup`. Fields that are set will be updated. */
export type SuctionGroupPatch = {
  /** The unique identifier for the suction group. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** The display label of the suction group. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** References the refrigeration system this suction group belongs to. */
  refrigerationSystemId?: InputMaybe<Scalars['Int']['input']>;
  /** The suction pressure value for the suction group. */
  suctionPressureId?: InputMaybe<Scalars['Int']['input']>;
  /** The setpoint pressure for the suction group. */
  suctionPressureSetpointId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `SuctionGroup` values. */
export type SuctionGroupsConnection = {
  __typename?: 'SuctionGroupsConnection';
  /** A list of edges which contains the `SuctionGroup` and cursor to aid in pagination. */
  edges: Array<SuctionGroupsEdge>;
  /** A list of `SuctionGroup` objects. */
  nodes: Array<SuctionGroup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Returns the aggregate suctionPressure timeseries data for the SuctionGroupsConnection  */
  suctionPressure?: Maybe<MetricDataConnection>;
  /** Returns the aggregate suctionPressureSetpoint timeseries data for the SuctionGroupsConnection  */
  suctionPressureSetpoint?: Maybe<MetricDataConnection>;
  /** The count of *all* `SuctionGroup` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A connection to a list of `SuctionGroup` values. */
export type SuctionGroupsConnectionSuctionPressureArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `SuctionGroup` values. */
export type SuctionGroupsConnectionSuctionPressureSetpointArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A `SuctionGroup` edge in the connection. */
export type SuctionGroupsEdge = {
  __typename?: 'SuctionGroupsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `SuctionGroup` at the end of the edge. */
  node: SuctionGroup;
};

/** Methods to use when ordering `SuctionGroup`. */
export enum SuctionGroupsOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LABEL_ASC = 'LABEL_ASC',
  LABEL_DESC = 'LABEL_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  REFRIGERATION_SYSTEM_ID_ASC = 'REFRIGERATION_SYSTEM_ID_ASC',
  REFRIGERATION_SYSTEM_ID_DESC = 'REFRIGERATION_SYSTEM_ID_DESC',
  SUCTION_PRESSURE_ID_ASC = 'SUCTION_PRESSURE_ID_ASC',
  SUCTION_PRESSURE_ID_DESC = 'SUCTION_PRESSURE_ID_DESC',
  SUCTION_PRESSURE_SETPOINT_ID_ASC = 'SUCTION_PRESSURE_SETPOINT_ID_ASC',
  SUCTION_PRESSURE_SETPOINT_ID_DESC = 'SUCTION_PRESSURE_SETPOINT_ID_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** Representation of a physical suction header in a refrigeration system. */
export type SuctionHeader = Node & {
  __typename?: 'SuctionHeader';
  /** The time the record was created. */
  createdAt: Scalars['Datetime']['output'];
  /** Reads and enables pagination through a set of `Evaporator`. */
  evaporatorsByReturnSuctionHeaderId: EvaporatorsConnection;
  /** The unique identifier for the suction header. */
  id: Scalars['Int']['output'];
  /** The display label of the suction header. */
  label: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `RefrigerationSystem` that is related to this `SuctionHeader`. */
  refrigerationSystem?: Maybe<RefrigerationSystem>;
  /** References the refrigeration system this suction header belongs to. */
  refrigerationSystemId: Scalars['Int']['output'];
  /** Reads a single `SuctionGroup` that is related to this `SuctionHeader`. */
  suctionGroup?: Maybe<SuctionGroup>;
  /** References the suction group this header is part of. */
  suctionGroupId: Scalars['Int']['output'];
  /** Reads and enables pagination through a set of `SuctionHeadersCompressor`. */
  suctionHeadersCompressors: SuctionHeadersCompressorsConnection;
  /** The time the record was last updated. */
  updatedAt: Scalars['Datetime']['output'];
};

/** Representation of a physical suction header in a refrigeration system. */
export type SuctionHeaderEvaporatorsByReturnSuctionHeaderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EvaporatorCondition>;
  filter?: InputMaybe<EvaporatorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvaporatorsOrderBy>>;
};

/** Representation of a physical suction header in a refrigeration system. */
export type SuctionHeaderSuctionHeadersCompressorsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SuctionHeadersCompressorCondition>;
  filter?: InputMaybe<SuctionHeadersCompressorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SuctionHeadersCompressorsOrderBy>>;
};

/**
 * A condition to be used against `SuctionHeader` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type SuctionHeaderCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `label` field. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `refrigerationSystemId` field. */
  refrigerationSystemId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `suctionGroupId` field. */
  suctionGroupId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `SuctionHeader` object types. All fields are combined with a logical ‘and.’ */
export type SuctionHeaderFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SuctionHeaderFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `label` field. */
  label?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SuctionHeaderFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SuctionHeaderFilter>>;
  /** Filter by the object’s `refrigerationSystemId` field. */
  refrigerationSystemId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `suctionGroupId` field. */
  suctionGroupId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `SuctionHeader` */
export type SuctionHeaderInput = {
  /** The unique identifier for the suction header. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** The display label of the suction header. */
  label: Scalars['String']['input'];
  /** Mutates a `RefrigerationSystem` as part of the payload */
  refrigerationSystem?: InputMaybe<RefrigerationSystemInput>;
  /** References the refrigeration system this suction header belongs to. */
  refrigerationSystemId?: InputMaybe<Scalars['Int']['input']>;
  /** Mutates a `SuctionGroup` as part of the payload */
  suctionGroup?: InputMaybe<SuctionGroupInput>;
  /** References the suction group this header is part of. */
  suctionGroupId?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents an update to a `SuctionHeader`. Fields that are set will be updated. */
export type SuctionHeaderPatch = {
  /** The unique identifier for the suction header. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** The display label of the suction header. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** References the refrigeration system this suction header belongs to. */
  refrigerationSystemId?: InputMaybe<Scalars['Int']['input']>;
  /** References the suction group this header is part of. */
  suctionGroupId?: InputMaybe<Scalars['Int']['input']>;
};

/** Representation of a physical connection between suction headers and compressors */
export type SuctionHeadersCompressor = Node & {
  __typename?: 'SuctionHeadersCompressor';
  /** Reads a single `DataPoint` that is related to this `SuctionHeadersCompressor`. */
  active?: Maybe<DataPoint>;
  /** Indicates whether the header is active for the given compressor. */
  activeId?: Maybe<Scalars['BigInt']['output']>;
  /** Reads a single `Compressor` that is related to this `SuctionHeadersCompressor`. */
  compressor?: Maybe<Compressor>;
  /** References the compressor connection */
  compressorId?: Maybe<Scalars['Int']['output']>;
  /** The time the record was created. */
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `SuctionHeader` that is related to this `SuctionHeadersCompressor`. */
  suctionHeader?: Maybe<SuctionHeader>;
  /** References the suction header connection */
  suctionHeaderId?: Maybe<Scalars['Int']['output']>;
  /** The time the record was last updated. */
  updatedAt: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `SuctionHeadersCompressor` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type SuctionHeadersCompressorCondition = {
  /** Checks for equality with the object’s `activeId` field. */
  activeId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `compressorId` field. */
  compressorId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `suctionHeaderId` field. */
  suctionHeaderId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `SuctionHeadersCompressor` object types. All fields are combined with a logical ‘and.’ */
export type SuctionHeadersCompressorFilter = {
  /** Filter by the object’s `activeId` field. */
  activeId?: InputMaybe<BigIntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SuctionHeadersCompressorFilter>>;
  /** Filter by the object’s `compressorId` field. */
  compressorId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SuctionHeadersCompressorFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SuctionHeadersCompressorFilter>>;
  /** Filter by the object’s `suctionHeaderId` field. */
  suctionHeaderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `SuctionHeadersCompressor` */
export type SuctionHeadersCompressorInput = {
  /** Indicates whether the header is active for the given compressor. */
  activeId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Mutates a `Compressor` as part of the payload */
  compressor?: InputMaybe<CompressorInput>;
  /** References the compressor connection */
  compressorId?: InputMaybe<Scalars['Int']['input']>;
  /** Mutates a `DataPoint` as part of the payload */
  dataPoint?: InputMaybe<DataPointInput>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Mutates a `SuctionHeader` as part of the payload */
  suctionHeader?: InputMaybe<SuctionHeaderInput>;
  /** References the suction header connection */
  suctionHeaderId?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents an update to a `SuctionHeadersCompressor`. Fields that are set will be updated. */
export type SuctionHeadersCompressorPatch = {
  /** Indicates whether the header is active for the given compressor. */
  activeId?: InputMaybe<Scalars['BigInt']['input']>;
  /** References the compressor connection */
  compressorId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** References the suction header connection */
  suctionHeaderId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `SuctionHeadersCompressor` values. */
export type SuctionHeadersCompressorsConnection = {
  __typename?: 'SuctionHeadersCompressorsConnection';
  /** Returns the aggregate active timeseries data for the SuctionHeadersCompressorsConnection  */
  active?: Maybe<MetricDataConnection>;
  /** A list of edges which contains the `SuctionHeadersCompressor` and cursor to aid in pagination. */
  edges: Array<SuctionHeadersCompressorsEdge>;
  /** A list of `SuctionHeadersCompressor` objects. */
  nodes: Array<SuctionHeadersCompressor>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SuctionHeadersCompressor` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A connection to a list of `SuctionHeadersCompressor` values. */
export type SuctionHeadersCompressorsConnectionActiveArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A `SuctionHeadersCompressor` edge in the connection. */
export type SuctionHeadersCompressorsEdge = {
  __typename?: 'SuctionHeadersCompressorsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `SuctionHeadersCompressor` at the end of the edge. */
  node: SuctionHeadersCompressor;
};

/** Methods to use when ordering `SuctionHeadersCompressor`. */
export enum SuctionHeadersCompressorsOrderBy {
  ACTIVE_ID_ASC = 'ACTIVE_ID_ASC',
  ACTIVE_ID_DESC = 'ACTIVE_ID_DESC',
  COMPRESSOR_ID_ASC = 'COMPRESSOR_ID_ASC',
  COMPRESSOR_ID_DESC = 'COMPRESSOR_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  SUCTION_HEADER_ID_ASC = 'SUCTION_HEADER_ID_ASC',
  SUCTION_HEADER_ID_DESC = 'SUCTION_HEADER_ID_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** A connection to a list of `SuctionHeader` values. */
export type SuctionHeadersConnection = {
  __typename?: 'SuctionHeadersConnection';
  /** A list of edges which contains the `SuctionHeader` and cursor to aid in pagination. */
  edges: Array<SuctionHeadersEdge>;
  /** A list of `SuctionHeader` objects. */
  nodes: Array<SuctionHeader>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SuctionHeader` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `SuctionHeader` edge in the connection. */
export type SuctionHeadersEdge = {
  __typename?: 'SuctionHeadersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `SuctionHeader` at the end of the edge. */
  node: SuctionHeader;
};

/** Methods to use when ordering `SuctionHeader`. */
export enum SuctionHeadersOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LABEL_ASC = 'LABEL_ASC',
  LABEL_DESC = 'LABEL_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  REFRIGERATION_SYSTEM_ID_ASC = 'REFRIGERATION_SYSTEM_ID_ASC',
  REFRIGERATION_SYSTEM_ID_DESC = 'REFRIGERATION_SYSTEM_ID_DESC',
  SUCTION_GROUP_ID_ASC = 'SUCTION_GROUP_ID_ASC',
  SUCTION_GROUP_ID_DESC = 'SUCTION_GROUP_ID_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** A suggestion for the associated optimization project. */
export type Suggestion = Node & {
  __typename?: 'Suggestion';
  /** Returns the timestamp at which an acknowledgement cannot occur past. */
  acknowledgementCutoff?: Maybe<Scalars['Datetime']['output']>;
  /** The current acknowledgement status on the suggestion. */
  acknowledgementStatus: Acknowledgement;
  availableAcknowledgements: Array<Acknowledgement>;
  /** Reads and enables pagination through a set of `ControlEvent`. */
  controlEvents: ControlEventsConnection;
  /** Returns the control type of a suggestion. */
  controlType?: Maybe<ControlType>;
  /** The time the suggestion was created. */
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  /** The current Project Enrollment associated with the suggestion. */
  currentEnrollment?: Maybe<ProjectEnrollment>;
  /** The description of suggestions. */
  description?: Maybe<Scalars['String']['output']>;
  /** The effectiveness of the taken action against the set target for the project fields */
  effectiveness?: Maybe<Scalars['Float']['output']>;
  /** The date in which the suggestion event ends. */
  endTime?: Maybe<Scalars['Datetime']['output']>;
  /** The `Facility` associated with the suggestion. */
  facility?: Maybe<Facility>;
  /** Facility Id */
  facilityId?: Maybe<Scalars['Int']['output']>;
  /** Facility Name */
  facilityName?: Maybe<Scalars['String']['output']>;
  /** The identifier of the suggestions. */
  id: Scalars['Int']['output'];
  isAcknowledged?: Maybe<Scalars['Boolean']['output']>;
  isRejected?: Maybe<Scalars['Boolean']['output']>;
  /** Is current user is watching the suggestion’s project. */
  isWatching?: Maybe<Scalars['Boolean']['output']>;
  isWithdrawn?: Maybe<Scalars['Boolean']['output']>;
  metadata: Scalars['JSON']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Available permissions for the Suggestion. */
  permissions?: Maybe<SuggestionPermissions>;
  /** The program id for the associated project. */
  programId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `Project` that is related to this `Suggestion`. */
  project?: Maybe<Project>;
  /** The identifier of the project. */
  projectId: Scalars['Int']['output'];
  /** Project Name. */
  projectName?: Maybe<Scalars['String']['output']>;
  /** Project Type */
  projectType?: Maybe<Scalars['String']['output']>;
  /** Returns the associated savings event for the suggestion. */
  savingsEvent?: Maybe<SavingsEvent>;
  /** The time in which the suggestion event begins. */
  startTime: Scalars['Datetime']['output'];
  /** The current state of the suggestion. */
  state?: Maybe<SuggestionState>;
  /** Reads and enables pagination through a set of `SuggestionActivityLog`. */
  suggestionActivityLogs: SuggestionActivityLogsConnection;
  /** The time the suggestion was updated. */
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  /** The timestamp when the suggestion was withdrawn. */
  withdrawnAt?: Maybe<Scalars['Datetime']['output']>;
};

/** A suggestion for the associated optimization project. */
export type SuggestionControlEventsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<ControlEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** A suggestion for the associated optimization project. */
export type SuggestionSuggestionActivityLogsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SuggestionActivityLogCondition>;
  filter?: InputMaybe<SuggestionActivityLogFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SuggestionActivityLogsOrderBy>>;
};

export type SuggestionActivityLog = {
  __typename?: 'SuggestionActivityLog';
  /** The identifier of the actor who triggered the activity. */
  actor?: Maybe<Actor>;
  /** The time the suggestion activity event occurred. */
  createdAt: Scalars['Datetime']['output'];
  /** Metadata about the activity. */
  metadata: Scalars['JSON']['output'];
  /** Reads a single `Suggestion` that is related to this `SuggestionActivityLog`. */
  suggestion?: Maybe<Suggestion>;
  /** The identifier of the suggestion. */
  suggestionId: Scalars['Int']['output'];
  /** The type of activity. */
  type: SuggestionActivityType;
};

/**
 * A condition to be used against `SuggestionActivityLog` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type SuggestionActivityLogCondition = {
  /** Checks for equality with the object’s `actor` field. */
  actor?: InputMaybe<ActorInput>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `metadata` field. */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `suggestionId` field. */
  suggestionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<SuggestionActivityType>;
};

/** A filter to be used against `SuggestionActivityLog` object types. All fields are combined with a logical ‘and.’ */
export type SuggestionActivityLogFilter = {
  /** Filter by the object’s `actor` field. */
  actor?: InputMaybe<ActorFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SuggestionActivityLogFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `metadata` field. */
  metadata?: InputMaybe<JsonFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SuggestionActivityLogFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SuggestionActivityLogFilter>>;
  /** Filter by the object’s `suggestionId` field. */
  suggestionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<SuggestionActivityTypeFilter>;
};

/** An input for mutations affecting `SuggestionActivityLog` */
export type SuggestionActivityLogInput = {
  /** The identifier of the actor who triggered the activity. */
  actor?: InputMaybe<ActorInput>;
  /** The time the suggestion activity event occurred. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Metadata about the activity. */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** Mutates a `Suggestion` as part of the payload */
  suggestion?: InputMaybe<SuggestionInput>;
  /** The identifier of the suggestion. */
  suggestionId?: InputMaybe<Scalars['Int']['input']>;
  /** The type of activity. */
  type: SuggestionActivityType;
};

/** A connection to a list of `SuggestionActivityLog` values. */
export type SuggestionActivityLogsConnection = {
  __typename?: 'SuggestionActivityLogsConnection';
  /** A list of edges which contains the `SuggestionActivityLog` and cursor to aid in pagination. */
  edges: Array<SuggestionActivityLogsEdge>;
  /** A list of `SuggestionActivityLog` objects. */
  nodes: Array<SuggestionActivityLog>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SuggestionActivityLog` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `SuggestionActivityLog` edge in the connection. */
export type SuggestionActivityLogsEdge = {
  __typename?: 'SuggestionActivityLogsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `SuggestionActivityLog` at the end of the edge. */
  node: SuggestionActivityLog;
};

/** Methods to use when ordering `SuggestionActivityLog`. */
export enum SuggestionActivityLogsOrderBy {
  ACTOR_ASC = 'ACTOR_ASC',
  ACTOR_DESC = 'ACTOR_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  METADATA_ASC = 'METADATA_ASC',
  METADATA_DESC = 'METADATA_DESC',
  NATURAL = 'NATURAL',
  SUGGESTION_ID_ASC = 'SUGGESTION_ID_ASC',
  SUGGESTION_ID_DESC = 'SUGGESTION_ID_DESC',
  TYPE_ASC = 'TYPE_ASC',
  TYPE_DESC = 'TYPE_DESC'
}

export enum SuggestionActivityType {
  ACKNOWLEDGED = 'ACKNOWLEDGED',
  REJECTED = 'REJECTED',
  UPDATED = 'UPDATED',
  WITHDRAWN = 'WITHDRAWN'
}

/** A filter to be used against SuggestionActivityType fields. All fields are combined with a logical ‘and.’ */
export type SuggestionActivityTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<SuggestionActivityType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<SuggestionActivityType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<SuggestionActivityType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<SuggestionActivityType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<SuggestionActivityType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<SuggestionActivityType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<SuggestionActivityType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<SuggestionActivityType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<SuggestionActivityType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<SuggestionActivityType>>;
};

/**
 * A condition to be used against `Suggestion` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type SuggestionCondition = {
  /** Checks for equality with the object’s `acknowledgementStatus` field. */
  acknowledgementStatus?: InputMaybe<Acknowledgement>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `effectiveness` field. */
  effectiveness?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `endTime` field. */
  endTime?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `metadata` field. */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `startTime` field. */
  startTime?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `withdrawnAt` field. */
  withdrawnAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export type SuggestionControlEvent = Node & {
  __typename?: 'SuggestionControlEvent';
  /** Reads a single `ControlEvent` that is related to this `SuggestionControlEvent`. */
  controlEvent?: Maybe<ControlEvent>;
  controlEventId: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Suggestion` that is related to this `SuggestionControlEvent`. */
  suggestion?: Maybe<Suggestion>;
  suggestionId: Scalars['Int']['output'];
};

/** An input for mutations affecting `SuggestionControlEvent` */
export type SuggestionControlEventInput = {
  /** Mutates a `ControlEvent` as part of the payload */
  controlEvent?: InputMaybe<ControlEventInput>;
  controlEventId?: InputMaybe<Scalars['Int']['input']>;
  suggestionId: Scalars['Int']['input'];
};

/** Represents an update to a `SuggestionControlEvent`. Fields that are set will be updated. */
export type SuggestionControlEventPatch = {
  controlEventId?: InputMaybe<Scalars['Int']['input']>;
  suggestionId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `Suggestion` object types. All fields are combined with a logical ‘and.’ */
export type SuggestionFilter = {
  /** Filter by the object’s `acknowledgementCutoff` field. */
  acknowledgementCutoff?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `acknowledgementStatus` field. */
  acknowledgementStatus?: InputMaybe<AcknowledgementFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SuggestionFilter>>;
  /** Filter by the permission can_control */
  canControl?: InputMaybe<PermissionBooleanFilter>;
  /** Filter by the object’s `controlType` field. */
  controlType?: InputMaybe<ControlTypeFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `effectiveness` field. */
  effectiveness?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `endTime` field. */
  endTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `facilityName` field. */
  facilityName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isAcknowledged` field. */
  isAcknowledged?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isRejected` field. */
  isRejected?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isWatching` field. */
  isWatching?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isWithdrawn` field. */
  isWithdrawn?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `metadata` field. */
  metadata?: InputMaybe<JsonFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SuggestionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SuggestionFilter>>;
  /** Filter by the object’s `programId` field. */
  programId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `projectName` field. */
  projectName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `projectType` field. */
  projectType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `startTime` field. */
  startTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `state` field. */
  state?: InputMaybe<SuggestionStateFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `withdrawnAt` field. */
  withdrawnAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `Suggestion` */
export type SuggestionInput = {
  /** The description of suggestions. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The effectiveness of the taken action against the set target for the project fields */
  effectiveness?: InputMaybe<Scalars['Float']['input']>;
  /** The date in which the suggestion event ends. */
  endTime?: InputMaybe<Scalars['Datetime']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** The identifier of the project. */
  projectId: Scalars['Int']['input'];
  /** The time in which the suggestion event begins. */
  startTime: Scalars['Datetime']['input'];
};

/** Represents an update to a `Suggestion`. Fields that are set will be updated. */
export type SuggestionPatch = {
  /** The description of suggestions. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The effectiveness of the taken action against the set target for the project fields */
  effectiveness?: InputMaybe<Scalars['Float']['input']>;
  /** The date in which the suggestion event ends. */
  endTime?: InputMaybe<Scalars['Datetime']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** The identifier of the project. */
  projectId?: InputMaybe<Scalars['Int']['input']>;
  /** The time in which the suggestion event begins. */
  startTime?: InputMaybe<Scalars['Datetime']['input']>;
};

/** Permissive capabilities on a Suggestion. */
export type SuggestionPermissions = {
  __typename?: 'SuggestionPermissions';
  /** Whether a user can approve and/or transition the suggestion. */
  canControl: Scalars['Boolean']['output'];
};

export enum SuggestionState {
  ACTIVE = 'ACTIVE',
  PAST = 'PAST',
  UPCOMING = 'UPCOMING',
  WITHDRAWN = 'WITHDRAWN'
}

/** A filter to be used against SuggestionState fields. All fields are combined with a logical ‘and.’ */
export type SuggestionStateFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<SuggestionState>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<SuggestionState>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<SuggestionState>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<SuggestionState>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<SuggestionState>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<SuggestionState>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<SuggestionState>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<SuggestionState>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<SuggestionState>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<SuggestionState>>;
};

/** A connection to a list of `Suggestion` values. */
export type SuggestionsConnection = {
  __typename?: 'SuggestionsConnection';
  /** A list of edges which contains the `Suggestion` and cursor to aid in pagination. */
  edges: Array<SuggestionsEdge>;
  /** A list of `Suggestion` objects. */
  nodes: Array<Suggestion>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Suggestion` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Suggestion` edge in the connection. */
export type SuggestionsEdge = {
  __typename?: 'SuggestionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Suggestion` at the end of the edge. */
  node: Suggestion;
};

/** Methods to use when ordering `Suggestion`. */
export enum SuggestionsOrderBy {
  ACKNOWLEDGEMENT_CUTOFF_ASC = 'ACKNOWLEDGEMENT_CUTOFF_ASC',
  ACKNOWLEDGEMENT_CUTOFF_DESC = 'ACKNOWLEDGEMENT_CUTOFF_DESC',
  ACKNOWLEDGEMENT_STATUS_ASC = 'ACKNOWLEDGEMENT_STATUS_ASC',
  ACKNOWLEDGEMENT_STATUS_DESC = 'ACKNOWLEDGEMENT_STATUS_DESC',
  CONTROL_TYPE_ASC = 'CONTROL_TYPE_ASC',
  CONTROL_TYPE_DESC = 'CONTROL_TYPE_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  EFFECTIVENESS_ASC = 'EFFECTIVENESS_ASC',
  EFFECTIVENESS_DESC = 'EFFECTIVENESS_DESC',
  END_TIME_ASC = 'END_TIME_ASC',
  END_TIME_DESC = 'END_TIME_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  FACILITY_NAME_ASC = 'FACILITY_NAME_ASC',
  FACILITY_NAME_DESC = 'FACILITY_NAME_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  IS_WATCHING_ASC = 'IS_WATCHING_ASC',
  IS_WATCHING_DESC = 'IS_WATCHING_DESC',
  METADATA_ASC = 'METADATA_ASC',
  METADATA_DESC = 'METADATA_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  PROJECT_ID_ASC = 'PROJECT_ID_ASC',
  PROJECT_ID_DESC = 'PROJECT_ID_DESC',
  PROJECT_NAME_ASC = 'PROJECT_NAME_ASC',
  PROJECT_NAME_DESC = 'PROJECT_NAME_DESC',
  PROJECT_TYPE_ASC = 'PROJECT_TYPE_ASC',
  PROJECT_TYPE_DESC = 'PROJECT_TYPE_DESC',
  RELEVANCY_ASC = 'RELEVANCY_ASC',
  RELEVANCY_DESC = 'RELEVANCY_DESC',
  START_TIME_ASC = 'START_TIME_ASC',
  START_TIME_DESC = 'START_TIME_DESC',
  STATE_ASC = 'STATE_ASC',
  STATE_DESC = 'STATE_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  WITHDRAWN_AT_ASC = 'WITHDRAWN_AT_ASC',
  WITHDRAWN_AT_DESC = 'WITHDRAWN_AT_DESC'
}

/** This represents a wireless temperature sensor that exists in a facility */
export type TemperatureSensor = Node & {
  __typename?: 'TemperatureSensor';
  assetFacilityId?: Maybe<Scalars['Int']['output']>;
  assetName?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DataPoint` that is related to this `TemperatureSensor`. */
  battery?: Maybe<DataPoint>;
  /** The battery level */
  batteryId?: Maybe<Scalars['BigInt']['output']>;
  /** The building area where the sensor is installed. */
  buildingAreaId?: Maybe<Scalars['Int']['output']>;
  /** Reads and enables pagination through a set of `BuildingArea`. */
  buildingAreas: BuildingAreasConnection;
  /** The time at which the Temperature Sensor was created */
  createdAt: Scalars['Datetime']['output'];
  /** Reads a single `Facility` that is related to this `TemperatureSensor`. */
  facility?: Maybe<Facility>;
  /** The facility where the temperature sensor is installed */
  facilityId?: Maybe<Scalars['Int']['output']>;
  /** The GIS geometry specifies the physical location of where the sensor is installed */
  geometry?: Maybe<GeometryInterface>;
  /** The hardware ID for the sensor. */
  hardwareId?: Maybe<Scalars['String']['output']>;
  /** The id of the temperature sensor */
  id: Scalars['Int']['output'];
  /** The Human-readable label for the sensor */
  label: Scalars['String']['output'];
  /** The metadata for the sensor */
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** The related monitored asset. */
  monitoredAsset?: Maybe<MonitoredAsset>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** A short link used for sensor provisioning */
  shortLink?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DataPoint` that is related to this `TemperatureSensor`. */
  signal?: Maybe<DataPoint>;
  /** The signal strength */
  signalId?: Maybe<Scalars['BigInt']['output']>;
  /** Reads a single `DataPoint` that is related to this `TemperatureSensor`. */
  temperature?: Maybe<DataPoint>;
  /** The recorded temperature */
  temperatureId?: Maybe<Scalars['BigInt']['output']>;
  /** The time at which the Temperature Sensor was updated */
  updatedAt: Scalars['Datetime']['output'];
};

/** This represents a wireless temperature sensor that exists in a facility */
export type TemperatureSensorBuildingAreasArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<BuildingAreaFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * A condition to be used against `TemperatureSensor` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type TemperatureSensorCondition = {
  /** Checks for equality with the object’s `batteryId` field. */
  batteryId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `buildingAreaId` field. */
  buildingAreaId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `geometry` field. */
  geometry?: InputMaybe<Scalars['GeoJSON']['input']>;
  /** Checks for equality with the object’s `hardwareId` field. */
  hardwareId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `label` field. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `metadata` field. */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `shortLink` field. */
  shortLink?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `signalId` field. */
  signalId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `temperatureId` field. */
  temperatureId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `TemperatureSensor` object types. All fields are combined with a logical ‘and.’ */
export type TemperatureSensorFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TemperatureSensorFilter>>;
  /** Filter by the object’s `assetFacilityId` field. */
  assetFacilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `assetName` field. */
  assetName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `batteryId` field. */
  batteryId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `buildingAreaId` field. */
  buildingAreaId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `hardwareId` field. */
  hardwareId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `label` field. */
  label?: InputMaybe<StringFilter>;
  /** Filter by the object’s `metadata` field. */
  metadata?: InputMaybe<JsonFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TemperatureSensorFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TemperatureSensorFilter>>;
  /** Filter by the object’s `shortLink` field. */
  shortLink?: InputMaybe<StringFilter>;
  /** Filter by the object’s `signalId` field. */
  signalId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `temperatureId` field. */
  temperatureId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `TemperatureSensor` */
export type TemperatureSensorInput = {
  /** The battery level */
  batteryId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The building area where the sensor is installed. */
  buildingAreaId?: InputMaybe<Scalars['Int']['input']>;
  /** Mutates a `DataPoint` as part of the payload */
  dataPoint?: InputMaybe<DataPointInput>;
  /** The facility where the temperature sensor is installed */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** The GIS geometry specifies the physical location of where the sensor is installed */
  geometry?: InputMaybe<Scalars['GeoJSON']['input']>;
  /** The hardware ID for the sensor. */
  hardwareId?: InputMaybe<Scalars['String']['input']>;
  /** The Human-readable label for the sensor */
  label: Scalars['String']['input'];
  /** The metadata for the sensor */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** A short link used for sensor provisioning */
  shortLink?: InputMaybe<Scalars['String']['input']>;
  /** The signal strength */
  signalId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The recorded temperature */
  temperatureId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** Represents an update to a `TemperatureSensor`. Fields that are set will be updated. */
export type TemperatureSensorPatch = {
  /** The battery level */
  batteryId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The building area where the sensor is installed. */
  buildingAreaId?: InputMaybe<Scalars['Int']['input']>;
  /** The facility where the temperature sensor is installed */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** The GIS geometry specifies the physical location of where the sensor is installed */
  geometry?: InputMaybe<Scalars['GeoJSON']['input']>;
  /** The hardware ID for the sensor. */
  hardwareId?: InputMaybe<Scalars['String']['input']>;
  /** The Human-readable label for the sensor */
  label?: InputMaybe<Scalars['String']['input']>;
  /** The metadata for the sensor */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** A short link used for sensor provisioning */
  shortLink?: InputMaybe<Scalars['String']['input']>;
  /** The signal strength */
  signalId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The recorded temperature */
  temperatureId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A connection to a list of `TemperatureSensor` values. */
export type TemperatureSensorsConnection = {
  __typename?: 'TemperatureSensorsConnection';
  /** Returns the aggregate battery timeseries data for the TemperatureSensorsConnection  */
  battery?: Maybe<MetricDataConnection>;
  /** A list of edges which contains the `TemperatureSensor` and cursor to aid in pagination. */
  edges: Array<TemperatureSensorsEdge>;
  /** A list of `TemperatureSensor` objects. */
  nodes: Array<TemperatureSensor>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Returns the aggregate signal timeseries data for the TemperatureSensorsConnection  */
  signal?: Maybe<MetricDataConnection>;
  /** Returns the aggregate temperature timeseries data for the TemperatureSensorsConnection  */
  temperature?: Maybe<MetricDataConnection>;
  /** The count of *all* `TemperatureSensor` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A connection to a list of `TemperatureSensor` values. */
export type TemperatureSensorsConnectionBatteryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `TemperatureSensor` values. */
export type TemperatureSensorsConnectionSignalArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `TemperatureSensor` values. */
export type TemperatureSensorsConnectionTemperatureArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A `TemperatureSensor` edge in the connection. */
export type TemperatureSensorsEdge = {
  __typename?: 'TemperatureSensorsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `TemperatureSensor` at the end of the edge. */
  node: TemperatureSensor;
};

/** Methods to use when ordering `TemperatureSensor`. */
export enum TemperatureSensorsOrderBy {
  BATTERY_ID_ASC = 'BATTERY_ID_ASC',
  BATTERY_ID_DESC = 'BATTERY_ID_DESC',
  BUILDING_AREA_ID_ASC = 'BUILDING_AREA_ID_ASC',
  BUILDING_AREA_ID_DESC = 'BUILDING_AREA_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  GEOMETRY_ASC = 'GEOMETRY_ASC',
  GEOMETRY_DESC = 'GEOMETRY_DESC',
  HARDWARE_ID_ASC = 'HARDWARE_ID_ASC',
  HARDWARE_ID_DESC = 'HARDWARE_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LABEL_ASC = 'LABEL_ASC',
  LABEL_DESC = 'LABEL_DESC',
  METADATA_ASC = 'METADATA_ASC',
  METADATA_DESC = 'METADATA_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  SHORT_LINK_ASC = 'SHORT_LINK_ASC',
  SHORT_LINK_DESC = 'SHORT_LINK_DESC',
  SIGNAL_ID_ASC = 'SIGNAL_ID_ASC',
  SIGNAL_ID_DESC = 'SIGNAL_ID_DESC',
  TEMPERATURE_ID_ASC = 'TEMPERATURE_ID_ASC',
  TEMPERATURE_ID_DESC = 'TEMPERATURE_ID_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

export enum ThresholdCondition {
  EQUAL = 'EQUAL',
  GREATER = 'GREATER',
  GREATER_EQUAL = 'GREATER_EQUAL',
  LESS = 'LESS',
  LESS_EQUAL = 'LESS_EQUAL',
  NOT_EQUAL = 'NOT_EQUAL'
}

/** A filter to be used against ThresholdCondition fields. All fields are combined with a logical ‘and.’ */
export type ThresholdConditionFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<ThresholdCondition>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<ThresholdCondition>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<ThresholdCondition>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<ThresholdCondition>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<ThresholdCondition>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<ThresholdCondition>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<ThresholdCondition>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<ThresholdCondition>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<ThresholdCondition>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<ThresholdCondition>>;
};

/** Represents a timezone type. */
export type Timezone = Node & {
  __typename?: 'Timezone';
  /** The abbreviation of the timezone. */
  abbreviation?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `Facility`. */
  facilitiesByTimezoneName: FacilitiesConnection;
  /** Whether the timezone follows daylight savings time (DST). */
  isDst?: Maybe<Scalars['Boolean']['output']>;
  /** The name of the timezone. */
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `Program`. */
  programsByTimezoneName: ProgramsConnection;
  /** The offset of the timezone as an interval. */
  utcOffset?: Maybe<Interval>;
  /** Returns the total seconds for the interval field utcOffset */
  utcOffsetSeconds?: Maybe<Scalars['Int']['output']>;
};

/** Represents a timezone type. */
export type TimezoneFacilitiesByTimezoneNameArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FacilityCondition>;
  filter?: InputMaybe<FacilityFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FacilitiesOrderBy>>;
};

/** Represents a timezone type. */
export type TimezoneProgramsByTimezoneNameArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProgramCondition>;
  filter?: InputMaybe<ProgramFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProgramsOrderBy>>;
};

/**
 * A condition to be used against `Timezone` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type TimezoneCondition = {
  /** Checks for equality with the object’s `abbreviation` field. */
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `isDst` field. */
  isDst?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `utcOffset` field. */
  utcOffset?: InputMaybe<IntervalInput>;
};

/** A filter to be used against `Timezone` object types. All fields are combined with a logical ‘and.’ */
export type TimezoneFilter = {
  /** Filter by the object’s `abbreviation` field. */
  abbreviation?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TimezoneFilter>>;
  /** Filter by the object’s `isDst` field. */
  isDst?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TimezoneFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TimezoneFilter>>;
  /** Filter by the object’s `utcOffset` field. */
  utcOffset?: InputMaybe<IntervalFilter>;
};

/** A connection to a list of `Timezone` values. */
export type TimezonesConnection = {
  __typename?: 'TimezonesConnection';
  /** A list of edges which contains the `Timezone` and cursor to aid in pagination. */
  edges: Array<TimezonesEdge>;
  /** A list of `Timezone` objects. */
  nodes: Array<Timezone>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Timezone` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Timezone` edge in the connection. */
export type TimezonesEdge = {
  __typename?: 'TimezonesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Timezone` at the end of the edge. */
  node: Timezone;
};

/** Methods to use when ordering `Timezone`. */
export enum TimezonesOrderBy {
  ABBREVIATION_ASC = 'ABBREVIATION_ASC',
  ABBREVIATION_DESC = 'ABBREVIATION_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_ADDRESS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_ADDRESS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_ADDRESS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_ADDRESS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_BONUS_LTR_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_BONUS_LTR_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_BONUS_LTR_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_BONUS_LTR_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_CITY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_CITY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_CITY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_CITY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_COMMODITY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_COMMODITY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_COMMODITY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_COMMODITY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_CONTXT_9249_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_CONTXT_9249_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_CONTXT_9249_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_CONTXT_9249_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_COST_CENTER_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_COST_CENTER_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_COST_CENTER_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_COST_CENTER_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_COUNTRY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_COUNTRY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_COUNTRY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_COUNTRY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_CREATED_AT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_CREATED_AT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_CREATED_AT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_CREATED_AT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_CUSTOMER_LOCATION_ID_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_CUSTOMER_LOCATION_ID_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_CUSTOMER_LOCATION_ID_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_CUSTOMER_LOCATION_ID_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_DATATYPE_1_TEST_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_DATATYPE_1_TEST_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_DATATYPE_1_TEST_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_DATATYPE_1_TEST_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_DATA_TYPE_2_TEST_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_DATA_TYPE_2_TEST_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_DATA_TYPE_2_TEST_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_DATA_TYPE_2_TEST_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_DATA_TYPE_3_TEST_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_DATA_TYPE_3_TEST_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_DATA_TYPE_3_TEST_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_DATA_TYPE_3_TEST_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_FACILITY_CONTACTS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_FACILITY_CONTACTS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_FACILITY_CONTACTS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_FACILITY_CONTACTS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_FLOOR_PLAN_GEOMETRY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_FLOOR_PLAN_GEOMETRY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_FLOOR_PLAN_GEOMETRY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_FLOOR_PLAN_GEOMETRY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_GEOMETRY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_GEOMETRY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_GEOMETRY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_GEOMETRY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_GO_LIVE_DATE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_GO_LIVE_DATE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_GO_LIVE_DATE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_GO_LIVE_DATE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_ID_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_ID_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_ID_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_ID_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_LATITUDE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_LATITUDE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_LATITUDE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_LATITUDE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_LINK_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_LINK_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_LINK_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_LINK_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_LONGITUDE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_LONGITUDE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_LONGITUDE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_LONGITUDE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_METRICS_ONE_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_METRICS_ONE_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_METRICS_ONE_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_METRICS_ONE_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_NAME_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_NAME_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_NAME_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_NAME_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_NOTE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_NOTE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_NOTE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_NOTE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_N_SIGHT_2_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_N_SIGHT_2_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_N_SIGHT_2_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_N_SIGHT_2_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_N_SIGHT_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_N_SIGHT_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_N_SIGHT_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_N_SIGHT_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_PRE_BONUS_EBITDA_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_PRE_BONUS_EBITDA_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_PRE_BONUS_EBITDA_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_PRE_BONUS_EBITDA_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_PRICING_NODE_ID_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_PRICING_NODE_ID_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_PRICING_NODE_ID_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_PRICING_NODE_ID_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_REAL_TIME_ENABLED_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_REAL_TIME_ENABLED_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_REAL_TIME_ENABLED_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_REAL_TIME_ENABLED_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_REFRIGERATIONVENDOR_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_REFRIGERATIONVENDOR_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_REFRIGERATIONVENDOR_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_REFRIGERATIONVENDOR_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_RETIRED_AT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_RETIRED_AT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_RETIRED_AT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_RETIRED_AT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_SLUG_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_SLUG_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_SLUG_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_SLUG_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_STATE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_STATE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_STATE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_STATE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_SUPPRESSE_FINANCIALS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_SUPPRESSE_FINANCIALS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_SUPPRESSE_FINANCIALS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_SUPPRESSE_FINANCIALS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_TAT_ATTRIBUTE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_TAT_ATTRIBUTE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_TAT_ATTRIBUTE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_TAT_ATTRIBUTE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_TIMEZONE_NAME_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_TIMEZONE_NAME_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_TIMEZONE_NAME_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_TIMEZONE_NAME_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_TYPE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_TYPE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_TYPE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_TYPE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_UNIT_GROUP_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_UNIT_GROUP_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_UNIT_GROUP_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_UNIT_GROUP_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_UPDATED_AT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_UPDATED_AT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_UPDATED_AT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_UPDATED_AT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_WMS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_WMS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_WMS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_WMS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_ZIP_ASC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_ZIP_ASC',
  FACILITIES_BY_TIMEZONE_NAME_AVERAGE_ZIP_DESC = 'FACILITIES_BY_TIMEZONE_NAME_AVERAGE_ZIP_DESC',
  FACILITIES_BY_TIMEZONE_NAME_COUNT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_COUNT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_COUNT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_COUNT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_ADDRESS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_ADDRESS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_ADDRESS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_ADDRESS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_BONUS_LTR_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_BONUS_LTR_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_BONUS_LTR_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_BONUS_LTR_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_CITY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_CITY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_CITY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_CITY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COMMODITY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COMMODITY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COMMODITY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COMMODITY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_CONTXT_9249_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_CONTXT_9249_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_CONTXT_9249_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_CONTXT_9249_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COST_CENTER_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COST_CENTER_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COST_CENTER_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COST_CENTER_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNTRY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNTRY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNTRY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNTRY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_ADDRESS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_ADDRESS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_ADDRESS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_ADDRESS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_BONUS_LTR_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_BONUS_LTR_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_BONUS_LTR_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_BONUS_LTR_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_CITY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_CITY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_CITY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_CITY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_COMMODITY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_COMMODITY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_COMMODITY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_COMMODITY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_CONTXT_9249_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_CONTXT_9249_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_CONTXT_9249_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_CONTXT_9249_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_COST_CENTER_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_COST_CENTER_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_COST_CENTER_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_COST_CENTER_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_COUNTRY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_COUNTRY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_COUNTRY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_COUNTRY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_CREATED_AT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_CREATED_AT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_CREATED_AT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_CREATED_AT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_CUSTOMER_LOCATION_ID_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_CUSTOMER_LOCATION_ID_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_CUSTOMER_LOCATION_ID_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_CUSTOMER_LOCATION_ID_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_DATATYPE_1_TEST_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_DATATYPE_1_TEST_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_DATATYPE_1_TEST_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_DATATYPE_1_TEST_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_DATA_TYPE_2_TEST_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_DATA_TYPE_2_TEST_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_DATA_TYPE_2_TEST_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_DATA_TYPE_2_TEST_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_DATA_TYPE_3_TEST_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_DATA_TYPE_3_TEST_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_DATA_TYPE_3_TEST_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_DATA_TYPE_3_TEST_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_FACILITY_CONTACTS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_FACILITY_CONTACTS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_FACILITY_CONTACTS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_FACILITY_CONTACTS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_FLOOR_PLAN_GEOMETRY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_FLOOR_PLAN_GEOMETRY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_FLOOR_PLAN_GEOMETRY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_FLOOR_PLAN_GEOMETRY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_GEOMETRY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_GEOMETRY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_GEOMETRY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_GEOMETRY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_GO_LIVE_DATE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_GO_LIVE_DATE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_GO_LIVE_DATE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_GO_LIVE_DATE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_ID_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_ID_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_ID_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_ID_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_LATITUDE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_LATITUDE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_LATITUDE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_LATITUDE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_LINK_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_LINK_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_LINK_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_LINK_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_LONGITUDE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_LONGITUDE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_LONGITUDE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_LONGITUDE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_METRICS_ONE_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_METRICS_ONE_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_METRICS_ONE_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_METRICS_ONE_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_NAME_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_NAME_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_NAME_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_NAME_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_NOTE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_NOTE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_NOTE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_NOTE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_N_SIGHT_2_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_N_SIGHT_2_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_N_SIGHT_2_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_N_SIGHT_2_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_N_SIGHT_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_N_SIGHT_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_N_SIGHT_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_N_SIGHT_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_PRE_BONUS_EBITDA_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_PRE_BONUS_EBITDA_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_PRE_BONUS_EBITDA_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_PRE_BONUS_EBITDA_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_PRICING_NODE_ID_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_PRICING_NODE_ID_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_PRICING_NODE_ID_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_PRICING_NODE_ID_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_REAL_TIME_ENABLED_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_REAL_TIME_ENABLED_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_REAL_TIME_ENABLED_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_REAL_TIME_ENABLED_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_REFRIGERATIONVENDOR_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_REFRIGERATIONVENDOR_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_REFRIGERATIONVENDOR_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_REFRIGERATIONVENDOR_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_RETIRED_AT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_RETIRED_AT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_RETIRED_AT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_RETIRED_AT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_SLUG_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_SLUG_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_SLUG_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_SLUG_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_STATE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_STATE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_STATE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_STATE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_SUPPRESSE_FINANCIALS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_SUPPRESSE_FINANCIALS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_SUPPRESSE_FINANCIALS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_SUPPRESSE_FINANCIALS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_TAT_ATTRIBUTE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_TAT_ATTRIBUTE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_TAT_ATTRIBUTE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_TAT_ATTRIBUTE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_TIMEZONE_NAME_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_TIMEZONE_NAME_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_TIMEZONE_NAME_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_TIMEZONE_NAME_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_TYPE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_TYPE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_TYPE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_TYPE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_UNIT_GROUP_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_UNIT_GROUP_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_UNIT_GROUP_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_UNIT_GROUP_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_UPDATED_AT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_UPDATED_AT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_UPDATED_AT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_UPDATED_AT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_WMS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_WMS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_WMS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_WMS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_ZIP_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_ZIP_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_ZIP_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_COUNT_ZIP_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_CREATED_AT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_CREATED_AT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_CREATED_AT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_CREATED_AT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_CUSTOMER_LOCATION_ID_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_CUSTOMER_LOCATION_ID_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_CUSTOMER_LOCATION_ID_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_CUSTOMER_LOCATION_ID_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_DATATYPE_1_TEST_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_DATATYPE_1_TEST_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_DATATYPE_1_TEST_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_DATATYPE_1_TEST_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_DATA_TYPE_2_TEST_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_DATA_TYPE_2_TEST_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_DATA_TYPE_2_TEST_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_DATA_TYPE_2_TEST_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_DATA_TYPE_3_TEST_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_DATA_TYPE_3_TEST_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_DATA_TYPE_3_TEST_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_DATA_TYPE_3_TEST_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_FACILITY_CONTACTS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_FACILITY_CONTACTS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_FACILITY_CONTACTS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_FACILITY_CONTACTS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_FLOOR_PLAN_GEOMETRY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_FLOOR_PLAN_GEOMETRY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_FLOOR_PLAN_GEOMETRY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_FLOOR_PLAN_GEOMETRY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_GEOMETRY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_GEOMETRY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_GEOMETRY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_GEOMETRY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_GO_LIVE_DATE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_GO_LIVE_DATE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_GO_LIVE_DATE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_GO_LIVE_DATE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_ID_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_ID_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_ID_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_ID_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_LATITUDE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_LATITUDE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_LATITUDE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_LATITUDE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_LINK_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_LINK_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_LINK_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_LINK_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_LONGITUDE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_LONGITUDE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_LONGITUDE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_LONGITUDE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_METRICS_ONE_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_METRICS_ONE_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_METRICS_ONE_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_METRICS_ONE_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_NAME_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_NAME_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_NAME_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_NAME_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_NOTE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_NOTE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_NOTE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_NOTE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_N_SIGHT_2_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_N_SIGHT_2_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_N_SIGHT_2_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_N_SIGHT_2_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_N_SIGHT_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_N_SIGHT_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_N_SIGHT_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_N_SIGHT_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_PRE_BONUS_EBITDA_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_PRE_BONUS_EBITDA_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_PRE_BONUS_EBITDA_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_PRE_BONUS_EBITDA_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_PRICING_NODE_ID_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_PRICING_NODE_ID_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_PRICING_NODE_ID_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_PRICING_NODE_ID_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_REAL_TIME_ENABLED_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_REAL_TIME_ENABLED_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_REAL_TIME_ENABLED_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_REAL_TIME_ENABLED_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_REFRIGERATIONVENDOR_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_REFRIGERATIONVENDOR_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_REFRIGERATIONVENDOR_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_REFRIGERATIONVENDOR_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_RETIRED_AT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_RETIRED_AT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_RETIRED_AT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_RETIRED_AT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_SLUG_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_SLUG_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_SLUG_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_SLUG_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_STATE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_STATE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_STATE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_STATE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_SUPPRESSE_FINANCIALS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_SUPPRESSE_FINANCIALS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_SUPPRESSE_FINANCIALS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_SUPPRESSE_FINANCIALS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_TAT_ATTRIBUTE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_TAT_ATTRIBUTE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_TAT_ATTRIBUTE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_TAT_ATTRIBUTE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_TIMEZONE_NAME_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_TIMEZONE_NAME_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_TIMEZONE_NAME_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_TIMEZONE_NAME_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_TYPE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_TYPE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_TYPE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_TYPE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_UNIT_GROUP_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_UNIT_GROUP_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_UNIT_GROUP_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_UNIT_GROUP_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_UPDATED_AT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_UPDATED_AT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_UPDATED_AT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_UPDATED_AT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_WMS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_WMS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_WMS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_WMS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_ZIP_ASC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_ZIP_ASC',
  FACILITIES_BY_TIMEZONE_NAME_DISTINCT_ZIP_DESC = 'FACILITIES_BY_TIMEZONE_NAME_DISTINCT_ZIP_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_ADDRESS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_ADDRESS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_ADDRESS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_ADDRESS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_BONUS_LTR_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_BONUS_LTR_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_BONUS_LTR_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_BONUS_LTR_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_CITY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_CITY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_CITY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_CITY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_COMMODITY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_COMMODITY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_COMMODITY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_COMMODITY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_CONTXT_9249_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_CONTXT_9249_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_CONTXT_9249_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_CONTXT_9249_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_COST_CENTER_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_COST_CENTER_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_COST_CENTER_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_COST_CENTER_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_COUNTRY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_COUNTRY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_COUNTRY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_COUNTRY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_CREATED_AT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_CREATED_AT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_CREATED_AT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_CREATED_AT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_CUSTOMER_LOCATION_ID_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_CUSTOMER_LOCATION_ID_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_CUSTOMER_LOCATION_ID_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_CUSTOMER_LOCATION_ID_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_DATATYPE_1_TEST_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_DATATYPE_1_TEST_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_DATATYPE_1_TEST_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_DATATYPE_1_TEST_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_DATA_TYPE_2_TEST_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_DATA_TYPE_2_TEST_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_DATA_TYPE_2_TEST_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_DATA_TYPE_2_TEST_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_DATA_TYPE_3_TEST_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_DATA_TYPE_3_TEST_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_DATA_TYPE_3_TEST_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_DATA_TYPE_3_TEST_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_FACILITY_CONTACTS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_FACILITY_CONTACTS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_FACILITY_CONTACTS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_FACILITY_CONTACTS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_FLOOR_PLAN_GEOMETRY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_FLOOR_PLAN_GEOMETRY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_FLOOR_PLAN_GEOMETRY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_FLOOR_PLAN_GEOMETRY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_GEOMETRY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_GEOMETRY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_GEOMETRY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_GEOMETRY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_GO_LIVE_DATE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_GO_LIVE_DATE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_GO_LIVE_DATE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_GO_LIVE_DATE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_ID_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_ID_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_ID_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_ID_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_LATITUDE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_LATITUDE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_LATITUDE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_LATITUDE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_LINK_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_LINK_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_LINK_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_LINK_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_LONGITUDE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_LONGITUDE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_LONGITUDE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_LONGITUDE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_METRICS_ONE_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_METRICS_ONE_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_METRICS_ONE_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_METRICS_ONE_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_NAME_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_NAME_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_NAME_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_NAME_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_NOTE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_NOTE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_NOTE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_NOTE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_N_SIGHT_2_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_N_SIGHT_2_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_N_SIGHT_2_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_N_SIGHT_2_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_N_SIGHT_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_N_SIGHT_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_N_SIGHT_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_N_SIGHT_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_PRE_BONUS_EBITDA_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_PRE_BONUS_EBITDA_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_PRE_BONUS_EBITDA_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_PRE_BONUS_EBITDA_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_PRICING_NODE_ID_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_PRICING_NODE_ID_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_PRICING_NODE_ID_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_PRICING_NODE_ID_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_REAL_TIME_ENABLED_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_REAL_TIME_ENABLED_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_REAL_TIME_ENABLED_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_REAL_TIME_ENABLED_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_REFRIGERATIONVENDOR_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_REFRIGERATIONVENDOR_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_REFRIGERATIONVENDOR_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_REFRIGERATIONVENDOR_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_RETIRED_AT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_RETIRED_AT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_RETIRED_AT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_RETIRED_AT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_SLUG_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_SLUG_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_SLUG_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_SLUG_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_STATE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_STATE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_STATE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_STATE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_SUPPRESSE_FINANCIALS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_SUPPRESSE_FINANCIALS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_SUPPRESSE_FINANCIALS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_SUPPRESSE_FINANCIALS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_TAT_ATTRIBUTE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_TAT_ATTRIBUTE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_TAT_ATTRIBUTE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_TAT_ATTRIBUTE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_TIMEZONE_NAME_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_TIMEZONE_NAME_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_TIMEZONE_NAME_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_TIMEZONE_NAME_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_TYPE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_TYPE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_TYPE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_TYPE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_UNIT_GROUP_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_UNIT_GROUP_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_UNIT_GROUP_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_UNIT_GROUP_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_UPDATED_AT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_UPDATED_AT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_UPDATED_AT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_UPDATED_AT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_WMS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_WMS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_WMS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_WMS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_ZIP_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_ZIP_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MAX_ZIP_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MAX_ZIP_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_ADDRESS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_ADDRESS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_ADDRESS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_ADDRESS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_BONUS_LTR_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_BONUS_LTR_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_BONUS_LTR_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_BONUS_LTR_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_CITY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_CITY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_CITY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_CITY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_COMMODITY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_COMMODITY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_COMMODITY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_COMMODITY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_CONTXT_9249_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_CONTXT_9249_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_CONTXT_9249_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_CONTXT_9249_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_COST_CENTER_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_COST_CENTER_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_COST_CENTER_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_COST_CENTER_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_COUNTRY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_COUNTRY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_COUNTRY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_COUNTRY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_CREATED_AT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_CREATED_AT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_CREATED_AT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_CREATED_AT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_CUSTOMER_LOCATION_ID_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_CUSTOMER_LOCATION_ID_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_CUSTOMER_LOCATION_ID_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_CUSTOMER_LOCATION_ID_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_DATATYPE_1_TEST_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_DATATYPE_1_TEST_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_DATATYPE_1_TEST_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_DATATYPE_1_TEST_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_DATA_TYPE_2_TEST_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_DATA_TYPE_2_TEST_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_DATA_TYPE_2_TEST_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_DATA_TYPE_2_TEST_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_DATA_TYPE_3_TEST_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_DATA_TYPE_3_TEST_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_DATA_TYPE_3_TEST_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_DATA_TYPE_3_TEST_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_FACILITY_CONTACTS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_FACILITY_CONTACTS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_FACILITY_CONTACTS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_FACILITY_CONTACTS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_FLOOR_PLAN_GEOMETRY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_FLOOR_PLAN_GEOMETRY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_FLOOR_PLAN_GEOMETRY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_FLOOR_PLAN_GEOMETRY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_GEOMETRY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_GEOMETRY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_GEOMETRY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_GEOMETRY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_GO_LIVE_DATE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_GO_LIVE_DATE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_GO_LIVE_DATE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_GO_LIVE_DATE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_ID_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_ID_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_ID_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_ID_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_LATITUDE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_LATITUDE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_LATITUDE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_LATITUDE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_LINK_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_LINK_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_LINK_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_LINK_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_LONGITUDE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_LONGITUDE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_LONGITUDE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_LONGITUDE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_METRICS_ONE_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_METRICS_ONE_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_METRICS_ONE_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_METRICS_ONE_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_NAME_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_NAME_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_NAME_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_NAME_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_NOTE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_NOTE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_NOTE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_NOTE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_N_SIGHT_2_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_N_SIGHT_2_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_N_SIGHT_2_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_N_SIGHT_2_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_N_SIGHT_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_N_SIGHT_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_N_SIGHT_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_N_SIGHT_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_PRE_BONUS_EBITDA_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_PRE_BONUS_EBITDA_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_PRE_BONUS_EBITDA_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_PRE_BONUS_EBITDA_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_PRICING_NODE_ID_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_PRICING_NODE_ID_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_PRICING_NODE_ID_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_PRICING_NODE_ID_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_REAL_TIME_ENABLED_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_REAL_TIME_ENABLED_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_REAL_TIME_ENABLED_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_REAL_TIME_ENABLED_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_REFRIGERATIONVENDOR_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_REFRIGERATIONVENDOR_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_REFRIGERATIONVENDOR_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_REFRIGERATIONVENDOR_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_RETIRED_AT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_RETIRED_AT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_RETIRED_AT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_RETIRED_AT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_SLUG_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_SLUG_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_SLUG_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_SLUG_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_STATE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_STATE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_STATE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_STATE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_SUPPRESSE_FINANCIALS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_SUPPRESSE_FINANCIALS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_SUPPRESSE_FINANCIALS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_SUPPRESSE_FINANCIALS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_TAT_ATTRIBUTE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_TAT_ATTRIBUTE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_TAT_ATTRIBUTE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_TAT_ATTRIBUTE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_TIMEZONE_NAME_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_TIMEZONE_NAME_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_TIMEZONE_NAME_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_TIMEZONE_NAME_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_TYPE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_TYPE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_TYPE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_TYPE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_UNIT_GROUP_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_UNIT_GROUP_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_UNIT_GROUP_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_UNIT_GROUP_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_UPDATED_AT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_UPDATED_AT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_UPDATED_AT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_UPDATED_AT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_WMS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_WMS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_WMS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_WMS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_ZIP_ASC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_ZIP_ASC',
  FACILITIES_BY_TIMEZONE_NAME_MIN_ZIP_DESC = 'FACILITIES_BY_TIMEZONE_NAME_MIN_ZIP_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_ADDRESS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_ADDRESS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_ADDRESS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_ADDRESS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_BONUS_LTR_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_BONUS_LTR_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_BONUS_LTR_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_BONUS_LTR_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_CITY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_CITY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_CITY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_CITY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_COMMODITY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_COMMODITY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_COMMODITY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_COMMODITY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_CONTXT_9249_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_CONTXT_9249_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_CONTXT_9249_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_CONTXT_9249_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_COST_CENTER_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_COST_CENTER_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_COST_CENTER_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_COST_CENTER_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_COUNTRY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_COUNTRY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_COUNTRY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_COUNTRY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_CREATED_AT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_CREATED_AT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_CREATED_AT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_CREATED_AT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_CUSTOMER_LOCATION_ID_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_CUSTOMER_LOCATION_ID_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_CUSTOMER_LOCATION_ID_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_CUSTOMER_LOCATION_ID_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_DATATYPE_1_TEST_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_DATATYPE_1_TEST_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_DATATYPE_1_TEST_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_DATATYPE_1_TEST_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_DATA_TYPE_2_TEST_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_DATA_TYPE_2_TEST_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_DATA_TYPE_2_TEST_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_DATA_TYPE_2_TEST_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_DATA_TYPE_3_TEST_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_DATA_TYPE_3_TEST_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_DATA_TYPE_3_TEST_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_DATA_TYPE_3_TEST_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_FACILITY_CONTACTS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_FACILITY_CONTACTS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_FACILITY_CONTACTS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_FACILITY_CONTACTS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_FLOOR_PLAN_GEOMETRY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_FLOOR_PLAN_GEOMETRY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_FLOOR_PLAN_GEOMETRY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_FLOOR_PLAN_GEOMETRY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_GEOMETRY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_GEOMETRY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_GEOMETRY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_GEOMETRY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_GO_LIVE_DATE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_GO_LIVE_DATE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_GO_LIVE_DATE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_GO_LIVE_DATE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_ID_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_ID_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_ID_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_ID_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_LATITUDE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_LATITUDE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_LATITUDE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_LATITUDE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_LINK_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_LINK_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_LINK_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_LINK_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_LONGITUDE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_LONGITUDE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_LONGITUDE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_LONGITUDE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_METRICS_ONE_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_METRICS_ONE_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_METRICS_ONE_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_METRICS_ONE_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_NAME_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_NAME_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_NAME_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_NAME_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_NOTE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_NOTE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_NOTE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_NOTE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_N_SIGHT_2_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_N_SIGHT_2_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_N_SIGHT_2_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_N_SIGHT_2_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_N_SIGHT_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_N_SIGHT_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_N_SIGHT_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_N_SIGHT_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_PRE_BONUS_EBITDA_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_PRE_BONUS_EBITDA_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_PRE_BONUS_EBITDA_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_PRE_BONUS_EBITDA_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_PRICING_NODE_ID_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_PRICING_NODE_ID_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_PRICING_NODE_ID_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_PRICING_NODE_ID_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_REAL_TIME_ENABLED_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_REAL_TIME_ENABLED_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_REAL_TIME_ENABLED_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_REAL_TIME_ENABLED_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_REFRIGERATIONVENDOR_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_REFRIGERATIONVENDOR_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_REFRIGERATIONVENDOR_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_REFRIGERATIONVENDOR_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_RETIRED_AT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_RETIRED_AT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_RETIRED_AT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_RETIRED_AT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_SLUG_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_SLUG_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_SLUG_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_SLUG_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_STATE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_STATE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_STATE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_STATE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_SUPPRESSE_FINANCIALS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_SUPPRESSE_FINANCIALS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_SUPPRESSE_FINANCIALS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_SUPPRESSE_FINANCIALS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_TAT_ATTRIBUTE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_TAT_ATTRIBUTE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_TAT_ATTRIBUTE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_TAT_ATTRIBUTE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_TIMEZONE_NAME_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_TIMEZONE_NAME_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_TIMEZONE_NAME_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_TIMEZONE_NAME_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_TYPE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_TYPE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_TYPE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_TYPE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_UNIT_GROUP_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_UNIT_GROUP_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_UNIT_GROUP_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_UNIT_GROUP_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_UPDATED_AT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_UPDATED_AT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_UPDATED_AT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_UPDATED_AT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_WMS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_WMS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_WMS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_WMS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_ZIP_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_ZIP_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_ZIP_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_POPULATION_ZIP_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_ADDRESS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_ADDRESS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_ADDRESS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_ADDRESS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_BONUS_LTR_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_BONUS_LTR_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_BONUS_LTR_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_BONUS_LTR_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_CITY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_CITY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_CITY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_CITY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_COMMODITY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_COMMODITY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_COMMODITY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_COMMODITY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_CONTXT_9249_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_CONTXT_9249_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_CONTXT_9249_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_CONTXT_9249_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_COST_CENTER_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_COST_CENTER_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_COST_CENTER_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_COST_CENTER_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_COUNTRY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_COUNTRY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_COUNTRY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_COUNTRY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_CREATED_AT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_CREATED_AT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_CREATED_AT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_CREATED_AT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_CUSTOMER_LOCATION_ID_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_CUSTOMER_LOCATION_ID_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_CUSTOMER_LOCATION_ID_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_CUSTOMER_LOCATION_ID_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_DATATYPE_1_TEST_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_DATATYPE_1_TEST_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_DATATYPE_1_TEST_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_DATATYPE_1_TEST_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_DATA_TYPE_2_TEST_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_DATA_TYPE_2_TEST_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_DATA_TYPE_2_TEST_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_DATA_TYPE_2_TEST_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_DATA_TYPE_3_TEST_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_DATA_TYPE_3_TEST_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_DATA_TYPE_3_TEST_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_DATA_TYPE_3_TEST_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_FACILITY_CONTACTS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_FACILITY_CONTACTS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_FACILITY_CONTACTS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_FACILITY_CONTACTS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_FLOOR_PLAN_GEOMETRY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_FLOOR_PLAN_GEOMETRY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_FLOOR_PLAN_GEOMETRY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_FLOOR_PLAN_GEOMETRY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_GEOMETRY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_GEOMETRY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_GEOMETRY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_GEOMETRY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_GO_LIVE_DATE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_GO_LIVE_DATE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_GO_LIVE_DATE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_GO_LIVE_DATE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_ID_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_ID_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_ID_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_ID_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_LATITUDE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_LATITUDE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_LATITUDE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_LATITUDE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_LINK_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_LINK_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_LINK_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_LINK_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_LONGITUDE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_LONGITUDE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_LONGITUDE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_LONGITUDE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_METRICS_ONE_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_METRICS_ONE_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_METRICS_ONE_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_METRICS_ONE_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_NAME_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_NAME_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_NAME_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_NAME_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_NOTE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_NOTE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_NOTE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_NOTE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_N_SIGHT_2_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_N_SIGHT_2_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_N_SIGHT_2_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_N_SIGHT_2_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_N_SIGHT_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_N_SIGHT_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_N_SIGHT_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_N_SIGHT_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_PRE_BONUS_EBITDA_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_PRE_BONUS_EBITDA_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_PRE_BONUS_EBITDA_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_PRE_BONUS_EBITDA_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_PRICING_NODE_ID_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_PRICING_NODE_ID_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_PRICING_NODE_ID_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_PRICING_NODE_ID_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_REAL_TIME_ENABLED_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_REAL_TIME_ENABLED_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_REAL_TIME_ENABLED_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_REAL_TIME_ENABLED_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_REFRIGERATIONVENDOR_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_REFRIGERATIONVENDOR_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_REFRIGERATIONVENDOR_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_REFRIGERATIONVENDOR_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_RETIRED_AT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_RETIRED_AT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_RETIRED_AT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_RETIRED_AT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_SLUG_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_SLUG_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_SLUG_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_SLUG_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_STATE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_STATE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_STATE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_STATE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_SUPPRESSE_FINANCIALS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_SUPPRESSE_FINANCIALS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_SUPPRESSE_FINANCIALS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_SUPPRESSE_FINANCIALS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_TAT_ATTRIBUTE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_TAT_ATTRIBUTE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_TAT_ATTRIBUTE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_TAT_ATTRIBUTE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_TIMEZONE_NAME_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_TIMEZONE_NAME_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_TIMEZONE_NAME_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_TIMEZONE_NAME_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_TYPE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_TYPE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_TYPE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_TYPE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_UNIT_GROUP_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_UNIT_GROUP_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_UNIT_GROUP_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_UNIT_GROUP_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_UPDATED_AT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_UPDATED_AT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_UPDATED_AT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_UPDATED_AT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_WMS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_WMS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_WMS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_WMS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_ZIP_ASC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_ZIP_ASC',
  FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_ZIP_DESC = 'FACILITIES_BY_TIMEZONE_NAME_STDDEV_SAMPLE_ZIP_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_ADDRESS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_ADDRESS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_ADDRESS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_ADDRESS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_BONUS_LTR_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_BONUS_LTR_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_BONUS_LTR_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_BONUS_LTR_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_CITY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_CITY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_CITY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_CITY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_COMMODITY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_COMMODITY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_COMMODITY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_COMMODITY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_CONTXT_9249_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_CONTXT_9249_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_CONTXT_9249_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_CONTXT_9249_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_COST_CENTER_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_COST_CENTER_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_COST_CENTER_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_COST_CENTER_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_COUNTRY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_COUNTRY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_COUNTRY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_COUNTRY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_CREATED_AT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_CREATED_AT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_CREATED_AT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_CREATED_AT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_CUSTOMER_LOCATION_ID_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_CUSTOMER_LOCATION_ID_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_CUSTOMER_LOCATION_ID_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_CUSTOMER_LOCATION_ID_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_DATATYPE_1_TEST_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_DATATYPE_1_TEST_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_DATATYPE_1_TEST_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_DATATYPE_1_TEST_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_DATA_TYPE_2_TEST_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_DATA_TYPE_2_TEST_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_DATA_TYPE_2_TEST_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_DATA_TYPE_2_TEST_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_DATA_TYPE_3_TEST_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_DATA_TYPE_3_TEST_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_DATA_TYPE_3_TEST_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_DATA_TYPE_3_TEST_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_FACILITY_CONTACTS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_FACILITY_CONTACTS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_FACILITY_CONTACTS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_FACILITY_CONTACTS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_FLOOR_PLAN_GEOMETRY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_FLOOR_PLAN_GEOMETRY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_FLOOR_PLAN_GEOMETRY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_FLOOR_PLAN_GEOMETRY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_GEOMETRY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_GEOMETRY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_GEOMETRY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_GEOMETRY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_GO_LIVE_DATE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_GO_LIVE_DATE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_GO_LIVE_DATE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_GO_LIVE_DATE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_ID_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_ID_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_ID_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_ID_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_LATITUDE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_LATITUDE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_LATITUDE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_LATITUDE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_LINK_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_LINK_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_LINK_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_LINK_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_LONGITUDE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_LONGITUDE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_LONGITUDE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_LONGITUDE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_METRICS_ONE_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_METRICS_ONE_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_METRICS_ONE_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_METRICS_ONE_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_NAME_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_NAME_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_NAME_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_NAME_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_NOTE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_NOTE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_NOTE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_NOTE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_N_SIGHT_2_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_N_SIGHT_2_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_N_SIGHT_2_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_N_SIGHT_2_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_N_SIGHT_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_N_SIGHT_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_N_SIGHT_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_N_SIGHT_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_PRE_BONUS_EBITDA_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_PRE_BONUS_EBITDA_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_PRE_BONUS_EBITDA_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_PRE_BONUS_EBITDA_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_PRICING_NODE_ID_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_PRICING_NODE_ID_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_PRICING_NODE_ID_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_PRICING_NODE_ID_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_REAL_TIME_ENABLED_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_REAL_TIME_ENABLED_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_REAL_TIME_ENABLED_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_REAL_TIME_ENABLED_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_REFRIGERATIONVENDOR_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_REFRIGERATIONVENDOR_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_REFRIGERATIONVENDOR_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_REFRIGERATIONVENDOR_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_RETIRED_AT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_RETIRED_AT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_RETIRED_AT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_RETIRED_AT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_SLUG_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_SLUG_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_SLUG_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_SLUG_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_STATE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_STATE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_STATE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_STATE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_SUPPRESSE_FINANCIALS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_SUPPRESSE_FINANCIALS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_SUPPRESSE_FINANCIALS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_SUPPRESSE_FINANCIALS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_TAT_ATTRIBUTE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_TAT_ATTRIBUTE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_TAT_ATTRIBUTE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_TAT_ATTRIBUTE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_TIMEZONE_NAME_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_TIMEZONE_NAME_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_TIMEZONE_NAME_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_TIMEZONE_NAME_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_TYPE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_TYPE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_TYPE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_TYPE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_UNIT_GROUP_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_UNIT_GROUP_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_UNIT_GROUP_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_UNIT_GROUP_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_UPDATED_AT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_UPDATED_AT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_UPDATED_AT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_UPDATED_AT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_WMS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_WMS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_WMS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_WMS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_ZIP_ASC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_ZIP_ASC',
  FACILITIES_BY_TIMEZONE_NAME_SUM_ZIP_DESC = 'FACILITIES_BY_TIMEZONE_NAME_SUM_ZIP_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_ADDRESS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_ADDRESS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_ADDRESS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_ADDRESS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_BONUS_LTR_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_BONUS_LTR_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_BONUS_LTR_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_BONUS_LTR_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_CITY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_CITY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_CITY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_CITY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_COMMODITY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_COMMODITY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_COMMODITY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_COMMODITY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_CONTXT_9249_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_CONTXT_9249_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_CONTXT_9249_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_CONTXT_9249_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_COST_CENTER_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_COST_CENTER_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_COST_CENTER_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_COST_CENTER_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_COUNTRY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_COUNTRY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_COUNTRY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_COUNTRY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_CREATED_AT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_CREATED_AT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_CREATED_AT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_CREATED_AT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_CUSTOMER_LOCATION_ID_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_CUSTOMER_LOCATION_ID_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_CUSTOMER_LOCATION_ID_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_CUSTOMER_LOCATION_ID_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_DATATYPE_1_TEST_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_DATATYPE_1_TEST_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_DATATYPE_1_TEST_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_DATATYPE_1_TEST_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_DATA_TYPE_2_TEST_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_DATA_TYPE_2_TEST_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_DATA_TYPE_2_TEST_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_DATA_TYPE_2_TEST_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_DATA_TYPE_3_TEST_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_DATA_TYPE_3_TEST_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_DATA_TYPE_3_TEST_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_DATA_TYPE_3_TEST_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_FACILITY_CONTACTS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_FACILITY_CONTACTS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_FACILITY_CONTACTS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_FACILITY_CONTACTS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_FLOOR_PLAN_GEOMETRY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_FLOOR_PLAN_GEOMETRY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_FLOOR_PLAN_GEOMETRY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_FLOOR_PLAN_GEOMETRY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_GEOMETRY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_GEOMETRY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_GEOMETRY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_GEOMETRY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_GO_LIVE_DATE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_GO_LIVE_DATE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_GO_LIVE_DATE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_GO_LIVE_DATE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_ID_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_ID_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_ID_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_ID_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_LATITUDE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_LATITUDE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_LATITUDE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_LATITUDE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_LINK_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_LINK_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_LINK_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_LINK_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_LONGITUDE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_LONGITUDE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_LONGITUDE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_LONGITUDE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_METRICS_ONE_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_METRICS_ONE_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_METRICS_ONE_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_METRICS_ONE_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_NAME_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_NAME_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_NAME_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_NAME_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_NOTE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_NOTE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_NOTE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_NOTE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_N_SIGHT_2_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_N_SIGHT_2_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_N_SIGHT_2_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_N_SIGHT_2_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_N_SIGHT_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_N_SIGHT_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_N_SIGHT_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_N_SIGHT_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_PRE_BONUS_EBITDA_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_PRE_BONUS_EBITDA_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_PRE_BONUS_EBITDA_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_PRE_BONUS_EBITDA_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_PRICING_NODE_ID_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_PRICING_NODE_ID_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_PRICING_NODE_ID_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_PRICING_NODE_ID_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_REAL_TIME_ENABLED_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_REAL_TIME_ENABLED_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_REAL_TIME_ENABLED_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_REAL_TIME_ENABLED_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_REFRIGERATIONVENDOR_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_REFRIGERATIONVENDOR_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_REFRIGERATIONVENDOR_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_REFRIGERATIONVENDOR_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_RETIRED_AT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_RETIRED_AT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_RETIRED_AT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_RETIRED_AT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_SLUG_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_SLUG_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_SLUG_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_SLUG_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_STATE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_STATE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_STATE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_STATE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_SUPPRESSE_FINANCIALS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_SUPPRESSE_FINANCIALS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_SUPPRESSE_FINANCIALS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_SUPPRESSE_FINANCIALS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_TAT_ATTRIBUTE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_TAT_ATTRIBUTE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_TAT_ATTRIBUTE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_TAT_ATTRIBUTE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_TIMEZONE_NAME_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_TIMEZONE_NAME_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_TIMEZONE_NAME_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_TIMEZONE_NAME_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_TYPE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_TYPE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_TYPE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_TYPE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_UNIT_GROUP_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_UNIT_GROUP_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_UNIT_GROUP_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_UNIT_GROUP_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_UPDATED_AT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_UPDATED_AT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_UPDATED_AT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_UPDATED_AT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_WMS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_WMS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_WMS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_WMS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_ZIP_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_ZIP_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_ZIP_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_POPULATION_ZIP_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_ADDRESS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_ADDRESS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_ADDRESS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_ADDRESS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_BONUS_LTR_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_BONUS_LTR_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_BONUS_LTR_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_BONUS_LTR_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_CITY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_CITY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_CITY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_CITY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_COMMODITY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_COMMODITY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_COMMODITY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_COMMODITY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_CONTXT_9249_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_CONTXT_9249_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_CONTXT_9249_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_CONTXT_9249_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_COST_CENTER_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_COST_CENTER_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_COST_CENTER_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_COST_CENTER_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_COUNTRY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_COUNTRY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_COUNTRY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_COUNTRY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_CREATED_AT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_CREATED_AT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_CREATED_AT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_CREATED_AT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_CUSTOMER_LOCATION_ID_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_CUSTOMER_LOCATION_ID_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_CUSTOMER_LOCATION_ID_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_CUSTOMER_LOCATION_ID_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_DATATYPE_1_TEST_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_DATATYPE_1_TEST_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_DATATYPE_1_TEST_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_DATATYPE_1_TEST_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_DATA_TYPE_2_TEST_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_DATA_TYPE_2_TEST_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_DATA_TYPE_2_TEST_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_DATA_TYPE_2_TEST_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_DATA_TYPE_3_TEST_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_DATA_TYPE_3_TEST_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_DATA_TYPE_3_TEST_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_DATA_TYPE_3_TEST_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_FACILITY_CONTACTS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_FACILITY_CONTACTS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_FACILITY_CONTACTS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_FACILITY_CONTACTS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_FLOOR_PLAN_GEOMETRY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_FLOOR_PLAN_GEOMETRY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_FLOOR_PLAN_GEOMETRY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_FLOOR_PLAN_GEOMETRY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_GEOMETRY_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_GEOMETRY_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_GEOMETRY_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_GEOMETRY_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_GO_LIVE_DATE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_GO_LIVE_DATE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_GO_LIVE_DATE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_GO_LIVE_DATE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_ID_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_ID_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_ID_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_ID_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_LATITUDE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_LATITUDE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_LATITUDE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_LATITUDE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_LINK_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_LINK_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_LINK_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_LINK_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_LONGITUDE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_LONGITUDE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_LONGITUDE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_LONGITUDE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_METRICS_ONE_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_METRICS_ONE_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_METRICS_ONE_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_METRICS_ONE_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_NAME_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_NAME_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_NAME_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_NAME_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_NOTE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_NOTE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_NOTE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_NOTE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_N_SIGHT_2_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_N_SIGHT_2_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_N_SIGHT_2_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_N_SIGHT_2_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_N_SIGHT_ACTIVE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_N_SIGHT_ACTIVE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_N_SIGHT_ACTIVE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_N_SIGHT_ACTIVE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_PRE_BONUS_EBITDA_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_PRE_BONUS_EBITDA_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_PRE_BONUS_EBITDA_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_PRE_BONUS_EBITDA_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_PRICING_NODE_ID_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_PRICING_NODE_ID_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_PRICING_NODE_ID_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_PRICING_NODE_ID_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_REAL_TIME_ENABLED_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_REAL_TIME_ENABLED_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_REAL_TIME_ENABLED_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_REAL_TIME_ENABLED_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_REFRIGERATIONVENDOR_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_REFRIGERATIONVENDOR_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_REFRIGERATIONVENDOR_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_REFRIGERATIONVENDOR_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_RETIRED_AT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_RETIRED_AT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_RETIRED_AT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_RETIRED_AT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_SLUG_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_SLUG_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_SLUG_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_SLUG_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_STATE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_STATE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_STATE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_STATE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_SUPPRESSE_FINANCIALS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_SUPPRESSE_FINANCIALS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_SUPPRESSE_FINANCIALS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_SUPPRESSE_FINANCIALS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_TAT_ATTRIBUTE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_TAT_ATTRIBUTE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_TAT_ATTRIBUTE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_TAT_ATTRIBUTE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_TIMEZONE_NAME_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_TIMEZONE_NAME_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_TIMEZONE_NAME_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_TIMEZONE_NAME_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_TYPE_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_TYPE_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_TYPE_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_TYPE_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_UNIT_GROUP_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_UNIT_GROUP_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_UNIT_GROUP_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_UNIT_GROUP_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_UPDATED_AT_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_UPDATED_AT_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_UPDATED_AT_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_UPDATED_AT_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_WMS_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_WMS_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_WMS_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_WMS_DESC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_ZIP_ASC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_ZIP_ASC',
  FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_ZIP_DESC = 'FACILITIES_BY_TIMEZONE_NAME_VARIANCE_SAMPLE_ZIP_DESC',
  IS_DST_ASC = 'IS_DST_ASC',
  IS_DST_DESC = 'IS_DST_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UTC_OFFSET_ASC = 'UTC_OFFSET_ASC',
  UTC_OFFSET_DESC = 'UTC_OFFSET_DESC'
}

/** A trailer that can occupy a yard space */
export type Trailer = Node & {
  __typename?: 'Trailer';
  /** The carrier code for the trailer */
  carrierCode: Scalars['String']['output'];
  /** The carrier-specific trailer number */
  carrierTrailerNumber: Scalars['String']['output'];
  /** The time when this record was created */
  createdAt: Scalars['Datetime']['output'];
  /** The currently active park session for this trailer */
  currentParkSession?: Maybe<ParkSession>;
  /** The currently active trailer appointment for this trailer */
  currentTrailerAppointment?: Maybe<TrailerAppointment>;
  /** The DOT-issued alphanumeric code identifying the trailer */
  dotNumber?: Maybe<Scalars['String']['output']>;
  /** The internal ID of this trailer */
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `ParkSession`. */
  parkSessions: ParkSessionsConnection;
  /** The type of power used in the trailer refrigeration unit */
  powerSource?: Maybe<TrailerPowerSource>;
  /** Indicates if the trailer supports eTRU */
  supportEtru: Scalars['Boolean']['output'];
  /** Reads and enables pagination through a set of `TrailerAppointment`. */
  trailerAppointments: TrailerAppointmentsConnection;
  /** Reads and enables pagination through a set of `TrailerAudit`. */
  trailerAudits: TrailerAuditsConnection;
  /** The manufacturer of the trailer refrigeration unit */
  truMake?: Maybe<Scalars['String']['output']>;
  /** The model of the trailer refrigeration unit */
  truModel?: Maybe<Scalars['String']['output']>;
  /** The time when this record was last updated */
  updatedAt: Scalars['Datetime']['output'];
};

/** A trailer that can occupy a yard space */
export type TrailerParkSessionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ParkSessionCondition>;
  filter?: InputMaybe<ParkSessionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ParkSessionsOrderBy>>;
};

/** A trailer that can occupy a yard space */
export type TrailerTrailerAppointmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TrailerAppointmentCondition>;
  filter?: InputMaybe<TrailerAppointmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TrailerAppointmentsOrderBy>>;
};

/** A trailer that can occupy a yard space */
export type TrailerTrailerAuditsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TrailerAuditCondition>;
  filter?: InputMaybe<TrailerAuditFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TrailerAuditsOrderBy>>;
};

/** A link between appointments, drivers and trailers */
export type TrailerAppointment = Node & {
  __typename?: 'TrailerAppointment';
  /** Reads a single `Appointment` that is related to this `TrailerAppointment`. */
  appointment?: Maybe<Appointment>;
  appointmentId: Scalars['Int']['output'];
  /** The time when the trailer was checked in */
  checkinTime?: Maybe<Scalars['Datetime']['output']>;
  /** The time when the trailer was checkd out. If not set, the appointment is still active */
  checkoutTime?: Maybe<Scalars['Datetime']['output']>;
  /** The time when this record was created */
  createdAt: Scalars['Datetime']['output'];
  /** Reads a single `Driver` that is related to this `TrailerAppointment`. */
  driver?: Maybe<Driver>;
  /** The driver of the trailer for the appointment */
  driverId?: Maybe<Scalars['Int']['output']>;
  /** The internal ID of this trailer appointment */
  id: Scalars['Int']['output'];
  /** Indicates if the trailer is currently wait-listed */
  isWaitlisted?: Maybe<Scalars['Boolean']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The time when the trailer became ready to move to a space or dock */
  readyAt?: Maybe<Scalars['Datetime']['output']>;
  /** Reads a single `Trailer` that is related to this `TrailerAppointment`. */
  trailer?: Maybe<Trailer>;
  /** The trailer for the appointment */
  trailerId: Scalars['Int']['output'];
  /** The time when this record was last updated */
  updatedAt: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `TrailerAppointment` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type TrailerAppointmentCondition = {
  /** Checks for equality with the object’s `appointmentId` field. */
  appointmentId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `checkinTime` field. */
  checkinTime?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `checkoutTime` field. */
  checkoutTime?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `driverId` field. */
  driverId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `readyAt` field. */
  readyAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `trailerId` field. */
  trailerId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `TrailerAppointment` object types. All fields are combined with a logical ‘and.’ */
export type TrailerAppointmentFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TrailerAppointmentFilter>>;
  /** Filter by the object’s `appointmentId` field. */
  appointmentId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `checkinTime` field. */
  checkinTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `checkoutTime` field. */
  checkoutTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `driverId` field. */
  driverId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isWaitlisted` field. */
  isWaitlisted?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TrailerAppointmentFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TrailerAppointmentFilter>>;
  /** Filter by the object’s `readyAt` field. */
  readyAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `trailerId` field. */
  trailerId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** A connection to a list of `TrailerAppointment` values. */
export type TrailerAppointmentsConnection = {
  __typename?: 'TrailerAppointmentsConnection';
  /** A list of edges which contains the `TrailerAppointment` and cursor to aid in pagination. */
  edges: Array<TrailerAppointmentsEdge>;
  /** A list of `TrailerAppointment` objects. */
  nodes: Array<TrailerAppointment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TrailerAppointment` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `TrailerAppointment` edge in the connection. */
export type TrailerAppointmentsEdge = {
  __typename?: 'TrailerAppointmentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `TrailerAppointment` at the end of the edge. */
  node: TrailerAppointment;
};

/** Methods to use when ordering `TrailerAppointment`. */
export enum TrailerAppointmentsOrderBy {
  APPOINTMENT_ID_ASC = 'APPOINTMENT_ID_ASC',
  APPOINTMENT_ID_DESC = 'APPOINTMENT_ID_DESC',
  CHECKIN_TIME_ASC = 'CHECKIN_TIME_ASC',
  CHECKIN_TIME_DESC = 'CHECKIN_TIME_DESC',
  CHECKOUT_TIME_ASC = 'CHECKOUT_TIME_ASC',
  CHECKOUT_TIME_DESC = 'CHECKOUT_TIME_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DRIVER_ID_ASC = 'DRIVER_ID_ASC',
  DRIVER_ID_DESC = 'DRIVER_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  READY_AT_ASC = 'READY_AT_ASC',
  READY_AT_DESC = 'READY_AT_DESC',
  TRAILER_ID_ASC = 'TRAILER_ID_ASC',
  TRAILER_ID_DESC = 'TRAILER_ID_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** The log of audits for a given trailer */
export type TrailerAudit = Node & {
  __typename?: 'TrailerAudit';
  /** The person performing the audit */
  auditUser?: Maybe<Scalars['String']['output']>;
  /** The time when this record was created */
  createdAt: Scalars['Datetime']['output'];
  /** The trailer fuel level, as a percentage between 0 and 1, at the time of the audit */
  fuel: Scalars['Float']['output'];
  /** The internal ID of this trailer audit */
  id: Scalars['BigInt']['output'];
  /** The temperature, in Celsius, within the trailer at the time of the audit */
  internalTemperature: Scalars['Float']['output'];
  /** The status of the eTRU shore power connection, if applicable, at the time of the audit */
  isEtruOn: Scalars['Boolean']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The target temperature, in Celsius, that the trailer's refrigeration unit was set to maintain at the time of the audit */
  setTemperature?: Maybe<Scalars['Float']['output']>;
  /** Reads a single `Trailer` that is related to this `TrailerAudit`. */
  trailer?: Maybe<Trailer>;
  /** The trailer for which the audit was performed */
  trailerId: Scalars['Int']['output'];
  /** The time when this record was last updated */
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `TrailerAudit`. */
  userByAuditUser?: Maybe<User>;
  /** Reads a single `Yard` that is related to this `TrailerAudit`. */
  yard?: Maybe<Yard>;
  yardId?: Maybe<Scalars['Int']['output']>;
};

/**
 * A condition to be used against `TrailerAudit` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type TrailerAuditCondition = {
  /** Checks for equality with the object’s `auditUser` field. */
  auditUser?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `fuel` field. */
  fuel?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `internalTemperature` field. */
  internalTemperature?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `isEtruOn` field. */
  isEtruOn?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `setTemperature` field. */
  setTemperature?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `trailerId` field. */
  trailerId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `yardId` field. */
  yardId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `TrailerAudit` object types. All fields are combined with a logical ‘and.’ */
export type TrailerAuditFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TrailerAuditFilter>>;
  /** Filter by the object’s `auditUser` field. */
  auditUser?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `fuel` field. */
  fuel?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `internalTemperature` field. */
  internalTemperature?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `isEtruOn` field. */
  isEtruOn?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TrailerAuditFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TrailerAuditFilter>>;
  /** Filter by the object’s `setTemperature` field. */
  setTemperature?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `trailerId` field. */
  trailerId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `yardId` field. */
  yardId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `TrailerAudit` */
export type TrailerAuditInput = {
  /** The person performing the audit */
  auditUser?: InputMaybe<Scalars['String']['input']>;
  /** The trailer fuel level, as a percentage between 0 and 1, at the time of the audit */
  fuel: Scalars['Float']['input'];
  /** The temperature, in Celsius, within the trailer at the time of the audit */
  internalTemperature: Scalars['Float']['input'];
  /** The status of the eTRU shore power connection, if applicable, at the time of the audit */
  isEtruOn: Scalars['Boolean']['input'];
  /** The target temperature, in Celsius, that the trailer's refrigeration unit was set to maintain at the time of the audit */
  setTemperature?: InputMaybe<Scalars['Float']['input']>;
  /** Mutates a `Trailer` as part of the payload */
  trailer?: InputMaybe<TrailerInput>;
  /** The trailer for which the audit was performed */
  trailerId?: InputMaybe<Scalars['Int']['input']>;
  yardId?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents an update to a `TrailerAudit`. Fields that are set will be updated. */
export type TrailerAuditPatch = {
  /** The person performing the audit */
  auditUser?: InputMaybe<Scalars['String']['input']>;
  /** The trailer fuel level, as a percentage between 0 and 1, at the time of the audit */
  fuel?: InputMaybe<Scalars['Float']['input']>;
  /** The temperature, in Celsius, within the trailer at the time of the audit */
  internalTemperature?: InputMaybe<Scalars['Float']['input']>;
  /** The status of the eTRU shore power connection, if applicable, at the time of the audit */
  isEtruOn?: InputMaybe<Scalars['Boolean']['input']>;
  /** The target temperature, in Celsius, that the trailer's refrigeration unit was set to maintain at the time of the audit */
  setTemperature?: InputMaybe<Scalars['Float']['input']>;
  /** The trailer for which the audit was performed */
  trailerId?: InputMaybe<Scalars['Int']['input']>;
  yardId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `TrailerAudit` values. */
export type TrailerAuditsConnection = {
  __typename?: 'TrailerAuditsConnection';
  /** A list of edges which contains the `TrailerAudit` and cursor to aid in pagination. */
  edges: Array<TrailerAuditsEdge>;
  /** A list of `TrailerAudit` objects. */
  nodes: Array<TrailerAudit>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TrailerAudit` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `TrailerAudit` edge in the connection. */
export type TrailerAuditsEdge = {
  __typename?: 'TrailerAuditsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `TrailerAudit` at the end of the edge. */
  node: TrailerAudit;
};

/** Methods to use when ordering `TrailerAudit`. */
export enum TrailerAuditsOrderBy {
  AUDIT_USER_ASC = 'AUDIT_USER_ASC',
  AUDIT_USER_DESC = 'AUDIT_USER_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  FUEL_ASC = 'FUEL_ASC',
  FUEL_DESC = 'FUEL_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  INTERNAL_TEMPERATURE_ASC = 'INTERNAL_TEMPERATURE_ASC',
  INTERNAL_TEMPERATURE_DESC = 'INTERNAL_TEMPERATURE_DESC',
  IS_ETRU_ON_ASC = 'IS_ETRU_ON_ASC',
  IS_ETRU_ON_DESC = 'IS_ETRU_ON_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  SET_TEMPERATURE_ASC = 'SET_TEMPERATURE_ASC',
  SET_TEMPERATURE_DESC = 'SET_TEMPERATURE_DESC',
  TRAILER_ID_ASC = 'TRAILER_ID_ASC',
  TRAILER_ID_DESC = 'TRAILER_ID_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  YARD_ID_ASC = 'YARD_ID_ASC',
  YARD_ID_DESC = 'YARD_ID_DESC'
}

/** A condition to be used against `Trailer` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type TrailerCondition = {
  /** Checks for equality with the object’s `carrierCode` field. */
  carrierCode?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `carrierTrailerNumber` field. */
  carrierTrailerNumber?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `dotNumber` field. */
  dotNumber?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `powerSource` field. */
  powerSource?: InputMaybe<TrailerPowerSource>;
  /** Checks for equality with the object’s `supportEtru` field. */
  supportEtru?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `truMake` field. */
  truMake?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `truModel` field. */
  truModel?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `Trailer` object types. All fields are combined with a logical ‘and.’ */
export type TrailerFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TrailerFilter>>;
  /** Filter by the object’s `carrierCode` field. */
  carrierCode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `carrierTrailerNumber` field. */
  carrierTrailerNumber?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dotNumber` field. */
  dotNumber?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TrailerFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TrailerFilter>>;
  /** Filter by the object’s `powerSource` field. */
  powerSource?: InputMaybe<TrailerPowerSourceFilter>;
  /** Filter by the object’s `supportEtru` field. */
  supportEtru?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `truMake` field. */
  truMake?: InputMaybe<StringFilter>;
  /** Filter by the object’s `truModel` field. */
  truModel?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `Trailer` */
export type TrailerInput = {
  /** The carrier code for the trailer */
  carrierCode: Scalars['String']['input'];
  /** The carrier-specific trailer number */
  carrierTrailerNumber: Scalars['String']['input'];
  /** The DOT-issued alphanumeric code identifying the trailer */
  dotNumber?: InputMaybe<Scalars['String']['input']>;
  /** The type of power used in the trailer refrigeration unit */
  powerSource?: InputMaybe<TrailerPowerSource>;
  /** Indicates if the trailer supports eTRU */
  supportEtru?: InputMaybe<Scalars['Boolean']['input']>;
  /** The manufacturer of the trailer refrigeration unit */
  truMake?: InputMaybe<Scalars['String']['input']>;
  /** The model of the trailer refrigeration unit */
  truModel?: InputMaybe<Scalars['String']['input']>;
};

/** Represents an update to a `Trailer`. Fields that are set will be updated. */
export type TrailerPatch = {
  /** The DOT-issued alphanumeric code identifying the trailer */
  dotNumber?: InputMaybe<Scalars['String']['input']>;
  /** The type of power used in the trailer refrigeration unit */
  powerSource?: InputMaybe<TrailerPowerSource>;
  /** Indicates if the trailer supports eTRU */
  supportEtru?: InputMaybe<Scalars['Boolean']['input']>;
  /** The manufacturer of the trailer refrigeration unit */
  truMake?: InputMaybe<Scalars['String']['input']>;
  /** The model of the trailer refrigeration unit */
  truModel?: InputMaybe<Scalars['String']['input']>;
};

/** This represents a physical location of a trailer at a door or yard position */
export type TrailerPosition = Node & {
  __typename?: 'TrailerPosition';
  /** The time at which the Trailer Position was created */
  createdAt: Scalars['Datetime']['output'];
  /** Reads a single `Facility` that is related to this `TrailerPosition`. */
  facility?: Maybe<Facility>;
  /** The facility where the trailer position is located */
  facilityId?: Maybe<Scalars['Int']['output']>;
  /** The GIS geometry specifies the physical location of the trailer position */
  geometry?: Maybe<GeometryInterface>;
  /** The id of the trailer position */
  id: Scalars['Int']['output'];
  /** The Human-readable label for the trailer position */
  label: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `DataPoint` that is related to this `TrailerPosition`. */
  trailerIsPresent?: Maybe<DataPoint>;
  /** The state of the trailer position indicating if the position is occupied */
  trailerIsPresentId?: Maybe<Scalars['BigInt']['output']>;
  /** The time at which the Trailer Position was updated */
  updatedAt: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `TrailerPosition` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type TrailerPositionCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `geometry` field. */
  geometry?: InputMaybe<Scalars['GeoJSON']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `label` field. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `trailerIsPresentId` field. */
  trailerIsPresentId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `TrailerPosition` object types. All fields are combined with a logical ‘and.’ */
export type TrailerPositionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TrailerPositionFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `label` field. */
  label?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TrailerPositionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TrailerPositionFilter>>;
  /** Filter by the object’s `trailerIsPresentId` field. */
  trailerIsPresentId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `TrailerPosition` */
export type TrailerPositionInput = {
  /** Mutates a `DataPoint` as part of the payload */
  dataPoint?: InputMaybe<DataPointInput>;
  /** The facility where the trailer position is located */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** The GIS geometry specifies the physical location of the trailer position */
  geometry?: InputMaybe<Scalars['GeoJSON']['input']>;
  /** The Human-readable label for the trailer position */
  label: Scalars['String']['input'];
  /** The state of the trailer position indicating if the position is occupied */
  trailerIsPresentId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** Represents an update to a `TrailerPosition`. Fields that are set will be updated. */
export type TrailerPositionPatch = {
  /** The facility where the trailer position is located */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** The GIS geometry specifies the physical location of the trailer position */
  geometry?: InputMaybe<Scalars['GeoJSON']['input']>;
  /** The Human-readable label for the trailer position */
  label?: InputMaybe<Scalars['String']['input']>;
  /** The state of the trailer position indicating if the position is occupied */
  trailerIsPresentId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A connection to a list of `TrailerPosition` values. */
export type TrailerPositionsConnection = {
  __typename?: 'TrailerPositionsConnection';
  /** A list of edges which contains the `TrailerPosition` and cursor to aid in pagination. */
  edges: Array<TrailerPositionsEdge>;
  /** A list of `TrailerPosition` objects. */
  nodes: Array<TrailerPosition>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TrailerPosition` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
  /** Returns the aggregate trailerIsPresent timeseries data for the TrailerPositionsConnection  */
  trailerIsPresent?: Maybe<MetricDataConnection>;
};

/** A connection to a list of `TrailerPosition` values. */
export type TrailerPositionsConnectionTrailerIsPresentArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A `TrailerPosition` edge in the connection. */
export type TrailerPositionsEdge = {
  __typename?: 'TrailerPositionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `TrailerPosition` at the end of the edge. */
  node: TrailerPosition;
};

/** Methods to use when ordering `TrailerPosition`. */
export enum TrailerPositionsOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  GEOMETRY_ASC = 'GEOMETRY_ASC',
  GEOMETRY_DESC = 'GEOMETRY_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LABEL_ASC = 'LABEL_ASC',
  LABEL_DESC = 'LABEL_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  TRAILER_IS_PRESENT_ID_ASC = 'TRAILER_IS_PRESENT_ID_ASC',
  TRAILER_IS_PRESENT_ID_DESC = 'TRAILER_IS_PRESENT_ID_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

export enum TrailerPowerSource {
  DIESEL = 'DIESEL',
  ELECTRIC = 'ELECTRIC',
  HYBRID = 'HYBRID'
}

/** A filter to be used against TrailerPowerSource fields. All fields are combined with a logical ‘and.’ */
export type TrailerPowerSourceFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<TrailerPowerSource>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<TrailerPowerSource>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<TrailerPowerSource>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<TrailerPowerSource>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<TrailerPowerSource>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<TrailerPowerSource>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<TrailerPowerSource>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<TrailerPowerSource>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<TrailerPowerSource>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<TrailerPowerSource>>;
};

/** A connection to a list of `Trailer` values. */
export type TrailersConnection = {
  __typename?: 'TrailersConnection';
  /** A list of edges which contains the `Trailer` and cursor to aid in pagination. */
  edges: Array<TrailersEdge>;
  /** A list of `Trailer` objects. */
  nodes: Array<Trailer>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Trailer` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Trailer` edge in the connection. */
export type TrailersEdge = {
  __typename?: 'TrailersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Trailer` at the end of the edge. */
  node: Trailer;
};

/** Methods to use when ordering `Trailer`. */
export enum TrailersOrderBy {
  CARRIER_CODE_ASC = 'CARRIER_CODE_ASC',
  CARRIER_CODE_DESC = 'CARRIER_CODE_DESC',
  CARRIER_TRAILER_NUMBER_ASC = 'CARRIER_TRAILER_NUMBER_ASC',
  CARRIER_TRAILER_NUMBER_DESC = 'CARRIER_TRAILER_NUMBER_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DOT_NUMBER_ASC = 'DOT_NUMBER_ASC',
  DOT_NUMBER_DESC = 'DOT_NUMBER_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  POWER_SOURCE_ASC = 'POWER_SOURCE_ASC',
  POWER_SOURCE_DESC = 'POWER_SOURCE_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  SUPPORT_ETRU_ASC = 'SUPPORT_ETRU_ASC',
  SUPPORT_ETRU_DESC = 'SUPPORT_ETRU_DESC',
  TRU_MAKE_ASC = 'TRU_MAKE_ASC',
  TRU_MAKE_DESC = 'TRU_MAKE_DESC',
  TRU_MODEL_ASC = 'TRU_MODEL_ASC',
  TRU_MODEL_DESC = 'TRU_MODEL_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

export type TransitionControlEventInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  controlEventId: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  state: ControlEventState;
};

/** All input for the `transitionOpportunity` mutation. */
export type TransitionOpportunityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  newState?: InputMaybe<OpportunityState>;
  opportunityId?: InputMaybe<Scalars['Int']['input']>;
  transitionedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** The output of our `transitionOpportunity` mutation. */
export type TransitionOpportunityPayload = {
  __typename?: 'TransitionOpportunityPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Facility` that is related to this `Opportunity`. */
  facility?: Maybe<Facility>;
  opportunity?: Maybe<Opportunity>;
  /** An edge for our `Opportunity`. May be used by Relay 1. */
  opportunityEdge?: Maybe<OpportunitiesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our `transitionOpportunity` mutation. */
export type TransitionOpportunityPayloadOpportunityEdgeArgs = {
  orderBy?: InputMaybe<Array<OpportunitiesOrderBy>>;
};

/** A unit dimension that identifies the base of a unit. */
export type UnitDimension = Node & {
  __typename?: 'UnitDimension';
  /** Returns a distinct list of units that are in use across facilities. */
  activeMappings?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The name of a unit dimension. */
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `UnitGroupDimension`. */
  unitGroups: UnitGroupDimensionsConnection;
};

/** A unit dimension that identifies the base of a unit. */
export type UnitDimensionUnitGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UnitGroupDimensionCondition>;
  filter?: InputMaybe<UnitGroupDimensionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UnitGroupDimensionsOrderBy>>;
};

/**
 * A condition to be used against `UnitDimension` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type UnitDimensionCondition = {
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `UnitDimension` object types. All fields are combined with a logical ‘and.’ */
export type UnitDimensionFilter = {
  /** Filter by the object’s `activeMappings` field. */
  activeMappings?: InputMaybe<StringListFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UnitDimensionFilter>>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UnitDimensionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UnitDimensionFilter>>;
};

/** A connection to a list of `UnitDimension` values. */
export type UnitDimensionsConnection = {
  __typename?: 'UnitDimensionsConnection';
  /** A list of edges which contains the `UnitDimension` and cursor to aid in pagination. */
  edges: Array<UnitDimensionsEdge>;
  /** A list of `UnitDimension` objects. */
  nodes: Array<UnitDimension>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UnitDimension` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `UnitDimension` edge in the connection. */
export type UnitDimensionsEdge = {
  __typename?: 'UnitDimensionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UnitDimension` at the end of the edge. */
  node: UnitDimension;
};

/** Methods to use when ordering `UnitDimension`. */
export enum UnitDimensionsOrderBy {
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UNIT_GROUPS_AVERAGE_CREATED_AT_ASC = 'UNIT_GROUPS_AVERAGE_CREATED_AT_ASC',
  UNIT_GROUPS_AVERAGE_CREATED_AT_DESC = 'UNIT_GROUPS_AVERAGE_CREATED_AT_DESC',
  UNIT_GROUPS_AVERAGE_UNIT_ASC = 'UNIT_GROUPS_AVERAGE_UNIT_ASC',
  UNIT_GROUPS_AVERAGE_UNIT_DESC = 'UNIT_GROUPS_AVERAGE_UNIT_DESC',
  UNIT_GROUPS_AVERAGE_UNIT_DIMENSION_ASC = 'UNIT_GROUPS_AVERAGE_UNIT_DIMENSION_ASC',
  UNIT_GROUPS_AVERAGE_UNIT_DIMENSION_DESC = 'UNIT_GROUPS_AVERAGE_UNIT_DIMENSION_DESC',
  UNIT_GROUPS_AVERAGE_UNIT_GROUP_ASC = 'UNIT_GROUPS_AVERAGE_UNIT_GROUP_ASC',
  UNIT_GROUPS_AVERAGE_UNIT_GROUP_DESC = 'UNIT_GROUPS_AVERAGE_UNIT_GROUP_DESC',
  UNIT_GROUPS_AVERAGE_UPDATED_AT_ASC = 'UNIT_GROUPS_AVERAGE_UPDATED_AT_ASC',
  UNIT_GROUPS_AVERAGE_UPDATED_AT_DESC = 'UNIT_GROUPS_AVERAGE_UPDATED_AT_DESC',
  UNIT_GROUPS_COUNT_ASC = 'UNIT_GROUPS_COUNT_ASC',
  UNIT_GROUPS_COUNT_DESC = 'UNIT_GROUPS_COUNT_DESC',
  UNIT_GROUPS_DISTINCT_COUNT_CREATED_AT_ASC = 'UNIT_GROUPS_DISTINCT_COUNT_CREATED_AT_ASC',
  UNIT_GROUPS_DISTINCT_COUNT_CREATED_AT_DESC = 'UNIT_GROUPS_DISTINCT_COUNT_CREATED_AT_DESC',
  UNIT_GROUPS_DISTINCT_COUNT_UNIT_ASC = 'UNIT_GROUPS_DISTINCT_COUNT_UNIT_ASC',
  UNIT_GROUPS_DISTINCT_COUNT_UNIT_DESC = 'UNIT_GROUPS_DISTINCT_COUNT_UNIT_DESC',
  UNIT_GROUPS_DISTINCT_COUNT_UNIT_DIMENSION_ASC = 'UNIT_GROUPS_DISTINCT_COUNT_UNIT_DIMENSION_ASC',
  UNIT_GROUPS_DISTINCT_COUNT_UNIT_DIMENSION_DESC = 'UNIT_GROUPS_DISTINCT_COUNT_UNIT_DIMENSION_DESC',
  UNIT_GROUPS_DISTINCT_COUNT_UNIT_GROUP_ASC = 'UNIT_GROUPS_DISTINCT_COUNT_UNIT_GROUP_ASC',
  UNIT_GROUPS_DISTINCT_COUNT_UNIT_GROUP_DESC = 'UNIT_GROUPS_DISTINCT_COUNT_UNIT_GROUP_DESC',
  UNIT_GROUPS_DISTINCT_COUNT_UPDATED_AT_ASC = 'UNIT_GROUPS_DISTINCT_COUNT_UPDATED_AT_ASC',
  UNIT_GROUPS_DISTINCT_COUNT_UPDATED_AT_DESC = 'UNIT_GROUPS_DISTINCT_COUNT_UPDATED_AT_DESC',
  UNIT_GROUPS_DISTINCT_CREATED_AT_ASC = 'UNIT_GROUPS_DISTINCT_CREATED_AT_ASC',
  UNIT_GROUPS_DISTINCT_CREATED_AT_DESC = 'UNIT_GROUPS_DISTINCT_CREATED_AT_DESC',
  UNIT_GROUPS_DISTINCT_UNIT_ASC = 'UNIT_GROUPS_DISTINCT_UNIT_ASC',
  UNIT_GROUPS_DISTINCT_UNIT_DESC = 'UNIT_GROUPS_DISTINCT_UNIT_DESC',
  UNIT_GROUPS_DISTINCT_UNIT_DIMENSION_ASC = 'UNIT_GROUPS_DISTINCT_UNIT_DIMENSION_ASC',
  UNIT_GROUPS_DISTINCT_UNIT_DIMENSION_DESC = 'UNIT_GROUPS_DISTINCT_UNIT_DIMENSION_DESC',
  UNIT_GROUPS_DISTINCT_UNIT_GROUP_ASC = 'UNIT_GROUPS_DISTINCT_UNIT_GROUP_ASC',
  UNIT_GROUPS_DISTINCT_UNIT_GROUP_DESC = 'UNIT_GROUPS_DISTINCT_UNIT_GROUP_DESC',
  UNIT_GROUPS_DISTINCT_UPDATED_AT_ASC = 'UNIT_GROUPS_DISTINCT_UPDATED_AT_ASC',
  UNIT_GROUPS_DISTINCT_UPDATED_AT_DESC = 'UNIT_GROUPS_DISTINCT_UPDATED_AT_DESC',
  UNIT_GROUPS_MAX_CREATED_AT_ASC = 'UNIT_GROUPS_MAX_CREATED_AT_ASC',
  UNIT_GROUPS_MAX_CREATED_AT_DESC = 'UNIT_GROUPS_MAX_CREATED_AT_DESC',
  UNIT_GROUPS_MAX_UNIT_ASC = 'UNIT_GROUPS_MAX_UNIT_ASC',
  UNIT_GROUPS_MAX_UNIT_DESC = 'UNIT_GROUPS_MAX_UNIT_DESC',
  UNIT_GROUPS_MAX_UNIT_DIMENSION_ASC = 'UNIT_GROUPS_MAX_UNIT_DIMENSION_ASC',
  UNIT_GROUPS_MAX_UNIT_DIMENSION_DESC = 'UNIT_GROUPS_MAX_UNIT_DIMENSION_DESC',
  UNIT_GROUPS_MAX_UNIT_GROUP_ASC = 'UNIT_GROUPS_MAX_UNIT_GROUP_ASC',
  UNIT_GROUPS_MAX_UNIT_GROUP_DESC = 'UNIT_GROUPS_MAX_UNIT_GROUP_DESC',
  UNIT_GROUPS_MAX_UPDATED_AT_ASC = 'UNIT_GROUPS_MAX_UPDATED_AT_ASC',
  UNIT_GROUPS_MAX_UPDATED_AT_DESC = 'UNIT_GROUPS_MAX_UPDATED_AT_DESC',
  UNIT_GROUPS_MIN_CREATED_AT_ASC = 'UNIT_GROUPS_MIN_CREATED_AT_ASC',
  UNIT_GROUPS_MIN_CREATED_AT_DESC = 'UNIT_GROUPS_MIN_CREATED_AT_DESC',
  UNIT_GROUPS_MIN_UNIT_ASC = 'UNIT_GROUPS_MIN_UNIT_ASC',
  UNIT_GROUPS_MIN_UNIT_DESC = 'UNIT_GROUPS_MIN_UNIT_DESC',
  UNIT_GROUPS_MIN_UNIT_DIMENSION_ASC = 'UNIT_GROUPS_MIN_UNIT_DIMENSION_ASC',
  UNIT_GROUPS_MIN_UNIT_DIMENSION_DESC = 'UNIT_GROUPS_MIN_UNIT_DIMENSION_DESC',
  UNIT_GROUPS_MIN_UNIT_GROUP_ASC = 'UNIT_GROUPS_MIN_UNIT_GROUP_ASC',
  UNIT_GROUPS_MIN_UNIT_GROUP_DESC = 'UNIT_GROUPS_MIN_UNIT_GROUP_DESC',
  UNIT_GROUPS_MIN_UPDATED_AT_ASC = 'UNIT_GROUPS_MIN_UPDATED_AT_ASC',
  UNIT_GROUPS_MIN_UPDATED_AT_DESC = 'UNIT_GROUPS_MIN_UPDATED_AT_DESC',
  UNIT_GROUPS_STDDEV_POPULATION_CREATED_AT_ASC = 'UNIT_GROUPS_STDDEV_POPULATION_CREATED_AT_ASC',
  UNIT_GROUPS_STDDEV_POPULATION_CREATED_AT_DESC = 'UNIT_GROUPS_STDDEV_POPULATION_CREATED_AT_DESC',
  UNIT_GROUPS_STDDEV_POPULATION_UNIT_ASC = 'UNIT_GROUPS_STDDEV_POPULATION_UNIT_ASC',
  UNIT_GROUPS_STDDEV_POPULATION_UNIT_DESC = 'UNIT_GROUPS_STDDEV_POPULATION_UNIT_DESC',
  UNIT_GROUPS_STDDEV_POPULATION_UNIT_DIMENSION_ASC = 'UNIT_GROUPS_STDDEV_POPULATION_UNIT_DIMENSION_ASC',
  UNIT_GROUPS_STDDEV_POPULATION_UNIT_DIMENSION_DESC = 'UNIT_GROUPS_STDDEV_POPULATION_UNIT_DIMENSION_DESC',
  UNIT_GROUPS_STDDEV_POPULATION_UNIT_GROUP_ASC = 'UNIT_GROUPS_STDDEV_POPULATION_UNIT_GROUP_ASC',
  UNIT_GROUPS_STDDEV_POPULATION_UNIT_GROUP_DESC = 'UNIT_GROUPS_STDDEV_POPULATION_UNIT_GROUP_DESC',
  UNIT_GROUPS_STDDEV_POPULATION_UPDATED_AT_ASC = 'UNIT_GROUPS_STDDEV_POPULATION_UPDATED_AT_ASC',
  UNIT_GROUPS_STDDEV_POPULATION_UPDATED_AT_DESC = 'UNIT_GROUPS_STDDEV_POPULATION_UPDATED_AT_DESC',
  UNIT_GROUPS_STDDEV_SAMPLE_CREATED_AT_ASC = 'UNIT_GROUPS_STDDEV_SAMPLE_CREATED_AT_ASC',
  UNIT_GROUPS_STDDEV_SAMPLE_CREATED_AT_DESC = 'UNIT_GROUPS_STDDEV_SAMPLE_CREATED_AT_DESC',
  UNIT_GROUPS_STDDEV_SAMPLE_UNIT_ASC = 'UNIT_GROUPS_STDDEV_SAMPLE_UNIT_ASC',
  UNIT_GROUPS_STDDEV_SAMPLE_UNIT_DESC = 'UNIT_GROUPS_STDDEV_SAMPLE_UNIT_DESC',
  UNIT_GROUPS_STDDEV_SAMPLE_UNIT_DIMENSION_ASC = 'UNIT_GROUPS_STDDEV_SAMPLE_UNIT_DIMENSION_ASC',
  UNIT_GROUPS_STDDEV_SAMPLE_UNIT_DIMENSION_DESC = 'UNIT_GROUPS_STDDEV_SAMPLE_UNIT_DIMENSION_DESC',
  UNIT_GROUPS_STDDEV_SAMPLE_UNIT_GROUP_ASC = 'UNIT_GROUPS_STDDEV_SAMPLE_UNIT_GROUP_ASC',
  UNIT_GROUPS_STDDEV_SAMPLE_UNIT_GROUP_DESC = 'UNIT_GROUPS_STDDEV_SAMPLE_UNIT_GROUP_DESC',
  UNIT_GROUPS_STDDEV_SAMPLE_UPDATED_AT_ASC = 'UNIT_GROUPS_STDDEV_SAMPLE_UPDATED_AT_ASC',
  UNIT_GROUPS_STDDEV_SAMPLE_UPDATED_AT_DESC = 'UNIT_GROUPS_STDDEV_SAMPLE_UPDATED_AT_DESC',
  UNIT_GROUPS_SUM_CREATED_AT_ASC = 'UNIT_GROUPS_SUM_CREATED_AT_ASC',
  UNIT_GROUPS_SUM_CREATED_AT_DESC = 'UNIT_GROUPS_SUM_CREATED_AT_DESC',
  UNIT_GROUPS_SUM_UNIT_ASC = 'UNIT_GROUPS_SUM_UNIT_ASC',
  UNIT_GROUPS_SUM_UNIT_DESC = 'UNIT_GROUPS_SUM_UNIT_DESC',
  UNIT_GROUPS_SUM_UNIT_DIMENSION_ASC = 'UNIT_GROUPS_SUM_UNIT_DIMENSION_ASC',
  UNIT_GROUPS_SUM_UNIT_DIMENSION_DESC = 'UNIT_GROUPS_SUM_UNIT_DIMENSION_DESC',
  UNIT_GROUPS_SUM_UNIT_GROUP_ASC = 'UNIT_GROUPS_SUM_UNIT_GROUP_ASC',
  UNIT_GROUPS_SUM_UNIT_GROUP_DESC = 'UNIT_GROUPS_SUM_UNIT_GROUP_DESC',
  UNIT_GROUPS_SUM_UPDATED_AT_ASC = 'UNIT_GROUPS_SUM_UPDATED_AT_ASC',
  UNIT_GROUPS_SUM_UPDATED_AT_DESC = 'UNIT_GROUPS_SUM_UPDATED_AT_DESC',
  UNIT_GROUPS_VARIANCE_POPULATION_CREATED_AT_ASC = 'UNIT_GROUPS_VARIANCE_POPULATION_CREATED_AT_ASC',
  UNIT_GROUPS_VARIANCE_POPULATION_CREATED_AT_DESC = 'UNIT_GROUPS_VARIANCE_POPULATION_CREATED_AT_DESC',
  UNIT_GROUPS_VARIANCE_POPULATION_UNIT_ASC = 'UNIT_GROUPS_VARIANCE_POPULATION_UNIT_ASC',
  UNIT_GROUPS_VARIANCE_POPULATION_UNIT_DESC = 'UNIT_GROUPS_VARIANCE_POPULATION_UNIT_DESC',
  UNIT_GROUPS_VARIANCE_POPULATION_UNIT_DIMENSION_ASC = 'UNIT_GROUPS_VARIANCE_POPULATION_UNIT_DIMENSION_ASC',
  UNIT_GROUPS_VARIANCE_POPULATION_UNIT_DIMENSION_DESC = 'UNIT_GROUPS_VARIANCE_POPULATION_UNIT_DIMENSION_DESC',
  UNIT_GROUPS_VARIANCE_POPULATION_UNIT_GROUP_ASC = 'UNIT_GROUPS_VARIANCE_POPULATION_UNIT_GROUP_ASC',
  UNIT_GROUPS_VARIANCE_POPULATION_UNIT_GROUP_DESC = 'UNIT_GROUPS_VARIANCE_POPULATION_UNIT_GROUP_DESC',
  UNIT_GROUPS_VARIANCE_POPULATION_UPDATED_AT_ASC = 'UNIT_GROUPS_VARIANCE_POPULATION_UPDATED_AT_ASC',
  UNIT_GROUPS_VARIANCE_POPULATION_UPDATED_AT_DESC = 'UNIT_GROUPS_VARIANCE_POPULATION_UPDATED_AT_DESC',
  UNIT_GROUPS_VARIANCE_SAMPLE_CREATED_AT_ASC = 'UNIT_GROUPS_VARIANCE_SAMPLE_CREATED_AT_ASC',
  UNIT_GROUPS_VARIANCE_SAMPLE_CREATED_AT_DESC = 'UNIT_GROUPS_VARIANCE_SAMPLE_CREATED_AT_DESC',
  UNIT_GROUPS_VARIANCE_SAMPLE_UNIT_ASC = 'UNIT_GROUPS_VARIANCE_SAMPLE_UNIT_ASC',
  UNIT_GROUPS_VARIANCE_SAMPLE_UNIT_DESC = 'UNIT_GROUPS_VARIANCE_SAMPLE_UNIT_DESC',
  UNIT_GROUPS_VARIANCE_SAMPLE_UNIT_DIMENSION_ASC = 'UNIT_GROUPS_VARIANCE_SAMPLE_UNIT_DIMENSION_ASC',
  UNIT_GROUPS_VARIANCE_SAMPLE_UNIT_DIMENSION_DESC = 'UNIT_GROUPS_VARIANCE_SAMPLE_UNIT_DIMENSION_DESC',
  UNIT_GROUPS_VARIANCE_SAMPLE_UNIT_GROUP_ASC = 'UNIT_GROUPS_VARIANCE_SAMPLE_UNIT_GROUP_ASC',
  UNIT_GROUPS_VARIANCE_SAMPLE_UNIT_GROUP_DESC = 'UNIT_GROUPS_VARIANCE_SAMPLE_UNIT_GROUP_DESC',
  UNIT_GROUPS_VARIANCE_SAMPLE_UPDATED_AT_ASC = 'UNIT_GROUPS_VARIANCE_SAMPLE_UPDATED_AT_ASC',
  UNIT_GROUPS_VARIANCE_SAMPLE_UPDATED_AT_DESC = 'UNIT_GROUPS_VARIANCE_SAMPLE_UPDATED_AT_DESC'
}

/** A grouping used to collect values for a set of unit dimensions. */
export type UnitGroup = Node & {
  __typename?: 'UnitGroup';
  /** Reads and enables pagination through a set of `Facility`. */
  facilities: FacilitiesConnection;
  /** The name of a unique unit group. */
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `UnitGroupDimension`. */
  unitGroupDimensions: UnitGroupDimensionsConnection;
  /**
   * The unit group dimensions of the unit group.
   * @deprecated true
   */
  unitGroupDimensionsByUnitGroup: UnitGroupDimensionsConnection;
};

/** A grouping used to collect values for a set of unit dimensions. */
export type UnitGroupFacilitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FacilityCondition>;
  filter?: InputMaybe<FacilityFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FacilitiesOrderBy>>;
};

/** A grouping used to collect values for a set of unit dimensions. */
export type UnitGroupUnitGroupDimensionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UnitGroupDimensionCondition>;
  filter?: InputMaybe<UnitGroupDimensionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UnitGroupDimensionsOrderBy>>;
};

/** A grouping used to collect values for a set of unit dimensions. */
export type UnitGroupUnitGroupDimensionsByUnitGroupArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<UnitGroupDimensionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * A condition to be used against `UnitGroup` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type UnitGroupCondition = {
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A mapping of a unit dimension for a specific unit group. */
export type UnitGroupDimension = Node & {
  __typename?: 'UnitGroupDimension';
  /** The time the unit group dimension was created. */
  createdAt: Scalars['Datetime']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The value of the unit for the dimension. */
  unit: Scalars['String']['output'];
  /** The associated unit dimension. */
  unitDimension: Scalars['String']['output'];
  /** The associated unit grouping. */
  unitGroup: Scalars['String']['output'];
  /** Reads a single `UnitDimension` that is related to this `UnitGroupDimension`. */
  unitGroupDimension?: Maybe<UnitDimension>;
  /** Reads a single `UnitGroup` that is related to this `UnitGroupDimension`. */
  unitGroupItem?: Maybe<UnitGroup>;
  /** The time the unit group dimension was updated. */
  updatedAt: Scalars['Datetime']['output'];
};

export type UnitGroupDimensionAggregates = {
  __typename?: 'UnitGroupDimensionAggregates';
  /** Distinct aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinct?: Maybe<UnitGroupDimensionDistinctAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
};

/**
 * A condition to be used against `UnitGroupDimension` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type UnitGroupDimensionCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `unit` field. */
  unit?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `unitDimension` field. */
  unitDimension?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `unitGroup` field. */
  unitGroup?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export type UnitGroupDimensionDistinctAggregates = {
  __typename?: 'UnitGroupDimensionDistinctAggregates';
  /** Distinct of unit across the matching connection */
  unit?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Distinct of unitDimension across the matching connection */
  unitDimension?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** A filter to be used against `UnitGroupDimension` object types. All fields are combined with a logical ‘and.’ */
export type UnitGroupDimensionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UnitGroupDimensionFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UnitGroupDimensionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UnitGroupDimensionFilter>>;
  /** Filter by the object’s `unit` field. */
  unit?: InputMaybe<StringFilter>;
  /** Filter by the object’s `unitDimension` field. */
  unitDimension?: InputMaybe<StringFilter>;
  /** Filter by the object’s `unitGroup` field. */
  unitGroup?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** A connection to a list of `UnitGroupDimension` values. */
export type UnitGroupDimensionsConnection = {
  __typename?: 'UnitGroupDimensionsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<UnitGroupDimensionAggregates>;
  /** A list of edges which contains the `UnitGroupDimension` and cursor to aid in pagination. */
  edges: Array<UnitGroupDimensionsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<UnitGroupDimensionAggregates>>;
  /** A list of `UnitGroupDimension` objects. */
  nodes: Array<UnitGroupDimension>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UnitGroupDimension` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A connection to a list of `UnitGroupDimension` values. */
export type UnitGroupDimensionsConnectionGroupedAggregatesArgs = {
  groupBy: Array<UnitGroupDimensionsGroupBy>;
  having?: InputMaybe<UnitGroupDimensionsHavingInput>;
};

/** A `UnitGroupDimension` edge in the connection. */
export type UnitGroupDimensionsEdge = {
  __typename?: 'UnitGroupDimensionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UnitGroupDimension` at the end of the edge. */
  node: UnitGroupDimension;
};

/** Grouping methods for `UnitGroupDimension` for usage during aggregation. */
export enum UnitGroupDimensionsGroupBy {
  CREATED_AT = 'CREATED_AT',
  CREATED_AT_DISTINCT = 'CREATED_AT_DISTINCT',
  CREATED_AT_TRUNCATED_TO_DAY = 'CREATED_AT_TRUNCATED_TO_DAY',
  CREATED_AT_TRUNCATED_TO_HOUR = 'CREATED_AT_TRUNCATED_TO_HOUR',
  UNIT = 'UNIT',
  UNIT_DIMENSION = 'UNIT_DIMENSION',
  UNIT_DIMENSION_DISTINCT = 'UNIT_DIMENSION_DISTINCT',
  UNIT_DISTINCT = 'UNIT_DISTINCT',
  UNIT_GROUP = 'UNIT_GROUP',
  UNIT_GROUP_DISTINCT = 'UNIT_GROUP_DISTINCT',
  UPDATED_AT = 'UPDATED_AT',
  UPDATED_AT_DISTINCT = 'UPDATED_AT_DISTINCT',
  UPDATED_AT_TRUNCATED_TO_DAY = 'UPDATED_AT_TRUNCATED_TO_DAY',
  UPDATED_AT_TRUNCATED_TO_HOUR = 'UPDATED_AT_TRUNCATED_TO_HOUR'
}

export type UnitGroupDimensionsHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type UnitGroupDimensionsHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type UnitGroupDimensionsHavingDistinctInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `UnitGroupDimension` aggregates. */
export type UnitGroupDimensionsHavingInput = {
  AND?: InputMaybe<Array<UnitGroupDimensionsHavingInput>>;
  OR?: InputMaybe<Array<UnitGroupDimensionsHavingInput>>;
  average?: InputMaybe<UnitGroupDimensionsHavingAverageInput>;
  distinct?: InputMaybe<UnitGroupDimensionsHavingDistinctInput>;
  distinctCount?: InputMaybe<UnitGroupDimensionsHavingDistinctCountInput>;
  max?: InputMaybe<UnitGroupDimensionsHavingMaxInput>;
  min?: InputMaybe<UnitGroupDimensionsHavingMinInput>;
  stddevPopulation?: InputMaybe<UnitGroupDimensionsHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<UnitGroupDimensionsHavingStddevSampleInput>;
  sum?: InputMaybe<UnitGroupDimensionsHavingSumInput>;
  variancePopulation?: InputMaybe<UnitGroupDimensionsHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<UnitGroupDimensionsHavingVarianceSampleInput>;
};

export type UnitGroupDimensionsHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type UnitGroupDimensionsHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type UnitGroupDimensionsHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type UnitGroupDimensionsHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type UnitGroupDimensionsHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type UnitGroupDimensionsHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type UnitGroupDimensionsHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Methods to use when ordering `UnitGroupDimension`. */
export enum UnitGroupDimensionsOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UNIT_ASC = 'UNIT_ASC',
  UNIT_DESC = 'UNIT_DESC',
  UNIT_DIMENSION_ASC = 'UNIT_DIMENSION_ASC',
  UNIT_DIMENSION_DESC = 'UNIT_DIMENSION_DESC',
  UNIT_GROUP_ASC = 'UNIT_GROUP_ASC',
  UNIT_GROUP_DESC = 'UNIT_GROUP_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** A filter to be used against `UnitGroup` object types. All fields are combined with a logical ‘and.’ */
export type UnitGroupFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UnitGroupFilter>>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UnitGroupFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UnitGroupFilter>>;
};

/** A connection to a list of `UnitGroup` values. */
export type UnitGroupsConnection = {
  __typename?: 'UnitGroupsConnection';
  /** A list of edges which contains the `UnitGroup` and cursor to aid in pagination. */
  edges: Array<UnitGroupsEdge>;
  /** A list of `UnitGroup` objects. */
  nodes: Array<UnitGroup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UnitGroup` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `UnitGroup` edge in the connection. */
export type UnitGroupsEdge = {
  __typename?: 'UnitGroupsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UnitGroup` at the end of the edge. */
  node: UnitGroup;
};

/** Methods to use when ordering `UnitGroup`. */
export enum UnitGroupsOrderBy {
  FACILITIES_AVERAGE_ADDRESS_ASC = 'FACILITIES_AVERAGE_ADDRESS_ASC',
  FACILITIES_AVERAGE_ADDRESS_DESC = 'FACILITIES_AVERAGE_ADDRESS_DESC',
  FACILITIES_AVERAGE_BONUS_LTR_ASC = 'FACILITIES_AVERAGE_BONUS_LTR_ASC',
  FACILITIES_AVERAGE_BONUS_LTR_DESC = 'FACILITIES_AVERAGE_BONUS_LTR_DESC',
  FACILITIES_AVERAGE_CITY_ASC = 'FACILITIES_AVERAGE_CITY_ASC',
  FACILITIES_AVERAGE_CITY_DESC = 'FACILITIES_AVERAGE_CITY_DESC',
  FACILITIES_AVERAGE_COMMODITY_ASC = 'FACILITIES_AVERAGE_COMMODITY_ASC',
  FACILITIES_AVERAGE_COMMODITY_DESC = 'FACILITIES_AVERAGE_COMMODITY_DESC',
  FACILITIES_AVERAGE_CONTXT_9249_ASC = 'FACILITIES_AVERAGE_CONTXT_9249_ASC',
  FACILITIES_AVERAGE_CONTXT_9249_DESC = 'FACILITIES_AVERAGE_CONTXT_9249_DESC',
  FACILITIES_AVERAGE_COST_CENTER_ASC = 'FACILITIES_AVERAGE_COST_CENTER_ASC',
  FACILITIES_AVERAGE_COST_CENTER_DESC = 'FACILITIES_AVERAGE_COST_CENTER_DESC',
  FACILITIES_AVERAGE_COUNTRY_ASC = 'FACILITIES_AVERAGE_COUNTRY_ASC',
  FACILITIES_AVERAGE_COUNTRY_DESC = 'FACILITIES_AVERAGE_COUNTRY_DESC',
  FACILITIES_AVERAGE_CREATED_AT_ASC = 'FACILITIES_AVERAGE_CREATED_AT_ASC',
  FACILITIES_AVERAGE_CREATED_AT_DESC = 'FACILITIES_AVERAGE_CREATED_AT_DESC',
  FACILITIES_AVERAGE_CUSTOMER_LOCATION_ID_ASC = 'FACILITIES_AVERAGE_CUSTOMER_LOCATION_ID_ASC',
  FACILITIES_AVERAGE_CUSTOMER_LOCATION_ID_DESC = 'FACILITIES_AVERAGE_CUSTOMER_LOCATION_ID_DESC',
  FACILITIES_AVERAGE_DATATYPE_1_TEST_ASC = 'FACILITIES_AVERAGE_DATATYPE_1_TEST_ASC',
  FACILITIES_AVERAGE_DATATYPE_1_TEST_DESC = 'FACILITIES_AVERAGE_DATATYPE_1_TEST_DESC',
  FACILITIES_AVERAGE_DATA_TYPE_2_TEST_ASC = 'FACILITIES_AVERAGE_DATA_TYPE_2_TEST_ASC',
  FACILITIES_AVERAGE_DATA_TYPE_2_TEST_DESC = 'FACILITIES_AVERAGE_DATA_TYPE_2_TEST_DESC',
  FACILITIES_AVERAGE_DATA_TYPE_3_TEST_ASC = 'FACILITIES_AVERAGE_DATA_TYPE_3_TEST_ASC',
  FACILITIES_AVERAGE_DATA_TYPE_3_TEST_DESC = 'FACILITIES_AVERAGE_DATA_TYPE_3_TEST_DESC',
  FACILITIES_AVERAGE_FACILITY_CONTACTS_ASC = 'FACILITIES_AVERAGE_FACILITY_CONTACTS_ASC',
  FACILITIES_AVERAGE_FACILITY_CONTACTS_DESC = 'FACILITIES_AVERAGE_FACILITY_CONTACTS_DESC',
  FACILITIES_AVERAGE_FLOOR_PLAN_GEOMETRY_ASC = 'FACILITIES_AVERAGE_FLOOR_PLAN_GEOMETRY_ASC',
  FACILITIES_AVERAGE_FLOOR_PLAN_GEOMETRY_DESC = 'FACILITIES_AVERAGE_FLOOR_PLAN_GEOMETRY_DESC',
  FACILITIES_AVERAGE_GEOMETRY_ASC = 'FACILITIES_AVERAGE_GEOMETRY_ASC',
  FACILITIES_AVERAGE_GEOMETRY_DESC = 'FACILITIES_AVERAGE_GEOMETRY_DESC',
  FACILITIES_AVERAGE_GO_LIVE_DATE_ASC = 'FACILITIES_AVERAGE_GO_LIVE_DATE_ASC',
  FACILITIES_AVERAGE_GO_LIVE_DATE_DESC = 'FACILITIES_AVERAGE_GO_LIVE_DATE_DESC',
  FACILITIES_AVERAGE_ID_ASC = 'FACILITIES_AVERAGE_ID_ASC',
  FACILITIES_AVERAGE_ID_DESC = 'FACILITIES_AVERAGE_ID_DESC',
  FACILITIES_AVERAGE_LATITUDE_ASC = 'FACILITIES_AVERAGE_LATITUDE_ASC',
  FACILITIES_AVERAGE_LATITUDE_DESC = 'FACILITIES_AVERAGE_LATITUDE_DESC',
  FACILITIES_AVERAGE_LINK_ACTIVE_ASC = 'FACILITIES_AVERAGE_LINK_ACTIVE_ASC',
  FACILITIES_AVERAGE_LINK_ACTIVE_DESC = 'FACILITIES_AVERAGE_LINK_ACTIVE_DESC',
  FACILITIES_AVERAGE_LONGITUDE_ASC = 'FACILITIES_AVERAGE_LONGITUDE_ASC',
  FACILITIES_AVERAGE_LONGITUDE_DESC = 'FACILITIES_AVERAGE_LONGITUDE_DESC',
  FACILITIES_AVERAGE_METRICS_ONE_ACTIVE_ASC = 'FACILITIES_AVERAGE_METRICS_ONE_ACTIVE_ASC',
  FACILITIES_AVERAGE_METRICS_ONE_ACTIVE_DESC = 'FACILITIES_AVERAGE_METRICS_ONE_ACTIVE_DESC',
  FACILITIES_AVERAGE_NAME_ASC = 'FACILITIES_AVERAGE_NAME_ASC',
  FACILITIES_AVERAGE_NAME_DESC = 'FACILITIES_AVERAGE_NAME_DESC',
  FACILITIES_AVERAGE_NOTE_ASC = 'FACILITIES_AVERAGE_NOTE_ASC',
  FACILITIES_AVERAGE_NOTE_DESC = 'FACILITIES_AVERAGE_NOTE_DESC',
  FACILITIES_AVERAGE_N_SIGHT_2_ACTIVE_ASC = 'FACILITIES_AVERAGE_N_SIGHT_2_ACTIVE_ASC',
  FACILITIES_AVERAGE_N_SIGHT_2_ACTIVE_DESC = 'FACILITIES_AVERAGE_N_SIGHT_2_ACTIVE_DESC',
  FACILITIES_AVERAGE_N_SIGHT_ACTIVE_ASC = 'FACILITIES_AVERAGE_N_SIGHT_ACTIVE_ASC',
  FACILITIES_AVERAGE_N_SIGHT_ACTIVE_DESC = 'FACILITIES_AVERAGE_N_SIGHT_ACTIVE_DESC',
  FACILITIES_AVERAGE_PRE_BONUS_EBITDA_ASC = 'FACILITIES_AVERAGE_PRE_BONUS_EBITDA_ASC',
  FACILITIES_AVERAGE_PRE_BONUS_EBITDA_DESC = 'FACILITIES_AVERAGE_PRE_BONUS_EBITDA_DESC',
  FACILITIES_AVERAGE_PRICING_NODE_ID_ASC = 'FACILITIES_AVERAGE_PRICING_NODE_ID_ASC',
  FACILITIES_AVERAGE_PRICING_NODE_ID_DESC = 'FACILITIES_AVERAGE_PRICING_NODE_ID_DESC',
  FACILITIES_AVERAGE_REAL_TIME_ENABLED_ASC = 'FACILITIES_AVERAGE_REAL_TIME_ENABLED_ASC',
  FACILITIES_AVERAGE_REAL_TIME_ENABLED_DESC = 'FACILITIES_AVERAGE_REAL_TIME_ENABLED_DESC',
  FACILITIES_AVERAGE_REFRIGERATIONVENDOR_ASC = 'FACILITIES_AVERAGE_REFRIGERATIONVENDOR_ASC',
  FACILITIES_AVERAGE_REFRIGERATIONVENDOR_DESC = 'FACILITIES_AVERAGE_REFRIGERATIONVENDOR_DESC',
  FACILITIES_AVERAGE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'FACILITIES_AVERAGE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  FACILITIES_AVERAGE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'FACILITIES_AVERAGE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  FACILITIES_AVERAGE_RETIRED_AT_ASC = 'FACILITIES_AVERAGE_RETIRED_AT_ASC',
  FACILITIES_AVERAGE_RETIRED_AT_DESC = 'FACILITIES_AVERAGE_RETIRED_AT_DESC',
  FACILITIES_AVERAGE_SLUG_ASC = 'FACILITIES_AVERAGE_SLUG_ASC',
  FACILITIES_AVERAGE_SLUG_DESC = 'FACILITIES_AVERAGE_SLUG_DESC',
  FACILITIES_AVERAGE_STATE_ASC = 'FACILITIES_AVERAGE_STATE_ASC',
  FACILITIES_AVERAGE_STATE_DESC = 'FACILITIES_AVERAGE_STATE_DESC',
  FACILITIES_AVERAGE_SUPPRESSE_FINANCIALS_ASC = 'FACILITIES_AVERAGE_SUPPRESSE_FINANCIALS_ASC',
  FACILITIES_AVERAGE_SUPPRESSE_FINANCIALS_DESC = 'FACILITIES_AVERAGE_SUPPRESSE_FINANCIALS_DESC',
  FACILITIES_AVERAGE_TAT_ATTRIBUTE_ASC = 'FACILITIES_AVERAGE_TAT_ATTRIBUTE_ASC',
  FACILITIES_AVERAGE_TAT_ATTRIBUTE_DESC = 'FACILITIES_AVERAGE_TAT_ATTRIBUTE_DESC',
  FACILITIES_AVERAGE_TIMEZONE_NAME_ASC = 'FACILITIES_AVERAGE_TIMEZONE_NAME_ASC',
  FACILITIES_AVERAGE_TIMEZONE_NAME_DESC = 'FACILITIES_AVERAGE_TIMEZONE_NAME_DESC',
  FACILITIES_AVERAGE_TYPE_ASC = 'FACILITIES_AVERAGE_TYPE_ASC',
  FACILITIES_AVERAGE_TYPE_DESC = 'FACILITIES_AVERAGE_TYPE_DESC',
  FACILITIES_AVERAGE_UNIT_GROUP_ASC = 'FACILITIES_AVERAGE_UNIT_GROUP_ASC',
  FACILITIES_AVERAGE_UNIT_GROUP_DESC = 'FACILITIES_AVERAGE_UNIT_GROUP_DESC',
  FACILITIES_AVERAGE_UPDATED_AT_ASC = 'FACILITIES_AVERAGE_UPDATED_AT_ASC',
  FACILITIES_AVERAGE_UPDATED_AT_DESC = 'FACILITIES_AVERAGE_UPDATED_AT_DESC',
  FACILITIES_AVERAGE_WMS_ASC = 'FACILITIES_AVERAGE_WMS_ASC',
  FACILITIES_AVERAGE_WMS_DESC = 'FACILITIES_AVERAGE_WMS_DESC',
  FACILITIES_AVERAGE_ZIP_ASC = 'FACILITIES_AVERAGE_ZIP_ASC',
  FACILITIES_AVERAGE_ZIP_DESC = 'FACILITIES_AVERAGE_ZIP_DESC',
  FACILITIES_COUNT_ASC = 'FACILITIES_COUNT_ASC',
  FACILITIES_COUNT_DESC = 'FACILITIES_COUNT_DESC',
  FACILITIES_DISTINCT_ADDRESS_ASC = 'FACILITIES_DISTINCT_ADDRESS_ASC',
  FACILITIES_DISTINCT_ADDRESS_DESC = 'FACILITIES_DISTINCT_ADDRESS_DESC',
  FACILITIES_DISTINCT_BONUS_LTR_ASC = 'FACILITIES_DISTINCT_BONUS_LTR_ASC',
  FACILITIES_DISTINCT_BONUS_LTR_DESC = 'FACILITIES_DISTINCT_BONUS_LTR_DESC',
  FACILITIES_DISTINCT_CITY_ASC = 'FACILITIES_DISTINCT_CITY_ASC',
  FACILITIES_DISTINCT_CITY_DESC = 'FACILITIES_DISTINCT_CITY_DESC',
  FACILITIES_DISTINCT_COMMODITY_ASC = 'FACILITIES_DISTINCT_COMMODITY_ASC',
  FACILITIES_DISTINCT_COMMODITY_DESC = 'FACILITIES_DISTINCT_COMMODITY_DESC',
  FACILITIES_DISTINCT_CONTXT_9249_ASC = 'FACILITIES_DISTINCT_CONTXT_9249_ASC',
  FACILITIES_DISTINCT_CONTXT_9249_DESC = 'FACILITIES_DISTINCT_CONTXT_9249_DESC',
  FACILITIES_DISTINCT_COST_CENTER_ASC = 'FACILITIES_DISTINCT_COST_CENTER_ASC',
  FACILITIES_DISTINCT_COST_CENTER_DESC = 'FACILITIES_DISTINCT_COST_CENTER_DESC',
  FACILITIES_DISTINCT_COUNTRY_ASC = 'FACILITIES_DISTINCT_COUNTRY_ASC',
  FACILITIES_DISTINCT_COUNTRY_DESC = 'FACILITIES_DISTINCT_COUNTRY_DESC',
  FACILITIES_DISTINCT_COUNT_ADDRESS_ASC = 'FACILITIES_DISTINCT_COUNT_ADDRESS_ASC',
  FACILITIES_DISTINCT_COUNT_ADDRESS_DESC = 'FACILITIES_DISTINCT_COUNT_ADDRESS_DESC',
  FACILITIES_DISTINCT_COUNT_BONUS_LTR_ASC = 'FACILITIES_DISTINCT_COUNT_BONUS_LTR_ASC',
  FACILITIES_DISTINCT_COUNT_BONUS_LTR_DESC = 'FACILITIES_DISTINCT_COUNT_BONUS_LTR_DESC',
  FACILITIES_DISTINCT_COUNT_CITY_ASC = 'FACILITIES_DISTINCT_COUNT_CITY_ASC',
  FACILITIES_DISTINCT_COUNT_CITY_DESC = 'FACILITIES_DISTINCT_COUNT_CITY_DESC',
  FACILITIES_DISTINCT_COUNT_COMMODITY_ASC = 'FACILITIES_DISTINCT_COUNT_COMMODITY_ASC',
  FACILITIES_DISTINCT_COUNT_COMMODITY_DESC = 'FACILITIES_DISTINCT_COUNT_COMMODITY_DESC',
  FACILITIES_DISTINCT_COUNT_CONTXT_9249_ASC = 'FACILITIES_DISTINCT_COUNT_CONTXT_9249_ASC',
  FACILITIES_DISTINCT_COUNT_CONTXT_9249_DESC = 'FACILITIES_DISTINCT_COUNT_CONTXT_9249_DESC',
  FACILITIES_DISTINCT_COUNT_COST_CENTER_ASC = 'FACILITIES_DISTINCT_COUNT_COST_CENTER_ASC',
  FACILITIES_DISTINCT_COUNT_COST_CENTER_DESC = 'FACILITIES_DISTINCT_COUNT_COST_CENTER_DESC',
  FACILITIES_DISTINCT_COUNT_COUNTRY_ASC = 'FACILITIES_DISTINCT_COUNT_COUNTRY_ASC',
  FACILITIES_DISTINCT_COUNT_COUNTRY_DESC = 'FACILITIES_DISTINCT_COUNT_COUNTRY_DESC',
  FACILITIES_DISTINCT_COUNT_CREATED_AT_ASC = 'FACILITIES_DISTINCT_COUNT_CREATED_AT_ASC',
  FACILITIES_DISTINCT_COUNT_CREATED_AT_DESC = 'FACILITIES_DISTINCT_COUNT_CREATED_AT_DESC',
  FACILITIES_DISTINCT_COUNT_CUSTOMER_LOCATION_ID_ASC = 'FACILITIES_DISTINCT_COUNT_CUSTOMER_LOCATION_ID_ASC',
  FACILITIES_DISTINCT_COUNT_CUSTOMER_LOCATION_ID_DESC = 'FACILITIES_DISTINCT_COUNT_CUSTOMER_LOCATION_ID_DESC',
  FACILITIES_DISTINCT_COUNT_DATATYPE_1_TEST_ASC = 'FACILITIES_DISTINCT_COUNT_DATATYPE_1_TEST_ASC',
  FACILITIES_DISTINCT_COUNT_DATATYPE_1_TEST_DESC = 'FACILITIES_DISTINCT_COUNT_DATATYPE_1_TEST_DESC',
  FACILITIES_DISTINCT_COUNT_DATA_TYPE_2_TEST_ASC = 'FACILITIES_DISTINCT_COUNT_DATA_TYPE_2_TEST_ASC',
  FACILITIES_DISTINCT_COUNT_DATA_TYPE_2_TEST_DESC = 'FACILITIES_DISTINCT_COUNT_DATA_TYPE_2_TEST_DESC',
  FACILITIES_DISTINCT_COUNT_DATA_TYPE_3_TEST_ASC = 'FACILITIES_DISTINCT_COUNT_DATA_TYPE_3_TEST_ASC',
  FACILITIES_DISTINCT_COUNT_DATA_TYPE_3_TEST_DESC = 'FACILITIES_DISTINCT_COUNT_DATA_TYPE_3_TEST_DESC',
  FACILITIES_DISTINCT_COUNT_FACILITY_CONTACTS_ASC = 'FACILITIES_DISTINCT_COUNT_FACILITY_CONTACTS_ASC',
  FACILITIES_DISTINCT_COUNT_FACILITY_CONTACTS_DESC = 'FACILITIES_DISTINCT_COUNT_FACILITY_CONTACTS_DESC',
  FACILITIES_DISTINCT_COUNT_FLOOR_PLAN_GEOMETRY_ASC = 'FACILITIES_DISTINCT_COUNT_FLOOR_PLAN_GEOMETRY_ASC',
  FACILITIES_DISTINCT_COUNT_FLOOR_PLAN_GEOMETRY_DESC = 'FACILITIES_DISTINCT_COUNT_FLOOR_PLAN_GEOMETRY_DESC',
  FACILITIES_DISTINCT_COUNT_GEOMETRY_ASC = 'FACILITIES_DISTINCT_COUNT_GEOMETRY_ASC',
  FACILITIES_DISTINCT_COUNT_GEOMETRY_DESC = 'FACILITIES_DISTINCT_COUNT_GEOMETRY_DESC',
  FACILITIES_DISTINCT_COUNT_GO_LIVE_DATE_ASC = 'FACILITIES_DISTINCT_COUNT_GO_LIVE_DATE_ASC',
  FACILITIES_DISTINCT_COUNT_GO_LIVE_DATE_DESC = 'FACILITIES_DISTINCT_COUNT_GO_LIVE_DATE_DESC',
  FACILITIES_DISTINCT_COUNT_ID_ASC = 'FACILITIES_DISTINCT_COUNT_ID_ASC',
  FACILITIES_DISTINCT_COUNT_ID_DESC = 'FACILITIES_DISTINCT_COUNT_ID_DESC',
  FACILITIES_DISTINCT_COUNT_LATITUDE_ASC = 'FACILITIES_DISTINCT_COUNT_LATITUDE_ASC',
  FACILITIES_DISTINCT_COUNT_LATITUDE_DESC = 'FACILITIES_DISTINCT_COUNT_LATITUDE_DESC',
  FACILITIES_DISTINCT_COUNT_LINK_ACTIVE_ASC = 'FACILITIES_DISTINCT_COUNT_LINK_ACTIVE_ASC',
  FACILITIES_DISTINCT_COUNT_LINK_ACTIVE_DESC = 'FACILITIES_DISTINCT_COUNT_LINK_ACTIVE_DESC',
  FACILITIES_DISTINCT_COUNT_LONGITUDE_ASC = 'FACILITIES_DISTINCT_COUNT_LONGITUDE_ASC',
  FACILITIES_DISTINCT_COUNT_LONGITUDE_DESC = 'FACILITIES_DISTINCT_COUNT_LONGITUDE_DESC',
  FACILITIES_DISTINCT_COUNT_METRICS_ONE_ACTIVE_ASC = 'FACILITIES_DISTINCT_COUNT_METRICS_ONE_ACTIVE_ASC',
  FACILITIES_DISTINCT_COUNT_METRICS_ONE_ACTIVE_DESC = 'FACILITIES_DISTINCT_COUNT_METRICS_ONE_ACTIVE_DESC',
  FACILITIES_DISTINCT_COUNT_NAME_ASC = 'FACILITIES_DISTINCT_COUNT_NAME_ASC',
  FACILITIES_DISTINCT_COUNT_NAME_DESC = 'FACILITIES_DISTINCT_COUNT_NAME_DESC',
  FACILITIES_DISTINCT_COUNT_NOTE_ASC = 'FACILITIES_DISTINCT_COUNT_NOTE_ASC',
  FACILITIES_DISTINCT_COUNT_NOTE_DESC = 'FACILITIES_DISTINCT_COUNT_NOTE_DESC',
  FACILITIES_DISTINCT_COUNT_N_SIGHT_2_ACTIVE_ASC = 'FACILITIES_DISTINCT_COUNT_N_SIGHT_2_ACTIVE_ASC',
  FACILITIES_DISTINCT_COUNT_N_SIGHT_2_ACTIVE_DESC = 'FACILITIES_DISTINCT_COUNT_N_SIGHT_2_ACTIVE_DESC',
  FACILITIES_DISTINCT_COUNT_N_SIGHT_ACTIVE_ASC = 'FACILITIES_DISTINCT_COUNT_N_SIGHT_ACTIVE_ASC',
  FACILITIES_DISTINCT_COUNT_N_SIGHT_ACTIVE_DESC = 'FACILITIES_DISTINCT_COUNT_N_SIGHT_ACTIVE_DESC',
  FACILITIES_DISTINCT_COUNT_PRE_BONUS_EBITDA_ASC = 'FACILITIES_DISTINCT_COUNT_PRE_BONUS_EBITDA_ASC',
  FACILITIES_DISTINCT_COUNT_PRE_BONUS_EBITDA_DESC = 'FACILITIES_DISTINCT_COUNT_PRE_BONUS_EBITDA_DESC',
  FACILITIES_DISTINCT_COUNT_PRICING_NODE_ID_ASC = 'FACILITIES_DISTINCT_COUNT_PRICING_NODE_ID_ASC',
  FACILITIES_DISTINCT_COUNT_PRICING_NODE_ID_DESC = 'FACILITIES_DISTINCT_COUNT_PRICING_NODE_ID_DESC',
  FACILITIES_DISTINCT_COUNT_REAL_TIME_ENABLED_ASC = 'FACILITIES_DISTINCT_COUNT_REAL_TIME_ENABLED_ASC',
  FACILITIES_DISTINCT_COUNT_REAL_TIME_ENABLED_DESC = 'FACILITIES_DISTINCT_COUNT_REAL_TIME_ENABLED_DESC',
  FACILITIES_DISTINCT_COUNT_REFRIGERATIONVENDOR_ASC = 'FACILITIES_DISTINCT_COUNT_REFRIGERATIONVENDOR_ASC',
  FACILITIES_DISTINCT_COUNT_REFRIGERATIONVENDOR_DESC = 'FACILITIES_DISTINCT_COUNT_REFRIGERATIONVENDOR_DESC',
  FACILITIES_DISTINCT_COUNT_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'FACILITIES_DISTINCT_COUNT_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  FACILITIES_DISTINCT_COUNT_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'FACILITIES_DISTINCT_COUNT_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  FACILITIES_DISTINCT_COUNT_RETIRED_AT_ASC = 'FACILITIES_DISTINCT_COUNT_RETIRED_AT_ASC',
  FACILITIES_DISTINCT_COUNT_RETIRED_AT_DESC = 'FACILITIES_DISTINCT_COUNT_RETIRED_AT_DESC',
  FACILITIES_DISTINCT_COUNT_SLUG_ASC = 'FACILITIES_DISTINCT_COUNT_SLUG_ASC',
  FACILITIES_DISTINCT_COUNT_SLUG_DESC = 'FACILITIES_DISTINCT_COUNT_SLUG_DESC',
  FACILITIES_DISTINCT_COUNT_STATE_ASC = 'FACILITIES_DISTINCT_COUNT_STATE_ASC',
  FACILITIES_DISTINCT_COUNT_STATE_DESC = 'FACILITIES_DISTINCT_COUNT_STATE_DESC',
  FACILITIES_DISTINCT_COUNT_SUPPRESSE_FINANCIALS_ASC = 'FACILITIES_DISTINCT_COUNT_SUPPRESSE_FINANCIALS_ASC',
  FACILITIES_DISTINCT_COUNT_SUPPRESSE_FINANCIALS_DESC = 'FACILITIES_DISTINCT_COUNT_SUPPRESSE_FINANCIALS_DESC',
  FACILITIES_DISTINCT_COUNT_TAT_ATTRIBUTE_ASC = 'FACILITIES_DISTINCT_COUNT_TAT_ATTRIBUTE_ASC',
  FACILITIES_DISTINCT_COUNT_TAT_ATTRIBUTE_DESC = 'FACILITIES_DISTINCT_COUNT_TAT_ATTRIBUTE_DESC',
  FACILITIES_DISTINCT_COUNT_TIMEZONE_NAME_ASC = 'FACILITIES_DISTINCT_COUNT_TIMEZONE_NAME_ASC',
  FACILITIES_DISTINCT_COUNT_TIMEZONE_NAME_DESC = 'FACILITIES_DISTINCT_COUNT_TIMEZONE_NAME_DESC',
  FACILITIES_DISTINCT_COUNT_TYPE_ASC = 'FACILITIES_DISTINCT_COUNT_TYPE_ASC',
  FACILITIES_DISTINCT_COUNT_TYPE_DESC = 'FACILITIES_DISTINCT_COUNT_TYPE_DESC',
  FACILITIES_DISTINCT_COUNT_UNIT_GROUP_ASC = 'FACILITIES_DISTINCT_COUNT_UNIT_GROUP_ASC',
  FACILITIES_DISTINCT_COUNT_UNIT_GROUP_DESC = 'FACILITIES_DISTINCT_COUNT_UNIT_GROUP_DESC',
  FACILITIES_DISTINCT_COUNT_UPDATED_AT_ASC = 'FACILITIES_DISTINCT_COUNT_UPDATED_AT_ASC',
  FACILITIES_DISTINCT_COUNT_UPDATED_AT_DESC = 'FACILITIES_DISTINCT_COUNT_UPDATED_AT_DESC',
  FACILITIES_DISTINCT_COUNT_WMS_ASC = 'FACILITIES_DISTINCT_COUNT_WMS_ASC',
  FACILITIES_DISTINCT_COUNT_WMS_DESC = 'FACILITIES_DISTINCT_COUNT_WMS_DESC',
  FACILITIES_DISTINCT_COUNT_ZIP_ASC = 'FACILITIES_DISTINCT_COUNT_ZIP_ASC',
  FACILITIES_DISTINCT_COUNT_ZIP_DESC = 'FACILITIES_DISTINCT_COUNT_ZIP_DESC',
  FACILITIES_DISTINCT_CREATED_AT_ASC = 'FACILITIES_DISTINCT_CREATED_AT_ASC',
  FACILITIES_DISTINCT_CREATED_AT_DESC = 'FACILITIES_DISTINCT_CREATED_AT_DESC',
  FACILITIES_DISTINCT_CUSTOMER_LOCATION_ID_ASC = 'FACILITIES_DISTINCT_CUSTOMER_LOCATION_ID_ASC',
  FACILITIES_DISTINCT_CUSTOMER_LOCATION_ID_DESC = 'FACILITIES_DISTINCT_CUSTOMER_LOCATION_ID_DESC',
  FACILITIES_DISTINCT_DATATYPE_1_TEST_ASC = 'FACILITIES_DISTINCT_DATATYPE_1_TEST_ASC',
  FACILITIES_DISTINCT_DATATYPE_1_TEST_DESC = 'FACILITIES_DISTINCT_DATATYPE_1_TEST_DESC',
  FACILITIES_DISTINCT_DATA_TYPE_2_TEST_ASC = 'FACILITIES_DISTINCT_DATA_TYPE_2_TEST_ASC',
  FACILITIES_DISTINCT_DATA_TYPE_2_TEST_DESC = 'FACILITIES_DISTINCT_DATA_TYPE_2_TEST_DESC',
  FACILITIES_DISTINCT_DATA_TYPE_3_TEST_ASC = 'FACILITIES_DISTINCT_DATA_TYPE_3_TEST_ASC',
  FACILITIES_DISTINCT_DATA_TYPE_3_TEST_DESC = 'FACILITIES_DISTINCT_DATA_TYPE_3_TEST_DESC',
  FACILITIES_DISTINCT_FACILITY_CONTACTS_ASC = 'FACILITIES_DISTINCT_FACILITY_CONTACTS_ASC',
  FACILITIES_DISTINCT_FACILITY_CONTACTS_DESC = 'FACILITIES_DISTINCT_FACILITY_CONTACTS_DESC',
  FACILITIES_DISTINCT_FLOOR_PLAN_GEOMETRY_ASC = 'FACILITIES_DISTINCT_FLOOR_PLAN_GEOMETRY_ASC',
  FACILITIES_DISTINCT_FLOOR_PLAN_GEOMETRY_DESC = 'FACILITIES_DISTINCT_FLOOR_PLAN_GEOMETRY_DESC',
  FACILITIES_DISTINCT_GEOMETRY_ASC = 'FACILITIES_DISTINCT_GEOMETRY_ASC',
  FACILITIES_DISTINCT_GEOMETRY_DESC = 'FACILITIES_DISTINCT_GEOMETRY_DESC',
  FACILITIES_DISTINCT_GO_LIVE_DATE_ASC = 'FACILITIES_DISTINCT_GO_LIVE_DATE_ASC',
  FACILITIES_DISTINCT_GO_LIVE_DATE_DESC = 'FACILITIES_DISTINCT_GO_LIVE_DATE_DESC',
  FACILITIES_DISTINCT_ID_ASC = 'FACILITIES_DISTINCT_ID_ASC',
  FACILITIES_DISTINCT_ID_DESC = 'FACILITIES_DISTINCT_ID_DESC',
  FACILITIES_DISTINCT_LATITUDE_ASC = 'FACILITIES_DISTINCT_LATITUDE_ASC',
  FACILITIES_DISTINCT_LATITUDE_DESC = 'FACILITIES_DISTINCT_LATITUDE_DESC',
  FACILITIES_DISTINCT_LINK_ACTIVE_ASC = 'FACILITIES_DISTINCT_LINK_ACTIVE_ASC',
  FACILITIES_DISTINCT_LINK_ACTIVE_DESC = 'FACILITIES_DISTINCT_LINK_ACTIVE_DESC',
  FACILITIES_DISTINCT_LONGITUDE_ASC = 'FACILITIES_DISTINCT_LONGITUDE_ASC',
  FACILITIES_DISTINCT_LONGITUDE_DESC = 'FACILITIES_DISTINCT_LONGITUDE_DESC',
  FACILITIES_DISTINCT_METRICS_ONE_ACTIVE_ASC = 'FACILITIES_DISTINCT_METRICS_ONE_ACTIVE_ASC',
  FACILITIES_DISTINCT_METRICS_ONE_ACTIVE_DESC = 'FACILITIES_DISTINCT_METRICS_ONE_ACTIVE_DESC',
  FACILITIES_DISTINCT_NAME_ASC = 'FACILITIES_DISTINCT_NAME_ASC',
  FACILITIES_DISTINCT_NAME_DESC = 'FACILITIES_DISTINCT_NAME_DESC',
  FACILITIES_DISTINCT_NOTE_ASC = 'FACILITIES_DISTINCT_NOTE_ASC',
  FACILITIES_DISTINCT_NOTE_DESC = 'FACILITIES_DISTINCT_NOTE_DESC',
  FACILITIES_DISTINCT_N_SIGHT_2_ACTIVE_ASC = 'FACILITIES_DISTINCT_N_SIGHT_2_ACTIVE_ASC',
  FACILITIES_DISTINCT_N_SIGHT_2_ACTIVE_DESC = 'FACILITIES_DISTINCT_N_SIGHT_2_ACTIVE_DESC',
  FACILITIES_DISTINCT_N_SIGHT_ACTIVE_ASC = 'FACILITIES_DISTINCT_N_SIGHT_ACTIVE_ASC',
  FACILITIES_DISTINCT_N_SIGHT_ACTIVE_DESC = 'FACILITIES_DISTINCT_N_SIGHT_ACTIVE_DESC',
  FACILITIES_DISTINCT_PRE_BONUS_EBITDA_ASC = 'FACILITIES_DISTINCT_PRE_BONUS_EBITDA_ASC',
  FACILITIES_DISTINCT_PRE_BONUS_EBITDA_DESC = 'FACILITIES_DISTINCT_PRE_BONUS_EBITDA_DESC',
  FACILITIES_DISTINCT_PRICING_NODE_ID_ASC = 'FACILITIES_DISTINCT_PRICING_NODE_ID_ASC',
  FACILITIES_DISTINCT_PRICING_NODE_ID_DESC = 'FACILITIES_DISTINCT_PRICING_NODE_ID_DESC',
  FACILITIES_DISTINCT_REAL_TIME_ENABLED_ASC = 'FACILITIES_DISTINCT_REAL_TIME_ENABLED_ASC',
  FACILITIES_DISTINCT_REAL_TIME_ENABLED_DESC = 'FACILITIES_DISTINCT_REAL_TIME_ENABLED_DESC',
  FACILITIES_DISTINCT_REFRIGERATIONVENDOR_ASC = 'FACILITIES_DISTINCT_REFRIGERATIONVENDOR_ASC',
  FACILITIES_DISTINCT_REFRIGERATIONVENDOR_DESC = 'FACILITIES_DISTINCT_REFRIGERATIONVENDOR_DESC',
  FACILITIES_DISTINCT_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'FACILITIES_DISTINCT_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  FACILITIES_DISTINCT_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'FACILITIES_DISTINCT_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  FACILITIES_DISTINCT_RETIRED_AT_ASC = 'FACILITIES_DISTINCT_RETIRED_AT_ASC',
  FACILITIES_DISTINCT_RETIRED_AT_DESC = 'FACILITIES_DISTINCT_RETIRED_AT_DESC',
  FACILITIES_DISTINCT_SLUG_ASC = 'FACILITIES_DISTINCT_SLUG_ASC',
  FACILITIES_DISTINCT_SLUG_DESC = 'FACILITIES_DISTINCT_SLUG_DESC',
  FACILITIES_DISTINCT_STATE_ASC = 'FACILITIES_DISTINCT_STATE_ASC',
  FACILITIES_DISTINCT_STATE_DESC = 'FACILITIES_DISTINCT_STATE_DESC',
  FACILITIES_DISTINCT_SUPPRESSE_FINANCIALS_ASC = 'FACILITIES_DISTINCT_SUPPRESSE_FINANCIALS_ASC',
  FACILITIES_DISTINCT_SUPPRESSE_FINANCIALS_DESC = 'FACILITIES_DISTINCT_SUPPRESSE_FINANCIALS_DESC',
  FACILITIES_DISTINCT_TAT_ATTRIBUTE_ASC = 'FACILITIES_DISTINCT_TAT_ATTRIBUTE_ASC',
  FACILITIES_DISTINCT_TAT_ATTRIBUTE_DESC = 'FACILITIES_DISTINCT_TAT_ATTRIBUTE_DESC',
  FACILITIES_DISTINCT_TIMEZONE_NAME_ASC = 'FACILITIES_DISTINCT_TIMEZONE_NAME_ASC',
  FACILITIES_DISTINCT_TIMEZONE_NAME_DESC = 'FACILITIES_DISTINCT_TIMEZONE_NAME_DESC',
  FACILITIES_DISTINCT_TYPE_ASC = 'FACILITIES_DISTINCT_TYPE_ASC',
  FACILITIES_DISTINCT_TYPE_DESC = 'FACILITIES_DISTINCT_TYPE_DESC',
  FACILITIES_DISTINCT_UNIT_GROUP_ASC = 'FACILITIES_DISTINCT_UNIT_GROUP_ASC',
  FACILITIES_DISTINCT_UNIT_GROUP_DESC = 'FACILITIES_DISTINCT_UNIT_GROUP_DESC',
  FACILITIES_DISTINCT_UPDATED_AT_ASC = 'FACILITIES_DISTINCT_UPDATED_AT_ASC',
  FACILITIES_DISTINCT_UPDATED_AT_DESC = 'FACILITIES_DISTINCT_UPDATED_AT_DESC',
  FACILITIES_DISTINCT_WMS_ASC = 'FACILITIES_DISTINCT_WMS_ASC',
  FACILITIES_DISTINCT_WMS_DESC = 'FACILITIES_DISTINCT_WMS_DESC',
  FACILITIES_DISTINCT_ZIP_ASC = 'FACILITIES_DISTINCT_ZIP_ASC',
  FACILITIES_DISTINCT_ZIP_DESC = 'FACILITIES_DISTINCT_ZIP_DESC',
  FACILITIES_MAX_ADDRESS_ASC = 'FACILITIES_MAX_ADDRESS_ASC',
  FACILITIES_MAX_ADDRESS_DESC = 'FACILITIES_MAX_ADDRESS_DESC',
  FACILITIES_MAX_BONUS_LTR_ASC = 'FACILITIES_MAX_BONUS_LTR_ASC',
  FACILITIES_MAX_BONUS_LTR_DESC = 'FACILITIES_MAX_BONUS_LTR_DESC',
  FACILITIES_MAX_CITY_ASC = 'FACILITIES_MAX_CITY_ASC',
  FACILITIES_MAX_CITY_DESC = 'FACILITIES_MAX_CITY_DESC',
  FACILITIES_MAX_COMMODITY_ASC = 'FACILITIES_MAX_COMMODITY_ASC',
  FACILITIES_MAX_COMMODITY_DESC = 'FACILITIES_MAX_COMMODITY_DESC',
  FACILITIES_MAX_CONTXT_9249_ASC = 'FACILITIES_MAX_CONTXT_9249_ASC',
  FACILITIES_MAX_CONTXT_9249_DESC = 'FACILITIES_MAX_CONTXT_9249_DESC',
  FACILITIES_MAX_COST_CENTER_ASC = 'FACILITIES_MAX_COST_CENTER_ASC',
  FACILITIES_MAX_COST_CENTER_DESC = 'FACILITIES_MAX_COST_CENTER_DESC',
  FACILITIES_MAX_COUNTRY_ASC = 'FACILITIES_MAX_COUNTRY_ASC',
  FACILITIES_MAX_COUNTRY_DESC = 'FACILITIES_MAX_COUNTRY_DESC',
  FACILITIES_MAX_CREATED_AT_ASC = 'FACILITIES_MAX_CREATED_AT_ASC',
  FACILITIES_MAX_CREATED_AT_DESC = 'FACILITIES_MAX_CREATED_AT_DESC',
  FACILITIES_MAX_CUSTOMER_LOCATION_ID_ASC = 'FACILITIES_MAX_CUSTOMER_LOCATION_ID_ASC',
  FACILITIES_MAX_CUSTOMER_LOCATION_ID_DESC = 'FACILITIES_MAX_CUSTOMER_LOCATION_ID_DESC',
  FACILITIES_MAX_DATATYPE_1_TEST_ASC = 'FACILITIES_MAX_DATATYPE_1_TEST_ASC',
  FACILITIES_MAX_DATATYPE_1_TEST_DESC = 'FACILITIES_MAX_DATATYPE_1_TEST_DESC',
  FACILITIES_MAX_DATA_TYPE_2_TEST_ASC = 'FACILITIES_MAX_DATA_TYPE_2_TEST_ASC',
  FACILITIES_MAX_DATA_TYPE_2_TEST_DESC = 'FACILITIES_MAX_DATA_TYPE_2_TEST_DESC',
  FACILITIES_MAX_DATA_TYPE_3_TEST_ASC = 'FACILITIES_MAX_DATA_TYPE_3_TEST_ASC',
  FACILITIES_MAX_DATA_TYPE_3_TEST_DESC = 'FACILITIES_MAX_DATA_TYPE_3_TEST_DESC',
  FACILITIES_MAX_FACILITY_CONTACTS_ASC = 'FACILITIES_MAX_FACILITY_CONTACTS_ASC',
  FACILITIES_MAX_FACILITY_CONTACTS_DESC = 'FACILITIES_MAX_FACILITY_CONTACTS_DESC',
  FACILITIES_MAX_FLOOR_PLAN_GEOMETRY_ASC = 'FACILITIES_MAX_FLOOR_PLAN_GEOMETRY_ASC',
  FACILITIES_MAX_FLOOR_PLAN_GEOMETRY_DESC = 'FACILITIES_MAX_FLOOR_PLAN_GEOMETRY_DESC',
  FACILITIES_MAX_GEOMETRY_ASC = 'FACILITIES_MAX_GEOMETRY_ASC',
  FACILITIES_MAX_GEOMETRY_DESC = 'FACILITIES_MAX_GEOMETRY_DESC',
  FACILITIES_MAX_GO_LIVE_DATE_ASC = 'FACILITIES_MAX_GO_LIVE_DATE_ASC',
  FACILITIES_MAX_GO_LIVE_DATE_DESC = 'FACILITIES_MAX_GO_LIVE_DATE_DESC',
  FACILITIES_MAX_ID_ASC = 'FACILITIES_MAX_ID_ASC',
  FACILITIES_MAX_ID_DESC = 'FACILITIES_MAX_ID_DESC',
  FACILITIES_MAX_LATITUDE_ASC = 'FACILITIES_MAX_LATITUDE_ASC',
  FACILITIES_MAX_LATITUDE_DESC = 'FACILITIES_MAX_LATITUDE_DESC',
  FACILITIES_MAX_LINK_ACTIVE_ASC = 'FACILITIES_MAX_LINK_ACTIVE_ASC',
  FACILITIES_MAX_LINK_ACTIVE_DESC = 'FACILITIES_MAX_LINK_ACTIVE_DESC',
  FACILITIES_MAX_LONGITUDE_ASC = 'FACILITIES_MAX_LONGITUDE_ASC',
  FACILITIES_MAX_LONGITUDE_DESC = 'FACILITIES_MAX_LONGITUDE_DESC',
  FACILITIES_MAX_METRICS_ONE_ACTIVE_ASC = 'FACILITIES_MAX_METRICS_ONE_ACTIVE_ASC',
  FACILITIES_MAX_METRICS_ONE_ACTIVE_DESC = 'FACILITIES_MAX_METRICS_ONE_ACTIVE_DESC',
  FACILITIES_MAX_NAME_ASC = 'FACILITIES_MAX_NAME_ASC',
  FACILITIES_MAX_NAME_DESC = 'FACILITIES_MAX_NAME_DESC',
  FACILITIES_MAX_NOTE_ASC = 'FACILITIES_MAX_NOTE_ASC',
  FACILITIES_MAX_NOTE_DESC = 'FACILITIES_MAX_NOTE_DESC',
  FACILITIES_MAX_N_SIGHT_2_ACTIVE_ASC = 'FACILITIES_MAX_N_SIGHT_2_ACTIVE_ASC',
  FACILITIES_MAX_N_SIGHT_2_ACTIVE_DESC = 'FACILITIES_MAX_N_SIGHT_2_ACTIVE_DESC',
  FACILITIES_MAX_N_SIGHT_ACTIVE_ASC = 'FACILITIES_MAX_N_SIGHT_ACTIVE_ASC',
  FACILITIES_MAX_N_SIGHT_ACTIVE_DESC = 'FACILITIES_MAX_N_SIGHT_ACTIVE_DESC',
  FACILITIES_MAX_PRE_BONUS_EBITDA_ASC = 'FACILITIES_MAX_PRE_BONUS_EBITDA_ASC',
  FACILITIES_MAX_PRE_BONUS_EBITDA_DESC = 'FACILITIES_MAX_PRE_BONUS_EBITDA_DESC',
  FACILITIES_MAX_PRICING_NODE_ID_ASC = 'FACILITIES_MAX_PRICING_NODE_ID_ASC',
  FACILITIES_MAX_PRICING_NODE_ID_DESC = 'FACILITIES_MAX_PRICING_NODE_ID_DESC',
  FACILITIES_MAX_REAL_TIME_ENABLED_ASC = 'FACILITIES_MAX_REAL_TIME_ENABLED_ASC',
  FACILITIES_MAX_REAL_TIME_ENABLED_DESC = 'FACILITIES_MAX_REAL_TIME_ENABLED_DESC',
  FACILITIES_MAX_REFRIGERATIONVENDOR_ASC = 'FACILITIES_MAX_REFRIGERATIONVENDOR_ASC',
  FACILITIES_MAX_REFRIGERATIONVENDOR_DESC = 'FACILITIES_MAX_REFRIGERATIONVENDOR_DESC',
  FACILITIES_MAX_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'FACILITIES_MAX_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  FACILITIES_MAX_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'FACILITIES_MAX_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  FACILITIES_MAX_RETIRED_AT_ASC = 'FACILITIES_MAX_RETIRED_AT_ASC',
  FACILITIES_MAX_RETIRED_AT_DESC = 'FACILITIES_MAX_RETIRED_AT_DESC',
  FACILITIES_MAX_SLUG_ASC = 'FACILITIES_MAX_SLUG_ASC',
  FACILITIES_MAX_SLUG_DESC = 'FACILITIES_MAX_SLUG_DESC',
  FACILITIES_MAX_STATE_ASC = 'FACILITIES_MAX_STATE_ASC',
  FACILITIES_MAX_STATE_DESC = 'FACILITIES_MAX_STATE_DESC',
  FACILITIES_MAX_SUPPRESSE_FINANCIALS_ASC = 'FACILITIES_MAX_SUPPRESSE_FINANCIALS_ASC',
  FACILITIES_MAX_SUPPRESSE_FINANCIALS_DESC = 'FACILITIES_MAX_SUPPRESSE_FINANCIALS_DESC',
  FACILITIES_MAX_TAT_ATTRIBUTE_ASC = 'FACILITIES_MAX_TAT_ATTRIBUTE_ASC',
  FACILITIES_MAX_TAT_ATTRIBUTE_DESC = 'FACILITIES_MAX_TAT_ATTRIBUTE_DESC',
  FACILITIES_MAX_TIMEZONE_NAME_ASC = 'FACILITIES_MAX_TIMEZONE_NAME_ASC',
  FACILITIES_MAX_TIMEZONE_NAME_DESC = 'FACILITIES_MAX_TIMEZONE_NAME_DESC',
  FACILITIES_MAX_TYPE_ASC = 'FACILITIES_MAX_TYPE_ASC',
  FACILITIES_MAX_TYPE_DESC = 'FACILITIES_MAX_TYPE_DESC',
  FACILITIES_MAX_UNIT_GROUP_ASC = 'FACILITIES_MAX_UNIT_GROUP_ASC',
  FACILITIES_MAX_UNIT_GROUP_DESC = 'FACILITIES_MAX_UNIT_GROUP_DESC',
  FACILITIES_MAX_UPDATED_AT_ASC = 'FACILITIES_MAX_UPDATED_AT_ASC',
  FACILITIES_MAX_UPDATED_AT_DESC = 'FACILITIES_MAX_UPDATED_AT_DESC',
  FACILITIES_MAX_WMS_ASC = 'FACILITIES_MAX_WMS_ASC',
  FACILITIES_MAX_WMS_DESC = 'FACILITIES_MAX_WMS_DESC',
  FACILITIES_MAX_ZIP_ASC = 'FACILITIES_MAX_ZIP_ASC',
  FACILITIES_MAX_ZIP_DESC = 'FACILITIES_MAX_ZIP_DESC',
  FACILITIES_MIN_ADDRESS_ASC = 'FACILITIES_MIN_ADDRESS_ASC',
  FACILITIES_MIN_ADDRESS_DESC = 'FACILITIES_MIN_ADDRESS_DESC',
  FACILITIES_MIN_BONUS_LTR_ASC = 'FACILITIES_MIN_BONUS_LTR_ASC',
  FACILITIES_MIN_BONUS_LTR_DESC = 'FACILITIES_MIN_BONUS_LTR_DESC',
  FACILITIES_MIN_CITY_ASC = 'FACILITIES_MIN_CITY_ASC',
  FACILITIES_MIN_CITY_DESC = 'FACILITIES_MIN_CITY_DESC',
  FACILITIES_MIN_COMMODITY_ASC = 'FACILITIES_MIN_COMMODITY_ASC',
  FACILITIES_MIN_COMMODITY_DESC = 'FACILITIES_MIN_COMMODITY_DESC',
  FACILITIES_MIN_CONTXT_9249_ASC = 'FACILITIES_MIN_CONTXT_9249_ASC',
  FACILITIES_MIN_CONTXT_9249_DESC = 'FACILITIES_MIN_CONTXT_9249_DESC',
  FACILITIES_MIN_COST_CENTER_ASC = 'FACILITIES_MIN_COST_CENTER_ASC',
  FACILITIES_MIN_COST_CENTER_DESC = 'FACILITIES_MIN_COST_CENTER_DESC',
  FACILITIES_MIN_COUNTRY_ASC = 'FACILITIES_MIN_COUNTRY_ASC',
  FACILITIES_MIN_COUNTRY_DESC = 'FACILITIES_MIN_COUNTRY_DESC',
  FACILITIES_MIN_CREATED_AT_ASC = 'FACILITIES_MIN_CREATED_AT_ASC',
  FACILITIES_MIN_CREATED_AT_DESC = 'FACILITIES_MIN_CREATED_AT_DESC',
  FACILITIES_MIN_CUSTOMER_LOCATION_ID_ASC = 'FACILITIES_MIN_CUSTOMER_LOCATION_ID_ASC',
  FACILITIES_MIN_CUSTOMER_LOCATION_ID_DESC = 'FACILITIES_MIN_CUSTOMER_LOCATION_ID_DESC',
  FACILITIES_MIN_DATATYPE_1_TEST_ASC = 'FACILITIES_MIN_DATATYPE_1_TEST_ASC',
  FACILITIES_MIN_DATATYPE_1_TEST_DESC = 'FACILITIES_MIN_DATATYPE_1_TEST_DESC',
  FACILITIES_MIN_DATA_TYPE_2_TEST_ASC = 'FACILITIES_MIN_DATA_TYPE_2_TEST_ASC',
  FACILITIES_MIN_DATA_TYPE_2_TEST_DESC = 'FACILITIES_MIN_DATA_TYPE_2_TEST_DESC',
  FACILITIES_MIN_DATA_TYPE_3_TEST_ASC = 'FACILITIES_MIN_DATA_TYPE_3_TEST_ASC',
  FACILITIES_MIN_DATA_TYPE_3_TEST_DESC = 'FACILITIES_MIN_DATA_TYPE_3_TEST_DESC',
  FACILITIES_MIN_FACILITY_CONTACTS_ASC = 'FACILITIES_MIN_FACILITY_CONTACTS_ASC',
  FACILITIES_MIN_FACILITY_CONTACTS_DESC = 'FACILITIES_MIN_FACILITY_CONTACTS_DESC',
  FACILITIES_MIN_FLOOR_PLAN_GEOMETRY_ASC = 'FACILITIES_MIN_FLOOR_PLAN_GEOMETRY_ASC',
  FACILITIES_MIN_FLOOR_PLAN_GEOMETRY_DESC = 'FACILITIES_MIN_FLOOR_PLAN_GEOMETRY_DESC',
  FACILITIES_MIN_GEOMETRY_ASC = 'FACILITIES_MIN_GEOMETRY_ASC',
  FACILITIES_MIN_GEOMETRY_DESC = 'FACILITIES_MIN_GEOMETRY_DESC',
  FACILITIES_MIN_GO_LIVE_DATE_ASC = 'FACILITIES_MIN_GO_LIVE_DATE_ASC',
  FACILITIES_MIN_GO_LIVE_DATE_DESC = 'FACILITIES_MIN_GO_LIVE_DATE_DESC',
  FACILITIES_MIN_ID_ASC = 'FACILITIES_MIN_ID_ASC',
  FACILITIES_MIN_ID_DESC = 'FACILITIES_MIN_ID_DESC',
  FACILITIES_MIN_LATITUDE_ASC = 'FACILITIES_MIN_LATITUDE_ASC',
  FACILITIES_MIN_LATITUDE_DESC = 'FACILITIES_MIN_LATITUDE_DESC',
  FACILITIES_MIN_LINK_ACTIVE_ASC = 'FACILITIES_MIN_LINK_ACTIVE_ASC',
  FACILITIES_MIN_LINK_ACTIVE_DESC = 'FACILITIES_MIN_LINK_ACTIVE_DESC',
  FACILITIES_MIN_LONGITUDE_ASC = 'FACILITIES_MIN_LONGITUDE_ASC',
  FACILITIES_MIN_LONGITUDE_DESC = 'FACILITIES_MIN_LONGITUDE_DESC',
  FACILITIES_MIN_METRICS_ONE_ACTIVE_ASC = 'FACILITIES_MIN_METRICS_ONE_ACTIVE_ASC',
  FACILITIES_MIN_METRICS_ONE_ACTIVE_DESC = 'FACILITIES_MIN_METRICS_ONE_ACTIVE_DESC',
  FACILITIES_MIN_NAME_ASC = 'FACILITIES_MIN_NAME_ASC',
  FACILITIES_MIN_NAME_DESC = 'FACILITIES_MIN_NAME_DESC',
  FACILITIES_MIN_NOTE_ASC = 'FACILITIES_MIN_NOTE_ASC',
  FACILITIES_MIN_NOTE_DESC = 'FACILITIES_MIN_NOTE_DESC',
  FACILITIES_MIN_N_SIGHT_2_ACTIVE_ASC = 'FACILITIES_MIN_N_SIGHT_2_ACTIVE_ASC',
  FACILITIES_MIN_N_SIGHT_2_ACTIVE_DESC = 'FACILITIES_MIN_N_SIGHT_2_ACTIVE_DESC',
  FACILITIES_MIN_N_SIGHT_ACTIVE_ASC = 'FACILITIES_MIN_N_SIGHT_ACTIVE_ASC',
  FACILITIES_MIN_N_SIGHT_ACTIVE_DESC = 'FACILITIES_MIN_N_SIGHT_ACTIVE_DESC',
  FACILITIES_MIN_PRE_BONUS_EBITDA_ASC = 'FACILITIES_MIN_PRE_BONUS_EBITDA_ASC',
  FACILITIES_MIN_PRE_BONUS_EBITDA_DESC = 'FACILITIES_MIN_PRE_BONUS_EBITDA_DESC',
  FACILITIES_MIN_PRICING_NODE_ID_ASC = 'FACILITIES_MIN_PRICING_NODE_ID_ASC',
  FACILITIES_MIN_PRICING_NODE_ID_DESC = 'FACILITIES_MIN_PRICING_NODE_ID_DESC',
  FACILITIES_MIN_REAL_TIME_ENABLED_ASC = 'FACILITIES_MIN_REAL_TIME_ENABLED_ASC',
  FACILITIES_MIN_REAL_TIME_ENABLED_DESC = 'FACILITIES_MIN_REAL_TIME_ENABLED_DESC',
  FACILITIES_MIN_REFRIGERATIONVENDOR_ASC = 'FACILITIES_MIN_REFRIGERATIONVENDOR_ASC',
  FACILITIES_MIN_REFRIGERATIONVENDOR_DESC = 'FACILITIES_MIN_REFRIGERATIONVENDOR_DESC',
  FACILITIES_MIN_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'FACILITIES_MIN_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  FACILITIES_MIN_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'FACILITIES_MIN_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  FACILITIES_MIN_RETIRED_AT_ASC = 'FACILITIES_MIN_RETIRED_AT_ASC',
  FACILITIES_MIN_RETIRED_AT_DESC = 'FACILITIES_MIN_RETIRED_AT_DESC',
  FACILITIES_MIN_SLUG_ASC = 'FACILITIES_MIN_SLUG_ASC',
  FACILITIES_MIN_SLUG_DESC = 'FACILITIES_MIN_SLUG_DESC',
  FACILITIES_MIN_STATE_ASC = 'FACILITIES_MIN_STATE_ASC',
  FACILITIES_MIN_STATE_DESC = 'FACILITIES_MIN_STATE_DESC',
  FACILITIES_MIN_SUPPRESSE_FINANCIALS_ASC = 'FACILITIES_MIN_SUPPRESSE_FINANCIALS_ASC',
  FACILITIES_MIN_SUPPRESSE_FINANCIALS_DESC = 'FACILITIES_MIN_SUPPRESSE_FINANCIALS_DESC',
  FACILITIES_MIN_TAT_ATTRIBUTE_ASC = 'FACILITIES_MIN_TAT_ATTRIBUTE_ASC',
  FACILITIES_MIN_TAT_ATTRIBUTE_DESC = 'FACILITIES_MIN_TAT_ATTRIBUTE_DESC',
  FACILITIES_MIN_TIMEZONE_NAME_ASC = 'FACILITIES_MIN_TIMEZONE_NAME_ASC',
  FACILITIES_MIN_TIMEZONE_NAME_DESC = 'FACILITIES_MIN_TIMEZONE_NAME_DESC',
  FACILITIES_MIN_TYPE_ASC = 'FACILITIES_MIN_TYPE_ASC',
  FACILITIES_MIN_TYPE_DESC = 'FACILITIES_MIN_TYPE_DESC',
  FACILITIES_MIN_UNIT_GROUP_ASC = 'FACILITIES_MIN_UNIT_GROUP_ASC',
  FACILITIES_MIN_UNIT_GROUP_DESC = 'FACILITIES_MIN_UNIT_GROUP_DESC',
  FACILITIES_MIN_UPDATED_AT_ASC = 'FACILITIES_MIN_UPDATED_AT_ASC',
  FACILITIES_MIN_UPDATED_AT_DESC = 'FACILITIES_MIN_UPDATED_AT_DESC',
  FACILITIES_MIN_WMS_ASC = 'FACILITIES_MIN_WMS_ASC',
  FACILITIES_MIN_WMS_DESC = 'FACILITIES_MIN_WMS_DESC',
  FACILITIES_MIN_ZIP_ASC = 'FACILITIES_MIN_ZIP_ASC',
  FACILITIES_MIN_ZIP_DESC = 'FACILITIES_MIN_ZIP_DESC',
  FACILITIES_STDDEV_POPULATION_ADDRESS_ASC = 'FACILITIES_STDDEV_POPULATION_ADDRESS_ASC',
  FACILITIES_STDDEV_POPULATION_ADDRESS_DESC = 'FACILITIES_STDDEV_POPULATION_ADDRESS_DESC',
  FACILITIES_STDDEV_POPULATION_BONUS_LTR_ASC = 'FACILITIES_STDDEV_POPULATION_BONUS_LTR_ASC',
  FACILITIES_STDDEV_POPULATION_BONUS_LTR_DESC = 'FACILITIES_STDDEV_POPULATION_BONUS_LTR_DESC',
  FACILITIES_STDDEV_POPULATION_CITY_ASC = 'FACILITIES_STDDEV_POPULATION_CITY_ASC',
  FACILITIES_STDDEV_POPULATION_CITY_DESC = 'FACILITIES_STDDEV_POPULATION_CITY_DESC',
  FACILITIES_STDDEV_POPULATION_COMMODITY_ASC = 'FACILITIES_STDDEV_POPULATION_COMMODITY_ASC',
  FACILITIES_STDDEV_POPULATION_COMMODITY_DESC = 'FACILITIES_STDDEV_POPULATION_COMMODITY_DESC',
  FACILITIES_STDDEV_POPULATION_CONTXT_9249_ASC = 'FACILITIES_STDDEV_POPULATION_CONTXT_9249_ASC',
  FACILITIES_STDDEV_POPULATION_CONTXT_9249_DESC = 'FACILITIES_STDDEV_POPULATION_CONTXT_9249_DESC',
  FACILITIES_STDDEV_POPULATION_COST_CENTER_ASC = 'FACILITIES_STDDEV_POPULATION_COST_CENTER_ASC',
  FACILITIES_STDDEV_POPULATION_COST_CENTER_DESC = 'FACILITIES_STDDEV_POPULATION_COST_CENTER_DESC',
  FACILITIES_STDDEV_POPULATION_COUNTRY_ASC = 'FACILITIES_STDDEV_POPULATION_COUNTRY_ASC',
  FACILITIES_STDDEV_POPULATION_COUNTRY_DESC = 'FACILITIES_STDDEV_POPULATION_COUNTRY_DESC',
  FACILITIES_STDDEV_POPULATION_CREATED_AT_ASC = 'FACILITIES_STDDEV_POPULATION_CREATED_AT_ASC',
  FACILITIES_STDDEV_POPULATION_CREATED_AT_DESC = 'FACILITIES_STDDEV_POPULATION_CREATED_AT_DESC',
  FACILITIES_STDDEV_POPULATION_CUSTOMER_LOCATION_ID_ASC = 'FACILITIES_STDDEV_POPULATION_CUSTOMER_LOCATION_ID_ASC',
  FACILITIES_STDDEV_POPULATION_CUSTOMER_LOCATION_ID_DESC = 'FACILITIES_STDDEV_POPULATION_CUSTOMER_LOCATION_ID_DESC',
  FACILITIES_STDDEV_POPULATION_DATATYPE_1_TEST_ASC = 'FACILITIES_STDDEV_POPULATION_DATATYPE_1_TEST_ASC',
  FACILITIES_STDDEV_POPULATION_DATATYPE_1_TEST_DESC = 'FACILITIES_STDDEV_POPULATION_DATATYPE_1_TEST_DESC',
  FACILITIES_STDDEV_POPULATION_DATA_TYPE_2_TEST_ASC = 'FACILITIES_STDDEV_POPULATION_DATA_TYPE_2_TEST_ASC',
  FACILITIES_STDDEV_POPULATION_DATA_TYPE_2_TEST_DESC = 'FACILITIES_STDDEV_POPULATION_DATA_TYPE_2_TEST_DESC',
  FACILITIES_STDDEV_POPULATION_DATA_TYPE_3_TEST_ASC = 'FACILITIES_STDDEV_POPULATION_DATA_TYPE_3_TEST_ASC',
  FACILITIES_STDDEV_POPULATION_DATA_TYPE_3_TEST_DESC = 'FACILITIES_STDDEV_POPULATION_DATA_TYPE_3_TEST_DESC',
  FACILITIES_STDDEV_POPULATION_FACILITY_CONTACTS_ASC = 'FACILITIES_STDDEV_POPULATION_FACILITY_CONTACTS_ASC',
  FACILITIES_STDDEV_POPULATION_FACILITY_CONTACTS_DESC = 'FACILITIES_STDDEV_POPULATION_FACILITY_CONTACTS_DESC',
  FACILITIES_STDDEV_POPULATION_FLOOR_PLAN_GEOMETRY_ASC = 'FACILITIES_STDDEV_POPULATION_FLOOR_PLAN_GEOMETRY_ASC',
  FACILITIES_STDDEV_POPULATION_FLOOR_PLAN_GEOMETRY_DESC = 'FACILITIES_STDDEV_POPULATION_FLOOR_PLAN_GEOMETRY_DESC',
  FACILITIES_STDDEV_POPULATION_GEOMETRY_ASC = 'FACILITIES_STDDEV_POPULATION_GEOMETRY_ASC',
  FACILITIES_STDDEV_POPULATION_GEOMETRY_DESC = 'FACILITIES_STDDEV_POPULATION_GEOMETRY_DESC',
  FACILITIES_STDDEV_POPULATION_GO_LIVE_DATE_ASC = 'FACILITIES_STDDEV_POPULATION_GO_LIVE_DATE_ASC',
  FACILITIES_STDDEV_POPULATION_GO_LIVE_DATE_DESC = 'FACILITIES_STDDEV_POPULATION_GO_LIVE_DATE_DESC',
  FACILITIES_STDDEV_POPULATION_ID_ASC = 'FACILITIES_STDDEV_POPULATION_ID_ASC',
  FACILITIES_STDDEV_POPULATION_ID_DESC = 'FACILITIES_STDDEV_POPULATION_ID_DESC',
  FACILITIES_STDDEV_POPULATION_LATITUDE_ASC = 'FACILITIES_STDDEV_POPULATION_LATITUDE_ASC',
  FACILITIES_STDDEV_POPULATION_LATITUDE_DESC = 'FACILITIES_STDDEV_POPULATION_LATITUDE_DESC',
  FACILITIES_STDDEV_POPULATION_LINK_ACTIVE_ASC = 'FACILITIES_STDDEV_POPULATION_LINK_ACTIVE_ASC',
  FACILITIES_STDDEV_POPULATION_LINK_ACTIVE_DESC = 'FACILITIES_STDDEV_POPULATION_LINK_ACTIVE_DESC',
  FACILITIES_STDDEV_POPULATION_LONGITUDE_ASC = 'FACILITIES_STDDEV_POPULATION_LONGITUDE_ASC',
  FACILITIES_STDDEV_POPULATION_LONGITUDE_DESC = 'FACILITIES_STDDEV_POPULATION_LONGITUDE_DESC',
  FACILITIES_STDDEV_POPULATION_METRICS_ONE_ACTIVE_ASC = 'FACILITIES_STDDEV_POPULATION_METRICS_ONE_ACTIVE_ASC',
  FACILITIES_STDDEV_POPULATION_METRICS_ONE_ACTIVE_DESC = 'FACILITIES_STDDEV_POPULATION_METRICS_ONE_ACTIVE_DESC',
  FACILITIES_STDDEV_POPULATION_NAME_ASC = 'FACILITIES_STDDEV_POPULATION_NAME_ASC',
  FACILITIES_STDDEV_POPULATION_NAME_DESC = 'FACILITIES_STDDEV_POPULATION_NAME_DESC',
  FACILITIES_STDDEV_POPULATION_NOTE_ASC = 'FACILITIES_STDDEV_POPULATION_NOTE_ASC',
  FACILITIES_STDDEV_POPULATION_NOTE_DESC = 'FACILITIES_STDDEV_POPULATION_NOTE_DESC',
  FACILITIES_STDDEV_POPULATION_N_SIGHT_2_ACTIVE_ASC = 'FACILITIES_STDDEV_POPULATION_N_SIGHT_2_ACTIVE_ASC',
  FACILITIES_STDDEV_POPULATION_N_SIGHT_2_ACTIVE_DESC = 'FACILITIES_STDDEV_POPULATION_N_SIGHT_2_ACTIVE_DESC',
  FACILITIES_STDDEV_POPULATION_N_SIGHT_ACTIVE_ASC = 'FACILITIES_STDDEV_POPULATION_N_SIGHT_ACTIVE_ASC',
  FACILITIES_STDDEV_POPULATION_N_SIGHT_ACTIVE_DESC = 'FACILITIES_STDDEV_POPULATION_N_SIGHT_ACTIVE_DESC',
  FACILITIES_STDDEV_POPULATION_PRE_BONUS_EBITDA_ASC = 'FACILITIES_STDDEV_POPULATION_PRE_BONUS_EBITDA_ASC',
  FACILITIES_STDDEV_POPULATION_PRE_BONUS_EBITDA_DESC = 'FACILITIES_STDDEV_POPULATION_PRE_BONUS_EBITDA_DESC',
  FACILITIES_STDDEV_POPULATION_PRICING_NODE_ID_ASC = 'FACILITIES_STDDEV_POPULATION_PRICING_NODE_ID_ASC',
  FACILITIES_STDDEV_POPULATION_PRICING_NODE_ID_DESC = 'FACILITIES_STDDEV_POPULATION_PRICING_NODE_ID_DESC',
  FACILITIES_STDDEV_POPULATION_REAL_TIME_ENABLED_ASC = 'FACILITIES_STDDEV_POPULATION_REAL_TIME_ENABLED_ASC',
  FACILITIES_STDDEV_POPULATION_REAL_TIME_ENABLED_DESC = 'FACILITIES_STDDEV_POPULATION_REAL_TIME_ENABLED_DESC',
  FACILITIES_STDDEV_POPULATION_REFRIGERATIONVENDOR_ASC = 'FACILITIES_STDDEV_POPULATION_REFRIGERATIONVENDOR_ASC',
  FACILITIES_STDDEV_POPULATION_REFRIGERATIONVENDOR_DESC = 'FACILITIES_STDDEV_POPULATION_REFRIGERATIONVENDOR_DESC',
  FACILITIES_STDDEV_POPULATION_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'FACILITIES_STDDEV_POPULATION_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  FACILITIES_STDDEV_POPULATION_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'FACILITIES_STDDEV_POPULATION_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  FACILITIES_STDDEV_POPULATION_RETIRED_AT_ASC = 'FACILITIES_STDDEV_POPULATION_RETIRED_AT_ASC',
  FACILITIES_STDDEV_POPULATION_RETIRED_AT_DESC = 'FACILITIES_STDDEV_POPULATION_RETIRED_AT_DESC',
  FACILITIES_STDDEV_POPULATION_SLUG_ASC = 'FACILITIES_STDDEV_POPULATION_SLUG_ASC',
  FACILITIES_STDDEV_POPULATION_SLUG_DESC = 'FACILITIES_STDDEV_POPULATION_SLUG_DESC',
  FACILITIES_STDDEV_POPULATION_STATE_ASC = 'FACILITIES_STDDEV_POPULATION_STATE_ASC',
  FACILITIES_STDDEV_POPULATION_STATE_DESC = 'FACILITIES_STDDEV_POPULATION_STATE_DESC',
  FACILITIES_STDDEV_POPULATION_SUPPRESSE_FINANCIALS_ASC = 'FACILITIES_STDDEV_POPULATION_SUPPRESSE_FINANCIALS_ASC',
  FACILITIES_STDDEV_POPULATION_SUPPRESSE_FINANCIALS_DESC = 'FACILITIES_STDDEV_POPULATION_SUPPRESSE_FINANCIALS_DESC',
  FACILITIES_STDDEV_POPULATION_TAT_ATTRIBUTE_ASC = 'FACILITIES_STDDEV_POPULATION_TAT_ATTRIBUTE_ASC',
  FACILITIES_STDDEV_POPULATION_TAT_ATTRIBUTE_DESC = 'FACILITIES_STDDEV_POPULATION_TAT_ATTRIBUTE_DESC',
  FACILITIES_STDDEV_POPULATION_TIMEZONE_NAME_ASC = 'FACILITIES_STDDEV_POPULATION_TIMEZONE_NAME_ASC',
  FACILITIES_STDDEV_POPULATION_TIMEZONE_NAME_DESC = 'FACILITIES_STDDEV_POPULATION_TIMEZONE_NAME_DESC',
  FACILITIES_STDDEV_POPULATION_TYPE_ASC = 'FACILITIES_STDDEV_POPULATION_TYPE_ASC',
  FACILITIES_STDDEV_POPULATION_TYPE_DESC = 'FACILITIES_STDDEV_POPULATION_TYPE_DESC',
  FACILITIES_STDDEV_POPULATION_UNIT_GROUP_ASC = 'FACILITIES_STDDEV_POPULATION_UNIT_GROUP_ASC',
  FACILITIES_STDDEV_POPULATION_UNIT_GROUP_DESC = 'FACILITIES_STDDEV_POPULATION_UNIT_GROUP_DESC',
  FACILITIES_STDDEV_POPULATION_UPDATED_AT_ASC = 'FACILITIES_STDDEV_POPULATION_UPDATED_AT_ASC',
  FACILITIES_STDDEV_POPULATION_UPDATED_AT_DESC = 'FACILITIES_STDDEV_POPULATION_UPDATED_AT_DESC',
  FACILITIES_STDDEV_POPULATION_WMS_ASC = 'FACILITIES_STDDEV_POPULATION_WMS_ASC',
  FACILITIES_STDDEV_POPULATION_WMS_DESC = 'FACILITIES_STDDEV_POPULATION_WMS_DESC',
  FACILITIES_STDDEV_POPULATION_ZIP_ASC = 'FACILITIES_STDDEV_POPULATION_ZIP_ASC',
  FACILITIES_STDDEV_POPULATION_ZIP_DESC = 'FACILITIES_STDDEV_POPULATION_ZIP_DESC',
  FACILITIES_STDDEV_SAMPLE_ADDRESS_ASC = 'FACILITIES_STDDEV_SAMPLE_ADDRESS_ASC',
  FACILITIES_STDDEV_SAMPLE_ADDRESS_DESC = 'FACILITIES_STDDEV_SAMPLE_ADDRESS_DESC',
  FACILITIES_STDDEV_SAMPLE_BONUS_LTR_ASC = 'FACILITIES_STDDEV_SAMPLE_BONUS_LTR_ASC',
  FACILITIES_STDDEV_SAMPLE_BONUS_LTR_DESC = 'FACILITIES_STDDEV_SAMPLE_BONUS_LTR_DESC',
  FACILITIES_STDDEV_SAMPLE_CITY_ASC = 'FACILITIES_STDDEV_SAMPLE_CITY_ASC',
  FACILITIES_STDDEV_SAMPLE_CITY_DESC = 'FACILITIES_STDDEV_SAMPLE_CITY_DESC',
  FACILITIES_STDDEV_SAMPLE_COMMODITY_ASC = 'FACILITIES_STDDEV_SAMPLE_COMMODITY_ASC',
  FACILITIES_STDDEV_SAMPLE_COMMODITY_DESC = 'FACILITIES_STDDEV_SAMPLE_COMMODITY_DESC',
  FACILITIES_STDDEV_SAMPLE_CONTXT_9249_ASC = 'FACILITIES_STDDEV_SAMPLE_CONTXT_9249_ASC',
  FACILITIES_STDDEV_SAMPLE_CONTXT_9249_DESC = 'FACILITIES_STDDEV_SAMPLE_CONTXT_9249_DESC',
  FACILITIES_STDDEV_SAMPLE_COST_CENTER_ASC = 'FACILITIES_STDDEV_SAMPLE_COST_CENTER_ASC',
  FACILITIES_STDDEV_SAMPLE_COST_CENTER_DESC = 'FACILITIES_STDDEV_SAMPLE_COST_CENTER_DESC',
  FACILITIES_STDDEV_SAMPLE_COUNTRY_ASC = 'FACILITIES_STDDEV_SAMPLE_COUNTRY_ASC',
  FACILITIES_STDDEV_SAMPLE_COUNTRY_DESC = 'FACILITIES_STDDEV_SAMPLE_COUNTRY_DESC',
  FACILITIES_STDDEV_SAMPLE_CREATED_AT_ASC = 'FACILITIES_STDDEV_SAMPLE_CREATED_AT_ASC',
  FACILITIES_STDDEV_SAMPLE_CREATED_AT_DESC = 'FACILITIES_STDDEV_SAMPLE_CREATED_AT_DESC',
  FACILITIES_STDDEV_SAMPLE_CUSTOMER_LOCATION_ID_ASC = 'FACILITIES_STDDEV_SAMPLE_CUSTOMER_LOCATION_ID_ASC',
  FACILITIES_STDDEV_SAMPLE_CUSTOMER_LOCATION_ID_DESC = 'FACILITIES_STDDEV_SAMPLE_CUSTOMER_LOCATION_ID_DESC',
  FACILITIES_STDDEV_SAMPLE_DATATYPE_1_TEST_ASC = 'FACILITIES_STDDEV_SAMPLE_DATATYPE_1_TEST_ASC',
  FACILITIES_STDDEV_SAMPLE_DATATYPE_1_TEST_DESC = 'FACILITIES_STDDEV_SAMPLE_DATATYPE_1_TEST_DESC',
  FACILITIES_STDDEV_SAMPLE_DATA_TYPE_2_TEST_ASC = 'FACILITIES_STDDEV_SAMPLE_DATA_TYPE_2_TEST_ASC',
  FACILITIES_STDDEV_SAMPLE_DATA_TYPE_2_TEST_DESC = 'FACILITIES_STDDEV_SAMPLE_DATA_TYPE_2_TEST_DESC',
  FACILITIES_STDDEV_SAMPLE_DATA_TYPE_3_TEST_ASC = 'FACILITIES_STDDEV_SAMPLE_DATA_TYPE_3_TEST_ASC',
  FACILITIES_STDDEV_SAMPLE_DATA_TYPE_3_TEST_DESC = 'FACILITIES_STDDEV_SAMPLE_DATA_TYPE_3_TEST_DESC',
  FACILITIES_STDDEV_SAMPLE_FACILITY_CONTACTS_ASC = 'FACILITIES_STDDEV_SAMPLE_FACILITY_CONTACTS_ASC',
  FACILITIES_STDDEV_SAMPLE_FACILITY_CONTACTS_DESC = 'FACILITIES_STDDEV_SAMPLE_FACILITY_CONTACTS_DESC',
  FACILITIES_STDDEV_SAMPLE_FLOOR_PLAN_GEOMETRY_ASC = 'FACILITIES_STDDEV_SAMPLE_FLOOR_PLAN_GEOMETRY_ASC',
  FACILITIES_STDDEV_SAMPLE_FLOOR_PLAN_GEOMETRY_DESC = 'FACILITIES_STDDEV_SAMPLE_FLOOR_PLAN_GEOMETRY_DESC',
  FACILITIES_STDDEV_SAMPLE_GEOMETRY_ASC = 'FACILITIES_STDDEV_SAMPLE_GEOMETRY_ASC',
  FACILITIES_STDDEV_SAMPLE_GEOMETRY_DESC = 'FACILITIES_STDDEV_SAMPLE_GEOMETRY_DESC',
  FACILITIES_STDDEV_SAMPLE_GO_LIVE_DATE_ASC = 'FACILITIES_STDDEV_SAMPLE_GO_LIVE_DATE_ASC',
  FACILITIES_STDDEV_SAMPLE_GO_LIVE_DATE_DESC = 'FACILITIES_STDDEV_SAMPLE_GO_LIVE_DATE_DESC',
  FACILITIES_STDDEV_SAMPLE_ID_ASC = 'FACILITIES_STDDEV_SAMPLE_ID_ASC',
  FACILITIES_STDDEV_SAMPLE_ID_DESC = 'FACILITIES_STDDEV_SAMPLE_ID_DESC',
  FACILITIES_STDDEV_SAMPLE_LATITUDE_ASC = 'FACILITIES_STDDEV_SAMPLE_LATITUDE_ASC',
  FACILITIES_STDDEV_SAMPLE_LATITUDE_DESC = 'FACILITIES_STDDEV_SAMPLE_LATITUDE_DESC',
  FACILITIES_STDDEV_SAMPLE_LINK_ACTIVE_ASC = 'FACILITIES_STDDEV_SAMPLE_LINK_ACTIVE_ASC',
  FACILITIES_STDDEV_SAMPLE_LINK_ACTIVE_DESC = 'FACILITIES_STDDEV_SAMPLE_LINK_ACTIVE_DESC',
  FACILITIES_STDDEV_SAMPLE_LONGITUDE_ASC = 'FACILITIES_STDDEV_SAMPLE_LONGITUDE_ASC',
  FACILITIES_STDDEV_SAMPLE_LONGITUDE_DESC = 'FACILITIES_STDDEV_SAMPLE_LONGITUDE_DESC',
  FACILITIES_STDDEV_SAMPLE_METRICS_ONE_ACTIVE_ASC = 'FACILITIES_STDDEV_SAMPLE_METRICS_ONE_ACTIVE_ASC',
  FACILITIES_STDDEV_SAMPLE_METRICS_ONE_ACTIVE_DESC = 'FACILITIES_STDDEV_SAMPLE_METRICS_ONE_ACTIVE_DESC',
  FACILITIES_STDDEV_SAMPLE_NAME_ASC = 'FACILITIES_STDDEV_SAMPLE_NAME_ASC',
  FACILITIES_STDDEV_SAMPLE_NAME_DESC = 'FACILITIES_STDDEV_SAMPLE_NAME_DESC',
  FACILITIES_STDDEV_SAMPLE_NOTE_ASC = 'FACILITIES_STDDEV_SAMPLE_NOTE_ASC',
  FACILITIES_STDDEV_SAMPLE_NOTE_DESC = 'FACILITIES_STDDEV_SAMPLE_NOTE_DESC',
  FACILITIES_STDDEV_SAMPLE_N_SIGHT_2_ACTIVE_ASC = 'FACILITIES_STDDEV_SAMPLE_N_SIGHT_2_ACTIVE_ASC',
  FACILITIES_STDDEV_SAMPLE_N_SIGHT_2_ACTIVE_DESC = 'FACILITIES_STDDEV_SAMPLE_N_SIGHT_2_ACTIVE_DESC',
  FACILITIES_STDDEV_SAMPLE_N_SIGHT_ACTIVE_ASC = 'FACILITIES_STDDEV_SAMPLE_N_SIGHT_ACTIVE_ASC',
  FACILITIES_STDDEV_SAMPLE_N_SIGHT_ACTIVE_DESC = 'FACILITIES_STDDEV_SAMPLE_N_SIGHT_ACTIVE_DESC',
  FACILITIES_STDDEV_SAMPLE_PRE_BONUS_EBITDA_ASC = 'FACILITIES_STDDEV_SAMPLE_PRE_BONUS_EBITDA_ASC',
  FACILITIES_STDDEV_SAMPLE_PRE_BONUS_EBITDA_DESC = 'FACILITIES_STDDEV_SAMPLE_PRE_BONUS_EBITDA_DESC',
  FACILITIES_STDDEV_SAMPLE_PRICING_NODE_ID_ASC = 'FACILITIES_STDDEV_SAMPLE_PRICING_NODE_ID_ASC',
  FACILITIES_STDDEV_SAMPLE_PRICING_NODE_ID_DESC = 'FACILITIES_STDDEV_SAMPLE_PRICING_NODE_ID_DESC',
  FACILITIES_STDDEV_SAMPLE_REAL_TIME_ENABLED_ASC = 'FACILITIES_STDDEV_SAMPLE_REAL_TIME_ENABLED_ASC',
  FACILITIES_STDDEV_SAMPLE_REAL_TIME_ENABLED_DESC = 'FACILITIES_STDDEV_SAMPLE_REAL_TIME_ENABLED_DESC',
  FACILITIES_STDDEV_SAMPLE_REFRIGERATIONVENDOR_ASC = 'FACILITIES_STDDEV_SAMPLE_REFRIGERATIONVENDOR_ASC',
  FACILITIES_STDDEV_SAMPLE_REFRIGERATIONVENDOR_DESC = 'FACILITIES_STDDEV_SAMPLE_REFRIGERATIONVENDOR_DESC',
  FACILITIES_STDDEV_SAMPLE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'FACILITIES_STDDEV_SAMPLE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  FACILITIES_STDDEV_SAMPLE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'FACILITIES_STDDEV_SAMPLE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  FACILITIES_STDDEV_SAMPLE_RETIRED_AT_ASC = 'FACILITIES_STDDEV_SAMPLE_RETIRED_AT_ASC',
  FACILITIES_STDDEV_SAMPLE_RETIRED_AT_DESC = 'FACILITIES_STDDEV_SAMPLE_RETIRED_AT_DESC',
  FACILITIES_STDDEV_SAMPLE_SLUG_ASC = 'FACILITIES_STDDEV_SAMPLE_SLUG_ASC',
  FACILITIES_STDDEV_SAMPLE_SLUG_DESC = 'FACILITIES_STDDEV_SAMPLE_SLUG_DESC',
  FACILITIES_STDDEV_SAMPLE_STATE_ASC = 'FACILITIES_STDDEV_SAMPLE_STATE_ASC',
  FACILITIES_STDDEV_SAMPLE_STATE_DESC = 'FACILITIES_STDDEV_SAMPLE_STATE_DESC',
  FACILITIES_STDDEV_SAMPLE_SUPPRESSE_FINANCIALS_ASC = 'FACILITIES_STDDEV_SAMPLE_SUPPRESSE_FINANCIALS_ASC',
  FACILITIES_STDDEV_SAMPLE_SUPPRESSE_FINANCIALS_DESC = 'FACILITIES_STDDEV_SAMPLE_SUPPRESSE_FINANCIALS_DESC',
  FACILITIES_STDDEV_SAMPLE_TAT_ATTRIBUTE_ASC = 'FACILITIES_STDDEV_SAMPLE_TAT_ATTRIBUTE_ASC',
  FACILITIES_STDDEV_SAMPLE_TAT_ATTRIBUTE_DESC = 'FACILITIES_STDDEV_SAMPLE_TAT_ATTRIBUTE_DESC',
  FACILITIES_STDDEV_SAMPLE_TIMEZONE_NAME_ASC = 'FACILITIES_STDDEV_SAMPLE_TIMEZONE_NAME_ASC',
  FACILITIES_STDDEV_SAMPLE_TIMEZONE_NAME_DESC = 'FACILITIES_STDDEV_SAMPLE_TIMEZONE_NAME_DESC',
  FACILITIES_STDDEV_SAMPLE_TYPE_ASC = 'FACILITIES_STDDEV_SAMPLE_TYPE_ASC',
  FACILITIES_STDDEV_SAMPLE_TYPE_DESC = 'FACILITIES_STDDEV_SAMPLE_TYPE_DESC',
  FACILITIES_STDDEV_SAMPLE_UNIT_GROUP_ASC = 'FACILITIES_STDDEV_SAMPLE_UNIT_GROUP_ASC',
  FACILITIES_STDDEV_SAMPLE_UNIT_GROUP_DESC = 'FACILITIES_STDDEV_SAMPLE_UNIT_GROUP_DESC',
  FACILITIES_STDDEV_SAMPLE_UPDATED_AT_ASC = 'FACILITIES_STDDEV_SAMPLE_UPDATED_AT_ASC',
  FACILITIES_STDDEV_SAMPLE_UPDATED_AT_DESC = 'FACILITIES_STDDEV_SAMPLE_UPDATED_AT_DESC',
  FACILITIES_STDDEV_SAMPLE_WMS_ASC = 'FACILITIES_STDDEV_SAMPLE_WMS_ASC',
  FACILITIES_STDDEV_SAMPLE_WMS_DESC = 'FACILITIES_STDDEV_SAMPLE_WMS_DESC',
  FACILITIES_STDDEV_SAMPLE_ZIP_ASC = 'FACILITIES_STDDEV_SAMPLE_ZIP_ASC',
  FACILITIES_STDDEV_SAMPLE_ZIP_DESC = 'FACILITIES_STDDEV_SAMPLE_ZIP_DESC',
  FACILITIES_SUM_ADDRESS_ASC = 'FACILITIES_SUM_ADDRESS_ASC',
  FACILITIES_SUM_ADDRESS_DESC = 'FACILITIES_SUM_ADDRESS_DESC',
  FACILITIES_SUM_BONUS_LTR_ASC = 'FACILITIES_SUM_BONUS_LTR_ASC',
  FACILITIES_SUM_BONUS_LTR_DESC = 'FACILITIES_SUM_BONUS_LTR_DESC',
  FACILITIES_SUM_CITY_ASC = 'FACILITIES_SUM_CITY_ASC',
  FACILITIES_SUM_CITY_DESC = 'FACILITIES_SUM_CITY_DESC',
  FACILITIES_SUM_COMMODITY_ASC = 'FACILITIES_SUM_COMMODITY_ASC',
  FACILITIES_SUM_COMMODITY_DESC = 'FACILITIES_SUM_COMMODITY_DESC',
  FACILITIES_SUM_CONTXT_9249_ASC = 'FACILITIES_SUM_CONTXT_9249_ASC',
  FACILITIES_SUM_CONTXT_9249_DESC = 'FACILITIES_SUM_CONTXT_9249_DESC',
  FACILITIES_SUM_COST_CENTER_ASC = 'FACILITIES_SUM_COST_CENTER_ASC',
  FACILITIES_SUM_COST_CENTER_DESC = 'FACILITIES_SUM_COST_CENTER_DESC',
  FACILITIES_SUM_COUNTRY_ASC = 'FACILITIES_SUM_COUNTRY_ASC',
  FACILITIES_SUM_COUNTRY_DESC = 'FACILITIES_SUM_COUNTRY_DESC',
  FACILITIES_SUM_CREATED_AT_ASC = 'FACILITIES_SUM_CREATED_AT_ASC',
  FACILITIES_SUM_CREATED_AT_DESC = 'FACILITIES_SUM_CREATED_AT_DESC',
  FACILITIES_SUM_CUSTOMER_LOCATION_ID_ASC = 'FACILITIES_SUM_CUSTOMER_LOCATION_ID_ASC',
  FACILITIES_SUM_CUSTOMER_LOCATION_ID_DESC = 'FACILITIES_SUM_CUSTOMER_LOCATION_ID_DESC',
  FACILITIES_SUM_DATATYPE_1_TEST_ASC = 'FACILITIES_SUM_DATATYPE_1_TEST_ASC',
  FACILITIES_SUM_DATATYPE_1_TEST_DESC = 'FACILITIES_SUM_DATATYPE_1_TEST_DESC',
  FACILITIES_SUM_DATA_TYPE_2_TEST_ASC = 'FACILITIES_SUM_DATA_TYPE_2_TEST_ASC',
  FACILITIES_SUM_DATA_TYPE_2_TEST_DESC = 'FACILITIES_SUM_DATA_TYPE_2_TEST_DESC',
  FACILITIES_SUM_DATA_TYPE_3_TEST_ASC = 'FACILITIES_SUM_DATA_TYPE_3_TEST_ASC',
  FACILITIES_SUM_DATA_TYPE_3_TEST_DESC = 'FACILITIES_SUM_DATA_TYPE_3_TEST_DESC',
  FACILITIES_SUM_FACILITY_CONTACTS_ASC = 'FACILITIES_SUM_FACILITY_CONTACTS_ASC',
  FACILITIES_SUM_FACILITY_CONTACTS_DESC = 'FACILITIES_SUM_FACILITY_CONTACTS_DESC',
  FACILITIES_SUM_FLOOR_PLAN_GEOMETRY_ASC = 'FACILITIES_SUM_FLOOR_PLAN_GEOMETRY_ASC',
  FACILITIES_SUM_FLOOR_PLAN_GEOMETRY_DESC = 'FACILITIES_SUM_FLOOR_PLAN_GEOMETRY_DESC',
  FACILITIES_SUM_GEOMETRY_ASC = 'FACILITIES_SUM_GEOMETRY_ASC',
  FACILITIES_SUM_GEOMETRY_DESC = 'FACILITIES_SUM_GEOMETRY_DESC',
  FACILITIES_SUM_GO_LIVE_DATE_ASC = 'FACILITIES_SUM_GO_LIVE_DATE_ASC',
  FACILITIES_SUM_GO_LIVE_DATE_DESC = 'FACILITIES_SUM_GO_LIVE_DATE_DESC',
  FACILITIES_SUM_ID_ASC = 'FACILITIES_SUM_ID_ASC',
  FACILITIES_SUM_ID_DESC = 'FACILITIES_SUM_ID_DESC',
  FACILITIES_SUM_LATITUDE_ASC = 'FACILITIES_SUM_LATITUDE_ASC',
  FACILITIES_SUM_LATITUDE_DESC = 'FACILITIES_SUM_LATITUDE_DESC',
  FACILITIES_SUM_LINK_ACTIVE_ASC = 'FACILITIES_SUM_LINK_ACTIVE_ASC',
  FACILITIES_SUM_LINK_ACTIVE_DESC = 'FACILITIES_SUM_LINK_ACTIVE_DESC',
  FACILITIES_SUM_LONGITUDE_ASC = 'FACILITIES_SUM_LONGITUDE_ASC',
  FACILITIES_SUM_LONGITUDE_DESC = 'FACILITIES_SUM_LONGITUDE_DESC',
  FACILITIES_SUM_METRICS_ONE_ACTIVE_ASC = 'FACILITIES_SUM_METRICS_ONE_ACTIVE_ASC',
  FACILITIES_SUM_METRICS_ONE_ACTIVE_DESC = 'FACILITIES_SUM_METRICS_ONE_ACTIVE_DESC',
  FACILITIES_SUM_NAME_ASC = 'FACILITIES_SUM_NAME_ASC',
  FACILITIES_SUM_NAME_DESC = 'FACILITIES_SUM_NAME_DESC',
  FACILITIES_SUM_NOTE_ASC = 'FACILITIES_SUM_NOTE_ASC',
  FACILITIES_SUM_NOTE_DESC = 'FACILITIES_SUM_NOTE_DESC',
  FACILITIES_SUM_N_SIGHT_2_ACTIVE_ASC = 'FACILITIES_SUM_N_SIGHT_2_ACTIVE_ASC',
  FACILITIES_SUM_N_SIGHT_2_ACTIVE_DESC = 'FACILITIES_SUM_N_SIGHT_2_ACTIVE_DESC',
  FACILITIES_SUM_N_SIGHT_ACTIVE_ASC = 'FACILITIES_SUM_N_SIGHT_ACTIVE_ASC',
  FACILITIES_SUM_N_SIGHT_ACTIVE_DESC = 'FACILITIES_SUM_N_SIGHT_ACTIVE_DESC',
  FACILITIES_SUM_PRE_BONUS_EBITDA_ASC = 'FACILITIES_SUM_PRE_BONUS_EBITDA_ASC',
  FACILITIES_SUM_PRE_BONUS_EBITDA_DESC = 'FACILITIES_SUM_PRE_BONUS_EBITDA_DESC',
  FACILITIES_SUM_PRICING_NODE_ID_ASC = 'FACILITIES_SUM_PRICING_NODE_ID_ASC',
  FACILITIES_SUM_PRICING_NODE_ID_DESC = 'FACILITIES_SUM_PRICING_NODE_ID_DESC',
  FACILITIES_SUM_REAL_TIME_ENABLED_ASC = 'FACILITIES_SUM_REAL_TIME_ENABLED_ASC',
  FACILITIES_SUM_REAL_TIME_ENABLED_DESC = 'FACILITIES_SUM_REAL_TIME_ENABLED_DESC',
  FACILITIES_SUM_REFRIGERATIONVENDOR_ASC = 'FACILITIES_SUM_REFRIGERATIONVENDOR_ASC',
  FACILITIES_SUM_REFRIGERATIONVENDOR_DESC = 'FACILITIES_SUM_REFRIGERATIONVENDOR_DESC',
  FACILITIES_SUM_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'FACILITIES_SUM_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  FACILITIES_SUM_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'FACILITIES_SUM_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  FACILITIES_SUM_RETIRED_AT_ASC = 'FACILITIES_SUM_RETIRED_AT_ASC',
  FACILITIES_SUM_RETIRED_AT_DESC = 'FACILITIES_SUM_RETIRED_AT_DESC',
  FACILITIES_SUM_SLUG_ASC = 'FACILITIES_SUM_SLUG_ASC',
  FACILITIES_SUM_SLUG_DESC = 'FACILITIES_SUM_SLUG_DESC',
  FACILITIES_SUM_STATE_ASC = 'FACILITIES_SUM_STATE_ASC',
  FACILITIES_SUM_STATE_DESC = 'FACILITIES_SUM_STATE_DESC',
  FACILITIES_SUM_SUPPRESSE_FINANCIALS_ASC = 'FACILITIES_SUM_SUPPRESSE_FINANCIALS_ASC',
  FACILITIES_SUM_SUPPRESSE_FINANCIALS_DESC = 'FACILITIES_SUM_SUPPRESSE_FINANCIALS_DESC',
  FACILITIES_SUM_TAT_ATTRIBUTE_ASC = 'FACILITIES_SUM_TAT_ATTRIBUTE_ASC',
  FACILITIES_SUM_TAT_ATTRIBUTE_DESC = 'FACILITIES_SUM_TAT_ATTRIBUTE_DESC',
  FACILITIES_SUM_TIMEZONE_NAME_ASC = 'FACILITIES_SUM_TIMEZONE_NAME_ASC',
  FACILITIES_SUM_TIMEZONE_NAME_DESC = 'FACILITIES_SUM_TIMEZONE_NAME_DESC',
  FACILITIES_SUM_TYPE_ASC = 'FACILITIES_SUM_TYPE_ASC',
  FACILITIES_SUM_TYPE_DESC = 'FACILITIES_SUM_TYPE_DESC',
  FACILITIES_SUM_UNIT_GROUP_ASC = 'FACILITIES_SUM_UNIT_GROUP_ASC',
  FACILITIES_SUM_UNIT_GROUP_DESC = 'FACILITIES_SUM_UNIT_GROUP_DESC',
  FACILITIES_SUM_UPDATED_AT_ASC = 'FACILITIES_SUM_UPDATED_AT_ASC',
  FACILITIES_SUM_UPDATED_AT_DESC = 'FACILITIES_SUM_UPDATED_AT_DESC',
  FACILITIES_SUM_WMS_ASC = 'FACILITIES_SUM_WMS_ASC',
  FACILITIES_SUM_WMS_DESC = 'FACILITIES_SUM_WMS_DESC',
  FACILITIES_SUM_ZIP_ASC = 'FACILITIES_SUM_ZIP_ASC',
  FACILITIES_SUM_ZIP_DESC = 'FACILITIES_SUM_ZIP_DESC',
  FACILITIES_VARIANCE_POPULATION_ADDRESS_ASC = 'FACILITIES_VARIANCE_POPULATION_ADDRESS_ASC',
  FACILITIES_VARIANCE_POPULATION_ADDRESS_DESC = 'FACILITIES_VARIANCE_POPULATION_ADDRESS_DESC',
  FACILITIES_VARIANCE_POPULATION_BONUS_LTR_ASC = 'FACILITIES_VARIANCE_POPULATION_BONUS_LTR_ASC',
  FACILITIES_VARIANCE_POPULATION_BONUS_LTR_DESC = 'FACILITIES_VARIANCE_POPULATION_BONUS_LTR_DESC',
  FACILITIES_VARIANCE_POPULATION_CITY_ASC = 'FACILITIES_VARIANCE_POPULATION_CITY_ASC',
  FACILITIES_VARIANCE_POPULATION_CITY_DESC = 'FACILITIES_VARIANCE_POPULATION_CITY_DESC',
  FACILITIES_VARIANCE_POPULATION_COMMODITY_ASC = 'FACILITIES_VARIANCE_POPULATION_COMMODITY_ASC',
  FACILITIES_VARIANCE_POPULATION_COMMODITY_DESC = 'FACILITIES_VARIANCE_POPULATION_COMMODITY_DESC',
  FACILITIES_VARIANCE_POPULATION_CONTXT_9249_ASC = 'FACILITIES_VARIANCE_POPULATION_CONTXT_9249_ASC',
  FACILITIES_VARIANCE_POPULATION_CONTXT_9249_DESC = 'FACILITIES_VARIANCE_POPULATION_CONTXT_9249_DESC',
  FACILITIES_VARIANCE_POPULATION_COST_CENTER_ASC = 'FACILITIES_VARIANCE_POPULATION_COST_CENTER_ASC',
  FACILITIES_VARIANCE_POPULATION_COST_CENTER_DESC = 'FACILITIES_VARIANCE_POPULATION_COST_CENTER_DESC',
  FACILITIES_VARIANCE_POPULATION_COUNTRY_ASC = 'FACILITIES_VARIANCE_POPULATION_COUNTRY_ASC',
  FACILITIES_VARIANCE_POPULATION_COUNTRY_DESC = 'FACILITIES_VARIANCE_POPULATION_COUNTRY_DESC',
  FACILITIES_VARIANCE_POPULATION_CREATED_AT_ASC = 'FACILITIES_VARIANCE_POPULATION_CREATED_AT_ASC',
  FACILITIES_VARIANCE_POPULATION_CREATED_AT_DESC = 'FACILITIES_VARIANCE_POPULATION_CREATED_AT_DESC',
  FACILITIES_VARIANCE_POPULATION_CUSTOMER_LOCATION_ID_ASC = 'FACILITIES_VARIANCE_POPULATION_CUSTOMER_LOCATION_ID_ASC',
  FACILITIES_VARIANCE_POPULATION_CUSTOMER_LOCATION_ID_DESC = 'FACILITIES_VARIANCE_POPULATION_CUSTOMER_LOCATION_ID_DESC',
  FACILITIES_VARIANCE_POPULATION_DATATYPE_1_TEST_ASC = 'FACILITIES_VARIANCE_POPULATION_DATATYPE_1_TEST_ASC',
  FACILITIES_VARIANCE_POPULATION_DATATYPE_1_TEST_DESC = 'FACILITIES_VARIANCE_POPULATION_DATATYPE_1_TEST_DESC',
  FACILITIES_VARIANCE_POPULATION_DATA_TYPE_2_TEST_ASC = 'FACILITIES_VARIANCE_POPULATION_DATA_TYPE_2_TEST_ASC',
  FACILITIES_VARIANCE_POPULATION_DATA_TYPE_2_TEST_DESC = 'FACILITIES_VARIANCE_POPULATION_DATA_TYPE_2_TEST_DESC',
  FACILITIES_VARIANCE_POPULATION_DATA_TYPE_3_TEST_ASC = 'FACILITIES_VARIANCE_POPULATION_DATA_TYPE_3_TEST_ASC',
  FACILITIES_VARIANCE_POPULATION_DATA_TYPE_3_TEST_DESC = 'FACILITIES_VARIANCE_POPULATION_DATA_TYPE_3_TEST_DESC',
  FACILITIES_VARIANCE_POPULATION_FACILITY_CONTACTS_ASC = 'FACILITIES_VARIANCE_POPULATION_FACILITY_CONTACTS_ASC',
  FACILITIES_VARIANCE_POPULATION_FACILITY_CONTACTS_DESC = 'FACILITIES_VARIANCE_POPULATION_FACILITY_CONTACTS_DESC',
  FACILITIES_VARIANCE_POPULATION_FLOOR_PLAN_GEOMETRY_ASC = 'FACILITIES_VARIANCE_POPULATION_FLOOR_PLAN_GEOMETRY_ASC',
  FACILITIES_VARIANCE_POPULATION_FLOOR_PLAN_GEOMETRY_DESC = 'FACILITIES_VARIANCE_POPULATION_FLOOR_PLAN_GEOMETRY_DESC',
  FACILITIES_VARIANCE_POPULATION_GEOMETRY_ASC = 'FACILITIES_VARIANCE_POPULATION_GEOMETRY_ASC',
  FACILITIES_VARIANCE_POPULATION_GEOMETRY_DESC = 'FACILITIES_VARIANCE_POPULATION_GEOMETRY_DESC',
  FACILITIES_VARIANCE_POPULATION_GO_LIVE_DATE_ASC = 'FACILITIES_VARIANCE_POPULATION_GO_LIVE_DATE_ASC',
  FACILITIES_VARIANCE_POPULATION_GO_LIVE_DATE_DESC = 'FACILITIES_VARIANCE_POPULATION_GO_LIVE_DATE_DESC',
  FACILITIES_VARIANCE_POPULATION_ID_ASC = 'FACILITIES_VARIANCE_POPULATION_ID_ASC',
  FACILITIES_VARIANCE_POPULATION_ID_DESC = 'FACILITIES_VARIANCE_POPULATION_ID_DESC',
  FACILITIES_VARIANCE_POPULATION_LATITUDE_ASC = 'FACILITIES_VARIANCE_POPULATION_LATITUDE_ASC',
  FACILITIES_VARIANCE_POPULATION_LATITUDE_DESC = 'FACILITIES_VARIANCE_POPULATION_LATITUDE_DESC',
  FACILITIES_VARIANCE_POPULATION_LINK_ACTIVE_ASC = 'FACILITIES_VARIANCE_POPULATION_LINK_ACTIVE_ASC',
  FACILITIES_VARIANCE_POPULATION_LINK_ACTIVE_DESC = 'FACILITIES_VARIANCE_POPULATION_LINK_ACTIVE_DESC',
  FACILITIES_VARIANCE_POPULATION_LONGITUDE_ASC = 'FACILITIES_VARIANCE_POPULATION_LONGITUDE_ASC',
  FACILITIES_VARIANCE_POPULATION_LONGITUDE_DESC = 'FACILITIES_VARIANCE_POPULATION_LONGITUDE_DESC',
  FACILITIES_VARIANCE_POPULATION_METRICS_ONE_ACTIVE_ASC = 'FACILITIES_VARIANCE_POPULATION_METRICS_ONE_ACTIVE_ASC',
  FACILITIES_VARIANCE_POPULATION_METRICS_ONE_ACTIVE_DESC = 'FACILITIES_VARIANCE_POPULATION_METRICS_ONE_ACTIVE_DESC',
  FACILITIES_VARIANCE_POPULATION_NAME_ASC = 'FACILITIES_VARIANCE_POPULATION_NAME_ASC',
  FACILITIES_VARIANCE_POPULATION_NAME_DESC = 'FACILITIES_VARIANCE_POPULATION_NAME_DESC',
  FACILITIES_VARIANCE_POPULATION_NOTE_ASC = 'FACILITIES_VARIANCE_POPULATION_NOTE_ASC',
  FACILITIES_VARIANCE_POPULATION_NOTE_DESC = 'FACILITIES_VARIANCE_POPULATION_NOTE_DESC',
  FACILITIES_VARIANCE_POPULATION_N_SIGHT_2_ACTIVE_ASC = 'FACILITIES_VARIANCE_POPULATION_N_SIGHT_2_ACTIVE_ASC',
  FACILITIES_VARIANCE_POPULATION_N_SIGHT_2_ACTIVE_DESC = 'FACILITIES_VARIANCE_POPULATION_N_SIGHT_2_ACTIVE_DESC',
  FACILITIES_VARIANCE_POPULATION_N_SIGHT_ACTIVE_ASC = 'FACILITIES_VARIANCE_POPULATION_N_SIGHT_ACTIVE_ASC',
  FACILITIES_VARIANCE_POPULATION_N_SIGHT_ACTIVE_DESC = 'FACILITIES_VARIANCE_POPULATION_N_SIGHT_ACTIVE_DESC',
  FACILITIES_VARIANCE_POPULATION_PRE_BONUS_EBITDA_ASC = 'FACILITIES_VARIANCE_POPULATION_PRE_BONUS_EBITDA_ASC',
  FACILITIES_VARIANCE_POPULATION_PRE_BONUS_EBITDA_DESC = 'FACILITIES_VARIANCE_POPULATION_PRE_BONUS_EBITDA_DESC',
  FACILITIES_VARIANCE_POPULATION_PRICING_NODE_ID_ASC = 'FACILITIES_VARIANCE_POPULATION_PRICING_NODE_ID_ASC',
  FACILITIES_VARIANCE_POPULATION_PRICING_NODE_ID_DESC = 'FACILITIES_VARIANCE_POPULATION_PRICING_NODE_ID_DESC',
  FACILITIES_VARIANCE_POPULATION_REAL_TIME_ENABLED_ASC = 'FACILITIES_VARIANCE_POPULATION_REAL_TIME_ENABLED_ASC',
  FACILITIES_VARIANCE_POPULATION_REAL_TIME_ENABLED_DESC = 'FACILITIES_VARIANCE_POPULATION_REAL_TIME_ENABLED_DESC',
  FACILITIES_VARIANCE_POPULATION_REFRIGERATIONVENDOR_ASC = 'FACILITIES_VARIANCE_POPULATION_REFRIGERATIONVENDOR_ASC',
  FACILITIES_VARIANCE_POPULATION_REFRIGERATIONVENDOR_DESC = 'FACILITIES_VARIANCE_POPULATION_REFRIGERATIONVENDOR_DESC',
  FACILITIES_VARIANCE_POPULATION_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'FACILITIES_VARIANCE_POPULATION_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  FACILITIES_VARIANCE_POPULATION_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'FACILITIES_VARIANCE_POPULATION_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  FACILITIES_VARIANCE_POPULATION_RETIRED_AT_ASC = 'FACILITIES_VARIANCE_POPULATION_RETIRED_AT_ASC',
  FACILITIES_VARIANCE_POPULATION_RETIRED_AT_DESC = 'FACILITIES_VARIANCE_POPULATION_RETIRED_AT_DESC',
  FACILITIES_VARIANCE_POPULATION_SLUG_ASC = 'FACILITIES_VARIANCE_POPULATION_SLUG_ASC',
  FACILITIES_VARIANCE_POPULATION_SLUG_DESC = 'FACILITIES_VARIANCE_POPULATION_SLUG_DESC',
  FACILITIES_VARIANCE_POPULATION_STATE_ASC = 'FACILITIES_VARIANCE_POPULATION_STATE_ASC',
  FACILITIES_VARIANCE_POPULATION_STATE_DESC = 'FACILITIES_VARIANCE_POPULATION_STATE_DESC',
  FACILITIES_VARIANCE_POPULATION_SUPPRESSE_FINANCIALS_ASC = 'FACILITIES_VARIANCE_POPULATION_SUPPRESSE_FINANCIALS_ASC',
  FACILITIES_VARIANCE_POPULATION_SUPPRESSE_FINANCIALS_DESC = 'FACILITIES_VARIANCE_POPULATION_SUPPRESSE_FINANCIALS_DESC',
  FACILITIES_VARIANCE_POPULATION_TAT_ATTRIBUTE_ASC = 'FACILITIES_VARIANCE_POPULATION_TAT_ATTRIBUTE_ASC',
  FACILITIES_VARIANCE_POPULATION_TAT_ATTRIBUTE_DESC = 'FACILITIES_VARIANCE_POPULATION_TAT_ATTRIBUTE_DESC',
  FACILITIES_VARIANCE_POPULATION_TIMEZONE_NAME_ASC = 'FACILITIES_VARIANCE_POPULATION_TIMEZONE_NAME_ASC',
  FACILITIES_VARIANCE_POPULATION_TIMEZONE_NAME_DESC = 'FACILITIES_VARIANCE_POPULATION_TIMEZONE_NAME_DESC',
  FACILITIES_VARIANCE_POPULATION_TYPE_ASC = 'FACILITIES_VARIANCE_POPULATION_TYPE_ASC',
  FACILITIES_VARIANCE_POPULATION_TYPE_DESC = 'FACILITIES_VARIANCE_POPULATION_TYPE_DESC',
  FACILITIES_VARIANCE_POPULATION_UNIT_GROUP_ASC = 'FACILITIES_VARIANCE_POPULATION_UNIT_GROUP_ASC',
  FACILITIES_VARIANCE_POPULATION_UNIT_GROUP_DESC = 'FACILITIES_VARIANCE_POPULATION_UNIT_GROUP_DESC',
  FACILITIES_VARIANCE_POPULATION_UPDATED_AT_ASC = 'FACILITIES_VARIANCE_POPULATION_UPDATED_AT_ASC',
  FACILITIES_VARIANCE_POPULATION_UPDATED_AT_DESC = 'FACILITIES_VARIANCE_POPULATION_UPDATED_AT_DESC',
  FACILITIES_VARIANCE_POPULATION_WMS_ASC = 'FACILITIES_VARIANCE_POPULATION_WMS_ASC',
  FACILITIES_VARIANCE_POPULATION_WMS_DESC = 'FACILITIES_VARIANCE_POPULATION_WMS_DESC',
  FACILITIES_VARIANCE_POPULATION_ZIP_ASC = 'FACILITIES_VARIANCE_POPULATION_ZIP_ASC',
  FACILITIES_VARIANCE_POPULATION_ZIP_DESC = 'FACILITIES_VARIANCE_POPULATION_ZIP_DESC',
  FACILITIES_VARIANCE_SAMPLE_ADDRESS_ASC = 'FACILITIES_VARIANCE_SAMPLE_ADDRESS_ASC',
  FACILITIES_VARIANCE_SAMPLE_ADDRESS_DESC = 'FACILITIES_VARIANCE_SAMPLE_ADDRESS_DESC',
  FACILITIES_VARIANCE_SAMPLE_BONUS_LTR_ASC = 'FACILITIES_VARIANCE_SAMPLE_BONUS_LTR_ASC',
  FACILITIES_VARIANCE_SAMPLE_BONUS_LTR_DESC = 'FACILITIES_VARIANCE_SAMPLE_BONUS_LTR_DESC',
  FACILITIES_VARIANCE_SAMPLE_CITY_ASC = 'FACILITIES_VARIANCE_SAMPLE_CITY_ASC',
  FACILITIES_VARIANCE_SAMPLE_CITY_DESC = 'FACILITIES_VARIANCE_SAMPLE_CITY_DESC',
  FACILITIES_VARIANCE_SAMPLE_COMMODITY_ASC = 'FACILITIES_VARIANCE_SAMPLE_COMMODITY_ASC',
  FACILITIES_VARIANCE_SAMPLE_COMMODITY_DESC = 'FACILITIES_VARIANCE_SAMPLE_COMMODITY_DESC',
  FACILITIES_VARIANCE_SAMPLE_CONTXT_9249_ASC = 'FACILITIES_VARIANCE_SAMPLE_CONTXT_9249_ASC',
  FACILITIES_VARIANCE_SAMPLE_CONTXT_9249_DESC = 'FACILITIES_VARIANCE_SAMPLE_CONTXT_9249_DESC',
  FACILITIES_VARIANCE_SAMPLE_COST_CENTER_ASC = 'FACILITIES_VARIANCE_SAMPLE_COST_CENTER_ASC',
  FACILITIES_VARIANCE_SAMPLE_COST_CENTER_DESC = 'FACILITIES_VARIANCE_SAMPLE_COST_CENTER_DESC',
  FACILITIES_VARIANCE_SAMPLE_COUNTRY_ASC = 'FACILITIES_VARIANCE_SAMPLE_COUNTRY_ASC',
  FACILITIES_VARIANCE_SAMPLE_COUNTRY_DESC = 'FACILITIES_VARIANCE_SAMPLE_COUNTRY_DESC',
  FACILITIES_VARIANCE_SAMPLE_CREATED_AT_ASC = 'FACILITIES_VARIANCE_SAMPLE_CREATED_AT_ASC',
  FACILITIES_VARIANCE_SAMPLE_CREATED_AT_DESC = 'FACILITIES_VARIANCE_SAMPLE_CREATED_AT_DESC',
  FACILITIES_VARIANCE_SAMPLE_CUSTOMER_LOCATION_ID_ASC = 'FACILITIES_VARIANCE_SAMPLE_CUSTOMER_LOCATION_ID_ASC',
  FACILITIES_VARIANCE_SAMPLE_CUSTOMER_LOCATION_ID_DESC = 'FACILITIES_VARIANCE_SAMPLE_CUSTOMER_LOCATION_ID_DESC',
  FACILITIES_VARIANCE_SAMPLE_DATATYPE_1_TEST_ASC = 'FACILITIES_VARIANCE_SAMPLE_DATATYPE_1_TEST_ASC',
  FACILITIES_VARIANCE_SAMPLE_DATATYPE_1_TEST_DESC = 'FACILITIES_VARIANCE_SAMPLE_DATATYPE_1_TEST_DESC',
  FACILITIES_VARIANCE_SAMPLE_DATA_TYPE_2_TEST_ASC = 'FACILITIES_VARIANCE_SAMPLE_DATA_TYPE_2_TEST_ASC',
  FACILITIES_VARIANCE_SAMPLE_DATA_TYPE_2_TEST_DESC = 'FACILITIES_VARIANCE_SAMPLE_DATA_TYPE_2_TEST_DESC',
  FACILITIES_VARIANCE_SAMPLE_DATA_TYPE_3_TEST_ASC = 'FACILITIES_VARIANCE_SAMPLE_DATA_TYPE_3_TEST_ASC',
  FACILITIES_VARIANCE_SAMPLE_DATA_TYPE_3_TEST_DESC = 'FACILITIES_VARIANCE_SAMPLE_DATA_TYPE_3_TEST_DESC',
  FACILITIES_VARIANCE_SAMPLE_FACILITY_CONTACTS_ASC = 'FACILITIES_VARIANCE_SAMPLE_FACILITY_CONTACTS_ASC',
  FACILITIES_VARIANCE_SAMPLE_FACILITY_CONTACTS_DESC = 'FACILITIES_VARIANCE_SAMPLE_FACILITY_CONTACTS_DESC',
  FACILITIES_VARIANCE_SAMPLE_FLOOR_PLAN_GEOMETRY_ASC = 'FACILITIES_VARIANCE_SAMPLE_FLOOR_PLAN_GEOMETRY_ASC',
  FACILITIES_VARIANCE_SAMPLE_FLOOR_PLAN_GEOMETRY_DESC = 'FACILITIES_VARIANCE_SAMPLE_FLOOR_PLAN_GEOMETRY_DESC',
  FACILITIES_VARIANCE_SAMPLE_GEOMETRY_ASC = 'FACILITIES_VARIANCE_SAMPLE_GEOMETRY_ASC',
  FACILITIES_VARIANCE_SAMPLE_GEOMETRY_DESC = 'FACILITIES_VARIANCE_SAMPLE_GEOMETRY_DESC',
  FACILITIES_VARIANCE_SAMPLE_GO_LIVE_DATE_ASC = 'FACILITIES_VARIANCE_SAMPLE_GO_LIVE_DATE_ASC',
  FACILITIES_VARIANCE_SAMPLE_GO_LIVE_DATE_DESC = 'FACILITIES_VARIANCE_SAMPLE_GO_LIVE_DATE_DESC',
  FACILITIES_VARIANCE_SAMPLE_ID_ASC = 'FACILITIES_VARIANCE_SAMPLE_ID_ASC',
  FACILITIES_VARIANCE_SAMPLE_ID_DESC = 'FACILITIES_VARIANCE_SAMPLE_ID_DESC',
  FACILITIES_VARIANCE_SAMPLE_LATITUDE_ASC = 'FACILITIES_VARIANCE_SAMPLE_LATITUDE_ASC',
  FACILITIES_VARIANCE_SAMPLE_LATITUDE_DESC = 'FACILITIES_VARIANCE_SAMPLE_LATITUDE_DESC',
  FACILITIES_VARIANCE_SAMPLE_LINK_ACTIVE_ASC = 'FACILITIES_VARIANCE_SAMPLE_LINK_ACTIVE_ASC',
  FACILITIES_VARIANCE_SAMPLE_LINK_ACTIVE_DESC = 'FACILITIES_VARIANCE_SAMPLE_LINK_ACTIVE_DESC',
  FACILITIES_VARIANCE_SAMPLE_LONGITUDE_ASC = 'FACILITIES_VARIANCE_SAMPLE_LONGITUDE_ASC',
  FACILITIES_VARIANCE_SAMPLE_LONGITUDE_DESC = 'FACILITIES_VARIANCE_SAMPLE_LONGITUDE_DESC',
  FACILITIES_VARIANCE_SAMPLE_METRICS_ONE_ACTIVE_ASC = 'FACILITIES_VARIANCE_SAMPLE_METRICS_ONE_ACTIVE_ASC',
  FACILITIES_VARIANCE_SAMPLE_METRICS_ONE_ACTIVE_DESC = 'FACILITIES_VARIANCE_SAMPLE_METRICS_ONE_ACTIVE_DESC',
  FACILITIES_VARIANCE_SAMPLE_NAME_ASC = 'FACILITIES_VARIANCE_SAMPLE_NAME_ASC',
  FACILITIES_VARIANCE_SAMPLE_NAME_DESC = 'FACILITIES_VARIANCE_SAMPLE_NAME_DESC',
  FACILITIES_VARIANCE_SAMPLE_NOTE_ASC = 'FACILITIES_VARIANCE_SAMPLE_NOTE_ASC',
  FACILITIES_VARIANCE_SAMPLE_NOTE_DESC = 'FACILITIES_VARIANCE_SAMPLE_NOTE_DESC',
  FACILITIES_VARIANCE_SAMPLE_N_SIGHT_2_ACTIVE_ASC = 'FACILITIES_VARIANCE_SAMPLE_N_SIGHT_2_ACTIVE_ASC',
  FACILITIES_VARIANCE_SAMPLE_N_SIGHT_2_ACTIVE_DESC = 'FACILITIES_VARIANCE_SAMPLE_N_SIGHT_2_ACTIVE_DESC',
  FACILITIES_VARIANCE_SAMPLE_N_SIGHT_ACTIVE_ASC = 'FACILITIES_VARIANCE_SAMPLE_N_SIGHT_ACTIVE_ASC',
  FACILITIES_VARIANCE_SAMPLE_N_SIGHT_ACTIVE_DESC = 'FACILITIES_VARIANCE_SAMPLE_N_SIGHT_ACTIVE_DESC',
  FACILITIES_VARIANCE_SAMPLE_PRE_BONUS_EBITDA_ASC = 'FACILITIES_VARIANCE_SAMPLE_PRE_BONUS_EBITDA_ASC',
  FACILITIES_VARIANCE_SAMPLE_PRE_BONUS_EBITDA_DESC = 'FACILITIES_VARIANCE_SAMPLE_PRE_BONUS_EBITDA_DESC',
  FACILITIES_VARIANCE_SAMPLE_PRICING_NODE_ID_ASC = 'FACILITIES_VARIANCE_SAMPLE_PRICING_NODE_ID_ASC',
  FACILITIES_VARIANCE_SAMPLE_PRICING_NODE_ID_DESC = 'FACILITIES_VARIANCE_SAMPLE_PRICING_NODE_ID_DESC',
  FACILITIES_VARIANCE_SAMPLE_REAL_TIME_ENABLED_ASC = 'FACILITIES_VARIANCE_SAMPLE_REAL_TIME_ENABLED_ASC',
  FACILITIES_VARIANCE_SAMPLE_REAL_TIME_ENABLED_DESC = 'FACILITIES_VARIANCE_SAMPLE_REAL_TIME_ENABLED_DESC',
  FACILITIES_VARIANCE_SAMPLE_REFRIGERATIONVENDOR_ASC = 'FACILITIES_VARIANCE_SAMPLE_REFRIGERATIONVENDOR_ASC',
  FACILITIES_VARIANCE_SAMPLE_REFRIGERATIONVENDOR_DESC = 'FACILITIES_VARIANCE_SAMPLE_REFRIGERATIONVENDOR_DESC',
  FACILITIES_VARIANCE_SAMPLE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC = 'FACILITIES_VARIANCE_SAMPLE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_ASC',
  FACILITIES_VARIANCE_SAMPLE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC = 'FACILITIES_VARIANCE_SAMPLE_REFRIGERATION_CONTROL_SYSTEM_VENDOR_DESC',
  FACILITIES_VARIANCE_SAMPLE_RETIRED_AT_ASC = 'FACILITIES_VARIANCE_SAMPLE_RETIRED_AT_ASC',
  FACILITIES_VARIANCE_SAMPLE_RETIRED_AT_DESC = 'FACILITIES_VARIANCE_SAMPLE_RETIRED_AT_DESC',
  FACILITIES_VARIANCE_SAMPLE_SLUG_ASC = 'FACILITIES_VARIANCE_SAMPLE_SLUG_ASC',
  FACILITIES_VARIANCE_SAMPLE_SLUG_DESC = 'FACILITIES_VARIANCE_SAMPLE_SLUG_DESC',
  FACILITIES_VARIANCE_SAMPLE_STATE_ASC = 'FACILITIES_VARIANCE_SAMPLE_STATE_ASC',
  FACILITIES_VARIANCE_SAMPLE_STATE_DESC = 'FACILITIES_VARIANCE_SAMPLE_STATE_DESC',
  FACILITIES_VARIANCE_SAMPLE_SUPPRESSE_FINANCIALS_ASC = 'FACILITIES_VARIANCE_SAMPLE_SUPPRESSE_FINANCIALS_ASC',
  FACILITIES_VARIANCE_SAMPLE_SUPPRESSE_FINANCIALS_DESC = 'FACILITIES_VARIANCE_SAMPLE_SUPPRESSE_FINANCIALS_DESC',
  FACILITIES_VARIANCE_SAMPLE_TAT_ATTRIBUTE_ASC = 'FACILITIES_VARIANCE_SAMPLE_TAT_ATTRIBUTE_ASC',
  FACILITIES_VARIANCE_SAMPLE_TAT_ATTRIBUTE_DESC = 'FACILITIES_VARIANCE_SAMPLE_TAT_ATTRIBUTE_DESC',
  FACILITIES_VARIANCE_SAMPLE_TIMEZONE_NAME_ASC = 'FACILITIES_VARIANCE_SAMPLE_TIMEZONE_NAME_ASC',
  FACILITIES_VARIANCE_SAMPLE_TIMEZONE_NAME_DESC = 'FACILITIES_VARIANCE_SAMPLE_TIMEZONE_NAME_DESC',
  FACILITIES_VARIANCE_SAMPLE_TYPE_ASC = 'FACILITIES_VARIANCE_SAMPLE_TYPE_ASC',
  FACILITIES_VARIANCE_SAMPLE_TYPE_DESC = 'FACILITIES_VARIANCE_SAMPLE_TYPE_DESC',
  FACILITIES_VARIANCE_SAMPLE_UNIT_GROUP_ASC = 'FACILITIES_VARIANCE_SAMPLE_UNIT_GROUP_ASC',
  FACILITIES_VARIANCE_SAMPLE_UNIT_GROUP_DESC = 'FACILITIES_VARIANCE_SAMPLE_UNIT_GROUP_DESC',
  FACILITIES_VARIANCE_SAMPLE_UPDATED_AT_ASC = 'FACILITIES_VARIANCE_SAMPLE_UPDATED_AT_ASC',
  FACILITIES_VARIANCE_SAMPLE_UPDATED_AT_DESC = 'FACILITIES_VARIANCE_SAMPLE_UPDATED_AT_DESC',
  FACILITIES_VARIANCE_SAMPLE_WMS_ASC = 'FACILITIES_VARIANCE_SAMPLE_WMS_ASC',
  FACILITIES_VARIANCE_SAMPLE_WMS_DESC = 'FACILITIES_VARIANCE_SAMPLE_WMS_DESC',
  FACILITIES_VARIANCE_SAMPLE_ZIP_ASC = 'FACILITIES_VARIANCE_SAMPLE_ZIP_ASC',
  FACILITIES_VARIANCE_SAMPLE_ZIP_DESC = 'FACILITIES_VARIANCE_SAMPLE_ZIP_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UNIT_GROUP_DIMENSIONS_AVERAGE_CREATED_AT_ASC = 'UNIT_GROUP_DIMENSIONS_AVERAGE_CREATED_AT_ASC',
  UNIT_GROUP_DIMENSIONS_AVERAGE_CREATED_AT_DESC = 'UNIT_GROUP_DIMENSIONS_AVERAGE_CREATED_AT_DESC',
  UNIT_GROUP_DIMENSIONS_AVERAGE_UNIT_ASC = 'UNIT_GROUP_DIMENSIONS_AVERAGE_UNIT_ASC',
  UNIT_GROUP_DIMENSIONS_AVERAGE_UNIT_DESC = 'UNIT_GROUP_DIMENSIONS_AVERAGE_UNIT_DESC',
  UNIT_GROUP_DIMENSIONS_AVERAGE_UNIT_DIMENSION_ASC = 'UNIT_GROUP_DIMENSIONS_AVERAGE_UNIT_DIMENSION_ASC',
  UNIT_GROUP_DIMENSIONS_AVERAGE_UNIT_DIMENSION_DESC = 'UNIT_GROUP_DIMENSIONS_AVERAGE_UNIT_DIMENSION_DESC',
  UNIT_GROUP_DIMENSIONS_AVERAGE_UNIT_GROUP_ASC = 'UNIT_GROUP_DIMENSIONS_AVERAGE_UNIT_GROUP_ASC',
  UNIT_GROUP_DIMENSIONS_AVERAGE_UNIT_GROUP_DESC = 'UNIT_GROUP_DIMENSIONS_AVERAGE_UNIT_GROUP_DESC',
  UNIT_GROUP_DIMENSIONS_AVERAGE_UPDATED_AT_ASC = 'UNIT_GROUP_DIMENSIONS_AVERAGE_UPDATED_AT_ASC',
  UNIT_GROUP_DIMENSIONS_AVERAGE_UPDATED_AT_DESC = 'UNIT_GROUP_DIMENSIONS_AVERAGE_UPDATED_AT_DESC',
  UNIT_GROUP_DIMENSIONS_COUNT_ASC = 'UNIT_GROUP_DIMENSIONS_COUNT_ASC',
  UNIT_GROUP_DIMENSIONS_COUNT_DESC = 'UNIT_GROUP_DIMENSIONS_COUNT_DESC',
  UNIT_GROUP_DIMENSIONS_DISTINCT_COUNT_CREATED_AT_ASC = 'UNIT_GROUP_DIMENSIONS_DISTINCT_COUNT_CREATED_AT_ASC',
  UNIT_GROUP_DIMENSIONS_DISTINCT_COUNT_CREATED_AT_DESC = 'UNIT_GROUP_DIMENSIONS_DISTINCT_COUNT_CREATED_AT_DESC',
  UNIT_GROUP_DIMENSIONS_DISTINCT_COUNT_UNIT_ASC = 'UNIT_GROUP_DIMENSIONS_DISTINCT_COUNT_UNIT_ASC',
  UNIT_GROUP_DIMENSIONS_DISTINCT_COUNT_UNIT_DESC = 'UNIT_GROUP_DIMENSIONS_DISTINCT_COUNT_UNIT_DESC',
  UNIT_GROUP_DIMENSIONS_DISTINCT_COUNT_UNIT_DIMENSION_ASC = 'UNIT_GROUP_DIMENSIONS_DISTINCT_COUNT_UNIT_DIMENSION_ASC',
  UNIT_GROUP_DIMENSIONS_DISTINCT_COUNT_UNIT_DIMENSION_DESC = 'UNIT_GROUP_DIMENSIONS_DISTINCT_COUNT_UNIT_DIMENSION_DESC',
  UNIT_GROUP_DIMENSIONS_DISTINCT_COUNT_UNIT_GROUP_ASC = 'UNIT_GROUP_DIMENSIONS_DISTINCT_COUNT_UNIT_GROUP_ASC',
  UNIT_GROUP_DIMENSIONS_DISTINCT_COUNT_UNIT_GROUP_DESC = 'UNIT_GROUP_DIMENSIONS_DISTINCT_COUNT_UNIT_GROUP_DESC',
  UNIT_GROUP_DIMENSIONS_DISTINCT_COUNT_UPDATED_AT_ASC = 'UNIT_GROUP_DIMENSIONS_DISTINCT_COUNT_UPDATED_AT_ASC',
  UNIT_GROUP_DIMENSIONS_DISTINCT_COUNT_UPDATED_AT_DESC = 'UNIT_GROUP_DIMENSIONS_DISTINCT_COUNT_UPDATED_AT_DESC',
  UNIT_GROUP_DIMENSIONS_DISTINCT_CREATED_AT_ASC = 'UNIT_GROUP_DIMENSIONS_DISTINCT_CREATED_AT_ASC',
  UNIT_GROUP_DIMENSIONS_DISTINCT_CREATED_AT_DESC = 'UNIT_GROUP_DIMENSIONS_DISTINCT_CREATED_AT_DESC',
  UNIT_GROUP_DIMENSIONS_DISTINCT_UNIT_ASC = 'UNIT_GROUP_DIMENSIONS_DISTINCT_UNIT_ASC',
  UNIT_GROUP_DIMENSIONS_DISTINCT_UNIT_DESC = 'UNIT_GROUP_DIMENSIONS_DISTINCT_UNIT_DESC',
  UNIT_GROUP_DIMENSIONS_DISTINCT_UNIT_DIMENSION_ASC = 'UNIT_GROUP_DIMENSIONS_DISTINCT_UNIT_DIMENSION_ASC',
  UNIT_GROUP_DIMENSIONS_DISTINCT_UNIT_DIMENSION_DESC = 'UNIT_GROUP_DIMENSIONS_DISTINCT_UNIT_DIMENSION_DESC',
  UNIT_GROUP_DIMENSIONS_DISTINCT_UNIT_GROUP_ASC = 'UNIT_GROUP_DIMENSIONS_DISTINCT_UNIT_GROUP_ASC',
  UNIT_GROUP_DIMENSIONS_DISTINCT_UNIT_GROUP_DESC = 'UNIT_GROUP_DIMENSIONS_DISTINCT_UNIT_GROUP_DESC',
  UNIT_GROUP_DIMENSIONS_DISTINCT_UPDATED_AT_ASC = 'UNIT_GROUP_DIMENSIONS_DISTINCT_UPDATED_AT_ASC',
  UNIT_GROUP_DIMENSIONS_DISTINCT_UPDATED_AT_DESC = 'UNIT_GROUP_DIMENSIONS_DISTINCT_UPDATED_AT_DESC',
  UNIT_GROUP_DIMENSIONS_MAX_CREATED_AT_ASC = 'UNIT_GROUP_DIMENSIONS_MAX_CREATED_AT_ASC',
  UNIT_GROUP_DIMENSIONS_MAX_CREATED_AT_DESC = 'UNIT_GROUP_DIMENSIONS_MAX_CREATED_AT_DESC',
  UNIT_GROUP_DIMENSIONS_MAX_UNIT_ASC = 'UNIT_GROUP_DIMENSIONS_MAX_UNIT_ASC',
  UNIT_GROUP_DIMENSIONS_MAX_UNIT_DESC = 'UNIT_GROUP_DIMENSIONS_MAX_UNIT_DESC',
  UNIT_GROUP_DIMENSIONS_MAX_UNIT_DIMENSION_ASC = 'UNIT_GROUP_DIMENSIONS_MAX_UNIT_DIMENSION_ASC',
  UNIT_GROUP_DIMENSIONS_MAX_UNIT_DIMENSION_DESC = 'UNIT_GROUP_DIMENSIONS_MAX_UNIT_DIMENSION_DESC',
  UNIT_GROUP_DIMENSIONS_MAX_UNIT_GROUP_ASC = 'UNIT_GROUP_DIMENSIONS_MAX_UNIT_GROUP_ASC',
  UNIT_GROUP_DIMENSIONS_MAX_UNIT_GROUP_DESC = 'UNIT_GROUP_DIMENSIONS_MAX_UNIT_GROUP_DESC',
  UNIT_GROUP_DIMENSIONS_MAX_UPDATED_AT_ASC = 'UNIT_GROUP_DIMENSIONS_MAX_UPDATED_AT_ASC',
  UNIT_GROUP_DIMENSIONS_MAX_UPDATED_AT_DESC = 'UNIT_GROUP_DIMENSIONS_MAX_UPDATED_AT_DESC',
  UNIT_GROUP_DIMENSIONS_MIN_CREATED_AT_ASC = 'UNIT_GROUP_DIMENSIONS_MIN_CREATED_AT_ASC',
  UNIT_GROUP_DIMENSIONS_MIN_CREATED_AT_DESC = 'UNIT_GROUP_DIMENSIONS_MIN_CREATED_AT_DESC',
  UNIT_GROUP_DIMENSIONS_MIN_UNIT_ASC = 'UNIT_GROUP_DIMENSIONS_MIN_UNIT_ASC',
  UNIT_GROUP_DIMENSIONS_MIN_UNIT_DESC = 'UNIT_GROUP_DIMENSIONS_MIN_UNIT_DESC',
  UNIT_GROUP_DIMENSIONS_MIN_UNIT_DIMENSION_ASC = 'UNIT_GROUP_DIMENSIONS_MIN_UNIT_DIMENSION_ASC',
  UNIT_GROUP_DIMENSIONS_MIN_UNIT_DIMENSION_DESC = 'UNIT_GROUP_DIMENSIONS_MIN_UNIT_DIMENSION_DESC',
  UNIT_GROUP_DIMENSIONS_MIN_UNIT_GROUP_ASC = 'UNIT_GROUP_DIMENSIONS_MIN_UNIT_GROUP_ASC',
  UNIT_GROUP_DIMENSIONS_MIN_UNIT_GROUP_DESC = 'UNIT_GROUP_DIMENSIONS_MIN_UNIT_GROUP_DESC',
  UNIT_GROUP_DIMENSIONS_MIN_UPDATED_AT_ASC = 'UNIT_GROUP_DIMENSIONS_MIN_UPDATED_AT_ASC',
  UNIT_GROUP_DIMENSIONS_MIN_UPDATED_AT_DESC = 'UNIT_GROUP_DIMENSIONS_MIN_UPDATED_AT_DESC',
  UNIT_GROUP_DIMENSIONS_STDDEV_POPULATION_CREATED_AT_ASC = 'UNIT_GROUP_DIMENSIONS_STDDEV_POPULATION_CREATED_AT_ASC',
  UNIT_GROUP_DIMENSIONS_STDDEV_POPULATION_CREATED_AT_DESC = 'UNIT_GROUP_DIMENSIONS_STDDEV_POPULATION_CREATED_AT_DESC',
  UNIT_GROUP_DIMENSIONS_STDDEV_POPULATION_UNIT_ASC = 'UNIT_GROUP_DIMENSIONS_STDDEV_POPULATION_UNIT_ASC',
  UNIT_GROUP_DIMENSIONS_STDDEV_POPULATION_UNIT_DESC = 'UNIT_GROUP_DIMENSIONS_STDDEV_POPULATION_UNIT_DESC',
  UNIT_GROUP_DIMENSIONS_STDDEV_POPULATION_UNIT_DIMENSION_ASC = 'UNIT_GROUP_DIMENSIONS_STDDEV_POPULATION_UNIT_DIMENSION_ASC',
  UNIT_GROUP_DIMENSIONS_STDDEV_POPULATION_UNIT_DIMENSION_DESC = 'UNIT_GROUP_DIMENSIONS_STDDEV_POPULATION_UNIT_DIMENSION_DESC',
  UNIT_GROUP_DIMENSIONS_STDDEV_POPULATION_UNIT_GROUP_ASC = 'UNIT_GROUP_DIMENSIONS_STDDEV_POPULATION_UNIT_GROUP_ASC',
  UNIT_GROUP_DIMENSIONS_STDDEV_POPULATION_UNIT_GROUP_DESC = 'UNIT_GROUP_DIMENSIONS_STDDEV_POPULATION_UNIT_GROUP_DESC',
  UNIT_GROUP_DIMENSIONS_STDDEV_POPULATION_UPDATED_AT_ASC = 'UNIT_GROUP_DIMENSIONS_STDDEV_POPULATION_UPDATED_AT_ASC',
  UNIT_GROUP_DIMENSIONS_STDDEV_POPULATION_UPDATED_AT_DESC = 'UNIT_GROUP_DIMENSIONS_STDDEV_POPULATION_UPDATED_AT_DESC',
  UNIT_GROUP_DIMENSIONS_STDDEV_SAMPLE_CREATED_AT_ASC = 'UNIT_GROUP_DIMENSIONS_STDDEV_SAMPLE_CREATED_AT_ASC',
  UNIT_GROUP_DIMENSIONS_STDDEV_SAMPLE_CREATED_AT_DESC = 'UNIT_GROUP_DIMENSIONS_STDDEV_SAMPLE_CREATED_AT_DESC',
  UNIT_GROUP_DIMENSIONS_STDDEV_SAMPLE_UNIT_ASC = 'UNIT_GROUP_DIMENSIONS_STDDEV_SAMPLE_UNIT_ASC',
  UNIT_GROUP_DIMENSIONS_STDDEV_SAMPLE_UNIT_DESC = 'UNIT_GROUP_DIMENSIONS_STDDEV_SAMPLE_UNIT_DESC',
  UNIT_GROUP_DIMENSIONS_STDDEV_SAMPLE_UNIT_DIMENSION_ASC = 'UNIT_GROUP_DIMENSIONS_STDDEV_SAMPLE_UNIT_DIMENSION_ASC',
  UNIT_GROUP_DIMENSIONS_STDDEV_SAMPLE_UNIT_DIMENSION_DESC = 'UNIT_GROUP_DIMENSIONS_STDDEV_SAMPLE_UNIT_DIMENSION_DESC',
  UNIT_GROUP_DIMENSIONS_STDDEV_SAMPLE_UNIT_GROUP_ASC = 'UNIT_GROUP_DIMENSIONS_STDDEV_SAMPLE_UNIT_GROUP_ASC',
  UNIT_GROUP_DIMENSIONS_STDDEV_SAMPLE_UNIT_GROUP_DESC = 'UNIT_GROUP_DIMENSIONS_STDDEV_SAMPLE_UNIT_GROUP_DESC',
  UNIT_GROUP_DIMENSIONS_STDDEV_SAMPLE_UPDATED_AT_ASC = 'UNIT_GROUP_DIMENSIONS_STDDEV_SAMPLE_UPDATED_AT_ASC',
  UNIT_GROUP_DIMENSIONS_STDDEV_SAMPLE_UPDATED_AT_DESC = 'UNIT_GROUP_DIMENSIONS_STDDEV_SAMPLE_UPDATED_AT_DESC',
  UNIT_GROUP_DIMENSIONS_SUM_CREATED_AT_ASC = 'UNIT_GROUP_DIMENSIONS_SUM_CREATED_AT_ASC',
  UNIT_GROUP_DIMENSIONS_SUM_CREATED_AT_DESC = 'UNIT_GROUP_DIMENSIONS_SUM_CREATED_AT_DESC',
  UNIT_GROUP_DIMENSIONS_SUM_UNIT_ASC = 'UNIT_GROUP_DIMENSIONS_SUM_UNIT_ASC',
  UNIT_GROUP_DIMENSIONS_SUM_UNIT_DESC = 'UNIT_GROUP_DIMENSIONS_SUM_UNIT_DESC',
  UNIT_GROUP_DIMENSIONS_SUM_UNIT_DIMENSION_ASC = 'UNIT_GROUP_DIMENSIONS_SUM_UNIT_DIMENSION_ASC',
  UNIT_GROUP_DIMENSIONS_SUM_UNIT_DIMENSION_DESC = 'UNIT_GROUP_DIMENSIONS_SUM_UNIT_DIMENSION_DESC',
  UNIT_GROUP_DIMENSIONS_SUM_UNIT_GROUP_ASC = 'UNIT_GROUP_DIMENSIONS_SUM_UNIT_GROUP_ASC',
  UNIT_GROUP_DIMENSIONS_SUM_UNIT_GROUP_DESC = 'UNIT_GROUP_DIMENSIONS_SUM_UNIT_GROUP_DESC',
  UNIT_GROUP_DIMENSIONS_SUM_UPDATED_AT_ASC = 'UNIT_GROUP_DIMENSIONS_SUM_UPDATED_AT_ASC',
  UNIT_GROUP_DIMENSIONS_SUM_UPDATED_AT_DESC = 'UNIT_GROUP_DIMENSIONS_SUM_UPDATED_AT_DESC',
  UNIT_GROUP_DIMENSIONS_VARIANCE_POPULATION_CREATED_AT_ASC = 'UNIT_GROUP_DIMENSIONS_VARIANCE_POPULATION_CREATED_AT_ASC',
  UNIT_GROUP_DIMENSIONS_VARIANCE_POPULATION_CREATED_AT_DESC = 'UNIT_GROUP_DIMENSIONS_VARIANCE_POPULATION_CREATED_AT_DESC',
  UNIT_GROUP_DIMENSIONS_VARIANCE_POPULATION_UNIT_ASC = 'UNIT_GROUP_DIMENSIONS_VARIANCE_POPULATION_UNIT_ASC',
  UNIT_GROUP_DIMENSIONS_VARIANCE_POPULATION_UNIT_DESC = 'UNIT_GROUP_DIMENSIONS_VARIANCE_POPULATION_UNIT_DESC',
  UNIT_GROUP_DIMENSIONS_VARIANCE_POPULATION_UNIT_DIMENSION_ASC = 'UNIT_GROUP_DIMENSIONS_VARIANCE_POPULATION_UNIT_DIMENSION_ASC',
  UNIT_GROUP_DIMENSIONS_VARIANCE_POPULATION_UNIT_DIMENSION_DESC = 'UNIT_GROUP_DIMENSIONS_VARIANCE_POPULATION_UNIT_DIMENSION_DESC',
  UNIT_GROUP_DIMENSIONS_VARIANCE_POPULATION_UNIT_GROUP_ASC = 'UNIT_GROUP_DIMENSIONS_VARIANCE_POPULATION_UNIT_GROUP_ASC',
  UNIT_GROUP_DIMENSIONS_VARIANCE_POPULATION_UNIT_GROUP_DESC = 'UNIT_GROUP_DIMENSIONS_VARIANCE_POPULATION_UNIT_GROUP_DESC',
  UNIT_GROUP_DIMENSIONS_VARIANCE_POPULATION_UPDATED_AT_ASC = 'UNIT_GROUP_DIMENSIONS_VARIANCE_POPULATION_UPDATED_AT_ASC',
  UNIT_GROUP_DIMENSIONS_VARIANCE_POPULATION_UPDATED_AT_DESC = 'UNIT_GROUP_DIMENSIONS_VARIANCE_POPULATION_UPDATED_AT_DESC',
  UNIT_GROUP_DIMENSIONS_VARIANCE_SAMPLE_CREATED_AT_ASC = 'UNIT_GROUP_DIMENSIONS_VARIANCE_SAMPLE_CREATED_AT_ASC',
  UNIT_GROUP_DIMENSIONS_VARIANCE_SAMPLE_CREATED_AT_DESC = 'UNIT_GROUP_DIMENSIONS_VARIANCE_SAMPLE_CREATED_AT_DESC',
  UNIT_GROUP_DIMENSIONS_VARIANCE_SAMPLE_UNIT_ASC = 'UNIT_GROUP_DIMENSIONS_VARIANCE_SAMPLE_UNIT_ASC',
  UNIT_GROUP_DIMENSIONS_VARIANCE_SAMPLE_UNIT_DESC = 'UNIT_GROUP_DIMENSIONS_VARIANCE_SAMPLE_UNIT_DESC',
  UNIT_GROUP_DIMENSIONS_VARIANCE_SAMPLE_UNIT_DIMENSION_ASC = 'UNIT_GROUP_DIMENSIONS_VARIANCE_SAMPLE_UNIT_DIMENSION_ASC',
  UNIT_GROUP_DIMENSIONS_VARIANCE_SAMPLE_UNIT_DIMENSION_DESC = 'UNIT_GROUP_DIMENSIONS_VARIANCE_SAMPLE_UNIT_DIMENSION_DESC',
  UNIT_GROUP_DIMENSIONS_VARIANCE_SAMPLE_UNIT_GROUP_ASC = 'UNIT_GROUP_DIMENSIONS_VARIANCE_SAMPLE_UNIT_GROUP_ASC',
  UNIT_GROUP_DIMENSIONS_VARIANCE_SAMPLE_UNIT_GROUP_DESC = 'UNIT_GROUP_DIMENSIONS_VARIANCE_SAMPLE_UNIT_GROUP_DESC',
  UNIT_GROUP_DIMENSIONS_VARIANCE_SAMPLE_UPDATED_AT_ASC = 'UNIT_GROUP_DIMENSIONS_VARIANCE_SAMPLE_UPDATED_AT_ASC',
  UNIT_GROUP_DIMENSIONS_VARIANCE_SAMPLE_UPDATED_AT_DESC = 'UNIT_GROUP_DIMENSIONS_VARIANCE_SAMPLE_UPDATED_AT_DESC'
}

/** All input for the `updateAccountCharge` mutation. */
export type UpdateAccountChargeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `AccountCharge` being updated. */
  patch: AccountChargePatch;
};

/** The output of our update `AccountCharge` mutation. */
export type UpdateAccountChargePayload = {
  __typename?: 'UpdateAccountChargePayload';
  /** The `AccountCharge` that was updated by this mutation. */
  accountCharge?: Maybe<AccountCharge>;
  /** An edge for our `AccountCharge`. May be used by Relay 1. */
  accountChargeEdge?: Maybe<AccountChargesEdge>;
  /** Reads a single `AccountStatement` that is related to this `AccountCharge`. */
  accountStatement?: Maybe<AccountStatement>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `AccountCharge` mutation. */
export type UpdateAccountChargePayloadAccountChargeEdgeArgs = {
  orderBy?: InputMaybe<Array<AccountChargesOrderBy>>;
};

/** All input for the `updateAccountStatement` mutation. */
export type UpdateAccountStatementInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `AccountStatement` being updated. */
  patch: AccountStatementPatch;
};

/** The output of our update `AccountStatement` mutation. */
export type UpdateAccountStatementPayload = {
  __typename?: 'UpdateAccountStatementPayload';
  /** The `AccountStatement` that was updated by this mutation. */
  accountStatement?: Maybe<AccountStatement>;
  /** An edge for our `AccountStatement`. May be used by Relay 1. */
  accountStatementEdge?: Maybe<AccountStatementsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `UtilityAccount` that is related to this `AccountStatement`. */
  utilityAccount?: Maybe<UtilityAccount>;
};

/** The output of our update `AccountStatement` mutation. */
export type UpdateAccountStatementPayloadAccountStatementEdgeArgs = {
  orderBy?: InputMaybe<Array<AccountStatementsOrderBy>>;
};

/** All input for the `updateAssessment` mutation. */
export type UpdateAssessmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifier of the assessment. */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `Assessment` being updated. */
  patch: AssessmentPatch;
};

/** The output of our update `Assessment` mutation. */
export type UpdateAssessmentPayload = {
  __typename?: 'UpdateAssessmentPayload';
  /** The `Assessment` that was updated by this mutation. */
  assessment?: Maybe<Assessment>;
  /** An edge for our `Assessment`. May be used by Relay 1. */
  assessmentEdge?: Maybe<AssessmentsEdge>;
  /** Reads a single `AssessmentType` that is related to this `Assessment`. */
  assessmentType?: Maybe<AssessmentType>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `MonitoredAsset` that is related to this `Assessment`. */
  monitoredAsset?: Maybe<MonitoredAsset>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `Assessment` mutation. */
export type UpdateAssessmentPayloadAssessmentEdgeArgs = {
  orderBy?: InputMaybe<Array<AssessmentsOrderBy>>;
};

/** All input for the `updateAssessmentTypeBySlug` mutation. */
export type UpdateAssessmentTypeBySlugInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `AssessmentType` being updated. */
  patch: AssessmentTypePatch;
  /** The unique slug used to reference the assessment type. */
  slug: Scalars['String']['input'];
};

/** All input for the `updateAssessmentType` mutation. */
export type UpdateAssessmentTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifier of the assessment type. */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `AssessmentType` being updated. */
  patch: AssessmentTypePatch;
};

/** The output of our update `AssessmentType` mutation. */
export type UpdateAssessmentTypePayload = {
  __typename?: 'UpdateAssessmentTypePayload';
  /** The `AssessmentType` that was updated by this mutation. */
  assessmentType?: Maybe<AssessmentType>;
  /** An edge for our `AssessmentType`. May be used by Relay 1. */
  assessmentTypeEdge?: Maybe<AssessmentTypesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SoftwarePackage` that is related to this `AssessmentType`. */
  softwarePackage?: Maybe<SoftwarePackage>;
};

/** The output of our update `AssessmentType` mutation. */
export type UpdateAssessmentTypePayloadAssessmentTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<AssessmentTypesOrderBy>>;
};

/** All input for the `updateBalancingAuthorityBySlug` mutation. */
export type UpdateBalancingAuthorityBySlugInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `BalancingAuthority` being updated. */
  patch: BalancingAuthorityPatch;
  /** The slug identifier of the balancing authority. */
  slug: Scalars['String']['input'];
};

/** All input for the `updateBalancingAuthority` mutation. */
export type UpdateBalancingAuthorityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifer of the balancing authority. */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `BalancingAuthority` being updated. */
  patch: BalancingAuthorityPatch;
};

/** The output of our update `BalancingAuthority` mutation. */
export type UpdateBalancingAuthorityPayload = {
  __typename?: 'UpdateBalancingAuthorityPayload';
  /** The `BalancingAuthority` that was updated by this mutation. */
  balancingAuthority?: Maybe<BalancingAuthority>;
  /** An edge for our `BalancingAuthority`. May be used by Relay 1. */
  balancingAuthorityEdge?: Maybe<BalancingAuthoritiesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `BalancingAuthority` mutation. */
export type UpdateBalancingAuthorityPayloadBalancingAuthorityEdgeArgs = {
  orderBy?: InputMaybe<Array<BalancingAuthoritiesOrderBy>>;
};

/** All input for the `updateBillableCustomerByCarrierCode` mutation. */
export type UpdateBillableCustomerByCarrierCodeInput = {
  /** The carrier code of this customer */
  carrierCode: Scalars['String']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `BillableCustomer` being updated. */
  patch: BillableCustomerPatch;
};

/** All input for the `updateBillableCustomer` mutation. */
export type UpdateBillableCustomerInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The internal ID of this customer */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `BillableCustomer` being updated. */
  patch: BillableCustomerPatch;
};

/** The output of our update `BillableCustomer` mutation. */
export type UpdateBillableCustomerPayload = {
  __typename?: 'UpdateBillableCustomerPayload';
  /** The `BillableCustomer` that was updated by this mutation. */
  billableCustomer?: Maybe<BillableCustomer>;
  /** An edge for our `BillableCustomer`. May be used by Relay 1. */
  billableCustomerEdge?: Maybe<BillableCustomersEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `BillableCustomer` mutation. */
export type UpdateBillableCustomerPayloadBillableCustomerEdgeArgs = {
  orderBy?: InputMaybe<Array<BillableCustomersOrderBy>>;
};

/** All input for the `updateBlastByLabelAndFacilityId` mutation. */
export type UpdateBlastByLabelAndFacilityIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The facility a blast is within */
  facilityId: Scalars['Int']['input'];
  /** The unique local (facility-level) human-readable label of the blast */
  label: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `Blast` being updated. */
  patch: BlastPatch;
};

/** All input for the `updateBlastEvaporator` mutation. */
export type UpdateBlastEvaporatorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `BlastEvaporator` being updated. */
  patch: BlastEvaporatorPatch;
};

/** The output of our update `BlastEvaporator` mutation. */
export type UpdateBlastEvaporatorPayload = {
  __typename?: 'UpdateBlastEvaporatorPayload';
  /** Reads a single `Blast` that is related to this `BlastEvaporator`. */
  blast?: Maybe<Blast>;
  /** The `BlastEvaporator` that was updated by this mutation. */
  blastEvaporator?: Maybe<BlastEvaporator>;
  /** An edge for our `BlastEvaporator`. May be used by Relay 1. */
  blastEvaporatorEdge?: Maybe<BlastEvaporatorsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Evaporator` that is related to this `BlastEvaporator`. */
  evaporator?: Maybe<Evaporator>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `BlastEvaporator` mutation. */
export type UpdateBlastEvaporatorPayloadBlastEvaporatorEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastEvaporatorsOrderBy>>;
};

/** All input for the `updateBlast` mutation. */
export type UpdateBlastInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `Blast` being updated. */
  patch: BlastPatch;
};

/** All input for the `updateBlastPallet` mutation. */
export type UpdateBlastPalletInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `BlastPallet` being updated. */
  patch: BlastPalletPatch;
};

/** All input for the `updateBlastPalletLocation` mutation. */
export type UpdateBlastPalletLocationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `BlastPalletLocation` being updated. */
  patch: BlastPalletLocationPatch;
};

/** The output of our update `BlastPalletLocation` mutation. */
export type UpdateBlastPalletLocationPayload = {
  __typename?: 'UpdateBlastPalletLocationPayload';
  /** Reads a single `Blast` that is related to this `BlastPalletLocation`. */
  blast?: Maybe<Blast>;
  /** The `BlastPalletLocation` that was updated by this mutation. */
  blastPalletLocation?: Maybe<BlastPalletLocation>;
  /** An edge for our `BlastPalletLocation`. May be used by Relay 1. */
  blastPalletLocationEdge?: Maybe<BlastPalletLocationsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `PalletLocation` that is related to this `BlastPalletLocation`. */
  palletLocation?: Maybe<PalletLocation>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `BlastPalletLocation` mutation. */
export type UpdateBlastPalletLocationPayloadBlastPalletLocationEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastPalletLocationsOrderBy>>;
};

/** The output of our update `BlastPallet` mutation. */
export type UpdateBlastPalletPayload = {
  __typename?: 'UpdateBlastPalletPayload';
  /** Reads a single `Blast` that is related to this `BlastPallet`. */
  blast?: Maybe<Blast>;
  /** The `BlastPallet` that was updated by this mutation. */
  blastPallet?: Maybe<BlastPallet>;
  /** An edge for our `BlastPallet`. May be used by Relay 1. */
  blastPalletEdge?: Maybe<BlastPalletsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Pallet` that is related to this `BlastPallet`. */
  pallet?: Maybe<Pallet>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `BlastPallet` mutation. */
export type UpdateBlastPalletPayloadBlastPalletEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastPalletsOrderBy>>;
};

/** The output of our update `Blast` mutation. */
export type UpdateBlastPayload = {
  __typename?: 'UpdateBlastPayload';
  /** Reads a single `DataPoint` that is related to this `Blast`. */
  actualUtilization?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Blast`. */
  automationState?: Maybe<DataPoint>;
  /** The `Blast` that was updated by this mutation. */
  blast?: Maybe<Blast>;
  /** An edge for our `Blast`. May be used by Relay 1. */
  blastEdge?: Maybe<BlastsEdge>;
  /** Reads a single `BlastType` that is related to this `Blast`. */
  blastType?: Maybe<BlastType>;
  /** Reads a single `BuildingArea` that is related to this `Blast`. */
  buildingArea?: Maybe<BuildingArea>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Component` that is related to this `Blast`. */
  component?: Maybe<Component>;
  /** Reads a single `Facility` that is related to this `Blast`. */
  facility?: Maybe<Facility>;
  /** Reads a single `DataPoint` that is related to this `Blast`. */
  idealUtilization?: Maybe<DataPoint>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DataPoint` that is related to this `Blast`. */
  stagingTimer?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Blast`. */
  state?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Blast`. */
  timer?: Maybe<DataPoint>;
};

/** The output of our update `Blast` mutation. */
export type UpdateBlastPayloadBlastEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastsOrderBy>>;
};

/** All input for the `updateBlastRotationAlert` mutation. */
export type UpdateBlastRotationAlertInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifer of the blast rotation alert */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `BlastRotationAlert` being updated. */
  patch: BlastRotationAlertPatch;
};

/** The output of our update `BlastRotationAlert` mutation. */
export type UpdateBlastRotationAlertPayload = {
  __typename?: 'UpdateBlastRotationAlertPayload';
  /** Reads a single `BlastRotation` that is related to this `BlastRotationAlert`. */
  blastRotation?: Maybe<BlastRotation>;
  /** The `BlastRotationAlert` that was updated by this mutation. */
  blastRotationAlert?: Maybe<BlastRotationAlert>;
  /** An edge for our `BlastRotationAlert`. May be used by Relay 1. */
  blastRotationAlertEdge?: Maybe<BlastRotationAlertsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `BlastRotationAlert` mutation. */
export type UpdateBlastRotationAlertPayloadBlastRotationAlertEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastRotationAlertsOrderBy>>;
};

/** All input for the `updateBlastRotationEventLogByBlastRotationIdAndDescriptionAndBlastRotationEventTypeId` mutation. */
export type UpdateBlastRotationEventLogByBlastRotationIdAndDescriptionAndBlastRotationEventTypeIdInput =
  {
    /** The type of event for this record */
    blastRotationEventTypeId: Scalars['String']['input'];
    /** The associated blast rotation */
    blastRotationId: Scalars['Int']['input'];
    /**
     * An arbitrary string value with no semantic meaning. Will be included in the
     * payload verbatim. May be used to track mutations by the client.
     */
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** A short description of the event */
    description: Scalars['String']['input'];
    /** An object where the defined keys will be set on the `BlastRotationEventLog` being updated. */
    patch: BlastRotationEventLogPatch;
  };

/** All input for the `updateBlastRotationEventLog` mutation. */
export type UpdateBlastRotationEventLogInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `BlastRotationEventLog` being updated. */
  patch: BlastRotationEventLogPatch;
};

/** The output of our update `BlastRotationEventLog` mutation. */
export type UpdateBlastRotationEventLogPayload = {
  __typename?: 'UpdateBlastRotationEventLogPayload';
  /** Reads a single `BlastRotation` that is related to this `BlastRotationEventLog`. */
  blastRotation?: Maybe<BlastRotation>;
  /** The `BlastRotationEventLog` that was updated by this mutation. */
  blastRotationEventLog?: Maybe<BlastRotationEventLog>;
  /** An edge for our `BlastRotationEventLog`. May be used by Relay 1. */
  blastRotationEventLogEdge?: Maybe<BlastRotationEventLogsEdge>;
  /** Reads a single `BlastRotationEventType` that is related to this `BlastRotationEventLog`. */
  blastRotationEventType?: Maybe<BlastRotationEventType>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `BlastRotationEventLog` mutation. */
export type UpdateBlastRotationEventLogPayloadBlastRotationEventLogEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastRotationEventLogsOrderBy>>;
};

/** All input for the `updateBlastRotationEventType` mutation. */
export type UpdateBlastRotationEventTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** A unique, readable type of event that can occur within a blast rotation */
  eventType: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `BlastRotationEventType` being updated. */
  patch: BlastRotationEventTypePatch;
};

/** The output of our update `BlastRotationEventType` mutation. */
export type UpdateBlastRotationEventTypePayload = {
  __typename?: 'UpdateBlastRotationEventTypePayload';
  /** The `BlastRotationEventType` that was updated by this mutation. */
  blastRotationEventType?: Maybe<BlastRotationEventType>;
  /** An edge for our `BlastRotationEventType`. May be used by Relay 1. */
  blastRotationEventTypeEdge?: Maybe<BlastRotationEventTypesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `BlastRotationEventType` mutation. */
export type UpdateBlastRotationEventTypePayloadBlastRotationEventTypeEdgeArgs =
  {
    orderBy?: InputMaybe<Array<BlastRotationEventTypesOrderBy>>;
  };

/** All input for the `updateBlastRotation` mutation. */
export type UpdateBlastRotationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `BlastRotation` being updated. */
  patch: BlastRotationPatch;
};

/** All input for the `updateBlastRotationPalletByBlastRotationIdAndPalletId` mutation. */
export type UpdateBlastRotationPalletByBlastRotationIdAndPalletIdInput = {
  /** The associated blast rotation */
  blastRotationId: Scalars['Int']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The associated pallet */
  palletId: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `BlastRotationPallet` being updated. */
  patch: BlastRotationPalletPatch;
};

/** All input for the `updateBlastRotationPallet` mutation. */
export type UpdateBlastRotationPalletInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `BlastRotationPallet` being updated. */
  patch: BlastRotationPalletPatch;
};

/** The output of our update `BlastRotationPallet` mutation. */
export type UpdateBlastRotationPalletPayload = {
  __typename?: 'UpdateBlastRotationPalletPayload';
  /** Reads a single `BlastRotation` that is related to this `BlastRotationPallet`. */
  blastRotation?: Maybe<BlastRotation>;
  /** The `BlastRotationPallet` that was updated by this mutation. */
  blastRotationPallet?: Maybe<BlastRotationPallet>;
  /** An edge for our `BlastRotationPallet`. May be used by Relay 1. */
  blastRotationPalletEdge?: Maybe<BlastRotationPalletsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Pallet` that is related to this `BlastRotationPallet`. */
  pallet?: Maybe<Pallet>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `BlastRotationPallet` mutation. */
export type UpdateBlastRotationPalletPayloadBlastRotationPalletEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastRotationPalletsOrderBy>>;
};

/** The output of our update `BlastRotation` mutation. */
export type UpdateBlastRotationPayload = {
  __typename?: 'UpdateBlastRotationPayload';
  /** Reads a single `Blast` that is related to this `BlastRotation`. */
  blast?: Maybe<Blast>;
  /** The `BlastRotation` that was updated by this mutation. */
  blastRotation?: Maybe<BlastRotation>;
  /** An edge for our `BlastRotation`. May be used by Relay 1. */
  blastRotationEdge?: Maybe<BlastRotationsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `BlastRotation` mutation. */
export type UpdateBlastRotationPayloadBlastRotationEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastRotationsOrderBy>>;
};

/** All input for the `updateBlastType` mutation. */
export type UpdateBlastTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `BlastType` being updated. */
  patch: BlastTypePatch;
};

/** The output of our update `BlastType` mutation. */
export type UpdateBlastTypePayload = {
  __typename?: 'UpdateBlastTypePayload';
  /** The `BlastType` that was updated by this mutation. */
  blastType?: Maybe<BlastType>;
  /** An edge for our `BlastType`. May be used by Relay 1. */
  blastTypeEdge?: Maybe<BlastTypesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `BlastType` mutation. */
export type UpdateBlastTypePayloadBlastTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastTypesOrderBy>>;
};

/** All input for the `updateBuildingAreaByFacilityIdAndLabel` mutation. */
export type UpdateBuildingAreaByFacilityIdAndLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** This represents the facility that the building area belongs to. */
  facilityId: Scalars['Int']['input'];
  /** Human-readable label for the building area. */
  label: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `BuildingArea` being updated. */
  patch: BuildingAreaPatch;
};

/** All input for the `updateBuildingAreaComplianceGroupByBuildingAreaIdAndComplianceType` mutation. */
export type UpdateBuildingAreaComplianceGroupByBuildingAreaIdAndComplianceTypeInput =
  {
    /** The building area the compliance group applies to */
    buildingAreaId: Scalars['Int']['input'];
    /**
     * An arbitrary string value with no semantic meaning. Will be included in the
     * payload verbatim. May be used to track mutations by the client.
     */
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** The type of compliance group for this relationship */
    complianceType: ComplianceType;
    /** An object where the defined keys will be set on the `BuildingAreaComplianceGroup` being updated. */
    patch: BuildingAreaComplianceGroupPatch;
  };

/** All input for the `updateBuildingAreaComplianceGroup` mutation. */
export type UpdateBuildingAreaComplianceGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the building area compliance group */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `BuildingAreaComplianceGroup` being updated. */
  patch: BuildingAreaComplianceGroupPatch;
};

/** The output of our update `BuildingAreaComplianceGroup` mutation. */
export type UpdateBuildingAreaComplianceGroupPayload = {
  __typename?: 'UpdateBuildingAreaComplianceGroupPayload';
  /** Reads a single `BuildingArea` that is related to this `BuildingAreaComplianceGroup`. */
  buildingArea?: Maybe<BuildingArea>;
  /** The `BuildingAreaComplianceGroup` that was updated by this mutation. */
  buildingAreaComplianceGroup?: Maybe<BuildingAreaComplianceGroup>;
  /** An edge for our `BuildingAreaComplianceGroup`. May be used by Relay 1. */
  buildingAreaComplianceGroupEdge?: Maybe<BuildingAreaComplianceGroupsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `ComplianceGroup` that is related to this `BuildingAreaComplianceGroup`. */
  complianceGroup?: Maybe<ComplianceGroup>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `BuildingAreaComplianceGroup` mutation. */
export type UpdateBuildingAreaComplianceGroupPayloadBuildingAreaComplianceGroupEdgeArgs =
  {
    orderBy?: InputMaybe<Array<BuildingAreaComplianceGroupsOrderBy>>;
  };

/** All input for the `updateBuildingArea` mutation. */
export type UpdateBuildingAreaInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `BuildingArea` being updated. */
  patch: BuildingAreaPatch;
};

/** The output of our update `BuildingArea` mutation. */
export type UpdateBuildingAreaPayload = {
  __typename?: 'UpdateBuildingAreaPayload';
  /** The `BuildingArea` that was updated by this mutation. */
  buildingArea?: Maybe<BuildingArea>;
  /** An edge for our `BuildingArea`. May be used by Relay 1. */
  buildingAreaEdge?: Maybe<BuildingAreasEdge>;
  /** Reads a single `BuildingAreaType` that is related to this `BuildingArea`. */
  buildingAreaType?: Maybe<BuildingAreaType>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Facility` that is related to this `BuildingArea`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `BuildingArea` mutation. */
export type UpdateBuildingAreaPayloadBuildingAreaEdgeArgs = {
  orderBy?: InputMaybe<Array<BuildingAreasOrderBy>>;
};

/** All input for the `updateBuildingAreaType` mutation. */
export type UpdateBuildingAreaTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `BuildingAreaType` being updated. */
  patch: BuildingAreaTypePatch;
  /** The short name of the building area type. */
  type: Scalars['String']['input'];
};

/** The output of our update `BuildingAreaType` mutation. */
export type UpdateBuildingAreaTypePayload = {
  __typename?: 'UpdateBuildingAreaTypePayload';
  /** The `BuildingAreaType` that was updated by this mutation. */
  buildingAreaType?: Maybe<BuildingAreaType>;
  /** An edge for our `BuildingAreaType`. May be used by Relay 1. */
  buildingAreaTypeEdge?: Maybe<BuildingAreaTypesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `BuildingAreaType` mutation. */
export type UpdateBuildingAreaTypePayloadBuildingAreaTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<BuildingAreaTypesOrderBy>>;
};

/** All input for the `updateChart` mutation. */
export type UpdateChartInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `Chart` being updated. */
  patch: ChartPatch;
};

/** The output of our update `Chart` mutation. */
export type UpdateChartPayload = {
  __typename?: 'UpdateChartPayload';
  /** The `Chart` that was updated by this mutation. */
  chart?: Maybe<Chart>;
  /** An edge for our `Chart`. May be used by Relay 1. */
  chartEdge?: Maybe<ChartsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Facility` that is related to this `Chart`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `Chart` mutation. */
export type UpdateChartPayloadChartEdgeArgs = {
  orderBy?: InputMaybe<Array<ChartsOrderBy>>;
};

/** All input for the `updateCheckBySlug` mutation. */
export type UpdateCheckBySlugInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `Check` being updated. */
  patch: CheckPatch;
  /** The unique key of the check. */
  slug: Scalars['String']['input'];
};

/** All input for the `updateCheck` mutation. */
export type UpdateCheckInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifier of the check */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `Check` being updated. */
  patch: CheckPatch;
};

/** All input for the `updateCheckMonitorByMonitorId` mutation. */
export type UpdateCheckMonitorByMonitorIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The monitor. */
  monitorId: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `CheckMonitor` being updated. */
  patch: CheckMonitorPatch;
};

/** All input for the `updateCheckMonitor` mutation. */
export type UpdateCheckMonitorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `CheckMonitor` being updated. */
  patch: CheckMonitorPatch;
};

/** The output of our update `CheckMonitor` mutation. */
export type UpdateCheckMonitorPayload = {
  __typename?: 'UpdateCheckMonitorPayload';
  /** Reads a single `Check` that is related to this `CheckMonitor`. */
  check?: Maybe<Check>;
  /** The `CheckMonitor` that was updated by this mutation. */
  checkMonitor?: Maybe<CheckMonitor>;
  /** An edge for our `CheckMonitor`. May be used by Relay 1. */
  checkMonitorEdge?: Maybe<CheckMonitorsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Facility` that is related to this `CheckMonitor`. */
  facility?: Maybe<Facility>;
  /** Reads a single `Monitor` that is related to this `CheckMonitor`. */
  monitor?: Maybe<Monitor>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `CheckMonitor` mutation. */
export type UpdateCheckMonitorPayloadCheckMonitorEdgeArgs = {
  orderBy?: InputMaybe<Array<CheckMonitorsOrderBy>>;
};

/** The output of our update `Check` mutation. */
export type UpdateCheckPayload = {
  __typename?: 'UpdateCheckPayload';
  /** The `Check` that was updated by this mutation. */
  check?: Maybe<Check>;
  /** An edge for our `Check`. May be used by Relay 1. */
  checkEdge?: Maybe<ChecksEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Severity` that is related to this `Check`. */
  severity?: Maybe<Severity>;
  /** Reads a single `SoftwarePackage` that is related to this `Check`. */
  softwarePackage?: Maybe<SoftwarePackage>;
};

/** The output of our update `Check` mutation. */
export type UpdateCheckPayloadCheckEdgeArgs = {
  orderBy?: InputMaybe<Array<ChecksOrderBy>>;
};

/** All input for the `updateClassificationByAssessmentTypeIdAndName` mutation. */
export type UpdateClassificationByAssessmentTypeIdAndNameInput = {
  /** References the assessment type this classification is associated with. */
  assessmentTypeId: Scalars['Int']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The name of the classification. */
  name: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `Classification` being updated. */
  patch: ClassificationPatch;
};

/** All input for the `updateClassification` mutation. */
export type UpdateClassificationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifier of the classification. */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `Classification` being updated. */
  patch: ClassificationPatch;
};

/** The output of our update `Classification` mutation. */
export type UpdateClassificationPayload = {
  __typename?: 'UpdateClassificationPayload';
  /** Reads a single `AssessmentType` that is related to this `Classification`. */
  assessmentType?: Maybe<AssessmentType>;
  /** The `Classification` that was updated by this mutation. */
  classification?: Maybe<Classification>;
  /** An edge for our `Classification`. May be used by Relay 1. */
  classificationEdge?: Maybe<ClassificationsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `Classification` mutation. */
export type UpdateClassificationPayloadClassificationEdgeArgs = {
  orderBy?: InputMaybe<Array<ClassificationsOrderBy>>;
};

/** All input for the `updateClassificationResultByAssessmentIdAndClassificationId` mutation. */
export type UpdateClassificationResultByAssessmentIdAndClassificationIdInput = {
  /** References the assessment in which this classification was found. */
  assessmentId: Scalars['Int']['input'];
  /** References the classification that was triggered. */
  classificationId: Scalars['Int']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `ClassificationResult` being updated. */
  patch: ClassificationResultPatch;
};

/** All input for the `updateClassificationResult` mutation. */
export type UpdateClassificationResultInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifier of the classification result. */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `ClassificationResult` being updated. */
  patch: ClassificationResultPatch;
};

/** The output of our update `ClassificationResult` mutation. */
export type UpdateClassificationResultPayload = {
  __typename?: 'UpdateClassificationResultPayload';
  /** Reads a single `Assessment` that is related to this `ClassificationResult`. */
  assessment?: Maybe<Assessment>;
  /** Reads a single `Classification` that is related to this `ClassificationResult`. */
  classification?: Maybe<Classification>;
  /** The `ClassificationResult` that was updated by this mutation. */
  classificationResult?: Maybe<ClassificationResult>;
  /** An edge for our `ClassificationResult`. May be used by Relay 1. */
  classificationResultEdge?: Maybe<ClassificationResultsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `ClassificationResult` mutation. */
export type UpdateClassificationResultPayloadClassificationResultEdgeArgs = {
  orderBy?: InputMaybe<Array<ClassificationResultsOrderBy>>;
};

/** All input for the `updateComplianceGroupByLabel` mutation. */
export type UpdateComplianceGroupByLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The unique label of the compliance group (ex: Freezer, Cooler, Ice Cream Freezer) */
  label: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `ComplianceGroup` being updated. */
  patch: ComplianceGroupPatch;
};

/** All input for the `updateComplianceGroup` mutation. */
export type UpdateComplianceGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the compliance group */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `ComplianceGroup` being updated. */
  patch: ComplianceGroupPatch;
};

/** The output of our update `ComplianceGroup` mutation. */
export type UpdateComplianceGroupPayload = {
  __typename?: 'UpdateComplianceGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `ComplianceGroup` that was updated by this mutation. */
  complianceGroup?: Maybe<ComplianceGroup>;
  /** An edge for our `ComplianceGroup`. May be used by Relay 1. */
  complianceGroupEdge?: Maybe<ComplianceGroupsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `ComplianceGroup` mutation. */
export type UpdateComplianceGroupPayloadComplianceGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<ComplianceGroupsOrderBy>>;
};

/** All input for the `updateComplianceRangeByComplianceGroupIdAndLabel` mutation. */
export type UpdateComplianceRangeByComplianceGroupIdAndLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The group this compliance range belongs to */
  complianceGroupId: Scalars['Int']['input'];
  /** The unique label of the compliance range (ex: Out of Compliance, Above Compliance) */
  label: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `ComplianceRange` being updated. */
  patch: ComplianceRangePatch;
};

/** All input for the `updateComplianceRange` mutation. */
export type UpdateComplianceRangeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the compliance range */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `ComplianceRange` being updated. */
  patch: ComplianceRangePatch;
};

/** The output of our update `ComplianceRange` mutation. */
export type UpdateComplianceRangePayload = {
  __typename?: 'UpdateComplianceRangePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `ComplianceGroup` that is related to this `ComplianceRange`. */
  complianceGroup?: Maybe<ComplianceGroup>;
  /** The `ComplianceRange` that was updated by this mutation. */
  complianceRange?: Maybe<ComplianceRange>;
  /** An edge for our `ComplianceRange`. May be used by Relay 1. */
  complianceRangeEdge?: Maybe<ComplianceRangesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `ComplianceRange` mutation. */
export type UpdateComplianceRangePayloadComplianceRangeEdgeArgs = {
  orderBy?: InputMaybe<Array<ComplianceRangesOrderBy>>;
};

/** All input for the `updateComponent` mutation. */
export type UpdateComponentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifier of the component */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `Component` being updated. */
  patch: ComponentPatch;
};

/** The output of our update `Component` mutation. */
export type UpdateComponentPayload = {
  __typename?: 'UpdateComponentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Component` that was updated by this mutation. */
  component?: Maybe<Component>;
  /** An edge for our `Component`. May be used by Relay 1. */
  componentEdge?: Maybe<ComponentsEdge>;
  /** Reads a single `Facility` that is related to this `Component`. */
  facility?: Maybe<Facility>;
  /** Reads a single `MachineUser` that is related to this `Component`. */
  machineUser?: Maybe<MachineUser>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `Component` mutation. */
export type UpdateComponentPayloadComponentEdgeArgs = {
  orderBy?: InputMaybe<Array<ComponentsOrderBy>>;
};

/** All input for the `updateCompressorByFacilityIdAndLabel` mutation. */
export type UpdateCompressorByFacilityIdAndLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The facility a compressor is installed within */
  facilityId: Scalars['Int']['input'];
  /** A human-readable label for a compressor */
  label: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `Compressor` being updated. */
  patch: CompressorPatch;
};

/** All input for the `updateCompressor` mutation. */
export type UpdateCompressorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the compressor. */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `Compressor` being updated. */
  patch: CompressorPatch;
};

/** The output of our update `Compressor` mutation. */
export type UpdateCompressorPayload = {
  __typename?: 'UpdateCompressorPayload';
  /** Reads a single `BuildingArea` that is related to this `Compressor`. */
  buildingArea?: Maybe<BuildingArea>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  capacity?: Maybe<DataPoint>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Compressor` that was updated by this mutation. */
  compressor?: Maybe<Compressor>;
  /** An edge for our `Compressor`. May be used by Relay 1. */
  compressorEdge?: Maybe<CompressorsEdge>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  controlMode?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  differentialPressure?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  dischargePressure?: Maybe<DataPoint>;
  /** Reads a single `Facility` that is related to this `Compressor`. */
  facility?: Maybe<Facility>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  kwDemand?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  motorAmps?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  motorState?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  oilPressure?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  oilTemperature?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  onStatus?: Maybe<DataPoint>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RefrigerationSystem` that is related to this `Compressor`. */
  refrigerationSystem?: Maybe<RefrigerationSystem>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  runtimeHours?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  setpoint?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  slideValvePosition?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  state?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  suctionPressure?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  suctionPressureSetpointDeviation?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  suctionTemperature?: Maybe<DataPoint>;
};

/** The output of our update `Compressor` mutation. */
export type UpdateCompressorPayloadCompressorEdgeArgs = {
  orderBy?: InputMaybe<Array<CompressorsOrderBy>>;
};

/** All input for the `updateControlEvent` mutation. */
export type UpdateControlEventInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifier of the control event */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `ControlEvent` being updated. */
  patch: ControlEventPatch;
};

/** All input for the `updateControlEventLog` mutation. */
export type UpdateControlEventLogInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifier of the control event log entry */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `ControlEventLog` being updated. */
  patch: ControlEventLogPatch;
};

/** The output of our update `ControlEventLog` mutation. */
export type UpdateControlEventLogPayload = {
  __typename?: 'UpdateControlEventLogPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `ControlEvent` that is related to this `ControlEventLog`. */
  controlEvent?: Maybe<ControlEvent>;
  /** The `ControlEventLog` that was updated by this mutation. */
  controlEventLog?: Maybe<ControlEventLog>;
  /** An edge for our `ControlEventLog`. May be used by Relay 1. */
  controlEventLogEdge?: Maybe<ControlEventLogsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `ControlEventLog` mutation. */
export type UpdateControlEventLogPayloadControlEventLogEdgeArgs = {
  orderBy?: InputMaybe<Array<ControlEventLogsOrderBy>>;
};

/** The output of our update `ControlEvent` mutation. */
export type UpdateControlEventPayload = {
  __typename?: 'UpdateControlEventPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Component` that is related to this `ControlEvent`. */
  component?: Maybe<Component>;
  /** The `ControlEvent` that was updated by this mutation. */
  controlEvent?: Maybe<ControlEvent>;
  /** An edge for our `ControlEvent`. May be used by Relay 1. */
  controlEventEdge?: Maybe<ControlEventsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `ControlEvent` mutation. */
export type UpdateControlEventPayloadControlEventEdgeArgs = {
  orderBy?: InputMaybe<Array<ControlEventsOrderBy>>;
};

/** All input for the `updateCustomerBillingRateByCustomerIdAndEffectiveStart` mutation. */
export type UpdateCustomerBillingRateByCustomerIdAndEffectiveStartInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The customer this rate belongs to */
  customerId: Scalars['Int']['input'];
  /** The date when this rate becomes effective */
  effectiveStart: Scalars['Datetime']['input'];
  /** An object where the defined keys will be set on the `CustomerBillingRate` being updated. */
  patch: CustomerBillingRatePatch;
};

/** All input for the `updateCustomerBillingRate` mutation. */
export type UpdateCustomerBillingRateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The internal ID of this customer rate */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `CustomerBillingRate` being updated. */
  patch: CustomerBillingRatePatch;
};

/** The output of our update `CustomerBillingRate` mutation. */
export type UpdateCustomerBillingRatePayload = {
  __typename?: 'UpdateCustomerBillingRatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `BillableCustomer` that is related to this `CustomerBillingRate`. */
  customer?: Maybe<BillableCustomer>;
  /** The `CustomerBillingRate` that was updated by this mutation. */
  customerBillingRate?: Maybe<CustomerBillingRate>;
  /** An edge for our `CustomerBillingRate`. May be used by Relay 1. */
  customerBillingRateEdge?: Maybe<CustomerBillingRatesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `CustomerBillingRate` mutation. */
export type UpdateCustomerBillingRatePayloadCustomerBillingRateEdgeArgs = {
  orderBy?: InputMaybe<Array<CustomerBillingRatesOrderBy>>;
};

/** All input for the `updateCustomerBySourceId` mutation. */
export type UpdateCustomerBySourceIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `Customer` being updated. */
  patch: CustomerPatch;
  /** The globally unique external identifier of the record from the original source system */
  sourceId: Scalars['String']['input'];
};

/** All input for the `updateCustomer` mutation. */
export type UpdateCustomerInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `Customer` being updated. */
  patch: CustomerPatch;
};

/** The output of our update `Customer` mutation. */
export type UpdateCustomerPayload = {
  __typename?: 'UpdateCustomerPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Customer` that was updated by this mutation. */
  customer?: Maybe<Customer>;
  /** An edge for our `Customer`. May be used by Relay 1. */
  customerEdge?: Maybe<CustomersEdge>;
  /** Reads a single `Facility` that is related to this `Customer`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `Customer` mutation. */
export type UpdateCustomerPayloadCustomerEdgeArgs = {
  orderBy?: InputMaybe<Array<CustomersOrderBy>>;
};

/** All input for the `updateDashboard` mutation. */
export type UpdateDashboardInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `Dashboard` being updated. */
  patch: DashboardPatch;
};

/** The output of our update `Dashboard` mutation. */
export type UpdateDashboardPayload = {
  __typename?: 'UpdateDashboardPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Dashboard` that was updated by this mutation. */
  dashboard?: Maybe<Dashboard>;
  /** An edge for our `Dashboard`. May be used by Relay 1. */
  dashboardEdge?: Maybe<DashboardsEdge>;
  /** Reads a single `Facility` that is related to this `Dashboard`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `Dashboard` mutation. */
export type UpdateDashboardPayloadDashboardEdgeArgs = {
  orderBy?: InputMaybe<Array<DashboardsOrderBy>>;
};

/** All input for the `updateDataPointByDataSourceNameAndName` mutation. */
export type UpdateDataPointByDataSourceNameAndNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dataSourceName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `DataPoint` being updated. */
  patch: DataPointPatch;
};

/** All input for the `updateDataPoint` mutation. */
export type UpdateDataPointInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `DataPoint` being updated. */
  patch: DataPointPatch;
};

/** The output of our update `DataPoint` mutation. */
export type UpdateDataPointPayload = {
  __typename?: 'UpdateDataPointPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `DataPoint` that was updated by this mutation. */
  dataPoint?: Maybe<DataPoint>;
  /** An edge for our `DataPoint`. May be used by Relay 1. */
  dataPointEdge?: Maybe<DataPointsEdge>;
  /** Reads a single `DataSource` that is related to this `DataPoint`. */
  dataSource?: Maybe<DataSource>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `DataPoint` mutation. */
export type UpdateDataPointPayloadDataPointEdgeArgs = {
  orderBy?: InputMaybe<Array<DataPointsOrderBy>>;
};

/** All input for the `updateDependencyByPath` mutation. */
export type UpdateDependencyByPathInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `Dependency` being updated. */
  patch: DependencyPatch;
  path: Scalars['String']['input'];
};

/** All input for the `updateDependency` mutation. */
export type UpdateDependencyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `Dependency` being updated. */
  patch: DependencyPatch;
};

/** The output of our update `Dependency` mutation. */
export type UpdateDependencyPayload = {
  __typename?: 'UpdateDependencyPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Dependency` that was updated by this mutation. */
  dependency?: Maybe<Dependency>;
  /** An edge for our `Dependency`. May be used by Relay 1. */
  dependencyEdge?: Maybe<DependenciesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `Dependency` mutation. */
export type UpdateDependencyPayloadDependencyEdgeArgs = {
  orderBy?: InputMaybe<Array<DependenciesOrderBy>>;
};

/** All input for the `updateDischargeHeaderByRefrigerationSystemIdAndLabel` mutation. */
export type UpdateDischargeHeaderByRefrigerationSystemIdAndLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The display label of the discharge header. */
  label: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `DischargeHeader` being updated. */
  patch: DischargeHeaderPatch;
  /** References the refrigeration system this discharge header belongs to. */
  refrigerationSystemId: Scalars['Int']['input'];
};

/** All input for the `updateDischargeHeader` mutation. */
export type UpdateDischargeHeaderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The unique identifier for the discharge header. */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `DischargeHeader` being updated. */
  patch: DischargeHeaderPatch;
};

/** The output of our update `DischargeHeader` mutation. */
export type UpdateDischargeHeaderPayload = {
  __typename?: 'UpdateDischargeHeaderPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `DischargeHeader` that was updated by this mutation. */
  dischargeHeader?: Maybe<DischargeHeader>;
  /** An edge for our `DischargeHeader`. May be used by Relay 1. */
  dischargeHeaderEdge?: Maybe<DischargeHeadersEdge>;
  /** Reads a single `DataPoint` that is related to this `DischargeHeader`. */
  dischargePressure?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `DischargeHeader`. */
  dischargePressureSetpoint?: Maybe<DataPoint>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RefrigerationSystem` that is related to this `DischargeHeader`. */
  refrigerationSystem?: Maybe<RefrigerationSystem>;
};

/** The output of our update `DischargeHeader` mutation. */
export type UpdateDischargeHeaderPayloadDischargeHeaderEdgeArgs = {
  orderBy?: InputMaybe<Array<DischargeHeadersOrderBy>>;
};

/** All input for the `updateDoorByFacilityIdAndLabel` mutation. */
export type UpdateDoorByFacilityIdAndLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The facility where the door is located */
  facilityId: Scalars['Int']['input'];
  /** The Human-readable label for the door */
  label: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `Door` being updated. */
  patch: DoorPatch;
};

/** All input for the `updateDoor` mutation. */
export type UpdateDoorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the door */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `Door` being updated. */
  patch: DoorPatch;
};

/** The output of our update `Door` mutation. */
export type UpdateDoorPayload = {
  __typename?: 'UpdateDoorPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Door` that was updated by this mutation. */
  door?: Maybe<Door>;
  /** An edge for our `Door`. May be used by Relay 1. */
  doorEdge?: Maybe<DoorsEdge>;
  /** Reads a single `DataPoint` that is related to this `Door`. */
  doorState?: Maybe<DataPoint>;
  /** Reads a single `Facility` that is related to this `Door`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `Door` mutation. */
export type UpdateDoorPayloadDoorEdgeArgs = {
  orderBy?: InputMaybe<Array<DoorsOrderBy>>;
};

/** All input for the `updateDriverByConversationId` mutation. */
export type UpdateDriverByConversationIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The external messaging service conversion ID */
  conversationId: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `Driver` being updated. */
  patch: DriverPatch;
};

/** All input for the `updateDriverByPhoneNumber` mutation. */
export type UpdateDriverByPhoneNumberInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `Driver` being updated. */
  patch: DriverPatch;
  /** The phone number of the driver */
  phoneNumber: Scalars['String']['input'];
};

/** All input for the `updateDriver` mutation. */
export type UpdateDriverInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The internal ID of this driver */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `Driver` being updated. */
  patch: DriverPatch;
};

/** The output of our update `Driver` mutation. */
export type UpdateDriverPayload = {
  __typename?: 'UpdateDriverPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Driver` that was updated by this mutation. */
  driver?: Maybe<Driver>;
  /** An edge for our `Driver`. May be used by Relay 1. */
  driverEdge?: Maybe<DriversEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `Driver` mutation. */
export type UpdateDriverPayloadDriverEdgeArgs = {
  orderBy?: InputMaybe<Array<DriversOrderBy>>;
};

/** All input for the `updateElectricalCircuit` mutation. */
export type UpdateElectricalCircuitInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifier of the record. */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `ElectricalCircuit` being updated. */
  patch: ElectricalCircuitPatch;
};

/** The output of our update `ElectricalCircuit` mutation. */
export type UpdateElectricalCircuitPayload = {
  __typename?: 'UpdateElectricalCircuitPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `ElectricalCircuit` that was updated by this mutation. */
  electricalCircuit?: Maybe<ElectricalCircuit>;
  /** An edge for our `ElectricalCircuit`. May be used by Relay 1. */
  electricalCircuitEdge?: Maybe<ElectricalCircuitsEdge>;
  /** Reads a single `ElectricalMeteringPoint` that is related to this `ElectricalCircuit`. */
  electricalMeteringPoint?: Maybe<ElectricalMeteringPoint>;
  /** Reads a single `ElectricalPanel` that is related to this `ElectricalCircuit`. */
  electricalPanel?: Maybe<ElectricalPanel>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `ElectricalCircuit` mutation. */
export type UpdateElectricalCircuitPayloadElectricalCircuitEdgeArgs = {
  orderBy?: InputMaybe<Array<ElectricalCircuitsOrderBy>>;
};

/** All input for the `updateElectricalMeteringPoint` mutation. */
export type UpdateElectricalMeteringPointInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifier of the record. */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `ElectricalMeteringPoint` being updated. */
  patch: ElectricalMeteringPointPatch;
};

/** The output of our update `ElectricalMeteringPoint` mutation. */
export type UpdateElectricalMeteringPointPayload = {
  __typename?: 'UpdateElectricalMeteringPointPayload';
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  apparentPower?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  apparentPowerPhaseA?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  apparentPowerPhaseB?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  apparentPowerPhaseC?: Maybe<DataPoint>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  crestFactorPhaseA?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  crestFactorPhaseB?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  crestFactorPhaseC?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  cumulativeKwh?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  current?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  currentAmplitudeImbalance?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  currentAverage?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  currentThdAverage?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  currentThdPhaseA?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  currentThdPhaseB?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  currentThdPhaseC?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  currentUnbalanceFactor?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  demandPhaseA?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  demandPhaseB?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  demandPhaseC?: Maybe<DataPoint>;
  /** The `ElectricalMeteringPoint` that was updated by this mutation. */
  electricalMeteringPoint?: Maybe<ElectricalMeteringPoint>;
  /** An edge for our `ElectricalMeteringPoint`. May be used by Relay 1. */
  electricalMeteringPointEdge?: Maybe<ElectricalMeteringPointsEdge>;
  /** Reads a single `Facility` that is related to this `ElectricalMeteringPoint`. */
  facility?: Maybe<Facility>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  frequency?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  frequencyDeviation?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  generatedEnergy?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  kwDemand?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  lineToLineDeviationAverage?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  lineToLineVoltage?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  lineToLineVoltageAb?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  lineToLineVoltageBc?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  lineToLineVoltageCa?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  lineToNeutralDeviationAverage?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  lineToNeutralVoltage?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  lineToNeutralVoltageA?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  lineToNeutralVoltageB?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  lineToNeutralVoltageC?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  netEnergy?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  neutralCurrent?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  phaseACurrent?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  phaseACurrentDeviation?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  phaseAVoltage?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  phaseAVoltageDeviation?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  phaseBCurrent?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  phaseBCurrentDeviation?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  phaseBVoltage?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  phaseBVoltageDeviation?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  phaseCCurrent?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  phaseCCurrentDeviation?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  phaseCVoltage?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  phaseCVoltageDeviation?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  powerFactor?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  powerFactorPhaseA?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  powerFactorPhaseB?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  powerFactorPhaseC?: Maybe<DataPoint>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  reactivePower?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  reactivePowerPhaseA?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  reactivePowerPhaseB?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  reactivePowerPhaseC?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  totalEnergy?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  voltageAmplitudeImbalance?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  voltageAverage?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  voltageThdAverage?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  voltageThdPhaseA?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  voltageThdPhaseB?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  voltageThdPhaseC?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  voltageUnbalanceFactor?: Maybe<DataPoint>;
};

/** The output of our update `ElectricalMeteringPoint` mutation. */
export type UpdateElectricalMeteringPointPayloadElectricalMeteringPointEdgeArgs =
  {
    orderBy?: InputMaybe<Array<ElectricalMeteringPointsOrderBy>>;
  };

/** All input for the `updateElectricalPanelByElectricalMeteringPointId` mutation. */
export type UpdateElectricalPanelByElectricalMeteringPointIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The electrical metering point where this panel is monitored. */
  electricalMeteringPointId: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `ElectricalPanel` being updated. */
  patch: ElectricalPanelPatch;
};

/** All input for the `updateElectricalPanel` mutation. */
export type UpdateElectricalPanelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifier of the record. */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `ElectricalPanel` being updated. */
  patch: ElectricalPanelPatch;
};

/** The output of our update `ElectricalPanel` mutation. */
export type UpdateElectricalPanelPayload = {
  __typename?: 'UpdateElectricalPanelPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `ElectricalMeteringPoint` that is related to this `ElectricalPanel`. */
  electricalMeteringPoint?: Maybe<ElectricalMeteringPoint>;
  /** The `ElectricalPanel` that was updated by this mutation. */
  electricalPanel?: Maybe<ElectricalPanel>;
  /** An edge for our `ElectricalPanel`. May be used by Relay 1. */
  electricalPanelEdge?: Maybe<ElectricalPanelsEdge>;
  /** Reads a single `Facility` that is related to this `ElectricalPanel`. */
  facility?: Maybe<Facility>;
  /** Reads a single `ElectricalCircuit` that is related to this `ElectricalPanel`. */
  parentCircuit?: Maybe<ElectricalCircuit>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `ElectricalPanel` mutation. */
export type UpdateElectricalPanelPayloadElectricalPanelEdgeArgs = {
  orderBy?: InputMaybe<Array<ElectricalPanelsOrderBy>>;
};

/** All input for the `updateEvaporatorByFacilityIdAndLabel` mutation. */
export type UpdateEvaporatorByFacilityIdAndLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The facility an evaporator is installed within */
  facilityId: Scalars['Int']['input'];
  /** A human-readable label */
  label: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `Evaporator` being updated. */
  patch: EvaporatorPatch;
};

/** All input for the `updateEvaporator` mutation. */
export type UpdateEvaporatorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the evaporator */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `Evaporator` being updated. */
  patch: EvaporatorPatch;
};

/** The output of our update `Evaporator` mutation. */
export type UpdateEvaporatorPayload = {
  __typename?: 'UpdateEvaporatorPayload';
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  ammoniaState?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  bleedSolenoid?: Maybe<DataPoint>;
  /** Reads a single `BuildingArea` that is related to this `Evaporator`. */
  buildingArea?: Maybe<BuildingArea>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  defrostState?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  defrostTemperature?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  defrostTimer?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  differentialAirTemperature?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  estimatedKwDemand?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  evapState?: Maybe<DataPoint>;
  /** The `Evaporator` that was updated by this mutation. */
  evaporator?: Maybe<Evaporator>;
  /** An edge for our `Evaporator`. May be used by Relay 1. */
  evaporatorEdge?: Maybe<EvaporatorsEdge>;
  /** Reads a single `Facility` that is related to this `Evaporator`. */
  facility?: Maybe<Facility>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  fanState?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  fanTimer?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  hotGasSolenoid?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  liquidFeedRuntime?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  liquidFeedRuntimeSetpoint?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  liquidSolenoid?: Maybe<DataPoint>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RefrigerationSystem` that is related to this `Evaporator`. */
  refrigerationSystem?: Maybe<RefrigerationSystem>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  returnAirTemperature?: Maybe<DataPoint>;
  /** Reads a single `SuctionHeader` that is related to this `Evaporator`. */
  returnSuctionHeader?: Maybe<SuctionHeader>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  setpoint?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  softHotGasSolenoid?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  suctionPressure?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  suctionSolenoid?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  suctionTemperature?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  supplyAirTemperature?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  zoneTemperature?: Maybe<DataPoint>;
};

/** The output of our update `Evaporator` mutation. */
export type UpdateEvaporatorPayloadEvaporatorEdgeArgs = {
  orderBy?: InputMaybe<Array<EvaporatorsOrderBy>>;
};

/** All input for the `updateFacilityBySlug` mutation. */
export type UpdateFacilityBySlugInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `Facility` being updated. */
  patch: FacilityPatch;
  /** The facility’s slug. */
  slug: Scalars['String']['input'];
};

/** All input for the `updateFacilityCheckByFacilityIdAndCheckId` mutation. */
export type UpdateFacilityCheckByFacilityIdAndCheckIdInput = {
  /** The check. */
  checkId: Scalars['Int']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The facility. */
  facilityId: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `FacilityCheck` being updated. */
  patch: FacilityCheckPatch;
};

/** All input for the `updateFacilityCheck` mutation. */
export type UpdateFacilityCheckInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifier of the facility check */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `FacilityCheck` being updated. */
  patch: FacilityCheckPatch;
};

/** The output of our update `FacilityCheck` mutation. */
export type UpdateFacilityCheckPayload = {
  __typename?: 'UpdateFacilityCheckPayload';
  /** Reads a single `Check` that is related to this `FacilityCheck`. */
  check?: Maybe<Check>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Facility` that is related to this `FacilityCheck`. */
  facility?: Maybe<Facility>;
  /** The `FacilityCheck` that was updated by this mutation. */
  facilityCheck?: Maybe<FacilityCheck>;
  /** An edge for our `FacilityCheck`. May be used by Relay 1. */
  facilityCheckEdge?: Maybe<FacilityChecksEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `FacilityCheck` mutation. */
export type UpdateFacilityCheckPayloadFacilityCheckEdgeArgs = {
  orderBy?: InputMaybe<Array<FacilityChecksOrderBy>>;
};

/** All input for the `updateFacilityDocument` mutation. */
export type UpdateFacilityDocumentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifier of the facility document. */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `FacilityDocument` being updated. */
  patch: FacilityDocumentPatch;
};

/** The output of our update `FacilityDocument` mutation. */
export type UpdateFacilityDocumentPayload = {
  __typename?: 'UpdateFacilityDocumentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Facility` that is related to this `FacilityDocument`. */
  facility?: Maybe<Facility>;
  /** The `FacilityDocument` that was updated by this mutation. */
  facilityDocument?: Maybe<FacilityDocument>;
  /** An edge for our `FacilityDocument`. May be used by Relay 1. */
  facilityDocumentEdge?: Maybe<FacilityDocumentsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SoftwarePackage` that is related to this `FacilityDocument`. */
  softwarePackage?: Maybe<SoftwarePackage>;
};

/** The output of our update `FacilityDocument` mutation. */
export type UpdateFacilityDocumentPayloadFacilityDocumentEdgeArgs = {
  orderBy?: InputMaybe<Array<FacilityDocumentsOrderBy>>;
};

/** All input for the `updateFacilityGroup` mutation. */
export type UpdateFacilityGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The facility group’s id. */
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `FacilityGroup` being updated. */
  patch: FacilityGroupPatch;
};

/** The output of our update `FacilityGroup` mutation. */
export type UpdateFacilityGroupPayload = {
  __typename?: 'UpdateFacilityGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `FacilityGroup` that was updated by this mutation. */
  facilityGroup?: Maybe<FacilityGroup>;
  /** An edge for our `FacilityGroup`. May be used by Relay 1. */
  facilityGroupEdge?: Maybe<FacilityGroupsEdge>;
  /** Reads a single `FacilityGroup` that is related to this `FacilityGroup`. */
  parent?: Maybe<FacilityGroup>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `FacilityGroup` mutation. */
export type UpdateFacilityGroupPayloadFacilityGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<FacilityGroupsOrderBy>>;
};

/** All input for the `updateFacilityGroupsLinker` mutation. */
export type UpdateFacilityGroupsLinkerInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  facilityGroupingId: Scalars['BigInt']['input'];
  facilityId: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `FacilityGroupsLinker` being updated. */
  patch: FacilityGroupsLinkerPatch;
};

/** The output of our update `FacilityGroupsLinker` mutation. */
export type UpdateFacilityGroupsLinkerPayload = {
  __typename?: 'UpdateFacilityGroupsLinkerPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Facility` that is related to this `FacilityGroupsLinker`. */
  facility?: Maybe<Facility>;
  /** Reads a single `FacilityGroup` that is related to this `FacilityGroupsLinker`. */
  facilityGrouping?: Maybe<FacilityGroup>;
  /** The `FacilityGroupsLinker` that was updated by this mutation. */
  facilityGroupsLinker?: Maybe<FacilityGroupsLinker>;
  /** An edge for our `FacilityGroupsLinker`. May be used by Relay 1. */
  facilityGroupsLinkerEdge?: Maybe<FacilityGroupsLinkersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `FacilityGroupsLinker` mutation. */
export type UpdateFacilityGroupsLinkerPayloadFacilityGroupsLinkerEdgeArgs = {
  orderBy?: InputMaybe<Array<FacilityGroupsLinkersOrderBy>>;
};

/** All input for the `updateFacility` mutation. */
export type UpdateFacilityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The primary unique identifier for the facility. */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `Facility` being updated. */
  patch: FacilityPatch;
};

/** The output of our update `Facility` mutation. */
export type UpdateFacilityPayload = {
  __typename?: 'UpdateFacilityPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Facility` that was updated by this mutation. */
  facility?: Maybe<Facility>;
  /** An edge for our `Facility`. May be used by Relay 1. */
  facilityEdge?: Maybe<FacilitiesEdge>;
  /** Reads a single `PricingNode` that is related to this `Facility`. */
  pricingNode?: Maybe<PricingNode>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Timezone` that is related to this `Facility`. */
  timezone?: Maybe<Timezone>;
  /** Reads a single `UnitGroup` that is related to this `Facility`. */
  unitGroupItem?: Maybe<UnitGroup>;
};

/** The output of our update `Facility` mutation. */
export type UpdateFacilityPayloadFacilityEdgeArgs = {
  orderBy?: InputMaybe<Array<FacilitiesOrderBy>>;
};

/** All input for the `updateFacilitySoftwarePackageByFacilityIdAndSoftwarePackageId` mutation. */
export type UpdateFacilitySoftwarePackageByFacilityIdAndSoftwarePackageIdInput =
  {
    /**
     * An arbitrary string value with no semantic meaning. Will be included in the
     * payload verbatim. May be used to track mutations by the client.
     */
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** The facility using the software package. */
    facilityId: Scalars['Int']['input'];
    /** An object where the defined keys will be set on the `FacilitySoftwarePackage` being updated. */
    patch: FacilitySoftwarePackagePatch;
    /** The enabled software package. */
    softwarePackageId: Scalars['Int']['input'];
  };

/** All input for the `updateFacilitySoftwarePackage` mutation. */
export type UpdateFacilitySoftwarePackageInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifer of the record. */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `FacilitySoftwarePackage` being updated. */
  patch: FacilitySoftwarePackagePatch;
};

/** The output of our update `FacilitySoftwarePackage` mutation. */
export type UpdateFacilitySoftwarePackagePayload = {
  __typename?: 'UpdateFacilitySoftwarePackagePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Facility` that is related to this `FacilitySoftwarePackage`. */
  facility?: Maybe<Facility>;
  /** The `FacilitySoftwarePackage` that was updated by this mutation. */
  facilitySoftwarePackage?: Maybe<FacilitySoftwarePackage>;
  /** An edge for our `FacilitySoftwarePackage`. May be used by Relay 1. */
  facilitySoftwarePackageEdge?: Maybe<FacilitySoftwarePackagesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SoftwarePackage` that is related to this `FacilitySoftwarePackage`. */
  softwarePackage?: Maybe<SoftwarePackage>;
};

/** The output of our update `FacilitySoftwarePackage` mutation. */
export type UpdateFacilitySoftwarePackagePayloadFacilitySoftwarePackageEdgeArgs =
  {
    orderBy?: InputMaybe<Array<FacilitySoftwarePackagesOrderBy>>;
  };

/** All input for the `updateFacilityTaggedDataPoint` mutation. */
export type UpdateFacilityTaggedDataPointInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `FacilityTaggedDataPoint` being updated. */
  patch: FacilityTaggedDataPointPatch;
};

/** The output of our update `FacilityTaggedDataPoint` mutation. */
export type UpdateFacilityTaggedDataPointPayload = {
  __typename?: 'UpdateFacilityTaggedDataPointPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DataPoint` that is related to this `FacilityTaggedDataPoint`. */
  dataPoint?: Maybe<DataPoint>;
  /** Reads a single `Facility` that is related to this `FacilityTaggedDataPoint`. */
  facility?: Maybe<Facility>;
  /** The `FacilityTaggedDataPoint` that was updated by this mutation. */
  facilityTaggedDataPoint?: Maybe<FacilityTaggedDataPoint>;
  /** An edge for our `FacilityTaggedDataPoint`. May be used by Relay 1. */
  facilityTaggedDataPointEdge?: Maybe<FacilityTaggedDataPointsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DataPointTag` that is related to this `FacilityTaggedDataPoint`. */
  tag?: Maybe<DataPointTag>;
};

/** The output of our update `FacilityTaggedDataPoint` mutation. */
export type UpdateFacilityTaggedDataPointPayloadFacilityTaggedDataPointEdgeArgs =
  {
    orderBy?: InputMaybe<Array<FacilityTaggedDataPointsOrderBy>>;
  };

/** All input for the `updateGatewayByFacilityIdAndHardwareId` mutation. */
export type UpdateGatewayByFacilityIdAndHardwareIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The facility where the gateway is installed. */
  facilityId: Scalars['Int']['input'];
  /** The hardware ID for the gateway. */
  hardwareId: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `Gateway` being updated. */
  patch: GatewayPatch;
};

/** All input for the `updateGatewayByFacilityIdAndLabel` mutation. */
export type UpdateGatewayByFacilityIdAndLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The facility where the gateway is installed. */
  facilityId: Scalars['Int']['input'];
  /** The human-readable label for the gateway. */
  label: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `Gateway` being updated. */
  patch: GatewayPatch;
};

/** All input for the `updateGateway` mutation. */
export type UpdateGatewayInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifier of the gateway. */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `Gateway` being updated. */
  patch: GatewayPatch;
};

/** The output of our update `Gateway` mutation. */
export type UpdateGatewayPayload = {
  __typename?: 'UpdateGatewayPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Facility` that is related to this `Gateway`. */
  facility?: Maybe<Facility>;
  /** The `Gateway` that was updated by this mutation. */
  gateway?: Maybe<Gateway>;
  /** An edge for our `Gateway`. May be used by Relay 1. */
  gatewayEdge?: Maybe<GatewaysEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DataPoint` that is related to this `Gateway`. */
  status?: Maybe<DataPoint>;
};

/** The output of our update `Gateway` mutation. */
export type UpdateGatewayPayloadGatewayEdgeArgs = {
  orderBy?: InputMaybe<Array<GatewaysOrderBy>>;
};

/** All input for the `updateInboundOutboundLoadBySourceId` mutation. */
export type UpdateInboundOutboundLoadBySourceIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `InboundOutboundLoad` being updated. */
  patch: InboundOutboundLoadPatch;
  /** The globally unique external identifier of the record from the original source system */
  sourceId: Scalars['String']['input'];
};

/** All input for the `updateInboundOutboundLoad` mutation. */
export type UpdateInboundOutboundLoadInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `InboundOutboundLoad` being updated. */
  patch: InboundOutboundLoadPatch;
};

/** The output of our update `InboundOutboundLoad` mutation. */
export type UpdateInboundOutboundLoadPayload = {
  __typename?: 'UpdateInboundOutboundLoadPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Facility` that is related to this `InboundOutboundLoad`. */
  facility?: Maybe<Facility>;
  /** The `InboundOutboundLoad` that was updated by this mutation. */
  inboundOutboundLoad?: Maybe<InboundOutboundLoad>;
  /** An edge for our `InboundOutboundLoad`. May be used by Relay 1. */
  inboundOutboundLoadEdge?: Maybe<InboundOutboundLoadsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `InboundOutboundLoad` mutation. */
export type UpdateInboundOutboundLoadPayloadInboundOutboundLoadEdgeArgs = {
  orderBy?: InputMaybe<Array<InboundOutboundLoadsOrderBy>>;
};

/** All input for the `updateIncidentByCheckMonitorIdAndMonitorDetectionId` mutation. */
export type UpdateIncidentByCheckMonitorIdAndMonitorDetectionIdInput = {
  /** The check monitor. */
  checkMonitorId: Scalars['Int']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The monitor detection. */
  monitorDetectionId: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `Incident` being updated. */
  patch: IncidentPatch;
};

/** All input for the `updateIncident` mutation. */
export type UpdateIncidentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifier of the incident. */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `Incident` being updated. */
  patch: IncidentPatch;
};

/** The output of our update `Incident` mutation. */
export type UpdateIncidentPayload = {
  __typename?: 'UpdateIncidentPayload';
  /** Reads a single `CheckMonitor` that is related to this `Incident`. */
  checkMonitor?: Maybe<CheckMonitor>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Incident` that was updated by this mutation. */
  incident?: Maybe<Incident>;
  /** An edge for our `Incident`. May be used by Relay 1. */
  incidentEdge?: Maybe<IncidentsEdge>;
  /** Reads a single `MonitorDetection` that is related to this `Incident`. */
  monitorDetection?: Maybe<MonitorDetection>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `Incident` mutation. */
export type UpdateIncidentPayloadIncidentEdgeArgs = {
  orderBy?: InputMaybe<Array<IncidentsOrderBy>>;
};

/** All input for the `updateLiquidHeaderByRefrigerationSystemIdAndLabel` mutation. */
export type UpdateLiquidHeaderByRefrigerationSystemIdAndLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The display label of the liquid header. */
  label: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `LiquidHeader` being updated. */
  patch: LiquidHeaderPatch;
  /** References the refrigeration system this liquid header belongs to. */
  refrigerationSystemId: Scalars['Int']['input'];
};

/** All input for the `updateLiquidHeader` mutation. */
export type UpdateLiquidHeaderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The unique identifier for the liquid header. */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `LiquidHeader` being updated. */
  patch: LiquidHeaderPatch;
};

/** The output of our update `LiquidHeader` mutation. */
export type UpdateLiquidHeaderPayload = {
  __typename?: 'UpdateLiquidHeaderPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `LiquidHeader` that was updated by this mutation. */
  liquidHeader?: Maybe<LiquidHeader>;
  /** An edge for our `LiquidHeader`. May be used by Relay 1. */
  liquidHeaderEdge?: Maybe<LiquidHeadersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RefrigerationSystem` that is related to this `LiquidHeader`. */
  refrigerationSystem?: Maybe<RefrigerationSystem>;
  /** Reads a single `Vessel` that is related to this `LiquidHeader`. */
  vessel?: Maybe<Vessel>;
};

/** The output of our update `LiquidHeader` mutation. */
export type UpdateLiquidHeaderPayloadLiquidHeaderEdgeArgs = {
  orderBy?: InputMaybe<Array<LiquidHeadersOrderBy>>;
};

/** All input for the `updateLiquidHeadersEvaporatorByLiquidHeaderIdAndEvaporatorId` mutation. */
export type UpdateLiquidHeadersEvaporatorByLiquidHeaderIdAndEvaporatorIdInput =
  {
    /**
     * An arbitrary string value with no semantic meaning. Will be included in the
     * payload verbatim. May be used to track mutations by the client.
     */
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** References the evaporator connection */
    evaporatorId: Scalars['Int']['input'];
    /** References the liquid header connection */
    liquidHeaderId: Scalars['Int']['input'];
    /** An object where the defined keys will be set on the `LiquidHeadersEvaporator` being updated. */
    patch: LiquidHeadersEvaporatorPatch;
  };

/** All input for the `updateLiquidHeadersEvaporator` mutation. */
export type UpdateLiquidHeadersEvaporatorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `LiquidHeadersEvaporator` being updated. */
  patch: LiquidHeadersEvaporatorPatch;
};

/** The output of our update `LiquidHeadersEvaporator` mutation. */
export type UpdateLiquidHeadersEvaporatorPayload = {
  __typename?: 'UpdateLiquidHeadersEvaporatorPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Evaporator` that is related to this `LiquidHeadersEvaporator`. */
  evaporator?: Maybe<Evaporator>;
  /** Reads a single `LiquidHeader` that is related to this `LiquidHeadersEvaporator`. */
  liquidHeader?: Maybe<LiquidHeader>;
  /** The `LiquidHeadersEvaporator` that was updated by this mutation. */
  liquidHeadersEvaporator?: Maybe<LiquidHeadersEvaporator>;
  /** An edge for our `LiquidHeadersEvaporator`. May be used by Relay 1. */
  liquidHeadersEvaporatorEdge?: Maybe<LiquidHeadersEvaporatorsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `LiquidHeadersEvaporator` mutation. */
export type UpdateLiquidHeadersEvaporatorPayloadLiquidHeadersEvaporatorEdgeArgs =
  {
    orderBy?: InputMaybe<Array<LiquidHeadersEvaporatorsOrderBy>>;
  };

/** All input for the `updateMachineUser` mutation. */
export type UpdateMachineUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifier of the machine user. */
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `MachineUser` being updated. */
  patch: MachineUserPatch;
};

/** The output of our update `MachineUser` mutation. */
export type UpdateMachineUserPayload = {
  __typename?: 'UpdateMachineUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `MachineUser` that was updated by this mutation. */
  machineUser?: Maybe<MachineUser>;
  /** An edge for our `MachineUser`. May be used by Relay 1. */
  machineUserEdge?: Maybe<MachineUsersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `MachineUser` mutation. */
export type UpdateMachineUserPayloadMachineUserEdgeArgs = {
  orderBy?: InputMaybe<Array<MachineUsersOrderBy>>;
};

/** All input for the `updateMainServiceByFacilityIdAndName` mutation. */
export type UpdateMainServiceByFacilityIdAndNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The facility this main service belongs to */
  facilityId: Scalars['Int']['input'];
  /** The name for this main service */
  name: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `MainService` being updated. */
  patch: MainServicePatch;
};

/** All input for the `updateMainServiceByFacilityIdAndUsageDataPointIdAndDemandDataPointId` mutation. */
export type UpdateMainServiceByFacilityIdAndUsageDataPointIdAndDemandDataPointIdInput =
  {
    /**
     * An arbitrary string value with no semantic meaning. Will be included in the
     * payload verbatim. May be used to track mutations by the client.
     */
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** The demand data point that represents this main service's contribution to/from the facility */
    demandDataPointId: Scalars['Int']['input'];
    /** The facility this main service belongs to */
    facilityId: Scalars['Int']['input'];
    /** An object where the defined keys will be set on the `MainService` being updated. */
    patch: MainServicePatch;
    /** The usage data point that represents this main service's contribution to/from the facility */
    usageDataPointId: Scalars['Int']['input'];
  };

/** All input for the `updateMainService` mutation. */
export type UpdateMainServiceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the main service */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `MainService` being updated. */
  patch: MainServicePatch;
};

/** The output of our update `MainService` mutation. */
export type UpdateMainServicePayload = {
  __typename?: 'UpdateMainServicePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DataPoint` that is related to this `MainService`. */
  demand?: Maybe<DataPoint>;
  /** Reads a single `Facility` that is related to this `MainService`. */
  facility?: Maybe<Facility>;
  /** Reads a single `DataPoint` that is related to this `MainService`. */
  gridDemand?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `MainService`. */
  gridUsage?: Maybe<DataPoint>;
  /** The `MainService` that was updated by this mutation. */
  mainService?: Maybe<MainService>;
  /** An edge for our `MainService`. May be used by Relay 1. */
  mainServiceEdge?: Maybe<MainServicesEdge>;
  /** Reads a single `DataPoint` that is related to this `MainService`. */
  meterDemand?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `MainService`. */
  meterUsage?: Maybe<DataPoint>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DataPoint` that is related to this `MainService`. */
  usage?: Maybe<DataPoint>;
};

/** The output of our update `MainService` mutation. */
export type UpdateMainServicePayloadMainServiceEdgeArgs = {
  orderBy?: InputMaybe<Array<MainServicesOrderBy>>;
};

/** All input for the `updateMeterCharge` mutation. */
export type UpdateMeterChargeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `MeterCharge` being updated. */
  patch: MeterChargePatch;
};

/** The output of our update `MeterCharge` mutation. */
export type UpdateMeterChargePayload = {
  __typename?: 'UpdateMeterChargePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `MeterCharge` that was updated by this mutation. */
  meterCharge?: Maybe<MeterCharge>;
  /** An edge for our `MeterCharge`. May be used by Relay 1. */
  meterChargeEdge?: Maybe<MeterChargesEdge>;
  /** Reads a single `MeterStatement` that is related to this `MeterCharge`. */
  meterStatement?: Maybe<MeterStatement>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `MeterCharge` mutation. */
export type UpdateMeterChargePayloadMeterChargeEdgeArgs = {
  orderBy?: InputMaybe<Array<MeterChargesOrderBy>>;
};

/** All input for the `updateMeterStatement` mutation. */
export type UpdateMeterStatementInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `MeterStatement` being updated. */
  patch: MeterStatementPatch;
};

/** The output of our update `MeterStatement` mutation. */
export type UpdateMeterStatementPayload = {
  __typename?: 'UpdateMeterStatementPayload';
  /** Reads a single `AccountStatement` that is related to this `MeterStatement`. */
  accountStatement?: Maybe<AccountStatement>;
  /** Reads a single `AccountStatementPdf` that is related to this `MeterStatement`. */
  accountStatementPdf?: Maybe<AccountStatementPdf>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `MeterStatement` that was updated by this mutation. */
  meterStatement?: Maybe<MeterStatement>;
  /** An edge for our `MeterStatement`. May be used by Relay 1. */
  meterStatementEdge?: Maybe<MeterStatementsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `UtilityMeter` that is related to this `MeterStatement`. */
  utilityMeter?: Maybe<UtilityMeter>;
};

/** The output of our update `MeterStatement` mutation. */
export type UpdateMeterStatementPayloadMeterStatementEdgeArgs = {
  orderBy?: InputMaybe<Array<MeterStatementsOrderBy>>;
};

/** All input for the `updateMeterUsage` mutation. */
export type UpdateMeterUsageInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `MeterUsage` being updated. */
  patch: MeterUsagePatch;
};

/** The output of our update `MeterUsage` mutation. */
export type UpdateMeterUsagePayload = {
  __typename?: 'UpdateMeterUsagePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `MeterStatement` that is related to this `MeterUsage`. */
  meterStatement?: Maybe<MeterStatement>;
  /** The `MeterUsage` that was updated by this mutation. */
  meterUsage?: Maybe<MeterUsage>;
  /** An edge for our `MeterUsage`. May be used by Relay 1. */
  meterUsageEdge?: Maybe<MeterUsagesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `MeterUsage` mutation. */
export type UpdateMeterUsagePayloadMeterUsageEdgeArgs = {
  orderBy?: InputMaybe<Array<MeterUsagesOrderBy>>;
};

/** All input for the `updateMonitorDataPoint` mutation. */
export type UpdateMonitorDataPointInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The associated data point. */
  dataPointId: Scalars['Int']['input'];
  /** The associated monitor. */
  monitorId: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `MonitorDataPoint` being updated. */
  patch: MonitorDataPointPatch;
};

/** The output of our update `MonitorDataPoint` mutation. */
export type UpdateMonitorDataPointPayload = {
  __typename?: 'UpdateMonitorDataPointPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DataPoint` that is related to this `MonitorDataPoint`. */
  dataPoint?: Maybe<DataPoint>;
  /** Reads a single `Monitor` that is related to this `MonitorDataPoint`. */
  monitor?: Maybe<Monitor>;
  /** The `MonitorDataPoint` that was updated by this mutation. */
  monitorDataPoint?: Maybe<MonitorDataPoint>;
  /** An edge for our `MonitorDataPoint`. May be used by Relay 1. */
  monitorDataPointEdge?: Maybe<MonitorDataPointsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `MonitorDataPoint` mutation. */
export type UpdateMonitorDataPointPayloadMonitorDataPointEdgeArgs = {
  orderBy?: InputMaybe<Array<MonitorDataPointsOrderBy>>;
};

/** All input for the `updateMonitorDetection` mutation. */
export type UpdateMonitorDetectionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifer of the detected event. */
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `MonitorDetection` being updated. */
  patch: MonitorDetectionPatch;
};

/** The output of our update `MonitorDetection` mutation. */
export type UpdateMonitorDetectionPayload = {
  __typename?: 'UpdateMonitorDetectionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Monitor` that is related to this `MonitorDetection`. */
  monitor?: Maybe<Monitor>;
  /** The `MonitorDetection` that was updated by this mutation. */
  monitorDetection?: Maybe<MonitorDetection>;
  /** An edge for our `MonitorDetection`. May be used by Relay 1. */
  monitorDetectionEdge?: Maybe<MonitorDetectionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `MonitorDetection` mutation. */
export type UpdateMonitorDetectionPayloadMonitorDetectionEdgeArgs = {
  orderBy?: InputMaybe<Array<MonitorDetectionsOrderBy>>;
};

/** All input for the `updateMonitor` mutation. */
export type UpdateMonitorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifer of the monitor. */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `Monitor` being updated. */
  patch: MonitorPatch;
};

/** The output of our update `Monitor` mutation. */
export type UpdateMonitorPayload = {
  __typename?: 'UpdateMonitorPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Monitor` that was updated by this mutation. */
  monitor?: Maybe<Monitor>;
  /** An edge for our `Monitor`. May be used by Relay 1. */
  monitorEdge?: Maybe<MonitorsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `Monitor` mutation. */
export type UpdateMonitorPayloadMonitorEdgeArgs = {
  orderBy?: InputMaybe<Array<MonitorsOrderBy>>;
};

/** All input for the `updateOpportunityAttachment` mutation. */
export type UpdateOpportunityAttachmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifier of the opportunity attachment. */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `OpportunityAttachment` being updated. */
  patch: OpportunityAttachmentPatch;
};

/** The output of our update `OpportunityAttachment` mutation. */
export type UpdateOpportunityAttachmentPayload = {
  __typename?: 'UpdateOpportunityAttachmentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Opportunity` that is related to this `OpportunityAttachment`. */
  opportunity?: Maybe<Opportunity>;
  /** The `OpportunityAttachment` that was updated by this mutation. */
  opportunityAttachment?: Maybe<OpportunityAttachment>;
  /** An edge for our `OpportunityAttachment`. May be used by Relay 1. */
  opportunityAttachmentEdge?: Maybe<OpportunityAttachmentsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `OpportunityAttachment` mutation. */
export type UpdateOpportunityAttachmentPayloadOpportunityAttachmentEdgeArgs = {
  orderBy?: InputMaybe<Array<OpportunityAttachmentsOrderBy>>;
};

/** All input for the `updateOpportunity` mutation. */
export type UpdateOpportunityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifier of the opportunity. */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `Opportunity` being updated. */
  patch: OpportunityPatch;
};

/** The output of our update `Opportunity` mutation. */
export type UpdateOpportunityPayload = {
  __typename?: 'UpdateOpportunityPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Facility` that is related to this `Opportunity`. */
  facility?: Maybe<Facility>;
  /** The `Opportunity` that was updated by this mutation. */
  opportunity?: Maybe<Opportunity>;
  /** An edge for our `Opportunity`. May be used by Relay 1. */
  opportunityEdge?: Maybe<OpportunitiesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `Opportunity` mutation. */
export type UpdateOpportunityPayloadOpportunityEdgeArgs = {
  orderBy?: InputMaybe<Array<OpportunitiesOrderBy>>;
};

/** All input for the `updatePalletBySourceId` mutation. */
export type UpdatePalletBySourceIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `Pallet` being updated. */
  patch: PalletPatch;
  /** The globally unique external identifier of the record from the original source system */
  sourceId: Scalars['String']['input'];
};

/** All input for the `updatePalletHistoryBySourceId` mutation. */
export type UpdatePalletHistoryBySourceIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `PalletHistory` being updated. */
  patch: PalletHistoryPatch;
  /** The globally unique external identifier of the record from the original source system */
  sourceId: Scalars['String']['input'];
};

/** All input for the `updatePalletHistory` mutation. */
export type UpdatePalletHistoryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `PalletHistory` being updated. */
  patch: PalletHistoryPatch;
};

/** The output of our update `PalletHistory` mutation. */
export type UpdatePalletHistoryPayload = {
  __typename?: 'UpdatePalletHistoryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `PalletHistory` that was updated by this mutation. */
  palletHistory?: Maybe<PalletHistory>;
  /** An edge for our `PalletHistory`. May be used by Relay 1. */
  palletHistoryEdge?: Maybe<PalletHistoriesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `PalletHistory` mutation. */
export type UpdatePalletHistoryPayloadPalletHistoryEdgeArgs = {
  orderBy?: InputMaybe<Array<PalletHistoriesOrderBy>>;
};

/** All input for the `updatePallet` mutation. */
export type UpdatePalletInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `Pallet` being updated. */
  patch: PalletPatch;
};

/** All input for the `updatePalletLocationBySourceId` mutation. */
export type UpdatePalletLocationBySourceIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `PalletLocation` being updated. */
  patch: PalletLocationPatch;
  /** The globally unique external identifier of the record from the original source system */
  sourceId: Scalars['String']['input'];
};

/** All input for the `updatePalletLocation` mutation. */
export type UpdatePalletLocationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `PalletLocation` being updated. */
  patch: PalletLocationPatch;
};

/** The output of our update `PalletLocation` mutation. */
export type UpdatePalletLocationPayload = {
  __typename?: 'UpdatePalletLocationPayload';
  /** Reads a single `BuildingArea` that is related to this `PalletLocation`. */
  buildingArea?: Maybe<BuildingArea>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Facility` that is related to this `PalletLocation`. */
  facility?: Maybe<Facility>;
  /** The `PalletLocation` that was updated by this mutation. */
  palletLocation?: Maybe<PalletLocation>;
  /** An edge for our `PalletLocation`. May be used by Relay 1. */
  palletLocationEdge?: Maybe<PalletLocationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `PalletLocation` mutation. */
export type UpdatePalletLocationPayloadPalletLocationEdgeArgs = {
  orderBy?: InputMaybe<Array<PalletLocationsOrderBy>>;
};

/** The output of our update `Pallet` mutation. */
export type UpdatePalletPayload = {
  __typename?: 'UpdatePalletPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Pallet` that was updated by this mutation. */
  pallet?: Maybe<Pallet>;
  /** An edge for our `Pallet`. May be used by Relay 1. */
  palletEdge?: Maybe<PalletsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `Pallet` mutation. */
export type UpdatePalletPayloadPalletEdgeArgs = {
  orderBy?: InputMaybe<Array<PalletsOrderBy>>;
};

export type UpdatePhoneNumberInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
  verificationCode: Scalars['String']['input'];
};

export type UpdatePhoneNumberResponse = {
  __typename?: 'UpdatePhoneNumberResponse';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user: User;
};

/** All input for the `updatePricingNode` mutation. */
export type UpdatePricingNodeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifer of the pricing node. */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `PricingNode` being updated. */
  patch: PricingNodePatch;
};

/** The output of our update `PricingNode` mutation. */
export type UpdatePricingNodePayload = {
  __typename?: 'UpdatePricingNodePayload';
  /** Reads a single `BalancingAuthority` that is related to this `PricingNode`. */
  balancingAuthority?: Maybe<BalancingAuthority>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `PricingNode` that was updated by this mutation. */
  pricingNode?: Maybe<PricingNode>;
  /** An edge for our `PricingNode`. May be used by Relay 1. */
  pricingNodeEdge?: Maybe<PricingNodesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `PricingNode` mutation. */
export type UpdatePricingNodePayloadPricingNodeEdgeArgs = {
  orderBy?: InputMaybe<Array<PricingNodesOrderBy>>;
};

/** All input for the `updateProductBySourceId` mutation. */
export type UpdateProductBySourceIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `Product` being updated. */
  patch: ProductPatch;
  /** The globally unique external identifier of the record from the original source system */
  sourceId: Scalars['String']['input'];
};

/** All input for the `updateProduct` mutation. */
export type UpdateProductInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The unique, auto-generated ID of the record */
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `Product` being updated. */
  patch: ProductPatch;
};

/** The output of our update `Product` mutation. */
export type UpdateProductPayload = {
  __typename?: 'UpdateProductPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Facility` that is related to this `Product`. */
  facility?: Maybe<Facility>;
  /** The `Product` that was updated by this mutation. */
  product?: Maybe<Product>;
  /** An edge for our `Product`. May be used by Relay 1. */
  productEdge?: Maybe<ProductsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `Product` mutation. */
export type UpdateProductPayloadProductEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};

/** All input for the `updateProgramByProjectTypeIdAndName` mutation. */
export type UpdateProgramByProjectTypeIdAndNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The name of the program. */
  name: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `Program` being updated. */
  patch: ProgramPatch;
  /** The id of the project type the program is associated with. */
  projectTypeId: Scalars['Int']['input'];
};

/** All input for the `updateProgramEnrollmentByProgramIdAndName` mutation. */
export type UpdateProgramEnrollmentByProgramIdAndNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The name of this program enrollment. */
  name: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `ProgramEnrollment` being updated. */
  patch: ProgramEnrollmentPatch;
  /** The program this program enrollment belongs to. */
  programId: Scalars['Int']['input'];
};

/** All input for the `updateProgramEnrollment` mutation. */
export type UpdateProgramEnrollmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifer of the program enrollment. */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `ProgramEnrollment` being updated. */
  patch: ProgramEnrollmentPatch;
};

/** The output of our update `ProgramEnrollment` mutation. */
export type UpdateProgramEnrollmentPayload = {
  __typename?: 'UpdateProgramEnrollmentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Program` that is related to this `ProgramEnrollment`. */
  program?: Maybe<Program>;
  /** The `ProgramEnrollment` that was updated by this mutation. */
  programEnrollment?: Maybe<ProgramEnrollment>;
  /** An edge for our `ProgramEnrollment`. May be used by Relay 1. */
  programEnrollmentEdge?: Maybe<ProgramEnrollmentsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `ProgramEnrollment` mutation. */
export type UpdateProgramEnrollmentPayloadProgramEnrollmentEdgeArgs = {
  orderBy?: InputMaybe<Array<ProgramEnrollmentsOrderBy>>;
};

/** All input for the `updateProgram` mutation. */
export type UpdateProgramInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifer of the program. */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `Program` being updated. */
  patch: ProgramPatch;
};

/** The output of our update `Program` mutation. */
export type UpdateProgramPayload = {
  __typename?: 'UpdateProgramPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Program` that was updated by this mutation. */
  program?: Maybe<Program>;
  /** An edge for our `Program`. May be used by Relay 1. */
  programEdge?: Maybe<ProgramsEdge>;
  /** Reads a single `ProjectType` that is related to this `Program`. */
  projectType?: Maybe<ProjectType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Timezone` that is related to this `Program`. */
  timezone?: Maybe<Timezone>;
};

/** The output of our update `Program` mutation. */
export type UpdateProgramPayloadProgramEdgeArgs = {
  orderBy?: InputMaybe<Array<ProgramsOrderBy>>;
};

/** All input for the `updateProjectByFacilityIdAndProgramId` mutation. */
export type UpdateProjectByFacilityIdAndProgramIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifier of the facility. */
  facilityId: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `Project` being updated. */
  patch: ProjectPatch;
  /** The id of the program the project is associated with */
  programId: Scalars['Int']['input'];
};

/** All input for the `updateProjectComponent` mutation. */
export type UpdateProjectComponentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  componentId: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `ProjectComponent` being updated. */
  patch: ProjectComponentPatch;
  projectId: Scalars['Int']['input'];
};

/** The output of our update `ProjectComponent` mutation. */
export type UpdateProjectComponentPayload = {
  __typename?: 'UpdateProjectComponentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Component` that is related to this `ProjectComponent`. */
  component?: Maybe<Component>;
  /** Reads a single `Project` that is related to this `ProjectComponent`. */
  project?: Maybe<Project>;
  /** The `ProjectComponent` that was updated by this mutation. */
  projectComponent?: Maybe<ProjectComponent>;
  /** An edge for our `ProjectComponent`. May be used by Relay 1. */
  projectComponentEdge?: Maybe<ProjectComponentsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `ProjectComponent` mutation. */
export type UpdateProjectComponentPayloadProjectComponentEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectComponentsOrderBy>>;
};

/** All input for the `updateProjectEnrollmentByProjectIdAndProgramEnrollmentId` mutation. */
export type UpdateProjectEnrollmentByProjectIdAndProgramEnrollmentIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `ProjectEnrollment` being updated. */
  patch: ProjectEnrollmentPatch;
  /** The program enrollment this project enrollment belongs to. */
  programEnrollmentId: Scalars['Int']['input'];
  /** The project this project enrollment belongs to. */
  projectId: Scalars['Int']['input'];
};

/** All input for the `updateProjectEnrollmentDataPointByProjectEnrollmentIdAndDataPointId` mutation. */
export type UpdateProjectEnrollmentDataPointByProjectEnrollmentIdAndDataPointIdInput =
  {
    /**
     * An arbitrary string value with no semantic meaning. Will be included in the
     * payload verbatim. May be used to track mutations by the client.
     */
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** The data point being referenced. */
    dataPointId: Scalars['Int']['input'];
    /** An object where the defined keys will be set on the `ProjectEnrollmentDataPoint` being updated. */
    patch: ProjectEnrollmentDataPointPatch;
    /** The project enrollment this data point belongs to. */
    projectEnrollmentId: Scalars['Int']['input'];
  };

/** All input for the `updateProjectEnrollmentDataPointGroup` mutation. */
export type UpdateProjectEnrollmentDataPointGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifer of the project enrollment. */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `ProjectEnrollmentDataPointGroup` being updated. */
  patch: ProjectEnrollmentDataPointGroupPatch;
};

/** The output of our update `ProjectEnrollmentDataPointGroup` mutation. */
export type UpdateProjectEnrollmentDataPointGroupPayload = {
  __typename?: 'UpdateProjectEnrollmentDataPointGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `ProjectEnrollmentDataPointGroup` that was updated by this mutation. */
  projectEnrollmentDataPointGroup?: Maybe<ProjectEnrollmentDataPointGroup>;
  /** An edge for our `ProjectEnrollmentDataPointGroup`. May be used by Relay 1. */
  projectEnrollmentDataPointGroupEdge?: Maybe<ProjectEnrollmentDataPointGroupsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `ProjectEnrollmentDataPointGroup` mutation. */
export type UpdateProjectEnrollmentDataPointGroupPayloadProjectEnrollmentDataPointGroupEdgeArgs =
  {
    orderBy?: InputMaybe<Array<ProjectEnrollmentDataPointGroupsOrderBy>>;
  };

/** All input for the `updateProjectEnrollmentDataPoint` mutation. */
export type UpdateProjectEnrollmentDataPointInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifer of the project enrollment data point. */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `ProjectEnrollmentDataPoint` being updated. */
  patch: ProjectEnrollmentDataPointPatch;
};

/** The output of our update `ProjectEnrollmentDataPoint` mutation. */
export type UpdateProjectEnrollmentDataPointPayload = {
  __typename?: 'UpdateProjectEnrollmentDataPointPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DataPoint` that is related to this `ProjectEnrollmentDataPoint`. */
  dataPoint?: Maybe<DataPoint>;
  /** Reads a single `ProjectEnrollmentDataPointGroup` that is related to this `ProjectEnrollmentDataPoint`. */
  group?: Maybe<ProjectEnrollmentDataPointGroup>;
  /** Reads a single `DataPoint` that is related to this `ProjectEnrollmentDataPoint`. */
  profileDataPoint?: Maybe<DataPoint>;
  /** Reads a single `ProjectEnrollment` that is related to this `ProjectEnrollmentDataPoint`. */
  projectEnrollment?: Maybe<ProjectEnrollment>;
  /** The `ProjectEnrollmentDataPoint` that was updated by this mutation. */
  projectEnrollmentDataPoint?: Maybe<ProjectEnrollmentDataPoint>;
  /** An edge for our `ProjectEnrollmentDataPoint`. May be used by Relay 1. */
  projectEnrollmentDataPointEdge?: Maybe<ProjectEnrollmentDataPointsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `ProjectEnrollmentDataPoint` mutation. */
export type UpdateProjectEnrollmentDataPointPayloadProjectEnrollmentDataPointEdgeArgs =
  {
    orderBy?: InputMaybe<Array<ProjectEnrollmentDataPointsOrderBy>>;
  };

/** All input for the `updateProjectEnrollment` mutation. */
export type UpdateProjectEnrollmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifer of the project enrollment. */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `ProjectEnrollment` being updated. */
  patch: ProjectEnrollmentPatch;
};

/** The output of our update `ProjectEnrollment` mutation. */
export type UpdateProjectEnrollmentPayload = {
  __typename?: 'UpdateProjectEnrollmentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `ProgramEnrollment` that is related to this `ProjectEnrollment`. */
  programEnrollment?: Maybe<ProgramEnrollment>;
  /** Reads a single `Project` that is related to this `ProjectEnrollment`. */
  project?: Maybe<Project>;
  /** The `ProjectEnrollment` that was updated by this mutation. */
  projectEnrollment?: Maybe<ProjectEnrollment>;
  /** An edge for our `ProjectEnrollment`. May be used by Relay 1. */
  projectEnrollmentEdge?: Maybe<ProjectEnrollmentsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `ProjectEnrollment` mutation. */
export type UpdateProjectEnrollmentPayloadProjectEnrollmentEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectEnrollmentsOrderBy>>;
};

/** All input for the `updateProject` mutation. */
export type UpdateProjectInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifier of the optimization project. */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `Project` being updated. */
  patch: ProjectPatch;
};

/** The output of our update `Project` mutation. */
export type UpdateProjectPayload = {
  __typename?: 'UpdateProjectPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Facility` that is related to this `Project`. */
  facility?: Maybe<Facility>;
  /** Reads a single `Program` that is related to this `Project`. */
  program?: Maybe<Program>;
  /** The `Project` that was updated by this mutation. */
  project?: Maybe<Project>;
  /** An edge for our `Project`. May be used by Relay 1. */
  projectEdge?: Maybe<ProjectsEdge>;
  /** Reads a single `ProjectType` that is related to this `Project`. */
  projectType?: Maybe<ProjectType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `Project` mutation. */
export type UpdateProjectPayloadProjectEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectsOrderBy>>;
};

/** All input for the `updateProjectWatcher` mutation. */
export type UpdateProjectWatcherInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `ProjectWatcher` being updated. */
  patch: ProjectWatcherPatch;
  projectId: Scalars['Int']['input'];
  userId: Scalars['String']['input'];
};

/** The output of our update `ProjectWatcher` mutation. */
export type UpdateProjectWatcherPayload = {
  __typename?: 'UpdateProjectWatcherPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Project` that is related to this `ProjectWatcher`. */
  project?: Maybe<Project>;
  /** The `ProjectWatcher` that was updated by this mutation. */
  projectWatcher?: Maybe<ProjectWatcher>;
  /** An edge for our `ProjectWatcher`. May be used by Relay 1. */
  projectWatcherEdge?: Maybe<ProjectWatchersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `ProjectWatcher`. */
  user?: Maybe<User>;
};

/** The output of our update `ProjectWatcher` mutation. */
export type UpdateProjectWatcherPayloadProjectWatcherEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectWatchersOrderBy>>;
};

/** All input for the `updateRefrigerationSystemByFacilityIdAndLabel` mutation. */
export type UpdateRefrigerationSystemByFacilityIdAndLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** References the facility this refrigeration system belongs to. */
  facilityId: Scalars['Int']['input'];
  /** The display label of the refrigeration system. */
  label: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `RefrigerationSystem` being updated. */
  patch: RefrigerationSystemPatch;
};

/** All input for the `updateRefrigerationSystem` mutation. */
export type UpdateRefrigerationSystemInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The unique identifier for the refrigeration system. */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `RefrigerationSystem` being updated. */
  patch: RefrigerationSystemPatch;
};

/** The output of our update `RefrigerationSystem` mutation. */
export type UpdateRefrigerationSystemPayload = {
  __typename?: 'UpdateRefrigerationSystemPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Facility` that is related to this `RefrigerationSystem`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Refrigerant` that is related to this `RefrigerationSystem`. */
  refrigerant?: Maybe<Refrigerant>;
  /** The `RefrigerationSystem` that was updated by this mutation. */
  refrigerationSystem?: Maybe<RefrigerationSystem>;
  /** An edge for our `RefrigerationSystem`. May be used by Relay 1. */
  refrigerationSystemEdge?: Maybe<RefrigerationSystemsEdge>;
};

/** The output of our update `RefrigerationSystem` mutation. */
export type UpdateRefrigerationSystemPayloadRefrigerationSystemEdgeArgs = {
  orderBy?: InputMaybe<Array<RefrigerationSystemsOrderBy>>;
};

/** All input for the `updateReportByLabel` mutation. */
export type UpdateReportByLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The label of the report */
  label: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `Report` being updated. */
  patch: ReportPatch;
};

/** All input for the `updateReportExecution` mutation. */
export type UpdateReportExecutionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the record */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `ReportExecution` being updated. */
  patch: ReportExecutionPatch;
};

/** The output of our update `ReportExecution` mutation. */
export type UpdateReportExecutionPayload = {
  __typename?: 'UpdateReportExecutionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Report` that is related to this `ReportExecution`. */
  report?: Maybe<Report>;
  /** Reads a single `ReportAutomation` that is related to this `ReportExecution`. */
  reportAutomation?: Maybe<ReportAutomation>;
  /** The `ReportExecution` that was updated by this mutation. */
  reportExecution?: Maybe<ReportExecution>;
  /** An edge for our `ReportExecution`. May be used by Relay 1. */
  reportExecutionEdge?: Maybe<ReportExecutionsEdge>;
};

/** The output of our update `ReportExecution` mutation. */
export type UpdateReportExecutionPayloadReportExecutionEdgeArgs = {
  orderBy?: InputMaybe<Array<ReportExecutionsOrderBy>>;
};

/** All input for the `updateReport` mutation. */
export type UpdateReportInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the report */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `Report` being updated. */
  patch: ReportPatch;
};

/** The output of our update `Report` mutation. */
export type UpdateReportPayload = {
  __typename?: 'UpdateReportPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Report` that was updated by this mutation. */
  report?: Maybe<Report>;
  /** An edge for our `Report`. May be used by Relay 1. */
  reportEdge?: Maybe<ReportsEdge>;
};

/** The output of our update `Report` mutation. */
export type UpdateReportPayloadReportEdgeArgs = {
  orderBy?: InputMaybe<Array<ReportsOrderBy>>;
};

/** All input for the `updateSavingsEventByProjectIdAndStartTimeAndEndTime` mutation. */
export type UpdateSavingsEventByProjectIdAndStartTimeAndEndTimeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The time that the savings_event ended */
  endTime: Scalars['Datetime']['input'];
  /** An object where the defined keys will be set on the `SavingsEvent` being updated. */
  patch: SavingsEventPatch;
  /** This maps the savings_event to a project */
  projectId: Scalars['Int']['input'];
  /** The time that the savings_event started */
  startTime: Scalars['Datetime']['input'];
};

/** All input for the `updateSavingsEventDatumBySavingsEventIdAndLabel` mutation. */
export type UpdateSavingsEventDatumBySavingsEventIdAndLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** This column represents the attribute being recorded. */
  label: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `SavingsEventDatum` being updated. */
  patch: SavingsEventDatumPatch;
  /** This savings event this data belongs to. */
  savingsEventId: Scalars['Int']['input'];
};

/** All input for the `updateSavingsEventDatum` mutation. */
export type UpdateSavingsEventDatumInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifer of the savings event data. */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `SavingsEventDatum` being updated. */
  patch: SavingsEventDatumPatch;
};

/** The output of our update `SavingsEventDatum` mutation. */
export type UpdateSavingsEventDatumPayload = {
  __typename?: 'UpdateSavingsEventDatumPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SavingsEvent` that is related to this `SavingsEventDatum`. */
  savingsEvent?: Maybe<SavingsEvent>;
  /** The `SavingsEventDatum` that was updated by this mutation. */
  savingsEventDatum?: Maybe<SavingsEventDatum>;
  /** An edge for our `SavingsEventDatum`. May be used by Relay 1. */
  savingsEventDatumEdge?: Maybe<SavingsEventDataEdge>;
};

/** The output of our update `SavingsEventDatum` mutation. */
export type UpdateSavingsEventDatumPayloadSavingsEventDatumEdgeArgs = {
  orderBy?: InputMaybe<Array<SavingsEventDataOrderBy>>;
};

/** All input for the `updateSavingsEvent` mutation. */
export type UpdateSavingsEventInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `SavingsEvent` being updated. */
  patch: SavingsEventPatch;
};

/** The output of our update `SavingsEvent` mutation. */
export type UpdateSavingsEventPayload = {
  __typename?: 'UpdateSavingsEventPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Project` that is related to this `SavingsEvent`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SavingsEvent` that was updated by this mutation. */
  savingsEvent?: Maybe<SavingsEvent>;
  /** An edge for our `SavingsEvent`. May be used by Relay 1. */
  savingsEventEdge?: Maybe<SavingsEventsEdge>;
};

/** The output of our update `SavingsEvent` mutation. */
export type UpdateSavingsEventPayloadSavingsEventEdgeArgs = {
  orderBy?: InputMaybe<Array<SavingsEventsOrderBy>>;
};

/** All input for the `updateSeverityByName` mutation. */
export type UpdateSeverityByNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The unique name of the severity. */
  name: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `Severity` being updated. */
  patch: SeverityPatch;
};

/** All input for the `updateSeverityBySlug` mutation. */
export type UpdateSeverityBySlugInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `Severity` being updated. */
  patch: SeverityPatch;
  /** The unique slug of the severity. */
  slug: Scalars['String']['input'];
};

/** All input for the `updateSeverity` mutation. */
export type UpdateSeverityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifier of the severity. */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `Severity` being updated. */
  patch: SeverityPatch;
};

/** The output of our update `Severity` mutation. */
export type UpdateSeverityPayload = {
  __typename?: 'UpdateSeverityPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Severity` that was updated by this mutation. */
  severity?: Maybe<Severity>;
  /** An edge for our `Severity`. May be used by Relay 1. */
  severityEdge?: Maybe<SeveritiesEdge>;
};

/** The output of our update `Severity` mutation. */
export type UpdateSeverityPayloadSeverityEdgeArgs = {
  orderBy?: InputMaybe<Array<SeveritiesOrderBy>>;
};

/** All input for the `updateSubmeter` mutation. */
export type UpdateSubmeterInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The internal ID of this submeter */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `Submeter` being updated. */
  patch: SubmeterPatch;
};

/** The output of our update `Submeter` mutation. */
export type UpdateSubmeterPayload = {
  __typename?: 'UpdateSubmeterPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DataPoint` that is related to this `Submeter`. */
  demand?: Maybe<DataPoint>;
  /** Reads a single `Facility` that is related to this `Submeter`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Submeter` that was updated by this mutation. */
  submeter?: Maybe<Submeter>;
  /** An edge for our `Submeter`. May be used by Relay 1. */
  submeterEdge?: Maybe<SubmetersEdge>;
  /** Reads a single `DataPoint` that is related to this `Submeter`. */
  usage?: Maybe<DataPoint>;
  /** Reads a single `UtilityMeter` that is related to this `Submeter`. */
  utilityMeter?: Maybe<UtilityMeter>;
};

/** The output of our update `Submeter` mutation. */
export type UpdateSubmeterPayloadSubmeterEdgeArgs = {
  orderBy?: InputMaybe<Array<SubmetersOrderBy>>;
};

/** All input for the `updateSubmeterSessionBySubmeterIdAndStartTime` mutation. */
export type UpdateSubmeterSessionBySubmeterIdAndStartTimeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `SubmeterSession` being updated. */
  patch: SubmeterSessionPatch;
  /** The beginning of this session */
  startTime: Scalars['Datetime']['input'];
  /** The submeter this session belongs to */
  submeterId: Scalars['Int']['input'];
};

/** All input for the `updateSubmeterSession` mutation. */
export type UpdateSubmeterSessionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The internal ID of this submeter session */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `SubmeterSession` being updated. */
  patch: SubmeterSessionPatch;
};

/** The output of our update `SubmeterSession` mutation. */
export type UpdateSubmeterSessionPayload = {
  __typename?: 'UpdateSubmeterSessionPayload';
  /** Reads a single `BillableCustomer` that is related to this `SubmeterSession`. */
  associatedCustomer?: Maybe<BillableCustomer>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Submeter` that is related to this `SubmeterSession`. */
  submeter?: Maybe<Submeter>;
  /** The `SubmeterSession` that was updated by this mutation. */
  submeterSession?: Maybe<SubmeterSession>;
  /** An edge for our `SubmeterSession`. May be used by Relay 1. */
  submeterSessionEdge?: Maybe<SubmeterSessionsEdge>;
};

/** The output of our update `SubmeterSession` mutation. */
export type UpdateSubmeterSessionPayloadSubmeterSessionEdgeArgs = {
  orderBy?: InputMaybe<Array<SubmeterSessionsOrderBy>>;
};

/** All input for the `updateSuctionGroupByRefrigerationSystemIdAndLabel` mutation. */
export type UpdateSuctionGroupByRefrigerationSystemIdAndLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The display label of the suction group. */
  label: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `SuctionGroup` being updated. */
  patch: SuctionGroupPatch;
  /** References the refrigeration system this suction group belongs to. */
  refrigerationSystemId: Scalars['Int']['input'];
};

/** All input for the `updateSuctionGroupCompressorBySuctionGroupIdAndCompressorId` mutation. */
export type UpdateSuctionGroupCompressorBySuctionGroupIdAndCompressorIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** References the compressor connection */
  compressorId: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `SuctionGroupCompressor` being updated. */
  patch: SuctionGroupCompressorPatch;
  /** References the suction group connection */
  suctionGroupId: Scalars['Int']['input'];
};

/** All input for the `updateSuctionGroupCompressor` mutation. */
export type UpdateSuctionGroupCompressorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `SuctionGroupCompressor` being updated. */
  patch: SuctionGroupCompressorPatch;
};

/** The output of our update `SuctionGroupCompressor` mutation. */
export type UpdateSuctionGroupCompressorPayload = {
  __typename?: 'UpdateSuctionGroupCompressorPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Compressor` that is related to this `SuctionGroupCompressor`. */
  compressor?: Maybe<Compressor>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SuctionGroup` that is related to this `SuctionGroupCompressor`. */
  suctionGroup?: Maybe<SuctionGroup>;
  /** The `SuctionGroupCompressor` that was updated by this mutation. */
  suctionGroupCompressor?: Maybe<SuctionGroupCompressor>;
  /** An edge for our `SuctionGroupCompressor`. May be used by Relay 1. */
  suctionGroupCompressorEdge?: Maybe<SuctionGroupCompressorsEdge>;
};

/** The output of our update `SuctionGroupCompressor` mutation. */
export type UpdateSuctionGroupCompressorPayloadSuctionGroupCompressorEdgeArgs =
  {
    orderBy?: InputMaybe<Array<SuctionGroupCompressorsOrderBy>>;
  };

/** All input for the `updateSuctionGroup` mutation. */
export type UpdateSuctionGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The unique identifier for the suction group. */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `SuctionGroup` being updated. */
  patch: SuctionGroupPatch;
};

/** The output of our update `SuctionGroup` mutation. */
export type UpdateSuctionGroupPayload = {
  __typename?: 'UpdateSuctionGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RefrigerationSystem` that is related to this `SuctionGroup`. */
  refrigerationSystem?: Maybe<RefrigerationSystem>;
  /** The `SuctionGroup` that was updated by this mutation. */
  suctionGroup?: Maybe<SuctionGroup>;
  /** An edge for our `SuctionGroup`. May be used by Relay 1. */
  suctionGroupEdge?: Maybe<SuctionGroupsEdge>;
  /** Reads a single `DataPoint` that is related to this `SuctionGroup`. */
  suctionPressure?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `SuctionGroup`. */
  suctionPressureSetpoint?: Maybe<DataPoint>;
};

/** The output of our update `SuctionGroup` mutation. */
export type UpdateSuctionGroupPayloadSuctionGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<SuctionGroupsOrderBy>>;
};

/** All input for the `updateSuctionHeaderByRefrigerationSystemIdAndLabel` mutation. */
export type UpdateSuctionHeaderByRefrigerationSystemIdAndLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The display label of the suction header. */
  label: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `SuctionHeader` being updated. */
  patch: SuctionHeaderPatch;
  /** References the refrigeration system this suction header belongs to. */
  refrigerationSystemId: Scalars['Int']['input'];
};

/** All input for the `updateSuctionHeader` mutation. */
export type UpdateSuctionHeaderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The unique identifier for the suction header. */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `SuctionHeader` being updated. */
  patch: SuctionHeaderPatch;
};

/** The output of our update `SuctionHeader` mutation. */
export type UpdateSuctionHeaderPayload = {
  __typename?: 'UpdateSuctionHeaderPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RefrigerationSystem` that is related to this `SuctionHeader`. */
  refrigerationSystem?: Maybe<RefrigerationSystem>;
  /** Reads a single `SuctionGroup` that is related to this `SuctionHeader`. */
  suctionGroup?: Maybe<SuctionGroup>;
  /** The `SuctionHeader` that was updated by this mutation. */
  suctionHeader?: Maybe<SuctionHeader>;
  /** An edge for our `SuctionHeader`. May be used by Relay 1. */
  suctionHeaderEdge?: Maybe<SuctionHeadersEdge>;
};

/** The output of our update `SuctionHeader` mutation. */
export type UpdateSuctionHeaderPayloadSuctionHeaderEdgeArgs = {
  orderBy?: InputMaybe<Array<SuctionHeadersOrderBy>>;
};

/** All input for the `updateSuctionHeadersCompressorBySuctionHeaderIdAndCompressorId` mutation. */
export type UpdateSuctionHeadersCompressorBySuctionHeaderIdAndCompressorIdInput =
  {
    /**
     * An arbitrary string value with no semantic meaning. Will be included in the
     * payload verbatim. May be used to track mutations by the client.
     */
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** References the compressor connection */
    compressorId: Scalars['Int']['input'];
    /** An object where the defined keys will be set on the `SuctionHeadersCompressor` being updated. */
    patch: SuctionHeadersCompressorPatch;
    /** References the suction header connection */
    suctionHeaderId: Scalars['Int']['input'];
  };

/** All input for the `updateSuctionHeadersCompressor` mutation. */
export type UpdateSuctionHeadersCompressorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `SuctionHeadersCompressor` being updated. */
  patch: SuctionHeadersCompressorPatch;
};

/** The output of our update `SuctionHeadersCompressor` mutation. */
export type UpdateSuctionHeadersCompressorPayload = {
  __typename?: 'UpdateSuctionHeadersCompressorPayload';
  /** Reads a single `DataPoint` that is related to this `SuctionHeadersCompressor`. */
  active?: Maybe<DataPoint>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Compressor` that is related to this `SuctionHeadersCompressor`. */
  compressor?: Maybe<Compressor>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SuctionHeader` that is related to this `SuctionHeadersCompressor`. */
  suctionHeader?: Maybe<SuctionHeader>;
  /** The `SuctionHeadersCompressor` that was updated by this mutation. */
  suctionHeadersCompressor?: Maybe<SuctionHeadersCompressor>;
  /** An edge for our `SuctionHeadersCompressor`. May be used by Relay 1. */
  suctionHeadersCompressorEdge?: Maybe<SuctionHeadersCompressorsEdge>;
};

/** The output of our update `SuctionHeadersCompressor` mutation. */
export type UpdateSuctionHeadersCompressorPayloadSuctionHeadersCompressorEdgeArgs =
  {
    orderBy?: InputMaybe<Array<SuctionHeadersCompressorsOrderBy>>;
  };

/** All input for the `updateSuggestionControlEventByControlEventId` mutation. */
export type UpdateSuggestionControlEventByControlEventIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  controlEventId: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `SuggestionControlEvent` being updated. */
  patch: SuggestionControlEventPatch;
};

/** All input for the `updateSuggestionControlEvent` mutation. */
export type UpdateSuggestionControlEventInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  controlEventId: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `SuggestionControlEvent` being updated. */
  patch: SuggestionControlEventPatch;
  suggestionId: Scalars['Int']['input'];
};

/** The output of our update `SuggestionControlEvent` mutation. */
export type UpdateSuggestionControlEventPayload = {
  __typename?: 'UpdateSuggestionControlEventPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `ControlEvent` that is related to this `SuggestionControlEvent`. */
  controlEvent?: Maybe<ControlEvent>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Suggestion` that is related to this `SuggestionControlEvent`. */
  suggestion?: Maybe<Suggestion>;
  /** The `SuggestionControlEvent` that was updated by this mutation. */
  suggestionControlEvent?: Maybe<SuggestionControlEvent>;
};

/** All input for the `updateSuggestion` mutation. */
export type UpdateSuggestionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The identifier of the suggestions. */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `Suggestion` being updated. */
  patch: SuggestionPatch;
};

/** The output of our update `Suggestion` mutation. */
export type UpdateSuggestionPayload = {
  __typename?: 'UpdateSuggestionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Project` that is related to this `Suggestion`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Suggestion` that was updated by this mutation. */
  suggestion?: Maybe<Suggestion>;
  /** An edge for our `Suggestion`. May be used by Relay 1. */
  suggestionEdge?: Maybe<SuggestionsEdge>;
};

/** The output of our update `Suggestion` mutation. */
export type UpdateSuggestionPayloadSuggestionEdgeArgs = {
  orderBy?: InputMaybe<Array<SuggestionsOrderBy>>;
};

/** All input for the `updateTemperatureSensorByFacilityIdAndHardwareId` mutation. */
export type UpdateTemperatureSensorByFacilityIdAndHardwareIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The facility where the temperature sensor is installed */
  facilityId: Scalars['Int']['input'];
  /** The hardware ID for the sensor. */
  hardwareId: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `TemperatureSensor` being updated. */
  patch: TemperatureSensorPatch;
};

/** All input for the `updateTemperatureSensorByFacilityIdAndLabel` mutation. */
export type UpdateTemperatureSensorByFacilityIdAndLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The facility where the temperature sensor is installed */
  facilityId: Scalars['Int']['input'];
  /** The Human-readable label for the sensor */
  label: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `TemperatureSensor` being updated. */
  patch: TemperatureSensorPatch;
};

/** All input for the `updateTemperatureSensor` mutation. */
export type UpdateTemperatureSensorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the temperature sensor */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `TemperatureSensor` being updated. */
  patch: TemperatureSensorPatch;
};

/** The output of our update `TemperatureSensor` mutation. */
export type UpdateTemperatureSensorPayload = {
  __typename?: 'UpdateTemperatureSensorPayload';
  /** Reads a single `DataPoint` that is related to this `TemperatureSensor`. */
  battery?: Maybe<DataPoint>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Facility` that is related to this `TemperatureSensor`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DataPoint` that is related to this `TemperatureSensor`. */
  signal?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `TemperatureSensor`. */
  temperature?: Maybe<DataPoint>;
  /** The `TemperatureSensor` that was updated by this mutation. */
  temperatureSensor?: Maybe<TemperatureSensor>;
  /** An edge for our `TemperatureSensor`. May be used by Relay 1. */
  temperatureSensorEdge?: Maybe<TemperatureSensorsEdge>;
};

/** The output of our update `TemperatureSensor` mutation. */
export type UpdateTemperatureSensorPayloadTemperatureSensorEdgeArgs = {
  orderBy?: InputMaybe<Array<TemperatureSensorsOrderBy>>;
};

export type UpdateTrailerAppointmentInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of existing driver to reassign to trailer appointment. If defined, any values within newDriver input are not considered. */
  driverId?: InputMaybe<Scalars['Int']['input']>;
  /** Optional input for creating new driver to reassign to trailer appointment */
  newDriver?: InputMaybe<FleetDriverInput>;
  /** Optional input for creating new trailer to reassign to trailer appointment. */
  newTrailer?: InputMaybe<FleetTrailerInput>;
  trailerAppointmentId: Scalars['Int']['input'];
  /** ID of existing trailer to reassign to trailer appointment. If defined, any values within newTrailer input are not considered. */
  trailerId?: InputMaybe<Scalars['Int']['input']>;
  yardId: Scalars['Int']['input'];
};

export type UpdateTrailerAppointmentPayload = {
  __typename?: 'UpdateTrailerAppointmentPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  trailerAppointment?: Maybe<TrailerAppointment>;
};

/** All input for the `updateTrailerAudit` mutation. */
export type UpdateTrailerAuditInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The internal ID of this trailer audit */
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `TrailerAudit` being updated. */
  patch: TrailerAuditPatch;
};

/** The output of our update `TrailerAudit` mutation. */
export type UpdateTrailerAuditPayload = {
  __typename?: 'UpdateTrailerAuditPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Trailer` that is related to this `TrailerAudit`. */
  trailer?: Maybe<Trailer>;
  /** The `TrailerAudit` that was updated by this mutation. */
  trailerAudit?: Maybe<TrailerAudit>;
  /** An edge for our `TrailerAudit`. May be used by Relay 1. */
  trailerAuditEdge?: Maybe<TrailerAuditsEdge>;
  /** Reads a single `User` that is related to this `TrailerAudit`. */
  userByAuditUser?: Maybe<User>;
  /** Reads a single `Yard` that is related to this `TrailerAudit`. */
  yard?: Maybe<Yard>;
};

/** The output of our update `TrailerAudit` mutation. */
export type UpdateTrailerAuditPayloadTrailerAuditEdgeArgs = {
  orderBy?: InputMaybe<Array<TrailerAuditsOrderBy>>;
};

/** All input for the `updateTrailerByCarrierCodeAndCarrierTrailerNumber` mutation. */
export type UpdateTrailerByCarrierCodeAndCarrierTrailerNumberInput = {
  /** The carrier code for the trailer */
  carrierCode: Scalars['String']['input'];
  /** The carrier-specific trailer number */
  carrierTrailerNumber: Scalars['String']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `Trailer` being updated. */
  patch: TrailerPatch;
};

/** All input for the `updateTrailer` mutation. */
export type UpdateTrailerInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The internal ID of this trailer */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `Trailer` being updated. */
  patch: TrailerPatch;
};

/** The output of our update `Trailer` mutation. */
export type UpdateTrailerPayload = {
  __typename?: 'UpdateTrailerPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Trailer` that was updated by this mutation. */
  trailer?: Maybe<Trailer>;
  /** An edge for our `Trailer`. May be used by Relay 1. */
  trailerEdge?: Maybe<TrailersEdge>;
};

/** The output of our update `Trailer` mutation. */
export type UpdateTrailerPayloadTrailerEdgeArgs = {
  orderBy?: InputMaybe<Array<TrailersOrderBy>>;
};

/** All input for the `updateTrailerPositionByFacilityIdAndLabel` mutation. */
export type UpdateTrailerPositionByFacilityIdAndLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The facility where the trailer position is located */
  facilityId: Scalars['Int']['input'];
  /** The Human-readable label for the trailer position */
  label: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `TrailerPosition` being updated. */
  patch: TrailerPositionPatch;
};

/** All input for the `updateTrailerPosition` mutation. */
export type UpdateTrailerPositionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the trailer position */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `TrailerPosition` being updated. */
  patch: TrailerPositionPatch;
};

/** The output of our update `TrailerPosition` mutation. */
export type UpdateTrailerPositionPayload = {
  __typename?: 'UpdateTrailerPositionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Facility` that is related to this `TrailerPosition`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DataPoint` that is related to this `TrailerPosition`. */
  trailerIsPresent?: Maybe<DataPoint>;
  /** The `TrailerPosition` that was updated by this mutation. */
  trailerPosition?: Maybe<TrailerPosition>;
  /** An edge for our `TrailerPosition`. May be used by Relay 1. */
  trailerPositionEdge?: Maybe<TrailerPositionsEdge>;
};

/** The output of our update `TrailerPosition` mutation. */
export type UpdateTrailerPositionPayloadTrailerPositionEdgeArgs = {
  orderBy?: InputMaybe<Array<TrailerPositionsOrderBy>>;
};

/** All input for the `updateUser` mutation. */
export type UpdateUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The primary unique identifier of the user. */
  id: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `User` being updated. */
  patch: UserPatch;
};

/** The output of our update `User` mutation. */
export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `User` that was updated by this mutation. */
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
};

/** The output of our update `User` mutation. */
export type UpdateUserPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** All input for the `updateUtilityAccount` mutation. */
export type UpdateUtilityAccountInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The primary unique identifier of the account. */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `UtilityAccount` being updated. */
  patch: UtilityAccountPatch;
};

/** The output of our update `UtilityAccount` mutation. */
export type UpdateUtilityAccountPayload = {
  __typename?: 'UpdateUtilityAccountPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UtilityAccount` that was updated by this mutation. */
  utilityAccount?: Maybe<UtilityAccount>;
  /** An edge for our `UtilityAccount`. May be used by Relay 1. */
  utilityAccountEdge?: Maybe<UtilityAccountsEdge>;
  /** Reads a single `UtilityCredential` that is related to this `UtilityAccount`. */
  utilityCredential?: Maybe<UtilityCredential>;
  /** Reads a single `UtilityProvider` that is related to this `UtilityAccount`. */
  utilityProvider?: Maybe<UtilityProvider>;
};

/** The output of our update `UtilityAccount` mutation. */
export type UpdateUtilityAccountPayloadUtilityAccountEdgeArgs = {
  orderBy?: InputMaybe<Array<UtilityAccountsOrderBy>>;
};

/** All input for the `updateUtilityCredentialByIntegrationAndIntegrationKey` mutation. */
export type UpdateUtilityCredentialByIntegrationAndIntegrationKeyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The type of integration used for acquiring the utility data. */
  integration: UtilityIntegration;
  /** The identifier of this record as indicated by the integration. */
  integrationKey: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `UtilityCredential` being updated. */
  patch: UtilityCredentialPatch;
};

/** All input for the `updateUtilityCredential` mutation. */
export type UpdateUtilityCredentialInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The internal identifer of the record. */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `UtilityCredential` being updated. */
  patch: UtilityCredentialPatch;
};

/** The output of our update `UtilityCredential` mutation. */
export type UpdateUtilityCredentialPayload = {
  __typename?: 'UpdateUtilityCredentialPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UtilityCredential` that was updated by this mutation. */
  utilityCredential?: Maybe<UtilityCredential>;
  /** An edge for our `UtilityCredential`. May be used by Relay 1. */
  utilityCredentialEdge?: Maybe<UtilityCredentialsEdge>;
  /** Reads a single `UtilityProvider` that is related to this `UtilityCredential`. */
  utilityProvider?: Maybe<UtilityProvider>;
};

/** The output of our update `UtilityCredential` mutation. */
export type UpdateUtilityCredentialPayloadUtilityCredentialEdgeArgs = {
  orderBy?: InputMaybe<Array<UtilityCredentialsOrderBy>>;
};

/** All input for the `updateUtilityFileUploadByIntegrationAndIntegrationKey` mutation. */
export type UpdateUtilityFileUploadByIntegrationAndIntegrationKeyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The type of integration to which this file was uploaded. */
  integration: UtilityIntegration;
  /** The identifier of this record as indicated by the integration. */
  integrationKey: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `UtilityFileUpload` being updated. */
  patch: UtilityFileUploadPatch;
};

/** All input for the `updateUtilityFileUpload` mutation. */
export type UpdateUtilityFileUploadInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The internal identifier of the record. */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `UtilityFileUpload` being updated. */
  patch: UtilityFileUploadPatch;
};

/** The output of our update `UtilityFileUpload` mutation. */
export type UpdateUtilityFileUploadPayload = {
  __typename?: 'UpdateUtilityFileUploadPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UtilityFileUpload` that was updated by this mutation. */
  utilityFileUpload?: Maybe<UtilityFileUpload>;
  /** An edge for our `UtilityFileUpload`. May be used by Relay 1. */
  utilityFileUploadEdge?: Maybe<UtilityFileUploadsEdge>;
};

/** The output of our update `UtilityFileUpload` mutation. */
export type UpdateUtilityFileUploadPayloadUtilityFileUploadEdgeArgs = {
  orderBy?: InputMaybe<Array<UtilityFileUploadsOrderBy>>;
};

/** All input for the `updateUtilityMeter` mutation. */
export type UpdateUtilityMeterInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `UtilityMeter` being updated. */
  patch: UtilityMeterPatch;
};

/** The output of our update `UtilityMeter` mutation. */
export type UpdateUtilityMeterPayload = {
  __typename?: 'UpdateUtilityMeterPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Facility` that is related to this `UtilityMeter`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `UtilityAccount` that is related to this `UtilityMeter`. */
  utilityAccount?: Maybe<UtilityAccount>;
  /** The `UtilityMeter` that was updated by this mutation. */
  utilityMeter?: Maybe<UtilityMeter>;
  /** An edge for our `UtilityMeter`. May be used by Relay 1. */
  utilityMeterEdge?: Maybe<UtilityMetersEdge>;
};

/** The output of our update `UtilityMeter` mutation. */
export type UpdateUtilityMeterPayloadUtilityMeterEdgeArgs = {
  orderBy?: InputMaybe<Array<UtilityMetersOrderBy>>;
};

/** All input for the `updateUtilityPendingMeterByIntegrationAndIntegrationKey` mutation. */
export type UpdateUtilityPendingMeterByIntegrationAndIntegrationKeyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The type of integration that discovered this meter. */
  integration: UtilityIntegration;
  /** The identifier of this record as indicated by the integration. */
  integrationKey: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `UtilityPendingMeter` being updated. */
  patch: UtilityPendingMeterPatch;
};

/** All input for the `updateUtilityPendingMeter` mutation. */
export type UpdateUtilityPendingMeterInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The internal identifer of the record. */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `UtilityPendingMeter` being updated. */
  patch: UtilityPendingMeterPatch;
};

/** The output of our update `UtilityPendingMeter` mutation. */
export type UpdateUtilityPendingMeterPayload = {
  __typename?: 'UpdateUtilityPendingMeterPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Facility` that is related to this `UtilityPendingMeter`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `UtilityCredential` that is related to this `UtilityPendingMeter`. */
  utilityCredential?: Maybe<UtilityCredential>;
  /** The `UtilityPendingMeter` that was updated by this mutation. */
  utilityPendingMeter?: Maybe<UtilityPendingMeter>;
  /** An edge for our `UtilityPendingMeter`. May be used by Relay 1. */
  utilityPendingMeterEdge?: Maybe<UtilityPendingMetersEdge>;
};

/** The output of our update `UtilityPendingMeter` mutation. */
export type UpdateUtilityPendingMeterPayloadUtilityPendingMeterEdgeArgs = {
  orderBy?: InputMaybe<Array<UtilityPendingMetersOrderBy>>;
};

/** All input for the `updateUtilityProviderByName` mutation. */
export type UpdateUtilityProviderByNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The name of the provider. */
  name: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `UtilityProvider` being updated. */
  patch: UtilityProviderPatch;
};

/** All input for the `updateUtilityProvider` mutation. */
export type UpdateUtilityProviderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The primary unique identifier for the provider. */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `UtilityProvider` being updated. */
  patch: UtilityProviderPatch;
};

/** The output of our update `UtilityProvider` mutation. */
export type UpdateUtilityProviderPayload = {
  __typename?: 'UpdateUtilityProviderPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UtilityProvider` that was updated by this mutation. */
  utilityProvider?: Maybe<UtilityProvider>;
  /** An edge for our `UtilityProvider`. May be used by Relay 1. */
  utilityProviderEdge?: Maybe<UtilityProvidersEdge>;
};

/** The output of our update `UtilityProvider` mutation. */
export type UpdateUtilityProviderPayloadUtilityProviderEdgeArgs = {
  orderBy?: InputMaybe<Array<UtilityProvidersOrderBy>>;
};

/** All input for the `updateVendorUserByEmail` mutation. */
export type UpdateVendorUserByEmailInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The email of the vendor user. */
  email: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `VendorUser` being updated. */
  patch: VendorUserPatch;
};

/** All input for the `updateVendorUser` mutation. */
export type UpdateVendorUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the vendor user. */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `VendorUser` being updated. */
  patch: VendorUserPatch;
};

/** All input for the `updateVendorUserMachineUserByMachineUserId` mutation. */
export type UpdateVendorUserMachineUserByMachineUserIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The machine user associated with the vendor user. */
  machineUserId: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `VendorUserMachineUser` being updated. */
  patch: VendorUserMachineUserPatch;
};

/** All input for the `updateVendorUserMachineUser` mutation. */
export type UpdateVendorUserMachineUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The machine user associated with the vendor user. */
  machineUserId: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `VendorUserMachineUser` being updated. */
  patch: VendorUserMachineUserPatch;
  /** The id of the vendor user. */
  vendorUserId: Scalars['Int']['input'];
};

/** The output of our update `VendorUserMachineUser` mutation. */
export type UpdateVendorUserMachineUserPayload = {
  __typename?: 'UpdateVendorUserMachineUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `VendorUserMachineUser` that was updated by this mutation. */
  vendorUserMachineUser?: Maybe<VendorUserMachineUser>;
};

/** The output of our update `VendorUser` mutation. */
export type UpdateVendorUserPayload = {
  __typename?: 'UpdateVendorUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `VendorUser` that was updated by this mutation. */
  vendorUser?: Maybe<VendorUser>;
  /** An edge for our `VendorUser`. May be used by Relay 1. */
  vendorUserEdge?: Maybe<VendorUsersEdge>;
};

/** The output of our update `VendorUser` mutation. */
export type UpdateVendorUserPayloadVendorUserEdgeArgs = {
  orderBy?: InputMaybe<Array<VendorUsersOrderBy>>;
};

/** All input for the `updateVesselByRefrigerationSystemIdAndLabel` mutation. */
export type UpdateVesselByRefrigerationSystemIdAndLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The label for the vessel. */
  label: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `Vessel` being updated. */
  patch: VesselPatch;
  /** References the refrigeration system this vessel is located in. */
  refrigerationSystemId: Scalars['Int']['input'];
};

/** All input for the `updateVessel` mutation. */
export type UpdateVesselInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The unique identifier for the vessel. */
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `Vessel` being updated. */
  patch: VesselPatch;
};

/** The output of our update `Vessel` mutation. */
export type UpdateVesselPayload = {
  __typename?: 'UpdateVesselPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DataPoint` that is related to this `Vessel`. */
  level?: Maybe<DataPoint>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RefrigerationSystem` that is related to this `Vessel`. */
  refrigerationSystem?: Maybe<RefrigerationSystem>;
  /** Reads a single `SuctionGroup` that is related to this `Vessel`. */
  suctionGroup?: Maybe<SuctionGroup>;
  /** The `Vessel` that was updated by this mutation. */
  vessel?: Maybe<Vessel>;
  /** An edge for our `Vessel`. May be used by Relay 1. */
  vesselEdge?: Maybe<VesselsEdge>;
};

/** The output of our update `Vessel` mutation. */
export type UpdateVesselPayloadVesselEdgeArgs = {
  orderBy?: InputMaybe<Array<VesselsOrderBy>>;
};

/** All input for the `updateVirtualPointInterval` mutation. */
export type UpdateVirtualPointIntervalInput = {
  /** The id of the child data point. */
  childId: Scalars['BigInt']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the VIRTUAL data point. */
  parentId: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `VirtualPointInterval` being updated. */
  patch: VirtualPointIntervalPatch;
};

/** The output of our update `VirtualPointInterval` mutation. */
export type UpdateVirtualPointIntervalPayload = {
  __typename?: 'UpdateVirtualPointIntervalPayload';
  /** Reads a single `DataPoint` that is related to this `VirtualPointInterval`. */
  child?: Maybe<DataPoint>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DataPoint` that is related to this `VirtualPointInterval`. */
  parent?: Maybe<DataPoint>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `VirtualPointInterval` that was updated by this mutation. */
  virtualPointInterval?: Maybe<VirtualPointInterval>;
  /** An edge for our `VirtualPointInterval`. May be used by Relay 1. */
  virtualPointIntervalEdge?: Maybe<VirtualPointIntervalsEdge>;
};

/** The output of our update `VirtualPointInterval` mutation. */
export type UpdateVirtualPointIntervalPayloadVirtualPointIntervalEdgeArgs = {
  orderBy?: InputMaybe<Array<VirtualPointIntervalsOrderBy>>;
};

/** All input for the upsert `AccountCharge` mutation. */
export type UpsertAccountChargeInput = {
  /** The `AccountCharge` to be upserted by this mutation. */
  accountCharge: AccountChargeInput;
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our upsert `AccountCharge` mutation. */
export type UpsertAccountChargePayload = {
  __typename?: 'UpsertAccountChargePayload';
  /** The `AccountCharge` that was upserted by this mutation. */
  accountCharge?: Maybe<AccountCharge>;
  /** An edge for our `AccountCharge`. May be used by Relay 1. */
  accountChargeEdge?: Maybe<AccountChargesEdge>;
  /** Reads a single `AccountStatement` that is related to this `AccountCharge`. */
  accountStatement?: Maybe<AccountStatement>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `AccountCharge` mutation. */
export type UpsertAccountChargePayloadAccountChargeEdgeArgs = {
  orderBy?: InputMaybe<Array<AccountChargesOrderBy>>;
};

/** Where conditions for the upsert `AccountCharge` mutation. */
export type UpsertAccountChargeWhere = {
  accountStatementId?: InputMaybe<Scalars['Int']['input']>;
  category?: InputMaybe<UtilityAccountChargeCategory>;
  id?: InputMaybe<Scalars['Int']['input']>;
  intervalEnd?: InputMaybe<Scalars['Date']['input']>;
  intervalStart?: InputMaybe<Scalars['Date']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  lineNumber?: InputMaybe<Scalars['Int']['input']>;
};

/** All input for the upsert `AccountStatement` mutation. */
export type UpsertAccountStatementInput = {
  /** The `AccountStatement` to be upserted by this mutation. */
  accountStatement: AccountStatementInput;
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our upsert `AccountStatement` mutation. */
export type UpsertAccountStatementPayload = {
  __typename?: 'UpsertAccountStatementPayload';
  /** The `AccountStatement` that was upserted by this mutation. */
  accountStatement?: Maybe<AccountStatement>;
  /** An edge for our `AccountStatement`. May be used by Relay 1. */
  accountStatementEdge?: Maybe<AccountStatementsEdge>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `UtilityAccount` that is related to this `AccountStatement`. */
  utilityAccount?: Maybe<UtilityAccount>;
};

/** The output of our upsert `AccountStatement` mutation. */
export type UpsertAccountStatementPayloadAccountStatementEdgeArgs = {
  orderBy?: InputMaybe<Array<AccountStatementsOrderBy>>;
};

/** All input for the upsert `AccountStatementPdf` mutation. */
export type UpsertAccountStatementPdfInput = {
  /** The `AccountStatementPdf` to be upserted by this mutation. */
  accountStatementPdf: AccountStatementPdfInput;
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our upsert `AccountStatementPdf` mutation. */
export type UpsertAccountStatementPdfPayload = {
  __typename?: 'UpsertAccountStatementPdfPayload';
  /** Reads a single `AccountStatement` that is related to this `AccountStatementPdf`. */
  accountStatement?: Maybe<AccountStatement>;
  /** The `AccountStatementPdf` that was upserted by this mutation. */
  accountStatementPdf?: Maybe<AccountStatementPdf>;
  /** An edge for our `AccountStatementPdf`. May be used by Relay 1. */
  accountStatementPdfEdge?: Maybe<AccountStatementPdfsEdge>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `AccountStatementPdf` mutation. */
export type UpsertAccountStatementPdfPayloadAccountStatementPdfEdgeArgs = {
  orderBy?: InputMaybe<Array<AccountStatementPdfsOrderBy>>;
};

/** Where conditions for the upsert `AccountStatementPdf` mutation. */
export type UpsertAccountStatementPdfWhere = {
  accountStatementId?: InputMaybe<Scalars['Int']['input']>;
  fileKey?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** Where conditions for the upsert `AccountStatement` mutation. */
export type UpsertAccountStatementWhere = {
  id?: InputMaybe<Scalars['Int']['input']>;
  integration?: InputMaybe<UtilityIntegration>;
  integrationKey?: InputMaybe<Scalars['String']['input']>;
};

/** All input for the upsert `Assessment` mutation. */
export type UpsertAssessmentInput = {
  /** The `Assessment` to be upserted by this mutation. */
  assessment: AssessmentInput;
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our upsert `Assessment` mutation. */
export type UpsertAssessmentPayload = {
  __typename?: 'UpsertAssessmentPayload';
  /** The `Assessment` that was upserted by this mutation. */
  assessment?: Maybe<Assessment>;
  /** An edge for our `Assessment`. May be used by Relay 1. */
  assessmentEdge?: Maybe<AssessmentsEdge>;
  /** Reads a single `AssessmentType` that is related to this `Assessment`. */
  assessmentType?: Maybe<AssessmentType>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `MonitoredAsset` that is related to this `Assessment`. */
  monitoredAsset?: Maybe<MonitoredAsset>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `Assessment` mutation. */
export type UpsertAssessmentPayloadAssessmentEdgeArgs = {
  orderBy?: InputMaybe<Array<AssessmentsOrderBy>>;
};

/** Where conditions for the upsert `Assessment` mutation. */
export type UpsertAssessmentWhere = {
  analysisEnd?: InputMaybe<Scalars['Date']['input']>;
  analysisStart?: InputMaybe<Scalars['Date']['input']>;
  assessmentTypeId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  monitoredAssetId?: InputMaybe<Scalars['Int']['input']>;
};

/** All input for the upsert `BalancingAuthority` mutation. */
export type UpsertBalancingAuthorityInput = {
  /** The `BalancingAuthority` to be upserted by this mutation. */
  balancingAuthority: BalancingAuthorityInput;
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our upsert `BalancingAuthority` mutation. */
export type UpsertBalancingAuthorityPayload = {
  __typename?: 'UpsertBalancingAuthorityPayload';
  /** The `BalancingAuthority` that was upserted by this mutation. */
  balancingAuthority?: Maybe<BalancingAuthority>;
  /** An edge for our `BalancingAuthority`. May be used by Relay 1. */
  balancingAuthorityEdge?: Maybe<BalancingAuthoritiesEdge>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `BalancingAuthority` mutation. */
export type UpsertBalancingAuthorityPayloadBalancingAuthorityEdgeArgs = {
  orderBy?: InputMaybe<Array<BalancingAuthoritiesOrderBy>>;
};

/** Where conditions for the upsert `BalancingAuthority` mutation. */
export type UpsertBalancingAuthorityWhere = {
  id?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** All input for the upsert `BillableCustomer` mutation. */
export type UpsertBillableCustomerInput = {
  /** The `BillableCustomer` to be upserted by this mutation. */
  billableCustomer: BillableCustomerInput;
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our upsert `BillableCustomer` mutation. */
export type UpsertBillableCustomerPayload = {
  __typename?: 'UpsertBillableCustomerPayload';
  /** The `BillableCustomer` that was upserted by this mutation. */
  billableCustomer?: Maybe<BillableCustomer>;
  /** An edge for our `BillableCustomer`. May be used by Relay 1. */
  billableCustomerEdge?: Maybe<BillableCustomersEdge>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `BillableCustomer` mutation. */
export type UpsertBillableCustomerPayloadBillableCustomerEdgeArgs = {
  orderBy?: InputMaybe<Array<BillableCustomersOrderBy>>;
};

/** Where conditions for the upsert `BillableCustomer` mutation. */
export type UpsertBillableCustomerWhere = {
  carrierCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** All input for the upsert `BlastEvaporator` mutation. */
export type UpsertBlastEvaporatorInput = {
  /** The `BlastEvaporator` to be upserted by this mutation. */
  blastEvaporator: BlastEvaporatorInput;
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our upsert `BlastEvaporator` mutation. */
export type UpsertBlastEvaporatorPayload = {
  __typename?: 'UpsertBlastEvaporatorPayload';
  /** Reads a single `Blast` that is related to this `BlastEvaporator`. */
  blast?: Maybe<Blast>;
  /** The `BlastEvaporator` that was upserted by this mutation. */
  blastEvaporator?: Maybe<BlastEvaporator>;
  /** An edge for our `BlastEvaporator`. May be used by Relay 1. */
  blastEvaporatorEdge?: Maybe<BlastEvaporatorsEdge>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Evaporator` that is related to this `BlastEvaporator`. */
  evaporator?: Maybe<Evaporator>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `BlastEvaporator` mutation. */
export type UpsertBlastEvaporatorPayloadBlastEvaporatorEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastEvaporatorsOrderBy>>;
};

/** Where conditions for the upsert `BlastEvaporator` mutation. */
export type UpsertBlastEvaporatorWhere = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** All input for the upsert `Blast` mutation. */
export type UpsertBlastInput = {
  /** The `Blast` to be upserted by this mutation. */
  blast: BlastInput;
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** All input for the upsert `BlastPallet` mutation. */
export type UpsertBlastPalletInput = {
  /** The `BlastPallet` to be upserted by this mutation. */
  blastPallet: BlastPalletInput;
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** All input for the upsert `BlastPalletLocation` mutation. */
export type UpsertBlastPalletLocationInput = {
  /** The `BlastPalletLocation` to be upserted by this mutation. */
  blastPalletLocation: BlastPalletLocationInput;
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our upsert `BlastPalletLocation` mutation. */
export type UpsertBlastPalletLocationPayload = {
  __typename?: 'UpsertBlastPalletLocationPayload';
  /** Reads a single `Blast` that is related to this `BlastPalletLocation`. */
  blast?: Maybe<Blast>;
  /** The `BlastPalletLocation` that was upserted by this mutation. */
  blastPalletLocation?: Maybe<BlastPalletLocation>;
  /** An edge for our `BlastPalletLocation`. May be used by Relay 1. */
  blastPalletLocationEdge?: Maybe<BlastPalletLocationsEdge>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `PalletLocation` that is related to this `BlastPalletLocation`. */
  palletLocation?: Maybe<PalletLocation>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `BlastPalletLocation` mutation. */
export type UpsertBlastPalletLocationPayloadBlastPalletLocationEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastPalletLocationsOrderBy>>;
};

/** Where conditions for the upsert `BlastPalletLocation` mutation. */
export type UpsertBlastPalletLocationWhere = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** The output of our upsert `BlastPallet` mutation. */
export type UpsertBlastPalletPayload = {
  __typename?: 'UpsertBlastPalletPayload';
  /** Reads a single `Blast` that is related to this `BlastPallet`. */
  blast?: Maybe<Blast>;
  /** The `BlastPallet` that was upserted by this mutation. */
  blastPallet?: Maybe<BlastPallet>;
  /** An edge for our `BlastPallet`. May be used by Relay 1. */
  blastPalletEdge?: Maybe<BlastPalletsEdge>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Pallet` that is related to this `BlastPallet`. */
  pallet?: Maybe<Pallet>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `BlastPallet` mutation. */
export type UpsertBlastPalletPayloadBlastPalletEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastPalletsOrderBy>>;
};

/** Where conditions for the upsert `BlastPallet` mutation. */
export type UpsertBlastPalletWhere = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** The output of our upsert `Blast` mutation. */
export type UpsertBlastPayload = {
  __typename?: 'UpsertBlastPayload';
  /** Reads a single `DataPoint` that is related to this `Blast`. */
  actualUtilization?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Blast`. */
  automationState?: Maybe<DataPoint>;
  /** The `Blast` that was upserted by this mutation. */
  blast?: Maybe<Blast>;
  /** An edge for our `Blast`. May be used by Relay 1. */
  blastEdge?: Maybe<BlastsEdge>;
  /** Reads a single `BlastType` that is related to this `Blast`. */
  blastType?: Maybe<BlastType>;
  /** Reads a single `BuildingArea` that is related to this `Blast`. */
  buildingArea?: Maybe<BuildingArea>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Component` that is related to this `Blast`. */
  component?: Maybe<Component>;
  /** Reads a single `Facility` that is related to this `Blast`. */
  facility?: Maybe<Facility>;
  /** Reads a single `DataPoint` that is related to this `Blast`. */
  idealUtilization?: Maybe<DataPoint>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DataPoint` that is related to this `Blast`. */
  stagingTimer?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Blast`. */
  state?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Blast`. */
  timer?: Maybe<DataPoint>;
};

/** The output of our upsert `Blast` mutation. */
export type UpsertBlastPayloadBlastEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastsOrderBy>>;
};

/** All input for the upsert `BlastRotationAlert` mutation. */
export type UpsertBlastRotationAlertInput = {
  /** The `BlastRotationAlert` to be upserted by this mutation. */
  blastRotationAlert: BlastRotationAlertInput;
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our upsert `BlastRotationAlert` mutation. */
export type UpsertBlastRotationAlertPayload = {
  __typename?: 'UpsertBlastRotationAlertPayload';
  /** Reads a single `BlastRotation` that is related to this `BlastRotationAlert`. */
  blastRotation?: Maybe<BlastRotation>;
  /** The `BlastRotationAlert` that was upserted by this mutation. */
  blastRotationAlert?: Maybe<BlastRotationAlert>;
  /** An edge for our `BlastRotationAlert`. May be used by Relay 1. */
  blastRotationAlertEdge?: Maybe<BlastRotationAlertsEdge>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `BlastRotationAlert` mutation. */
export type UpsertBlastRotationAlertPayloadBlastRotationAlertEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastRotationAlertsOrderBy>>;
};

/** Where conditions for the upsert `BlastRotationAlert` mutation. */
export type UpsertBlastRotationAlertWhere = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** All input for the upsert `BlastRotationEventLog` mutation. */
export type UpsertBlastRotationEventLogInput = {
  /** The `BlastRotationEventLog` to be upserted by this mutation. */
  blastRotationEventLog: BlastRotationEventLogInput;
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our upsert `BlastRotationEventLog` mutation. */
export type UpsertBlastRotationEventLogPayload = {
  __typename?: 'UpsertBlastRotationEventLogPayload';
  /** Reads a single `BlastRotation` that is related to this `BlastRotationEventLog`. */
  blastRotation?: Maybe<BlastRotation>;
  /** The `BlastRotationEventLog` that was upserted by this mutation. */
  blastRotationEventLog?: Maybe<BlastRotationEventLog>;
  /** An edge for our `BlastRotationEventLog`. May be used by Relay 1. */
  blastRotationEventLogEdge?: Maybe<BlastRotationEventLogsEdge>;
  /** Reads a single `BlastRotationEventType` that is related to this `BlastRotationEventLog`. */
  blastRotationEventType?: Maybe<BlastRotationEventType>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `BlastRotationEventLog` mutation. */
export type UpsertBlastRotationEventLogPayloadBlastRotationEventLogEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastRotationEventLogsOrderBy>>;
};

/** Where conditions for the upsert `BlastRotationEventLog` mutation. */
export type UpsertBlastRotationEventLogWhere = {
  blastRotationEventTypeId?: InputMaybe<Scalars['String']['input']>;
  blastRotationId?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** All input for the upsert `BlastRotationEventType` mutation. */
export type UpsertBlastRotationEventTypeInput = {
  /** The `BlastRotationEventType` to be upserted by this mutation. */
  blastRotationEventType: BlastRotationEventTypeInput;
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our upsert `BlastRotationEventType` mutation. */
export type UpsertBlastRotationEventTypePayload = {
  __typename?: 'UpsertBlastRotationEventTypePayload';
  /** The `BlastRotationEventType` that was upserted by this mutation. */
  blastRotationEventType?: Maybe<BlastRotationEventType>;
  /** An edge for our `BlastRotationEventType`. May be used by Relay 1. */
  blastRotationEventTypeEdge?: Maybe<BlastRotationEventTypesEdge>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `BlastRotationEventType` mutation. */
export type UpsertBlastRotationEventTypePayloadBlastRotationEventTypeEdgeArgs =
  {
    orderBy?: InputMaybe<Array<BlastRotationEventTypesOrderBy>>;
  };

/** Where conditions for the upsert `BlastRotationEventType` mutation. */
export type UpsertBlastRotationEventTypeWhere = {
  eventType?: InputMaybe<Scalars['String']['input']>;
};

/** All input for the upsert `BlastRotation` mutation. */
export type UpsertBlastRotationInput = {
  /** The `BlastRotation` to be upserted by this mutation. */
  blastRotation: BlastRotationInput;
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** All input for the upsert `BlastRotationPallet` mutation. */
export type UpsertBlastRotationPalletInput = {
  /** The `BlastRotationPallet` to be upserted by this mutation. */
  blastRotationPallet: BlastRotationPalletInput;
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our upsert `BlastRotationPallet` mutation. */
export type UpsertBlastRotationPalletPayload = {
  __typename?: 'UpsertBlastRotationPalletPayload';
  /** Reads a single `BlastRotation` that is related to this `BlastRotationPallet`. */
  blastRotation?: Maybe<BlastRotation>;
  /** The `BlastRotationPallet` that was upserted by this mutation. */
  blastRotationPallet?: Maybe<BlastRotationPallet>;
  /** An edge for our `BlastRotationPallet`. May be used by Relay 1. */
  blastRotationPalletEdge?: Maybe<BlastRotationPalletsEdge>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Pallet` that is related to this `BlastRotationPallet`. */
  pallet?: Maybe<Pallet>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `BlastRotationPallet` mutation. */
export type UpsertBlastRotationPalletPayloadBlastRotationPalletEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastRotationPalletsOrderBy>>;
};

/** Where conditions for the upsert `BlastRotationPallet` mutation. */
export type UpsertBlastRotationPalletWhere = {
  blastRotationId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  palletId?: InputMaybe<Scalars['Int']['input']>;
};

/** The output of our upsert `BlastRotation` mutation. */
export type UpsertBlastRotationPayload = {
  __typename?: 'UpsertBlastRotationPayload';
  /** Reads a single `Blast` that is related to this `BlastRotation`. */
  blast?: Maybe<Blast>;
  /** The `BlastRotation` that was upserted by this mutation. */
  blastRotation?: Maybe<BlastRotation>;
  /** An edge for our `BlastRotation`. May be used by Relay 1. */
  blastRotationEdge?: Maybe<BlastRotationsEdge>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `BlastRotation` mutation. */
export type UpsertBlastRotationPayloadBlastRotationEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastRotationsOrderBy>>;
};

/** Where conditions for the upsert `BlastRotation` mutation. */
export type UpsertBlastRotationWhere = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** All input for the upsert `BlastType` mutation. */
export type UpsertBlastTypeInput = {
  /** The `BlastType` to be upserted by this mutation. */
  blastType: BlastTypeInput;
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our upsert `BlastType` mutation. */
export type UpsertBlastTypePayload = {
  __typename?: 'UpsertBlastTypePayload';
  /** The `BlastType` that was upserted by this mutation. */
  blastType?: Maybe<BlastType>;
  /** An edge for our `BlastType`. May be used by Relay 1. */
  blastTypeEdge?: Maybe<BlastTypesEdge>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `BlastType` mutation. */
export type UpsertBlastTypePayloadBlastTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<BlastTypesOrderBy>>;
};

/** Where conditions for the upsert `BlastType` mutation. */
export type UpsertBlastTypeWhere = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** Where conditions for the upsert `Blast` mutation. */
export type UpsertBlastWhere = {
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

/** All input for the upsert `BuildingAreaComplianceGroup` mutation. */
export type UpsertBuildingAreaComplianceGroupInput = {
  /** The `BuildingAreaComplianceGroup` to be upserted by this mutation. */
  buildingAreaComplianceGroup: BuildingAreaComplianceGroupInput;
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our upsert `BuildingAreaComplianceGroup` mutation. */
export type UpsertBuildingAreaComplianceGroupPayload = {
  __typename?: 'UpsertBuildingAreaComplianceGroupPayload';
  /** Reads a single `BuildingArea` that is related to this `BuildingAreaComplianceGroup`. */
  buildingArea?: Maybe<BuildingArea>;
  /** The `BuildingAreaComplianceGroup` that was upserted by this mutation. */
  buildingAreaComplianceGroup?: Maybe<BuildingAreaComplianceGroup>;
  /** An edge for our `BuildingAreaComplianceGroup`. May be used by Relay 1. */
  buildingAreaComplianceGroupEdge?: Maybe<BuildingAreaComplianceGroupsEdge>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `ComplianceGroup` that is related to this `BuildingAreaComplianceGroup`. */
  complianceGroup?: Maybe<ComplianceGroup>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `BuildingAreaComplianceGroup` mutation. */
export type UpsertBuildingAreaComplianceGroupPayloadBuildingAreaComplianceGroupEdgeArgs =
  {
    orderBy?: InputMaybe<Array<BuildingAreaComplianceGroupsOrderBy>>;
  };

/** Where conditions for the upsert `BuildingAreaComplianceGroup` mutation. */
export type UpsertBuildingAreaComplianceGroupWhere = {
  buildingAreaId?: InputMaybe<Scalars['Int']['input']>;
  complianceType?: InputMaybe<ComplianceType>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** All input for the upsert `BuildingArea` mutation. */
export type UpsertBuildingAreaInput = {
  /** The `BuildingArea` to be upserted by this mutation. */
  buildingArea: BuildingAreaInput;
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our upsert `BuildingArea` mutation. */
export type UpsertBuildingAreaPayload = {
  __typename?: 'UpsertBuildingAreaPayload';
  /** The `BuildingArea` that was upserted by this mutation. */
  buildingArea?: Maybe<BuildingArea>;
  /** An edge for our `BuildingArea`. May be used by Relay 1. */
  buildingAreaEdge?: Maybe<BuildingAreasEdge>;
  /** Reads a single `BuildingAreaType` that is related to this `BuildingArea`. */
  buildingAreaType?: Maybe<BuildingAreaType>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Facility` that is related to this `BuildingArea`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `BuildingArea` mutation. */
export type UpsertBuildingAreaPayloadBuildingAreaEdgeArgs = {
  orderBy?: InputMaybe<Array<BuildingAreasOrderBy>>;
};

/** All input for the upsert `BuildingAreaType` mutation. */
export type UpsertBuildingAreaTypeInput = {
  /** The `BuildingAreaType` to be upserted by this mutation. */
  buildingAreaType: BuildingAreaTypeInput;
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our upsert `BuildingAreaType` mutation. */
export type UpsertBuildingAreaTypePayload = {
  __typename?: 'UpsertBuildingAreaTypePayload';
  /** The `BuildingAreaType` that was upserted by this mutation. */
  buildingAreaType?: Maybe<BuildingAreaType>;
  /** An edge for our `BuildingAreaType`. May be used by Relay 1. */
  buildingAreaTypeEdge?: Maybe<BuildingAreaTypesEdge>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `BuildingAreaType` mutation. */
export type UpsertBuildingAreaTypePayloadBuildingAreaTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<BuildingAreaTypesOrderBy>>;
};

/** Where conditions for the upsert `BuildingAreaType` mutation. */
export type UpsertBuildingAreaTypeWhere = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Where conditions for the upsert `BuildingArea` mutation. */
export type UpsertBuildingAreaWhere = {
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

/** All input for the upsert `Chart` mutation. */
export type UpsertChartInput = {
  /** The `Chart` to be upserted by this mutation. */
  chart: ChartInput;
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our upsert `Chart` mutation. */
export type UpsertChartPayload = {
  __typename?: 'UpsertChartPayload';
  /** The `Chart` that was upserted by this mutation. */
  chart?: Maybe<Chart>;
  /** An edge for our `Chart`. May be used by Relay 1. */
  chartEdge?: Maybe<ChartsEdge>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Facility` that is related to this `Chart`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `Chart` mutation. */
export type UpsertChartPayloadChartEdgeArgs = {
  orderBy?: InputMaybe<Array<ChartsOrderBy>>;
};

/** Where conditions for the upsert `Chart` mutation. */
export type UpsertChartWhere = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** All input for the upsert `ClassificationResult` mutation. */
export type UpsertClassificationResultInput = {
  /** The `ClassificationResult` to be upserted by this mutation. */
  classificationResult: ClassificationResultInput;
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our upsert `ClassificationResult` mutation. */
export type UpsertClassificationResultPayload = {
  __typename?: 'UpsertClassificationResultPayload';
  /** Reads a single `Assessment` that is related to this `ClassificationResult`. */
  assessment?: Maybe<Assessment>;
  /** Reads a single `Classification` that is related to this `ClassificationResult`. */
  classification?: Maybe<Classification>;
  /** The `ClassificationResult` that was upserted by this mutation. */
  classificationResult?: Maybe<ClassificationResult>;
  /** An edge for our `ClassificationResult`. May be used by Relay 1. */
  classificationResultEdge?: Maybe<ClassificationResultsEdge>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `ClassificationResult` mutation. */
export type UpsertClassificationResultPayloadClassificationResultEdgeArgs = {
  orderBy?: InputMaybe<Array<ClassificationResultsOrderBy>>;
};

/** Where conditions for the upsert `ClassificationResult` mutation. */
export type UpsertClassificationResultWhere = {
  assessmentId?: InputMaybe<Scalars['Int']['input']>;
  classificationId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** All input for the upsert `ComplianceGroup` mutation. */
export type UpsertComplianceGroupInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `ComplianceGroup` to be upserted by this mutation. */
  complianceGroup: ComplianceGroupInput;
};

/** The output of our upsert `ComplianceGroup` mutation. */
export type UpsertComplianceGroupPayload = {
  __typename?: 'UpsertComplianceGroupPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `ComplianceGroup` that was upserted by this mutation. */
  complianceGroup?: Maybe<ComplianceGroup>;
  /** An edge for our `ComplianceGroup`. May be used by Relay 1. */
  complianceGroupEdge?: Maybe<ComplianceGroupsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `ComplianceGroup` mutation. */
export type UpsertComplianceGroupPayloadComplianceGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<ComplianceGroupsOrderBy>>;
};

/** Where conditions for the upsert `ComplianceGroup` mutation. */
export type UpsertComplianceGroupWhere = {
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

/** All input for the upsert `ComplianceRange` mutation. */
export type UpsertComplianceRangeInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `ComplianceRange` to be upserted by this mutation. */
  complianceRange: ComplianceRangeInput;
};

/** The output of our upsert `ComplianceRange` mutation. */
export type UpsertComplianceRangePayload = {
  __typename?: 'UpsertComplianceRangePayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `ComplianceGroup` that is related to this `ComplianceRange`. */
  complianceGroup?: Maybe<ComplianceGroup>;
  /** The `ComplianceRange` that was upserted by this mutation. */
  complianceRange?: Maybe<ComplianceRange>;
  /** An edge for our `ComplianceRange`. May be used by Relay 1. */
  complianceRangeEdge?: Maybe<ComplianceRangesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `ComplianceRange` mutation. */
export type UpsertComplianceRangePayloadComplianceRangeEdgeArgs = {
  orderBy?: InputMaybe<Array<ComplianceRangesOrderBy>>;
};

/** Where conditions for the upsert `ComplianceRange` mutation. */
export type UpsertComplianceRangeWhere = {
  complianceGroupId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

/** All input for the upsert `Compressor` mutation. */
export type UpsertCompressorInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Compressor` to be upserted by this mutation. */
  compressor: CompressorInput;
};

/** The output of our upsert `Compressor` mutation. */
export type UpsertCompressorPayload = {
  __typename?: 'UpsertCompressorPayload';
  /** Reads a single `BuildingArea` that is related to this `Compressor`. */
  buildingArea?: Maybe<BuildingArea>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  capacity?: Maybe<DataPoint>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Compressor` that was upserted by this mutation. */
  compressor?: Maybe<Compressor>;
  /** An edge for our `Compressor`. May be used by Relay 1. */
  compressorEdge?: Maybe<CompressorsEdge>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  controlMode?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  differentialPressure?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  dischargePressure?: Maybe<DataPoint>;
  /** Reads a single `Facility` that is related to this `Compressor`. */
  facility?: Maybe<Facility>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  kwDemand?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  motorAmps?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  motorState?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  oilPressure?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  oilTemperature?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  onStatus?: Maybe<DataPoint>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RefrigerationSystem` that is related to this `Compressor`. */
  refrigerationSystem?: Maybe<RefrigerationSystem>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  runtimeHours?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  setpoint?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  slideValvePosition?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  state?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  suctionPressure?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  suctionPressureSetpointDeviation?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Compressor`. */
  suctionTemperature?: Maybe<DataPoint>;
};

/** The output of our upsert `Compressor` mutation. */
export type UpsertCompressorPayloadCompressorEdgeArgs = {
  orderBy?: InputMaybe<Array<CompressorsOrderBy>>;
};

/** Where conditions for the upsert `Compressor` mutation. */
export type UpsertCompressorWhere = {
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

/** All input for the upsert `CustomerBillingRate` mutation. */
export type UpsertCustomerBillingRateInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `CustomerBillingRate` to be upserted by this mutation. */
  customerBillingRate: CustomerBillingRateInput;
};

/** The output of our upsert `CustomerBillingRate` mutation. */
export type UpsertCustomerBillingRatePayload = {
  __typename?: 'UpsertCustomerBillingRatePayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `BillableCustomer` that is related to this `CustomerBillingRate`. */
  customer?: Maybe<BillableCustomer>;
  /** The `CustomerBillingRate` that was upserted by this mutation. */
  customerBillingRate?: Maybe<CustomerBillingRate>;
  /** An edge for our `CustomerBillingRate`. May be used by Relay 1. */
  customerBillingRateEdge?: Maybe<CustomerBillingRatesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `CustomerBillingRate` mutation. */
export type UpsertCustomerBillingRatePayloadCustomerBillingRateEdgeArgs = {
  orderBy?: InputMaybe<Array<CustomerBillingRatesOrderBy>>;
};

/** Where conditions for the upsert `CustomerBillingRate` mutation. */
export type UpsertCustomerBillingRateWhere = {
  customerId?: InputMaybe<Scalars['Int']['input']>;
  effectiveStart?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** All input for the upsert `Customer` mutation. */
export type UpsertCustomerInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Customer` to be upserted by this mutation. */
  customer: CustomerInput;
};

/** The output of our upsert `Customer` mutation. */
export type UpsertCustomerPayload = {
  __typename?: 'UpsertCustomerPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Customer` that was upserted by this mutation. */
  customer?: Maybe<Customer>;
  /** An edge for our `Customer`. May be used by Relay 1. */
  customerEdge?: Maybe<CustomersEdge>;
  /** Reads a single `Facility` that is related to this `Customer`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `Customer` mutation. */
export type UpsertCustomerPayloadCustomerEdgeArgs = {
  orderBy?: InputMaybe<Array<CustomersOrderBy>>;
};

/** Where conditions for the upsert `Customer` mutation. */
export type UpsertCustomerWhere = {
  id?: InputMaybe<Scalars['BigInt']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
};

/** All input for the upsert `Dashboard` mutation. */
export type UpsertDashboardInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Dashboard` to be upserted by this mutation. */
  dashboard: DashboardInput;
};

/** The output of our upsert `Dashboard` mutation. */
export type UpsertDashboardPayload = {
  __typename?: 'UpsertDashboardPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Dashboard` that was upserted by this mutation. */
  dashboard?: Maybe<Dashboard>;
  /** An edge for our `Dashboard`. May be used by Relay 1. */
  dashboardEdge?: Maybe<DashboardsEdge>;
  /** Reads a single `Facility` that is related to this `Dashboard`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `Dashboard` mutation. */
export type UpsertDashboardPayloadDashboardEdgeArgs = {
  orderBy?: InputMaybe<Array<DashboardsOrderBy>>;
};

/** Where conditions for the upsert `Dashboard` mutation. */
export type UpsertDashboardWhere = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** All input for the upsert `DataPoint` mutation. */
export type UpsertDataPointInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `DataPoint` to be upserted by this mutation. */
  dataPoint: DataPointInput;
};

/** The output of our upsert `DataPoint` mutation. */
export type UpsertDataPointPayload = {
  __typename?: 'UpsertDataPointPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `DataPoint` that was upserted by this mutation. */
  dataPoint?: Maybe<DataPoint>;
  /** An edge for our `DataPoint`. May be used by Relay 1. */
  dataPointEdge?: Maybe<DataPointsEdge>;
  /** Reads a single `DataSource` that is related to this `DataPoint`. */
  dataSource?: Maybe<DataSource>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `DataPoint` mutation. */
export type UpsertDataPointPayloadDataPointEdgeArgs = {
  orderBy?: InputMaybe<Array<DataPointsOrderBy>>;
};

/** Where conditions for the upsert `DataPoint` mutation. */
export type UpsertDataPointWhere = {
  dataSourceName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** All input for the upsert `Dependency` mutation. */
export type UpsertDependencyInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Dependency` to be upserted by this mutation. */
  dependency: DependencyInput;
};

/** The output of our upsert `Dependency` mutation. */
export type UpsertDependencyPayload = {
  __typename?: 'UpsertDependencyPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Dependency` that was upserted by this mutation. */
  dependency?: Maybe<Dependency>;
  /** An edge for our `Dependency`. May be used by Relay 1. */
  dependencyEdge?: Maybe<DependenciesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `Dependency` mutation. */
export type UpsertDependencyPayloadDependencyEdgeArgs = {
  orderBy?: InputMaybe<Array<DependenciesOrderBy>>;
};

/** Where conditions for the upsert `Dependency` mutation. */
export type UpsertDependencyWhere = {
  id?: InputMaybe<Scalars['BigInt']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
};

/** All input for the upsert `DischargeHeader` mutation. */
export type UpsertDischargeHeaderInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `DischargeHeader` to be upserted by this mutation. */
  dischargeHeader: DischargeHeaderInput;
};

/** The output of our upsert `DischargeHeader` mutation. */
export type UpsertDischargeHeaderPayload = {
  __typename?: 'UpsertDischargeHeaderPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `DischargeHeader` that was upserted by this mutation. */
  dischargeHeader?: Maybe<DischargeHeader>;
  /** An edge for our `DischargeHeader`. May be used by Relay 1. */
  dischargeHeaderEdge?: Maybe<DischargeHeadersEdge>;
  /** Reads a single `DataPoint` that is related to this `DischargeHeader`. */
  dischargePressure?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `DischargeHeader`. */
  dischargePressureSetpoint?: Maybe<DataPoint>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RefrigerationSystem` that is related to this `DischargeHeader`. */
  refrigerationSystem?: Maybe<RefrigerationSystem>;
};

/** The output of our upsert `DischargeHeader` mutation. */
export type UpsertDischargeHeaderPayloadDischargeHeaderEdgeArgs = {
  orderBy?: InputMaybe<Array<DischargeHeadersOrderBy>>;
};

/** Where conditions for the upsert `DischargeHeader` mutation. */
export type UpsertDischargeHeaderWhere = {
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  refrigerationSystemId?: InputMaybe<Scalars['Int']['input']>;
};

/** All input for the upsert `Door` mutation. */
export type UpsertDoorInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Door` to be upserted by this mutation. */
  door: DoorInput;
};

/** The output of our upsert `Door` mutation. */
export type UpsertDoorPayload = {
  __typename?: 'UpsertDoorPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Door` that was upserted by this mutation. */
  door?: Maybe<Door>;
  /** An edge for our `Door`. May be used by Relay 1. */
  doorEdge?: Maybe<DoorsEdge>;
  /** Reads a single `DataPoint` that is related to this `Door`. */
  doorState?: Maybe<DataPoint>;
  /** Reads a single `Facility` that is related to this `Door`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `Door` mutation. */
export type UpsertDoorPayloadDoorEdgeArgs = {
  orderBy?: InputMaybe<Array<DoorsOrderBy>>;
};

/** Where conditions for the upsert `Door` mutation. */
export type UpsertDoorWhere = {
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

/** All input for the upsert `Driver` mutation. */
export type UpsertDriverInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Driver` to be upserted by this mutation. */
  driver: DriverInput;
};

/** The output of our upsert `Driver` mutation. */
export type UpsertDriverPayload = {
  __typename?: 'UpsertDriverPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Driver` that was upserted by this mutation. */
  driver?: Maybe<Driver>;
  /** An edge for our `Driver`. May be used by Relay 1. */
  driverEdge?: Maybe<DriversEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `Driver` mutation. */
export type UpsertDriverPayloadDriverEdgeArgs = {
  orderBy?: InputMaybe<Array<DriversOrderBy>>;
};

/** Where conditions for the upsert `Driver` mutation. */
export type UpsertDriverWhere = {
  conversationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

/** All input for the upsert `ElectricalCircuit` mutation. */
export type UpsertElectricalCircuitInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `ElectricalCircuit` to be upserted by this mutation. */
  electricalCircuit: ElectricalCircuitInput;
};

/** The output of our upsert `ElectricalCircuit` mutation. */
export type UpsertElectricalCircuitPayload = {
  __typename?: 'UpsertElectricalCircuitPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `ElectricalCircuit` that was upserted by this mutation. */
  electricalCircuit?: Maybe<ElectricalCircuit>;
  /** An edge for our `ElectricalCircuit`. May be used by Relay 1. */
  electricalCircuitEdge?: Maybe<ElectricalCircuitsEdge>;
  /** Reads a single `ElectricalMeteringPoint` that is related to this `ElectricalCircuit`. */
  electricalMeteringPoint?: Maybe<ElectricalMeteringPoint>;
  /** Reads a single `ElectricalPanel` that is related to this `ElectricalCircuit`. */
  electricalPanel?: Maybe<ElectricalPanel>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `ElectricalCircuit` mutation. */
export type UpsertElectricalCircuitPayloadElectricalCircuitEdgeArgs = {
  orderBy?: InputMaybe<Array<ElectricalCircuitsOrderBy>>;
};

/** Where conditions for the upsert `ElectricalCircuit` mutation. */
export type UpsertElectricalCircuitWhere = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** All input for the upsert `ElectricalMeteringPoint` mutation. */
export type UpsertElectricalMeteringPointInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `ElectricalMeteringPoint` to be upserted by this mutation. */
  electricalMeteringPoint: ElectricalMeteringPointInput;
};

/** The output of our upsert `ElectricalMeteringPoint` mutation. */
export type UpsertElectricalMeteringPointPayload = {
  __typename?: 'UpsertElectricalMeteringPointPayload';
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  apparentPower?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  apparentPowerPhaseA?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  apparentPowerPhaseB?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  apparentPowerPhaseC?: Maybe<DataPoint>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  crestFactorPhaseA?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  crestFactorPhaseB?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  crestFactorPhaseC?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  cumulativeKwh?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  current?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  currentAmplitudeImbalance?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  currentAverage?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  currentThdAverage?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  currentThdPhaseA?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  currentThdPhaseB?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  currentThdPhaseC?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  currentUnbalanceFactor?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  demandPhaseA?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  demandPhaseB?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  demandPhaseC?: Maybe<DataPoint>;
  /** The `ElectricalMeteringPoint` that was upserted by this mutation. */
  electricalMeteringPoint?: Maybe<ElectricalMeteringPoint>;
  /** An edge for our `ElectricalMeteringPoint`. May be used by Relay 1. */
  electricalMeteringPointEdge?: Maybe<ElectricalMeteringPointsEdge>;
  /** Reads a single `Facility` that is related to this `ElectricalMeteringPoint`. */
  facility?: Maybe<Facility>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  frequency?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  frequencyDeviation?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  generatedEnergy?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  kwDemand?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  lineToLineDeviationAverage?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  lineToLineVoltage?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  lineToLineVoltageAb?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  lineToLineVoltageBc?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  lineToLineVoltageCa?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  lineToNeutralDeviationAverage?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  lineToNeutralVoltage?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  lineToNeutralVoltageA?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  lineToNeutralVoltageB?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  lineToNeutralVoltageC?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  netEnergy?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  neutralCurrent?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  phaseACurrent?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  phaseACurrentDeviation?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  phaseAVoltage?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  phaseAVoltageDeviation?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  phaseBCurrent?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  phaseBCurrentDeviation?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  phaseBVoltage?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  phaseBVoltageDeviation?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  phaseCCurrent?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  phaseCCurrentDeviation?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  phaseCVoltage?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  phaseCVoltageDeviation?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  powerFactor?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  powerFactorPhaseA?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  powerFactorPhaseB?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  powerFactorPhaseC?: Maybe<DataPoint>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  reactivePower?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  reactivePowerPhaseA?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  reactivePowerPhaseB?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  reactivePowerPhaseC?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  totalEnergy?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  voltageAmplitudeImbalance?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  voltageAverage?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  voltageThdAverage?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  voltageThdPhaseA?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  voltageThdPhaseB?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  voltageThdPhaseC?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `ElectricalMeteringPoint`. */
  voltageUnbalanceFactor?: Maybe<DataPoint>;
};

/** The output of our upsert `ElectricalMeteringPoint` mutation. */
export type UpsertElectricalMeteringPointPayloadElectricalMeteringPointEdgeArgs =
  {
    orderBy?: InputMaybe<Array<ElectricalMeteringPointsOrderBy>>;
  };

/** Where conditions for the upsert `ElectricalMeteringPoint` mutation. */
export type UpsertElectricalMeteringPointWhere = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** All input for the upsert `ElectricalPanel` mutation. */
export type UpsertElectricalPanelInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `ElectricalPanel` to be upserted by this mutation. */
  electricalPanel: ElectricalPanelInput;
};

/** The output of our upsert `ElectricalPanel` mutation. */
export type UpsertElectricalPanelPayload = {
  __typename?: 'UpsertElectricalPanelPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `ElectricalMeteringPoint` that is related to this `ElectricalPanel`. */
  electricalMeteringPoint?: Maybe<ElectricalMeteringPoint>;
  /** The `ElectricalPanel` that was upserted by this mutation. */
  electricalPanel?: Maybe<ElectricalPanel>;
  /** An edge for our `ElectricalPanel`. May be used by Relay 1. */
  electricalPanelEdge?: Maybe<ElectricalPanelsEdge>;
  /** Reads a single `Facility` that is related to this `ElectricalPanel`. */
  facility?: Maybe<Facility>;
  /** Reads a single `ElectricalCircuit` that is related to this `ElectricalPanel`. */
  parentCircuit?: Maybe<ElectricalCircuit>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `ElectricalPanel` mutation. */
export type UpsertElectricalPanelPayloadElectricalPanelEdgeArgs = {
  orderBy?: InputMaybe<Array<ElectricalPanelsOrderBy>>;
};

/** Where conditions for the upsert `ElectricalPanel` mutation. */
export type UpsertElectricalPanelWhere = {
  electricalMeteringPointId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** All input for the upsert `Evaporator` mutation. */
export type UpsertEvaporatorInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Evaporator` to be upserted by this mutation. */
  evaporator: EvaporatorInput;
};

/** The output of our upsert `Evaporator` mutation. */
export type UpsertEvaporatorPayload = {
  __typename?: 'UpsertEvaporatorPayload';
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  ammoniaState?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  bleedSolenoid?: Maybe<DataPoint>;
  /** Reads a single `BuildingArea` that is related to this `Evaporator`. */
  buildingArea?: Maybe<BuildingArea>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  defrostState?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  defrostTemperature?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  defrostTimer?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  differentialAirTemperature?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  estimatedKwDemand?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  evapState?: Maybe<DataPoint>;
  /** The `Evaporator` that was upserted by this mutation. */
  evaporator?: Maybe<Evaporator>;
  /** An edge for our `Evaporator`. May be used by Relay 1. */
  evaporatorEdge?: Maybe<EvaporatorsEdge>;
  /** Reads a single `Facility` that is related to this `Evaporator`. */
  facility?: Maybe<Facility>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  fanState?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  fanTimer?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  hotGasSolenoid?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  liquidFeedRuntime?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  liquidFeedRuntimeSetpoint?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  liquidSolenoid?: Maybe<DataPoint>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RefrigerationSystem` that is related to this `Evaporator`. */
  refrigerationSystem?: Maybe<RefrigerationSystem>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  returnAirTemperature?: Maybe<DataPoint>;
  /** Reads a single `SuctionHeader` that is related to this `Evaporator`. */
  returnSuctionHeader?: Maybe<SuctionHeader>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  setpoint?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  softHotGasSolenoid?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  suctionPressure?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  suctionSolenoid?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  suctionTemperature?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  supplyAirTemperature?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `Evaporator`. */
  zoneTemperature?: Maybe<DataPoint>;
};

/** The output of our upsert `Evaporator` mutation. */
export type UpsertEvaporatorPayloadEvaporatorEdgeArgs = {
  orderBy?: InputMaybe<Array<EvaporatorsOrderBy>>;
};

/** Where conditions for the upsert `Evaporator` mutation. */
export type UpsertEvaporatorWhere = {
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

/** All input for the upsert `FacilityCheckUser` mutation. */
export type UpsertFacilityCheckUserInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `FacilityCheckUser` to be upserted by this mutation. */
  facilityCheckUser: FacilityCheckUserInput;
};

/** The output of our upsert `FacilityCheckUser` mutation. */
export type UpsertFacilityCheckUserPayload = {
  __typename?: 'UpsertFacilityCheckUserPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `FacilityCheckUser` that was upserted by this mutation. */
  facilityCheckUser?: Maybe<FacilityCheckUser>;
  /** An edge for our `FacilityCheckUser`. May be used by Relay 1. */
  facilityCheckUserEdge?: Maybe<FacilityCheckUsersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `FacilityCheckUser`. */
  user?: Maybe<User>;
};

/** The output of our upsert `FacilityCheckUser` mutation. */
export type UpsertFacilityCheckUserPayloadFacilityCheckUserEdgeArgs = {
  orderBy?: InputMaybe<Array<FacilityCheckUsersOrderBy>>;
};

/** Where conditions for the upsert `FacilityCheckUser` mutation. */
export type UpsertFacilityCheckUserWhere = {
  facilityCheckId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** All input for the upsert `FacilitySoftwarePackage` mutation. */
export type UpsertFacilitySoftwarePackageInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `FacilitySoftwarePackage` to be upserted by this mutation. */
  facilitySoftwarePackage: FacilitySoftwarePackageInput;
};

/** The output of our upsert `FacilitySoftwarePackage` mutation. */
export type UpsertFacilitySoftwarePackagePayload = {
  __typename?: 'UpsertFacilitySoftwarePackagePayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Facility` that is related to this `FacilitySoftwarePackage`. */
  facility?: Maybe<Facility>;
  /** The `FacilitySoftwarePackage` that was upserted by this mutation. */
  facilitySoftwarePackage?: Maybe<FacilitySoftwarePackage>;
  /** An edge for our `FacilitySoftwarePackage`. May be used by Relay 1. */
  facilitySoftwarePackageEdge?: Maybe<FacilitySoftwarePackagesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SoftwarePackage` that is related to this `FacilitySoftwarePackage`. */
  softwarePackage?: Maybe<SoftwarePackage>;
};

/** The output of our upsert `FacilitySoftwarePackage` mutation. */
export type UpsertFacilitySoftwarePackagePayloadFacilitySoftwarePackageEdgeArgs =
  {
    orderBy?: InputMaybe<Array<FacilitySoftwarePackagesOrderBy>>;
  };

/** Where conditions for the upsert `FacilitySoftwarePackage` mutation. */
export type UpsertFacilitySoftwarePackageWhere = {
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  softwarePackageId?: InputMaybe<Scalars['Int']['input']>;
};

/** All input for the upsert `FacilityTaggedDataPoint` mutation. */
export type UpsertFacilityTaggedDataPointInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `FacilityTaggedDataPoint` to be upserted by this mutation. */
  facilityTaggedDataPoint: FacilityTaggedDataPointInput;
};

/** The output of our upsert `FacilityTaggedDataPoint` mutation. */
export type UpsertFacilityTaggedDataPointPayload = {
  __typename?: 'UpsertFacilityTaggedDataPointPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DataPoint` that is related to this `FacilityTaggedDataPoint`. */
  dataPoint?: Maybe<DataPoint>;
  /** Reads a single `Facility` that is related to this `FacilityTaggedDataPoint`. */
  facility?: Maybe<Facility>;
  /** The `FacilityTaggedDataPoint` that was upserted by this mutation. */
  facilityTaggedDataPoint?: Maybe<FacilityTaggedDataPoint>;
  /** An edge for our `FacilityTaggedDataPoint`. May be used by Relay 1. */
  facilityTaggedDataPointEdge?: Maybe<FacilityTaggedDataPointsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DataPointTag` that is related to this `FacilityTaggedDataPoint`. */
  tag?: Maybe<DataPointTag>;
};

/** The output of our upsert `FacilityTaggedDataPoint` mutation. */
export type UpsertFacilityTaggedDataPointPayloadFacilityTaggedDataPointEdgeArgs =
  {
    orderBy?: InputMaybe<Array<FacilityTaggedDataPointsOrderBy>>;
  };

/** Where conditions for the upsert `FacilityTaggedDataPoint` mutation. */
export type UpsertFacilityTaggedDataPointWhere = {
  dataPointId?: InputMaybe<Scalars['BigInt']['input']>;
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  tagId?: InputMaybe<Scalars['Int']['input']>;
};

/** All input for the upsert `Gateway` mutation. */
export type UpsertGatewayInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Gateway` to be upserted by this mutation. */
  gateway: GatewayInput;
};

/** The output of our upsert `Gateway` mutation. */
export type UpsertGatewayPayload = {
  __typename?: 'UpsertGatewayPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Facility` that is related to this `Gateway`. */
  facility?: Maybe<Facility>;
  /** The `Gateway` that was upserted by this mutation. */
  gateway?: Maybe<Gateway>;
  /** An edge for our `Gateway`. May be used by Relay 1. */
  gatewayEdge?: Maybe<GatewaysEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DataPoint` that is related to this `Gateway`. */
  status?: Maybe<DataPoint>;
};

/** The output of our upsert `Gateway` mutation. */
export type UpsertGatewayPayloadGatewayEdgeArgs = {
  orderBy?: InputMaybe<Array<GatewaysOrderBy>>;
};

/** Where conditions for the upsert `Gateway` mutation. */
export type UpsertGatewayWhere = {
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  hardwareId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

/** All input for the upsert `InboundOutboundLoad` mutation. */
export type UpsertInboundOutboundLoadInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `InboundOutboundLoad` to be upserted by this mutation. */
  inboundOutboundLoad: InboundOutboundLoadInput;
};

/** The output of our upsert `InboundOutboundLoad` mutation. */
export type UpsertInboundOutboundLoadPayload = {
  __typename?: 'UpsertInboundOutboundLoadPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Facility` that is related to this `InboundOutboundLoad`. */
  facility?: Maybe<Facility>;
  /** The `InboundOutboundLoad` that was upserted by this mutation. */
  inboundOutboundLoad?: Maybe<InboundOutboundLoad>;
  /** An edge for our `InboundOutboundLoad`. May be used by Relay 1. */
  inboundOutboundLoadEdge?: Maybe<InboundOutboundLoadsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `InboundOutboundLoad` mutation. */
export type UpsertInboundOutboundLoadPayloadInboundOutboundLoadEdgeArgs = {
  orderBy?: InputMaybe<Array<InboundOutboundLoadsOrderBy>>;
};

/** Where conditions for the upsert `InboundOutboundLoad` mutation. */
export type UpsertInboundOutboundLoadWhere = {
  id?: InputMaybe<Scalars['BigInt']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
};

/** All input for the `upsertIntegrationUtilityProvider` mutation. */
export type UpsertIntegrationUtilityProviderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  integration: UtilityIntegration;
  integrationKey: Scalars['String']['input'];
  providerName: Scalars['String']['input'];
};

/** The output of our `upsertIntegrationUtilityProvider` mutation. */
export type UpsertIntegrationUtilityProviderPayload = {
  __typename?: 'UpsertIntegrationUtilityProviderPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  recordId?: Maybe<Scalars['Int']['output']>;
};

/** All input for the upsert `LiquidHeader` mutation. */
export type UpsertLiquidHeaderInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `LiquidHeader` to be upserted by this mutation. */
  liquidHeader: LiquidHeaderInput;
};

/** The output of our upsert `LiquidHeader` mutation. */
export type UpsertLiquidHeaderPayload = {
  __typename?: 'UpsertLiquidHeaderPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `LiquidHeader` that was upserted by this mutation. */
  liquidHeader?: Maybe<LiquidHeader>;
  /** An edge for our `LiquidHeader`. May be used by Relay 1. */
  liquidHeaderEdge?: Maybe<LiquidHeadersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RefrigerationSystem` that is related to this `LiquidHeader`. */
  refrigerationSystem?: Maybe<RefrigerationSystem>;
  /** Reads a single `Vessel` that is related to this `LiquidHeader`. */
  vessel?: Maybe<Vessel>;
};

/** The output of our upsert `LiquidHeader` mutation. */
export type UpsertLiquidHeaderPayloadLiquidHeaderEdgeArgs = {
  orderBy?: InputMaybe<Array<LiquidHeadersOrderBy>>;
};

/** Where conditions for the upsert `LiquidHeader` mutation. */
export type UpsertLiquidHeaderWhere = {
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  refrigerationSystemId?: InputMaybe<Scalars['Int']['input']>;
};

/** All input for the upsert `LiquidHeadersEvaporator` mutation. */
export type UpsertLiquidHeadersEvaporatorInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `LiquidHeadersEvaporator` to be upserted by this mutation. */
  liquidHeadersEvaporator: LiquidHeadersEvaporatorInput;
};

/** The output of our upsert `LiquidHeadersEvaporator` mutation. */
export type UpsertLiquidHeadersEvaporatorPayload = {
  __typename?: 'UpsertLiquidHeadersEvaporatorPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Evaporator` that is related to this `LiquidHeadersEvaporator`. */
  evaporator?: Maybe<Evaporator>;
  /** Reads a single `LiquidHeader` that is related to this `LiquidHeadersEvaporator`. */
  liquidHeader?: Maybe<LiquidHeader>;
  /** The `LiquidHeadersEvaporator` that was upserted by this mutation. */
  liquidHeadersEvaporator?: Maybe<LiquidHeadersEvaporator>;
  /** An edge for our `LiquidHeadersEvaporator`. May be used by Relay 1. */
  liquidHeadersEvaporatorEdge?: Maybe<LiquidHeadersEvaporatorsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `LiquidHeadersEvaporator` mutation. */
export type UpsertLiquidHeadersEvaporatorPayloadLiquidHeadersEvaporatorEdgeArgs =
  {
    orderBy?: InputMaybe<Array<LiquidHeadersEvaporatorsOrderBy>>;
  };

/** Where conditions for the upsert `LiquidHeadersEvaporator` mutation. */
export type UpsertLiquidHeadersEvaporatorWhere = {
  evaporatorId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  liquidHeaderId?: InputMaybe<Scalars['Int']['input']>;
};

/** All input for the upsert `MachineUser` mutation. */
export type UpsertMachineUserInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `MachineUser` to be upserted by this mutation. */
  machineUser: MachineUserInput;
};

/** The output of our upsert `MachineUser` mutation. */
export type UpsertMachineUserPayload = {
  __typename?: 'UpsertMachineUserPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `MachineUser` that was upserted by this mutation. */
  machineUser?: Maybe<MachineUser>;
  /** An edge for our `MachineUser`. May be used by Relay 1. */
  machineUserEdge?: Maybe<MachineUsersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `MachineUser` mutation. */
export type UpsertMachineUserPayloadMachineUserEdgeArgs = {
  orderBy?: InputMaybe<Array<MachineUsersOrderBy>>;
};

/** Where conditions for the upsert `MachineUser` mutation. */
export type UpsertMachineUserWhere = {
  id?: InputMaybe<Scalars['BigInt']['input']>;
};

/** All input for the upsert `MainService` mutation. */
export type UpsertMainServiceInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `MainService` to be upserted by this mutation. */
  mainService: MainServiceInput;
};

/** The output of our upsert `MainService` mutation. */
export type UpsertMainServicePayload = {
  __typename?: 'UpsertMainServicePayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DataPoint` that is related to this `MainService`. */
  demand?: Maybe<DataPoint>;
  /** Reads a single `Facility` that is related to this `MainService`. */
  facility?: Maybe<Facility>;
  /** Reads a single `DataPoint` that is related to this `MainService`. */
  gridDemand?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `MainService`. */
  gridUsage?: Maybe<DataPoint>;
  /** The `MainService` that was upserted by this mutation. */
  mainService?: Maybe<MainService>;
  /** An edge for our `MainService`. May be used by Relay 1. */
  mainServiceEdge?: Maybe<MainServicesEdge>;
  /** Reads a single `DataPoint` that is related to this `MainService`. */
  meterDemand?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `MainService`. */
  meterUsage?: Maybe<DataPoint>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DataPoint` that is related to this `MainService`. */
  usage?: Maybe<DataPoint>;
};

/** The output of our upsert `MainService` mutation. */
export type UpsertMainServicePayloadMainServiceEdgeArgs = {
  orderBy?: InputMaybe<Array<MainServicesOrderBy>>;
};

/** Where conditions for the upsert `MainService` mutation. */
export type UpsertMainServiceWhere = {
  demandDataPointId?: InputMaybe<Scalars['Int']['input']>;
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  usageDataPointId?: InputMaybe<Scalars['Int']['input']>;
};

/** All input for the upsert `MeterCharge` mutation. */
export type UpsertMeterChargeInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `MeterCharge` to be upserted by this mutation. */
  meterCharge: MeterChargeInput;
};

/** The output of our upsert `MeterCharge` mutation. */
export type UpsertMeterChargePayload = {
  __typename?: 'UpsertMeterChargePayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `MeterCharge` that was upserted by this mutation. */
  meterCharge?: Maybe<MeterCharge>;
  /** An edge for our `MeterCharge`. May be used by Relay 1. */
  meterChargeEdge?: Maybe<MeterChargesEdge>;
  /** Reads a single `MeterStatement` that is related to this `MeterCharge`. */
  meterStatement?: Maybe<MeterStatement>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `MeterCharge` mutation. */
export type UpsertMeterChargePayloadMeterChargeEdgeArgs = {
  orderBy?: InputMaybe<Array<MeterChargesOrderBy>>;
};

/** Where conditions for the upsert `MeterCharge` mutation. */
export type UpsertMeterChargeWhere = {
  category?: InputMaybe<UtilityMeterChargeCategory>;
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  lineNumber?: InputMaybe<Scalars['Int']['input']>;
  meterStatementId?: InputMaybe<Scalars['Int']['input']>;
};

/** All input for the upsert `MeterStatement` mutation. */
export type UpsertMeterStatementInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `MeterStatement` to be upserted by this mutation. */
  meterStatement: MeterStatementInput;
};

/** The output of our upsert `MeterStatement` mutation. */
export type UpsertMeterStatementPayload = {
  __typename?: 'UpsertMeterStatementPayload';
  /** Reads a single `AccountStatement` that is related to this `MeterStatement`. */
  accountStatement?: Maybe<AccountStatement>;
  /** Reads a single `AccountStatementPdf` that is related to this `MeterStatement`. */
  accountStatementPdf?: Maybe<AccountStatementPdf>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `MeterStatement` that was upserted by this mutation. */
  meterStatement?: Maybe<MeterStatement>;
  /** An edge for our `MeterStatement`. May be used by Relay 1. */
  meterStatementEdge?: Maybe<MeterStatementsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `UtilityMeter` that is related to this `MeterStatement`. */
  utilityMeter?: Maybe<UtilityMeter>;
};

/** The output of our upsert `MeterStatement` mutation. */
export type UpsertMeterStatementPayloadMeterStatementEdgeArgs = {
  orderBy?: InputMaybe<Array<MeterStatementsOrderBy>>;
};

/** Where conditions for the upsert `MeterStatement` mutation. */
export type UpsertMeterStatementWhere = {
  id?: InputMaybe<Scalars['Int']['input']>;
  integrationKey?: InputMaybe<Scalars['String']['input']>;
  statementDate?: InputMaybe<Scalars['Date']['input']>;
};

/** All input for the upsert `MeterUsage` mutation. */
export type UpsertMeterUsageInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `MeterUsage` to be upserted by this mutation. */
  meterUsage: MeterUsageInput;
};

/** The output of our upsert `MeterUsage` mutation. */
export type UpsertMeterUsagePayload = {
  __typename?: 'UpsertMeterUsagePayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `MeterStatement` that is related to this `MeterUsage`. */
  meterStatement?: Maybe<MeterStatement>;
  /** The `MeterUsage` that was upserted by this mutation. */
  meterUsage?: Maybe<MeterUsage>;
  /** An edge for our `MeterUsage`. May be used by Relay 1. */
  meterUsageEdge?: Maybe<MeterUsagesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `MeterUsage` mutation. */
export type UpsertMeterUsagePayloadMeterUsageEdgeArgs = {
  orderBy?: InputMaybe<Array<MeterUsagesOrderBy>>;
};

/** Where conditions for the upsert `MeterUsage` mutation. */
export type UpsertMeterUsageWhere = {
  category?: InputMaybe<UtilityMeterUsageCategory>;
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  lineNumber?: InputMaybe<Scalars['Int']['input']>;
  meterStatementId?: InputMaybe<Scalars['Int']['input']>;
  units?: InputMaybe<Scalars['String']['input']>;
};

/** All input for the upsert `MonitorAttribute` mutation. */
export type UpsertMonitorAttributeInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `MonitorAttribute` to be upserted by this mutation. */
  monitorAttribute: MonitorAttributeInput;
};

/** The output of our upsert `MonitorAttribute` mutation. */
export type UpsertMonitorAttributePayload = {
  __typename?: 'UpsertMonitorAttributePayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Monitor` that is related to this `MonitorAttribute`. */
  monitor?: Maybe<Monitor>;
  /** The `MonitorAttribute` that was upserted by this mutation. */
  monitorAttribute?: Maybe<MonitorAttribute>;
  /** An edge for our `MonitorAttribute`. May be used by Relay 1. */
  monitorAttributeEdge?: Maybe<MonitorAttributesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `MonitorAttribute` mutation. */
export type UpsertMonitorAttributePayloadMonitorAttributeEdgeArgs = {
  orderBy?: InputMaybe<Array<MonitorAttributesOrderBy>>;
};

/** Where conditions for the upsert `MonitorAttribute` mutation. */
export type UpsertMonitorAttributeWhere = {
  key?: InputMaybe<Scalars['String']['input']>;
  monitorId?: InputMaybe<Scalars['Int']['input']>;
};

/** All input for the upsert `MonitorDataPoint` mutation. */
export type UpsertMonitorDataPointInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `MonitorDataPoint` to be upserted by this mutation. */
  monitorDataPoint: MonitorDataPointInput;
};

/** The output of our upsert `MonitorDataPoint` mutation. */
export type UpsertMonitorDataPointPayload = {
  __typename?: 'UpsertMonitorDataPointPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DataPoint` that is related to this `MonitorDataPoint`. */
  dataPoint?: Maybe<DataPoint>;
  /** Reads a single `Monitor` that is related to this `MonitorDataPoint`. */
  monitor?: Maybe<Monitor>;
  /** The `MonitorDataPoint` that was upserted by this mutation. */
  monitorDataPoint?: Maybe<MonitorDataPoint>;
  /** An edge for our `MonitorDataPoint`. May be used by Relay 1. */
  monitorDataPointEdge?: Maybe<MonitorDataPointsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `MonitorDataPoint` mutation. */
export type UpsertMonitorDataPointPayloadMonitorDataPointEdgeArgs = {
  orderBy?: InputMaybe<Array<MonitorDataPointsOrderBy>>;
};

/** Where conditions for the upsert `MonitorDataPoint` mutation. */
export type UpsertMonitorDataPointWhere = {
  dataPointId?: InputMaybe<Scalars['Int']['input']>;
  monitorId?: InputMaybe<Scalars['Int']['input']>;
};

/** All input for the `upsertMonitoredAsset` mutation. */
export type UpsertMonitoredAssetInput = {
  assetId?: InputMaybe<Scalars['Int']['input']>;
  assetType?: InputMaybe<Scalars['String']['input']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `upsertMonitoredAsset` mutation. */
export type UpsertMonitoredAssetPayload = {
  __typename?: 'UpsertMonitoredAssetPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  monitoredAsset?: Maybe<MonitoredAsset>;
  /** An edge for our `MonitoredAsset`. May be used by Relay 1. */
  monitoredAssetEdge?: Maybe<MonitoredAssetsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our `upsertMonitoredAsset` mutation. */
export type UpsertMonitoredAssetPayloadMonitoredAssetEdgeArgs = {
  orderBy?: InputMaybe<Array<MonitoredAssetsOrderBy>>;
};

/** All input for the upsert `PalletHistory` mutation. */
export type UpsertPalletHistoryInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `PalletHistory` to be upserted by this mutation. */
  palletHistory: PalletHistoryInput;
};

/** The output of our upsert `PalletHistory` mutation. */
export type UpsertPalletHistoryPayload = {
  __typename?: 'UpsertPalletHistoryPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `PalletHistory` that was upserted by this mutation. */
  palletHistory?: Maybe<PalletHistory>;
  /** An edge for our `PalletHistory`. May be used by Relay 1. */
  palletHistoryEdge?: Maybe<PalletHistoriesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `PalletHistory` mutation. */
export type UpsertPalletHistoryPayloadPalletHistoryEdgeArgs = {
  orderBy?: InputMaybe<Array<PalletHistoriesOrderBy>>;
};

/** Where conditions for the upsert `PalletHistory` mutation. */
export type UpsertPalletHistoryWhere = {
  id?: InputMaybe<Scalars['BigInt']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
};

/** All input for the upsert `Pallet` mutation. */
export type UpsertPalletInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Pallet` to be upserted by this mutation. */
  pallet: PalletInput;
};

/** All input for the upsert `PalletLocation` mutation. */
export type UpsertPalletLocationInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `PalletLocation` to be upserted by this mutation. */
  palletLocation: PalletLocationInput;
};

/** The output of our upsert `PalletLocation` mutation. */
export type UpsertPalletLocationPayload = {
  __typename?: 'UpsertPalletLocationPayload';
  /** Reads a single `BuildingArea` that is related to this `PalletLocation`. */
  buildingArea?: Maybe<BuildingArea>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Facility` that is related to this `PalletLocation`. */
  facility?: Maybe<Facility>;
  /** The `PalletLocation` that was upserted by this mutation. */
  palletLocation?: Maybe<PalletLocation>;
  /** An edge for our `PalletLocation`. May be used by Relay 1. */
  palletLocationEdge?: Maybe<PalletLocationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `PalletLocation` mutation. */
export type UpsertPalletLocationPayloadPalletLocationEdgeArgs = {
  orderBy?: InputMaybe<Array<PalletLocationsOrderBy>>;
};

/** Where conditions for the upsert `PalletLocation` mutation. */
export type UpsertPalletLocationWhere = {
  id?: InputMaybe<Scalars['BigInt']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our upsert `Pallet` mutation. */
export type UpsertPalletPayload = {
  __typename?: 'UpsertPalletPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Pallet` that was upserted by this mutation. */
  pallet?: Maybe<Pallet>;
  /** An edge for our `Pallet`. May be used by Relay 1. */
  palletEdge?: Maybe<PalletsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `Pallet` mutation. */
export type UpsertPalletPayloadPalletEdgeArgs = {
  orderBy?: InputMaybe<Array<PalletsOrderBy>>;
};

/** Where conditions for the upsert `Pallet` mutation. */
export type UpsertPalletWhere = {
  id?: InputMaybe<Scalars['BigInt']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
};

/** All input for the upsert `PricingNode` mutation. */
export type UpsertPricingNodeInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `PricingNode` to be upserted by this mutation. */
  pricingNode: PricingNodeInput;
};

/** The output of our upsert `PricingNode` mutation. */
export type UpsertPricingNodePayload = {
  __typename?: 'UpsertPricingNodePayload';
  /** Reads a single `BalancingAuthority` that is related to this `PricingNode`. */
  balancingAuthority?: Maybe<BalancingAuthority>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `PricingNode` that was upserted by this mutation. */
  pricingNode?: Maybe<PricingNode>;
  /** An edge for our `PricingNode`. May be used by Relay 1. */
  pricingNodeEdge?: Maybe<PricingNodesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `PricingNode` mutation. */
export type UpsertPricingNodePayloadPricingNodeEdgeArgs = {
  orderBy?: InputMaybe<Array<PricingNodesOrderBy>>;
};

/** Where conditions for the upsert `PricingNode` mutation. */
export type UpsertPricingNodeWhere = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** All input for the upsert `Product` mutation. */
export type UpsertProductInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Product` to be upserted by this mutation. */
  product: ProductInput;
};

/** The output of our upsert `Product` mutation. */
export type UpsertProductPayload = {
  __typename?: 'UpsertProductPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Facility` that is related to this `Product`. */
  facility?: Maybe<Facility>;
  /** The `Product` that was upserted by this mutation. */
  product?: Maybe<Product>;
  /** An edge for our `Product`. May be used by Relay 1. */
  productEdge?: Maybe<ProductsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `Product` mutation. */
export type UpsertProductPayloadProductEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};

/** Where conditions for the upsert `Product` mutation. */
export type UpsertProductWhere = {
  id?: InputMaybe<Scalars['BigInt']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
};

/** All input for the upsert `ProgramEnrollment` mutation. */
export type UpsertProgramEnrollmentInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `ProgramEnrollment` to be upserted by this mutation. */
  programEnrollment: ProgramEnrollmentInput;
};

/** The output of our upsert `ProgramEnrollment` mutation. */
export type UpsertProgramEnrollmentPayload = {
  __typename?: 'UpsertProgramEnrollmentPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Program` that is related to this `ProgramEnrollment`. */
  program?: Maybe<Program>;
  /** The `ProgramEnrollment` that was upserted by this mutation. */
  programEnrollment?: Maybe<ProgramEnrollment>;
  /** An edge for our `ProgramEnrollment`. May be used by Relay 1. */
  programEnrollmentEdge?: Maybe<ProgramEnrollmentsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `ProgramEnrollment` mutation. */
export type UpsertProgramEnrollmentPayloadProgramEnrollmentEdgeArgs = {
  orderBy?: InputMaybe<Array<ProgramEnrollmentsOrderBy>>;
};

/** Where conditions for the upsert `ProgramEnrollment` mutation. */
export type UpsertProgramEnrollmentWhere = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  programId?: InputMaybe<Scalars['Int']['input']>;
};

/** All input for the upsert `Program` mutation. */
export type UpsertProgramInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Program` to be upserted by this mutation. */
  program: ProgramInput;
};

/** The output of our upsert `Program` mutation. */
export type UpsertProgramPayload = {
  __typename?: 'UpsertProgramPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Program` that was upserted by this mutation. */
  program?: Maybe<Program>;
  /** An edge for our `Program`. May be used by Relay 1. */
  programEdge?: Maybe<ProgramsEdge>;
  /** Reads a single `ProjectType` that is related to this `Program`. */
  projectType?: Maybe<ProjectType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Timezone` that is related to this `Program`. */
  timezone?: Maybe<Timezone>;
};

/** The output of our upsert `Program` mutation. */
export type UpsertProgramPayloadProgramEdgeArgs = {
  orderBy?: InputMaybe<Array<ProgramsOrderBy>>;
};

/** Where conditions for the upsert `Program` mutation. */
export type UpsertProgramWhere = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectTypeId?: InputMaybe<Scalars['Int']['input']>;
};

/** All input for the upsert `ProjectComponent` mutation. */
export type UpsertProjectComponentInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `ProjectComponent` to be upserted by this mutation. */
  projectComponent: ProjectComponentInput;
};

/** The output of our upsert `ProjectComponent` mutation. */
export type UpsertProjectComponentPayload = {
  __typename?: 'UpsertProjectComponentPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Component` that is related to this `ProjectComponent`. */
  component?: Maybe<Component>;
  /** Reads a single `Project` that is related to this `ProjectComponent`. */
  project?: Maybe<Project>;
  /** The `ProjectComponent` that was upserted by this mutation. */
  projectComponent?: Maybe<ProjectComponent>;
  /** An edge for our `ProjectComponent`. May be used by Relay 1. */
  projectComponentEdge?: Maybe<ProjectComponentsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `ProjectComponent` mutation. */
export type UpsertProjectComponentPayloadProjectComponentEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectComponentsOrderBy>>;
};

/** Where conditions for the upsert `ProjectComponent` mutation. */
export type UpsertProjectComponentWhere = {
  componentId?: InputMaybe<Scalars['Int']['input']>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
};

/** All input for the upsert `ProjectEnrollmentDataPointGroup` mutation. */
export type UpsertProjectEnrollmentDataPointGroupInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `ProjectEnrollmentDataPointGroup` to be upserted by this mutation. */
  projectEnrollmentDataPointGroup: ProjectEnrollmentDataPointGroupInput;
};

/** The output of our upsert `ProjectEnrollmentDataPointGroup` mutation. */
export type UpsertProjectEnrollmentDataPointGroupPayload = {
  __typename?: 'UpsertProjectEnrollmentDataPointGroupPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `ProjectEnrollmentDataPointGroup` that was upserted by this mutation. */
  projectEnrollmentDataPointGroup?: Maybe<ProjectEnrollmentDataPointGroup>;
  /** An edge for our `ProjectEnrollmentDataPointGroup`. May be used by Relay 1. */
  projectEnrollmentDataPointGroupEdge?: Maybe<ProjectEnrollmentDataPointGroupsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `ProjectEnrollmentDataPointGroup` mutation. */
export type UpsertProjectEnrollmentDataPointGroupPayloadProjectEnrollmentDataPointGroupEdgeArgs =
  {
    orderBy?: InputMaybe<Array<ProjectEnrollmentDataPointGroupsOrderBy>>;
  };

/** Where conditions for the upsert `ProjectEnrollmentDataPointGroup` mutation. */
export type UpsertProjectEnrollmentDataPointGroupWhere = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** All input for the upsert `ProjectEnrollmentDataPoint` mutation. */
export type UpsertProjectEnrollmentDataPointInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `ProjectEnrollmentDataPoint` to be upserted by this mutation. */
  projectEnrollmentDataPoint: ProjectEnrollmentDataPointInput;
};

/** The output of our upsert `ProjectEnrollmentDataPoint` mutation. */
export type UpsertProjectEnrollmentDataPointPayload = {
  __typename?: 'UpsertProjectEnrollmentDataPointPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DataPoint` that is related to this `ProjectEnrollmentDataPoint`. */
  dataPoint?: Maybe<DataPoint>;
  /** Reads a single `ProjectEnrollmentDataPointGroup` that is related to this `ProjectEnrollmentDataPoint`. */
  group?: Maybe<ProjectEnrollmentDataPointGroup>;
  /** Reads a single `DataPoint` that is related to this `ProjectEnrollmentDataPoint`. */
  profileDataPoint?: Maybe<DataPoint>;
  /** Reads a single `ProjectEnrollment` that is related to this `ProjectEnrollmentDataPoint`. */
  projectEnrollment?: Maybe<ProjectEnrollment>;
  /** The `ProjectEnrollmentDataPoint` that was upserted by this mutation. */
  projectEnrollmentDataPoint?: Maybe<ProjectEnrollmentDataPoint>;
  /** An edge for our `ProjectEnrollmentDataPoint`. May be used by Relay 1. */
  projectEnrollmentDataPointEdge?: Maybe<ProjectEnrollmentDataPointsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `ProjectEnrollmentDataPoint` mutation. */
export type UpsertProjectEnrollmentDataPointPayloadProjectEnrollmentDataPointEdgeArgs =
  {
    orderBy?: InputMaybe<Array<ProjectEnrollmentDataPointsOrderBy>>;
  };

/** Where conditions for the upsert `ProjectEnrollmentDataPoint` mutation. */
export type UpsertProjectEnrollmentDataPointWhere = {
  dataPointId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  projectEnrollmentId?: InputMaybe<Scalars['Int']['input']>;
};

/** All input for the upsert `ProjectEnrollment` mutation. */
export type UpsertProjectEnrollmentInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `ProjectEnrollment` to be upserted by this mutation. */
  projectEnrollment: ProjectEnrollmentInput;
};

/** The output of our upsert `ProjectEnrollment` mutation. */
export type UpsertProjectEnrollmentPayload = {
  __typename?: 'UpsertProjectEnrollmentPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `ProgramEnrollment` that is related to this `ProjectEnrollment`. */
  programEnrollment?: Maybe<ProgramEnrollment>;
  /** Reads a single `Project` that is related to this `ProjectEnrollment`. */
  project?: Maybe<Project>;
  /** The `ProjectEnrollment` that was upserted by this mutation. */
  projectEnrollment?: Maybe<ProjectEnrollment>;
  /** An edge for our `ProjectEnrollment`. May be used by Relay 1. */
  projectEnrollmentEdge?: Maybe<ProjectEnrollmentsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our upsert `ProjectEnrollment` mutation. */
export type UpsertProjectEnrollmentPayloadProjectEnrollmentEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectEnrollmentsOrderBy>>;
};

/** Where conditions for the upsert `ProjectEnrollment` mutation. */
export type UpsertProjectEnrollmentWhere = {
  id?: InputMaybe<Scalars['Int']['input']>;
  programEnrollmentId?: InputMaybe<Scalars['Int']['input']>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
};

/** All input for the `upsertProjectSubscription` mutation. */
export type UpsertProjectSubscriptionInput = {
  channels?: InputMaybe<Array<InputMaybe<UserSubscriptionChannel>>>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
};

/** The output of our `upsertProjectSubscription` mutation. */
export type UpsertProjectSubscriptionPayload = {
  __typename?: 'UpsertProjectSubscriptionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  userSubscriptions?: Maybe<Array<UserSubscription>>;
};

/** All input for the upsert `ProjectWatcher` mutation. */
export type UpsertProjectWatcherInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `ProjectWatcher` to be upserted by this mutation. */
  projectWatcher: ProjectWatcherInput;
};

/** The output of our upsert `ProjectWatcher` mutation. */
export type UpsertProjectWatcherPayload = {
  __typename?: 'UpsertProjectWatcherPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Project` that is related to this `ProjectWatcher`. */
  project?: Maybe<Project>;
  /** The `ProjectWatcher` that was upserted by this mutation. */
  projectWatcher?: Maybe<ProjectWatcher>;
  /** An edge for our `ProjectWatcher`. May be used by Relay 1. */
  projectWatcherEdge?: Maybe<ProjectWatchersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `ProjectWatcher`. */
  user?: Maybe<User>;
};

/** The output of our upsert `ProjectWatcher` mutation. */
export type UpsertProjectWatcherPayloadProjectWatcherEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectWatchersOrderBy>>;
};

/** Where conditions for the upsert `ProjectWatcher` mutation. */
export type UpsertProjectWatcherWhere = {
  projectId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** All input for the upsert `RefrigerationSystem` mutation. */
export type UpsertRefrigerationSystemInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `RefrigerationSystem` to be upserted by this mutation. */
  refrigerationSystem: RefrigerationSystemInput;
};

/** The output of our upsert `RefrigerationSystem` mutation. */
export type UpsertRefrigerationSystemPayload = {
  __typename?: 'UpsertRefrigerationSystemPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Facility` that is related to this `RefrigerationSystem`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Refrigerant` that is related to this `RefrigerationSystem`. */
  refrigerant?: Maybe<Refrigerant>;
  /** The `RefrigerationSystem` that was upserted by this mutation. */
  refrigerationSystem?: Maybe<RefrigerationSystem>;
  /** An edge for our `RefrigerationSystem`. May be used by Relay 1. */
  refrigerationSystemEdge?: Maybe<RefrigerationSystemsEdge>;
};

/** The output of our upsert `RefrigerationSystem` mutation. */
export type UpsertRefrigerationSystemPayloadRefrigerationSystemEdgeArgs = {
  orderBy?: InputMaybe<Array<RefrigerationSystemsOrderBy>>;
};

/** Where conditions for the upsert `RefrigerationSystem` mutation. */
export type UpsertRefrigerationSystemWhere = {
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

/** All input for the upsert `ReportExecution` mutation. */
export type UpsertReportExecutionInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `ReportExecution` to be upserted by this mutation. */
  reportExecution: ReportExecutionInput;
};

/** The output of our upsert `ReportExecution` mutation. */
export type UpsertReportExecutionPayload = {
  __typename?: 'UpsertReportExecutionPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Report` that is related to this `ReportExecution`. */
  report?: Maybe<Report>;
  /** Reads a single `ReportAutomation` that is related to this `ReportExecution`. */
  reportAutomation?: Maybe<ReportAutomation>;
  /** The `ReportExecution` that was upserted by this mutation. */
  reportExecution?: Maybe<ReportExecution>;
  /** An edge for our `ReportExecution`. May be used by Relay 1. */
  reportExecutionEdge?: Maybe<ReportExecutionsEdge>;
};

/** The output of our upsert `ReportExecution` mutation. */
export type UpsertReportExecutionPayloadReportExecutionEdgeArgs = {
  orderBy?: InputMaybe<Array<ReportExecutionsOrderBy>>;
};

/** Where conditions for the upsert `ReportExecution` mutation. */
export type UpsertReportExecutionWhere = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** All input for the upsert `ReportQuery` mutation. */
export type UpsertReportQueryInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `ReportQuery` to be upserted by this mutation. */
  reportQuery: ReportQueryInput;
};

/** The output of our upsert `ReportQuery` mutation. */
export type UpsertReportQueryPayload = {
  __typename?: 'UpsertReportQueryPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Report` that is related to this `ReportQuery`. */
  report?: Maybe<Report>;
  /** The `ReportQuery` that was upserted by this mutation. */
  reportQuery?: Maybe<ReportQuery>;
  /** An edge for our `ReportQuery`. May be used by Relay 1. */
  reportQueryEdge?: Maybe<ReportQueriesEdge>;
};

/** The output of our upsert `ReportQuery` mutation. */
export type UpsertReportQueryPayloadReportQueryEdgeArgs = {
  orderBy?: InputMaybe<Array<ReportQueriesOrderBy>>;
};

/** Where conditions for the upsert `ReportQuery` mutation. */
export type UpsertReportQueryWhere = {
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  reportId?: InputMaybe<Scalars['Int']['input']>;
};

/** All input for the upsert `SavingsEventDatum` mutation. */
export type UpsertSavingsEventDatumInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `SavingsEventDatum` to be upserted by this mutation. */
  savingsEventDatum: SavingsEventDatumInput;
};

/** The output of our upsert `SavingsEventDatum` mutation. */
export type UpsertSavingsEventDatumPayload = {
  __typename?: 'UpsertSavingsEventDatumPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SavingsEvent` that is related to this `SavingsEventDatum`. */
  savingsEvent?: Maybe<SavingsEvent>;
  /** The `SavingsEventDatum` that was upserted by this mutation. */
  savingsEventDatum?: Maybe<SavingsEventDatum>;
  /** An edge for our `SavingsEventDatum`. May be used by Relay 1. */
  savingsEventDatumEdge?: Maybe<SavingsEventDataEdge>;
};

/** The output of our upsert `SavingsEventDatum` mutation. */
export type UpsertSavingsEventDatumPayloadSavingsEventDatumEdgeArgs = {
  orderBy?: InputMaybe<Array<SavingsEventDataOrderBy>>;
};

/** Where conditions for the upsert `SavingsEventDatum` mutation. */
export type UpsertSavingsEventDatumWhere = {
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  savingsEventId?: InputMaybe<Scalars['Int']['input']>;
};

/** All input for the upsert `SavingsEvent` mutation. */
export type UpsertSavingsEventInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `SavingsEvent` to be upserted by this mutation. */
  savingsEvent: SavingsEventInput;
};

/** The output of our upsert `SavingsEvent` mutation. */
export type UpsertSavingsEventPayload = {
  __typename?: 'UpsertSavingsEventPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Project` that is related to this `SavingsEvent`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SavingsEvent` that was upserted by this mutation. */
  savingsEvent?: Maybe<SavingsEvent>;
  /** An edge for our `SavingsEvent`. May be used by Relay 1. */
  savingsEventEdge?: Maybe<SavingsEventsEdge>;
};

/** The output of our upsert `SavingsEvent` mutation. */
export type UpsertSavingsEventPayloadSavingsEventEdgeArgs = {
  orderBy?: InputMaybe<Array<SavingsEventsOrderBy>>;
};

/** Where conditions for the upsert `SavingsEvent` mutation. */
export type UpsertSavingsEventWhere = {
  endTime?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
  startTime?: InputMaybe<Scalars['Datetime']['input']>;
};

/** All input for the upsert `Submeter` mutation. */
export type UpsertSubmeterInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Submeter` to be upserted by this mutation. */
  submeter: SubmeterInput;
};

/** The output of our upsert `Submeter` mutation. */
export type UpsertSubmeterPayload = {
  __typename?: 'UpsertSubmeterPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DataPoint` that is related to this `Submeter`. */
  demand?: Maybe<DataPoint>;
  /** Reads a single `Facility` that is related to this `Submeter`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Submeter` that was upserted by this mutation. */
  submeter?: Maybe<Submeter>;
  /** An edge for our `Submeter`. May be used by Relay 1. */
  submeterEdge?: Maybe<SubmetersEdge>;
  /** Reads a single `DataPoint` that is related to this `Submeter`. */
  usage?: Maybe<DataPoint>;
  /** Reads a single `UtilityMeter` that is related to this `Submeter`. */
  utilityMeter?: Maybe<UtilityMeter>;
};

/** The output of our upsert `Submeter` mutation. */
export type UpsertSubmeterPayloadSubmeterEdgeArgs = {
  orderBy?: InputMaybe<Array<SubmetersOrderBy>>;
};

/** All input for the upsert `SubmeterSession` mutation. */
export type UpsertSubmeterSessionInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `SubmeterSession` to be upserted by this mutation. */
  submeterSession: SubmeterSessionInput;
};

/** The output of our upsert `SubmeterSession` mutation. */
export type UpsertSubmeterSessionPayload = {
  __typename?: 'UpsertSubmeterSessionPayload';
  /** Reads a single `BillableCustomer` that is related to this `SubmeterSession`. */
  associatedCustomer?: Maybe<BillableCustomer>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Submeter` that is related to this `SubmeterSession`. */
  submeter?: Maybe<Submeter>;
  /** The `SubmeterSession` that was upserted by this mutation. */
  submeterSession?: Maybe<SubmeterSession>;
  /** An edge for our `SubmeterSession`. May be used by Relay 1. */
  submeterSessionEdge?: Maybe<SubmeterSessionsEdge>;
};

/** The output of our upsert `SubmeterSession` mutation. */
export type UpsertSubmeterSessionPayloadSubmeterSessionEdgeArgs = {
  orderBy?: InputMaybe<Array<SubmeterSessionsOrderBy>>;
};

/** Where conditions for the upsert `SubmeterSession` mutation. */
export type UpsertSubmeterSessionWhere = {
  id?: InputMaybe<Scalars['Int']['input']>;
  startTime?: InputMaybe<Scalars['Datetime']['input']>;
  submeterId?: InputMaybe<Scalars['Int']['input']>;
};

/** Where conditions for the upsert `Submeter` mutation. */
export type UpsertSubmeterWhere = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** All input for the upsert `SuctionGroupCompressor` mutation. */
export type UpsertSuctionGroupCompressorInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `SuctionGroupCompressor` to be upserted by this mutation. */
  suctionGroupCompressor: SuctionGroupCompressorInput;
};

/** The output of our upsert `SuctionGroupCompressor` mutation. */
export type UpsertSuctionGroupCompressorPayload = {
  __typename?: 'UpsertSuctionGroupCompressorPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Compressor` that is related to this `SuctionGroupCompressor`. */
  compressor?: Maybe<Compressor>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SuctionGroup` that is related to this `SuctionGroupCompressor`. */
  suctionGroup?: Maybe<SuctionGroup>;
  /** The `SuctionGroupCompressor` that was upserted by this mutation. */
  suctionGroupCompressor?: Maybe<SuctionGroupCompressor>;
  /** An edge for our `SuctionGroupCompressor`. May be used by Relay 1. */
  suctionGroupCompressorEdge?: Maybe<SuctionGroupCompressorsEdge>;
};

/** The output of our upsert `SuctionGroupCompressor` mutation. */
export type UpsertSuctionGroupCompressorPayloadSuctionGroupCompressorEdgeArgs =
  {
    orderBy?: InputMaybe<Array<SuctionGroupCompressorsOrderBy>>;
  };

/** Where conditions for the upsert `SuctionGroupCompressor` mutation. */
export type UpsertSuctionGroupCompressorWhere = {
  compressorId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  suctionGroupId?: InputMaybe<Scalars['Int']['input']>;
};

/** All input for the upsert `SuctionGroup` mutation. */
export type UpsertSuctionGroupInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `SuctionGroup` to be upserted by this mutation. */
  suctionGroup: SuctionGroupInput;
};

/** The output of our upsert `SuctionGroup` mutation. */
export type UpsertSuctionGroupPayload = {
  __typename?: 'UpsertSuctionGroupPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RefrigerationSystem` that is related to this `SuctionGroup`. */
  refrigerationSystem?: Maybe<RefrigerationSystem>;
  /** The `SuctionGroup` that was upserted by this mutation. */
  suctionGroup?: Maybe<SuctionGroup>;
  /** An edge for our `SuctionGroup`. May be used by Relay 1. */
  suctionGroupEdge?: Maybe<SuctionGroupsEdge>;
  /** Reads a single `DataPoint` that is related to this `SuctionGroup`. */
  suctionPressure?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `SuctionGroup`. */
  suctionPressureSetpoint?: Maybe<DataPoint>;
};

/** The output of our upsert `SuctionGroup` mutation. */
export type UpsertSuctionGroupPayloadSuctionGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<SuctionGroupsOrderBy>>;
};

/** Where conditions for the upsert `SuctionGroup` mutation. */
export type UpsertSuctionGroupWhere = {
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  refrigerationSystemId?: InputMaybe<Scalars['Int']['input']>;
};

/** All input for the upsert `SuctionHeader` mutation. */
export type UpsertSuctionHeaderInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `SuctionHeader` to be upserted by this mutation. */
  suctionHeader: SuctionHeaderInput;
};

/** The output of our upsert `SuctionHeader` mutation. */
export type UpsertSuctionHeaderPayload = {
  __typename?: 'UpsertSuctionHeaderPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RefrigerationSystem` that is related to this `SuctionHeader`. */
  refrigerationSystem?: Maybe<RefrigerationSystem>;
  /** Reads a single `SuctionGroup` that is related to this `SuctionHeader`. */
  suctionGroup?: Maybe<SuctionGroup>;
  /** The `SuctionHeader` that was upserted by this mutation. */
  suctionHeader?: Maybe<SuctionHeader>;
  /** An edge for our `SuctionHeader`. May be used by Relay 1. */
  suctionHeaderEdge?: Maybe<SuctionHeadersEdge>;
};

/** The output of our upsert `SuctionHeader` mutation. */
export type UpsertSuctionHeaderPayloadSuctionHeaderEdgeArgs = {
  orderBy?: InputMaybe<Array<SuctionHeadersOrderBy>>;
};

/** Where conditions for the upsert `SuctionHeader` mutation. */
export type UpsertSuctionHeaderWhere = {
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  refrigerationSystemId?: InputMaybe<Scalars['Int']['input']>;
};

/** All input for the upsert `SuctionHeadersCompressor` mutation. */
export type UpsertSuctionHeadersCompressorInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `SuctionHeadersCompressor` to be upserted by this mutation. */
  suctionHeadersCompressor: SuctionHeadersCompressorInput;
};

/** The output of our upsert `SuctionHeadersCompressor` mutation. */
export type UpsertSuctionHeadersCompressorPayload = {
  __typename?: 'UpsertSuctionHeadersCompressorPayload';
  /** Reads a single `DataPoint` that is related to this `SuctionHeadersCompressor`. */
  active?: Maybe<DataPoint>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Compressor` that is related to this `SuctionHeadersCompressor`. */
  compressor?: Maybe<Compressor>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SuctionHeader` that is related to this `SuctionHeadersCompressor`. */
  suctionHeader?: Maybe<SuctionHeader>;
  /** The `SuctionHeadersCompressor` that was upserted by this mutation. */
  suctionHeadersCompressor?: Maybe<SuctionHeadersCompressor>;
  /** An edge for our `SuctionHeadersCompressor`. May be used by Relay 1. */
  suctionHeadersCompressorEdge?: Maybe<SuctionHeadersCompressorsEdge>;
};

/** The output of our upsert `SuctionHeadersCompressor` mutation. */
export type UpsertSuctionHeadersCompressorPayloadSuctionHeadersCompressorEdgeArgs =
  {
    orderBy?: InputMaybe<Array<SuctionHeadersCompressorsOrderBy>>;
  };

/** Where conditions for the upsert `SuctionHeadersCompressor` mutation. */
export type UpsertSuctionHeadersCompressorWhere = {
  compressorId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  suctionHeaderId?: InputMaybe<Scalars['Int']['input']>;
};

/** All input for the upsert `SuggestionControlEvent` mutation. */
export type UpsertSuggestionControlEventInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `SuggestionControlEvent` to be upserted by this mutation. */
  suggestionControlEvent: SuggestionControlEventInput;
};

/** The output of our upsert `SuggestionControlEvent` mutation. */
export type UpsertSuggestionControlEventPayload = {
  __typename?: 'UpsertSuggestionControlEventPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `ControlEvent` that is related to this `SuggestionControlEvent`. */
  controlEvent?: Maybe<ControlEvent>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Suggestion` that is related to this `SuggestionControlEvent`. */
  suggestion?: Maybe<Suggestion>;
  /** The `SuggestionControlEvent` that was upserted by this mutation. */
  suggestionControlEvent?: Maybe<SuggestionControlEvent>;
};

/** Where conditions for the upsert `SuggestionControlEvent` mutation. */
export type UpsertSuggestionControlEventWhere = {
  controlEventId?: InputMaybe<Scalars['Int']['input']>;
  suggestionId?: InputMaybe<Scalars['Int']['input']>;
};

/** All input for the upsert `TemperatureSensor` mutation. */
export type UpsertTemperatureSensorInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `TemperatureSensor` to be upserted by this mutation. */
  temperatureSensor: TemperatureSensorInput;
};

/** The output of our upsert `TemperatureSensor` mutation. */
export type UpsertTemperatureSensorPayload = {
  __typename?: 'UpsertTemperatureSensorPayload';
  /** Reads a single `DataPoint` that is related to this `TemperatureSensor`. */
  battery?: Maybe<DataPoint>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Facility` that is related to this `TemperatureSensor`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DataPoint` that is related to this `TemperatureSensor`. */
  signal?: Maybe<DataPoint>;
  /** Reads a single `DataPoint` that is related to this `TemperatureSensor`. */
  temperature?: Maybe<DataPoint>;
  /** The `TemperatureSensor` that was upserted by this mutation. */
  temperatureSensor?: Maybe<TemperatureSensor>;
  /** An edge for our `TemperatureSensor`. May be used by Relay 1. */
  temperatureSensorEdge?: Maybe<TemperatureSensorsEdge>;
};

/** The output of our upsert `TemperatureSensor` mutation. */
export type UpsertTemperatureSensorPayloadTemperatureSensorEdgeArgs = {
  orderBy?: InputMaybe<Array<TemperatureSensorsOrderBy>>;
};

/** Where conditions for the upsert `TemperatureSensor` mutation. */
export type UpsertTemperatureSensorWhere = {
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  hardwareId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

/** All input for the upsert `TrailerAudit` mutation. */
export type UpsertTrailerAuditInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `TrailerAudit` to be upserted by this mutation. */
  trailerAudit: TrailerAuditInput;
};

/** The output of our upsert `TrailerAudit` mutation. */
export type UpsertTrailerAuditPayload = {
  __typename?: 'UpsertTrailerAuditPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Trailer` that is related to this `TrailerAudit`. */
  trailer?: Maybe<Trailer>;
  /** The `TrailerAudit` that was upserted by this mutation. */
  trailerAudit?: Maybe<TrailerAudit>;
  /** An edge for our `TrailerAudit`. May be used by Relay 1. */
  trailerAuditEdge?: Maybe<TrailerAuditsEdge>;
  /** Reads a single `User` that is related to this `TrailerAudit`. */
  userByAuditUser?: Maybe<User>;
  /** Reads a single `Yard` that is related to this `TrailerAudit`. */
  yard?: Maybe<Yard>;
};

/** The output of our upsert `TrailerAudit` mutation. */
export type UpsertTrailerAuditPayloadTrailerAuditEdgeArgs = {
  orderBy?: InputMaybe<Array<TrailerAuditsOrderBy>>;
};

/** Where conditions for the upsert `TrailerAudit` mutation. */
export type UpsertTrailerAuditWhere = {
  id?: InputMaybe<Scalars['BigInt']['input']>;
};

/** All input for the upsert `Trailer` mutation. */
export type UpsertTrailerInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Trailer` to be upserted by this mutation. */
  trailer: TrailerInput;
};

/** The output of our upsert `Trailer` mutation. */
export type UpsertTrailerPayload = {
  __typename?: 'UpsertTrailerPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Trailer` that was upserted by this mutation. */
  trailer?: Maybe<Trailer>;
  /** An edge for our `Trailer`. May be used by Relay 1. */
  trailerEdge?: Maybe<TrailersEdge>;
};

/** The output of our upsert `Trailer` mutation. */
export type UpsertTrailerPayloadTrailerEdgeArgs = {
  orderBy?: InputMaybe<Array<TrailersOrderBy>>;
};

/** All input for the upsert `TrailerPosition` mutation. */
export type UpsertTrailerPositionInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `TrailerPosition` to be upserted by this mutation. */
  trailerPosition: TrailerPositionInput;
};

/** The output of our upsert `TrailerPosition` mutation. */
export type UpsertTrailerPositionPayload = {
  __typename?: 'UpsertTrailerPositionPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Facility` that is related to this `TrailerPosition`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DataPoint` that is related to this `TrailerPosition`. */
  trailerIsPresent?: Maybe<DataPoint>;
  /** The `TrailerPosition` that was upserted by this mutation. */
  trailerPosition?: Maybe<TrailerPosition>;
  /** An edge for our `TrailerPosition`. May be used by Relay 1. */
  trailerPositionEdge?: Maybe<TrailerPositionsEdge>;
};

/** The output of our upsert `TrailerPosition` mutation. */
export type UpsertTrailerPositionPayloadTrailerPositionEdgeArgs = {
  orderBy?: InputMaybe<Array<TrailerPositionsOrderBy>>;
};

/** Where conditions for the upsert `TrailerPosition` mutation. */
export type UpsertTrailerPositionWhere = {
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

/** Where conditions for the upsert `Trailer` mutation. */
export type UpsertTrailerWhere = {
  carrierCode?: InputMaybe<Scalars['String']['input']>;
  carrierTrailerNumber?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** All input for the `upsertUrjanetUtilityProvider` mutation. */
export type UpsertUrjanetUtilityProviderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  urjanetSlug: Scalars['String']['input'];
};

/** The output of our `upsertUrjanetUtilityProvider` mutation. */
export type UpsertUrjanetUtilityProviderPayload = {
  __typename?: 'UpsertUrjanetUtilityProviderPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  recordId?: Maybe<Scalars['Int']['output']>;
};

/** All input for the upsert `UtilityAccount` mutation. */
export type UpsertUtilityAccountInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `UtilityAccount` to be upserted by this mutation. */
  utilityAccount: UtilityAccountInput;
};

/** The output of our upsert `UtilityAccount` mutation. */
export type UpsertUtilityAccountPayload = {
  __typename?: 'UpsertUtilityAccountPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UtilityAccount` that was upserted by this mutation. */
  utilityAccount?: Maybe<UtilityAccount>;
  /** An edge for our `UtilityAccount`. May be used by Relay 1. */
  utilityAccountEdge?: Maybe<UtilityAccountsEdge>;
  /** Reads a single `UtilityCredential` that is related to this `UtilityAccount`. */
  utilityCredential?: Maybe<UtilityCredential>;
  /** Reads a single `UtilityProvider` that is related to this `UtilityAccount`. */
  utilityProvider?: Maybe<UtilityProvider>;
};

/** The output of our upsert `UtilityAccount` mutation. */
export type UpsertUtilityAccountPayloadUtilityAccountEdgeArgs = {
  orderBy?: InputMaybe<Array<UtilityAccountsOrderBy>>;
};

/** Where conditions for the upsert `UtilityAccount` mutation. */
export type UpsertUtilityAccountWhere = {
  id?: InputMaybe<Scalars['Int']['input']>;
  integration?: InputMaybe<UtilityIntegration>;
  integrationAccountKey?: InputMaybe<Scalars['String']['input']>;
};

/** All input for the upsert `UtilityCredentialFacility` mutation. */
export type UpsertUtilityCredentialFacilityInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `UtilityCredentialFacility` to be upserted by this mutation. */
  utilityCredentialFacility: UtilityCredentialFacilityInput;
};

/** The output of our upsert `UtilityCredentialFacility` mutation. */
export type UpsertUtilityCredentialFacilityPayload = {
  __typename?: 'UpsertUtilityCredentialFacilityPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Facility` that is related to this `UtilityCredentialFacility`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `UtilityCredential` that is related to this `UtilityCredentialFacility`. */
  utilityCredential?: Maybe<UtilityCredential>;
  /** The `UtilityCredentialFacility` that was upserted by this mutation. */
  utilityCredentialFacility?: Maybe<UtilityCredentialFacility>;
  /** An edge for our `UtilityCredentialFacility`. May be used by Relay 1. */
  utilityCredentialFacilityEdge?: Maybe<UtilityCredentialFacilitiesEdge>;
};

/** The output of our upsert `UtilityCredentialFacility` mutation. */
export type UpsertUtilityCredentialFacilityPayloadUtilityCredentialFacilityEdgeArgs =
  {
    orderBy?: InputMaybe<Array<UtilityCredentialFacilitiesOrderBy>>;
  };

/** Where conditions for the upsert `UtilityCredentialFacility` mutation. */
export type UpsertUtilityCredentialFacilityWhere = {
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  utilityCredentialId?: InputMaybe<Scalars['Int']['input']>;
};

/** All input for the upsert `UtilityCredential` mutation. */
export type UpsertUtilityCredentialInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `UtilityCredential` to be upserted by this mutation. */
  utilityCredential: UtilityCredentialInput;
};

/** The output of our upsert `UtilityCredential` mutation. */
export type UpsertUtilityCredentialPayload = {
  __typename?: 'UpsertUtilityCredentialPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UtilityCredential` that was upserted by this mutation. */
  utilityCredential?: Maybe<UtilityCredential>;
  /** An edge for our `UtilityCredential`. May be used by Relay 1. */
  utilityCredentialEdge?: Maybe<UtilityCredentialsEdge>;
  /** Reads a single `UtilityProvider` that is related to this `UtilityCredential`. */
  utilityProvider?: Maybe<UtilityProvider>;
};

/** The output of our upsert `UtilityCredential` mutation. */
export type UpsertUtilityCredentialPayloadUtilityCredentialEdgeArgs = {
  orderBy?: InputMaybe<Array<UtilityCredentialsOrderBy>>;
};

/** Where conditions for the upsert `UtilityCredential` mutation. */
export type UpsertUtilityCredentialWhere = {
  id?: InputMaybe<Scalars['Int']['input']>;
  integration?: InputMaybe<UtilityIntegration>;
  integrationKey?: InputMaybe<Scalars['String']['input']>;
};

/** All input for the upsert `UtilityFileUpload` mutation. */
export type UpsertUtilityFileUploadInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `UtilityFileUpload` to be upserted by this mutation. */
  utilityFileUpload: UtilityFileUploadInput;
};

/** The output of our upsert `UtilityFileUpload` mutation. */
export type UpsertUtilityFileUploadPayload = {
  __typename?: 'UpsertUtilityFileUploadPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UtilityFileUpload` that was upserted by this mutation. */
  utilityFileUpload?: Maybe<UtilityFileUpload>;
  /** An edge for our `UtilityFileUpload`. May be used by Relay 1. */
  utilityFileUploadEdge?: Maybe<UtilityFileUploadsEdge>;
};

/** The output of our upsert `UtilityFileUpload` mutation. */
export type UpsertUtilityFileUploadPayloadUtilityFileUploadEdgeArgs = {
  orderBy?: InputMaybe<Array<UtilityFileUploadsOrderBy>>;
};

/** Where conditions for the upsert `UtilityFileUpload` mutation. */
export type UpsertUtilityFileUploadWhere = {
  id?: InputMaybe<Scalars['Int']['input']>;
  integration?: InputMaybe<UtilityIntegration>;
  integrationKey?: InputMaybe<Scalars['String']['input']>;
};

/** All input for the upsert `UtilityMeter` mutation. */
export type UpsertUtilityMeterInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `UtilityMeter` to be upserted by this mutation. */
  utilityMeter: UtilityMeterInput;
};

/** The output of our upsert `UtilityMeter` mutation. */
export type UpsertUtilityMeterPayload = {
  __typename?: 'UpsertUtilityMeterPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Facility` that is related to this `UtilityMeter`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `UtilityAccount` that is related to this `UtilityMeter`. */
  utilityAccount?: Maybe<UtilityAccount>;
  /** The `UtilityMeter` that was upserted by this mutation. */
  utilityMeter?: Maybe<UtilityMeter>;
  /** An edge for our `UtilityMeter`. May be used by Relay 1. */
  utilityMeterEdge?: Maybe<UtilityMetersEdge>;
};

/** The output of our upsert `UtilityMeter` mutation. */
export type UpsertUtilityMeterPayloadUtilityMeterEdgeArgs = {
  orderBy?: InputMaybe<Array<UtilityMetersOrderBy>>;
};

/** Where conditions for the upsert `UtilityMeter` mutation. */
export type UpsertUtilityMeterWhere = {
  id?: InputMaybe<Scalars['Int']['input']>;
  integrationMeterKey?: InputMaybe<Scalars['String']['input']>;
  serviceType?: InputMaybe<UtilityMeterServiceType>;
  utilityAccountId?: InputMaybe<Scalars['Int']['input']>;
};

/** All input for the upsert `UtilityPendingMeter` mutation. */
export type UpsertUtilityPendingMeterInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `UtilityPendingMeter` to be upserted by this mutation. */
  utilityPendingMeter: UtilityPendingMeterInput;
};

/** The output of our upsert `UtilityPendingMeter` mutation. */
export type UpsertUtilityPendingMeterPayload = {
  __typename?: 'UpsertUtilityPendingMeterPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Facility` that is related to this `UtilityPendingMeter`. */
  facility?: Maybe<Facility>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `UtilityCredential` that is related to this `UtilityPendingMeter`. */
  utilityCredential?: Maybe<UtilityCredential>;
  /** The `UtilityPendingMeter` that was upserted by this mutation. */
  utilityPendingMeter?: Maybe<UtilityPendingMeter>;
  /** An edge for our `UtilityPendingMeter`. May be used by Relay 1. */
  utilityPendingMeterEdge?: Maybe<UtilityPendingMetersEdge>;
};

/** The output of our upsert `UtilityPendingMeter` mutation. */
export type UpsertUtilityPendingMeterPayloadUtilityPendingMeterEdgeArgs = {
  orderBy?: InputMaybe<Array<UtilityPendingMetersOrderBy>>;
};

/** Where conditions for the upsert `UtilityPendingMeter` mutation. */
export type UpsertUtilityPendingMeterWhere = {
  id?: InputMaybe<Scalars['Int']['input']>;
  integration?: InputMaybe<UtilityIntegration>;
  integrationKey?: InputMaybe<Scalars['String']['input']>;
};

/** All input for the upsert `UtilityProvider` mutation. */
export type UpsertUtilityProviderInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `UtilityProvider` to be upserted by this mutation. */
  utilityProvider: UtilityProviderInput;
};

/** The output of our upsert `UtilityProvider` mutation. */
export type UpsertUtilityProviderPayload = {
  __typename?: 'UpsertUtilityProviderPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UtilityProvider` that was upserted by this mutation. */
  utilityProvider?: Maybe<UtilityProvider>;
  /** An edge for our `UtilityProvider`. May be used by Relay 1. */
  utilityProviderEdge?: Maybe<UtilityProvidersEdge>;
};

/** The output of our upsert `UtilityProvider` mutation. */
export type UpsertUtilityProviderPayloadUtilityProviderEdgeArgs = {
  orderBy?: InputMaybe<Array<UtilityProvidersOrderBy>>;
};

/** Where conditions for the upsert `UtilityProvider` mutation. */
export type UpsertUtilityProviderWhere = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** All input for the upsert `VendorUserMachineUser` mutation. */
export type UpsertVendorUserMachineUserInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `VendorUserMachineUser` to be upserted by this mutation. */
  vendorUserMachineUser: VendorUserMachineUserInput;
};

/** The output of our upsert `VendorUserMachineUser` mutation. */
export type UpsertVendorUserMachineUserPayload = {
  __typename?: 'UpsertVendorUserMachineUserPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `VendorUserMachineUser` that was upserted by this mutation. */
  vendorUserMachineUser?: Maybe<VendorUserMachineUser>;
};

/** Where conditions for the upsert `VendorUserMachineUser` mutation. */
export type UpsertVendorUserMachineUserWhere = {
  machineUserId?: InputMaybe<Scalars['BigInt']['input']>;
  vendorUserId?: InputMaybe<Scalars['Int']['input']>;
};

/** All input for the upsert `Vessel` mutation. */
export type UpsertVesselInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Vessel` to be upserted by this mutation. */
  vessel: VesselInput;
};

/** The output of our upsert `Vessel` mutation. */
export type UpsertVesselPayload = {
  __typename?: 'UpsertVesselPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DataPoint` that is related to this `Vessel`. */
  level?: Maybe<DataPoint>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RefrigerationSystem` that is related to this `Vessel`. */
  refrigerationSystem?: Maybe<RefrigerationSystem>;
  /** Reads a single `SuctionGroup` that is related to this `Vessel`. */
  suctionGroup?: Maybe<SuctionGroup>;
  /** The `Vessel` that was upserted by this mutation. */
  vessel?: Maybe<Vessel>;
  /** An edge for our `Vessel`. May be used by Relay 1. */
  vesselEdge?: Maybe<VesselsEdge>;
};

/** The output of our upsert `Vessel` mutation. */
export type UpsertVesselPayloadVesselEdgeArgs = {
  orderBy?: InputMaybe<Array<VesselsOrderBy>>;
};

/** Where conditions for the upsert `Vessel` mutation. */
export type UpsertVesselWhere = {
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  refrigerationSystemId?: InputMaybe<Scalars['Int']['input']>;
};

/** All input for the upsert `VirtualPointInterval` mutation. */
export type UpsertVirtualPointIntervalInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `VirtualPointInterval` to be upserted by this mutation. */
  virtualPointInterval: VirtualPointIntervalInput;
};

/** The output of our upsert `VirtualPointInterval` mutation. */
export type UpsertVirtualPointIntervalPayload = {
  __typename?: 'UpsertVirtualPointIntervalPayload';
  /** Reads a single `DataPoint` that is related to this `VirtualPointInterval`. */
  child?: Maybe<DataPoint>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `DataPoint` that is related to this `VirtualPointInterval`. */
  parent?: Maybe<DataPoint>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `VirtualPointInterval` that was upserted by this mutation. */
  virtualPointInterval?: Maybe<VirtualPointInterval>;
  /** An edge for our `VirtualPointInterval`. May be used by Relay 1. */
  virtualPointIntervalEdge?: Maybe<VirtualPointIntervalsEdge>;
};

/** The output of our upsert `VirtualPointInterval` mutation. */
export type UpsertVirtualPointIntervalPayloadVirtualPointIntervalEdgeArgs = {
  orderBy?: InputMaybe<Array<VirtualPointIntervalsOrderBy>>;
};

/** Where conditions for the upsert `VirtualPointInterval` mutation. */
export type UpsertVirtualPointIntervalWhere = {
  childId?: InputMaybe<Scalars['BigInt']['input']>;
  parentId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A user. */
export type User = Node & {
  __typename?: 'User';
  /** Returns the user`s access tokens. */
  accessTokens: PlatformAccessTokensConnection;
  /** The time the user was created. */
  createdAt: Scalars['Datetime']['output'];
  /** The user’s email address. */
  email?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `FacilityCheckUser`. */
  facilityCheckUsers: FacilityCheckUsersConnection;
  /** Returns the facilities that the user has favorited. */
  favoriteFacilities: FacilitiesConnection;
  /** The user’s first name. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** The primary unique identifier of the user. */
  id: Scalars['String']['output'];
  /** The user’s last name. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `MonitorEnabledUserSubscription`. */
  monitorEnabledUserSubscriptions: MonitorEnabledUserSubscriptionsConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Available permissions for the User. */
  permissions?: Maybe<UserPermissions>;
  /** The user’s phone number. */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneNumberValidated: Scalars['Boolean']['output'];
  preferredLocale?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `ProjectEnabledUserSubscription`. */
  projectEnabledUserSubscriptions: ProjectEnabledUserSubscriptionsConnection;
  /** Reads and enables pagination through a set of `ProjectWatcher`. */
  projectWatchers: ProjectWatchersConnection;
  /** Reads and enables pagination through a set of `TrailerAudit`. */
  trailerAuditsByAuditUser: TrailerAuditsConnection;
  /** The time the user was updated . */
  updatedAt: Scalars['Datetime']['output'];
  /** Reads and enables pagination through a set of `Project`. */
  watchedProjects: ProjectsConnection;
};

/** A user. */
export type UserAccessTokensArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<PlatformAccessTokenFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** A user. */
export type UserFacilityCheckUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FacilityCheckUserCondition>;
  filter?: InputMaybe<FacilityCheckUserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FacilityCheckUsersOrderBy>>;
};

/** A user. */
export type UserFavoriteFacilitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<FacilityFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** A user. */
export type UserMonitorEnabledUserSubscriptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MonitorEnabledUserSubscriptionCondition>;
  filter?: InputMaybe<MonitorEnabledUserSubscriptionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MonitorEnabledUserSubscriptionsOrderBy>>;
};

/** A user. */
export type UserProjectEnabledUserSubscriptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProjectEnabledUserSubscriptionCondition>;
  filter?: InputMaybe<ProjectEnabledUserSubscriptionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProjectEnabledUserSubscriptionsOrderBy>>;
};

/** A user. */
export type UserProjectWatchersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProjectWatcherCondition>;
  filter?: InputMaybe<ProjectWatcherFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProjectWatchersOrderBy>>;
};

/** A user. */
export type UserTrailerAuditsByAuditUserArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TrailerAuditCondition>;
  filter?: InputMaybe<TrailerAuditFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TrailerAuditsOrderBy>>;
};

/** A user. */
export type UserWatchedProjectsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<ProjectFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** A condition to be used against `User` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type UserCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `email` field. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `firstName` field. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `lastName` field. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `phoneNumber` field. */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `phoneNumberValidated` field. */
  phoneNumberValidated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `preferredLocale` field. */
  preferredLocale?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `User` object types. All fields are combined with a logical ‘and.’ */
export type UserFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserFilter>>;
  /** Filter by the permission canEdit */
  canEdit?: InputMaybe<PermissionBooleanFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `email` field. */
  email?: InputMaybe<StringFilter>;
  /** Filter by the object’s `firstName` field. */
  firstName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Filter by the object’s `lastName` field. */
  lastName?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserFilter>>;
  /** Filter by the object’s `phoneNumber` field. */
  phoneNumber?: InputMaybe<StringFilter>;
  /** Filter by the object’s `phoneNumberValidated` field. */
  phoneNumberValidated?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `preferredLocale` field. */
  preferredLocale?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

export type UserIdentity = Identity & {
  __typename?: 'UserIdentity';
  authorizationType: Scalars['String']['output'];
  id: Scalars['String']['output'];
  signature: Scalars['String']['output'];
  type: AccessTokenType;
  user: User;
};

/** Represents an update to a `User`. Fields that are set will be updated. */
export type UserPatch = {
  phoneNumberValidated?: InputMaybe<Scalars['Boolean']['input']>;
  preferredLocale?: InputMaybe<Scalars['String']['input']>;
};

/** Permissive capabilities on a User. */
export type UserPermissions = {
  __typename?: 'UserPermissions';
  /** Whether a user can edit the settings of a user. */
  canEdit: Scalars['Boolean']['output'];
};

/** A user subscription for a specific event type and action. */
export type UserSubscription = Node & {
  __typename?: 'UserSubscription';
  /** The associated action. */
  action?: Maybe<Scalars['String']['output']>;
  channels: Scalars['JSON']['output'];
  /** The time the subscription was created. */
  createdAt: Scalars['Datetime']['output'];
  /** Reads a single `EventType` that is related to this `UserSubscription`. */
  eventTypeByType?: Maybe<EventType>;
  /** The identifier of the subscription. */
  id: Scalars['BigInt']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  scope: Scalars['JSON']['output'];
  /** The type of event. */
  type: Scalars['String']['output'];
  /** The time the subscription was updated. */
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `UserSubscription`. */
  user?: Maybe<User>;
  /** The associated User. */
  userId: Scalars['String']['output'];
};

export enum UserSubscriptionChannel {
  EMAIL = 'EMAIL',
  SMS = 'SMS',
  SMS_AI = 'SMS_AI'
}

/** A filter to be used against UserSubscriptionChannel List fields. All fields are combined with a logical ‘and.’ */
export type UserSubscriptionChannelListFilter = {
  /** Any array item is equal to the specified value. */
  anyEqualTo?: InputMaybe<UserSubscriptionChannel>;
  /** Any array item is greater than the specified value. */
  anyGreaterThan?: InputMaybe<UserSubscriptionChannel>;
  /** Any array item is greater than or equal to the specified value. */
  anyGreaterThanOrEqualTo?: InputMaybe<UserSubscriptionChannel>;
  /** Any array item is less than the specified value. */
  anyLessThan?: InputMaybe<UserSubscriptionChannel>;
  /** Any array item is less than or equal to the specified value. */
  anyLessThanOrEqualTo?: InputMaybe<UserSubscriptionChannel>;
  /** Any array item is not equal to the specified value. */
  anyNotEqualTo?: InputMaybe<UserSubscriptionChannel>;
  /** Contained by the specified list of values. */
  containedBy?: InputMaybe<Array<InputMaybe<UserSubscriptionChannel>>>;
  /** Contains the specified list of values. */
  contains?: InputMaybe<Array<InputMaybe<UserSubscriptionChannel>>>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Array<InputMaybe<UserSubscriptionChannel>>>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Array<InputMaybe<UserSubscriptionChannel>>>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Array<InputMaybe<UserSubscriptionChannel>>>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Array<InputMaybe<UserSubscriptionChannel>>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Array<InputMaybe<UserSubscriptionChannel>>>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Array<InputMaybe<UserSubscriptionChannel>>>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Array<InputMaybe<UserSubscriptionChannel>>>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Array<InputMaybe<UserSubscriptionChannel>>>;
  /** Overlaps the specified list of values. */
  overlaps?: InputMaybe<Array<InputMaybe<UserSubscriptionChannel>>>;
};

/** A filter to be used against `UserSubscription` object types. All fields are combined with a logical ‘and.’ */
export type UserSubscriptionFilter = {
  /** Filter by the object’s `action` field. */
  action?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserSubscriptionFilter>>;
  /** Filter by the object’s `channels` field. */
  channels?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserSubscriptionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserSubscriptionFilter>>;
  /** Filter by the object’s `scope` field. */
  scope?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<StringFilter>;
};

/** A connection to a list of `UserSubscription` values. */
export type UserSubscriptionsConnection = {
  __typename?: 'UserSubscriptionsConnection';
  /** A list of edges which contains the `UserSubscription` and cursor to aid in pagination. */
  edges: Array<UserSubscriptionsEdge>;
  /** A list of `UserSubscription` objects. */
  nodes: Array<UserSubscription>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserSubscription` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `UserSubscription` edge in the connection. */
export type UserSubscriptionsEdge = {
  __typename?: 'UserSubscriptionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UserSubscription` at the end of the edge. */
  node: UserSubscription;
};

/** A connection to a list of `User` values. */
export type UsersConnection = {
  __typename?: 'UsersConnection';
  /** A list of edges which contains the `User` and cursor to aid in pagination. */
  edges: Array<UsersEdge>;
  /** A list of `User` objects. */
  nodes: Array<User>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `User` edge in the connection. */
export type UsersEdge = {
  __typename?: 'UsersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `User` at the end of the edge. */
  node: User;
};

/** Methods to use when ordering `User`. */
export enum UsersOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  EMAIL_ASC = 'EMAIL_ASC',
  EMAIL_DESC = 'EMAIL_DESC',
  FIRST_NAME_ASC = 'FIRST_NAME_ASC',
  FIRST_NAME_DESC = 'FIRST_NAME_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LAST_NAME_ASC = 'LAST_NAME_ASC',
  LAST_NAME_DESC = 'LAST_NAME_DESC',
  NATURAL = 'NATURAL',
  PHONE_NUMBER_ASC = 'PHONE_NUMBER_ASC',
  PHONE_NUMBER_DESC = 'PHONE_NUMBER_DESC',
  PHONE_NUMBER_VALIDATED_ASC = 'PHONE_NUMBER_VALIDATED_ASC',
  PHONE_NUMBER_VALIDATED_DESC = 'PHONE_NUMBER_VALIDATED_DESC',
  PREFERRED_LOCALE_ASC = 'PREFERRED_LOCALE_ASC',
  PREFERRED_LOCALE_DESC = 'PREFERRED_LOCALE_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** A utility account. */
export type UtilityAccount = Node & {
  __typename?: 'UtilityAccount';
  /** The account’s number. */
  accountNumber: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `AccountStatement`. */
  accountStatements: AccountStatementsConnection;
  /** The time the account was created. */
  createdAt: Scalars['Datetime']['output'];
  /** The time the account was deleted. */
  deletedAt?: Maybe<Scalars['Datetime']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `FacilityUtilityAccount`. */
  facilityUtilityAccounts: FacilityUtilityAccountsConnection;
  /** The primary unique identifier of the account. */
  id: Scalars['Int']['output'];
  /** The integration that owns the account. */
  integration: UtilityIntegration;
  /** The identifier in the integration’s system. */
  integrationAccountKey: Scalars['String']['output'];
  /** Returns the integration attribute of the last statement (by statement_year, statement_month) for this account */
  lastStatementIntegration?: Maybe<UtilityIntegration>;
  /** Extra metadata about the account. */
  metadata: Scalars['JSON']['output'];
  /**
   * Returns a set of year/month combinations that are missing as statements across all meters for a given account. Also provides a list of `UtilityMeters` that correspond to the missing bills for each year/month combiantion.
   * @deprecated true
   */
  missingStatements: AccountMissingStatementsConnection;
  /** The account’s name. */
  name?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The time the account was updated. */
  updatedAt: Scalars['Datetime']['output'];
  /** Reads and enables pagination through a set of `UtilityAccountStatementRollup`. */
  utilityAccountStatementRollups: UtilityAccountStatementRollupsConnection;
  /** Reads and enables pagination through a set of `UtilityAccountStatement`. */
  utilityAccountStatements: UtilityAccountStatementsConnection;
  /** Reads a single `UtilityCredential` that is related to this `UtilityAccount`. */
  utilityCredential?: Maybe<UtilityCredential>;
  /** The credential this account was discovered on. */
  utilityCredentialId?: Maybe<Scalars['Int']['output']>;
  /** Reads and enables pagination through a set of `UtilityMeterStatementRollup`. */
  utilityMeterStatementRollups: UtilityMeterStatementRollupsConnection;
  /** Reads and enables pagination through a set of `UtilityMeterStatement`. */
  utilityMeterStatements: UtilityMeterStatementsConnection;
  /** Reads and enables pagination through a set of `UtilityMeter`. */
  utilityMeters: UtilityMetersConnection;
  /** Reads a single `UtilityProvider` that is related to this `UtilityAccount`. */
  utilityProvider?: Maybe<UtilityProvider>;
  /** The account’s provider. */
  utilityProviderId: Scalars['Int']['output'];
};

/** A utility account. */
export type UtilityAccountAccountStatementsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AccountStatementCondition>;
  filter?: InputMaybe<AccountStatementFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountStatementsOrderBy>>;
};

/** A utility account. */
export type UtilityAccountFacilityUtilityAccountsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FacilityUtilityAccountCondition>;
  filter?: InputMaybe<FacilityUtilityAccountFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FacilityUtilityAccountsOrderBy>>;
};

/** A utility account. */
export type UtilityAccountMissingStatementsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<AccountMissingStatementFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** A utility account. */
export type UtilityAccountUtilityAccountStatementRollupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UtilityAccountStatementRollupCondition>;
  filter?: InputMaybe<UtilityAccountStatementRollupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UtilityAccountStatementRollupsOrderBy>>;
};

/** A utility account. */
export type UtilityAccountUtilityAccountStatementsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UtilityAccountStatementCondition>;
  filter?: InputMaybe<UtilityAccountStatementFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UtilityAccountStatementsOrderBy>>;
};

/** A utility account. */
export type UtilityAccountUtilityMeterStatementRollupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UtilityMeterStatementRollupCondition>;
  filter?: InputMaybe<UtilityMeterStatementRollupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UtilityMeterStatementRollupsOrderBy>>;
};

/** A utility account. */
export type UtilityAccountUtilityMeterStatementsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UtilityMeterStatementCondition>;
  filter?: InputMaybe<UtilityMeterStatementFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UtilityMeterStatementsOrderBy>>;
};

/** A utility account. */
export type UtilityAccountUtilityMetersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UtilityMeterCondition>;
  filter?: InputMaybe<UtilityMeterFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UtilityMetersOrderBy>>;
};

export enum UtilityAccountChargeCategory {
  CREDITS = 'CREDITS',
  DEMAND = 'DEMAND',
  FEES = 'FEES',
  TAXES = 'TAXES',
  USAGE = 'USAGE'
}

/** A filter to be used against UtilityAccountChargeCategory fields. All fields are combined with a logical ‘and.’ */
export type UtilityAccountChargeCategoryFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<UtilityAccountChargeCategory>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<UtilityAccountChargeCategory>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<UtilityAccountChargeCategory>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<UtilityAccountChargeCategory>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<UtilityAccountChargeCategory>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<UtilityAccountChargeCategory>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<UtilityAccountChargeCategory>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<UtilityAccountChargeCategory>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<UtilityAccountChargeCategory>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<UtilityAccountChargeCategory>>;
};

/**
 * A condition to be used against `UtilityAccount` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type UtilityAccountCondition = {
  /** Checks for equality with the object’s `accountNumber` field. */
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `integration` field. */
  integration?: InputMaybe<UtilityIntegration>;
  /** Checks for equality with the object’s `integrationAccountKey` field. */
  integrationAccountKey?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `metadata` field. */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `utilityCredentialId` field. */
  utilityCredentialId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `utilityProviderId` field. */
  utilityProviderId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `UtilityAccount` object types. All fields are combined with a logical ‘and.’ */
export type UtilityAccountFilter = {
  /** Filter by the object’s `accountNumber` field. */
  accountNumber?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UtilityAccountFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `displayName` field. */
  displayName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `integration` field. */
  integration?: InputMaybe<UtilityIntegrationFilter>;
  /** Filter by the object’s `integrationAccountKey` field. */
  integrationAccountKey?: InputMaybe<StringFilter>;
  /** Filter by the object’s `lastStatementIntegration` field. */
  lastStatementIntegration?: InputMaybe<UtilityIntegrationFilter>;
  /** Filter by the object’s `metadata` field. */
  metadata?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UtilityAccountFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UtilityAccountFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `utilityCredentialId` field. */
  utilityCredentialId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `utilityProviderId` field. */
  utilityProviderId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `UtilityAccount` */
export type UtilityAccountInput = {
  /** The account’s number. */
  accountNumber: Scalars['String']['input'];
  /** The primary unique identifier of the account. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** The integration that owns the account. */
  integration: UtilityIntegration;
  /** The identifier in the integration’s system. */
  integrationAccountKey?: InputMaybe<Scalars['String']['input']>;
  /** Extra metadata about the account. */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** The account’s name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Mutates a `UtilityCredential` as part of the payload */
  utilityCredential?: InputMaybe<UtilityCredentialInput>;
  /** The credential this account was discovered on. */
  utilityCredentialId?: InputMaybe<Scalars['Int']['input']>;
  /** Mutates a `UtilityProvider` as part of the payload */
  utilityProvider?: InputMaybe<UtilityProviderInput>;
  /** The account’s provider. */
  utilityProviderId?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents an update to a `UtilityAccount`. Fields that are set will be updated. */
export type UtilityAccountPatch = {
  /** Extra metadata about the account. */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** The account’s name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The account’s provider. */
  utilityProviderId?: InputMaybe<Scalars['Int']['input']>;
};

export type UtilityAccountStatement = Node & {
  __typename?: 'UtilityAccountStatement';
  accountLabel?: Maybe<Scalars['String']['output']>;
  /** Reads a single `AccountStatement` that is related to this `UtilityAccountStatement`. */
  accountStatement?: Maybe<AccountStatement>;
  accountStatementId: Scalars['Int']['output'];
  billArrivalDate?: Maybe<Scalars['Datetime']['output']>;
  /** Returns the total charges of a given utility_account_statements (view) row. */
  billCost?: Maybe<Scalars['Float']['output']>;
  /** Returns the total credits of a given utility_account_statements (view) row. */
  credits?: Maybe<Scalars['Float']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  /** Returns the total fee charges of a given utility_account_statements (view) row. */
  fees?: Maybe<Scalars['Float']['output']>;
  intervalEnd?: Maybe<Scalars['Date']['output']>;
  intervalStart?: Maybe<Scalars['Date']['output']>;
  isValidated?: Maybe<Scalars['Boolean']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  provider?: Maybe<Scalars['String']['output']>;
  serviceTypes?: Maybe<Array<Maybe<UtilityMeterServiceType>>>;
  statementMonth?: Maybe<Scalars['Int']['output']>;
  statementYear?: Maybe<Scalars['Int']['output']>;
  /** Returns the total tax charges of a given utility_account_statements (view) row. */
  taxes?: Maybe<Scalars['Float']['output']>;
  /** Reads a single `UtilityAccount` that is related to this `UtilityAccountStatement`. */
  utilityAccount?: Maybe<UtilityAccount>;
  utilityAccountId?: Maybe<Scalars['Int']['output']>;
};

export type UtilityAccountStatementAggregates = {
  __typename?: 'UtilityAccountStatementAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<UtilityAccountStatementAverageAggregates>;
  /** Distinct aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinct?: Maybe<UtilityAccountStatementDistinctAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<UtilityAccountStatementDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<UtilityAccountStatementMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<UtilityAccountStatementMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<UtilityAccountStatementStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<UtilityAccountStatementStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<UtilityAccountStatementSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<UtilityAccountStatementVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<UtilityAccountStatementVarianceSampleAggregates>;
};

export type UtilityAccountStatementAverageAggregates = {
  __typename?: 'UtilityAccountStatementAverageAggregates';
  /** Mean average of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['BigFloat']['output']>;
  /**
   * Mean average of this field across the matching connection.
   *
   * ---
   *
   * Returns the total charges of a given utility_account_statements (view) row.
   */
  billCost?: Maybe<Scalars['Float']['output']>;
  /**
   * Mean average of this field across the matching connection.
   *
   * ---
   *
   * Returns the total credits of a given utility_account_statements (view) row.
   */
  credits?: Maybe<Scalars['Float']['output']>;
  /**
   * Mean average of this field across the matching connection.
   *
   * ---
   *
   * Returns the total fee charges of a given utility_account_statements (view) row.
   */
  fees?: Maybe<Scalars['Float']['output']>;
  /** Mean average of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['BigFloat']['output']>;
  /**
   * Mean average of this field across the matching connection.
   *
   * ---
   *
   * Returns the total tax charges of a given utility_account_statements (view) row.
   */
  taxes?: Maybe<Scalars['Float']['output']>;
  /** Mean average of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `UtilityAccountStatement` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type UtilityAccountStatementCondition = {
  /** Checks for equality with the object’s `accountLabel` field. */
  accountLabel?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `accountStatementId` field. */
  accountStatementId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `billArrivalDate` field. */
  billArrivalDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `currencyCode` field. */
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `intervalEnd` field. */
  intervalEnd?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `intervalStart` field. */
  intervalStart?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `isValidated` field. */
  isValidated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `provider` field. */
  provider?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `statementMonth` field. */
  statementMonth?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `statementYear` field. */
  statementYear?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `utilityAccountId` field. */
  utilityAccountId?: InputMaybe<Scalars['Int']['input']>;
};

export type UtilityAccountStatementDistinctAggregates = {
  __typename?: 'UtilityAccountStatementDistinctAggregates';
  /** Distinct of accountLabel across the matching connection */
  accountLabel?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Distinct of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Distinct of billArrivalDate across the matching connection */
  billArrivalDate?: Maybe<Scalars['JSON']['output']>;
  /**
   * Distinct of this field across the matching connection.
   *
   * ---
   *
   * Returns the total charges of a given utility_account_statements (view) row.
   */
  billCost?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /**
   * Distinct of this field across the matching connection.
   *
   * ---
   *
   * Returns the total credits of a given utility_account_statements (view) row.
   */
  credits?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Distinct of currencyCode across the matching connection */
  currencyCode?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /**
   * Distinct of this field across the matching connection.
   *
   * ---
   *
   * Returns the total fee charges of a given utility_account_statements (view) row.
   */
  fees?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Distinct of intervalEnd across the matching connection */
  intervalEnd?: Maybe<Scalars['JSON']['output']>;
  /** Distinct of intervalStart across the matching connection */
  intervalStart?: Maybe<Scalars['JSON']['output']>;
  /** Distinct of isValidated across the matching connection */
  isValidated?: Maybe<Scalars['JSON']['output']>;
  /** Distinct of provider across the matching connection */
  provider?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Distinct of this field across the matching connection. */
  serviceTypes?: Maybe<Scalars['JSON']['output']>;
  /** Distinct of statementMonth across the matching connection */
  statementMonth?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Distinct of statementYear across the matching connection */
  statementYear?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /**
   * Distinct of this field across the matching connection.
   *
   * ---
   *
   * Returns the total tax charges of a given utility_account_statements (view) row.
   */
  taxes?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Distinct of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type UtilityAccountStatementDistinctCountAggregates = {
  __typename?: 'UtilityAccountStatementDistinctCountAggregates';
  /** Distinct count of accountLabel across the matching connection */
  accountLabel?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of billArrivalDate across the matching connection */
  billArrivalDate?: Maybe<Scalars['BigInt']['output']>;
  /**
   * Distinct count of this field across the matching connection.
   *
   * ---
   *
   * Returns the total charges of a given utility_account_statements (view) row.
   */
  billCost?: Maybe<Scalars['BigInt']['output']>;
  /**
   * Distinct count of this field across the matching connection.
   *
   * ---
   *
   * Returns the total credits of a given utility_account_statements (view) row.
   */
  credits?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of currencyCode across the matching connection */
  currencyCode?: Maybe<Scalars['BigInt']['output']>;
  /**
   * Distinct count of this field across the matching connection.
   *
   * ---
   *
   * Returns the total fee charges of a given utility_account_statements (view) row.
   */
  fees?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of intervalEnd across the matching connection */
  intervalEnd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of intervalStart across the matching connection */
  intervalStart?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of isValidated across the matching connection */
  isValidated?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of provider across the matching connection */
  provider?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of this field across the matching connection. */
  serviceTypes?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['BigInt']['output']>;
  /**
   * Distinct count of this field across the matching connection.
   *
   * ---
   *
   * Returns the total tax charges of a given utility_account_statements (view) row.
   */
  taxes?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `UtilityAccountStatement` object types. All fields are combined with a logical ‘and.’ */
export type UtilityAccountStatementFilter = {
  /** Filter by the object’s `accountLabel` field. */
  accountLabel?: InputMaybe<StringFilter>;
  /** Filter by the object’s `accountStatementId` field. */
  accountStatementId?: InputMaybe<IntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UtilityAccountStatementFilter>>;
  /** Filter by the object’s `billArrivalDate` field. */
  billArrivalDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `billCost` field. */
  billCost?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `credits` field. */
  credits?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `currencyCode` field. */
  currencyCode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `fees` field. */
  fees?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `intervalEnd` field. */
  intervalEnd?: InputMaybe<DateFilter>;
  /** Filter by the object’s `intervalStart` field. */
  intervalStart?: InputMaybe<DateFilter>;
  /** Filter by the object’s `isValidated` field. */
  isValidated?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UtilityAccountStatementFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UtilityAccountStatementFilter>>;
  /** Filter by the object’s `provider` field. */
  provider?: InputMaybe<StringFilter>;
  /** Filter by the object’s `serviceTypes` field. */
  serviceTypes?: InputMaybe<UtilityMeterServiceTypeListFilter>;
  /** Filter by the object’s `statementMonth` field. */
  statementMonth?: InputMaybe<IntFilter>;
  /** Filter by the object’s `statementYear` field. */
  statementYear?: InputMaybe<IntFilter>;
  /** Filter by the object’s `taxes` field. */
  taxes?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `utilityAccountId` field. */
  utilityAccountId?: InputMaybe<IntFilter>;
};

export type UtilityAccountStatementMaxAggregates = {
  __typename?: 'UtilityAccountStatementMaxAggregates';
  /** Maximum of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['Int']['output']>;
  /**
   * Maximum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total charges of a given utility_account_statements (view) row.
   */
  billCost?: Maybe<Scalars['Float']['output']>;
  /**
   * Maximum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total credits of a given utility_account_statements (view) row.
   */
  credits?: Maybe<Scalars['Float']['output']>;
  /**
   * Maximum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total fee charges of a given utility_account_statements (view) row.
   */
  fees?: Maybe<Scalars['Float']['output']>;
  /** Maximum of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['Int']['output']>;
  /** Maximum of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['Int']['output']>;
  /**
   * Maximum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total tax charges of a given utility_account_statements (view) row.
   */
  taxes?: Maybe<Scalars['Float']['output']>;
  /** Maximum of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['Int']['output']>;
};

export type UtilityAccountStatementMinAggregates = {
  __typename?: 'UtilityAccountStatementMinAggregates';
  /** Minimum of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['Int']['output']>;
  /**
   * Minimum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total charges of a given utility_account_statements (view) row.
   */
  billCost?: Maybe<Scalars['Float']['output']>;
  /**
   * Minimum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total credits of a given utility_account_statements (view) row.
   */
  credits?: Maybe<Scalars['Float']['output']>;
  /**
   * Minimum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total fee charges of a given utility_account_statements (view) row.
   */
  fees?: Maybe<Scalars['Float']['output']>;
  /** Minimum of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['Int']['output']>;
  /** Minimum of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['Int']['output']>;
  /**
   * Minimum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total tax charges of a given utility_account_statements (view) row.
   */
  taxes?: Maybe<Scalars['Float']['output']>;
  /** Minimum of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['Int']['output']>;
};

export type UtilityAccountStatementRollup = Node & {
  __typename?: 'UtilityAccountStatementRollup';
  accountLabel?: Maybe<Scalars['String']['output']>;
  /** Reads a single `AccountStatement` that is related to this `UtilityAccountStatementRollup`. */
  accountStatement?: Maybe<AccountStatement>;
  accountStatementId: Scalars['Int']['output'];
  billArrivalDate?: Maybe<Scalars['Datetime']['output']>;
  billCost?: Maybe<Scalars['Float']['output']>;
  billDemandCost?: Maybe<Scalars['Float']['output']>;
  billUsageCost?: Maybe<Scalars['Float']['output']>;
  credits?: Maybe<Scalars['Float']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  fees?: Maybe<Scalars['Float']['output']>;
  intervalEnd?: Maybe<Scalars['Date']['output']>;
  intervalStart?: Maybe<Scalars['Date']['output']>;
  isValidated?: Maybe<Scalars['Boolean']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  percentChange?: Maybe<Scalars['Float']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  serviceTypes?: Maybe<Array<Maybe<UtilityMeterServiceType>>>;
  statementMonth?: Maybe<Scalars['Int']['output']>;
  statementYear?: Maybe<Scalars['Int']['output']>;
  taxes?: Maybe<Scalars['Float']['output']>;
  /** Reads a single `UtilityAccount` that is related to this `UtilityAccountStatementRollup`. */
  utilityAccount?: Maybe<UtilityAccount>;
  utilityAccountId?: Maybe<Scalars['Int']['output']>;
};

export type UtilityAccountStatementRollupAggregates = {
  __typename?: 'UtilityAccountStatementRollupAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<UtilityAccountStatementRollupAverageAggregates>;
  /** Distinct aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinct?: Maybe<UtilityAccountStatementRollupDistinctAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<UtilityAccountStatementRollupDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<UtilityAccountStatementRollupMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<UtilityAccountStatementRollupMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<UtilityAccountStatementRollupStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<UtilityAccountStatementRollupStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<UtilityAccountStatementRollupSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<UtilityAccountStatementRollupVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<UtilityAccountStatementRollupVarianceSampleAggregates>;
};

export type UtilityAccountStatementRollupAverageAggregates = {
  __typename?: 'UtilityAccountStatementRollupAverageAggregates';
  /** Mean average of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of billCost across the matching connection */
  billCost?: Maybe<Scalars['Float']['output']>;
  /** Mean average of billDemandCost across the matching connection */
  billDemandCost?: Maybe<Scalars['Float']['output']>;
  /** Mean average of billUsageCost across the matching connection */
  billUsageCost?: Maybe<Scalars['Float']['output']>;
  /** Mean average of credits across the matching connection */
  credits?: Maybe<Scalars['Float']['output']>;
  /** Mean average of fees across the matching connection */
  fees?: Maybe<Scalars['Float']['output']>;
  /** Mean average of percentChange across the matching connection */
  percentChange?: Maybe<Scalars['Float']['output']>;
  /** Mean average of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of taxes across the matching connection */
  taxes?: Maybe<Scalars['Float']['output']>;
  /** Mean average of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `UtilityAccountStatementRollup` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type UtilityAccountStatementRollupCondition = {
  /** Checks for equality with the object’s `accountLabel` field. */
  accountLabel?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `accountStatementId` field. */
  accountStatementId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `billArrivalDate` field. */
  billArrivalDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `billCost` field. */
  billCost?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `billDemandCost` field. */
  billDemandCost?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `billUsageCost` field. */
  billUsageCost?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `credits` field. */
  credits?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `currencyCode` field. */
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `fees` field. */
  fees?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `intervalEnd` field. */
  intervalEnd?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `intervalStart` field. */
  intervalStart?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `isValidated` field. */
  isValidated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `percentChange` field. */
  percentChange?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `provider` field. */
  provider?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `statementMonth` field. */
  statementMonth?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `statementYear` field. */
  statementYear?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `taxes` field. */
  taxes?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `utilityAccountId` field. */
  utilityAccountId?: InputMaybe<Scalars['Int']['input']>;
};

export type UtilityAccountStatementRollupDistinctAggregates = {
  __typename?: 'UtilityAccountStatementRollupDistinctAggregates';
  /** Distinct of accountLabel across the matching connection */
  accountLabel?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Distinct of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Distinct of billArrivalDate across the matching connection */
  billArrivalDate?: Maybe<Scalars['JSON']['output']>;
  /** Distinct of billCost across the matching connection */
  billCost?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Distinct of billDemandCost across the matching connection */
  billDemandCost?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Distinct of billUsageCost across the matching connection */
  billUsageCost?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Distinct of credits across the matching connection */
  credits?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Distinct of currencyCode across the matching connection */
  currencyCode?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Distinct of fees across the matching connection */
  fees?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Distinct of intervalEnd across the matching connection */
  intervalEnd?: Maybe<Scalars['JSON']['output']>;
  /** Distinct of intervalStart across the matching connection */
  intervalStart?: Maybe<Scalars['JSON']['output']>;
  /** Distinct of isValidated across the matching connection */
  isValidated?: Maybe<Scalars['JSON']['output']>;
  /** Distinct of percentChange across the matching connection */
  percentChange?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Distinct of provider across the matching connection */
  provider?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Distinct of this field across the matching connection. */
  serviceTypes?: Maybe<Scalars['JSON']['output']>;
  /** Distinct of statementMonth across the matching connection */
  statementMonth?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Distinct of statementYear across the matching connection */
  statementYear?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Distinct of taxes across the matching connection */
  taxes?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Distinct of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type UtilityAccountStatementRollupDistinctCountAggregates = {
  __typename?: 'UtilityAccountStatementRollupDistinctCountAggregates';
  /** Distinct count of accountLabel across the matching connection */
  accountLabel?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of billArrivalDate across the matching connection */
  billArrivalDate?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of billCost across the matching connection */
  billCost?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of billDemandCost across the matching connection */
  billDemandCost?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of billUsageCost across the matching connection */
  billUsageCost?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of credits across the matching connection */
  credits?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of currencyCode across the matching connection */
  currencyCode?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of fees across the matching connection */
  fees?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of intervalEnd across the matching connection */
  intervalEnd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of intervalStart across the matching connection */
  intervalStart?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of isValidated across the matching connection */
  isValidated?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of percentChange across the matching connection */
  percentChange?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of provider across the matching connection */
  provider?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of this field across the matching connection. */
  serviceTypes?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of taxes across the matching connection */
  taxes?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `UtilityAccountStatementRollup` object types. All fields are combined with a logical ‘and.’ */
export type UtilityAccountStatementRollupFilter = {
  /** Filter by the object’s `accountLabel` field. */
  accountLabel?: InputMaybe<StringFilter>;
  /** Filter by the object’s `accountStatementId` field. */
  accountStatementId?: InputMaybe<IntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UtilityAccountStatementRollupFilter>>;
  /** Filter by the object’s `billArrivalDate` field. */
  billArrivalDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `billCost` field. */
  billCost?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `billDemandCost` field. */
  billDemandCost?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `billUsageCost` field. */
  billUsageCost?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `credits` field. */
  credits?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `currencyCode` field. */
  currencyCode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `fees` field. */
  fees?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `intervalEnd` field. */
  intervalEnd?: InputMaybe<DateFilter>;
  /** Filter by the object’s `intervalStart` field. */
  intervalStart?: InputMaybe<DateFilter>;
  /** Filter by the object’s `isValidated` field. */
  isValidated?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UtilityAccountStatementRollupFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UtilityAccountStatementRollupFilter>>;
  /** Filter by the object’s `percentChange` field. */
  percentChange?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `provider` field. */
  provider?: InputMaybe<StringFilter>;
  /** Filter by the object’s `serviceTypes` field. */
  serviceTypes?: InputMaybe<UtilityMeterServiceTypeListFilter>;
  /** Filter by the object’s `statementMonth` field. */
  statementMonth?: InputMaybe<IntFilter>;
  /** Filter by the object’s `statementYear` field. */
  statementYear?: InputMaybe<IntFilter>;
  /** Filter by the object’s `taxes` field. */
  taxes?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `utilityAccountId` field. */
  utilityAccountId?: InputMaybe<IntFilter>;
};

export type UtilityAccountStatementRollupMaxAggregates = {
  __typename?: 'UtilityAccountStatementRollupMaxAggregates';
  /** Maximum of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of billCost across the matching connection */
  billCost?: Maybe<Scalars['Float']['output']>;
  /** Maximum of billDemandCost across the matching connection */
  billDemandCost?: Maybe<Scalars['Float']['output']>;
  /** Maximum of billUsageCost across the matching connection */
  billUsageCost?: Maybe<Scalars['Float']['output']>;
  /** Maximum of credits across the matching connection */
  credits?: Maybe<Scalars['Float']['output']>;
  /** Maximum of fees across the matching connection */
  fees?: Maybe<Scalars['Float']['output']>;
  /** Maximum of percentChange across the matching connection */
  percentChange?: Maybe<Scalars['Float']['output']>;
  /** Maximum of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['Int']['output']>;
  /** Maximum of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['Int']['output']>;
  /** Maximum of taxes across the matching connection */
  taxes?: Maybe<Scalars['Float']['output']>;
  /** Maximum of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['Int']['output']>;
};

export type UtilityAccountStatementRollupMinAggregates = {
  __typename?: 'UtilityAccountStatementRollupMinAggregates';
  /** Minimum of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of billCost across the matching connection */
  billCost?: Maybe<Scalars['Float']['output']>;
  /** Minimum of billDemandCost across the matching connection */
  billDemandCost?: Maybe<Scalars['Float']['output']>;
  /** Minimum of billUsageCost across the matching connection */
  billUsageCost?: Maybe<Scalars['Float']['output']>;
  /** Minimum of credits across the matching connection */
  credits?: Maybe<Scalars['Float']['output']>;
  /** Minimum of fees across the matching connection */
  fees?: Maybe<Scalars['Float']['output']>;
  /** Minimum of percentChange across the matching connection */
  percentChange?: Maybe<Scalars['Float']['output']>;
  /** Minimum of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['Int']['output']>;
  /** Minimum of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['Int']['output']>;
  /** Minimum of taxes across the matching connection */
  taxes?: Maybe<Scalars['Float']['output']>;
  /** Minimum of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['Int']['output']>;
};

export type UtilityAccountStatementRollupStddevPopulationAggregates = {
  __typename?: 'UtilityAccountStatementRollupStddevPopulationAggregates';
  /** Population standard deviation of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of billCost across the matching connection */
  billCost?: Maybe<Scalars['Float']['output']>;
  /** Population standard deviation of billDemandCost across the matching connection */
  billDemandCost?: Maybe<Scalars['Float']['output']>;
  /** Population standard deviation of billUsageCost across the matching connection */
  billUsageCost?: Maybe<Scalars['Float']['output']>;
  /** Population standard deviation of credits across the matching connection */
  credits?: Maybe<Scalars['Float']['output']>;
  /** Population standard deviation of fees across the matching connection */
  fees?: Maybe<Scalars['Float']['output']>;
  /** Population standard deviation of percentChange across the matching connection */
  percentChange?: Maybe<Scalars['Float']['output']>;
  /** Population standard deviation of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of taxes across the matching connection */
  taxes?: Maybe<Scalars['Float']['output']>;
  /** Population standard deviation of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UtilityAccountStatementRollupStddevSampleAggregates = {
  __typename?: 'UtilityAccountStatementRollupStddevSampleAggregates';
  /** Sample standard deviation of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of billCost across the matching connection */
  billCost?: Maybe<Scalars['Float']['output']>;
  /** Sample standard deviation of billDemandCost across the matching connection */
  billDemandCost?: Maybe<Scalars['Float']['output']>;
  /** Sample standard deviation of billUsageCost across the matching connection */
  billUsageCost?: Maybe<Scalars['Float']['output']>;
  /** Sample standard deviation of credits across the matching connection */
  credits?: Maybe<Scalars['Float']['output']>;
  /** Sample standard deviation of fees across the matching connection */
  fees?: Maybe<Scalars['Float']['output']>;
  /** Sample standard deviation of percentChange across the matching connection */
  percentChange?: Maybe<Scalars['Float']['output']>;
  /** Sample standard deviation of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of taxes across the matching connection */
  taxes?: Maybe<Scalars['Float']['output']>;
  /** Sample standard deviation of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UtilityAccountStatementRollupSumAggregates = {
  __typename?: 'UtilityAccountStatementRollupSumAggregates';
  /** Sum of accountStatementId across the matching connection */
  accountStatementId: Scalars['BigInt']['output'];
  /** Sum of billCost across the matching connection */
  billCost: Scalars['Float']['output'];
  /** Sum of billDemandCost across the matching connection */
  billDemandCost: Scalars['Float']['output'];
  /** Sum of billUsageCost across the matching connection */
  billUsageCost: Scalars['Float']['output'];
  /** Sum of credits across the matching connection */
  credits: Scalars['Float']['output'];
  /** Sum of fees across the matching connection */
  fees: Scalars['Float']['output'];
  /** Sum of percentChange across the matching connection */
  percentChange: Scalars['Float']['output'];
  /** Sum of statementMonth across the matching connection */
  statementMonth: Scalars['BigInt']['output'];
  /** Sum of statementYear across the matching connection */
  statementYear: Scalars['BigInt']['output'];
  /** Sum of taxes across the matching connection */
  taxes: Scalars['Float']['output'];
  /** Sum of utilityAccountId across the matching connection */
  utilityAccountId: Scalars['BigInt']['output'];
};

export type UtilityAccountStatementRollupVariancePopulationAggregates = {
  __typename?: 'UtilityAccountStatementRollupVariancePopulationAggregates';
  /** Population variance of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of billCost across the matching connection */
  billCost?: Maybe<Scalars['Float']['output']>;
  /** Population variance of billDemandCost across the matching connection */
  billDemandCost?: Maybe<Scalars['Float']['output']>;
  /** Population variance of billUsageCost across the matching connection */
  billUsageCost?: Maybe<Scalars['Float']['output']>;
  /** Population variance of credits across the matching connection */
  credits?: Maybe<Scalars['Float']['output']>;
  /** Population variance of fees across the matching connection */
  fees?: Maybe<Scalars['Float']['output']>;
  /** Population variance of percentChange across the matching connection */
  percentChange?: Maybe<Scalars['Float']['output']>;
  /** Population variance of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of taxes across the matching connection */
  taxes?: Maybe<Scalars['Float']['output']>;
  /** Population variance of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UtilityAccountStatementRollupVarianceSampleAggregates = {
  __typename?: 'UtilityAccountStatementRollupVarianceSampleAggregates';
  /** Sample variance of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of billCost across the matching connection */
  billCost?: Maybe<Scalars['Float']['output']>;
  /** Sample variance of billDemandCost across the matching connection */
  billDemandCost?: Maybe<Scalars['Float']['output']>;
  /** Sample variance of billUsageCost across the matching connection */
  billUsageCost?: Maybe<Scalars['Float']['output']>;
  /** Sample variance of credits across the matching connection */
  credits?: Maybe<Scalars['Float']['output']>;
  /** Sample variance of fees across the matching connection */
  fees?: Maybe<Scalars['Float']['output']>;
  /** Sample variance of percentChange across the matching connection */
  percentChange?: Maybe<Scalars['Float']['output']>;
  /** Sample variance of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of taxes across the matching connection */
  taxes?: Maybe<Scalars['Float']['output']>;
  /** Sample variance of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `UtilityAccountStatementRollup` values. */
export type UtilityAccountStatementRollupsConnection = {
  __typename?: 'UtilityAccountStatementRollupsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<UtilityAccountStatementRollupAggregates>;
  /** A list of edges which contains the `UtilityAccountStatementRollup` and cursor to aid in pagination. */
  edges: Array<UtilityAccountStatementRollupsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<UtilityAccountStatementRollupAggregates>>;
  /** A list of `UtilityAccountStatementRollup` objects. */
  nodes: Array<UtilityAccountStatementRollup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UtilityAccountStatementRollup` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A connection to a list of `UtilityAccountStatementRollup` values. */
export type UtilityAccountStatementRollupsConnectionGroupedAggregatesArgs = {
  groupBy: Array<UtilityAccountStatementRollupsGroupBy>;
  having?: InputMaybe<UtilityAccountStatementRollupsHavingInput>;
};

/** A `UtilityAccountStatementRollup` edge in the connection. */
export type UtilityAccountStatementRollupsEdge = {
  __typename?: 'UtilityAccountStatementRollupsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UtilityAccountStatementRollup` at the end of the edge. */
  node: UtilityAccountStatementRollup;
};

/** Grouping methods for `UtilityAccountStatementRollup` for usage during aggregation. */
export enum UtilityAccountStatementRollupsGroupBy {
  ACCOUNT_LABEL = 'ACCOUNT_LABEL',
  ACCOUNT_LABEL_DISTINCT = 'ACCOUNT_LABEL_DISTINCT',
  ACCOUNT_STATEMENT_ID = 'ACCOUNT_STATEMENT_ID',
  ACCOUNT_STATEMENT_ID_DISTINCT = 'ACCOUNT_STATEMENT_ID_DISTINCT',
  BILL_ARRIVAL_DATE = 'BILL_ARRIVAL_DATE',
  BILL_ARRIVAL_DATE_DISTINCT = 'BILL_ARRIVAL_DATE_DISTINCT',
  BILL_ARRIVAL_DATE_TRUNCATED_TO_DAY = 'BILL_ARRIVAL_DATE_TRUNCATED_TO_DAY',
  BILL_ARRIVAL_DATE_TRUNCATED_TO_HOUR = 'BILL_ARRIVAL_DATE_TRUNCATED_TO_HOUR',
  BILL_COST = 'BILL_COST',
  BILL_COST_DISTINCT = 'BILL_COST_DISTINCT',
  BILL_DEMAND_COST = 'BILL_DEMAND_COST',
  BILL_DEMAND_COST_DISTINCT = 'BILL_DEMAND_COST_DISTINCT',
  BILL_USAGE_COST = 'BILL_USAGE_COST',
  BILL_USAGE_COST_DISTINCT = 'BILL_USAGE_COST_DISTINCT',
  CREDITS = 'CREDITS',
  CREDITS_DISTINCT = 'CREDITS_DISTINCT',
  CURRENCY_CODE = 'CURRENCY_CODE',
  CURRENCY_CODE_DISTINCT = 'CURRENCY_CODE_DISTINCT',
  FEES = 'FEES',
  FEES_DISTINCT = 'FEES_DISTINCT',
  INTERVAL_END = 'INTERVAL_END',
  INTERVAL_END_DISTINCT = 'INTERVAL_END_DISTINCT',
  INTERVAL_START = 'INTERVAL_START',
  INTERVAL_START_DISTINCT = 'INTERVAL_START_DISTINCT',
  IS_VALIDATED = 'IS_VALIDATED',
  IS_VALIDATED_DISTINCT = 'IS_VALIDATED_DISTINCT',
  PERCENT_CHANGE = 'PERCENT_CHANGE',
  PERCENT_CHANGE_DISTINCT = 'PERCENT_CHANGE_DISTINCT',
  PROVIDER = 'PROVIDER',
  PROVIDER_DISTINCT = 'PROVIDER_DISTINCT',
  STATEMENT_MONTH = 'STATEMENT_MONTH',
  STATEMENT_MONTH_DISTINCT = 'STATEMENT_MONTH_DISTINCT',
  STATEMENT_YEAR = 'STATEMENT_YEAR',
  STATEMENT_YEAR_DISTINCT = 'STATEMENT_YEAR_DISTINCT',
  TAXES = 'TAXES',
  TAXES_DISTINCT = 'TAXES_DISTINCT',
  UTILITY_ACCOUNT_ID = 'UTILITY_ACCOUNT_ID',
  UTILITY_ACCOUNT_ID_DISTINCT = 'UTILITY_ACCOUNT_ID_DISTINCT'
}

export type UtilityAccountStatementRollupsHavingAverageInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<HavingFloatFilter>;
  billDemandCost?: InputMaybe<HavingFloatFilter>;
  billUsageCost?: InputMaybe<HavingFloatFilter>;
  credits?: InputMaybe<HavingFloatFilter>;
  fees?: InputMaybe<HavingFloatFilter>;
  intervalEnd?: InputMaybe<HavingDatetimeFilter>;
  intervalStart?: InputMaybe<HavingDatetimeFilter>;
  percentChange?: InputMaybe<HavingFloatFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<HavingFloatFilter>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
};

export type UtilityAccountStatementRollupsHavingDistinctCountInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<HavingFloatFilter>;
  billDemandCost?: InputMaybe<HavingFloatFilter>;
  billUsageCost?: InputMaybe<HavingFloatFilter>;
  credits?: InputMaybe<HavingFloatFilter>;
  fees?: InputMaybe<HavingFloatFilter>;
  intervalEnd?: InputMaybe<HavingDatetimeFilter>;
  intervalStart?: InputMaybe<HavingDatetimeFilter>;
  percentChange?: InputMaybe<HavingFloatFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<HavingFloatFilter>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
};

export type UtilityAccountStatementRollupsHavingDistinctInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<HavingFloatFilter>;
  billDemandCost?: InputMaybe<HavingFloatFilter>;
  billUsageCost?: InputMaybe<HavingFloatFilter>;
  credits?: InputMaybe<HavingFloatFilter>;
  fees?: InputMaybe<HavingFloatFilter>;
  intervalEnd?: InputMaybe<HavingDatetimeFilter>;
  intervalStart?: InputMaybe<HavingDatetimeFilter>;
  percentChange?: InputMaybe<HavingFloatFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<HavingFloatFilter>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `UtilityAccountStatementRollup` aggregates. */
export type UtilityAccountStatementRollupsHavingInput = {
  AND?: InputMaybe<Array<UtilityAccountStatementRollupsHavingInput>>;
  OR?: InputMaybe<Array<UtilityAccountStatementRollupsHavingInput>>;
  average?: InputMaybe<UtilityAccountStatementRollupsHavingAverageInput>;
  distinct?: InputMaybe<UtilityAccountStatementRollupsHavingDistinctInput>;
  distinctCount?: InputMaybe<UtilityAccountStatementRollupsHavingDistinctCountInput>;
  max?: InputMaybe<UtilityAccountStatementRollupsHavingMaxInput>;
  min?: InputMaybe<UtilityAccountStatementRollupsHavingMinInput>;
  stddevPopulation?: InputMaybe<UtilityAccountStatementRollupsHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<UtilityAccountStatementRollupsHavingStddevSampleInput>;
  sum?: InputMaybe<UtilityAccountStatementRollupsHavingSumInput>;
  variancePopulation?: InputMaybe<UtilityAccountStatementRollupsHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<UtilityAccountStatementRollupsHavingVarianceSampleInput>;
};

export type UtilityAccountStatementRollupsHavingMaxInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<HavingFloatFilter>;
  billDemandCost?: InputMaybe<HavingFloatFilter>;
  billUsageCost?: InputMaybe<HavingFloatFilter>;
  credits?: InputMaybe<HavingFloatFilter>;
  fees?: InputMaybe<HavingFloatFilter>;
  intervalEnd?: InputMaybe<HavingDatetimeFilter>;
  intervalStart?: InputMaybe<HavingDatetimeFilter>;
  percentChange?: InputMaybe<HavingFloatFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<HavingFloatFilter>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
};

export type UtilityAccountStatementRollupsHavingMinInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<HavingFloatFilter>;
  billDemandCost?: InputMaybe<HavingFloatFilter>;
  billUsageCost?: InputMaybe<HavingFloatFilter>;
  credits?: InputMaybe<HavingFloatFilter>;
  fees?: InputMaybe<HavingFloatFilter>;
  intervalEnd?: InputMaybe<HavingDatetimeFilter>;
  intervalStart?: InputMaybe<HavingDatetimeFilter>;
  percentChange?: InputMaybe<HavingFloatFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<HavingFloatFilter>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
};

export type UtilityAccountStatementRollupsHavingStddevPopulationInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<HavingFloatFilter>;
  billDemandCost?: InputMaybe<HavingFloatFilter>;
  billUsageCost?: InputMaybe<HavingFloatFilter>;
  credits?: InputMaybe<HavingFloatFilter>;
  fees?: InputMaybe<HavingFloatFilter>;
  intervalEnd?: InputMaybe<HavingDatetimeFilter>;
  intervalStart?: InputMaybe<HavingDatetimeFilter>;
  percentChange?: InputMaybe<HavingFloatFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<HavingFloatFilter>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
};

export type UtilityAccountStatementRollupsHavingStddevSampleInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<HavingFloatFilter>;
  billDemandCost?: InputMaybe<HavingFloatFilter>;
  billUsageCost?: InputMaybe<HavingFloatFilter>;
  credits?: InputMaybe<HavingFloatFilter>;
  fees?: InputMaybe<HavingFloatFilter>;
  intervalEnd?: InputMaybe<HavingDatetimeFilter>;
  intervalStart?: InputMaybe<HavingDatetimeFilter>;
  percentChange?: InputMaybe<HavingFloatFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<HavingFloatFilter>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
};

export type UtilityAccountStatementRollupsHavingSumInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<HavingFloatFilter>;
  billDemandCost?: InputMaybe<HavingFloatFilter>;
  billUsageCost?: InputMaybe<HavingFloatFilter>;
  credits?: InputMaybe<HavingFloatFilter>;
  fees?: InputMaybe<HavingFloatFilter>;
  intervalEnd?: InputMaybe<HavingDatetimeFilter>;
  intervalStart?: InputMaybe<HavingDatetimeFilter>;
  percentChange?: InputMaybe<HavingFloatFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<HavingFloatFilter>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
};

export type UtilityAccountStatementRollupsHavingVariancePopulationInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<HavingFloatFilter>;
  billDemandCost?: InputMaybe<HavingFloatFilter>;
  billUsageCost?: InputMaybe<HavingFloatFilter>;
  credits?: InputMaybe<HavingFloatFilter>;
  fees?: InputMaybe<HavingFloatFilter>;
  intervalEnd?: InputMaybe<HavingDatetimeFilter>;
  intervalStart?: InputMaybe<HavingDatetimeFilter>;
  percentChange?: InputMaybe<HavingFloatFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<HavingFloatFilter>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
};

export type UtilityAccountStatementRollupsHavingVarianceSampleInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<HavingFloatFilter>;
  billDemandCost?: InputMaybe<HavingFloatFilter>;
  billUsageCost?: InputMaybe<HavingFloatFilter>;
  credits?: InputMaybe<HavingFloatFilter>;
  fees?: InputMaybe<HavingFloatFilter>;
  intervalEnd?: InputMaybe<HavingDatetimeFilter>;
  intervalStart?: InputMaybe<HavingDatetimeFilter>;
  percentChange?: InputMaybe<HavingFloatFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<HavingFloatFilter>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
};

/** Methods to use when ordering `UtilityAccountStatementRollup`. */
export enum UtilityAccountStatementRollupsOrderBy {
  ACCOUNT_LABEL_ASC = 'ACCOUNT_LABEL_ASC',
  ACCOUNT_LABEL_DESC = 'ACCOUNT_LABEL_DESC',
  ACCOUNT_STATEMENT_ID_ASC = 'ACCOUNT_STATEMENT_ID_ASC',
  ACCOUNT_STATEMENT_ID_DESC = 'ACCOUNT_STATEMENT_ID_DESC',
  BILL_ARRIVAL_DATE_ASC = 'BILL_ARRIVAL_DATE_ASC',
  BILL_ARRIVAL_DATE_DESC = 'BILL_ARRIVAL_DATE_DESC',
  BILL_COST_ASC = 'BILL_COST_ASC',
  BILL_COST_DESC = 'BILL_COST_DESC',
  BILL_DEMAND_COST_ASC = 'BILL_DEMAND_COST_ASC',
  BILL_DEMAND_COST_DESC = 'BILL_DEMAND_COST_DESC',
  BILL_USAGE_COST_ASC = 'BILL_USAGE_COST_ASC',
  BILL_USAGE_COST_DESC = 'BILL_USAGE_COST_DESC',
  CREDITS_ASC = 'CREDITS_ASC',
  CREDITS_DESC = 'CREDITS_DESC',
  CURRENCY_CODE_ASC = 'CURRENCY_CODE_ASC',
  CURRENCY_CODE_DESC = 'CURRENCY_CODE_DESC',
  FEES_ASC = 'FEES_ASC',
  FEES_DESC = 'FEES_DESC',
  INTERVAL_END_ASC = 'INTERVAL_END_ASC',
  INTERVAL_END_DESC = 'INTERVAL_END_DESC',
  INTERVAL_START_ASC = 'INTERVAL_START_ASC',
  INTERVAL_START_DESC = 'INTERVAL_START_DESC',
  IS_VALIDATED_ASC = 'IS_VALIDATED_ASC',
  IS_VALIDATED_DESC = 'IS_VALIDATED_DESC',
  NATURAL = 'NATURAL',
  PERCENT_CHANGE_ASC = 'PERCENT_CHANGE_ASC',
  PERCENT_CHANGE_DESC = 'PERCENT_CHANGE_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  PROVIDER_ASC = 'PROVIDER_ASC',
  PROVIDER_DESC = 'PROVIDER_DESC',
  STATEMENT_MONTH_ASC = 'STATEMENT_MONTH_ASC',
  STATEMENT_MONTH_DESC = 'STATEMENT_MONTH_DESC',
  STATEMENT_YEAR_ASC = 'STATEMENT_YEAR_ASC',
  STATEMENT_YEAR_DESC = 'STATEMENT_YEAR_DESC',
  TAXES_ASC = 'TAXES_ASC',
  TAXES_DESC = 'TAXES_DESC',
  UTILITY_ACCOUNT_ID_ASC = 'UTILITY_ACCOUNT_ID_ASC',
  UTILITY_ACCOUNT_ID_DESC = 'UTILITY_ACCOUNT_ID_DESC'
}

export type UtilityAccountStatementStddevPopulationAggregates = {
  __typename?: 'UtilityAccountStatementStddevPopulationAggregates';
  /** Population standard deviation of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['BigFloat']['output']>;
  /**
   * Population standard deviation of this field across the matching connection.
   *
   * ---
   *
   * Returns the total charges of a given utility_account_statements (view) row.
   */
  billCost?: Maybe<Scalars['Float']['output']>;
  /**
   * Population standard deviation of this field across the matching connection.
   *
   * ---
   *
   * Returns the total credits of a given utility_account_statements (view) row.
   */
  credits?: Maybe<Scalars['Float']['output']>;
  /**
   * Population standard deviation of this field across the matching connection.
   *
   * ---
   *
   * Returns the total fee charges of a given utility_account_statements (view) row.
   */
  fees?: Maybe<Scalars['Float']['output']>;
  /** Population standard deviation of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['BigFloat']['output']>;
  /**
   * Population standard deviation of this field across the matching connection.
   *
   * ---
   *
   * Returns the total tax charges of a given utility_account_statements (view) row.
   */
  taxes?: Maybe<Scalars['Float']['output']>;
  /** Population standard deviation of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UtilityAccountStatementStddevSampleAggregates = {
  __typename?: 'UtilityAccountStatementStddevSampleAggregates';
  /** Sample standard deviation of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['BigFloat']['output']>;
  /**
   * Sample standard deviation of this field across the matching connection.
   *
   * ---
   *
   * Returns the total charges of a given utility_account_statements (view) row.
   */
  billCost?: Maybe<Scalars['Float']['output']>;
  /**
   * Sample standard deviation of this field across the matching connection.
   *
   * ---
   *
   * Returns the total credits of a given utility_account_statements (view) row.
   */
  credits?: Maybe<Scalars['Float']['output']>;
  /**
   * Sample standard deviation of this field across the matching connection.
   *
   * ---
   *
   * Returns the total fee charges of a given utility_account_statements (view) row.
   */
  fees?: Maybe<Scalars['Float']['output']>;
  /** Sample standard deviation of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['BigFloat']['output']>;
  /**
   * Sample standard deviation of this field across the matching connection.
   *
   * ---
   *
   * Returns the total tax charges of a given utility_account_statements (view) row.
   */
  taxes?: Maybe<Scalars['Float']['output']>;
  /** Sample standard deviation of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UtilityAccountStatementSumAggregates = {
  __typename?: 'UtilityAccountStatementSumAggregates';
  /** Sum of accountStatementId across the matching connection */
  accountStatementId: Scalars['BigInt']['output'];
  /**
   * Sum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total charges of a given utility_account_statements (view) row.
   */
  billCost?: Maybe<Scalars['Float']['output']>;
  /**
   * Sum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total credits of a given utility_account_statements (view) row.
   */
  credits?: Maybe<Scalars['Float']['output']>;
  /**
   * Sum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total fee charges of a given utility_account_statements (view) row.
   */
  fees?: Maybe<Scalars['Float']['output']>;
  /** Sum of statementMonth across the matching connection */
  statementMonth: Scalars['BigInt']['output'];
  /** Sum of statementYear across the matching connection */
  statementYear: Scalars['BigInt']['output'];
  /**
   * Sum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total tax charges of a given utility_account_statements (view) row.
   */
  taxes?: Maybe<Scalars['Float']['output']>;
  /** Sum of utilityAccountId across the matching connection */
  utilityAccountId: Scalars['BigInt']['output'];
};

export type UtilityAccountStatementVariancePopulationAggregates = {
  __typename?: 'UtilityAccountStatementVariancePopulationAggregates';
  /** Population variance of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['BigFloat']['output']>;
  /**
   * Population variance of this field across the matching connection.
   *
   * ---
   *
   * Returns the total charges of a given utility_account_statements (view) row.
   */
  billCost?: Maybe<Scalars['Float']['output']>;
  /**
   * Population variance of this field across the matching connection.
   *
   * ---
   *
   * Returns the total credits of a given utility_account_statements (view) row.
   */
  credits?: Maybe<Scalars['Float']['output']>;
  /**
   * Population variance of this field across the matching connection.
   *
   * ---
   *
   * Returns the total fee charges of a given utility_account_statements (view) row.
   */
  fees?: Maybe<Scalars['Float']['output']>;
  /** Population variance of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['BigFloat']['output']>;
  /**
   * Population variance of this field across the matching connection.
   *
   * ---
   *
   * Returns the total tax charges of a given utility_account_statements (view) row.
   */
  taxes?: Maybe<Scalars['Float']['output']>;
  /** Population variance of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UtilityAccountStatementVarianceSampleAggregates = {
  __typename?: 'UtilityAccountStatementVarianceSampleAggregates';
  /** Sample variance of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['BigFloat']['output']>;
  /**
   * Sample variance of this field across the matching connection.
   *
   * ---
   *
   * Returns the total charges of a given utility_account_statements (view) row.
   */
  billCost?: Maybe<Scalars['Float']['output']>;
  /**
   * Sample variance of this field across the matching connection.
   *
   * ---
   *
   * Returns the total credits of a given utility_account_statements (view) row.
   */
  credits?: Maybe<Scalars['Float']['output']>;
  /**
   * Sample variance of this field across the matching connection.
   *
   * ---
   *
   * Returns the total fee charges of a given utility_account_statements (view) row.
   */
  fees?: Maybe<Scalars['Float']['output']>;
  /** Sample variance of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['BigFloat']['output']>;
  /**
   * Sample variance of this field across the matching connection.
   *
   * ---
   *
   * Returns the total tax charges of a given utility_account_statements (view) row.
   */
  taxes?: Maybe<Scalars['Float']['output']>;
  /** Sample variance of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `UtilityAccountStatement` values. */
export type UtilityAccountStatementsConnection = {
  __typename?: 'UtilityAccountStatementsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<UtilityAccountStatementAggregates>;
  /** A list of edges which contains the `UtilityAccountStatement` and cursor to aid in pagination. */
  edges: Array<UtilityAccountStatementsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<UtilityAccountStatementAggregates>>;
  /** A list of `UtilityAccountStatement` objects. */
  nodes: Array<UtilityAccountStatement>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UtilityAccountStatement` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A connection to a list of `UtilityAccountStatement` values. */
export type UtilityAccountStatementsConnectionGroupedAggregatesArgs = {
  groupBy: Array<UtilityAccountStatementsGroupBy>;
  having?: InputMaybe<UtilityAccountStatementsHavingInput>;
};

/** A `UtilityAccountStatement` edge in the connection. */
export type UtilityAccountStatementsEdge = {
  __typename?: 'UtilityAccountStatementsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UtilityAccountStatement` at the end of the edge. */
  node: UtilityAccountStatement;
};

/** Grouping methods for `UtilityAccountStatement` for usage during aggregation. */
export enum UtilityAccountStatementsGroupBy {
  ACCOUNT_LABEL = 'ACCOUNT_LABEL',
  ACCOUNT_LABEL_DISTINCT = 'ACCOUNT_LABEL_DISTINCT',
  ACCOUNT_STATEMENT_ID = 'ACCOUNT_STATEMENT_ID',
  ACCOUNT_STATEMENT_ID_DISTINCT = 'ACCOUNT_STATEMENT_ID_DISTINCT',
  BILL_ARRIVAL_DATE = 'BILL_ARRIVAL_DATE',
  BILL_ARRIVAL_DATE_DISTINCT = 'BILL_ARRIVAL_DATE_DISTINCT',
  BILL_ARRIVAL_DATE_TRUNCATED_TO_DAY = 'BILL_ARRIVAL_DATE_TRUNCATED_TO_DAY',
  BILL_ARRIVAL_DATE_TRUNCATED_TO_HOUR = 'BILL_ARRIVAL_DATE_TRUNCATED_TO_HOUR',
  CURRENCY_CODE = 'CURRENCY_CODE',
  CURRENCY_CODE_DISTINCT = 'CURRENCY_CODE_DISTINCT',
  INTERVAL_END = 'INTERVAL_END',
  INTERVAL_END_DISTINCT = 'INTERVAL_END_DISTINCT',
  INTERVAL_START = 'INTERVAL_START',
  INTERVAL_START_DISTINCT = 'INTERVAL_START_DISTINCT',
  IS_VALIDATED = 'IS_VALIDATED',
  IS_VALIDATED_DISTINCT = 'IS_VALIDATED_DISTINCT',
  PROVIDER = 'PROVIDER',
  PROVIDER_DISTINCT = 'PROVIDER_DISTINCT',
  STATEMENT_MONTH = 'STATEMENT_MONTH',
  STATEMENT_MONTH_DISTINCT = 'STATEMENT_MONTH_DISTINCT',
  STATEMENT_YEAR = 'STATEMENT_YEAR',
  STATEMENT_YEAR_DISTINCT = 'STATEMENT_YEAR_DISTINCT',
  UTILITY_ACCOUNT_ID = 'UTILITY_ACCOUNT_ID',
  UTILITY_ACCOUNT_ID_DISTINCT = 'UTILITY_ACCOUNT_ID_DISTINCT'
}

export type UtilityAccountStatementsHavingAverageInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<UtilityAccountStatementsHavingAverageUtilityAccountStatementsBillCostInput>;
  credits?: InputMaybe<UtilityAccountStatementsHavingAverageUtilityAccountStatementsCreditsInput>;
  fees?: InputMaybe<UtilityAccountStatementsHavingAverageUtilityAccountStatementsFeesInput>;
  intervalEnd?: InputMaybe<HavingDatetimeFilter>;
  intervalStart?: InputMaybe<HavingDatetimeFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<UtilityAccountStatementsHavingAverageUtilityAccountStatementsTaxesInput>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
};

export type UtilityAccountStatementsHavingAverageUtilityAccountStatementsBillCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingAverageUtilityAccountStatementsCreditsInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingAverageUtilityAccountStatementsFeesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingAverageUtilityAccountStatementsTaxesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingDistinctCountInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<UtilityAccountStatementsHavingDistinctCountUtilityAccountStatementsBillCostInput>;
  credits?: InputMaybe<UtilityAccountStatementsHavingDistinctCountUtilityAccountStatementsCreditsInput>;
  fees?: InputMaybe<UtilityAccountStatementsHavingDistinctCountUtilityAccountStatementsFeesInput>;
  intervalEnd?: InputMaybe<HavingDatetimeFilter>;
  intervalStart?: InputMaybe<HavingDatetimeFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<UtilityAccountStatementsHavingDistinctCountUtilityAccountStatementsTaxesInput>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
};

export type UtilityAccountStatementsHavingDistinctCountUtilityAccountStatementsBillCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingDistinctCountUtilityAccountStatementsCreditsInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingDistinctCountUtilityAccountStatementsFeesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingDistinctCountUtilityAccountStatementsTaxesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingDistinctInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<UtilityAccountStatementsHavingDistinctUtilityAccountStatementsBillCostInput>;
  credits?: InputMaybe<UtilityAccountStatementsHavingDistinctUtilityAccountStatementsCreditsInput>;
  fees?: InputMaybe<UtilityAccountStatementsHavingDistinctUtilityAccountStatementsFeesInput>;
  intervalEnd?: InputMaybe<HavingDatetimeFilter>;
  intervalStart?: InputMaybe<HavingDatetimeFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<UtilityAccountStatementsHavingDistinctUtilityAccountStatementsTaxesInput>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
};

export type UtilityAccountStatementsHavingDistinctUtilityAccountStatementsBillCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingDistinctUtilityAccountStatementsCreditsInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingDistinctUtilityAccountStatementsFeesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingDistinctUtilityAccountStatementsTaxesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

/** Conditions for `UtilityAccountStatement` aggregates. */
export type UtilityAccountStatementsHavingInput = {
  AND?: InputMaybe<Array<UtilityAccountStatementsHavingInput>>;
  OR?: InputMaybe<Array<UtilityAccountStatementsHavingInput>>;
  average?: InputMaybe<UtilityAccountStatementsHavingAverageInput>;
  distinct?: InputMaybe<UtilityAccountStatementsHavingDistinctInput>;
  distinctCount?: InputMaybe<UtilityAccountStatementsHavingDistinctCountInput>;
  max?: InputMaybe<UtilityAccountStatementsHavingMaxInput>;
  min?: InputMaybe<UtilityAccountStatementsHavingMinInput>;
  stddevPopulation?: InputMaybe<UtilityAccountStatementsHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<UtilityAccountStatementsHavingStddevSampleInput>;
  sum?: InputMaybe<UtilityAccountStatementsHavingSumInput>;
  variancePopulation?: InputMaybe<UtilityAccountStatementsHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<UtilityAccountStatementsHavingVarianceSampleInput>;
};

export type UtilityAccountStatementsHavingMaxInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<UtilityAccountStatementsHavingMaxUtilityAccountStatementsBillCostInput>;
  credits?: InputMaybe<UtilityAccountStatementsHavingMaxUtilityAccountStatementsCreditsInput>;
  fees?: InputMaybe<UtilityAccountStatementsHavingMaxUtilityAccountStatementsFeesInput>;
  intervalEnd?: InputMaybe<HavingDatetimeFilter>;
  intervalStart?: InputMaybe<HavingDatetimeFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<UtilityAccountStatementsHavingMaxUtilityAccountStatementsTaxesInput>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
};

export type UtilityAccountStatementsHavingMaxUtilityAccountStatementsBillCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingMaxUtilityAccountStatementsCreditsInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingMaxUtilityAccountStatementsFeesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingMaxUtilityAccountStatementsTaxesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingMinInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<UtilityAccountStatementsHavingMinUtilityAccountStatementsBillCostInput>;
  credits?: InputMaybe<UtilityAccountStatementsHavingMinUtilityAccountStatementsCreditsInput>;
  fees?: InputMaybe<UtilityAccountStatementsHavingMinUtilityAccountStatementsFeesInput>;
  intervalEnd?: InputMaybe<HavingDatetimeFilter>;
  intervalStart?: InputMaybe<HavingDatetimeFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<UtilityAccountStatementsHavingMinUtilityAccountStatementsTaxesInput>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
};

export type UtilityAccountStatementsHavingMinUtilityAccountStatementsBillCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingMinUtilityAccountStatementsCreditsInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingMinUtilityAccountStatementsFeesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingMinUtilityAccountStatementsTaxesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingStddevPopulationInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<UtilityAccountStatementsHavingStddevPopulationUtilityAccountStatementsBillCostInput>;
  credits?: InputMaybe<UtilityAccountStatementsHavingStddevPopulationUtilityAccountStatementsCreditsInput>;
  fees?: InputMaybe<UtilityAccountStatementsHavingStddevPopulationUtilityAccountStatementsFeesInput>;
  intervalEnd?: InputMaybe<HavingDatetimeFilter>;
  intervalStart?: InputMaybe<HavingDatetimeFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<UtilityAccountStatementsHavingStddevPopulationUtilityAccountStatementsTaxesInput>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
};

export type UtilityAccountStatementsHavingStddevPopulationUtilityAccountStatementsBillCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingStddevPopulationUtilityAccountStatementsCreditsInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingStddevPopulationUtilityAccountStatementsFeesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingStddevPopulationUtilityAccountStatementsTaxesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingStddevSampleInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<UtilityAccountStatementsHavingStddevSampleUtilityAccountStatementsBillCostInput>;
  credits?: InputMaybe<UtilityAccountStatementsHavingStddevSampleUtilityAccountStatementsCreditsInput>;
  fees?: InputMaybe<UtilityAccountStatementsHavingStddevSampleUtilityAccountStatementsFeesInput>;
  intervalEnd?: InputMaybe<HavingDatetimeFilter>;
  intervalStart?: InputMaybe<HavingDatetimeFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<UtilityAccountStatementsHavingStddevSampleUtilityAccountStatementsTaxesInput>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
};

export type UtilityAccountStatementsHavingStddevSampleUtilityAccountStatementsBillCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingStddevSampleUtilityAccountStatementsCreditsInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingStddevSampleUtilityAccountStatementsFeesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingStddevSampleUtilityAccountStatementsTaxesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingSumInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<UtilityAccountStatementsHavingSumUtilityAccountStatementsBillCostInput>;
  credits?: InputMaybe<UtilityAccountStatementsHavingSumUtilityAccountStatementsCreditsInput>;
  fees?: InputMaybe<UtilityAccountStatementsHavingSumUtilityAccountStatementsFeesInput>;
  intervalEnd?: InputMaybe<HavingDatetimeFilter>;
  intervalStart?: InputMaybe<HavingDatetimeFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<UtilityAccountStatementsHavingSumUtilityAccountStatementsTaxesInput>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
};

export type UtilityAccountStatementsHavingSumUtilityAccountStatementsBillCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingSumUtilityAccountStatementsCreditsInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingSumUtilityAccountStatementsFeesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingSumUtilityAccountStatementsTaxesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingVariancePopulationInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<UtilityAccountStatementsHavingVariancePopulationUtilityAccountStatementsBillCostInput>;
  credits?: InputMaybe<UtilityAccountStatementsHavingVariancePopulationUtilityAccountStatementsCreditsInput>;
  fees?: InputMaybe<UtilityAccountStatementsHavingVariancePopulationUtilityAccountStatementsFeesInput>;
  intervalEnd?: InputMaybe<HavingDatetimeFilter>;
  intervalStart?: InputMaybe<HavingDatetimeFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<UtilityAccountStatementsHavingVariancePopulationUtilityAccountStatementsTaxesInput>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
};

export type UtilityAccountStatementsHavingVariancePopulationUtilityAccountStatementsBillCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingVariancePopulationUtilityAccountStatementsCreditsInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingVariancePopulationUtilityAccountStatementsFeesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingVariancePopulationUtilityAccountStatementsTaxesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingVarianceSampleInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<UtilityAccountStatementsHavingVarianceSampleUtilityAccountStatementsBillCostInput>;
  credits?: InputMaybe<UtilityAccountStatementsHavingVarianceSampleUtilityAccountStatementsCreditsInput>;
  fees?: InputMaybe<UtilityAccountStatementsHavingVarianceSampleUtilityAccountStatementsFeesInput>;
  intervalEnd?: InputMaybe<HavingDatetimeFilter>;
  intervalStart?: InputMaybe<HavingDatetimeFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<UtilityAccountStatementsHavingVarianceSampleUtilityAccountStatementsTaxesInput>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
};

export type UtilityAccountStatementsHavingVarianceSampleUtilityAccountStatementsBillCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingVarianceSampleUtilityAccountStatementsCreditsInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingVarianceSampleUtilityAccountStatementsFeesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityAccountStatementsHavingVarianceSampleUtilityAccountStatementsTaxesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

/** Methods to use when ordering `UtilityAccountStatement`. */
export enum UtilityAccountStatementsOrderBy {
  ACCOUNT_LABEL_ASC = 'ACCOUNT_LABEL_ASC',
  ACCOUNT_LABEL_DESC = 'ACCOUNT_LABEL_DESC',
  ACCOUNT_STATEMENT_ID_ASC = 'ACCOUNT_STATEMENT_ID_ASC',
  ACCOUNT_STATEMENT_ID_DESC = 'ACCOUNT_STATEMENT_ID_DESC',
  BILL_ARRIVAL_DATE_ASC = 'BILL_ARRIVAL_DATE_ASC',
  BILL_ARRIVAL_DATE_DESC = 'BILL_ARRIVAL_DATE_DESC',
  CURRENCY_CODE_ASC = 'CURRENCY_CODE_ASC',
  CURRENCY_CODE_DESC = 'CURRENCY_CODE_DESC',
  INTERVAL_END_ASC = 'INTERVAL_END_ASC',
  INTERVAL_END_DESC = 'INTERVAL_END_DESC',
  INTERVAL_START_ASC = 'INTERVAL_START_ASC',
  INTERVAL_START_DESC = 'INTERVAL_START_DESC',
  IS_VALIDATED_ASC = 'IS_VALIDATED_ASC',
  IS_VALIDATED_DESC = 'IS_VALIDATED_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  PROVIDER_ASC = 'PROVIDER_ASC',
  PROVIDER_DESC = 'PROVIDER_DESC',
  STATEMENT_MONTH_ASC = 'STATEMENT_MONTH_ASC',
  STATEMENT_MONTH_DESC = 'STATEMENT_MONTH_DESC',
  STATEMENT_YEAR_ASC = 'STATEMENT_YEAR_ASC',
  STATEMENT_YEAR_DESC = 'STATEMENT_YEAR_DESC',
  UTILITY_ACCOUNT_ID_ASC = 'UTILITY_ACCOUNT_ID_ASC',
  UTILITY_ACCOUNT_ID_DESC = 'UTILITY_ACCOUNT_ID_DESC'
}

/** A connection to a list of `UtilityAccount` values. */
export type UtilityAccountsConnection = {
  __typename?: 'UtilityAccountsConnection';
  /** A list of edges which contains the `UtilityAccount` and cursor to aid in pagination. */
  edges: Array<UtilityAccountsEdge>;
  /** A list of `UtilityAccount` objects. */
  nodes: Array<UtilityAccount>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UtilityAccount` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `UtilityAccount` edge in the connection. */
export type UtilityAccountsEdge = {
  __typename?: 'UtilityAccountsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UtilityAccount` at the end of the edge. */
  node: UtilityAccount;
};

/** Methods to use when ordering `UtilityAccount`. */
export enum UtilityAccountsOrderBy {
  ACCOUNT_NUMBER_ASC = 'ACCOUNT_NUMBER_ASC',
  ACCOUNT_NUMBER_DESC = 'ACCOUNT_NUMBER_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DELETED_AT_ASC = 'DELETED_AT_ASC',
  DELETED_AT_DESC = 'DELETED_AT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  INTEGRATION_ACCOUNT_KEY_ASC = 'INTEGRATION_ACCOUNT_KEY_ASC',
  INTEGRATION_ACCOUNT_KEY_DESC = 'INTEGRATION_ACCOUNT_KEY_DESC',
  INTEGRATION_ASC = 'INTEGRATION_ASC',
  INTEGRATION_DESC = 'INTEGRATION_DESC',
  METADATA_ASC = 'METADATA_ASC',
  METADATA_DESC = 'METADATA_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  UTILITY_ACCOUNT_STATEMENTS_AVERAGE_ACCOUNT_LABEL_ASC = 'UTILITY_ACCOUNT_STATEMENTS_AVERAGE_ACCOUNT_LABEL_ASC',
  UTILITY_ACCOUNT_STATEMENTS_AVERAGE_ACCOUNT_LABEL_DESC = 'UTILITY_ACCOUNT_STATEMENTS_AVERAGE_ACCOUNT_LABEL_DESC',
  UTILITY_ACCOUNT_STATEMENTS_AVERAGE_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENTS_AVERAGE_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENTS_AVERAGE_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENTS_AVERAGE_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENTS_AVERAGE_BILL_ARRIVAL_DATE_ASC = 'UTILITY_ACCOUNT_STATEMENTS_AVERAGE_BILL_ARRIVAL_DATE_ASC',
  UTILITY_ACCOUNT_STATEMENTS_AVERAGE_BILL_ARRIVAL_DATE_DESC = 'UTILITY_ACCOUNT_STATEMENTS_AVERAGE_BILL_ARRIVAL_DATE_DESC',
  UTILITY_ACCOUNT_STATEMENTS_AVERAGE_CURRENCY_CODE_ASC = 'UTILITY_ACCOUNT_STATEMENTS_AVERAGE_CURRENCY_CODE_ASC',
  UTILITY_ACCOUNT_STATEMENTS_AVERAGE_CURRENCY_CODE_DESC = 'UTILITY_ACCOUNT_STATEMENTS_AVERAGE_CURRENCY_CODE_DESC',
  UTILITY_ACCOUNT_STATEMENTS_AVERAGE_INTERVAL_END_ASC = 'UTILITY_ACCOUNT_STATEMENTS_AVERAGE_INTERVAL_END_ASC',
  UTILITY_ACCOUNT_STATEMENTS_AVERAGE_INTERVAL_END_DESC = 'UTILITY_ACCOUNT_STATEMENTS_AVERAGE_INTERVAL_END_DESC',
  UTILITY_ACCOUNT_STATEMENTS_AVERAGE_INTERVAL_START_ASC = 'UTILITY_ACCOUNT_STATEMENTS_AVERAGE_INTERVAL_START_ASC',
  UTILITY_ACCOUNT_STATEMENTS_AVERAGE_INTERVAL_START_DESC = 'UTILITY_ACCOUNT_STATEMENTS_AVERAGE_INTERVAL_START_DESC',
  UTILITY_ACCOUNT_STATEMENTS_AVERAGE_IS_VALIDATED_ASC = 'UTILITY_ACCOUNT_STATEMENTS_AVERAGE_IS_VALIDATED_ASC',
  UTILITY_ACCOUNT_STATEMENTS_AVERAGE_IS_VALIDATED_DESC = 'UTILITY_ACCOUNT_STATEMENTS_AVERAGE_IS_VALIDATED_DESC',
  UTILITY_ACCOUNT_STATEMENTS_AVERAGE_PROVIDER_ASC = 'UTILITY_ACCOUNT_STATEMENTS_AVERAGE_PROVIDER_ASC',
  UTILITY_ACCOUNT_STATEMENTS_AVERAGE_PROVIDER_DESC = 'UTILITY_ACCOUNT_STATEMENTS_AVERAGE_PROVIDER_DESC',
  UTILITY_ACCOUNT_STATEMENTS_AVERAGE_STATEMENT_MONTH_ASC = 'UTILITY_ACCOUNT_STATEMENTS_AVERAGE_STATEMENT_MONTH_ASC',
  UTILITY_ACCOUNT_STATEMENTS_AVERAGE_STATEMENT_MONTH_DESC = 'UTILITY_ACCOUNT_STATEMENTS_AVERAGE_STATEMENT_MONTH_DESC',
  UTILITY_ACCOUNT_STATEMENTS_AVERAGE_STATEMENT_YEAR_ASC = 'UTILITY_ACCOUNT_STATEMENTS_AVERAGE_STATEMENT_YEAR_ASC',
  UTILITY_ACCOUNT_STATEMENTS_AVERAGE_STATEMENT_YEAR_DESC = 'UTILITY_ACCOUNT_STATEMENTS_AVERAGE_STATEMENT_YEAR_DESC',
  UTILITY_ACCOUNT_STATEMENTS_AVERAGE_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENTS_AVERAGE_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENTS_AVERAGE_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENTS_AVERAGE_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENTS_COUNT_ASC = 'UTILITY_ACCOUNT_STATEMENTS_COUNT_ASC',
  UTILITY_ACCOUNT_STATEMENTS_COUNT_DESC = 'UTILITY_ACCOUNT_STATEMENTS_COUNT_DESC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_ACCOUNT_LABEL_ASC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_ACCOUNT_LABEL_ASC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_ACCOUNT_LABEL_DESC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_ACCOUNT_LABEL_DESC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_BILL_ARRIVAL_DATE_ASC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_BILL_ARRIVAL_DATE_ASC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_BILL_ARRIVAL_DATE_DESC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_BILL_ARRIVAL_DATE_DESC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_ACCOUNT_LABEL_ASC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_ACCOUNT_LABEL_ASC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_ACCOUNT_LABEL_DESC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_ACCOUNT_LABEL_DESC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_ASC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_ASC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_DESC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_DESC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_CURRENCY_CODE_ASC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_CURRENCY_CODE_ASC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_CURRENCY_CODE_DESC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_CURRENCY_CODE_DESC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_INTERVAL_END_ASC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_INTERVAL_END_ASC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_INTERVAL_END_DESC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_INTERVAL_END_DESC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_INTERVAL_START_ASC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_INTERVAL_START_ASC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_INTERVAL_START_DESC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_INTERVAL_START_DESC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_IS_VALIDATED_ASC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_IS_VALIDATED_ASC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_IS_VALIDATED_DESC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_IS_VALIDATED_DESC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_PROVIDER_ASC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_PROVIDER_ASC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_PROVIDER_DESC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_PROVIDER_DESC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_STATEMENT_MONTH_ASC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_STATEMENT_MONTH_ASC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_STATEMENT_MONTH_DESC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_STATEMENT_MONTH_DESC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_STATEMENT_YEAR_ASC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_STATEMENT_YEAR_ASC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_STATEMENT_YEAR_DESC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_STATEMENT_YEAR_DESC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_CURRENCY_CODE_ASC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_CURRENCY_CODE_ASC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_CURRENCY_CODE_DESC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_CURRENCY_CODE_DESC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_INTERVAL_END_ASC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_INTERVAL_END_ASC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_INTERVAL_END_DESC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_INTERVAL_END_DESC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_INTERVAL_START_ASC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_INTERVAL_START_ASC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_INTERVAL_START_DESC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_INTERVAL_START_DESC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_IS_VALIDATED_ASC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_IS_VALIDATED_ASC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_IS_VALIDATED_DESC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_IS_VALIDATED_DESC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_PROVIDER_ASC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_PROVIDER_ASC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_PROVIDER_DESC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_PROVIDER_DESC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_STATEMENT_MONTH_ASC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_STATEMENT_MONTH_ASC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_STATEMENT_MONTH_DESC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_STATEMENT_MONTH_DESC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_STATEMENT_YEAR_ASC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_STATEMENT_YEAR_ASC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_STATEMENT_YEAR_DESC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_STATEMENT_YEAR_DESC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENTS_DISTINCT_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENTS_DISTINCT_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENTS_MAX_ACCOUNT_LABEL_ASC = 'UTILITY_ACCOUNT_STATEMENTS_MAX_ACCOUNT_LABEL_ASC',
  UTILITY_ACCOUNT_STATEMENTS_MAX_ACCOUNT_LABEL_DESC = 'UTILITY_ACCOUNT_STATEMENTS_MAX_ACCOUNT_LABEL_DESC',
  UTILITY_ACCOUNT_STATEMENTS_MAX_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENTS_MAX_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENTS_MAX_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENTS_MAX_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENTS_MAX_BILL_ARRIVAL_DATE_ASC = 'UTILITY_ACCOUNT_STATEMENTS_MAX_BILL_ARRIVAL_DATE_ASC',
  UTILITY_ACCOUNT_STATEMENTS_MAX_BILL_ARRIVAL_DATE_DESC = 'UTILITY_ACCOUNT_STATEMENTS_MAX_BILL_ARRIVAL_DATE_DESC',
  UTILITY_ACCOUNT_STATEMENTS_MAX_CURRENCY_CODE_ASC = 'UTILITY_ACCOUNT_STATEMENTS_MAX_CURRENCY_CODE_ASC',
  UTILITY_ACCOUNT_STATEMENTS_MAX_CURRENCY_CODE_DESC = 'UTILITY_ACCOUNT_STATEMENTS_MAX_CURRENCY_CODE_DESC',
  UTILITY_ACCOUNT_STATEMENTS_MAX_INTERVAL_END_ASC = 'UTILITY_ACCOUNT_STATEMENTS_MAX_INTERVAL_END_ASC',
  UTILITY_ACCOUNT_STATEMENTS_MAX_INTERVAL_END_DESC = 'UTILITY_ACCOUNT_STATEMENTS_MAX_INTERVAL_END_DESC',
  UTILITY_ACCOUNT_STATEMENTS_MAX_INTERVAL_START_ASC = 'UTILITY_ACCOUNT_STATEMENTS_MAX_INTERVAL_START_ASC',
  UTILITY_ACCOUNT_STATEMENTS_MAX_INTERVAL_START_DESC = 'UTILITY_ACCOUNT_STATEMENTS_MAX_INTERVAL_START_DESC',
  UTILITY_ACCOUNT_STATEMENTS_MAX_IS_VALIDATED_ASC = 'UTILITY_ACCOUNT_STATEMENTS_MAX_IS_VALIDATED_ASC',
  UTILITY_ACCOUNT_STATEMENTS_MAX_IS_VALIDATED_DESC = 'UTILITY_ACCOUNT_STATEMENTS_MAX_IS_VALIDATED_DESC',
  UTILITY_ACCOUNT_STATEMENTS_MAX_PROVIDER_ASC = 'UTILITY_ACCOUNT_STATEMENTS_MAX_PROVIDER_ASC',
  UTILITY_ACCOUNT_STATEMENTS_MAX_PROVIDER_DESC = 'UTILITY_ACCOUNT_STATEMENTS_MAX_PROVIDER_DESC',
  UTILITY_ACCOUNT_STATEMENTS_MAX_STATEMENT_MONTH_ASC = 'UTILITY_ACCOUNT_STATEMENTS_MAX_STATEMENT_MONTH_ASC',
  UTILITY_ACCOUNT_STATEMENTS_MAX_STATEMENT_MONTH_DESC = 'UTILITY_ACCOUNT_STATEMENTS_MAX_STATEMENT_MONTH_DESC',
  UTILITY_ACCOUNT_STATEMENTS_MAX_STATEMENT_YEAR_ASC = 'UTILITY_ACCOUNT_STATEMENTS_MAX_STATEMENT_YEAR_ASC',
  UTILITY_ACCOUNT_STATEMENTS_MAX_STATEMENT_YEAR_DESC = 'UTILITY_ACCOUNT_STATEMENTS_MAX_STATEMENT_YEAR_DESC',
  UTILITY_ACCOUNT_STATEMENTS_MAX_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENTS_MAX_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENTS_MAX_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENTS_MAX_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENTS_MIN_ACCOUNT_LABEL_ASC = 'UTILITY_ACCOUNT_STATEMENTS_MIN_ACCOUNT_LABEL_ASC',
  UTILITY_ACCOUNT_STATEMENTS_MIN_ACCOUNT_LABEL_DESC = 'UTILITY_ACCOUNT_STATEMENTS_MIN_ACCOUNT_LABEL_DESC',
  UTILITY_ACCOUNT_STATEMENTS_MIN_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENTS_MIN_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENTS_MIN_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENTS_MIN_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENTS_MIN_BILL_ARRIVAL_DATE_ASC = 'UTILITY_ACCOUNT_STATEMENTS_MIN_BILL_ARRIVAL_DATE_ASC',
  UTILITY_ACCOUNT_STATEMENTS_MIN_BILL_ARRIVAL_DATE_DESC = 'UTILITY_ACCOUNT_STATEMENTS_MIN_BILL_ARRIVAL_DATE_DESC',
  UTILITY_ACCOUNT_STATEMENTS_MIN_CURRENCY_CODE_ASC = 'UTILITY_ACCOUNT_STATEMENTS_MIN_CURRENCY_CODE_ASC',
  UTILITY_ACCOUNT_STATEMENTS_MIN_CURRENCY_CODE_DESC = 'UTILITY_ACCOUNT_STATEMENTS_MIN_CURRENCY_CODE_DESC',
  UTILITY_ACCOUNT_STATEMENTS_MIN_INTERVAL_END_ASC = 'UTILITY_ACCOUNT_STATEMENTS_MIN_INTERVAL_END_ASC',
  UTILITY_ACCOUNT_STATEMENTS_MIN_INTERVAL_END_DESC = 'UTILITY_ACCOUNT_STATEMENTS_MIN_INTERVAL_END_DESC',
  UTILITY_ACCOUNT_STATEMENTS_MIN_INTERVAL_START_ASC = 'UTILITY_ACCOUNT_STATEMENTS_MIN_INTERVAL_START_ASC',
  UTILITY_ACCOUNT_STATEMENTS_MIN_INTERVAL_START_DESC = 'UTILITY_ACCOUNT_STATEMENTS_MIN_INTERVAL_START_DESC',
  UTILITY_ACCOUNT_STATEMENTS_MIN_IS_VALIDATED_ASC = 'UTILITY_ACCOUNT_STATEMENTS_MIN_IS_VALIDATED_ASC',
  UTILITY_ACCOUNT_STATEMENTS_MIN_IS_VALIDATED_DESC = 'UTILITY_ACCOUNT_STATEMENTS_MIN_IS_VALIDATED_DESC',
  UTILITY_ACCOUNT_STATEMENTS_MIN_PROVIDER_ASC = 'UTILITY_ACCOUNT_STATEMENTS_MIN_PROVIDER_ASC',
  UTILITY_ACCOUNT_STATEMENTS_MIN_PROVIDER_DESC = 'UTILITY_ACCOUNT_STATEMENTS_MIN_PROVIDER_DESC',
  UTILITY_ACCOUNT_STATEMENTS_MIN_STATEMENT_MONTH_ASC = 'UTILITY_ACCOUNT_STATEMENTS_MIN_STATEMENT_MONTH_ASC',
  UTILITY_ACCOUNT_STATEMENTS_MIN_STATEMENT_MONTH_DESC = 'UTILITY_ACCOUNT_STATEMENTS_MIN_STATEMENT_MONTH_DESC',
  UTILITY_ACCOUNT_STATEMENTS_MIN_STATEMENT_YEAR_ASC = 'UTILITY_ACCOUNT_STATEMENTS_MIN_STATEMENT_YEAR_ASC',
  UTILITY_ACCOUNT_STATEMENTS_MIN_STATEMENT_YEAR_DESC = 'UTILITY_ACCOUNT_STATEMENTS_MIN_STATEMENT_YEAR_DESC',
  UTILITY_ACCOUNT_STATEMENTS_MIN_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENTS_MIN_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENTS_MIN_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENTS_MIN_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_ACCOUNT_LABEL_ASC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_ACCOUNT_LABEL_ASC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_ACCOUNT_LABEL_DESC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_ACCOUNT_LABEL_DESC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_ASC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_ASC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_DESC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_DESC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_CURRENCY_CODE_ASC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_CURRENCY_CODE_ASC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_CURRENCY_CODE_DESC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_CURRENCY_CODE_DESC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_INTERVAL_END_ASC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_INTERVAL_END_ASC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_INTERVAL_END_DESC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_INTERVAL_END_DESC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_INTERVAL_START_ASC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_INTERVAL_START_ASC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_INTERVAL_START_DESC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_INTERVAL_START_DESC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_IS_VALIDATED_ASC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_IS_VALIDATED_ASC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_IS_VALIDATED_DESC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_IS_VALIDATED_DESC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_PROVIDER_ASC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_PROVIDER_ASC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_PROVIDER_DESC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_PROVIDER_DESC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_STATEMENT_MONTH_ASC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_STATEMENT_MONTH_ASC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_STATEMENT_MONTH_DESC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_STATEMENT_MONTH_DESC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_STATEMENT_YEAR_ASC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_STATEMENT_YEAR_ASC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_STATEMENT_YEAR_DESC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_STATEMENT_YEAR_DESC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_LABEL_ASC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_LABEL_ASC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_LABEL_DESC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_LABEL_DESC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_ASC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_ASC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_DESC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_DESC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_CURRENCY_CODE_ASC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_CURRENCY_CODE_ASC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_CURRENCY_CODE_DESC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_CURRENCY_CODE_DESC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_INTERVAL_END_ASC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_INTERVAL_END_ASC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_INTERVAL_END_DESC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_INTERVAL_END_DESC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_INTERVAL_START_ASC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_INTERVAL_START_ASC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_INTERVAL_START_DESC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_INTERVAL_START_DESC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_IS_VALIDATED_ASC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_IS_VALIDATED_ASC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_IS_VALIDATED_DESC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_IS_VALIDATED_DESC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_PROVIDER_ASC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_PROVIDER_ASC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_PROVIDER_DESC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_PROVIDER_DESC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_STATEMENT_MONTH_ASC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_STATEMENT_MONTH_ASC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_STATEMENT_MONTH_DESC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_STATEMENT_MONTH_DESC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_STATEMENT_YEAR_ASC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_STATEMENT_YEAR_ASC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_STATEMENT_YEAR_DESC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_STATEMENT_YEAR_DESC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENTS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENTS_SUM_ACCOUNT_LABEL_ASC = 'UTILITY_ACCOUNT_STATEMENTS_SUM_ACCOUNT_LABEL_ASC',
  UTILITY_ACCOUNT_STATEMENTS_SUM_ACCOUNT_LABEL_DESC = 'UTILITY_ACCOUNT_STATEMENTS_SUM_ACCOUNT_LABEL_DESC',
  UTILITY_ACCOUNT_STATEMENTS_SUM_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENTS_SUM_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENTS_SUM_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENTS_SUM_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENTS_SUM_BILL_ARRIVAL_DATE_ASC = 'UTILITY_ACCOUNT_STATEMENTS_SUM_BILL_ARRIVAL_DATE_ASC',
  UTILITY_ACCOUNT_STATEMENTS_SUM_BILL_ARRIVAL_DATE_DESC = 'UTILITY_ACCOUNT_STATEMENTS_SUM_BILL_ARRIVAL_DATE_DESC',
  UTILITY_ACCOUNT_STATEMENTS_SUM_CURRENCY_CODE_ASC = 'UTILITY_ACCOUNT_STATEMENTS_SUM_CURRENCY_CODE_ASC',
  UTILITY_ACCOUNT_STATEMENTS_SUM_CURRENCY_CODE_DESC = 'UTILITY_ACCOUNT_STATEMENTS_SUM_CURRENCY_CODE_DESC',
  UTILITY_ACCOUNT_STATEMENTS_SUM_INTERVAL_END_ASC = 'UTILITY_ACCOUNT_STATEMENTS_SUM_INTERVAL_END_ASC',
  UTILITY_ACCOUNT_STATEMENTS_SUM_INTERVAL_END_DESC = 'UTILITY_ACCOUNT_STATEMENTS_SUM_INTERVAL_END_DESC',
  UTILITY_ACCOUNT_STATEMENTS_SUM_INTERVAL_START_ASC = 'UTILITY_ACCOUNT_STATEMENTS_SUM_INTERVAL_START_ASC',
  UTILITY_ACCOUNT_STATEMENTS_SUM_INTERVAL_START_DESC = 'UTILITY_ACCOUNT_STATEMENTS_SUM_INTERVAL_START_DESC',
  UTILITY_ACCOUNT_STATEMENTS_SUM_IS_VALIDATED_ASC = 'UTILITY_ACCOUNT_STATEMENTS_SUM_IS_VALIDATED_ASC',
  UTILITY_ACCOUNT_STATEMENTS_SUM_IS_VALIDATED_DESC = 'UTILITY_ACCOUNT_STATEMENTS_SUM_IS_VALIDATED_DESC',
  UTILITY_ACCOUNT_STATEMENTS_SUM_PROVIDER_ASC = 'UTILITY_ACCOUNT_STATEMENTS_SUM_PROVIDER_ASC',
  UTILITY_ACCOUNT_STATEMENTS_SUM_PROVIDER_DESC = 'UTILITY_ACCOUNT_STATEMENTS_SUM_PROVIDER_DESC',
  UTILITY_ACCOUNT_STATEMENTS_SUM_STATEMENT_MONTH_ASC = 'UTILITY_ACCOUNT_STATEMENTS_SUM_STATEMENT_MONTH_ASC',
  UTILITY_ACCOUNT_STATEMENTS_SUM_STATEMENT_MONTH_DESC = 'UTILITY_ACCOUNT_STATEMENTS_SUM_STATEMENT_MONTH_DESC',
  UTILITY_ACCOUNT_STATEMENTS_SUM_STATEMENT_YEAR_ASC = 'UTILITY_ACCOUNT_STATEMENTS_SUM_STATEMENT_YEAR_ASC',
  UTILITY_ACCOUNT_STATEMENTS_SUM_STATEMENT_YEAR_DESC = 'UTILITY_ACCOUNT_STATEMENTS_SUM_STATEMENT_YEAR_DESC',
  UTILITY_ACCOUNT_STATEMENTS_SUM_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENTS_SUM_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENTS_SUM_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENTS_SUM_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_LABEL_ASC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_LABEL_ASC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_LABEL_DESC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_LABEL_DESC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_ASC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_ASC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_DESC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_DESC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_CURRENCY_CODE_ASC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_CURRENCY_CODE_ASC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_CURRENCY_CODE_DESC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_CURRENCY_CODE_DESC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_INTERVAL_END_ASC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_INTERVAL_END_ASC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_INTERVAL_END_DESC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_INTERVAL_END_DESC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_INTERVAL_START_ASC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_INTERVAL_START_ASC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_INTERVAL_START_DESC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_INTERVAL_START_DESC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_IS_VALIDATED_ASC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_IS_VALIDATED_ASC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_IS_VALIDATED_DESC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_IS_VALIDATED_DESC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_PROVIDER_ASC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_PROVIDER_ASC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_PROVIDER_DESC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_PROVIDER_DESC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_STATEMENT_MONTH_ASC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_STATEMENT_MONTH_ASC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_STATEMENT_MONTH_DESC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_STATEMENT_MONTH_DESC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_STATEMENT_YEAR_ASC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_STATEMENT_YEAR_ASC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_STATEMENT_YEAR_DESC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_STATEMENT_YEAR_DESC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_LABEL_ASC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_LABEL_ASC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_LABEL_DESC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_LABEL_DESC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_ASC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_ASC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_DESC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_DESC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_CURRENCY_CODE_ASC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_CURRENCY_CODE_ASC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_CURRENCY_CODE_DESC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_CURRENCY_CODE_DESC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_INTERVAL_END_ASC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_INTERVAL_END_ASC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_INTERVAL_END_DESC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_INTERVAL_END_DESC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_INTERVAL_START_ASC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_INTERVAL_START_ASC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_INTERVAL_START_DESC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_INTERVAL_START_DESC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_IS_VALIDATED_ASC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_IS_VALIDATED_ASC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_IS_VALIDATED_DESC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_IS_VALIDATED_DESC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_PROVIDER_ASC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_PROVIDER_ASC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_PROVIDER_DESC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_PROVIDER_DESC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_MONTH_ASC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_MONTH_ASC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_MONTH_DESC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_MONTH_DESC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_YEAR_ASC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_YEAR_ASC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_YEAR_DESC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_YEAR_DESC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENTS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_LABEL_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_LABEL_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_LABEL_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_LABEL_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_BILL_ARRIVAL_DATE_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_BILL_ARRIVAL_DATE_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_BILL_ARRIVAL_DATE_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_BILL_ARRIVAL_DATE_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_BILL_COST_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_BILL_COST_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_BILL_COST_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_BILL_COST_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_BILL_DEMAND_COST_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_BILL_DEMAND_COST_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_BILL_DEMAND_COST_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_BILL_DEMAND_COST_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_BILL_USAGE_COST_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_BILL_USAGE_COST_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_BILL_USAGE_COST_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_BILL_USAGE_COST_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_CREDITS_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_CREDITS_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_CREDITS_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_CREDITS_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_CURRENCY_CODE_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_CURRENCY_CODE_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_CURRENCY_CODE_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_CURRENCY_CODE_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_FEES_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_FEES_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_FEES_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_FEES_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_INTERVAL_END_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_INTERVAL_END_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_INTERVAL_END_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_INTERVAL_END_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_INTERVAL_START_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_INTERVAL_START_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_INTERVAL_START_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_INTERVAL_START_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_IS_VALIDATED_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_IS_VALIDATED_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_IS_VALIDATED_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_IS_VALIDATED_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_PERCENT_CHANGE_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_PERCENT_CHANGE_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_PERCENT_CHANGE_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_PERCENT_CHANGE_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_PROVIDER_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_PROVIDER_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_PROVIDER_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_PROVIDER_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_MONTH_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_MONTH_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_MONTH_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_MONTH_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_YEAR_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_YEAR_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_YEAR_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_YEAR_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_TAXES_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_TAXES_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_TAXES_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_TAXES_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_AVERAGE_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_COUNT_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_COUNT_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_COUNT_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_COUNT_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_LABEL_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_LABEL_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_LABEL_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_LABEL_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_BILL_ARRIVAL_DATE_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_BILL_ARRIVAL_DATE_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_BILL_ARRIVAL_DATE_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_BILL_ARRIVAL_DATE_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_BILL_COST_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_BILL_COST_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_BILL_COST_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_BILL_COST_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_BILL_DEMAND_COST_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_BILL_DEMAND_COST_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_BILL_DEMAND_COST_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_BILL_DEMAND_COST_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_BILL_USAGE_COST_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_BILL_USAGE_COST_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_BILL_USAGE_COST_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_BILL_USAGE_COST_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_LABEL_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_LABEL_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_LABEL_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_LABEL_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_COST_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_COST_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_COST_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_COST_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_DEMAND_COST_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_DEMAND_COST_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_DEMAND_COST_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_DEMAND_COST_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_USAGE_COST_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_USAGE_COST_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_USAGE_COST_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_USAGE_COST_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_CREDITS_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_CREDITS_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_CREDITS_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_CREDITS_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_CURRENCY_CODE_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_CURRENCY_CODE_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_CURRENCY_CODE_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_CURRENCY_CODE_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_FEES_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_FEES_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_FEES_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_FEES_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_INTERVAL_END_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_INTERVAL_END_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_INTERVAL_END_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_INTERVAL_END_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_INTERVAL_START_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_INTERVAL_START_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_INTERVAL_START_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_INTERVAL_START_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_IS_VALIDATED_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_IS_VALIDATED_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_IS_VALIDATED_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_IS_VALIDATED_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_PERCENT_CHANGE_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_PERCENT_CHANGE_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_PERCENT_CHANGE_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_PERCENT_CHANGE_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_PROVIDER_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_PROVIDER_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_PROVIDER_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_PROVIDER_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_MONTH_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_MONTH_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_MONTH_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_MONTH_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_YEAR_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_YEAR_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_YEAR_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_YEAR_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_TAXES_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_TAXES_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_TAXES_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_TAXES_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_CREDITS_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_CREDITS_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_CREDITS_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_CREDITS_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_CURRENCY_CODE_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_CURRENCY_CODE_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_CURRENCY_CODE_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_CURRENCY_CODE_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_FEES_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_FEES_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_FEES_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_FEES_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_INTERVAL_END_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_INTERVAL_END_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_INTERVAL_END_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_INTERVAL_END_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_INTERVAL_START_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_INTERVAL_START_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_INTERVAL_START_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_INTERVAL_START_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_IS_VALIDATED_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_IS_VALIDATED_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_IS_VALIDATED_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_IS_VALIDATED_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_PERCENT_CHANGE_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_PERCENT_CHANGE_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_PERCENT_CHANGE_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_PERCENT_CHANGE_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_PROVIDER_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_PROVIDER_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_PROVIDER_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_PROVIDER_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_MONTH_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_MONTH_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_MONTH_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_MONTH_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_YEAR_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_YEAR_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_YEAR_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_YEAR_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_TAXES_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_TAXES_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_TAXES_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_TAXES_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_DISTINCT_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_ACCOUNT_LABEL_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_ACCOUNT_LABEL_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_ACCOUNT_LABEL_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_ACCOUNT_LABEL_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_BILL_ARRIVAL_DATE_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_BILL_ARRIVAL_DATE_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_BILL_ARRIVAL_DATE_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_BILL_ARRIVAL_DATE_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_BILL_COST_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_BILL_COST_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_BILL_COST_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_BILL_COST_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_BILL_DEMAND_COST_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_BILL_DEMAND_COST_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_BILL_DEMAND_COST_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_BILL_DEMAND_COST_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_BILL_USAGE_COST_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_BILL_USAGE_COST_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_BILL_USAGE_COST_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_BILL_USAGE_COST_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_CREDITS_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_CREDITS_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_CREDITS_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_CREDITS_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_CURRENCY_CODE_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_CURRENCY_CODE_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_CURRENCY_CODE_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_CURRENCY_CODE_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_FEES_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_FEES_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_FEES_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_FEES_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_INTERVAL_END_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_INTERVAL_END_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_INTERVAL_END_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_INTERVAL_END_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_INTERVAL_START_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_INTERVAL_START_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_INTERVAL_START_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_INTERVAL_START_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_IS_VALIDATED_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_IS_VALIDATED_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_IS_VALIDATED_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_IS_VALIDATED_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_PERCENT_CHANGE_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_PERCENT_CHANGE_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_PERCENT_CHANGE_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_PERCENT_CHANGE_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_PROVIDER_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_PROVIDER_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_PROVIDER_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_PROVIDER_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_STATEMENT_MONTH_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_STATEMENT_MONTH_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_STATEMENT_MONTH_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_STATEMENT_MONTH_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_STATEMENT_YEAR_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_STATEMENT_YEAR_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_STATEMENT_YEAR_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_STATEMENT_YEAR_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_TAXES_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_TAXES_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_TAXES_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_TAXES_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MAX_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_ACCOUNT_LABEL_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_ACCOUNT_LABEL_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_ACCOUNT_LABEL_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_ACCOUNT_LABEL_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_BILL_ARRIVAL_DATE_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_BILL_ARRIVAL_DATE_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_BILL_ARRIVAL_DATE_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_BILL_ARRIVAL_DATE_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_BILL_COST_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_BILL_COST_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_BILL_COST_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_BILL_COST_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_BILL_DEMAND_COST_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_BILL_DEMAND_COST_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_BILL_DEMAND_COST_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_BILL_DEMAND_COST_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_BILL_USAGE_COST_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_BILL_USAGE_COST_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_BILL_USAGE_COST_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_BILL_USAGE_COST_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_CREDITS_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_CREDITS_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_CREDITS_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_CREDITS_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_CURRENCY_CODE_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_CURRENCY_CODE_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_CURRENCY_CODE_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_CURRENCY_CODE_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_FEES_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_FEES_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_FEES_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_FEES_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_INTERVAL_END_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_INTERVAL_END_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_INTERVAL_END_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_INTERVAL_END_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_INTERVAL_START_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_INTERVAL_START_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_INTERVAL_START_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_INTERVAL_START_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_IS_VALIDATED_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_IS_VALIDATED_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_IS_VALIDATED_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_IS_VALIDATED_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_PERCENT_CHANGE_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_PERCENT_CHANGE_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_PERCENT_CHANGE_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_PERCENT_CHANGE_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_PROVIDER_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_PROVIDER_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_PROVIDER_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_PROVIDER_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_STATEMENT_MONTH_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_STATEMENT_MONTH_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_STATEMENT_MONTH_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_STATEMENT_MONTH_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_STATEMENT_YEAR_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_STATEMENT_YEAR_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_STATEMENT_YEAR_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_STATEMENT_YEAR_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_TAXES_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_TAXES_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_TAXES_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_TAXES_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_MIN_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_LABEL_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_LABEL_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_LABEL_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_LABEL_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_COST_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_COST_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_COST_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_COST_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_DEMAND_COST_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_DEMAND_COST_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_DEMAND_COST_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_DEMAND_COST_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_USAGE_COST_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_USAGE_COST_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_USAGE_COST_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_USAGE_COST_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_CREDITS_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_CREDITS_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_CREDITS_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_CREDITS_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_CURRENCY_CODE_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_CURRENCY_CODE_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_CURRENCY_CODE_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_CURRENCY_CODE_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_FEES_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_FEES_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_FEES_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_FEES_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_INTERVAL_END_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_INTERVAL_END_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_INTERVAL_END_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_INTERVAL_END_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_INTERVAL_START_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_INTERVAL_START_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_INTERVAL_START_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_INTERVAL_START_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_IS_VALIDATED_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_IS_VALIDATED_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_IS_VALIDATED_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_IS_VALIDATED_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_PERCENT_CHANGE_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_PERCENT_CHANGE_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_PERCENT_CHANGE_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_PERCENT_CHANGE_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_PROVIDER_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_PROVIDER_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_PROVIDER_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_PROVIDER_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_MONTH_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_MONTH_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_MONTH_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_MONTH_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_YEAR_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_YEAR_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_YEAR_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_YEAR_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_TAXES_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_TAXES_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_TAXES_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_TAXES_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_LABEL_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_LABEL_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_LABEL_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_LABEL_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_COST_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_COST_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_COST_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_COST_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_DEMAND_COST_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_DEMAND_COST_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_DEMAND_COST_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_DEMAND_COST_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_USAGE_COST_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_USAGE_COST_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_USAGE_COST_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_USAGE_COST_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CREDITS_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CREDITS_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CREDITS_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CREDITS_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CURRENCY_CODE_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CURRENCY_CODE_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CURRENCY_CODE_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CURRENCY_CODE_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_FEES_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_FEES_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_FEES_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_FEES_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_INTERVAL_END_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_INTERVAL_END_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_INTERVAL_END_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_INTERVAL_END_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_INTERVAL_START_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_INTERVAL_START_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_INTERVAL_START_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_INTERVAL_START_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_IS_VALIDATED_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_IS_VALIDATED_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_IS_VALIDATED_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_IS_VALIDATED_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PERCENT_CHANGE_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PERCENT_CHANGE_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PERCENT_CHANGE_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PERCENT_CHANGE_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PROVIDER_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PROVIDER_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PROVIDER_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PROVIDER_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_MONTH_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_MONTH_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_MONTH_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_MONTH_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_YEAR_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_YEAR_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_YEAR_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_YEAR_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_TAXES_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_TAXES_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_TAXES_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_TAXES_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_ACCOUNT_LABEL_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_ACCOUNT_LABEL_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_ACCOUNT_LABEL_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_ACCOUNT_LABEL_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_BILL_ARRIVAL_DATE_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_BILL_ARRIVAL_DATE_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_BILL_ARRIVAL_DATE_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_BILL_ARRIVAL_DATE_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_BILL_COST_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_BILL_COST_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_BILL_COST_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_BILL_COST_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_BILL_DEMAND_COST_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_BILL_DEMAND_COST_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_BILL_DEMAND_COST_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_BILL_DEMAND_COST_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_BILL_USAGE_COST_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_BILL_USAGE_COST_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_BILL_USAGE_COST_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_BILL_USAGE_COST_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_CREDITS_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_CREDITS_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_CREDITS_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_CREDITS_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_CURRENCY_CODE_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_CURRENCY_CODE_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_CURRENCY_CODE_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_CURRENCY_CODE_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_FEES_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_FEES_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_FEES_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_FEES_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_INTERVAL_END_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_INTERVAL_END_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_INTERVAL_END_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_INTERVAL_END_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_INTERVAL_START_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_INTERVAL_START_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_INTERVAL_START_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_INTERVAL_START_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_IS_VALIDATED_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_IS_VALIDATED_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_IS_VALIDATED_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_IS_VALIDATED_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_PERCENT_CHANGE_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_PERCENT_CHANGE_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_PERCENT_CHANGE_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_PERCENT_CHANGE_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_PROVIDER_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_PROVIDER_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_PROVIDER_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_PROVIDER_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_STATEMENT_MONTH_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_STATEMENT_MONTH_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_STATEMENT_MONTH_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_STATEMENT_MONTH_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_STATEMENT_YEAR_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_STATEMENT_YEAR_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_STATEMENT_YEAR_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_STATEMENT_YEAR_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_TAXES_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_TAXES_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_TAXES_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_TAXES_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_SUM_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_LABEL_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_LABEL_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_LABEL_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_LABEL_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_COST_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_COST_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_COST_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_COST_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_DEMAND_COST_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_DEMAND_COST_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_DEMAND_COST_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_DEMAND_COST_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_USAGE_COST_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_USAGE_COST_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_USAGE_COST_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_USAGE_COST_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CREDITS_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CREDITS_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CREDITS_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CREDITS_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CURRENCY_CODE_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CURRENCY_CODE_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CURRENCY_CODE_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CURRENCY_CODE_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_FEES_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_FEES_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_FEES_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_FEES_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_INTERVAL_END_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_INTERVAL_END_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_INTERVAL_END_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_INTERVAL_END_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_INTERVAL_START_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_INTERVAL_START_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_INTERVAL_START_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_INTERVAL_START_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_IS_VALIDATED_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_IS_VALIDATED_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_IS_VALIDATED_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_IS_VALIDATED_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PERCENT_CHANGE_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PERCENT_CHANGE_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PERCENT_CHANGE_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PERCENT_CHANGE_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PROVIDER_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PROVIDER_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PROVIDER_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PROVIDER_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_MONTH_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_MONTH_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_MONTH_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_MONTH_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_YEAR_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_YEAR_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_YEAR_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_YEAR_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_TAXES_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_TAXES_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_TAXES_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_TAXES_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_LABEL_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_LABEL_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_LABEL_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_LABEL_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_COST_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_COST_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_COST_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_COST_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_DEMAND_COST_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_DEMAND_COST_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_DEMAND_COST_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_DEMAND_COST_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_USAGE_COST_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_USAGE_COST_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_USAGE_COST_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_USAGE_COST_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CREDITS_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CREDITS_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CREDITS_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CREDITS_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CURRENCY_CODE_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CURRENCY_CODE_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CURRENCY_CODE_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CURRENCY_CODE_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_FEES_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_FEES_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_FEES_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_FEES_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_INTERVAL_END_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_INTERVAL_END_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_INTERVAL_END_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_INTERVAL_END_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_INTERVAL_START_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_INTERVAL_START_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_INTERVAL_START_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_INTERVAL_START_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_IS_VALIDATED_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_IS_VALIDATED_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_IS_VALIDATED_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_IS_VALIDATED_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PERCENT_CHANGE_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PERCENT_CHANGE_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PERCENT_CHANGE_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PERCENT_CHANGE_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PROVIDER_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PROVIDER_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PROVIDER_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PROVIDER_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_MONTH_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_MONTH_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_MONTH_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_MONTH_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_YEAR_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_YEAR_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_YEAR_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_YEAR_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_TAXES_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_TAXES_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_TAXES_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_TAXES_DESC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_ACCOUNT_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_CREDENTIAL_ID_ASC = 'UTILITY_CREDENTIAL_ID_ASC',
  UTILITY_CREDENTIAL_ID_DESC = 'UTILITY_CREDENTIAL_ID_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_STATEMENT_PDF_ID_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_STATEMENT_PDF_ID_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_STATEMENT_PDF_ID_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_STATEMENT_PDF_ID_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_COUNT_ASC = 'UTILITY_METER_STATEMENTS_COUNT_ASC',
  UTILITY_METER_STATEMENTS_COUNT_DESC = 'UTILITY_METER_STATEMENTS_COUNT_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_STATEMENT_PDF_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_STATEMENT_PDF_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_STATEMENT_PDF_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_STATEMENT_PDF_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_STATEMENT_PDF_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_STATEMENT_PDF_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_STATEMENT_PDF_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_STATEMENT_PDF_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_MAX_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_MAX_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_MAX_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_MAX_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_MAX_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_MAX_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_MAX_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_MAX_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_MAX_ACCOUNT_STATEMENT_PDF_ID_ASC = 'UTILITY_METER_STATEMENTS_MAX_ACCOUNT_STATEMENT_PDF_ID_ASC',
  UTILITY_METER_STATEMENTS_MAX_ACCOUNT_STATEMENT_PDF_ID_DESC = 'UTILITY_METER_STATEMENTS_MAX_ACCOUNT_STATEMENT_PDF_ID_DESC',
  UTILITY_METER_STATEMENTS_MAX_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_MAX_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_MAX_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_MAX_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_MAX_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_MAX_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_MAX_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_MAX_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_MAX_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_MAX_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_MAX_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_MAX_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_MAX_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_MAX_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_MAX_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_MAX_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_MAX_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_MAX_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_MAX_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_MAX_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_MAX_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_MAX_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_MAX_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_MAX_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_MAX_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_MAX_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_MAX_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_MAX_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_MAX_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_MAX_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_MAX_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_MAX_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_MAX_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_MAX_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_MAX_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_MAX_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_MAX_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_MAX_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_MAX_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_MAX_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_MAX_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_MAX_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_MAX_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_MAX_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_MAX_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_MAX_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_MAX_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_MAX_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_MAX_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_MAX_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_MAX_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_MAX_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_MAX_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_MAX_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_MAX_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_MAX_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_MAX_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_MAX_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_MAX_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_MAX_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_MAX_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_MAX_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_MAX_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_MAX_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_MAX_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_MAX_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_MAX_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_MAX_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_MAX_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_MAX_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_MAX_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_MAX_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_MAX_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_MAX_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_MAX_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_MAX_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_MIN_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_MIN_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_MIN_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_MIN_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_MIN_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_MIN_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_MIN_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_MIN_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_MIN_ACCOUNT_STATEMENT_PDF_ID_ASC = 'UTILITY_METER_STATEMENTS_MIN_ACCOUNT_STATEMENT_PDF_ID_ASC',
  UTILITY_METER_STATEMENTS_MIN_ACCOUNT_STATEMENT_PDF_ID_DESC = 'UTILITY_METER_STATEMENTS_MIN_ACCOUNT_STATEMENT_PDF_ID_DESC',
  UTILITY_METER_STATEMENTS_MIN_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_MIN_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_MIN_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_MIN_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_MIN_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_MIN_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_MIN_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_MIN_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_MIN_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_MIN_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_MIN_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_MIN_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_MIN_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_MIN_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_MIN_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_MIN_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_MIN_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_MIN_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_MIN_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_MIN_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_MIN_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_MIN_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_MIN_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_MIN_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_MIN_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_MIN_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_MIN_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_MIN_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_MIN_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_MIN_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_MIN_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_MIN_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_MIN_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_MIN_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_MIN_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_MIN_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_MIN_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_MIN_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_MIN_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_MIN_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_MIN_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_MIN_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_MIN_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_MIN_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_MIN_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_MIN_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_MIN_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_MIN_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_MIN_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_MIN_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_MIN_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_MIN_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_MIN_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_MIN_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_MIN_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_MIN_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_MIN_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_MIN_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_MIN_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_MIN_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_MIN_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_MIN_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_MIN_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_MIN_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_MIN_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_MIN_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_MIN_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_MIN_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_MIN_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_MIN_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_MIN_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_MIN_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_MIN_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_MIN_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_MIN_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_MIN_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_STATEMENT_PDF_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_STATEMENT_PDF_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_STATEMENT_PDF_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_STATEMENT_PDF_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_PDF_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_PDF_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_PDF_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_PDF_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_SUM_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_SUM_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_SUM_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_SUM_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_SUM_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_SUM_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_SUM_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_SUM_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_SUM_ACCOUNT_STATEMENT_PDF_ID_ASC = 'UTILITY_METER_STATEMENTS_SUM_ACCOUNT_STATEMENT_PDF_ID_ASC',
  UTILITY_METER_STATEMENTS_SUM_ACCOUNT_STATEMENT_PDF_ID_DESC = 'UTILITY_METER_STATEMENTS_SUM_ACCOUNT_STATEMENT_PDF_ID_DESC',
  UTILITY_METER_STATEMENTS_SUM_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_SUM_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_SUM_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_SUM_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_SUM_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_SUM_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_SUM_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_SUM_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_SUM_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_SUM_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_SUM_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_SUM_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_SUM_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_SUM_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_SUM_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_SUM_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_SUM_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_SUM_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_SUM_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_SUM_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_SUM_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_SUM_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_SUM_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_SUM_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_SUM_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_SUM_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_SUM_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_SUM_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_SUM_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_SUM_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_SUM_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_SUM_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_SUM_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_SUM_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_SUM_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_SUM_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_SUM_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_SUM_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_SUM_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_SUM_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_SUM_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_SUM_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_SUM_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_SUM_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_SUM_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_SUM_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_SUM_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_SUM_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_SUM_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_SUM_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_SUM_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_SUM_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_SUM_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_SUM_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_SUM_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_SUM_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_SUM_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_SUM_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_SUM_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_SUM_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_SUM_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_SUM_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_SUM_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_SUM_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_SUM_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_SUM_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_SUM_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_SUM_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_SUM_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_SUM_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_SUM_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_SUM_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_SUM_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_SUM_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_SUM_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_SUM_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_PDF_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_PDF_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_PDF_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_PDF_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_PDF_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_PDF_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_PDF_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_PDF_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_DEMAND_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_DEMAND_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_DEMAND_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_DEMAND_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_DEMAND_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_DEMAND_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_DEMAND_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_DEMAND_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_EXPORT_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_EXPORT_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_EXPORT_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_EXPORT_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_IMPORT_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_IMPORT_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_IMPORT_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_IMPORT_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_USAGE_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_USAGE_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_USAGE_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_USAGE_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BLENDED_RATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BLENDED_RATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BLENDED_RATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BLENDED_RATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_CREDITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_CREDITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_CREDITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_CREDITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_END_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_END_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_END_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_END_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_FEES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_FEES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_FEES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_FEES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_LOAD_FACTOR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_LOAD_FACTOR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_LOAD_FACTOR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_LOAD_FACTOR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_NET_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_NET_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_NET_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_NET_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_PERCENT_CHANGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_PERCENT_CHANGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_PERCENT_CHANGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_PERCENT_CHANGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_PROVIDER_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_PROVIDER_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_PROVIDER_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_PROVIDER_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_START_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_START_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_START_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_START_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_TAXES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_TAXES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_TAXES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_TAXES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_COUNT_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_COUNT_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_COUNT_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_COUNT_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_DEMAND_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_DEMAND_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_DEMAND_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_DEMAND_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_DEMAND_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_DEMAND_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_DEMAND_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_DEMAND_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_EXPORT_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_EXPORT_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_EXPORT_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_EXPORT_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_IMPORT_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_IMPORT_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_IMPORT_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_IMPORT_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_USAGE_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_USAGE_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_USAGE_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_USAGE_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BLENDED_RATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BLENDED_RATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BLENDED_RATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BLENDED_RATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_DEMAND_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_DEMAND_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_DEMAND_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_DEMAND_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_DEMAND_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_DEMAND_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_DEMAND_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_DEMAND_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_EXPORT_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_EXPORT_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_EXPORT_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_EXPORT_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_IMPORT_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_IMPORT_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_IMPORT_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_IMPORT_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_USAGE_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_USAGE_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_USAGE_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_USAGE_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BLENDED_RATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BLENDED_RATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BLENDED_RATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BLENDED_RATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_CREDITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_CREDITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_CREDITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_CREDITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_END_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_END_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_END_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_END_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_FEES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_FEES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_FEES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_FEES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_LOAD_FACTOR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_LOAD_FACTOR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_LOAD_FACTOR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_LOAD_FACTOR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_NET_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_NET_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_NET_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_NET_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_PERCENT_CHANGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_PERCENT_CHANGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_PERCENT_CHANGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_PERCENT_CHANGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_PROVIDER_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_PROVIDER_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_PROVIDER_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_PROVIDER_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_START_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_START_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_START_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_START_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_TAXES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_TAXES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_TAXES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_TAXES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_CREDITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_CREDITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_CREDITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_CREDITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_END_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_END_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_END_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_END_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_FEES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_FEES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_FEES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_FEES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_LOAD_FACTOR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_LOAD_FACTOR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_LOAD_FACTOR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_LOAD_FACTOR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_NET_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_NET_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_NET_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_NET_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_PERCENT_CHANGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_PERCENT_CHANGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_PERCENT_CHANGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_PERCENT_CHANGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_PROVIDER_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_PROVIDER_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_PROVIDER_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_PROVIDER_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_START_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_START_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_START_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_START_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_TAXES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_TAXES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_TAXES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_TAXES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_DEMAND_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_DEMAND_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_DEMAND_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_DEMAND_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_DEMAND_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_DEMAND_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_DEMAND_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_DEMAND_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_EXPORT_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_EXPORT_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_EXPORT_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_EXPORT_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_IMPORT_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_IMPORT_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_IMPORT_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_IMPORT_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_USAGE_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_USAGE_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_USAGE_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_USAGE_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BLENDED_RATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BLENDED_RATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BLENDED_RATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BLENDED_RATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_CREDITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_CREDITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_CREDITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_CREDITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_END_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_END_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_END_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_END_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_FEES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_FEES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_FEES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_FEES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_LOAD_FACTOR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_LOAD_FACTOR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_LOAD_FACTOR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_LOAD_FACTOR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_NET_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_NET_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_NET_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_NET_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_PERCENT_CHANGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_PERCENT_CHANGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_PERCENT_CHANGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_PERCENT_CHANGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_PROVIDER_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_PROVIDER_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_PROVIDER_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_PROVIDER_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_START_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_START_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_START_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_START_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_TAXES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_TAXES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_TAXES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_TAXES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_DEMAND_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_DEMAND_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_DEMAND_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_DEMAND_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_DEMAND_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_DEMAND_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_DEMAND_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_DEMAND_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_EXPORT_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_EXPORT_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_EXPORT_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_EXPORT_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_IMPORT_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_IMPORT_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_IMPORT_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_IMPORT_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_USAGE_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_USAGE_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_USAGE_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_USAGE_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BLENDED_RATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BLENDED_RATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BLENDED_RATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BLENDED_RATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_CREDITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_CREDITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_CREDITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_CREDITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_END_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_END_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_END_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_END_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_FEES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_FEES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_FEES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_FEES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_LOAD_FACTOR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_LOAD_FACTOR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_LOAD_FACTOR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_LOAD_FACTOR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_NET_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_NET_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_NET_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_NET_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_PERCENT_CHANGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_PERCENT_CHANGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_PERCENT_CHANGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_PERCENT_CHANGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_PROVIDER_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_PROVIDER_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_PROVIDER_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_PROVIDER_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_START_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_START_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_START_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_START_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_TAXES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_TAXES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_TAXES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_TAXES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_DEMAND_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_DEMAND_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_DEMAND_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_DEMAND_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_DEMAND_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_DEMAND_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_DEMAND_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_DEMAND_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_EXPORT_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_EXPORT_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_EXPORT_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_EXPORT_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_IMPORT_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_IMPORT_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_IMPORT_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_IMPORT_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_USAGE_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_USAGE_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_USAGE_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_USAGE_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BLENDED_RATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BLENDED_RATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BLENDED_RATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BLENDED_RATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_CREDITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_CREDITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_CREDITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_CREDITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_END_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_END_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_END_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_END_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_FEES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_FEES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_FEES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_FEES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_LOAD_FACTOR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_LOAD_FACTOR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_LOAD_FACTOR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_LOAD_FACTOR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_NET_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_NET_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_NET_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_NET_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_PERCENT_CHANGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_PERCENT_CHANGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_PERCENT_CHANGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_PERCENT_CHANGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_PROVIDER_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_PROVIDER_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_PROVIDER_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_PROVIDER_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_START_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_START_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_START_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_START_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_TAXES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_TAXES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_TAXES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_TAXES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_DEMAND_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_DEMAND_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_DEMAND_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_DEMAND_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_DEMAND_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_DEMAND_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_DEMAND_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_DEMAND_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_EXPORT_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_EXPORT_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_EXPORT_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_EXPORT_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_IMPORT_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_IMPORT_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_IMPORT_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_IMPORT_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_USAGE_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_USAGE_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_USAGE_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_USAGE_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BLENDED_RATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BLENDED_RATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BLENDED_RATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BLENDED_RATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CREDITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CREDITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CREDITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CREDITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_END_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_END_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_END_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_END_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_FEES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_FEES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_FEES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_FEES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_LOAD_FACTOR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_LOAD_FACTOR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_LOAD_FACTOR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_LOAD_FACTOR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_NET_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_NET_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_NET_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_NET_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PERCENT_CHANGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PERCENT_CHANGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PERCENT_CHANGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PERCENT_CHANGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PROVIDER_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PROVIDER_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PROVIDER_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PROVIDER_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_START_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_START_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_START_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_START_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_TAXES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_TAXES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_TAXES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_TAXES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_DEMAND_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_DEMAND_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_DEMAND_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_DEMAND_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_DEMAND_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_DEMAND_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_DEMAND_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_DEMAND_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_EXPORT_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_EXPORT_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_EXPORT_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_EXPORT_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_IMPORT_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_IMPORT_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_IMPORT_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_IMPORT_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_USAGE_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_USAGE_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_USAGE_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_USAGE_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BLENDED_RATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BLENDED_RATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BLENDED_RATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BLENDED_RATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_CREDITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_CREDITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_CREDITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_CREDITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_END_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_END_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_END_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_END_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_FEES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_FEES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_FEES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_FEES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_LOAD_FACTOR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_LOAD_FACTOR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_LOAD_FACTOR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_LOAD_FACTOR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_NET_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_NET_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_NET_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_NET_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_PERCENT_CHANGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_PERCENT_CHANGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_PERCENT_CHANGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_PERCENT_CHANGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_PROVIDER_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_PROVIDER_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_PROVIDER_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_PROVIDER_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_START_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_START_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_START_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_START_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_TAXES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_TAXES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_TAXES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_TAXES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_DEMAND_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_DEMAND_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_DEMAND_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_DEMAND_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_DEMAND_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_DEMAND_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_DEMAND_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_DEMAND_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_EXPORT_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_EXPORT_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_EXPORT_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_EXPORT_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_IMPORT_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_IMPORT_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_IMPORT_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_IMPORT_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_USAGE_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_USAGE_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_USAGE_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_USAGE_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BLENDED_RATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BLENDED_RATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BLENDED_RATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BLENDED_RATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CREDITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CREDITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CREDITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CREDITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_END_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_END_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_END_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_END_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_FEES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_FEES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_FEES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_FEES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_LOAD_FACTOR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_LOAD_FACTOR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_LOAD_FACTOR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_LOAD_FACTOR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_NET_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_NET_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_NET_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_NET_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PERCENT_CHANGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PERCENT_CHANGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PERCENT_CHANGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PERCENT_CHANGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PROVIDER_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PROVIDER_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PROVIDER_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PROVIDER_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_START_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_START_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_START_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_START_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_TAXES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_TAXES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_TAXES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_TAXES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_DEMAND_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_DEMAND_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_DEMAND_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_DEMAND_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_DEMAND_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_DEMAND_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_DEMAND_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_DEMAND_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_EXPORT_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_EXPORT_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_EXPORT_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_EXPORT_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_IMPORT_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_IMPORT_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_IMPORT_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_IMPORT_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_USAGE_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_USAGE_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_USAGE_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_USAGE_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BLENDED_RATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BLENDED_RATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BLENDED_RATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BLENDED_RATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CREDITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CREDITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CREDITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CREDITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_END_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_END_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_END_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_END_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_FEES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_FEES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_FEES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_FEES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_LOAD_FACTOR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_LOAD_FACTOR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_LOAD_FACTOR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_LOAD_FACTOR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_NET_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_NET_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_NET_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_NET_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PERCENT_CHANGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PERCENT_CHANGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PERCENT_CHANGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PERCENT_CHANGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PROVIDER_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PROVIDER_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PROVIDER_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PROVIDER_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_START_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_START_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_START_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_START_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_TAXES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_TAXES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_TAXES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_TAXES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_UTILITY_METER_ID_DESC',
  UTILITY_PROVIDER_ID_ASC = 'UTILITY_PROVIDER_ID_ASC',
  UTILITY_PROVIDER_ID_DESC = 'UTILITY_PROVIDER_ID_DESC'
}

/** A profile for managing credentials for extracting data from accounts with various utility providers. No sensitive information is stored here. */
export type UtilityCredential = Node & {
  __typename?: 'UtilityCredential';
  /** The time at which the record was created */
  createdAt: Scalars['Datetime']['output'];
  /** The actor that created this record. */
  createdBy?: Maybe<Actor>;
  /** The list of IDs of the facilities this utility credential is associated with. */
  facilities?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** The internal identifer of the record. */
  id: Scalars['Int']['output'];
  /** The type of integration used for acquiring the utility data. */
  integration: UtilityIntegration;
  /** The identifier of this record as indicated by the integration. */
  integrationKey: Scalars['String']['output'];
  /** Indicates if this credential is actively used and monitored. */
  isEnabled: Scalars['Boolean']['output'];
  /** Any extra information that may help describe this record. */
  metadata: Scalars['JSON']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The current status of this credential as indicated by the integration. */
  remoteStatus: Scalars['String']['output'];
  /** The time at which the record was last updated */
  updatedAt: Scalars['Datetime']['output'];
  /** The primary username or account number used to interact with the provider. */
  username?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `UtilityAccount`. */
  utilityAccounts: UtilityAccountsConnection;
  /** Reads and enables pagination through a set of `UtilityCredentialFacility`. */
  utilityCredentialFacilities: UtilityCredentialFacilitiesConnection;
  /** Reads and enables pagination through a set of `UtilityPendingMeter`. */
  utilityPendingMeters: UtilityPendingMetersConnection;
  /** Reads a single `UtilityProvider` that is related to this `UtilityCredential`. */
  utilityProvider?: Maybe<UtilityProvider>;
  /** The provider this credential works with. */
  utilityProviderId?: Maybe<Scalars['Int']['output']>;
};

/** A profile for managing credentials for extracting data from accounts with various utility providers. No sensitive information is stored here. */
export type UtilityCredentialUtilityAccountsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UtilityAccountCondition>;
  filter?: InputMaybe<UtilityAccountFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UtilityAccountsOrderBy>>;
};

/** A profile for managing credentials for extracting data from accounts with various utility providers. No sensitive information is stored here. */
export type UtilityCredentialUtilityCredentialFacilitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UtilityCredentialFacilityCondition>;
  filter?: InputMaybe<UtilityCredentialFacilityFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UtilityCredentialFacilitiesOrderBy>>;
};

/** A profile for managing credentials for extracting data from accounts with various utility providers. No sensitive information is stored here. */
export type UtilityCredentialUtilityPendingMetersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UtilityPendingMeterCondition>;
  filter?: InputMaybe<UtilityPendingMeterFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UtilityPendingMetersOrderBy>>;
};

/**
 * A condition to be used against `UtilityCredential` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type UtilityCredentialCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdBy` field. */
  createdBy?: InputMaybe<ActorInput>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `integration` field. */
  integration?: InputMaybe<UtilityIntegration>;
  /** Checks for equality with the object’s `integrationKey` field. */
  integrationKey?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `isEnabled` field. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `metadata` field. */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `remoteStatus` field. */
  remoteStatus?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `username` field. */
  username?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `utilityProviderId` field. */
  utilityProviderId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `UtilityCredentialFacility` values. */
export type UtilityCredentialFacilitiesConnection = {
  __typename?: 'UtilityCredentialFacilitiesConnection';
  /** A list of edges which contains the `UtilityCredentialFacility` and cursor to aid in pagination. */
  edges: Array<UtilityCredentialFacilitiesEdge>;
  /** A list of `UtilityCredentialFacility` objects. */
  nodes: Array<UtilityCredentialFacility>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UtilityCredentialFacility` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `UtilityCredentialFacility` edge in the connection. */
export type UtilityCredentialFacilitiesEdge = {
  __typename?: 'UtilityCredentialFacilitiesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UtilityCredentialFacility` at the end of the edge. */
  node: UtilityCredentialFacility;
};

/** Methods to use when ordering `UtilityCredentialFacility`. */
export enum UtilityCredentialFacilitiesOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  UTILITY_CREDENTIAL_ID_ASC = 'UTILITY_CREDENTIAL_ID_ASC',
  UTILITY_CREDENTIAL_ID_DESC = 'UTILITY_CREDENTIAL_ID_DESC'
}

/** Associates utility credentials to facilities */
export type UtilityCredentialFacility = Node & {
  __typename?: 'UtilityCredentialFacility';
  /** The time at which the record was created */
  createdAt: Scalars['Datetime']['output'];
  /** Reads a single `Facility` that is related to this `UtilityCredentialFacility`. */
  facility?: Maybe<Facility>;
  /** The facility associated to the utility credential. */
  facilityId: Scalars['Int']['output'];
  /** The internal identifier of the record. */
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The time at which the record was last updated */
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `UtilityCredential` that is related to this `UtilityCredentialFacility`. */
  utilityCredential?: Maybe<UtilityCredential>;
  /** The utility credential associated to the facility. */
  utilityCredentialId: Scalars['Int']['output'];
};

/**
 * A condition to be used against `UtilityCredentialFacility` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type UtilityCredentialFacilityCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `utilityCredentialId` field. */
  utilityCredentialId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `UtilityCredentialFacility` object types. All fields are combined with a logical ‘and.’ */
export type UtilityCredentialFacilityFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UtilityCredentialFacilityFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UtilityCredentialFacilityFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UtilityCredentialFacilityFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `utilityCredentialId` field. */
  utilityCredentialId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `UtilityCredentialFacility` */
export type UtilityCredentialFacilityInput = {
  /** The facility associated to the utility credential. */
  facilityId: Scalars['Int']['input'];
  /** Mutates a `UtilityCredential` as part of the payload */
  utilityCredential?: InputMaybe<UtilityCredentialInput>;
  /** The utility credential associated to the facility. */
  utilityCredentialId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `UtilityCredential` object types. All fields are combined with a logical ‘and.’ */
export type UtilityCredentialFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UtilityCredentialFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdBy` field. */
  createdBy?: InputMaybe<ActorFilter>;
  /** Filter by the object’s `facilities` field. */
  facilities?: InputMaybe<IntListFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `integration` field. */
  integration?: InputMaybe<UtilityIntegrationFilter>;
  /** Filter by the object’s `integrationKey` field. */
  integrationKey?: InputMaybe<StringFilter>;
  /** Filter by the object’s `isEnabled` field. */
  isEnabled?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `metadata` field. */
  metadata?: InputMaybe<JsonFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UtilityCredentialFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UtilityCredentialFilter>>;
  /** Filter by the object’s `remoteStatus` field. */
  remoteStatus?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `username` field. */
  username?: InputMaybe<StringFilter>;
  /** Filter by the object’s `utilityProviderId` field. */
  utilityProviderId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `UtilityCredential` */
export type UtilityCredentialInput = {
  /** The type of integration used for acquiring the utility data. */
  integration: UtilityIntegration;
  /** The identifier of this record as indicated by the integration. */
  integrationKey: Scalars['String']['input'];
  /** Indicates if this credential is actively used and monitored. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any extra information that may help describe this record. */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** The current status of this credential as indicated by the integration. */
  remoteStatus: Scalars['String']['input'];
  /** The primary username or account number used to interact with the provider. */
  username?: InputMaybe<Scalars['String']['input']>;
  /** Mutates a `UtilityProvider` as part of the payload */
  utilityProvider?: InputMaybe<UtilityProviderInput>;
  /** The provider this credential works with. */
  utilityProviderId?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents an update to a `UtilityCredential`. Fields that are set will be updated. */
export type UtilityCredentialPatch = {
  /** Indicates if this credential is actively used and monitored. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A connection to a list of `UtilityCredential` values. */
export type UtilityCredentialsConnection = {
  __typename?: 'UtilityCredentialsConnection';
  /** A list of edges which contains the `UtilityCredential` and cursor to aid in pagination. */
  edges: Array<UtilityCredentialsEdge>;
  /** A list of `UtilityCredential` objects. */
  nodes: Array<UtilityCredential>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UtilityCredential` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `UtilityCredential` edge in the connection. */
export type UtilityCredentialsEdge = {
  __typename?: 'UtilityCredentialsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UtilityCredential` at the end of the edge. */
  node: UtilityCredential;
};

/** Methods to use when ordering `UtilityCredential`. */
export enum UtilityCredentialsOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  CREATED_BY_ASC = 'CREATED_BY_ASC',
  CREATED_BY_DESC = 'CREATED_BY_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  INTEGRATION_ASC = 'INTEGRATION_ASC',
  INTEGRATION_DESC = 'INTEGRATION_DESC',
  INTEGRATION_KEY_ASC = 'INTEGRATION_KEY_ASC',
  INTEGRATION_KEY_DESC = 'INTEGRATION_KEY_DESC',
  IS_ENABLED_ASC = 'IS_ENABLED_ASC',
  IS_ENABLED_DESC = 'IS_ENABLED_DESC',
  METADATA_ASC = 'METADATA_ASC',
  METADATA_DESC = 'METADATA_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  REMOTE_STATUS_ASC = 'REMOTE_STATUS_ASC',
  REMOTE_STATUS_DESC = 'REMOTE_STATUS_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  USERNAME_ASC = 'USERNAME_ASC',
  USERNAME_DESC = 'USERNAME_DESC',
  UTILITY_PROVIDER_ID_ASC = 'UTILITY_PROVIDER_ID_ASC',
  UTILITY_PROVIDER_ID_DESC = 'UTILITY_PROVIDER_ID_DESC'
}

/** A record to track information related to files uploaded to a utility billing integration. */
export type UtilityFileUpload = Node & {
  __typename?: 'UtilityFileUpload';
  /** Reads and enables pagination through a set of `AccountStatement`. */
  accountStatements: AccountStatementsConnection;
  /** The time at which the record was created */
  createdAt: Scalars['Datetime']['output'];
  /** The actor that created this record. */
  createdBy: Actor;
  /** The internal identifier of the record. */
  id: Scalars['Int']['output'];
  /** The type of integration to which this file was uploaded. */
  integration: UtilityIntegration;
  /** The identifier of this record as indicated by the integration. */
  integrationKey: Scalars['String']['output'];
  /** Indicates if the record should no longer be displayed in Nsight. */
  isDismissed: Scalars['Boolean']['output'];
  /** Any extra information that may help describe this record. */
  metadata: Scalars['JSON']['output'];
  /** Reads and enables pagination through a set of `MeterStatement`. */
  meterStatements: MeterStatementsConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The time at which the record was last updated */
  updatedAt: Scalars['Datetime']['output'];
};

/** A record to track information related to files uploaded to a utility billing integration. */
export type UtilityFileUploadAccountStatementsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<AccountStatementFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** A record to track information related to files uploaded to a utility billing integration. */
export type UtilityFileUploadMeterStatementsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<MeterStatementFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * A condition to be used against `UtilityFileUpload` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type UtilityFileUploadCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdBy` field. */
  createdBy?: InputMaybe<ActorInput>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `integration` field. */
  integration?: InputMaybe<UtilityIntegration>;
  /** Checks for equality with the object’s `integrationKey` field. */
  integrationKey?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `isDismissed` field. */
  isDismissed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `metadata` field. */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `UtilityFileUpload` object types. All fields are combined with a logical ‘and.’ */
export type UtilityFileUploadFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UtilityFileUploadFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdBy` field. */
  createdBy?: InputMaybe<ActorFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `integration` field. */
  integration?: InputMaybe<UtilityIntegrationFilter>;
  /** Filter by the object’s `integrationKey` field. */
  integrationKey?: InputMaybe<StringFilter>;
  /** Filter by the object’s `isDismissed` field. */
  isDismissed?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `metadata` field. */
  metadata?: InputMaybe<JsonFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UtilityFileUploadFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UtilityFileUploadFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `UtilityFileUpload` */
export type UtilityFileUploadInput = {
  /** The type of integration to which this file was uploaded. */
  integration: UtilityIntegration;
  /** The identifier of this record as indicated by the integration. */
  integrationKey: Scalars['String']['input'];
  /** Any extra information that may help describe this record. */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
};

/** Represents an update to a `UtilityFileUpload`. Fields that are set will be updated. */
export type UtilityFileUploadPatch = {
  /** Indicates if the record should no longer be displayed in Nsight. */
  isDismissed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any extra information that may help describe this record. */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
};

/** A connection to a list of `UtilityFileUpload` values. */
export type UtilityFileUploadsConnection = {
  __typename?: 'UtilityFileUploadsConnection';
  /** A list of edges which contains the `UtilityFileUpload` and cursor to aid in pagination. */
  edges: Array<UtilityFileUploadsEdge>;
  /** A list of `UtilityFileUpload` objects. */
  nodes: Array<UtilityFileUpload>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UtilityFileUpload` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `UtilityFileUpload` edge in the connection. */
export type UtilityFileUploadsEdge = {
  __typename?: 'UtilityFileUploadsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UtilityFileUpload` at the end of the edge. */
  node: UtilityFileUpload;
};

/** Methods to use when ordering `UtilityFileUpload`. */
export enum UtilityFileUploadsOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  CREATED_BY_ASC = 'CREATED_BY_ASC',
  CREATED_BY_DESC = 'CREATED_BY_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  INTEGRATION_ASC = 'INTEGRATION_ASC',
  INTEGRATION_DESC = 'INTEGRATION_DESC',
  INTEGRATION_KEY_ASC = 'INTEGRATION_KEY_ASC',
  INTEGRATION_KEY_DESC = 'INTEGRATION_KEY_DESC',
  IS_DISMISSED_ASC = 'IS_DISMISSED_ASC',
  IS_DISMISSED_DESC = 'IS_DISMISSED_DESC',
  METADATA_ASC = 'METADATA_ASC',
  METADATA_DESC = 'METADATA_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

export enum UtilityIntegration {
  ARCADIA_PLUG = 'ARCADIA_PLUG',
  MANUAL = 'MANUAL',
  URJANET = 'URJANET'
}

/** A filter to be used against UtilityIntegration fields. All fields are combined with a logical ‘and.’ */
export type UtilityIntegrationFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<UtilityIntegration>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<UtilityIntegration>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<UtilityIntegration>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<UtilityIntegration>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<UtilityIntegration>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<UtilityIntegration>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<UtilityIntegration>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<UtilityIntegration>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<UtilityIntegration>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<UtilityIntegration>>;
};

export type UtilityMeter = Node & {
  __typename?: 'UtilityMeter';
  activeEnd?: Maybe<Scalars['Date']['output']>;
  activeStart: Scalars['Date']['output'];
  /** Returns a set of days and flags for a given meter. */
  billingCoverage: UtilityMetersBillingCoverageConnection;
  /**
   * Returns a set of statement months and flags for a given meter and year.
   * @deprecated true
   */
  billingCoverageByStatementMonth: UtilityMetersBillingCoverageByStatementMonthConnection;
  /** The time the meter was created. */
  createdAt: Scalars['Datetime']['output'];
  /** Default units for meter demand. */
  defaultDemandUnits?: Maybe<Scalars['String']['output']>;
  /** Default units for meter usage. */
  defaultUsageUnits?: Maybe<Scalars['String']['output']>;
  /** Returns the deleted_at column of this record or its parent */
  deletedAt?: Maybe<Scalars['Datetime']['output']>;
  /** Used to indicate whether this utility meter contributes to carbon reporting based on its location in the facility. */
  excludeCarbon?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates that the meter`s usage should not be included in calcuations. */
  excludeUsage: Scalars['Boolean']['output'];
  /** Returns a number that represents the estimated number of days in the billing cycle for this utility meter. This is based on the median of the intervals for the meter statements. */
  expectedBillCycleDays?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `Facility` that is related to this `UtilityMeter`. */
  facility?: Maybe<Facility>;
  facilityId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  integrationMeterKey: Scalars['String']['output'];
  /** Flag for detecting if an automatically created utility meter record needs review or not. */
  isReviewed: Scalars['Boolean']['output'];
  /** Returns the integration attribute of the last statement (by statement_year, statement_month) for this meter */
  lastStatementIntegration?: Maybe<UtilityIntegration>;
  metadata: Scalars['JSON']['output'];
  meterNumber: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `MeterStatement`. */
  meterStatements: MeterStatementsConnection;
  /**
   * Returns a set of year/month combinations that are missing as statements for a given meter.
   * @deprecated true
   */
  missingStatements: UtilityMetersMissingStatementsConnection;
  /** Returns a set of months and flags for a given meter. */
  monthlyBillingCoverage: UtilityMetersMonthlyBillingCoverageConnection;
  name?: Maybe<Scalars['String']['output']>;
  /** Indicates if the meter statements report any kind of net metering. */
  netMeteringType: UtilityNetMeteringType;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  overrideAt?: Maybe<Scalars['Datetime']['output']>;
  /** The service type of the meter. */
  serviceType: UtilityMeterServiceType;
  /** Reads and enables pagination through a set of `Submeter`. */
  submeters: SubmetersConnection;
  /** The time the meter was updated. */
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `UtilityAccount` that is related to this `UtilityMeter`. */
  utilityAccount?: Maybe<UtilityAccount>;
  utilityAccountId: Scalars['Int']['output'];
  /** Reads and enables pagination through a set of `UtilityMeterStatementRollup`. */
  utilityMeterStatementRollups: UtilityMeterStatementRollupsConnection;
  /** Reads and enables pagination through a set of `UtilityMeterStatement`. */
  utilityMeterStatements: UtilityMeterStatementsConnection;
};

export type UtilityMeterBillingCoverageArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<UtilityMetersBillingCoverageRecordFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type UtilityMeterBillingCoverageByStatementMonthArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<UtilityMetersBillingCoverageByStatementMonthRecordFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type UtilityMeterMeterStatementsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MeterStatementCondition>;
  filter?: InputMaybe<MeterStatementFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MeterStatementsOrderBy>>;
};

export type UtilityMeterMissingStatementsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<UtilityMetersMissingStatementsRecordFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type UtilityMeterMonthlyBillingCoverageArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<UtilityMetersMonthlyBillingCoverageRecordFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type UtilityMeterSubmetersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SubmeterCondition>;
  filter?: InputMaybe<SubmeterFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SubmetersOrderBy>>;
};

export type UtilityMeterUtilityMeterStatementRollupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UtilityMeterStatementRollupCondition>;
  filter?: InputMaybe<UtilityMeterStatementRollupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UtilityMeterStatementRollupsOrderBy>>;
};

export type UtilityMeterUtilityMeterStatementsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UtilityMeterStatementCondition>;
  filter?: InputMaybe<UtilityMeterStatementFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UtilityMeterStatementsOrderBy>>;
};

export enum UtilityMeterChargeCategory {
  CREDITS = 'CREDITS',
  DEMAND = 'DEMAND',
  FEES = 'FEES',
  TAXES = 'TAXES',
  USAGE = 'USAGE'
}

/** A filter to be used against UtilityMeterChargeCategory fields. All fields are combined with a logical ‘and.’ */
export type UtilityMeterChargeCategoryFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<UtilityMeterChargeCategory>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<UtilityMeterChargeCategory>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<UtilityMeterChargeCategory>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<UtilityMeterChargeCategory>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<UtilityMeterChargeCategory>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<UtilityMeterChargeCategory>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<UtilityMeterChargeCategory>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<UtilityMeterChargeCategory>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<UtilityMeterChargeCategory>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<UtilityMeterChargeCategory>>;
};

/**
 * A condition to be used against `UtilityMeter` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type UtilityMeterCondition = {
  /** Checks for equality with the object’s `activeEnd` field. */
  activeEnd?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `activeStart` field. */
  activeStart?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `defaultDemandUnits` field. */
  defaultDemandUnits?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `defaultUsageUnits` field. */
  defaultUsageUnits?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `excludeCarbon` field. */
  excludeCarbon?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `excludeUsage` field. */
  excludeUsage?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `integrationMeterKey` field. */
  integrationMeterKey?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `isReviewed` field. */
  isReviewed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `metadata` field. */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `netMeteringType` field. */
  netMeteringType?: InputMaybe<UtilityNetMeteringType>;
  /** Checks for equality with the object’s `overrideAt` field. */
  overrideAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `serviceType` field. */
  serviceType?: InputMaybe<UtilityMeterServiceType>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `utilityAccountId` field. */
  utilityAccountId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `UtilityMeter` object types. All fields are combined with a logical ‘and.’ */
export type UtilityMeterFilter = {
  /** Filter by the object’s `activeEnd` field. */
  activeEnd?: InputMaybe<DateFilter>;
  /** Filter by the object’s `activeStart` field. */
  activeStart?: InputMaybe<DateFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UtilityMeterFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `defaultDemandUnits` field. */
  defaultDemandUnits?: InputMaybe<StringFilter>;
  /** Filter by the object’s `defaultUsageUnits` field. */
  defaultUsageUnits?: InputMaybe<StringFilter>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `excludeCarbon` field. */
  excludeCarbon?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `excludeUsage` field. */
  excludeUsage?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `expectedBillCycleDays` field. */
  expectedBillCycleDays?: InputMaybe<IntFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `integrationMeterKey` field. */
  integrationMeterKey?: InputMaybe<StringFilter>;
  /** Filter by the object’s `isReviewed` field. */
  isReviewed?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `lastStatementIntegration` field. */
  lastStatementIntegration?: InputMaybe<UtilityIntegrationFilter>;
  /** Filter by the object’s `metadata` field. */
  metadata?: InputMaybe<JsonFilter>;
  /** Filter by the object's `meterNumber` field. */
  meterNumber?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Filter by the object’s `netMeteringType` field. */
  netMeteringType?: InputMaybe<UtilityNetMeteringTypeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UtilityMeterFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UtilityMeterFilter>>;
  /** Filter by the object’s `overrideAt` field. */
  overrideAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `serviceType` field. */
  serviceType?: InputMaybe<UtilityMeterServiceTypeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `utilityAccountId` field. */
  utilityAccountId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `UtilityMeter` */
export type UtilityMeterInput = {
  activeEnd?: InputMaybe<Scalars['Date']['input']>;
  activeStart?: InputMaybe<Scalars['Date']['input']>;
  /** Default units for meter demand. */
  defaultDemandUnits?: InputMaybe<Scalars['String']['input']>;
  /** Default units for meter usage. */
  defaultUsageUnits?: InputMaybe<Scalars['String']['input']>;
  /** Used to indicate whether this utility meter contributes to carbon reporting based on its location in the facility. */
  excludeCarbon?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates that the meter`s usage should not be included in calcuations. */
  excludeUsage?: InputMaybe<Scalars['Boolean']['input']>;
  facilityId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  integrationMeterKey?: InputMaybe<Scalars['String']['input']>;
  /** Flag for detecting if an automatically created utility meter record needs review or not. */
  isReviewed?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  meterNumber: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  /** Indicates if the meter statements report any kind of net metering. */
  netMeteringType?: InputMaybe<UtilityNetMeteringType>;
  overrideAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** The service type of the meter. */
  serviceType: UtilityMeterServiceType;
  /** Mutates a `UtilityAccount` as part of the payload */
  utilityAccount?: InputMaybe<UtilityAccountInput>;
  utilityAccountId?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents an update to a `UtilityMeter`. Fields that are set will be updated. */
export type UtilityMeterPatch = {
  activeEnd?: InputMaybe<Scalars['Date']['input']>;
  activeStart?: InputMaybe<Scalars['Date']['input']>;
  /** Default units for meter demand. */
  defaultDemandUnits?: InputMaybe<Scalars['String']['input']>;
  /** Default units for meter usage. */
  defaultUsageUnits?: InputMaybe<Scalars['String']['input']>;
  /** Used to indicate whether this utility meter contributes to carbon reporting based on its location in the facility. */
  excludeCarbon?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates that the meter`s usage should not be included in calcuations. */
  excludeUsage?: InputMaybe<Scalars['Boolean']['input']>;
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** Flag for detecting if an automatically created utility meter record needs review or not. */
  isReviewed?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** Overrides the original meter_number. */
  meterNumber?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Indicates if the meter statements report any kind of net metering. */
  netMeteringType?: InputMaybe<UtilityNetMeteringType>;
  overrideAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** The service type of the meter. */
  serviceType?: InputMaybe<UtilityMeterServiceType>;
};

export enum UtilityMeterServiceType {
  ELECTRIC = 'ELECTRIC',
  IRRIGATION = 'IRRIGATION',
  LIGHTING = 'LIGHTING',
  NATURAL_GAS = 'NATURAL_GAS',
  OTHER = 'OTHER',
  PROPANE = 'PROPANE',
  SANITATION = 'SANITATION',
  SEWER = 'SEWER',
  SOLAR = 'SOLAR',
  WATER = 'WATER'
}

/** A filter to be used against UtilityMeterServiceType fields. All fields are combined with a logical ‘and.’ */
export type UtilityMeterServiceTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<UtilityMeterServiceType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<UtilityMeterServiceType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<UtilityMeterServiceType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<UtilityMeterServiceType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<UtilityMeterServiceType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<UtilityMeterServiceType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<UtilityMeterServiceType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<UtilityMeterServiceType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<UtilityMeterServiceType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<UtilityMeterServiceType>>;
};

/** A filter to be used against UtilityMeterServiceType List fields. All fields are combined with a logical ‘and.’ */
export type UtilityMeterServiceTypeListFilter = {
  /** Any array item is equal to the specified value. */
  anyEqualTo?: InputMaybe<UtilityMeterServiceType>;
  /** Any array item is greater than the specified value. */
  anyGreaterThan?: InputMaybe<UtilityMeterServiceType>;
  /** Any array item is greater than or equal to the specified value. */
  anyGreaterThanOrEqualTo?: InputMaybe<UtilityMeterServiceType>;
  /** Any array item is less than the specified value. */
  anyLessThan?: InputMaybe<UtilityMeterServiceType>;
  /** Any array item is less than or equal to the specified value. */
  anyLessThanOrEqualTo?: InputMaybe<UtilityMeterServiceType>;
  /** Any array item is not equal to the specified value. */
  anyNotEqualTo?: InputMaybe<UtilityMeterServiceType>;
  /** Contained by the specified list of values. */
  containedBy?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
  /** Contains the specified list of values. */
  contains?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
  /** Overlaps the specified list of values. */
  overlaps?: InputMaybe<Array<InputMaybe<UtilityMeterServiceType>>>;
};

export type UtilityMeterStatement = Node & {
  __typename?: 'UtilityMeterStatement';
  accountLabel?: Maybe<Scalars['String']['output']>;
  /** Reads a single `AccountStatement` that is related to this `UtilityMeterStatement`. */
  accountStatement?: Maybe<AccountStatement>;
  accountStatementId?: Maybe<Scalars['Int']['output']>;
  accountStatementPdfId?: Maybe<Scalars['Int']['output']>;
  billArrivalDate?: Maybe<Scalars['Datetime']['output']>;
  /** Returns the total charges of a given utility_meter_statements (view) row. */
  billCost?: Maybe<Scalars['Float']['output']>;
  billDemand?: Maybe<Scalars['Float']['output']>;
  /** Returns the total demand charges of a given utility_meter_statements (view) row. */
  billDemandCost?: Maybe<Scalars['Float']['output']>;
  /** Returns the total demand of a given utility_meter_statements (view) row. */
  billUsage?: Maybe<Scalars['Float']['output']>;
  /** Returns the total usage charges of a given utility_meter_statements (view) row. */
  billUsageCost?: Maybe<Scalars['Float']['output']>;
  /** Returns the total credits of a given utility_meter_statements (view) row. */
  credits?: Maybe<Scalars['Float']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  daysInBill?: Maybe<Scalars['Int']['output']>;
  demandUnits?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  excludeUsage?: Maybe<Scalars['Boolean']['output']>;
  /** Reads a single `Facility` that is related to this `UtilityMeterStatement`. */
  facility?: Maybe<Facility>;
  facilityId?: Maybe<Scalars['Int']['output']>;
  /** Returns the total fee charges of a given utility_meter_statements (view) row. */
  fees?: Maybe<Scalars['Float']['output']>;
  isValidated?: Maybe<Scalars['Boolean']['output']>;
  meterEndDateSet?: Maybe<Scalars['Boolean']['output']>;
  meterLabel?: Maybe<Scalars['String']['output']>;
  /** Reads a single `MeterStatement` that is related to this `UtilityMeterStatement`. */
  meterStatement?: Maybe<MeterStatement>;
  meterStatementId: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  provider?: Maybe<Scalars['String']['output']>;
  serviceType?: Maybe<UtilityMeterServiceType>;
  startDate?: Maybe<Scalars['Date']['output']>;
  statementMonth?: Maybe<Scalars['Int']['output']>;
  statementYear?: Maybe<Scalars['Int']['output']>;
  /** Returns the total tax charges of a given utility_meter_statements (view) row. */
  taxes?: Maybe<Scalars['Float']['output']>;
  usageUnits?: Maybe<Scalars['String']['output']>;
  /** Reads a single `UtilityAccount` that is related to this `UtilityMeterStatement`. */
  utilityAccount?: Maybe<UtilityAccount>;
  utilityAccountId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `UtilityMeter` that is related to this `UtilityMeterStatement`. */
  utilityMeter?: Maybe<UtilityMeter>;
  utilityMeterId?: Maybe<Scalars['Int']['output']>;
};

export type UtilityMeterStatementAggregates = {
  __typename?: 'UtilityMeterStatementAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<UtilityMeterStatementAverageAggregates>;
  /** Distinct aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinct?: Maybe<UtilityMeterStatementDistinctAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<UtilityMeterStatementDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<UtilityMeterStatementMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<UtilityMeterStatementMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<UtilityMeterStatementStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<UtilityMeterStatementStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<UtilityMeterStatementSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<UtilityMeterStatementVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<UtilityMeterStatementVarianceSampleAggregates>;
};

export type UtilityMeterStatementAverageAggregates = {
  __typename?: 'UtilityMeterStatementAverageAggregates';
  /** Mean average of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of accountStatementPdfId across the matching connection */
  accountStatementPdfId?: Maybe<Scalars['BigFloat']['output']>;
  /**
   * Mean average of this field across the matching connection.
   *
   * ---
   *
   * Returns the total charges of a given utility_meter_statements (view) row.
   */
  billCost?: Maybe<Scalars['Float']['output']>;
  /** Mean average of this field across the matching connection. */
  billDemand?: Maybe<Scalars['Float']['output']>;
  /**
   * Mean average of this field across the matching connection.
   *
   * ---
   *
   * Returns the total demand charges of a given utility_meter_statements (view) row.
   */
  billDemandCost?: Maybe<Scalars['Float']['output']>;
  /**
   * Mean average of this field across the matching connection.
   *
   * ---
   *
   * Returns the total demand of a given utility_meter_statements (view) row.
   */
  billUsage?: Maybe<Scalars['Float']['output']>;
  /**
   * Mean average of this field across the matching connection.
   *
   * ---
   *
   * Returns the total usage charges of a given utility_meter_statements (view) row.
   */
  billUsageCost?: Maybe<Scalars['Float']['output']>;
  /**
   * Mean average of this field across the matching connection.
   *
   * ---
   *
   * Returns the total credits of a given utility_meter_statements (view) row.
   */
  credits?: Maybe<Scalars['Float']['output']>;
  /** Mean average of daysInBill across the matching connection */
  daysInBill?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of facilityId across the matching connection */
  facilityId?: Maybe<Scalars['BigFloat']['output']>;
  /**
   * Mean average of this field across the matching connection.
   *
   * ---
   *
   * Returns the total fee charges of a given utility_meter_statements (view) row.
   */
  fees?: Maybe<Scalars['Float']['output']>;
  /** Mean average of meterStatementId across the matching connection */
  meterStatementId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['BigFloat']['output']>;
  /**
   * Mean average of this field across the matching connection.
   *
   * ---
   *
   * Returns the total tax charges of a given utility_meter_statements (view) row.
   */
  taxes?: Maybe<Scalars['Float']['output']>;
  /** Mean average of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of utilityMeterId across the matching connection */
  utilityMeterId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `UtilityMeterStatement` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type UtilityMeterStatementCondition = {
  /** Checks for equality with the object’s `accountLabel` field. */
  accountLabel?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `accountStatementId` field. */
  accountStatementId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `accountStatementPdfId` field. */
  accountStatementPdfId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `billArrivalDate` field. */
  billArrivalDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `currencyCode` field. */
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `daysInBill` field. */
  daysInBill?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `demandUnits` field. */
  demandUnits?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `endDate` field. */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `excludeUsage` field. */
  excludeUsage?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `isValidated` field. */
  isValidated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `meterEndDateSet` field. */
  meterEndDateSet?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `meterLabel` field. */
  meterLabel?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `meterStatementId` field. */
  meterStatementId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `provider` field. */
  provider?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `serviceType` field. */
  serviceType?: InputMaybe<UtilityMeterServiceType>;
  /** Checks for equality with the object’s `startDate` field. */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `statementMonth` field. */
  statementMonth?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `statementYear` field. */
  statementYear?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `usageUnits` field. */
  usageUnits?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `utilityAccountId` field. */
  utilityAccountId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `utilityMeterId` field. */
  utilityMeterId?: InputMaybe<Scalars['Int']['input']>;
};

export type UtilityMeterStatementDistinctAggregates = {
  __typename?: 'UtilityMeterStatementDistinctAggregates';
  /** Distinct of accountLabel across the matching connection */
  accountLabel?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Distinct of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Distinct of accountStatementPdfId across the matching connection */
  accountStatementPdfId?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Distinct of billArrivalDate across the matching connection */
  billArrivalDate?: Maybe<Scalars['JSON']['output']>;
  /**
   * Distinct of this field across the matching connection.
   *
   * ---
   *
   * Returns the total charges of a given utility_meter_statements (view) row.
   */
  billCost?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Distinct of this field across the matching connection. */
  billDemand?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /**
   * Distinct of this field across the matching connection.
   *
   * ---
   *
   * Returns the total demand charges of a given utility_meter_statements (view) row.
   */
  billDemandCost?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /**
   * Distinct of this field across the matching connection.
   *
   * ---
   *
   * Returns the total demand of a given utility_meter_statements (view) row.
   */
  billUsage?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /**
   * Distinct of this field across the matching connection.
   *
   * ---
   *
   * Returns the total usage charges of a given utility_meter_statements (view) row.
   */
  billUsageCost?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /**
   * Distinct of this field across the matching connection.
   *
   * ---
   *
   * Returns the total credits of a given utility_meter_statements (view) row.
   */
  credits?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Distinct of currencyCode across the matching connection */
  currencyCode?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Distinct of daysInBill across the matching connection */
  daysInBill?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Distinct of demandUnits across the matching connection */
  demandUnits?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Distinct of endDate across the matching connection */
  endDate?: Maybe<Scalars['JSON']['output']>;
  /** Distinct of excludeUsage across the matching connection */
  excludeUsage?: Maybe<Scalars['JSON']['output']>;
  /** Distinct of facilityId across the matching connection */
  facilityId?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /**
   * Distinct of this field across the matching connection.
   *
   * ---
   *
   * Returns the total fee charges of a given utility_meter_statements (view) row.
   */
  fees?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Distinct of isValidated across the matching connection */
  isValidated?: Maybe<Scalars['JSON']['output']>;
  /** Distinct of meterEndDateSet across the matching connection */
  meterEndDateSet?: Maybe<Scalars['JSON']['output']>;
  /** Distinct of meterLabel across the matching connection */
  meterLabel?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Distinct of meterStatementId across the matching connection */
  meterStatementId?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Distinct of provider across the matching connection */
  provider?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Distinct of serviceType across the matching connection */
  serviceType?: Maybe<Scalars['JSON']['output']>;
  /** Distinct of startDate across the matching connection */
  startDate?: Maybe<Scalars['JSON']['output']>;
  /** Distinct of statementMonth across the matching connection */
  statementMonth?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Distinct of statementYear across the matching connection */
  statementYear?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /**
   * Distinct of this field across the matching connection.
   *
   * ---
   *
   * Returns the total tax charges of a given utility_meter_statements (view) row.
   */
  taxes?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Distinct of usageUnits across the matching connection */
  usageUnits?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Distinct of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Distinct of utilityMeterId across the matching connection */
  utilityMeterId?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type UtilityMeterStatementDistinctCountAggregates = {
  __typename?: 'UtilityMeterStatementDistinctCountAggregates';
  /** Distinct count of accountLabel across the matching connection */
  accountLabel?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of accountStatementPdfId across the matching connection */
  accountStatementPdfId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of billArrivalDate across the matching connection */
  billArrivalDate?: Maybe<Scalars['BigInt']['output']>;
  /**
   * Distinct count of this field across the matching connection.
   *
   * ---
   *
   * Returns the total charges of a given utility_meter_statements (view) row.
   */
  billCost?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of this field across the matching connection. */
  billDemand?: Maybe<Scalars['BigInt']['output']>;
  /**
   * Distinct count of this field across the matching connection.
   *
   * ---
   *
   * Returns the total demand charges of a given utility_meter_statements (view) row.
   */
  billDemandCost?: Maybe<Scalars['BigInt']['output']>;
  /**
   * Distinct count of this field across the matching connection.
   *
   * ---
   *
   * Returns the total demand of a given utility_meter_statements (view) row.
   */
  billUsage?: Maybe<Scalars['BigInt']['output']>;
  /**
   * Distinct count of this field across the matching connection.
   *
   * ---
   *
   * Returns the total usage charges of a given utility_meter_statements (view) row.
   */
  billUsageCost?: Maybe<Scalars['BigInt']['output']>;
  /**
   * Distinct count of this field across the matching connection.
   *
   * ---
   *
   * Returns the total credits of a given utility_meter_statements (view) row.
   */
  credits?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of currencyCode across the matching connection */
  currencyCode?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of daysInBill across the matching connection */
  daysInBill?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of demandUnits across the matching connection */
  demandUnits?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of endDate across the matching connection */
  endDate?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of excludeUsage across the matching connection */
  excludeUsage?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of facilityId across the matching connection */
  facilityId?: Maybe<Scalars['BigInt']['output']>;
  /**
   * Distinct count of this field across the matching connection.
   *
   * ---
   *
   * Returns the total fee charges of a given utility_meter_statements (view) row.
   */
  fees?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of isValidated across the matching connection */
  isValidated?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of meterEndDateSet across the matching connection */
  meterEndDateSet?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of meterLabel across the matching connection */
  meterLabel?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of meterStatementId across the matching connection */
  meterStatementId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of provider across the matching connection */
  provider?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of serviceType across the matching connection */
  serviceType?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of startDate across the matching connection */
  startDate?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['BigInt']['output']>;
  /**
   * Distinct count of this field across the matching connection.
   *
   * ---
   *
   * Returns the total tax charges of a given utility_meter_statements (view) row.
   */
  taxes?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of usageUnits across the matching connection */
  usageUnits?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of utilityMeterId across the matching connection */
  utilityMeterId?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `UtilityMeterStatement` object types. All fields are combined with a logical ‘and.’ */
export type UtilityMeterStatementFilter = {
  /** Filter by the object’s `accountLabel` field. */
  accountLabel?: InputMaybe<StringFilter>;
  /** Filter by the object’s `accountStatementId` field. */
  accountStatementId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `accountStatementPdfId` field. */
  accountStatementPdfId?: InputMaybe<IntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UtilityMeterStatementFilter>>;
  /** Filter by the object’s `billArrivalDate` field. */
  billArrivalDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `billCost` field. */
  billCost?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `billDemand` field. */
  billDemand?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `billDemandCost` field. */
  billDemandCost?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `billUsage` field. */
  billUsage?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `billUsageCost` field. */
  billUsageCost?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `credits` field. */
  credits?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `currencyCode` field. */
  currencyCode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `daysInBill` field. */
  daysInBill?: InputMaybe<IntFilter>;
  /** Filter by the object’s `demandUnits` field. */
  demandUnits?: InputMaybe<StringFilter>;
  /** Filter by the object’s `endDate` field. */
  endDate?: InputMaybe<DateFilter>;
  /** Filter by the object’s `excludeUsage` field. */
  excludeUsage?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `fees` field. */
  fees?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `isValidated` field. */
  isValidated?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `meterEndDateSet` field. */
  meterEndDateSet?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `meterLabel` field. */
  meterLabel?: InputMaybe<StringFilter>;
  /** Filter by the object’s `meterStatementId` field. */
  meterStatementId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UtilityMeterStatementFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UtilityMeterStatementFilter>>;
  /** Filter by the object’s `provider` field. */
  provider?: InputMaybe<StringFilter>;
  /** Filter by the object’s `serviceType` field. */
  serviceType?: InputMaybe<UtilityMeterServiceTypeFilter>;
  /** Filter by the object’s `startDate` field. */
  startDate?: InputMaybe<DateFilter>;
  /** Filter by the object’s `statementMonth` field. */
  statementMonth?: InputMaybe<IntFilter>;
  /** Filter by the object’s `statementYear` field. */
  statementYear?: InputMaybe<IntFilter>;
  /** Filter by the object’s `taxes` field. */
  taxes?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `usageUnits` field. */
  usageUnits?: InputMaybe<StringFilter>;
  /** Filter by the object’s `utilityAccountId` field. */
  utilityAccountId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `utilityMeterId` field. */
  utilityMeterId?: InputMaybe<IntFilter>;
};

export type UtilityMeterStatementMaxAggregates = {
  __typename?: 'UtilityMeterStatementMaxAggregates';
  /** Maximum of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of accountStatementPdfId across the matching connection */
  accountStatementPdfId?: Maybe<Scalars['Int']['output']>;
  /**
   * Maximum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total charges of a given utility_meter_statements (view) row.
   */
  billCost?: Maybe<Scalars['Float']['output']>;
  /** Maximum of this field across the matching connection. */
  billDemand?: Maybe<Scalars['Float']['output']>;
  /**
   * Maximum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total demand charges of a given utility_meter_statements (view) row.
   */
  billDemandCost?: Maybe<Scalars['Float']['output']>;
  /**
   * Maximum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total demand of a given utility_meter_statements (view) row.
   */
  billUsage?: Maybe<Scalars['Float']['output']>;
  /**
   * Maximum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total usage charges of a given utility_meter_statements (view) row.
   */
  billUsageCost?: Maybe<Scalars['Float']['output']>;
  /**
   * Maximum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total credits of a given utility_meter_statements (view) row.
   */
  credits?: Maybe<Scalars['Float']['output']>;
  /** Maximum of daysInBill across the matching connection */
  daysInBill?: Maybe<Scalars['Int']['output']>;
  /** Maximum of facilityId across the matching connection */
  facilityId?: Maybe<Scalars['Int']['output']>;
  /**
   * Maximum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total fee charges of a given utility_meter_statements (view) row.
   */
  fees?: Maybe<Scalars['Float']['output']>;
  /** Maximum of meterStatementId across the matching connection */
  meterStatementId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['Int']['output']>;
  /** Maximum of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['Int']['output']>;
  /**
   * Maximum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total tax charges of a given utility_meter_statements (view) row.
   */
  taxes?: Maybe<Scalars['Float']['output']>;
  /** Maximum of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of utilityMeterId across the matching connection */
  utilityMeterId?: Maybe<Scalars['Int']['output']>;
};

export type UtilityMeterStatementMinAggregates = {
  __typename?: 'UtilityMeterStatementMinAggregates';
  /** Minimum of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of accountStatementPdfId across the matching connection */
  accountStatementPdfId?: Maybe<Scalars['Int']['output']>;
  /**
   * Minimum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total charges of a given utility_meter_statements (view) row.
   */
  billCost?: Maybe<Scalars['Float']['output']>;
  /** Minimum of this field across the matching connection. */
  billDemand?: Maybe<Scalars['Float']['output']>;
  /**
   * Minimum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total demand charges of a given utility_meter_statements (view) row.
   */
  billDemandCost?: Maybe<Scalars['Float']['output']>;
  /**
   * Minimum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total demand of a given utility_meter_statements (view) row.
   */
  billUsage?: Maybe<Scalars['Float']['output']>;
  /**
   * Minimum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total usage charges of a given utility_meter_statements (view) row.
   */
  billUsageCost?: Maybe<Scalars['Float']['output']>;
  /**
   * Minimum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total credits of a given utility_meter_statements (view) row.
   */
  credits?: Maybe<Scalars['Float']['output']>;
  /** Minimum of daysInBill across the matching connection */
  daysInBill?: Maybe<Scalars['Int']['output']>;
  /** Minimum of facilityId across the matching connection */
  facilityId?: Maybe<Scalars['Int']['output']>;
  /**
   * Minimum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total fee charges of a given utility_meter_statements (view) row.
   */
  fees?: Maybe<Scalars['Float']['output']>;
  /** Minimum of meterStatementId across the matching connection */
  meterStatementId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['Int']['output']>;
  /** Minimum of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['Int']['output']>;
  /**
   * Minimum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total tax charges of a given utility_meter_statements (view) row.
   */
  taxes?: Maybe<Scalars['Float']['output']>;
  /** Minimum of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of utilityMeterId across the matching connection */
  utilityMeterId?: Maybe<Scalars['Int']['output']>;
};

export type UtilityMeterStatementRollup = Node & {
  __typename?: 'UtilityMeterStatementRollup';
  accountLabel?: Maybe<Scalars['String']['output']>;
  accountStatementId?: Maybe<Scalars['Int']['output']>;
  billArrivalDate?: Maybe<Scalars['Datetime']['output']>;
  billCost?: Maybe<Scalars['Float']['output']>;
  billDemand?: Maybe<Scalars['Float']['output']>;
  billDemandCost?: Maybe<Scalars['Float']['output']>;
  billExportUsage?: Maybe<Scalars['Float']['output']>;
  billImportUsage?: Maybe<Scalars['Float']['output']>;
  billUsage?: Maybe<Scalars['Float']['output']>;
  billUsageCost?: Maybe<Scalars['Float']['output']>;
  blendedRate?: Maybe<Scalars['Float']['output']>;
  credits?: Maybe<Scalars['Float']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  daysInBill?: Maybe<Scalars['Int']['output']>;
  demandUnits?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  /** Reads a single `Facility` that is related to this `UtilityMeterStatementRollup`. */
  facility?: Maybe<Facility>;
  facilityId?: Maybe<Scalars['Int']['output']>;
  /** The name of the facility associated with the meter statement. */
  facilityName?: Maybe<Scalars['String']['output']>;
  fees?: Maybe<Scalars['Float']['output']>;
  isValidated?: Maybe<Scalars['Boolean']['output']>;
  loadFactor?: Maybe<Scalars['Float']['output']>;
  meterEndDateSet?: Maybe<Scalars['Boolean']['output']>;
  meterLabel?: Maybe<Scalars['String']['output']>;
  /** Reads a single `MeterStatement` that is related to this `UtilityMeterStatementRollup`. */
  meterStatement?: Maybe<MeterStatement>;
  meterStatementId: Scalars['Int']['output'];
  /** The nsight2 active status of the rows facility. */
  nSight2Active?: Maybe<Scalars['Boolean']['output']>;
  netBillUsage?: Maybe<Scalars['Float']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  percentChange?: Maybe<Scalars['Float']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  serviceType?: Maybe<UtilityMeterServiceType>;
  startDate?: Maybe<Scalars['Date']['output']>;
  /** The statement date of the meter statement. */
  statementDate?: Maybe<Scalars['String']['output']>;
  statementMonth?: Maybe<Scalars['Int']['output']>;
  statementYear?: Maybe<Scalars['Int']['output']>;
  taxes?: Maybe<Scalars['Float']['output']>;
  usageUnits?: Maybe<Scalars['String']['output']>;
  /** Reads a single `UtilityAccount` that is related to this `UtilityMeterStatementRollup`. */
  utilityAccount?: Maybe<UtilityAccount>;
  utilityAccountId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `UtilityMeter` that is related to this `UtilityMeterStatementRollup`. */
  utilityMeter?: Maybe<UtilityMeter>;
  utilityMeterId?: Maybe<Scalars['Int']['output']>;
};

export type UtilityMeterStatementRollupAggregates = {
  __typename?: 'UtilityMeterStatementRollupAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<UtilityMeterStatementRollupAverageAggregates>;
  /** Distinct aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinct?: Maybe<UtilityMeterStatementRollupDistinctAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<UtilityMeterStatementRollupDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<UtilityMeterStatementRollupMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<UtilityMeterStatementRollupMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<UtilityMeterStatementRollupStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<UtilityMeterStatementRollupStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<UtilityMeterStatementRollupSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<UtilityMeterStatementRollupVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<UtilityMeterStatementRollupVarianceSampleAggregates>;
};

export type UtilityMeterStatementRollupAverageAggregates = {
  __typename?: 'UtilityMeterStatementRollupAverageAggregates';
  /** Mean average of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of billCost across the matching connection */
  billCost?: Maybe<Scalars['Float']['output']>;
  /** Mean average of billDemand across the matching connection */
  billDemand?: Maybe<Scalars['Float']['output']>;
  /** Mean average of billDemandCost across the matching connection */
  billDemandCost?: Maybe<Scalars['Float']['output']>;
  /** Mean average of billExportUsage across the matching connection */
  billExportUsage?: Maybe<Scalars['Float']['output']>;
  /** Mean average of billImportUsage across the matching connection */
  billImportUsage?: Maybe<Scalars['Float']['output']>;
  /** Mean average of billUsage across the matching connection */
  billUsage?: Maybe<Scalars['Float']['output']>;
  /** Mean average of billUsageCost across the matching connection */
  billUsageCost?: Maybe<Scalars['Float']['output']>;
  /** Mean average of blendedRate across the matching connection */
  blendedRate?: Maybe<Scalars['Float']['output']>;
  /** Mean average of credits across the matching connection */
  credits?: Maybe<Scalars['Float']['output']>;
  /** Mean average of daysInBill across the matching connection */
  daysInBill?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of facilityId across the matching connection */
  facilityId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of fees across the matching connection */
  fees?: Maybe<Scalars['Float']['output']>;
  /** Mean average of loadFactor across the matching connection */
  loadFactor?: Maybe<Scalars['Float']['output']>;
  /** Mean average of meterStatementId across the matching connection */
  meterStatementId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of netBillUsage across the matching connection */
  netBillUsage?: Maybe<Scalars['Float']['output']>;
  /** Mean average of percentChange across the matching connection */
  percentChange?: Maybe<Scalars['Float']['output']>;
  /** Mean average of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of taxes across the matching connection */
  taxes?: Maybe<Scalars['Float']['output']>;
  /** Mean average of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of utilityMeterId across the matching connection */
  utilityMeterId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `UtilityMeterStatementRollup` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type UtilityMeterStatementRollupCondition = {
  /** Checks for equality with the object’s `accountLabel` field. */
  accountLabel?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `accountStatementId` field. */
  accountStatementId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `billArrivalDate` field. */
  billArrivalDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `billCost` field. */
  billCost?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `billDemand` field. */
  billDemand?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `billDemandCost` field. */
  billDemandCost?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `billExportUsage` field. */
  billExportUsage?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `billImportUsage` field. */
  billImportUsage?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `billUsage` field. */
  billUsage?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `billUsageCost` field. */
  billUsageCost?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `blendedRate` field. */
  blendedRate?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `credits` field. */
  credits?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `currencyCode` field. */
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `daysInBill` field. */
  daysInBill?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `demandUnits` field. */
  demandUnits?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `endDate` field. */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `fees` field. */
  fees?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `isValidated` field. */
  isValidated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `loadFactor` field. */
  loadFactor?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `meterEndDateSet` field. */
  meterEndDateSet?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `meterLabel` field. */
  meterLabel?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `meterStatementId` field. */
  meterStatementId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `netBillUsage` field. */
  netBillUsage?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `percentChange` field. */
  percentChange?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `provider` field. */
  provider?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `serviceType` field. */
  serviceType?: InputMaybe<UtilityMeterServiceType>;
  /** Checks for equality with the object’s `startDate` field. */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `statementMonth` field. */
  statementMonth?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `statementYear` field. */
  statementYear?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `taxes` field. */
  taxes?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `usageUnits` field. */
  usageUnits?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `utilityAccountId` field. */
  utilityAccountId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `utilityMeterId` field. */
  utilityMeterId?: InputMaybe<Scalars['Int']['input']>;
};

export type UtilityMeterStatementRollupDistinctAggregates = {
  __typename?: 'UtilityMeterStatementRollupDistinctAggregates';
  /** Distinct of accountLabel across the matching connection */
  accountLabel?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Distinct of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Distinct of billArrivalDate across the matching connection */
  billArrivalDate?: Maybe<Scalars['JSON']['output']>;
  /** Distinct of billCost across the matching connection */
  billCost?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Distinct of billDemand across the matching connection */
  billDemand?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Distinct of billDemandCost across the matching connection */
  billDemandCost?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Distinct of billExportUsage across the matching connection */
  billExportUsage?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Distinct of billImportUsage across the matching connection */
  billImportUsage?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Distinct of billUsage across the matching connection */
  billUsage?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Distinct of billUsageCost across the matching connection */
  billUsageCost?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Distinct of blendedRate across the matching connection */
  blendedRate?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Distinct of credits across the matching connection */
  credits?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Distinct of currencyCode across the matching connection */
  currencyCode?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Distinct of daysInBill across the matching connection */
  daysInBill?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Distinct of demandUnits across the matching connection */
  demandUnits?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Distinct of endDate across the matching connection */
  endDate?: Maybe<Scalars['JSON']['output']>;
  /** Distinct of facilityId across the matching connection */
  facilityId?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /**
   * Distinct of this field across the matching connection.
   *
   * ---
   *
   * The name of the facility associated with the meter statement.
   */
  facilityName?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Distinct of fees across the matching connection */
  fees?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Distinct of isValidated across the matching connection */
  isValidated?: Maybe<Scalars['JSON']['output']>;
  /** Distinct of loadFactor across the matching connection */
  loadFactor?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Distinct of meterEndDateSet across the matching connection */
  meterEndDateSet?: Maybe<Scalars['JSON']['output']>;
  /** Distinct of meterLabel across the matching connection */
  meterLabel?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Distinct of meterStatementId across the matching connection */
  meterStatementId?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /**
   * Distinct of this field across the matching connection.
   *
   * ---
   *
   * The nsight2 active status of the rows facility.
   */
  nSight2Active?: Maybe<Scalars['JSON']['output']>;
  /** Distinct of netBillUsage across the matching connection */
  netBillUsage?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Distinct of percentChange across the matching connection */
  percentChange?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Distinct of provider across the matching connection */
  provider?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Distinct of serviceType across the matching connection */
  serviceType?: Maybe<Scalars['JSON']['output']>;
  /** Distinct of startDate across the matching connection */
  startDate?: Maybe<Scalars['JSON']['output']>;
  /**
   * Distinct of this field across the matching connection.
   *
   * ---
   *
   * The statement date of the meter statement.
   */
  statementDate?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Distinct of statementMonth across the matching connection */
  statementMonth?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Distinct of statementYear across the matching connection */
  statementYear?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Distinct of taxes across the matching connection */
  taxes?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Distinct of usageUnits across the matching connection */
  usageUnits?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Distinct of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Distinct of utilityMeterId across the matching connection */
  utilityMeterId?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type UtilityMeterStatementRollupDistinctCountAggregates = {
  __typename?: 'UtilityMeterStatementRollupDistinctCountAggregates';
  /** Distinct count of accountLabel across the matching connection */
  accountLabel?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of billArrivalDate across the matching connection */
  billArrivalDate?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of billCost across the matching connection */
  billCost?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of billDemand across the matching connection */
  billDemand?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of billDemandCost across the matching connection */
  billDemandCost?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of billExportUsage across the matching connection */
  billExportUsage?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of billImportUsage across the matching connection */
  billImportUsage?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of billUsage across the matching connection */
  billUsage?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of billUsageCost across the matching connection */
  billUsageCost?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of blendedRate across the matching connection */
  blendedRate?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of credits across the matching connection */
  credits?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of currencyCode across the matching connection */
  currencyCode?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of daysInBill across the matching connection */
  daysInBill?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of demandUnits across the matching connection */
  demandUnits?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of endDate across the matching connection */
  endDate?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of facilityId across the matching connection */
  facilityId?: Maybe<Scalars['BigInt']['output']>;
  /**
   * Distinct count of this field across the matching connection.
   *
   * ---
   *
   * The name of the facility associated with the meter statement.
   */
  facilityName?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of fees across the matching connection */
  fees?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of isValidated across the matching connection */
  isValidated?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of loadFactor across the matching connection */
  loadFactor?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of meterEndDateSet across the matching connection */
  meterEndDateSet?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of meterLabel across the matching connection */
  meterLabel?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of meterStatementId across the matching connection */
  meterStatementId?: Maybe<Scalars['BigInt']['output']>;
  /**
   * Distinct count of this field across the matching connection.
   *
   * ---
   *
   * The nsight2 active status of the rows facility.
   */
  nSight2Active?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of netBillUsage across the matching connection */
  netBillUsage?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of percentChange across the matching connection */
  percentChange?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of provider across the matching connection */
  provider?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of serviceType across the matching connection */
  serviceType?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of startDate across the matching connection */
  startDate?: Maybe<Scalars['BigInt']['output']>;
  /**
   * Distinct count of this field across the matching connection.
   *
   * ---
   *
   * The statement date of the meter statement.
   */
  statementDate?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of taxes across the matching connection */
  taxes?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of usageUnits across the matching connection */
  usageUnits?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of utilityMeterId across the matching connection */
  utilityMeterId?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `UtilityMeterStatementRollup` object types. All fields are combined with a logical ‘and.’ */
export type UtilityMeterStatementRollupFilter = {
  /** Filter by the object’s `accountLabel` field. */
  accountLabel?: InputMaybe<StringFilter>;
  /** Filter by the object’s `accountStatementId` field. */
  accountStatementId?: InputMaybe<IntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UtilityMeterStatementRollupFilter>>;
  /** Filter by the object’s `billArrivalDate` field. */
  billArrivalDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `billCost` field. */
  billCost?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `billDemand` field. */
  billDemand?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `billDemandCost` field. */
  billDemandCost?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `billExportUsage` field. */
  billExportUsage?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `billImportUsage` field. */
  billImportUsage?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `billUsage` field. */
  billUsage?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `billUsageCost` field. */
  billUsageCost?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `blendedRate` field. */
  blendedRate?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `credits` field. */
  credits?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `currencyCode` field. */
  currencyCode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `daysInBill` field. */
  daysInBill?: InputMaybe<IntFilter>;
  /** Filter by the object’s `demandUnits` field. */
  demandUnits?: InputMaybe<StringFilter>;
  /** Filter by the object’s `endDate` field. */
  endDate?: InputMaybe<DateFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `facilityName` field. */
  facilityName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `fees` field. */
  fees?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `isValidated` field. */
  isValidated?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `loadFactor` field. */
  loadFactor?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `meterEndDateSet` field. */
  meterEndDateSet?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `meterLabel` field. */
  meterLabel?: InputMaybe<StringFilter>;
  /** Filter by the object’s `meterStatementId` field. */
  meterStatementId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `nSight2Active` field. */
  nSight2Active?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `netBillUsage` field. */
  netBillUsage?: InputMaybe<FloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UtilityMeterStatementRollupFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UtilityMeterStatementRollupFilter>>;
  /** Filter by the object’s `percentChange` field. */
  percentChange?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `provider` field. */
  provider?: InputMaybe<StringFilter>;
  /** Filter by the object’s `serviceType` field. */
  serviceType?: InputMaybe<UtilityMeterServiceTypeFilter>;
  /** Filter by the object’s `startDate` field. */
  startDate?: InputMaybe<DateFilter>;
  /** Filter by the object’s `statementDate` field. */
  statementDate?: InputMaybe<StringFilter>;
  /** Filter by the object’s `statementMonth` field. */
  statementMonth?: InputMaybe<IntFilter>;
  /** Filter by the object’s `statementYear` field. */
  statementYear?: InputMaybe<IntFilter>;
  /** Filter by the object’s `taxes` field. */
  taxes?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `usageUnits` field. */
  usageUnits?: InputMaybe<StringFilter>;
  /** Filter by the object’s `utilityAccountId` field. */
  utilityAccountId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `utilityMeterId` field. */
  utilityMeterId?: InputMaybe<IntFilter>;
};

export type UtilityMeterStatementRollupMaxAggregates = {
  __typename?: 'UtilityMeterStatementRollupMaxAggregates';
  /** Maximum of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of billCost across the matching connection */
  billCost?: Maybe<Scalars['Float']['output']>;
  /** Maximum of billDemand across the matching connection */
  billDemand?: Maybe<Scalars['Float']['output']>;
  /** Maximum of billDemandCost across the matching connection */
  billDemandCost?: Maybe<Scalars['Float']['output']>;
  /** Maximum of billExportUsage across the matching connection */
  billExportUsage?: Maybe<Scalars['Float']['output']>;
  /** Maximum of billImportUsage across the matching connection */
  billImportUsage?: Maybe<Scalars['Float']['output']>;
  /** Maximum of billUsage across the matching connection */
  billUsage?: Maybe<Scalars['Float']['output']>;
  /** Maximum of billUsageCost across the matching connection */
  billUsageCost?: Maybe<Scalars['Float']['output']>;
  /** Maximum of blendedRate across the matching connection */
  blendedRate?: Maybe<Scalars['Float']['output']>;
  /** Maximum of credits across the matching connection */
  credits?: Maybe<Scalars['Float']['output']>;
  /** Maximum of daysInBill across the matching connection */
  daysInBill?: Maybe<Scalars['Int']['output']>;
  /** Maximum of facilityId across the matching connection */
  facilityId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of fees across the matching connection */
  fees?: Maybe<Scalars['Float']['output']>;
  /** Maximum of loadFactor across the matching connection */
  loadFactor?: Maybe<Scalars['Float']['output']>;
  /** Maximum of meterStatementId across the matching connection */
  meterStatementId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of netBillUsage across the matching connection */
  netBillUsage?: Maybe<Scalars['Float']['output']>;
  /** Maximum of percentChange across the matching connection */
  percentChange?: Maybe<Scalars['Float']['output']>;
  /** Maximum of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['Int']['output']>;
  /** Maximum of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['Int']['output']>;
  /** Maximum of taxes across the matching connection */
  taxes?: Maybe<Scalars['Float']['output']>;
  /** Maximum of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of utilityMeterId across the matching connection */
  utilityMeterId?: Maybe<Scalars['Int']['output']>;
};

export type UtilityMeterStatementRollupMinAggregates = {
  __typename?: 'UtilityMeterStatementRollupMinAggregates';
  /** Minimum of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of billCost across the matching connection */
  billCost?: Maybe<Scalars['Float']['output']>;
  /** Minimum of billDemand across the matching connection */
  billDemand?: Maybe<Scalars['Float']['output']>;
  /** Minimum of billDemandCost across the matching connection */
  billDemandCost?: Maybe<Scalars['Float']['output']>;
  /** Minimum of billExportUsage across the matching connection */
  billExportUsage?: Maybe<Scalars['Float']['output']>;
  /** Minimum of billImportUsage across the matching connection */
  billImportUsage?: Maybe<Scalars['Float']['output']>;
  /** Minimum of billUsage across the matching connection */
  billUsage?: Maybe<Scalars['Float']['output']>;
  /** Minimum of billUsageCost across the matching connection */
  billUsageCost?: Maybe<Scalars['Float']['output']>;
  /** Minimum of blendedRate across the matching connection */
  blendedRate?: Maybe<Scalars['Float']['output']>;
  /** Minimum of credits across the matching connection */
  credits?: Maybe<Scalars['Float']['output']>;
  /** Minimum of daysInBill across the matching connection */
  daysInBill?: Maybe<Scalars['Int']['output']>;
  /** Minimum of facilityId across the matching connection */
  facilityId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of fees across the matching connection */
  fees?: Maybe<Scalars['Float']['output']>;
  /** Minimum of loadFactor across the matching connection */
  loadFactor?: Maybe<Scalars['Float']['output']>;
  /** Minimum of meterStatementId across the matching connection */
  meterStatementId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of netBillUsage across the matching connection */
  netBillUsage?: Maybe<Scalars['Float']['output']>;
  /** Minimum of percentChange across the matching connection */
  percentChange?: Maybe<Scalars['Float']['output']>;
  /** Minimum of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['Int']['output']>;
  /** Minimum of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['Int']['output']>;
  /** Minimum of taxes across the matching connection */
  taxes?: Maybe<Scalars['Float']['output']>;
  /** Minimum of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of utilityMeterId across the matching connection */
  utilityMeterId?: Maybe<Scalars['Int']['output']>;
};

export type UtilityMeterStatementRollupStddevPopulationAggregates = {
  __typename?: 'UtilityMeterStatementRollupStddevPopulationAggregates';
  /** Population standard deviation of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of billCost across the matching connection */
  billCost?: Maybe<Scalars['Float']['output']>;
  /** Population standard deviation of billDemand across the matching connection */
  billDemand?: Maybe<Scalars['Float']['output']>;
  /** Population standard deviation of billDemandCost across the matching connection */
  billDemandCost?: Maybe<Scalars['Float']['output']>;
  /** Population standard deviation of billExportUsage across the matching connection */
  billExportUsage?: Maybe<Scalars['Float']['output']>;
  /** Population standard deviation of billImportUsage across the matching connection */
  billImportUsage?: Maybe<Scalars['Float']['output']>;
  /** Population standard deviation of billUsage across the matching connection */
  billUsage?: Maybe<Scalars['Float']['output']>;
  /** Population standard deviation of billUsageCost across the matching connection */
  billUsageCost?: Maybe<Scalars['Float']['output']>;
  /** Population standard deviation of blendedRate across the matching connection */
  blendedRate?: Maybe<Scalars['Float']['output']>;
  /** Population standard deviation of credits across the matching connection */
  credits?: Maybe<Scalars['Float']['output']>;
  /** Population standard deviation of daysInBill across the matching connection */
  daysInBill?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of facilityId across the matching connection */
  facilityId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of fees across the matching connection */
  fees?: Maybe<Scalars['Float']['output']>;
  /** Population standard deviation of loadFactor across the matching connection */
  loadFactor?: Maybe<Scalars['Float']['output']>;
  /** Population standard deviation of meterStatementId across the matching connection */
  meterStatementId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of netBillUsage across the matching connection */
  netBillUsage?: Maybe<Scalars['Float']['output']>;
  /** Population standard deviation of percentChange across the matching connection */
  percentChange?: Maybe<Scalars['Float']['output']>;
  /** Population standard deviation of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of taxes across the matching connection */
  taxes?: Maybe<Scalars['Float']['output']>;
  /** Population standard deviation of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of utilityMeterId across the matching connection */
  utilityMeterId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UtilityMeterStatementRollupStddevSampleAggregates = {
  __typename?: 'UtilityMeterStatementRollupStddevSampleAggregates';
  /** Sample standard deviation of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of billCost across the matching connection */
  billCost?: Maybe<Scalars['Float']['output']>;
  /** Sample standard deviation of billDemand across the matching connection */
  billDemand?: Maybe<Scalars['Float']['output']>;
  /** Sample standard deviation of billDemandCost across the matching connection */
  billDemandCost?: Maybe<Scalars['Float']['output']>;
  /** Sample standard deviation of billExportUsage across the matching connection */
  billExportUsage?: Maybe<Scalars['Float']['output']>;
  /** Sample standard deviation of billImportUsage across the matching connection */
  billImportUsage?: Maybe<Scalars['Float']['output']>;
  /** Sample standard deviation of billUsage across the matching connection */
  billUsage?: Maybe<Scalars['Float']['output']>;
  /** Sample standard deviation of billUsageCost across the matching connection */
  billUsageCost?: Maybe<Scalars['Float']['output']>;
  /** Sample standard deviation of blendedRate across the matching connection */
  blendedRate?: Maybe<Scalars['Float']['output']>;
  /** Sample standard deviation of credits across the matching connection */
  credits?: Maybe<Scalars['Float']['output']>;
  /** Sample standard deviation of daysInBill across the matching connection */
  daysInBill?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of facilityId across the matching connection */
  facilityId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of fees across the matching connection */
  fees?: Maybe<Scalars['Float']['output']>;
  /** Sample standard deviation of loadFactor across the matching connection */
  loadFactor?: Maybe<Scalars['Float']['output']>;
  /** Sample standard deviation of meterStatementId across the matching connection */
  meterStatementId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of netBillUsage across the matching connection */
  netBillUsage?: Maybe<Scalars['Float']['output']>;
  /** Sample standard deviation of percentChange across the matching connection */
  percentChange?: Maybe<Scalars['Float']['output']>;
  /** Sample standard deviation of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of taxes across the matching connection */
  taxes?: Maybe<Scalars['Float']['output']>;
  /** Sample standard deviation of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of utilityMeterId across the matching connection */
  utilityMeterId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UtilityMeterStatementRollupSumAggregates = {
  __typename?: 'UtilityMeterStatementRollupSumAggregates';
  /** Sum of accountStatementId across the matching connection */
  accountStatementId: Scalars['BigInt']['output'];
  /** Sum of billCost across the matching connection */
  billCost: Scalars['Float']['output'];
  /** Sum of billDemand across the matching connection */
  billDemand: Scalars['Float']['output'];
  /** Sum of billDemandCost across the matching connection */
  billDemandCost: Scalars['Float']['output'];
  /** Sum of billExportUsage across the matching connection */
  billExportUsage: Scalars['Float']['output'];
  /** Sum of billImportUsage across the matching connection */
  billImportUsage: Scalars['Float']['output'];
  /** Sum of billUsage across the matching connection */
  billUsage: Scalars['Float']['output'];
  /** Sum of billUsageCost across the matching connection */
  billUsageCost: Scalars['Float']['output'];
  /** Sum of blendedRate across the matching connection */
  blendedRate: Scalars['Float']['output'];
  /** Sum of credits across the matching connection */
  credits: Scalars['Float']['output'];
  /** Sum of daysInBill across the matching connection */
  daysInBill: Scalars['BigInt']['output'];
  /** Sum of facilityId across the matching connection */
  facilityId: Scalars['BigInt']['output'];
  /** Sum of fees across the matching connection */
  fees: Scalars['Float']['output'];
  /** Sum of loadFactor across the matching connection */
  loadFactor: Scalars['Float']['output'];
  /** Sum of meterStatementId across the matching connection */
  meterStatementId: Scalars['BigInt']['output'];
  /** Sum of netBillUsage across the matching connection */
  netBillUsage: Scalars['Float']['output'];
  /** Sum of percentChange across the matching connection */
  percentChange: Scalars['Float']['output'];
  /** Sum of statementMonth across the matching connection */
  statementMonth: Scalars['BigInt']['output'];
  /** Sum of statementYear across the matching connection */
  statementYear: Scalars['BigInt']['output'];
  /** Sum of taxes across the matching connection */
  taxes: Scalars['Float']['output'];
  /** Sum of utilityAccountId across the matching connection */
  utilityAccountId: Scalars['BigInt']['output'];
  /** Sum of utilityMeterId across the matching connection */
  utilityMeterId: Scalars['BigInt']['output'];
};

export type UtilityMeterStatementRollupVariancePopulationAggregates = {
  __typename?: 'UtilityMeterStatementRollupVariancePopulationAggregates';
  /** Population variance of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of billCost across the matching connection */
  billCost?: Maybe<Scalars['Float']['output']>;
  /** Population variance of billDemand across the matching connection */
  billDemand?: Maybe<Scalars['Float']['output']>;
  /** Population variance of billDemandCost across the matching connection */
  billDemandCost?: Maybe<Scalars['Float']['output']>;
  /** Population variance of billExportUsage across the matching connection */
  billExportUsage?: Maybe<Scalars['Float']['output']>;
  /** Population variance of billImportUsage across the matching connection */
  billImportUsage?: Maybe<Scalars['Float']['output']>;
  /** Population variance of billUsage across the matching connection */
  billUsage?: Maybe<Scalars['Float']['output']>;
  /** Population variance of billUsageCost across the matching connection */
  billUsageCost?: Maybe<Scalars['Float']['output']>;
  /** Population variance of blendedRate across the matching connection */
  blendedRate?: Maybe<Scalars['Float']['output']>;
  /** Population variance of credits across the matching connection */
  credits?: Maybe<Scalars['Float']['output']>;
  /** Population variance of daysInBill across the matching connection */
  daysInBill?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of facilityId across the matching connection */
  facilityId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of fees across the matching connection */
  fees?: Maybe<Scalars['Float']['output']>;
  /** Population variance of loadFactor across the matching connection */
  loadFactor?: Maybe<Scalars['Float']['output']>;
  /** Population variance of meterStatementId across the matching connection */
  meterStatementId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of netBillUsage across the matching connection */
  netBillUsage?: Maybe<Scalars['Float']['output']>;
  /** Population variance of percentChange across the matching connection */
  percentChange?: Maybe<Scalars['Float']['output']>;
  /** Population variance of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of taxes across the matching connection */
  taxes?: Maybe<Scalars['Float']['output']>;
  /** Population variance of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of utilityMeterId across the matching connection */
  utilityMeterId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UtilityMeterStatementRollupVarianceSampleAggregates = {
  __typename?: 'UtilityMeterStatementRollupVarianceSampleAggregates';
  /** Sample variance of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of billCost across the matching connection */
  billCost?: Maybe<Scalars['Float']['output']>;
  /** Sample variance of billDemand across the matching connection */
  billDemand?: Maybe<Scalars['Float']['output']>;
  /** Sample variance of billDemandCost across the matching connection */
  billDemandCost?: Maybe<Scalars['Float']['output']>;
  /** Sample variance of billExportUsage across the matching connection */
  billExportUsage?: Maybe<Scalars['Float']['output']>;
  /** Sample variance of billImportUsage across the matching connection */
  billImportUsage?: Maybe<Scalars['Float']['output']>;
  /** Sample variance of billUsage across the matching connection */
  billUsage?: Maybe<Scalars['Float']['output']>;
  /** Sample variance of billUsageCost across the matching connection */
  billUsageCost?: Maybe<Scalars['Float']['output']>;
  /** Sample variance of blendedRate across the matching connection */
  blendedRate?: Maybe<Scalars['Float']['output']>;
  /** Sample variance of credits across the matching connection */
  credits?: Maybe<Scalars['Float']['output']>;
  /** Sample variance of daysInBill across the matching connection */
  daysInBill?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of facilityId across the matching connection */
  facilityId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of fees across the matching connection */
  fees?: Maybe<Scalars['Float']['output']>;
  /** Sample variance of loadFactor across the matching connection */
  loadFactor?: Maybe<Scalars['Float']['output']>;
  /** Sample variance of meterStatementId across the matching connection */
  meterStatementId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of netBillUsage across the matching connection */
  netBillUsage?: Maybe<Scalars['Float']['output']>;
  /** Sample variance of percentChange across the matching connection */
  percentChange?: Maybe<Scalars['Float']['output']>;
  /** Sample variance of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of taxes across the matching connection */
  taxes?: Maybe<Scalars['Float']['output']>;
  /** Sample variance of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of utilityMeterId across the matching connection */
  utilityMeterId?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `UtilityMeterStatementRollup` values. */
export type UtilityMeterStatementRollupsConnection = {
  __typename?: 'UtilityMeterStatementRollupsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<UtilityMeterStatementRollupAggregates>;
  /** A list of edges which contains the `UtilityMeterStatementRollup` and cursor to aid in pagination. */
  edges: Array<UtilityMeterStatementRollupsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<UtilityMeterStatementRollupAggregates>>;
  /** A list of `UtilityMeterStatementRollup` objects. */
  nodes: Array<UtilityMeterStatementRollup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UtilityMeterStatementRollup` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A connection to a list of `UtilityMeterStatementRollup` values. */
export type UtilityMeterStatementRollupsConnectionGroupedAggregatesArgs = {
  groupBy: Array<UtilityMeterStatementRollupsGroupBy>;
  having?: InputMaybe<UtilityMeterStatementRollupsHavingInput>;
};

/** A `UtilityMeterStatementRollup` edge in the connection. */
export type UtilityMeterStatementRollupsEdge = {
  __typename?: 'UtilityMeterStatementRollupsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UtilityMeterStatementRollup` at the end of the edge. */
  node: UtilityMeterStatementRollup;
};

/** Grouping methods for `UtilityMeterStatementRollup` for usage during aggregation. */
export enum UtilityMeterStatementRollupsGroupBy {
  ACCOUNT_LABEL = 'ACCOUNT_LABEL',
  ACCOUNT_LABEL_DISTINCT = 'ACCOUNT_LABEL_DISTINCT',
  ACCOUNT_STATEMENT_ID = 'ACCOUNT_STATEMENT_ID',
  ACCOUNT_STATEMENT_ID_DISTINCT = 'ACCOUNT_STATEMENT_ID_DISTINCT',
  BILL_ARRIVAL_DATE = 'BILL_ARRIVAL_DATE',
  BILL_ARRIVAL_DATE_DISTINCT = 'BILL_ARRIVAL_DATE_DISTINCT',
  BILL_ARRIVAL_DATE_TRUNCATED_TO_DAY = 'BILL_ARRIVAL_DATE_TRUNCATED_TO_DAY',
  BILL_ARRIVAL_DATE_TRUNCATED_TO_HOUR = 'BILL_ARRIVAL_DATE_TRUNCATED_TO_HOUR',
  BILL_COST = 'BILL_COST',
  BILL_COST_DISTINCT = 'BILL_COST_DISTINCT',
  BILL_DEMAND = 'BILL_DEMAND',
  BILL_DEMAND_COST = 'BILL_DEMAND_COST',
  BILL_DEMAND_COST_DISTINCT = 'BILL_DEMAND_COST_DISTINCT',
  BILL_DEMAND_DISTINCT = 'BILL_DEMAND_DISTINCT',
  BILL_EXPORT_USAGE = 'BILL_EXPORT_USAGE',
  BILL_EXPORT_USAGE_DISTINCT = 'BILL_EXPORT_USAGE_DISTINCT',
  BILL_IMPORT_USAGE = 'BILL_IMPORT_USAGE',
  BILL_IMPORT_USAGE_DISTINCT = 'BILL_IMPORT_USAGE_DISTINCT',
  BILL_USAGE = 'BILL_USAGE',
  BILL_USAGE_COST = 'BILL_USAGE_COST',
  BILL_USAGE_COST_DISTINCT = 'BILL_USAGE_COST_DISTINCT',
  BILL_USAGE_DISTINCT = 'BILL_USAGE_DISTINCT',
  BLENDED_RATE = 'BLENDED_RATE',
  BLENDED_RATE_DISTINCT = 'BLENDED_RATE_DISTINCT',
  CREDITS = 'CREDITS',
  CREDITS_DISTINCT = 'CREDITS_DISTINCT',
  CURRENCY_CODE = 'CURRENCY_CODE',
  CURRENCY_CODE_DISTINCT = 'CURRENCY_CODE_DISTINCT',
  DAYS_IN_BILL = 'DAYS_IN_BILL',
  DAYS_IN_BILL_DISTINCT = 'DAYS_IN_BILL_DISTINCT',
  DEMAND_UNITS = 'DEMAND_UNITS',
  DEMAND_UNITS_DISTINCT = 'DEMAND_UNITS_DISTINCT',
  END_DATE = 'END_DATE',
  END_DATE_DISTINCT = 'END_DATE_DISTINCT',
  FACILITY_ID = 'FACILITY_ID',
  FACILITY_ID_DISTINCT = 'FACILITY_ID_DISTINCT',
  FEES = 'FEES',
  FEES_DISTINCT = 'FEES_DISTINCT',
  IS_VALIDATED = 'IS_VALIDATED',
  IS_VALIDATED_DISTINCT = 'IS_VALIDATED_DISTINCT',
  LOAD_FACTOR = 'LOAD_FACTOR',
  LOAD_FACTOR_DISTINCT = 'LOAD_FACTOR_DISTINCT',
  METER_END_DATE_SET = 'METER_END_DATE_SET',
  METER_END_DATE_SET_DISTINCT = 'METER_END_DATE_SET_DISTINCT',
  METER_LABEL = 'METER_LABEL',
  METER_LABEL_DISTINCT = 'METER_LABEL_DISTINCT',
  METER_STATEMENT_ID = 'METER_STATEMENT_ID',
  METER_STATEMENT_ID_DISTINCT = 'METER_STATEMENT_ID_DISTINCT',
  NET_BILL_USAGE = 'NET_BILL_USAGE',
  NET_BILL_USAGE_DISTINCT = 'NET_BILL_USAGE_DISTINCT',
  PERCENT_CHANGE = 'PERCENT_CHANGE',
  PERCENT_CHANGE_DISTINCT = 'PERCENT_CHANGE_DISTINCT',
  PROVIDER = 'PROVIDER',
  PROVIDER_DISTINCT = 'PROVIDER_DISTINCT',
  SERVICE_TYPE = 'SERVICE_TYPE',
  SERVICE_TYPE_DISTINCT = 'SERVICE_TYPE_DISTINCT',
  START_DATE = 'START_DATE',
  START_DATE_DISTINCT = 'START_DATE_DISTINCT',
  STATEMENT_MONTH = 'STATEMENT_MONTH',
  STATEMENT_MONTH_DISTINCT = 'STATEMENT_MONTH_DISTINCT',
  STATEMENT_YEAR = 'STATEMENT_YEAR',
  STATEMENT_YEAR_DISTINCT = 'STATEMENT_YEAR_DISTINCT',
  TAXES = 'TAXES',
  TAXES_DISTINCT = 'TAXES_DISTINCT',
  USAGE_UNITS = 'USAGE_UNITS',
  USAGE_UNITS_DISTINCT = 'USAGE_UNITS_DISTINCT',
  UTILITY_ACCOUNT_ID = 'UTILITY_ACCOUNT_ID',
  UTILITY_ACCOUNT_ID_DISTINCT = 'UTILITY_ACCOUNT_ID_DISTINCT',
  UTILITY_METER_ID = 'UTILITY_METER_ID',
  UTILITY_METER_ID_DISTINCT = 'UTILITY_METER_ID_DISTINCT'
}

export type UtilityMeterStatementRollupsHavingAverageInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<HavingFloatFilter>;
  billDemand?: InputMaybe<HavingFloatFilter>;
  billDemandCost?: InputMaybe<HavingFloatFilter>;
  billExportUsage?: InputMaybe<HavingFloatFilter>;
  billImportUsage?: InputMaybe<HavingFloatFilter>;
  billUsage?: InputMaybe<HavingFloatFilter>;
  billUsageCost?: InputMaybe<HavingFloatFilter>;
  blendedRate?: InputMaybe<HavingFloatFilter>;
  credits?: InputMaybe<HavingFloatFilter>;
  daysInBill?: InputMaybe<HavingIntFilter>;
  endDate?: InputMaybe<HavingDatetimeFilter>;
  facilityId?: InputMaybe<HavingIntFilter>;
  fees?: InputMaybe<HavingFloatFilter>;
  loadFactor?: InputMaybe<HavingFloatFilter>;
  meterStatementId?: InputMaybe<HavingIntFilter>;
  netBillUsage?: InputMaybe<HavingFloatFilter>;
  percentChange?: InputMaybe<HavingFloatFilter>;
  startDate?: InputMaybe<HavingDatetimeFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<HavingFloatFilter>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
  utilityMeterId?: InputMaybe<HavingIntFilter>;
};

export type UtilityMeterStatementRollupsHavingDistinctCountInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<HavingFloatFilter>;
  billDemand?: InputMaybe<HavingFloatFilter>;
  billDemandCost?: InputMaybe<HavingFloatFilter>;
  billExportUsage?: InputMaybe<HavingFloatFilter>;
  billImportUsage?: InputMaybe<HavingFloatFilter>;
  billUsage?: InputMaybe<HavingFloatFilter>;
  billUsageCost?: InputMaybe<HavingFloatFilter>;
  blendedRate?: InputMaybe<HavingFloatFilter>;
  credits?: InputMaybe<HavingFloatFilter>;
  daysInBill?: InputMaybe<HavingIntFilter>;
  endDate?: InputMaybe<HavingDatetimeFilter>;
  facilityId?: InputMaybe<HavingIntFilter>;
  fees?: InputMaybe<HavingFloatFilter>;
  loadFactor?: InputMaybe<HavingFloatFilter>;
  meterStatementId?: InputMaybe<HavingIntFilter>;
  netBillUsage?: InputMaybe<HavingFloatFilter>;
  percentChange?: InputMaybe<HavingFloatFilter>;
  startDate?: InputMaybe<HavingDatetimeFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<HavingFloatFilter>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
  utilityMeterId?: InputMaybe<HavingIntFilter>;
};

export type UtilityMeterStatementRollupsHavingDistinctInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<HavingFloatFilter>;
  billDemand?: InputMaybe<HavingFloatFilter>;
  billDemandCost?: InputMaybe<HavingFloatFilter>;
  billExportUsage?: InputMaybe<HavingFloatFilter>;
  billImportUsage?: InputMaybe<HavingFloatFilter>;
  billUsage?: InputMaybe<HavingFloatFilter>;
  billUsageCost?: InputMaybe<HavingFloatFilter>;
  blendedRate?: InputMaybe<HavingFloatFilter>;
  credits?: InputMaybe<HavingFloatFilter>;
  daysInBill?: InputMaybe<HavingIntFilter>;
  endDate?: InputMaybe<HavingDatetimeFilter>;
  facilityId?: InputMaybe<HavingIntFilter>;
  fees?: InputMaybe<HavingFloatFilter>;
  loadFactor?: InputMaybe<HavingFloatFilter>;
  meterStatementId?: InputMaybe<HavingIntFilter>;
  netBillUsage?: InputMaybe<HavingFloatFilter>;
  percentChange?: InputMaybe<HavingFloatFilter>;
  startDate?: InputMaybe<HavingDatetimeFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<HavingFloatFilter>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
  utilityMeterId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `UtilityMeterStatementRollup` aggregates. */
export type UtilityMeterStatementRollupsHavingInput = {
  AND?: InputMaybe<Array<UtilityMeterStatementRollupsHavingInput>>;
  OR?: InputMaybe<Array<UtilityMeterStatementRollupsHavingInput>>;
  average?: InputMaybe<UtilityMeterStatementRollupsHavingAverageInput>;
  distinct?: InputMaybe<UtilityMeterStatementRollupsHavingDistinctInput>;
  distinctCount?: InputMaybe<UtilityMeterStatementRollupsHavingDistinctCountInput>;
  max?: InputMaybe<UtilityMeterStatementRollupsHavingMaxInput>;
  min?: InputMaybe<UtilityMeterStatementRollupsHavingMinInput>;
  stddevPopulation?: InputMaybe<UtilityMeterStatementRollupsHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<UtilityMeterStatementRollupsHavingStddevSampleInput>;
  sum?: InputMaybe<UtilityMeterStatementRollupsHavingSumInput>;
  variancePopulation?: InputMaybe<UtilityMeterStatementRollupsHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<UtilityMeterStatementRollupsHavingVarianceSampleInput>;
};

export type UtilityMeterStatementRollupsHavingMaxInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<HavingFloatFilter>;
  billDemand?: InputMaybe<HavingFloatFilter>;
  billDemandCost?: InputMaybe<HavingFloatFilter>;
  billExportUsage?: InputMaybe<HavingFloatFilter>;
  billImportUsage?: InputMaybe<HavingFloatFilter>;
  billUsage?: InputMaybe<HavingFloatFilter>;
  billUsageCost?: InputMaybe<HavingFloatFilter>;
  blendedRate?: InputMaybe<HavingFloatFilter>;
  credits?: InputMaybe<HavingFloatFilter>;
  daysInBill?: InputMaybe<HavingIntFilter>;
  endDate?: InputMaybe<HavingDatetimeFilter>;
  facilityId?: InputMaybe<HavingIntFilter>;
  fees?: InputMaybe<HavingFloatFilter>;
  loadFactor?: InputMaybe<HavingFloatFilter>;
  meterStatementId?: InputMaybe<HavingIntFilter>;
  netBillUsage?: InputMaybe<HavingFloatFilter>;
  percentChange?: InputMaybe<HavingFloatFilter>;
  startDate?: InputMaybe<HavingDatetimeFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<HavingFloatFilter>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
  utilityMeterId?: InputMaybe<HavingIntFilter>;
};

export type UtilityMeterStatementRollupsHavingMinInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<HavingFloatFilter>;
  billDemand?: InputMaybe<HavingFloatFilter>;
  billDemandCost?: InputMaybe<HavingFloatFilter>;
  billExportUsage?: InputMaybe<HavingFloatFilter>;
  billImportUsage?: InputMaybe<HavingFloatFilter>;
  billUsage?: InputMaybe<HavingFloatFilter>;
  billUsageCost?: InputMaybe<HavingFloatFilter>;
  blendedRate?: InputMaybe<HavingFloatFilter>;
  credits?: InputMaybe<HavingFloatFilter>;
  daysInBill?: InputMaybe<HavingIntFilter>;
  endDate?: InputMaybe<HavingDatetimeFilter>;
  facilityId?: InputMaybe<HavingIntFilter>;
  fees?: InputMaybe<HavingFloatFilter>;
  loadFactor?: InputMaybe<HavingFloatFilter>;
  meterStatementId?: InputMaybe<HavingIntFilter>;
  netBillUsage?: InputMaybe<HavingFloatFilter>;
  percentChange?: InputMaybe<HavingFloatFilter>;
  startDate?: InputMaybe<HavingDatetimeFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<HavingFloatFilter>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
  utilityMeterId?: InputMaybe<HavingIntFilter>;
};

export type UtilityMeterStatementRollupsHavingStddevPopulationInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<HavingFloatFilter>;
  billDemand?: InputMaybe<HavingFloatFilter>;
  billDemandCost?: InputMaybe<HavingFloatFilter>;
  billExportUsage?: InputMaybe<HavingFloatFilter>;
  billImportUsage?: InputMaybe<HavingFloatFilter>;
  billUsage?: InputMaybe<HavingFloatFilter>;
  billUsageCost?: InputMaybe<HavingFloatFilter>;
  blendedRate?: InputMaybe<HavingFloatFilter>;
  credits?: InputMaybe<HavingFloatFilter>;
  daysInBill?: InputMaybe<HavingIntFilter>;
  endDate?: InputMaybe<HavingDatetimeFilter>;
  facilityId?: InputMaybe<HavingIntFilter>;
  fees?: InputMaybe<HavingFloatFilter>;
  loadFactor?: InputMaybe<HavingFloatFilter>;
  meterStatementId?: InputMaybe<HavingIntFilter>;
  netBillUsage?: InputMaybe<HavingFloatFilter>;
  percentChange?: InputMaybe<HavingFloatFilter>;
  startDate?: InputMaybe<HavingDatetimeFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<HavingFloatFilter>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
  utilityMeterId?: InputMaybe<HavingIntFilter>;
};

export type UtilityMeterStatementRollupsHavingStddevSampleInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<HavingFloatFilter>;
  billDemand?: InputMaybe<HavingFloatFilter>;
  billDemandCost?: InputMaybe<HavingFloatFilter>;
  billExportUsage?: InputMaybe<HavingFloatFilter>;
  billImportUsage?: InputMaybe<HavingFloatFilter>;
  billUsage?: InputMaybe<HavingFloatFilter>;
  billUsageCost?: InputMaybe<HavingFloatFilter>;
  blendedRate?: InputMaybe<HavingFloatFilter>;
  credits?: InputMaybe<HavingFloatFilter>;
  daysInBill?: InputMaybe<HavingIntFilter>;
  endDate?: InputMaybe<HavingDatetimeFilter>;
  facilityId?: InputMaybe<HavingIntFilter>;
  fees?: InputMaybe<HavingFloatFilter>;
  loadFactor?: InputMaybe<HavingFloatFilter>;
  meterStatementId?: InputMaybe<HavingIntFilter>;
  netBillUsage?: InputMaybe<HavingFloatFilter>;
  percentChange?: InputMaybe<HavingFloatFilter>;
  startDate?: InputMaybe<HavingDatetimeFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<HavingFloatFilter>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
  utilityMeterId?: InputMaybe<HavingIntFilter>;
};

export type UtilityMeterStatementRollupsHavingSumInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<HavingFloatFilter>;
  billDemand?: InputMaybe<HavingFloatFilter>;
  billDemandCost?: InputMaybe<HavingFloatFilter>;
  billExportUsage?: InputMaybe<HavingFloatFilter>;
  billImportUsage?: InputMaybe<HavingFloatFilter>;
  billUsage?: InputMaybe<HavingFloatFilter>;
  billUsageCost?: InputMaybe<HavingFloatFilter>;
  blendedRate?: InputMaybe<HavingFloatFilter>;
  credits?: InputMaybe<HavingFloatFilter>;
  daysInBill?: InputMaybe<HavingIntFilter>;
  endDate?: InputMaybe<HavingDatetimeFilter>;
  facilityId?: InputMaybe<HavingIntFilter>;
  fees?: InputMaybe<HavingFloatFilter>;
  loadFactor?: InputMaybe<HavingFloatFilter>;
  meterStatementId?: InputMaybe<HavingIntFilter>;
  netBillUsage?: InputMaybe<HavingFloatFilter>;
  percentChange?: InputMaybe<HavingFloatFilter>;
  startDate?: InputMaybe<HavingDatetimeFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<HavingFloatFilter>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
  utilityMeterId?: InputMaybe<HavingIntFilter>;
};

export type UtilityMeterStatementRollupsHavingVariancePopulationInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<HavingFloatFilter>;
  billDemand?: InputMaybe<HavingFloatFilter>;
  billDemandCost?: InputMaybe<HavingFloatFilter>;
  billExportUsage?: InputMaybe<HavingFloatFilter>;
  billImportUsage?: InputMaybe<HavingFloatFilter>;
  billUsage?: InputMaybe<HavingFloatFilter>;
  billUsageCost?: InputMaybe<HavingFloatFilter>;
  blendedRate?: InputMaybe<HavingFloatFilter>;
  credits?: InputMaybe<HavingFloatFilter>;
  daysInBill?: InputMaybe<HavingIntFilter>;
  endDate?: InputMaybe<HavingDatetimeFilter>;
  facilityId?: InputMaybe<HavingIntFilter>;
  fees?: InputMaybe<HavingFloatFilter>;
  loadFactor?: InputMaybe<HavingFloatFilter>;
  meterStatementId?: InputMaybe<HavingIntFilter>;
  netBillUsage?: InputMaybe<HavingFloatFilter>;
  percentChange?: InputMaybe<HavingFloatFilter>;
  startDate?: InputMaybe<HavingDatetimeFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<HavingFloatFilter>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
  utilityMeterId?: InputMaybe<HavingIntFilter>;
};

export type UtilityMeterStatementRollupsHavingVarianceSampleInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<HavingFloatFilter>;
  billDemand?: InputMaybe<HavingFloatFilter>;
  billDemandCost?: InputMaybe<HavingFloatFilter>;
  billExportUsage?: InputMaybe<HavingFloatFilter>;
  billImportUsage?: InputMaybe<HavingFloatFilter>;
  billUsage?: InputMaybe<HavingFloatFilter>;
  billUsageCost?: InputMaybe<HavingFloatFilter>;
  blendedRate?: InputMaybe<HavingFloatFilter>;
  credits?: InputMaybe<HavingFloatFilter>;
  daysInBill?: InputMaybe<HavingIntFilter>;
  endDate?: InputMaybe<HavingDatetimeFilter>;
  facilityId?: InputMaybe<HavingIntFilter>;
  fees?: InputMaybe<HavingFloatFilter>;
  loadFactor?: InputMaybe<HavingFloatFilter>;
  meterStatementId?: InputMaybe<HavingIntFilter>;
  netBillUsage?: InputMaybe<HavingFloatFilter>;
  percentChange?: InputMaybe<HavingFloatFilter>;
  startDate?: InputMaybe<HavingDatetimeFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<HavingFloatFilter>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
  utilityMeterId?: InputMaybe<HavingIntFilter>;
};

/** Methods to use when ordering `UtilityMeterStatementRollup`. */
export enum UtilityMeterStatementRollupsOrderBy {
  ACCOUNT_LABEL_ASC = 'ACCOUNT_LABEL_ASC',
  ACCOUNT_LABEL_DESC = 'ACCOUNT_LABEL_DESC',
  ACCOUNT_STATEMENT_ID_ASC = 'ACCOUNT_STATEMENT_ID_ASC',
  ACCOUNT_STATEMENT_ID_DESC = 'ACCOUNT_STATEMENT_ID_DESC',
  BILL_ARRIVAL_DATE_ASC = 'BILL_ARRIVAL_DATE_ASC',
  BILL_ARRIVAL_DATE_DESC = 'BILL_ARRIVAL_DATE_DESC',
  BILL_COST_ASC = 'BILL_COST_ASC',
  BILL_COST_DESC = 'BILL_COST_DESC',
  BILL_DEMAND_ASC = 'BILL_DEMAND_ASC',
  BILL_DEMAND_COST_ASC = 'BILL_DEMAND_COST_ASC',
  BILL_DEMAND_COST_DESC = 'BILL_DEMAND_COST_DESC',
  BILL_DEMAND_DESC = 'BILL_DEMAND_DESC',
  BILL_EXPORT_USAGE_ASC = 'BILL_EXPORT_USAGE_ASC',
  BILL_EXPORT_USAGE_DESC = 'BILL_EXPORT_USAGE_DESC',
  BILL_IMPORT_USAGE_ASC = 'BILL_IMPORT_USAGE_ASC',
  BILL_IMPORT_USAGE_DESC = 'BILL_IMPORT_USAGE_DESC',
  BILL_USAGE_ASC = 'BILL_USAGE_ASC',
  BILL_USAGE_COST_ASC = 'BILL_USAGE_COST_ASC',
  BILL_USAGE_COST_DESC = 'BILL_USAGE_COST_DESC',
  BILL_USAGE_DESC = 'BILL_USAGE_DESC',
  BLENDED_RATE_ASC = 'BLENDED_RATE_ASC',
  BLENDED_RATE_DESC = 'BLENDED_RATE_DESC',
  CREDITS_ASC = 'CREDITS_ASC',
  CREDITS_DESC = 'CREDITS_DESC',
  CURRENCY_CODE_ASC = 'CURRENCY_CODE_ASC',
  CURRENCY_CODE_DESC = 'CURRENCY_CODE_DESC',
  DAYS_IN_BILL_ASC = 'DAYS_IN_BILL_ASC',
  DAYS_IN_BILL_DESC = 'DAYS_IN_BILL_DESC',
  DEMAND_UNITS_ASC = 'DEMAND_UNITS_ASC',
  DEMAND_UNITS_DESC = 'DEMAND_UNITS_DESC',
  END_DATE_ASC = 'END_DATE_ASC',
  END_DATE_DESC = 'END_DATE_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  FACILITY_NAME_ASC = 'FACILITY_NAME_ASC',
  FACILITY_NAME_DESC = 'FACILITY_NAME_DESC',
  FEES_ASC = 'FEES_ASC',
  FEES_DESC = 'FEES_DESC',
  IS_VALIDATED_ASC = 'IS_VALIDATED_ASC',
  IS_VALIDATED_DESC = 'IS_VALIDATED_DESC',
  LOAD_FACTOR_ASC = 'LOAD_FACTOR_ASC',
  LOAD_FACTOR_DESC = 'LOAD_FACTOR_DESC',
  METER_END_DATE_SET_ASC = 'METER_END_DATE_SET_ASC',
  METER_END_DATE_SET_DESC = 'METER_END_DATE_SET_DESC',
  METER_LABEL_ASC = 'METER_LABEL_ASC',
  METER_LABEL_DESC = 'METER_LABEL_DESC',
  METER_STATEMENT_ID_ASC = 'METER_STATEMENT_ID_ASC',
  METER_STATEMENT_ID_DESC = 'METER_STATEMENT_ID_DESC',
  NATURAL = 'NATURAL',
  NET_BILL_USAGE_ASC = 'NET_BILL_USAGE_ASC',
  NET_BILL_USAGE_DESC = 'NET_BILL_USAGE_DESC',
  N_SIGHT2_ACTIVE_ASC = 'N_SIGHT2_ACTIVE_ASC',
  N_SIGHT2_ACTIVE_DESC = 'N_SIGHT2_ACTIVE_DESC',
  PERCENT_CHANGE_ASC = 'PERCENT_CHANGE_ASC',
  PERCENT_CHANGE_DESC = 'PERCENT_CHANGE_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  PROVIDER_ASC = 'PROVIDER_ASC',
  PROVIDER_DESC = 'PROVIDER_DESC',
  SERVICE_TYPE_ASC = 'SERVICE_TYPE_ASC',
  SERVICE_TYPE_DESC = 'SERVICE_TYPE_DESC',
  START_DATE_ASC = 'START_DATE_ASC',
  START_DATE_DESC = 'START_DATE_DESC',
  STATEMENT_DATE_ASC = 'STATEMENT_DATE_ASC',
  STATEMENT_DATE_DESC = 'STATEMENT_DATE_DESC',
  STATEMENT_MONTH_ASC = 'STATEMENT_MONTH_ASC',
  STATEMENT_MONTH_DESC = 'STATEMENT_MONTH_DESC',
  STATEMENT_YEAR_ASC = 'STATEMENT_YEAR_ASC',
  STATEMENT_YEAR_DESC = 'STATEMENT_YEAR_DESC',
  TAXES_ASC = 'TAXES_ASC',
  TAXES_DESC = 'TAXES_DESC',
  USAGE_UNITS_ASC = 'USAGE_UNITS_ASC',
  USAGE_UNITS_DESC = 'USAGE_UNITS_DESC',
  UTILITY_ACCOUNT_ID_ASC = 'UTILITY_ACCOUNT_ID_ASC',
  UTILITY_ACCOUNT_ID_DESC = 'UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_ID_ASC = 'UTILITY_METER_ID_ASC',
  UTILITY_METER_ID_DESC = 'UTILITY_METER_ID_DESC'
}

export type UtilityMeterStatementStddevPopulationAggregates = {
  __typename?: 'UtilityMeterStatementStddevPopulationAggregates';
  /** Population standard deviation of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of accountStatementPdfId across the matching connection */
  accountStatementPdfId?: Maybe<Scalars['BigFloat']['output']>;
  /**
   * Population standard deviation of this field across the matching connection.
   *
   * ---
   *
   * Returns the total charges of a given utility_meter_statements (view) row.
   */
  billCost?: Maybe<Scalars['Float']['output']>;
  /** Population standard deviation of this field across the matching connection. */
  billDemand?: Maybe<Scalars['Float']['output']>;
  /**
   * Population standard deviation of this field across the matching connection.
   *
   * ---
   *
   * Returns the total demand charges of a given utility_meter_statements (view) row.
   */
  billDemandCost?: Maybe<Scalars['Float']['output']>;
  /**
   * Population standard deviation of this field across the matching connection.
   *
   * ---
   *
   * Returns the total demand of a given utility_meter_statements (view) row.
   */
  billUsage?: Maybe<Scalars['Float']['output']>;
  /**
   * Population standard deviation of this field across the matching connection.
   *
   * ---
   *
   * Returns the total usage charges of a given utility_meter_statements (view) row.
   */
  billUsageCost?: Maybe<Scalars['Float']['output']>;
  /**
   * Population standard deviation of this field across the matching connection.
   *
   * ---
   *
   * Returns the total credits of a given utility_meter_statements (view) row.
   */
  credits?: Maybe<Scalars['Float']['output']>;
  /** Population standard deviation of daysInBill across the matching connection */
  daysInBill?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of facilityId across the matching connection */
  facilityId?: Maybe<Scalars['BigFloat']['output']>;
  /**
   * Population standard deviation of this field across the matching connection.
   *
   * ---
   *
   * Returns the total fee charges of a given utility_meter_statements (view) row.
   */
  fees?: Maybe<Scalars['Float']['output']>;
  /** Population standard deviation of meterStatementId across the matching connection */
  meterStatementId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['BigFloat']['output']>;
  /**
   * Population standard deviation of this field across the matching connection.
   *
   * ---
   *
   * Returns the total tax charges of a given utility_meter_statements (view) row.
   */
  taxes?: Maybe<Scalars['Float']['output']>;
  /** Population standard deviation of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of utilityMeterId across the matching connection */
  utilityMeterId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UtilityMeterStatementStddevSampleAggregates = {
  __typename?: 'UtilityMeterStatementStddevSampleAggregates';
  /** Sample standard deviation of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of accountStatementPdfId across the matching connection */
  accountStatementPdfId?: Maybe<Scalars['BigFloat']['output']>;
  /**
   * Sample standard deviation of this field across the matching connection.
   *
   * ---
   *
   * Returns the total charges of a given utility_meter_statements (view) row.
   */
  billCost?: Maybe<Scalars['Float']['output']>;
  /** Sample standard deviation of this field across the matching connection. */
  billDemand?: Maybe<Scalars['Float']['output']>;
  /**
   * Sample standard deviation of this field across the matching connection.
   *
   * ---
   *
   * Returns the total demand charges of a given utility_meter_statements (view) row.
   */
  billDemandCost?: Maybe<Scalars['Float']['output']>;
  /**
   * Sample standard deviation of this field across the matching connection.
   *
   * ---
   *
   * Returns the total demand of a given utility_meter_statements (view) row.
   */
  billUsage?: Maybe<Scalars['Float']['output']>;
  /**
   * Sample standard deviation of this field across the matching connection.
   *
   * ---
   *
   * Returns the total usage charges of a given utility_meter_statements (view) row.
   */
  billUsageCost?: Maybe<Scalars['Float']['output']>;
  /**
   * Sample standard deviation of this field across the matching connection.
   *
   * ---
   *
   * Returns the total credits of a given utility_meter_statements (view) row.
   */
  credits?: Maybe<Scalars['Float']['output']>;
  /** Sample standard deviation of daysInBill across the matching connection */
  daysInBill?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of facilityId across the matching connection */
  facilityId?: Maybe<Scalars['BigFloat']['output']>;
  /**
   * Sample standard deviation of this field across the matching connection.
   *
   * ---
   *
   * Returns the total fee charges of a given utility_meter_statements (view) row.
   */
  fees?: Maybe<Scalars['Float']['output']>;
  /** Sample standard deviation of meterStatementId across the matching connection */
  meterStatementId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['BigFloat']['output']>;
  /**
   * Sample standard deviation of this field across the matching connection.
   *
   * ---
   *
   * Returns the total tax charges of a given utility_meter_statements (view) row.
   */
  taxes?: Maybe<Scalars['Float']['output']>;
  /** Sample standard deviation of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of utilityMeterId across the matching connection */
  utilityMeterId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UtilityMeterStatementSumAggregates = {
  __typename?: 'UtilityMeterStatementSumAggregates';
  /** Sum of accountStatementId across the matching connection */
  accountStatementId: Scalars['BigInt']['output'];
  /** Sum of accountStatementPdfId across the matching connection */
  accountStatementPdfId: Scalars['BigInt']['output'];
  /**
   * Sum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total charges of a given utility_meter_statements (view) row.
   */
  billCost?: Maybe<Scalars['Float']['output']>;
  /** Sum of this field across the matching connection. */
  billDemand?: Maybe<Scalars['Float']['output']>;
  /**
   * Sum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total demand charges of a given utility_meter_statements (view) row.
   */
  billDemandCost?: Maybe<Scalars['Float']['output']>;
  /**
   * Sum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total demand of a given utility_meter_statements (view) row.
   */
  billUsage?: Maybe<Scalars['Float']['output']>;
  /**
   * Sum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total usage charges of a given utility_meter_statements (view) row.
   */
  billUsageCost?: Maybe<Scalars['Float']['output']>;
  /**
   * Sum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total credits of a given utility_meter_statements (view) row.
   */
  credits?: Maybe<Scalars['Float']['output']>;
  /** Sum of daysInBill across the matching connection */
  daysInBill: Scalars['BigInt']['output'];
  /** Sum of facilityId across the matching connection */
  facilityId: Scalars['BigInt']['output'];
  /**
   * Sum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total fee charges of a given utility_meter_statements (view) row.
   */
  fees?: Maybe<Scalars['Float']['output']>;
  /** Sum of meterStatementId across the matching connection */
  meterStatementId: Scalars['BigInt']['output'];
  /** Sum of statementMonth across the matching connection */
  statementMonth: Scalars['BigInt']['output'];
  /** Sum of statementYear across the matching connection */
  statementYear: Scalars['BigInt']['output'];
  /**
   * Sum of this field across the matching connection.
   *
   * ---
   *
   * Returns the total tax charges of a given utility_meter_statements (view) row.
   */
  taxes?: Maybe<Scalars['Float']['output']>;
  /** Sum of utilityAccountId across the matching connection */
  utilityAccountId: Scalars['BigInt']['output'];
  /** Sum of utilityMeterId across the matching connection */
  utilityMeterId: Scalars['BigInt']['output'];
};

export type UtilityMeterStatementVariancePopulationAggregates = {
  __typename?: 'UtilityMeterStatementVariancePopulationAggregates';
  /** Population variance of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of accountStatementPdfId across the matching connection */
  accountStatementPdfId?: Maybe<Scalars['BigFloat']['output']>;
  /**
   * Population variance of this field across the matching connection.
   *
   * ---
   *
   * Returns the total charges of a given utility_meter_statements (view) row.
   */
  billCost?: Maybe<Scalars['Float']['output']>;
  /** Population variance of this field across the matching connection. */
  billDemand?: Maybe<Scalars['Float']['output']>;
  /**
   * Population variance of this field across the matching connection.
   *
   * ---
   *
   * Returns the total demand charges of a given utility_meter_statements (view) row.
   */
  billDemandCost?: Maybe<Scalars['Float']['output']>;
  /**
   * Population variance of this field across the matching connection.
   *
   * ---
   *
   * Returns the total demand of a given utility_meter_statements (view) row.
   */
  billUsage?: Maybe<Scalars['Float']['output']>;
  /**
   * Population variance of this field across the matching connection.
   *
   * ---
   *
   * Returns the total usage charges of a given utility_meter_statements (view) row.
   */
  billUsageCost?: Maybe<Scalars['Float']['output']>;
  /**
   * Population variance of this field across the matching connection.
   *
   * ---
   *
   * Returns the total credits of a given utility_meter_statements (view) row.
   */
  credits?: Maybe<Scalars['Float']['output']>;
  /** Population variance of daysInBill across the matching connection */
  daysInBill?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of facilityId across the matching connection */
  facilityId?: Maybe<Scalars['BigFloat']['output']>;
  /**
   * Population variance of this field across the matching connection.
   *
   * ---
   *
   * Returns the total fee charges of a given utility_meter_statements (view) row.
   */
  fees?: Maybe<Scalars['Float']['output']>;
  /** Population variance of meterStatementId across the matching connection */
  meterStatementId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['BigFloat']['output']>;
  /**
   * Population variance of this field across the matching connection.
   *
   * ---
   *
   * Returns the total tax charges of a given utility_meter_statements (view) row.
   */
  taxes?: Maybe<Scalars['Float']['output']>;
  /** Population variance of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of utilityMeterId across the matching connection */
  utilityMeterId?: Maybe<Scalars['BigFloat']['output']>;
};

export type UtilityMeterStatementVarianceSampleAggregates = {
  __typename?: 'UtilityMeterStatementVarianceSampleAggregates';
  /** Sample variance of accountStatementId across the matching connection */
  accountStatementId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of accountStatementPdfId across the matching connection */
  accountStatementPdfId?: Maybe<Scalars['BigFloat']['output']>;
  /**
   * Sample variance of this field across the matching connection.
   *
   * ---
   *
   * Returns the total charges of a given utility_meter_statements (view) row.
   */
  billCost?: Maybe<Scalars['Float']['output']>;
  /** Sample variance of this field across the matching connection. */
  billDemand?: Maybe<Scalars['Float']['output']>;
  /**
   * Sample variance of this field across the matching connection.
   *
   * ---
   *
   * Returns the total demand charges of a given utility_meter_statements (view) row.
   */
  billDemandCost?: Maybe<Scalars['Float']['output']>;
  /**
   * Sample variance of this field across the matching connection.
   *
   * ---
   *
   * Returns the total demand of a given utility_meter_statements (view) row.
   */
  billUsage?: Maybe<Scalars['Float']['output']>;
  /**
   * Sample variance of this field across the matching connection.
   *
   * ---
   *
   * Returns the total usage charges of a given utility_meter_statements (view) row.
   */
  billUsageCost?: Maybe<Scalars['Float']['output']>;
  /**
   * Sample variance of this field across the matching connection.
   *
   * ---
   *
   * Returns the total credits of a given utility_meter_statements (view) row.
   */
  credits?: Maybe<Scalars['Float']['output']>;
  /** Sample variance of daysInBill across the matching connection */
  daysInBill?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of facilityId across the matching connection */
  facilityId?: Maybe<Scalars['BigFloat']['output']>;
  /**
   * Sample variance of this field across the matching connection.
   *
   * ---
   *
   * Returns the total fee charges of a given utility_meter_statements (view) row.
   */
  fees?: Maybe<Scalars['Float']['output']>;
  /** Sample variance of meterStatementId across the matching connection */
  meterStatementId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of statementMonth across the matching connection */
  statementMonth?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of statementYear across the matching connection */
  statementYear?: Maybe<Scalars['BigFloat']['output']>;
  /**
   * Sample variance of this field across the matching connection.
   *
   * ---
   *
   * Returns the total tax charges of a given utility_meter_statements (view) row.
   */
  taxes?: Maybe<Scalars['Float']['output']>;
  /** Sample variance of utilityAccountId across the matching connection */
  utilityAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of utilityMeterId across the matching connection */
  utilityMeterId?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `UtilityMeterStatement` values. */
export type UtilityMeterStatementsConnection = {
  __typename?: 'UtilityMeterStatementsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<UtilityMeterStatementAggregates>;
  /** A list of edges which contains the `UtilityMeterStatement` and cursor to aid in pagination. */
  edges: Array<UtilityMeterStatementsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<UtilityMeterStatementAggregates>>;
  /** A list of `UtilityMeterStatement` objects. */
  nodes: Array<UtilityMeterStatement>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UtilityMeterStatement` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A connection to a list of `UtilityMeterStatement` values. */
export type UtilityMeterStatementsConnectionGroupedAggregatesArgs = {
  groupBy: Array<UtilityMeterStatementsGroupBy>;
  having?: InputMaybe<UtilityMeterStatementsHavingInput>;
};

/** A `UtilityMeterStatement` edge in the connection. */
export type UtilityMeterStatementsEdge = {
  __typename?: 'UtilityMeterStatementsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UtilityMeterStatement` at the end of the edge. */
  node: UtilityMeterStatement;
};

/** Grouping methods for `UtilityMeterStatement` for usage during aggregation. */
export enum UtilityMeterStatementsGroupBy {
  ACCOUNT_LABEL = 'ACCOUNT_LABEL',
  ACCOUNT_LABEL_DISTINCT = 'ACCOUNT_LABEL_DISTINCT',
  ACCOUNT_STATEMENT_ID = 'ACCOUNT_STATEMENT_ID',
  ACCOUNT_STATEMENT_ID_DISTINCT = 'ACCOUNT_STATEMENT_ID_DISTINCT',
  ACCOUNT_STATEMENT_PDF_ID = 'ACCOUNT_STATEMENT_PDF_ID',
  ACCOUNT_STATEMENT_PDF_ID_DISTINCT = 'ACCOUNT_STATEMENT_PDF_ID_DISTINCT',
  BILL_ARRIVAL_DATE = 'BILL_ARRIVAL_DATE',
  BILL_ARRIVAL_DATE_DISTINCT = 'BILL_ARRIVAL_DATE_DISTINCT',
  BILL_ARRIVAL_DATE_TRUNCATED_TO_DAY = 'BILL_ARRIVAL_DATE_TRUNCATED_TO_DAY',
  BILL_ARRIVAL_DATE_TRUNCATED_TO_HOUR = 'BILL_ARRIVAL_DATE_TRUNCATED_TO_HOUR',
  CURRENCY_CODE = 'CURRENCY_CODE',
  CURRENCY_CODE_DISTINCT = 'CURRENCY_CODE_DISTINCT',
  DAYS_IN_BILL = 'DAYS_IN_BILL',
  DAYS_IN_BILL_DISTINCT = 'DAYS_IN_BILL_DISTINCT',
  DEMAND_UNITS = 'DEMAND_UNITS',
  DEMAND_UNITS_DISTINCT = 'DEMAND_UNITS_DISTINCT',
  END_DATE = 'END_DATE',
  END_DATE_DISTINCT = 'END_DATE_DISTINCT',
  EXCLUDE_USAGE = 'EXCLUDE_USAGE',
  EXCLUDE_USAGE_DISTINCT = 'EXCLUDE_USAGE_DISTINCT',
  FACILITY_ID = 'FACILITY_ID',
  FACILITY_ID_DISTINCT = 'FACILITY_ID_DISTINCT',
  IS_VALIDATED = 'IS_VALIDATED',
  IS_VALIDATED_DISTINCT = 'IS_VALIDATED_DISTINCT',
  METER_END_DATE_SET = 'METER_END_DATE_SET',
  METER_END_DATE_SET_DISTINCT = 'METER_END_DATE_SET_DISTINCT',
  METER_LABEL = 'METER_LABEL',
  METER_LABEL_DISTINCT = 'METER_LABEL_DISTINCT',
  METER_STATEMENT_ID = 'METER_STATEMENT_ID',
  METER_STATEMENT_ID_DISTINCT = 'METER_STATEMENT_ID_DISTINCT',
  PROVIDER = 'PROVIDER',
  PROVIDER_DISTINCT = 'PROVIDER_DISTINCT',
  SERVICE_TYPE = 'SERVICE_TYPE',
  SERVICE_TYPE_DISTINCT = 'SERVICE_TYPE_DISTINCT',
  START_DATE = 'START_DATE',
  START_DATE_DISTINCT = 'START_DATE_DISTINCT',
  STATEMENT_MONTH = 'STATEMENT_MONTH',
  STATEMENT_MONTH_DISTINCT = 'STATEMENT_MONTH_DISTINCT',
  STATEMENT_YEAR = 'STATEMENT_YEAR',
  STATEMENT_YEAR_DISTINCT = 'STATEMENT_YEAR_DISTINCT',
  USAGE_UNITS = 'USAGE_UNITS',
  USAGE_UNITS_DISTINCT = 'USAGE_UNITS_DISTINCT',
  UTILITY_ACCOUNT_ID = 'UTILITY_ACCOUNT_ID',
  UTILITY_ACCOUNT_ID_DISTINCT = 'UTILITY_ACCOUNT_ID_DISTINCT',
  UTILITY_METER_ID = 'UTILITY_METER_ID',
  UTILITY_METER_ID_DISTINCT = 'UTILITY_METER_ID_DISTINCT'
}

export type UtilityMeterStatementsHavingAverageInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  accountStatementPdfId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<UtilityMeterStatementsHavingAverageUtilityMeterStatementsBillCostInput>;
  billDemand?: InputMaybe<UtilityMeterStatementsHavingAverageUtilityMeterStatementsBillDemandInput>;
  billDemandCost?: InputMaybe<UtilityMeterStatementsHavingAverageUtilityMeterStatementsBillDemandCostInput>;
  billUsage?: InputMaybe<UtilityMeterStatementsHavingAverageUtilityMeterStatementsBillUsageInput>;
  billUsageCost?: InputMaybe<UtilityMeterStatementsHavingAverageUtilityMeterStatementsBillUsageCostInput>;
  credits?: InputMaybe<UtilityMeterStatementsHavingAverageUtilityMeterStatementsCreditsInput>;
  daysInBill?: InputMaybe<HavingIntFilter>;
  endDate?: InputMaybe<HavingDatetimeFilter>;
  facilityId?: InputMaybe<HavingIntFilter>;
  fees?: InputMaybe<UtilityMeterStatementsHavingAverageUtilityMeterStatementsFeesInput>;
  meterStatementId?: InputMaybe<HavingIntFilter>;
  startDate?: InputMaybe<HavingDatetimeFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<UtilityMeterStatementsHavingAverageUtilityMeterStatementsTaxesInput>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
  utilityMeterId?: InputMaybe<HavingIntFilter>;
};

export type UtilityMeterStatementsHavingAverageUtilityMeterStatementsBillCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingAverageUtilityMeterStatementsBillDemandCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingAverageUtilityMeterStatementsBillDemandInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingAverageUtilityMeterStatementsBillUsageCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingAverageUtilityMeterStatementsBillUsageInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingAverageUtilityMeterStatementsCreditsInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingAverageUtilityMeterStatementsFeesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingAverageUtilityMeterStatementsTaxesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingDistinctCountInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  accountStatementPdfId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<UtilityMeterStatementsHavingDistinctCountUtilityMeterStatementsBillCostInput>;
  billDemand?: InputMaybe<UtilityMeterStatementsHavingDistinctCountUtilityMeterStatementsBillDemandInput>;
  billDemandCost?: InputMaybe<UtilityMeterStatementsHavingDistinctCountUtilityMeterStatementsBillDemandCostInput>;
  billUsage?: InputMaybe<UtilityMeterStatementsHavingDistinctCountUtilityMeterStatementsBillUsageInput>;
  billUsageCost?: InputMaybe<UtilityMeterStatementsHavingDistinctCountUtilityMeterStatementsBillUsageCostInput>;
  credits?: InputMaybe<UtilityMeterStatementsHavingDistinctCountUtilityMeterStatementsCreditsInput>;
  daysInBill?: InputMaybe<HavingIntFilter>;
  endDate?: InputMaybe<HavingDatetimeFilter>;
  facilityId?: InputMaybe<HavingIntFilter>;
  fees?: InputMaybe<UtilityMeterStatementsHavingDistinctCountUtilityMeterStatementsFeesInput>;
  meterStatementId?: InputMaybe<HavingIntFilter>;
  startDate?: InputMaybe<HavingDatetimeFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<UtilityMeterStatementsHavingDistinctCountUtilityMeterStatementsTaxesInput>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
  utilityMeterId?: InputMaybe<HavingIntFilter>;
};

export type UtilityMeterStatementsHavingDistinctCountUtilityMeterStatementsBillCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingDistinctCountUtilityMeterStatementsBillDemandCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingDistinctCountUtilityMeterStatementsBillDemandInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingDistinctCountUtilityMeterStatementsBillUsageCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingDistinctCountUtilityMeterStatementsBillUsageInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingDistinctCountUtilityMeterStatementsCreditsInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingDistinctCountUtilityMeterStatementsFeesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingDistinctCountUtilityMeterStatementsTaxesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingDistinctInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  accountStatementPdfId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<UtilityMeterStatementsHavingDistinctUtilityMeterStatementsBillCostInput>;
  billDemand?: InputMaybe<UtilityMeterStatementsHavingDistinctUtilityMeterStatementsBillDemandInput>;
  billDemandCost?: InputMaybe<UtilityMeterStatementsHavingDistinctUtilityMeterStatementsBillDemandCostInput>;
  billUsage?: InputMaybe<UtilityMeterStatementsHavingDistinctUtilityMeterStatementsBillUsageInput>;
  billUsageCost?: InputMaybe<UtilityMeterStatementsHavingDistinctUtilityMeterStatementsBillUsageCostInput>;
  credits?: InputMaybe<UtilityMeterStatementsHavingDistinctUtilityMeterStatementsCreditsInput>;
  daysInBill?: InputMaybe<HavingIntFilter>;
  endDate?: InputMaybe<HavingDatetimeFilter>;
  facilityId?: InputMaybe<HavingIntFilter>;
  fees?: InputMaybe<UtilityMeterStatementsHavingDistinctUtilityMeterStatementsFeesInput>;
  meterStatementId?: InputMaybe<HavingIntFilter>;
  startDate?: InputMaybe<HavingDatetimeFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<UtilityMeterStatementsHavingDistinctUtilityMeterStatementsTaxesInput>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
  utilityMeterId?: InputMaybe<HavingIntFilter>;
};

export type UtilityMeterStatementsHavingDistinctUtilityMeterStatementsBillCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingDistinctUtilityMeterStatementsBillDemandCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingDistinctUtilityMeterStatementsBillDemandInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingDistinctUtilityMeterStatementsBillUsageCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingDistinctUtilityMeterStatementsBillUsageInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingDistinctUtilityMeterStatementsCreditsInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingDistinctUtilityMeterStatementsFeesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingDistinctUtilityMeterStatementsTaxesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

/** Conditions for `UtilityMeterStatement` aggregates. */
export type UtilityMeterStatementsHavingInput = {
  AND?: InputMaybe<Array<UtilityMeterStatementsHavingInput>>;
  OR?: InputMaybe<Array<UtilityMeterStatementsHavingInput>>;
  average?: InputMaybe<UtilityMeterStatementsHavingAverageInput>;
  distinct?: InputMaybe<UtilityMeterStatementsHavingDistinctInput>;
  distinctCount?: InputMaybe<UtilityMeterStatementsHavingDistinctCountInput>;
  max?: InputMaybe<UtilityMeterStatementsHavingMaxInput>;
  min?: InputMaybe<UtilityMeterStatementsHavingMinInput>;
  stddevPopulation?: InputMaybe<UtilityMeterStatementsHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<UtilityMeterStatementsHavingStddevSampleInput>;
  sum?: InputMaybe<UtilityMeterStatementsHavingSumInput>;
  variancePopulation?: InputMaybe<UtilityMeterStatementsHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<UtilityMeterStatementsHavingVarianceSampleInput>;
};

export type UtilityMeterStatementsHavingMaxInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  accountStatementPdfId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<UtilityMeterStatementsHavingMaxUtilityMeterStatementsBillCostInput>;
  billDemand?: InputMaybe<UtilityMeterStatementsHavingMaxUtilityMeterStatementsBillDemandInput>;
  billDemandCost?: InputMaybe<UtilityMeterStatementsHavingMaxUtilityMeterStatementsBillDemandCostInput>;
  billUsage?: InputMaybe<UtilityMeterStatementsHavingMaxUtilityMeterStatementsBillUsageInput>;
  billUsageCost?: InputMaybe<UtilityMeterStatementsHavingMaxUtilityMeterStatementsBillUsageCostInput>;
  credits?: InputMaybe<UtilityMeterStatementsHavingMaxUtilityMeterStatementsCreditsInput>;
  daysInBill?: InputMaybe<HavingIntFilter>;
  endDate?: InputMaybe<HavingDatetimeFilter>;
  facilityId?: InputMaybe<HavingIntFilter>;
  fees?: InputMaybe<UtilityMeterStatementsHavingMaxUtilityMeterStatementsFeesInput>;
  meterStatementId?: InputMaybe<HavingIntFilter>;
  startDate?: InputMaybe<HavingDatetimeFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<UtilityMeterStatementsHavingMaxUtilityMeterStatementsTaxesInput>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
  utilityMeterId?: InputMaybe<HavingIntFilter>;
};

export type UtilityMeterStatementsHavingMaxUtilityMeterStatementsBillCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingMaxUtilityMeterStatementsBillDemandCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingMaxUtilityMeterStatementsBillDemandInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingMaxUtilityMeterStatementsBillUsageCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingMaxUtilityMeterStatementsBillUsageInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingMaxUtilityMeterStatementsCreditsInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingMaxUtilityMeterStatementsFeesInput = {
  filter?: InputMaybe<HavingFloatFilter>;
};

export type UtilityMeterStatementsHavingMaxUtilityMeterStatementsTaxesInput = {
  filter?: InputMaybe<HavingFloatFilter>;
};

export type UtilityMeterStatementsHavingMinInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  accountStatementPdfId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<UtilityMeterStatementsHavingMinUtilityMeterStatementsBillCostInput>;
  billDemand?: InputMaybe<UtilityMeterStatementsHavingMinUtilityMeterStatementsBillDemandInput>;
  billDemandCost?: InputMaybe<UtilityMeterStatementsHavingMinUtilityMeterStatementsBillDemandCostInput>;
  billUsage?: InputMaybe<UtilityMeterStatementsHavingMinUtilityMeterStatementsBillUsageInput>;
  billUsageCost?: InputMaybe<UtilityMeterStatementsHavingMinUtilityMeterStatementsBillUsageCostInput>;
  credits?: InputMaybe<UtilityMeterStatementsHavingMinUtilityMeterStatementsCreditsInput>;
  daysInBill?: InputMaybe<HavingIntFilter>;
  endDate?: InputMaybe<HavingDatetimeFilter>;
  facilityId?: InputMaybe<HavingIntFilter>;
  fees?: InputMaybe<UtilityMeterStatementsHavingMinUtilityMeterStatementsFeesInput>;
  meterStatementId?: InputMaybe<HavingIntFilter>;
  startDate?: InputMaybe<HavingDatetimeFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<UtilityMeterStatementsHavingMinUtilityMeterStatementsTaxesInput>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
  utilityMeterId?: InputMaybe<HavingIntFilter>;
};

export type UtilityMeterStatementsHavingMinUtilityMeterStatementsBillCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingMinUtilityMeterStatementsBillDemandCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingMinUtilityMeterStatementsBillDemandInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingMinUtilityMeterStatementsBillUsageCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingMinUtilityMeterStatementsBillUsageInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingMinUtilityMeterStatementsCreditsInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingMinUtilityMeterStatementsFeesInput = {
  filter?: InputMaybe<HavingFloatFilter>;
};

export type UtilityMeterStatementsHavingMinUtilityMeterStatementsTaxesInput = {
  filter?: InputMaybe<HavingFloatFilter>;
};

export type UtilityMeterStatementsHavingStddevPopulationInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  accountStatementPdfId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<UtilityMeterStatementsHavingStddevPopulationUtilityMeterStatementsBillCostInput>;
  billDemand?: InputMaybe<UtilityMeterStatementsHavingStddevPopulationUtilityMeterStatementsBillDemandInput>;
  billDemandCost?: InputMaybe<UtilityMeterStatementsHavingStddevPopulationUtilityMeterStatementsBillDemandCostInput>;
  billUsage?: InputMaybe<UtilityMeterStatementsHavingStddevPopulationUtilityMeterStatementsBillUsageInput>;
  billUsageCost?: InputMaybe<UtilityMeterStatementsHavingStddevPopulationUtilityMeterStatementsBillUsageCostInput>;
  credits?: InputMaybe<UtilityMeterStatementsHavingStddevPopulationUtilityMeterStatementsCreditsInput>;
  daysInBill?: InputMaybe<HavingIntFilter>;
  endDate?: InputMaybe<HavingDatetimeFilter>;
  facilityId?: InputMaybe<HavingIntFilter>;
  fees?: InputMaybe<UtilityMeterStatementsHavingStddevPopulationUtilityMeterStatementsFeesInput>;
  meterStatementId?: InputMaybe<HavingIntFilter>;
  startDate?: InputMaybe<HavingDatetimeFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<UtilityMeterStatementsHavingStddevPopulationUtilityMeterStatementsTaxesInput>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
  utilityMeterId?: InputMaybe<HavingIntFilter>;
};

export type UtilityMeterStatementsHavingStddevPopulationUtilityMeterStatementsBillCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingStddevPopulationUtilityMeterStatementsBillDemandCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingStddevPopulationUtilityMeterStatementsBillDemandInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingStddevPopulationUtilityMeterStatementsBillUsageCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingStddevPopulationUtilityMeterStatementsBillUsageInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingStddevPopulationUtilityMeterStatementsCreditsInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingStddevPopulationUtilityMeterStatementsFeesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingStddevPopulationUtilityMeterStatementsTaxesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingStddevSampleInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  accountStatementPdfId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<UtilityMeterStatementsHavingStddevSampleUtilityMeterStatementsBillCostInput>;
  billDemand?: InputMaybe<UtilityMeterStatementsHavingStddevSampleUtilityMeterStatementsBillDemandInput>;
  billDemandCost?: InputMaybe<UtilityMeterStatementsHavingStddevSampleUtilityMeterStatementsBillDemandCostInput>;
  billUsage?: InputMaybe<UtilityMeterStatementsHavingStddevSampleUtilityMeterStatementsBillUsageInput>;
  billUsageCost?: InputMaybe<UtilityMeterStatementsHavingStddevSampleUtilityMeterStatementsBillUsageCostInput>;
  credits?: InputMaybe<UtilityMeterStatementsHavingStddevSampleUtilityMeterStatementsCreditsInput>;
  daysInBill?: InputMaybe<HavingIntFilter>;
  endDate?: InputMaybe<HavingDatetimeFilter>;
  facilityId?: InputMaybe<HavingIntFilter>;
  fees?: InputMaybe<UtilityMeterStatementsHavingStddevSampleUtilityMeterStatementsFeesInput>;
  meterStatementId?: InputMaybe<HavingIntFilter>;
  startDate?: InputMaybe<HavingDatetimeFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<UtilityMeterStatementsHavingStddevSampleUtilityMeterStatementsTaxesInput>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
  utilityMeterId?: InputMaybe<HavingIntFilter>;
};

export type UtilityMeterStatementsHavingStddevSampleUtilityMeterStatementsBillCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingStddevSampleUtilityMeterStatementsBillDemandCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingStddevSampleUtilityMeterStatementsBillDemandInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingStddevSampleUtilityMeterStatementsBillUsageCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingStddevSampleUtilityMeterStatementsBillUsageInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingStddevSampleUtilityMeterStatementsCreditsInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingStddevSampleUtilityMeterStatementsFeesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingStddevSampleUtilityMeterStatementsTaxesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingSumInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  accountStatementPdfId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<UtilityMeterStatementsHavingSumUtilityMeterStatementsBillCostInput>;
  billDemand?: InputMaybe<UtilityMeterStatementsHavingSumUtilityMeterStatementsBillDemandInput>;
  billDemandCost?: InputMaybe<UtilityMeterStatementsHavingSumUtilityMeterStatementsBillDemandCostInput>;
  billUsage?: InputMaybe<UtilityMeterStatementsHavingSumUtilityMeterStatementsBillUsageInput>;
  billUsageCost?: InputMaybe<UtilityMeterStatementsHavingSumUtilityMeterStatementsBillUsageCostInput>;
  credits?: InputMaybe<UtilityMeterStatementsHavingSumUtilityMeterStatementsCreditsInput>;
  daysInBill?: InputMaybe<HavingIntFilter>;
  endDate?: InputMaybe<HavingDatetimeFilter>;
  facilityId?: InputMaybe<HavingIntFilter>;
  fees?: InputMaybe<UtilityMeterStatementsHavingSumUtilityMeterStatementsFeesInput>;
  meterStatementId?: InputMaybe<HavingIntFilter>;
  startDate?: InputMaybe<HavingDatetimeFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<UtilityMeterStatementsHavingSumUtilityMeterStatementsTaxesInput>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
  utilityMeterId?: InputMaybe<HavingIntFilter>;
};

export type UtilityMeterStatementsHavingSumUtilityMeterStatementsBillCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingSumUtilityMeterStatementsBillDemandCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingSumUtilityMeterStatementsBillDemandInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingSumUtilityMeterStatementsBillUsageCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingSumUtilityMeterStatementsBillUsageInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingSumUtilityMeterStatementsCreditsInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingSumUtilityMeterStatementsFeesInput = {
  filter?: InputMaybe<HavingFloatFilter>;
};

export type UtilityMeterStatementsHavingSumUtilityMeterStatementsTaxesInput = {
  filter?: InputMaybe<HavingFloatFilter>;
};

export type UtilityMeterStatementsHavingVariancePopulationInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  accountStatementPdfId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<UtilityMeterStatementsHavingVariancePopulationUtilityMeterStatementsBillCostInput>;
  billDemand?: InputMaybe<UtilityMeterStatementsHavingVariancePopulationUtilityMeterStatementsBillDemandInput>;
  billDemandCost?: InputMaybe<UtilityMeterStatementsHavingVariancePopulationUtilityMeterStatementsBillDemandCostInput>;
  billUsage?: InputMaybe<UtilityMeterStatementsHavingVariancePopulationUtilityMeterStatementsBillUsageInput>;
  billUsageCost?: InputMaybe<UtilityMeterStatementsHavingVariancePopulationUtilityMeterStatementsBillUsageCostInput>;
  credits?: InputMaybe<UtilityMeterStatementsHavingVariancePopulationUtilityMeterStatementsCreditsInput>;
  daysInBill?: InputMaybe<HavingIntFilter>;
  endDate?: InputMaybe<HavingDatetimeFilter>;
  facilityId?: InputMaybe<HavingIntFilter>;
  fees?: InputMaybe<UtilityMeterStatementsHavingVariancePopulationUtilityMeterStatementsFeesInput>;
  meterStatementId?: InputMaybe<HavingIntFilter>;
  startDate?: InputMaybe<HavingDatetimeFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<UtilityMeterStatementsHavingVariancePopulationUtilityMeterStatementsTaxesInput>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
  utilityMeterId?: InputMaybe<HavingIntFilter>;
};

export type UtilityMeterStatementsHavingVariancePopulationUtilityMeterStatementsBillCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingVariancePopulationUtilityMeterStatementsBillDemandCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingVariancePopulationUtilityMeterStatementsBillDemandInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingVariancePopulationUtilityMeterStatementsBillUsageCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingVariancePopulationUtilityMeterStatementsBillUsageInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingVariancePopulationUtilityMeterStatementsCreditsInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingVariancePopulationUtilityMeterStatementsFeesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingVariancePopulationUtilityMeterStatementsTaxesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingVarianceSampleInput = {
  accountStatementId?: InputMaybe<HavingIntFilter>;
  accountStatementPdfId?: InputMaybe<HavingIntFilter>;
  billArrivalDate?: InputMaybe<HavingDatetimeFilter>;
  billCost?: InputMaybe<UtilityMeterStatementsHavingVarianceSampleUtilityMeterStatementsBillCostInput>;
  billDemand?: InputMaybe<UtilityMeterStatementsHavingVarianceSampleUtilityMeterStatementsBillDemandInput>;
  billDemandCost?: InputMaybe<UtilityMeterStatementsHavingVarianceSampleUtilityMeterStatementsBillDemandCostInput>;
  billUsage?: InputMaybe<UtilityMeterStatementsHavingVarianceSampleUtilityMeterStatementsBillUsageInput>;
  billUsageCost?: InputMaybe<UtilityMeterStatementsHavingVarianceSampleUtilityMeterStatementsBillUsageCostInput>;
  credits?: InputMaybe<UtilityMeterStatementsHavingVarianceSampleUtilityMeterStatementsCreditsInput>;
  daysInBill?: InputMaybe<HavingIntFilter>;
  endDate?: InputMaybe<HavingDatetimeFilter>;
  facilityId?: InputMaybe<HavingIntFilter>;
  fees?: InputMaybe<UtilityMeterStatementsHavingVarianceSampleUtilityMeterStatementsFeesInput>;
  meterStatementId?: InputMaybe<HavingIntFilter>;
  startDate?: InputMaybe<HavingDatetimeFilter>;
  statementMonth?: InputMaybe<HavingIntFilter>;
  statementYear?: InputMaybe<HavingIntFilter>;
  taxes?: InputMaybe<UtilityMeterStatementsHavingVarianceSampleUtilityMeterStatementsTaxesInput>;
  utilityAccountId?: InputMaybe<HavingIntFilter>;
  utilityMeterId?: InputMaybe<HavingIntFilter>;
};

export type UtilityMeterStatementsHavingVarianceSampleUtilityMeterStatementsBillCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingVarianceSampleUtilityMeterStatementsBillDemandCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingVarianceSampleUtilityMeterStatementsBillDemandInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingVarianceSampleUtilityMeterStatementsBillUsageCostInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingVarianceSampleUtilityMeterStatementsBillUsageInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingVarianceSampleUtilityMeterStatementsCreditsInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingVarianceSampleUtilityMeterStatementsFeesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type UtilityMeterStatementsHavingVarianceSampleUtilityMeterStatementsTaxesInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

/** Methods to use when ordering `UtilityMeterStatement`. */
export enum UtilityMeterStatementsOrderBy {
  ACCOUNT_LABEL_ASC = 'ACCOUNT_LABEL_ASC',
  ACCOUNT_LABEL_DESC = 'ACCOUNT_LABEL_DESC',
  ACCOUNT_STATEMENT_ID_ASC = 'ACCOUNT_STATEMENT_ID_ASC',
  ACCOUNT_STATEMENT_ID_DESC = 'ACCOUNT_STATEMENT_ID_DESC',
  ACCOUNT_STATEMENT_PDF_ID_ASC = 'ACCOUNT_STATEMENT_PDF_ID_ASC',
  ACCOUNT_STATEMENT_PDF_ID_DESC = 'ACCOUNT_STATEMENT_PDF_ID_DESC',
  BILL_ARRIVAL_DATE_ASC = 'BILL_ARRIVAL_DATE_ASC',
  BILL_ARRIVAL_DATE_DESC = 'BILL_ARRIVAL_DATE_DESC',
  CURRENCY_CODE_ASC = 'CURRENCY_CODE_ASC',
  CURRENCY_CODE_DESC = 'CURRENCY_CODE_DESC',
  DAYS_IN_BILL_ASC = 'DAYS_IN_BILL_ASC',
  DAYS_IN_BILL_DESC = 'DAYS_IN_BILL_DESC',
  DEMAND_UNITS_ASC = 'DEMAND_UNITS_ASC',
  DEMAND_UNITS_DESC = 'DEMAND_UNITS_DESC',
  END_DATE_ASC = 'END_DATE_ASC',
  END_DATE_DESC = 'END_DATE_DESC',
  EXCLUDE_USAGE_ASC = 'EXCLUDE_USAGE_ASC',
  EXCLUDE_USAGE_DESC = 'EXCLUDE_USAGE_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  IS_VALIDATED_ASC = 'IS_VALIDATED_ASC',
  IS_VALIDATED_DESC = 'IS_VALIDATED_DESC',
  METER_END_DATE_SET_ASC = 'METER_END_DATE_SET_ASC',
  METER_END_DATE_SET_DESC = 'METER_END_DATE_SET_DESC',
  METER_LABEL_ASC = 'METER_LABEL_ASC',
  METER_LABEL_DESC = 'METER_LABEL_DESC',
  METER_STATEMENT_ID_ASC = 'METER_STATEMENT_ID_ASC',
  METER_STATEMENT_ID_DESC = 'METER_STATEMENT_ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  PROVIDER_ASC = 'PROVIDER_ASC',
  PROVIDER_DESC = 'PROVIDER_DESC',
  SERVICE_TYPE_ASC = 'SERVICE_TYPE_ASC',
  SERVICE_TYPE_DESC = 'SERVICE_TYPE_DESC',
  START_DATE_ASC = 'START_DATE_ASC',
  START_DATE_DESC = 'START_DATE_DESC',
  STATEMENT_MONTH_ASC = 'STATEMENT_MONTH_ASC',
  STATEMENT_MONTH_DESC = 'STATEMENT_MONTH_DESC',
  STATEMENT_YEAR_ASC = 'STATEMENT_YEAR_ASC',
  STATEMENT_YEAR_DESC = 'STATEMENT_YEAR_DESC',
  USAGE_UNITS_ASC = 'USAGE_UNITS_ASC',
  USAGE_UNITS_DESC = 'USAGE_UNITS_DESC',
  UTILITY_ACCOUNT_ID_ASC = 'UTILITY_ACCOUNT_ID_ASC',
  UTILITY_ACCOUNT_ID_DESC = 'UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_ID_ASC = 'UTILITY_METER_ID_ASC',
  UTILITY_METER_ID_DESC = 'UTILITY_METER_ID_DESC'
}

export enum UtilityMeterUsageCategory {
  DEMAND = 'DEMAND',
  USAGE = 'USAGE'
}

/** A filter to be used against UtilityMeterUsageCategory fields. All fields are combined with a logical ‘and.’ */
export type UtilityMeterUsageCategoryFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<UtilityMeterUsageCategory>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<UtilityMeterUsageCategory>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<UtilityMeterUsageCategory>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<UtilityMeterUsageCategory>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<UtilityMeterUsageCategory>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<UtilityMeterUsageCategory>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<UtilityMeterUsageCategory>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<UtilityMeterUsageCategory>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<UtilityMeterUsageCategory>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<UtilityMeterUsageCategory>>;
};

/** A connection to a list of `UtilityMetersBillingCoverageByStatementMonthRecord` values. */
export type UtilityMetersBillingCoverageByStatementMonthConnection = {
  __typename?: 'UtilityMetersBillingCoverageByStatementMonthConnection';
  /** A list of edges which contains the `UtilityMetersBillingCoverageByStatementMonthRecord` and cursor to aid in pagination. */
  edges: Array<UtilityMetersBillingCoverageByStatementMonthEdge>;
  /** A list of `UtilityMetersBillingCoverageByStatementMonthRecord` objects. */
  nodes: Array<UtilityMetersBillingCoverageByStatementMonthRecord>;
  /** The count of *all* `UtilityMetersBillingCoverageByStatementMonthRecord` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `UtilityMetersBillingCoverageByStatementMonthRecord` edge in the connection. */
export type UtilityMetersBillingCoverageByStatementMonthEdge = {
  __typename?: 'UtilityMetersBillingCoverageByStatementMonthEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UtilityMetersBillingCoverageByStatementMonthRecord` at the end of the edge. */
  node: UtilityMetersBillingCoverageByStatementMonthRecord;
};

/** The return type of our `billingCoverageByStatementMonth` query. */
export type UtilityMetersBillingCoverageByStatementMonthRecord = {
  __typename?: 'UtilityMetersBillingCoverageByStatementMonthRecord';
  anticipatedDate?: Maybe<Scalars['Date']['output']>;
  expected?: Maybe<Scalars['Boolean']['output']>;
  lastExpectedStatementDate?: Maybe<Scalars['Date']['output']>;
  lastStatementDate?: Maybe<Scalars['Date']['output']>;
  manualUpload?: Maybe<Scalars['Boolean']['output']>;
  month?: Maybe<Scalars['Date']['output']>;
  present?: Maybe<Scalars['Boolean']['output']>;
  statementYearMonth?: Maybe<Scalars['Date']['output']>;
  statementYearMonthAvgSpanDays?: Maybe<Scalars['Int']['output']>;
  validated?: Maybe<Scalars['Boolean']['output']>;
};

/** A filter to be used against `UtilityMetersBillingCoverageByStatementMonthRecord` object types. All fields are combined with a logical ‘and.’ */
export type UtilityMetersBillingCoverageByStatementMonthRecordFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<
    Array<UtilityMetersBillingCoverageByStatementMonthRecordFilter>
  >;
  /** Filter by the object’s `anticipatedDate` field. */
  anticipatedDate?: InputMaybe<DateFilter>;
  /** Filter by the object’s `expected` field. */
  expected?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `lastExpectedStatementDate` field. */
  lastExpectedStatementDate?: InputMaybe<DateFilter>;
  /** Filter by the object’s `lastStatementDate` field. */
  lastStatementDate?: InputMaybe<DateFilter>;
  /** Filter by the object’s `manualUpload` field. */
  manualUpload?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `month` field. */
  month?: InputMaybe<DateFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UtilityMetersBillingCoverageByStatementMonthRecordFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<
    Array<UtilityMetersBillingCoverageByStatementMonthRecordFilter>
  >;
  /** Filter by the object’s `present` field. */
  present?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `statementYearMonth` field. */
  statementYearMonth?: InputMaybe<DateFilter>;
  /** Filter by the object’s `statementYearMonthAvgSpanDays` field. */
  statementYearMonthAvgSpanDays?: InputMaybe<IntFilter>;
  /** Filter by the object’s `validated` field. */
  validated?: InputMaybe<BooleanFilter>;
};

/** A connection to a list of `UtilityMetersBillingCoverageRecord` values. */
export type UtilityMetersBillingCoverageConnection = {
  __typename?: 'UtilityMetersBillingCoverageConnection';
  /** A list of edges which contains the `UtilityMetersBillingCoverageRecord` and cursor to aid in pagination. */
  edges: Array<UtilityMetersBillingCoverageEdge>;
  /** A list of `UtilityMetersBillingCoverageRecord` objects. */
  nodes: Array<UtilityMetersBillingCoverageRecord>;
  /** The count of *all* `UtilityMetersBillingCoverageRecord` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `UtilityMetersBillingCoverageRecord` edge in the connection. */
export type UtilityMetersBillingCoverageEdge = {
  __typename?: 'UtilityMetersBillingCoverageEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UtilityMetersBillingCoverageRecord` at the end of the edge. */
  node: UtilityMetersBillingCoverageRecord;
};

/** The return type of our `billingCoverage` query. */
export type UtilityMetersBillingCoverageRecord = {
  __typename?: 'UtilityMetersBillingCoverageRecord';
  anticipatedDate?: Maybe<Scalars['Date']['output']>;
  day?: Maybe<Scalars['Date']['output']>;
  expected?: Maybe<Scalars['Boolean']['output']>;
  lastExpectedStatementDate?: Maybe<Scalars['Date']['output']>;
  lastStatementDate?: Maybe<Scalars['Date']['output']>;
  manualUpload?: Maybe<Scalars['Boolean']['output']>;
  present?: Maybe<Scalars['Boolean']['output']>;
  statementYearMonth?: Maybe<Scalars['Date']['output']>;
  statementYearMonthAvgSpanDays?: Maybe<Scalars['Int']['output']>;
  validated?: Maybe<Scalars['Boolean']['output']>;
};

/** A filter to be used against `UtilityMetersBillingCoverageRecord` object types. All fields are combined with a logical ‘and.’ */
export type UtilityMetersBillingCoverageRecordFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UtilityMetersBillingCoverageRecordFilter>>;
  /** Filter by the object’s `anticipatedDate` field. */
  anticipatedDate?: InputMaybe<DateFilter>;
  /** Filter by the object’s `day` field. */
  day?: InputMaybe<DateFilter>;
  /** Filter by the object’s `expected` field. */
  expected?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `lastExpectedStatementDate` field. */
  lastExpectedStatementDate?: InputMaybe<DateFilter>;
  /** Filter by the object’s `lastStatementDate` field. */
  lastStatementDate?: InputMaybe<DateFilter>;
  /** Filter by the object’s `manualUpload` field. */
  manualUpload?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UtilityMetersBillingCoverageRecordFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UtilityMetersBillingCoverageRecordFilter>>;
  /** Filter by the object’s `present` field. */
  present?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `statementYearMonth` field. */
  statementYearMonth?: InputMaybe<DateFilter>;
  /** Filter by the object’s `statementYearMonthAvgSpanDays` field. */
  statementYearMonthAvgSpanDays?: InputMaybe<IntFilter>;
  /** Filter by the object’s `validated` field. */
  validated?: InputMaybe<BooleanFilter>;
};

/** A connection to a list of `UtilityMeter` values. */
export type UtilityMetersConnection = {
  __typename?: 'UtilityMetersConnection';
  /** A list of edges which contains the `UtilityMeter` and cursor to aid in pagination. */
  edges: Array<UtilityMetersEdge>;
  /** A list of `UtilityMeter` objects. */
  nodes: Array<UtilityMeter>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UtilityMeter` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `UtilityMeter` edge in the connection. */
export type UtilityMetersEdge = {
  __typename?: 'UtilityMetersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UtilityMeter` at the end of the edge. */
  node: UtilityMeter;
};

/** A `UtilityMetersMissingStatementsRecord` edge in the connection. */
export type UtilityMetersMissingStatementEdge = {
  __typename?: 'UtilityMetersMissingStatementEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UtilityMetersMissingStatementsRecord` at the end of the edge. */
  node: UtilityMetersMissingStatementsRecord;
};

/** A connection to a list of `UtilityMetersMissingStatementsRecord` values. */
export type UtilityMetersMissingStatementsConnection = {
  __typename?: 'UtilityMetersMissingStatementsConnection';
  /** A list of edges which contains the `UtilityMetersMissingStatementsRecord` and cursor to aid in pagination. */
  edges: Array<UtilityMetersMissingStatementEdge>;
  /** A list of `UtilityMetersMissingStatementsRecord` objects. */
  nodes: Array<UtilityMetersMissingStatementsRecord>;
  /** The count of *all* `UtilityMetersMissingStatementsRecord` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** The return type of our `missingStatements` query. */
export type UtilityMetersMissingStatementsRecord = {
  __typename?: 'UtilityMetersMissingStatementsRecord';
  facilityId?: Maybe<Scalars['Int']['output']>;
  statementDate?: Maybe<Scalars['Date']['output']>;
  statementMonth?: Maybe<Scalars['Int']['output']>;
  statementYear?: Maybe<Scalars['Int']['output']>;
  utilityMeterId?: Maybe<Scalars['Int']['output']>;
};

/** A filter to be used against `UtilityMetersMissingStatementsRecord` object types. All fields are combined with a logical ‘and.’ */
export type UtilityMetersMissingStatementsRecordFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UtilityMetersMissingStatementsRecordFilter>>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UtilityMetersMissingStatementsRecordFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UtilityMetersMissingStatementsRecordFilter>>;
  /** Filter by the object’s `statementDate` field. */
  statementDate?: InputMaybe<DateFilter>;
  /** Filter by the object’s `statementMonth` field. */
  statementMonth?: InputMaybe<IntFilter>;
  /** Filter by the object’s `statementYear` field. */
  statementYear?: InputMaybe<IntFilter>;
  /** Filter by the object’s `utilityMeterId` field. */
  utilityMeterId?: InputMaybe<IntFilter>;
};

/** A connection to a list of `UtilityMetersMonthlyBillingCoverageRecord` values. */
export type UtilityMetersMonthlyBillingCoverageConnection = {
  __typename?: 'UtilityMetersMonthlyBillingCoverageConnection';
  /** A list of edges which contains the `UtilityMetersMonthlyBillingCoverageRecord` and cursor to aid in pagination. */
  edges: Array<UtilityMetersMonthlyBillingCoverageEdge>;
  /** A list of `UtilityMetersMonthlyBillingCoverageRecord` objects. */
  nodes: Array<UtilityMetersMonthlyBillingCoverageRecord>;
  /** The count of *all* `UtilityMetersMonthlyBillingCoverageRecord` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `UtilityMetersMonthlyBillingCoverageRecord` edge in the connection. */
export type UtilityMetersMonthlyBillingCoverageEdge = {
  __typename?: 'UtilityMetersMonthlyBillingCoverageEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UtilityMetersMonthlyBillingCoverageRecord` at the end of the edge. */
  node: UtilityMetersMonthlyBillingCoverageRecord;
};

/** The return type of our `monthlyBillingCoverage` query. */
export type UtilityMetersMonthlyBillingCoverageRecord = {
  __typename?: 'UtilityMetersMonthlyBillingCoverageRecord';
  anticipatedDate?: Maybe<Scalars['Date']['output']>;
  expected?: Maybe<Scalars['Boolean']['output']>;
  lastExpectedStatementDate?: Maybe<Scalars['Date']['output']>;
  lastStatementDate?: Maybe<Scalars['Date']['output']>;
  manualUpload?: Maybe<Scalars['Boolean']['output']>;
  month?: Maybe<Scalars['Date']['output']>;
  percentPresent?: Maybe<Scalars['Float']['output']>;
  present?: Maybe<Scalars['Boolean']['output']>;
  statementYearMonth?: Maybe<Scalars['Date']['output']>;
  statementYearMonthAvgSpanDays?: Maybe<Scalars['Int']['output']>;
  validated?: Maybe<Scalars['Boolean']['output']>;
};

/** A filter to be used against `UtilityMetersMonthlyBillingCoverageRecord` object types. All fields are combined with a logical ‘and.’ */
export type UtilityMetersMonthlyBillingCoverageRecordFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UtilityMetersMonthlyBillingCoverageRecordFilter>>;
  /** Filter by the object’s `anticipatedDate` field. */
  anticipatedDate?: InputMaybe<DateFilter>;
  /** Filter by the object’s `expected` field. */
  expected?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `lastExpectedStatementDate` field. */
  lastExpectedStatementDate?: InputMaybe<DateFilter>;
  /** Filter by the object’s `lastStatementDate` field. */
  lastStatementDate?: InputMaybe<DateFilter>;
  /** Filter by the object’s `manualUpload` field. */
  manualUpload?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `month` field. */
  month?: InputMaybe<DateFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UtilityMetersMonthlyBillingCoverageRecordFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UtilityMetersMonthlyBillingCoverageRecordFilter>>;
  /** Filter by the object’s `percentPresent` field. */
  percentPresent?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `present` field. */
  present?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `statementYearMonth` field. */
  statementYearMonth?: InputMaybe<DateFilter>;
  /** Filter by the object’s `statementYearMonthAvgSpanDays` field. */
  statementYearMonthAvgSpanDays?: InputMaybe<IntFilter>;
  /** Filter by the object’s `validated` field. */
  validated?: InputMaybe<BooleanFilter>;
};

/** Methods to use when ordering `UtilityMeter`. */
export enum UtilityMetersOrderBy {
  ACTIVE_END_ASC = 'ACTIVE_END_ASC',
  ACTIVE_END_DESC = 'ACTIVE_END_DESC',
  ACTIVE_START_ASC = 'ACTIVE_START_ASC',
  ACTIVE_START_DESC = 'ACTIVE_START_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DEFAULT_DEMAND_UNITS_ASC = 'DEFAULT_DEMAND_UNITS_ASC',
  DEFAULT_DEMAND_UNITS_DESC = 'DEFAULT_DEMAND_UNITS_DESC',
  DEFAULT_USAGE_UNITS_ASC = 'DEFAULT_USAGE_UNITS_ASC',
  DEFAULT_USAGE_UNITS_DESC = 'DEFAULT_USAGE_UNITS_DESC',
  DELETED_AT_ASC = 'DELETED_AT_ASC',
  DELETED_AT_DESC = 'DELETED_AT_DESC',
  EXCLUDE_CARBON_ASC = 'EXCLUDE_CARBON_ASC',
  EXCLUDE_CARBON_DESC = 'EXCLUDE_CARBON_DESC',
  EXCLUDE_USAGE_ASC = 'EXCLUDE_USAGE_ASC',
  EXCLUDE_USAGE_DESC = 'EXCLUDE_USAGE_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  INTEGRATION_METER_KEY_ASC = 'INTEGRATION_METER_KEY_ASC',
  INTEGRATION_METER_KEY_DESC = 'INTEGRATION_METER_KEY_DESC',
  IS_REVIEWED_ASC = 'IS_REVIEWED_ASC',
  IS_REVIEWED_DESC = 'IS_REVIEWED_DESC',
  METADATA_ASC = 'METADATA_ASC',
  METADATA_DESC = 'METADATA_DESC',
  METER_NUMBER_ASC = 'METER_NUMBER_ASC',
  METER_NUMBER_DESC = 'METER_NUMBER_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  NET_METERING_TYPE_ASC = 'NET_METERING_TYPE_ASC',
  NET_METERING_TYPE_DESC = 'NET_METERING_TYPE_DESC',
  OVERRIDE_AT_ASC = 'OVERRIDE_AT_ASC',
  OVERRIDE_AT_DESC = 'OVERRIDE_AT_DESC',
  OVERRIDE_METER_NUMBER_ASC = 'OVERRIDE_METER_NUMBER_ASC',
  OVERRIDE_METER_NUMBER_DESC = 'OVERRIDE_METER_NUMBER_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  SERVICE_TYPE_ASC = 'SERVICE_TYPE_ASC',
  SERVICE_TYPE_DESC = 'SERVICE_TYPE_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  UTILITY_ACCOUNT_ID_ASC = 'UTILITY_ACCOUNT_ID_ASC',
  UTILITY_ACCOUNT_ID_DESC = 'UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_STATEMENT_PDF_ID_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_STATEMENT_PDF_ID_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_STATEMENT_PDF_ID_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_ACCOUNT_STATEMENT_PDF_ID_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_AVERAGE_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_COUNT_ASC = 'UTILITY_METER_STATEMENTS_COUNT_ASC',
  UTILITY_METER_STATEMENTS_COUNT_DESC = 'UTILITY_METER_STATEMENTS_COUNT_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_STATEMENT_PDF_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_STATEMENT_PDF_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_STATEMENT_PDF_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_ACCOUNT_STATEMENT_PDF_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_STATEMENT_PDF_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_STATEMENT_PDF_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_STATEMENT_PDF_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_ACCOUNT_STATEMENT_PDF_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_COUNT_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_DISTINCT_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_MAX_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_MAX_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_MAX_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_MAX_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_MAX_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_MAX_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_MAX_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_MAX_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_MAX_ACCOUNT_STATEMENT_PDF_ID_ASC = 'UTILITY_METER_STATEMENTS_MAX_ACCOUNT_STATEMENT_PDF_ID_ASC',
  UTILITY_METER_STATEMENTS_MAX_ACCOUNT_STATEMENT_PDF_ID_DESC = 'UTILITY_METER_STATEMENTS_MAX_ACCOUNT_STATEMENT_PDF_ID_DESC',
  UTILITY_METER_STATEMENTS_MAX_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_MAX_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_MAX_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_MAX_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_MAX_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_MAX_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_MAX_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_MAX_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_MAX_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_MAX_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_MAX_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_MAX_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_MAX_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_MAX_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_MAX_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_MAX_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_MAX_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_MAX_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_MAX_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_MAX_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_MAX_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_MAX_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_MAX_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_MAX_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_MAX_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_MAX_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_MAX_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_MAX_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_MAX_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_MAX_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_MAX_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_MAX_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_MAX_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_MAX_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_MAX_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_MAX_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_MAX_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_MAX_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_MAX_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_MAX_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_MAX_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_MAX_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_MAX_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_MAX_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_MAX_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_MAX_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_MAX_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_MAX_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_MAX_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_MAX_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_MAX_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_MAX_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_MAX_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_MAX_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_MAX_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_MAX_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_MAX_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_MAX_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_MAX_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_MAX_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_MAX_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_MAX_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_MAX_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_MAX_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_MAX_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_MAX_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_MAX_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_MAX_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_MAX_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_MAX_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_MAX_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_MAX_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_MAX_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_MAX_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_MAX_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_MAX_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_MIN_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_MIN_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_MIN_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_MIN_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_MIN_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_MIN_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_MIN_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_MIN_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_MIN_ACCOUNT_STATEMENT_PDF_ID_ASC = 'UTILITY_METER_STATEMENTS_MIN_ACCOUNT_STATEMENT_PDF_ID_ASC',
  UTILITY_METER_STATEMENTS_MIN_ACCOUNT_STATEMENT_PDF_ID_DESC = 'UTILITY_METER_STATEMENTS_MIN_ACCOUNT_STATEMENT_PDF_ID_DESC',
  UTILITY_METER_STATEMENTS_MIN_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_MIN_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_MIN_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_MIN_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_MIN_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_MIN_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_MIN_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_MIN_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_MIN_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_MIN_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_MIN_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_MIN_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_MIN_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_MIN_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_MIN_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_MIN_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_MIN_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_MIN_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_MIN_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_MIN_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_MIN_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_MIN_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_MIN_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_MIN_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_MIN_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_MIN_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_MIN_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_MIN_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_MIN_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_MIN_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_MIN_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_MIN_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_MIN_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_MIN_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_MIN_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_MIN_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_MIN_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_MIN_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_MIN_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_MIN_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_MIN_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_MIN_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_MIN_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_MIN_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_MIN_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_MIN_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_MIN_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_MIN_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_MIN_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_MIN_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_MIN_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_MIN_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_MIN_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_MIN_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_MIN_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_MIN_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_MIN_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_MIN_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_MIN_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_MIN_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_MIN_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_MIN_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_MIN_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_MIN_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_MIN_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_MIN_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_MIN_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_MIN_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_MIN_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_MIN_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_MIN_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_MIN_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_MIN_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_MIN_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_MIN_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_MIN_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_STATEMENT_PDF_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_STATEMENT_PDF_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_STATEMENT_PDF_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_ACCOUNT_STATEMENT_PDF_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_POPULATION_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_PDF_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_PDF_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_PDF_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_PDF_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_STDDEV_SAMPLE_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_SUM_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_SUM_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_SUM_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_SUM_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_SUM_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_SUM_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_SUM_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_SUM_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_SUM_ACCOUNT_STATEMENT_PDF_ID_ASC = 'UTILITY_METER_STATEMENTS_SUM_ACCOUNT_STATEMENT_PDF_ID_ASC',
  UTILITY_METER_STATEMENTS_SUM_ACCOUNT_STATEMENT_PDF_ID_DESC = 'UTILITY_METER_STATEMENTS_SUM_ACCOUNT_STATEMENT_PDF_ID_DESC',
  UTILITY_METER_STATEMENTS_SUM_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_SUM_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_SUM_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_SUM_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_SUM_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_SUM_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_SUM_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_SUM_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_SUM_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_SUM_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_SUM_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_SUM_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_SUM_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_SUM_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_SUM_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_SUM_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_SUM_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_SUM_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_SUM_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_SUM_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_SUM_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_SUM_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_SUM_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_SUM_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_SUM_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_SUM_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_SUM_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_SUM_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_SUM_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_SUM_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_SUM_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_SUM_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_SUM_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_SUM_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_SUM_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_SUM_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_SUM_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_SUM_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_SUM_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_SUM_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_SUM_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_SUM_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_SUM_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_SUM_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_SUM_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_SUM_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_SUM_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_SUM_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_SUM_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_SUM_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_SUM_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_SUM_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_SUM_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_SUM_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_SUM_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_SUM_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_SUM_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_SUM_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_SUM_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_SUM_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_SUM_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_SUM_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_SUM_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_SUM_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_SUM_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_SUM_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_SUM_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_SUM_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_SUM_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_SUM_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_SUM_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_SUM_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_SUM_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_SUM_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_SUM_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_SUM_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_PDF_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_PDF_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_PDF_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_PDF_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_POPULATION_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_PDF_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_PDF_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_PDF_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_PDF_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_END_DATE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_END_DATE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_END_DATE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_END_DATE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_EXCLUDE_USAGE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_EXCLUDE_USAGE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_EXCLUDE_USAGE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_EXCLUDE_USAGE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_LABEL_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_LABEL_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_LABEL_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_LABEL_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_PROVIDER_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_PROVIDER_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_PROVIDER_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_PROVIDER_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_START_DATE_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_START_DATE_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_START_DATE_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_START_DATE_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENTS_VARIANCE_SAMPLE_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_DEMAND_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_DEMAND_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_DEMAND_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_DEMAND_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_DEMAND_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_DEMAND_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_DEMAND_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_DEMAND_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_EXPORT_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_EXPORT_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_EXPORT_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_EXPORT_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_IMPORT_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_IMPORT_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_IMPORT_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_IMPORT_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_USAGE_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_USAGE_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_USAGE_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_USAGE_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BLENDED_RATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BLENDED_RATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BLENDED_RATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_BLENDED_RATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_CREDITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_CREDITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_CREDITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_CREDITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_END_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_END_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_END_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_END_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_FEES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_FEES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_FEES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_FEES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_LOAD_FACTOR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_LOAD_FACTOR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_LOAD_FACTOR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_LOAD_FACTOR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_NET_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_NET_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_NET_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_NET_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_PERCENT_CHANGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_PERCENT_CHANGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_PERCENT_CHANGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_PERCENT_CHANGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_PROVIDER_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_PROVIDER_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_PROVIDER_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_PROVIDER_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_START_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_START_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_START_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_START_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_TAXES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_TAXES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_TAXES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_TAXES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_AVERAGE_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_COUNT_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_COUNT_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_COUNT_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_COUNT_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_DEMAND_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_DEMAND_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_DEMAND_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_DEMAND_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_DEMAND_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_DEMAND_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_DEMAND_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_DEMAND_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_EXPORT_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_EXPORT_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_EXPORT_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_EXPORT_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_IMPORT_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_IMPORT_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_IMPORT_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_IMPORT_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_USAGE_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_USAGE_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_USAGE_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_USAGE_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BLENDED_RATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BLENDED_RATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BLENDED_RATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_BLENDED_RATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_DEMAND_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_DEMAND_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_DEMAND_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_DEMAND_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_DEMAND_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_DEMAND_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_DEMAND_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_DEMAND_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_EXPORT_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_EXPORT_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_EXPORT_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_EXPORT_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_IMPORT_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_IMPORT_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_IMPORT_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_IMPORT_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_USAGE_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_USAGE_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_USAGE_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_USAGE_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BLENDED_RATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BLENDED_RATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BLENDED_RATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_BLENDED_RATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_CREDITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_CREDITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_CREDITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_CREDITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_END_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_END_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_END_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_END_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_FEES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_FEES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_FEES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_FEES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_LOAD_FACTOR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_LOAD_FACTOR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_LOAD_FACTOR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_LOAD_FACTOR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_NET_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_NET_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_NET_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_NET_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_PERCENT_CHANGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_PERCENT_CHANGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_PERCENT_CHANGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_PERCENT_CHANGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_PROVIDER_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_PROVIDER_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_PROVIDER_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_PROVIDER_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_START_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_START_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_START_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_START_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_TAXES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_TAXES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_TAXES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_TAXES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_COUNT_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_CREDITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_CREDITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_CREDITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_CREDITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_END_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_END_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_END_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_END_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_FEES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_FEES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_FEES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_FEES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_LOAD_FACTOR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_LOAD_FACTOR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_LOAD_FACTOR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_LOAD_FACTOR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_NET_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_NET_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_NET_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_NET_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_PERCENT_CHANGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_PERCENT_CHANGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_PERCENT_CHANGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_PERCENT_CHANGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_PROVIDER_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_PROVIDER_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_PROVIDER_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_PROVIDER_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_START_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_START_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_START_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_START_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_TAXES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_TAXES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_TAXES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_TAXES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_DISTINCT_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_DEMAND_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_DEMAND_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_DEMAND_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_DEMAND_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_DEMAND_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_DEMAND_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_DEMAND_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_DEMAND_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_EXPORT_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_EXPORT_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_EXPORT_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_EXPORT_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_IMPORT_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_IMPORT_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_IMPORT_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_IMPORT_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_USAGE_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_USAGE_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_USAGE_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_USAGE_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BLENDED_RATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BLENDED_RATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_BLENDED_RATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_BLENDED_RATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_CREDITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_CREDITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_CREDITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_CREDITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_END_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_END_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_END_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_END_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_FEES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_FEES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_FEES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_FEES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_LOAD_FACTOR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_LOAD_FACTOR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_LOAD_FACTOR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_LOAD_FACTOR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_NET_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_NET_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_NET_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_NET_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_PERCENT_CHANGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_PERCENT_CHANGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_PERCENT_CHANGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_PERCENT_CHANGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_PROVIDER_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_PROVIDER_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_PROVIDER_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_PROVIDER_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_START_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_START_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_START_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_START_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_TAXES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_TAXES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_TAXES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_TAXES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MAX_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MAX_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_DEMAND_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_DEMAND_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_DEMAND_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_DEMAND_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_DEMAND_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_DEMAND_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_DEMAND_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_DEMAND_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_EXPORT_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_EXPORT_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_EXPORT_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_EXPORT_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_IMPORT_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_IMPORT_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_IMPORT_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_IMPORT_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_USAGE_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_USAGE_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_USAGE_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_USAGE_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BLENDED_RATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BLENDED_RATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_BLENDED_RATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_BLENDED_RATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_CREDITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_CREDITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_CREDITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_CREDITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_END_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_END_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_END_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_END_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_FEES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_FEES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_FEES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_FEES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_LOAD_FACTOR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_LOAD_FACTOR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_LOAD_FACTOR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_LOAD_FACTOR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_NET_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_NET_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_NET_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_NET_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_PERCENT_CHANGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_PERCENT_CHANGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_PERCENT_CHANGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_PERCENT_CHANGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_PROVIDER_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_PROVIDER_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_PROVIDER_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_PROVIDER_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_START_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_START_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_START_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_START_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_TAXES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_TAXES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_TAXES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_TAXES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_MIN_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_MIN_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_DEMAND_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_DEMAND_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_DEMAND_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_DEMAND_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_DEMAND_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_DEMAND_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_DEMAND_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_DEMAND_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_EXPORT_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_EXPORT_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_EXPORT_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_EXPORT_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_IMPORT_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_IMPORT_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_IMPORT_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_IMPORT_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_USAGE_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_USAGE_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_USAGE_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_USAGE_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BLENDED_RATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BLENDED_RATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BLENDED_RATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_BLENDED_RATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_CREDITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_CREDITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_CREDITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_CREDITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_END_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_END_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_END_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_END_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_FEES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_FEES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_FEES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_FEES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_LOAD_FACTOR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_LOAD_FACTOR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_LOAD_FACTOR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_LOAD_FACTOR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_NET_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_NET_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_NET_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_NET_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_PERCENT_CHANGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_PERCENT_CHANGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_PERCENT_CHANGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_PERCENT_CHANGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_PROVIDER_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_PROVIDER_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_PROVIDER_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_PROVIDER_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_START_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_START_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_START_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_START_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_TAXES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_TAXES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_TAXES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_TAXES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_POPULATION_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_DEMAND_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_DEMAND_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_DEMAND_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_DEMAND_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_DEMAND_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_DEMAND_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_DEMAND_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_DEMAND_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_EXPORT_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_EXPORT_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_EXPORT_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_EXPORT_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_IMPORT_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_IMPORT_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_IMPORT_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_IMPORT_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_USAGE_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_USAGE_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_USAGE_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_USAGE_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BLENDED_RATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BLENDED_RATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BLENDED_RATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_BLENDED_RATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CREDITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CREDITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CREDITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CREDITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_END_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_END_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_END_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_END_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_FEES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_FEES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_FEES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_FEES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_LOAD_FACTOR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_LOAD_FACTOR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_LOAD_FACTOR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_LOAD_FACTOR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_NET_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_NET_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_NET_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_NET_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PERCENT_CHANGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PERCENT_CHANGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PERCENT_CHANGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PERCENT_CHANGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PROVIDER_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PROVIDER_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PROVIDER_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_PROVIDER_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_START_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_START_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_START_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_START_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_TAXES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_TAXES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_TAXES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_TAXES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_STDDEV_SAMPLE_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_DEMAND_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_DEMAND_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_DEMAND_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_DEMAND_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_DEMAND_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_DEMAND_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_DEMAND_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_DEMAND_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_EXPORT_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_EXPORT_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_EXPORT_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_EXPORT_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_IMPORT_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_IMPORT_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_IMPORT_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_IMPORT_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_USAGE_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_USAGE_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_USAGE_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_USAGE_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BLENDED_RATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BLENDED_RATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_BLENDED_RATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_BLENDED_RATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_CREDITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_CREDITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_CREDITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_CREDITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_END_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_END_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_END_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_END_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_FEES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_FEES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_FEES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_FEES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_LOAD_FACTOR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_LOAD_FACTOR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_LOAD_FACTOR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_LOAD_FACTOR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_NET_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_NET_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_NET_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_NET_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_PERCENT_CHANGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_PERCENT_CHANGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_PERCENT_CHANGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_PERCENT_CHANGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_PROVIDER_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_PROVIDER_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_PROVIDER_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_PROVIDER_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_START_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_START_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_START_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_START_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_TAXES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_TAXES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_TAXES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_TAXES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_SUM_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_SUM_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_DEMAND_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_DEMAND_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_DEMAND_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_DEMAND_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_DEMAND_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_DEMAND_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_DEMAND_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_DEMAND_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_EXPORT_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_EXPORT_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_EXPORT_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_EXPORT_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_IMPORT_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_IMPORT_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_IMPORT_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_IMPORT_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_USAGE_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_USAGE_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_USAGE_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_USAGE_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BLENDED_RATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BLENDED_RATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BLENDED_RATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_BLENDED_RATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CREDITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CREDITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CREDITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CREDITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_END_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_END_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_END_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_END_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_FEES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_FEES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_FEES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_FEES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_LOAD_FACTOR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_LOAD_FACTOR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_LOAD_FACTOR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_LOAD_FACTOR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_NET_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_NET_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_NET_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_NET_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PERCENT_CHANGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PERCENT_CHANGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PERCENT_CHANGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PERCENT_CHANGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PROVIDER_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PROVIDER_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PROVIDER_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_PROVIDER_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_START_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_START_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_START_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_START_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_TAXES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_TAXES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_TAXES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_TAXES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_POPULATION_UTILITY_METER_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_ACCOUNT_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_ARRIVAL_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_DEMAND_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_DEMAND_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_DEMAND_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_DEMAND_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_DEMAND_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_DEMAND_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_DEMAND_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_DEMAND_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_EXPORT_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_EXPORT_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_EXPORT_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_EXPORT_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_IMPORT_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_IMPORT_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_IMPORT_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_IMPORT_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_USAGE_COST_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_USAGE_COST_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_USAGE_COST_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_USAGE_COST_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BLENDED_RATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BLENDED_RATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BLENDED_RATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_BLENDED_RATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CREDITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CREDITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CREDITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CREDITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CURRENCY_CODE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CURRENCY_CODE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CURRENCY_CODE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_CURRENCY_CODE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_DAYS_IN_BILL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_DAYS_IN_BILL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_DAYS_IN_BILL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_DAYS_IN_BILL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_DEMAND_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_DEMAND_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_DEMAND_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_DEMAND_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_END_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_END_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_END_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_END_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_FACILITY_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_FACILITY_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_FACILITY_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_FACILITY_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_FEES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_FEES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_FEES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_FEES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_IS_VALIDATED_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_IS_VALIDATED_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_IS_VALIDATED_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_IS_VALIDATED_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_LOAD_FACTOR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_LOAD_FACTOR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_LOAD_FACTOR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_LOAD_FACTOR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_END_DATE_SET_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_END_DATE_SET_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_END_DATE_SET_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_END_DATE_SET_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_LABEL_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_LABEL_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_LABEL_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_LABEL_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_STATEMENT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_STATEMENT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_STATEMENT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_METER_STATEMENT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_NET_BILL_USAGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_NET_BILL_USAGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_NET_BILL_USAGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_NET_BILL_USAGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PERCENT_CHANGE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PERCENT_CHANGE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PERCENT_CHANGE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PERCENT_CHANGE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PROVIDER_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PROVIDER_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PROVIDER_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_PROVIDER_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_SERVICE_TYPE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_SERVICE_TYPE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_SERVICE_TYPE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_SERVICE_TYPE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_START_DATE_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_START_DATE_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_START_DATE_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_START_DATE_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_MONTH_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_MONTH_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_MONTH_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_MONTH_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_YEAR_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_YEAR_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_YEAR_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_STATEMENT_YEAR_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_TAXES_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_TAXES_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_TAXES_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_TAXES_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_USAGE_UNITS_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_USAGE_UNITS_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_USAGE_UNITS_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_USAGE_UNITS_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_UTILITY_ACCOUNT_ID_DESC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_UTILITY_METER_ID_ASC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_UTILITY_METER_ID_ASC',
  UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_UTILITY_METER_ID_DESC = 'UTILITY_METER_STATEMENT_ROLLUPS_VARIANCE_SAMPLE_UTILITY_METER_ID_DESC'
}

export enum UtilityNetMeteringType {
  IMPORT_EXPORT_BILLING = 'IMPORT_EXPORT_BILLING',
  NET_ONLY_BILLING = 'NET_ONLY_BILLING',
  NONE = 'NONE'
}

/** A filter to be used against UtilityNetMeteringType fields. All fields are combined with a logical ‘and.’ */
export type UtilityNetMeteringTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<UtilityNetMeteringType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<UtilityNetMeteringType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<UtilityNetMeteringType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<UtilityNetMeteringType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<UtilityNetMeteringType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<UtilityNetMeteringType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<UtilityNetMeteringType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<UtilityNetMeteringType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<UtilityNetMeteringType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<UtilityNetMeteringType>>;
};

/** A profile for managing credentials for extracting data from accounts with various utility providers. No sensitive information is stored here. */
export type UtilityPendingMeter = Node & {
  __typename?: 'UtilityPendingMeter';
  /** The identifier of the account for this record as indicated by the integration. */
  accountIntegrationKey: Scalars['String']['output'];
  /** The account label, if different from the normalized account number, such as the raw account number from the utility provider. */
  accountLabel?: Maybe<Scalars['String']['output']>;
  /** The normalized account number from the integration. */
  accountNumber: Scalars['String']['output'];
  /** The time at which the record was created */
  createdAt: Scalars['Datetime']['output'];
  /** The list of IDs of the facilities this pending meter might belong to. */
  credentialFacilities?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Reads a single `Facility` that is related to this `UtilityPendingMeter`. */
  facility?: Maybe<Facility>;
  /** The facility this meter will be assigned to. */
  facilityId?: Maybe<Scalars['Int']['output']>;
  /** The internal identifer of the record. */
  id: Scalars['Int']['output'];
  /** The type of integration that discovered this meter. */
  integration: UtilityIntegration;
  /** The identifier of this record as indicated by the integration. */
  integrationKey: Scalars['String']['output'];
  /** Any extra information that may help describe this record. */
  metadata: Scalars['JSON']['output'];
  /** The meter label, if different from the normalized meter number, such as the raw meter number from the utility provider. */
  meterLabel?: Maybe<Scalars['String']['output']>;
  /** The nromalized meter number from the integration. */
  meterNumber: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The identifier of the utility provider as indicated by the integration, which may be different from the provider linked to the credential. */
  providerIntegrationKey: Scalars['String']['output'];
  /** The name of the utility provider, which may be different from the provider linked to the credential. */
  providerName: Scalars['String']['output'];
  /** The service type for this meter. */
  serviceType: Scalars['String']['output'];
  /** The time at which the record was last updated */
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `UtilityCredential` that is related to this `UtilityPendingMeter`. */
  utilityCredential?: Maybe<UtilityCredential>;
  /** The credential this meter was discovered on, if any. */
  utilityCredentialId?: Maybe<Scalars['Int']['output']>;
};

/**
 * A condition to be used against `UtilityPendingMeter` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type UtilityPendingMeterCondition = {
  /** Checks for equality with the object’s `accountIntegrationKey` field. */
  accountIntegrationKey?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `accountLabel` field. */
  accountLabel?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `accountNumber` field. */
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `integration` field. */
  integration?: InputMaybe<UtilityIntegration>;
  /** Checks for equality with the object’s `integrationKey` field. */
  integrationKey?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `metadata` field. */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `meterLabel` field. */
  meterLabel?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `meterNumber` field. */
  meterNumber?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `providerIntegrationKey` field. */
  providerIntegrationKey?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `providerName` field. */
  providerName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `serviceType` field. */
  serviceType?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `utilityCredentialId` field. */
  utilityCredentialId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `UtilityPendingMeter` object types. All fields are combined with a logical ‘and.’ */
export type UtilityPendingMeterFilter = {
  /** Filter by the object’s `accountIntegrationKey` field. */
  accountIntegrationKey?: InputMaybe<StringFilter>;
  /** Filter by the object’s `accountLabel` field. */
  accountLabel?: InputMaybe<StringFilter>;
  /** Filter by the object’s `accountNumber` field. */
  accountNumber?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UtilityPendingMeterFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `credentialFacilities` field. */
  credentialFacilities?: InputMaybe<IntListFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `integration` field. */
  integration?: InputMaybe<UtilityIntegrationFilter>;
  /** Filter by the object’s `integrationKey` field. */
  integrationKey?: InputMaybe<StringFilter>;
  /** Filter by the object’s `metadata` field. */
  metadata?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `meterLabel` field. */
  meterLabel?: InputMaybe<StringFilter>;
  /** Filter by the object’s `meterNumber` field. */
  meterNumber?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UtilityPendingMeterFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UtilityPendingMeterFilter>>;
  /** Filter by the object’s `providerIntegrationKey` field. */
  providerIntegrationKey?: InputMaybe<StringFilter>;
  /** Filter by the object’s `providerName` field. */
  providerName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `serviceType` field. */
  serviceType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `utilityCredentialId` field. */
  utilityCredentialId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `UtilityPendingMeter` */
export type UtilityPendingMeterInput = {
  /** The identifier of the account for this record as indicated by the integration. */
  accountIntegrationKey: Scalars['String']['input'];
  /** The account label, if different from the normalized account number, such as the raw account number from the utility provider. */
  accountLabel?: InputMaybe<Scalars['String']['input']>;
  /** The normalized account number from the integration. */
  accountNumber: Scalars['String']['input'];
  /** The facility this meter will be assigned to. */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** The type of integration that discovered this meter. */
  integration: UtilityIntegration;
  /** The identifier of this record as indicated by the integration. */
  integrationKey: Scalars['String']['input'];
  /** Any extra information that may help describe this record. */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** The meter label, if different from the normalized meter number, such as the raw meter number from the utility provider. */
  meterLabel?: InputMaybe<Scalars['String']['input']>;
  /** The nromalized meter number from the integration. */
  meterNumber: Scalars['String']['input'];
  /** The identifier of the utility provider as indicated by the integration, which may be different from the provider linked to the credential. */
  providerIntegrationKey: Scalars['String']['input'];
  /** The name of the utility provider, which may be different from the provider linked to the credential. */
  providerName: Scalars['String']['input'];
  /** The service type for this meter. */
  serviceType: Scalars['String']['input'];
  /** Mutates a `UtilityCredential` as part of the payload */
  utilityCredential?: InputMaybe<UtilityCredentialInput>;
  /** The credential this meter was discovered on, if any. */
  utilityCredentialId?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents an update to a `UtilityPendingMeter`. Fields that are set will be updated. */
export type UtilityPendingMeterPatch = {
  /** The facility this meter will be assigned to. */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `UtilityPendingMeter` values. */
export type UtilityPendingMetersConnection = {
  __typename?: 'UtilityPendingMetersConnection';
  /** A list of edges which contains the `UtilityPendingMeter` and cursor to aid in pagination. */
  edges: Array<UtilityPendingMetersEdge>;
  /** A list of `UtilityPendingMeter` objects. */
  nodes: Array<UtilityPendingMeter>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UtilityPendingMeter` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `UtilityPendingMeter` edge in the connection. */
export type UtilityPendingMetersEdge = {
  __typename?: 'UtilityPendingMetersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UtilityPendingMeter` at the end of the edge. */
  node: UtilityPendingMeter;
};

/** Methods to use when ordering `UtilityPendingMeter`. */
export enum UtilityPendingMetersOrderBy {
  ACCOUNT_INTEGRATION_KEY_ASC = 'ACCOUNT_INTEGRATION_KEY_ASC',
  ACCOUNT_INTEGRATION_KEY_DESC = 'ACCOUNT_INTEGRATION_KEY_DESC',
  ACCOUNT_LABEL_ASC = 'ACCOUNT_LABEL_ASC',
  ACCOUNT_LABEL_DESC = 'ACCOUNT_LABEL_DESC',
  ACCOUNT_NUMBER_ASC = 'ACCOUNT_NUMBER_ASC',
  ACCOUNT_NUMBER_DESC = 'ACCOUNT_NUMBER_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  INTEGRATION_ASC = 'INTEGRATION_ASC',
  INTEGRATION_DESC = 'INTEGRATION_DESC',
  INTEGRATION_KEY_ASC = 'INTEGRATION_KEY_ASC',
  INTEGRATION_KEY_DESC = 'INTEGRATION_KEY_DESC',
  METADATA_ASC = 'METADATA_ASC',
  METADATA_DESC = 'METADATA_DESC',
  METER_LABEL_ASC = 'METER_LABEL_ASC',
  METER_LABEL_DESC = 'METER_LABEL_DESC',
  METER_NUMBER_ASC = 'METER_NUMBER_ASC',
  METER_NUMBER_DESC = 'METER_NUMBER_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  PROVIDER_INTEGRATION_KEY_ASC = 'PROVIDER_INTEGRATION_KEY_ASC',
  PROVIDER_INTEGRATION_KEY_DESC = 'PROVIDER_INTEGRATION_KEY_DESC',
  PROVIDER_NAME_ASC = 'PROVIDER_NAME_ASC',
  PROVIDER_NAME_DESC = 'PROVIDER_NAME_DESC',
  SERVICE_TYPE_ASC = 'SERVICE_TYPE_ASC',
  SERVICE_TYPE_DESC = 'SERVICE_TYPE_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  UTILITY_CREDENTIAL_ID_ASC = 'UTILITY_CREDENTIAL_ID_ASC',
  UTILITY_CREDENTIAL_ID_DESC = 'UTILITY_CREDENTIAL_ID_DESC'
}

/** A utility provider. */
export type UtilityProvider = Node & {
  __typename?: 'UtilityProvider';
  /** The time this provider was created. */
  createdAt: Scalars['Datetime']['output'];
  /** The primary unique identifier for the provider. */
  id: Scalars['Int']['output'];
  /** The name of the provider. */
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The time this provider was updated. */
  updatedAt: Scalars['Datetime']['output'];
  /** Reads and enables pagination through a set of `UtilityAccount`. */
  utilityAccounts: UtilityAccountsConnection;
  /** Reads and enables pagination through a set of `UtilityCredential`. */
  utilityCredentials: UtilityCredentialsConnection;
};

/** A utility provider. */
export type UtilityProviderUtilityAccountsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UtilityAccountCondition>;
  filter?: InputMaybe<UtilityAccountFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UtilityAccountsOrderBy>>;
};

/** A utility provider. */
export type UtilityProviderUtilityCredentialsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UtilityCredentialCondition>;
  filter?: InputMaybe<UtilityCredentialFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UtilityCredentialsOrderBy>>;
};

/**
 * A condition to be used against `UtilityProvider` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type UtilityProviderCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `UtilityProvider` object types. All fields are combined with a logical ‘and.’ */
export type UtilityProviderFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UtilityProviderFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UtilityProviderFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UtilityProviderFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `UtilityProvider` */
export type UtilityProviderInput = {
  /** The primary unique identifier for the provider. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** The name of the provider. */
  name: Scalars['String']['input'];
};

/** Represents an update to a `UtilityProvider`. Fields that are set will be updated. */
export type UtilityProviderPatch = {
  /** The name of the provider. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `UtilityProvider` values. */
export type UtilityProvidersConnection = {
  __typename?: 'UtilityProvidersConnection';
  /** A list of edges which contains the `UtilityProvider` and cursor to aid in pagination. */
  edges: Array<UtilityProvidersEdge>;
  /** A list of `UtilityProvider` objects. */
  nodes: Array<UtilityProvider>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UtilityProvider` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `UtilityProvider` edge in the connection. */
export type UtilityProvidersEdge = {
  __typename?: 'UtilityProvidersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UtilityProvider` at the end of the edge. */
  node: UtilityProvider;
};

/** Methods to use when ordering `UtilityProvider`. */
export enum UtilityProvidersOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** External vendor users that may access the plaform via machine users. */
export type VendorUser = Node & {
  __typename?: 'VendorUser';
  /** The company in which the vendor user belongs. */
  company: Scalars['String']['output'];
  /** The time the vendor user was created. */
  createdAt: Scalars['Datetime']['output'];
  /** The email of the vendor user. */
  email: Scalars['String']['output'];
  /** The first name of the vendor user. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** The id of the vendor user. */
  id: Scalars['Int']['output'];
  /** The last name of the vendor user. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `MachineUser`. */
  machineUsers: MachineUsersConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Available permissions for the VendorUser. */
  permissions?: Maybe<VendorUserPermissions>;
  /** The time the vendor user was updated. */
  updatedAt: Scalars['Datetime']['output'];
};

/** External vendor users that may access the plaform via machine users. */
export type VendorUserMachineUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<MachineUserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * A condition to be used against `VendorUser` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type VendorUserCondition = {
  /** Checks for equality with the object’s `company` field. */
  company?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `email` field. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `firstName` field. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `lastName` field. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `VendorUser` object types. All fields are combined with a logical ‘and.’ */
export type VendorUserFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VendorUserFilter>>;
  /** Filter by the permission can_write */
  canWrite?: InputMaybe<PermissionBooleanFilter>;
  /** Filter by the object’s `company` field. */
  company?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `email` field. */
  email?: InputMaybe<StringFilter>;
  /** Filter by the object’s `firstName` field. */
  firstName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `lastName` field. */
  lastName?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<VendorUserFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VendorUserFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `VendorUser` */
export type VendorUserInput = {
  /** The company in which the vendor user belongs. */
  company: Scalars['String']['input'];
  /** The email of the vendor user. */
  email: Scalars['String']['input'];
  /** The first name of the vendor user. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** The last name of the vendor user. */
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type VendorUserMachineUser = Node & {
  __typename?: 'VendorUserMachineUser';
  /** The machine user associated with the vendor user. */
  machineUserId: Scalars['BigInt']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The id of the vendor user. */
  vendorUserId: Scalars['Int']['output'];
};

/** An input for mutations affecting `VendorUserMachineUser` */
export type VendorUserMachineUserInput = {
  /** The machine user associated with the vendor user. */
  machineUserId: Scalars['BigInt']['input'];
  /** The id of the vendor user. */
  vendorUserId: Scalars['Int']['input'];
};

/** Represents an update to a `VendorUserMachineUser`. Fields that are set will be updated. */
export type VendorUserMachineUserPatch = {
  /** The machine user associated with the vendor user. */
  machineUserId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The id of the vendor user. */
  vendorUserId?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents an update to a `VendorUser`. Fields that are set will be updated. */
export type VendorUserPatch = {
  /** The company in which the vendor user belongs. */
  company?: InputMaybe<Scalars['String']['input']>;
  /** The email of the vendor user. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The first name of the vendor user. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** The last name of the vendor user. */
  lastName?: InputMaybe<Scalars['String']['input']>;
};

/** Permissive capabilities on a VendorUser. */
export type VendorUserPermissions = {
  __typename?: 'VendorUserPermissions';
  /** Whether a user can write a vendor user */
  canWrite: Scalars['Boolean']['output'];
};

/** A connection to a list of `VendorUser` values. */
export type VendorUsersConnection = {
  __typename?: 'VendorUsersConnection';
  /** A list of edges which contains the `VendorUser` and cursor to aid in pagination. */
  edges: Array<VendorUsersEdge>;
  /** A list of `VendorUser` objects. */
  nodes: Array<VendorUser>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VendorUser` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `VendorUser` edge in the connection. */
export type VendorUsersEdge = {
  __typename?: 'VendorUsersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `VendorUser` at the end of the edge. */
  node: VendorUser;
};

/** Methods to use when ordering `VendorUser`. */
export enum VendorUsersOrderBy {
  COMPANY_ASC = 'COMPANY_ASC',
  COMPANY_DESC = 'COMPANY_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  EMAIL_ASC = 'EMAIL_ASC',
  EMAIL_DESC = 'EMAIL_DESC',
  FIRST_NAME_ASC = 'FIRST_NAME_ASC',
  FIRST_NAME_DESC = 'FIRST_NAME_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LAST_NAME_ASC = 'LAST_NAME_ASC',
  LAST_NAME_DESC = 'LAST_NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

export type VerifyPhoneNumberInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
};

export type VerifyPhoneNumberResponse = {
  __typename?: 'VerifyPhoneNumberResponse';
  attempts: Scalars['Int']['output'];
  clientMutationId?: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['String']['output'];
  verificationId: Scalars['String']['output'];
};

/** A physical vessel in a refrigeration system */
export type Vessel = Node & {
  __typename?: 'Vessel';
  /** The time the record was created. */
  createdAt: Scalars['Datetime']['output'];
  /** The unique identifier for the vessel. */
  id: Scalars['Int']['output'];
  /** The label for the vessel. */
  label: Scalars['String']['output'];
  /** Reads a single `DataPoint` that is related to this `Vessel`. */
  level?: Maybe<DataPoint>;
  /** References the level datapoint for the vessel. */
  levelId?: Maybe<Scalars['Int']['output']>;
  /** Reads and enables pagination through a set of `LiquidHeader`. */
  liquidHeaders: LiquidHeadersConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `RefrigerationSystem` that is related to this `Vessel`. */
  refrigerationSystem?: Maybe<RefrigerationSystem>;
  /** References the refrigeration system this vessel is located in. */
  refrigerationSystemId: Scalars['Int']['output'];
  /** Reads a single `SuctionGroup` that is related to this `Vessel`. */
  suctionGroup?: Maybe<SuctionGroup>;
  /** References the suction group this vessel is part of. */
  suctionGroupId?: Maybe<Scalars['Int']['output']>;
  /** The time the record was last updated. */
  updatedAt: Scalars['Datetime']['output'];
  /** References the type of vessel. */
  vesselType: VesselType;
};

/** A physical vessel in a refrigeration system */
export type VesselLiquidHeadersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LiquidHeaderCondition>;
  filter?: InputMaybe<LiquidHeaderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiquidHeadersOrderBy>>;
};

/** A condition to be used against `Vessel` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type VesselCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `label` field. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `levelId` field. */
  levelId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `refrigerationSystemId` field. */
  refrigerationSystemId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `suctionGroupId` field. */
  suctionGroupId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `vesselType` field. */
  vesselType?: InputMaybe<VesselType>;
};

/** A filter to be used against `Vessel` object types. All fields are combined with a logical ‘and.’ */
export type VesselFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VesselFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `label` field. */
  label?: InputMaybe<StringFilter>;
  /** Filter by the object’s `levelId` field. */
  levelId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<VesselFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VesselFilter>>;
  /** Filter by the object’s `refrigerationSystemId` field. */
  refrigerationSystemId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `suctionGroupId` field. */
  suctionGroupId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `vesselType` field. */
  vesselType?: InputMaybe<VesselTypeFilter>;
};

/** An input for mutations affecting `Vessel` */
export type VesselInput = {
  /** Mutates a `DataPoint` as part of the payload */
  dataPoint?: InputMaybe<DataPointInput>;
  /** The unique identifier for the vessel. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** The label for the vessel. */
  label: Scalars['String']['input'];
  /** References the level datapoint for the vessel. */
  levelId?: InputMaybe<Scalars['Int']['input']>;
  /** Mutates a `RefrigerationSystem` as part of the payload */
  refrigerationSystem?: InputMaybe<RefrigerationSystemInput>;
  /** References the refrigeration system this vessel is located in. */
  refrigerationSystemId?: InputMaybe<Scalars['Int']['input']>;
  /** Mutates a `SuctionGroup` as part of the payload */
  suctionGroup?: InputMaybe<SuctionGroupInput>;
  /** References the suction group this vessel is part of. */
  suctionGroupId?: InputMaybe<Scalars['Int']['input']>;
  /** References the type of vessel. */
  vesselType: VesselType;
};

/** Represents an update to a `Vessel`. Fields that are set will be updated. */
export type VesselPatch = {
  /** The unique identifier for the vessel. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** The label for the vessel. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** References the level datapoint for the vessel. */
  levelId?: InputMaybe<Scalars['Int']['input']>;
  /** References the refrigeration system this vessel is located in. */
  refrigerationSystemId?: InputMaybe<Scalars['Int']['input']>;
  /** References the suction group this vessel is part of. */
  suctionGroupId?: InputMaybe<Scalars['Int']['input']>;
  /** References the type of vessel. */
  vesselType?: InputMaybe<VesselType>;
};

/** The type of vessel in the refrigeration system */
export enum VesselType {
  ECONOMIZER = 'ECONOMIZER',
  HIGH_PRESSURE_RECEIVER = 'HIGH_PRESSURE_RECEIVER',
  INTERCOOLER = 'INTERCOOLER',
  LOW_PRESSURE_RECEIVER = 'LOW_PRESSURE_RECEIVER',
  RECIRCULATOR = 'RECIRCULATOR',
  SURGE_DRUM = 'SURGE_DRUM'
}

/** A filter to be used against VesselType fields. All fields are combined with a logical ‘and.’ */
export type VesselTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<VesselType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<VesselType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<VesselType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<VesselType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<VesselType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<VesselType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<VesselType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<VesselType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<VesselType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<VesselType>>;
};

/** A connection to a list of `Vessel` values. */
export type VesselsConnection = {
  __typename?: 'VesselsConnection';
  /** A list of edges which contains the `Vessel` and cursor to aid in pagination. */
  edges: Array<VesselsEdge>;
  /** Returns the aggregate level timeseries data for the VesselsConnection  */
  level?: Maybe<MetricDataConnection>;
  /** A list of `Vessel` objects. */
  nodes: Array<Vessel>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Vessel` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A connection to a list of `Vessel` values. */
export type VesselsConnectionLevelArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A `Vessel` edge in the connection. */
export type VesselsEdge = {
  __typename?: 'VesselsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Vessel` at the end of the edge. */
  node: Vessel;
};

/** Methods to use when ordering `Vessel`. */
export enum VesselsOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LABEL_ASC = 'LABEL_ASC',
  LABEL_DESC = 'LABEL_DESC',
  LEVEL_ID_ASC = 'LEVEL_ID_ASC',
  LEVEL_ID_DESC = 'LEVEL_ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  REFRIGERATION_SYSTEM_ID_ASC = 'REFRIGERATION_SYSTEM_ID_ASC',
  REFRIGERATION_SYSTEM_ID_DESC = 'REFRIGERATION_SYSTEM_ID_DESC',
  SUCTION_GROUP_ID_ASC = 'SUCTION_GROUP_ID_ASC',
  SUCTION_GROUP_ID_DESC = 'SUCTION_GROUP_ID_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  VESSEL_TYPE_ASC = 'VESSEL_TYPE_ASC',
  VESSEL_TYPE_DESC = 'VESSEL_TYPE_DESC'
}

/** Maps VIRTUAL data points to time bounded child data points which creates a single virtual data stream. */
export type VirtualPointInterval = Node & {
  __typename?: 'VirtualPointInterval';
  /** Reads a single `DataPoint` that is related to this `VirtualPointInterval`. */
  child?: Maybe<DataPoint>;
  /** The id of the child data point. */
  childId: Scalars['BigInt']['output'];
  /** The upper bound of datetime window to apply to child data stream. */
  endTime?: Maybe<Scalars['Datetime']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `DataPoint` that is related to this `VirtualPointInterval`. */
  parent?: Maybe<DataPoint>;
  /** The id of the VIRTUAL data point. */
  parentId: Scalars['BigInt']['output'];
  /** The lower bound of datetime window to apply to child data stream. */
  startTime: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `VirtualPointInterval` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type VirtualPointIntervalCondition = {
  /** Checks for equality with the object’s `childId` field. */
  childId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `endTime` field. */
  endTime?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `parentId` field. */
  parentId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `startTime` field. */
  startTime?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `VirtualPointInterval` object types. All fields are combined with a logical ‘and.’ */
export type VirtualPointIntervalFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VirtualPointIntervalFilter>>;
  /** Filter by the object’s `childId` field. */
  childId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `endTime` field. */
  endTime?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<VirtualPointIntervalFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VirtualPointIntervalFilter>>;
  /** Filter by the object’s `parentId` field. */
  parentId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `startTime` field. */
  startTime?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `VirtualPointInterval` */
export type VirtualPointIntervalInput = {
  /** The id of the child data point. */
  childId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Mutates a `DataPoint` as part of the payload */
  dataPoint?: InputMaybe<DataPointInput>;
  /** The upper bound of datetime window to apply to child data stream. */
  endTime?: InputMaybe<Scalars['Datetime']['input']>;
  /** The id of the VIRTUAL data point. */
  parentId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The lower bound of datetime window to apply to child data stream. */
  startTime: Scalars['Datetime']['input'];
};

/** Represents an update to a `VirtualPointInterval`. Fields that are set will be updated. */
export type VirtualPointIntervalPatch = {
  /** The id of the child data point. */
  childId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The upper bound of datetime window to apply to child data stream. */
  endTime?: InputMaybe<Scalars['Datetime']['input']>;
  /** The id of the VIRTUAL data point. */
  parentId?: InputMaybe<Scalars['BigInt']['input']>;
  /** The lower bound of datetime window to apply to child data stream. */
  startTime?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A connection to a list of `VirtualPointInterval` values. */
export type VirtualPointIntervalsConnection = {
  __typename?: 'VirtualPointIntervalsConnection';
  /** Returns the aggregate child timeseries data for the VirtualPointIntervalsConnection  */
  child?: Maybe<MetricDataConnection>;
  /** A list of edges which contains the `VirtualPointInterval` and cursor to aid in pagination. */
  edges: Array<VirtualPointIntervalsEdge>;
  /** A list of `VirtualPointInterval` objects. */
  nodes: Array<VirtualPointInterval>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Returns the aggregate parent timeseries data for the VirtualPointIntervalsConnection  */
  parent?: Maybe<MetricDataConnection>;
  /** The count of *all* `VirtualPointInterval` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A connection to a list of `VirtualPointInterval` values. */
export type VirtualPointIntervalsConnectionChildArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A connection to a list of `VirtualPointInterval` values. */
export type VirtualPointIntervalsConnectionParentArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  aggregation?: MetricDataAggregationMethod;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: MetricDataOrderBy;
  samplingWindow?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  window?: Scalars['String']['input'];
};

/** A `VirtualPointInterval` edge in the connection. */
export type VirtualPointIntervalsEdge = {
  __typename?: 'VirtualPointIntervalsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `VirtualPointInterval` at the end of the edge. */
  node: VirtualPointInterval;
};

/** Methods to use when ordering `VirtualPointInterval`. */
export enum VirtualPointIntervalsOrderBy {
  CHILD_ID_ASC = 'CHILD_ID_ASC',
  CHILD_ID_DESC = 'CHILD_ID_DESC',
  END_TIME_ASC = 'END_TIME_ASC',
  END_TIME_DESC = 'END_TIME_DESC',
  NATURAL = 'NATURAL',
  PARENT_ID_ASC = 'PARENT_ID_ASC',
  PARENT_ID_DESC = 'PARENT_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  START_TIME_ASC = 'START_TIME_ASC',
  START_TIME_DESC = 'START_TIME_DESC'
}

export type WithdrawSuggestionInput = {
  id: Scalars['Int']['input'];
};

/** The yard of a given facility */
export type Yard = Node & {
  __typename?: 'Yard';
  /** Reads and enables pagination through a set of `Appointment`. */
  appointments: AppointmentsConnection;
  /** The time when this record was created */
  createdAt: Scalars['Datetime']['output'];
  /** Reads a single `Facility` that is related to this `Yard`. */
  facility?: Maybe<Facility>;
  /** The facility associated with this yard */
  facilityId: Scalars['Int']['output'];
  /** The internal ID of this yard */
  id: Scalars['Int']['output'];
  /** The name of this yard */
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** The external ID used to track conversations with the driver */
  smsClientId: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `SpaceCategory`. */
  spaceCategories: SpaceCategoriesConnection;
  /** Reads and enables pagination through a set of `TrailerAudit`. */
  trailerAudits: TrailerAuditsConnection;
  /** The trailers currently parked in the yard */
  trailers: TrailersConnection;
  /** The time when this record was last updated */
  updatedAt: Scalars['Datetime']['output'];
};

/** The yard of a given facility */
export type YardAppointmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AppointmentCondition>;
  filter?: InputMaybe<AppointmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AppointmentsOrderBy>>;
};

/** The yard of a given facility */
export type YardSpaceCategoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SpaceCategoryCondition>;
  filter?: InputMaybe<SpaceCategoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SpaceCategoriesOrderBy>>;
};

/** The yard of a given facility */
export type YardTrailerAuditsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TrailerAuditCondition>;
  filter?: InputMaybe<TrailerAuditFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TrailerAuditsOrderBy>>;
};

/** The yard of a given facility */
export type YardTrailersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<TrailerFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** A condition to be used against `Yard` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type YardCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `facilityId` field. */
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `smsClientId` field. */
  smsClientId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `Yard` object types. All fields are combined with a logical ‘and.’ */
export type YardFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<YardFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `facilityId` field. */
  facilityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<YardFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<YardFilter>>;
  /** Filter by the object’s `smsClientId` field. */
  smsClientId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

export type YardUpdatedPayload = {
  __typename?: 'YardUpdatedPayload';
  event?: Maybe<Scalars['String']['output']>;
  yard?: Maybe<Yard>;
};

/** A connection to a list of `Yard` values. */
export type YardsConnection = {
  __typename?: 'YardsConnection';
  /** A list of edges which contains the `Yard` and cursor to aid in pagination. */
  edges: Array<YardsEdge>;
  /** A list of `Yard` objects. */
  nodes: Array<Yard>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Yard` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Yard` edge in the connection. */
export type YardsEdge = {
  __typename?: 'YardsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Yard` at the end of the edge. */
  node: Yard;
};

/** Methods to use when ordering `Yard`. */
export enum YardsOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  FACILITY_ID_ASC = 'FACILITY_ID_ASC',
  FACILITY_ID_DESC = 'FACILITY_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  SMS_CLIENT_ID_ASC = 'SMS_CLIENT_ID_ASC',
  SMS_CLIENT_ID_DESC = 'SMS_CLIENT_ID_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** One possible value for a given Enum. Enum values are unique values, not a placeholder for a string or numeric value. However an Enum value is returned in a JSON response as a string. */
export type __EnumValue = {
  __typename?: '__EnumValue';
  name: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  isDeprecated: Scalars['Boolean']['output'];
  deprecationReason?: Maybe<Scalars['String']['output']>;
};

/** Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type. */
export type __Field = {
  __typename?: '__Field';
  name: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  args: Array<__InputValue>;
  type: __Type;
  isDeprecated: Scalars['Boolean']['output'];
  deprecationReason?: Maybe<Scalars['String']['output']>;
};

/** Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type. */
export type __FieldArgsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Arguments provided to Fields or Directives and the input fields of an InputObject are represented as Input Values which describe their type and optionally a default value. */
export type __InputValue = {
  __typename?: '__InputValue';
  name: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  type: __Type;
  /** A GraphQL-formatted string representing the default value for this input value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  isDeprecated: Scalars['Boolean']['output'];
  deprecationReason?: Maybe<Scalars['String']['output']>;
};

/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __Type = {
  __typename?: '__Type';
  kind: __TypeKind;
  name?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  specifiedByURL?: Maybe<Scalars['String']['output']>;
  fields?: Maybe<Array<__Field>>;
  interfaces?: Maybe<Array<__Type>>;
  possibleTypes?: Maybe<Array<__Type>>;
  enumValues?: Maybe<Array<__EnumValue>>;
  inputFields?: Maybe<Array<__InputValue>>;
  ofType?: Maybe<__Type>;
  isOneOf?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeFieldsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeEnumValuesArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeInputFieldsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An enum describing what kind of type a given `__Type` is. */
export enum __TypeKind {
  /** Indicates this type is a scalar. */
  SCALAR = 'SCALAR',
  /** Indicates this type is an object. `fields` and `interfaces` are valid fields. */
  OBJECT = 'OBJECT',
  /** Indicates this type is an interface. `fields`, `interfaces`, and `possibleTypes` are valid fields. */
  INTERFACE = 'INTERFACE',
  /** Indicates this type is a union. `possibleTypes` is a valid field. */
  UNION = 'UNION',
  /** Indicates this type is an enum. `enumValues` is a valid field. */
  ENUM = 'ENUM',
  /** Indicates this type is an input object. `inputFields` is a valid field. */
  INPUT_OBJECT = 'INPUT_OBJECT',
  /** Indicates this type is a list. `ofType` is a valid field. */
  LIST = 'LIST',
  /** Indicates this type is a non-null. `ofType` is a valid field. */
  NON_NULL = 'NON_NULL'
}

export type AllFaciltiesQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<FacilitiesOrderBy> | FacilitiesOrderBy>;
}>;

export type AllFaciltiesQuery = {
  __typename?: 'Query';
  facilities?: {
    __typename?: 'FacilitiesConnection';
    nodes: Array<{ __typename?: 'Facility'; id: number; name: string }>;
  } | null;
};

export type ExtendMutationVariables = Exact<{
  payload: Scalars['String']['input'];
  failOnExists?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type ExtendMutation = {
  __typename?: 'Mutation';
  extend?: boolean | null;
};

export type GetFacilitySchemaQueryVariables = Exact<{ [key: string]: never }>;

export type GetFacilitySchemaQuery = {
  __typename?: 'Query';
  __type?: {
    __typename?: '__Type';
    fields?: Array<{
      __typename?: '__Field';
      name: string;
      description?: string | null;
      type: {
        __typename?: '__Type';
        name?: string | null;
        kind: __TypeKind;
        ofType?: {
          __typename?: '__Type';
          name?: string | null;
          kind: __TypeKind;
        } | null;
      };
    }> | null;
  } | null;
};

export type AllFacilitiesWithAddressQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AllFacilitiesWithAddressQuery = {
  __typename?: 'Query';
  facilities?: {
    __typename?: 'FacilitiesConnection';
    nodes: Array<{
      __typename?: 'Facility';
      id: number;
      slug: string;
      name: string;
      address?: string | null;
    }>;
  } | null;
};

export type DeleteFacilityBySlugMutationVariables = Exact<{
  input: DeleteFacilityBySlugInput;
}>;

export type DeleteFacilityBySlugMutation = {
  __typename?: 'Mutation';
  deleteFacilityBySlug?: {
    __typename?: 'DeleteFacilityPayload';
    deletedFacilityNodeId?: string | null;
  } | null;
};

export type GetTimezonesQueryVariables = Exact<{ [key: string]: never }>;

export type GetTimezonesQuery = {
  __typename?: 'Query';
  timezones?: {
    __typename?: 'TimezonesConnection';
    nodes: Array<{
      __typename?: 'Timezone';
      abbreviation?: string | null;
      name: string;
      isDst?: boolean | null;
      utcOffset?: { __typename?: 'Interval'; hours?: number | null } | null;
    }>;
  } | null;
};

export type FacilityGroupByIdQueryVariables = Exact<{
  facilityGroupByIdId: Scalars['BigInt']['input'];
}>;

export type FacilityGroupByIdQuery = {
  __typename?: 'Query';
  facilityGroup?: {
    __typename?: 'FacilityGroup';
    facilities: {
      __typename?: 'FacilitiesConnection';
      nodes: Array<{
        __typename?: 'Facility';
        id: number;
        name: string;
        city?: string | null;
        state?: string | null;
        zip?: string | null;
      }>;
    };
  } | null;
};

export type AllFacilitiesQueryVariables = Exact<{ [key: string]: never }>;

export type AllFacilitiesQuery = {
  __typename?: 'Query';
  facilities?: {
    __typename?: 'FacilitiesConnection';
    nodes: Array<{
      __typename?: 'Facility';
      name: string;
      address?: string | null;
      city?: string | null;
      state?: string | null;
      zip?: string | null;
      slug: string;
      id: number;
      facilityGroups: {
        __typename?: 'FacilityGroupsConnection';
        nodes: Array<{ __typename?: 'FacilityGroup'; id: any; name: string }>;
      };
    }>;
  } | null;
};

export type CreateFacilityGroupMutationVariables = Exact<{
  input: CreateFacilityGroupInput;
}>;

export type CreateFacilityGroupMutation = {
  __typename?: 'Mutation';
  createFacilityGroup?: {
    __typename?: 'CreateFacilityGroupPayload';
    facilityGroup?: {
      __typename?: 'FacilityGroup';
      name: string;
      parentId?: any | null;
      id: any;
    } | null;
  } | null;
};

export type UpdateFacilityGroupByIdMutationVariables = Exact<{
  input: UpdateFacilityGroupInput;
}>;

export type UpdateFacilityGroupByIdMutation = {
  __typename?: 'Mutation';
  updateFacilityGroup?: {
    __typename?: 'UpdateFacilityGroupPayload';
    facilityGroup?: {
      __typename?: 'FacilityGroup';
      id: any;
      name: string;
      parent?: { __typename?: 'FacilityGroup'; id: any; name: string } | null;
    } | null;
  } | null;
};

export type AllGroupsQueryVariables = Exact<{ [key: string]: never }>;

export type AllGroupsQuery = {
  __typename?: 'Query';
  facilityGroups?: {
    __typename?: 'FacilityGroupsConnection';
    nodes: Array<{
      __typename?: 'FacilityGroup';
      id: any;
      name: string;
      parentId?: any | null;
      facilities: {
        __typename?: 'FacilitiesConnection';
        nodes: Array<{
          __typename?: 'Facility';
          id: number;
          name: string;
          address?: string | null;
          city?: string | null;
          state?: string | null;
          zip?: string | null;
          slug: string;
          facilityGroups: {
            __typename?: 'FacilityGroupsConnection';
            nodes: Array<{ __typename?: 'FacilityGroup'; id: any }>;
          };
        }>;
      };
    }>;
  } | null;
};

export type AddFacilityToGroupMutationVariables = Exact<{
  input: CreateFacilityGroupsLinkerInput;
}>;

export type AddFacilityToGroupMutation = {
  __typename?: 'Mutation';
  createFacilityGroupsLinker?: {
    __typename?: 'CreateFacilityGroupsLinkerPayload';
    facilityGroupsLinker?: {
      __typename?: 'FacilityGroupsLinker';
      facilityGroupingId: any;
      facilityId: number;
    } | null;
  } | null;
};

export type RemoveFacilityFromGroupMutationVariables = Exact<{
  input: DeleteFacilityGroupsLinkerInput;
}>;

export type RemoveFacilityFromGroupMutation = {
  __typename?: 'Mutation';
  deleteFacilityGroupsLinker?: {
    __typename?: 'DeleteFacilityGroupsLinkerPayload';
    facilityGroupsLinker?: {
      __typename?: 'FacilityGroupsLinker';
      facilityGroupingId: any;
      facilityId: number;
    } | null;
  } | null;
};

export type DeleteFacilityGroupByIdMutationVariables = Exact<{
  input: DeleteFacilityGroupInput;
}>;

export type DeleteFacilityGroupByIdMutation = {
  __typename?: 'Mutation';
  deleteFacilityGroup?: {
    __typename?: 'DeleteFacilityGroupPayload';
    facilityGroup?: {
      __typename?: 'FacilityGroup';
      name: string;
      id: any;
    } | null;
  } | null;
};

export const AllFaciltiesDocument = gql`
  query AllFacilties($orderBy: [FacilitiesOrderBy!]) {
    facilities(orderBy: $orderBy) {
      nodes {
        id
        name
      }
    }
  }
`;

/**
 * __useAllFaciltiesQuery__
 *
 * To run a query within a React component, call `useAllFaciltiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllFaciltiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllFaciltiesQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useAllFaciltiesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AllFaciltiesQuery,
    AllFaciltiesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AllFaciltiesQuery, AllFaciltiesQueryVariables>(
    AllFaciltiesDocument,
    options
  );
}
export function useAllFaciltiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AllFaciltiesQuery,
    AllFaciltiesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AllFaciltiesQuery, AllFaciltiesQueryVariables>(
    AllFaciltiesDocument,
    options
  );
}
// @ts-ignore
export function useAllFaciltiesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AllFaciltiesQuery,
    AllFaciltiesQueryVariables
  >
): Apollo.UseSuspenseQueryResult<AllFaciltiesQuery, AllFaciltiesQueryVariables>;
export function useAllFaciltiesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AllFaciltiesQuery,
        AllFaciltiesQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  AllFaciltiesQuery | undefined,
  AllFaciltiesQueryVariables
>;
export function useAllFaciltiesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AllFaciltiesQuery,
        AllFaciltiesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AllFaciltiesQuery, AllFaciltiesQueryVariables>(
    AllFaciltiesDocument,
    options
  );
}
export type AllFaciltiesQueryHookResult = ReturnType<
  typeof useAllFaciltiesQuery
>;
export type AllFaciltiesLazyQueryHookResult = ReturnType<
  typeof useAllFaciltiesLazyQuery
>;
export type AllFaciltiesSuspenseQueryHookResult = ReturnType<
  typeof useAllFaciltiesSuspenseQuery
>;
export type AllFaciltiesQueryResult = Apollo.QueryResult<
  AllFaciltiesQuery,
  AllFaciltiesQueryVariables
>;
export const ExtendDocument = gql`
  mutation Extend($payload: String!, $failOnExists: Boolean) {
    extend(payload: $payload, failOnExists: $failOnExists)
  }
`;
export type ExtendMutationFn = Apollo.MutationFunction<
  ExtendMutation,
  ExtendMutationVariables
>;

/**
 * __useExtendMutation__
 *
 * To run a mutation, you first call `useExtendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExtendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [extendMutation, { data, loading, error }] = useExtendMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *      failOnExists: // value for 'failOnExists'
 *   },
 * });
 */
export function useExtendMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ExtendMutation,
    ExtendMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ExtendMutation, ExtendMutationVariables>(
    ExtendDocument,
    options
  );
}
export type ExtendMutationHookResult = ReturnType<typeof useExtendMutation>;
export type ExtendMutationResult = Apollo.MutationResult<ExtendMutation>;
export type ExtendMutationOptions = Apollo.BaseMutationOptions<
  ExtendMutation,
  ExtendMutationVariables
>;
export const GetFacilitySchemaDocument = gql`
  query getFacilitySchema {
    __type(name: "Facility") {
      fields {
        name
        description
        type {
          name
          kind
          ofType {
            name
            kind
          }
        }
      }
    }
  }
`;

/**
 * __useGetFacilitySchemaQuery__
 *
 * To run a query within a React component, call `useGetFacilitySchemaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFacilitySchemaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFacilitySchemaQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFacilitySchemaQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetFacilitySchemaQuery,
    GetFacilitySchemaQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetFacilitySchemaQuery,
    GetFacilitySchemaQueryVariables
  >(GetFacilitySchemaDocument, options);
}
export function useGetFacilitySchemaLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFacilitySchemaQuery,
    GetFacilitySchemaQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetFacilitySchemaQuery,
    GetFacilitySchemaQueryVariables
  >(GetFacilitySchemaDocument, options);
}
// @ts-ignore
export function useGetFacilitySchemaSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetFacilitySchemaQuery,
    GetFacilitySchemaQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetFacilitySchemaQuery,
  GetFacilitySchemaQueryVariables
>;
export function useGetFacilitySchemaSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetFacilitySchemaQuery,
        GetFacilitySchemaQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetFacilitySchemaQuery | undefined,
  GetFacilitySchemaQueryVariables
>;
export function useGetFacilitySchemaSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetFacilitySchemaQuery,
        GetFacilitySchemaQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetFacilitySchemaQuery,
    GetFacilitySchemaQueryVariables
  >(GetFacilitySchemaDocument, options);
}
export type GetFacilitySchemaQueryHookResult = ReturnType<
  typeof useGetFacilitySchemaQuery
>;
export type GetFacilitySchemaLazyQueryHookResult = ReturnType<
  typeof useGetFacilitySchemaLazyQuery
>;
export type GetFacilitySchemaSuspenseQueryHookResult = ReturnType<
  typeof useGetFacilitySchemaSuspenseQuery
>;
export type GetFacilitySchemaQueryResult = Apollo.QueryResult<
  GetFacilitySchemaQuery,
  GetFacilitySchemaQueryVariables
>;
export const AllFacilitiesWithAddressDocument = gql`
  query AllFacilitiesWithAddress {
    facilities {
      nodes {
        id
        slug
        name
        address
      }
    }
  }
`;

/**
 * __useAllFacilitiesWithAddressQuery__
 *
 * To run a query within a React component, call `useAllFacilitiesWithAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllFacilitiesWithAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllFacilitiesWithAddressQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllFacilitiesWithAddressQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AllFacilitiesWithAddressQuery,
    AllFacilitiesWithAddressQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AllFacilitiesWithAddressQuery,
    AllFacilitiesWithAddressQueryVariables
  >(AllFacilitiesWithAddressDocument, options);
}
export function useAllFacilitiesWithAddressLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AllFacilitiesWithAddressQuery,
    AllFacilitiesWithAddressQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AllFacilitiesWithAddressQuery,
    AllFacilitiesWithAddressQueryVariables
  >(AllFacilitiesWithAddressDocument, options);
}
// @ts-ignore
export function useAllFacilitiesWithAddressSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AllFacilitiesWithAddressQuery,
    AllFacilitiesWithAddressQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  AllFacilitiesWithAddressQuery,
  AllFacilitiesWithAddressQueryVariables
>;
export function useAllFacilitiesWithAddressSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AllFacilitiesWithAddressQuery,
        AllFacilitiesWithAddressQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  AllFacilitiesWithAddressQuery | undefined,
  AllFacilitiesWithAddressQueryVariables
>;
export function useAllFacilitiesWithAddressSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AllFacilitiesWithAddressQuery,
        AllFacilitiesWithAddressQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AllFacilitiesWithAddressQuery,
    AllFacilitiesWithAddressQueryVariables
  >(AllFacilitiesWithAddressDocument, options);
}
export type AllFacilitiesWithAddressQueryHookResult = ReturnType<
  typeof useAllFacilitiesWithAddressQuery
>;
export type AllFacilitiesWithAddressLazyQueryHookResult = ReturnType<
  typeof useAllFacilitiesWithAddressLazyQuery
>;
export type AllFacilitiesWithAddressSuspenseQueryHookResult = ReturnType<
  typeof useAllFacilitiesWithAddressSuspenseQuery
>;
export type AllFacilitiesWithAddressQueryResult = Apollo.QueryResult<
  AllFacilitiesWithAddressQuery,
  AllFacilitiesWithAddressQueryVariables
>;
export const DeleteFacilityBySlugDocument = gql`
  mutation DeleteFacilityBySlug($input: DeleteFacilityBySlugInput!) {
    deleteFacilityBySlug(input: $input) {
      deletedFacilityNodeId
    }
  }
`;
export type DeleteFacilityBySlugMutationFn = Apollo.MutationFunction<
  DeleteFacilityBySlugMutation,
  DeleteFacilityBySlugMutationVariables
>;

/**
 * __useDeleteFacilityBySlugMutation__
 *
 * To run a mutation, you first call `useDeleteFacilityBySlugMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFacilityBySlugMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFacilityBySlugMutation, { data, loading, error }] = useDeleteFacilityBySlugMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteFacilityBySlugMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteFacilityBySlugMutation,
    DeleteFacilityBySlugMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteFacilityBySlugMutation,
    DeleteFacilityBySlugMutationVariables
  >(DeleteFacilityBySlugDocument, options);
}
export type DeleteFacilityBySlugMutationHookResult = ReturnType<
  typeof useDeleteFacilityBySlugMutation
>;
export type DeleteFacilityBySlugMutationResult =
  Apollo.MutationResult<DeleteFacilityBySlugMutation>;
export type DeleteFacilityBySlugMutationOptions = Apollo.BaseMutationOptions<
  DeleteFacilityBySlugMutation,
  DeleteFacilityBySlugMutationVariables
>;
export const GetTimezonesDocument = gql`
  query getTimezones {
    timezones {
      nodes {
        abbreviation
        name
        isDst
        utcOffset {
          hours
        }
      }
    }
  }
`;

/**
 * __useGetTimezonesQuery__
 *
 * To run a query within a React component, call `useGetTimezonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimezonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimezonesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTimezonesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetTimezonesQuery,
    GetTimezonesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTimezonesQuery, GetTimezonesQueryVariables>(
    GetTimezonesDocument,
    options
  );
}
export function useGetTimezonesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTimezonesQuery,
    GetTimezonesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTimezonesQuery, GetTimezonesQueryVariables>(
    GetTimezonesDocument,
    options
  );
}
// @ts-ignore
export function useGetTimezonesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetTimezonesQuery,
    GetTimezonesQueryVariables
  >
): Apollo.UseSuspenseQueryResult<GetTimezonesQuery, GetTimezonesQueryVariables>;
export function useGetTimezonesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTimezonesQuery,
        GetTimezonesQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetTimezonesQuery | undefined,
  GetTimezonesQueryVariables
>;
export function useGetTimezonesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTimezonesQuery,
        GetTimezonesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetTimezonesQuery, GetTimezonesQueryVariables>(
    GetTimezonesDocument,
    options
  );
}
export type GetTimezonesQueryHookResult = ReturnType<
  typeof useGetTimezonesQuery
>;
export type GetTimezonesLazyQueryHookResult = ReturnType<
  typeof useGetTimezonesLazyQuery
>;
export type GetTimezonesSuspenseQueryHookResult = ReturnType<
  typeof useGetTimezonesSuspenseQuery
>;
export type GetTimezonesQueryResult = Apollo.QueryResult<
  GetTimezonesQuery,
  GetTimezonesQueryVariables
>;
export const FacilityGroupByIdDocument = gql`
  query FacilityGroupById($facilityGroupByIdId: BigInt!) {
    facilityGroup(id: $facilityGroupByIdId) {
      facilities {
        nodes {
          id
          name
          city
          state
          zip
        }
      }
    }
  }
`;

/**
 * __useFacilityGroupByIdQuery__
 *
 * To run a query within a React component, call `useFacilityGroupByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFacilityGroupByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFacilityGroupByIdQuery({
 *   variables: {
 *      facilityGroupByIdId: // value for 'facilityGroupByIdId'
 *   },
 * });
 */
export function useFacilityGroupByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    FacilityGroupByIdQuery,
    FacilityGroupByIdQueryVariables
  > &
    (
      | { variables: FacilityGroupByIdQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    FacilityGroupByIdQuery,
    FacilityGroupByIdQueryVariables
  >(FacilityGroupByIdDocument, options);
}
export function useFacilityGroupByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FacilityGroupByIdQuery,
    FacilityGroupByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FacilityGroupByIdQuery,
    FacilityGroupByIdQueryVariables
  >(FacilityGroupByIdDocument, options);
}
// @ts-ignore
export function useFacilityGroupByIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FacilityGroupByIdQuery,
    FacilityGroupByIdQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  FacilityGroupByIdQuery,
  FacilityGroupByIdQueryVariables
>;
export function useFacilityGroupByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FacilityGroupByIdQuery,
        FacilityGroupByIdQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  FacilityGroupByIdQuery | undefined,
  FacilityGroupByIdQueryVariables
>;
export function useFacilityGroupByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FacilityGroupByIdQuery,
        FacilityGroupByIdQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FacilityGroupByIdQuery,
    FacilityGroupByIdQueryVariables
  >(FacilityGroupByIdDocument, options);
}
export type FacilityGroupByIdQueryHookResult = ReturnType<
  typeof useFacilityGroupByIdQuery
>;
export type FacilityGroupByIdLazyQueryHookResult = ReturnType<
  typeof useFacilityGroupByIdLazyQuery
>;
export type FacilityGroupByIdSuspenseQueryHookResult = ReturnType<
  typeof useFacilityGroupByIdSuspenseQuery
>;
export type FacilityGroupByIdQueryResult = Apollo.QueryResult<
  FacilityGroupByIdQuery,
  FacilityGroupByIdQueryVariables
>;
export const AllFacilitiesDocument = gql`
  query AllFacilities {
    facilities {
      nodes {
        name
        address
        city
        state
        zip
        slug
        id
        facilityGroups {
          nodes {
            id
            name
          }
        }
      }
    }
  }
`;

/**
 * __useAllFacilitiesQuery__
 *
 * To run a query within a React component, call `useAllFacilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllFacilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllFacilitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllFacilitiesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AllFacilitiesQuery,
    AllFacilitiesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AllFacilitiesQuery, AllFacilitiesQueryVariables>(
    AllFacilitiesDocument,
    options
  );
}
export function useAllFacilitiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AllFacilitiesQuery,
    AllFacilitiesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AllFacilitiesQuery, AllFacilitiesQueryVariables>(
    AllFacilitiesDocument,
    options
  );
}
// @ts-ignore
export function useAllFacilitiesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AllFacilitiesQuery,
    AllFacilitiesQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  AllFacilitiesQuery,
  AllFacilitiesQueryVariables
>;
export function useAllFacilitiesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AllFacilitiesQuery,
        AllFacilitiesQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  AllFacilitiesQuery | undefined,
  AllFacilitiesQueryVariables
>;
export function useAllFacilitiesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AllFacilitiesQuery,
        AllFacilitiesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AllFacilitiesQuery,
    AllFacilitiesQueryVariables
  >(AllFacilitiesDocument, options);
}
export type AllFacilitiesQueryHookResult = ReturnType<
  typeof useAllFacilitiesQuery
>;
export type AllFacilitiesLazyQueryHookResult = ReturnType<
  typeof useAllFacilitiesLazyQuery
>;
export type AllFacilitiesSuspenseQueryHookResult = ReturnType<
  typeof useAllFacilitiesSuspenseQuery
>;
export type AllFacilitiesQueryResult = Apollo.QueryResult<
  AllFacilitiesQuery,
  AllFacilitiesQueryVariables
>;
export const CreateFacilityGroupDocument = gql`
  mutation CreateFacilityGroup($input: CreateFacilityGroupInput!) {
    createFacilityGroup(input: $input) {
      facilityGroup {
        name
        parentId
        id
      }
    }
  }
`;
export type CreateFacilityGroupMutationFn = Apollo.MutationFunction<
  CreateFacilityGroupMutation,
  CreateFacilityGroupMutationVariables
>;

/**
 * __useCreateFacilityGroupMutation__
 *
 * To run a mutation, you first call `useCreateFacilityGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFacilityGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFacilityGroupMutation, { data, loading, error }] = useCreateFacilityGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFacilityGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateFacilityGroupMutation,
    CreateFacilityGroupMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateFacilityGroupMutation,
    CreateFacilityGroupMutationVariables
  >(CreateFacilityGroupDocument, options);
}
export type CreateFacilityGroupMutationHookResult = ReturnType<
  typeof useCreateFacilityGroupMutation
>;
export type CreateFacilityGroupMutationResult =
  Apollo.MutationResult<CreateFacilityGroupMutation>;
export type CreateFacilityGroupMutationOptions = Apollo.BaseMutationOptions<
  CreateFacilityGroupMutation,
  CreateFacilityGroupMutationVariables
>;
export const UpdateFacilityGroupByIdDocument = gql`
  mutation UpdateFacilityGroupById($input: UpdateFacilityGroupInput!) {
    updateFacilityGroup(input: $input) {
      facilityGroup {
        id
        name
        parent {
          id
          name
        }
      }
    }
  }
`;
export type UpdateFacilityGroupByIdMutationFn = Apollo.MutationFunction<
  UpdateFacilityGroupByIdMutation,
  UpdateFacilityGroupByIdMutationVariables
>;

/**
 * __useUpdateFacilityGroupByIdMutation__
 *
 * To run a mutation, you first call `useUpdateFacilityGroupByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFacilityGroupByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFacilityGroupByIdMutation, { data, loading, error }] = useUpdateFacilityGroupByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFacilityGroupByIdMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateFacilityGroupByIdMutation,
    UpdateFacilityGroupByIdMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateFacilityGroupByIdMutation,
    UpdateFacilityGroupByIdMutationVariables
  >(UpdateFacilityGroupByIdDocument, options);
}
export type UpdateFacilityGroupByIdMutationHookResult = ReturnType<
  typeof useUpdateFacilityGroupByIdMutation
>;
export type UpdateFacilityGroupByIdMutationResult =
  Apollo.MutationResult<UpdateFacilityGroupByIdMutation>;
export type UpdateFacilityGroupByIdMutationOptions = Apollo.BaseMutationOptions<
  UpdateFacilityGroupByIdMutation,
  UpdateFacilityGroupByIdMutationVariables
>;
export const AllGroupsDocument = gql`
  query AllGroups {
    facilityGroups {
      nodes {
        id
        name
        parentId
        facilities {
          nodes {
            id
            name
            address
            city
            state
            zip
            slug
            facilityGroups {
              nodes {
                id
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useAllGroupsQuery__
 *
 * To run a query within a React component, call `useAllGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllGroupsQuery(
  baseOptions?: Apollo.QueryHookOptions<AllGroupsQuery, AllGroupsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AllGroupsQuery, AllGroupsQueryVariables>(
    AllGroupsDocument,
    options
  );
}
export function useAllGroupsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AllGroupsQuery,
    AllGroupsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AllGroupsQuery, AllGroupsQueryVariables>(
    AllGroupsDocument,
    options
  );
}
// @ts-ignore
export function useAllGroupsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AllGroupsQuery,
    AllGroupsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<AllGroupsQuery, AllGroupsQueryVariables>;
export function useAllGroupsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AllGroupsQuery, AllGroupsQueryVariables>
): Apollo.UseSuspenseQueryResult<
  AllGroupsQuery | undefined,
  AllGroupsQueryVariables
>;
export function useAllGroupsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AllGroupsQuery, AllGroupsQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AllGroupsQuery, AllGroupsQueryVariables>(
    AllGroupsDocument,
    options
  );
}
export type AllGroupsQueryHookResult = ReturnType<typeof useAllGroupsQuery>;
export type AllGroupsLazyQueryHookResult = ReturnType<
  typeof useAllGroupsLazyQuery
>;
export type AllGroupsSuspenseQueryHookResult = ReturnType<
  typeof useAllGroupsSuspenseQuery
>;
export type AllGroupsQueryResult = Apollo.QueryResult<
  AllGroupsQuery,
  AllGroupsQueryVariables
>;
export const AddFacilityToGroupDocument = gql`
  mutation AddFacilityToGroup($input: CreateFacilityGroupsLinkerInput!) {
    createFacilityGroupsLinker(input: $input) {
      facilityGroupsLinker {
        facilityGroupingId
        facilityId
      }
    }
  }
`;
export type AddFacilityToGroupMutationFn = Apollo.MutationFunction<
  AddFacilityToGroupMutation,
  AddFacilityToGroupMutationVariables
>;

/**
 * __useAddFacilityToGroupMutation__
 *
 * To run a mutation, you first call `useAddFacilityToGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFacilityToGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFacilityToGroupMutation, { data, loading, error }] = useAddFacilityToGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddFacilityToGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddFacilityToGroupMutation,
    AddFacilityToGroupMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddFacilityToGroupMutation,
    AddFacilityToGroupMutationVariables
  >(AddFacilityToGroupDocument, options);
}
export type AddFacilityToGroupMutationHookResult = ReturnType<
  typeof useAddFacilityToGroupMutation
>;
export type AddFacilityToGroupMutationResult =
  Apollo.MutationResult<AddFacilityToGroupMutation>;
export type AddFacilityToGroupMutationOptions = Apollo.BaseMutationOptions<
  AddFacilityToGroupMutation,
  AddFacilityToGroupMutationVariables
>;
export const RemoveFacilityFromGroupDocument = gql`
  mutation RemoveFacilityFromGroup($input: DeleteFacilityGroupsLinkerInput!) {
    deleteFacilityGroupsLinker(input: $input) {
      facilityGroupsLinker {
        facilityGroupingId
        facilityId
      }
    }
  }
`;
export type RemoveFacilityFromGroupMutationFn = Apollo.MutationFunction<
  RemoveFacilityFromGroupMutation,
  RemoveFacilityFromGroupMutationVariables
>;

/**
 * __useRemoveFacilityFromGroupMutation__
 *
 * To run a mutation, you first call `useRemoveFacilityFromGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFacilityFromGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFacilityFromGroupMutation, { data, loading, error }] = useRemoveFacilityFromGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveFacilityFromGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveFacilityFromGroupMutation,
    RemoveFacilityFromGroupMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveFacilityFromGroupMutation,
    RemoveFacilityFromGroupMutationVariables
  >(RemoveFacilityFromGroupDocument, options);
}
export type RemoveFacilityFromGroupMutationHookResult = ReturnType<
  typeof useRemoveFacilityFromGroupMutation
>;
export type RemoveFacilityFromGroupMutationResult =
  Apollo.MutationResult<RemoveFacilityFromGroupMutation>;
export type RemoveFacilityFromGroupMutationOptions = Apollo.BaseMutationOptions<
  RemoveFacilityFromGroupMutation,
  RemoveFacilityFromGroupMutationVariables
>;
export const DeleteFacilityGroupByIdDocument = gql`
  mutation DeleteFacilityGroupById($input: DeleteFacilityGroupInput!) {
    deleteFacilityGroup(input: $input) {
      facilityGroup {
        name
        id
      }
    }
  }
`;
export type DeleteFacilityGroupByIdMutationFn = Apollo.MutationFunction<
  DeleteFacilityGroupByIdMutation,
  DeleteFacilityGroupByIdMutationVariables
>;

/**
 * __useDeleteFacilityGroupByIdMutation__
 *
 * To run a mutation, you first call `useDeleteFacilityGroupByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFacilityGroupByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFacilityGroupByIdMutation, { data, loading, error }] = useDeleteFacilityGroupByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteFacilityGroupByIdMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteFacilityGroupByIdMutation,
    DeleteFacilityGroupByIdMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteFacilityGroupByIdMutation,
    DeleteFacilityGroupByIdMutationVariables
  >(DeleteFacilityGroupByIdDocument, options);
}
export type DeleteFacilityGroupByIdMutationHookResult = ReturnType<
  typeof useDeleteFacilityGroupByIdMutation
>;
export type DeleteFacilityGroupByIdMutationResult =
  Apollo.MutationResult<DeleteFacilityGroupByIdMutation>;
export type DeleteFacilityGroupByIdMutationOptions = Apollo.BaseMutationOptions<
  DeleteFacilityGroupByIdMutation,
  DeleteFacilityGroupByIdMutationVariables
>;
